/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1665);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1612);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1534)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(305);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1268);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1266);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(132);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(132);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1284), __esModule: true };

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(147);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(1521)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(248)(module)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var core = __webpack_require__(82);
var hide = __webpack_require__(56);
var redefine = __webpack_require__(57);
var ctx = __webpack_require__(74);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _env = __webpack_require__(197);

var _env2 = _interopRequireDefault(_env);

var _commonUtils = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// IMPORTANT: Make sure to use env.property in this file instead of
// process.env.property.

// If adding a new config item which requires the use of process.env
// make sure to add it to the env.js file.
var advertSizes = (0, _commonUtils.globalCssExports)("adverts");

var topBannerSlotSmall = [[300, advertSizes.smallBannerHeight], [320, advertSizes.smallBannerHeight]];

var topBannerSlotMedium = [].concat(topBannerSlotSmall, [[advertSizes.mediumBannerWidth, advertSizes.mediumBannerHeight]]);

var topBannerSlotLarge = [].concat((0, _toConsumableArray3.default)(topBannerSlotMedium), [[advertSizes.billboardBannerWidth, advertSizes.billboardBannerHeight]]);

var config = {
  environment: _env2.default.NODE_ENV || 'development',
  isProduction: _env2.default.NODE_ENV === 'production',
  protectableFeatures: _env2.default.PROTECTABLE_FEATURES === "on",

  featureBucket: {
    configExpiry: _env2.default.FEATURE_CANARY_CONFIG_EXPIRY || 1800000,
    configUrl: _env2.default.FEATURE_CANARY_CONFIG_URL || "https://sportinglife.com/canary/features.json",
    cookie: {
      key: _env2.default.FEATURE_BUCKET_COOKIE_KEY || 'bucketID',
      maxAge: _env2.default.FEATURE_BUCKET_COOKIE_AGE || 900000
    }
  },

  cookiePolicy: {
    cookieName: "cookie_policy_accepted",
    cookieValue: "yes",
    policyLink: "/privacy"
  },

  splashpage: {
    cookieName: "splash_screen_seen",
    cookieValue: "true"
  },

  wss: {
    topic: {
      hrFastResults: _env2.default.HR_FR_TOPIC || "hr/$cg/+/+/+/fast-result"
    }
  },

  app: {
    head: {
      title: "Sporting Life Universal Web Application"
    }
  },

  nav: {
    event: {
      title: _env2.default.NAV_EVENT_TITLE,
      uri: _env2.default.NAV_EVENT_URL,
      mainNavIndex: _env2.default.NAV_EVENT_MAIN_INDEX || 5,
      subNavIndex: _env2.default.NAV_EVENT_SUB_INDEX || 7
    }
  },

  pageTitle: {
    mainSuffix: "Sporting Life",
    midfix: {
      football: "Football",
      horseRacing: "Horse Racing",
      myStable: "My Stable",
      greyhoundRacing: "Greyhound Racing",
      cricket: "Cricket",
      darts: "Darts",
      golf: "Golf",
      rugbyLeague: "Rugby League",
      rugbyUnion: "Rugby Union",
      tennis: "Tennis",
      boxing: "Boxing",
      formula1: "Formula 1",
      snooker: "Snooker",
      nfl: "NFL",
      insider: "Insider"
    },
    default: "Horse Racing Tips & Results | Football Scores & News"
  },

  cacheBuster: _env2.default.API_GET_CACHE_BUSTER,
  canonicalBase: _env2.default.SITE_CANONICAL_BASE || 'https://www.sportinglife.com',
  apiUrl: _env2.default.SERVICE_APP_HOSTNAME || 'www.sportinglife.com',
  apiPort: _env2.default.SERVICE_APP_PORT || 8080,
  apiProtocol: _env2.default.SERVICE_APP_PROTOCOL || 'https',
  apiTimeout: _env2.default.SERVICE_APP_TIMEOUT || 30000,
  siteTimeout: _env2.default.SERVICE_SITE_TIMEOUT || 30000,
  siteMaxConnections: _env2.default.SERVICE_SITE_MAX_CONN,
  siteRestartConnections: _env2.default.SERVICE_SITE_RESTART_CONN_COUNT,
  cookieDomain: _env2.default.COOKIE_DOMAIN || 'sportinglife.com',
  googleConsoleTag: _env2.default.GOOGLE_CONSOLE_TAG || '',
  googleRecaptchaSiteKey: _env2.default.GOOGLE_RECAPTCHA_SITE_KEY || '6LeErDAUAAAAACZPNLbjbFpYwP_FqnjVvs-_T3Y2',
  itunesAppId: _env2.default.ITUNES_APP_ID || '1077299974',
  fastresultsAppId: _env2.default.FASTRESULTS_APP_ID || '1345907668',
  SkyBetAccountEnabled: _env2.default.SBG_ACC_ENABLED != "false",
  skyBetAccountHost: _env2.default.SBG_SSO_HOST || "www.skybet.com",
  serviceWorkerEnabled: _env2.default.SERVICE_WORKER_ENABLED != "false",
  staging: _env2.default.STAGING === "true",
  cacheHost: _env2.default.CACHE_HOST,
  applicationColour: _env2.default.APPLICATION_COLOUR,
  atrVideo: { placeholderTimestamp: _env2.default.ATR_VIDEO_TIMESTAMP || 0 },
  api: {
    football: {
      matchDetail: "api/football/match_detail",
      matchEvents: "api/football/match_events",
      dailyMatches: "api/football/match_day",
      competitions: "api/football/competition",
      teams: "api/football/team",
      loadMatch: "api/football/match",
      loadMatches: "api/football/match",
      loadTeamForm: "api/football/form",
      vidiprinter: "api/football/vidiprinter",
      competitionList: "api/football/competition",
      leagueTable: "api/football/league-tables",
      fixtures: "api/football/match_day"
    },
    horseRacing: {
      mostFollowed: {
        horse: "api/horse-racing/horse/search/most-followed",
        jockey: "api/horse-racing/jockey/search/most-followed",
        trainer: "api/horse-racing/trainer/search/most-followed"
      },
      loadFastCard: "api/horse-racing/fast-card",
      loadFastResult: "api/horse-racing/fast-result",
      loadMeetingData: "api/horse-racing/fast-meeting-result",
      loadEntries: "api/horse-racing/mystableEntry",
      loadResults: "api/horse-racing/mystableResult",
      loadMeeting: "api/horse-racing/meeting",
      loadMeetings: "api/horse-racing/racing/racecards",
      loadRace: "api/horse-racing/race",
      horse: "api/horse-racing/horse",
      jockey: "api/horse-racing/jockey",
      trainer: "api/horse-racing/trainer",
      atrVideo: "api/horse-racing/atr-url",
      nonRunners: "api/horse-racing/nonrunner",
      going: "api/horse-racing/going",
      naps: "api/horse-racing/naps",
      abc: "api/horse-racing/abcguide"
    },
    greyhoundRacing: {
      loadFastResult: "api/greyhound-racing/fast-result",
      loadMeetings: "api/greyhound-racing/meeting",
      loadMeeting: "api/greyhound-racing/meeting",
      loadRace: "api/greyhound-racing/race",
      loadGreyhound: "api/greyhound-racing/greyhound"
    },
    common: {
      wssUrl: "api/wss",
      loadArticle: "api/cms-news/article",
      loadArticleSummary: "api/cms-news/article-summary",
      layout: {
        loadLayout: "api/cms-news/layout"
      },
      userService: {
        unsubscribeEmail: "api/user/email/unsubscribe",
        feedback: "api/user/feedback",
        loadSubscriptions: "api/user/subscription/search",
        saveSubscriptions: "api/user/subscription",
        deleteSubscriptions: "api/user/subscription"
      }
    },
    sso: {
      loggedIn: "logged-in",
      loggedOut: "logged-out"
    },
    media: {
      loadMedia: "api/cms-media/media",
      imagesURL: _env2.default.IMAGES_URL || 'https://www.sportinglife.com/images/',
      fallbackSilkPath: "/img/default-silk.png"
    },
    splashpage: {
      cmsSplashpageUri: "api/cms-app/splashpage/"
    },
    campaignGroups: {
      cmsCampaignGroupsUri: "api/cms-app/campaign-groups/current-filtered"
    }
  },
  metricsVendors: {
    signal: {
      name: "SBG Signal",
      setup: {}
    },
    google: {
      name: "Google Analytics",
      setup: {
        trackingId: _env2.default.GOOGLE_ANALYTICS_PROPERTY_ID || "UA-83524757-1",
        samplingRate: _env2.default.GOOGLE_ANALYTICS_SAMPLING_RATE || "100"
      }
    },
    omniture: {
      name: "Omniture",
      setup: {
        suite: _env2.default.OMNITURE_SUITE || "sbgsportinglifetest"
      }
    }
  },
  sitemap: {
    SITEMAP_DAYS_BEHIND: _env2.default.SITEMAP_DAYS_BEHIND || 6,
    SITEMAP_DAYS_AHEAD: _env2.default.SITEMAP_DAYS_AHEAD || 6,
    SITEMAP_BASKET_ARTICLE_LIMIT: _env2.default.SITEMAP_BASKET_ARTICLE_LIMIT || 50
  },
  cacheTimeStatic: isNaN(_env2.default.STATIC_ASSET_CACHE_TTL) ? 604800000 : _env2.default.STATIC_ASSET_CACHE_TTL, // One week by default
  cacheTimePage: "1",
  hstsCacheTime: "7776000",
  oddschecker: {
    enabled: _env2.default.ODDSCHECKER_ENABLED != "false",
    betlinkEnabled: true,
    affId: _env2.default.ODDSCHECKER_AFF_ID || "1197320072",
    apiKey: _env2.default.ODDSCHECKER_API_KEY || "22e9d194-d446-4f45-b59a-5b000d4e97dc",
    slotID: {
      footer: "Hkz08doCuf",
      homepage: {
        leaderboard: "Bkx55OuBm",
        mpu: "HkiuixDSm"
      },
      racingFastResults: {
        leaderboard: "B1VD8uzlm"
      },
      racing: {
        leaderboard: "BkM6cu_rQ",
        mpu: "SyiiquOHX"
      },
      football: {
        leaderboard: "r15kj__rm",
        mpu: "Hyw0cudrm"
      },
      greyhounds: {
        leaderboard: "S1dzoOOBm",
        mpu: "r1AljuOrQ"
      },
      golf: {
        leaderboard: "HJAZhJiBm",
        mpu: "Hky-hyjSQ"
      },
      darts: {
        leaderboard: "SyeNnksrQ",
        mpu: "Sk3MhksHQ"
      },
      cricket: {
        leaderboard: "S14wgAzwQ",
        mpu: "B1vrgCGvQ"
      },
      snooker: {
        leaderboard: "B1FKeRzwm",
        mpu: "SyOtg0fwQ"
      },
      tennis: {
        leaderboard: "SkAFgCzP7",
        mpu: "ry6YlRfwX"
      },
      boxing: {
        leaderboard: "ByJqe0zw7",
        mpu: "HJgAKgRGDQ"
      },
      formula1: {
        leaderboard: "BkA--0GPm",
        mpu: "H1l6ZZRGw7"
      },
      nfl: {
        leaderboard: "HkpWZCGP7",
        mpu: "SJsZ-Cfv7"
      },
      "rugby-league": {
        leaderboard: "Sk1o0kiSQ",
        mpu: "r1cKAksH7"
      },
      "rugby-union": {
        leaderboard: "BJ3deejBX",
        mpu: "B1nvxejH7"
      },
      "other-sports": {
        leaderboard: "B1Q5bCzvm",
        mpu: "ryfq-0fPm"
      },
      "custom-basket": {
        leaderboard: "B1Q5bCzvm",
        mpu: "ryfq-0fPm"
      },
      cms: {
        leaderboard: "Syg4E1ED7"
      }
    }
  },
  googlePublisherTag: {
    enabled: _env2.default.GPT_ENABLED != "false",
    topBanner: {
      sizeMapping: [{
        viewport: [0, 0],
        slot: topBannerSlotSmall
      }, {
        viewport: [advertSizes.mediumBannerSafeWidth, 0],
        slot: topBannerSlotMedium
      }, {
        viewport: [advertSizes.billboardBannerSafeWidth, 0],
        slot: topBannerSlotLarge
      }],
      targeting: {
        'Display_Ad_Position': ['ATF'],
        'Display_Ad_Size': ['Top_Banner']
      }
    },
    topMPU: {
      sizeMapping: [{
        viewport: [0, 0],
        slot: [[300, advertSizes.singleMpuHeight], [300, advertSizes.doubleMpuHeight]]
      }],
      targeting: {
        'Display_Ad_Position': ['ATF'],
        'Display_Ad_Size': ['Top_MPU']
      }
    },
    bottomMPU: {
      sizeMapping: [{ viewport: [0, 0], slot: [[300, advertSizes.singleMpuHeight], [300, advertSizes.doubleMpuHeight]] }],
      targeting: {
        'Display_Ad_Position': ['BTF'],
        'Display_Ad_Size': ['Bottom_MPU']
      }
    },
    singleBottomMPU: {
      sizeMapping: [{ viewport: [0, 0], slot: [[300, advertSizes.singleMpuHeight], [300, advertSizes.doubleMpuHeight]] }],
      targeting: {
        'Display_Ad_Position': ['BTF'],
        'Display_Ad_Size': ['Bottom_MPU']
      }
    }
  },
  structuredData: {
    legalName: "Hestview Ltd",
    founded: 1859,
    email: "editorial@sportinglife.com",
    streetAddress: "2 Wellington Place",
    city: "Leeds",
    region: "West Yorkshire",
    postalCode: "LS1 4AP"
  },
  tam: {
    enabled: _env2.default.AMAZON_TAM_ENABLED != "false",
    url: "//c.amazon-adsystem.com/aax2/apstag.js",
    scriptLoadTimeoutMs: 200,
    bidRetreivalTimeoutMs: 6000,
    initializationParams: {
      pubID: '3117',
      adServer: 'googletag',
      bidTimeout: 4000
    }
  }
};

exports.default = config;

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(1572);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(680);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(1568);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexLink", function() { return __WEBPACK_IMPORTED_MODULE_2__IndexLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(1583);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(1569);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRedirect", function() { return __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(1570);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRoute", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(682);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(1571);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRoutes", function() { return __WEBPACK_IMPORTED_MODULE_8__RouteUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(344);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_9__RouterContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "locationShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(1581);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "match", function() { return __WEBPACK_IMPORTED_MODULE_11__match__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(687);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRouterHistory", function() { return __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPattern", function() { return __WEBPACK_IMPORTED_MODULE_13__PatternUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(1574);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouterMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(1575);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserHistory", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(1579);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hashHistory", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(684);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__["a"]; });
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MetaDataWrapper = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(17);

var _reactHelmet = __webpack_require__(156);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MetaDataWrapper = exports.MetaDataWrapper = function (_Component) {
    (0, _inherits3.default)(MetaDataWrapper, _Component);

    function MetaDataWrapper(props) {
        (0, _classCallCheck3.default)(this, MetaDataWrapper);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MetaDataWrapper.__proto__ || (0, _getPrototypeOf2.default)(MetaDataWrapper)).call(this, props));

        var metaData = _this.getMetaDataFromProps(props.pathname, props);

        _this.state = (0, _extends3.default)({}, metaData);
        return _this;
    }

    (0, _createClass3.default)(MetaDataWrapper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (window.location && window.location.pathname) {
                this.setMetaDataStateFromPathname(window.location.pathname, this.props);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (window.location && window.location.pathname) {
                this.setMetaDataStateFromPathname(window.location.pathname, nextProps);
            }
        }
    }, {
        key: 'getTitle',
        value: function getTitle(meta, props) {
            if (meta && meta.title) {
                return meta.title;
            }

            if (props.title) {
                return props.title;
            }

            if (props.helmetProps && props.helmetProps.title) {
                return props.helmetProps.title;
            }

            return '';
        }
    }, {
        key: 'getOverridingMetaDataValue',
        value: function getOverridingMetaDataValue(meta, name) {
            if (meta[name] && meta[name].length > 0) {
                return meta[name];
            }

            return '';
        }
    }, {
        key: 'getMetaDataFromProps',
        value: function getMetaDataFromProps(pathname, props) {
            var meta = this.getMetaDataByPathname(pathname, props.metadata);
            var title = this.getTitle(meta, props);
            var description = this.getOverridingMetaDataValue(meta, "description");
            var keywords = this.getOverridingMetaDataValue(meta, "keywords");

            return { title: title, description: description, keywords: keywords };
        }
    }, {
        key: 'setMetaDataStateFromPathname',
        value: function setMetaDataStateFromPathname(pathname, props) {
            var metaData = this.getMetaDataFromProps(pathname, props);

            this.setState(metaData);
        }
    }, {
        key: 'getMetaDataByPathname',
        value: function getMetaDataByPathname(path, metadata) {
            if (!metadata || metadata.length === 0) {
                return false;
            }

            var meta = metadata.filter(function (m) {
                return m.path === path;
            });

            return meta[0] || false;
        }
    }, {
        key: 'renderMetaTag',
        value: function renderMetaTag(props) {
            if (props.content && props.content.length > 0) {
                return _react2.default.createElement('meta', props);
            }

            return null;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactHelmet2.default,
                this.props.helmetProps,
                this.state.title && this.state.title.length > 0 ? _react2.default.createElement(
                    'title',
                    null,
                    this.state.title
                ) : '',
                this.renderMetaTag({ name: "description", content: this.state.description }),
                this.renderMetaTag({ name: "keywords", content: this.state.keywords }),
                this.props.children
            );
        }
    }]);
    return MetaDataWrapper;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
    var metadata = state.common && state.common.metaData && state.common.metaData.entries ? state.common.metaData.entries : [];

    var pathname = state.routing && state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.pathname ? state.routing.locationBeforeTransitions.pathname : '';

    return {
        metadata: metadata,
        pathname: pathname
    };
})(MetaDataWrapper);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.timeStampToUnix = timeStampToUnix;
exports.sameDate = sameDate;
exports.momentInUTC = momentInUTC;
exports.isToday = isToday;
exports.isYesterday = isYesterday;
exports.isTomorrow = isTomorrow;
exports.isInThePast = isInThePast;
exports.addDuration = addDuration;
exports.isBefore = isBefore;
exports.local12Hour = local12Hour;
exports.localDateTime = localDateTime;
exports.localDateTimeLong = localDateTimeLong;
exports.isoDate = isoDate;
exports.localDate = localDate;
exports.localDateShort = localDateShort;
exports.getRelativeDay = getRelativeDay;
exports.getRelativeDayURI = getRelativeDayURI;
exports.localDateShortDescriptive = localDateShortDescriptive;
exports.localFullDate = localFullDate;
exports.localLongDate = localLongDate;
exports.localFullDateTime = localFullDateTime;
exports.localFullDateLong = localFullDateLong;
exports.localFullDateShort = localFullDateShort;
exports.localFullDateNoDay = localFullDateNoDay;
exports.localMonth = localMonth;
exports.localLongMonth = localLongMonth;
exports.localYearMonth = localYearMonth;
exports.localDayOfWeek = localDayOfWeek;
exports.localShortDayOfWeek = localShortDayOfWeek;
exports.yearMonthToMoment = yearMonthToMoment;
exports.localTime = localTime;
exports.localDateTimeShort = localDateTimeShort;
exports.localTimeShort = localTimeShort;
exports.getTodaysDate = getTodaysDate;
exports.getYesterdaysDate = getYesterdaysDate;
exports.getTomorrowsDate = getTomorrowsDate;
exports.beforeNow = beforeNow;

var _momentTimezone = __webpack_require__(241);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _consts = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function timeStampToUnix(timeStamp) {
  var momentTs = (0, _momentTimezone2.default)(timeStamp);
  if (!momentTs.isValid()) {
    return 0;
  }
  return momentTs.unix();
}

function sameDate(d1, d2) {
  return (0, _momentTimezone2.default)(d1).isValid() && (0, _momentTimezone2.default)(d2).isValid() && isoDate((0, _momentTimezone2.default)(d1)) === isoDate((0, _momentTimezone2.default)(d2));
}

function momentInUTC(d) {
  return _momentTimezone2.default.utc(d).tz(_consts.TZ);
}

function numberOfHoursSinceNow(d) {
  return _momentTimezone2.default.utc().startOf('day').diff(_momentTimezone2.default.utc(d).startOf('day'), 'hours');
}

function isToday(d) {
  return numberOfHoursSinceNow(d) === 0;
}

function isYesterday(d) {
  return numberOfHoursSinceNow(d) === 24;
}

function isTomorrow(d) {
  return numberOfHoursSinceNow(d) === -24;
}

function isInThePast(d) {
  return (0, _momentTimezone2.default)().valueOf() > momentInUTC(d).valueOf();
}

function addDuration(d) {
  var _momentInUTC;

  for (var _len = arguments.length, t = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    t[_key - 1] = arguments[_key];
  }

  return (_momentInUTC = momentInUTC(d)).add.apply(_momentInUTC, t);
}

// Spread param to support moment's options for `add`;
function isBefore(d) {
  var _momentInUTC2;

  for (var _len2 = arguments.length, t = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    t[_key2 - 1] = arguments[_key2];
  }

  return momentInUTC().isBefore((_momentInUTC2 = momentInUTC(d)).add.apply(_momentInUTC2, t));
}

function local12Hour(time) {

  var momentTime = (0, _momentTimezone2.default)(time, 'HH:mm');

  if (!momentTime.isValid()) {
    return "";
  }

  return momentTime.format('h a');
}

function localDateTime(d) {
  return momentInUTC(d).format("DD-MM-YYYY HH:mm");
}

function localDateTimeLong(d) {
  return momentInUTC(d).format("DD-MM-YYYY HH:mm:ss");
}

function isoDate(d) {
  return momentInUTC(d).format("YYYY-MM-DD");
}

function localDate(d) {
  return momentInUTC(d).format("DD-MM-YYYY");
}

function localDateShort(d) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      convertToday = _ref.convertToday,
      convertYesterday = _ref.convertYesterday,
      convertTomorrow = _ref.convertTomorrow;

  if (convertToday && isToday(d)) {
    return 'Today';
  } else if (convertYesterday && isYesterday(d)) {
    return 'Yesterday';
  } else if (convertTomorrow && isTomorrow(d)) {
    return 'Tomorrow';
  } else {
    return momentInUTC(d).format('ddd DD');
  }
}

function getRelativeDay(d, difference) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      convertToday = _ref2.convertToday,
      convertYesterday = _ref2.convertYesterday,
      convertTomorrow = _ref2.convertTomorrow;

  d = _momentTimezone2.default.utc(d).add(difference, 'days').tz(_consts.TZ);
  if (convertToday && isToday(d)) {
    return '';
  } else if (convertYesterday && isYesterday(d)) {
    return 'yesterday';
  } else if (convertTomorrow && isTomorrow(d)) {
    return 'tomorrow';
  } else {
    return '' + isoDate(d);
  }
}

// For URIs
function getRelativeDayURI(d, difference) {
  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      convertToday = _ref3.convertToday,
      convertYesterday = _ref3.convertYesterday,
      convertTomorrow = _ref3.convertTomorrow;

  var uri = getRelativeDay(d, difference, { convertToday: convertToday, convertYesterday: convertYesterday, convertTomorrow: convertTomorrow });
  if (uri != '') {
    uri = '/' + uri;
  }
  return uri;
}

function localDateShortDescriptive(d) {
  return momentInUTC(d).format('ddd Do');
}

function localFullDate(d) {
  return momentInUTC(d).format("Do MMMM YYYY");
}

function localLongDate(d) {
  return momentInUTC(d).format("dddd MMMM D");
}

function localFullDateTime(d) {
  return momentInUTC(d).format("HH:mm Do MMMM YYYY");
}

function localFullDateLong(d) {
  return momentInUTC(d).format("ddd D MMMM YYYY");
}

function localFullDateShort(d) {
  return momentInUTC(d).format("DD/MM/YY");
}

function localFullDateNoDay(d) {
  return momentInUTC(d).format("D MMMM YYYY");
}

function localMonth(d) {
  return momentInUTC(d).format("MMM");
}

function localLongMonth(d) {
  return momentInUTC(d).format("MMMM");
}

function localYearMonth(d) {
  return momentInUTC(d).format("YYYY-MM");
}

function localDayOfWeek(d) {
  return (0, _momentTimezone2.default)(d).format("dddd");
}

function localShortDayOfWeek(d) {
  return (0, _momentTimezone2.default)(d).format("ddd");
}

function yearMonthToMoment(d) {
  return (0, _momentTimezone2.default)(d, "YYYY-MM");
}

function localTime(t) {
  return momentInUTC(t).format("HH:mm:ss");
}

function localDateTimeShort(t) {
  return momentInUTC(t).format("HH:mm DD/MM/YY");
}

function localTimeShort(t) {
  return momentInUTC(t).format("HH:mm");
}

function getTodaysDate(format) {
  return (0, _momentTimezone2.default)().tz(_consts.TZ).format(format);
}

function getYesterdaysDate(format) {
  return (0, _momentTimezone2.default)().add(-1, 'days').tz(_consts.TZ).format(format);
}

function getTomorrowsDate(format) {
  return (0, _momentTimezone2.default)().add(1, 'days').tz(_consts.TZ).format(format);
}

function beforeNow(timestamp) {
  // duration units as ms
  var min = 1000 * 60;
  var hour = min * 60;
  var day = hour * 24;
  var week = day * 7;
  // year and month are approximate, but good enough in this scenario
  var year = day * 365.25;
  var month = year / 12;

  // boundaries and units
  var gaps = [[hour, 45 * min, "h"], [day, 20 * hour, "d"], [week, 6 * day, "w"], [month, 26 * day, "M"], [year, 350 * day, "y"]];

  var gapMs = Math.abs(_momentTimezone2.default.now() - momentInUTC(timestamp).valueOf());

  // start by assuming minutes
  var gapCalc = gapMs / min;
  var gapUnit = "m";

  // then move up the scale
  gaps.forEach(function (_ref4) {
    var _ref5 = (0, _slicedToArray3.default)(_ref4, 3),
        scale = _ref5[0],
        boundary = _ref5[1],
        unit = _ref5[2];

    if (gapMs > boundary) {
      gapCalc = gapMs / scale;
      gapUnit = unit;
    }
  });

  // format the result
  var gapString = '' + Math.round(gapCalc) + gapUnit;

  // but prevent zero
  if (gapString == "0m") {
    return "1m";
  } else {
    return gapString;
  }
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get4 = __webpack_require__(233);

var _get5 = _interopRequireDefault(_get4);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

exports.standardAsyncConnect = standardAsyncConnect;
exports.layoutAsyncConnect = layoutAsyncConnect;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(91);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reduxConnect = __webpack_require__(351);

var _reactRouterRedux = __webpack_require__(138);

var _pageTranstition = __webpack_require__(260);

var _skysso = __webpack_require__(72);

var _userService = __webpack_require__(44);

var _server = __webpack_require__(438);

var _mediaQueryHelpers = __webpack_require__(440);

var _layouts = __webpack_require__(719);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isProduction = _config2.default.isProduction; // direct import doesn't work

function standardAsyncConnect(dispatches) {
  return layoutAsyncConnect("", dispatches);
}

function layoutAsyncConnect(componentName, dispatches) {

  // seed the collection with something that will simply set the transtion to busy
  var asynced = [{
    promise: function promise(_ref) {
      var _ref$store = _ref.store,
          dispatch = _ref$store.dispatch,
          getState = _ref$store.getState;

      if (!getState().common.pageTranstition.busy) {
        // ensure no duplicated dispatches
        dispatch((0, _pageTranstition.setBusy)(true));
      }
    }
  }];

  // Require this for error handling and status codes on the server.
  var connections = [];
  var errorConnections = [];
  var refresh = [];

  dispatches.forEach(function (element) {
    var _element$preventResol = element.preventResolve,
        preventResolve = _element$preventResol === undefined ? function () {
      return false;
    } : _element$preventResol,
        _element$dispatch = element.dispatch,
        dispatch = _element$dispatch === undefined ? function () {} : _element$dispatch,
        state = element.state,
        errorState = element.errorState,
        _element$refreshInter = element.refreshInterval,
        refreshInterval = _element$refreshInter === undefined ? 0 : _element$refreshInter,
        _element$preserveRefr = element.preserveRefresh,
        preserveRefresh = _element$preserveRefr === undefined ? false : _element$preserveRefr,
        _element$then = element.then,
        then = _element$then === undefined ? function () {} : _element$then,
        reset = element.reset,
        _element$handleError = element.handleError,
        handleError = _element$handleError === undefined ? true : _element$handleError,
        _element$reportStatus = element.reportStatus,
        reportStatus = _element$reportStatus === undefined ? false : _element$reportStatus;


    var dispatchFunc = dispatch;
    var thenFunc = then;

    asynced.push({
      promise: function promise(_ref2) {
        var _ref2$store = _ref2.store,
            dispatch = _ref2$store.dispatch,
            getState = _ref2$store.getState,
            location = _ref2.location,
            pathname = _ref2.location.pathname,
            routes = _ref2.routes,
            params = _ref2.params;

        var promiseState = getState();
        // Define any helper stuff here and include them in the promise destructuring below.
        var _promiseState$common = promiseState.common;
        _promiseState$common = _promiseState$common === undefined ? {} : _promiseState$common;
        var auth = _promiseState$common.auth,
            _promiseState$common$ = _promiseState$common.auth;
        _promiseState$common$ = _promiseState$common$ === undefined ? {} : _promiseState$common$;
        var _promiseState$common$2 = _promiseState$common$.loggedIn,
            loggedIn = _promiseState$common$2 === undefined ? false : _promiseState$common$2;


        if (preventResolve({ state: promiseState, loggedIn: loggedIn, params: params }) || componentName && (0, _layouts.preventLoadData)(componentName, { state: promiseState, location: location, routes: routes, params: params })) {
          return _promise2.default.resolve();
        } else {
          return dispatch(dispatchFunc({ dispatch: dispatch, getState: getState, state: promiseState, pathname: pathname, params: params, routes: routes, auth: auth })).then(function (result) {
            return thenFunc({ dispatch: dispatch, getState: getState, state: promiseState, pathname: pathname, params: params, routes: routes, auth: auth, result: result });
          }).catch(function (caught) {
            var _caught$body = caught.body,
                body = _caught$body === undefined ? {} : _caught$body,
                _caught$status = caught.status,
                status = _caught$status === undefined ? 500 : _caught$status,
                error = caught.error;


            if (!isProduction) {
              if (error) {
                console.error("Error in Page Transition:", body.message, error.message); // eslint-disable-line no-console
              } else {
                console.error("Error in Page Transition;", caught); // eslint-disable-line no-console
              }
            }

            // If an API call reports the user isn't authorised, log them out, and prevent error redirection
            var userAuthorised = void 0;
            if (status === 401 || status === 403) {
              dispatch((0, _skysso.logout)());
              dispatch((0, _userService.resetSubscriptions)());
              userAuthorised = false;
            } else {
              userAuthorised = true;
            }

            // this component reports it is capable of handling its own errors.
            if (handleError) {
              // Make sure we can get a message to the server on initial render.
              // The client app will never use this state, only the server. Only makes
              // sense if we are going to handle the error.
              if (reportStatus) {
                dispatch((0, _server.setStatus)(status, error.message));
              }
            }

            // 404s have their own error page
            else if (status === 404) {
                dispatch((0, _reactRouterRedux.replace)('/error/404' + promiseState.routing.locationBeforeTransitions.pathname));
              }

              // if we've got this far, default to reporting a 500
              else if (userAuthorised) {
                  dispatch((0, _reactRouterRedux.replace)('/error/500/from' + promiseState.routing.locationBeforeTransitions.pathname));
                }
          });
        }
      }
    });

    if (refreshInterval) {
      // non-zero or a function
      refresh.push({ dispatch: dispatch, interval: refreshInterval, preserveRefresh: preserveRefresh, reset: reset, handleError: handleError });
    }

    if (state) {
      connections.push(state);
    }

    if (errorState) {
      errorConnections.push(errorState);
    }
  });

  return function (Decorated) {
    var _class, _temp;

    var AsyncConnectWrapper = (_temp = _class = function (_Decorated) {
      (0, _inherits3.default)(AsyncConnectWrapper, _Decorated);

      function AsyncConnectWrapper() {
        var _ref3;

        (0, _classCallCheck3.default)(this, AsyncConnectWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var _this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = AsyncConnectWrapper.__proto__ || (0, _getPrototypeOf2.default)(AsyncConnectWrapper)).call.apply(_ref3, [this].concat(args)));

        _this.activeTimeouts = [];
        _this.mounted = false;
        _this.unwatchTablet = function () {}; // initial noop

        var asyncError = !!_this.props.asyncError;
        _this.state = (0, _extends3.default)({}, _this.state, {
          asyncError: asyncError
        });
        return _this;
      }

      (0, _createClass3.default)(AsyncConnectWrapper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          var _this2 = this;

          if ((0, _get5.default)(AsyncConnectWrapper.prototype.__proto__ || (0, _getPrototypeOf2.default)(AsyncConnectWrapper.prototype), 'componentDidMount', this)) {
            var _get2;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            (_get2 = (0, _get5.default)(AsyncConnectWrapper.prototype.__proto__ || (0, _getPrototypeOf2.default)(AsyncConnectWrapper.prototype), 'componentDidMount', this)).call.apply(_get2, [this].concat(args));
          }

          this.unwatchTablet = (0, _mediaQueryHelpers.watchMediaQuery)("tablet", function () {
            refresh.forEach(function (_ref4) {
              var dispatch = _ref4.dispatch;

              // No need to have a callback here as its a single time action.
              _this2.dispatchWithCallback(dispatch, function () {});
            });
          });

          refresh.forEach(function (_ref5, index) {
            var dispatch = _ref5.dispatch,
                interval = _ref5.interval;

            _this2.activeTimeouts[index] = _this2.timeoutCallback(dispatch, interval, index);
          });

          // Set mounted AFTER media query watcher
          this.mounted = true;
        }
      }, {
        key: 'timeoutCallback',
        value: function timeoutCallback(dispatch, interval, index) {
          var _this3 = this;

          var delay = void 0;

          if (typeof interval == 'function') {
            var state = this.context.store.getState();
            var params = this.props.params;

            delay = interval({ state: state, params: params });
          } else {
            delay = interval;
          }

          if (delay) {
            return setTimeout(function () {

              // The callback should over write the timeout reference with a new one.
              _this3.dispatchWithCallback(dispatch, function () {
                _this3.activeTimeouts[index] = _this3.timeoutCallback(dispatch, interval, index);
              });
            }, delay);
          }
        }
      }, {
        key: 'dispatchWithCallback',
        value: function dispatchWithCallback(dispatch, callback) {
          var _this4 = this;

          if (this.mounted) {
            var getState = this.context.store.getState;

            var _props = this.props,
                _props$location = _props.location;
            _props$location = _props$location === undefined ? {} : _props$location;
            var _props$location$pathn = _props$location.pathname,
                pathname = _props$location$pathn === undefined ? "" : _props$location$pathn,
                _props$params = _props.params,
                params = _props$params === undefined ? {} : _props$params,
                dispatcher = _props.dispatch,
                routes = _props.routes;


            var promiseState = getState();

            var auth = promiseState.common.auth;

            // We do not know how the actual function operates to determine
            // if it should be executed or not, however if the component is hidden
            // we don't want to load its data. Check to see if the area of this component
            // meets visiblity criteria.

            var domElement = _reactDom2.default.findDOMNode(this);
            if (domElement) {
              var rect = domElement.getBoundingClientRect();

              var width = rect.right - rect.left;
              var height = rect.bottom - rect.top;
              var area = width * height;
              // Display threshold is that the component needs to be at least 1px wide or 1px in height.
              var isDisplayed = area > Math.min(height, width) ? true : false;

              if (isDisplayed) {
                dispatcher(dispatch({ dispatch: dispatch, getState: getState, state: promiseState, pathname: pathname, params: params, routes: routes, auth: auth })).then(function () {
                  return callback();
                }).catch(function (e) {
                  if (!isProduction) {
                    console.error("Error in Live Update", e); // eslint-disable-line no-console
                  }
                  _this4.componentError(e);
                  callback();
                });
              } else {
                callback();
              }
            }
          }
        }
      }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
          this.activeTimeouts.forEach(function (timeout) {
            clearTimeout(timeout);
          });
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          var _this5 = this;

          if ((0, _get5.default)(AsyncConnectWrapper.prototype.__proto__ || (0, _getPrototypeOf2.default)(AsyncConnectWrapper.prototype), 'componentWillUnmount', this)) {
            var _get3;

            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = arguments[_key3];
            }

            (_get3 = (0, _get5.default)(AsyncConnectWrapper.prototype.__proto__ || (0, _getPrototypeOf2.default)(AsyncConnectWrapper.prototype), 'componentWillUnmount', this)).call.apply(_get3, [this].concat(args));
          }
          this.mounted = false;
          this.unwatchTablet();
          this.clearTimeouts();
          refresh.forEach(function (_ref6) {
            var reset = _ref6.reset;

            if (reset) {
              _this5.props.dispatch(reset());
            }
          });
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          var _this6 = this;

          if ((0, _get5.default)(AsyncConnectWrapper.prototype.__proto__ || (0, _getPrototypeOf2.default)(AsyncConnectWrapper.prototype), 'componentWillReceiveProps', this)) {
            (0, _get5.default)(AsyncConnectWrapper.prototype.__proto__ || (0, _getPrototypeOf2.default)(AsyncConnectWrapper.prototype), 'componentWillReceiveProps', this).call(this, nextProps);
          }
          if (this.props.location.pathname !== nextProps.location.pathname) {
            refresh.forEach(function (_ref7, index) {
              var dispatch = _ref7.dispatch,
                  interval = _ref7.interval,
                  preserveRefresh = _ref7.preserveRefresh;

              if (!preserveRefresh) {
                clearTimeout(_this6.activeTimeouts[index]);
                _this6.activeTimeouts[index] = _this6.timeoutCallback(dispatch, interval, index);
              }
            });
          }
        }
      }, {
        key: 'componentError',
        value: function componentError(error) {
          if (refresh.some(function (_ref8) {
            var handleError = _ref8.handleError;
            return handleError;
          })) {
            this.setState({
              asyncError: true,
              error: error
            });
          }
        }
      }, {
        key: 'render',
        value: function render() {
          if (this.state.asyncError && typeof (0, _get5.default)(AsyncConnectWrapper.prototype.__proto__ || (0, _getPrototypeOf2.default)(AsyncConnectWrapper.prototype), 'renderError', this) === "function") {
            return (0, _get5.default)(AsyncConnectWrapper.prototype.__proto__ || (0, _getPrototypeOf2.default)(AsyncConnectWrapper.prototype), 'renderError', this).call(this);
          } else {
            try {
              return (0, _get5.default)(AsyncConnectWrapper.prototype.__proto__ || (0, _getPrototypeOf2.default)(AsyncConnectWrapper.prototype), 'render', this).call(this);
            } catch (e) {
              return (0, _get5.default)(AsyncConnectWrapper.prototype.__proto__ || (0, _getPrototypeOf2.default)(AsyncConnectWrapper.prototype), 'renderError', this).call(this, e);
            }
          }
        }
      }]);
      return AsyncConnectWrapper;
    }(Decorated), _class.contextTypes = {
      store: _propTypes2.default.object.isRequired
    }, _temp);


    return (0, _reduxConnect.asyncConnect)(asynced, function () {
      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return evaluateConnections(connections, errorConnections, args);
    })(AsyncConnectWrapper);
  };
}

function evaluateConnections(connections, errorConnections, args) {
  var states = {};
  connections.forEach(function (connection) {
    states = (0, _extends3.default)({}, states, connection.apply(undefined, (0, _toConsumableArray3.default)(args)));
  });
  errorConnections.forEach(function (connection) {
    states = (0, _extends3.default)({}, states, { asyncError: connection.apply(undefined, (0, _toConsumableArray3.default)(args)) });
  });
  return states;
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get10 = __webpack_require__(233);

var _get11 = _interopRequireDefault(_get10);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = __webpack_require__(147);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = catchLifeCycleErrors;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(138);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _showError = function _showError(e, target, superRenderError) {
  var renderArgs = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  if (superRenderError) {
    return superRenderError.apply(undefined, (0, _toConsumableArray3.default)(renderArgs));
  }

  var pathname = void 0;
  var _target$context = target.context;
  _target$context = _target$context === undefined ? {} : _target$context;
  var _target$context$store = _target$context.store;
  _target$context$store = _target$context$store === undefined ? {} : _target$context$store;
  var getState = _target$context$store.getState,
      storeDispatch = _target$context$store.dispatch,
      _target$props = target.props;
  _target$props = _target$props === undefined ? {} : _target$props;
  var _target$props$dispatc = _target$props.dispatch,
      dispatch = _target$props$dispatc === undefined ? storeDispatch : _target$props$dispatc,
      _target$props$locatio = _target$props.location;
  _target$props$locatio = _target$props$locatio === undefined ? {} : _target$props$locatio;
  var propsPath = _target$props$locatio.pathname;


  if (getState) {
    var _getState = getState();

    var _getState$routing = _getState.routing;
    _getState$routing = _getState$routing === undefined ? {} : _getState$routing;
    var _getState$routing$loc = _getState$routing.locationBeforeTransitions;
    _getState$routing$loc = _getState$routing$loc === undefined ? {} : _getState$routing$loc;
    var _getState$routing$loc2 = _getState$routing$loc.pathname;
    pathname = _getState$routing$loc2 === undefined ? propsPath : _getState$routing$loc2;
  }

  if (!pathname) {
    pathname = "/$unknown";
  }

  if (pathname == "/") {
    pathname = "/$home-page";
  }

  if (!_config2.default.isProduction) {
    console.error(e); // eslint-disable-line no-console
  }

  var title = "Server Error";
  var errorPixelSrc = '/1x1.gif?type=page&id=' + title + '&cb=' + Date.now();

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement('img', { src: errorPixelSrc, width: '1', height: '1' })
  );
};

function _wrapError(e, target, methodName) {
  target._classInError = (0, _assign2.default)(e, {
    message: e.message + ' (from ' + methodName + ')',
    from: methodName
  });
}

function catchLifeCycleErrors(ComponentClass) {
  if (!_react.Component.isPrototypeOf(ComponentClass)) {
    throw new Error("Cannot catch lifecycle methods of something that isn't a React Component");
  }

  var Decorated = function (_ComponentClass) {
    (0, _inherits3.default)(Decorated, _ComponentClass);

    // TODO add error handling to the constructor
    function Decorated() {
      var _ref;

      (0, _classCallCheck3.default)(this, Decorated);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Decorated.__proto__ || (0, _getPrototypeOf2.default)(Decorated)).call.apply(_ref, [this].concat(args)));

      _this._classInError = false;
      return _this;
    }

    (0, _createClass3.default)(Decorated, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        if ((0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'componentWillMount', this)) {
          try {
            var _get2;

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }

            (_get2 = (0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'componentWillMount', this)).call.apply(_get2, [this].concat(args));
          } catch (e) {
            _wrapError(e, this, "componentWillMount");
          }
        }
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if ((0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'componentDidMount', this)) {
          try {
            var _get3;

            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              args[_key3] = arguments[_key3];
            }

            (_get3 = (0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'componentDidMount', this)).call.apply(_get3, [this].concat(args));
          } catch (e) {
            _wrapError(e, this, "componentDidMount");
          }
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps() {
        if ((0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'componentWillReceiveProps', this)) {
          try {
            var _get4;

            for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              args[_key4] = arguments[_key4];
            }

            (_get4 = (0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'componentWillReceiveProps', this)).call.apply(_get4, [this].concat(args));
          } catch (e) {
            _wrapError(e, this, "componentWillReceiveProps");
          }
        }
      }
    }, {
      key: 'componentWillUpdate',
      value: function componentWillUpdate() {
        if ((0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'componentWillUpdate', this)) {
          try {
            var _get5;

            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
              args[_key5] = arguments[_key5];
            }

            (_get5 = (0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'componentWillUpdate', this)).call.apply(_get5, [this].concat(args));
          } catch (e) {
            _wrapError(e, this, "componentWillUpdate");
          }
        }
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        if ((0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'componentDidUpdate', this)) {
          try {
            var _get6;

            for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
              args[_key6] = arguments[_key6];
            }

            (_get6 = (0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'componentDidUpdate', this)).call.apply(_get6, [this].concat(args));
          } catch (e) {
            _wrapError(e, this, "componentDidUpdate");
          }
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if ((0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'componentWillUnmount', this)) {
          try {
            var _get7;

            for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
              args[_key7] = arguments[_key7];
            }

            (_get7 = (0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'componentWillUnmount', this)).call.apply(_get7, [this].concat(args));
          } catch (e) {
            _wrapError(e, this, "componentWillUnmount");
          }
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate() {
        if ((0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'shouldComponentUpdate', this)) {
          try {
            var _get8;

            for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
              args[_key8] = arguments[_key8];
            }

            return !!(_get8 = (0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'shouldComponentUpdate', this)).call.apply(_get8, [this].concat(args));
          } catch (e) {
            _wrapError(e, this, "shouldComponentUpdate");
            return false;
          }
        }

        return true;
      }
    }, {
      key: 'render',
      value: function render() {
        if (this._classInError) {
          return _showError(this._classInError, this, (0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'renderError', this));
        }

        if ((0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'render', this)) {
          for (var _len9 = arguments.length, args = Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
            args[_key9] = arguments[_key9];
          }

          try {
            var _get9;

            return (_get9 = (0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'render', this)).call.apply(_get9, [this].concat(args));
          } catch (e) {
            return _showError(e, this, (0, _get11.default)(Decorated.prototype.__proto__ || (0, _getPrototypeOf2.default)(Decorated.prototype), 'renderError', this), args);
          }
        }
      }
    }]);
    return Decorated;
  }(ComponentClass);

  return Decorated;
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.connect = exports.Provider = undefined;

var _Provider = __webpack_require__(1561);

var _Provider2 = _interopRequireDefault(_Provider);

var _connect = __webpack_require__(1562);

var _connect2 = _interopRequireDefault(_connect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.Provider = _Provider2["default"];
exports.connect = _connect2["default"];

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slugifyName = exports.toSlug = exports.slug = undefined;
exports.hrTimerToMilliseconds = hrTimerToMilliseconds;
exports.simpleStringCompare = simpleStringCompare;
exports.isServer = isServer;

var _slugify = __webpack_require__(1632);

var _slugify2 = _interopRequireDefault(_slugify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var slug = exports.slug = _slugify2.default;

var replaceHTMLRegex = /<[^>]+>/g;
var replaceNonAlphaNumericRegex = /[^a-zA-Z0-9À-ž-\s]/g;
var slugGen = function slugGen(t) {
  if (t && /\S/.test(t)) {
    return slug(t.replace(replaceHTMLRegex, ''), {
      replacement: '-',
      remove: replaceNonAlphaNumericRegex,
      lower: true
    });
  }

  return null;
};

var toSlug = exports.toSlug = function toSlug(t) {
  return slugGen(t) || "unknown";
};

var slugifyName = exports.slugifyName = function slugifyName(t) {
  return slugGen(t) || "";
};

function hrTimerToMilliseconds(timer) {
  return Math.round((timer[0] * 1e9 + timer[1]) / 1e6);
}

function simpleStringCompare(a, b) {
  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}

function isServer() {
  return typeof window === 'undefined' || typeof document === 'undefined';
}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.11';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });

        return result;
      }

      if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });

        return result;
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30), __webpack_require__(248)(module)))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightColumn = RightColumn;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _GooglePublisherTag = __webpack_require__(71);

var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);

var _GptProperties = __webpack_require__(51);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _MostReadAll = __webpack_require__(141);

var _MostReadAll2 = _interopRequireDefault(_MostReadAll);

var _RacingTips = __webpack_require__(116);

var _RacingTips2 = _interopRequireDefault(_RacingTips);

var _HorseRacingNextRaceOff = __webpack_require__(115);

var _HorseRacingNextRaceOff2 = _interopRequireDefault(_HorseRacingNextRaceOff);

var _FootballTips = __webpack_require__(140);

var _FootballTips2 = _interopRequireDefault(_FootballTips);

var _MostReadFootball = __webpack_require__(372);

var _MostReadFootball2 = _interopRequireDefault(_MostReadFootball);

var _MostReadRacing = __webpack_require__(203);

var _MostReadRacing2 = _interopRequireDefault(_MostReadRacing);

var _HorseRacingMostFollowed = __webpack_require__(80);

var _HorseRacingMostFollowed2 = _interopRequireDefault(_HorseRacingMostFollowed);

var _FootballLiveHomeVidiprinterContainer = __webpack_require__(383);

var _FootballLiveHomeVidiprinterContainer2 = _interopRequireDefault(_FootballLiveHomeVidiprinterContainer);

var _InsiderMpu = __webpack_require__(370);

var _InsiderMpu2 = _interopRequireDefault(_InsiderMpu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RightColumn(props) {
  var sport = props.sport,
      location = props.location,
      content = props.content;


  var blocks = {
    mostReadAll: {
      id: "right-most-read",
      component: _react2.default.createElement(_MostReadAll2.default, { location: location })
    },
    mostReadRacing: {
      id: "right-most-read-racing",
      component: _react2.default.createElement(_MostReadRacing2.default, { location: location })
    },
    mostReadFootball: {
      id: "right-most-read-football",
      component: _react2.default.createElement(_MostReadFootball2.default, { location: location })
    },
    topMpu: {
      id: "right-first-mpu",
      component: _react2.default.createElement(_GooglePublisherTag2.default, { adUnitPath: _GptProperties.topMPUProps.adUnitPath, type: _GptProperties.topMPUProps.type })
    },
    horseRacingNextRaceOff: {
      id: "right-next-race",
      component: _react2.default.createElement(_HorseRacingNextRaceOff2.default, { location: location, plainTitle: true })
    },
    horseRacingNextRaceOffAll: {
      id: "right-next-race-all",
      component: _react2.default.createElement(_HorseRacingNextRaceOff2.default, { location: location, plainTitle: true, displayAll: true })
    },
    racingTips: {
      id: "right-racing-tips",
      component: _react2.default.createElement(_RacingTips2.default, { location: location, plainTitle: true })
    },
    ocWidget: {
      id: "right-oc",
      component: _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: [sport, 'mpu'], additionalProperties: { view: sport } })
    },
    horseRacingMostFollowed: {
      id: "right-horse-racing-most-followed",
      component: _react2.default.createElement(_HorseRacingMostFollowed2.default, { location: location, plainTitle: true })
    },
    footballTips: {
      id: "right-football-tips",
      component: _react2.default.createElement(_FootballTips2.default, { location: location, plainTitle: true })
    },
    bottomMpu: {
      id: "right-bottom-mpu",
      component: _react2.default.createElement(_GooglePublisherTag2.default, { adUnitPath: _GptProperties.bottomMPUProps.adUnitPath, type: _GptProperties.bottomMPUProps.type })
    },
    vidiPrinter: {
      id: "right-vidiprinter",
      component: _react2.default.createElement(_FootballLiveHomeVidiprinterContainer2.default, { location: location })
    },
    insiderMpu: {
      id: "right-insider-mpu",
      component: _react2.default.createElement(_InsiderMpu2.default, null)
    }
  };

  return _react2.default.createElement(
    'div',
    { className: 'main-layout-right-column' },
    content.map(function (blockName, index) {
      var _blocks$blockName = blocks[blockName],
          id = _blocks$blockName.id,
          component = _blocks$blockName.component;

      var isLastItem = index === content.length - 1;
      var className = isLastItem ? "main-layout-block last-desktop" : "main-layout-block";

      return _react2.default.createElement(
        'div',
        { key: id, id: id, className: className },
        component
      );
    })
  );
}

RightColumn.propTypes = {
  location: _propTypes2.default.object.isRequired,
  sport: _propTypes2.default.string.isRequired,
  content: _propTypes2.default.array
};

RightColumn.defaultProps = {
  content: ["mostReadAll", "topMpu", "racingTips", "horseRacingNextRaceOff", "footballTips", "bottomMpu", "ocWidget"]
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StandardPage = StandardPage;

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _GooglePublisherTag = __webpack_require__(71);

var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);

var _GptProperties = __webpack_require__(51);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StandardPage(props) {
  var sport = props.sport,
      title = props.title,
      helmetProps = props.helmetProps;


  return _react2.default.createElement(
    'div',
    { className: 'main-layout ' + sport + '-home-page' },
    _react2.default.createElement(_MetaDataWrapper2.default, { title: title, helmetProps: helmetProps }),
    _react2.default.createElement(
      'div',
      { className: 'main-layout-banner', id: 'main-layout-banner' },
      _react2.default.createElement(_GooglePublisherTag2.default, { adUnitPath: _GptProperties.bannerAd.adUnitPath, type: _GptProperties.bannerAd.type, section: sport })
    ),
    _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["footer"], additionalProperties: { classname: "fresh8-banner", view: sport }, isFooter: true }),
    props.children
  );
}

StandardPage.propTypes = {
  sport: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  helmetProps: _propTypes2.default.object
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.titleTemplate = undefined;

var _defineProperty = __webpack_require__(305);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

exports.makeTitleTemplate = makeTitleTemplate;
exports.canonicalLink = canonicalLink;
exports.canonicalRel = canonicalRel;
exports.metaDescription = metaDescription;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _commonUtils = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Set of helpers for simplifying Helmet titleTemplate creation

function makeTitleTemplate(middle) {
  var titleTemplate = ["%s"];

  if (middle) {
    titleTemplate.push(middle);
  }

  titleTemplate.push(_config2.default.pageTitle.mainSuffix);

  return titleTemplate.join(" - ");
}

var titleTemplate = exports.titleTemplate = {
  get plain() {
    return makeTitleTemplate();
  }
};

var midfixList = _config2.default.pageTitle.midfix;
(0, _keys2.default)(midfixList).forEach(function (sport) {
  (0, _defineProperty2.default)(titleTemplate, sport, { get: function get() {
      return makeTitleTemplate(midfixList[sport]);
    } });
});

function canonicalLink(routeArray) {
  var paramList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var path = (0, _commonUtils.buildPath)(routeArray);
  (0, _keys2.default)(paramList).forEach(function (name) {
    path = path.replace(new RegExp(':' + name + '(\\b)', 'g'), paramList[name]);
  });

  return canonicalRel(path);
}

function canonicalRel(path) {
  return { link: [{
      rel: "canonical",
      href: '' + _config2.default.canonicalBase + path
    }] };
}

function metaDescription(content) {
  return { meta: [{
      name: "description",
      content: content
    }] };
}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1264);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(146);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1288), __esModule: true };

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(305);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1285), __esModule: true };

/***/ }),
/* 30 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _OddscheckerWidget = __webpack_require__(743);

var _OddscheckerWidget2 = _interopRequireDefault(_OddscheckerWidget);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _features = __webpack_require__(65);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdvertWrapper = function (_Component) {
    (0, _inherits3.default)(AdvertWrapper, _Component);

    function AdvertWrapper(props) {
        (0, _classCallCheck3.default)(this, AdvertWrapper);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AdvertWrapper.__proto__ || (0, _getPrototypeOf2.default)(AdvertWrapper)).call(this, props));

        _this.state = {
            hasOddscheckerIntegration: false
        };
        return _this;
    }

    (0, _createClass3.default)(AdvertWrapper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState({
                hasOddscheckerIntegration: (0, _features.has)("oddschecker-integration")
            });
        }
    }, {
        key: 'getSlot',
        value: function getSlot(conf, slotArray) {
            if (!conf) {
                return;
            }

            var innerSlots = slotArray.slice();
            if (innerSlots.length === 0) {
                return conf;
            }
            var element = innerSlots.shift();
            return this.getSlot(conf[element], innerSlots);
        }
    }, {
        key: 'render',
        value: function render() {
            var ocIdConfig = _config2.default.oddschecker.slotID;
            var ocId = this.getSlot(ocIdConfig, this.props.ocSlot);

            var showOddsChecker = ocId && this.state.hasOddscheckerIntegration;

            return showOddsChecker ? _react2.default.createElement(_OddscheckerWidget2.default, { hash: ocId, isFooter: this.props.isFooter }) : _react2.default.createElement('div', { className: 'ocwPlaceholder' });
        }
    }]);
    return AdvertWrapper;
}(_react.Component);

AdvertWrapper.propTypes = {
    isFooter: _propTypes2.default.bool,
    ocSlot: _propTypes2.default.array,
    additionalProperties: _propTypes2.default.object
};

AdvertWrapper.defaultProps = {
    isFooter: false,
    ocSlot: []
};

exports.default = AdvertWrapper;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.isBeforeOffStatus = isBeforeOffStatus;
exports.raceStatusLabel = raceStatusLabel;
exports.transformCasualty = transformCasualty;
exports.keepUpperCase = keepUpperCase;
exports.formatHorseAge = formatHorseAge;
exports.distanceFormat = distanceFormat;
exports.formatHeadgear = formatHeadgear;
exports.formatPosition = formatPosition;
exports.formatRaceDetails = formatRaceDetails;
exports.racecardHref = racecardHref;
exports.resultHref = resultHref;
exports.racecardResultHref = racecardResultHref;
exports.getProfileHelpers = getProfileHelpers;
exports.racingProfileLink = racingProfileLink;
exports.rideDetailsFromEntry = rideDetailsFromEntry;
exports.buildRuleFourString = buildRuleFourString;
exports.transformedRideDataFromArticleWidget = transformedRideDataFromArticleWidget;
exports.bracket = bracket;
exports.getSkyRef = getSkyRef;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _consts = __webpack_require__(46);

var _utils = __webpack_require__(18);

var _LocalDateTimeHelper = __webpack_require__(13);

var _widgets = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RACE_RESULT_STATUSES = {
  // before
  DORMANT: "Scheduled",
  DELAYED: "Delayed",
  PARADING: "Parading",
  GOINGDOWN: "Going Down",
  ATTHEPOST: "At The Post",
  GOINGBEHIND: "Going Behind",
  GOINGINSTALLS: "Going In Stalls",
  UNDERORDERS: "Under Orders",
  OFF: "Running",
  FALSESTART: "False Start",
  RACEVOID: "Race Void",
  ABANDONED: "Abandoned",

  // after
  FINISHED: "Finished",
  PHOTOGRAPH: "Photograph",
  RESULT: "Result",
  WEIGHEDIN: "Weighed In",
  AMENDEDRESULT: "Amended Result"
};

function isFinishedRaceStatus(stage) {
  return ['FINISHED', 'PHOTOGRAPH', 'RESULT', 'WEIGHEDIN'].indexOf(stage) !== -1;
}

function isBeforeOffStatus(stage) {
  return ["DORMANT", "DELAYED", "PARADING", "GOINGDOWN", "ATTHEPOST", "GOINGBEHIND", "GOINGINSTALLS", "UNDERORDERS"].indexOf(stage) !== -1;
}

function raceStatusLabel(status, stewards) {
  return RACE_RESULT_STATUSES[stewards] || RACE_RESULT_STATUSES[status] || status;
}

function transformCasualty(casualty) {
  var defaultCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "DNF";

  return _consts.HORSE_RACE_CASUALTIES[casualty] || defaultCode;
}

function keepUpperCase(s) {
  return s.replace(/[^A-Z]/g, '');
}

function formatHorseAge(age) {
  return (age || '').toLowerCase().replace(' only', '').replace(' plus', '+');
}

function distanceFormat(dist) {
  return (dist || '').replace(/^0m | 0f| 0y/g, "");
}

function formatHeadgear(headgears) {
  return headgears.filter(function (h) {
    return h.symbol && h.symbol.length > 0;
  }).map(function (h) {
    return '' + h.symbol + (h.count === 1 ? '1' : '');
  }).join();
}

function formatPosition(runner) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$defaultPosition = _ref.defaultPosition,
      defaultPosition = _ref$defaultPosition === undefined ? "-" : _ref$defaultPosition,
      defaultCasualtyCode = _ref.defaultCasualtyCode,
      _ref$showRunnerCount = _ref.showRunnerCount,
      showRunnerCount = _ref$showRunnerCount === undefined ? true : _ref$showRunnerCount;

  var positionString = void 0;

  var casualty = runner.casualty.reason,
      position = runner.position,
      amended_position = runner.amended_position,
      runner_count = runner.runner_count;


  if (amended_position || position) {
    positionString = amended_position || position;

    if (showRunnerCount && runner_count) {
      positionString = positionString + '/' + runner_count;
    }
  } else if (casualty) {
    positionString = transformCasualty(casualty, defaultCasualtyCode);
  } else {
    positionString = defaultPosition;
  }

  return positionString;
}

function formatRaceDetails(result) {
  var details = [];
  if (result.course_name) {
    details.push({ text: result.course_name, strong: true });
  }

  if (result.distance) {
    details.push({ text: result.distance });
  }

  if (result.going) {
    details.push({ text: result.going });
  }

  if (result.race_class) {
    details.push({ text: 'C' + result.race_class });
  }

  return details.map(function (d, i) {
    return d.strong ? _react2.default.createElement(
      'strong',
      { key: i },
      d.text
    ) : _react2.default.createElement(
      'span',
      { key: i },
      i ? ", " : "",
      d.text
    );
  });
}

function racecardHref(_ref2) {
  var race_id = _ref2.race_id,
      _ref2$race_name = _ref2.race_name,
      race_name = _ref2$race_name === undefined ? "unknown" : _ref2$race_name,
      date = _ref2.date,
      course_name = _ref2.course_name;

  return '/racing/racecards/' + date + '/' + (0, _utils.slugifyName)(course_name) + '/racecard/' + race_id + '/' + (0, _utils.slugifyName)(race_name);
}

function resultHref(_ref3) {
  var race_id = _ref3.race_id,
      _ref3$race_name = _ref3.race_name,
      race_name = _ref3$race_name === undefined ? "unknown" : _ref3$race_name,
      date = _ref3.date,
      course_name = _ref3.course_name;

  return '/racing/results/' + date + '/' + (0, _utils.slugifyName)(course_name) + '/' + race_id + '/' + (0, _utils.slugifyName)(race_name);
}

function racecardResultHref(raceDetails) {
  var raceStage = raceDetails.raceStage;


  return isFinishedRaceStatus(raceStage) ? resultHref(raceDetails) : racecardHref(raceDetails);
}

function getProfileHelpers(profile, earlyEntries) {
  var dataKey = void 0,
      formatDateTime = void 0,
      buildHref = void 0;

  if (earlyEntries) {
    dataKey = "future_entries";
    formatDateTime = function formatDateTime(result) {
      return (0, _LocalDateTimeHelper.localDateTimeShort)(result.date + ' ' + result.time);
    };
    buildHref = racecardHref;
  } else {
    dataKey = "previous_results";
    formatDateTime = function formatDateTime(result) {
      return (0, _LocalDateTimeHelper.localFullDateShort)(result.date);
    };
    buildHref = resultHref;
  }

  var _profile$dataKey = profile[dataKey],
      results = _profile$dataKey === undefined ? [] : _profile$dataKey;


  return { results: results, formatDateTime: formatDateTime, buildHref: buildHref };
}

function racingProfileLink(profileType, id) {
  return id && '/racing/profiles/' + profileType + '/' + id;
}

function rideDetailsFromEntry(entry) {
  var _entry$ride = entry.ride,
      externalRideReference = _entry$ride.ride_reference.external_reference,
      horseName = _entry$ride.horse.name,
      _entry$ride$betting = _entry$ride.betting,
      odds = _entry$ride$betting.current_odds,
      _entry$ride$betting$m = _entry$ride$betting.market_reference;
  _entry$ride$betting$m = _entry$ride$betting$m === undefined ? {} : _entry$ride$betting$m;
  var _entry$ride$betting$m2 = _entry$ride$betting$m.external_reference;
  _entry$ride$betting$m2 = _entry$ride$betting$m2 === undefined ? [] : _entry$ride$betting$m2;

  var _entry$ride$betting$m3 = (0, _slicedToArray3.default)(_entry$ride$betting$m2, 1),
      _entry$ride$betting$m4 = _entry$ride$betting$m3[0];

  _entry$ride$betting$m4 = _entry$ride$betting$m4 === undefined ? {} : _entry$ride$betting$m4;
  var marketId = _entry$ride$betting$m4.value,
      startingPriceAvailable = _entry$ride.has_sp,
      _entry$race = entry.race,
      _entry$race$race_summ = _entry$race.race_summary,
      _entry$race$race_summ2 = _entry$race$race_summ.race_summary_reference,
      externalRaceReference = _entry$race$race_summ2.external_reference,
      raceId = _entry$race$race_summ2.id,
      raceDate = _entry$race$race_summ.date,
      raceTime = _entry$race$race_summ.time,
      courseName = _entry$race$race_summ.course_name,
      raceStage = _entry$race$race_summ.race_stage,
      raceName = _entry$race$race_summ.name,
      eachWay = _entry$race.each_way,
      suspended = _entry$race.market_suspended,
      fixture = _entry$race.fixture;


  var betlinkIds = externalRideReference.filter(function (r) {
    return r.ref === 'skybet';
  }).map(function (r) {
    return r.value;
  });
  var raceSkyBetIds = externalRaceReference.filter(function (r) {
    return r.ref === 'skybet';
  }).map(function (r) {
    return r.value;
  });
  var raceExternalId = raceSkyBetIds.length > 0 ? raceSkyBetIds[0] : '';
  var displayTime = (0, _LocalDateTimeHelper.localTimeShort)(raceDate + 'T' + raceTime + 'Z');
  var eventName = displayTime + ' ' + courseName;

  var betlinkProps = void 0;
  if (odds) {
    betlinkProps = {
      marketId: marketId,
      eventId: raceExternalId,
      eventName: eventName,
      eventCompetition: courseName, // only relevant for feature "integrated-betslip"
      dateTime: raceDate + ' ' + raceTime,
      sport: "horseRacing",
      betId: betlinkIds[0],
      betName: horseName,
      odds: odds,
      eachWay: eachWay, // only relevant for feature "integrated-betslip"
      suspended: suspended, // only relevant for feature "integrated-betslip"
      fixture: fixture, // only relevant for feature "integrated-betslip"
      startingPriceAvailable: startingPriceAvailable // only relevant for feature "integrated-betslip"
    };
  }

  var raceLinkDetails = {
    raceStage: raceStage,
    eventName: eventName,
    race_id: raceId,
    race_name: raceName,
    date: raceDate,
    course_name: courseName
  };

  return { raceLinkDetails: raceLinkDetails, betlinkProps: betlinkProps };
}

function buildRuleFourString(deduction) {
  var type = void 0;
  switch (deduction.type) {
    case "BoardPrices":
      type = "board prices only";
      break;
    case "AllBets":
      type = "all bets";
      break;
    default:
      return "No rule 4 in effect"; // Only displayed if illegal value was returned
  }
  return 'Rule 4 applies to ' + type + ' - deduction ' + deduction.value + 'p in the pound';
}

function transformedRideDataFromArticleWidget(widget, races) {
  var _getWidgetValues = (0, _widgets.getWidgetValues)(widget, ["ride_id", "race_id"]),
      ride_id = _getWidgetValues.ride_id,
      race_id = _getWidgetValues.race_id;

  if (!ride_id || !race_id) {
    return;
  }

  if (!races) {
    return;
  }

  var _races$filter = races.filter(function () {
    var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$race_summary = _ref4.race_summary;

    _ref4$race_summary = _ref4$race_summary === undefined ? {} : _ref4$race_summary;
    var _ref4$race_summary$ra = _ref4$race_summary.race_summary_reference;
    _ref4$race_summary$ra = _ref4$race_summary$ra === undefined ? {} : _ref4$race_summary$ra;
    var id = _ref4$race_summary$ra.id;
    return id == race_id;
  }),
      _races$filter2 = (0, _slicedToArray3.default)(_races$filter, 1),
      raceData = _races$filter2[0];

  if (!raceData) {
    return;
  }

  var _raceData$rides$filte = raceData.rides.filter(function () {
    var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref5$ride_reference = _ref5.ride_reference;

    _ref5$ride_reference = _ref5$ride_reference === undefined ? {} : _ref5$ride_reference;
    var id = _ref5$ride_reference.id;
    return id == ride_id;
  }),
      _raceData$rides$filte2 = (0, _slicedToArray3.default)(_raceData$rides$filte, 1),
      rideData = _raceData$rides$filte2[0];

  if (!rideData) {
    return;
  }

  var raceSummary = raceData.race_summary,
      _raceData$race_summar = raceData.race_summary;
  _raceData$race_summar = _raceData$race_summar === undefined ? {} : _raceData$race_summar;
  var _raceData$race_summar2 = _raceData$race_summar.race_summary_reference,
      race_summary_reference = _raceData$race_summar2 === undefined ? {} : _raceData$race_summar2,
      eachWay = raceData.each_way,
      fixture = raceData.fixture,
      suspended = raceData.market_suspended;
  var status = rideData.ride_status,
      saddleClothNo = rideData.cloth_number,
      drawNumber = rideData.draw_number,
      amended_position = rideData.amended_position,
      finish_position = rideData.finish_position,
      horse = rideData.horse,
      _rideData$horse = rideData.horse;
  _rideData$horse = _rideData$horse === undefined ? {} : _rideData$horse;
  var _rideData$horse$forms = _rideData$horse.formsummary;
  _rideData$horse$forms = _rideData$horse$forms === undefined ? {} : _rideData$horse$forms;
  var form = _rideData$horse$forms.display_text,
      horseName = _rideData$horse.name,
      horseLastRan = _rideData$horse.last_ran_days,
      horseAge = _rideData$horse.age,
      last_run_video = _rideData$horse.last_run_video,
      formWatch = rideData.formwatch,
      headgear = rideData.headgear,
      raceHistoryStats = rideData.race_history_stats,
      weightPenalty = rideData.weight_penalty,
      weight = rideData.handicap,
      rideDesc = rideData.ride_description,
      ride_reference = rideData.ride_reference,
      trainer = rideData.trainer,
      jockey = rideData.jockey,
      jockey_claim = rideData.jockey_claim,
      officialRating = rideData.official_rating,
      _rideData$betting = rideData.betting;
  _rideData$betting = _rideData$betting === undefined ? {} : _rideData$betting;
  var odds = _rideData$betting.current_odds,
      market_reference = _rideData$betting.market_reference,
      silkFilename = rideData.silk_filename,
      startingPriceAvailable = rideData.has_sp;


  return {
    runner: {
      key: ride_id,
      status: status,
      saddleClothNo: saddleClothNo,
      drawNumber: drawNumber,
      position: (amended_position || finish_position) + ' ' + bracket(drawNumber),
      form: form,
      commentary: "", // not used by embedded card
      formWatch: formWatch,
      headgear: headgear,
      raceHistoryStats: raceHistoryStats,
      weightPenalty: weightPenalty,
      horse: horse,
      horseName: horseName,
      horseLastRan: horseLastRan,
      horseAge: horseAge,
      lastRunVideo: last_run_video ? [last_run_video] : [],
      weight: weight,
      rideDesc: rideDesc,
      rideBetlinkIds: [getSkyRef(ride_reference)],
      trainer: trainer,
      jockey: jockey,
      jockeyClaim: bracket(jockey_claim),
      officialRating: officialRating,
      odds: odds,
      marketId: getSkyRef(market_reference),
      silkFilename: silkFilename,
      startingPriceAvailable: startingPriceAvailable
    },
    raceSummary: raceSummary,
    eventRef: getSkyRef(race_summary_reference),
    eachWay: eachWay,
    fixture: fixture,
    suspended: suspended
  };
}

function bracket(t) {
  return t ? '(' + t + ')' : '';
}

function getSkyRef() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref6$external_refere = _ref6.external_reference,
      external_reference = _ref6$external_refere === undefined ? [] : _ref6$external_refere;

  var _external_reference$f = external_reference.filter(function (r) {
    return r.ref === 'skybet';
  }),
      _external_reference$f2 = (0, _slicedToArray3.default)(_external_reference$f, 1),
      _external_reference$f3 = _external_reference$f2[0];

  _external_reference$f3 = _external_reference$f3 === undefined ? {} : _external_reference$f3;
  var value = _external_reference$f3.value;

  return value;
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(230)('wks');
var uid = __webpack_require__(131);
var Symbol = __webpack_require__(19).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 34 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(480);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(7);

var _extends5 = _interopRequireDefault(_extends4);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = __webpack_require__(132);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.noNullDeepClone = noNullDeepClone;
exports.parseCssExports = parseCssExports;
exports.globalCssExports = globalCssExports;
exports.preventLinkScroll = preventLinkScroll;
exports.getSection = getSection;
exports.buildPath = buildPath;
exports.consumerUrl = consumerUrl;
exports.getDecodedQueryString = getDecodedQueryString;
exports.getActionParam = getActionParam;
exports.isMobileApp = isMobileApp;
exports.getXsellUrl = getXsellUrl;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Sometimes we get data with explicit nulls.
This can cause issues (not least with destructuring), so lets have a function
that strips them out.

*/
function noNullDeepClone(srcObject) {
  var cloned = void 0;

  function copy(key) {
    var value = srcObject[key];


    if (value !== null && value !== undefined) {
      if ((typeof value === "undefined" ? "undefined" : (0, _typeof3.default)(value)) == "object") {
        cloned[key] = noNullDeepClone(value);
      } else {
        cloned[key] = value;
      }
    }
  }

  if (srcObject instanceof Array) {
    var length = srcObject.length;

    cloned = Array(length);

    srcObject.forEach(function (v, key) {
      return copy(key);
    });
  } else if (srcObject instanceof Object) {
    cloned = {};

    (0, _keys2.default)(srcObject).forEach(function (key) {
      return copy(key);
    });
  } else {
    cloned = srcObject;
  }

  return cloned;
}

/*
The Webpack CSS loader can read exports from the CSS. It returns an object, flattening the keys with dashes as necessary;

The values are Strings exactly from the CSS, so to allow types, they should be JSON encoded (ie the CSS should closely resemble JS)

eg starting with this in "my.scss";

:export {
  count: 1;
  names: {
    bob: "Robert Smith";
    alice: "Alice Jones";
  }
}

calling parseCssExports(require("my.scss")) will yeild;

{
  "count": 1,
  "names-bob": "Robert Smith",
  "names-alice": "Alice Jones"
}

Without the quotes in the CSS, the parse would throw an error.

Is is possible to override the JSON.parse default behaviour by passing in an alternative transform option.

So calling parseCssExports(require("my.scss"), {transform: v => v}) on the above example source CSS will yeild;

{
  "count": "1",
  "names-bob": "\"Robert Smit\"",
  "names-alice": "\"Alice Jones\""
}

If a prefix option is given, only those keys that started with the prefix (dash separated from the rest) give values
in the result, with the prefix stripped from the key.

So calling parseCssExports(require("my.scss"), {prefix: "names"}) on the above example source CSS will yeild;

{
  "bob": "Robert Smith",
  "alice": "Alice Jones"
}

Note that you have to call require with a string, or it will not work.


*/
function parseCssExports(sourceObj) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      prefix = _ref.prefix,
      _ref$transform = _ref.transform,
      transform = _ref$transform === undefined ? JSON.parse : _ref$transform;

  var parsedValues = (0, _keys2.default)(sourceObj);

  if (prefix) {
    parsedValues = parsedValues.filter(function (k) {
      return k.substring(0, prefix.length + 1) == prefix + "-";
    });
  }

  parsedValues = parsedValues.map(function (k) {
    return [k, prefix && k.substring(prefix.length + 1)];
  }).reduce(function (o, _ref2) {
    var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
        srcKey = _ref3[0],
        parsedKey = _ref3[1];

    return (0, _extends5.default)({}, o, (0, _defineProperty3.default)({}, parsedKey || srcKey, transform(sourceObj[srcKey])));
  }, {});

  return parsedValues;
}

var globalExports = __webpack_require__(1463);

function globalCssExports(prefix) {
  return parseCssExports(globalExports, { prefix: prefix });
}

// Use this to wrap an href in a <Link to> to prevent the scroll to top behaviour for that link
function preventLinkScroll(href) {
  return {
    pathname: href,
    state: {
      preventScroll: true
    }
  };
}

function getSection() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
      _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
      _ref5$ = _ref5[1];

  _ref5$ = _ref5$ === undefined ? {} : _ref5$;
  var _ref5$$path = _ref5$.path,
      path = _ref5$$path === undefined ? "home" : _ref5$$path;
  // arg is routes array
  return path;
}

function buildPath() {
  var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return routes.reduce(function (fullPath, _ref6) {
    var _ref6$path = _ref6.path,
        path = _ref6$path === undefined ? '' : _ref6$path;
    return path ? fullPath + "/" + path : fullPath;
  }, '/').replace(/\/{2,}/, '/');
}

function consumerUrl() {
  var _window$location = window.location,
      origin = _window$location.origin,
      protocol = _window$location.protocol,
      hostname = _window$location.hostname,
      port = _window$location.port;


  var out = origin || protocol + "//" + hostname + (port ? ":" + port : '');

  if (out.endsWith(".dev")) {
    return out.replace(".dev", ".com");
  }

  return out;
}

// Simple decoder for a flat list fo URL query string params as they exist *right now*
// The params that started this session (but need not still be there) are stored in Redux
function getDecodedQueryString() {
  var _global = global,
      _global$location = _global.location;
  _global$location = _global$location === undefined ? {} : _global$location;
  var _global$location$sear = _global$location.search,
      search = _global$location$sear === undefined ? "" : _global$location$sear,
      _global$decodeURIComp = _global.decodeURIComponent,
      decodeURIComponent = _global$decodeURIComp === undefined ? function (i) {
    return i;
  } : _global$decodeURIComp;


  return search.substring(1).split("&").reduce(function (o, pair) {
    var _pair$split = pair.split("="),
        _pair$split2 = (0, _slicedToArray3.default)(_pair$split, 2),
        key = _pair$split2[0],
        _pair$split2$ = _pair$split2[1],
        value = _pair$split2$ === undefined ? "" : _pair$split2$;

    if (key) {
      return (0, _extends5.default)({}, o, (0, _defineProperty3.default)({}, key, decodeURIComponent(value.replace(/\+/g, "%20"))));
    }

    return o;
  }, {});
}

// Actions are query string params that some buttons can look for
// The key is the action name, and the value is the required action params, separated by |
// eg a subscription button can look for params like ?subscribe=TYPE|id (eg ?subscribe=HORSE|1234)
function getActionParam(action) {
  var _getDecodedQueryStrin = getDecodedQueryString(),
      _getDecodedQueryStrin2 = _getDecodedQueryStrin[action],
      value = _getDecodedQueryStrin2 === undefined ? "" : _getDecodedQueryStrin2;

  return value.split("|");
}

var MOBILE_APP_BROWSER_AGENT_IDENTIFIER = "Sky SportingLife Mobile App";

function isMobileApp(agent) {
  return agent && agent.toLowerCase().indexOf(MOBILE_APP_BROWSER_AGENT_IDENTIFIER.toLowerCase()) >= 0;
}

var BASE_SSO_REDIRECT_URL = "https://www.skybet.com/secure/identity/referral/";

function getXsellUrl(referralUrl, ssoConsumer) {
  return ssoConsumer ? "" + BASE_SSO_REDIRECT_URL + ssoConsumer + "?referralUrl=" + encodeURIComponent(referralUrl) : referralUrl;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genericRoute = undefined;

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.isLinkActive = isLinkActive;
exports.activeClassName = activeClassName;
exports.getPropertyFromRoutes = getPropertyFromRoutes;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _ArticleContainer = __webpack_require__(216);

var _ArticleContainer2 = _interopRequireDefault(_ArticleContainer);

var _Article = __webpack_require__(173);

var _Article2 = _interopRequireDefault(_Article);

var _MoreNews = __webpack_require__(93);

var _MoreNews2 = _interopRequireDefault(_MoreNews);

var _MostReadAll = __webpack_require__(141);

var _MostReadAll2 = _interopRequireDefault(_MostReadAll);

var _HomeFootballVidiprinter = __webpack_require__(398);

var _HomeFootballVidiprinter2 = _interopRequireDefault(_HomeFootballVidiprinter);

var _SectionLink = __webpack_require__(202);

var _SectionLink2 = _interopRequireDefault(_SectionLink);

var _RacingTips = __webpack_require__(116);

var _RacingTips2 = _interopRequireDefault(_RacingTips);

var _FootballTips = __webpack_require__(140);

var _FootballTips2 = _interopRequireDefault(_FootballTips);

var _HorseRacingNextRaceOff = __webpack_require__(115);

var _HorseRacingNextRaceOff2 = _interopRequireDefault(_HorseRacingNextRaceOff);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _GptAdvert = __webpack_require__(101);

var _GptAdvert2 = _interopRequireDefault(_GptAdvert);

var _GooglePublisherTag = __webpack_require__(71);

var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);

var _sitemapHelper = __webpack_require__(217);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GenericRHSComponents = {
  MostReadAll: _MostReadAll2.default,
  HomeFootballVidiprinter: _HomeFootballVidiprinter2.default,
  SectionLink: _SectionLink2.default,
  RacingTips: _RacingTips2.default,
  FootballTips: _FootballTips2.default,
  HorseRacingNextRaceOff: _HorseRacingNextRaceOff2.default,
  AdvertWrapper: _AdvertWrapper2.default,
  GptAdvert: _GptAdvert2.default,
  GooglePublisherTag: _GooglePublisherTag2.default
};

var genericRoute = exports.genericRoute = function genericRoute(homeComponent, navComponent, routePath) {
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: routePath, subnav: navComponent },
    _react2.default.createElement(
      _reactRouter.Route,
      { component: homeComponent },
      ' ',
      _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: (0, _extends3.default)({ MoreNews: _MoreNews2.default }, GenericRHSComponents) }),
      ' '
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'news/:title/:articleId', component: _ArticleContainer2.default },
      ' ',
      _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: { expand: (0, _sitemapHelper.newsArticleExpander)(routePath) }, components: (0, _extends3.default)({ Article: _Article2.default }, GenericRHSComponents) }),
      ' '
    )
  );
};

// More sophisticated alternative to the activeClassName property of react-router's <Link> to allow the link to be "active" for several
// alternative URLs, and for some URLs to prevent the link being active if it otherwise would have been.
// 1st arg is the router - destructuring safety is a hack for tests
// 2nd arg is a link spec, with the following properties
//    href: mandatory url. This will normally be the destination URL of the link being tested.
//    isIndex: optional boolean (default false) to denote if the link should only match exactly
//    alternatives: optional array of objects with href and isIndex properties as above. Add to this to highlight the link for urls other than the links destination
//    exceptions: optional array of objects with href and isIndex properties as above. Add to this to prevent the link being highlighted for some urls that would otherwise have matched
// Testing for a match is done by react-router in the same way as<Link>.
function isLinkActive() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$isActive = _ref2.isActive,
      isActive = _ref2$isActive === undefined ? function () {
    return false;
  } : _ref2$isActive;

  var _ref = arguments[1];
  var _ref$href = _ref.href,
      href = _ref$href === undefined ? '' : _ref$href,
      _ref$isIndex = _ref.isIndex,
      isIndex = _ref$isIndex === undefined ? false : _ref$isIndex,
      _ref$alternatives = _ref.alternatives,
      alternatives = _ref$alternatives === undefined ? [] : _ref$alternatives,
      _ref$exceptions = _ref.exceptions,
      exceptions = _ref$exceptions === undefined ? [] : _ref$exceptions;

  // add the link spec to the list of inclusions
  var inclusions = [{ href: href, isIndex: isIndex }].concat((0, _toConsumableArray3.default)(alternatives));

  // check for all possible positive matches
  var linkIsActive = inclusions.reduce(function (progress, _ref3) {
    var href = _ref3.href,
        isIndex = _ref3.isIndex;
    return progress || isActive(href, isIndex);
  }, false);

  // then check for any exceptions. Will be shortcut is isActive is already false
  linkIsActive = exceptions.reduce(function (progress, _ref4) {
    var href = _ref4.href,
        isIndex = _ref4.isIndex;
    return progress && !isActive(href, isIndex);
  }, linkIsActive);

  return linkIsActive;
}

function activeClassName(router, item, activeClassName, staticClassName) {
  var classList = [];
  var linkIsActive = isLinkActive(router, item);

  if (linkIsActive) {
    classList.push(activeClassName);
  }

  if (staticClassName) {
    classList.push(staticClassName);
  }

  return classList.join(" ");
}

function getPropertyFromRoutes(routes, propertyName) {
  var found = routes.filter(function (r) {
    return r[propertyName];
  });

  var _found = (0, _slicedToArray3.default)(found, 1),
      _found$ = _found[0];

  _found$ = _found$ === undefined ? {} : _found$;
  var propertyValue = _found$[propertyName];


  return propertyValue;
}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(25)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var IE8_DOM_DEFINE = __webpack_require__(455);
var toPrimitive = __webpack_require__(86);
var dP = Object.defineProperty;

exports.f = __webpack_require__(39) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(85);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(53);
var core = __webpack_require__(34);
var ctx = __webpack_require__(96);
var hide = __webpack_require__(105);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var carets = {
  full: {
    up: {
      viewBox: "0 0 30 18",
      path: "M29.728 15.683l-.17-.197L16.81.806C16.38.31 15.732 0 15.01 0c-.72 0-1.367.32-1.8.807L.47 15.457l-.215.245c-.16.234-.253.516-.253.816C0 17.334.694 18 1.556 18h26.888c.862 0 1.556-.666 1.556-1.482 0-.31-.103-.6-.272-.835"
    },
    down: {
      viewBox: "0 0 30 18",
      path: "M29.728 2.317l-.17.197-12.75 14.68c-.43.496-1.077.806-1.8.806-.72 0-1.367-.32-1.8-.807L.47 2.543l-.215-.245C.093 2.064 0 1.782 0 1.482 0 .666.694 0 1.556 0h26.888C29.306 0 30 .666 30 1.482c0 .31-.103.6-.272.835"
    },
    left: {
      viewBox: "0 0 18 30",
      path: "M15.683 29.728l-.197-.17L.806 16.81C.31 16.38 0 15.732 0 15.01c0-.72.32-1.367.807-1.8L15.457.47l.245-.215c.234-.16.516-.253.816-.253C17.334 0 18 .694 18 1.556v26.888c0 .862-.666 1.556-1.482 1.556-.31 0-.6-.103-.835-.272"
    },
    right: {
      viewBox: "0 0 18 30",
      path: "M2.317 29.728l.197-.17 14.68-12.75c.496-.43.806-1.077.806-1.8 0-.72-.32-1.367-.807-1.8L2.543.47 2.297.254C2.064.093 1.782 0 1.482 0 .666 0 0 .694 0 1.556v26.888C0 29.306.666 30 1.482 30c.31 0 .6-.103.835-.272"
    }
  },
  line: {
    up: {
      viewBox: "0 0 30 18",
      path: "M14.995 5.733l11.663 11.194c.288.282.764.275 1.058-.013l2.05-2.002c.294-.288.3-.756.012-1.038L15.538.204c-.148-.15-.35-.216-.543-.202-.2-.007-.395.06-.542.2L.213 13.875c-.29.282-.282.75.012 1.038l2.05 2.002c.293.288.77.295 1.057.013L14.995 5.733z"
    },
    down: {
      viewBox: "0 0 30 18",
      path: "M14.995 11.407L26.658.213c.288-.282.764-.275 1.058.013l2.05 2.002c.294.288.3.756.012 1.038l-14.24 13.67c-.148.15-.35.216-.543.202-.2.007-.395-.06-.542-.2L.213 3.265c-.29-.282-.282-.75.012-1.038L2.275.226c.293-.288.77-.295 1.057-.013l11.663 11.194z"
    },
    left: {
      viewBox: "0 0 18 30",
      path: "M5.74 14.99L16.936 3.333c.28-.288.275-.763-.013-1.058L14.92.224c-.288-.293-.756-.3-1.038-.012L.208 14.455c-.147.147-.214.348-.2.543-.007.2.06.395.2.542l13.674 14.237c.282.288.75.28 1.038-.014l2.003-2.05c.288-.294.294-.77.013-1.057L5.74 14.99z"
    },
    right: {
      viewBox: "0 0 18 30",
      path: "M11.403 14.99L.207 3.333c-.28-.288-.275-.763.013-1.058L2.222.224c.288-.293.757-.3 1.038-.012l13.675 14.243c.147.147.214.348.2.543.007.2-.06.395-.2.542L3.26 29.777c-.28.288-.75.28-1.038-.014L.22 27.713c-.288-.294-.294-.77-.013-1.057L11.403 14.99z"
    }
  }
};

function CaretIcon(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === undefined ? "full" : _ref$type,
      _ref$direction = _ref.direction,
      direction = _ref$direction === undefined ? "right" : _ref$direction;
  var _carets$type = carets[type];
  _carets$type = _carets$type === undefined ? {} : _carets$type;
  var caret = _carets$type[direction];


  if (!caret) {
    throw new Error('Invalid CaretIcon requested: ' + type + ' ' + direction);
  }

  return _react2.default.createElement(
    'svg',
    { className: 'caret-icon', viewBox: caret.viewBox, xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: caret.path, fillRule: 'evenodd' })
  );
}

CaretIcon.propTypes = {
  height: _propTypes2.default.number,
  width: _propTypes2.default.number,
  type: _propTypes2.default.string.isRequired,
  direction: _propTypes2.default.string.isRequired
};

exports.default = CaretIcon;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadSubscriptions = loadSubscriptions;
exports.saveSubscriptions = saveSubscriptions;
exports.deleteSubscriptions = deleteSubscriptions;
exports.resetSubscriptions = resetSubscriptions;
exports.userServiceLayoutConnect = userServiceLayoutConnect;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SAVE_LOAD_SUBSCRIPTIONS = 'userService/selections/SAVE_LOAD_SUBSCRIPTIONS';
var SAVE_LOAD_SUBSCRIPTIONS_SUCCESS = 'userService/selections/SAVE_LOAD_SUBSCRIPTIONS_SUCCESS';
var SAVE_LOAD_SUBSCRIPTIONS_FAIL = 'userService/selections/SAVE_LOAD_SUBSCRIPTIONS_FAIL';

var DELETE_SUBSCRIPTIONS = 'userService/selections/DELETE_SUBSCRIPTIONS';
var DELETE_SUBSCRIPTIONS_SUCCESS = 'userService/selections/DELETE_SUBSCRIPTIONS_SUCCESS';
var DELETE_SUBSCRIPTIONS_FAIL = 'userService/selections/DELETE_SUBSCRIPTIONS_FAIL';

var RESET_SUBSCRIPTIONS = 'userService/subscriptions/RESET_SUBSCRIPTIONS';

var initialState = {
  loading: false,
  loaded: false,
  subscriptions: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SAVE_LOAD_SUBSCRIPTIONS:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case SAVE_LOAD_SUBSCRIPTIONS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        subscriptions: mergeSubscriptions(state.subscriptions, action.result.subscription)
      });
    case SAVE_LOAD_SUBSCRIPTIONS_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error.body,
        status: action.error.status
      });
    case DELETE_SUBSCRIPTIONS:
      return (0, _extends3.default)({}, state);
    case DELETE_SUBSCRIPTIONS_SUCCESS:
      return (0, _extends3.default)({}, state, {
        subscriptions: removeSubscriptions(state.subscriptions, action.subscription)
      });
    case DELETE_SUBSCRIPTIONS_FAIL:
      return (0, _extends3.default)({}, state, {
        error: action.error.body,
        status: action.error.status
      });
    case RESET_SUBSCRIPTIONS:
      return initialState;
    default:
      return state;
  }
}

function mergeSubscriptions() {
  var stateSubscriptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var flatSubscriptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var structuredSubs = (0, _extends3.default)({}, stateSubscriptions);

  flatSubscriptions.forEach(function (subscription) {
    var subId = subscription.user_subscription_id,
        id = subscription.subscription_id,
        type = subscription.subscription_type,
        text = subscription.display_text;


    if (!structuredSubs[type]) {
      structuredSubs[type] = {};
    }
    structuredSubs[type][id] = { text: text, subId: subId };
  });

  return structuredSubs;
}

function removeSubscriptions() {
  var stateSubscriptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var flatSubscriptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var removableSubs = (0, _extends3.default)({}, stateSubscriptions);

  flatSubscriptions.forEach(function (subscription) {
    var id = subscription.id,
        type = subscription.type;


    if (removableSubs[type] && removableSubs[type][id]) {
      delete removableSubs[type][id];
    }
  });

  return removableSubs;
}

function loadSubscriptions(auth) {
  return {
    types: [SAVE_LOAD_SUBSCRIPTIONS, SAVE_LOAD_SUBSCRIPTIONS_SUCCESS, SAVE_LOAD_SUBSCRIPTIONS_FAIL],
    promise: function promise(client) {
      return client.post(_config2.default.api.common.userService.loadSubscriptions, { data: loadSubscriptionsTemplate(auth) }, { Authorization: auth.user.ssoToken });
    }
  };
}

function saveSubscriptions(auth, subscription) {
  return {
    types: [SAVE_LOAD_SUBSCRIPTIONS, SAVE_LOAD_SUBSCRIPTIONS_SUCCESS, SAVE_LOAD_SUBSCRIPTIONS_FAIL],
    promise: function promise(client) {
      return client.post(_config2.default.api.common.userService.saveSubscriptions, { data: saveSubscriptionsTemplate(auth, subscription) }, { Authorization: auth.user.ssoToken });
    }
  };
}

function deleteSubscriptions(_ref, subscriptions) {
  var _ref$user = _ref.user;
  _ref$user = _ref$user === undefined ? {} : _ref$user;
  var ssoToken = _ref$user.ssoToken;

  return {
    types: [DELETE_SUBSCRIPTIONS, DELETE_SUBSCRIPTIONS_SUCCESS, DELETE_SUBSCRIPTIONS_FAIL],
    promise: function promise(client) {
      return _promise2.default.all(subscriptions.map(function (_ref2) {
        var _ref2$subId = _ref2.subId,
            subId = _ref2$subId === undefined ? 0 : _ref2$subId;
        return client.del(_config2.default.api.common.userService.deleteSubscriptions + '/' + subId, {}, { Authorization: ssoToken });
      }));
    },
    subscription: subscriptions
  };
}

function resetSubscriptions() {
  return {
    type: RESET_SUBSCRIPTIONS
  };
}

function loadSubscriptionsTemplate(_ref3) {
  var user = _ref3.user;

  if (user) {
    return {
      user: {
        user_reference: {
          external_reference: [{ ref: 'skybet', value: user.customerId }]
        },
        email: user.email,
        roles: [{ name: 'PUNTER' }]
      },
      filter: ['HORSE', 'JOCKEY', 'TRAINER', 'RACE', 'FOOTBALL_MATCH']
    };
  }
  return {};
}

function saveSubscriptionsTemplate(_ref4, subscriptions) {
  var user = _ref4.user,
      deviceId = _ref4.deviceId;

  if (user) {
    return {
      user: {
        user_reference: {
          external_reference: [{ ref: 'skybet', value: user.customerId }]
        },
        email: user.email,
        roles: [{ name: 'PUNTER' }],
        devices: [{ push_id: deviceId }]
      },
      subscription: subscriptions.map(function (sub) {
        return {
          subscription_id: sub.id,
          subscription_type: sub.type,
          display_text: sub.text
        };
      })
    };
  }
  return {};
}

function userServiceLayoutConnect() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      state = _ref5.state,
      then = _ref5.then;

  var connectSpec = {
    dispatch: function dispatch(_ref6) {
      var auth = _ref6.auth;
      return loadSubscriptions(auth);
    },
    preventResolve: function preventResolve(_ref7) {
      var state = _ref7.state,
          loggedIn = _ref7.loggedIn;
      return !loggedIn || !!state.common.userService.loading;
    }
  };

  if (state) {
    connectSpec.state = state;
  }

  if (then) {
    connectSpec.then = then;
  }

  return connectSpec;
}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(83);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RACE_WEIGHEDIN = exports.RACE_WEIGHEDIN = 'WEIGHEDIN';
var RACE_RESULT = exports.RACE_RESULT = 'RESULT';
var RACE_FINISHED = exports.RACE_FINISHED = 'FINISHED';

var HORSE_RACE_COMPLETE_STATUSES = exports.HORSE_RACE_COMPLETE_STATUSES = [RACE_WEIGHEDIN, RACE_RESULT, RACE_FINISHED];
var GREYHOUND_RACE_COMPLETE_STATUSES = exports.GREYHOUND_RACE_COMPLETE_STATUSES = ['Result', 'Final Result'];

var HORSE_RACE_CASUALTIES = exports.HORSE_RACE_CASUALTIES = {
  BroughtDown: 'BD',
  CarriedOut: 'CO',
  DidNotFinish: 'DNF',
  Fell: 'F',
  HitRails: 'HR',
  PulledUp: 'PU',
  RanOut: 'RO',
  Refused: 'R',
  RefusedToRace: 'RTR',
  SlippedUp: 'SU',
  UnseatedRider: 'UR'
};

var TZ = exports.TZ = "Europe/London";

var SUBSCRIPTIONS_FOOTBALL_MATCH = exports.SUBSCRIPTIONS_FOOTBALL_MATCH = "FOOTBALL_MATCH";
var SUBSCRIPTIONS_HORSE_RACE = exports.SUBSCRIPTIONS_HORSE_RACE = "RACE";
var NOT_LOGGED_IN_ERROR = exports.NOT_LOGGED_IN_ERROR = "NO_LOGIN";
var INSIDERS_LINK_CLICK_TRACKING_EVENT = exports.INSIDERS_LINK_CLICK_TRACKING_EVENT = "insidersLinkClick";

var FACEBOOK_BASE_URL = exports.FACEBOOK_BASE_URL = "https://www.facebook.com/sharer/sharer.php";
var TWITTER_BASE_URL = exports.TWITTER_BASE_URL = "https://twitter.com/intent/tweet";

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withErrorBoundary = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorBoundary = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(ErrorBoundary, _Component);

  function ErrorBoundary() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ErrorBoundary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ErrorBoundary.__proto__ || (0, _getPrototypeOf2.default)(ErrorBoundary)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      error: null,
      info: null
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      console.error(error, info);
      this.setState({ error: error, info: info });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          children = _props.children,
          FallbackComponent = _props.FallbackComponent;
      var _state = this.state,
          error = _state.error,
          info = _state.info;


      if (error !== null) {
        return _react2.default.createElement(FallbackComponent, {
          error: error,
          info: info
        });
      }

      return children;
    }
  }]);
  return ErrorBoundary;
}(_react.Component), _class.defaultProps = {
  FallbackComponent: function FallbackComponent() {
    return "Something went wrong.";
  }
}, _temp2);


ErrorBoundary.propTypes = {
  children: _propTypes2.default.any,
  FallbackComponent: _propTypes2.default.any
};

var withErrorBoundary = exports.withErrorBoundary = function withErrorBoundary(Component, FallbackComponent) {
  return function (props) {
    return _react2.default.createElement(
      ErrorBoundary,
      { FallbackComponent: FallbackComponent },
      _react2.default.createElement(Component, props)
    );
  };
};

exports.default = withErrorBoundary;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(11);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _routeUtils = __webpack_require__(38);

var _urlRewrite = __webpack_require__(120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function navLiWithLink(router, link, linkLocation) {
  var actualClass = {};

  var showOnDesktop = link.inDesktopDropdown ? linkLocation == "more-menu" : linkLocation == "secondary-nav";
  var showOnTablet = link.inDesktopDropdown || link.inDropdown ? linkLocation == "more-menu" : linkLocation == "secondary-nav";
  actualClass.className = '';
  if (!showOnTablet) {
    actualClass.className = 'hide-on-tablet';
  }

  if (!showOnDesktop) {
    actualClass.className = actualClass.className + ' hide-on-desktop';
  }

  return _react2.default.createElement(
    'li',
    (0, _extends3.default)({ key: link.href }, actualClass),
    link.href.includes('://') ? _react2.default.createElement(
      'a',
      { href: link.href, target: '_blank' },
      link.text
    ) : _react2.default.createElement(
      _reactRouter.Link,
      { className: (0, _routeUtils.activeClassName)(router, link, "nav-active"), id: "nav-level2-" + (0, _urlRewrite.titleToId)(link.text), to: link.href },
      link.text
    )
  );
}

var SecondaryNav = (0, _reactRouter.withRouter)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SecondaryNav, _Component);

  function SecondaryNav() {
    (0, _classCallCheck3.default)(this, SecondaryNav);
    return (0, _possibleConstructorReturn3.default)(this, (SecondaryNav.__proto__ || (0, _getPrototypeOf2.default)(SecondaryNav)).apply(this, arguments));
  }

  (0, _createClass3.default)(SecondaryNav, [{
    key: 'moreLinksMenu',
    value: function moreLinksMenu(links, moreOpen, moreOpener) {
      var _this2 = this;

      var moreLinksTablet = links.filter(function (link) {
        return link.inDropdown || link.inDesktopDropdown;
      });
      var moreLinksDesktop = links.filter(function (link) {
        return link.inDesktopDropdown;
      });

      var className = 'nav-level2-more no-link';

      if (moreOpen) {
        className += ' nav-level2-more-open';
      }

      if (!moreLinksTablet.length) {
        className += ' hide-on-tablet';
      }

      if (!moreLinksDesktop.length) {
        className += ' hide-on-desktop';
      }

      return _react2.default.createElement(
        'li',
        { className: className, onClick: function onClick(e) {
            return moreOpener(e);
          } },
        'More ',
        _react2.default.createElement(_CaretIcon2.default, { type: 'line', direction: moreOpen ? "up" : "down" }),
        _react2.default.createElement(
          'ul',
          { className: !moreOpen && "nav-level2-more-closed" },
          links.map(function (link) {
            return navLiWithLink(_this2.props.router, link, "more-menu");
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          open = _props.open,
          opener = _props.opener,
          _props$moreOpen = _props.moreOpen,
          moreOpen = _props$moreOpen === undefined ? false : _props$moreOpen,
          _props$moreOpener = _props.moreOpener,
          moreOpener = _props$moreOpener === undefined ? function () {} : _props$moreOpener,
          title = _props.title,
          links = _props.links,
          _props$back = _props.back,
          back = _props$back === undefined ? [] : _props$back;

      var topLevelClassList = ["nav-level2"];

      if (links.length == 1) {
        topLevelClassList.push("nav-level2-solo");
      }
      return _react2.default.createElement(
        'div',
        { className: topLevelClassList.join(" ") },
        _react2.default.createElement(
          'div',
          { className: 'nav-level2-label', onClick: function onClick(e) {
              return opener(e);
            } },
          _react2.default.createElement(
            'h1',
            { className: 'nav-level2-label-text' },
            title
          ),
          _react2.default.createElement(
            'span',
            { className: 'nav-level2-label-caret' },
            _react2.default.createElement(_CaretIcon2.default, { type: 'line', direction: open ? "up" : "down" })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'nav-level2-menu' + (open ? " open" : ""), onClick: function onClick(e) {
              opener(e, false);
              moreOpener(e, false);
            } },
          _react2.default.createElement(
            'ul',
            null,
            links.map(function (link) {
              return navLiWithLink(_this3.props.router, link, "secondary-nav");
            }),
            links.length > 0 && this.moreLinksMenu(links, moreOpen, moreOpener)
          ),
          _react2.default.createElement(
            'ul',
            { className: 'nav-level2-return' },
            back.map(function (link) {
              return _react2.default.createElement(
                'li',
                { key: link.href },
                _react2.default.createElement(
                  _reactRouter.IndexLink,
                  { activeClassName: 'nav-active', to: link.href },
                  link.text
                )
              );
            }),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.IndexLink,
                { to: '/' },
                'Sporting Life Home'
              )
            )
          )
        )
      );
    }
  }]);
  return SecondaryNav;
}(_react.Component), _class2.propTypes = {
  router: _propTypes2.default.object.isRequired,
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired,
  moreOpen: _propTypes2.default.bool,
  moreOpener: _propTypes2.default.func,
  title: _propTypes2.default.string.isRequired,
  links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    href: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.string.isRequired,
    isIndex: _propTypes2.default.bool
  })).isRequired,
  back: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    href: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.string.isRequired
  }))
}, _temp)) || _class;

exports.default = SecondaryNav;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(320)('wks');
var uid = __webpack_require__(238);
var Symbol = __webpack_require__(53).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var topMPUProps = exports.topMPUProps = {
  adUnitPath: '/67970281/display_thirdparty_gb/sporting_life_responsive/ros/top_mpu',
  type: "topMPU"
};

var singleBottomMPUProps = exports.singleBottomMPUProps = {
  adUnitPath: '/67970281/display_thirdparty_gb/sporting_life_responsive/ros/bottom_mpu',
  type: 'singleBottomMPU'
};

var bannerAd = exports.bannerAd = {
  adUnitPath: '/67970281/display_thirdparty_gb/sporting_life_responsive/ros/top_banner',
  type: "topBanner"
};

var rosBottomMpuProps = exports.rosBottomMpuProps = {
  adUnitPath: '/67970281/display_thirdparty_gb/sporting_life_responsive/ros/Bottom_MPU',
  type: 'bottomMPU'
};

var bottomMPUProps = exports.bottomMPUProps = {
  adUnitPath: '/67970281/display_thirdparty_gb/sporting_life_responsive/ros/Bottom_MPU',
  type: 'bottomMPU'
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SportHomePageContent = SportHomePageContent;

var _GptProperties = __webpack_require__(51);

var _MoreNews = __webpack_require__(93);

var _MoreNews2 = _interopRequireDefault(_MoreNews);

var _GptAdvert = __webpack_require__(101);

var _GptAdvert2 = _interopRequireDefault(_GptAdvert);

var _MostReadAll = __webpack_require__(141);

var _MostReadAll2 = _interopRequireDefault(_MostReadAll);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RightColumn = __webpack_require__(21);

var _StandardPage = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SportHomePageContent(props) {
  var location = props.location,
      sport = props.sport,
      title = props.title,
      helmetProps = props.helmetProps,
      rightColumnContent = props.rightColumnContent;


  return _react2.default.createElement(
    _StandardPage.StandardPage,
    { sport: sport, title: title, helmetProps: helmetProps },
    _react2.default.createElement(
      'div',
      { className: 'main-layout-left-column' },
      _react2.default.createElement(
        'div',
        { id: 'left-more-news', className: 'main-layout-block' },
        _react2.default.createElement(_MoreNews2.default, { location: location })
      ),
      _react2.default.createElement(
        'div',
        { className: 'main-layout-block last-desktop' },
        _react2.default.createElement(_GptAdvert2.default, { ocDetails: { ocSlot: [sport, 'leaderboard'] }, performDetails: _GptProperties.singleBottomMPUProps })
      ),
      _react2.default.createElement(
        'div',
        { id: 'left-most-read', className: 'main-layout-block last-handheld main-layout-hide-desktop' },
        _react2.default.createElement(_MostReadAll2.default, { location: location })
      )
    ),
    _react2.default.createElement(_RightColumn.RightColumn, { sport: sport, location: location, content: rightColumnContent })
  );
}

SportHomePageContent.propTypes = {
  location: _propTypes2.default.object.isRequired,
  sport: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  helmetProps: _propTypes2.default.object,
  rightColumnContent: _propTypes2.default.array
};

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CaretLink;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CaretLink(props) {
  __webpack_require__(1360);

  var linkTo = props.to,
      _props$className = props.className,
      parentClass = _props$className === undefined ? "" : _props$className,
      _props$caretDirection = props.caretDirection,
      direction = _props$caretDirection === undefined ? "right" : _props$caretDirection,
      children = props.children;


  return _react2.default.createElement(
    _reactRouter.Link,
    { className: 'caret-link ' + parentClass, to: linkTo },
    _react2.default.createElement(_CaretIcon2.default, { type: 'full', direction: direction }),
    children
  );
}

CaretLink.propTypes = {
  to: _propTypes2.default.string,
  className: _propTypes2.default.string,
  caretDirection: _propTypes2.default.string,
  children: _propTypes2.default.any
};

/***/ }),
/* 55 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(40);
var createDesc = __webpack_require__(127);
module.exports = __webpack_require__(39) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var hide = __webpack_require__(56);
var has = __webpack_require__(55);
var SRC = __webpack_require__(131)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(82).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var fails = __webpack_require__(25);
var defined = __webpack_require__(83);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by tools/gen_submodule.js 
module['exports'] = __webpack_require__(1634);

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalDateTime = LocalDateTime;
exports.LocalDateTimeLong = LocalDateTimeLong;
exports.LocalIsoDate = LocalIsoDate;
exports.LocalDate = LocalDate;
exports.LocalDateShort = LocalDateShort;
exports.LocalFullDate = LocalFullDate;
exports.LocalFullDateLong = LocalFullDateLong;
exports.LocalFullDateShort = LocalFullDateShort;
exports.LocalTime = LocalTime;
exports.LocalTimeShort = LocalTimeShort;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LocalDateTimeHelper = __webpack_require__(13);

var dateTimeHelper = _interopRequireWildcard(_LocalDateTimeHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  DD-MM-YYYY HH:mm
//  Example:        17-10-2016 14:00
//
///////////////////////////////////////////////////////////////////////////////

function LocalDateTime(props) {
  var dt = props.iso,
      _props$className = props.className,
      className = _props$className === undefined ? "date-time" : _props$className;


  var dateTimeFormatted = dateTimeHelper.localDateTime(dt);
  return _react2.default.createElement(
    'span',
    { className: className },
    dateTimeFormatted
  );
}
LocalDateTime.propTypes = {
  iso: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,
  className: _propTypes2.default.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  DD-MM-YYYY HH:mm:ss
//  Example:        17-10-2016 14:00:00
//
///////////////////////////////////////////////////////////////////////////////

function LocalDateTimeLong(props) {
  var dt = props.iso,
      _props$className2 = props.className,
      className = _props$className2 === undefined ? "date-time-long" : _props$className2;


  var dateTimeFormatted = dateTimeHelper.localDateTimeLong(dt);
  return _react2.default.createElement(
    'span',
    { className: className },
    dateTimeFormatted
  );
}
LocalDateTimeLong.propTypes = {
  iso: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,
  className: _propTypes2.default.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  YYYY-MM-DD
//  Example:        2016-10-17
//
///////////////////////////////////////////////////////////////////////////////

function LocalIsoDate(props) {
  var dt = props.iso,
      _props$className3 = props.className,
      className = _props$className3 === undefined ? "date" : _props$className3;


  var dateFormatted = dateTimeHelper.isoDate(dt);
  return _react2.default.createElement(
    'span',
    { className: className },
    dateFormatted
  );
}
LocalIsoDate.propTypes = {
  iso: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,
  className: _propTypes2.default.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  DD-MM-YYYY
//  Example:        17-10-2016
//
///////////////////////////////////////////////////////////////////////////////

function LocalDate(props) {
  var dt = props.iso,
      _props$className4 = props.className,
      className = _props$className4 === undefined ? "date" : _props$className4;


  var dateFormatted = dateTimeHelper.localDate(dt);
  return _react2.default.createElement(
    'span',
    { className: className },
    dateFormatted
  );
}
LocalDate.propTypes = {
  iso: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,
  className: _propTypes2.default.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  ddd DD
//  Example:        Mon 17
//
///////////////////////////////////////////////////////////////////////////////

function LocalDateShort(props) {
  var dt = props.iso,
      _props$className5 = props.className,
      className = _props$className5 === undefined ? "date-short" : _props$className5;


  var dateFormatted = dateTimeHelper.localDateShort(dt);
  return _react2.default.createElement(
    'span',
    { className: className },
    dateFormatted
  );
}
LocalDateShort.propTypes = {
  iso: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,
  className: _propTypes2.default.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  Do MMMM YYYY
//  Example:        17th October 2016
//
///////////////////////////////////////////////////////////////////////////////

function LocalFullDate(props) {
  var dt = props.iso,
      _props$className6 = props.className,
      className = _props$className6 === undefined ? "full-date" : _props$className6;


  var dateFormatted = dateTimeHelper.localFullDate(dt);
  return _react2.default.createElement(
    'span',
    { className: className },
    dateFormatted
  );
}
LocalFullDate.propTypes = {
  iso: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
  className: _propTypes2.default.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  ddd MMMM DD YYYY
//  Example:        Mon October 17 2016
//
///////////////////////////////////////////////////////////////////////////////

function LocalFullDateLong(props) {
  var dt = props.iso,
      _props$className7 = props.className,
      className = _props$className7 === undefined ? "full-date-long" : _props$className7;


  var dateFormatted = dateTimeHelper.localFullDateLong(dt);
  return _react2.default.createElement(
    'span',
    { className: className },
    dateFormatted
  );
}
LocalFullDateLong.propTypes = {
  iso: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,
  className: _propTypes2.default.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  DD/MM/YY
//  Example:        17/10/16
//
///////////////////////////////////////////////////////////////////////////////

function LocalFullDateShort(props) {
  var dt = props.iso,
      _props$className8 = props.className,
      className = _props$className8 === undefined ? "full-date-short" : _props$className8;


  var dateFormatted = dateTimeHelper.localFullDateShort(dt);
  return _react2.default.createElement(
    'span',
    { className: className },
    dateFormatted
  );
}
LocalFullDateShort.propTypes = {
  iso: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,
  className: _propTypes2.default.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  HH:mm:ss
//  Example:        14:00:00
//
///////////////////////////////////////////////////////////////////////////////

function LocalTime(props) {
  var dt = props.iso,
      _props$className9 = props.className,
      className = _props$className9 === undefined ? "time" : _props$className9;


  var timeFormatted = dateTimeHelper.localTime(dt);
  return _react2.default.createElement(
    'span',
    { className: className },
    timeFormatted
  );
}
LocalTime.propTypes = {
  iso: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,
  className: _propTypes2.default.string
};

///////////////////////////////////////////////////////////////////////////////
//
//  Output Format:  HH:mm
//  Example:        14:00
//
///////////////////////////////////////////////////////////////////////////////

function LocalTimeShort(props) {
  var dt = props.iso,
      _props$className10 = props.className,
      className = _props$className10 === undefined ? "time-short" : _props$className10;


  var timeFormatted = dateTimeHelper.localTimeShort(dt);
  return _react2.default.createElement(
    'span',
    { className: className },
    timeFormatted
  );
}
LocalTimeShort.propTypes = {
  iso: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]).isRequired,
  className: _propTypes2.default.string
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var KICKOFF = exports.KICKOFF = "KICK_OFF";
var ENDOFFIRSTHALF = exports.ENDOFFIRSTHALF = "END_OF_FIRST_HALF";
var STARTOFSECONDHALF = exports.STARTOFSECONDHALF = "START_OF_SECOND_HALF";
var STARTOFPENALTYSHOOTOUT = exports.STARTOFPENALTYSHOOTOUT = "START_OF_PENALTY_SHOOTOUT";
var ENDOFSECONDHALF = exports.ENDOFSECONDHALF = "END_OF_SECOND_HALF";
var FULLTIME = exports.FULLTIME = "FULL_TIME";
var GOAL = exports.GOAL = "GOAL";
var OWNGOAL = exports.OWNGOAL = "OWN_GOAL";
var PENALTY = exports.PENALTY = "PENALTY";
var SUBON = exports.SUBON = "SUBSTITUTION_ON";
var SUBOFF = exports.SUBOFF = "SUBSTITUTION_OFF";
var YELLOWCARD = exports.YELLOWCARD = "YELLOW_CARD";
var SECONDYELLOWCARD = exports.SECONDYELLOWCARD = "SECOND_YELLOW_CARD";
var REDCARD = exports.REDCARD = "RED_CARD";

var LIVE_REFRESH_INTERVAL_MILLIS = exports.LIVE_REFRESH_INTERVAL_MILLIS = 10000;
var FIXTURES_REFRESH_INTERVAL_MILLIS = exports.FIXTURES_REFRESH_INTERVAL_MILLIS = 30000;
var COMPETITIONS_REFRESH_INTERVAL_MILLIS = exports.COMPETITIONS_REFRESH_INTERVAL_MILLIS = 30000;

var MATCH_STATE_ALL = exports.MATCH_STATE_ALL = ["ABANDONED", "PREMATCH", "FIRSTHALF", "HALFTIME", "SECONDHALF", "FULLTIME90", "EXTRAFIRSTHALF", "EXTRAHALFTIME", "EXTRASECONDHALF", "FULLTIMEPENS", "SHOOTOUT", "LIVE", "FULLTIME"];

var MATCH_STATE_UPNEXT = exports.MATCH_STATE_UPNEXT = ["PREMATCH"];

var MATCH_STATE_LIVE = exports.MATCH_STATE_LIVE = ["FIRSTHALF", "HALFTIME", "SECONDHALF", "FULLTIME90", "EXTRAFIRSTHALF", "EXTRAHALFTIME", "EXTRASECONDHALF", "FULLTIMEPENS", "SHOOTOUT", "LIVE"];

var MATCH_STATE_FINISHED = exports.MATCH_STATE_FINISHED = ["FULLTIME"];

var MATCH_FILTER_EMPTY_MESSAGE = exports.MATCH_FILTER_EMPTY_MESSAGE = {
  noTabs: "Nothing to show for this competition",
  results: "There are no results to show at the moment.",
  fixtures: "There are no fixtures to show.",
  resultsmonth: "There are currently no results to show for this month.",
  fixturesmonth: "There are no fixtures to show for this month.",

  all: "There are no matches at the moment.",
  upNext: "There are no scheduled matches at the moment.",
  ongoing: "There are no live matches at the moment.",
  finished: "There are no finished matches at the moment."
};

var GOAL_ALERT_TIME = exports.GOAL_ALERT_TIME = 5000;

var MATCH_TYPE_REGULAR = exports.MATCH_TYPE_REGULAR = "Regular";

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(147);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.trackClick = trackClick;
exports.passThroughParams = passThroughParams;
exports.transformPlainParams = transformPlainParams;
exports.transformTypedParams = transformTypedParams;
exports.simpleMap = simpleMap;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
  This is to be used to add the tracking properties to an element (usually a <Link>, but seems to work on anything) via the property spread operator

  eg
    {...trackClick("TestEvent", {arbitrary: "value"})}
  will add
    data-metrics-event-name="TestEvent"
    data-metrics-arbitrary="value"
 */
var camelRx = /([a-z])([A-Z])/g;
var dashFn = function dashFn(m, l, u) {
  return l + "-" + u.toLowerCase();
};
var camelToDash = function camelToDash(camel) {
  return camel.replace(camelRx, dashFn).toLowerCase();
};

function trackClick(eventName, params) {
  var track = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (track) {
    var data = (0, _extends3.default)({ eventName: eventName }, params);

    var add = function add(props, key) {
      props["data-metrics-" + camelToDash(key)] = data[key];
      return props;
    };

    return (0, _keys2.default)(data).reduce(add, {});
  }
}

/**
  This is to be used as a helper for AnalyticsApi and its vendor implementations
  It simply passes on all params without altering or mapping them
 */
function passThroughParams(params /*, map*/) {
  return params;
}

/**
  This is to be used as a helper for AnalyticsApi and its vendor implementations
  It turns a single level key map in to an object of values

  eg
    Map of `{a: "AA", b: "BB"}`
    with data `data-metrics-a="1" data-metrics-b="B"` or `{...trackClick("someEvent", {a: 1, b: 2})}`
    will yeild `{AA: 1, BB: 2}`
 */
function transformPlainParams(params, map) {
  return (0, _keys2.default)(params).reduce(function (obj, key) {
    if (key in map) {
      obj[map[key]] = params[key];
    }
    return obj;
  }, {});
}

/**
  This is to be used as a helper for AnalyticsApi and its vendor implementations
  It turns a two level key map in to an object of values

  eg
    Map of `{a: {key: "AA", type: "x"}, b: {key: "BB", type: "y"}}`
    with data `data-metrics-a="1" data-metrics-b="B"` or `{...trackClick("someEvent", {a: 1, b: 2})}`
    will yeild `{x: {AA: 1}, y: {BB: 2}}`
 */
function transformTypedParams(params, map) {
  return (0, _keys2.default)(params).reduce(function (obj, key) {
    if (key in map) {
      obj[map[key].type] = obj[map[key].type] || {};

      obj[map[key].type][map[key].key] = params[key];
    }

    return obj;
  }, {});
}

/**
  Helper that creates a map from a list of keys. Useful in defining a vendor map.

  eg
    simpleMap("foo", "bar")

  returns
    {foo: "foo", bar: "bar"}
 */
function simpleMap() {
  for (var _len = arguments.length, paramKeys = Array(_len), _key = 0; _key < _len; _key++) {
    paramKeys[_key] = arguments[_key];
  }

  return paramKeys.reduce(function (map, key) {
    return (0, _assign2.default)(map, (0, _defineProperty3.default)({}, key, key));
  }, {});
}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _superagent = __webpack_require__(444);

var _superagent2 = _interopRequireDefault(_superagent);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _env = __webpack_require__(197);

var _env2 = _interopRequireDefault(_env);

var _commonUtils = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var methods = ['get', 'post', 'put', 'patch', 'del'];

var ApiClient = function () {
  function ApiClient() {
    var _this = this;

    var agent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    (0, _classCallCheck3.default)(this, ApiClient);


    methods.forEach(function (method) {
      return _this[method] = function (path) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            params = _ref.params,
            data = _ref.data,
            withCredentials = _ref.withCredentials;

        var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return new _promise2.default(function (resolve, reject) {

          var univesalPath = void 0;
          if (typeof window === 'undefined' || _env2.default.API_CROSS_ORIGIN_DISABLED !== 'true') {
            univesalPath = _config2.default.apiProtocol + '://' + _config2.default.apiUrl + ':' + _config2.default.apiPort + '/' + path;
          } else {
            univesalPath = '/' + path;
          }

          var request = _superagent2.default[method](univesalPath);

          if (agent) {
            request._agent = agent;
          }

          if (headers) {
            request.set(headers);
          }

          if (params) {
            request.query(params);
          }

          if (_config2.default.cacheBuster && method === "get") {
            request.query({ "sl_cb": _config2.default.cacheBuster });
          }

          request.timeout(_config2.default.apiTimeout);

          if (withCredentials) {
            request.withCredentials();
          }

          if (data) {
            request.send(data);
          }

          request.end(function (err) {
            var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                body = _ref2.body;

            var cleanBody = (0, _commonUtils.noNullDeepClone)(body);

            if (err) {
              reject({
                body: cleanBody,
                status: err.status,
                error: err
              });
            } else {
              resolve(cleanBody);
            }
          });
        });
      };
    });
  }

  (0, _createClass3.default)(ApiClient, [{
    key: 'init',
    value: function init() {}

    /*
     * Relevant bug: https://phabricator.babeljs.io/T2455
     * Recommended not to use classes with just a constructor.
     */

  }, {
    key: 'empty',
    value: function empty() {}
  }]);
  return ApiClient;
}();

exports.default = ApiClient;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocalStorageClient = undefined;

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

exports.has = has;
exports.setFeatures = setFeatures;
exports.getEnabledFeatures = getEnabledFeatures;
exports.isBetSlipEnabled = isBetSlipEnabled;

var _reactCookie = __webpack_require__(339);

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _env = __webpack_require__(197);

var _env2 = _interopRequireDefault(_env);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _localStorage = __webpack_require__(249);

var _localStorage2 = _interopRequireDefault(_localStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*

How to code a feature switch
============================
Decide on a feature switch id.

If code needs to behave differently, use has, eg if (has("my-feature")) {}

Never store the result or the id in a variable, so that the id can be searched for.

If code exists just for the feature (eg config or a property), comment it with the feature id.

Accompany everything with a thorough explanatory comment as to what's going on.


How to turn on and off for an individual
========================================
Visit any page of the site with a given query string to control feature switches, using Express's syntax for structured query parameters.

eg for a feature called "bob"
Visit https://www.sportinglife.com?feature[bob]=on

feature[bob]=on will turn it on
feature[bob]=off will turn it off

feature[bob]=reset (or indeed anything other than on or off) will reset it to the default value (ie what users see).

This places a session cookie on the client. So navigating to another page and refreshing will no affect the state of
the switch, but closing the browser will reset the feature to its default state.


How to turn on and off for all users
====================================
A feature must have an entry in `featureSpec` to work. User requests to an unexpected feature switch will fail silently.

By default, features are off. So the minimum for a spec is an empty object.

If a given feature should be "on" unless set by the query string, give it a `defaultValue` of "on" in featureSpec.
  eg
  const featureSpec = {
    'make-it-red': {
      defaultValue: "on"
    }
  };

If a given feature should be switchable for all users using an environment variable, prefix the variable name
with FEATURE_, and add the name to featureSpec (don't forget to update the env module to expose it).
  eg
  const featureSpec = {
    'make-it-red': {
      environmentVariable: "FEATURE_MAKE_IT_RED"
    }
  };

  or

  const featureSpec = {
    'make-it-red': {
      defaultValue: "on",
      environmentVariable: "FEATURE_MAKE_IT_RED"
    }
  };

An individual can still override this with the above query string switch, unless it is protected.

If a feature should be blocked in a given environment (eg prod), this is possible, with two stages to the process.

1. Ensure the envonment has a PROTECTABLE_FEATURES variable, set to "on"
2. add protected: true to the featureSpec
  eg

  const featureSpec = {
    'make-it-red': {
      protected: true
    }
  };

When you add, remove or update a feature switch, update the list on the Kepler page <https://kepler.bjss.com/display/SPL/Feature+Switches>.


*/
var localStorage = new _localStorage2.default();
var setLocalStorageClient = exports.setLocalStorageClient = function setLocalStorageClient(client) {
  localStorage = client;
};

function getFeatureSpec() {
  return global.FEATURE_SPEC || {
    "integrated-betslip": {
      defaultValue: "on",
      environmentVariable: "FEATURE_INTEGRATED_BETSLIP"
    },
    "push-fast-results": {
      defaultValue: "on",
      environmentVariable: "FEATURE_PUSH_FAST_RESULTS"
    },
    "insider-benefits": {
      defaultValue: "on",
      environmentVariable: "FEATURE_INSIDER_BENEFITS"
    },
    "oddschecker-integration": {
      defaultValue: "canary",
      environmentVariable: "FEATURE_ODDSCHECKER_INTEGRATION"
    },
    "oddschecker-betslip": {
      defaultValue: "canary",
      environmentVariable: "FEATURE_ODDSCHECKER_BETSLIP"
    }
  };
}

function key(feature) {
  return 'feature_' + feature;
}

function defaultValue(spec) {
  return _env2.default[spec.environmentVariable] || spec.defaultValue;
}

function has(feature) {
  var spec = getFeatureSpec()[feature] || {};
  var value = void 0;

  if (!_config2.default.isProduction && !getFeatureSpec().hasOwnProperty(feature)) {
    console.warn('Feature "' + feature + '" has not been specified'); // eslint-disable-line no-console
  }

  if (spec.protected && _config2.default.protectableFeatures) {
    value = defaultValue(spec);
  } else {
    value = _reactCookie2.default.load(key(feature)) || defaultValue(spec);
  }

  if (value === "canary") {
    var canaryFeatures = localStorage.getValue('features') || [];
    value = canaryFeatures.includes(feature) ? "on" : "off";
  }

  return value === "on";
}

function setFeatures(features) {
  if (features) {
    (0, _keys2.default)(features).forEach(function (feature) {
      var value = features[feature];

      switch (value) {
        case "on":
        case "off":
          if (getFeatureSpec().hasOwnProperty(feature)) {
            _reactCookie2.default.save(key(feature), value, { path: "/" });
          }
          break;
        default:
          _reactCookie2.default.remove(key(feature));
      }
    });
  }
}

function getEnabledFeatures() {
  var features = [];
  (0, _keys2.default)(getFeatureSpec()).forEach(function (feature) {
    if (has(feature)) {
      features.push(feature);
    }
  });

  return features;
}

function isBetSlipEnabled() {
  var checkBetlinkEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (!has("integrated-betslip")) {
    return false;
  }

  var oddscheckerEnabled = has('oddschecker-betslip') && _config2.default.oddschecker.enabled;
  if (oddscheckerEnabled && checkBetlinkEnabled) {
    return oddscheckerEnabled && _config2.default.oddschecker.betlinkEnabled;
  }

  return oddscheckerEnabled;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(179);
var createDesc = __webpack_require__(127);
var toIObject = __webpack_require__(68);
var toPrimitive = __webpack_require__(86);
var has = __webpack_require__(55);
var IE8_DOM_DEFINE = __webpack_require__(455);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(39) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(55);
var toObject = __webpack_require__(45);
var IE_PROTO = __webpack_require__(294)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(178);
var defined = __webpack_require__(83);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropTypes = exports.MetricsElement = exports.exposeMetrics = exports.metrics = exports.createMetrics = undefined;

var _createMetrics = __webpack_require__(672);

var _createMetrics2 = _interopRequireDefault(_createMetrics);

var _metrics = __webpack_require__(1559);

var _metrics2 = _interopRequireDefault(_metrics);

var _PropTypes = __webpack_require__(242);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _exposeMetrics = __webpack_require__(675);

var _exposeMetrics2 = _interopRequireDefault(_exposeMetrics);

var _MetricsElement = __webpack_require__(1554);

var _MetricsElement2 = _interopRequireDefault(_MetricsElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createMetrics = _createMetrics2.default;
exports.metrics = _metrics2.default;
exports.exposeMetrics = _exposeMetrics2.default;
exports.MetricsElement = _MetricsElement2.default;
exports.PropTypes = _PropTypes2.default;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp; /*
                            
                            Provide a set of Links formatted as a horizontal tab set
                            
                            className: optionally override the className of the root <nav> element. Defaults to "tabs"
                            activeTabClassName: optionally override the activeClassName applied to the <a> tag of the active tab. Defaults to "tab-selected"
                            tabs: mandatory array of objects that are used to create the individual tabs
                              href: mandatory link value. Passed to <Link> as the to property
                              text: mandatory text for the tab's <Link>
                              className: optional className to add to the tab. Gets applied to the <a>. Defaults to nothing.
                              isIndex: optional boolean to say if the link is an index page for other tabs. Passed to <Link> as the onlyActiveOnIndex property
                              isExternalLink: optiona boolean to indicate if link should open in a new tab. Defaults to false
                            
                            */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(11);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _commonUtils = __webpack_require__(36);

var _routeUtils = __webpack_require__(38);

var _lodash = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MOVE_MINIMUM = 5;

var _globalCssExports = (0, _commonUtils.globalCssExports)("tabs"),
    arrowWidth = _globalCssExports.arrowWidth;

var Tabs = (0, _reactRouter.withRouter)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Tabs, _Component);

  function Tabs() {
    var _ref;

    (0, _classCallCheck3.default)(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args)));

    _this.removeScrollEvents = function () {};
    _this.removeSetupEvents = function () {};
    _this.scrollPosition = 0;
    _this.maxTranslate = 0;

    // also defined elsewhere
    // this.minTranslate;
    // this.domElement
    // this.tabList
    // this.baseClass
    // this.leftEnd
    // this.rightEnd
    // this.supportsCssPointerEvents
    return _this;
  }

  (0, _createClass3.default)(Tabs, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.supportsCssPointerEvents = document.documentElement.style.pointerEvents === '';
      this.scrollTabIntoView(!!this.props.centerDefault);
      this.addScrollEvents();
      this.addSetupEvents();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeScrollEvents();
      this.removeSetupEvents();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!(0, _lodash.isEqual)(prevProps.tabs, this.props.tabs)) {
        this.scrollTabIntoView(false); // never try to center on update, only on initial mount
      }
    }
  }, {
    key: 'getDomElements',
    value: function getDomElements(el) {
      if (el) {
        this.domElement = el;
        this.tabList = el.querySelector("ul");
        this.baseClass = el.className;
        this.leftEnd = el.querySelector('.' + el.className + '-left-end');
        this.rightEnd = el.querySelector('.' + el.className + '-right-end');
      }
    }
  }, {
    key: 'moveTabs',
    value: function moveTabs(scrollBy) {
      return this.positionTabs(this.scrollPosition + scrollBy);
    }
  }, {
    key: 'positionTabs',
    value: function positionTabs(scrollTo) {
      this.minTranslate = this.tabList.clientWidth - this.tabList.scrollWidth;
      this.scrollPosition = Math.max(this.minTranslate, Math.min(this.maxTranslate, scrollTo));
      this.tabList.style.transform = 'translate(' + this.scrollPosition + 'px)';
      this.setArrows();

      return this.scrollPosition == scrollTo; // successfully moved to the requested position
    }
  }, {
    key: 'setArrows',
    value: function setArrows() {
      this.minTranslate = this.tabList.clientWidth - this.tabList.scrollWidth;
      var canGoLeft = this.supportsCssPointerEvents && this.scrollPosition < this.maxTranslate;
      var canGoRight = this.supportsCssPointerEvents && this.scrollPosition > this.minTranslate;

      this.leftEnd.style.display = canGoLeft ? "block" : "none";
      this.rightEnd.style.display = canGoRight ? "block" : "none";
    }
  }, {
    key: 'scrollTabIntoView',
    value: function scrollTabIntoView(tryToCentre) {
      var activeLink = this.domElement.querySelector(".tab-selected");

      if (activeLink) {
        var activeTab = activeLink.parentElement;
        var domDimensions = this.domElement.getBoundingClientRect();
        var activeTabDimensions = activeTab.getBoundingClientRect();
        var offLeft = activeTabDimensions.left < domDimensions.left;
        var offRight = activeTabDimensions.right > domDimensions.right;

        if (tryToCentre) {
          this.moveTabs((domDimensions.left + domDimensions.right - activeTabDimensions.left - activeTabDimensions.right) / 2);
        } else if (offLeft) {
          this.moveTabs(domDimensions.left + arrowWidth - activeTabDimensions.left);
        } else if (offRight) {
          this.moveTabs(domDimensions.right - arrowWidth - activeTabDimensions.right);
        } else {
          this.setArrows();
        }
      }
    }
  }, {
    key: 'addSetupEvents',
    value: function addSetupEvents() {
      var _this2 = this;

      var onResize = function onResize() {
        return _this2.moveTabs(0);
      }; // using moveTabs ensures the position limits are respected

      var eventList = [{
        target: window,
        event: "resize",
        handler: onResize
      }];

      var scrollTimer = new ScrollTimer(this);
      var onMouseUp = function onMouseUp() {
        scrollTimer.stop();
        document.removeEventListener("mouseup", onMouseUp);
      };

      [this.leftEnd, this.rightEnd].forEach(function (end, i) {
        var px = 1 - 2 * i; // +1 or -1
        var blockZone = new BlockZone(1000);

        /*
        Events are fired in these orders for the different user actions
          Click:
            mousedown (user) -> mouseup (user) -> click (auto: 1ms)
          Mouse Hold:
            mousedown (user) -> {{hold}} -> mouseup (user) -> click (auto: 1ms)
          Tap (touch release within 680ms):
            touchstart (user) -> touchend (user) -> mousedown (auto: usually 1ms, but 300ms observed) -> mouseup (1auto: ms) -> click (auto: 1ms)
          Touch Hold (touch release after 680ms):
            touchstart (user) -> mousedown (auto: 680ms observed) -> {{hold}} -> touchend (user)
        */
        eventList.push({
          target: end,
          event: "touchstart",
          handler: function handler() {
            scrollTimer.start(px);
            blockZone.start();
          }
        }, {
          target: end,
          event: "touchend",
          handler: function handler() {
            scrollTimer.stop();
          }
        }, {
          target: end,
          event: "mousedown",
          handler: function handler() {
            if (blockZone.clear && scrollTimer.idle) {
              scrollTimer.start(px);
              document.addEventListener("mouseup", onMouseUp, false);
            }
          }
        });
      });

      eventList.forEach(function (_ref2) {
        var target = _ref2.target,
            event = _ref2.event,
            handler = _ref2.handler;

        if (target.addEventListener) {
          target.addEventListener(event, handler, false);
        }
      });
      onResize();

      this.removeSetupEvents = function () {
        eventList.forEach(function (_ref3) {
          var target = _ref3.target,
              event = _ref3.event,
              handler = _ref3.handler;
          return target.removeEventListener(event, handler);
        });
        document.removeEventListener("mouseup", onMouseUp);
      };
    }
  }, {
    key: 'addScrollEvents',
    value: function addScrollEvents() {
      var _this3 = this;

      var mask = document.createElement("div");
      mask.className = "mask";
      this.domElement.appendChild(mask);

      var startPointerX = void 0;
      var startTranslate = 0;

      var setStartPositions = function setStartPositions(eventX) {
        startPointerX = eventX;
        startTranslate = _this3.scrollPosition;
      };

      var movedEnough = function movedEnough(eventX) {
        var movedBy = eventX - startPointerX;
        return Math.abs(movedBy) > MOVE_MINIMUM;
      };

      var doDrag = function doDrag(eventX) {
        var moveTo = eventX - startPointerX + startTranslate;
        _this3.positionTabs(moveTo);
      };

      var prepareMouseMove = function prepareMouseMove(e) {
        setStartPositions(e.screenX);

        document.addEventListener("mousemove", startMouseMove, false);
        document.addEventListener("mouseup", endMouseMove, false);
      };

      var startMouseMove = function startMouseMove(e) {
        if (movedEnough(e.screenX)) {
          mask.style.display = "block";
          mask.addEventListener("mousemove", doMouseMove, false);
          document.removeEventListener("mousemove", startMouseMove);
        }
      };

      var doMouseMove = function doMouseMove(e) {
        doDrag(e.screenX);
      };

      var endMouseMove = function endMouseMove() {
        _this3.removeScrollEvents();
        mask.style.display = "none";
      };

      this.tabList.addEventListener("mousedown", prepareMouseMove, false);

      var prepareTouchMove = function prepareTouchMove(e) {
        setStartPositions(e.touches[0].screenX);
        _this3.tabList.addEventListener("touchmove", startTouchMove, false);
      };

      var startTouchMove = function startTouchMove(e) {
        if (movedEnough(e.touches[0].screenX)) {
          _this3.tabList.removeEventListener("touchmove", startTouchMove);
          _this3.tabList.addEventListener("touchmove", doTouchMove, false);
        }
      };

      var doTouchMove = function doTouchMove(e) {
        doDrag(e.touches[0].screenX);
      };

      var endTouchMove = function endTouchMove() {
        _this3.removeScrollEvents();
      };

      this.tabList.addEventListener("touchstart", prepareTouchMove, false);
      this.tabList.addEventListener("touchend", endTouchMove, false);

      // reassign
      this.removeScrollEvents = function () {
        document.removeEventListener("mousemove", startMouseMove);
        document.removeEventListener("mouseup", endMouseMove);

        _this3.tabList.removeEventListener("touchmove", startTouchMove);
        _this3.tabList.removeEventListener("touchmove", doTouchMove);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          tabs = _props.tabs,
          _props$className = _props.className,
          className = _props$className === undefined ? "tabs" : _props$className,
          _props$activeTabClass = _props.activeTabClassName,
          activeTabClassName = _props$activeTabClass === undefined ? "tab-selected" : _props$activeTabClass;


      return _react2.default.createElement(
        'nav',
        { className: className, ref: function ref(el) {
            return _this4.getDomElements(el);
          } },
        _react2.default.createElement(
          'ul',
          null,
          tabs.map(function (tab) {
            var href = tab.href,
                _tab$isExternal = tab.isExternal,
                isExternal = _tab$isExternal === undefined ? false : _tab$isExternal,
                text = tab.text,
                className = tab.className;


            return _react2.default.createElement(
              'li',
              { key: tab.href },
              isExternal ? _react2.default.createElement(
                'a',
                { href: href, target: '_blank' },
                text
              ) : _react2.default.createElement(
                _reactRouter.Link,
                { to: (0, _commonUtils.preventLinkScroll)(href), className: (0, _routeUtils.activeClassName)(_this4.props.router, tab, activeTabClassName, className) },
                text
              )
            );
          })
        ),
        _react2.default.createElement(
          'div',
          { className: className + '-left-end' },
          _react2.default.createElement(_CaretIcon2.default, { type: 'line', direction: 'left' })
        ),
        _react2.default.createElement(
          'div',
          { className: className + '-right-end' },
          _react2.default.createElement(_CaretIcon2.default, { type: 'line', direction: 'right' })
        )
      );
    }
  }]);
  return Tabs;
}(_react.Component), _class2.propTypes = {
  tabs: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    href: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    className: _propTypes2.default.string,
    isIndex: _propTypes2.default.bool,
    isExternalLink: _propTypes2.default.bool
  })).isRequired,
  router: _propTypes2.default.object.isRequired,
  centerDefault: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  activeTabClassName: _propTypes2.default.string
}, _temp)) || _class;

/*
Block period
  clear initially
  blocked for 1 second after being started
*/


exports.default = Tabs;

var BlockZone = function () {
  function BlockZone(t) {
    (0, _classCallCheck3.default)(this, BlockZone);

    this._time = t;
    this._blocked = false;
    this._timeoutId = 0;
  }

  (0, _createClass3.default)(BlockZone, [{
    key: 'start',
    value: function start() {
      var _this5 = this;

      window.clearTimeout(this._timeoutId);
      this._blocked = true;

      this._timeoutId = window.setTimeout(function () {
        _this5._blocked = false;
      }, this._time);
    }
  }, {
    key: 'clear',
    get: function get() {
      return !this._blocked;
    }
  }]);
  return BlockZone;
}();

/*
Timer - one move after 100ms
      - wait 500ms
      - then animate
      - move checks if theres is anywhere to move to before advancing to the next frame

  Timer is "running" immediately
  Timer is "activated" one the 100ms first move has happened

  If a started timer is cancelled before being activated, do a block move (this is how click / tap will work)
*/


var ScrollTimer = function () {
  function ScrollTimer(tabset) {
    (0, _classCallCheck3.default)(this, ScrollTimer);

    this._tabset = tabset;
    this._timeoutId = 0;
    this._started = false;
    this._activated = false;
  }

  (0, _createClass3.default)(ScrollTimer, [{
    key: 'moveTabs',
    value: function moveTabs(by) {
      return this._tabset.moveTabs(by * this._px);
    }
  }, {
    key: 'stop',
    value: function stop() {
      window.clearTimeout(this._timeoutId);

      if (this._started && !this._activated) {
        this.moveTabs(60);
      }

      this._started = false;
      this._activated = false;
    }
  }, {
    key: 'start',
    value: function start(px) {
      var _this6 = this;

      var initialDelay = 200;
      var holdPause = 500;
      var frameDelay = 1000 / 20; // 20 is frame rate

      this._px = px;
      this.stop();
      this._started = true;

      var frameCount = 0;

      var _frame = function _frame() {
        window.clearTimeout(_this6._timeoutId);
        var msGap = [initialDelay, holdPause][frameCount++] || frameDelay;

        _this6._timeoutId = window.setTimeout(function () {
          _this6._activated = true;

          if (_this6.moveTabs(10)) {
            _frame();
          } else {
            _this6.stop();
          }
        }, msGap);
      };

      _frame();
    }
  }, {
    key: 'idle',
    get: function get() {
      return !this._started;
    }
  }]);
  return ScrollTimer;
}();

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _reactRedux = __webpack_require__(17);

var _reactRouter = __webpack_require__(11);

var _GooglePublisherTag = __webpack_require__(735);

var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _tamGptInitialization = __webpack_require__(256);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, props) {
  var _state$common = state.common;
  _state$common = _state$common === undefined ? {} : _state$common;
  var _state$common$window = _state$common.window;
  _state$common$window = _state$common$window === undefined ? {} : _state$common$window;
  var _state$common$window$ = _state$common$window.isLoaded,
      windowIsLoaded = _state$common$window$ === undefined ? false : _state$common$window$,
      _state$common$tamGpt = _state$common.tamGpt,
      _state$common$tamGpt$ = _state$common$tamGpt.initializationComplete,
      initializationComplete = _state$common$tamGpt$ === undefined ? false : _state$common$tamGpt$,
      _state$common$tamGpt$2 = _state$common$tamGpt.tamAvailable,
      tamAvailable = _state$common$tamGpt$2 === undefined ? false : _state$common$tamGpt$2,
      _state$common$tamGpt$3 = _state$common$tamGpt.advertSlots,
      advertSlots = _state$common$tamGpt$3 === undefined ? {} : _state$common$tamGpt$3,
      _state$auth = state.auth;
  _state$auth = _state$auth === undefined ? {} : _state$auth;
  var _state$auth$loggedIn = _state$auth.loggedIn,
      loggedIn = _state$auth$loggedIn === undefined ? false : _state$auth$loggedIn,
      _state$auth$user = _state$auth.user;
  _state$auth$user = _state$auth$user === undefined ? {} : _state$auth$user;
  var _state$auth$user$full = _state$auth$user.fullyregistered,
      fullyregistered = _state$auth$user$full === undefined ? false : _state$auth$user$full;
  var _props$type = props.type,
      adType = _props$type === undefined ? null : _props$type,
      _props$routes = props.routes;
  _props$routes = _props$routes === undefined ? [] : _props$routes;

  var _props$routes2 = (0, _slicedToArray3.default)(_props$routes, 2),
      _props$routes2$1$last = _props$routes2[1].lastRegisteredPath,
      lastRegisteredPath = _props$routes2$1$last === undefined ? "home" : _props$routes2$1$last;

  var _config$googlePublish = _config2.default.googlePublisherTag.enabled,
      adsEnabled = _config$googlePublish === undefined ? false : _config$googlePublish;

  var targetParams = adType ? _config2.default.googlePublisherTag[adType] : {};

  return (0, _extends3.default)({}, props, {
    windowIsLoaded: windowIsLoaded,
    path: props.section ? props.section : lastRegisteredPath,
    fullyRegistered: loggedIn ? fullyregistered : null,
    targetParams: targetParams,
    adType: adType,
    adsEnabled: adsEnabled,
    isStagingEnv: _config2.default.staging,
    hostname: global.location ? global.location.hostname : 'www.sportinglife.com',
    initializationComplete: initializationComplete,
    tamAvailable: tamAvailable,
    advertSlots: advertSlots
  });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    fetchAdverts: function fetchAdverts(slotId, slotSize, sizeMapping) {
      dispatch({ type: _tamGptInitialization.LOAD_ADVERTS, slotId: slotId, slotSize: slotSize, sizeMapping: sizeMapping });
    }
  };
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_GooglePublisherTag2.default));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SSO_MY_ACCOUNT = exports.SSO_REGISTER = exports.SSO_LOGIN = exports.GET_LOGIN_STATE = exports.APPBRIDGE_SLEEP = exports.BIND_APPBRIDGE = exports.BIND_SSO_API = exports.LOGIN = exports.LOGOUT = exports.SBA_READY = exports.APPBRIDGE_READY = exports.SAVE_PUSH_ID = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.setLogin = setLogin;
exports.login = login;
exports.logout = logout;
exports.savePushId = savePushId;
exports.appBridgeReady = appBridgeReady;
exports.sbaReady = sbaReady;
exports.appBridgeSleep = appBridgeSleep;
exports.bindToSSO = bindToSSO;
exports.bindToAppbridge = bindToAppbridge;
exports.updateLoginState = updateLoginState;
exports.SSOLogin = SSOLogin;
exports.SSORegister = SSORegister;
exports.SSOMyAccount = SSOMyAccount;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SAVE_PUSH_ID = exports.SAVE_PUSH_ID = 'common/skysso/SAVE_PUSH_ID';
var APPBRIDGE_READY = exports.APPBRIDGE_READY = 'common/skysso/APPBRIDGE_READY';
var SBA_READY = exports.SBA_READY = 'common/skysso/SBA_READY';
var LOGOUT = exports.LOGOUT = 'common/skysso/LOGOUT';
var LOGIN = exports.LOGIN = 'common/skysso/LOGIN';
var BIND_SSO_API = exports.BIND_SSO_API = 'common/skysso/BIND_SSO_API';
var BIND_APPBRIDGE = exports.BIND_APPBRIDGE = 'common/skysso/BIND_APPBRIDGE';
var APPBRIDGE_SLEEP = exports.APPBRIDGE_SLEEP = 'common/skysso/APPBRIDGE_SLEEP';
var GET_LOGIN_STATE = exports.GET_LOGIN_STATE = 'common/skysso/GET_LOGIN_STATE';
var SSO_LOGIN = exports.SSO_LOGIN = 'common/skysso/SSO_LOGIN';
var SSO_REGISTER = exports.SSO_REGISTER = 'common/skysso/SSO_REGISTER';
var SSO_MY_ACCOUNT = exports.SSO_MY_ACCOUNT = 'common/skysso/SSO_MY_ACCOUNT';

var initialState = {
  loggedIn: false,
  loginInitiated: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOGIN:
      return (0, _extends3.default)({}, state, {
        loggedIn: true,
        user: action.data.user
      });
    case LOGOUT:
      return (0, _extends3.default)({}, state, {
        loggedIn: false,
        user: undefined
      });
    case SAVE_PUSH_ID:
      return (0, _extends3.default)({}, state, {
        deviceId: action.deviceId
      });
    case APPBRIDGE_READY:
      return (0, _extends3.default)({}, state, {
        appBridgeReady: true
      });
    case SBA_READY:
      return (0, _extends3.default)({}, state, {
        ssoApi: action.sba
      });
    case SSO_LOGIN:
      return (0, _extends3.default)({}, state, {
        loginInitiated: true
      });
    default:
      return state;
  }
}

function setLogin(data) {
  if (data && data.user && data.user.ssoToken) {
    return {
      type: LOGIN,
      data: data
    };
  }
}

function login(data) {
  if (data && data.user && data.user.ssoToken) {
    return {
      type: LOGIN,
      data: data
    };
  }
}

function logout() {
  return {
    type: LOGOUT
  };
}

function savePushId(pushId) {
  return {
    type: SAVE_PUSH_ID,
    deviceId: pushId
  };
}

function appBridgeReady() {
  return {
    type: APPBRIDGE_READY,
    appBridgeReady: true
  };
}

function sbaReady(sba) {
  return {
    type: SBA_READY,
    sba: sba
  };
}

function appBridgeSleep() {
  return {
    type: APPBRIDGE_SLEEP
  };
}

function bindToSSO() {
  return {
    type: BIND_SSO_API
  };
}

function bindToAppbridge() {
  return {
    type: BIND_APPBRIDGE
  };
}

function updateLoginState() {
  return {
    type: GET_LOGIN_STATE
  };
}

function SSOLogin() {
  return {
    type: SSO_LOGIN
  };
}

function SSORegister() {
  return {
    type: SSO_REGISTER
  };
}

function SSOMyAccount() {
  return {
    type: SSO_MY_ACCOUNT
  };
}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(49);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(25);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(87);
var IE8_DOM_DEFINE = __webpack_require__(486);
var toPrimitive = __webpack_require__(322);
var dP = Object.defineProperty;

exports.f = __webpack_require__(88) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _set = __webpack_require__(481);

var _set2 = _interopRequireDefault(_set);

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends7 = __webpack_require__(7);

var _extends8 = _interopRequireDefault(_extends7);

exports.default = reducer;
exports.isMediaLoaded = isMediaLoaded;
exports.loadMediaForArticles = loadMediaForArticles;
exports.loadVideoMediaUrl = loadVideoMediaUrl;
exports.loadMediaUrl = loadMediaUrl;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _utils = __webpack_require__(271);

var _mediaTypes = __webpack_require__(1635);

var _OoyalaApiClient = __webpack_require__(272);

var _OoyalaApiClient2 = _interopRequireDefault(_OoyalaApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_MEDIA_URL = 'common/media/LOAD_MEDIA_URL';
var LOAD_OTHER_MEDIA_URL_SUCCESS = 'common/media/LOAD_OTHER_MEDIA_URL_SUCCESS';
var LOAD_VIDEO_MEDIA_URL_SUCCESS = 'common/media/LOAD_VIDEO_MEDIA_URL_SUCCESS';
var LOAD_MEDIA_URL_FAIL = 'common/media/LOAD_MEDIA_URL_FAIL';

var initialState = {};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var id = action.mediaType === _mediaTypes.VIDEO ? "video_" + action.mediaId : action.mediaId;
  switch (action.type) {
    case LOAD_MEDIA_URL:
      return (0, _extends8.default)({}, state, (0, _defineProperty3.default)({}, id, {
        loading: true
      }));
    case LOAD_VIDEO_MEDIA_URL_SUCCESS:
      return (0, _extends8.default)({}, state, (0, _defineProperty3.default)({}, id, (0, _extends8.default)({
        loading: false,
        loaded: true
      }, {
        videoData: action.result
      })));
    case LOAD_OTHER_MEDIA_URL_SUCCESS:
      return (0, _extends8.default)({}, state, (0, _defineProperty3.default)({}, id, (0, _extends8.default)({
        loading: false,
        loaded: true
      }, {
        caption: action.result.default_caption,
        artefacts: action.result.artefacts
      })));
    case LOAD_MEDIA_URL_FAIL:
      return (0, _extends8.default)({}, state, (0, _defineProperty3.default)({}, id, {
        loading: false,
        loaded: false,
        error: action.error
      }));
    default:
      return state;
  }
}

function isMediaLoaded(globalState, mediaId) {
  return globalState.common.media && globalState.common.media[mediaId] && globalState.common.media[mediaId].loaded;
}

function loadMediaForArticles(globalState, dispatch, articles) {
  var mediaLoad = [];
  var mediaIds = new _set2.default();

  articles.forEach(function (article) {
    (0, _utils.getMediaWidgetIds)(article.widgets).forEach(function (id) {
      return id && mediaIds.add(id);
    });
  });

  mediaIds.forEach(function (mediaId) {
    if (!isMediaLoaded(globalState, mediaId)) {
      mediaLoad.push(dispatch(loadMediaUrl(mediaId)));
    }
  });

  var convertToObject = function convertToObject(widget) {
    return widget.keys.reduce(function (out, kv) {
      return (0, _extends8.default)({}, out, (0, _defineProperty3.default)({}, kv.key, kv.value));
    }, {});
  };

  articles.reduce(function (widgets, article) {
    return widgets.concat(article.widgets);
  }, []).filter(function (widget) {
    return widget.widget_type === _mediaTypes.VIDEO;
  }).map(function (w) {
    return convertToObject(w).media_id;
  }).filter(function (mediaId) {
    return !isMediaLoaded(globalState, mediaId);
  }).forEach(function (mediaId) {
    return mediaLoad.push(dispatch(loadVideoMediaUrl(mediaId)));
  });

  return _promise2.default.all(mediaLoad);
}

function loadVideoMediaUrl(mediaId) {
  return {
    types: [LOAD_MEDIA_URL, LOAD_VIDEO_MEDIA_URL_SUCCESS, LOAD_MEDIA_URL_FAIL],
    promise: function promise() {
      return _OoyalaApiClient2.default.getAsset(mediaId);
    },
    mediaType: _mediaTypes.VIDEO,
    mediaId: mediaId
  };
}

function loadMediaUrl(mediaId) {
  return {
    types: [LOAD_MEDIA_URL, LOAD_OTHER_MEDIA_URL_SUCCESS, LOAD_MEDIA_URL_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.media.loadMedia + '/' + mediaId);
    },
    mediaType: "imageOrTip",
    mediaId: mediaId
  };
}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends6 = __webpack_require__(7);

var _extends7 = _interopRequireDefault(_extends6);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.loadByPath = loadByPath;
exports.loadById = loadById;
exports.loadByQuery = loadByQuery;
exports.loadMostRead = loadMostRead;
exports.connectMoreNews = connectMoreNews;
exports.asyncConnectMostRead = asyncConnectMostRead;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _media = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'common/more-news/LOAD';
var LOAD_SUCCESS = 'common/more-news/LOAD_SUCCESS';
var LOAD_SUCCESS_REFRESH = 'common/more-news/LOAD_SUCCESS_REFRESH';
var LOAD_FAIL = 'common/more-news/LOAD_FAIL';

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.basketPath, (0, _extends7.default)({}, state[action.basketPath], {
        loading: true,
        articles: state[action.basketPath] && state[action.basketPath].articles || []
      })));
    case LOAD_SUCCESS:
      {

        var currentSummaries = state[action.basketPath] && state[action.basketPath].articles;
        var summaries = currentSummaries.concat(action.result.articles);

        var sortAndUnique = function sortAndUnique(a) {
          return a.priority;
        };
        var sortedAndUnique = _lodash2.default.sortedUniqBy(_lodash2.default.sortBy(summaries, [sortAndUnique]), sortAndUnique);

        return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.basketPath, (0, _extends7.default)({}, state[action.basketPath], {
          loading: false,
          loaded: true,
          articles: sortedAndUnique,
          path: action.result.basket_path,
          name: action.result.basket_name,
          title: action.result.basket_title
        })));
      }
    case LOAD_SUCCESS_REFRESH:
      return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.basketPath, (0, _extends7.default)({}, state[action.basketPath], {
        loading: false,
        loaded: true,
        articles: action.result.articles,
        path: action.result.basket_path,
        name: action.result.basket_name,
        title: action.result.basket_title
      })));
    case LOAD_FAIL:
      return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.basketPath, (0, _extends7.default)({}, state[action.basketPath], {
        loading: false,
        error: action.error
      })));
    default:
      return state;
  }
}

function generateBasketPath(basketPath) {
  var newBasketPath = "sl" + basketPath;
  if (basketPath == "/") {
    newBasketPath = newBasketPath + "home";
  }
  return newBasketPath;
}

function isLoaded(globalState, basketPath) {
  return globalState.common.morenews && globalState.common.morenews[basketPath] && globalState.common.morenews[basketPath].loaded;
}

function load(basketPath, limit, offset, refresh) {
  return loadByPath(basketPath, limit, offset, refresh);
}

function loadByPath(basketPath, limit, offset, refresh) {
  return _loadData({
    key: "basketPath",
    value: basketPath
  }, { limit: limit, offset: offset, refresh: refresh });
}

function loadById(basketId, limit, offset, refresh) {
  return _loadData({
    key: "basketId",
    value: basketId
  }, { limit: limit, offset: offset, refresh: refresh });
}

function loadByQuery(query, limit, offset, refresh) {
  return _loadData(query, { limit: limit, offset: offset, refresh: refresh });
}

function loadMostRead(basketPath) {
  var query = {};

  if (basketPath) {
    query = {
      key: "basketPath",
      value: basketPath
    };
  }

  return _loadData(query, {
    mostRead: true
  });
}

var _mostReadKey = function _mostReadKey() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "all-articles";
  return path + '::MOST_READ';
};

function _loadData() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      key = _ref2.key,
      value = _ref2.value;

  var _ref = arguments[1];
  var _ref$limit = _ref.limit,
      limit = _ref$limit === undefined ? 5 : _ref$limit,
      _ref$offset = _ref.offset,
      offset = _ref$offset === undefined ? 0 : _ref$offset,
      _ref$refresh = _ref.refresh,
      refresh = _ref$refresh === undefined ? false : _ref$refresh,
      _ref$mostRead = _ref.mostRead,
      mostRead = _ref$mostRead === undefined ? false : _ref$mostRead;

  var params = {
    limit: limit,
    offset: offset
  };

  if (key == "basketPath") {
    params[key] = generateBasketPath(value);
  } else if (value) {
    params[key] = value;
  }

  var storageKey = value;

  if (mostRead) {
    storageKey = _mostReadKey(value);
    params.orderBy = "MOST_READ";
  }

  return {
    // Exact same data structure just slightly different logic in action based on a refresh or load morenews.
    // Had a problem when an article was removed and the state was keeping hold of it.
    types: [LOAD, refresh ? LOAD_SUCCESS_REFRESH : LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.common.loadArticleSummary, { params: params });
    },
    // store by path or ID, which ever the data was requested by
    // OK because paths always start with "sl/" and IDs never do
    // also path is for default baskets, and ID for custom ones, so there will be no duplication
    basketPath: storageKey
  };
}

function connectMoreNews(state) {
  return {
    news: state.common.morenews
  };
}

function asyncConnectMostRead(basketPath) {
  return [{
    dispatch: function dispatch() {
      return loadMostRead(basketPath);
    },
    state: function state(_ref3) {
      var _ref3$common = _ref3.common;
      _ref3$common = _ref3$common === undefined ? {} : _ref3$common;
      var _ref3$common$morenews = _ref3$common.morenews;
      _ref3$common$morenews = _ref3$common$morenews === undefined ? {} : _ref3$common$morenews;

      var _ref3$common$morenews2 = _ref3$common$morenews[_mostReadKey(basketPath)];

      _ref3$common$morenews2 = _ref3$common$morenews2 === undefined ? {} : _ref3$common$morenews2;
      var articles = _ref3$common$morenews2.articles;
      return {
        mostread: articles
      };
    },
    then: function then(_ref4) {
      var dispatch = _ref4.dispatch,
          state = _ref4.state,
          articles = _ref4.result.articles;
      return (0, _media.loadMediaForArticles)(state, dispatch, articles);
    }
  }];
}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _userService = __webpack_require__(44);

var _mostfollowed = __webpack_require__(420);

var _reactRouter = __webpack_require__(11);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _LocalDateTimeHelper = __webpack_require__(13);

var _SubscriptionContainer = __webpack_require__(92);

var _SubscriptionContainer2 = _interopRequireDefault(_SubscriptionContainer);

var _MyStableButton = __webpack_require__(167);

var _MyStableButton2 = _interopRequireDefault(_MyStableButton);

var _Silk = __webpack_require__(113);

var _Silk2 = _interopRequireDefault(_Silk);

var _SwitchBtns = __webpack_require__(102);

var _SwitchBtns2 = _interopRequireDefault(_SwitchBtns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1445);

var HorseRacingMostFollowed = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch() {
    return (0, _mostfollowed.load)("horse");
  },
  preventResolve: function preventResolve(_ref) {
    var state = _ref.state;
    return (0, _mostfollowed.isLoading)(state);
  },
  refreshInterval: 600000, // 10 minutes
  state: _mostfollowed.get
}, (0, _userService.userServiceLayoutConnect)()]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingMostFollowed, _Component);

  function HorseRacingMostFollowed() {
    var _ref2;

    (0, _classCallCheck3.default)(this, HorseRacingMostFollowed);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = HorseRacingMostFollowed.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingMostFollowed)).call.apply(_ref2, [this].concat(args)));

    _this.state = {
      list: "horse"
    };
    return _this;
  }

  (0, _createClass3.default)(HorseRacingMostFollowed, [{
    key: 'showList',
    value: function showList(list) {
      var _this2 = this;

      this.props.dispatch((0, _mostfollowed.load)(list)).then(function () {
        return _this2.setState({ list: list });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props$mostFollowed = this.props.mostFollowed,
          mostFollowed = _props$mostFollowed === undefined ? [] : _props$mostFollowed;
      var list = this.state.list;


      return _react2.default.createElement(
        'div',
        { className: 'most-followed' },
        _react2.default.createElement(
          'div',
          { className: 'section-title' },
          'Most Followed'
        ),
        _react2.default.createElement(
          'div',
          { className: 'most-followed-list' },
          _react2.default.createElement(_SwitchBtns2.default, { buttons: [{ text: "Horses", value: "horse" }, { text: "Jockeys", value: "jockey" }, { text: "Trainers", value: "trainer" }],
            onChange: function onChange(e, _ref3) {
              var value = _ref3.value;
              return _this3.showList(value);
            },
            value: this.state.list
          }),
          mostFollowed.map(function (item) {
            return types[list](item);
          }),
          !mostFollowed.length && _react2.default.createElement(
            'p',
            { className: 'most-followed-nothing' },
            'There\'s currently nothing to show here.'
          )
        )
      );
    }
  }]);
  return HorseRacingMostFollowed;
}(_react.Component), _class2.propTypes = {
  mostFollowed: _propTypes2.default.array,
  dispatch: _propTypes2.default.func
}, _temp)) || _class);
exports.default = HorseRacingMostFollowed;


var profile = function profile(type, id) {
  return _config2.default.canonicalBase + '/racing/profiles/' + type + '/' + id;
};

var types = {
  horse: function horse(data) {
    return horseEntry(data);
  },
  jockey: function jockey(data) {
    return personEntry("jockey", data);
  },
  trainer: function trainer(data) {
    return personEntry("trainer", data);
  }
};

function horseEntry(_ref4) {
  var _ref4$horse = _ref4.horse;
  _ref4$horse = _ref4$horse === undefined ? {} : _ref4$horse;
  var horseName = _ref4$horse.name,
      _ref4$horse$horse_ref = _ref4$horse.horse_reference;
  _ref4$horse$horse_ref = _ref4$horse$horse_ref === undefined ? {} : _ref4$horse$horse_ref;
  var horseId = _ref4$horse$horse_ref.id,
      _ref4$trainer = _ref4.trainer;
  _ref4$trainer = _ref4$trainer === undefined ? {} : _ref4$trainer;
  var trainerName = _ref4$trainer.name,
      silk_filename = _ref4.silk_filename,
      formwatch = _ref4.formwatch;

  return _react2.default.createElement(
    'div',
    { key: horseId, className: 'most-followed-list-item' },
    _react2.default.createElement(
      'div',
      { className: 'most-followed-horse-silk' },
      _react2.default.createElement(
        _reactRouter.Link,
        { to: profile("horse", horseId) },
        _react2.default.createElement(_Silk2.default, { filename: silk_filename })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'most-followed-horse-details' },
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          { to: profile("horse", horseId) },
          horseName
        )
      ),
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'span',
          { className: 'label' },
          'F:'
        ),
        ' ',
        formwatch || "-"
      ),
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'span',
          { className: 'label' },
          'T:'
        ),
        ' ',
        trainerName || "-"
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'most-followed-follow' },
      _react2.default.createElement(_SubscriptionContainer2.default, {
        addSubscriptions: [{ type: "HORSE", id: horseId, text: horseName }],
        icon: _react2.default.createElement(_MyStableButton2.default, null)
      })
    )
  );
}
horseEntry.propTypes = {
  horse: _propTypes2.default.object,
  trainer: _propTypes2.default.object,
  silk_filename: _propTypes2.default.string,
  formwatch: _propTypes2.default.string
};

function personEntry(type, _ref5) {
  var _ref5$person_details = _ref5.person_details;
  _ref5$person_details = _ref5$person_details === undefined ? {} : _ref5$person_details;
  var personName = _ref5$person_details.name,
      _ref5$person_details$ = _ref5$person_details.person_reference;
  _ref5$person_details$ = _ref5$person_details$ === undefined ? {} : _ref5$person_details$;
  var personId = _ref5$person_details$.id,
      _ref5$run_future_entr = _ref5.run_future_entries;
  _ref5$run_future_entr = _ref5$run_future_entr === undefined ? [] : _ref5$run_future_entr;

  var _ref5$run_future_entr2 = (0, _slicedToArray3.default)(_ref5$run_future_entr, 1),
      _ref5$run_future_entr3 = _ref5$run_future_entr2[0];

  _ref5$run_future_entr3 = _ref5$run_future_entr3 === undefined ? {} : _ref5$run_future_entr3;
  var _ref5$run_future_entr4 = _ref5$run_future_entr3.horse_summary;
  _ref5$run_future_entr4 = _ref5$run_future_entr4 === undefined ? {} : _ref5$run_future_entr4;
  var nextHorseName = _ref5$run_future_entr4.name,
      _ref5$run_future_entr5 = _ref5$run_future_entr3.horse_entry;
  _ref5$run_future_entr5 = _ref5$run_future_entr5 === undefined ? {} : _ref5$run_future_entr5;
  var nextDate = _ref5$run_future_entr5.date,
      _ref5$run_previous_re = _ref5.run_previous_results;
  _ref5$run_previous_re = _ref5$run_previous_re === undefined ? [] : _ref5$run_previous_re;

  var _ref5$run_previous_re2 = (0, _slicedToArray3.default)(_ref5$run_previous_re, 1),
      _ref5$run_previous_re3 = _ref5$run_previous_re2[0];

  _ref5$run_previous_re3 = _ref5$run_previous_re3 === undefined ? {} : _ref5$run_previous_re3;
  var _ref5$run_previous_re4 = _ref5$run_previous_re3.horse_summary;
  _ref5$run_previous_re4 = _ref5$run_previous_re4 === undefined ? {} : _ref5$run_previous_re4;
  var lastHorseName = _ref5$run_previous_re4.name,
      _ref5$run_previous_re5 = _ref5$run_previous_re3.horse_entry;
  _ref5$run_previous_re5 = _ref5$run_previous_re5 === undefined ? {} : _ref5$run_previous_re5;
  var lastPosition = _ref5$run_previous_re5.position,
      lastRunners = _ref5$run_previous_re5.runner_count;

  return _react2.default.createElement(
    'div',
    { key: personId, className: 'most-followed-list-item' },
    _react2.default.createElement(
      'div',
      { className: 'most-followed-person-details' },
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          { to: profile(type, personId) },
          personName
        )
      ),
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'span',
          { className: 'label' },
          'Next:'
        ),
        ' ',
        nextHorseName || "-",
        ' ',
        _react2.default.createElement(
          'span',
          { className: 'label' },
          'Date:'
        ),
        ' ',
        nextDate ? (0, _LocalDateTimeHelper.localFullDateShort)(nextDate) : "-"
      ),
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'span',
          { className: 'label' },
          'Previous:'
        ),
        ' ',
        lastHorseName || "-",
        ' ',
        _react2.default.createElement(
          'span',
          { className: 'label' },
          'Pos:'
        ),
        ' ',
        lastPosition || "-",
        !!lastRunners && '/' + lastRunners
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'most-followed-follow' },
      _react2.default.createElement(_SubscriptionContainer2.default, {
        addSubscriptions: [{ type: type.toUpperCase(), id: personId, text: personName }],
        icon: _react2.default.createElement(_MyStableButton2.default, null)
      })
    )
  );
}
personEntry.propTypes = {
  person_details: _propTypes2.default.object,
  run_future_entries: _propTypes2.default.object,
  run_previous_results: _propTypes2.default.object
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(74);
var IObject = __webpack_require__(178);
var toObject = __webpack_require__(45);
var toLength = __webpack_require__(41);
var asc = __webpack_require__(279);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 83 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(9);
var core = __webpack_require__(82);
var fails = __webpack_require__(25);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(26);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(76);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(133)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(1345);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 90 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(1542);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(17);

var _subscriptionUtils = __webpack_require__(277);

var _commonUtils = __webpack_require__(36);

var _display = __webpack_require__(258);

var _userService = __webpack_require__(44);

var _consts = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1395);

var SubscriptionContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    subscriptions: state.common.userService.subscriptions,
    auth: state.common.auth
  };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SubscriptionContainer, _Component);

  function SubscriptionContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SubscriptionContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SubscriptionContainer.__proto__ || (0, _getPrototypeOf2.default)(SubscriptionContainer)).call.apply(_ref, [this].concat(args))), _this), _this.loggedIn = function () {
      var _this$props$auth = _this.props.auth;
      _this$props$auth = _this$props$auth === undefined ? {} : _this$props$auth;
      var _this$props$auth$logg = _this$props$auth.loggedIn,
          loggedIn = _this$props$auth$logg === undefined ? false : _this$props$auth$logg;


      return loggedIn;
    }, _this.saveSubscriptions = function (subscriptionsToSave) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          _this$props$addSubscr = (0, _slicedToArray3.default)(_this$props.addSubscriptions, 1),
          type = _this$props$addSubscr[0].type;

      if (!_this.loggedIn()) {
        dispatch((0, _display.openLightbox)('login', type));
        return _promise2.default.reject(_consts.NOT_LOGGED_IN_ERROR);
      } else {
        return _this.dispatchSubscription(true, _userService.saveSubscriptions, subscriptionsToSave);
      }
    }, _this.deleteSubscriptions = function () {
      return _this.dispatchSubscription(false, _userService.deleteSubscriptions);
    }, _this.dispatchSubscription = function (filter, dispatchFunc) {
      var subscriptionsToUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.filterSubscriptions(filter);
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          auth = _this$props2.auth;


      if (subscriptionsToUpdate.length > 0) {
        return dispatch(dispatchFunc(auth, subscriptionsToUpdate));
      }
      return _promise2.default.reject();
    }, _this.hasSubscriptions = function () {
      return _this.filterSubscriptions(false).length > 0;
    }, _this.filterSubscriptions = function (difference) {
      var _this$props3 = _this.props,
          _this$props3$subscrip = _this$props3.subscriptions,
          subscriptions = _this$props3$subscrip === undefined ? {} : _this$props3$subscrip,
          _this$props3$addSubsc = _this$props3.addSubscriptions,
          addSubscriptions = _this$props3$addSubsc === undefined ? [] : _this$props3$addSubsc;


      return (0, _subscriptionUtils.subscriptionDifference)(addSubscriptions, subscriptions, difference);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SubscriptionContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _getActionParam = (0, _commonUtils.getActionParam)("subscribe"),
          _getActionParam2 = (0, _slicedToArray3.default)(_getActionParam, 2),
          reqType = _getActionParam2[0],
          reqId = _getActionParam2[1];

      if (reqId) {
        var _props$addSubscriptio = this.props.addSubscriptions,
            addSubscriptions = _props$addSubscriptio === undefined ? [] : _props$addSubscriptio;

        // get a list of those subscriptions this container is responsible for, that match the URL subscription parameter, and that aren't already subscribed to (ie don't have a valid subId)
        // There will be only one, since the URL param can't container several, at the moment

        var subsToAdd = addSubscriptions.filter(function (_ref2) {
          var type = _ref2.type,
              id = _ref2.id,
              subId = _ref2.subId;
          return !subId && type == reqType && id == reqId;
        });

        if (subsToAdd.length) {
          this.saveSubscriptions(subsToAdd);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var icon = this.props.icon;


      if (!icon) {
        return null;
      }

      return _react2.default.cloneElement(icon, {
        hasSubscriptions: this.hasSubscriptions(),
        saveSubscriptions: this.saveSubscriptions,
        deleteSubscriptions: this.deleteSubscriptions
      });
    }
  }]);
  return SubscriptionContainer;
}(_react.Component), _class2.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  subscriptions: _propTypes2.default.object.isRequired,
  auth: _propTypes2.default.object.isRequired,
  addSubscriptions: _propTypes2.default.array.isRequired,
  icon: _propTypes2.default.node.isRequired
}, _temp2)) || _class);
exports.default = SubscriptionContainer;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _morenews = __webpack_require__(79);

var _media = __webpack_require__(78);

var _MoreNewsList = __webpack_require__(431);

var _MoreNewsList2 = _interopRequireDefault(_MoreNewsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_PAGE_SIZE = 12;

var MoreNews = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)('MoreNews', [{
  dispatch: function dispatch(_ref) {
    var pathname = _ref.pathname;
    return (0, _morenews.load)(pathname, INITIAL_PAGE_SIZE + 1);
  },
  // no state - not needed here, MoreNewsList @connects
  then: function then(_ref2) {
    var dispatch = _ref2.dispatch,
        state = _ref2.state,
        articles = _ref2.result.articles;
    return (0, _media.loadMediaForArticles)(state, dispatch, articles);
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MoreNews, _Component);

  function MoreNews() {
    (0, _classCallCheck3.default)(this, MoreNews);
    return (0, _possibleConstructorReturn3.default)(this, (MoreNews.__proto__ || (0, _getPrototypeOf2.default)(MoreNews)).apply(this, arguments));
  }

  (0, _createClass3.default)(MoreNews, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_MoreNewsList2.default, {
        basketQuery: { key: "basketPath", value: location.pathname },
        initialPageSize: INITIAL_PAGE_SIZE
      });
    }
  }]);
  return MoreNews;
}(_react.Component), _class2.propTypes = {
  location: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = MoreNews;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(476);
var $export = __webpack_require__(9);
var shared = __webpack_require__(230)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(479))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(39)) {
  var LIBRARY = __webpack_require__(123);
  var global = __webpack_require__(19);
  var fails = __webpack_require__(25);
  var $export = __webpack_require__(9);
  var $typed = __webpack_require__(232);
  var $buffer = __webpack_require__(300);
  var ctx = __webpack_require__(74);
  var anInstance = __webpack_require__(121);
  var propertyDesc = __webpack_require__(127);
  var hide = __webpack_require__(56);
  var redefineAll = __webpack_require__(128);
  var toInteger = __webpack_require__(85);
  var toLength = __webpack_require__(41);
  var toIndex = __webpack_require__(474);
  var toAbsoluteIndex = __webpack_require__(130);
  var toPrimitive = __webpack_require__(86);
  var has = __webpack_require__(55);
  var classof = __webpack_require__(177);
  var isObject = __webpack_require__(26);
  var toObject = __webpack_require__(45);
  var isArrayIter = __webpack_require__(286);
  var create = __webpack_require__(124);
  var getPrototypeOf = __webpack_require__(67);
  var gOPN = __webpack_require__(125).f;
  var getIterFn = __webpack_require__(303);
  var uid = __webpack_require__(131);
  var wks = __webpack_require__(33);
  var createArrayMethod = __webpack_require__(81);
  var createArrayIncludes = __webpack_require__(219);
  var speciesConstructor = __webpack_require__(231);
  var ArrayIterators = __webpack_require__(304);
  var Iterators = __webpack_require__(142);
  var $iterDetect = __webpack_require__(225);
  var setSpecies = __webpack_require__(129);
  var arrayFill = __webpack_require__(278);
  var arrayCopyWithin = __webpack_require__(447);
  var $DP = __webpack_require__(40);
  var $GOPD = __webpack_require__(66);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(182);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(188)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _FeedIcon = __webpack_require__(364);

var _FeedIcon2 = _interopRequireDefault(_FeedIcon);

var _reactRouter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollapsibleSection = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CollapsibleSection, _Component);

  function CollapsibleSection(props) {
    (0, _classCallCheck3.default)(this, CollapsibleSection);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CollapsibleSection.__proto__ || (0, _getPrototypeOf2.default)(CollapsibleSection)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.state = {
      collapsed: props.collapsed || false
    };
    return _this;
  }

  (0, _createClass3.default)(CollapsibleSection, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // checks that collapsed has initially been set, and then checks whether to update
      if (this.state.hasOwnProperty('collapsed') && this.state.collapsed !== nextProps.collapsed) {
        this.setState({
          collapsed: nextProps.collapsed
        });
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      this.setState({ collapsed: !this.state.collapsed });
    }
  }, {
    key: 'render',
    value: function render() {
      __webpack_require__(1362);

      return _react2.default.createElement(
        'div',
        { className: 'collapsibleSection' },
        _react2.default.createElement(
          'div',
          { onClick: this.handleClick, className: this.state.collapsed ? "dividerRowCollapsed" : "dividerRow" },
          _react2.default.createElement(
            'h2',
            { className: this.props.feedLogo ? "sectionTitleWithProviderLogo" : "sectionTitle" },
            this.props.linkTo ? _react2.default.createElement(
              _reactRouter.Link,
              { to: this.props.linkTo },
              this.props.title
            ) : this.props.title
          ),
          !!this.props.feedLogo && _react2.default.createElement(_FeedIcon2.default, { feed: this.props.feedLogo }),
          _react2.default.createElement(
            'div',
            { className: 'collapseArrow' },
            _react2.default.createElement(_CaretIcon2.default, { type: 'line', direction: this.state.collapsed ? "down" : "up" })
          )
        ),
        this.state.collapsed || _react2.default.createElement(
          'div',
          null,
          this.props.children
        )
      );
    }
  }]);
  return CollapsibleSection;
}(_react.Component), _class.propTypes = {
  collapsed: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  feedLogo: _propTypes2.default.string,
  title: _propTypes2.default.string.isRequired,
  linkTo: _propTypes2.default.string
}, _temp);
exports.default = CollapsibleSection;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(148);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(11);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _reactSelect = __webpack_require__(1597);

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _commonUtils = __webpack_require__(36);

var _reactDeviceDetect = __webpack_require__(109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1366);

var Dropdown = (0, _reactRouter.withRouter)(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Dropdown.__proto__ || (0, _getPrototypeOf2.default)(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.singleValue = function (_ref2) {
      var children = _ref2.children,
          props = (0, _objectWithoutProperties3.default)(_ref2, ['children']);

      return _react2.default.createElement(
        _reactSelect.components.SingleValue,
        (0, _extends3.default)({}, props, { className: 'dropdown-value' }),
        children
      );
    }, _this.handleChange = function (selectedOption) {
      var value = selectedOption.value;
      if (!value) {
        return;
      }
      if (_this.props.onChange) {
        _this.props.onChange(value);
      }
      if (_this.props.shouldNavigate && _this.props.router.location !== value) {
        _this.props.router.push((0, _commonUtils.preventLinkScroll)(value));
      }
    }, _this.dropdownIndicator = function (props) {
      return _reactSelect.components.DropdownIndicator && _react2.default.createElement(
        _reactSelect.components.DropdownIndicator,
        props,
        _react2.default.createElement(_CaretIcon2.default, { type: "line", direction: "down" })
      );
    }, _this.option = function (props) {
      var linkProps = {};
      if (_this.props.shouldNavigate) {
        linkProps.to = (0, _commonUtils.preventLinkScroll)(props.value);
      }
      var optionClass = props.isFocused ? 'focused-dropdown-option' : 'not-focused-dropdown-option';
      return _react2.default.createElement(
        _reactRouter.Link,
        (0, _extends3.default)({}, linkProps, { className: 'dropdown-link' }),
        _react2.default.createElement(_reactSelect.components.Option, (0, _extends3.default)({}, props, {
          className: optionClass + ' dropdown-value'
        }))
      );
    }, _this.noOptionsMessage = function () {
      if (_this.props.noOptionsMessage) {
        return _this.props.noOptionsMessage;
      }
      var searchable = _this.props.title.toLowerCase() || 'options';
      return 'No ' + searchable + ' found';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Dropdown, [{
    key: 'render',
    value: function render() {
      var stringify = function stringify(option) {
        return option.label;
      };
      var filterOption = (0, _reactSelect.createFilter)({ stringify: stringify });
      var props = {
        components: {
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          },
          DropdownIndicator: this.dropdownIndicator,
          Option: this.option,
          SingleValue: this.singleValue
        },
        options: this.props.options.map(function (option) {
          return { value: option.href || option.value, label: option.text };
        }),
        menuShouldScrollIntoView: true,
        onChange: this.handleChange,
        isSearchable: !_reactDeviceDetect.isMobile,
        noOptionsMessage: this.noOptionsMessage,
        className: this.props.className + ' dropdown',
        filterOption: filterOption
      };
      props.placeholder = this.props.showSelected ? props.options[0].label : this.props.title;
      return _react2.default.createElement(_reactSelect2.default, props);
    }
  }]);
  return Dropdown;
}(_react.Component), _class2.propTypes = {
  router: _propTypes2.default.object,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    href: _propTypes2.default.string,
    value: _propTypes2.default.string,
    onSelect: _propTypes2.default.func,
    text: _propTypes2.default.string.isRequired
  })).isRequired,
  title: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  shouldNavigate: _propTypes2.default.bool,
  showSelected: _propTypes2.default.bool,
  noOptionsMessage: _propTypes2.default.string
}, _temp2)) || _class;

exports.default = Dropdown;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _GooglePublisherTag = __webpack_require__(71);

var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);

var _features = __webpack_require__(65);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1374);

// Will display GPT on mobile or Standard advert on tablet / desktop
var GptAdvert = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GptAdvert, _Component);

  function GptAdvert(props) {
    (0, _classCallCheck3.default)(this, GptAdvert);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GptAdvert.__proto__ || (0, _getPrototypeOf2.default)(GptAdvert)).call(this, props));

    _this.state = {
      hasOddscheckerIntegration: false
    };
    return _this;
  }

  (0, _createClass3.default)(GptAdvert, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({
        hasOddscheckerIntegration: (0, _features.has)("oddschecker-integration-stage2")
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          ocDetails = _props.ocDetails,
          performDetails = _props.performDetails;


      return _react2.default.createElement(
        'div',
        { className: 'gpt-advert' },
        _react2.default.createElement(_AdvertWrapper2.default, ocDetails),
        _react2.default.createElement(_GooglePublisherTag2.default, performDetails)
      );
    }
  }]);
  return GptAdvert;
}(_react.Component), _class.propTypes = {
  ocDetails: _propTypes2.default.object,
  performDetails: _propTypes2.default.object
}, _temp);
exports.default = GptAdvert;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(11);

var _commonUtils = __webpack_require__(36);

var _routeUtils = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitchBtns = (0, _reactRouter.withRouter)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SwitchBtns, _Component);

  function SwitchBtns(props) {
    var _ref;

    (0, _classCallCheck3.default)(this, SwitchBtns);

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SwitchBtns.__proto__ || (0, _getPrototypeOf2.default)(SwitchBtns)).call.apply(_ref, [this, props].concat(args)));

    _this.state = {
      value: props.value
    };
    return _this;
  }

  (0, _createClass3.default)(SwitchBtns, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.value != this.props.value) {
        this.setState({
          value: newProps.value
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$buttons = _props.buttons,
          buttons = _props$buttons === undefined ? [] : _props$buttons,
          _props$activeOptionCl = _props.activeOptionClassName,
          activeOptionClassName = _props$activeOptionCl === undefined ? "tab-selected" : _props$activeOptionCl,
          _props$className = _props.className,
          className = _props$className === undefined ? "switch-buttons" : _props$className,
          _props$buttonCount = _props.buttonCount,
          buttonCount = _props$buttonCount === undefined ? buttons.length : _props$buttonCount,
          onChange = _props.onChange,
          router = _props.router;
      var controlValue = this.state.value;


      var buttonLink = function buttonLink(button) {
        var href = button.href,
            text = button.text,
            _button$value = button.value,
            value = _button$value === undefined ? href : _button$value,
            onSelect = button.onSelect;


        var props = {};
        var link = void 0;

        if (onChange || onSelect) {
          props.onClick = function (event) {
            var eventData = [event, { href: href, text: text, value: value }];

            if (onChange) {
              onChange.apply(undefined, eventData);
            }

            if (onSelect) {
              onSelect.apply(undefined, eventData);
            }
          };
        }

        if (href) {
          if ((0, _routeUtils.isLinkActive)(router, button)) {
            props.className = activeOptionClassName;
          }

          props.to = (0, _commonUtils.preventLinkScroll)(href);

          link = _react2.default.createElement(
            _reactRouter.Link,
            props,
            text
          );
        } else {
          if (button.value == controlValue) {
            props.className = activeOptionClassName;
          }

          link = _react2.default.createElement(
            'span',
            props,
            text
          );
        }

        return _react2.default.createElement(
          'li',
          { key: value, className: 'button-count-' + buttonCount },
          link
        );
      };

      return _react2.default.createElement(
        'nav',
        { className: className },
        _react2.default.createElement(
          'ul',
          null,
          buttons.map(buttonLink)
        )
      );
    }
  }]);
  return SwitchBtns;
}(_react.Component), _class2.propTypes = {
  buttons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string,
    onSelect: _propTypes2.default.func,

    href: _propTypes2.default.string,
    text: _propTypes2.default.string.isRequired
  })).isRequired,

  value: _propTypes2.default.any,
  onChange: _propTypes2.default.func,

  router: _propTypes2.default.object,
  className: _propTypes2.default.string,
  activeOptionClassName: _propTypes2.default.string,
  buttonCount: _propTypes2.default.string
}, _temp)) || _class;

exports.default = SwitchBtns;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(33)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(56)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(131)('meta');
var isObject = __webpack_require__(26);
var has = __webpack_require__(55);
var setDesc = __webpack_require__(40).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(25)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(77);
var createDesc = __webpack_require__(186);
module.exports = __webpack_require__(88) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(311);
var defined = __webpack_require__(308);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(522);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UAParser = __webpack_require__(6);

var UA = exports.UA = new UAParser();

var browser = exports.browser = UA.getBrowser();
var cpu = exports.cpu = UA.getCPU();
var device = exports.device = UA.getDevice();
var engine = exports.engine = UA.getEngine();
var os = exports.os = UA.getOS();
var ua = exports.ua = UA.getUA();
var setUA = exports.setUA = function setUA(uaStr) {
  return UA.setUA(uaStr);
};

var mockUserAgent = exports.mockUserAgent = function mockUserAgent(userAgent) {
  window.navigator.__defineGetter__("userAgent", function () {
    return userAgent;
  });
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isYandex = exports.isEdge = exports.getUA = exports.engineVersion = exports.engineName = exports.mobileModel = exports.mobileVendor = exports.browserName = exports.browserVersion = exports.fullBrowserVersion = exports.osName = exports.osVersion = exports.isIE = exports.isOpera = exports.isSafari = exports.isFirefox = exports.isChrome = exports.isIOS = exports.isWinPhone = exports.isAndroid = exports.isBrowser = exports.isTablet = exports.isMobileOnly = exports.isMobile = exports.isChromium = exports.isMobileSafari = exports.isWearable = exports.isConsole = exports.isSmartTV = undefined;

var _getUaData = __webpack_require__(0);

var _types = __webpack_require__(2);

var CHROME = _types.BROWSER_TYPES.CHROME,
    CHROMIUM = _types.BROWSER_TYPES.CHROMIUM,
    IE = _types.BROWSER_TYPES.IE,
    INTERNET_EXPLORER = _types.BROWSER_TYPES.INTERNET_EXPLORER,
    OPERA = _types.BROWSER_TYPES.OPERA,
    FIREFOX = _types.BROWSER_TYPES.FIREFOX,
    SAFARI = _types.BROWSER_TYPES.SAFARI,
    MOBILE_SAFARI = _types.BROWSER_TYPES.MOBILE_SAFARI,
    EDGE = _types.BROWSER_TYPES.EDGE,
    YANDEX = _types.BROWSER_TYPES.YANDEX;
var MOBILE = _types.DEVICE_TYPES.MOBILE,
    TABLET = _types.DEVICE_TYPES.TABLET,
    SMART_TV = _types.DEVICE_TYPES.SMART_TV,
    BROWSER = _types.DEVICE_TYPES.BROWSER,
    WEARABLE = _types.DEVICE_TYPES.WEARABLE,
    CONSOLE = _types.DEVICE_TYPES.CONSOLE;
var ANDROID = _types.OS_TYPES.ANDROID,
    WINDOWS_PHONE = _types.OS_TYPES.WINDOWS_PHONE,
    IOS = _types.OS_TYPES.IOS;


var isMobileType = function isMobileType() {
  return _getUaData.device.type === MOBILE;
};
var isTabletType = function isTabletType() {
  return _getUaData.device.type === TABLET;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (_getUaData.device.type) {
    case MOBILE:
    case TABLET:
      return true;
    default:
      return false;
  }
};

var isSmartTVType = function isSmartTVType() {
  return _getUaData.device.type === SMART_TV;
};
var isBrowserType = function isBrowserType() {
  return _getUaData.device.type === BROWSER;
};
var isWearableType = function isWearableType() {
  return _getUaData.device.type === WEARABLE;
};
var isConsoleType = function isConsoleType() {
  return _getUaData.device.type === CONSOLE;
};
var isAndroidType = function isAndroidType() {
  return _getUaData.os.name === ANDROID;
};
var isWinPhoneType = function isWinPhoneType() {
  return _getUaData.os.name === WINDOWS_PHONE;
};
var isIOSType = function isIOSType() {
  return _getUaData.os.name === IOS;
};
var isChromeType = function isChromeType() {
  return _getUaData.browser.name === CHROME;
};
var isFirefoxType = function isFirefoxType() {
  return _getUaData.browser.name === FIREFOX;
};
var isChromiumType = function isChromiumType() {
  return _getUaData.browser.name === CHROMIUM;
};
var isEdgeType = function isEdgeType() {
  return _getUaData.browser.name === EDGE;
};
var isYandexType = function isYandexType() {
  return _getUaData.browser.name === YANDEX;
};
var isSafariType = function isSafariType() {
  return _getUaData.browser.name === SAFARI || _getUaData.browser.name === MOBILE_SAFARI;
};
var isMobileSafariType = function isMobileSafariType() {
  return _getUaData.browser.name === MOBILE_SAFARI;
};
var isOperaType = function isOperaType() {
  return _getUaData.browser.name === OPERA;
};
var isIEType = function isIEType() {
  return _getUaData.browser.name === INTERNET_EXPLORER || _getUaData.browser.name === IE;
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return _getUaData.browser.major;
};
var getBrowserVersion = function getBrowserVersion() {
  return _getUaData.browser.version;
};
var getOsVersion = function getOsVersion() {
  return _getUaData.os.version ? _getUaData.os.version : "none";
};
var getOsName = function getOsName() {
  return _getUaData.os.name ? _getUaData.os.name : "none";
};
var getBrowserName = function getBrowserName() {
  return _getUaData.browser.name;
};
var getMobileVendor = function getMobileVendor() {
  return _getUaData.device.vendor ? _getUaData.device.vendor : "none";
};
var getMobileModel = function getMobileModel() {
  return _getUaData.device.model ? _getUaData.device.model : "none";
};
var getEngineName = function getEngineName() {
  return _getUaData.engine.name;
};
var getEngineVersion = function getEngineVersion() {
  return _getUaData.engine.version;
};
var getUseragent = function getUseragent() {
  return _getUaData.ua;
};

var isSmartTV = exports.isSmartTV = isSmartTVType();
var isConsole = exports.isConsole = isConsoleType();
var isWearable = exports.isWearable = isWearableType();
var isMobileSafari = exports.isMobileSafari = isMobileSafariType();
var isChromium = exports.isChromium = isChromiumType();
var isMobile = exports.isMobile = isMobileAndTabletType();
var isMobileOnly = exports.isMobileOnly = isMobileType();
var isTablet = exports.isTablet = isTabletType();
var isBrowser = exports.isBrowser = isBrowserType();
var isAndroid = exports.isAndroid = isAndroidType();
var isWinPhone = exports.isWinPhone = isWinPhoneType();
var isIOS = exports.isIOS = isIOSType();
var isChrome = exports.isChrome = isChromeType();
var isFirefox = exports.isFirefox = isFirefoxType();
var isSafari = exports.isSafari = isSafariType();
var isOpera = exports.isOpera = isOperaType();
var isIE = exports.isIE = isIEType();
var osVersion = exports.osVersion = getOsVersion();
var osName = exports.osName = getOsName();
var fullBrowserVersion = exports.fullBrowserVersion = getBrowserFullVersion();
var browserVersion = exports.browserVersion = getBrowserVersion();
var browserName = exports.browserName = getBrowserName();
var mobileVendor = exports.mobileVendor = getMobileVendor();
var mobileModel = exports.mobileModel = getMobileModel();
var engineName = exports.engineName = getEngineName();
var engineVersion = exports.engineVersion = getEngineVersion();
var getUA = exports.getUA = getUseragent();
var isEdge = exports.isEdge = isEdgeType();
var isYandex = exports.isYandex = isYandexType();

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wearPayload = exports.consolePayload = exports.stvPayload = exports.mobilePayload = exports.broPayload = exports.getCurrentBrowser = exports.checkType = exports.OS_TYPES = exports.BROWSER_TYPES = exports.DEVICE_TYPES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getUaData = __webpack_require__(0);

var DEVICE_TYPES = exports.DEVICE_TYPES = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  SMART_TV: 'smarttv',
  CONSOLE: 'console',
  WEARABLE: 'wearable',
  BROWSER: undefined
};

var BROWSER_TYPES = exports.BROWSER_TYPES = {
  CHROME: 'Chrome',
  FIREFOX: "Firefox",
  OPERA: "Opera",
  YANDEX: "Yandex",
  SAFARI: "Safari",
  INTERNET_EXPLORER: "Internet Explorer",
  EDGE: "Edge",
  CHROMIUM: "Chromium",
  IE: 'IE',
  MOBILE_SAFARI: "Mobile Safari"
};

var OS_TYPES = exports.OS_TYPES = {
  IOS: 'iOS',
  ANDROID: "Android",
  WINDOWS_PHONE: "Windows Phone"
};

var initialData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

var checkType = exports.checkType = function checkType(type) {
  switch (type) {
    case DEVICE_TYPES.MOBILE:
      return { isMobile: true };
    case DEVICE_TYPES.TABLET:
      return { isTablet: true };
    case DEVICE_TYPES.SMART_TV:
      return { isSmartTV: true };
    case DEVICE_TYPES.CONSOLE:
      return { isConsole: true };
    case DEVICE_TYPES.WEARABLE:
      return { isWearable: true };
    case DEVICE_TYPES.BROWSER:
      return { isBrowser: true };
    default:
      return initialData;
  }
};

var getCurrentBrowser = exports.getCurrentBrowser = function getCurrentBrowser(name) {
  switch (name) {
    case BROWSER_TYPES.CHROME:
    case BROWSER_TYPES.FIREFOX:
    case BROWSER_TYPES.OPERA:
    case BROWSER_TYPES.YANDEX:
    case BROWSER_TYPES.SAFARI:
    case BROWSER_TYPES.IE:
    case BROWSER_TYPES.EDGE:
    case BROWSER_TYPES.CHROMIUM:
      return true;
    default:
      return false;
  }
};

var broPayload = exports.broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: browser.major,
    browserFullVersion: browser.version,
    browserName: browser.name,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var mobilePayload = exports.mobilePayload = function mobilePayload(type, device, os, ua) {
  return _extends({}, type, {
    vendor: device.vendor || "none",
    model: device.model || "none",
    os: os.name || "none",
    osVersion: os.version || "none",
    ua: ua || "none"
  });
};

var stvPayload = exports.stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var consolePayload = exports.consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var wearPayload = exports.wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deviceDetect = undefined;

var _views = __webpack_require__(4);

Object.keys(_views).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _views[key];
    }
  });
});

var _selectors = __webpack_require__(1);

Object.keys(_selectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _selectors[key];
    }
  });
});

var _detect = __webpack_require__(8);

var _detect2 = _interopRequireDefault(_detect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.deviceDetect = _detect2.default;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomView = exports.WearableView = exports.ConsoleView = exports.SmartTVView = exports.MobileOnlyView = exports.WinPhoneView = exports.TabletView = exports.MobileView = exports.IOSView = exports.IEView = exports.BrowserView = exports.AndroidView = undefined;

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _selectors = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AndroidView = exports.AndroidView = function AndroidView(_ref) {
  var renderWithFragment = _ref.renderWithFragment,
      children = _ref.children,
      viewClassName = _ref.viewClassName,
      style = _ref.style;

  return _selectors.isAndroid ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var BrowserView = exports.BrowserView = function BrowserView(_ref2) {
  var renderWithFragment = _ref2.renderWithFragment,
      children = _ref2.children,
      viewClassName = _ref2.viewClassName,
      style = _ref2.style;

  return _selectors.isBrowser ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var IEView = exports.IEView = function IEView(_ref3) {
  var renderWithFragment = _ref3.renderWithFragment,
      children = _ref3.children,
      viewClassName = _ref3.viewClassName,
      style = _ref3.style;

  return _selectors.isIE ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var IOSView = exports.IOSView = function IOSView(_ref4) {
  var renderWithFragment = _ref4.renderWithFragment,
      children = _ref4.children,
      viewClassName = _ref4.viewClassName,
      style = _ref4.style;

  return _selectors.isIOS ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var MobileView = exports.MobileView = function MobileView(_ref5) {
  var renderWithFragment = _ref5.renderWithFragment,
      children = _ref5.children,
      viewClassName = _ref5.viewClassName,
      style = _ref5.style;

  return _selectors.isMobile ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var TabletView = exports.TabletView = function TabletView(_ref6) {
  var renderWithFragment = _ref6.renderWithFragment,
      children = _ref6.children,
      viewClassName = _ref6.viewClassName,
      style = _ref6.style;

  return _selectors.isTablet ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var WinPhoneView = exports.WinPhoneView = function WinPhoneView(_ref7) {
  var renderWithFragment = _ref7.renderWithFragment,
      children = _ref7.children,
      viewClassName = _ref7.viewClassName,
      style = _ref7.style;

  return _selectors.isWinPhone ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var MobileOnlyView = exports.MobileOnlyView = function MobileOnlyView(_ref8) {
  var renderWithFragment = _ref8.renderWithFragment,
      children = _ref8.children,
      viewClassName = _ref8.viewClassName,
      style = _ref8.style;

  return _selectors.isMobileOnly ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var SmartTVView = exports.SmartTVView = function SmartTVView(_ref9) {
  var renderWithFragment = _ref9.renderWithFragment,
      children = _ref9.children,
      viewClassName = _ref9.viewClassName,
      style = _ref9.style;

  return _selectors.isSmartTV ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var ConsoleView = exports.ConsoleView = function ConsoleView(_ref10) {
  var renderWithFragment = _ref10.renderWithFragment,
      children = _ref10.children,
      viewClassName = _ref10.viewClassName,
      style = _ref10.style;

  return _selectors.isConsole ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var WearableView = exports.WearableView = function WearableView(_ref11) {
  var renderWithFragment = _ref11.renderWithFragment,
      children = _ref11.children,
      viewClassName = _ref11.viewClassName,
      style = _ref11.style;

  return _selectors.isWearable ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

var CustomView = exports.CustomView = function CustomView(_ref12) {
  var renderWithFragment = _ref12.renderWithFragment,
      children = _ref12.children,
      viewClassName = _ref12.viewClassName,
      style = _ref12.style,
      condition = _ref12.condition;

  return condition ? renderWithFragment ? _react2.default.createElement(
    _react.Fragment,
    null,
    children
  ) : _react2.default.createElement(
    'div',
    { className: viewClassName, style: style },
    children
  ) : null;
};

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(0);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.18
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 or MIT
 */
(function(window,undefined){"use strict";var LIBVERSION="0.7.18",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var margedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){margedRegexes[i]=extensions[i].concat(regexes[i])}else{margedRegexes[i]=regexes[i]}}return margedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i],[NAME,VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge|edgios|edgea)\/((\d+)?[\w\.]+)/i],[[NAME,"Edge"],VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(qqbrowserlite)\/([\w\.]+)/i],[NAME,VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(BIDUBrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i],[NAME],[/(LBBROWSER)/i],[NAME],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/.+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android\s3\.[\s\w;-]{10}(a\d{3})/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel xl|pixel)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,TABLET]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})\s+build/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9}).+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,/linux;.+(sailfish);/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(7)){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if(typeof $!==UNDEF_TYPE){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 7 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getUaData = __webpack_require__(0);

var _types = __webpack_require__(2);

var create = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var type = create.checkType(_getUaData.device.type);

exports.default = function () {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return create.broPayload(isBrowser, _getUaData.browser, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isSmartTV) {
    return create.stvPayload(isSmartTV, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isConsole) {
    return create.consolePayload(isConsole, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }

  if (isMobile) {
    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
  }

  if (isTablet) {
    return create.mobilePayload(type, _getUaData.device, _getUaData.os, _getUaData.ua);
  }

  if (isWearable) {
    return create.wearPayload(isWearable, _getUaData.engine, _getUaData.os, _getUaData.ua);
  }
};

/***/ })
/******/ ]);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["a"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(98);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(707);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _config$api$media = _config2.default.api.media,
    imagesURL = _config$api$media.imagesURL,
    fallbackSilkPath = _config$api$media.fallbackSilkPath;
var Silk = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Silk, _Component);

  function Silk(props) {
    (0, _classCallCheck3.default)(this, Silk);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Silk.__proto__ || (0, _getPrototypeOf2.default)(Silk)).call(this, props));

    _this.setImageUrl = function (imagePath) {
      return _this.setState({
        imageUrl: imagePath
      });
    };

    _this.getImageElement = function (source) {
      //set fallback image path on error
      var onError = function onError() {
        return _this.setImageUrl(_this.state.fallbackPath);
      };

      return source ? _react2.default.createElement('img', { src: _this.state.imageUrl, onError: onError }) : '';
    };

    var fallbackPath = props.fallbackImagePath ? props.fallbackImagePath : fallbackSilkPath;

    _this.state = {
      fallbackPath: fallbackPath,
      imageUrl: ''
    };
    return _this;
  }

  (0, _createClass3.default)(Silk, [{
    key: 'componentDidMount',
    value: function componentDidMount() {

      var imagePath = this.props.filename ? imagesURL + 'images/silks/' + this.props.filename : this.state.fallbackPath;

      return this.setImageUrl(imagePath);
    }
  }, {
    key: 'render',
    value: function render() {
      __webpack_require__(1384);
      return _react2.default.createElement(
        'div',
        { className: 'silk' },
        this.getImageElement(this.state.imageUrl)
      );
    }
  }]);
  return Silk;
}(_react.Component), _class.propTypes = {
  filename: _propTypes2.default.string,
  fallbackImagePath: _propTypes2.default.string
}, _temp);
exports.default = Silk;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PureBetLink = undefined;

var _assign = __webpack_require__(147);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMetrics = __webpack_require__(69);

var _betlink = __webpack_require__(257);

var _AnalyticsUtils = __webpack_require__(63);

var _features = __webpack_require__(65);

var _reactRedux = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PureBetLink = exports.PureBetLink = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PureBetLink, _Component);

  function PureBetLink(props) {
    (0, _classCallCheck3.default)(this, PureBetLink);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PureBetLink.__proto__ || (0, _getPrototypeOf2.default)(PureBetLink)).call(this, props));

    _this.state = {
      betSlipEnabled: (0, _features.isBetSlipEnabled)(true)
    };
    return _this;
  }

  (0, _createClass3.default)(PureBetLink, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var betSlipEnabled = (0, _features.isBetSlipEnabled)(true);
      if (betSlipEnabled !== this.state.betSlipEnabled) {
        this.setState({
          betSlipEnabled: betSlipEnabled
        });
      }
    }
  }, {
    key: 'addBet',
    value: function addBet() {
      var _props = this.props,
          marketId = _props.marketId,
          eventId = _props.eventId,
          eventName = _props.eventName,
          eventCompetition = _props.eventCompetition,
          dateTime = _props.dateTime,
          fixture = _props.fixture,
          sport = _props.sport,
          betId = _props.betId,
          betName = _props.betName,
          odds = _props.odds,
          isLive = _props.isLive,
          eachWay = _props.eachWay,
          _props$suspended = _props.suspended,
          suspended = _props$suspended === undefined ? false : _props$suspended,
          startingPriceAvailable = _props.startingPriceAvailable;


      this.props.sendToBetslip({
        marketId: marketId,
        eventId: eventId,
        eventName: eventName,
        eventCompetition: eventCompetition,
        dateTime: dateTime,
        fixture: fixture,
        sport: sport,
        betId: betId,
        betName: betName,
        odds: odds,
        isLive: isLive,
        eachWay: eachWay,
        suspended: suspended,
        startingPriceAvailable: startingPriceAvailable
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          marketId = _props2.marketId,
          eventId = _props2.eventId,
          betId = _props2.betId,
          odds = _props2.odds,
          className = _props2.className,
          children = _props2.children,
          _props2$forceLinkOut = _props2.forceLinkOut,
          forceLinkOut = _props2$forceLinkOut === undefined ? false : _props2$forceLinkOut;


      var addBetHandler = function addBetHandler(e) {
        e.preventDefault();

        _this2.addBet();
      };

      var buttonProps = (0, _extends3.default)({
        className: className
      }, (0, _AnalyticsUtils.trackClick)('addToBetSlip', { betlinkId: eventId }));

      if (marketId && eventId && betId && this.state.betSlipEnabled && !forceLinkOut) {
        (0, _assign2.default)(buttonProps, {
          href: "#",
          onClick: addBetHandler
        });
      } else {
        (0, _assign2.default)(buttonProps, {
          href: 'http://m.skybet.com/go/event/' + eventId + '/bet?sels=' + betId + '|' + odds + '&aff=681&dcmp=sl_hr_betlink',
          target: "_blank"
        });
      }

      if (betId) {
        return _react2.default.createElement(
          _reactMetrics.MetricsElement,
          null,
          _react2.default.createElement(
            'a',
            buttonProps,
            children
          )
        );
      } else {
        return _react2.default.createElement(
          'span',
          buttonProps,
          children
        );
      }
    }
  }]);
  return PureBetLink;
}(_react.Component), _class.propTypes = {
  marketId: _propTypes2.default.string,
  eventId: _propTypes2.default.string,
  eventName: _propTypes2.default.string,
  eventCompetition: _propTypes2.default.string,
  dateTime: _propTypes2.default.string,
  fixture: _propTypes2.default.string,
  sport: _propTypes2.default.string,
  betId: _propTypes2.default.string,
  betName: _propTypes2.default.string,
  odds: _propTypes2.default.string,
  isLive: _propTypes2.default.bool,
  eachWay: _propTypes2.default.object,
  suspended: _propTypes2.default.bool,
  startingPriceAvailable: _propTypes2.default.bool,
  forceLinkOut: _propTypes2.default.bool,

  sendToBetslip: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
}, _temp);


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    sendToBetslip: function sendToBetslip(data) {
      dispatch((0, _betlink.addBet)(data));
    }
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(PureBetLink);

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _nextrace = __webpack_require__(427);

var _utils = __webpack_require__(18);

var _compare = __webpack_require__(118);

var _rideFilter = __webpack_require__(171);

var _LocalDateTimeHelper = __webpack_require__(13);

var _CaretLink = __webpack_require__(54);

var _CaretLink2 = _interopRequireDefault(_CaretLink);

var _HorseRacingRideSummaryTable = __webpack_require__(403);

var _HorseRacingRideSummaryTable2 = _interopRequireDefault(_HorseRacingRideSummaryTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingNextRaceOff = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)("HorseRacingNextRaceOff", [{
  dispatch: function dispatch() {
    return (0, _nextrace.loadNextRace)();
  },
  preventResolve: function preventResolve(_ref) {
    var state = _ref.state;
    return (0, _nextrace.isNextRaceLoading)(state);
  },
  refreshInterval: 30000,
  state: function state(_state) {
    return { race: _state.horseRacing.nextrace };
  },
  handleError: true
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingNextRaceOff, _Component);

  function HorseRacingNextRaceOff() {
    (0, _classCallCheck3.default)(this, HorseRacingNextRaceOff);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingNextRaceOff.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingNextRaceOff)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingNextRaceOff, [{
    key: 'generateRacecardLink',
    value: function generateRacecardLink(race) {

      var raceSummary = race.race_summary || {};

      var date = raceSummary.date;
      var courseName = raceSummary.course_name && (0, _utils.slug)(raceSummary.course_name).toLowerCase();
      var raceName = raceSummary.name && (0, _utils.slug)(raceSummary.name).toLowerCase();

      var raceRef = raceSummary.race_summary_reference || {};
      var raceId = raceRef.id;

      if (date == null || courseName == null || raceId == null) {
        return null;
      } else {
        return _react2.default.createElement(
          _reactRouter.Link,
          { className: 'section-button large-primary-blue-button', to: '/racing/racecards/' + date + '/' + courseName + '/racecard/' + raceId + '/' + raceName },
          'Full Racecard'
        );
      }
    }
  }, {
    key: 'render',
    value: function render() {
      __webpack_require__(1393);

      var race = this.props.race.race || {};
      var raceSummary = race.race_summary || {};

      var raceTitleParts = [];

      if (raceSummary.time && raceSummary.date) {
        raceTitleParts.push((0, _LocalDateTimeHelper.localTimeShort)(raceSummary.date + 'T' + raceSummary.time + 'Z'));
      }

      if (raceSummary.course_name) {
        raceTitleParts.push(raceSummary.course_name);
      }

      var raceTitle = raceTitleParts.join(" ");
      var raceSummaryRef = raceSummary.race_summary_reference || {};
      var raceExternalIds = raceSummaryRef.external_reference || [];
      var raceSkyBetIds = raceExternalIds.filter(function (r) {
        return r.ref === 'skybet';
      }).map(function (r) {
        return r.value;
      });
      var raceExternalId = raceSkyBetIds.length > 0 ? raceSkyBetIds[0] : '';
      var rides = race.rides || [];
      var runners = (0, _rideFilter.filterRidesByStatus)(rides, "RUNNER").sort(_compare.sortByOdds);

      var runnersToDisplay = runners;
      if (this.props.displayAll !== true) {
        runnersToDisplay = runners.slice(0, race.number_of_placed_rides);
      }

      var titleClass = "section-title";
      if (this.props.plainTitle === true) {
        titleClass = titleClass + ' ' + titleClass + '-plain';
      } else {
        titleClass = titleClass + ' ' + titleClass + '-full';
      }

      var errorPixelSrc = '/1x1.gif?type=next-race-off&id=0&cb=' + Date.now();

      return _react2.default.createElement(
        'div',
        { className: 'sport-section next-race-off', id: 'next-race-off' },
        _react2.default.createElement(
          'h3',
          { className: titleClass },
          'Next Race Off'
        ),
        raceTitle ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'section-subtitle' },
            raceTitle
          ),
          _react2.default.createElement(_HorseRacingRideSummaryTable2.default, { runners: runnersToDisplay, raceExternalId: raceExternalId, raceSummary: race.race_summary, eachWay: race.each_way,
            suspended: race.market_suspended, fixture: race.fixture })
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'next-race-off-error' },
            'Unable to display the next race off.'
          ),
          _react2.default.createElement('img', { src: errorPixelSrc, width: '1', height: '1' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'action-links' },
          this.generateRacecardLink(race),
          _react2.default.createElement(
            _reactRouter.Link,
            { className: 'section-button large-primary-button', to: '/racing/racecards' },
            'All Racecards'
          )
        )
      );
    }
  }]);
  return HorseRacingNextRaceOff;
}(_react.Component), _class2.propTypes = {
  plainTitle: _propTypes2.default.bool,
  race: _propTypes2.default.shape({
    race: _propTypes2.default.object
  }).isRequired,
  displayAll: _propTypes2.default.bool,
  dispatch: _propTypes2.default.func.isRequired
}, _temp)) || _class);
exports.default = HorseRacingNextRaceOff;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _morenews = __webpack_require__(79);

var _media = __webpack_require__(78);

var _TipsSection = __webpack_require__(362);

var _TipsSection2 = _interopRequireDefault(_TipsSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TIPS_PATH = '/racing/tips-centre';

var RacingTips = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)("RacingTips", [{
  dispatch: function dispatch() {
    return (0, _morenews.load)(TIPS_PATH, 3);
  },
  state: _morenews.connectMoreNews,
  then: function then(_ref) {
    var dispatch = _ref.dispatch,
        state = _ref.state,
        articles = _ref.result.articles;
    return (0, _media.loadMediaForArticles)(state, dispatch, articles);
  }
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(RacingTips, _Component);

  function RacingTips() {
    (0, _classCallCheck3.default)(this, RacingTips);
    return (0, _possibleConstructorReturn3.default)(this, (RacingTips.__proto__ || (0, _getPrototypeOf2.default)(RacingTips)).apply(this, arguments));
  }

  (0, _createClass3.default)(RacingTips, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$news = _props.news;
      _props$news = _props$news === undefined ? {} : _props$news;
      var _props$news$TIPS_PATH = _props$news[TIPS_PATH];
      _props$news$TIPS_PATH = _props$news$TIPS_PATH === undefined ? {} : _props$news$TIPS_PATH;
      var _props$news$TIPS_PATH2 = _props$news$TIPS_PATH.articles,
          tipsItems = _props$news$TIPS_PATH2 === undefined ? [] : _props$news$TIPS_PATH2,
          plainTitle = _props.plainTitle;


      var componentData = {
        plainTitle: plainTitle,
        sectionLabel: "Racing",
        sectionLink: "/racing",
        additionalTipsLinks: [{ text: "All Racing Tips", href: "/racing/tips-centre" }],
        tipsItems: tipsItems.slice(0, 3)
      };

      return _react2.default.createElement(_TipsSection2.default, componentData);
    }
  }]);
  return RacingTips;
}(_react.Component), _class2.propTypes = {
  plainTitle: _propTypes2.default.bool,
  news: _propTypes2.default.object
}, _temp)) || _class);
exports.default = RacingTips;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _map = __webpack_require__(181);

var _map2 = _interopRequireDefault(_map);

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

exports.filterMatchesByState = filterMatchesByState;
exports.mapMatchesToDates = mapMatchesToDates;
exports.mapMatchesToCompetitions = mapMatchesToCompetitions;
exports.mapMatchesToCompetitionRounds = mapMatchesToCompetitionRounds;
exports.getMonths = getMonths;
exports.getCompetitionsNavList = getCompetitionsNavList;
exports.getTeamsNavList = getTeamsNavList;

var _momentTimezone = __webpack_require__(241);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _compare = __webpack_require__(118);

var _utils = __webpack_require__(18);

var _consts = __webpack_require__(62);

var _LocalDateTimeHelper = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var KNOWN_STATES = {
  all: function all(state) {
    return _consts.MATCH_STATE_ALL.includes(state);
  },
  upNext: function upNext(state) {
    return _consts.MATCH_STATE_UPNEXT.includes(state);
  },
  ongoing: function ongoing(state) {
    return _consts.MATCH_STATE_LIVE.includes(state);
  },
  finished: function finished(state) {
    return _consts.MATCH_STATE_FINISHED.includes(state);
  }
};

function filterMatchesByState() {
  var matches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var filter = arguments[1];

  return matches.filter(function (match) {
    return KNOWN_STATES[filter] && KNOWN_STATES[filter](match.state);
  });
}

function mapMatchesToDates() {
  var matches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var fixturesResults = arguments[1];

  var dates = {};

  matches.map(function (match) {
    var _ref = match || {},
        match_reference = _ref.match_reference,
        match_date = _ref.match_date,
        _ref$match_betting_ma = _ref.match_betting_market,
        match_betting_market = _ref$match_betting_ma === undefined ? {} : _ref$match_betting_ma,
        state = _ref.state,
        _ref$match_type = _ref.match_type,
        match_type = _ref$match_type === undefined ? _consts.MATCH_TYPE_REGULAR : _ref$match_type,
        _ref$round = _ref.round,
        round = _ref$round === undefined ? {} : _ref$round,
        clock = _ref.clock,
        _ref$team_score_a = _ref.team_score_a,
        team_score_a = _ref$team_score_a === undefined ? {} : _ref$team_score_a,
        _ref$team_score_b = _ref.team_score_b,
        team_score_b = _ref$team_score_b === undefined ? {} : _ref$team_score_b,
        _ref$penalty_shootout = _ref.penalty_shootout_score,
        penalty_shootout_score = _ref$penalty_shootout === undefined ? {} : _ref$penalty_shootout,
        _ref$competition = _ref.competition,
        competition = _ref$competition === undefined ? {} : _ref$competition,
        _ref$match_outcome = _ref.match_outcome,
        match_outcome = _ref$match_outcome === undefined ? {} : _ref$match_outcome;

    var day = (0, _momentTimezone2.default)(match_date).startOf('day').format('YYYYMMDD');

    if (!dates[day]) {
      dates[day] = {
        name: (0, _LocalDateTimeHelper.localLongDate)(match_date),
        id: match_date,
        day: day,
        matchList: []
      };
    }

    dates[day].matchList.push({
      match_reference: match_reference,
      match_date: match_date,
      match_betting_market: match_betting_market,
      state: state,
      clock: clock,
      match_type: match_type,
      round: round,
      team_score_a: team_score_a,
      team_score_b: team_score_b,
      penalty_shootout_score: penalty_shootout_score,
      competition: competition,
      match_outcome: match_outcome
    });
  });

  var sortedDates = (0, _keys2.default)(dates).sort().map(function (day) {
    return dates[day];
  });

  sortedDates.forEach(function (date) {
    return date.matchList.sort(function (a, b) {
      return sortWithinGrouping(a, b);
    });
  });

  if (fixturesResults == "results") {
    return sortedDates.reverse();
  } else {
    return sortedDates.filter(function (date) {
      return date.day >= (0, _momentTimezone2.default)().format('YYYYMMDD');
    });
  }
}

function mapMatchesToCompetitions() {
  var matches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var competitions = {};

  matches.map(function (match) {
    var _ref2 = match || {},
        match_reference = _ref2.match_reference,
        match_date = _ref2.match_date,
        _ref2$match_betting_m = _ref2.match_betting_market,
        match_betting_market = _ref2$match_betting_m === undefined ? {} : _ref2$match_betting_m,
        state = _ref2.state,
        clock = _ref2.clock,
        _ref2$match_type = _ref2.match_type,
        match_type = _ref2$match_type === undefined ? _consts.MATCH_TYPE_REGULAR : _ref2$match_type,
        _ref2$round = _ref2.round,
        round = _ref2$round === undefined ? {} : _ref2$round,
        _ref2$match_outcome = _ref2.match_outcome,
        match_outcome = _ref2$match_outcome === undefined ? {} : _ref2$match_outcome,
        _ref2$team_score_a = _ref2.team_score_a,
        team_score_a = _ref2$team_score_a === undefined ? {} : _ref2$team_score_a,
        _ref2$team_score_b = _ref2.team_score_b,
        team_score_b = _ref2$team_score_b === undefined ? {} : _ref2$team_score_b,
        _ref2$penalty_shootou = _ref2.penalty_shootout_score,
        penalty_shootout_score = _ref2$penalty_shootou === undefined ? {} : _ref2$penalty_shootou,
        _ref2$competition = _ref2.competition;

    _ref2$competition = _ref2$competition === undefined ? {} : _ref2$competition;
    var _ref2$competition$com = _ref2$competition.competition_reference;
    _ref2$competition$com = _ref2$competition$com === undefined ? {} : _ref2$competition$com;
    var competitionId = _ref2$competition$com.id,
        competitionName = _ref2$competition.name,
        _ref2$competition$sor = _ref2$competition.sort_order,
        competitionSortOrder = _ref2$competition$sor === undefined ? -1 : _ref2$competition$sor;


    if (!competitions[competitionId]) {
      competitions[competitionId] = {
        name: competitionName,
        id: competitionId,
        sortOrder: competitionSortOrder,
        matchList: []
      };
    }

    competitions[competitionId].matchList.push({
      match_reference: match_reference,
      match_date: match_date,
      match_betting_market: match_betting_market,
      state: state,
      match_type: match_type,
      round: round,
      clock: clock,
      match_outcome: match_outcome,
      team_score_a: team_score_a,
      team_score_b: team_score_b,
      penalty_shootout_score: penalty_shootout_score
    });
  });

  var sortedCompetitions = (0, _keys2.default)(competitions).map(function (id) {
    return competitions[id];
  }).sort(function (a, b) {
    if (a.sortOrder === b.sortOrder) {
      return (0, _compare.compareStrings)(a.name, b.name);
    } else if (a.sortOrder === -1) {
      return 1;
    } else if (b.sortOrder === -1) {
      return -1;
    } else {
      return a.sortOrder - b.sortOrder;
    }
  });

  sortedCompetitions.forEach(function (competition) {
    return competition.matchList.sort(function (a, b) {
      return sortWithinGrouping(a, b);
    });
  });

  return sortedCompetitions;
}

function mapMatchesToCompetitionRounds() {
  var matches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  function assignToRound(rounds, match) {
    var round = match.round,
        match_type = match.match_type;


    var roundKey = getRoundKey(match_type, round);

    if (!rounds.has(roundKey)) {
      rounds.set(roundKey, { matchList: [] });
    }

    rounds.get(roundKey).matchList.push(match);
    rounds.get(roundKey).round = round;
    return rounds;
  }

  var rounds = matches.reduce(assignToRound, new _map2.default());
  //rounds.entries().forEach(round => round.matchList.sort((a,b) => sortWithinGrouping(a,b)));

  return rounds;
}

function getRoundKey(matchType, round) {
  var defaultKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _consts.MATCH_TYPE_REGULAR;

  if (matchType != _consts.MATCH_TYPE_REGULAR && round && round.round_type) {
    return round.round_type + '-' + (round.round_number || "0");
  }

  return defaultKey;
}

function sortWithinGrouping(a, b) {
  var dateDiff = new Date(a.match_date) - new Date(b.match_date);

  if (dateDiff === 0) {
    var _a$team_score_a = a.team_score_a;
    _a$team_score_a = _a$team_score_a === undefined ? {} : _a$team_score_a;
    var _a$team_score_a$team = _a$team_score_a.team;
    _a$team_score_a$team = _a$team_score_a$team === undefined ? {} : _a$team_score_a$team;
    var teamNameA = _a$team_score_a$team.name;
    var _b$team_score_a = b.team_score_a;
    _b$team_score_a = _b$team_score_a === undefined ? {} : _b$team_score_a;
    var _b$team_score_a$team = _b$team_score_a.team;
    _b$team_score_a$team = _b$team_score_a$team === undefined ? {} : _b$team_score_a$team;
    var teamNameB = _b$team_score_a$team.name;

    return (0, _compare.compareStrings)(teamNameA, teamNameB);
  }

  return dateDiff;
}

function getMonths(competitionStart, competitionEnd, fixturesResults) {

  if (competitionStart && competitionEnd) {
    var date = void 0,
        end = void 0,
        months = [],
        now = (0, _momentTimezone2.default)();

    if (fixturesResults == "results") {
      date = (0, _momentTimezone2.default)(competitionStart).startOf('month');
      end = (0, _momentTimezone2.default)(competitionEnd).isBefore(now) ? (0, _momentTimezone2.default)(competitionEnd) : now;
    } else {
      date = (0, _momentTimezone2.default)(competitionStart).isAfter(now) ? (0, _momentTimezone2.default)(competitionStart) : now;
      end = (0, _momentTimezone2.default)(competitionEnd);
    }

    while (!date.isAfter(end)) {
      months.push((0, _LocalDateTimeHelper.localYearMonth)(date));
      date = date.add(1, 'month').startOf('month');
    }

    return months;
  } else {
    return [];
  }
}

function getCompetitionsNavList(competitions, fixturesResults) {
  return competitions.map(function (_ref3) {
    var name = _ref3.name,
        competition_id = _ref3.competition_reference.id;
    return {
      text: name,
      href: '/football/' + fixturesResults + '/competitions/' + (0, _utils.toSlug)(name) + '/' + competition_id
    };
  });
}

function getTeamsNavList(teams, fixturesResults, competitionName, competitionId) {
  var teamsList = teams.map(function (_ref4) {
    var name = _ref4.name,
        team_id = _ref4.team_reference.id;
    return {
      text: name,
      href: '/football/' + fixturesResults + '/teams/' + (0, _utils.toSlug)(name) + '/' + team_id + '/' + (0, _utils.toSlug)(competitionName) + '/' + competitionId
    };
  });

  return teamsList.sort(function (a, b) {
    return (0, _compare.compareStrings)(a.text, b.text);
  });
}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.compareStrings = compareStrings;
exports.sortByOdds = sortByOdds;
exports.sortByHorseName = sortByHorseName;
exports.sortByClothNumber = sortByClothNumber;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function compareStrings(a, b) {
  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}

// items should be {betting: {current_odds}}
function sortByOdds() {
  for (var _len = arguments.length, items = Array(_len), _key = 0; _key < _len; _key++) {
    items[_key] = arguments[_key];
  }

  var _items$map = items.map(function (_ref) {
    var _ref$betting = _ref.betting;
    _ref$betting = _ref$betting === undefined ? {} : _ref$betting;
    var current_odds = _ref$betting.current_odds;

    if (!current_odds) {
      return Number.MAX_VALUE;
    }

    var _current_odds$split$m = current_odds.split('/').map(function (o) {
      return parseInt(o, 10);
    }),
        _current_odds$split$m2 = (0, _slicedToArray3.default)(_current_odds$split$m, 2),
        numerator = _current_odds$split$m2[0],
        denominator = _current_odds$split$m2[1];

    if (numerator && denominator) {
      return numerator / denominator;
    } else {
      return Number.MAX_VALUE;
    }
  }),
      _items$map2 = (0, _slicedToArray3.default)(_items$map, 2),
      a = _items$map2[0],
      b = _items$map2[1];

  return a - b;
}

// items should be {horse: {name}}
function sortByHorseName() {
  for (var _len2 = arguments.length, items = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    items[_key2] = arguments[_key2];
  }

  return compareStrings.apply(undefined, (0, _toConsumableArray3.default)(items.map(function (_ref2) {
    var _ref2$horse = _ref2.horse;
    _ref2$horse = _ref2$horse === undefined ? {} : _ref2$horse;
    var name = _ref2$horse.name;
    return name;
  })));
}

// items should be {cloth_number}
function sortByClothNumber() {
  for (var _len3 = arguments.length, items = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    items[_key3] = arguments[_key3];
  }

  var _items$ = items[0];
  _items$ = _items$ === undefined ? {} : _items$;
  var _items$$cloth_number = _items$.cloth_number,
      a = _items$$cloth_number === undefined ? Number.MAX_VALUE : _items$$cloth_number,
      _items$2 = items[1];
  _items$2 = _items$2 === undefined ? {} : _items$2;
  var _items$2$cloth_number = _items$2.cloth_number,
      b = _items$2$cloth_number === undefined ? Number.MAX_VALUE : _items$2$cloth_number;


  return a - b;
}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var middlewareWrapper = exports.middlewareWrapper = function middlewareWrapper(func) {
  return function (store) {
    return function (next) {
      return function (action) {
        func(store, next, action);
      };
    };
  };
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends5 = __webpack_require__(7);

var _extends6 = _interopRequireDefault(_extends5);

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

exports.matchUrlForRedirect = matchUrlForRedirect;
exports.titleToId = titleToId;

var _LocalDateTimeHelper = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Check the incoming URL against each rule, until a pattern is matched, then run that rule's function to get the destination
function matchUrlForRedirect(originalUrl) {
  rulesList = rulesList || parsedRules(); // only call it once

  var found = false;
  rulesList.forEach(function (rule) {
    if (!found) {
      var match = originalUrl.match(rule.pattern);

      if (match) {
        found = rule.redirect(match); // quick break
      }
    }
  });
  return found;
}

// Rules are specified as an object, so keep the list simple. This function "compiles" that into an array of Regexes and associated functions
function parsedRules() {
  return (0, _keys2.default)(urlRewriteRules).map(function (o) {
    var rule = {
      pattern: new RegExp("^" + o),
      redirect: urlRewriteRules[o]
    };

    if (typeof urlRewriteRules[o] == "string") {
      // allow specifying a string for the simple cases (most of them are simple)
      rule.redirect = function () {
        return urlRewriteRules[o];
      };
    }

    return rule;
  });
}

///////////////////////////////////////////
// Some helpers for common rule patterns
// Particularly useful for non-trivial rules

function dateExtracter(prefix) {
  var splitStart = prefix.length + 1;

  return function (input) {
    var _input$substring$spli = input.substring(splitStart).split("/"),
        _input$substring$spli2 = (0, _slicedToArray3.default)(_input$substring$spli, 1),
        dateText = _input$substring$spli2[0];

    return Date.parse(dateText);
  };
}

function titleToId(title) {
  return title.replace(/\s+/g, '-').toLowerCase();
}

function tooLittlePath(prefix) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$preserveDate = _ref.preserveDate,
      preserveDate = _ref$preserveDate === undefined ? false : _ref$preserveDate;

  var tooLittlePathRegex = prefix + "/[0-9-]+/[^/]+$";
  var extractDate = dateExtracter(prefix);

  return (0, _defineProperty3.default)({}, tooLittlePathRegex, function (_ref2) {
    var input = _ref2.input;

    var redirect = prefix;

    if (preserveDate) {
      var dateNumber = extractDate(input);

      if (dateNumber) {
        redirect = redirect + "/" + (0, _LocalDateTimeHelper.isoDate)(dateNumber);
      }
    }

    return redirect;
  });
}

// Catch incorrect date formats and attempt to correct them
function badDateFormat(prefix) {
  var _ref7;

  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref4$allowTomorrow = _ref4.allowTomorrow,
      allowTomorrow = _ref4$allowTomorrow === undefined ? false : _ref4$allowTomorrow,
      _ref4$allowYesterday = _ref4.allowYesterday,
      allowYesterday = _ref4$allowYesterday === undefined ? false : _ref4$allowYesterday,
      _ref4$allowCompetitio = _ref4.allowCompetitionTeams,
      allowCompetitionTeams = _ref4$allowCompetitio === undefined ? false : _ref4$allowCompetitio;

  var badDateRegex = prefix + "/[0-9](?!([0-9]{3}-[0-9]{2}-[0-9]{2}))";
  var extractDate = dateExtracter(prefix);

  var allowText = "";

  if (allowTomorrow || allowYesterday || allowCompetitionTeams) {
    var allowed = [];

    if (allowTomorrow) {
      allowed.push("tomorrow");
    }

    if (allowYesterday) {
      allowed.push("yesterday");
    }

    if (allowCompetitionTeams) {
      allowed.push("competitions");
      allowed.push("teams");
    }

    allowText = "(?!" + allowed.join("|") + ")";
  }

  var badTextRegex = prefix + "/" + allowText + "[^0-9]+";

  return _ref7 = {}, (0, _defineProperty3.default)(_ref7, badDateRegex, function (_ref5) {
    var input = _ref5.input;

    var redirect = prefix;
    var dateNumber = extractDate(input);

    if (dateNumber) {
      redirect = redirect + "/" + (0, _LocalDateTimeHelper.isoDate)(dateNumber);
    }

    return redirect;
  }), (0, _defineProperty3.default)(_ref7, prefix + "/Today", prefix), (0, _defineProperty3.default)(_ref7, badTextRegex, function (_ref6) {
    var input = _ref6.input;
    return "/error/404" + input;
  }), _ref7;
}

// Catch old format news articles, without breaking new ones
function legacyNews(section) {
  return (0, _extends6.default)((0, _defineProperty3.default)({}, section + "(?!/news)/(.*)", section), newsIndex(section));
}

function newsIndex(section) {
  return (0, _extends6.default)((0, _defineProperty3.default)({}, section + "/news/article/[0-9]+/[0-9]+/.*", section), exact(section + "/news", section));
}

function prefixed(path, redirect) {
  return (0, _extends6.default)((0, _defineProperty3.default)({}, path + "/(.*)", redirect), exact(path, redirect));
}

function exact(path, redirect) {
  return (0, _defineProperty3.default)({}, path + "$", redirect);
}

var rulesList = void 0; // ready to cache the "compiled" rule list

// and finally, the rules
var urlRewriteRules = (0, _extends6.default)({}, prefixed('/bettingzone/cricket', '/cricket'), exact('/about-us', '/'), exact('/ascot', '/racing'), exact('/betting-blog', '/'), exact('/bettingzone', '/'), prefixed('/bettingzone/67', '/'), prefixed('/bettingzone/american-football', '/nfl'), exact('/bettingzone/calculator', '/'), exact('/bettingzone/cheeky-punt', '/'), exact('/bettingzone/converter', '/'), prefixed('/bettingzone/football', '/football'), prefixed('/bettingzone/golf', '/golf'), exact('/bettingzone/market_moves', '/'), exact('/bettingzone/market-movers', '/'), exact('/bettingzone/market-moves', '/'), exact('/bettingzone/news', '/'), prefixed('/bettingzone/news/racing', '/racing'), prefixed('/bettingzone/other-sports', '/'), exact('/bettingzone/our-best-bets', '/'), prefixed('/bettingzone/previews', '/'), prefixed('/bettingzone/racing', '/racing'), exact('/bettingzone/record', '/'), prefixed('/bettingzone/rugby-league', '/rugby-league'), prefixed('/bettingzone/tennis', '/tennis'), prefixed('/bettingzone/tipsters', '/columnists'), prefixed('/bettingzone', '/'), legacyNews('/boxing'), exact('/calendar', '/'), exact('/calendar/sportsday.html', '/'), prefixed('/clients/ft/racing/news', '/racing'), prefixed('/clients/planetf1', '/formula1'), prefixed('/clients/stanjames/football', '/football'), prefixed('/clients/tiscali/football/transfer_centre', '/football'), exact('/columns/quiz', '/'), exact('/columns/tv', '/'), prefixed('/commonwealth2006', '/'), prefixed('/comp', '/'), exact('/competitions', '/'), exact('/contact-us', '/'), exact('/other-sports/news/article/678/10108332/key-sports-dates-for-2016-sporting-events-calendar', '/'), legacyNews('/cricket'), exact('/darts/news/article/10310/10541021/premier-league-darts-2017-fixtures-results-table-dates-venues-tv-schedule-odds', '/football/results/competitions/english-premier-league/1'), legacyNews('/darts'), exact('/football/champions-league/table', '/football/results/competitions/champions-league/63'), exact('/football/news/article/226/10693286/details-of-the-champions-league-last-16-draw-arsenal-leicester-manchester-city', '/football/fixtures/competitions/champions-league/63'), exact('/football/news/article/165/10775746/tuesday-champions-league-betting-preview-and-tips', '/football/results/competitions/champions-league/63'), exact('/football/news/article/165/10551310/champions-league-draw-live', '/football/fixtures/competitions/champions-league/63'), exact('/football/news/article/165/10723563/fa-cup-fourth-round-draw', '/football/fixtures/competitions/english-fa-cup/76'), exact('/football/news/article/165/10684753/fa-cup-3rd-round-draw-holders-man-utd-to-host-reading-west-ham-v-man-city', '/football/fixtures/competitions/english-fa-cup/76'), exact('/football/news/article/165/10770833/fa-cup-team-statistics-betting-tips-predictions-and-kick-off-times', '/football/fixtures/competitions/english-fa-cup/76'), exact('/football/news/article/165/10738026/scottish-cup-fourth-round-review-and-results-saturday-january-21', '/football/results/competitions/scottish-fa-cup/71'), exact('/football/news/article/165/10724477/manchester-united-v-liverpool-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'), exact('/football/news/article/165/10697280/everton-v-liverpool-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'), exact('/football/news/article/165/10316446/scottish-premiership-fixtures-announced-rangers-to-visit-celtic-on-september-10', '/football/fixtures/competitions/scottish-premiership/62'), exact('/football/news/article/165/10741597/chelsea-v-arsenal-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'), exact('/football/news/article/165/9924995/world-cup-2018-qualifying-draw-groups-fixtures-schedule', '/football/fixtures/competitions/world-cup/18'), exact('/football/news/article/165/10727546/africa-cup-of-nations-2017-fixtures-schedule-groups-results-odds-tv-guide', '/football/fixtures/competitions/african-world-cup-qualifiers/22'), exact('/football/news/article/165/10614599/africa-cup-of-nations-2017-which-premier-league-players-are-off-to-gabon', '/football/fixtures/competitions/african-world-cup-qualifiers/22'), exact('/football/news/article/165/10704629/manchester-united-v-sunderland-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures'), exact('/football/news/article/165/10667289/liverpool-v-sunderland-team-news-statistics-predictions-odds-kick-off-time', '/football/fixtures'), exact('/football/news/article/165/10759538/arsenal-v-hull-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures'), exact('/football/news/article/165/9946849/premier-league-betting-tips-preview-of-aston-villa-v-man-utd', '/football/fixtures'), exact('/football/news/article/678/10735798/live-football-on-tv-today-plus-horse-racing-tennis-cricket-darts-golf', '/football/fixtures'), exact('/football/news/article/165/10685681/manchester-united-v-tottenham-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'), exact('/football/news/article/165/10678208/manchester-city-v-chelsea-team-news-statistics-predictions-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'), exact('/football/news/article/165/10770858/newcastle-united-v-aston-villa-football-betting-tips-team-news-manager-quotes-kick-off-time', '/football/results/competitions/sky-bet-championship/10'), exact('/football/news/article/165/10658399/tottenham-hotspur-v-west-ham-united-team-news-statistics-predictions-odds-kick-off-time-tv-channel', '/football/fixtures/competitions/english-premier-league/1'), exact('/football/news/article/165/10690767/everton-v-arsenal-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'), exact('/football/news/article/165/9913283/sky-sports-fantasy-football-is-back-for-the-new-barclays-premier-league-season', '/football/tips-centre'), exact('/football/news/article/3538/10630948/philippe-coutinho-eden-hazard-sadio-mane-in-sky-sports-fantasy-football-team-of-the-week', '/football/tips-centre'), exact('/football/news/article/165/10523475/efl-football-betting-tips-for-championship-league-one-and-league-two', '/football/tips-centre'), exact('/football/news/article/165/10188718/soccer-saturday-super-6-matches-on-saturday', '/football/tips-centre'), exact('/football/news/article/165/10588593/super-6-predictions-for-the-soccer-saturday-super-6-game', '/football/tips-centre'), exact('/football/video/24811/10626357/mersons-super-six-predictions', '/football/tips-centre'), exact('/football/news/article/165/10692375/premier-league-football-results-and-review-for-sunday-december-11', '/football/results/competitions/english-premier-league/1'), exact('/football/news/article/165/10704880/tottenham-v-chelsea-team-news-predictions-statistics-odds-kick-off-time', '/football/fixtures/competitions/english-premier-league/1'), exact('/football/europa-league/table', '/football/fixtures/competitions/uefa-europa-league/70'), exact('/football/fa-cup/results', '/football/results/competitions/english-fa-cup/76'), exact('/football/fa-cup', '/football/fixtures/competitions/english-fa-cup/76'), exact('/football/fa-cup/draw', '/football/fixtures/competitions/english-fa-cup/76'), exact('/snooker/news/article/663/10241983/world-championship-snooker-2016-draw-schedule-results', '/snooker/news/world-championship-snooker-draw/146449'), exact('/football/scottish-league-cup/draw', '/football/fixtures/competitions/english-league-cup/50'), exact('/football/efl-cup/draw', '/football/fixtures/competitions/english-league-cup/50'), exact('/football/video/24811/10740437/rodgers-enjoyable-scottish-cup-draw', '/football/fixtures/competitions/scottish-fa-cup/71'), exact('/football/scottish-league-cup/results', '/football/results/competitions/scottish-fa-cup/71'), exact('/football/live/match-preview/357153/celtic-v-aberdeen', '/football/results/competitions/scottish-premiership/62'), exact('/football/scottish-football', '/football/league-tables/scottish-premiership/62'), {
  '/football/scottish-football/(.*)': '/football'
}, exact('/football/scottish-premier/table', '/football/league-tables/scottish-premiership/62'), exact('/football/scottish-premier/fixtures', '/football/results/competitions/scottish-premiership/62'), exact('/football/premier-league/top-scorers', '/football/league-tables/english-premier-league/1'), exact('/football/premier-league/swansea-city/fixtures', '/football/fixtures/teams/swansea-city/2/english-premier-league/1'), exact('/football/premier-league/results', '/football/results/competitions/english-premier-league/1'), exact('/football/premier-league', '/football/league-tables/english-premier-league/1'), exact('/football/premier-league/hull-city/fixtures', '/football/fixtures/competitions/sky-bet-championship/10'), exact('/football/premier-league/teams', '/football'), {
  '/football/premier-league/(.*)': '/football'
}, exact('/football/teams/leicester-city/fixtures', '/football/fixtures/teams/leicester-city/8/english-premier-league/1'), exact('/football/teams/tottenham-hotspur', '/football/results/competitions/english-premier-league/1'), exact('/football/teams/manchester-city', '/football/results/competitions/english-premier-league/1'), exact('/football/teams/tottenham-hotspur', '/football/results/competitions/english-premier-league/1'), exact('/football/europa-league/fixtures', '/football/fixtures/competitions/uefa-europa-league/70'), exact('/football/europa-league/results', '/football/results/competitions/uefa-europa-league/70'), exact('/football/live/match-commentary/362915/malaga-v-las-palmas', '/football/fixtures/teams/las-palmas/1082/spanish-la-liga/74'), exact('/football/la-liga/results', '/football/results/competitions/spanish-la-liga/74'), exact('/football/la-liga(.*)', '/football/league-tables/spanish-la-liga/74'), exact('/football/la-liga', '/football/league-tables/spanish-la-liga/74'), exact('/football/teams/cardiff-city/fixtures', '/football/fixtures/competitions/sky-bet-championship/10'), exact('/football/live/latest-scores', '/football/results/competitions/sky-bet-championship/10'), exact('/football/live/league-tables/league-two', '/football/league-tables/sky-bet-league-two/83'), exact('/football/league-two', '/football/league-tables/sky-bet-league-two/83'), exact('/football/league-two/results', '/football/results/competitions/sky-bet-league-two/83'), {
  '/football/league-two/(.*)': '/football'
}, exact('/football/league-one/results', '/football/results/competitions/sky-bet-league-one/16'), exact('/football/league-one', '/football/fixtures/competitions/sky-bet-league-one/16'), exact('/football/league-one/(.*)', '/football/results/competitions/sky-bet-league-one/16'), exact('/football/teams/wigan-athletic/fixtures', '/football/fixtures/teams/wigan-athletic/38/sky-bet-league-one/16'), exact('/football/bundesliga', '/football/league-tables/german-bundesliga/11'), exact('/football/bundesliga/results', '/football/results/competitions/german-bundesliga/11'), exact('/football/bundesliga/fixtures', '/football/fixtures/competitions/german-bundesliga/11'), {
  '/football/bundesliga/(.*)': '/football'
}, exact('/football/teams/sunderland', '/football/results'), exact('/football/news/article/26854/10320946/football-fixture-list-for-premi_1', '/football/fixtures'), exact('/football/live/team-lineups', '/football/fixtures'), newsIndex('/football'), prefixed('/football/cc_championship', '/football'), prefixed('/football/cc_league1', '/football'), prefixed('/football/cc_league2', '/football'), prefixed('/football/champ_draw', '/football'), exact('/football/championship/sheffield-wednesday/fixtures', '/football/fixtures/teams/sheffield-wednesday/221/sky-bet-championship/10'), exact('/football/championship/top-scorers', '/football/league-tables/sky-bet-championship/10'), exact('/football/championship(.*)', '/football/fixtures/competitions/sky-bet-championship/10'), prefixed('/football/champions-league', '/football'), prefixed('/football/cups', '/football'), prefixed('/football/efl-cup', '/football'), prefixed('/football/eredivisie', '/football'), prefixed('/football/euro2004', '/football'), prefixed('/football/euro2012', '/football'), prefixed('/football/euro-2016', '/football/results/competitions/european-world-cup-qualifiers/9'), prefixed('/football/europa-league', '/football'), prefixed('/football/europa-league-qualifying', '/football'), prefixed('/video/23481/10755550/chelsea-v-arsenal-volley-challenge', '/football'), exact('/snooker/news/article/663/10638569/mark-selby-thrashes-ding-junhui-to-win-international-championship', '/snooker/news/ding-destroys-xiao-to-reach-last-16/146782'), exact('/racing/news/article/465/10743050/doncaster-takes-precautions-against-frost-fears', '/racing/meeting/2018-04-27/doncaster/65010'), exact('/racing/courses/doncaster', '/racing/meeting/2018-04-27/doncaster/65010'), exact('/racing/courses/chepstow', '/racing/meeting/2018-04-27/chepstow/65011'), exact('/racing/news/article/465/9712940/timeform', '/racing/tips-centre'), exact('/racing/meeting/goodwood/29-07-2016', '/racing/racecards'), exact('/racing/courses/aintree', '/racing/racecards'), exact('/racing/meeting/aintree/07-04-2016', '/racing/racecards'), exact('/racing/news/article/465/10512752/glorious-goodwood-full-recap', '/racing/results'), exact('/racing/news/article/465/10300765/epsom-derby-2016-betting-tips-odds-start-time-racecards-results', '/racing/racecards'), exact('/racing/courses/cartmel', '/racing/racecards'), exact('/racing/courses/beverley', '/racing/racecards'), exact('/racing/courses/goodwood', '/racing/racecards'), exact('/racing/courses/windsor', '/racing/racecards'), exact('/racing/meeting/haydock-park/02-07-2016', '/racing/racecards'), exact('/racing/courses/newmarket', '/racing/racecards'), exact('/racing/results/09-04-2016/wolverhampton/result/717616/like-wolverhampton-racecourse-on-facebook-handicap', '/racing/racecards'), exact('/racing/results/26-11-2016/newbury', '/racing/racecards'), exact('/racing/meeting/newbury/12-02-2011', '/racing/racecards'), exact('/racing/news/article/465/10735160/ascot-call-inspection-ahead-of-clarence-house-chase-fixture', '/racing/racecards'), exact('/racing/news/article/465/10243338/newbury-saturday-fixture-in-doubt-as-friday-card-abandoned', '/racing/racecards'), exact('/racing/results/06-07-2016/yarmouth/result/731709/great-yarmouth-mercury-handicap/video', '/racing/results'), exact('/racing/report/761621/disko-beats-flogas-rivals', '/racing/results'), exact('/racing/results/04-09-2016/philadelphia-park/result/742848/claiming', '/racing/results'), exact('/racing/racecards/01-01-2017/cheltenham/racecard/757505/betbright-casino-handicap-hurdle', '/racing/tips-centre'), exact('/racing/racecards/29-10-2016/wetherby/racecard/750422/olbg-com-mares-hurdle-listed', '/racing/tips-centre'), exact('/racing/news/article/465/10576301/ante-post-preview-for-the-william-hill-ayr-gold-cup', '/racing/tips-centre'), exact('/racing/racecards/05-11-2016/doncaster/racecard/751423/betfred-mobile-wentworth-stakes-listed', '/racing/tips-centre'), exact('/racing/news/article/465/10080027/cheltenham-festival-2017-schedule-racecards-betting-tips-odds-results-key-trials-form', '/racing/tips-centre'), exact('/racing/news/article/465/10220524/grand-national-2016-full-list-of-40-horses-odds-betting-tips-aintree-racecards-dates-times', '/racing/tips-centre'), exact('/racing/results/05-01-2016/southwell/result/707546/coral-mobile-just-three-clicks-to-bet-handicap', '/racing/tips-centre'), exact('/racing/profiles/horse/945637/bo-selecta', '/racing/profiles/horse/18525'), exact('/racing/profiles/horse/727538/embankment', '/racing/profiles/horse/256855'), exact('/racing/profiles/horse/739877/waldorf-salad', '/racing/profiles/horse/263296'), exact('/racing/profiles/horse/792740/modus', '/racing/profiles/horse/473'), exact('/racing/profiles/horse/852806/identity-thief', '/racing/profiles/horse/9618'), exact('/racing/profiles/horse/595764/jessie-jane-ire', '/racing/profiles/horse/210351'), exact('/racing/report/386354/cosmos-out-of-this-world-in-leger', '/racing/profiles/horse/373713'), exact('/racing/profiles/horse/2464/eliza-dolittle', '/racing/profiles/horse/77714'), exact('/racing/profiles/horse/61314/blue-tomato', '/racing/profiles/horse/27159'), exact('/racing/profiles/horse/858163/duke-street', '/racing/profiles/horse/340377'), exact('/racing/profiles/horse/879457/papa-luigi', '/racing/profiles/horse/359659'), exact('/racing/profiles/horse/648539/commentary', '/racing/profiles/horse/880230'), exact('/racing/results/17-03-2016/cheltenham/result/708886/pertemps-network-final-listed-handicap-hurdle', '/racing/profiles/horse/51906'), exact('/racing/profiles/horse/905484/just-fab', '/racing/profiles/horse/24119'), exact('/racing/profiles/horse/947968/bravissimo', '/racing/profiles/horse/9668'), exact('/racing/profiles/horse/756628/goldie-horn', '/racing/profiles/horse/272768'), exact('/racing/profiles/horse/896711/koora', '/racing/profiles/horse/376889'), exact('/racing/profiles/horse/629721/dancing-leopard', '/racing/profiles/horse/259145'), exact('/racing/profiles/horse/846417/sykes', '/racing/profiles/horse/10944'), exact('/racing/profiles/horse/744852/baby-jake', '/racing/profiles/horse/265858'), exact('/racing/profiles/horse/279838/sexy-lady', '/racing/profiles/horse/319421'), exact('/racing/profiles/horse/895788/lumiere', '/racing/profiles/horse/375965'), exact('/racing/profiles/horse/319766/slugger-otoole', '/racing/profiles/horse/53561'), exact('/racing/profiles/horse/399383/gentlemen', '/racing/profiles/horse/799'), exact('/racing/profiles/trainer/306/k-c-bailey', '/racing/profiles/trainer/129'), exact('/racing/profiles/trainer/4254/d-pipe', '/racing/profiles/trainer/169'), exact('/racing/profiles/horse/859035/wait-for-me', '/racing/profiles/horse/10904'), exact('/racing/profiles/horse/759175/vicente', '/racing/profiles/horse/10972'), exact('/racing/profiles/horse/914661/atomix', '/racing/profiles/horse/14960'), exact('/racing/profiles/horse/621963/go-indigo', '/racing/profiles/horse/205515'), exact('/racing/profiles/horse/709175/vicky-valentine', '/racing/profiles/horse/247748'), exact('/racing/profiles/horse/829096/rocky-rider', '/racing/profiles/horse/320481'), exact('/racing/profiles/horse/877711/a-boy-named-sue', '/racing/profiles/horse/357931'), exact('/racing/profiles/horse/231280/mister-apples-fr', '/racing/profiles/horse/36724'), exact('/racing/profiles/horse/907083/remarkable', '/racing/profiles/horse/387252'), exact('/racing/profiles/horse/843643/who-dares-wins', '/racing/profiles/horse/468'), exact('/racing/profiles/trainer/14461/miss-s-smith', '/racing/profiles/trainer/121'), exact('/racing/profiles/trainer/67965/i-jardine', '/racing/profiles/trainer/346'), exact('/racing/profiles/trainer/4193/w-p-mullins/future-entries', '/racing/profiles/trainer/414'), exact('/racing/profiles/trainer/36948/i-mohammed', '/racing/profiles/trainer/178'), exact('/racing/profiles/jockey/23721/a-kirby', '/racing/profiles/jockey/793'), exact('/racing/profiles/jockey/72764/s-de-sousa', '/racing/profiles/jockey/3516'), exact('/racing/profiles/jockey/98041/d-r-fox', '/racing/profiles/jockey/754'), exact('/racing/profiles/jockey/620/hayley-turner', '/racing/profiles/jockey/2536'), exact('/racing/profiles/horse/338216/virtual_2', '/racing/abc-guide'), exact('/racing/news/article/465/10776342/paul-nicholls-stable-tour-including-zarkandar-and-movewiththetimes', '/racing/profiles/trainer/115'), exact('/racing/profiles/trainer/15101/a-m-balding', '/racing/profiles/trainer/3209'), exact('/football/transfer-centre/paper-talk', '/football/paper-talk'), badDateFormat('/football/results', { allowCompetitionTeams: true }), badDateFormat('/football/fixtures', { allowCompetitionTeams: true }), badDateFormat('/football/fixtures-results'), prefixed('/football/footballconference', '/football'), prefixed('/football/international', '/football/results/competitions/internationals/65'), prefixed('/football/la-liga', '/football'), prefixed('/football/league-cup', '/football'), prefixed('/football/ligue-1', '/football'), exact('/football/live/league-tables/championship', '/football/live'), exact('/football/live/latest_scores', '/football/live'), exact('/football/live/latest-commentary', '/football/live'), exact('/football/live/latestscores', '/football/live'), exact('/football/live/league-tables', '/football'), prefixed('/football/live/league-tables', '/football'), prefixed('/football/live/match', '/football'), prefixed('/football/live/match-betting', '/football/tips-centre'), prefixed('/football/live/match-commentary', '/football/live'), prefixed('/football/live/match-photos', '/football/live'), prefixed('/football/live/match-preview', '/football/live'), exact('/football/live/match-reaction', '/football/live'), prefixed('/football/live/match-reaction', '/football/live'), prefixed('/football/live/match-report', '/football/live'), exact('/football/live/match-reports', '/football/live'), prefixed('/football/live/match-stats', '/football/live'), exact('/football/live/reports', '/football/live'), prefixed('/football/live/tables', '/football/live'), prefixed('/football/live_match', '/football/live'), prefixed('/football/overseas', '/football'), prefixed('/football/photos', '/football'), prefixed('/football/player-profile', '/football'), prefixed('/football/popup', '/football'), prefixed('/football/premiership', '/football'), prefixed('/football/premteams', '/football'), exact('/football/scoreboard/index.html', '/football/results'), prefixed('/football/scotspremteams', '/football'), prefixed('/football/scottish1', '/football'), prefixed('/football/scottish-championship', '/football'), prefixed('/football/scottish-cup', '/football'), prefixed('/football/scottish-league-one', '/football'), prefixed('/football/scottish-premier', '/football'), prefixed('/football/scottishpremier', '/football'), exact('/football/serie-a', '/football/league-tables/italian-serie-a/6'), exact('/football/serie-a/(.*)', '/football'), prefixed('/football/suspensions', '/football'), prefixed('/football/tables', '/football'), prefixed('/football/team', '/football'), prefixed('/football/teams', '/football'), prefixed('/football/transfer_centre', '/football'), prefixed('/football/transfer-centre', '/football'), exact('/football/transfer-centre', '/football'), exact('/football/video', '/football'), {
  '/football/video(.*)': '/football'
}, prefixed('/football/world-cup', '/football'), prefixed('/football/worldcupfinals2002', '/football'), legacyNews('/formula1'), legacyNews('/golf'), newsIndex('/greyhounds'), tooLittlePath('/greyhounds/racecards'), badDateFormat('/greyhounds/racecards'), badDateFormat('/greyhounds/results', { allowYesterday: true }), exact('/greyhounds/abc-guide', '/greyhounds'), exact('/greyhounds/live-shows', '/greyhounds/racecards'), prefixed('/greyhounds/preview', '/greyhounds/racecards'), {
  '/greyhounds/selections(.*)': '/greyhounds'
}, legacyNews('/nfl'), exact('/pick7', 'https://pick7.sportinglife.com?dcmp=sl_redirect'), legacyNews('/other-sports'), newsIndex('/racing'), prefixed('/racing/ascot', '/racing'), exact('/racing/racecards/01-01-2015/southwell/racecard/655312/ladbrokes-mobile-handicap', '/racing/tips-centre'), prefixed('/racing/calendar', '/racing/racecards'), exact('/racing/columnists', '/columnists'), prefixed('/racing/courses', '/racing'), prefixed('/racing/draw_advantage', '/racing'), prefixed('/racing/goodwood', '/racing'), exact('/racing/live', '/racing'), prefixed('/racing/liveshows', '/racing'), prefixed('/racing/live-shows', '/racing/racecards'), prefixed('/racing/newbury', '/racing'), exact('/racing/notebook', '/racing'), prefixed('/racing/photos', '/racing'), exact('/racing/pointers', '/racing'), prefixed('/racing/racing_centre', '/racing/tips-centre'), exact('/racing/results/settlers.html', '/racing/results'), tooLittlePath('/racing/racecards', { preserveDate: true }), badDateFormat('/racing/racecards', { allowTomorrow: true }), exact('/racing/results/08-12-2016/aqueduct/result/755856/maiden-special-weight', '/nfl'), badDateFormat('/racing/results', { allowYesterday: true }), prefixed('/racing/racing_tipping_centre', '/racing/tips-centre'), prefixed('/racing/report', '/racing'), exact('/racing/results/search', '/racing/results'), prefixed('/search', '/racing/my-stable/search'), prefixed('/racing/profiles/search', '/racing/my-stable/search'), prefixed('/racing/stats', '/racing'), exact('/racing/steamers-drifters', '/racing/tips-centre'), exact('/racing/ten_to_follow', '/racing/tips-centre'), prefixed('/racing/tips-centre', '/racing/tips-centre'), exact('/racing/video', '/racing'), exact('/racting', '/racing'), exact('/fastresults', '/racing/fast-results'), {
  '/racing/video(.*)': '/racing'
}, exact('/rugbyleague', '/rugby-league'), legacyNews('/rugby-league'), prefixed('/rugbyleague', '/rugby-league'), prefixed('/rugbyunion', '/rugby-union'), legacyNews('/rugby-union'), legacyNews('/snooker'), prefixed('/soccer', '/football'), legacyNews('/tennis'), prefixed('/video', '/'), exact('/zone/golf/betting', '/golf'), exact('/football/missing-men', '/football'), exact('/football/national-league/table', '/football'), exact('/football/pools', '/football'), exact('/football/portuguese-liga/table', '/football'), exact('/football/scottish-league-cup', '/football'), exact('/football/top-scorers', '/football'), prefixed('/greyhounds/fast-results', '/greyhounds/fast-results'), prefixed('/greyhounds/live-shows', '/greyhounds/racecards'), exact('/greyhounds/non-runners', '/greyhounds/racecards'), prefixed('/greyhounds/profile/dog', '/greyhounds'), exact('/nfl/schedule', '/nfl'), exact('/nfl/standings', '/nfl'), exact('/photos', '/'), exact('/racing/fast-results-legacy', '/racing/fast-results'), exact('/racing/meeting/aqueduct/20-02-2017/fast-results', '/racing/fast-results'), exact('/racing/meeting/sedgefield/27-09-2016/fast-results', '/racing/fast-results'), prefixed('/racing/fast-results-legacy', '/racing/fast-results'), exact('/racing/point-to-point', '/racing'), prefixed('/snooker/draw', '/snooker'), exact('/tennis/atp-world-rankings', '/tennis'), exact('/tennis/fed-cup', '/tennis'), exact('/tennis/live', '/tennis'), prefixed('/tennis/live', '/tennis'), exact('/tennis/net-talk', '/tennis'), prefixed('/tennis/player-profile', '/tennis'), exact('/tennis/race-to-the-wta-championships', '/tennis'), exact('/tennis/results', '/tennis'), prefixed('/tennis/results', '/tennis'), prefixed('/tennis/video', '/tennis'), exact('/tennis/wta-world-rankings', '/tennis'), prefixed('/tv2/transfer-centre', '/'), prefixed('.*/news/article/[0-9]+/[0-9]+', '/'));

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(74);
var call = __webpack_require__(458);
var isArrayIter = __webpack_require__(286);
var anObject = __webpack_require__(16);
var toLength = __webpack_require__(41);
var getIterFn = __webpack_require__(303);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(16);
var dPs = __webpack_require__(464);
var enumBugKeys = __webpack_require__(282);
var IE_PROTO = __webpack_require__(294)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(281)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(284).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(466);
var hiddenKeys = __webpack_require__(282).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(466);
var enumBugKeys = __webpack_require__(282);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 127 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(57);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var dP = __webpack_require__(40);
var DESCRIPTORS = __webpack_require__(39);
var SPECIES = __webpack_require__(33)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(85);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1271);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1270);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 134 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1307)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(312)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1496);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(679);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(678);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(1567);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(1566);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var processNextTick = __webpack_require__(194);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(189);
util.inherits = __webpack_require__(90);
/*</replacement>*/

var Readable = __webpack_require__(695);
var Writable = __webpack_require__(697);

util.inherits(Duplex, Readable);

var keys = objectKeys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  processNextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  processNextTick(cb, err);
};

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _morenews = __webpack_require__(79);

var _media = __webpack_require__(78);

var _TipsSection = __webpack_require__(362);

var _TipsSection2 = _interopRequireDefault(_TipsSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TIPS_PATH = '/football/tips-centre';

var FootballTips = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)("FootballTips", [{
  dispatch: function dispatch() {
    return (0, _morenews.load)(TIPS_PATH, 3);
  },
  state: _morenews.connectMoreNews,
  then: function then(_ref) {
    var dispatch = _ref.dispatch,
        state = _ref.state,
        articles = _ref.result.articles;
    return (0, _media.loadMediaForArticles)(state, dispatch, articles);
  }
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballTips, _Component);

  function FootballTips() {
    (0, _classCallCheck3.default)(this, FootballTips);
    return (0, _possibleConstructorReturn3.default)(this, (FootballTips.__proto__ || (0, _getPrototypeOf2.default)(FootballTips)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballTips, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$news = _props.news;
      _props$news = _props$news === undefined ? {} : _props$news;
      var _props$news$TIPS_PATH = _props$news[TIPS_PATH];
      _props$news$TIPS_PATH = _props$news$TIPS_PATH === undefined ? {} : _props$news$TIPS_PATH;
      var _props$news$TIPS_PATH2 = _props$news$TIPS_PATH.articles,
          tipsItems = _props$news$TIPS_PATH2 === undefined ? [] : _props$news$TIPS_PATH2,
          plainTitle = _props.plainTitle;


      var componentData = {
        plainTitle: plainTitle,
        sectionLabel: "Football",
        sectionLink: "/football",
        additionalTipsLinks: [{ text: "All Football Tips", href: "/football/tips-centre" }, { text: "Tips & Previews", href: "/football" }],
        tipsItems: tipsItems.slice(0, 3)
      };

      return _react2.default.createElement(_TipsSection2.default, componentData);
    }
  }]);
  return FootballTips;
}(_react.Component), _class2.propTypes = {
  plainTitle: _propTypes2.default.bool,
  news: _propTypes2.default.object
}, _temp)) || _class);
exports.default = FootballTips;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _morenews = __webpack_require__(79);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _MostReadPanel = __webpack_require__(251);

var _MostReadPanel2 = _interopRequireDefault(_MostReadPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MostReadAll = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)("MostReadAll", (0, _morenews.asyncConnectMostRead)() /* all */), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MostReadAll, _Component);

  function MostReadAll() {
    (0, _classCallCheck3.default)(this, MostReadAll);
    return (0, _possibleConstructorReturn3.default)(this, (MostReadAll.__proto__ || (0, _getPrototypeOf2.default)(MostReadAll)).apply(this, arguments));
  }

  (0, _createClass3.default)(MostReadAll, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_MostReadPanel2.default, { articles: this.props.mostread, showCategory: true });
    }
  }]);
  return MostReadAll;
}(_react.Component), _class2.propTypes = {
  mostread: _propTypes2.default.array
}, _temp)) || _class) || _class);
exports.default = MostReadAll;

/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(40).f;
var has = __webpack_require__(55);
var TAG = __webpack_require__(33)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var defined = __webpack_require__(83);
var fails = __webpack_require__(25);
var spaces = __webpack_require__(298);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1274), __esModule: true };

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1279), __esModule: true };

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(494);
var enumBugKeys = __webpack_require__(310);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(308);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1312);
var global = __webpack_require__(53);
var hide = __webpack_require__(105);
var Iterators = __webpack_require__(149);
var TO_STRING_TAG = __webpack_require__(50)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(335);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(137);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(1607);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(327);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(1549);

var _HelmetConstants = __webpack_require__(669);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(98);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(111);

var _Actions = __webpack_require__(243);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var assign = make_assign()
var create = make_create()
var trim = make_trim()
var Global = (typeof window !== 'undefined' ? window : global)

module.exports = {
	assign: assign,
	create: create,
	trim: trim,
	bind: bind,
	slice: slice,
	each: each,
	map: map,
	pluck: pluck,
	isList: isList,
	isFunction: isFunction,
	isObject: isObject,
	Global: Global
}

function make_assign() {
	if (Object.assign) {
		return Object.assign
	} else {
		return function shimAssign(obj, props1, props2, etc) {
			for (var i = 1; i < arguments.length; i++) {
				each(Object(arguments[i]), function(val, key) {
					obj[key] = val
				})
			}			
			return obj
		}
	}
}

function make_create() {
	if (Object.create) {
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			return assign.apply(this, [Object.create(obj)].concat(assignArgsList))
		}
	} else {
		function F() {} // eslint-disable-line no-inner-declarations
		return function create(obj, assignProps1, assignProps2, etc) {
			var assignArgsList = slice(arguments, 1)
			F.prototype = obj
			return assign.apply(this, [new F()].concat(assignArgsList))
		}
	}
}

function make_trim() {
	if (String.prototype.trim) {
		return function trim(str) {
			return String.prototype.trim.call(str)
		}
	} else {
		return function trim(str) {
			return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '')
		}
	}
}

function bind(obj, fn) {
	return function() {
		return fn.apply(obj, Array.prototype.slice.call(arguments, 0))
	}
}

function slice(arr, index) {
	return Array.prototype.slice.call(arr, index || 0)
}

function each(obj, fn) {
	pluck(obj, function(val, key) {
		fn(val, key)
		return false
	})
}

function map(obj, fn) {
	var res = (isList(obj) ? [] : {})
	pluck(obj, function(v, k) {
		res[k] = fn(v, k)
		return false
	})
	return res
}

function pluck(obj, fn) {
	if (isList(obj)) {
		for (var i=0; i<obj.length; i++) {
			if (fn(obj[i], i)) {
				return obj[i]
			}
		}
	} else {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
				if (fn(obj[key], key)) {
					return obj[key]
				}
			}
		}
	}
}

function isList(val) {
	return (val != null && typeof val != 'function' && typeof val.length == 'number')
}

function isFunction(val) {
	return val && {}.toString.call(val) === '[object Function]'
}

function isObject(val) {
	return val && {}.toString.call(val) === '[object Object]'
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SUBMIT_FEEDBACK = exports.SUBMIT_FEEDBACK = "SUBMIT_FEEDBACK";
var SEND_FEEDBACK_FAILED = exports.SEND_FEEDBACK_FAILED = "SEND_FEEDBACK_FAILED";
var SEND_FEEDBACK_SUCCESS = exports.SEND_FEEDBACK_SUCCESS = "SEND_FEEDBACK_SUCCESS";
var SEND_FEEDBACK = exports.SEND_FEEDBACK = "SEND_FEEDBACK";
var TOGGLE_SHOW_FEEDBACK_FORM = exports.TOGGLE_SHOW_FEEDBACK_FORM = "TOGGLE_SHOW_FEEDBACK_FORM";
var RESET_FEEDBACK_FORM = exports.RESET_FEEDBACK_FORM = "RESET_FEEDBACK_FORM";

var sendFeedback = exports.sendFeedback = function sendFeedback(data) {
    return { type: SUBMIT_FEEDBACK, data: data };
};

var showFeedbackForm = exports.showFeedbackForm = function showFeedbackForm(toggle) {
    return { type: TOGGLE_SHOW_FEEDBACK_FORM, toggle: toggle };
};

var resetFeedbackForm = exports.resetFeedbackForm = function resetFeedbackForm() {
    return { type: RESET_FEEDBACK_FORM };
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CompactText;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CompactText(_ref) {
  var compactText = _ref.compactText,
      children = _ref.children;

  __webpack_require__(1363);

  return compactText ? _react2.default.createElement(
    'span',
    { 'data-compact-text': compactText },
    _react2.default.createElement(
      'span',
      null,
      children
    )
  ) : _react2.default.createElement(
    'span',
    null,
    children
  );
}

CompactText.propTypes = {
  compactText: _propTypes2.default.string,
  children: _propTypes2.default.any
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = Image;
exports.getFBImage = getFBImage;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _commonUtils = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function importCSS(source, prefix) {
  return (0, _commonUtils.parseCssExports)(source, { prefix: prefix, transform: function transform(i) {
      return i;
    } });
}

var SIZES = (0, _extends3.default)({}, importCSS(__webpack_require__(515), 'moreNewsImageSizes'), importCSS(__webpack_require__(514), 'articlePageImageSizes'), importCSS(__webpack_require__(507), 'tipsSectionImageSizes'), importCSS(__webpack_require__(506), 'newsSectionImageSizes'), importCSS(__webpack_require__(508), 'tipsWidgetImageSizes'));

var DEFAULT_SIZES = {
  leadArticle: 630,
  secondaryArticle: 450,
  otherArticle: 300,
  articlePage: 930,
  tipArticle: 320,
  tipWidget: 300,
  tipWidgetLarge: 289,
  sectionArticle: 250

  // These values need to be unique.
};var IMAGE_TYPES = ["leadArticle", "secondaryArticle", "otherArticle", "articlePage", "tipArticle", "tipWidget", "tipWidgetLarge", "sectionArticle"].map(function (s) {
  return {
    type: s,
    sizes: SIZES[s],
    default: DEFAULT_SIZES[s]
  };
});

__webpack_require__(1376);

var getRatio = function getRatio(width, height) {
  return Number(width / height).toFixed(1);
};

var getImagesAtRatio = function getImagesAtRatio(images, ratio) {
  return images.filter(function (i) {
    var r = getRatio(i.width, i.height);
    var diff = Math.abs(Math.round((r - ratio) * 10));

    return diff <= 1;
  });
};

function Image(_ref) {
  var _ref$imageMedia = _ref.imageMedia;
  _ref$imageMedia = _ref$imageMedia === undefined ? {} : _ref$imageMedia;
  var _ref$imageMedia$artef = _ref$imageMedia.artefacts,
      artefacts = _ref$imageMedia$artef === undefined ? [] : _ref$imageMedia$artef,
      caption = _ref$imageMedia.caption,
      imageType = _ref.imageType,
      ratio = _ref.ratio;


  var images = artefacts.filter(function (artefact) {
    return artefact.media_type === 'Image';
  });
  // If no images exist within the artefacts display a placeholder image.
  if (images.length === 0) {

    var errorPixelSrc = '/1x1.gif?type=image&id=0&cb=' + Date.now();
    return _react2.default.createElement(
      'div',
      { className: 'missing-image' },
      _react2.default.createElement(
        'span',
        null,
        'Image Missing'
      ),
      _react2.default.createElement('img', { src: errorPixelSrc, width: '1', height: '1' })
    );
  }

  // Get the orignal image.
  var original = images.filter(function (artefact) {
    return isArtefactOriginal(artefact);
  });

  // Get the processed images.
  images = images.filter(function (artefact) {
    return !isArtefactOriginal(artefact);
  });

  // If we have no processed images, best we can do is display the orignal
  // whatever its aspect ratio.
  if (images.length === 0) {
    images = original;
  } else if (ratio) {
    images = getImagesAtRatio(images, ratio);
  }

  if (!images || images.length == 0) {
    images = original;
  }

  // Make sure we have the given image type in the list.
  var imageObject = _lodash2.default.find(IMAGE_TYPES, function (o) {
    return o.type == imageType;
  });
  if (imageObject) {
    var imageSrc = findBestImageMatch(imageObject.default, images);

    var imgAttrs = {
      src: '/' + encodeURI(imageSrc.uri),
      sizes: imageObject.sizes,
      srcSet: images.map(function (image) {
        return '/' + encodeURI(image.uri) + ' ' + image.width + 'w';
      }).join()
    };

    if (caption.trim()) {
      imgAttrs.alt = caption;
      imgAttrs.className = "image--with-caption";
    }

    return _react2.default.createElement('img', imgAttrs);
  }

  // Return without a source set if an image type was not defined. We have no
  // information on what type of image here so just display a resonable default.
  var defaultSrc = findBestImageMatch(1000, images);
  return _react2.default.createElement('img', { src: '/' + encodeURI(defaultSrc.uri) });
}

Image.propTypes = {
  imageMedia: _propTypes2.default.object,
  imageType: _propTypes2.default.string,
  ratio: _propTypes2.default.number
};

function findBestImageMatch(targetWidth, images) {

  var imagesLower = [];
  var imagesHigher = [];
  images.map(function (image) {
    if (image.width < targetWidth) {
      imagesLower.push(image);
    } else {
      imagesHigher.push(image);
    }
  });

  // Return the first element.
  return [].concat((0, _toConsumableArray3.default)(_lodash2.default.sortBy(imagesHigher, function (image) {
    return image.width;
  })), (0, _toConsumableArray3.default)(_lodash2.default.sortBy(imagesLower, function (image) {
    return image.width;
  }).reverse()))[0];
}

// Function to check if an artefact is an orginal or has a different
// aspect ratio to 16 / 9
function isArtefactOriginal(artefact) {
  var aspectRatio = artefact.width / artefact.height;
  return artefact.uri.includes("images/news/original") || aspectRatio > 16 / 9 + 0.02 && aspectRatio < 16 / 9 - 0.02; // Include margin of error
}

function getFBImage(artefacts) {
  return findBestImageMatch(1200, artefacts.filter(function (artefact) {
    return artefact.media_type === 'Image';
  }));
}

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = __webpack_require__(180);

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(156);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JsonLD = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(JsonLD, _Component);

  function JsonLD(props) {
    (0, _classCallCheck3.default)(this, JsonLD);

    var _this = (0, _possibleConstructorReturn3.default)(this, (JsonLD.__proto__ || (0, _getPrototypeOf2.default)(JsonLD)).call(this, props));

    _this.state = { json: (0, _stringify2.default)(_this.getJSONData(props.data)) };
    return _this;
  }

  (0, _createClass3.default)(JsonLD, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState = { json: (0, _stringify2.default)(this.getJSONData(props.data)) };
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.json !== this.state.json;
    }
  }, {
    key: 'getJSONData',
    value: function getJSONData(data) {
      return data instanceof Array ? data.map(function (item) {
        return (0, _extends3.default)({
          "@context": "http://schema.org"
        }, item);
      } // this way around allows @context to be overwritten if need be
      ) : (0, _extends3.default)({
        "@context": "http://schema.org"
      }, data);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactHelmet2.default,
        null,
        _react2.default.createElement(
          'script',
          { type: 'application/ld+json' },
          this.state.data
        )
      );
    }
  }]);
  return JsonLD;
}(_react.Component), _class.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]).isRequired
}, _temp);
exports.default = JsonLD;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.RegisterLoginButtons = RegisterLoginButtons;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(17);

var _reactMetrics = __webpack_require__(69);

var _skysso = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Full width button row for register & login btns
function RegisterLoginButtons(props) {
  var _props$registerClick = props.registerClick,
      registerClick = _props$registerClick === undefined ? null : _props$registerClick,
      _props$loginClick = props.loginClick,
      loginClick = _props$loginClick === undefined ? null : _props$loginClick,
      _props$closeContext = props.closeContext,
      closeContext = _props$closeContext === undefined ? function () {} : _props$closeContext,
      _props$loginLabel = props.loginLabel,
      loginLabel = _props$loginLabel === undefined ? "Log in" : _props$loginLabel,
      _props$registerLabel = props.registerLabel,
      registerLabel = _props$registerLabel === undefined ? "Register" : _props$registerLabel,
      _props$trackLoginClic = props.trackLoginClickAttributes,
      trackLoginClickAttributes = _props$trackLoginClic === undefined ? {} : _props$trackLoginClic,
      _props$trackRegisterC = props.trackRegisterClickAttributes,
      trackRegisterClickAttributes = _props$trackRegisterC === undefined ? {} : _props$trackRegisterC,
      SSOLogin = props.SSOLogin,
      SSORegister = props.SSORegister;


  var onLoginClick = function onLoginClick() {

    if (loginClick) {
      loginClick();
    }
    closeContext();
    SSOLogin();
  };

  var onRegisterClick = function onRegisterClick() {
    if (registerClick) {
      registerClick();
    }
    closeContext();
    SSORegister();
  };

  return _react2.default.createElement(
    'div',
    { className: 'reglog-button-fw-row' },
    _react2.default.createElement(
      _reactMetrics.MetricsElement,
      null,
      _react2.default.createElement(
        'button',
        (0, _extends3.default)({}, trackLoginClickAttributes, { className: 'login-button', id: 'login-btn', onClick: onLoginClick }),
        loginLabel
      )
    ),
    _react2.default.createElement(
      _reactMetrics.MetricsElement,
      null,
      _react2.default.createElement(
        'button',
        (0, _extends3.default)({}, trackRegisterClickAttributes, { className: 'register-button', id: 'register-btn', onClick: onRegisterClick }),
        registerLabel
      )
    )
  );
}

RegisterLoginButtons.propTypes = {
  closeContext: _propTypes2.default.func,
  loginLabel: _propTypes2.default.string,
  registerLabel: _propTypes2.default.string,
  registerClick: _propTypes2.default.func,
  loginClick: _propTypes2.default.func,
  trackLoginClickAttributes: _propTypes2.default.object,
  trackRegisterClickAttributes: _propTypes2.default.object,
  SSOLogin: _propTypes2.default.func,
  SSORegister: _propTypes2.default.func
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    SSOLogin: function SSOLogin() {
      return dispatch((0, _skysso.SSOLogin)());
    },
    SSORegister: function SSORegister() {
      return dispatch((0, _skysso.SSORegister)());
    }
  };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(RegisterLoginButtons);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionPlainTitle = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SectionPlainTitle, _Component);

  function SectionPlainTitle() {
    (0, _classCallCheck3.default)(this, SectionPlainTitle);
    return (0, _possibleConstructorReturn3.default)(this, (SectionPlainTitle.__proto__ || (0, _getPrototypeOf2.default)(SectionPlainTitle)).apply(this, arguments));
  }

  (0, _createClass3.default)(SectionPlainTitle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$level = _props.level,
          level = _props$level === undefined ? 2 : _props$level,
          _props$className = _props.className,
          className = _props$className === undefined ? "section-plain-title" : _props$className,
          children = _props.children;


      return _react2.default.createElement('h' + level, { className: className }, children);
    }
  }]);
  return SectionPlainTitle;
}(_react.Component), _class.propTypes = {
  level: _propTypes2.default.number,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
}, _temp);
exports.default = SectionPlainTitle;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MyStableIcon = __webpack_require__(254);

var _MyStableIcon2 = _interopRequireDefault(_MyStableIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(509);

var MyStableButton = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(MyStableButton, _PureComponent);

  function MyStableButton() {
    (0, _classCallCheck3.default)(this, MyStableButton);
    return (0, _possibleConstructorReturn3.default)(this, (MyStableButton.__proto__ || (0, _getPrototypeOf2.default)(MyStableButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyStableButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$hasSubscriptio = _props.hasSubscriptions,
          hasSubscriptions = _props$hasSubscriptio === undefined ? false : _props$hasSubscriptio,
          _props$saveSubscripti = _props.saveSubscriptions,
          saveSubscriptions = _props$saveSubscripti === undefined ? function () {} : _props$saveSubscripti,
          _props$deleteSubscrip = _props.deleteSubscriptions,
          deleteSubscriptions = _props$deleteSubscrip === undefined ? function () {} : _props$deleteSubscrip,
          noText = _props.noText;


      var className = "my-stable-button";
      var subText = "My Stable";

      if (hasSubscriptions) {
        className = className + '-selected';
        subText = "Following";
      }

      if (noText) {
        subText = null;
      }

      var handleClick = function handleClick() {
        if (hasSubscriptions) {
          deleteSubscriptions();
        } else {
          saveSubscriptions();
        }
      };

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: className }, { id: 'my-stable-btn' }),
        _react2.default.createElement(
          'button',
          { onClick: handleClick },
          _react2.default.createElement(_MyStableIcon2.default, (0, _extends3.default)({ title: 'My Stable' }, { subText: subText }))
        )
      );
    }
  }]);
  return MyStableButton;
}(_react.PureComponent), _class.propTypes = {
  hasSubscriptions: _propTypes2.default.bool,
  saveSubscriptions: _propTypes2.default.func,
  deleteSubscriptions: _propTypes2.default.func,
  noText: _propTypes2.default.bool
}, _temp);
exports.default = MyStableButton;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'football/competition/LOAD';
var LOAD_SUCCESS = 'football/competition/LOAD_SUCCESS';
var LOAD_FAIL = 'football/competition/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          loading: false,
          loaded: true,
          list: action.result
        });
      }
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading(globalState) {
  return globalState.football && globalState.football.competition && globalState.football.competition.loading;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.football.competitionList);
    }
  };
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var HORSE_RACE_UPDATE_RECEIVED = exports.HORSE_RACE_UPDATE_RECEIVED = "HORSE_RACE_UPDATE";
var HORSE_RACE_UPDATE_RECEIVE_ERROR = exports.HORSE_RACE_UPDATE_RECEIVE_ERROR = "HORSE_RACE_UPDATE_RECEIVE_ERROR";
var HORSE_RACE_UPDATE_SUBSCRIBE = exports.HORSE_RACE_UPDATE_SUBSCRIBE = "HORSE_RACE_UPDATE_SUBSCRIBE";
var HORSE_RACE_UPDATE_SUBSCRIBE_ERROR = exports.HORSE_RACE_UPDATE_SUBSCRIBE_ERROR = "HORSE_RACE_UPDATE_SUBSCRIBE_ERROR";
var HORSE_RACE_UPDATE_SUBSCRIBED = exports.HORSE_RACE_UPDATE_SUBSCRIBED = "HORSE_RACE_UPDATE_SUBSCRIBED";
var HORSE_RACE_UPDATE_CONNECT = exports.HORSE_RACE_UPDATE_CONNECT = "HORSE_RACE_UPDATE_CONNECT";
var HORSE_RACE_UPDATE_CONNECT_ERROR = exports.HORSE_RACE_UPDATE_CONNECT_ERROR = "HORSE_RACE_UPDATE_CONNECT_ERROR";
var HORSE_RACE_UPDATE_UNSUBSCRIBE = exports.HORSE_RACE_UPDATE_UNSUBSCRIBE = "HORSE_RACE_UPDATE_UNSUBSCRIBE";
var HORSE_RACE_UPDATE_UNSUBSCRIBE_ERROR = exports.HORSE_RACE_UPDATE_UNSUBSCRIBE_ERROR = "HORSE_RACE_UPDATE_UNSUBSCRIBE_ERROR";
var HORSE_RACE_UPDATE_UNSUBSCRIBE_SUCCESS = exports.HORSE_RACE_UPDATE_UNSUBSCRIBE_SUCCESS = "HORSE_RACE_UPDATE_UNSUBSCRIBE_SUCCESS";
var HORSE_RACE_UPDATE_FALLBACK_TO_POLLING = exports.HORSE_RACE_UPDATE_FALLBACK_TO_POLLING = "HORSE_RACE_UPDATE_FALLBACK_TO_POLLING";
var HORSE_RACE_UPDATE_DISCONNECTED = exports.HORSE_RACE_UPDATE_DISCONNECTED = "HORSE_RACE_UPDATE_DISCONNECTED";
var HORSE_RACE_UPDATE_DISCONNECTING = exports.HORSE_RACE_UPDATE_DISCONNECTING = "HORSE_RACE_UPDATE_DISCONNECTING";

var connectToRaceUpdates = exports.connectToRaceUpdates = function connectToRaceUpdates() {
    var countryGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return { countryGroups: countryGroups, type: HORSE_RACE_UPDATE_CONNECT };
};

var unSubscribeRaceUpdates = exports.unSubscribeRaceUpdates = function unSubscribeRaceUpdates() {
    return { type: HORSE_RACE_UPDATE_DISCONNECTING };
};

var subscribeToRaceUpdates = exports.subscribeToRaceUpdates = function subscribeToRaceUpdates() {
    var countryGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var unsubscribe = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return { countryGroups: countryGroups, unsubscribe: unsubscribe, type: HORSE_RACE_UPDATE_SUBSCRIBE };
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(17);

var _ApiClient = __webpack_require__(64);

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _lodash = __webpack_require__(20);

var _EnhancedLoginPrompt = __webpack_require__(357);

var _EnhancedLoginPrompt2 = _interopRequireDefault(_EnhancedLoginPrompt);

var _AtrPlaceholderPrompt = __webpack_require__(903);

var _AtrPlaceholderPrompt2 = _interopRequireDefault(_AtrPlaceholderPrompt);

var _VideoPlayer = __webpack_require__(363);

var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1443);

var client = new _ApiClient2.default();

function defaultState() {
  return {
    autoPlayVideo: false,
    videoPlaying: false,
    videoUrlLoading: false
  };
}

var RaceVideoPlayer = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.common.auth, atrPlaceholderStartTimeMs: state.common.atrVideo.placeholderTimeStamp };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(RaceVideoPlayer, _Component);

  function RaceVideoPlayer() {
    var _ref;

    (0, _classCallCheck3.default)(this, RaceVideoPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // The URL provided for At The Races is a getter for a short lived Video URL, so it must be stored transiently.
    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = RaceVideoPlayer.__proto__ || (0, _getPrototypeOf2.default)(RaceVideoPlayer)).call.apply(_ref, [this].concat(args)));

    _this.state = defaultState();
    return _this;
  }

  (0, _createClass3.default)(RaceVideoPlayer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(this.props, nextProps)) {
        this.setState(defaultState());
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _lodash.isEqual)(this.props, nextProps) || !(0, _lodash.isEqual)(this.state, nextState);
    }
  }, {
    key: 'getVideo',
    value: function getVideo() {
      var _lastVideo = this.lastVideo(),
          _lastVideo2 = (0, _slicedToArray3.default)(_lastVideo, 1),
          _lastVideo2$ = _lastVideo2[0],
          video = _lastVideo2$ === undefined ? {} : _lastVideo2$;

      return video;
    }
  }, {
    key: 'hasVideo',
    value: function hasVideo() {
      var _getVideoArtefact = this.getVideoArtefact(),
          uri = _getVideoArtefact.uri,
          media_type = _getVideoArtefact.media_type;

      return uri && media_type === "Video";
    }
  }, {
    key: 'getVideoArtefact',
    value: function getVideoArtefact() {
      var _lastVideo3 = this.lastVideo(),
          _lastVideo4 = (0, _slicedToArray3.default)(_lastVideo3, 1),
          _lastVideo4$ = _lastVideo4[0];

      _lastVideo4$ = _lastVideo4$ === undefined ? {} : _lastVideo4$;
      var _lastVideo4$$artefact = _lastVideo4$.artefacts;
      _lastVideo4$$artefact = _lastVideo4$$artefact === undefined ? [] : _lastVideo4$$artefact;

      var _lastVideo4$$artefact2 = (0, _slicedToArray3.default)(_lastVideo4$$artefact, 1),
          _lastVideo4$$artefact3 = _lastVideo4$$artefact2[0],
          artefact = _lastVideo4$$artefact3 === undefined ? {} : _lastVideo4$$artefact3;

      return artefact;
    }
  }, {
    key: 'lastVideo',
    value: function lastVideo() {
      var _props$videos = this.props.videos,
          videos = _props$videos === undefined ? [] : _props$videos;

      return videos.slice(-1); // only want the last (ie most recent) one - not possible via destructuring
    }
  }, {
    key: 'loadVideoUri',
    value: function loadVideoUri() {
      var _this2 = this;

      this.setState({
        autoPlayVideo: true,
        videoUrlLoading: true
      }, function () {
        _this2.fetchVideoData();
      });
    }
  }, {
    key: 'getEventId',
    value: function getEventId() {
      // In the future we plan to alter the backend so that it just sends the eventId instead of a URL
      // but for the moment we need to extract the event id from the returned URL
      var eventIdStr = 'EventID=';
      var fullUrl = this.getVideoArtefact().uri;
      var eventIdPos = fullUrl.indexOf(eventIdStr) + eventIdStr.length;
      var eventIdEndPos = fullUrl.indexOf('&', eventIdPos);

      return fullUrl.substring(eventIdPos, eventIdEndPos);
    }

    // Only relevant for ATR videos

  }, {
    key: 'fetchVideoData',
    value: function fetchVideoData() {
      var _this3 = this;

      var headers = { 'Authorization': this.props.auth.user.ssoToken,
        'username': this.props.auth.user.customerId };
      var params = { 'eventId': this.getEventId() };

      client.get(_config2.default.api.horseRacing.atrVideo, { params: params }, headers).then(function (videoInfo) {
        var IsOK = videoInfo.IsOK,
            _videoInfo$EventInfo = videoInfo.EventInfo;
        _videoInfo$EventInfo = _videoInfo$EventInfo === undefined ? {} : _videoInfo$EventInfo;
        var _videoInfo$EventInfo$ = _videoInfo$EventInfo.Streams;
        _videoInfo$EventInfo$ = _videoInfo$EventInfo$ === undefined ? [] : _videoInfo$EventInfo$;

        var _videoInfo$EventInfo$2 = (0, _slicedToArray3.default)(_videoInfo$EventInfo$, 1),
            _videoInfo$EventInfo$3 = _videoInfo$EventInfo$2[0],
            defaultStream = _videoInfo$EventInfo$3 === undefined ? {} : _videoInfo$EventInfo$3,
            _videoInfo$EventInfo$4 = _videoInfo$EventInfo.Streams,
            streamList = _videoInfo$EventInfo$4 === undefined ? [] : _videoInfo$EventInfo$4;

        if (IsOK) {
          // Probably only one, but take the first if 2 or more match
          // If none match default to the first in the unfiltered list
          var _streamList$filter = streamList.filter(function (s) {
            return s.BitrateLevel == "Adaptive";
          }),
              _streamList$filter2 = (0, _slicedToArray3.default)(_streamList$filter, 1),
              _streamList$filter2$ = _streamList$filter2[0];

          _streamList$filter2$ = _streamList$filter2$ === undefined ? defaultStream : _streamList$filter2$;
          var videoPlaying = _streamList$filter2$.Url;


          if (videoPlaying) {
            // this only ever gets called for ATR videos, which are always HLS
            videoPlaying = {
              src: videoPlaying,
              type: "application/x-mpegURL"
            };

            _this3.setState({
              videoPlaying: videoPlaying,
              videoUrlLoading: false
            });
          }
        } else {
          _this3.onError();
        }
      });
    }
  }, {
    key: 'hasVideoUri',
    value: function hasVideoUri() {
      var _getVideo = this.getVideo(),
          origin = _getVideo.origin;

      return origin !== "AT_THE_RACES" || this.state.videoPlaying;
    }
  }, {
    key: 'getVideoUri',
    value: function getVideoUri() {
      if (this.hasVideoUri()) {
        return this.state.videoPlaying || this.getVideoArtefact().uri;
      }
    }
  }, {
    key: 'loginPrompt',
    value: function loginPrompt() {
      return {
        className: "video-login",
        title: _EnhancedLoginPrompt.EnhancedLoginPromptHeading,
        body: _react2.default.createElement(_EnhancedLoginPrompt2.default, { size: 'small', showLoginBenefits: this.props.showLoginBenefits })
      };
    }
  }, {
    key: 'atrPlaceholderPrompt',
    value: function atrPlaceholderPrompt() {
      return {
        className: "video-login",
        title: _AtrPlaceholderPrompt.AtrPlaceholderPromptHeading,
        body: _react2.default.createElement(_AtrPlaceholderPrompt2.default, { size: 'small' })
      };
    }
  }, {
    key: 'atrPlayButton',
    value: function atrPlayButton() {
      var _this4 = this;

      return {
        loadSrc: function loadSrc() {
          return _this4.loadVideoUri();
        },
        type: this.state.videoUrlLoading ? 'loading' : 'play'
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var playerProps = {
        src: this.getVideoUri(),
        caption: this.getVideo().default_caption,
        autoPlay: this.state.autoPlayVideo
      };

      // short out video player component with placeholder if provided by ATR.
      var provider = this.props.provider || 'unknown';

      //show atr placeholder for ATR videos after jan 1st 2018
      var atrTimeStamp = parseInt(this.props.atrPlaceholderStartTimeMs);
      var showAtrPlaceholder = false;
      if (atrTimeStamp !== 0 && Date.now() >= atrTimeStamp) {
        showAtrPlaceholder = true;
      }

      if (showAtrPlaceholder && provider === "atr") {
        playerProps.prompt = this.atrPlaceholderPrompt();
        return _react2.default.createElement(_VideoPlayer2.default, playerProps);
      }

      var _getVideo2 = this.getVideo(),
          origin = _getVideo2.origin;

      if (!this.props.auth.loggedIn) {
        playerProps.prompt = this.loginPrompt();
      }

      if (showAtrPlaceholder && origin === "AT_THE_RACES") {
        playerProps.prompt = this.atrPlaceholderPrompt();
      } else if (!this.hasVideoUri()) {
        playerProps.button = this.atrPlayButton();
      }

      return _react2.default.createElement(_VideoPlayer2.default, playerProps);
    }
  }]);
  return RaceVideoPlayer;
}(_react.Component), _class2.propTypes = {
  videos: _propTypes2.default.array.isRequired,
  atrPlaceholderStartTimeMs: _propTypes2.default.number.isRequired,
  auth: _propTypes2.default.shape({
    loggedIn: _propTypes2.default.bool.isRequired,
    user: _propTypes2.default.shape({
      ssoToken: _propTypes2.default.string,
      customerId: _propTypes2.default.string
    })
  }).isRequired,
  provider: _propTypes2.default.string,
  showLoginBenefits: _propTypes2.default.bool
}, _temp)) || _class);
exports.default = RaceVideoPlayer;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.filterRidesByStatus = filterRidesByStatus;
exports.filterRidesByPlacedStatus = filterRidesByPlacedStatus;
exports.filterRidesByAlsoRan = filterRidesByAlsoRan;
exports.filterRidesByCasualty = filterRidesByCasualty;
exports.sortByFinishPosition = sortByFinishPosition;
exports.sortByClothNo = sortByClothNo;

var _utils = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterRidesByStatus(rides) {
  for (var _len = arguments.length, statuses = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    statuses[_key - 1] = arguments[_key];
  }

  return rides.filter(function (ride) {
    return statuses.includes(ride.ride_status);
  });
}

function filterRidesByPlacedStatus(rides) {
  return rides.filter(function (ride) {
    return ride.finish_position;
  });
}

function filterRidesByAlsoRan(rides) {
  return rides.filter(function (ride) {
    return !ride.finish_position && !ride.casualty.status;
  });
}

function filterRidesByCasualty(rides) {
  return rides.filter(function (ride) {
    return !ride.finish_position && ride.casualty.status;
  });
}

function sortByFinishPosition(a, b) {
  if ((a.amended_position || a.finish_position) < (b.amended_position || b.finish_position)) {
    return -1;
  }

  if ((a.amended_position || a.finish_position) > (b.amended_position || b.finish_position)) {
    return 1;
  }

  if ((a.amended_position || a.finish_position) === (b.amended_position || b.finish_position)) {
    if (a.finish_distance === "dh" && b.finish_distance !== "dh") {
      return 1;
    }

    if (b.finish_distance === "dh" && a.finish_distance !== "dh") {
      return -1;
    }
  }

  return 0;
}

function sortDetails(_ref) {
  var cloth_number = _ref.cloth_number,
      _ref$horse = _ref.horse;
  _ref$horse = _ref$horse === undefined ? {} : _ref$horse;
  var name = _ref$horse.name,
      _ref$ride_reference = _ref.ride_reference;
  _ref$ride_reference = _ref$ride_reference === undefined ? {} : _ref$ride_reference;
  var id = _ref$ride_reference.id;

  return {
    cloth_number: cloth_number,
    name: name,
    id: id
  };
}

// this needs to be super safe, because horse early entries can be a pain
function sortByClothNo() {
  for (var _len2 = arguments.length, rides = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    rides[_key2] = arguments[_key2];
  }

  var _rides$map = rides.map(sortDetails),
      _rides$map2 = (0, _slicedToArray3.default)(_rides$map, 2),
      a = _rides$map2[0],
      b = _rides$map2[1];

  if (a.cloth_number && b.cloth_number) {
    return a.cloth_number - b.cloth_number;
  } else if (a.name && b.name) {
    return (0, _utils.simpleStringCompare)(a.name, b.name);
  } else if (a.id && b.id) {
    return a.id - b.id;
  }

  return 0;
}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.insiderLoginInitiated = insiderLoginInitiated;
exports.showNotification = showNotification;
exports.hideNotification = hideNotification;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INSIDER_LOGIN_INIT = 'insider/INSIDER_LOGIN_INIT';
var INSIDER_HIDE_NOTIFICATION = 'insider/INSIDER_HIDE_NOTIFICATION';
var INSIDER_SHOW_NOTIFICATION = 'insider/INSIDER_SHOW_NOTIFICATION';

var initialState = {
  insiderLoginInitiated: false,
  insiderLoginComplete: false,
  showNotification: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case INSIDER_LOGIN_INIT:
      return (0, _extends3.default)({}, state, {
        loginInitiated: true
      });
    case INSIDER_SHOW_NOTIFICATION:
      return (0, _extends3.default)({}, state, {
        showNotification: true
      });
    case INSIDER_HIDE_NOTIFICATION:
      return (0, _extends3.default)({}, state, {
        showNotification: false
      });
    default:
      return state;
  }
}

function insiderLoginInitiated() {
  return {
    type: INSIDER_LOGIN_INIT
  };
}

function showNotification() {
  return {
    type: INSIDER_SHOW_NOTIFICATION
  };
}

function hideNotification() {
  return {
    type: INSIDER_HIDE_NOTIFICATION
  };
}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PureArticle = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(17);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _seoUtils = __webpack_require__(23);

var _utils = __webpack_require__(18);

var _ArticleUtils = __webpack_require__(174);

var _utils2 = __webpack_require__(271);

var _widgets = __webpack_require__(60);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _GptAdvert = __webpack_require__(101);

var _GptAdvert2 = _interopRequireDefault(_GptAdvert);

var _ArticleSocialMediaButtons = __webpack_require__(1002);

var _ArticleSocialMediaButtons2 = _interopRequireDefault(_ArticleSocialMediaButtons);

var _EnhancedLoginPrompt = __webpack_require__(357);

var _EnhancedLoginPrompt2 = _interopRequireDefault(_EnhancedLoginPrompt);

var _commonUtils = __webpack_require__(36);

var _reactRouter = __webpack_require__(11);

var _ArticleSubheading = __webpack_require__(1003);

var _ArticleSubheading2 = _interopRequireDefault(_ArticleSubheading);

var _ArticleAuthor = __webpack_require__(999);

var _ArticleAuthor2 = _interopRequireDefault(_ArticleAuthor);

var _GptProperties = __webpack_require__(51);

var _lodash = __webpack_require__(20);

var _ArticleHelmetProps = __webpack_require__(1000);

var _ArticleHelmetProps2 = _interopRequireDefault(_ArticleHelmetProps);

var _getWidget2 = __webpack_require__(1014);

var _getWidget3 = _interopRequireDefault(_getWidget2);

var _ArticleHeroImage = __webpack_require__(1001);

var _ArticleHeroImage2 = _interopRequireDefault(_ArticleHeroImage);

var _withErrorBoundry = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(514);

var PureArticle = exports.PureArticle = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PureArticle, _Component);

  function PureArticle() {
    (0, _classCallCheck3.default)(this, PureArticle);
    return (0, _possibleConstructorReturn3.default)(this, (PureArticle.__proto__ || (0, _getPrototypeOf2.default)(PureArticle)).apply(this, arguments));
  }

  (0, _createClass3.default)(PureArticle, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var isUserLeavingArticle = nextProps.actualArticleId === undefined;
      return !isUserLeavingArticle;
    }
  }, {
    key: 'articleSuccess',
    value: function articleSuccess(article, widgets) {
      var _this2 = this;

      var _props = this.props,
          embedded = _props.embedded,
          routes = _props.routes,
          loggedIn = _props.loggedIn;

      var primaryImageId = (0, _widgets.getPrimaryMediaWidgetId)(widgets);
      var topImageSet = this.props.media[primaryImageId] || [];

      var articleBodyWidgets = (0, _widgets.getBodyWidgets)(widgets);

      var shareProps = {};

      var firstTextArea = articleBodyWidgets.find(function (bodyWidget) {
        return bodyWidget.widget_type === "TextArea";
      });
      var textContent = (0, _widgets.getWidgetValue)(firstTextArea, "html");
      shareProps.firstParagraph = textContent.trim();

      var canonical = undefined;

      if (!embedded) {
        if (routes && routes.length) {
          var routeArray = [].concat((0, _toConsumableArray3.default)(routes)).filter(function (r) {
            return !!r.path;
          });

          if (routeArray.length === 2) {
            // the generic "news" route
            routeArray = [routeArray[0], null, routeArray[1]]; // make a space
          }

          routeArray[1] = { path: (0, _ArticleUtils.categoryUrlRoot)(article.category) };
          canonical = (0, _seoUtils.canonicalLink)(routeArray, { articleId: this.props.actualArticleId, title: (0, _utils.toSlug)(article.title) });
          shareProps.page = canonical.link[0].href;
          shareProps.title = article.title;
        }
      }

      var editorVersion = (0, _utils2.getMetaDataWidgetValue)(article.widgets, "editorVersion") || "legacy";
      var contentClassName = 'news-article-body-' + editorVersion;

      var bodyVisible = !article.login_required || loggedIn;

      var section = (0, _commonUtils.getSection)(routes);
      var view = (0, _ArticleUtils.categoryAdvertView)(article.category);

      return _react2.default.createElement(
        'div',
        { className: 'news-article' },
        _react2.default.createElement(_ArticleHelmetProps2.default, {
          embedded: embedded,
          article: article,
          canonical: canonical,
          topImageSet: topImageSet
        }),
        _react2.default.createElement(
          'div',
          { className: 'news-article-heading' },
          !embedded && article.long_headline && _react2.default.createElement(
            'h1',
            { className: 'article-title' },
            article.long_headline
          ),
          !embedded && _react2.default.createElement(_ArticleSubheading2.default, { article: article })
        ),
        _react2.default.createElement(_ArticleHeroImage2.default, {
          articleId: this.props.actualArticleId,
          widgets: widgets
        }),
        _react2.default.createElement(
          'div',
          { className: contentClassName },
          topImageSet.caption && topImageSet.caption.trim() && _react2.default.createElement(
            'div',
            { className: 'photo-caption' },
            topImageSet.caption
          ),
          !article.sensitive && _react2.default.createElement(_AdvertWrapper2.default, {
            ocSlot: [view, "leaderboard"],
            additionalProperties: { view: view }
          }),
          _react2.default.createElement(_ArticleAuthor2.default, { article: article }),
          article.article_abstract && _react2.default.createElement(
            'p',
            { className: 'article-intro' },
            article.article_abstract
          ),
          _react2.default.createElement(
            'div',
            { className: !bodyVisible && "news-article-login-required" || undefined },
            articleBodyWidgets.map(function (widget, i) {
              var _getWidget = (0, _getWidget3.default)({
                widget: widget,
                view: view,
                bodyVisible: bodyVisible,
                article: article,
                media: _this2.props.media
              }),
                  Widget = _getWidget.Widget,
                  widgetProps = _getWidget.widgetProps;

              return _react2.default.createElement(Widget, (0, _extends3.default)({
                key: i
              }, widgetProps));
            }),
            !bodyVisible && _react2.default.createElement(
              'div',
              { className: 'news-article-login-prompt' },
              _react2.default.createElement(
                'h2',
                null,
                _EnhancedLoginPrompt.EnhancedLoginPromptHeading
              ),
              _react2.default.createElement(_EnhancedLoginPrompt2.default, { size: 'standard' })
            )
          ),
          !article.sensitive && _react2.default.createElement(_ArticleSocialMediaButtons2.default, shareProps),
          !article.sensitive && _react2.default.createElement(_GptAdvert2.default, {
            ocDetails: {
              hash: _config2.default.oddschecker.slotID.homepage.leaderboard
            },
            performDetails: (0, _extends3.default)({}, _GptProperties.singleBottomMPUProps, section)
          })
        )
      );
    }
  }, {
    key: 'articleFailed',
    value: function articleFailed() {
      var errorPixelSrc = '/1x1.gif?type=article&id=' + this.props.actualArticleId + '&cb=' + Date.now();
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'default-no-article' },
          'This article could not be displayed.'
        ),
        _react2.default.createElement('img', { src: errorPixelSrc, width: '1', height: '1' })
      );
    }
  }, {
    key: 'articleFailedEmbed',
    value: function articleFailedEmbed(label) {
      return _react2.default.createElement(
        'div',
        { className: 'default-no-article' },
        'There is currently no ',
        label.toLowerCase(),
        '.'
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var article = this.props.article;

      if (!article) {
        var label = this.props.embeddedLabel;
        return label ? this.articleFailedEmbed(label) : this.articleFailed();
      }

      var widgets = article.widgets || [];

      return this.articleSuccess(article, widgets);
    }
  }]);
  return PureArticle;
}(_react.Component), _class.propTypes = {
  loggedIn: _propTypes2.default.bool,
  races: _propTypes2.default.array,
  routes: _propTypes2.default.array,
  media: _propTypes2.default.object.isRequired,
  articleId: _propTypes2.default.number,
  articleIdRef: _propTypes2.default.string,
  embedded: _propTypes2.default.bool,
  embeddedLabel: _propTypes2.default.string,
  params: _propTypes2.default.shape({
    matchId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    articleId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
  }),
  article: _propTypes2.default.object,
  actualArticleId: _propTypes2.default.string
}, _temp);


var mapStateToProps = function mapStateToProps(state, ownProps) {
  var loggedIn = (0, _lodash.get)(state, 'common.auth.loggedIn', false);
  var _state$common = state.common,
      articles = _state$common.article,
      media = _state$common.media;

  var actualArticleId = (0, _ArticleUtils.getArticleId)(ownProps);

  var article = (0, _lodash.get)(articles, actualArticleId + '.article', undefined);

  return {
    article: article,
    actualArticleId: actualArticleId,
    media: media,
    loggedIn: loggedIn
  };
};

exports.default = (0, _withErrorBoundry.withErrorBoundary)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(mapStateToProps)(PureArticle)));

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.categoryName = categoryName;
exports.categoryPath = categoryPath;
exports.categoryUrlRoot = categoryUrlRoot;
exports.categoryAdvertView = categoryAdvertView;
exports.getStoryType = getStoryType;
exports.getArticleId = getArticleId;

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CATEGORY_NAME_MAP = {
  HORSE_RACING: 'Racing',
  GREYHOUND_RACING: 'Greyhounds',
  RUGBY_LEAGUE: 'Rugby League',
  RUGBY_UNION: 'Rugby Union',
  FORMULA_1: 'Formula 1',
  OTHER_SPORTS: 'Other Sports',
  _NFL: 'NFL'
};

var CATEGORY_PATH_MAP = {
  HORSE_RACING: "racing",
  GREYHOUND_RACING: "greyhounds",
  FORMULA_1: "formula1",
  _NFL: "nfl"
};

var underscores = /_/g;
var dash = "-";

function categoryName(categoryId) {
  return CATEGORY_NAME_MAP[categoryId] || _lodash2.default.capitalize(categoryId);
}

function categoryPath() {
  var categoryId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

  return CATEGORY_PATH_MAP[categoryId] || categoryId.toLowerCase().replace(underscores, dash);
}

function categoryUrlRoot(categoryId) {
  return categoryPath(categoryId);
}

function categoryAdvertView(categoryId) {
  return categoryPath(categoryId);
}

function getStoryType(routes) {
  return _lodash2.default.get(_lodash2.default.findLast(routes, function (route) {
    return route.storyType;
  }), 'storyType');
}

/*
  An Article can receive its article id in several ways.
  1. By being given its ID directly.
  2. Can be retrieved from the path params.
  3. An article reference which can then be looked up to find the ID.
*/
function getArticleId(props) {
  var _props$embedded = props.embedded,
      embedded = _props$embedded === undefined ? false : _props$embedded;


  if (embedded) {
    var articleIdRef = props.articleIdRef,
        _props$articles = props.articles;
    _props$articles = _props$articles === undefined ? {} : _props$articles;
    var _props$articles$artic = _props$articles.articleIdRefs;
    _props$articles$artic = _props$articles$artic === undefined ? {} : _props$articles$artic;
    var _props$articles$artic2 = _props$articles$artic[articleIdRef];
    _props$articles$artic2 = _props$articles$artic2 === undefined ? {} : _props$articles$artic2;
    var _props$articles$artic3 = _props$articles$artic2.articleIds,
        articleIds = _props$articles$artic3 === undefined ? [] : _props$articles$artic3;


    return articleIds[0];
  } else {
    var id = props.articleId || props.params.articleId;
    return id;
  }
}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.formatCurrency = formatCurrency;
exports.convertCurrencyString = convertCurrencyString;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatAmount(n) {
  return n ? parseFloat(n).toFixed(2).replace(/./g, function (c, i, a) {
    return i && c !== "." && (a.length - i) % 3 === 0 ? ',' + c : c;
  }) : '0.00';
}

function defaultCurrencyCode(code) {
  return code ? {
    symbol: code,
    left: false
  } : {
    symbol: '£',
    left: true
  };
}

var currencyCodeLibrary = {
  GBP: {
    symbol: '£',
    left: true
  },
  USD: {
    symbol: '$',
    left: true
  },
  EUR: {
    symbol: '€',
    left: true
  },
  ZAR: {
    symbol: 'R',
    left: true
  }
};

function formatCurrency(amount, currencyCode) {
  var formattedAmount = formatAmount(amount);
  var currencyObject = currencyCodeLibrary[currencyCode] || defaultCurrencyCode(currencyCode);

  return currencyObject.left ? currencyObject.symbol + formattedAmount : formattedAmount + ' ' + currencyObject.symbol;
}

function convertCurrencyString(currencyString) {
  if (!currencyString) {
    return null;
  }
  var values = currencyString.split(",");

  values = values.map(function (value) {
    var _value$split = value.split(" "),
        _value$split2 = (0, _slicedToArray3.default)(_value$split, 2),
        amount = _value$split2[0],
        currencyCode = _value$split2[1];

    return formatCurrency(amount, currencyCode);
  });

  return values.join(", ");
}

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastIndexWithDeviceOrder = exports.sortByDeviceDisplayOrder = exports.genericSportLayout = exports.genericLayoutFactory = exports.articleSensitivityLayout = undefined;

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _reactDeviceDetect = __webpack_require__(109);

var _GptProperties = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var componentLayoutDefinition = function componentLayoutDefinition(name) {
  var dOrd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var hOrd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var dCol = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'right';
  var props = arguments[4];
  return {
    component: name,
    desktopOrder: dOrd,
    handheldOrder: hOrd,
    desktopColumn: dCol,
    props: props
  };
};

var articleSensitivityLayout = exports.articleSensitivityLayout = function articleSensitivityLayout(layout, notSensitive, sensitive) {
  switch (layout) {
    default:
    case 'nonSensitive':
      return notSensitive;
    case 'sensitive':
      return sensitive;
  }
};

var plainTitleProps = {
  plainTitle: true
};

var genericLayoutFactory = exports.genericLayoutFactory = function genericLayoutFactory(sportName) {
  var advertView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : sportName;

  var advertProps = {
    ocSlot: [sportName || "homepage", "mpu"],
    additionalProperties: {
      view: advertView
    }
  };

  var leaderboardAd = {
    view: advertView
  };

  var rosTopMpu = componentLayoutDefinition('GooglePublisherTag', 2, false, 'right', _GptProperties.topMPUProps);
  var advertOffers = componentLayoutDefinition('AdvertWrapper', 8, false, 'right', advertProps);
  var rosBottomMpu = componentLayoutDefinition('GooglePublisherTag', 9, false, 'right', _GptProperties.rosBottomMpuProps);

  var RHSComponents = [componentLayoutDefinition("MostReadAll", 1, 3, "right"), componentLayoutDefinition('RacingTips', 4, false, 'right', plainTitleProps), componentLayoutDefinition('HorseRacingNextRaceOff', 5, false, 'right', plainTitleProps), componentLayoutDefinition('FootballTips', 7, false, 'right', plainTitleProps)];

  return {
    withAdverts: function withAdverts() {
      for (var _len = arguments.length, components = Array(_len), _key = 0; _key < _len; _key++) {
        components[_key] = arguments[_key];
      }

      return {
        bannerAd: _GptProperties.bannerAd,
        leaderboardAd: leaderboardAd,
        components: [rosTopMpu].concat(components, RHSComponents, [advertOffers, rosBottomMpu])
      };
    },
    withArticleAdverts: function withArticleAdverts() {
      for (var _len2 = arguments.length, components = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        components[_key2] = arguments[_key2];
      }

      return {
        leaderboardAd: leaderboardAd,
        components: [rosTopMpu].concat(components, RHSComponents, [advertOffers, rosBottomMpu])
      };
    },
    withoutAdverts: function withoutAdverts() {
      for (var _len3 = arguments.length, components = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        components[_key3] = arguments[_key3];
      }

      return {
        components: [].concat(components, RHSComponents)
      };
    }
  };
};

var genericSportLayout = exports.genericSportLayout = function genericSportLayout(sportName) {
  var _ref;

  var advertView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : sportName;

  var factory = genericLayoutFactory(sportName, advertView);

  var gptAdvertProps = {
    ocDetails: {
      ocSlot: [sportName || "homepage", "leaderboard"]
    },
    performDetails: _GptProperties.singleBottomMPUProps
  };

  var HomePageLayout = factory.withAdverts(componentLayoutDefinition('MoreNews', 1, 1, 'left'), componentLayoutDefinition('GptAdvert', 2, 2, 'left', gptAdvertProps));

  var ArticleLayout = factory.withArticleAdverts(componentLayoutDefinition('Article', 1, 1, 'left'));

  var ArticleSensitiveLayout = factory.withoutAdverts(componentLayoutDefinition('Article', 1, 1, 'left'));

  return _ref = {}, (0, _defineProperty3.default)(_ref, '/' + sportName, HomePageLayout), (0, _defineProperty3.default)(_ref, '/' + sportName + '/news/:title/:articleId', function undefined(layout) {
    return articleSensitivityLayout(layout, ArticleLayout, ArticleSensitiveLayout);
  }), _ref;
};

var sortByDeviceDisplayOrder = exports.sortByDeviceDisplayOrder = function sortByDeviceDisplayOrder(a, b) {
  if (_reactDeviceDetect.isMobile) {
    return a.handheldOrder > b.handheldOrder;
  }

  return a.desktopOrder > b.desktopOrder;
};

var getLastIndexWithDeviceOrder = exports.getLastIndexWithDeviceOrder = function getLastIndexWithDeviceOrder(col, side) {
  var selectHighestIndexForDevice = function selectHighestIndexForDevice(device, side) {
    return function (highestIdx, component, idx) {
      var isDisplayedInCol = !component[device + 'Column'] || component[device + 'Column'] == side;
      if (component[device + 'Order'] !== false && isDisplayedInCol) {
        return idx;
      }
      return highestIdx;
    };
  };

  var lastInstanceIndexes = {};
  lastInstanceIndexes.desktop = col.reduce(selectHighestIndexForDevice("desktop", side), 0);
  lastInstanceIndexes.handheld = col.reduce(selectHighestIndexForDevice("handheld", side), 0);

  return lastInstanceIndexes;
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(73);
var TAG = __webpack_require__(33)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(73);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 179 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1276), __esModule: true };

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1277), __esModule: true };

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(96);
var call = __webpack_require__(489);
var isArrayIter = __webpack_require__(487);
var anObject = __webpack_require__(87);
var toLength = __webpack_require__(237);
var getIterFn = __webpack_require__(326);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 185 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(77).f;
var has = __webpack_require__(134);
var TAG = __webpack_require__(50)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1337)
var ieee754 = __webpack_require__(1470)
var isArray = __webpack_require__(518)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(188).Buffer))

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(1492);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = nextTick;
} else {
  module.exports = process.nextTick;
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["func"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]]);
var components = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1604)();
}


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var envConfig = void 0;
if (typeof window === 'undefined') {
  // If running on Node
  envConfig = __webpack_require__.i({"NODE_ENV":"production"});
} else {
  // Otherwise were on a browser.
  envConfig = window.__envConfig;
}

module.exports = {
  // feature switches
  FEATURE_INTEGRATED_BETSLIP: envConfig.FEATURE_INTEGRATED_BETSLIP,
  FEATURE_PUSH_FAST_RESULTS: envConfig.FEATURE_PUSH_FAST_RESULTS,
  FEATURE_ODDSCHECKER_INTEGRATION: envConfig.FEATURE_ODDSCHECKER_INTEGRATION,
  FEATURE_ODDSCHECKER_INTEGRATION_STAGE2: envConfig.FEATURE_ODDSCHECKER_INTEGRATION_STAGE2,
  FEATURE_ODDSCHECKER_BETSLIP: envConfig.FEATURE_ODDSCHECKER_BETSLIP,

  // config
  PROTECTABLE_FEATURES: envConfig.PROTECTABLE_FEATURES,
  APPLICATION_COLOUR: envConfig.APPLICATION_COLOUR,
  CACHE_HOST: envConfig.CACHE_HOST,
  API_GET_CACHE_BUSTER: envConfig.API_GET_CACHE_BUSTER,
  ITUNES_APP_ID: envConfig.ITUNES_APP_ID,
  FASTRESULTS_APP_ID: envConfig.FASTRESULTS_APP_ID,
  NODE_ENV: envConfig.NODE_ENV,
  SERVICE_APP_HOSTNAME: envConfig.SERVICE_APP_HOSTNAME,
  SERVICE_APP_PORT: envConfig.SERVICE_APP_PORT,
  SERVICE_APP_PROTOCOL: envConfig.SERVICE_APP_PROTOCOL,
  COOKIE_DOMAIN: envConfig.COOKIE_DOMAIN,
  IMAGES_URL: envConfig.IMAGES_URL,
  ROBOTS_TXT: envConfig.ROBOTS_TXT,
  GOOGLE_ANALYTICS_PROPERTY_ID: envConfig.GOOGLE_ANALYTICS_PROPERTY_ID,
  GOOGLE_ANALYTICS_SAMPLING_RATE: envConfig.GOOGLE_ANALYTICS_SAMPLING_RATE,
  GOOGLE_RECAPTCHA_SITE_KEY: envConfig.GOOGLE_RECAPTCHA_SITE_KEY,
  OMNITURE_SERVER: envConfig.OMNITURE_SERVER,
  OMNITURE_SUITE: envConfig.OMNITURE_SUITE,
  SITE_CANONICAL_BASE: envConfig.SITE_CANONICAL_BASE,
  SITEMAP_DAYS_BEHIND: envConfig.SITEMAP_DAYS_BEHIND,
  SITEMAP_DAYS_AHEAD: envConfig.SITEMAP_DAYS_AHEAD,
  SITEMAP_BASKET_ARTICLE_LIMIT: envConfig.SITEMAP_BASKET_ARTICLE_LIMIT,
  GOOGLE_CONSOLE_TAG: envConfig.GOOGLE_CONSOLE_TAG,
  SBG_ACC_ENABLED: envConfig.SBG_ACC_ENABLED,
  SBG_SSO_HOST: envConfig.SBG_SSO_HOST,
  ODDSCHECKER_ENABLED: envConfig.ODDSCHECKER_ENABLED,
  ODDSCHECKER_API_KEY: envConfig.ODDSCHECKER_API_KEY,
  GPT_ENABLED: envConfig.GPT_ENABLED,
  AMAZON_TAM_ENABLED: envConfig.AMAZON_TAM_ENABLED,
  STAGING: envConfig.STAGING,
  API_CROSS_ORIGIN_DISABLED: envConfig.API_CROSS_ORIGIN_DISABLED,
  SERVICE_WORKER_ENABLED: envConfig.SERVICE_WORKER_ENABLED,
  SERVICE_APP_TIMEOUT: envConfig.SERVICE_APP_TIMEOUT,
  SERVICE_SITE_TIMEOUT: envConfig.SERVICE_SITE_TIMEOUT,
  SERVICE_SITE_MAX_CONN: envConfig.SERVICE_SITE_MAX_CONN, // Max agent connection count
  SERVICE_SITE_RESTART_CONN_COUNT: envConfig.SERVICE_SITE_RESTART_CONN_COUNT, // Become unhealthy connection count
  ATR_VIDEO_TIMESTAMP: envConfig.ATR_VIDEO_TIMESTAMP,
  FEATURE_BUCKET_COOKIE_KEY: envConfig.FEATURE_BUCKET_COOKIE_KEY,
  FEATURE_BUCKET_COOKIE_AGE: envConfig.FEATURE_BUCKET_COOKIE_AGE,
  FEATURE_CANARY_CONFIG_URL: envConfig.FEATURE_CANARY_CONFIG_URL,
  FEATURE_CANARY_CONFIG_EXPIRY: envConfig.FEATURE_CANARY_CONFIG_EXPIRY,
  HR_FR_TOPIC: envConfig.HR_FR_TOPIC,
  FEATURE_INSIDER_BENEFITS: envConfig.FEATURE_INSIDER_BENEFITS,
  FOOTBALL_WORLD_CUP_URL: envConfig.FOOTBALL_WORLD_CUP_URL,
  STATIC_ASSET_CACHE_TTL: envConfig.STATIC_ASSET_CACHE_TTL,
  OOYALA_PCODE: envConfig.OOYALA_PCODE,
  OOYALA_BRANDING_ID: envConfig.OOYALA_BRANDING_ID,
  NAV_EVENT_TITLE: envConfig.NAV_EVENT_TITLE,
  NAV_EVENT_URL: envConfig.NAV_EVENT_URL,
  NAV_EVENT_MAIN_INDEX: envConfig.NAV_EVENT_MAIN_INDEX,
  NAV_EVENT_SUB_INDEX: envConfig.NAV_EVENT_SUB_INDEX
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logger = void 0;

if (typeof window === 'undefined') {

  // Must be dynamically required as import will throw an error in browser
  // winston is not included in browser bundle with webpack
  var winston = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"winston\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));

  var transport = _config2.default.isProduction ? new winston.transports.Console({ json: true, level: 'info', stringify: true }) : new winston.transports.Console({ json: true, level: 'debug' });

  logger = new winston.Logger({
    level: 'info',
    transports: [transport]
  });
} else {

  // No implementation needed for these as it will be browser only.
  logger = {
    error: function error() {},
    warn: function warn() {},
    info: function info() {},
    debug: function debug() {},
    trace: function trace() {}
  };
}

exports.default = logger;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WINDOW_LOAD = exports.WINDOW_LOAD = "WINDOW_LOAD";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Ordinal;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _OrdinalSuffix = __webpack_require__(218);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ordinal(_ref) {
  var n = _ref.n,
      _ref$superscriptSuffi = _ref.superscriptSuffix,
      superscriptSuffix = _ref$superscriptSuffi === undefined ? true : _ref$superscriptSuffi;

  __webpack_require__(1383);
  var suf = (0, _OrdinalSuffix.suffix)(n);
  var renderedSuf = suf && superscriptSuffix ? _react2.default.createElement(
    'sup',
    null,
    suf
  ) : suf;

  return _react2.default.createElement(
    'span',
    { className: 'ordinal' },
    n,
    renderedSuf
  );
}

Ordinal.propTypes = {
  n: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  superscriptSuffix: _propTypes2.default.bool
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _JSONLDSportsEvent = __webpack_require__(738);

var _JsonLD = __webpack_require__(164);

var _JsonLD2 = _interopRequireDefault(_JsonLD);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RaceJSONLD = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RaceJSONLD, _Component);

  function RaceJSONLD() {
    (0, _classCallCheck3.default)(this, RaceJSONLD);
    return (0, _possibleConstructorReturn3.default)(this, (RaceJSONLD.__proto__ || (0, _getPrototypeOf2.default)(RaceJSONLD)).apply(this, arguments));
  }

  (0, _createClass3.default)(RaceJSONLD, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$meeting = _props.meeting;
      _props$meeting = _props$meeting === undefined ? {} : _props$meeting;
      var _props$meeting$meetin = _props$meeting.meeting_summary;
      _props$meeting$meetin = _props$meeting$meetin === undefined ? {} : _props$meeting$meetin;
      var _props$meeting$meetin2 = _props$meeting$meetin.course;
      _props$meeting$meetin2 = _props$meeting$meetin2 === undefined ? {} : _props$meeting$meetin2;
      var _props$meeting$meetin3 = _props$meeting$meetin2.name,
          courseName = _props$meeting$meetin3 === undefined ? '' : _props$meeting$meetin3,
          _props$meeting$races = _props$meeting.races,
          races = _props$meeting$races === undefined ? [] : _props$meeting$races,
          sport = _props.sport,
          _props$type = _props.type,
          type = _props$type === undefined ? 'racecard' : _props$type,
          _props$raceId = _props.raceId,
          singleRaceId = _props$raceId === undefined ? '' : _props$raceId;


      var racesToShow = races.filter(function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$race_summary_ref = _ref.race_summary_reference;

        _ref$race_summary_ref = _ref$race_summary_ref === undefined ? {} : _ref$race_summary_ref;
        var _ref$race_summary_ref2 = _ref$race_summary_ref.id,
            raceId = _ref$race_summary_ref2 === undefined ? '' : _ref$race_summary_ref2;


        return singleRaceId === raceId || singleRaceId === '';
      });

      var sportsEvents = (0, _JSONLDSportsEvent.createSportsEvents)(racesToShow, courseName, sport, type);

      return sport && _react2.default.createElement(_JsonLD2.default, { data: sportsEvents });
    }
  }]);
  return RaceJSONLD;
}(_react.Component), _class.propTypes = {
  meeting: _propTypes2.default.object,
  sport: _propTypes2.default.string,
  type: _propTypes2.default.string,
  raceId: _propTypes2.default.number
}, _temp);
exports.default = RaceJSONLD;

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SectionLink = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SectionLink, _Component);

  function SectionLink() {
    (0, _classCallCheck3.default)(this, SectionLink);
    return (0, _possibleConstructorReturn3.default)(this, (SectionLink.__proto__ || (0, _getPrototypeOf2.default)(SectionLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(SectionLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$className = _props.className,
          className = _props$className === undefined ? "section-link" : _props$className,
          to = _props.to;


      return _react2.default.createElement(
        'h2',
        { className: className },
        to ? _react2.default.createElement(
          _reactRouter.Link,
          { to: to, className: className + '-row' },
          _react2.default.createElement(
            'span',
            { className: className + '-row-text' },
            this.props.children
          ),
          _react2.default.createElement(
            'span',
            { className: className + '-row-caret' },
            _react2.default.createElement(_CaretIcon2.default, { type: 'line', direction: 'right' })
          )
        ) : this.props.children
      );
    }
  }]);
  return SectionLink;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  to: _propTypes2.default.string
}, _temp);
exports.default = SectionLink;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _morenews = __webpack_require__(79);

var _MostReadPanel = __webpack_require__(251);

var _MostReadPanel2 = _interopRequireDefault(_MostReadPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MostReadRacing = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)("MostReadRacing", (0, _morenews.asyncConnectMostRead)("/racing")), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MostReadRacing, _Component);

  function MostReadRacing() {
    (0, _classCallCheck3.default)(this, MostReadRacing);
    return (0, _possibleConstructorReturn3.default)(this, (MostReadRacing.__proto__ || (0, _getPrototypeOf2.default)(MostReadRacing)).apply(this, arguments));
  }

  (0, _createClass3.default)(MostReadRacing, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_MostReadPanel2.default, { articles: this.props.mostread, title: 'Racing' });
    }
  }]);
  return MostReadRacing;
}(_react.Component), _class2.propTypes = {
  mostread: _propTypes2.default.array
}, _temp)) || _class);
exports.default = MostReadRacing;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends8 = __webpack_require__(7);

var _extends9 = _interopRequireDefault(_extends8);

exports.default = reducer;
exports.lookupRef = lookupRef;
exports.isLoadingByEventIdStoryType = isLoadingByEventIdStoryType;
exports.isLoadingByArticleId = isLoadingByArticleId;
exports.loadByArticleId = loadByArticleId;
exports.loadByEventIdStoryType = loadByEventIdStoryType;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'common/article/LOAD';
var LOAD_SUCCESS = 'common/article/LOAD_SUCCESS';
var LOAD_FAIL = 'common/article/LOAD_FAIL';

var LOAD_EVENT_STORY = 'common/article/LOAD_EVENT_STORY';
var LOAD_SUCCESS_EVENT_STORY = 'common/article/LOAD_SUCCESS_EVENT_STORY';
var LOAD_FAIL_EVENT_STORY = 'common/article/LOAD_FAIL_EVENT_STORY';

var initialState = {
  articleIdRefs: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends9.default)({}, state, (0, _defineProperty3.default)({}, action.articleId, (0, _extends9.default)({}, state[action.articleId], {
        loading: true
      })));
    case LOAD_SUCCESS:
      return (0, _extends9.default)({}, state, (0, _defineProperty3.default)({}, action.articleId, (0, _extends9.default)({}, state[action.articleId], {
        loading: false,
        loaded: true,
        error: null,
        article: action.result
      })));
    case LOAD_FAIL:
      return (0, _extends9.default)({}, state, (0, _defineProperty3.default)({}, action.articleId, (0, _extends9.default)({}, state[action.articleId], {
        loading: false,
        loaded: false,
        error: action.error
      })));

    // The cases below are for when an article is retreived by an event id and story type.
    // It is to remove duplication of data in the case that an article is both in a basket
    // and an article for a particular event.
    case LOAD_EVENT_STORY:
      {
        var ref = lookupRef(action.eventId, action.storyType);
        return (0, _extends9.default)({}, state, {
          // This keeps a dictionary of references to a list of article IDs for lookups.
          articleIdRefs: (0, _extends9.default)({}, state.articleIdRefs, (0, _defineProperty3.default)({}, ref, (0, _extends9.default)({}, state.articleIdRefs[ref], {
            loading: true
          })))
        });
      }
    case LOAD_SUCCESS_EVENT_STORY:
      {
        var _ref = lookupRef(action.eventId, action.storyType);
        var articleList = action.result.articles;
        var idFor = function idFor(article) {
          return article.article_reference.id;
        };

        // Convert the articles retreived via the event id and story type to an object keyed
        // by its article reference ID. This can then be appended to the correct object using
        // object rest spread operator.
        var articles = articleList.reduce(function (prev, currArticle) {
          var articleId = idFor(currArticle);
          prev[articleId] = (0, _extends9.default)({}, state[articleId], {
            loading: false,
            loaded: true,
            error: null,
            article: currArticle
          });
          return prev;
        }, {});

        return (0, _extends9.default)({}, state, {
          articleIdRefs: (0, _extends9.default)({}, state.articleIdRefs, (0, _defineProperty3.default)({}, _ref, (0, _extends9.default)({}, state.articleIdRefs[_ref], {
            articleIds: articleList.map(idFor),
            loading: false,
            loaded: true,
            error: null
          })))
        }, articles);
      }
    case LOAD_FAIL_EVENT_STORY:
      {
        var _ref2 = lookupRef(action.eventId, action.storyType);
        return (0, _extends9.default)({}, state, {
          articleIdRefs: (0, _extends9.default)({}, state.articleIdRefs, (0, _defineProperty3.default)({}, _ref2, (0, _extends9.default)({}, state.articleIdRefs[_ref2], {
            loading: false,
            loaded: false,
            error: action.error
          })))
        });
      }
    default:
      return state;
  }
}

function lookupRef(eventId, storyType) {
  return eventId + "-" + storyType;
}

function isLoadingByEventIdStoryType(globalState, eventId, storyType) {
  var ref = lookupRef(eventId, storyType);

  if (!globalState.common.article.articleIdRefs[ref] || !globalState.common.article.articleIdRefs[ref].loaded) {
    return false;
  }

  var articleIds = globalState.common.article.articleIdRefs[ref] && globalState.common.article.articleIdRefs[ref].articleIds;

  var articlesLoaded = true;
  for (var i = 0; i < articleIds.length; i++) {
    if (!isLoadingByArticleId(globalState, articleIds[i])) {
      articlesLoaded = false;
    }
  }
  return articlesLoaded;
}

function isLoadingByArticleId(globalState, articleId) {
  return globalState.common.article && globalState.common.article[articleId] && globalState.common.article[articleId].loading;
}

function loadByArticleId(globalState, articleId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.common.loadArticle + '/' + articleId);
    },
    articleId: articleId
  };
}

function loadByEventIdStoryType(globalState, eventId, storyType) {
  return {
    types: [LOAD_EVENT_STORY, LOAD_SUCCESS_EVENT_STORY, LOAD_FAIL_EVENT_STORY],
    promise: function promise(client) {
      return client.get(_config2.default.api.common.loadArticle + '?eventId=' + eventId + '&storyType=' + storyType);
    },
    eventId: eventId,
    storyType: storyType
  };
}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPEN = exports.DESTRUCT = exports.INIT = exports.BET_COUNT = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.setBetCount = setBetCount;
exports.openBetslip = openBetslip;
exports.initBetslip = initBetslip;
exports.destructBetslip = destructBetslip;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BET_COUNT = exports.BET_COUNT = 'common/betslip/BET_COUNT';
var INIT = exports.INIT = 'common/betslip/INIT';
var DESTRUCT = exports.DESTRUCT = 'common/betslip/DESTRUCT';
var OPEN = exports.OPEN = 'common/betslip/OPEN';

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { initialised: false, count: 0 };
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case BET_COUNT:
      return (0, _extends3.default)({}, state, {
        count: action.count
      });
    case INIT:
      return (0, _extends3.default)({}, state, {
        initialised: true
      });
    case DESTRUCT:
      return (0, _extends3.default)({}, state, {
        initialised: false
      });
    default:
      return state;
  }
}

function setBetCount(count) {
  return {
    type: BET_COUNT,
    count: count
  };
}

function openBetslip() {
  return {
    type: OPEN
  };
}

function initBetslip() {
  return {
    type: INIT
  };
}

function destructBetslip() {
  return {
    type: DESTRUCT
  };
}

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STORE_COOKIE = exports.SET_COOKIE = exports.GET_COOKIE = undefined;

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(7);

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;
exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.storeCookie = storeCookie;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_COOKIE = exports.GET_COOKIE = 'common/cookie/GET';
var SET_COOKIE = exports.SET_COOKIE = 'common/cookie/SET';
var STORE_COOKIE = exports.STORE_COOKIE = 'common/cookie/STORE';

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case STORE_COOKIE:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.cookieName, action.value));
  }

  return state;
}

function getCookie(name) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: GET_COOKIE,
    cookieName: name,
    defaultValue: defaultValue
  };
}

function setCookie(name, value, options) {
  return {
    type: SET_COOKIE,
    cookieName: name,
    value: value,
    options: options
  };
}

function storeCookie(name, value) {
  return {
    type: STORE_COOKIE,
    cookieName: name,
    value: value
  };
}

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballMatchOutcomeDescription;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CompactText = __webpack_require__(162);

var _CompactText2 = _interopRequireDefault(_CompactText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1404);

function hasWinner(outcome, winnerName, resultType) {
  return outcome === 'WIN' && winnerName && resultType;
}

function generateWinnerComponent(winnerName, winnerShortName, enableCompactText) {
  return enableCompactText ? _react2.default.createElement(
    _CompactText2.default,
    { compactText: winnerShortName },
    winnerName
  ) : winnerName;
}

function generatePenaltyShootoutWinnerComponent(winnerName, winnerShortName, homePenaltyShootoutScore, awayPenaltyShootoutScore, enableCompactText, style) {
  if (homePenaltyShootoutScore === undefined || awayPenaltyShootoutScore === undefined) {
    return null;
  }

  var scorelineText = void 0;
  if (homePenaltyShootoutScore > awayPenaltyShootoutScore) {
    scorelineText = homePenaltyShootoutScore + '-' + awayPenaltyShootoutScore;
  } else {
    scorelineText = awayPenaltyShootoutScore + '-' + homePenaltyShootoutScore;
  }

  return _react2.default.createElement(
    'div',
    { className: "outcome-description " + style },
    generateWinnerComponent(winnerName, winnerShortName, enableCompactText),
    ' win ',
    scorelineText,
    ' on penalties'
  );
}

function generateAwayGoalsWinnerComponent(winnerName, winnerShortName, enableCompactText, style) {
  return _react2.default.createElement(
    'div',
    { className: "outcome-description " + style },
    generateWinnerComponent(winnerName, winnerShortName, enableCompactText),
    ' win on away goals'
  );
}

function FootballMatchOutcomeDescription() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$matchOutcome = _ref.matchOutcome;

  _ref$matchOutcome = _ref$matchOutcome === undefined ? {} : _ref$matchOutcome;
  var outcome = _ref$matchOutcome.outcome,
      resultType = _ref$matchOutcome.result_type,
      _ref$matchOutcome$win = _ref$matchOutcome.winner;
  _ref$matchOutcome$win = _ref$matchOutcome$win === undefined ? {} : _ref$matchOutcome$win;
  var winnerName = _ref$matchOutcome$win.name,
      winnerShortName = _ref$matchOutcome$win.short_name,
      _ref$penaltyShootoutS = _ref.penaltyShootoutScore;
  _ref$penaltyShootoutS = _ref$penaltyShootoutS === undefined ? {} : _ref$penaltyShootoutS;
  var homePenaltyShootoutScore = _ref$penaltyShootoutS.home,
      awayPenaltyShootoutScore = _ref$penaltyShootoutS.away,
      _ref$enableCompactTex = _ref.enableCompactText,
      enableCompactText = _ref$enableCompactTex === undefined ? true : _ref$enableCompactTex,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? "match-results" : _ref$style;

  if (hasWinner(outcome, winnerName, resultType)) {
    switch (resultType) {
      case "PENALTYSHOOTOUT":
        return generatePenaltyShootoutWinnerComponent(winnerName, winnerShortName, homePenaltyShootoutScore, awayPenaltyShootoutScore, enableCompactText, style);
      case "AWAYGOALS":
        return generateAwayGoalsWinnerComponent(winnerName, winnerShortName, enableCompactText, style);
      default:
        return null;
    }
  }

  return null;
}

FootballMatchOutcomeDescription.propTypes = {
  matchOutcome: _propTypes2.default.shape({
    outcome: _propTypes2.default.string,
    result_type: _propTypes2.default.string,
    winner: _propTypes2.default.shape({
      name: _propTypes2.default.string,
      short_name: _propTypes2.default.string
    })
  }),
  penaltyShootoutScore: _propTypes2.default.shape({
    home: _propTypes2.default.number,
    away: _propTypes2.default.number
  }),
  enableCompactText: _propTypes2.default.bool,
  style: _propTypes2.default.string
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClasses = {
  football: function football(type, title) {
    return _react2.default.createElement(
      'svg',
      { className: 'football-match-event-svgicon football-match-event-icon-' + type, viewBox: '0 0 63 66', xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement(
        'title',
        null,
        title
      ),
      _react2.default.createElement('path', { d: 'M31.28 0C14.006 0 0 14.654 0 32.727 0 50.8 14.006 65.455 31.28 65.455c17.275 0 31.28-14.655 31.28-32.728C62.56 14.655 48.555 0 31.28 0zm6.188 62.02c-2.032.42-4.56.66-6.616.7-1.985-.03-3.922-.272-5.79-.706-.323-.086-.66-.18-1.024-.28L20.366 51.44l2.955-6.125h15.92l.085.17 2.91 6.112L38.68 61.71c-.4.114-.806.217-1.214.31zM21.29 4.608l8.637 6.183v9.15L19.25 29.39l-7.43-3.542-.626-.3-3.36-10.07c3.31-4.91 7.992-8.74 13.457-10.87zM54.675 15.43L51.3 25.576l-8.12 3.837-10.697-9.474v-9.15l8.662-6.202c5.468 2.122 10.21 5.94 13.53 10.842zM2.73 35.467l8.083-7.32 7.45 3.557.084.04 2.965 12.16-3.073 6.063-10.507-.144c-2.76-4.148-4.543-9.055-5.004-14.356zm41.59 14.5l-3.072-6.063 2.97-12.18 7.52-3.585 8.093 7.327c-.46 5.3-2.244 10.208-5.003 14.356l-10.506.144z', fillRule: 'evenodd' })
    );
  },
  card: function card(type, title) {
    return _react2.default.createElement(
      'svg',
      { className: 'football-match-event-svgicon football-match-event-icon-' + type, viewBox: '0 0 44 66', xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement(
        'title',
        null,
        title
      ),
      _react2.default.createElement('rect', { x: '1578', y: '460', width: '43.01', height: '65.455', rx: '2', transform: 'translate(-1578 -460)', fillRule: 'evenodd' })
    );
  },
  text: function text(type, title, _text) {
    return _react2.default.createElement(
      'span',
      { className: 'football-match-event-texticon football-match-event-icon-' + type, title: title },
      _text
    );
  },
  subOff: function subOff(type, title) {
    return _react2.default.createElement(
      'svg',
      { className: 'football-match-event-svgicon football-match-event-icon-' + type, viewBox: '0 0 49 66', xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement(
        'title',
        null,
        title
      ),
      _react2.default.createElement('path', { d: 'M47.036 45.124L28.37 63.78c-1.032 1.117-2.437 1.675-3.983 1.675-1.547 0-2.934-.558-3.983-1.674L1.667 45.125c-2.223-2.213-2.223-5.822 0-8.035 2.222-2.214 5.813-2.214 8.035 0l8.96 8.964V5.692c0-3.144 2.542-5.692 5.69-5.692 3.146 0 5.688 2.548 5.688 5.692v40.362L39 37.09c2.222-2.214 5.813-2.214 8.036 0 2.222 2.212 2.222 5.802 0 8.034z' })
    );
  },
  subOn: function subOn(type, title) {
    return _react2.default.createElement(
      'svg',
      { className: 'football-match-event-svgicon football-match-event-icon-' + type, viewBox: '0 0 49 66', xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement(
        'title',
        null,
        title
      ),
      _react2.default.createElement('path', { d: 'M20.328 1.674C21.358.558 22.762 0 24.308 0c1.547 0 2.933.558 3.982 1.674l18.732 18.65c2.222 2.213 2.222 5.82 0 8.033-2.22 2.213-5.81 2.213-8.033 0l-8.96-8.944v40.35c0 3.144-2.54 5.692-5.686 5.692s-5.687-2.548-5.687-5.69V19.412L9.7 28.376c-2.222 2.213-5.812 2.213-8.034 0-2.22-2.23-2.22-5.82 0-8.052l18.662-18.65z' })
    );
  }
};

var icons = {
  "Unknown Type": _react2.default.createElement('span', null),

  "Goal": iconClasses.football("goal", "Goal"),
  "Penalty": iconClasses.text("penalty", "Penalty Scored", "PEN"),
  "Yellow Card": iconClasses.card("yellow-card", "Yellow Card"),
  "Second Yellow Card": iconClasses.card("second-yellow-card", "2nd Yellow Card"),
  "Red Card": iconClasses.card("red-card", "Red Card"),
  "Full Time": iconClasses.text("full-time", "Full Time", "FT"),
  "Half Time": iconClasses.text("half-time", "Half Time", "HT"),

  "Sub On": iconClasses.subOn("sub-on", "Sub On"),
  "Sub Off": iconClasses.subOff("sub-off", "Sub Off")
};

function FootballMatchEventIcon(props) {
  return icons[props.type] || icons["Unknown Type"];
}

FootballMatchEventIcon.propTypes = {
  type: _propTypes2.default.string.isRequired
};

exports.default = FootballMatchEventIcon;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.areMatchesLoaded = areMatchesLoaded;
exports.resetMatchesLoaded = resetMatchesLoaded;
exports.loadMatches = loadMatches;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _LocalDateTimeHelper = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_MATCHES = 'football/dailyMatches/LOAD_MATCHES';
var LOAD_MATCHES_SUCCESS = 'football/dailyMatches/LOAD_MATCHES_SUCCESS';
var LOAD_MATCHES_FAIL = 'football/dailyMatches/LOAD_MATCHES_FAIL';
var LOAD_MATCHES_RESET = 'football/dailyMatches/LOAD_MATCHES_RESET';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_MATCHES:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_MATCHES_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          loading: false,
          loaded: true,
          matches: action.result,
          date: action.date
        });
      }
    case LOAD_MATCHES_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case LOAD_MATCHES_RESET:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false
      });
    default:
      return state;
  }
}

function areMatchesLoaded(_ref, givenDate) {
  var _ref$football$dailyMa = _ref.football.dailyMatches,
      loading = _ref$football$dailyMa.loading,
      loaded = _ref$football$dailyMa.loaded,
      date = _ref$football$dailyMa.date;

  return (loading || loaded) && (date == givenDate || date == (0, _LocalDateTimeHelper.isoDate)(new Date()));
}

function resetMatchesLoaded() {
  return {
    type: LOAD_MATCHES_RESET
  };
}

function loadMatches(date) {
  var resultsOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!date) {
    date = (0, _LocalDateTimeHelper.isoDate)(new Date());
  }

  var params = {
    match_date: date
  };

  if (resultsOnly) {
    params.results_only = true;
  }

  return {
    types: [LOAD_MATCHES, LOAD_MATCHES_SUCCESS, LOAD_MATCHES_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.football.dailyMatches, { params: params });
    },
    date: date
  };
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__(180);

var _stringify2 = _interopRequireDefault(_stringify);

exports.listTeams = listTeams;
exports.getTeam = getTeam;
exports.listPlayers = listPlayers;
exports.getPlayer = getPlayer;

var _utils = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function placeKitten(scale) {
  var unit = 2 * scale;
  return "//placekitten.com/" + 16 * unit + "/" + 9 * unit;
}

function getSlug(item) {
  return item.id + "/" + (0, _utils.slug)(item.name).toLowerCase();
}

function copy(o) {
  return JSON.parse((0, _stringify2.default)(o));
}

function listTeams() {
  return (0, _keys2.default)(teams).map(function (id) {
    return getTeam(id);
  });
}

function getTeam(id) {
  var team = {
    id: id,
    name: teams[id].name,
    players: listPlayers(teams[id].playerIds)
  };

  team.urlSlug = getSlug(team);

  return team;
}

function listPlayers() {
  var idList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _keys2.default)(players);

  return idList.map(function (id) {
    var zeros = { played: { started: 0, onAsSub: 0 }, assists: 0, goals: 0, yellowCards: 0, redCards: 0 };
    var player = getPlayer(id);

    player.stats = player.stats.reduce(function (c, p) {
      return {
        played: {
          started: p.played.started + c.played.started,
          onAsSub: p.played.onAsSub + c.played.onAsSub
        },
        assists: p.assists + c.assists,
        goals: p.goals + c.goals,
        yellowCards: p.yellowCards + c.yellowCards,
        redCards: p.redCards + c.redCards
      };
    }, zeros);

    return player;
  });
}

function getPlayer(id) {
  var player = copy(players[id]);

  player.id = id;
  player.urlSlug = getSlug(player);

  return player;
}

var teams = {
  "123": { name: "Beatles United", playerIds: ["1", "2", "3", "4"] },
  "234": { name: "Stones Affletic", playerIds: ["5", "6", "7", "8", "9"] }
};

var players = {
  "1": {
    name: "John",
    img: placeKitten(20),
    shirtNumber: 3,
    dob: "09-Oct-1940",
    pob: "Woolton",
    position: "Guitar",
    club: "Beatles United",
    stats: [{ competition: "Some League", played: { started: 1, onAsSub: 0 }, assists: 0, goals: 0, yellowCards: 0, redCards: 0 }],
    transfers: [{ from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1" }]
  },
  "2": {
    name: "Paul",
    img: placeKitten(21),
    shirtNumber: 11,
    dob: "18-Jun-1942",
    pob: "Allerton",
    position: "Bass",
    club: "Beatles United",
    stats: [{ competition: "Some League", played: { started: 1, onAsSub: 2 }, assists: 1, goals: 1, yellowCards: 0, redCards: 0 }, { competition: "Another League", played: { started: 2, onAsSub: 0 }, assists: 4, goals: 0, yellowCards: 0, redCards: 0 }],
    transfers: [{ from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1" }, { from: "Another Club", to: "Some Club", date: "26-Dec-2016", fee: "£2" }]
  },
  "3": {
    name: "George",
    img: placeKitten(22),
    shirtNumber: 26,
    dob: "25-Feb-1943",
    pob: "Wavertree",
    position: "Guitar",
    club: "Beatles United",
    stats: [{ competition: "Some League", played: { started: 1, onAsSub: 2 }, assists: 2, goals: 1, yellowCards: 0, redCards: 0 }, { competition: "A Cup", played: { started: 0, onAsSub: 1 }, assists: 3, goals: 7, yellowCards: 6, redCards: 1 }],
    transfers: [{ from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1" }]
  },
  "4": {
    name: "Ringo",
    img: placeKitten(23),
    shirtNumber: 49,
    dob: "07-Jul-1940",
    pob: "Dingle",
    position: "Drums",
    club: "Beatles United",
    stats: [{ competition: "Some League", played: { started: 3, onAsSub: 0 }, assists: 1, goals: 2, yellowCards: 1, redCards: 0 }, { competition: "A Cup", played: { started: 0, onAsSub: 1 }, assists: 0, goals: 7, yellowCards: 6, redCards: 1 }, { competition: "Another Cup", played: { started: 1, onAsSub: 0 }, assists: 8, goals: 0, yellowCards: 0, redCards: 1 }],
    transfers: [{ from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1" }]
  },

  "5": {
    name: "Mick",
    img: placeKitten(24),
    shirtNumber: 1,
    dob: "26-Jul-1943",
    pob: "Dartford",
    position: "Vocals",
    club: "Stones Affletic",
    stats: [{ competition: "Another Cup", played: { started: 1, onAsSub: 0 }, assists: 8, goals: 0, yellowCards: 0, redCards: 1 }],
    transfers: [{ from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1" }]
  },
  "6": {
    name: "Keith",
    img: placeKitten(25),
    shirtNumber: 13,
    dob: "18-Dec-1943",
    pob: "Dartford",
    position: "Guitar",
    club: "Stones Affletic",
    stats: [{ competition: "Some League", played: { started: 4, onAsSub: 0 }, assists: 2, goals: 1, yellowCards: 1, redCards: 0 }, { competition: "Another Cup", played: { started: 1, onAsSub: 1 }, assists: 2, goals: 0, yellowCards: 3, redCards: 0 }],
    transfers: [{ from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1" }]
  },
  "7": {
    name: "Charlie",
    img: placeKitten(26),
    shirtNumber: 42,
    dob: "02-Jun-1941",
    pob: "Kingsbury",
    position: "Drums",
    club: "Stones Affletic",
    stats: [{ competition: "Some League", played: { started: 1, onAsSub: 0 }, assists: 6, goals: 0, yellowCards: 0, redCards: 4 }],
    transfers: [{ from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1" }]
  },
  "8": {
    name: "Ronnie",
    img: placeKitten(27),
    shirtNumber: 6,
    dob: "01-Jun-1947",
    pob: "Hillingdon",
    position: "Guitar",
    club: "Stones Affletic",
    stats: [{ competition: "Some League", played: { started: 1, onAsSub: 2 }, assists: 3, goals: 4, yellowCards: 5, redCards: 6 }, { competition: "A Cup", played: { started: 1, onAsSub: 2 }, assists: 3, goals: 4, yellowCards: 5, redCards: 6 }],
    transfers: [{ from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1" }]
  },
  "9": {
    name: "Bill",
    img: placeKitten(28),
    shirtNumber: 13,
    dob: "24-Oct-1936",
    pob: "Lewisham",
    position: "Bass",
    club: "Stones Affletic",
    stats: [{ competition: "Some League", played: { started: 2, onAsSub: 0 }, assists: 0, goals: 0, yellowCards: 1, redCards: 2 }, { competition: "A Cup", played: { started: 1, onAsSub: 0 }, assists: 0, goals: 0, yellowCards: 2, redCards: 1 }, { competition: "Another Cup", played: { started: 4, onAsSub: 0 }, assists: 0, goals: 0, yellowCards: 3, redCards: 0 }],
    transfers: [{ from: "A Club", to: "Another Club", date: "25-Dec-2016", fee: "£1" }]
  }
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'vidiprinter/LOAD';
var LOAD_SUCCESS = 'vidiprinter/LOAD_SUCCESS';
var LOAD_FAIL = 'vidiprinter/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        items: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading(globalState) {
  return globalState.football && globalState.football.vidiprinter && globalState.football.vidiprinter.loading;
}

function load(limit) {
  var data = limit ? { params: { max_results: limit } } : {};

  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.football.vidiprinter, data);
    }
  };
}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__(7);

var _extends6 = _interopRequireDefault(_extends5);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;
exports.get = get;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _momentTimezone = __webpack_require__(241);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'greyhound-racing/meetings/LOAD';
var LOAD_SUCCESS = 'greyhound-racing/meetings/LOAD_SUCCESS';
var LOAD_FAIL = 'greyhound-racing/meetings/LOAD_FAIL';

var initialState = {
  byDate: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends6.default)({}, state, {
        byDate: (0, _extends6.default)({}, state.byDate, (0, _defineProperty3.default)({}, action.date, (0, _extends6.default)({}, state.byDate[action.date], {
          loading: true
        })))
      });
    case LOAD_SUCCESS:
      return (0, _extends6.default)({}, state, {
        byDate: (0, _extends6.default)({}, state.byDate, (0, _defineProperty3.default)({}, action.date, {
          meetings: action.result,
          loading: false,
          loaded: true
        }))
      });
    case LOAD_FAIL:
      return (0, _extends6.default)({}, state, {
        byDate: (0, _extends6.default)({}, state.byDate, (0, _defineProperty3.default)({}, action.date, (0, _extends6.default)({}, state.byDate[action.date], {
          loading: false,
          loaded: false,
          error: action.error
        })))
      });
    default:
      return state;
  }
}

function isLoading(globalState, date) {
  return globalState.greyhoundRacing.meetings && globalState.greyhoundRacing.meetings.byDate && globalState.greyhoundRacing.meetings.byDate[date] && globalState.greyhoundRacing.meetings.byDate[date].loading;
}

// TODO: Swap over to this function if greyhound API swaps to something more sensible
/* export function load(date) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.greyhoundRacing.loadMeetings}/${date}`),
    date: date
  };
} */

function load(date) {
  // We need to presume that the provided timezone is UTC. That way it won't be changed when valueOf converts to UTC.
  var startDate = _momentTimezone2.default.tz(date, "UTC").startOf('day');

  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('' + _config2.default.api.greyhoundRacing.loadMeetings, {
        params: {
          from: startDate.valueOf(),
          to: (0, _momentTimezone2.default)(startDate).add(1, 'day').valueOf()
        }
      });
    },
    date: date
  };
}

function get(state) {
  return state.greyhoundRacing.meetings.byDate;
}

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PersonProfileTable;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _utils = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1442);

function PersonProfileTable(_ref) {
  var _ref$profile = _ref.profile,
      profile = _ref$profile === undefined ? {} : _ref$profile,
      rideLabel = _ref.rideLabel,
      _ref$earlyEntries = _ref.earlyEntries,
      earlyEntries = _ref$earlyEntries === undefined ? false : _ref$earlyEntries;
  var future_entries = profile.run_future_entries,
      previous_results = profile.run_previous_results;

  var _getProfileHelpers = (0, _utils.getProfileHelpers)({ future_entries: future_entries, previous_results: previous_results }, earlyEntries),
      results = _getProfileHelpers.results,
      formatDateTime = _getProfileHelpers.formatDateTime,
      buildHref = _getProfileHelpers.buildHref;

  if (!earlyEntries) {
    results.forEach(function (r) {
      return r.formattedPosition = (0, _utils.formatPosition)(r.horse_entry);
    });
  }

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'table',
      { className: 'default-table person-profile-results-table' },
      _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            null,
            'Date ',
            earlyEntries && "/ Time"
          ),
          !earlyEntries && _react2.default.createElement(
            'th',
            null,
            'Pos'
          ),
          _react2.default.createElement(
            'th',
            null,
            rideLabel
          ),
          !earlyEntries && _react2.default.createElement(
            'th',
            { className: 'person-profile-results-table-race-type' },
            'Type'
          ),
          _react2.default.createElement(
            'th',
            null,
            'Race Details'
          ),
          _react2.default.createElement(
            'th',
            null,
            'S',
            _react2.default.createElement(
              'span',
              { className: 'full-text' },
              'tarting '
            ),
            'P',
            _react2.default.createElement(
              'span',
              { className: 'full-text' },
              'rice'
            )
          )
        )
      ),
      _react2.default.createElement(
        'tbody',
        null,
        results.map(function (_ref2) {
          var ride = _ref2.horse_summary.name,
              formattedPosition = _ref2.formattedPosition,
              horse_entry = _ref2.horse_entry,
              _ref2$horse_entry = _ref2.horse_entry,
              race_id = _ref2$horse_entry.race_id,
              odds = _ref2$horse_entry.odds,
              run_type = _ref2$horse_entry.run_type;
          return _react2.default.createElement(
            'tr',
            { key: race_id + '-' + ride },
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: buildHref(horse_entry),
                  className: 'person-profile-racing-form-racecard-link' },
                formatDateTime(horse_entry)
              )
            ),
            !earlyEntries && _react2.default.createElement(
              'td',
              null,
              formattedPosition
            ),
            _react2.default.createElement(
              'td',
              null,
              ride
            ),
            !earlyEntries && _react2.default.createElement(
              'td',
              { className: 'person-profile-results-table-race-type' },
              run_type
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _utils.formatRaceDetails)(horse_entry)
            ),
            _react2.default.createElement(
              'td',
              null,
              odds
            )
          );
        })
      )
    ),
    !results.length && _react2.default.createElement(
      'p',
      { className: 'person-profile-results-table-empty' },
      'No ',
      earlyEntries ? "entries" : "results"
    )
  );
}

PersonProfileTable.propTypes = {
  earlyEntries: _propTypes2.default.bool,
  profile: _propTypes2.default.object.isRequired,
  rideLabel: _propTypes2.default.string.isRequired
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__(7);

var _extends6 = _interopRequireDefault(_extends5);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;
exports.get = get;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/meetings/LOAD';
var LOAD_SUCCESS = 'horse-racing/meetings/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/meetings/LOAD_FAIL';

var initialState = {
  byDate: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends6.default)({}, state, {
        byDate: (0, _extends6.default)({}, state.byDate, (0, _defineProperty3.default)({}, action.date, (0, _extends6.default)({}, state.byDate[action.date], {
          loading: true
        })))
      });
    case LOAD_SUCCESS:
      return (0, _extends6.default)({}, state, {
        byDate: (0, _extends6.default)({}, state.byDate, (0, _defineProperty3.default)({}, action.date, {
          meetings: action.result,
          loading: false,
          loaded: true
        }))
      });
    case LOAD_FAIL:
      return (0, _extends6.default)({}, state, {
        byDate: (0, _extends6.default)({}, state.byDate, (0, _defineProperty3.default)({}, action.date, (0, _extends6.default)({}, state.byDate[action.date], {
          loading: false,
          loaded: false,
          error: action.error
        })))
      });
    default:
      return state;
  }
}

function isLoading(globalState, date) {
  return globalState.horseRacing.meetings && globalState.horseRacing.meetings.byDate && globalState.horseRacing.meetings.byDate[date] && globalState.horseRacing.meetings.byDate[date].loading;
}

function load(date) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.loadMeetings + '/' + date);
    },
    date: date
  };
}

function get(state) {
  return state.horseRacing.meetings.byDate;
}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorySummary = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(17);

var _utils = __webpack_require__(18);

var _ArticleUtils = __webpack_require__(174);

var _widgets = __webpack_require__(60);

var _TimeSince = __webpack_require__(752);

var _TimeSince2 = _interopRequireDefault(_TimeSince);

var _Image = __webpack_require__(163);

var _Image2 = _interopRequireDefault(_Image);

var _OutLink = __webpack_require__(252);

var _OutLink2 = _interopRequireDefault(_OutLink);

var _OoyalaVideoIndicator = __webpack_require__(1004);

var _OoyalaVideoIndicator2 = _interopRequireDefault(_OoyalaVideoIndicator);

var _lodash = __webpack_require__(20);

var _OoyalaApiClient = __webpack_require__(272);

var _OoyalaApiClient2 = _interopRequireDefault(_OoyalaApiClient);

var _withErrorBoundry = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1461);

var StorySummary = exports.StorySummary = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(StorySummary, _Component);

  function StorySummary() {
    (0, _classCallCheck3.default)(this, StorySummary);
    return (0, _possibleConstructorReturn3.default)(this, (StorySummary.__proto__ || (0, _getPrototypeOf2.default)(StorySummary)).apply(this, arguments));
  }

  (0, _createClass3.default)(StorySummary, [{
    key: 'getVideoUri',
    value: function getVideoUri(primaryWidget, articleId) {
      var defaultUri = primaryWidget.uri;
      var videoDataSizes = (0, _lodash.get)(this.props, 'media.video_' + primaryWidget.media_id + '.videoData.primary_preview_image.sizes');

      // width and height at ratio 16/9 as per css.
      // Note: defaulting to a large size, as scaling will look better
      var width = 640;
      var height = 360;

      var id = "story-summary-for-" + articleId;
      try {
        var imageContainer = document.getElementById(id);
        if (imageContainer) {
          var derivedWidth = imageContainer.offsetWidth;
          width = derivedWidth > 0 ? derivedWidth : width;
          var derivedHeight = imageContainer.offsetHeight;
          height = derivedHeight > 0 ? derivedHeight : height;
        }
      } catch (e) {
        // Server side rendering, so ignore.
      }
      if (!videoDataSizes) {
        return defaultUri;
      }

      var closest = _OoyalaApiClient2.default.getClosestMatchingPreviewImage(width, height, videoDataSizes);
      return closest.url_ssl || defaultUri;
    }
  }, {
    key: 'getImage',
    value: function getImage(primaryWidget, articleId) {
      if (primaryWidget.widget_type === "Image") {
        var imageType = this.props.imageType;
        var imageMedia = (0, _lodash.get)(this.props, 'media.' + primaryWidget.media_id);

        return _react2.default.createElement(_Image2.default, {
          imageType: imageType,
          imageMedia: imageMedia,
          className: 'story-summary-thumbnail',
          ratio: 1.9
        });
      }

      if (primaryWidget.widget_type === "Video") {
        var uri = this.getVideoUri(primaryWidget, articleId);

        return _react2.default.createElement('img', {
          src: uri,
          className: 'story-summary-thumbnail'
        });
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var articleId = (0, _lodash.get)(this.props, "data.article_reference.id", undefined);
      var articleTitle = (0, _lodash.get)(this.props, "data.title", undefined);
      var snippet = (0, _lodash.get)(this.props, "data.snippet", undefined);
      var articleTimestamp = (0, _lodash.get)(this.props, "data.last_updated", undefined);
      var articleCategory = (0, _lodash.get)(this.props, "data.category", undefined);
      var articleByline = (0, _lodash.get)(this.props, "data.author", undefined);
      var redirectUrl = (0, _lodash.get)(this.props, "data.redirect_url", undefined);
      var redirectIsExternal = (0, _lodash.get)(this.props, "data.redirect_new_tab", undefined);

      var widgetTypes = (0, _lodash.get)(this.props, "data.widgetTypes", []);
      var showCategory = (0, _lodash.get)(this.props, "metaDataFlags.category", true);
      var showByline = (0, _lodash.get)(this.props, "metaDataFlags.byline", false);
      var widgets = (0, _lodash.get)(this.props, "data.widgets", []);
      var primaryWidget = (0, _widgets.spreadWidget)((0, _widgets.getPrimaryMediaWidget)(widgets));

      var badge = this.props.badge;


      var articleLink = (redirectUrl || '').trim() || '/' + (0, _ArticleUtils.categoryUrlRoot)(articleCategory) + '/news/' + (0, _utils.toSlug)(articleTitle) + '/' + articleId;

      return _react2.default.createElement(
        'div',
        { className: 'story-summary' },
        _react2.default.createElement(
          'div',
          { className: 'story-summary-image', id: "story-summary-for-" + articleId },
          _react2.default.createElement(
            _OutLink2.default,
            {
              className: 'story-link',
              to: articleLink,
              isExternal: redirectIsExternal
            },
            _react2.default.createElement('div', { style: {
                position: 'absolute',
                left: 0,
                bottom: 0,
                width: 74,
                height: 74
              } }),
            this.getImage(primaryWidget, articleId),
            _react2.default.createElement(_OoyalaVideoIndicator2.default, {
              heroImageType: primaryWidget.widget_type,
              widgetTypes: widgetTypes
            }),
            !!badge && _react2.default.createElement(
              'span',
              { className: 'story-summary-badge' },
              badge
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'story-summary-text' },
          _react2.default.createElement(
            'h3',
            { className: 'story-headline' },
            _react2.default.createElement(
              _OutLink2.default,
              {
                className: 'article-title',
                to: articleLink,
                isExternal: redirectIsExternal
              },
              articleTitle
            )
          ),
          _react2.default.createElement(
            'p',
            { className: 'story-snippet' },
            snippet
          ),
          _react2.default.createElement(
            'div',
            { className: 'story-metadata' },
            _react2.default.createElement(_TimeSince2.default, {
              timestamp: articleTimestamp,
              title: 'Last updated'
            }),
            showCategory ? _react2.default.createElement(
              'span',
              { className: 'category' },
              (0, _ArticleUtils.categoryName)(articleCategory)
            ) : showByline && _react2.default.createElement(
              'span',
              { className: 'category' },
              articleByline
            )
          )
        )
      );
    }
  }]);
  return StorySummary;
}(_react.Component), _class.propTypes = {
  data: _propTypes2.default.shape({
    article_reference: _propTypes2.default.shape({
      id: _propTypes2.default.number
    }),
    title: _propTypes2.default.string,
    snippet: _propTypes2.default.string,
    media: _propTypes2.default.shape({
      artefacts: _propTypes2.default.array
    }),
    widgets: _propTypes2.default.array.isRequired,
    widgetTypes: _propTypes2.default.array,
    last_updated: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    category: _propTypes2.default.string
  }).isRequired,
  heroArticle: _propTypes2.default.bool,
  media: _propTypes2.default.shape({
    articleImgUrl: _propTypes2.default.string
  }),
  metaDataFlags: _propTypes2.default.shape({
    category: _propTypes2.default.bool,
    byline: _propTypes2.default.bool
  }),
  badge: _propTypes2.default.string,
  imageType: _propTypes2.default.string
}, _temp);


var mapStateToProps = function mapStateToProps(state) {
  return {
    media: state.common.media
  };
};
exports.default = (0, _withErrorBoundry.withErrorBoundary)((0, _reactRedux.connect)(mapStateToProps)(StorySummary));

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleContainer = undefined;

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _commonUtils = __webpack_require__(36);

var _article = __webpack_require__(204);

var _layout = __webpack_require__(374);

var _rides = __webpack_require__(270);

var _media = __webpack_require__(78);

var _RightColumn = __webpack_require__(21);

var _StandardPage = __webpack_require__(22);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleContainer = exports.ArticleContainer = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ArticleContainer, _Component);

  function ArticleContainer() {
    (0, _classCallCheck3.default)(this, ArticleContainer);
    return (0, _possibleConstructorReturn3.default)(this, (ArticleContainer.__proto__ || (0, _getPrototypeOf2.default)(ArticleContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(ArticleContainer, [{
    key: 'render',
    value: function render() {
      // most read articles passed in from respective routers
      var _props = this.props,
          location = _props.location,
          Article = _props.Article,
          MostReadFootball = _props.MostReadFootball,
          MostReadAll = _props.MostReadAll,
          MostReadRacing = _props.MostReadRacing,
          route = _props.route;


      var mostRead = MostReadRacing || MostReadFootball || MostReadAll;

      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: route.sport, title: 'Article' },
        _react2.default.createElement(
          'div',
          { className: 'main-layout-left-column' },
          Article,
          mostRead && _react2.default.createElement(
            'div',
            { className: 'main-layout-block main-layout-hide-desktop last-handheld' },
            mostRead
          )
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: route.sport,
          content: route.rightHandContent })
      );
    }
  }]);
  return ArticleContainer;
}(_react.Component), _class.propTypes = {
  Article: _propTypes2.default.element.isRequired,
  MostReadFootball: _propTypes2.default.element,
  MostReadAll: _propTypes2.default.element,
  MostReadRacing: _propTypes2.default.element,
  location: _propTypes2.default.object.isRequired,
  route: _propTypes2.default.shape({
    rightHandContent: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
    sport: _propTypes2.default.string.isRequired
  }).isRequired
}, _temp);


function setLayoutForArticle(dispatch, routes, result) {
  var _result$sensitive = result.sensitive,
      sensitiveArticle = _result$sensitive === undefined ? false : _result$sensitive;


  var path = (0, _commonUtils.buildPath)(routes);
  if (sensitiveArticle) {
    dispatch((0, _layout.setLayout)(path, 'sensitive'));
  } else {
    dispatch((0, _layout.setLayout)(path, 'nonSensitive'));
  }
}

exports.default = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var state = _ref.state,
        articleId = _ref.params.articleId;
    return (0, _article.loadByArticleId)(state, articleId);
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state,
        articleId = _ref2.params.articleId;
    return (0, _article.isLoadingByArticleId)(state, articleId);
  },
  then: function then(_ref3) {
    var dispatch = _ref3.dispatch,
        state = _ref3.state,
        routes = _ref3.routes,
        result = _ref3.result;

    setLayoutForArticle(dispatch, routes, result);
    return _promise2.default.all([(0, _rides.loadRidesForArticle)(state, dispatch, result), (0, _media.loadMediaForArticles)(state, dispatch, [result])]);
  },
  state: function state(_state) {
    return { layout: _state.common.layout };
  }
}])((0, _catchLifeCycleErrors2.default)(ArticleContainer));

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(146);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

exports.newsArticleExpander = newsArticleExpander;

var _logger = __webpack_require__(198);

var _logger2 = _interopRequireDefault(_logger);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _ApiClient = __webpack_require__(64);

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _lodash = __webpack_require__(20);

var _utils = __webpack_require__(18);

var _baskets = __webpack_require__(1054);

var _baskets2 = _interopRequireDefault(_baskets);

var _ArticleUtils = __webpack_require__(174);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SITEMAP_BASKET_ARTICLE_LIMIT = _config2.default.sitemap.SITEMAP_BASKET_ARTICLE_LIMIT; /**********************************************
                                                                                            EXPANDERS EXPLAINED:
                                                                                          
                                                                                            Take a route from of the sitemap generation process,
                                                                                            return a promise for thenable routes - to be flattened when the sitemap is generated
                                                                                          
                                                                                          */ /////////////////////////////////////////////

var client = new _ApiClient2.default();

function newsArticleExpander(newsPath) {
  return function (_ref) {
    var url = _ref.url,
        _ref$sitemap = _ref.sitemap,
        changefreq = _ref$sitemap.changefreq,
        priority = _ref$sitemap.priority;

    var routeArray = [];
    var promiseStack = [];

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(_baskets2.default), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var basketPath = _step.value;

        promiseStack.push(client.get(_config2.default.api.common.loadArticleSummary, { params: { basketPath: basketPath, limit: SITEMAP_BASKET_ARTICLE_LIMIT, offset: 0 } }).then(function (result) {
          return result;
        }).catch(function (err) {
          _logger2.default.debug(err);
          return [];
        }));
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return _promise2.default.all(promiseStack).then(function (results) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(results), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var res = _step2.value;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = (0, _getIterator3.default)(res.articles), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _ref3 = _step3.value;
              var id = _ref3.article_reference.id,
                  category = _ref3.category,
                  title = _ref3.title,
                  last_updated = _ref3.last_updated;

              if ((0, _ArticleUtils.categoryUrlRoot)(category) == newsPath) {
                routeArray.push({
                  url: url.replace(':title', (0, _utils.slugifyName)(title)).replace(':articleId', id),
                  sitemap: {
                    changefreq: changefreq,
                    priority: priority,
                    lastmodISO: new Date(last_updated).toISOString()
                  }
                });
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
        // uniqBy de-dups URLS inside array of objects
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return (0, _lodash.uniqBy)(routeArray, 'url');
    });
  };
}

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (i) {
  return i + suffix(i);
};

exports.suffix = suffix;


var suffixes = {
  1: 'st',
  2: 'nd',
  3: 'rd'
};

function suffix(n) {
  if (parseInt(n) == n) {
    var isTeen = Math.floor(n / 10) % 10 === 1;
    return suffixes[!isTeen && n % 10] || 'th';
  }
}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(68);
var toLength = __webpack_require__(41);
var toAbsoluteIndex = __webpack_require__(130);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var $export = __webpack_require__(9);
var redefine = __webpack_require__(57);
var redefineAll = __webpack_require__(128);
var meta = __webpack_require__(104);
var forOf = __webpack_require__(122);
var anInstance = __webpack_require__(121);
var isObject = __webpack_require__(26);
var fails = __webpack_require__(25);
var $iterDetect = __webpack_require__(225);
var setToStringTag = __webpack_require__(143);
var inheritIfRequired = __webpack_require__(285);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(56);
var redefine = __webpack_require__(57);
var fails = __webpack_require__(25);
var defined = __webpack_require__(83);
var wks = __webpack_require__(33);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(16);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(73);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(26);
var cof = __webpack_require__(73);
var MATCH = __webpack_require__(33)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(33)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(123) || !__webpack_require__(25)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(19)[K];
});


/***/ }),
/* 227 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(9);
var aFunction = __webpack_require__(49);
var ctx = __webpack_require__(74);
var forOf = __webpack_require__(122);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(9);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(16);
var aFunction = __webpack_require__(49);
var SPECIES = __webpack_require__(33)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var hide = __webpack_require__(56);
var uid = __webpack_require__(131);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(1267);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(183);
var TAG = __webpack_require__(50)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(87);
var dPs = __webpack_require__(1304);
var enumBugKeys = __webpack_require__(310);
var IE_PROTO = __webpack_require__(319)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(309)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(485).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(321);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 238 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 239 */
/***/ (function(module, exports) {



/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(1520);
moment.tz.load(__webpack_require__(1472));


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.location = exports.metrics = undefined;

var _propTypes = __webpack_require__(1);

var metrics = exports.metrics = _propTypes.object;

var location = exports.location = (0, _propTypes.shape)({
    pathname: _propTypes.string.isRequired,
    search: _propTypes.string.isRequired,
    query: _propTypes.object,
    state: _propTypes.object
});

exports.default = {
    metrics: metrics,
    location: location
};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(695);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(697);
exports.Duplex = __webpack_require__(139);
exports.Transform = __webpack_require__(696);
exports.PassThrough = __webpack_require__(1614);


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.setToImmutableStateFunc = setToImmutableStateFunc;
exports.setToMutableStateFunc = setToMutableStateFunc;
// Global vars holding the custom state conversion methods. Default is just identity methods
var identity = function identity(arg) {
  return arg;
};

// default pass-through functions
var immutableStateFunc = identity;
var mutableStateFunc = identity;

/**
 * Sets the function to be used for converting mutable state to immutable state
 * @param {Function} func Converts mutable state to immutable state [(state) => state]
 */
function setToImmutableStateFunc(func) {
  immutableStateFunc = func;
}

/**
 * Sets the function to be used for converting immutable state to mutable state
 * @param {Function} func Converts immutable state to mutable state [(state) => state]
 */
function setToMutableStateFunc(func) {
  mutableStateFunc = func;
}

/**
 * Call when needing to transform mutable data to immutable data using the preset function
 * @param {Object} state Mutable state thats converted to immutable state by user defined func
 */
var getImmutableState = exports.getImmutableState = function getImmutableState(state) {
  return immutableStateFunc(state);
};

/**
 * Call when needing to transform immutable data to mutable data using the preset function
 * @param {Immutable} state Immutable state thats converted to mutable state by user defined func
 */
var getMutableState = exports.getMutableState = function getMutableState(state) {
  return mutableStateFunc(state);
};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.immutableReducer = exports.reducer = exports.loadFail = exports.loadSuccess = exports.load = exports.endGlobalLoad = exports.beginGlobalLoad = exports.clearKey = undefined;

var _extends8 = __webpack_require__(7);

var _extends9 = _interopRequireDefault(_extends8);

var _handleActions;

var _reduxActions = __webpack_require__(1621);

var _state = __webpack_require__(246);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clearKey = exports.clearKey = (0, _reduxActions.createAction)('@redux-conn/CLEAR');
var beginGlobalLoad = exports.beginGlobalLoad = (0, _reduxActions.createAction)('@redux-conn/BEGIN_GLOBAL_LOAD');
var endGlobalLoad = exports.endGlobalLoad = (0, _reduxActions.createAction)('@redux-conn/END_GLOBAL_LOAD');
var load = exports.load = (0, _reduxActions.createAction)('@redux-conn/LOAD', function (key) {
  return { key: key };
});
var loadSuccess = exports.loadSuccess = (0, _reduxActions.createAction)('@redux-conn/LOAD_SUCCESS', function (key, data) {
  return { key: key, data: data };
});
var loadFail = exports.loadFail = (0, _reduxActions.createAction)('@redux-conn/LOAD_FAIL', function (key, error) {
  return { key: key, error: error };
});

var initialState = {
  loaded: false,
  loadState: {}
};

var reducer = exports.reducer = (0, _reduxActions.handleActions)((_handleActions = {}, _handleActions[beginGlobalLoad] = function (state) {
  return (0, _extends9.default)({}, state, {
    loaded: false
  });
}, _handleActions[endGlobalLoad] = function (state) {
  return (0, _extends9.default)({}, state, {
    loaded: true
  });
}, _handleActions[load] = function (state, _ref) {
  var _extends2;

  var payload = _ref.payload;
  return (0, _extends9.default)({}, state, {
    loadState: (0, _extends9.default)({}, state.loadState, (_extends2 = {}, _extends2[payload.key] = {
      loading: true,
      loaded: false
    }, _extends2))
  });
}, _handleActions[loadSuccess] = function (state, _ref2) {
  var _extends3, _extends4;

  var _ref2$payload = _ref2.payload,
      key = _ref2$payload.key,
      data = _ref2$payload.data;
  return (0, _extends9.default)({}, state, (_extends4 = {
    loadState: (0, _extends9.default)({}, state.loadState, (_extends3 = {}, _extends3[key] = {
      loading: false,
      loaded: true,
      error: null
    }, _extends3))
  }, _extends4[key] = data, _extends4));
}, _handleActions[loadFail] = function (state, _ref3) {
  var _extends5;

  var _ref3$payload = _ref3.payload,
      key = _ref3$payload.key,
      error = _ref3$payload.error;
  return (0, _extends9.default)({}, state, {
    loadState: (0, _extends9.default)({}, state.loadState, (_extends5 = {}, _extends5[key] = {
      loading: false,
      loaded: false,
      error: error
    }, _extends5))
  });
}, _handleActions[clearKey] = function (state, _ref4) {
  var _extends6, _extends7;

  var payload = _ref4.payload;
  return (0, _extends9.default)({}, state, (_extends7 = {
    loadState: (0, _extends9.default)({}, state.loadState, (_extends6 = {}, _extends6[payload] = {
      loading: false,
      loaded: false,
      error: null
    }, _extends6))
  }, _extends7[payload] = null, _extends7));
}, _handleActions), initialState);

var immutableReducer = exports.immutableReducer = function wrapReducer(immutableState, action) {
  // We need to convert immutable state to mutable state before our reducer can act upon it
  var mutableState = void 0;
  if (immutableState === undefined) {
    // if state is undefined (no initial state yet) then we can't convert it, so let the
    // reducer set the initial state for us
    mutableState = immutableState;
  } else {
    // Convert immutable state to mutable state so our reducer will accept it
    mutableState = (0, _state.getMutableState)(immutableState);
  }

  // Run the reducer and then re-convert the mutable output state back to immutable state
  return (0, _state.getImmutableState)(reducer(mutableState, action));
};

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return {
        setValue: function setValue(key, value) {
            return _store2.default.set(key, value);
        },
        getValue: function getValue(key) {
            return _store2.default.get(key);
        },
        clearAll: function clearAll() {
            return _store2.default.clearAll();
        },
        removeValue: function removeValue(key) {
            return _store2.default.remove(key);
        }
    };
};

var _store = __webpack_require__(1636);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SEND_TIME_TRACKING = exports.SEND_TIME_TRACKING = "SEND_TIME_TRACKING";
var SEND_EVENT_TRACKING = exports.SEND_EVENT_TRACKING = "SEND_EVENT_TRACKING";

var FEED_RECEIVED_CATEGORY = exports.FEED_RECEIVED_CATEGORY = "FEED_RECEIVED_CATEGORY";
var INSIDER_CATEGORY = exports.INSIDER_CATEGORY = "INSIDER_CATEGORY";

var INSIDER_MPU_INFO_CLICK = exports.INSIDER_MPU_INFO_CLICK = "INSIDER_MPU_INFO_CLICK";
var INSIDER_MPU_GET_INVOLVED_CLICK = exports.INSIDER_MPU_GET_INVOLVED_CLICK = "INSIDER_MPU_GET_INVOLVED_CLICK";
var INSIDER_CTA_CLICK = exports.INSIDER_CTA_CLICK = "INSIDER_CTA_CLICK";
var INSIDER_PAGE_LOGIN_CLICK = exports.INSIDER_PAGE_LOGIN_CLICK = "INSIDER_PAGE_LOGIN_CLICK";
var INSIDER_PAGE_REGISTER_CLICK = exports.INSIDER_PAGE_REGISTER_CLICK = "INSIDER_PAGE_REGISTER_CLICK";

var sendFeedReceivedTimeTracking = exports.sendFeedReceivedTimeTracking = function sendFeedReceivedTimeTracking(metric, label, times) {

    return { type: SEND_TIME_TRACKING, data: { metric: metric, label: label, times: times, category: FEED_RECEIVED_CATEGORY } };
};

var sendEventTracking = exports.sendEventTracking = function sendEventTracking(category, eventAction) {
    return { type: SEND_EVENT_TRACKING, data: { category: category, eventAction: eventAction } };
};

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MostReadPanel;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StorySummary = __webpack_require__(215);

var _StorySummary2 = _interopRequireDefault(_StorySummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1380);

function MostReadPanel(_ref) {
  var _ref$articles = _ref.articles,
      articles = _ref$articles === undefined ? [] : _ref$articles,
      title = _ref.title,
      _ref$showCategory = _ref.showCategory,
      showCategory = _ref$showCategory === undefined ? false : _ref$showCategory;

  if (articles.length > 0) {
    return _react2.default.createElement(
      'section',
      { className: 'most-read-list', id: 'most-read' },
      _react2.default.createElement(
        'h3',
        { className: 'section-title' },
        'Most Read ',
        title
      ),
      articles.map(function (article, i) {
        return _react2.default.createElement(_StorySummary2.default, { badge: '' + (i + 1), key: article.article_reference.id, imageType: 'tipArticle', data: article, metaDataFlags: { category: showCategory, byline: true } });
      })
    );
  } else {
    return null;
  }
}

MostReadPanel.propTypes = {
  showCategory: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  articles: _propTypes2.default.array
};

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OutLink = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(OutLink, _Component);

  function OutLink() {
    (0, _classCallCheck3.default)(this, OutLink);
    return (0, _possibleConstructorReturn3.default)(this, (OutLink.__proto__ || (0, _getPrototypeOf2.default)(OutLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(OutLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          href = _props.to,
          className = _props.className,
          children = _props.children,
          _props$isExternal = _props.isExternal,
          isExternal = _props$isExternal === undefined ? false : _props$isExternal;


      if (isExternal) {
        return _react2.default.createElement(
          'a',
          (0, _extends3.default)({ className: className, href: href }, { target: '_blank' }),
          children
        );
      } else {
        // Regex matches any protocol and domain, and the rest of the path
        var _href$match = href.match(/^((?:https?:)?\/\/[^/]+)?(.*)/i),
            _href$match2 = (0, _slicedToArray3.default)(_href$match, 3),
            _href$match2$ = _href$match2[1],
            protocol = _href$match2$ === undefined ? false : _href$match2$,
            path = _href$match2[2];

        var to = protocol === false ? href : path;

        return _react2.default.createElement(
          _reactRouter.Link,
          { className: className, to: to },
          children
        );
      }
    }
  }]);
  return OutLink;
}(_react.Component), _class.propTypes = {
  to: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  isExternal: _propTypes2.default.bool
}, _temp);
exports.default = OutLink;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InsiderIcon;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InsiderIcon(_ref) {
  var title = _ref.title,
      colour = _ref.colour;


  var filename = colour === "white" ? "insiders-white.png" : "insiders-blue.png";
  var src = "/img/icons/" + filename;

  return _react2.default.createElement("img", { className: "insider-icon icon", src: src, title: title });
}

InsiderIcon.propTypes = {
  title: _propTypes2.default.string.isRequired,
  colour: _propTypes2.default.string
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MyStableIcon(_ref) {
  var title = _ref.title,
      subText = _ref.subText,
      className = _ref.className;

  return _react2.default.createElement(
    'div',
    { className: ["my-stable-icon", className].join(' ') },
    _react2.default.createElement(
      'svg',
      { viewBox: '0 0 64 64', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement(
        'title',
        null,
        title
      ),
      _react2.default.createElement(
        'g',
        { fillRule: 'evenodd' },
        _react2.default.createElement(
          'g',
          { transform: 'translate(-1465.000000, -366.000000)' },
          _react2.default.createElement(
            'g',
            { transform: 'translate(1365.000000, 35.000000)' },
            _react2.default.createElement(
              'g',
              { id: 'Group-17', transform: 'translate(100.000000, 331.000000)' },
              _react2.default.createElement(
                'g',
                { id: 'Group-16' },
                _react2.default.createElement('path', { d: 'M39.9909767,62.9941812 C37.4367343,63.6507989 34.7591473,64 32,64 C14.326888,64 0,49.673112 0,32 C0,14.326888 14.326888,0 32,0 C48.5612214,0 62.1840242,12.580866 63.8326083,28.7067979 C60.3293247,25.2262267 47.1771766,12.7370076 36.5745081,10.3839888 C24.2282843,7.64402799 31.2618151,9.26129692 31.2618151,9.26129692 L26.3714618,6.64631779 L27.3040195,11.4135893 L22.7776391,8.29615168 L25.3425005,14.0611334 L22.3551936,19.1720627 L25.2119949,19.5807551 L11,42.3569235 L12.3201396,44.6504203 L15.323736,46.5456141 L19.6191665,44.0282345 L17.0643537,46.4993819 L20.119103,46.4993819 L22.1829279,44.9234283 L26.1829279,40.0607994 L31.1214724,36.3602491 C31.1214724,36.3602491 43.541829,54.0583566 39.9909767,62.9941812 Z', id: 'Combined-Shape' }),
                _react2.default.createElement('path', { d: 'M56.8413589,52.1735629 C57.8803558,50.8957236 58.8227328,49.5361712 59.6573595,48.106036 L58.7978304,44.0979619 L53.683432,33.3431953 L45.1824458,22.9201183 L38,18 L42.3218277,22.4092702 L49.5335306,32.773833 L54.6186719,43.5295858 L56.8413589,52.1735629 Z', id: 'Combined-Shape' })
              )
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      'span',
      null,
      subText
    )
  );
}

MyStableIcon.propTypes = {
  title: _propTypes2.default.string.isRequired,
  subText: _propTypes2.default.string,
  className: _propTypes2.default.string
};

exports.default = MyStableIcon;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICONS = {
  BOG: {
    title: "BOG",
    path: "M42.593 45.305l-.626 1.6-.806 2.073-1.925-1.118-1.48-.863-.958 1.42-1.244 1.843-1.63-1.52-1.248-1.17-1.255 1.17-1.62 1.52-1.247-1.843-.956-1.42-1.482.863-1.92 1.118-.8-2.072-.65-1.6-.482.147V63.98l10.403-6.692 10.398 6.69V45.454l-.47-.148zM36.375 26.88c-.272-.237-.657-.45-1.155-.606-.5-.155-1.156-.248-1.963-.248h-2.954v5.243h2.81c1.4 0 2.415-.187 3.033-.59.62-.403.927-1.098.927-2.097 0-.285-.05-.577-.145-.887-.093-.308-.28-.58-.553-.817zm-1.568-5.077c.44-.142.793-.326 1.05-.564.264-.236.45-.502.557-.8.106-.296.16-.598.16-.907 0-.832-.276-1.452-.822-1.835-.546-.378-1.46-.585-2.744-.585h-2.705v4.893h2.81c.693 0 1.255-.06 1.694-.203zm18.344 2.51l2.38-2.55-2.89-1.95 1.758-3.012-3.252-1.26 1.05-3.33-3.46-.502.276-3.48-3.474.276-.507-3.455-3.328 1.044-1.264-3.252-3.01 1.757-1.955-2.894-2.547 2.382-2.544-2.382L28.43 4.6 25.407 2.84l-1.26 3.252-3.32-1.045-.51 3.454-3.475-.276.28 3.48-3.46.5 1.048 3.33-3.26 1.263 1.764 3.013-2.892 1.95 2.38 2.55-2.38 2.546 2.892 1.953-1.763 3.016 3.26 1.26-1.048 3.328 3.46.507-.28 3.475 3.477-.276.507 3.452 3.32-1.046 1.26 3.258 3.022-1.76 1.952 2.892 2.544-2.38 2.547 2.38 1.954-2.892 3.01 1.76 1.265-3.258 3.33 1.046.506-3.452 3.474.276-.277-3.475 3.46-.507-1.05-3.327 3.253-1.26-1.76-3.017 2.893-1.954-2.38-2.546zM40.69 34.2c-1.555 1.167-3.903 1.79-7.04 1.79H27.94c-.664 0-1.206-.114-1.62-.256-.417-.144-.737-.362-.966-.61-.224-.25-.407-.565-.492-.922-.083-.354-.154-.744-.154-1.15V15.575c0-.407.07-.786.154-1.142.085-.357.254-.658.478-.91.23-.248.556-.433.973-.577.417-.144.963-.204 1.627-.204h5.528c1.618 0 2.98.146 4.08.453 1.11.308 2.006.733 2.695 1.278.69.55 1.192 1.188 1.496 1.926.313.735.467 1.53.467 2.387 0 1.162-.32 2.178-.96 3.048-.644.868-1.536 1.527-2.676 1.977 1.616.502 2.763 1.222 3.443 2.16.675.938 1.014 2.012 1.014 3.177 0 2.185-.78 3.883-2.338 5.048z"
  },
  EXTRA_PLACES: {
    title: "Extra Places",
    path: "M53.652 1.28H10.998c-1.053 0-1.912.72-1.912 1.595v59.7c0 1.038.755 1.496 1.674.977l20.052-11.04c.92-.51 2.423-.505 3.34.01l19.89 11.032c.917.52 1.813.06 1.813-.977v-59.7c0-.877-1.15-1.594-2.203-1.594zm-8.595 26.3h-8.822v8.873h-7.818V27.58H19.59v-7.77h8.827v-8.823h7.818v8.822h8.822v7.77z"
  },
  MONEY_BACK: {
    title: "Moneyback",
    path: "M50.458 21.435l-19.192-.023 4.44-13.67L1.643 32.63l17.89 24.89 4.454-13.704 18.794.026 7.678-22.405zm2.602.005l-7.677 22.4 3.602.006 7.676-22.4-3.6-.005zm6.453.008l-7.675 22.4 3.83.008 7.675-22.398-3.83-.01z"
  },
  GENERIC_PROMO: {
    title: "Generic Promo",
    path: "M60.798 18.432H46.772c.98-.49 1.837-1.042 2.695-1.593 3-2.145 4.655-4.9 4.655-7.657 0-2.266-1.103-4.288-2.695-5.574-1.532-1.41-3.553-2.145-5.758-2.145-2.39 0-4.472.796-6.37 2.02-2.82 1.84-5.024 4.656-6.616 7.842l-.184.428c-.55-1.225-1.225-2.327-2.02-3.49-1.287-1.84-2.94-3.554-4.78-4.78-1.837-1.224-4.042-2.02-6.37-2.02-2.327 0-4.41.92-6.063 2.45-1.593 1.47-2.695 3.614-2.695 6.003 0 1.47.367 2.88 1.225 4.226 1.102 1.654 2.695 3.124 5.022 4.288H4.2c-1.652 0-3.06 1.41-3.06 3.124v11.27h29.584V18.432h3.614v14.394H63.86v-11.27c0-1.715-1.347-3.124-3.062-3.124zM6.713 63.82h24.01V37.05H6.714V63.82zm27.624 0h23.95V37.05h-23.95V63.82zM17.922 14.02c-1.225-.797-1.96-1.532-2.39-2.206-.366-.673-.55-1.286-.55-1.898 0-.92.49-2.022 1.286-2.757.858-.795 2.02-1.285 3-1.285 1.41 0 2.697.43 3.983 1.286 1.9 1.35 3.798 3.554 5.085 6.127.674 1.286 1.164 2.633 1.47 4.042-5.88-.613-9.74-1.96-11.883-3.308zm20.152-3.185C39.176 9.305 40.4 8.02 41.75 7.16c1.285-.856 2.633-1.285 3.858-1.285h.06c1.165 0 2.145.43 2.88 1.042.735.612 1.102 1.408 1.102 2.266 0 .98-.49 2.39-2.817 4.042-2.205 1.593-6.003 3.247-11.76 4.41.55-2.327 1.653-4.777 3-6.798z"
  },
  PRICE_BOOST: {
    title: "Priceboost",
    path: "M5.264 33.653H20.89l-6.287 18.19h23.44l6.228-18.19H59.9l-16.42-32.17-38.214 32.17zm5.25 30.34h23.44l1.22-3.603h-23.44l-1.22 3.602zm26.737-9.707H13.81l-1.1 3.418h23.442l1.1-3.418z"
  }
};

var PromoIcon = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PromoIcon, _Component);

  function PromoIcon() {
    (0, _classCallCheck3.default)(this, PromoIcon);
    return (0, _possibleConstructorReturn3.default)(this, (PromoIcon.__proto__ || (0, _getPrototypeOf2.default)(PromoIcon)).apply(this, arguments));
  }

  (0, _createClass3.default)(PromoIcon, [{
    key: 'render',
    value: function render() {
      var type = this.props.type;
      var _ICONS$type = ICONS[type];
      _ICONS$type = _ICONS$type === undefined ? ICONS.GENERIC_PROMO : _ICONS$type;
      var title = _ICONS$type.title,
          path = _ICONS$type.path;


      if (!_config2.default.isProduction && !ICONS.hasOwnProperty(type)) {
        console.warn('Invalid PromoIcon requested: "' + type + '", defaulted to "GENERIC_PROMO".'); // eslint-disable-line no-console
      }

      return _react2.default.createElement(
        'svg',
        { className: 'promo-icon', viewBox: '0 0 65 65', xmlns: 'http://www.w3.org/2000/svg' },
        _react2.default.createElement(
          'title',
          null,
          title
        ),
        _react2.default.createElement('path', { d: path })
      );
    }
  }]);
  return PromoIcon;
}(_react.Component), _class.propTypes = {
  type: _propTypes2.default.string
}, _temp);
exports.default = PromoIcon;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAdvertsForSlot = exports.gptFallbackTimer = exports.initializeTam = exports.initializeGptForTam = exports.CANCEL_GPT_FALLBACK_TIMER = exports.GPT_FALLBACK_TIMER_ID = exports.LOAD_ADVERTS = exports.ADVERT_BIDS_RECEIVED = exports.ADVERT_BIDS_REQUESTED = exports.UPDATE_ADVERT_SLOT = exports.INITIALIZE_TAM_SUCCESS = exports.TAM_SCRIPT_DISABLED = exports.TAM_SCRIPT_LOAD_TIMEOUT = exports.TAM_SCRIPT_LOAD_ERROR = exports.LOAD_TAM_SCRIPT_SUCCESS = undefined;

var _values = __webpack_require__(1269);

var _values2 = _interopRequireDefault(_values);

var _stringify = __webpack_require__(180);

var _stringify2 = _interopRequireDefault(_stringify);

var _reactGpt = __webpack_require__(668);

var _middlewareUtils = __webpack_require__(119);

var _windowEvents = __webpack_require__(199);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _commonUtils = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_TAM_SCRIPT_SUCCESS = exports.LOAD_TAM_SCRIPT_SUCCESS = "LOAD_TAM_SCRIPT_SUCCESS";
var TAM_SCRIPT_LOAD_ERROR = exports.TAM_SCRIPT_LOAD_ERROR = "TAM_SCRIPT_LOAD_ERROR";
var TAM_SCRIPT_LOAD_TIMEOUT = exports.TAM_SCRIPT_LOAD_TIMEOUT = "TAM_SCRIPT_LOAD_TIMEOUT";
var TAM_SCRIPT_DISABLED = exports.TAM_SCRIPT_DISABLED = "TAM_SCRIPT_DISABLED";
var INITIALIZE_TAM_SUCCESS = exports.INITIALIZE_TAM_SUCCESS = "INITIALIZE_TAM_SUCCESS";
var UPDATE_ADVERT_SLOT = exports.UPDATE_ADVERT_SLOT = "UPDATE_ADVERT_SLOT";
var ADVERT_BIDS_REQUESTED = exports.ADVERT_BIDS_REQUESTED = "ADVERT_BIDS_REQUESTED";
var ADVERT_BIDS_RECEIVED = exports.ADVERT_BIDS_RECEIVED = "ADVERT_BIDS_RECEIVED";
var LOAD_ADVERTS = exports.LOAD_ADVERTS = "LOAD_ADVERTS";
var GPT_FALLBACK_TIMER_ID = exports.GPT_FALLBACK_TIMER_ID = "GPT_FALLBACK_TIMER_ID";
var CANCEL_GPT_FALLBACK_TIMER = exports.CANCEL_GPT_FALLBACK_TIMER = "CANCEL_GPT_FALLBACK_TIMER";

var initializeGptForTam = exports.initializeGptForTam = function initializeGptForTam(documentFunction, configuration, gptApi) {
  return function (store, next, action) {
    if (action.type === _windowEvents.WINDOW_LOAD) {
      var _navigator = navigator,
          _navigator$userAgent = _navigator.userAgent,
          userAgent = _navigator$userAgent === undefined ? null : _navigator$userAgent;


      if (!(configuration.tam && configuration.tam.enabled) || (0, _commonUtils.isMobileApp)(userAgent)) {
        store.dispatch({ type: TAM_SCRIPT_DISABLED });
        return next(action);
      }

      gptApi.disableInitialLoad();
      gptApi.enableSingleRequest();
      gptApi.collapseEmptyDivs();
      // enableServices is called internally by the react-gpt code.

      var forceDFPLoad = function forceDFPLoad(type) {
        return function () {
          store.dispatch({ type: type });
          gptApi.refresh();
        };
      };

      var resetAndRun = function resetAndRun(timeoutId, toRun) {
        if (_timeoutID !== null) {
          clearTimeout(_timeoutID);
          toRun();
        }
      };

      var doc = documentFunction();
      var scriptTag = doc.createElement("script");

      var _timeoutID = setTimeout(forceDFPLoad(TAM_SCRIPT_LOAD_TIMEOUT), configuration.tam.scriptLoadTimeoutMs);

      // Handle Amazon script load errors. Fall back to GPT if it fails to load.
      scriptTag.addEventListener('error', function () {
        resetAndRun(_timeoutID, forceDFPLoad(TAM_SCRIPT_LOAD_ERROR));
      });

      scriptTag.addEventListener('load', function () {
        return resetAndRun(_timeoutID, function () {
          store.dispatch({ type: LOAD_TAM_SCRIPT_SUCCESS });
        });
      });

      scriptTag.async = true;
      scriptTag.src = configuration.tam.url;
      var head = doc.getElementsByTagName("head")[0];

      head.insertBefore(scriptTag, head.firstChild);
    }
    return next(action);
  };
};

var getApstag = function getApstag() {
  return window.apstag;
};
var getDocument = function getDocument() {
  return document;
};

var initializeTam = exports.initializeTam = function initializeTam(configuration, apstagFn) {
  return function (store, next, action) {
    if (action.type === LOAD_TAM_SCRIPT_SUCCESS) {
      apstagFn().init(configuration.tam.initializationParams);
      store.dispatch({ type: INITIALIZE_TAM_SUCCESS });
    }

    return next(action);
  };
};

var gptFallbackTimer = exports.gptFallbackTimer = function gptFallbackTimer(config, gptApi) {
  return function (store, next, action) {
    if (action.type === LOAD_TAM_SCRIPT_SUCCESS) {
      var _timeoutID2 = setTimeout(function () {
        return gptApi.refresh();
      }, config.tam.bidRetreivalTimeoutMs);
      store.dispatch({ type: GPT_FALLBACK_TIMER_ID, timeoutID: _timeoutID2 });
    }

    if (action.type === CANCEL_GPT_FALLBACK_TIMER) {
      var _store$getState = store.getState(),
          _store$getState$commo = _store$getState.common;

      _store$getState$commo = _store$getState$commo === undefined ? {} : _store$getState$commo;
      var gptTimeoutId = _store$getState$commo.tamGpt.gptTimeoutId;


      if (gptTimeoutId != null) {
        clearTimeout(gptTimeoutId);
      }
    }

    return next(action);
  };
};

var fetchAdvertsForSlot = exports.fetchAdvertsForSlot = function fetchAdvertsForSlot(apsTagFn, gptObject) {
  return function (store, next, action) {
    if (action.type === LOAD_ADVERTS) {
      var sizeMappings = action.slotSize || action.sizeMapping && action.sizeMapping.flatMap(function (size) {
        return size.slot;
      });
      var slotId = action.slotId;
      var slotData = {
        slots: [{
          slotID: slotId,
          slotName: slotId,
          sizes: sizeMappings
        }]
      };

      if (sizeMappings === action.slotSize || sizeMappings && sizeMappings.length > 0) {
        var apsTag = apsTagFn();
        store.dispatch({ type: UPDATE_ADVERT_SLOT, slotId: slotId, status: ADVERT_BIDS_REQUESTED });
        apsTag.fetchBids(slotData, function (bids) {
          store.dispatch({ type: UPDATE_ADVERT_SLOT, slotId: slotId, status: ADVERT_BIDS_RECEIVED });
          console.log("Bid callback for slot " + slotId + (0, _stringify2.default)(bids, null, "  "));

          var _store$getState2 = store.getState(),
              _store$getState2$comm = _store$getState2.common;

          _store$getState2$comm = _store$getState2$comm === undefined ? {} : _store$getState2$comm;
          var _store$getState2$comm2 = _store$getState2$comm.tamGpt.advertSlots,
              advertSlots = _store$getState2$comm2 === undefined ? {} : _store$getState2$comm2;


          gptObject.on(_reactGpt.Events.READY, function (adManager) {
            adManager.cmd.push(function () {
              console.log("Loading Bids for slot " + slotId);
              apsTag.setDisplayBids();
              if (allAdsRetrieved(advertSlots)) {
                store.dispatch({ type: CANCEL_GPT_FALLBACK_TIMER });
                console.log("Refreshing Advert components");
                adManager.pubads().refresh();
              }
            });
          });
        });
      }
    }
    return next(action);
  };
};

var allAdsRetrieved = function allAdsRetrieved(advertSlots) {
  return (0, _values2.default)(advertSlots).filter(function (status) {
    return status !== ADVERT_BIDS_RECEIVED;
  }).length === 0;
};

exports.default = function () {
  return [initializeGptForTam(getDocument, _config2.default, _reactGpt.Bling), initializeTam(_config2.default, getApstag), fetchAdvertsForSlot(getApstag, _reactGpt.Bling), gptFallbackTimer(_config2.default, _reactGpt.Bling)].map(_middlewareUtils.middlewareWrapper);
};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADD = exports.CLEAR = exports.STORE = undefined;

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.getQueuedBetLinks = getQueuedBetLinks;
exports.queueBetLink = queueBetLink;
exports.clearBetLinks = clearBetLinks;
exports.addBet = addBet;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
This is just for queing up betlinks that are clicked on before the
Fresh8 Integrated betslip is available.

Only relevant for feature "integrated-betslip"
*/

var STORE = exports.STORE = 'common/betlinks/STORE';
var CLEAR = exports.CLEAR = 'common/betlinks/CLEAR';
var ADD = exports.ADD = 'common/betlinks/ADD';

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case STORE:
      return (0, _extends3.default)({}, state, {
        queue: [].concat((0, _toConsumableArray3.default)(state.queue || []), [action.data])
      });
    case CLEAR:
      return (0, _extends3.default)({}, state, {
        queue: []
      });
    default:
      return state;
  }
}

function getQueuedBetLinks(globalState) {
  return globalState.common.betlink.queue;
}

function queueBetLink(data) {
  return {
    type: STORE,
    data: data
  };
}

function clearBetLinks() {
  return {
    type: CLEAR
  };
}

function addBet(data) {
  return {
    type: ADD,
    data: data
  };
}

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(7);

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;
exports.openLightbox = openLightbox;
exports.closeLightbox = closeLightbox;

var _feedbackForm = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OPEN_LIGHTBOX = 'common/display/OPEN_LIGHTBOX';
var CLOSE_LIGHTBOX = 'common/display/CLOSE_LIGHTBOX';

var initialState = {
  lightbox: {},
  feedbackForm: { show: false, sent: false, sendingError: false }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _feedbackForm.RESET_FEEDBACK_FORM:
      return (0, _extends5.default)({}, state, {
        feedbackForm: (0, _extends5.default)({}, state.feedbackForm, {
          sent: false,
          sendingError: false
        })
      });
    case _feedbackForm.SEND_FEEDBACK_FAILED:
      return (0, _extends5.default)({}, state, {
        feedbackForm: (0, _extends5.default)({}, state.feedbackForm, {
          sent: false,
          sendingError: true
        })
      });
    case _feedbackForm.SEND_FEEDBACK_SUCCESS:
      return (0, _extends5.default)({}, state, {
        feedbackForm: (0, _extends5.default)({}, state.feedbackForm, {
          sent: true,
          sendingError: false
        })
      });
    case _feedbackForm.TOGGLE_SHOW_FEEDBACK_FORM:
      return (0, _extends5.default)({}, state, {
        feedbackForm: (0, _extends5.default)({}, state.feedbackForm, {
          show: action.toggle || false
        })
      });
    case OPEN_LIGHTBOX:
      return (0, _extends5.default)({}, state, {
        lightbox: (0, _extends5.default)({}, state.lightbox, (0, _defineProperty3.default)({}, action.lightbox, {
          messageType: action.messageType,
          show: true
        }))
      });
    case CLOSE_LIGHTBOX:
      return (0, _extends5.default)({}, state, {
        lightbox: (0, _extends5.default)({}, state.lightbox, (0, _defineProperty3.default)({}, action.lightbox, {
          show: false
        }))
      });
    default:
      return state;
  }
}

function openLightbox(lightbox, messageType) {
  return {
    type: OPEN_LIGHTBOX,
    messageType: messageType,
    lightbox: lightbox
  };
}

function closeLightbox(lightbox) {
  return {
    type: CLOSE_LIGHTBOX,
    lightbox: lightbox
  };
}

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHOWN = exports.SHOW = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.showMenu = showMenu;
exports.shownMenu = shownMenu;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHOW = exports.SHOW = 'common/menu/SHOW';
var SHOWN = exports.SHOWN = 'common/menu/SHOWN';

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { show: false };
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SHOW:
      return (0, _extends3.default)({}, state, {
        show: true
      });
    case SHOWN:
      return (0, _extends3.default)({}, state, {
        show: false
      });
    default:
      return state;
  }
}

function showMenu() {
  return {
    type: SHOW
  };
}

function shownMenu() {
  return {
    type: SHOWN
  };
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.setBusy = setBusy;
var BUSY = 'common/pageTranstition/BUSY';
var IDLE = 'common/pageTranstition/IDLE';

var initialState = {
  busy: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case BUSY:
      return {
        busy: true
      };
    case IDLE:
      return {
        busy: false
      };
    default:
      return state;
  }
}

function setBusy(isBusy) {
  if (isBusy) {
    return { type: BUSY };
  }

  return { type: IDLE };
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballLiveCompetitionList;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(117);

var _CollapsibleSection = __webpack_require__(99);

var _CollapsibleSection2 = _interopRequireDefault(_CollapsibleSection);

var _FootballMatchRoundList = __webpack_require__(381);

var _FootballMatchRoundList2 = _interopRequireDefault(_FootballMatchRoundList);

var _urlRewrite = __webpack_require__(120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(510);

function FootballLiveCompetitionList(_ref) {
  var _ref$matchList = _ref.matchList,
      matchList = _ref$matchList === undefined ? [] : _ref$matchList;


  var mappedCompetitionMatches = (0, _utils.mapMatchesToCompetitions)(matchList) || [];

  return _react2.default.createElement(
    'ul',
    null,
    mappedCompetitionMatches.map(function (_ref2) {
      var id = _ref2.id,
          name = _ref2.name,
          _ref2$matchList = _ref2.matchList,
          matchList = _ref2$matchList === undefined ? [] : _ref2$matchList;
      return _react2.default.createElement(
        'li',
        { key: id },
        _react2.default.createElement(
          'div',
          { className: 'FootballMatchList', id: (0, _urlRewrite.titleToId)(name) },
          _react2.default.createElement(
            _CollapsibleSection2.default,
            { title: name },
            _react2.default.createElement(_FootballMatchRoundList2.default, { matchList: matchList })
          )
        )
      );
    })
  );
}

FootballLiveCompetitionList.propTypes = {
  matchList: _propTypes2.default.array.isRequired
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballMatchList;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _FootballMatchListItem = __webpack_require__(821);

var _FootballMatchListItem2 = _interopRequireDefault(_FootballMatchListItem);

var _utils = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1401);

function competitionHref(competitionId, competitionName, fixturesResults) {
  return '/football/' + fixturesResults + '/competitions/' + (0, _utils.toSlug)(competitionName) + '/' + competitionId;
}

function FootballMatchList(_ref) {
  var _ref$matchList = _ref.matchList,
      matchList = _ref$matchList === undefined ? [] : _ref$matchList,
      showCompetitions = _ref.showCompetitions,
      fixturesResults = _ref.fixturesResults;


  return _react2.default.createElement(
    'ul',
    null,
    matchList.map(function (match) {
      var matchId = match.match_reference.id,
          _match$competition = match.competition;
      _match$competition = _match$competition === undefined ? {} : _match$competition;
      var _match$competition$co = _match$competition.competition_reference;
      _match$competition$co = _match$competition$co === undefined ? {} : _match$competition$co;
      var competitionId = _match$competition$co.id,
          competitionName = _match$competition.name;


      return _react2.default.createElement(
        'li',
        { key: matchId },
        showCompetitions && _react2.default.createElement(
          'div',
          { className: 'competition-name' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: competitionHref(competitionId, competitionName, fixturesResults) },
            competitionName
          )
        ),
        _react2.default.createElement(_FootballMatchListItem2.default, { match: match })
      );
    })
  );
}

FootballMatchList.propTypes = {
  matchList: _propTypes2.default.array.isRequired,
  fixturesResults: _propTypes2.default.string,
  showCompetitions: _propTypes2.default.bool
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LocalDateTime = __webpack_require__(61);

var _reactRouter = __webpack_require__(11);

var _reactAddonsCssTransitionGroup = __webpack_require__(1540);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _FootballMatchEventIcon = __webpack_require__(208);

var _FootballMatchEventIcon2 = _interopRequireDefault(_FootballMatchEventIcon);

var _FootballMatchOutcomeDescription = __webpack_require__(207);

var _FootballMatchOutcomeDescription2 = _interopRequireDefault(_FootballMatchOutcomeDescription);

var _commonUtils = __webpack_require__(36);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_TYPES = {
  "KICK_OFF": timeFactory("Unknown Type", "Kick Off"),
  "END_OF_FIRST_HALF": timeFactory("Half Time", "Half time"),
  "START_OF_SECOND_HALF": timeFactory("Unknown Type", "Start of second half"),
  "END_OF_SECOND_HALF": timeFactory("Unknown Type", "End of second half"),
  "FULL_TIME": timeFactory("Full Time", "Full Time", true, true),

  "START_OF_EXTRA_TIME": timeFactory("Unknown Type", "Start of extra time"),
  "END_OF_EXTRA_TIME": timeFactory("Unknown Type", "End of extra time"),
  "START_OF_PENALTY_SHOOTOUT": timeFactory("Unknown Type", "Start of penalty shootout"),
  "END_OF_PENALTY_SHOOTOUT": timeFactory("Unknown Type", "End of penalty shootout"),
  "END_OF_EXTRA_TIME_FIRST_HALF": timeFactory("Unknown Type", "End of extra time first half"),
  "START_OF_EXTRA_TIME_SECOND_HALF": timeFactory("Unknown Type", "Start of extra time second half"),

  "GOAL": goalFactory("Goal", "GOAL"),
  "OWN_GOAL": goalFactory("Goal", "Own Goal"),
  "PENALTY": goalFactory("Penalty", "Penalty Scored"),
  "SHOOTOUT_PENALTY": goalFactory("Penalty", "Shootout Penalty"),

  "YELLOW_CARD": playerFactory("Yellow Card", "Yellow Card"),
  "SECOND_YELLOW_CARD": playerFactory("Second Yellow Card", "2nd Yellow Card"),
  "RED_CARD": playerFactory("Red Card", "Red Card"),

  "SUBSTITUTION_ON": playerFactory("Sub On", "Substitution On"),
  "SUBSTITUTION_OFF": playerFactory("Sub Off", "Substitution Off")
};

////////////////////////////////
// Line factory helpers

function matchHref(lineData) {
  var _lineData$match_refer = lineData.match_reference;
  _lineData$match_refer = _lineData$match_refer === undefined ? {} : _lineData$match_refer;
  var _lineData$match_refer2 = _lineData$match_refer.id,
      matchId = _lineData$match_refer2 === undefined ? null : _lineData$match_refer2;


  return matchId ? '/football/live/' + matchId + '/commentary' : "/football/live/vidiprinter";
}

function teamName(teamData) {
  var _teamData$team = teamData.team;
  _teamData$team = _teamData$team === undefined ? {} : _teamData$team;
  var _teamData$team$name = _teamData$team.name,
      teamName = _teamData$team$name === undefined ? "" : _teamData$team$name;


  return teamName || "";
}

function teamScore(teamData) {
  var _teamData$score = teamData.score,
      score = _teamData$score === undefined ? [{
    score: null
  }] : _teamData$score;


  return score[0].score || null;
}

function playerEvent(lineData) {
  var _lineData$player = lineData.player;
  _lineData$player = _lineData$player === undefined ? {} : _lineData$player;
  var _lineData$player$disp = _lineData$player.display_name,
      display_name = _lineData$player$disp === undefined ? '' : _lineData$player$disp,
      _lineData$match_time = lineData.match_time,
      match_time = _lineData$match_time === undefined ? '' : _lineData$match_time;


  return display_name && match_time ? _react2.default.createElement(
    'span',
    { className: 'vidiline-player' },
    '(',
    display_name,
    ' ',
    match_time,
    ')'
  ) : '';
}

function isScore(lineData, teamCode) {
  var _lineData$team = lineData.team;
  _lineData$team = _lineData$team === undefined ? {} : _lineData$team;
  var _lineData$team$team_r = _lineData$team.team_reference;
  _lineData$team$team_r = _lineData$team$team_r === undefined ? {} : _lineData$team$team_r;
  var _lineData$team$team_r2 = _lineData$team$team_r.id,
      scoredTeam = _lineData$team$team_r2 === undefined ? "noscore" : _lineData$team$team_r2,
      _lineData$ = lineData['team_score_' + teamCode];
  _lineData$ = _lineData$ === undefined ? {} : _lineData$;
  var _lineData$$team = _lineData$.team;
  _lineData$$team = _lineData$$team === undefined ? {} : _lineData$$team;
  var _lineData$$team$team_ = _lineData$$team.team_reference;
  _lineData$$team$team_ = _lineData$$team$team_ === undefined ? {} : _lineData$$team$team_;
  var _lineData$$team$team_2 = _lineData$$team$team_.id,
      thisTeam = _lineData$$team$team_2 === undefined ? "nothis" : _lineData$$team$team_2;


  return scoredTeam == thisTeam;
}

function getAggregateScore(lineData) {
  var _lineData$team_score_ = lineData.team_score_a;
  _lineData$team_score_ = _lineData$team_score_ === undefined ? {} : _lineData$team_score_;
  var teamA = _lineData$team_score_.aggregate_score,
      _lineData$team_score_2 = lineData.team_score_b;
  _lineData$team_score_2 = _lineData$team_score_2 === undefined ? {} : _lineData$team_score_2;
  var teamB = _lineData$team_score_2.aggregate_score;


  if (teamA !== undefined && teamB !== undefined) {
    return '(Agg: ' + teamA + '-' + teamB + ')';
  }
}

function getPenaltyShootoutScore(lineData) {
  var _lineData$team_score_3 = lineData.team_score_a;
  _lineData$team_score_3 = _lineData$team_score_3 === undefined ? {} : _lineData$team_score_3;
  var teamA = _lineData$team_score_3.penalty_shootout_score,
      _lineData$team_score_4 = lineData.team_score_b;
  _lineData$team_score_4 = _lineData$team_score_4 === undefined ? {} : _lineData$team_score_4;
  var teamB = _lineData$team_score_4.penalty_shootout_score;


  if (teamA !== undefined && teamB !== undefined) {
    return { home: teamA, away: teamB };
  }
}

////////////////////////////////
// Line factories

function timeFactory(icon, label) {
  var highlightMax = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var displayOutcome = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  function highlightIfMax(lineData, teamCode) {
    if (highlightMax) {
      var min = Math.min(teamScore(lineData.team_score_a), teamScore(lineData.team_score_b));
      var score = teamScore(lineData['team_score_' + teamCode]);

      return score > min ? "vidiline-highlight-team" : "";
    } else {
      return "";
    }
  }

  return function time(lineData, key) {
    var aggregateScore = getAggregateScore(lineData);
    var penaltyShootoutScore = getPenaltyShootoutScore(lineData);

    return _react2.default.createElement(
      Line,
      { line: lineData, key: key },
      _react2.default.createElement(Time, { line: lineData }),
      _react2.default.createElement(Icon, { type: icon }),
      _react2.default.createElement(
        Message,
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'vidiline-link', to: matchHref(lineData) },
          _react2.default.createElement(
            'span',
            null,
            label,
            ' -'
          ),
          _react2.default.createElement(
            'span',
            { className: highlightIfMax(lineData, "a") },
            teamName(lineData.team_score_a),
            ' ',
            teamScore(lineData.team_score_a)
          ),
          _react2.default.createElement(
            'span',
            { className: highlightIfMax(lineData, "b") },
            teamName(lineData.team_score_b),
            ' ',
            teamScore(lineData.team_score_b)
          ),
          aggregateScore && _react2.default.createElement(
            'span',
            null,
            aggregateScore
          )
        ),
        displayOutcome && _react2.default.createElement(_FootballMatchOutcomeDescription2.default, { matchOutcome: lineData.match_outcome, penaltyShootoutScore: penaltyShootoutScore, enableCompactText: false, style: 'vidiprinter-result' })
      )
    );
  };
}

function goalFactory(icon, label) {
  function highlightIfScore(lineData, teamCode) {
    // If this is an own goal then we need to swap teams over for highlighting
    if (lineData.event_type.event_type == "OWN_GOAL") {
      teamCode = teamCode == "a" ? "b" : "a";
    }
    return isScore(lineData, teamCode) ? "vidiline-highlight-score" : "";
  }

  return function goal(lineData, key) {
    var aggregateScore = getAggregateScore(lineData);

    return _react2.default.createElement(
      Line,
      { line: lineData, key: key },
      _react2.default.createElement(Time, { line: lineData }),
      _react2.default.createElement(Icon, { type: icon }),
      _react2.default.createElement(
        Message,
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'vidiline-link', to: matchHref(lineData) },
          _react2.default.createElement(
            'span',
            { className: 'vidiline-highlight-event' },
            label,
            ' -'
          ),
          _react2.default.createElement(
            'span',
            { className: highlightIfScore(lineData, "a") },
            teamName(lineData.team_score_a),
            ' ',
            teamScore(lineData.team_score_a)
          ),
          isScore(lineData, "a") && playerEvent(lineData),
          _react2.default.createElement(
            'span',
            { className: highlightIfScore(lineData, "b") },
            teamName(lineData.team_score_b),
            ' ',
            teamScore(lineData.team_score_b)
          ),
          isScore(lineData, "b") && playerEvent(lineData),
          aggregateScore && _react2.default.createElement(
            'span',
            null,
            aggregateScore
          )
        )
      )
    );
  };
}

function playerFactory(icon, label) {
  return function player(lineData, key) {
    return _react2.default.createElement(
      Line,
      { line: lineData, key: key },
      _react2.default.createElement(Time, { line: lineData }),
      _react2.default.createElement(Icon, { type: icon }),
      _react2.default.createElement(
        Message,
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          { className: 'vidiline-link', to: matchHref(lineData) },
          _react2.default.createElement(
            'span',
            null,
            label,
            ' -'
          ),
          _react2.default.createElement(
            'span',
            null,
            playerEvent(lineData)
          ),
          _react2.default.createElement(
            'span',
            null,
            teamName(lineData)
          )
        )
      )
    );
  };
}

function defaultLine(lineData, key) {
  return _react2.default.createElement(
    Line,
    { line: lineData, key: key },
    _react2.default.createElement(Time, { line: lineData }),
    _react2.default.createElement(Icon, null),
    _react2.default.createElement(
      Message,
      null,
      _react2.default.createElement(
        _reactRouter.Link,
        { className: 'vidiline-link', to: matchHref(lineData) },
        _react2.default.createElement(
          'span',
          null,
          lineData.vidiprinter_line
        )
      )
    )
  );
}

function transform(lineData) {
  var key = lineData.match_event_reference.id;
  var _lineData$event_type = lineData.event_type;
  _lineData$event_type = _lineData$event_type === undefined ? {} : _lineData$event_type;
  var eventType = _lineData$event_type.event_type;


  if (eventType && EVENT_TYPES[eventType]) {
    return EVENT_TYPES[eventType](lineData, key);
  } else {
    return defaultLine(lineData, key);
  }
}

////////////////////////////////
// Sub-components

function Line(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    { className: 'vidiline' },
    children
  );
}
Line.propTypes = {
  children: _propTypes2.default.node.isRequired
};

function Time(_ref2) {
  var date = _ref2.line.date;

  return _react2.default.createElement(
    'div',
    { className: 'vidiline-time' },
    _react2.default.createElement(_LocalDateTime.LocalTimeShort, { iso: date })
  );
}
Time.propTypes = {
  line: _propTypes2.default.shape({
    date: _propTypes2.default.string.isRequired
  })
};

function Icon(_ref3) {
  var type = _ref3.type;

  return _react2.default.createElement(
    'div',
    { className: 'vidiline-icon' },
    type && _react2.default.createElement(_FootballMatchEventIcon2.default, { type: type })
  );
}
Icon.propTypes = {
  type: _propTypes2.default.string
};

function Message(_ref4) {
  var children = _ref4.children;

  return _react2.default.createElement(
    'div',
    { className: 'vidiline-message' },
    children
  );
}
Message.propTypes = {
  children: _propTypes2.default.node.isRequired

  ////////////////////////////////
  // Main component

};var FootballVidiprinter = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FootballVidiprinter, _Component);

  function FootballVidiprinter() {
    (0, _classCallCheck3.default)(this, FootballVidiprinter);
    return (0, _possibleConstructorReturn3.default)(this, (FootballVidiprinter.__proto__ || (0, _getPrototypeOf2.default)(FootballVidiprinter)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballVidiprinter, [{
    key: 'render',
    value: function render() {
      __webpack_require__(1408);

      if (!_lodash2.default.get(this.props, 'data.lines')) {
        return _react2.default.createElement(
          'div',
          { className: 'default-no-article' },
          _react2.default.createElement(
            'p',
            null,
            'The Vidiprinter is currently unavailable, please try again later.'
          )
        );
      }

      var _props$data$lines = this.props.data.lines,
          lines = _props$data$lines === undefined ? [] : _props$data$lines;

      var _globalCssExports = (0, _commonUtils.globalCssExports)("animations"),
          highlightNewDataDuration = _globalCssExports.highlightNewDataDuration;

      // transitionLeaveTimeout is set to 1ms due to how React's library checks for timeouts.
      // It does a check based on a truthy value and 0 would be false.


      return _react2.default.createElement(
        'div',
        { className: 'vidiprinter-lines' },
        _react2.default.createElement(
          _reactAddonsCssTransitionGroup2.default,
          { transitionName: 'vidiprinter-newline', transitionEnterTimeout: highlightNewDataDuration, transitionLeaveTimeout: 1 },
          lines.map(transform)
        )
      );
    }
  }]);
  return FootballVidiprinter;
}(_react.Component), _class.propTypes = {
  data: _propTypes2.default.object
}, _temp);
exports.default = FootballVidiprinter;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.loadCompetition = loadCompetition;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_COMPETITION = 'football/competitions/LOAD_COMPETITION';
var LOAD_COMPETITION_SUCCESS = 'football/competitions/LOAD_COMPETITION_SUCCESS';
var LOAD_COMPETITION_FAIL = 'football/competitions/LOAD_COMPETITION_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_COMPETITION:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_COMPETITION_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          loading: false,
          loaded: true,
          selectedCompetition: action.result
        });
      }
    case LOAD_COMPETITION_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading(globalState) {
  return globalState.football && globalState.football.competition && globalState.football.competition.loading;
}

function loadCompetition(competitionId) {
  return {
    types: [LOAD_COMPETITION, LOAD_COMPETITION_SUCCESS, LOAD_COMPETITION_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.football.competitions + '/' + competitionId);
    }
  };
}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = undefined;

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends8 = __webpack_require__(7);

var _extends9 = _interopRequireDefault(_extends8);

exports.default = reducer;
exports.isLoadingByMatch = isLoadingByMatch;
exports.hasMatchCompetition = hasMatchCompetition;
exports.loadByMatch = loadByMatch;
exports.isLoadingByCompetition = isLoadingByCompetition;
exports.loadByCompetition = loadByCompetition;
exports.getByCompetition = getByCompetition;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'football/league-table/LOAD';
var LOAD_SUCCESS = 'football/league-table/LOAD_SUCCESS';
var LOAD_FAIL = 'football/league-table/LOAD_FAIL';

var initialState = {};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var seasonKey = action.season || 'current';
  var competition = action.competition;
  switch (action.type) {
    case LOAD:
      return (0, _extends9.default)({}, state, (0, _defineProperty3.default)({}, competition, (0, _extends9.default)({}, state[competition], (0, _defineProperty3.default)({}, seasonKey, (0, _extends9.default)({}, (state[competition] || {})[seasonKey], {
        loading: true
      })))));
    case LOAD_SUCCESS:
      return (0, _extends9.default)({}, state, (0, _defineProperty3.default)({}, competition, (0, _extends9.default)({}, state[competition], (0, _defineProperty3.default)({}, seasonKey, {
        loading: false,
        loaded: true,
        tables: action.result.tables
      }))));
    case LOAD_FAIL:
      return (0, _extends9.default)({}, state, (0, _defineProperty3.default)({}, competition, (0, _extends9.default)({}, state[competition], (0, _defineProperty3.default)({}, seasonKey, (0, _extends9.default)({}, (state[competition] || {})[seasonKey], {
        loading: false,
        loaded: false,
        error: action.error
      })))));
    default:
      return state;
  }
}

function getTableForMatchId(globalState, matchId) {
  // get the competition and season from the referenced match, which should already be in state
  var competitionId = getCompetitionIdFromMatchId(globalState, matchId);

  var seasonKey = 'current';
  return _lodash2.default.get(globalState.football.leagueTable, [competitionId, seasonKey], {});
}

function getMatchFromMatchId(globalState, matchId) {
  return _lodash2.default.get(globalState.football.match, [matchId, 'match'], null);
}

function getCompetitionIdFromMatchId(globalState, matchId) {
  return _lodash2.default.get(getMatchFromMatchId(globalState, matchId), "match_detail.competition.competition_reference.id", null);
}

function isLoadingByMatch(globalState, matchId) {
  return getTableForMatchId(globalState, matchId).loading;
}

function hasMatchCompetition(globalState, matchId) {
  return getCompetitionIdFromMatchId(globalState, matchId) !== null;
}

function loadByMatch(globalState, matchId) {
  // get the competition from the referenced match, which should already be in state
  var competition = getCompetitionIdFromMatchId(globalState, matchId);
  if (!competition) {
    return false;
  }

  return {
    competition: competition,
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.football.leagueTable, { params: { competition: competition } });
    }
  };
}

function isLoadingByCompetition(globalState) {
  var competition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";

  return _lodash2.default.get(globalState.football.leagueTable, [competition, "current"], {}).loading;
}

function loadByCompetition() {
  var competition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "default";
  var season = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "current";

  var params = void 0;

  if (competition == "default") {
    params = { default: true };
  } else if (season == "current") {
    params = { competition: competition };
  } else {
    params = { competition: competition, season: season };
  }

  return {
    competition: competition,
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.football.leagueTable, { params: params });
    }
  };
}

function getByCompetition(globalState) {
  var competition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
  var season = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "current";
  var _globalState$football = globalState.football.leagueTable[competition];
  _globalState$football = _globalState$football === undefined ? {} : _globalState$football;
  var _globalState$football2 = _globalState$football[season];
  _globalState$football2 = _globalState$football2 === undefined ? {} : _globalState$football2;
  var _globalState$football3 = _globalState$football2.tables,
      tables = _globalState$football3 === undefined ? [] : _globalState$football3;


  return tables;
}

var get = exports.get = getTableForMatchId;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MYSTABLE_EMAIL_UNSUBSCRIBE = exports.MYSTABLE_EMAIL_UNSUBSCRIBE = "MYSTABLE_EMAIL_UNSUBSCRIBE";
var MYSTABLE_EMAIL_UNSUBSCRIBE_SUCCESS = exports.MYSTABLE_EMAIL_UNSUBSCRIBE_SUCCESS = "MYSTABLE_EMAIL_UNSUBSCRIBE_SUCCESS";
var MYSTABLE_EMAIL_UNSUBSCRIBE_FAIL = exports.MYSTABLE_EMAIL_UNSUBSCRIBE_FAIL = "MYSTABLE_EMAIL_UNSUBSCRIBE_FAIL";

var myStableEmailUnsubscribe = exports.myStableEmailUnsubscribe = function myStableEmailUnsubscribe() {
    var email = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    return { type: MYSTABLE_EMAIL_UNSUBSCRIBE, token: token, email: email };
};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MyStableUnauthenticatedUser;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RegisterLoginButtons = __webpack_require__(165);

var _RegisterLoginButtons2 = _interopRequireDefault(_RegisterLoginButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function MyStableUnauthenticatedUser() {
  __webpack_require__(1440);

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'section',
      { className: 'my-stable-unauthenticated-user' },
      _react2.default.createElement(
        'h3',
        { className: 'section-title' },
        'Never Miss the Kick Again'
      ),
      _react2.default.createElement(
        'p',
        { className: 'section-subtitle' },
        'My Stable is FREE! Never miss a horse running again.'
      ),
      _react2.default.createElement(
        'p',
        null,
        'Let My Stable send you an e-mail to tell you:'
      ),
      _react2.default.createElement(
        'ul',
        { className: 'my-stable-benefits' },
        _react2.default.createElement(
          'li',
          null,
          'The night before any horse you\u2019ve added to your stable runs in the UK or Ireland or any of your trainers and jockeys have declared runners. This is all part of your free subscription.'
        ),
        _react2.default.createElement(
          'li',
          null,
          'Our fully automated database of all horses in training in the UK and Ireland will effortlessly assist you in setting up your stable of horses while we\'re also giving you the opportunity of staying on top of entries and runners from your favourite stables and jockeys.'
        )
      ),
      _react2.default.createElement(
        'p',
        null,
        'By registering you\u2019ll also receive access to our complete video form archive and have the ability to receive notifications of race results and/or football goalflashes direct to your phone. This unrivalled service is available completely free-of-charge on sportinglife.com.'
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(_RegisterLoginButtons2.default, null)
    )
  );
}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SubscriptionContainer = __webpack_require__(92);

var _SubscriptionContainer2 = _interopRequireDefault(_SubscriptionContainer);

var _MyStableButton = __webpack_require__(167);

var _MyStableButton2 = _interopRequireDefault(_MyStableButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProfileHeading = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(ProfileHeading, _PureComponent);

  function ProfileHeading() {
    (0, _classCallCheck3.default)(this, ProfileHeading);
    return (0, _possibleConstructorReturn3.default)(this, (ProfileHeading.__proto__ || (0, _getPrototypeOf2.default)(ProfileHeading)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProfileHeading, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          id = _props.id,
          name = _props.name,
          _props$classPrefix = _props.classPrefix,
          classPrefix = _props$classPrefix === undefined ? '' : _props$classPrefix;


      return _react2.default.createElement(
        'div',
        { className: classPrefix + '-profile-heading' },
        _react2.default.createElement(
          'h1',
          { className: classPrefix + '-profile-heading1' },
          name
        ),
        _react2.default.createElement(
          'div',
          { className: classPrefix + '-profile-heading-my-stable' },
          _react2.default.createElement(_SubscriptionContainer2.default, {
            addSubscriptions: [{ type: type, id: id, text: name }],
            icon: _react2.default.createElement(_MyStableButton2.default, null)
          })
        )
      );
    }
  }]);
  return ProfileHeading;
}(_react.PureComponent), _class.propTypes = {
  type: _propTypes2.default.string,
  id: _propTypes2.default.number,
  name: _propTypes2.default.string,
  classPrefix: _propTypes2.default.string
}, _temp);
exports.default = ProfileHeading;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var HORSE_SEXES = exports.HORSE_SEXES = {
  f: "Filly",
  c: "Colt",
  m: "Mare",
  h: "Horse",
  g: "Gelding",
  r: "Ridgling"
};

var TODAYS_RIDES_STRING = exports.TODAYS_RIDES_STRING = "Today's rides";
var TODAYS_ENTRIES_STRING = exports.TODAYS_ENTRIES_STRING = "Today's entries";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadRides = loadRides;
exports.loadRidesForArticle = loadRidesForArticle;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _widgets = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/rides/LOAD';
var LOAD_SUCCESS = 'horse-racing/rides/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/rides/LOAD_FAIL';

var initialState = {
  races: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      var mergedRaces = state.races ? [].concat((0, _toConsumableArray3.default)(state.races), (0, _toConsumableArray3.default)(action.result)) : action.result;

      return (0, _extends3.default)({}, state, {
        races: mergedRaces,
        loading: false,
        loaded: true,
        error: null
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function loadRides(idList) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.loadRace, { params: { ride_ids: idList.join(",") } });
    }
  };
}

function loadRidesForArticle(globalState, dispatch, article) {
  var idList = article.widgets.filter((0, _widgets.byMatching)({ type: "Racerunner" })).map(function (widget) {
    return (0, _widgets.getWidgetValue)(widget, "ride_id");
  });

  if (idList.length) {
    return dispatch(loadRides(idList));
  }

  return _promise2.default.resolve();
}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.getMediaWidgetIds = getMediaWidgetIds;
exports.getMetaDataWidget = getMetaDataWidget;
exports.getMetaDataWidgetValue = getMetaDataWidgetValue;
exports.getArticleWordCount = getArticleWordCount;
exports.getArticleReadTime = getArticleReadTime;

var _widgets = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*

WIDGET HELPERS

NB - very similar to (ie copied from from functions in) widgetHelpers.js in cms-web

*/
function getImageMediaIds(widgets) {
  return widgets.filter((0, _widgets.byMatching)({ type: "Image" }, {
    key: "media",
    value: "true"
  })).map(function (widget) {
    return (0, _widgets.getWidgetValue)(widget, "media_id");
  });
}

function getMediaIdsFromContent(content) {
  return (JSON.parse(content) || []).map(function (tip) {
    return tip.image_id;
  }).filter(function (imageId) {
    return !!imageId;
  }).map(function (imageId) {
    return imageId.toString();
  });
}

function getTipMediaIds(widgets) {
  return widgets.filter((0, _widgets.byMatching)({ type: "Tip" }, { key: "media", value: "true" })).map(function (widget) {
    return (0, _widgets.getWidgetValue)(widget, "tips");
  }).filter(function (tips) {
    return !!tips;
  }).reduce(function (acc, tip) {
    return acc.concat(getMediaIdsFromContent(tip));
  }, []);
}

function getMediaWidgetIds(widgets) {
  var imageMediaIds = getImageMediaIds(widgets);
  var tipMediaIds = getTipMediaIds(widgets);

  return imageMediaIds.concat(tipMediaIds);
}

/*

end WIDGET HELPERS copied from cms-web

*/

function getMetaDataWidget(widgets) {
  var _widgets$filter = widgets.filter((0, _widgets.byMatching)({ type: "MetaData" })),
      _widgets$filter2 = (0, _slicedToArray3.default)(_widgets$filter, 1),
      metaDataWidget = _widgets$filter2[0];

  return metaDataWidget;
}

function getMetaDataWidgetValue(widgets, key) {
  var metaDataWidget = getMetaDataWidget(widgets);

  if (metaDataWidget) {
    return (0, _widgets.getWidgetValue)(metaDataWidget, key);
  }
}

function getArticleWordCount(article) {
  var articleBodyWidgets = (0, _widgets.getBodyWidgets)(article.widgets);
  return articleBodyWidgets.reduce(function (previousValue, currentValue, index, array) {
    var widget = array[index];
    if (widget.widget_type) {
      var html = (0, _widgets.getWidgetValue)(widget, "html");
      if (!html) {
        return previousValue;
      }
      var text = html.replace(/<\/?[^>]+(>|$)/g, " ");

      return previousValue + text.split(' ').filter(function (word) {
        return word.length;
      }).length;
    }
  }, 0);
}

var WORDS_READ_PER_MINUTE = 250;

function getArticleReadTime(article) {
  var wordCount = getArticleWordCount(article);
  return Math.ceil(wordCount / WORDS_READ_PER_MINUTE);
}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OoyalaApiClient = undefined;

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(7);

var _extends4 = _interopRequireDefault(_extends3);

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _superagent = __webpack_require__(444);

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OoyalaApiClient = exports.OoyalaApiClient = function () {
  function OoyalaApiClient(client) {
    (0, _classCallCheck3.default)(this, OoyalaApiClient);

    this.client = client;
  }

  (0, _createClass3.default)(OoyalaApiClient, [{
    key: 'getAsset',
    value: function getAsset(id) {
      return _promise2.default.resolve();
    }
  }, {
    key: 'getClosestMatchingPreviewImage',
    value: function getClosestMatchingPreviewImage(width, height, assetData) {
      if (!assetData) {
        return null;
      }

      // 1. Group by aspect ratio (to 1 decimal place)
      var ratioFn = function ratioFn(w, h) {
        return Number((w / h).toFixed(1));
      };
      var diffFn = function diffFn(a, b) {
        return Math.abs(a - b);
      };
      var requiredRatio = ratioFn(width, height);

      var assetsByRatio = assetData.reduce(function (grouping, asset) {
        var ratio = ratioFn(asset.width, asset.height);
        var out = (0, _extends4.default)((0, _defineProperty3.default)({}, ratio, []), grouping); // default ratio group to an empty array.
        out[ratio].push(asset); // add the asset to the ratio group
        return out;
      }, {});

      // 2. find closest aspect ratio group
      var closestByRatio = (0, _keys2.default)(assetsByRatio).map(function (ratio) {
        return [diffFn(requiredRatio, ratio), assetsByRatio[ratio]];
      }) // Decorate with difference
      .sort(function (a, b) {
        return a[0] - b[0];
      }) // Sort by difference
      .map(function (pair) {
        return pair[1];
      })[0]; // Undecorate

      // 3. Sort group by closest to width.
      var closestByWidth = closestByRatio.map(function (asset) {
        return [diffFn(width, asset.width), asset];
      }) // Decorate with difference
      .sort(function (a, b) {
        return a[0] - b[0];
      }) // Sort by difference
      .map(function (pair) {
        return pair[1];
      })[0]; // Undecorate

      return closestByWidth;
    }
  }]);
  return OoyalaApiClient;
}();

var instance = new OoyalaApiClient(_superagent2.default);

exports.default = instance;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var VIDEO_FINISHED = exports.VIDEO_FINISHED = 'videoPlayed';
var PLAYBACK_READY = exports.PLAYBACK_READY = 'playbackReady';
var VIDEO_HMTL_CREATED = exports.VIDEO_HMTL_CREATED = 'videoControllerVideoElementCreated';
var VIDEO_STARTED = exports.VIDEO_STARTED = 'play';
var ALL_OOYALA_EVENTS = exports.ALL_OOYALA_EVENTS = '*';

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _AnalyticsEventMap = __webpack_require__(1052);

var _AnalyticsEventMap2 = _interopRequireDefault(_AnalyticsEventMap);

var _AnalyticsUtils = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Base class for all analytics Vendor APIs, in the form required for react-metrics

Vendor APIs should entend this and provide the following methods
  constructor(options), where options is the relevant configuration from config.js
  isSetUp(), which should return a boolean indicating if the vendors 3rd party code is set up and ready
  sendTracking(name, params, options), which delegates to the vendors own tracking call. All params come via the map
    name is the event name
    params is an object of the key/value pairs to send
    options is additional static data directly from the map
and optionally
  transformParams(params, map): Takes the params from the element, and transforms them according to the provided map
    This is likely to be unique per vendor, but analyticsUtils provides 3 useful helpers.

*/
var AnalyticsApi = function () {
  function AnalyticsApi(name, vendorId) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    (0, _classCallCheck3.default)(this, AnalyticsApi);

    this.name = name;
    this.vendorId = vendorId;
    this.options = options;
  }

  (0, _createClass3.default)(AnalyticsApi, [{
    key: 'pageView',
    value: function pageView(name, args) {
      var path = window.location.pathname.substr(1);
      args.pageUrl = window.location.href;

      if (path.substr(0, 14) !== "error/500/from") {
        return this.track(name, args);
      }
    }
  }, {
    key: 'user',
    value: function user(userId) {
      var _this = this;

      return new _promise2.default(function (resolve) {
        _this.userId = userId;
        resolve({
          userId: userId
        });
      });
    }
  }, {
    key: 'eventMapConfig',
    value: function eventMapConfig(eventName, args) {
      var _AnalyticsEventMap$ev = _AnalyticsEventMap2.default[eventName];
      _AnalyticsEventMap$ev = _AnalyticsEventMap$ev === undefined ? {} : _AnalyticsEventMap$ev;
      var eventMapConfig = _AnalyticsEventMap$ev[this.vendorId];


      if (eventMapConfig) {
        var _eventMapConfig$name = eventMapConfig.name,
            name = _eventMapConfig$name === undefined ? eventName : _eventMapConfig$name,
            _eventMapConfig$optio = eventMapConfig.options,
            options = _eventMapConfig$optio === undefined ? {} : _eventMapConfig$optio,
            _eventMapConfig$param = eventMapConfig.paramMap,
            paramMap = _eventMapConfig$param === undefined ? {} : _eventMapConfig$param;


        return {
          name: name,
          options: options,
          params: this.transformParams(args, paramMap)
        };
      }
    }
  }, {
    key: 'transformParams',
    value: function transformParams() {
      return _AnalyticsUtils.transformPlainParams.apply(undefined, arguments);
    }
  }, {
    key: 'track',
    value: function track(eventName, args) {
      if (this.isSetUp()) {
        var eventMapConfig = this.eventMapConfig(eventName, args);

        if (eventMapConfig) {
          var name = eventMapConfig.name,
              params = eventMapConfig.params,
              options = eventMapConfig.options;


          this.sendTracking(name, params, options);
        }
      }
    }
  }]);
  return AnalyticsApi;
}();

exports.default = AnalyticsApi;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AnalyticsApi2 = __webpack_require__(274);

var _AnalyticsApi3 = _interopRequireDefault(_AnalyticsApi2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoogleAnalytics = function (_AnalyticsApi) {
  (0, _inherits3.default)(GoogleAnalytics, _AnalyticsApi);

  function GoogleAnalytics(options) {
    (0, _classCallCheck3.default)(this, GoogleAnalytics);
    return (0, _possibleConstructorReturn3.default)(this, (GoogleAnalytics.__proto__ || (0, _getPrototypeOf2.default)(GoogleAnalytics)).call(this, "Google Analytics", "google", options));
  }

  (0, _createClass3.default)(GoogleAnalytics, [{
    key: "isSetUp",
    value: function isSetUp() {
      return !!window.ga;
    }
  }, {
    key: "sendTracking",
    value: function sendTracking(hitType, params) {
      window.ga('send', (0, _extends3.default)({ hitType: hitType }, params));
    }
  }]);
  return GoogleAnalytics;
}(_AnalyticsApi3.default);

exports.default = GoogleAnalytics;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nDayArrFactoryForwards = nDayArrFactoryForwards;
exports.nDayArrFactoryBackwards = nDayArrFactoryBackwards;
exports.nDayArrFactoryBoth = nDayArrFactoryBoth;
exports.stripTZD = stripTZD;

var _moment = __webpack_require__(8);

var _moment2 = _interopRequireDefault(_moment);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// how many days behind and ahead we want for sitemap fixtures/racecards
var _config$sitemap = _config2.default.sitemap,
    SITEMAP_DAYS_BEHIND = _config$sitemap.SITEMAP_DAYS_BEHIND,
    SITEMAP_DAYS_AHEAD = _config$sitemap.SITEMAP_DAYS_AHEAD;

// returns array of y days into the future

function nDayArrFactoryForwards() {
  var dateArray = [];
  var startDate = (0, _moment2.default)();

  // initial day
  dateArray.push(startDate.format('YYYY-MM-DD'));
  // loop
  for (var x = 0; x < SITEMAP_DAYS_AHEAD; x++) {
    dateArray.push(startDate.add(1, 'days').format('YYYY-MM-DD'));
  }

  return dateArray;
}

// returns array of x days into the past
function nDayArrFactoryBackwards() {
  var dateArray = [];
  var startDate = (0, _moment2.default)().subtract(SITEMAP_DAYS_BEHIND, 'days');

  // initial day
  dateArray.push(startDate.format('YYYY-MM-DD'));
  // loop
  for (var x = 0; x < SITEMAP_DAYS_AHEAD; x++) {
    dateArray.push(startDate.add(1, 'days').format('YYYY-MM-DD'));
  }

  return dateArray;
}

// returns array of past x days, today, and y days into the future
function nDayArrFactoryBoth() {
  var dateArray = [];
  var startDate = (0, _moment2.default)().subtract(SITEMAP_DAYS_BEHIND, 'days');

  // initial day
  dateArray.push(startDate.format('YYYY-MM-DD'));
  // loop
  for (var x = 0; x < SITEMAP_DAYS_BEHIND + SITEMAP_DAYS_AHEAD; x++) {
    dateArray.push(startDate.add(1, 'days').format('YYYY-MM-DD'));
  }

  return dateArray;
}

function stripTZD(time) {
  var trailingNumericTZD = /\+[0-9]{2}(:[0-9]{2})?$/;

  return time && ('' + time).replace(trailingNumericTZD, "");
}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscriptionDifference = undefined;

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

exports.flattenSubscriptions = flattenSubscriptions;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function accepts a list of subscription objects of any type as the first parameter
// and the current structured subscriptions from state.
//
// The list is will not contain any subscription IDs as they cannot be known ahead of time,
// so the IDs are looked up from the current subscription state object (second parameter)
// and then if there is a matching item, the ID is added to the subscription item from the list.
//
// The filtering is based on if this ID exists or not. If the difference parameter is set to false
// only the elements which have a subscription ID will be retured, i.e the elements we already know
// about, however if set to true, the set difference will be returned between known subscriptions
// and unknown given subscriptions.
var subscriptionDifference = exports.subscriptionDifference = function subscriptionDifference() {
  var addSubscriptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var subscriptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var difference = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return addSubscriptions.map(function (subscription) {
    var type = subscription.type,
        id = subscription.id;
    var _subscriptions$type = subscriptions[type];
    _subscriptions$type = _subscriptions$type === undefined ? {} : _subscriptions$type;
    var _subscriptions$type$i = _subscriptions$type[id],
        stateSubscription = _subscriptions$type$i === undefined ? {} : _subscriptions$type$i;


    subscription.subId = stateSubscription.subId || 0;
    return subscription;
  }).filter(function (subscription) {
    if (subscription.subId) {
      return !difference;
    } else {
      return difference;
    }
  });
};

function flattenSubscriptions(subscriptions) {
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var flatSubscriptions = [];

  filters.forEach(function (filter) {
    var subscriptionsSubset = subscriptions[filter];
    if (subscriptionsSubset) {
      (0, _keys2.default)(subscriptionsSubset).forEach(function (id) {
        flatSubscriptions.push({
          subscription_id: +id,
          subscription_type: filter
        });
      });
    }
  });

  return flatSubscriptions;
}

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(45);
var toAbsoluteIndex = __webpack_require__(130);
var toLength = __webpack_require__(41);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1064);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(40);
var createDesc = __webpack_require__(127);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
var document = __webpack_require__(19).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 282 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(33)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(19).document;
module.exports = document && document.documentElement;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
var setPrototypeOf = __webpack_require__(293).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(142);
var ITERATOR = __webpack_require__(33)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(124);
var descriptor = __webpack_require__(127);
var setToStringTag = __webpack_require__(143);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(56)(IteratorPrototype, __webpack_require__(33)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(123);
var $export = __webpack_require__(9);
var redefine = __webpack_require__(57);
var hide = __webpack_require__(56);
var has = __webpack_require__(55);
var Iterators = __webpack_require__(142);
var $iterCreate = __webpack_require__(287);
var setToStringTag = __webpack_require__(143);
var getPrototypeOf = __webpack_require__(67);
var ITERATOR = __webpack_require__(33)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 289 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 290 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var macrotask = __webpack_require__(299).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(73)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(49);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(26);
var anObject = __webpack_require__(16);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(74)(Function.call, __webpack_require__(66).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(230)('keys');
var uid = __webpack_require__(131);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(85);
var defined = __webpack_require__(83);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(224);
var defined = __webpack_require__(83);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(85);
var defined = __webpack_require__(83);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(74);
var invoke = __webpack_require__(456);
var html = __webpack_require__(284);
var cel = __webpack_require__(281);
var global = __webpack_require__(19);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(73)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var DESCRIPTORS = __webpack_require__(39);
var LIBRARY = __webpack_require__(123);
var $typed = __webpack_require__(232);
var hide = __webpack_require__(56);
var redefineAll = __webpack_require__(128);
var fails = __webpack_require__(25);
var anInstance = __webpack_require__(121);
var toInteger = __webpack_require__(85);
var toLength = __webpack_require__(41);
var toIndex = __webpack_require__(474);
var gOPN = __webpack_require__(125).f;
var dP = __webpack_require__(40).f;
var arrayFill = __webpack_require__(278);
var setToStringTag = __webpack_require__(143);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var core = __webpack_require__(82);
var LIBRARY = __webpack_require__(123);
var wksExt = __webpack_require__(475);
var defineProperty = __webpack_require__(40).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(177);
var ITERATOR = __webpack_require__(33)('iterator');
var Iterators = __webpack_require__(142);
module.exports = __webpack_require__(82).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(103);
var step = __webpack_require__(459);
var Iterators = __webpack_require__(142);
var toIObject = __webpack_require__(68);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(288)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1281), __esModule: true };

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1282), __esModule: true };

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 308 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(76);
var document = __webpack_require__(53).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 310 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(183);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(235);
var $export = __webpack_require__(42);
var redefine = __webpack_require__(498);
var hide = __webpack_require__(105);
var has = __webpack_require__(134);
var Iterators = __webpack_require__(149);
var $iterCreate = __webpack_require__(1301);
var setToStringTag = __webpack_require__(187);
var getPrototypeOf = __webpack_require__(493);
var ITERATOR = __webpack_require__(50)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(238)('meta');
var isObject = __webpack_require__(76);
var has = __webpack_require__(134);
var setDesc = __webpack_require__(77).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(133)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(182);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(185);
var createDesc = __webpack_require__(186);
var toIObject = __webpack_require__(106);
var toPrimitive = __webpack_require__(322);
var has = __webpack_require__(134);
var IE8_DOM_DEFINE = __webpack_require__(486);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(88) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 316 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(42);
var core = __webpack_require__(34);
var fails = __webpack_require__(133);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(105);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(320)('keys');
var uid = __webpack_require__(238);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(53);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 321 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(76);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(76);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(53);
var core = __webpack_require__(34);
var LIBRARY = __webpack_require__(235);
var wksExt = __webpack_require__(325);
var defineProperty = __webpack_require__(77).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(50);


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(234);
var ITERATOR = __webpack_require__(50)('iterator');
var Iterators = __webpack_require__(149);
module.exports = __webpack_require__(34).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(1348);
var isArguments = __webpack_require__(1347);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(108);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(530);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(525);




/* Node.js helper references. */
var nodeIsMap = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsMap) : __WEBPACK_IMPORTED_MODULE_0__baseIsMap_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isMap);


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(137);




/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == stringTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isString);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(137);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var tls = __webpack_require__(1663)

function buildBuilder (mqttClient, opts) {
  var connection
  opts.port = opts.port || 8883
  opts.host = opts.hostname || opts.host || 'localhost'

  opts.rejectUnauthorized = opts.rejectUnauthorized !== false

  delete opts.path

  connection = tls.connect(opts)
  /* eslint no-use-before-define: [2, "nofunc"] */
  connection.on('secureConnect', function () {
    if (opts.rejectUnauthorized && !connection.authorized) {
      connection.emit('error', new Error('TLS not authorized'))
    } else {
      connection.removeListener('error', handleTLSerrors)
    }
  })

  function handleTLSerrors (err) {
    // How can I get verify this error is a tls error?
    if (opts.rejectUnauthorized) {
      mqttClient.emit('error', err)
    }

    // close this connection to match the behaviour of net
    // otherwise all we get is an error from the connection
    // and close event doesn't fire. This is a work around
    // to enable the reconnect code to work the same as with
    // net.createConnection
    connection.end()
  }

  connection.on('error', handleTLSerrors)
  return connection
}

module.exports = buildBuilder


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.load = load;
exports.select = select;
exports.save = save;
exports.remove = remove;
exports.setRawCookie = setRawCookie;
exports.plugToRequest = plugToRequest;

var _cookie = __webpack_require__(1341);

var _cookie2 = _interopRequireDefault(_cookie);

var _objectAssign = __webpack_require__(155);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _isNode = __webpack_require__(1471);

var _isNode2 = _interopRequireDefault(_isNode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _rawCookie = {};
var _res = undefined;

function _isResWritable() {
  return _res && !_res.headersSent;
}

function load(name, doNotParse, opt) {
  var cookies = _isNode2.default ? _rawCookie : _cookie2.default.parse(document.cookie, opt);
  var cookieVal = cookies && cookies[name];

  if (typeof doNotParse === 'undefined') {
    doNotParse = !cookieVal || cookieVal[0] !== '{' && cookieVal[0] !== '[';
  }

  if (!doNotParse) {
    try {
      cookieVal = JSON.parse(cookieVal);
    } catch (e) {
      // Not serialized object
    }
  }

  return cookieVal;
}

function select(regex) {
  var cookies = _isNode2.default ? _rawCookie : _cookie2.default.parse(document.cookie);

  if (!cookies) {
    return {};
  }

  if (!regex) {
    return cookies;
  }

  return Object.keys(cookies).reduce(function (accumulator, name) {
    if (!regex.test(name)) {
      return accumulator;
    }

    var newCookie = {};
    newCookie[name] = cookies[name];
    return (0, _objectAssign2.default)({}, accumulator, newCookie);
  }, {});
}

function save(name, val, opt) {
  _rawCookie[name] = val;

  // allow you to work with cookies as objects.
  if ((typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object') {
    _rawCookie[name] = JSON.stringify(val);
  }

  // Cookies only work in the browser
  if (!_isNode2.default) {
    document.cookie = _cookie2.default.serialize(name, _rawCookie[name], opt);
  }

  if (_isResWritable() && _res.cookie) {
    var expressOpt = _extends({}, opt);
    if (expressOpt.maxAge) {
      // the standard for maxAge is seconds but express uses milliseconds
      expressOpt.maxAge = opt.maxAge * 1000;
    }

    _res.cookie(name, val, opt);
  }
}

function remove(name, opt) {
  delete _rawCookie[name];

  if (typeof opt === 'undefined') {
    opt = {};
  } else if (typeof opt === 'string') {
    // Will be deprecated in future versions
    opt = { path: opt };
  } else {
    // Prevent mutation of opt below
    opt = (0, _objectAssign2.default)({}, opt);
  }

  if (typeof document !== 'undefined') {
    opt.expires = new Date(1970, 1, 1, 0, 0, 1);
    opt.maxAge = 0;
    document.cookie = _cookie2.default.serialize(name, '', opt);
  }

  if (_isResWritable() && _res.clearCookie) {
    _res.clearCookie(name, opt);
  }
}

function setRawCookie(rawCookie) {
  if (rawCookie) {
    _rawCookie = _cookie2.default.parse(rawCookie);
  } else {
    _rawCookie = {};
  }
}

function plugToRequest(req, res) {
  if (req.cookie) {
    _rawCookie = req.cookie;
  } else if (req.cookies) {
    _rawCookie = req.cookies;
  } else if (req.headers && req.headers.cookie) {
    setRawCookie(req.headers.cookie);
  } else {
    _rawCookie = {};
  }

  _res = res;

  return function unplug() {
    _res = null;
    _rawCookie = {};
  };
}

exports.default = {
  setRawCookie: setRawCookie,
  load: load,
  select: select,
  save: save,
  remove: remove,
  plugToRequest: plugToRequest
};

/***/ }),
/* 340 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Events = {
    READY: "ready",
    RENDER: "render",
    SLOT_RENDER_ENDED: "slotRenderEnded",
    IMPRESSION_VIEWABLE: "impressionViewable",
    SLOT_VISIBILITY_CHANGED: "slotVisibilityChanged"
};

exports.default = Events;

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["a"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routerShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locationShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getRouteParams__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouteUtils__ = __webpack_require__(110);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };










/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_3_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__RouteUtils__["b" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(159);

var _DOMUtils = __webpack_require__(244);

var _DOMStateStorage = __webpack_require__(688);

var _PathUtils = __webpack_require__(111);

var _ExecutionEnvironment = __webpack_require__(346);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(1589);

var _PathUtils = __webpack_require__(111);

var _runTransitionHook = __webpack_require__(348);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(243);

var _LocationUtils = __webpack_require__(159);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(98);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ownKeys;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isMap__ = __webpack_require__(334);


function ownKeys(object) {

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isMap__["a" /* default */])(object)) {
    return Array.from(object.keys());
  }

  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
    return Reflect.ownKeys(object);
  }

  var keys = Object.getOwnPropertyNames(object);

  if (typeof Object.getOwnPropertySymbols === 'function') {
    keys = keys.concat(Object.getOwnPropertySymbols(object));
  }

  return keys;
}

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _objectWithoutProperties2 = __webpack_require__(148);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _typeof2 = __webpack_require__(132);

var _typeof3 = _interopRequireDefault(_typeof2);

exports.isPromise = isPromise;
exports.eachComponents = eachComponents;
exports.filterAndFlattenComponents = filterAndFlattenComponents;
exports.filterAndLayerComponents = filterAndLayerComponents;
exports.loadAsyncConnect = loadAsyncConnect;
exports.loadOnServer = loadOnServer;

var _store = __webpack_require__(247);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Tells us if input looks like promise or not
 * @param  {Mixed} obj
 * @return {Boolean}
 */
function isPromise(obj) {
  return (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) === 'object' && obj && obj.then instanceof Function;
}

/**
 * Utility to be able to iterate over array of promises in an async fashion
 * @param  {Array} iterable
 * @param  {Function} iterator
 * @return {Promise}
 */
var mapSeries = _promise2.default.mapSeries || function promiseMapSeries(iterable, iterator) {
  var length = iterable.length;
  var results = new Array(length);
  var i = 0;

  return _promise2.default.resolve().then(function iterateOverResults() {
    return iterator(iterable[i], i, iterable).then(function (result) {
      results[i] = result;
      i += 1;
      if (i < length) {
        return iterateOverResults();
      }

      return results;
    });
  });
};

/**
 * We need to iterate over all components for specified routes.
 * Components array can include objects if named components are used:
 * https://github.com/rackt/react-router/blob/latest/docs/API.md#named-components
 *
 * @param components
 * @param iterator
 */
function eachComponents(components, iterator) {
  var l = components.length;

  var _loop = function _loop(i) {
    var component = components[i];
    if ((typeof component === 'undefined' ? 'undefined' : (0, _typeof3.default)(component)) === 'object') {
      var keys = (0, _keys2.default)(component);
      keys.forEach(function (key) {
        return iterator(component[key], i, key);
      });
    } else {
      iterator(component, i);
    }
  };

  for (var i = 0; i < l; i += 1) {
    _loop(i);
  }
}

/**
 * Returns flattened array of components that are wrapped with reduxAsyncConnect
 * @param  {Array} components
 * @return {Array}
 */
function filterAndFlattenComponents(components) {
  var flattened = [];
  eachComponents(components, function (component) {
    if (component && component.reduxAsyncConnect) {
      flattened.push(component);
    }
  });
  return flattened;
}

/**
 * Returns an array of an array of components on the same layers that are wrapped
 * with reduxAsyncConnect
 * @param  {Array} components
 * @return {Array}
 */
function filterAndLayerComponents(components) {
  var layered = [];
  var l = components.length;

  var _loop2 = function _loop2(i) {
    var component = components[i];
    if ((typeof component === 'undefined' ? 'undefined' : (0, _typeof3.default)(component)) === 'object') {
      var keys = (0, _keys2.default)(component);
      var componentLayer = [];
      keys.forEach(function (key) {
        if (component[key] && component[key].reduxAsyncConnect) {
          componentLayer.push(component[key]);
        }
      });
      if (componentLayer.length > 0) {
        layered.push(componentLayer);
      }
    } else if (component && component.reduxAsyncConnect) {
      layered.push([component]);
    }
  };

  for (var i = 0; i < l; i += 1) {
    _loop2(i);
  }
  return layered;
}

/**
 * Function that accepts components with reduxAsyncConnect definitions
 * and loads data
 * @param  {Object} data.components
 * @param  {Function} [data.filter] - filtering function
 * @return {Promise}
 */
function loadAsyncConnect(_ref) {
  var _ref$components = _ref.components,
      components = _ref$components === undefined ? [] : _ref$components,
      _ref$filter = _ref.filter,
      filter = _ref$filter === undefined ? function () {
    return true;
  } : _ref$filter,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['components', 'filter']);

  var layered = filterAndLayerComponents(components);

  if (layered.length === 0) {
    return _promise2.default.resolve();
  }

  // this allows us to have nested promises, that rely on each other's completion
  // cycle
  return mapSeries(layered, function (componentArr) {
    if (componentArr.length === 0) {
      return _promise2.default.resolve();
    }
    // Collect the results of each component on current layer.
    var results = [];
    var asyncItemsArr = [];

    var _loop3 = function _loop3(i) {
      var component = componentArr[i];
      var asyncItems = component.reduxAsyncConnect;
      asyncItemsArr.push.apply(asyncItemsArr, asyncItems);

      // get array of results
      results.push.apply(results, asyncItems.reduce(function (itemsResults, item) {
        if (filter(item, component)) {
          var promiseOrResult = item.promise(rest);

          if (isPromise(promiseOrResult)) {
            promiseOrResult = promiseOrResult.catch(function (error) {
              return { error: error };
            });
          }

          itemsResults.push(promiseOrResult);
        }

        return itemsResults;
      }, []));
    };

    for (var i = 0; i < componentArr.length; i += 1) {
      _loop3(i);
    }

    return _promise2.default.all(results).then(function (finalResults) {
      return finalResults.reduce(function (finalResult, result, idx) {
        var key = asyncItemsArr[idx].key;

        if (key) {
          finalResult[key] = result;
        }

        return finalResult;
      }, {});
    });
  });
}

/**
 * Helper to load data on server
 * @param  {Mixed} args
 * @return {Promise}
 */
function loadOnServer(args) {
  return loadAsyncConnect(args).then(function () {
    args.store.dispatch((0, _store.endGlobalLoad)());
  });
}

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.setToMutableStateFunc = exports.setToImmutableStateFunc = exports.immutableReducer = exports.reducer = exports.loadOnServer = exports.asyncConnect = exports.ReduxAsyncConnect = undefined;

var _decorator = __webpack_require__(1624);

Object.defineProperty(exports, 'asyncConnect', {
  enumerable: true,
  get: function get() {
    return _decorator.asyncConnect;
  }
});

var _utils = __webpack_require__(350);

Object.defineProperty(exports, 'loadOnServer', {
  enumerable: true,
  get: function get() {
    return _utils.loadOnServer;
  }
});

var _store = __webpack_require__(247);

Object.defineProperty(exports, 'reducer', {
  enumerable: true,
  get: function get() {
    return _store.reducer;
  }
});
Object.defineProperty(exports, 'immutableReducer', {
  enumerable: true,
  get: function get() {
    return _store.immutableReducer;
  }
});

var _state = __webpack_require__(246);

Object.defineProperty(exports, 'setToImmutableStateFunc', {
  enumerable: true,
  get: function get() {
    return _state.setToImmutableStateFunc;
  }
});
Object.defineProperty(exports, 'setToMutableStateFunc', {
  enumerable: true,
  get: function get() {
    return _state.setToMutableStateFunc;
  }
});

var _AsyncConnect = __webpack_require__(1623);

var _AsyncConnect2 = _interopRequireDefault(_AsyncConnect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ReduxAsyncConnect = _AsyncConnect2.default;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(1536);
var util = __webpack_require__(1655);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(667);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 353 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AuthorAvatar;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AuthorAvatar(_ref) {
  var onClick = _ref.onClick,
      image = _ref.image,
      size = _ref.size;

  __webpack_require__(1359);

  return _react2.default.createElement('img', { className: ["author-avatar", size].join(' ').trim(), onClick: onClick, src: image ? '/' + image : "/img/default-profile.svg" });
}

AuthorAvatar.propTypes = {
  onClick: _propTypes2.default.func,
  image: _propTypes2.default.string,
  size: _propTypes2.default.string
};

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Cloth;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1361);

/*
  NB: Numbers are sent from the API and tied to specific styles.
  If dog is not running, override number with 'nr' to get disabled effect
*/

function Cloth(props) {
  var number = props.number;


  return _react2.default.createElement(
    'div',
    { className: 'cloth-' + number },
    number
  );
}

Cloth.propTypes = {
  number: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired
};

Cloth.defaultProps = {
  number: 'nr'
};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /*
                   
                   A Date Picker is a field of links that end in an ISO date, with some navigation, presented in a popup.
                   
                   There are 4 props;
                     earliestDate: the earliest date that can be selected. Optional, and defaults to "2005-01-01"
                     latestDate: the latest date that can be selected. Optional, and defaults to today
                     date: the initial date that the is selected in the popup
                     urlBase: the base on which all the Link hrefs are based
                   
                   At first implementation, this is only used on the Horse racing full results list. Where easy it has been coded to be generic, but this is not universal.
                   
                   */


var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _CalendarIcon = __webpack_require__(764);

var _CalendarIcon2 = _interopRequireDefault(_CalendarIcon);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _commonUtils = __webpack_require__(36);

var _LocalDateTimeHelper = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1365);

var earliestDataDate = "2005-01-01";

var DatePicker = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DatePicker, _Component);

  function DatePicker() {
    var _ref;

    (0, _classCallCheck3.default)(this, DatePicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePicker.__proto__ || (0, _getPrototypeOf2.default)(DatePicker)).call.apply(_ref, [this].concat(args)));

    _this.todayIso = (0, _LocalDateTimeHelper.isoDate)(new Date());

    _this.state = _this.initState(_this.props);
    _this.removeDocumentClickToClose = function () {}; // initial noop, gets reassigned by addDocumentClickToClose
    return _this;
  }

  (0, _createClass3.default)(DatePicker, [{
    key: 'initState',
    value: function initState(props) {
      var date = props.date,
          _props$earliestDate = props.earliestDate,
          earliestDate = _props$earliestDate === undefined ? earliestDataDate : _props$earliestDate,
          _props$latestDate = props.latestDate,
          latestDate = _props$latestDate === undefined ? this.todayIso : _props$latestDate;


      this.initialDate = date;
      this.selectedDate = new Date(date);
      this.selectedDate.setDate(1); // prevent issues with days that aren't in every month (eg 31st) and this is only to get the month

      this.earliestDate = new Date(earliestDate);
      this.latestDate = new Date(latestDate);

      return (0, _extends3.default)({
        popupOpen: false
      }, this.getStateForSelectedDate());
    }
  }, {
    key: 'togglePopup',
    value: function togglePopup() {
      var _this2 = this;

      var isOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.state.popupOpen;

      this.setState({
        popupOpen: isOpen
      }, function () {
        if (isOpen) {
          _this2.addDocumentClickToClose();
        } else {
          _this2.removeDocumentClickToClose();
        }
      });
    }
  }, {
    key: 'addDocumentClickToClose',
    value: function addDocumentClickToClose() {
      var _this3 = this;

      this.removeDocumentClickToClose(); // remove any existing - there can be only one

      var closePopup = function closePopup(e) {
        // unique new function for this time
        if (!(_this3.popupDomElement && _this3.popupDomElement.contains(e.target))) {
          _this3.togglePopup(false);
        }
      };

      document.addEventListener("click", closePopup, false); // add it

      this.removeDocumentClickToClose = function () {
        // store a function to remove it
        document.removeEventListener("click", closePopup);
        _this3.removeDocumentClickToClose = function () {}; // reset self
      };
    }
  }, {
    key: 'getStateForSelectedDate',
    value: function getStateForSelectedDate() {
      return {
        displayDate: new Date(this.selectedDate),
        currentMonth: this.getDisplayRange()
      };
    }
  }, {
    key: 'moveMonth',
    value: function moveMonth(by) {
      this.selectedDate.setMonth(this.selectedDate.getMonth() + by);
      this.setState(this.getStateForSelectedDate());
    }
  }, {
    key: 'moveYear',
    value: function moveYear(by) {
      this.selectedDate.setFullYear(this.selectedDate.getFullYear() + by);
      this.setState(this.getStateForSelectedDate());
    }
  }, {
    key: 'inRange',
    value: function inRange(testDate) {
      return testDate <= this.latestDate && testDate >= this.earliestDate;
    }
  }, {
    key: 'cantMoveMonth',
    value: function cantMoveMonth(by) {
      var testDate = new Date(this.selectedDate);
      testDate.setMonth(testDate.getMonth() + by);
      return !this.inRange(testDate);
    }
  }, {
    key: 'cantMoveYear',
    value: function cantMoveYear(by) {
      var testDate = new Date(this.selectedDate);
      testDate.setFullYear(testDate.getFullYear() + by);
      return !this.inRange(testDate);
    }
  }, {
    key: 'getDisplayRange',
    value: function getDisplayRange() {
      // this.selectedDate is always the 1st of the month, because the constructor sets it
      var start = new Date(this.selectedDate);

      // back to Monday
      start.setDate(2 - (start.getDay() || 7));

      var end = new Date(this.selectedDate);

      // last day of the month
      end.setMonth(end.getMonth() + 1);
      end.setDate(0);
      end.setHours(1, 0, 0, 0);

      // forward to Sunday
      end.setDate(end.getDate() + 7 - (end.getDay() || 7));

      var range = [];

      var current = new Date(start);
      current.setHours(1, 0, 0, 0);

      while (current - end <= 2 * 60 * 60 * 1000) {
        // can get confused by DST change, so allow a margin
        range.push({
          src: new Date(current),
          date: (0, _LocalDateTimeHelper.isoDate)(current),
          label: current.getDate(),
          inMonth: current.getMonth() == this.selectedDate.getMonth(),
          inRange: this.inRange(current)
        });

        current.setDate(current.getDate() + 1);
      }

      return range;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeDocumentClickToClose();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.date != this.props.date) {
        this.setState(this.initState(newProps));
      }
    }
  }, {
    key: 'getDomElements',
    value: function getDomElements(el) {
      if (el) {
        this.popupDomElement = el;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          urlBase = _props.urlBase,
          children = _props.children;


      var momentDisplay = (0, _LocalDateTimeHelper.momentInUTC)(this.state.displayDate);
      var monthLabel = momentDisplay.format("MMMM");
      var yearLabel = momentDisplay.format("YYYY");

      return _react2.default.createElement(
        'nav',
        { className: 'date-picker' },
        _react2.default.createElement(
          'button',
          { className: 'date-picker-icon-button', onClick: function onClick() {
              return _this4.togglePopup();
            } },
          _react2.default.createElement(_CalendarIcon2.default, null)
        ),
        _react2.default.createElement(
          'div',
          { className: 'date-picker-popup' + (this.state.popupOpen ? "-open" : ""), ref: function ref(el) {
              return _this4.getDomElements(el);
            } },
          _react2.default.createElement(
            'div',
            { className: 'date-picker-heading' },
            _react2.default.createElement(
              'div',
              { className: 'date-picker-caret' },
              _react2.default.createElement(
                'button',
                { disabled: this.cantMoveMonth(-1), onClick: function onClick() {
                    return _this4.moveMonth(-1);
                  } },
                _react2.default.createElement(_CaretIcon2.default, { direction: 'left', type: 'line' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'date-picker-month-label' },
              monthLabel
            ),
            _react2.default.createElement(
              'div',
              { className: 'date-picker-caret' },
              _react2.default.createElement(
                'button',
                { disabled: this.cantMoveMonth(1), onClick: function onClick() {
                    return _this4.moveMonth(1);
                  } },
                _react2.default.createElement(_CaretIcon2.default, { direction: 'right', type: 'line' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'date-picker-caret' },
              _react2.default.createElement(
                'button',
                { disabled: this.cantMoveYear(-1), onClick: function onClick() {
                    return _this4.moveYear(-1);
                  } },
                _react2.default.createElement(_CaretIcon2.default, { direction: 'left', type: 'line' })
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'date-picker-year-label' },
              yearLabel
            ),
            _react2.default.createElement(
              'div',
              { className: 'date-picker-caret' },
              _react2.default.createElement(
                'button',
                { disabled: this.cantMoveYear(1), onClick: function onClick() {
                    return _this4.moveYear(1);
                  } },
                _react2.default.createElement(_CaretIcon2.default, { direction: 'right', type: 'line' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'date-picker-row' },
            _react2.default.createElement(
              'div',
              { className: 'date-picker-label' },
              'Mon'
            ),
            _react2.default.createElement(
              'div',
              { className: 'date-picker-label' },
              'Tue'
            ),
            _react2.default.createElement(
              'div',
              { className: 'date-picker-label' },
              'Wed'
            ),
            _react2.default.createElement(
              'div',
              { className: 'date-picker-label' },
              'Thu'
            ),
            _react2.default.createElement(
              'div',
              { className: 'date-picker-label' },
              'Fri'
            ),
            _react2.default.createElement(
              'div',
              { className: 'date-picker-label' },
              'Sat'
            ),
            _react2.default.createElement(
              'div',
              { className: 'date-picker-label' },
              'Sun'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'date-picker-row' },
            this.state.currentMonth.map(function (day) {
              var href = void 0,
                  className = void 0;
              var key = day.date;

              if (_this4.todayIso == day.date) {
                href = urlBase;
              } else {
                href = urlBase + '/' + day.date;
              }

              if (day.inMonth) {
                className = "date-picker-in-month";
              } else {
                className = "date-picker-ex-month";
              }

              if (_this4.initialDate == day.date) {
                className = className + ' date-picker-initial';
              }

              if (day.inRange) {
                return _react2.default.createElement(
                  _reactRouter.Link,
                  (0, _extends3.default)({ key: key, className: className }, { to: (0, _commonUtils.preventLinkScroll)(href), onClick: function onClick() {
                      return _this4.togglePopup(false);
                    } }),
                  day.label
                );
              } else {
                return _react2.default.createElement(
                  'span',
                  { key: key, className: className },
                  day.label
                );
              }
            })
          ),
          children
        )
      );
    }
  }]);
  return DatePicker;
}(_react.Component), _class.propTypes = {
  earliestDate: _propTypes2.default.string,
  latestDate: _propTypes2.default.string,
  date: _propTypes2.default.string,
  urlBase: _propTypes2.default.string,
  children: _propTypes2.default.node
}, _temp);
exports.default = DatePicker;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EnhancedLoginPromptHeading = undefined;
exports.default = EnhancedLoginPrompt;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RegisterLoginButtons = __webpack_require__(165);

var _RegisterLoginButtons2 = _interopRequireDefault(_RegisterLoginButtons);

var _MyStableIcon = __webpack_require__(254);

var _MyStableIcon2 = _interopRequireDefault(_MyStableIcon);

var _NotificationsIcon = __webpack_require__(766);

var _NotificationsIcon2 = _interopRequireDefault(_NotificationsIcon);

var _VideoIcon = __webpack_require__(772);

var _VideoIcon2 = _interopRequireDefault(_VideoIcon);

var _StarIcon = __webpack_require__(369);

var _StarIcon2 = _interopRequireDefault(_StarIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function EnhancedLoginPrompt(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? "standard" : _ref$size,
      _ref$showLoginBenefit = _ref.showLoginBenefits,
      showLoginBenefits = _ref$showLoginBenefit === undefined ? true : _ref$showLoginBenefit;

  __webpack_require__(1370);

  var logos = [["sportinglife", "itv7-solid", "skybet"], ["super6-solid", "fantasyfootball-solid", "fantasysixaside-solid"]];

  var img = function img(logo) {
    return _react2.default.createElement('img', { key: logo, className: 'icon ' + logo, src: '/img/login-prompt-logos/' + logo + '.png' });
  };

  return _react2.default.createElement(
    'div',
    { className: 'enhanced-login-prompt-' + size },
    _react2.default.createElement(
      'div',
      { className: 'enhanced-login-prompt-accounts' },
      _react2.default.createElement(
        'div',
        { className: 'enhanced-login-prompt-accounts-text' },
        'You can log into Sporting Life with any of the following accounts:'
      ),
      _react2.default.createElement(
        'div',
        { className: 'enhanced-login-prompt-accounts-icons' },
        logos.map(function (row, i) {
          return _react2.default.createElement(
            'span',
            { key: i, className: 'enhanced-login-prompt-accounts-row' },
            row.map(img)
          );
        })
      )
    ),
    showLoginBenefits && _react2.default.createElement(
      'div',
      { className: 'enhanced-login-prompt-benefits' },
      _react2.default.createElement(
        'div',
        null,
        'Don\'t have any of these accounts? Register to enjoy the benefits of logging in:'
      ),
      _react2.default.createElement(
        'div',
        { className: 'enhanced-login-prompt-benefit-list' },
        _react2.default.createElement(
          'span',
          { className: 'enhanced-login-prompt-benefit' },
          _react2.default.createElement(_MyStableIcon2.default, { title: 'My Stable' }),
          ' My Stable'
        ),
        " ",
        _react2.default.createElement(
          'span',
          { className: 'enhanced-login-prompt-benefit' },
          _react2.default.createElement(_NotificationsIcon2.default, null),
          ' Live notifications'
        ),
        " ",
        _react2.default.createElement(
          'span',
          { className: 'enhanced-login-prompt-benefit' },
          _react2.default.createElement(_VideoIcon2.default, null),
          ' Video form'
        ),
        " ",
        _react2.default.createElement(
          'span',
          { className: 'enhanced-login-prompt-benefit' },
          _react2.default.createElement(_StarIcon2.default, { title: 'Offers' }),
          ' Exclusive offers & content'
        )
      )
    ),
    _react2.default.createElement(_RegisterLoginButtons2.default, null)
  );
}

EnhancedLoginPrompt.propTypes = {
  size: _propTypes2.default.string
};

var EnhancedLoginPromptHeading = exports.EnhancedLoginPromptHeading = "Log in for access to this exclusive content.";

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lightbox = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1378);

var Lightbox = exports.Lightbox = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Lightbox, _Component);

  function Lightbox() {
    var _ref;

    (0, _classCallCheck3.default)(this, Lightbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Lightbox.__proto__ || (0, _getPrototypeOf2.default)(Lightbox)).call.apply(_ref, [this].concat(args)));

    _this.closeLightbox = function () {
      _this.props.close();
    };

    _this.state = {
      disableOverlayClose: _this.props.disableOverlayClose
    };
    return _this;
  }

  (0, _createClass3.default)(Lightbox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var next = nextProps.disableOverlayClose;
      var current = this.props.disableOverlayClose;


      if (next !== current) {
        if (next) {
          // disable immediately
          this.setState({ disableOverlayClose: true });
        } else {
          // enable after a short delay, to allow for use on a blur event
          this.timeout = window.setTimeout(function () {
            return _this2.setState({ disableOverlayClose: false });
          }, 100);
        }
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      // stop bg behind overlay being scrollable
      document.querySelector("body").classList.add("no-scroll");
      // allow escape to hide lb
      this.closeLb = function (evt) {
        if (!_this3.props.disableEscClose && (evt.key === "Escape" || evt.keyCode === 27)) {
          _this3.props.close();
        }
      };
      this.escapeEventHandler = document.addEventListener('keyup', this.closeLb);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.querySelector("body").classList.remove("no-scroll");

      // unbind keyup event
      document.removeEventListener('keyup', this.closeLb);

      // clear any pending timeout for enabling overlay clicks
      window.clearTimeout(this.timeout);
    }
  }, {
    key: 'overlayClick',
    value: function overlayClick() {
      if (!this.state.disableOverlayClose) {
        this.closeLightbox();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'lb-container' },
        _react2.default.createElement('div', { className: 'lb-bg-overlay', onClick: function onClick() {
            return _this4.overlayClick();
          } }),
        _react2.default.createElement(
          'div',
          { className: 'lb', id: 'lb' },
          _react2.default.createElement(
            'div',
            { className: 'lb-title' },
            _react2.default.createElement(
              'span',
              null,
              this.props.title
            ),
            _react2.default.createElement(
              'a',
              { className: 'lb-close', onClick: function onClick() {
                  return _this4.closeLightbox();
                } },
              '\xD7'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'lb-content' },
            this.props.children
          )
        )
      );
    }
  }]);
  return Lightbox;
}(_react.Component), _class.propTypes = {
  data: _propTypes2.default.object,
  disableOverlayClose: _propTypes2.default.bool,
  disableEscClose: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  close: _propTypes2.default.func.isRequired,
  title: _propTypes2.default.string
}, _temp);

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Notification;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CloseIcon = __webpack_require__(765);

var _CloseIcon2 = _interopRequireDefault(_CloseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1381);

function Notification(_ref) {
    var _ref$showClose = _ref.showClose,
        showClose = _ref$showClose === undefined ? true : _ref$showClose,
        children = _ref.children,
        onDismiss = _ref.onDismiss,
        className = _ref.className;


    return _react2.default.createElement(
        'div',
        { className: [className, "notification"].join(' ') },
        _react2.default.createElement(
            'div',
            { className: 'notification-content' },
            children,
            showClose ? _react2.default.createElement(
                'button',
                { className: 'close', onClick: onDismiss },
                _react2.default.createElement(_CloseIcon2.default, null)
            ) : null
        ),
        _react2.default.createElement('div', { className: 'notification-background' })
    );
}

Notification.propTypes = {
    showClose: _propTypes2.default.bool,
    children: _propTypes2.default.object,
    onDismiss: _propTypes2.default.func,
    className: _propTypes2.default.string
};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CheckIcon = __webpack_require__(365);

var _CheckIcon2 = _interopRequireDefault(_CheckIcon);

__webpack_require__(1386);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubmitButton = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(SubmitButton, _Component);

    function SubmitButton() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SubmitButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SubmitButton.__proto__ || (0, _getPrototypeOf2.default)(SubmitButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            btnStatus: ''
        }, _this.handleOnClick = function (event) {
            event.preventDefault();
            if (_this.state.btnStatus === '') {
                _this.setState({ btnStatus: 'loading' });
            }
            _this.props.onClickAction();
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SubmitButton, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var btnStatus = prevState.btnStatus;
            if (this.props.successResult === true) {
                btnStatus = 'checked';
            } else if (this.props.successResult === false) {
                btnStatus = 'failed';
            }

            if (btnStatus !== prevState.btnStatus) {
                //ok to use setState here as wrapped in a condition 
                this.setState({ btnStatus: btnStatus }); //eslint-disable-line react/no-did-update-set-state
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$formRef = _props.formRef,
                formRef = _props$formRef === undefined ? '' : _props$formRef,
                _props$btnClass = _props.btnClass,
                btnClass = _props$btnClass === undefined ? 'submit-btn-default' : _props$btnClass;

            return _react2.default.createElement(
                'button',
                {
                    disabled: this.props.disabled,
                    className: 'submit-btn ' + btnClass + ' ' + this.state.btnStatus,
                    onClick: this.handleOnClick,
                    type: 'submit',
                    form: formRef
                },
                this.props.label,
                _react2.default.createElement(
                    'span',
                    null,
                    '.'
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    '.'
                ),
                _react2.default.createElement(
                    'span',
                    null,
                    '.'
                ),
                _react2.default.createElement(_CheckIcon2.default, { title: 'Successful ' + this.props.label })
            );
        }
    }]);
    return SubmitButton;
}(_react.Component), _class.propTypes = {
    label: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.bool.isRequired,
    onClickAction: _propTypes2.default.func.isRequired,
    successResult: _propTypes2.default.bool,
    formRef: _propTypes2.default.string,
    btnClass: _propTypes2.default.string
}, _temp2);
exports.default = SubmitButton;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = Table;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TableRow = __webpack_require__(750);

var _TableRow2 = _interopRequireDefault(_TableRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Table(props) {
  if (!props.row || !props.row.length) {
    return false;
  }

  return _react2.default.createElement(
    'table',
    null,
    _react2.default.createElement(
      'tbody',
      null,
      props.row.map(function (row, index) {
        return _react2.default.createElement(_TableRow2.default, (0, _extends3.default)({ key: index }, row));
      })
    )
  );
}

Table.propTypes = {
  row: _propTypes2.default.array
};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TipsSection;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _CaretLink = __webpack_require__(54);

var _CaretLink2 = _interopRequireDefault(_CaretLink);

var _StorySummary = __webpack_require__(215);

var _StorySummary2 = _interopRequireDefault(_StorySummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(507);

function TipsSection(_ref) {
  var sectionLabel = _ref.sectionLabel,
      tipsItems = _ref.tipsItems,
      _ref$additionalTipsLi = _ref.additionalTipsLinks,
      additionalTipsLinks = _ref$additionalTipsLi === undefined ? [] : _ref$additionalTipsLi,
      _ref$plainTitle = _ref.plainTitle,
      plainTitle = _ref$plainTitle === undefined ? false : _ref$plainTitle;

  if (tipsItems.length > 0) {
    var titleClass = "section-title";

    if (plainTitle === true) {
      titleClass = titleClass + ' ' + titleClass + '-plain';
    } else {
      titleClass = titleClass + ' ' + titleClass + '-full';
    }

    var mainLink = additionalTipsLinks && additionalTipsLinks.length > 0 ? additionalTipsLinks[0].href : null;
    var title = sectionLabel + ' Tips';

    return _react2.default.createElement(
      'section',
      { className: 'sport-section' },
      _react2.default.createElement(
        'h3',
        { className: titleClass },
        mainLink ? _react2.default.createElement(
          _reactRouter.Link,
          { to: mainLink },
          title
        ) : title
      ),
      _react2.default.createElement(
        'section',
        { className: 'sport-tips' },
        tipsItems.map(function (item) {
          return _react2.default.createElement(_StorySummary2.default, { key: item.article_reference.id, imageType: 'tipArticle', data: item, metaDataFlags: { category: false, byline: true } });
        })
      ),
      _react2.default.createElement(
        'div',
        { className: 'action-links sport-links' },
        additionalTipsLinks.map(function (link, idx) {
          var classList = ["section-button"];
          idx === 0 && additionalTipsLinks.length > 1 ? classList.push("large-primary-blue-button") : classList.push("large-primary-button");
          return _react2.default.createElement(
            _reactRouter.Link,
            { className: classList.join(' '), key: link.href + ':' + link.text, to: link.href },
            link.text
          );
        })
      )
    );
  } else {
    return null;
  }
}

TipsSection.propTypes = {
  plainTitle: _propTypes2.default.bool,
  sectionLabel: _propTypes2.default.string.isRequired,
  sectionLink: _propTypes2.default.string.isRequired,
  tipsItems: _propTypes2.default.array,
  additionalTipsLinks: _propTypes2.default.array
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(20);

var _reactMetrics = __webpack_require__(69);

var _VideoJS = __webpack_require__(759);

var _VideoJS2 = _interopRequireDefault(_VideoJS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1391);

function defaultState() {
  return {
    videoError: null
  };
}

var VideoPlayer = (0, _reactMetrics.exposeMetrics)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(VideoPlayer, _Component);

  function VideoPlayer() {
    var _ref;

    (0, _classCallCheck3.default)(this, VideoPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // The URL provided for At The Races is a getter for a short lived Video URL, so it must be stored transiently.
    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = VideoPlayer.__proto__ || (0, _getPrototypeOf2.default)(VideoPlayer)).call.apply(_ref, [this].concat(args)));

    _this.state = defaultState();
    _this.hasPlayed = false;
    return _this;
  }

  (0, _createClass3.default)(VideoPlayer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(this.props, nextProps)) {
        this.setState(defaultState());
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _lodash.isEqual)(this.props, nextProps) || !(0, _lodash.isEqual)(this.state, nextState);
    }
  }, {
    key: 'onVideoPlayed',
    value: function onVideoPlayed() {
      if (!this.hasPlayed) {
        this.hasPlayed = true;
        this.context.metrics.track("playVideo", { videoUri: this.props.caption });
      }

      if (this.props.onPlaying) {
        this.props.onPlaying();
      }
    }
  }, {
    key: 'prompt',
    value: function prompt() {
      var _props$prompt = this.props.prompt;
      _props$prompt = _props$prompt === undefined ? {} : _props$prompt;
      var className = _props$prompt.className,
          title = _props$prompt.title,
          body = _props$prompt.body;


      var classList = ["video-prompt"];

      if (className) {
        classList.push(className);
      }

      return _react2.default.createElement(
        'div',
        { className: classList.join(" ") },
        _react2.default.createElement(
          'h2',
          null,
          title
        ),
        body
      );
    }
  }, {
    key: 'videoPlayer',
    value: function videoPlayer() {
      var _this2 = this;

      var playerProps = {
        onPlaying: function onPlaying() {
          return _this2.onVideoPlayed();
        },
        onEnded: function onEnded(evt) {
          return _this2.props.onEnded && _this2.props.onEnded(evt);
        },
        onError: function onError(evt, player) {
          _this2.setState({ videoError: player.error() });
          _this2.props.onError && _this2.props.onError(evt);
        },
        autoPlay: this.props.autoPlay,
        src: this.props.src,
        caption: this.props.caption
      };

      return _react2.default.createElement(_VideoJS2.default, playerProps);
    }
  }, {
    key: 'playButton',
    value: function playButton() {
      var _props$button = this.props.button;
      _props$button = _props$button === undefined ? {} : _props$button;
      var _props$button$type = _props$button.type,
          type = _props$button$type === undefined ? 'play' : _props$button$type,
          loadSrc = _props$button.loadSrc;


      return _react2.default.createElement('div', {
        onClick: function onClick() {
          return loadSrc();
        },
        className: 'video-replay-placeholder-' + type
      });
    }
  }, {
    key: 'errorMessage',
    value: function errorMessage() {
      var videoError = this.state.videoError;


      var message = void 0;

      if (videoError && this.props.errorMessage) {
        message = this.props.errorMessage(videoError);
      }

      var errorPixelSrc = '/1x1.gif?type=video&id=0&cb=' + Date.now();

      return _react2.default.createElement(
        'div',
        { className: 'video-replay-error' },
        _react2.default.createElement(
          'h2',
          null,
          'Cannot Play Video'
        ),
        _react2.default.createElement(
          'p',
          null,
          'We\'re sorry, but ',
          message || "we can't play this video for you",
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'We will try to fix this as soon as possible, so please try again later.'
        ),
        _react2.default.createElement('img', { src: errorPixelSrc, width: '1', height: '1' })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var content = void 0;

      if (this.props.prompt) {
        content = this.prompt();
      } else if (this.state.videoError) {
        content = this.errorMessage();
      } else if (this.props.src) {
        content = this.videoPlayer();
      } else if (this.props.button) {
        content = this.playButton();
      } else {
        // catch incorrect configuration as an error
        content = this.errorMessage();
      }

      var outerProps = {};
      var placeholderImage = this.props.placeholderImage;


      if (placeholderImage) {
        outerProps.style = {
          backgroundImage: 'url(' + placeholderImage + ')'
        };
      }

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: 'video-replay-container', id: 'video-player' }, outerProps),
        _react2.default.createElement(
          'div',
          { className: 'video-replay-inner' },
          content
        )
      );
    }
  }]);
  return VideoPlayer;
}(_react.Component), _class2.contextTypes = {
  metrics: _reactMetrics.PropTypes.metrics
}, _class2.propTypes = {
  src: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    type: _propTypes2.default.string,
    src: _propTypes2.default.string
  })]),
  caption: _propTypes2.default.string,
  placeholderImage: _propTypes2.default.string,
  prompt: _propTypes2.default.object,
  autoPlay: _propTypes2.default.bool,
  button: _propTypes2.default.shape({
    type: _propTypes2.default.string,
    loadSrc: _propTypes2.default.func
  }),

  onPlaying: _propTypes2.default.func,
  onEnded: _propTypes2.default.func,
  errorMessage: _propTypes2.default.func,
  onError: _propTypes2.default.func
}, _temp)) || _class;

exports.default = VideoPlayer;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FeedIcon;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1392);

function FeedIcon(_ref) {
  var feed = _ref.feed;

  if (feed == "ATR") {
    return _react2.default.createElement(
      'div',
      { className: 'feed-provider-icon-ssr feed-provider-icon' },
      _react2.default.createElement('img', { src: '/img/feed-providers/ssr.svg' })
    );
  } else if (feed == "RUK") {
    return _react2.default.createElement(
      'div',
      { className: 'feed-provider-icon-rtv feed-provider-icon' },
      _react2.default.createElement(
        'a',
        { href: 'https://www.racingtv.com/', target: '_blank' },
        _react2.default.createElement('img', { src: '/img/feed-providers/rtv.svg' })
      )
    );
  }
  return null;
}

FeedIcon.propTypes = {
  feed: _propTypes2.default.oneOf(["ATR", "RUK"])
};

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = InsiderIcon;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function InsiderIcon(_ref) {
  var title = _ref.title;

  return _react2.default.createElement(
    "svg",
    { className: "insider-icon icon", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" },
    _react2.default.createElement(
      "title",
      null,
      title
    ),
    _react2.default.createElement(
      "g",
      null,
      _react2.default.createElement("path", { d: "M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z" }),
      _react2.default.createElement("path", { className: "tick", d: "M34.602,14.602L21,28.199l-5.602-5.598l-2.797,2.797L21,33.801l16.398-16.402L34.602,14.602z" })
    )
  );
}

InsiderIcon.propTypes = {
  title: _propTypes2.default.string.isRequired
};

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ClockIcon(_ref) {
  var title = _ref.title;

  return _react2.default.createElement(
    'svg',
    { className: 'clock-icon', viewBox: '0 0 64 64', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    _react2.default.createElement(
      'g',
      { fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M32 57.6C17.92 57.6 6.4 46.08 6.4 32 6.4 17.92 17.92 6.4 32 6.4c14.08 0 25.6 11.52 25.6 25.6 0 14.08-11.52 25.6-25.6 25.6M32 0C14.24 0 0 14.4 0 32s14.24 32 32 32c17.76 0 32-14.4 32-32S49.6 0 32 0' }),
      _react2.default.createElement('path', { d: 'M33.6 16h-4.8v19.2l16.8 10.08 2.4-4-14.4-8.48' })
    )
  );
}

ClockIcon.propTypes = {
  title: _propTypes2.default.string.isRequired
};

exports.default = ClockIcon;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SimpleBar;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*

Usage <SimpleBar a={oneValue} b={anotherValue} highlightMax={false} className="aClass" highlightClassName="anotherClass"/>

a: mandatory left hand value
b: mandatory right hand value
highlightMax: optionally set this to false to suppress adding a class to the largest number
className: optionally set the base class for all the element. All sub classes will use this base.

*/
function SimpleBar(_ref) {
  var a = _ref.a,
      b = _ref.b,
      _ref$highlightMax = _ref.highlightMax,
      highlightMax = _ref$highlightMax === undefined ? true : _ref$highlightMax,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "simple-bar" : _ref$className;

  var svgWidth = 100;
  var svgHeight = 20;

  var proportion = void 0;

  if (a + b == 0) {
    proportion = 0.5;
    highlightMax = false; // force no highlighting
  } else {
    proportion = a / (a + b);
  }

  var widthA = svgWidth * proportion;
  var widthB = svgWidth - widthA;

  var highlightA = "";
  var highlightB = "";

  if (highlightMax) {
    var maxValue = Math.max(a, b);

    // highlight both in a draw
    highlightA = a == maxValue ? ' ' + className + '-highlighted' : "";
    highlightB = b == maxValue ? ' ' + className + '-highlighted' : "";
  }

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'svg',
      { className: className + '-bars', viewBox: '0 0 ' + svgWidth + ' ' + svgHeight, preserveAspectRatio: 'none', xmlns: 'http://www.w3.</2000/svg' },
      _react2.default.createElement('rect', { className: className + '-bar-a', x: '0', y: '0', width: widthA, height: svgHeight }),
      _react2.default.createElement('rect', { className: className + '-bar-b', x: widthA, y: '0', width: widthB, height: svgHeight })
    ),
    _react2.default.createElement(
      'span',
      { className: className + '-text-a' + highlightA },
      a
    ),
    _react2.default.createElement(
      'span',
      { className: className + '-text-b' + highlightB },
      b
    )
  );
}

SimpleBar.propTypes = {
  className: _propTypes2.default.string,
  highlightMax: _propTypes2.default.bool,
  a: _propTypes2.default.number.isRequired,
  b: _propTypes2.default.number.isRequired
};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SportingLifeLogo() {
  return _react2.default.createElement(
    "svg",
    { className: "sporting-life-logo", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1027.8134 192.45332", preserveAspectRatio: "xMinYMid" },
    _react2.default.createElement(
      "title",
      null,
      "Sporting Life"
    ),
    _react2.default.createElement(
      "g",
      { className: "sporting-word" },
      _react2.default.createElement("path", { d: "M57.454 86.31c-.598-.12-1.296-.238-2.05-.37-5.935-1.03-16.983-2.934-16.983-11.55 0-7.276 8.633-9.916 14.436-9.916 5.95 0 13.105 1.63 18.94 4.247l9.914-18.853c-8.98-3.582-19.362-5.396-30.908-5.396-21.74 0-43.677 10.71-43.677 34.642 0 17.1 10.274 22.16 21.373 25.083 2.366.622 4.73 1.134 6.995 1.62 9.49 2.053 18.453 3.994 18.453 12.724 0 6.976-7.44 10.74-14.438 10.74-8.972 0-20.547-4.526-28.54-9.466L0 140.916c11.97 6.825 25.36 10.418 38.89 10.418 21.667 0 46.966-9.555 46.966-36.487 0-15.593-9.025-24.662-28.402-28.538" }),
      _react2.default.createElement("path", { d: "M496.193 4.455c-8.988 0-15.513 6.437-15.513 15.31 0 7.227 6.635 15.312 15.513 15.312 9.495 0 16.114-8.07 16.114-15.313 0-9.16-6.476-15.31-16.114-15.31M150.185 127.414c-15.102 0-27.39-13.01-27.39-29 0-15.883 12.288-28.802 27.39-28.802 7.436 0 13.928 2.603 18.778 7.526 5.346 5.43 8.34 13.345 8.21 21.717-.212 13.755-8.75 28.56-26.988 28.56zm53.464-27.828c.054-8.236-1.31-16.15-3.92-23.256-2.653-7.132-6.565-13.45-11.543-18.462-8.707-8.765-20.64-13.408-34.29-13.433-11.537.025-21.1 3.824-27.117 11.305l-5.323 5.786v-16.2H94.79V186.66h26.667v-51.483l5.25 5.218c6.212 7.072 16.062 10.97 26.722 10.992 36.345-.077 49.88-26.794 50.22-51.8M357.457 55.344V45.327h-25.333v104h25.333v-57.56c0-19.432 21.334-25.943 33.334-22.734V44.696c-1.333-.692-5.54-1.07-8.43-1.135-8.715-.133-15.392 2.616-21.6 8.575l-3.303 3.21M482.79 149.327h28v-104h-28zM587.977 44.236c-13.092.036-21.72 3.79-27.817 11.488l-4.036 5.894v-16.29H526.79v104h29.334V92.973c0-14.827 12.257-24.003 23.072-24.003 8.767 0 19.595 6.127 19.595 23.398v56.96h25.334v-57.16c0-31.885-11.312-47.557-36.147-47.932M716.812 98.615c0 16.63-13.66 25.557-27.145 25.78-12.884 0-26.806-7.933-27.03-25.346-.133-8.493 2.872-16.497 8.242-21.95 4.824-4.898 11.307-7.488 18.743-7.488 14.993 0 27.19 13.01 27.19 29.003zm-31.016-53.288h-.404c-29.98 0-49.352 20.842-49.352 53.636 0 25.29 12.593 42.657 33.784 48.36 4.86 1.278 10.173 1.9 15.892 1.9 11.525 0 19.608-3.512 25.48-10.388l3.595-5.42v7.095c0 19.767-13.307 27.237-25.562 27.237-10.3 0-18.34-5.087-21.205-10.42h-28.488c3.202 20 28.438 35.058 51.294 35.126 3.758-.006 7.478-.326 11.094-.982.055-.01.115.002.167-.007.885-.166 1.74-.402 2.61-.598 10.09-2.356 18.963-7.168 25.47-13.747 9.12-9.22 13.954-21.727 13.954-37.183V45.327H714.79v16.36l-3.663-5.627c-5.762-7.353-13.61-10.733-25.33-10.733" }),
      _react2.default.createElement("path", { d: "M459.945 129.874c-11.156 0-17.154-5.594-17.154-15.348V67.993h25.334V45.327H442.79V14.66h-25.333v30.667h-16v22.666h16v46.533c0 1.847-.12 3.622.008 5.328 1.555 20.476 11.464 30.843 32.294 31.582 5.204.184 14.364-.236 19.697-1.248v-20.836c-1.333.34-7.54.522-9.512.522" }),
      _react2.default.createElement("path", { d: "M267.096 126.407c-13.56 0-27.29-9.825-27.29-28.6 0-18.873 13.73-28.75 27.29-28.75 13.56 0 27.29 9.877 27.29 28.75 0 18.775-13.73 28.6-27.29 28.6zm0-82.332c-25.853 0-53.68 16.815-53.68 53.732 0 36.815 27.827 53.582 53.68 53.582 25.853 0 53.68-16.768 53.68-53.583 0-36.917-27.827-53.732-53.68-53.732" })
    ),
    _react2.default.createElement(
      "g",
      { className: "life-word" },
      _react2.default.createElement("path", { d: "M825.807 4.455c-8.987 0-15.51 6.437-15.51 15.31 0 7.227 6.634 15.312 15.51 15.312 9.497 0 16.114-8.07 16.114-15.313 0-9.16-6.473-15.31-16.113-15.31" }),
      _react2.default.createElement("path", { d: "M765.457 149.327h29.334V-.007h-29.333zM812.124 149.327h26.667v-104h-26.666zM902.816.037c-23.46.023-34.692 11.122-34.692 33.93v11.36h-16v22.666h16v81.334h25.333V67.993h24V45.327h-24v-11.36c0-9.335 5.456-14.528 15.575-14.803 2.295-.068 8.425.12 11.092.563V1.325C914.79.475 907.374.043 902.816.037" }),
      _react2.default.createElement("path", { d: "M948.756 86.66l1.02-2.836c3.31-10.96 12.452-17.502 23.857-17.502 12.347 0 21.575 6.26 24.678 17.424l.92 2.914zm25.38-42.533c-25.807 0-53.572 16.61-53.677 53.07.024 16.51 5.783 29.898 16.66 39.547 9.703 8.604 22.803 12.583 36.89 12.583h.01c22.32 0 41.29-9.334 49.365-29.334h-29.51c-4.767 5.334-11.68 7.66-19.163 7.66-5.953 0-11.488-1.485-16.028-4.45-4.54-2.916-8.087-6.873-10.055-12.006l-1.365-3.204h79.778c.524-2.666.772-6.81.773-10.265-.016-36.582-27.836-53.6-53.68-53.6" })
    )
  );
}

exports.default = SportingLifeLogo;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StarIcon;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StarIcon(_ref) {
  var title = _ref.title,
      filled = _ref.filled;

  return _react2.default.createElement(
    "svg",
    { className: "star-icon" + (filled ? " filled" : ""), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 60" },
    _react2.default.createElement(
      "title",
      null,
      title
    ),
    _react2.default.createElement("path", { d: "M31.646 0l-7.43 22.94H0l19.81 14.12L12.093 60l19.552-14.217L51.2 60l-7.727-22.94 19.822-14.12H39.078L31.646 0z", transform: "matrix(.8744 0 0 .865 4.343 4.51)", fillRule: "evenodd" })
  );
}

StarIcon.propTypes = {
  filled: _propTypes2.default.bool,
  title: _propTypes2.default.string.isRequired
};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.PureInsiderMpu = PureInsiderMpu;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _InsiderIcon = __webpack_require__(253);

var _InsiderIcon2 = _interopRequireDefault(_InsiderIcon);

var _reactRedux = __webpack_require__(17);

var _skysso = __webpack_require__(72);

var _reducer = __webpack_require__(172);

var _consts = __webpack_require__(46);

var _AnalyticsUtils = __webpack_require__(63);

var _reactMetrics = __webpack_require__(69);

var _reactRouter = __webpack_require__(11);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PureInsiderMpu(_ref) {
    var loggedIn = _ref.loggedIn,
        trackRegister = _ref.trackRegister,
        doRegister = _ref.doRegister;

    __webpack_require__(1394);

    var insiderUrl = '/insider';

    var iconProps = {
        title: "Insider Feature"
    };

    var onRegister = function onRegister() {
        trackRegister();
        doRegister();
    };

    if (loggedIn) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: 'insider-promo' },
        _react2.default.createElement(
            'div',
            { className: 'content' },
            _react2.default.createElement(
                'h2',
                { className: 'strap-line' },
                'Know it all.'
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                    'span',
                    { className: 'highlighted' },
                    'Become an ',
                    _react2.default.createElement(
                        'strong',
                        null,
                        'Insider'
                    ),
                    ' to unlock'
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'highlighted' },
                    'loads of exclusive features including:'
                )
            ),
            _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_InsiderIcon2.default, iconProps),
                    ' Unlimited video replays'
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_InsiderIcon2.default, iconProps),
                    ' Tips and previews'
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_InsiderIcon2.default, iconProps),
                    ' Live score update notifications'
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_InsiderIcon2.default, iconProps),
                    ' Betting offers and more!'
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'reglog-button-fw-row' },
                _react2.default.createElement(
                    _reactMetrics.MetricsElement,
                    null,
                    _react2.default.createElement(
                        _reactRouter.Link,
                        (0, _extends3.default)({ to: insiderUrl
                        }, (0, _AnalyticsUtils.trackClick)(_consts.INSIDERS_LINK_CLICK_TRACKING_EVENT, { link: "[Insiders] MPU Learn More" }), {
                            className: 'btn register-button',
                            id: 'register-btn' }),
                        'Learn more'
                    )
                ),
                _react2.default.createElement(
                    _reactMetrics.MetricsElement,
                    null,
                    _react2.default.createElement(
                        'button',
                        (0, _extends3.default)({ onClick: onRegister,
                            className: 'test btn login-button'
                        }, (0, _AnalyticsUtils.trackClick)(_consts.INSIDERS_LINK_CLICK_TRACKING_EVENT, { link: "[Insiders] MPU Join" }), {
                            id: 'login-btn' }),
                        'Join for free'
                    )
                )
            )
        )
    );
}

PureInsiderMpu.propTypes = {
    loggedIn: _propTypes2.default.bool.isRequired,
    trackRegister: _propTypes2.default.func.isRequired,
    doRegister: _propTypes2.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        loggedIn: state.common.auth.loggedIn
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        trackRegister: function trackRegister() {
            dispatch((0, _reducer.insiderLoginInitiated)());
        },
        doRegister: function doRegister() {
            dispatch((0, _skysso.SSORegister)());
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PureInsiderMpu);

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(17);

var _RegisterLoginButtons = __webpack_require__(165);

var _RegisterLoginButtons2 = _interopRequireDefault(_RegisterLoginButtons);

var _Lightbox = __webpack_require__(358);

var _display = __webpack_require__(258);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseLightboxContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return { lightbox: state.common.display.lightbox };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(BaseLightboxContainer, _Component);

  function BaseLightboxContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BaseLightboxContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BaseLightboxContainer.__proto__ || (0, _getPrototypeOf2.default)(BaseLightboxContainer)).call.apply(_ref, [this].concat(args))), _this), _this.closeLightbox = function () {
      _this.props.dispatch((0, _display.closeLightbox)(_this.props.type));
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BaseLightboxContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          message = _props.message,
          _props$messagesByType = _props.messagesByType,
          messagesByType = _props$messagesByType === undefined ? {} : _props$messagesByType,
          title = _props.title,
          _props$lightbox = _props.lightbox;
      _props$lightbox = _props$lightbox === undefined ? {} : _props$lightbox;
      var _props$lightbox$type = _props$lightbox[type];
      _props$lightbox$type = _props$lightbox$type === undefined ? {} : _props$lightbox$type;
      var messageType = _props$lightbox$type.messageType,
          _props$lightbox$type$ = _props$lightbox$type.show,
          show = _props$lightbox$type$ === undefined ? false : _props$lightbox$type$;
      var _messagesByType$messa = messagesByType[messageType],
          messageToShow = _messagesByType$messa === undefined ? message : _messagesByType$messa;


      return show && _react2.default.createElement(
        _Lightbox.Lightbox,
        { title: title, close: this.closeLightbox },
        _react2.default.createElement(
          'span',
          { className: 'subscription-lb-message' },
          messageToShow
        ),
        _react2.default.createElement(_RegisterLoginButtons2.default, { closeContext: this.closeLightbox })
      );
    }
  }]);
  return BaseLightboxContainer;
}(_react.Component), _class2.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  lightbox: _propTypes2.default.object.isRequired,
  title: _propTypes2.default.string.isRequired,
  message: _propTypes2.default.string.isRequired,
  messagesByType: _propTypes2.default.object,
  type: _propTypes2.default.string.isRequired
}, _temp2)) || _class);
exports.default = BaseLightboxContainer;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _morenews = __webpack_require__(79);

var _MostReadPanel = __webpack_require__(251);

var _MostReadPanel2 = _interopRequireDefault(_MostReadPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MostReadFootball = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)("MostReadFootball", (0, _morenews.asyncConnectMostRead)("/football")), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MostReadFootball, _Component);

  function MostReadFootball() {
    (0, _classCallCheck3.default)(this, MostReadFootball);
    return (0, _possibleConstructorReturn3.default)(this, (MostReadFootball.__proto__ || (0, _getPrototypeOf2.default)(MostReadFootball)).apply(this, arguments));
  }

  (0, _createClass3.default)(MostReadFootball, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_MostReadPanel2.default, { articles: this.props.mostread, title: 'Football' });
    }
  }]);
  return MostReadFootball;
}(_react.Component), _class2.propTypes = {
  mostread: _propTypes2.default.array
}, _temp)) || _class);
exports.default = MostReadFootball;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = StarButton;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactMetrics = __webpack_require__(69);

var _StarIcon = __webpack_require__(369);

var _StarIcon2 = _interopRequireDefault(_StarIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function StarButton(_ref) {
  var _ref$hasSubscriptions = _ref.hasSubscriptions,
      hasSubscriptions = _ref$hasSubscriptions === undefined ? false : _ref$hasSubscriptions,
      _ref$saveSubscription = _ref.saveSubscriptions,
      saveSubscriptions = _ref$saveSubscription === undefined ? function () {} : _ref$saveSubscription,
      _ref$deleteSubscripti = _ref.deleteSubscriptions,
      deleteSubscriptions = _ref$deleteSubscripti === undefined ? function () {} : _ref$deleteSubscripti,
      _ref$trackClick = _ref.trackClick,
      trackClick = _ref$trackClick === undefined ? {} : _ref$trackClick,
      selectedTitle = _ref.selectedTitle,
      deselectedTitle = _ref.deselectedTitle,
      _ref$hideIfDeselected = _ref.hideIfDeselected,
      hideIfDeselected = _ref$hideIfDeselected === undefined ? false : _ref$hideIfDeselected;

  if (!hasSubscriptions) {
    return _react2.default.createElement(
      _reactMetrics.MetricsElement,
      null,
      _react2.default.createElement(
        'button',
        (0, _extends3.default)({
          className: 'favourite-btn', id: 'favourite-btn',
          onClick: function onClick() {
            return saveSubscriptions();
          }
        }, trackClick),
        _react2.default.createElement(_StarIcon2.default, { title: selectedTitle, filled: false })
      )
    );
  } else if (!hideIfDeselected) {
    return _react2.default.createElement(
      'button',
      {
        className: 'favourite-btn', id: 'favourite-btn',
        onClick: function onClick() {
          return deleteSubscriptions();
        }
      },
      _react2.default.createElement(_StarIcon2.default, { title: deselectedTitle, filled: true })
    );
  } else {
    return null;
  }
}

StarButton.propTypes = {
  trackClick: _propTypes2.default.object,
  selectedTitle: _propTypes2.default.string,
  deselectedTitle: _propTypes2.default.string,
  hideIfDeselected: _propTypes2.default.bool,
  hasSubscriptions: _propTypes2.default.bool,
  saveSubscriptions: _propTypes2.default.func,
  deleteSubscriptions: _propTypes2.default.func
};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends6 = __webpack_require__(7);

var _extends7 = _interopRequireDefault(_extends6);

exports.default = reducer;
exports.loadLayout = loadLayout;
exports.setLayout = setLayout;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_LAYOUT = 'common/media/LOAD_LAYOUT';
var LOAD_LAYOUT_SUCCESS = 'common/media/LOAD_LAYOUT_SUCCESS';
var LOAD_LAYOUT_FAIL = 'common/media/LOAD_LAYOUT_FAIL';
var SET_LAYOUT = 'common/media/SET_LAYOUT';

var initialState = {};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_LAYOUT:
      return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.path, (0, _extends7.default)({}, state[action.path], {
        loading: true
      })));
    case LOAD_LAYOUT_SUCCESS:
      return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.path, (0, _extends7.default)({}, state[action.path], {
        loading: false,
        loaded: true,
        layout: action.result.layout
      })));
    case LOAD_LAYOUT_FAIL:
      return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.path, (0, _extends7.default)({}, state[action.path], {
        loading: false,
        loaded: false,
        error: action.error
      })));
    case SET_LAYOUT:
      {
        return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.path, (0, _extends7.default)({}, state[action.path], {
          loading: false,
          loaded: true,
          layout: action.layout
        })));
      }
    default:
      return state;
  }
}

function loadLayout(path) {
  return {
    types: [LOAD_LAYOUT, LOAD_LAYOUT_SUCCESS, LOAD_LAYOUT_FAIL],
    promise: function promise(client) {
      return client.get('' + _config2.default.api.common.layout.loadLayout);
    },
    path: path
  };
}

function setLayout(path, layout) {
  return {
    type: SET_LAYOUT,
    path: path,
    layout: layout
  };
}

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(7);

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;
exports.trackVar = trackVar;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TRACK_VAR = 'common/omniture/TRACK_VAR';

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case TRACK_VAR:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.key, action.value));
    default:
      return state;
  }
}

function trackVar(key, value) {
  return {
    type: TRACK_VAR,
    key: key,
    value: value
  };
}

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPLASH_SCREEN_RESPONSE = undefined;

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(7);

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

var _skysso = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SPLASH_SCREEN_RESPONSE = exports.SPLASH_SCREEN_RESPONSE = "SPLASH_SCREEN_RESPONSE";

var defaultState = {
  siteLoad: null,
  login: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SPLASH_SCREEN_RESPONSE:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.trigger, action.data));

    case _skysso.LOGOUT:
      return defaultState;

    default:
      return state;
  }
}

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ErrorPage;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(156);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _CaretLink = __webpack_require__(54);

var _CaretLink2 = _interopRequireDefault(_CaretLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ErrorPage(_ref) {
  var title = _ref.title,
      children = _ref.children;

  __webpack_require__(1396);

  var errorPixelSrc = '/1x1.gif?type=page&id=' + title + '&cb=' + Date.now();

  return _react2.default.createElement(
    'div',
    { className: 'error-page' },
    _react2.default.createElement(_reactHelmet2.default, { title: title }),
    _react2.default.createElement(
      'div',
      { className: 'error-heading' },
      _react2.default.createElement(
        'h1',
        { className: 'page-title' },
        title
      ),
      _react2.default.createElement(
        'p',
        { className: 'error-message' },
        children
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'error-links' },
      _react2.default.createElement(
        'p',
        null,
        'Here are some helpful links:'
      ),
      _react2.default.createElement(
        'div',
        { className: 'error-link' },
        _react2.default.createElement(
          _CaretLink2.default,
          { to: '/racing' },
          'Horse Racing'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'error-link' },
        _react2.default.createElement(
          _CaretLink2.default,
          { to: '/football' },
          'Football'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'error-link' },
        _react2.default.createElement(
          _CaretLink2.default,
          { to: '/greyhounds' },
          'Greyhound Racing'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'error-link' },
        _react2.default.createElement(
          _CaretLink2.default,
          { to: '/cricket' },
          'Cricket'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'error-link' },
        _react2.default.createElement(
          _CaretLink2.default,
          { to: '/darts' },
          'Darts'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'error-link' },
        _react2.default.createElement(
          _CaretLink2.default,
          { to: '/golf' },
          'Golf'
        )
      )
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement('img', { src: errorPixelSrc, width: '1', height: '1' })
    )
  );
}

ErrorPage.propTypes = {
  title: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node.isRequired
};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballLiveDatesList;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(117);

var _CollapsibleSection = __webpack_require__(99);

var _CollapsibleSection2 = _interopRequireDefault(_CollapsibleSection);

var _FootballMatchList = __webpack_require__(262);

var _FootballMatchList2 = _interopRequireDefault(_FootballMatchList);

var _FootballMatchRoundList = __webpack_require__(381);

var _FootballMatchRoundList2 = _interopRequireDefault(_FootballMatchRoundList);

var _consts = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(510);

function FootballLiveDatesList(_ref) {
  var _ref$matchList = _ref.matchList,
      matchList = _ref$matchList === undefined ? [] : _ref$matchList,
      fixturesResults = _ref.fixturesResults,
      showCompetitions = _ref.showCompetitions,
      _ref$messageType = _ref.messageType,
      messageType = _ref$messageType === undefined ? "" : _ref$messageType;


  var mappedDatesMatches = (0, _utils.mapMatchesToDates)(matchList, fixturesResults) || [];

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'ul',
      null,
      mappedDatesMatches.map(function (_ref2) {
        var id = _ref2.id,
            name = _ref2.name,
            _ref2$matchList = _ref2.matchList,
            matchList = _ref2$matchList === undefined ? [] : _ref2$matchList;
        return _react2.default.createElement(
          'li',
          { key: id },
          _react2.default.createElement(
            'div',
            { className: 'FootballMatchList' },
            _react2.default.createElement(
              _CollapsibleSection2.default,
              { title: name },
              _react2.default.createElement(_FootballMatchRoundList2.default, { matchList: matchList, showCompetitions: showCompetitions, fixturesResults: fixturesResults })
            )
          )
        );
      })
    ),
    !mappedDatesMatches.length && _react2.default.createElement(
      'div',
      { className: 'football-live-filter-no-match-msg' },
      _react2.default.createElement(
        'p',
        null,
        _consts.MATCH_FILTER_EMPTY_MESSAGE['' + fixturesResults + messageType]
      )
    )
  );
}

FootballLiveDatesList.propTypes = {
  matchList: _propTypes2.default.array.isRequired,
  fixturesResults: _propTypes2.default.string,
  messageType: _propTypes2.default.string,
  showCompetitions: _propTypes2.default.bool
};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballMatchForm;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LocalDateTimeHelper = __webpack_require__(13);

var _FootballMatchFormMatch = __webpack_require__(819);

var _FootballMatchFormMatch2 = _interopRequireDefault(_FootballMatchFormMatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballMatchForm(props) {
  __webpack_require__(511);

  return _react2.default.createElement(
    'div',
    { className: 'teamMatchForm' },
    _react2.default.createElement(
      'ul',
      { className: 'formMatches' },
      props.formMatches.map(function (match) {
        return _react2.default.createElement(
          'li',
          { key: match.match_reference.id, className: 'rowListElement' },
          _react2.default.createElement(
            'div',
            { className: 'matchDate' },
            (0, _LocalDateTimeHelper.localDate)(match.match_date)
          ),
          _react2.default.createElement(_FootballMatchFormMatch2.default, { match: match })
        );
      })
    )
  );
}

FootballMatchForm.propTypes = {
  formMatches: _propTypes2.default.array.isRequired
};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.default = FootballMatchOdds;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BetLink = __webpack_require__(114);

var _BetLink2 = _interopRequireDefault(_BetLink);

var _consts = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballMatchOdds(props) {
  __webpack_require__(1403);

  var _props$match = props.match,
      _props$match$competit = _props$match.competition;
  _props$match$competit = _props$match$competit === undefined ? {} : _props$match$competit;
  var eventCompetition = _props$match$competit.name,
      _props$match$match_be = _props$match.match_betting_market;
  _props$match$match_be = _props$match$match_be === undefined ? {} : _props$match$match_be;
  var matchBetting = _props$match$match_be.match_betting,
      suspended = _props$match$match_be.market_suspended,
      fixture = _props$match$match_be.fixture,
      _props$match$match_be2 = _props$match$match_be.live,
      live = _props$match$match_be2 === undefined ? false : _props$match$match_be2,
      matchReference = _props$match.match_reference,
      matchDate = _props$match.match_date,
      teamA = _props$match.team_score_a.team.name,
      teamB = _props$match.team_score_b.team.name,
      matchState = _props$match.state;


  function matchShouldShowOdds(state) {
    return state !== "ABANDONED" && _consts.MATCH_STATE_ALL.includes(state) && _consts.MATCH_STATE_ALL.indexOf(state) < _consts.MATCH_STATE_ALL.indexOf("FULLTIME90");
  }

  function generateBetLinkProps(eventId, betting, isLive) {
    var _betting$market_refer = betting.market_reference;
    _betting$market_refer = _betting$market_refer === undefined ? {} : _betting$market_refer;
    var _betting$market_refer2 = _betting$market_refer.external_reference;
    _betting$market_refer2 = _betting$market_refer2 === undefined ? [] : _betting$market_refer2;

    var _betting$market_refer3 = (0, _slicedToArray3.default)(_betting$market_refer2, 1),
        _betting$market_refer4 = _betting$market_refer3[0];

    _betting$market_refer4 = _betting$market_refer4 === undefined ? {} : _betting$market_refer4;
    var marketId = _betting$market_refer4.value,
        _betting$bet_referenc = betting.bet_reference;
    _betting$bet_referenc = _betting$bet_referenc === undefined ? {} : _betting$bet_referenc;
    var _betting$bet_referenc2 = _betting$bet_referenc.external_reference;
    _betting$bet_referenc2 = _betting$bet_referenc2 === undefined ? [] : _betting$bet_referenc2;

    var _betting$bet_referenc3 = (0, _slicedToArray3.default)(_betting$bet_referenc2, 1),
        _betting$bet_referenc4 = _betting$bet_referenc3[0];

    _betting$bet_referenc4 = _betting$bet_referenc4 === undefined ? {} : _betting$bet_referenc4;
    var betId = _betting$bet_referenc4.value,
        betName = betting.name,
        startingPriceAvailable = betting.has_sp,
        odds = betting.odds;


    return {
      eventName: teamA + ' v ' + teamB,
      eventCompetition: eventCompetition,
      dateTime: matchDate,
      sport: "football",
      isLive: isLive,
      marketId: marketId,
      eventId: eventId,
      betId: betId,
      betName: betName,
      odds: odds,
      suspended: suspended,
      fixture: fixture,
      startingPriceAvailable: startingPriceAvailable
    };
  }

  var skybetRefs = matchReference && matchReference.external_reference && matchReference.external_reference.filter(function (r) {
    return r.ref === 'skybet';
  }).map(function (r) {
    return r.value;
  }) || [];
  var eventRef = skybetRefs.length > 0 ? skybetRefs[0] : '';

  var teamABetting = matchBetting && matchBetting.filter(function (b) {
    return b.name === teamA;
  }) || [];
  var drawBetting = matchBetting && matchBetting.filter(function (b) {
    return b.name === "Draw";
  }) || [];
  var teamBBetting = matchBetting && matchBetting.filter(function (b) {
    return b.name === teamB;
  }) || [];

  if (!matchShouldShowOdds(matchState)) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'matchOdds' },
    teamABetting.length > 0 ? _react2.default.createElement(
      _BetLink2.default,
      (0, _extends3.default)({ className: 'odds' }, generateBetLinkProps(eventRef, teamABetting[0], live)),
      teamABetting[0].odds
    ) : _react2.default.createElement(
      'span',
      { className: 'odds' },
      '-'
    ),
    drawBetting.length > 0 ? _react2.default.createElement(
      _BetLink2.default,
      (0, _extends3.default)({ className: 'odds' }, generateBetLinkProps(eventRef, drawBetting[0], live)),
      drawBetting[0].odds
    ) : _react2.default.createElement(
      'span',
      { className: 'odds' },
      '-'
    ),
    teamBBetting.length > 0 ? _react2.default.createElement(
      _BetLink2.default,
      (0, _extends3.default)({ className: 'odds' }, generateBetLinkProps(eventRef, teamBBetting[0], live)),
      teamBBetting[0].odds
    ) : _react2.default.createElement(
      'span',
      { className: 'odds' },
      '-'
    )
  );
}

FootballMatchOdds.propTypes = {
  match: _propTypes2.default.shape({
    match_betting_market: _propTypes2.default.shape({
      match_betting: _propTypes2.default.array,
      live: _propTypes2.default.bool,
      market_suspended: _propTypes2.default.bool,
      fixture: _propTypes2.default.string
    }),
    matchExternalRefs: _propTypes2.default.object,
    teamA: _propTypes2.default.string,
    teamB: _propTypes2.default.string
  })
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(148);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = FootballMatchRoundList;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FootballMatchList = __webpack_require__(262);

var _FootballMatchList2 = _interopRequireDefault(_FootballMatchList);

var _utils = __webpack_require__(117);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballMatchRoundList(_ref) {
    var _ref$matchList = _ref.matchList,
        matchList = _ref$matchList === undefined ? [] : _ref$matchList,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['matchList']);

    __webpack_require__(1405);
    var groupedMatches = (0, _utils.mapMatchesToCompetitionRounds)(matchList);

    function getRoundName(round) {
        if (!round || !round.round_type) {
            return '';
        }

        return round.round_type == "Round" ? round.round_type + ' ' + round.round_number : round.round_type;
    }

    function renderRoundHeader(round) {
        // Do not display the round header if we have no round or the round === 1
        // (If we dont exclude Round 1 we display it for all cup competition group stage matches)
        if (!round || round.round_type == "Round" && round.round_number === 1) {
            return null;
        }

        var name = getRoundName(round);
        if (!name || name.length == 0) {
            return null;
        }

        return _react2.default.createElement(
            'h4',
            { className: 'round-title' },
            name
        );
    }

    function renderRoundList(_ref2) {
        var round = _ref2.round,
            matchList = _ref2.matchList;

        var header = renderRoundHeader(round);
        var name = getRoundName(round);
        return _react2.default.createElement(
            'div',
            { key: name, className: 'round-list' },
            header,
            _react2.default.createElement(_FootballMatchList2.default, (0, _extends3.default)({ matchList: matchList }, rest))
        );
    }

    if (!groupedMatches || groupedMatches.size === 0) {
        return null;
    }

    var rounds = [];
    groupedMatches.forEach(function (round) {
        rounds.push(renderRoundList(round));
    });

    return _react2.default.createElement(
        'div',
        null,
        rounds
    );
}

FootballMatchRoundList.propTypes = {
    matchList: _propTypes2.default.array
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballTeam;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FootballPlayer = __webpack_require__(828);

var _FootballPlayer2 = _interopRequireDefault(_FootballPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballTeam(props) {
  return _react2.default.createElement(
    'div',
    { className: 'footballTeamTeam' },
    _react2.default.createElement(
      'div',
      { className: 'footballTeamTeamName' },
      props.team.teamName,
      !!props.team.formation && ' (' + props.team.formation + ')'
    ),
    _react2.default.createElement(
      'ul',
      null,
      props.team.players.players.filter(function (player) {
        return player.starter;
      }).map(function (player) {
        return _react2.default.createElement(
          'li',
          { key: player.id, className: 'footballTeamPlayerListItem' },
          _react2.default.createElement(_FootballPlayer2.default, { player: player })
        );
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'footballTeamTeamName' },
      'Substitutes'
    ),
    _react2.default.createElement(
      'ul',
      null,
      props.team.players.players.filter(function (player) {
        return !player.starter;
      }).map(function (player) {
        return _react2.default.createElement(
          'li',
          { key: player.id, className: 'playerListItem' },
          _react2.default.createElement(_FootballPlayer2.default, { player: player })
        );
      })
    )
  );
}

FootballTeam.propTypes = {
  team: _propTypes2.default.object.isRequired
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _vidiprinter = __webpack_require__(211);

var _FootballVidiprinter = __webpack_require__(263);

var _FootballVidiprinter2 = _interopRequireDefault(_FootballVidiprinter);

var _CaretLink = __webpack_require__(54);

var _CaretLink2 = _interopRequireDefault(_CaretLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFRESH_INTERVAL_MILLIS = 10000;
var VIDIPRINTER_LINES = 5;

var FootballLiveHomeVidiprinterContainer = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)('FootballLiveHomeVidiprinterContainer', [{
  dispatch: function dispatch() {
    return (0, _vidiprinter.load)(VIDIPRINTER_LINES);
  },
  preventResolve: function preventResolve(_ref) {
    var state = _ref.state;
    return (0, _vidiprinter.isLoading)(state);
  },
  refreshInterval: REFRESH_INTERVAL_MILLIS,
  state: function state(_state) {
    var _state$football$vidip = _state.football.vidiprinter,
        vidiprinter = _state$football$vidip === undefined ? { items: [] } : _state$football$vidip;

    return { vidiprinter: vidiprinter };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballLiveHomeVidiprinterContainer, _Component);

  function FootballLiveHomeVidiprinterContainer() {
    (0, _classCallCheck3.default)(this, FootballLiveHomeVidiprinterContainer);
    return (0, _possibleConstructorReturn3.default)(this, (FootballLiveHomeVidiprinterContainer.__proto__ || (0, _getPrototypeOf2.default)(FootballLiveHomeVidiprinterContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballLiveHomeVidiprinterContainer, [{
    key: 'render',
    value: function render() {
      var _props$vidiprinter$it = this.props.vidiprinter.items;
      _props$vidiprinter$it = _props$vidiprinter$it === undefined ? {} : _props$vidiprinter$it;
      var _props$vidiprinter$it2 = _props$vidiprinter$it.lines,
          lines = _props$vidiprinter$it2 === undefined ? [] : _props$vidiprinter$it2;


      var limitedVidiprinterItems = {
        lines: lines.slice(0, VIDIPRINTER_LINES)
      };

      return _react2.default.createElement(
        'div',
        { className: 'footballLiveHomeVidiPrinter' },
        _react2.default.createElement(
          'h3',
          { className: 'section-title' },
          'Vidiprinter'
        ),
        _react2.default.createElement(_FootballVidiprinter2.default, { data: limitedVidiprinterItems }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _CaretLink2.default,
            { to: '/football/live/vidiprinter' },
            'See Full Vidiprinter'
          )
        )
      );
    }
  }]);
  return FootballLiveHomeVidiprinterContainer;
}(_react.Component), _class2.propTypes = {
  vidiprinter: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = FootballLiveHomeVidiprinterContainer;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(17);

var _RegisterLoginButtons = __webpack_require__(165);

var _RegisterLoginButtons2 = _interopRequireDefault(_RegisterLoginButtons);

var _CollapsibleSection = __webpack_require__(99);

var _CollapsibleSection2 = _interopRequireDefault(_CollapsibleSection);

var _FootballMatchList = __webpack_require__(262);

var _FootballMatchList2 = _interopRequireDefault(_FootballMatchList);

var _consts = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballMyScores = (_dec = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    auth: state.common.auth,
    matchList: ownProps.matchList,
    subscriptions: state.common.userService.subscriptions
  };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballMyScores, _Component);

  function FootballMyScores() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FootballMyScores);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FootballMyScores.__proto__ || (0, _getPrototypeOf2.default)(FootballMyScores)).call.apply(_ref, [this].concat(args))), _this), _this.renderDefault = function () {
      return _react2.default.createElement(
        'div',
        { className: 'matchlist-fav-container' },
        _react2.default.createElement(
          'div',
          { className: 'matchlist-favs-info' },
          _react2.default.createElement(
            'span',
            { className: 'matchlist-favs-msg' },
            'Log in or register for free to add matches to My Scores and then use the iOS app to receive score notifications direct to your phone during a game.'
          ),
          _react2.default.createElement(_RegisterLoginButtons2.default, null)
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FootballMyScores, [{
    key: 'isLoggedIn',
    value: function isLoggedIn() {
      var _props$auth = this.props.auth;
      _props$auth = _props$auth === undefined ? {} : _props$auth;
      var _props$auth$loggedIn = _props$auth.loggedIn,
          loggedIn = _props$auth$loggedIn === undefined ? false : _props$auth$loggedIn,
          user = _props$auth.user;


      return !!(loggedIn && user);
    }
  }, {
    key: 'filterMatchesBySubscriptions',
    value: function filterMatchesBySubscriptions() {
      var matchList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var subscriptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var myMatchSelectionIds = subscriptions[_consts.SUBSCRIPTIONS_FOOTBALL_MATCH];

      return matchList.filter(function (match) {
        var _match$match_referenc = match.match_reference;
        _match$match_referenc = _match$match_referenc === undefined ? {} : _match$match_referenc;
        var matchId = _match$match_referenc.id;


        if (myMatchSelectionIds) {
          return myMatchSelectionIds[matchId] != null;
        } else {
          return false;
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$hideIfEmpty = _props.hideIfEmpty,
          hideIfEmpty = _props$hideIfEmpty === undefined ? false : _props$hideIfEmpty,
          _props$matchList = _props.matchList,
          matchList = _props$matchList === undefined ? [] : _props$matchList,
          _props$subscriptions = _props.subscriptions,
          subscriptions = _props$subscriptions === undefined ? {} : _props$subscriptions;


      var selectedMatches = this.filterMatchesBySubscriptions(matchList, subscriptions);

      if (hideIfEmpty && selectedMatches.length === 0) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'FootballMatchList' },
        _react2.default.createElement(
          _CollapsibleSection2.default,
          { title: 'My Scores' },
          this.isLoggedIn() ? this.renderLoggedIn(selectedMatches) : this.renderDefault()
        )
      );
    }
  }, {
    key: 'renderLoggedIn',
    value: function renderLoggedIn(selectedMatches) {
      return selectedMatches.length ? _react2.default.createElement(_FootballMatchList2.default, { matchList: selectedMatches }) : _react2.default.createElement(
        'div',
        { className: 'matchlist-fav-container' },
        _react2.default.createElement(
          'span',
          { className: 'matchlist-favs-info' },
          'Starring a match will add it to \'My Scores\'. You\'ll also get goal notifications for this match.'
        )
      );
    }
  }]);
  return FootballMyScores;
}(_react.Component), _class2.propTypes = {
  auth: _propTypes2.default.object.isRequired,
  matchList: _propTypes2.default.array.isRequired,
  subscriptions: _propTypes2.default.object.isRequired,
  hideIfEmpty: _propTypes2.default.bool
}, _temp2)) || _class);
exports.default = FootballMyScores;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.loadCompetitionMatches = loadCompetitionMatches;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _LocalDateTimeHelper = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_MATCHES = 'football/competitions/LOAD_MATCHES';
var LOAD_MATCHES_SUCCESS = 'football/competitions/LOAD_MATCHES_SUCCESS';
var LOAD_MATCHES_FAIL = 'football/competitions/LOAD_MATCHES_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_MATCHES:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_MATCHES_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          loading: false,
          loaded: true,
          matches: action.result
        });
      }
    case LOAD_MATCHES_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading(globalState) {
  return globalState.football && globalState.football.competitionMatches && globalState.football.competitionMatches.loading;
}

function loadCompetitionMatches(competitionId, month, fixturesResults) {
  var params = void 0;

  if (!month) {
    params = {
      default_month: true
    };
  } else {
    params = {
      from: (0, _LocalDateTimeHelper.isoDate)((0, _LocalDateTimeHelper.yearMonthToMoment)(month).startOf('month')),
      to: (0, _LocalDateTimeHelper.isoDate)((0, _LocalDateTimeHelper.yearMonthToMoment)(month).add(1, 'month').startOf('month'))
    };
  }

  params = (0, _extends3.default)({}, params, {
    results_only: fixturesResults == "results"
  });

  return {
    types: [LOAD_MATCHES, LOAD_MATCHES_SUCCESS, LOAD_MATCHES_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.football.competitions + '/' + competitionId + '/matches', { params: params });
    }
  };
}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_MATCH_AND_EVENTS_FAIL = exports.LOAD_MATCH_AND_EVENTS_SUCCESS = exports.LOAD_MATCH_AND_EVENTS = undefined;

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__(7);

var _extends6 = _interopRequireDefault(_extends5);

exports.default = reducer;
exports.isMatchLoading = isMatchLoading;
exports.loadMatchAndEvents = loadMatchAndEvents;
exports.cardEvent = cardEvent;
exports.subEvent = subEvent;
exports.teamPlayerEventOccursUpon = teamPlayerEventOccursUpon;
exports.goalEvent = goalEvent;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _consts = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_MATCH_AND_EVENTS = exports.LOAD_MATCH_AND_EVENTS = 'football/match/LOAD_MATCH_AND_EVENTS';
var LOAD_MATCH_AND_EVENTS_SUCCESS = exports.LOAD_MATCH_AND_EVENTS_SUCCESS = 'football/match/LOAD_MATCH_AND_EVENTS_SUCCESS';
var LOAD_MATCH_AND_EVENTS_FAIL = exports.LOAD_MATCH_AND_EVENTS_FAIL = 'football/match/LOAD_MATCH_AND_EVENTS_FAIL';

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_MATCH_AND_EVENTS:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.matchId, (0, _extends6.default)({}, state[action.matchId], {
        matchLoading: true
      })));
    case LOAD_MATCH_AND_EVENTS_SUCCESS:
      {
        var currentMatch = transformMatch(state[action.matchId].match, action.result.matchDetails);
        var events = transformEvent(currentMatch, action.result.eventData);

        var _ref = state || {},
            _ref$action$matchId = _ref[action.matchId];

        _ref$action$matchId = _ref$action$matchId === undefined ? {} : _ref$action$matchId;
        var _ref$action$matchId$e = _ref$action$matchId.events,
            stateEvents = _ref$action$matchId$e === undefined ? {} : _ref$action$matchId$e;


        return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.matchId, (0, _extends6.default)({}, state[action.matchId], {
          matchLoading: false,
          matchLoaded: true,
          match: currentMatch,
          events: (0, _extends6.default)({}, stateEvents, events.events),
          last_modified_date: events.last_modified_date
        })));
      }
    case LOAD_MATCH_AND_EVENTS_FAIL:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.matchId, (0, _extends6.default)({}, state[action.matchId], {
        matchLoading: false,
        matchLoaded: false,
        error: action.error
      })));

    default:
      return state;
  }
}

function isMatchLoading(globalState, matchId) {
  return globalState.football.match[matchId] && globalState.football.match[matchId].matchLoading;
}

function loadMatchAndEvents(matchId, last_modified_date) {
  return {
    types: [LOAD_MATCH_AND_EVENTS, LOAD_MATCH_AND_EVENTS_SUCCESS, LOAD_MATCH_AND_EVENTS_FAIL],
    matchId: matchId,
    promise: function promise(client) {
      return _promise2.default.all([client.get(_config2.default.api.football.matchDetail + '/' + matchId), client.get(_config2.default.api.football.matchEvents, { params: { match_id: matchId, last_modified_date: last_modified_date, include_all_types: true } })]).then(function (results) {
        return {
          matchDetails: results[0],
          eventData: results[1]
        };
      });
    }
  };
}

function transformMatch() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      matchDetail = _ref2.match_detail,
      homeTeam = _ref2.homeTeam,
      awayTeam = _ref2.awayTeam;

  var resp = arguments[1];

  var hTeamPlayers = homeTeam ? homeTeam.players.players : [];
  var aTeamPlayers = awayTeam ? awayTeam.players.players : [];

  var aggregate_score = void 0;

  var _resp$team_score_a = resp.team_score_a;
  _resp$team_score_a = _resp$team_score_a === undefined ? {} : _resp$team_score_a;
  var teamAAggregate = _resp$team_score_a.aggregate_score,
      _resp$team_score_b = resp.team_score_b;
  _resp$team_score_b = _resp$team_score_b === undefined ? {} : _resp$team_score_b;
  var teamBAggregate = _resp$team_score_b.aggregate_score,
      _resp$team_statistics = resp.team_statistics_a,
      team_statistics_a = _resp$team_statistics === undefined ? {} : _resp$team_statistics,
      _resp$team_statistics2 = resp.team_statistics_b,
      team_statistics_b = _resp$team_statistics2 === undefined ? {} : _resp$team_statistics2;


  if (teamAAggregate != undefined && teamBAggregate != undefined) {
    aggregate_score = {
      home: resp.team_score_a.aggregate_score,
      away: resp.team_score_b.aggregate_score
    };
  }

  return {
    homeTeam: transformTeam(hTeamPlayers, resp.lineup_a, resp.team_score_a.team, resp.formation_a),
    awayTeam: transformTeam(aTeamPlayers, resp.lineup_b, resp.team_score_b.team, resp.formation_b),
    match_detail: {
      match_reference: resp.match_reference,
      match_date: resp.match_date,
      match_time: resp.match_time,
      match_outcome: resp.match_outcome,
      competition: resp.competition,
      team_score_a: {
        team: resp.team_score_a.team,
        total_goals: resp.team_score_a.score[0].score,
        goals: matchDetail ? matchDetail.team_score_a.goals : []
      },
      team_score_b: {
        team: resp.team_score_b.team,
        total_goals: resp.team_score_b.score[0].score,
        goals: matchDetail ? matchDetail.team_score_b.goals : []
      },
      clock: resp.clock,
      half_time_score: resp.half_time_score,
      full_time_score: resp.full_time_score,
      extra_time_score: resp.extra_time_score,
      penalty_shootout_score: resp.penalty_shootout_score,
      aggregate_score: aggregate_score,
      state: resp.state,
      attendance: resp.attendance,
      referee: resp.referee,
      description: resp.description,
      match_betting_market: resp.match_betting_market,
      venue: resp.venue
    },
    team_statistics_a: team_statistics_a,
    team_statistics_b: team_statistics_b
  };
}

function transformTeam(teamPlayers, lineUp, team, formation) {
  return {
    teamName: team.name,
    teamId: team.team_reference.id,
    players: transformPlayers(lineUp, teamPlayers),
    formation: formation
  };
}

function transformPlayers(lineUp, teamPlayers) {
  var players = lineUp.map(function (player, index) {
    return (0, _extends6.default)({}, player, {
      id: player.player.player_reference.id,
      name: player.player.display_name,
      shirt_number: player.player.shirt_number,
      starter: player.starter,
      sub: teamPlayers[index] ? teamPlayers[index].sub : {},
      yellowCardTime: teamPlayers[index] ? teamPlayers[index].yellowCardTime : undefined,
      secondYellowCardTime: teamPlayers[index] ? teamPlayers[index].secondYellowCardTime : undefined,
      redCardTime: teamPlayers[index] ? teamPlayers[index].redCardTime : undefined
    });
  });
  return { players: players };
}

function transformEvent(currentMatch, _ref3) {
  var events = _ref3.match_event,
      last_modified_date = _ref3.last_modified_date;

  var transformedEvents = events.map(function (event) {
    if (event.event.event_type != null) {
      switch (event.event.event_type.event_type) {
        case _consts.GOAL:
          goalEvent(currentMatch.match_detail, event, null);
          break;
        case _consts.OWNGOAL:
          goalEvent(currentMatch.match_detail, event, 'og');
          break;
        case _consts.PENALTY:
          goalEvent(currentMatch.match_detail, event, 'pen');
          break;
        case _consts.REDCARD:
          cardEvent(currentMatch, event, _consts.REDCARD);
          break;
        case _consts.YELLOWCARD:
          cardEvent(currentMatch, event, _consts.YELLOWCARD);
          break;
        case _consts.SECONDYELLOWCARD:
          cardEvent(currentMatch, event, _consts.SECONDYELLOWCARD);
          break;
        case _consts.SUBON:
          subEvent(currentMatch, event, _consts.SUBON);
          break;
        case _consts.SUBOFF:
          subEvent(currentMatch, event, _consts.SUBOFF);
          break;
        default:
          break;
      }
    }
    return {
      events: (0, _defineProperty3.default)({}, event.match_event_reference.id, event)
    };
  }).reduce(function (prev, current) {
    return {
      events: (0, _extends6.default)({}, prev.events, current.events)
    };
  }, { events: {} });
  transformedEvents.last_modified_date = last_modified_date;
  return transformedEvents;
}

function cardEvent(currentMatch, event, cardColour) {
  var player = teamPlayerEventOccursUpon(currentMatch, event);
  // each player should only ever have at most one of each card (e.g. cannot have 2 red cards)
  switch (cardColour) {
    case _consts.YELLOWCARD:
      player.yellowCardTime = event.match_time;
      break;
    case _consts.SECONDYELLOWCARD:
      player.secondYellowCardTime = event.match_time;
      break;
    case _consts.REDCARD:
      player.redCardTime = event.match_time;
      break;
  }
}

function subEvent(currentMatch, event, subDirection) {
  var player = teamPlayerEventOccursUpon(currentMatch, event);
  if (!player) {
    return;
  }
  if (subDirection == _consts.SUBON) {
    player.sub.subbedOn = true;
    player.sub.onTime = event.match_time;
  } else if (subDirection == _consts.SUBOFF) {
    player.sub.subbedOff = true;
    player.sub.offTime = event.match_time;
  }
}

function teamPlayerEventOccursUpon(currentMatch, event) {
  var teamPlayers = homeOrAwayPlayers(currentMatch, event.event.team.team_reference.id);
  return teamPlayers.players.find(function (player) {
    return player.id == _lodash2.default.get(event, 'event.player.player_reference.id', "none");
  });
}

function homeOrAwayPlayers(currentMatch, teamReferenceId) {
  if (teamReferenceId == currentMatch.homeTeam.teamId) {
    return currentMatch.homeTeam.players;
  } else {
    return currentMatch.awayTeam.players;
  }
}

function goalEvent(currentMatch, event, goalType) {

  var team = teamEventOccursUpon(currentMatch, event);

  if (team && event && currentMatch) {
    updateTeamGoalScorer(team, event, goalType);
  }
}

function updateTeamGoalScorer(teamScore, goalEvent, goalType) {
  var _ref4 = goalEvent || {},
      _ref4$event = _ref4.event;

  _ref4$event = _ref4$event === undefined ? {} : _ref4$event;
  var _ref4$event$player = _ref4$event.player;
  _ref4$event$player = _ref4$event$player === undefined ? {} : _ref4$event$player;
  var _ref4$event$player$pl = _ref4$event$player.player_reference;
  _ref4$event$player$pl = _ref4$event$player$pl === undefined ? {} : _ref4$event$player$pl;
  var goalScorerId = _ref4$event$player$pl.id,
      _ref4$event$player$di = _ref4$event$player.display_name,
      playerDisplayName = _ref4$event$player$di === undefined ? "" : _ref4$event$player$di,
      _ref4$match_event_ref = _ref4.match_event_reference;
  _ref4$match_event_ref = _ref4$match_event_ref === undefined ? {} : _ref4$match_event_ref;
  var goalEventMatchId = _ref4$match_event_ref.id,
      goalEventMatchTime = _ref4.match_time;

  var _ref5 = teamScore || {},
      _ref5$goals = _ref5.goals,
      teamGoals = _ref5$goals === undefined ? [] : _ref5$goals;

  var goalScorerHasAlreadyScored = void 0;

  teamGoals.forEach(function (goalScorer) {
    if (goalScorer.id == goalScorerId) {
      goalScorerHasAlreadyScored = goalScorer;

      // Check if this is an update for a previous event and remove the old one if so
      var filteredGoals = goalScorer.goal.filter(function (event) {
        return event.event_id != goalEventMatchId;
      });
      if (filteredGoals.length != goalScorer.goal.length) {
        goalScorer.goal = filteredGoals;
      }

      goalScorer.goal.push({
        type: goalType,
        time: goalEventMatchTime,
        event_id: goalEventMatchId,
        event_time: goalEvent.date
      });
    }
  });

  if (goalScorerHasAlreadyScored == undefined) {
    teamGoals.push({
      team_player: playerDisplayName,
      id: goalScorerId,
      goal: [{
        type: goalType,
        time: goalEventMatchTime,
        event_id: goalEventMatchId,
        event_time: goalEvent.date
      }]
    });
  }
}

function teamEventOccursUpon(currentMatch, event) {
  var _ref6 = event || {},
      _ref6$event = _ref6.event;

  _ref6$event = _ref6$event === undefined ? {} : _ref6$event;
  var _ref6$event$team = _ref6$event.team;
  _ref6$event$team = _ref6$event$team === undefined ? {} : _ref6$event$team;
  var _ref6$event$team$team = _ref6$event$team.team_reference;
  _ref6$event$team$team = _ref6$event$team$team === undefined ? {} : _ref6$event$team$team;
  var scoringTeamId = _ref6$event$team$team.id;

  var _ref7 = currentMatch || {},
      _ref7$team_score_a = _ref7.team_score_a;

  _ref7$team_score_a = _ref7$team_score_a === undefined ? {} : _ref7$team_score_a;
  var _ref7$team_score_a$te = _ref7$team_score_a.team;
  _ref7$team_score_a$te = _ref7$team_score_a$te === undefined ? {} : _ref7$team_score_a$te;
  var _ref7$team_score_a$te2 = _ref7$team_score_a$te.team_reference;
  _ref7$team_score_a$te2 = _ref7$team_score_a$te2 === undefined ? {} : _ref7$team_score_a$te2;
  var teamAId = _ref7$team_score_a$te2.id,
      teamScoreA = _ref7.team_score_a,
      _ref7$team_score_b = _ref7.team_score_b;
  _ref7$team_score_b = _ref7$team_score_b === undefined ? {} : _ref7$team_score_b;
  var _ref7$team_score_b$te = _ref7$team_score_b.team;
  _ref7$team_score_b$te = _ref7$team_score_b$te === undefined ? {} : _ref7$team_score_b$te;
  var _ref7$team_score_b$te2 = _ref7$team_score_b$te.team_reference;
  _ref7$team_score_b$te2 = _ref7$team_score_b$te2 === undefined ? {} : _ref7$team_score_b$te2;
  var teamBId = _ref7$team_score_b$te2.id,
      teamScoreB = _ref7.team_score_b;


  if (scoringTeamId) {
    if (scoringTeamId == teamAId) {
      return teamScoreA;
    } else if (scoringTeamId == teamBId) {
      return teamScoreB;
    }
  }
}

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.loadTeam = loadTeam;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_TEAM = 'football/competitions/LOAD_TEAM';
var LOAD_TEAM_SUCCESS = 'football/competitions/LOAD_TEAM_SUCCESS';
var LOAD_TEAM_FAIL = 'football/competitions/LOAD_TEAM_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_TEAM:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_TEAM_SUCCESS:
      {
        return (0, _extends3.default)({}, state, {
          loading: false,
          loaded: true,
          teamData: action.result
        });
      }
    case LOAD_TEAM_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading(globalState) {
  return globalState.football && globalState.football.competition && globalState.football.competition.loading;
}

function loadTeam(teamId, fixturesResults) {
  var params = {
    results_only: fixturesResults == "results"
  };

  return {
    types: [LOAD_TEAM, LOAD_TEAM_SUCCESS, LOAD_TEAM_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.football.teams + '/' + teamId, { params: params });
    }
  };
}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__(7);

var _extends6 = _interopRequireDefault(_extends5);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'football/teamForm/LOAD';
var LOAD_SUCCESS = 'football/teamForm/LOAD_SUCCESS';
var LOAD_FAIL = 'football/teamForm/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.matchId, (0, _extends6.default)({}, state[action.matchId], {
        loading: true
      })));
    case LOAD_SUCCESS:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.matchId, (0, _extends6.default)({}, state[action.matchId], {
        loading: false,
        loaded: true,
        form: action.result
      })));
    case LOAD_FAIL:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.matchId, (0, _extends6.default)({}, state[action.matchId], {
        loading: false,
        loaded: false,
        error: action.error
      })));
    default:
      return state;
  }
}

function isLoading(globalState, matchId) {
  return globalState.football && globalState.football.teamForm && globalState.football.teamForm[matchId] && globalState.football.teamForm[matchId].loading;
}

function load(matchId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.football.loadTeamForm, { params: { match_id: matchId } });
    },
    matchId: matchId
  };
}

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__(7);

var _extends6 = _interopRequireDefault(_extends5);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _MockHeadToHeadData = __webpack_require__(857);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'football/teamH2H/LOAD'; // saved for later
// import config from 'config';

var LOAD_SUCCESS = 'football/teamH2H/LOAD_SUCCESS';
var LOAD_FAIL = 'football/teamH2H/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.matchId, (0, _extends6.default)({}, state[action.matchId], {
        loading: true
      })));
    case LOAD_SUCCESS:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.matchId, (0, _extends6.default)({}, state[action.matchId], {
        loading: false,
        loaded: true,
        H2H: action.result
      })));
    case LOAD_FAIL:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.matchId, (0, _extends6.default)({}, state[action.matchId], {
        loading: false,
        loaded: false,
        error: action.error
      })));
    default:
      return state;
  }
}

function isLoading(globalState, matchId) {
  return globalState.football && globalState.football.teamH2H && globalState.football.teamH2H[matchId] && globalState.football.teamH2H[matchId].loading;
}

function load(matchId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise() {
      return _promise2.default.resolve(_MockHeadToHeadData.HEADTOHEAD);
    },
    matchId: matchId
  };
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GreyhoundRacingRacecardResultRunner;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _consts = __webpack_require__(393);

var _Cloth = __webpack_require__(355);

var _Cloth2 = _interopRequireDefault(_Cloth);

var _Ordinal = __webpack_require__(200);

var _Ordinal2 = _interopRequireDefault(_Ordinal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1416);

function GreyhoundRacingRacecardResultRunner(props) {
  var _props$runner = props.runner,
      position = _props$runner.position,
      finishDistance = _props$runner.finishDistance,
      clothNo = _props$runner.clothNo,
      greyhoundName = _props$runner.greyhoundName,
      odds = _props$runner.odds,
      _props$runner$runSpli = _props$runner.runSplit,
      runSplit = _props$runner$runSpli === undefined ? 'N/A' : _props$runner$runSpli,
      runTime = _props$runner.runTime,
      trainerName = _props$runner.trainer.name,
      runDesc = _props$runner.runDesc,
      reserve = _props$runner.reserve;


  return _react2.default.createElement(
    'section',
    { className: 'gh-racing-result-runner-wrapper' },
    _react2.default.createElement(
      'div',
      { className: 'gh-racing-result-runner-key-info-container' },
      _react2.default.createElement(
        'div',
        { className: 'gh-racing-result-runner-position' },
        _react2.default.createElement(_Ordinal2.default, { n: position })
      ),
      _react2.default.createElement(
        'div',
        { className: 'gh-racing-result-runner-distance' },
        finishDistance
      ),
      _react2.default.createElement(
        'div',
        { className: 'gh-racing-result-runner-cloth' },
        _react2.default.createElement(_Cloth2.default, { number: clothNo })
      ),
      _react2.default.createElement(
        'div',
        { className: 'gh-racing-result-runner-greyhound-info' },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'span',
            { className: 'gh-racing-result-runner-greyhound-name' },
            _react2.default.createElement(
              'span',
              { to: '/greyhounds/profiles/dog/' + greyhoundName },
              greyhoundName
            )
          ),
          _react2.default.createElement(
            'span',
            {
              className: 'gh-racing-result-runner-betting-odds sui-odds' },
            odds
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'gh-racing-result-runner-greyhound-sub-info' },
            _react2.default.createElement(
              'span',
              { className: 'gh-racing-result-runner-split' },
              _react2.default.createElement(
                'span',
                { className: 'gh-racing-result-runner-split-emphasis' },
                'Split:'
              ),
              ' ',
              runSplit
            ),
            _react2.default.createElement(
              'span',
              { className: 'gh-racing-result-runner-time' },
              _react2.default.createElement(
                'span',
                { className: 'gh-racing-result-runner-time-emphasis' },
                'Time:'
              ),
              ' ',
              runTime
            )
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'gh-racing-result-runner-run-info-container' },
      reserve ? _react2.default.createElement(
        'span',
        { className: 'gh-racing-result-runner-reserve' },
        _consts.REPLACEMENT_DOG_STRING
      ) : _react2.default.createElement(
        'span',
        { className: 'gh-racing-result-runner-run-trainer' },
        _react2.default.createElement(
          'span',
          { className: 'gh-racing-result-runner-run-trainer-emphasis' },
          'T:'
        ),
        ' ',
        trainerName
      ),
      _react2.default.createElement(
        'span',
        { className: 'gh-racing-result-runner-run-desc' },
        runDesc
      )
    )
  );
}

GreyhoundRacingRacecardResultRunner.propTypes = {
  runner: _propTypes2.default.object,
  showLastRun: _propTypes2.default.bool
};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _consts = __webpack_require__(393);

var _Cloth = __webpack_require__(355);

var _Cloth2 = _interopRequireDefault(_Cloth);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _LocalDateTimeHelper = __webpack_require__(13);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1417);

var GreyhoundRacingRacecardRunner = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GreyhoundRacingRacecardRunner, _Component);

  function GreyhoundRacingRacecardRunner(props) {
    (0, _classCallCheck3.default)(this, GreyhoundRacingRacecardRunner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GreyhoundRacingRacecardRunner.__proto__ || (0, _getPrototypeOf2.default)(GreyhoundRacingRacecardRunner)).call(this, props));

    _this.state = {
      formExpanded: false
    };
    return _this;
  }

  (0, _createClass3.default)(GreyhoundRacingRacecardRunner, [{
    key: 'hasFormList',
    value: function hasFormList() {
      var _props$runner = this.props.runner;
      _props$runner = _props$runner === undefined ? {} : _props$runner;
      var _props$runner$greyhou = _props$runner.greyhound;
      _props$runner$greyhou = _props$runner$greyhou === undefined ? {} : _props$runner$greyhou;
      var _props$runner$greyhou2 = _props$runner$greyhou.previous_results;
      _props$runner$greyhou2 = _props$runner$greyhou2 === undefined ? {} : _props$runner$greyhou2;
      var length = _props$runner$greyhou2.length;

      return !!length;
    }
  }, {
    key: 'toggleFormExpanded',
    value: function toggleFormExpanded() {
      this.setState({ formExpanded: this.hasFormList() && !this.state.formExpanded });
    }
  }, {
    key: 'toggleLastRunVideo',
    value: function toggleLastRunVideo() {
      this.setState({ showLastRunVideo: !this.state.showLastRunVideo });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$runner2 = this.props.runner,
          clothNo = _props$runner2.clothNo,
          greyhoundName = _props$runner2.greyhoundName,
          trainerName = _props$runner2.trainer.name,
          _props$runner2$form = _props$runner2.form,
          form = _props$runner2$form === undefined ? 'N/A' : _props$runner2$form,
          greyhound = _props$runner2.greyhound,
          _props$runner2$bestRu = _props$runner2.bestRunTime,
          bestRunTime = _props$runner2$bestRu === undefined ? 'N/A' : _props$runner2$bestRu,
          _props$runner2$lastRu = _props$runner2.lastRunTime,
          lastRunTime = _props$runner2$lastRu === undefined ? 'N/A' : _props$runner2$lastRu,
          reserve = _props$runner2.reserve;
      var formExpanded = this.state.formExpanded;


      var runnerHasForm = this.hasFormList();

      return _react2.default.createElement(
        'section',
        { className: 'gh-racing-runner-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'gh-racing-runner-key-info-container' },
          _react2.default.createElement(
            'div',
            { className: 'gh-racing-runner-cloth' },
            _react2.default.createElement(_Cloth2.default, { number: clothNo })
          ),
          _react2.default.createElement(
            'div',
            { className: 'gh-racing-runner-greyhound-info' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'gh-racing-runner-greyhound-name' },
                _react2.default.createElement(
                  'span',
                  { to: '/greyhounds/profiles/dog/' + greyhoundName },
                  greyhoundName
                ),
                _react2.default.createElement(
                  'sup',
                  { className: 'gh-racing-runner-greyhound-last-ran' },
                  '(' + greyhound.sex + (greyhound.colour ? ' - ' + greyhound.colour : '') + ')'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'gh-racing-runner-greyhound-sub-info' },
                _react2.default.createElement(
                  'span',
                  null,
                  'Best: ',
                  bestRunTime
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  'Last: ',
                  lastRunTime
                )
              )
            )
          ),
          _react2.default.createElement('div', { className: 'gh-racing-runner-betting-odds' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'gh-racing-runner-form-history-container' },
          _react2.default.createElement(
            'div',
            { className: 'gh-racing-runner-form-key-info' },
            _react2.default.createElement(
              'button',
              { className: 'gh-racing-runner-show-form', onClick: function onClick(e) {
                  return _this2.toggleFormExpanded(e);
                }, disabled: !runnerHasForm },
              runnerHasForm && _react2.default.createElement(_CaretIcon2.default, { type: 'full', direction: formExpanded ? 'up' : 'down' }),
              _react2.default.createElement(
                'label',
                { className: 'gh-racing-runner-form-stat' },
                _react2.default.createElement(
                  'span',
                  null,
                  'Form:'
                ),
                '\xA0',
                form
              )
            ),
            _react2.default.createElement(
              'span',
              { className: 'gh-racing-runner-form-trainer' },
              'T: ',
              trainerName
            )
          ),
          formExpanded && _react2.default.createElement(
            'div',
            { className: 'gh-racing-runner-form-table' },
            _react2.default.createElement(
              'table',
              { className: 'default-table' },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    'Date'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Track'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Dist'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Trp'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Split'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Pos'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'By'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'SP'
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Time'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                greyhound.previous_results.map(function (result) {
                  return _react2.default.createElement(
                    'tr',
                    { key: result.race_id },
                    _react2.default.createElement(
                      'td',
                      null,
                      (0, _LocalDateTimeHelper.localFullDateShort)(result.date)
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      result.course_name
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      result.distance + 'm'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      result.trap_number
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      result.sectional_time
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      result.position
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      result.finish_distance || '-'
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      result.odds
                    ),
                    _react2.default.createElement(
                      'td',
                      null,
                      result.run_time
                    )
                  );
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'gh-racing-runner-sire-dam-container' },
          _react2.default.createElement(
            'span',
            { className: 'gh-racing-runner-sire-dam-text' },
            _lodash2.default.get(greyhound, "sire.name", "Unknown") + '/' + _lodash2.default.get(greyhound, "dam.name", "Unknown")
          ),
          reserve && _react2.default.createElement(
            'span',
            { className: 'gh-racing-runner-reserve-text' },
            _consts.REPLACEMENT_DOG_STRING
          )
        )
      );
    }
  }]);
  return GreyhoundRacingRacecardRunner;
}(_react.Component), _class.propTypes = {
  runner: _propTypes2.default.object,
  showLastRun: _propTypes2.default.bool
}, _temp);
exports.default = GreyhoundRacingRacecardRunner;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = RacecardsMeetingSummary;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _utils = __webpack_require__(18);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _RaceJSONLD = __webpack_require__(201);

var _RaceJSONLD2 = _interopRequireDefault(_RaceJSONLD);

var _LocalDateTimeHelper = __webpack_require__(13);

var _LocalDateTime = __webpack_require__(61);

var _CollapsibleSection = __webpack_require__(99);

var _CollapsibleSection2 = _interopRequireDefault(_CollapsibleSection);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _consts = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// function
function RacecardsMeetingSummary(props) {
  var meeting = props.meeting;

  // TODO: get this information from the request
  var isBags = false;

  meeting.races = _lodash2.default.sortBy(meeting.races, ['date', function (race) {
    return (0, _LocalDateTimeHelper.localTimeShort)(race.date + 'T' + race.time + 'Z');
  }]);

  var meetingDate = props.date;
  var courseNameSlug = (0, _utils.slug)(meeting.meeting_summary.course.name).toLowerCase();

  return _react2.default.createElement(
    'section',
    { className: 'gh-meeting-container' },
    _react2.default.createElement(_RaceJSONLD2.default, (0, _extends3.default)({ meeting: meeting }, { sport: 'greyhounds', type: 'racecard' })),
    props.dateIncrement === 1 ? _react2.default.createElement(
      _CollapsibleSection2.default,
      { title: meeting.meeting_summary.course.name },
      ' ',
      isBags && _react2.default.createElement(
        'div',
        { className: 'gh-meeting-meta' },
        _react2.default.createElement(
          'div',
          { className: 'gh-meeting-meta-bags' },
          _react2.default.createElement(
            'span',
            { className: 'gh-meeting-meta-label' },
            'BAGS'
          )
        )
      ),
      _react2.default.createElement(
        'ul',
        { className: 'gh-meeting-races-container' },
        meeting.races.map(function (race) {
          return _react2.default.createElement(
            'li',
            { key: race.race_summary_reference.id },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: _consts.GREYHOUND_RACE_COMPLETE_STATUSES.includes(race.race_stage) ? "gh-meeting-race-resulted" : "", to: '/greyhounds/racecards/' + meetingDate + '/' + courseNameSlug + '/racecard/' + race.race_summary_reference.id },
              _react2.default.createElement(_LocalDateTime.LocalTimeShort, { className: 'gh-meeting-race-time', iso: race.date + 'T' + race.time + 'Z' })
            )
          );
        })
      )
    ) : _react2.default.createElement(
      'div',
      { className: 'dividerRow' },
      ' ',
      _react2.default.createElement(
        'div',
        { className: 'divider-title' },
        _react2.default.createElement(
          'div',
          { className: 'divider-title-text' },
          _react2.default.createElement(
            'span',
            null,
            meeting.meeting_summary.course.name
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'divider-subtitle' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: "/greyhounds/fast-results" },
            _react2.default.createElement(_CaretIcon2.default, { type: 'full', direction: 'right' }),
            '\xA0Fast Results'
          )
        )
      ),
      _react2.default.createElement(
        'ul',
        { className: 'gh-meeting-races-container' },
        meeting.races.map(function (race) {
          return _react2.default.createElement(
            'li',
            { key: race.race_summary_reference.id },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: _consts.GREYHOUND_RACE_COMPLETE_STATUSES.includes(race.race_stage) ? "gh-meeting-race-resulted" : "", to: '/greyhounds/racecards/' + meetingDate + '/' + courseNameSlug + '/racecard/' + race.race_summary_reference.id },
              _react2.default.createElement(_LocalDateTime.LocalTimeShort, { className: 'gh-meeting-race-time', iso: race.date + 'T' + race.time + 'Z' })
            )
          );
        })
      )
    )
  );
} // component

RacecardsMeetingSummary.propTypes = {
  meeting: _propTypes2.default.object.isRequired,
  date: _propTypes2.default.string.isRequired,
  dateIncrement: _propTypes2.default.number
};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var REPLACEMENT_DOG_STRING = exports.REPLACEMENT_DOG_STRING = "Reserve";

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'greyhound-racing/fast-results/LOAD';
var LOAD_SUCCESS = 'greyhound-racing/fast-results/LOAD_SUCCESS';
var LOAD_FAIL = 'greyhound-racing/fast-results/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        fastResults: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading(globalState) {
  return globalState.greyhoundRacing && globalState.greyhoundRacing.fastResults && globalState.greyhoundRacing.fastResults.loading;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('' + _config2.default.api.greyhoundRacing.loadFastResult);
    }
  };
}

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isMeetingLoading = isMeetingLoading;
exports.load = load;
exports.loadMeetingByRaceId = loadMeetingByRaceId;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'greyhound-racing/meeting/LOAD';
var LOAD_SUCCESS = 'greyhound-racing/meeting/LOAD_SUCCESS';
var LOAD_FAIL = 'greyhound-racing/meeting/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        meeting: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isMeetingLoading(globalState, meetingId) {
  return globalState.greyhoundRacing.meeting && globalState.greyhoundRacing.meeting.loading && globalState.greyhoundRacing.meeting.meeting && globalState.greyhoundRacing.meeting.meeting.id === meetingId;
}

function load(id) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.greyhoundRacing.loadMeeting + '/' + id);
    }
  };
}

// given a race ID load the corresponding meeting for this race
function loadMeetingByRaceId(raceId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('' + _config2.default.api.greyhoundRacing.loadMeeting, {
        params: {
          raceId: raceId
        }
      });
    }
  };
}

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'greyhound-racing/race/LOAD';
var LOAD_SUCCESS = 'greyhound-racing/race/LOAD_SUCCESS';
var LOAD_FAIL = 'greyhound-racing/race/LOAD_FAIL';

var initialState = {
  loaded: false,
  race: {
    race_summary: {
      meeting_summary_reference: { id: null, external_reference: [] },
      race_summary_reference: { id: null, external_reference: [] },
      name: null,
      course_name: null,
      course_surface: {
        surface: null,
        translation: null
      },
      age: null,
      race_class: null,
      distance: null,
      date: null,
      time: null,
      off_time: null,
      winning_time: null,
      ride_count: null,
      race_stage: null,
      has_video: null,
      going: null,
      has_handicap: false
    },
    previous_winner: null,
    prizes: {
      prize: []
    },
    verdict: null,
    betting_forecast: null,
    rides: [],
    number_of_placed_rides: null,
    videos: [],
    tote_win: null,
    place_win: null,
    exacta_win: null,
    trifecta: null,
    superfecta: null,
    tricast: null,
    swingers: null,
    straight_forecast: null,
    place_pot: { pot: null, pool: null, winStakes: null },
    quad_pot: { pot: null, pool: null, winStakes: null }
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      {
        // TODO: This is in relation to SPL-2289. The array should be fully parsed by this fix.
        // const result = action.result[0] || null;
        return (0, _extends3.default)({}, state, {
          loading: false,
          loaded: true,
          race: action.result,
          error: null
        });
      }
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading(globalState, raceId) {
  return globalState.greyhoundRacing.race && globalState.greyhoundRacing.race.loading && globalState.greyhoundRacing.race.race && globalState.greyhoundRacing.race.race.race_summary && globalState.greyhoundRacing.race.race.race_summary.race_summary_reference && globalState.greyhoundRacing.race.race.race_summary.race_summary_reference.id == raceId;
}

function load(id) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.greyhoundRacing.loadRace + '/' + id);
    }
  };
}

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterRunsByStatus = filterRunsByStatus;
exports.sortByClothNo = sortByClothNo;

var _utils = __webpack_require__(18);

function filterRunsByStatus(runs) {
  for (var _len = arguments.length, statuses = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    statuses[_key - 1] = arguments[_key];
  }

  return runs.filter(function (run) {
    return statuses.includes(run.run_status);
  });
}

function sortByClothNo(run_a, run_b) {
  return run_a.cloth_number - run_b.cloth_number;
}

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _vidiprinter = __webpack_require__(211);

var _FootballVidiprinter = __webpack_require__(263);

var _FootballVidiprinter2 = _interopRequireDefault(_FootballVidiprinter);

var _CaretLink = __webpack_require__(54);

var _CaretLink2 = _interopRequireDefault(_CaretLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VIDIPRINTER_LINES = 5;
var REFRESH_INTERVAL_MILLIS = 10000;

var HomeFootballVidiprinter = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)("HomeFootballVidiprinter", [{
  dispatch: function dispatch() {
    return (0, _vidiprinter.load)(VIDIPRINTER_LINES);
  },
  preventResolve: function preventResolve(_ref) {
    var state = _ref.state;
    return (0, _vidiprinter.isLoading)(state);
  },
  refreshInterval: REFRESH_INTERVAL_MILLIS,
  state: function state(_state) {
    var _state$football$vidip = _state.football.vidiprinter,
        vidiprinter = _state$football$vidip === undefined ? { items: [] } : _state$football$vidip;

    return { vidiprinter: vidiprinter };
  }
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HomeFootballVidiprinter, _Component);

  function HomeFootballVidiprinter() {
    (0, _classCallCheck3.default)(this, HomeFootballVidiprinter);
    return (0, _possibleConstructorReturn3.default)(this, (HomeFootballVidiprinter.__proto__ || (0, _getPrototypeOf2.default)(HomeFootballVidiprinter)).apply(this, arguments));
  }

  (0, _createClass3.default)(HomeFootballVidiprinter, [{
    key: 'render',
    value: function render() {
      var _props$vidiprinter$it = this.props.vidiprinter.items;
      _props$vidiprinter$it = _props$vidiprinter$it === undefined ? {} : _props$vidiprinter$it;
      var _props$vidiprinter$it2 = _props$vidiprinter$it.lines,
          lines = _props$vidiprinter$it2 === undefined ? [] : _props$vidiprinter$it2;


      var limitedVidiprinterItems = {
        lines: lines.slice(0, VIDIPRINTER_LINES)
      };

      return _react2.default.createElement(
        'div',
        { className: 'home-football-vidiprinter', id: 'football-vidiprinter' },
        _react2.default.createElement(
          'div',
          { className: 'section-title' },
          'Vidiprinter'
        ),
        _react2.default.createElement(_FootballVidiprinter2.default, { data: limitedVidiprinterItems }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _CaretLink2.default,
            { to: '/football/live/vidiprinter' },
            'See Full Vidiprinter'
          )
        )
      );
    }
  }]);
  return HomeFootballVidiprinter;
}(_react.Component), _class2.propTypes = {
  vidiprinter: _propTypes2.default.object,
  dispatch: _propTypes2.default.func.isRequired
}, _temp)) || _class);
exports.default = HomeFootballVidiprinter;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _CaretLink = __webpack_require__(54);

var _CaretLink2 = _interopRequireDefault(_CaretLink);

var _CurrencyFormatting = __webpack_require__(175);

var _moment = __webpack_require__(8);

var _moment2 = _interopRequireDefault(_moment);

var _LocalDateTime = __webpack_require__(61);

var _utils = __webpack_require__(32);

var _HorseRacingRideSummaryTable = __webpack_require__(403);

var _HorseRacingRideSummaryTable2 = _interopRequireDefault(_HorseRacingRideSummaryTable);

var _HorseRacingFastRacecardRide = __webpack_require__(400);

var _HorseRacingFastRacecardRide2 = _interopRequireDefault(_HorseRacingFastRacecardRide);

var _HorseRacingFastRacecardExtraPlaces = __webpack_require__(909);

var _HorseRacingFastRacecardExtraPlaces2 = _interopRequireDefault(_HorseRacingFastRacecardExtraPlaces);

var _compare = __webpack_require__(118);

var _rideFilter = __webpack_require__(171);

var _utils2 = __webpack_require__(18);

var _PromoIcon = __webpack_require__(255);

var _PromoIcon2 = _interopRequireDefault(_PromoIcon);

var _urlRewrite = __webpack_require__(120);

var _RaceVideoPlayer = __webpack_require__(170);

var _RaceVideoPlayer2 = _interopRequireDefault(_RaceVideoPlayer);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1423);

var statusFlags = {
  FINISHED: { after: true },
  PHOTOGRAPH: { after: true },
  RESULT: { after: true, positions: true },
  WEIGHEDIN: { after: true, positions: true, full: true }
};

function checkStatus(status, flag) {
  var _statusFlags$status = statusFlags[status];
  _statusFlags$status = _statusFlags$status === undefined ? {} : _statusFlags$status;
  var _statusFlags$status$f = _statusFlags$status[flag],
      result = _statusFlags$status$f === undefined ? false : _statusFlags$status$f;


  return result;
}

function numberSort() {
  for (var _len = arguments.length, numbers = Array(_len), _key = 0; _key < _len; _key++) {
    numbers[_key] = arguments[_key];
  }

  var _numbers$map = numbers.map(function (n) {
    return parseInt(n) || 0;
  }),
      _numbers$map2 = (0, _slicedToArray3.default)(_numbers$map, 2),
      a = _numbers$map2[0],
      b = _numbers$map2[1];

  return a - b;
}

var HorseRacingFastRacecard = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingFastRacecard, _Component);

  function HorseRacingFastRacecard() {
    (0, _classCallCheck3.default)(this, HorseRacingFastRacecard);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HorseRacingFastRacecard.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingFastRacecard)).call(this));

    _this.state = { playerOpen: false };
    return _this;
  }

  (0, _createClass3.default)(HorseRacingFastRacecard, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$top_horses = _props.top_horses,
          topHorses = _props$top_horses === undefined ? [] : _props$top_horses,
          _props$extra_place_ho = _props.extra_place_horses,
          extraPlaceHorses = _props$extra_place_ho === undefined ? [] : _props$extra_place_ho,
          _props$unplaced_favou = _props.unplaced_favourite,
          unplacedFavourite = _props$unplaced_favou === undefined ? [] : _props$unplaced_favou,
          raceTime = _props.time,
          courseName = _props.courseName,
          racecardSlug = _props.slug,
          raceStatus = _props.status,
          _props$meetingMode = _props.meetingMode,
          meetingMode = _props$meetingMode === undefined ? false : _props$meetingMode,
          _props$each_way = _props.each_way,
          eachWay = _props$each_way === undefined ? null : _props$each_way,
          _props$race = _props.race;
      _props$race = _props$race === undefined ? {} : _props$race;
      var _props$race$race_summ = _props$race.race_summary;
      _props$race$race_summ = _props$race$race_summ === undefined ? {} : _props$race$race_summ;
      var _props$race$race_summ2 = _props$race$race_summ.promotion;
      _props$race$race_summ2 = _props$race$race_summ2 === undefined ? {} : _props$race$race_summ2;
      var promotionImage = _props$race$race_summ2.image,
          redirect_url = _props$race$race_summ2.redirect_url;


      var today = (0, _moment2.default)().format("YYYY-MM-DD");
      var favToken = favHorsesToken(topHorses, unplacedFavourite);
      var isAfter = checkStatus(raceStatus, "after");
      var showRides = checkStatus(raceStatus, "positions") && topHorses.length > 0;

      var togglePlayer = function togglePlayer() {
        _this2.setState(function (prevState) {
          return { playerOpen: !prevState.playerOpen };
        });
      };

      var linkType = void 0;

      if (checkStatus(raceStatus, "full")) {
        linkType = "full";
      } else if (isAfter) {
        linkType = "disabled";
      } else {
        linkType = "card";
      }

      function cardUrl() {
        var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

        return '/racing/racecards/' + slug;
      }

      function resultUrl() {
        var slug = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

        // Slug comes from the API, which is why it needs (a) being super careful to cast to string and (b) altering to a result slug
        return '/racing/results/' + ('' + slug).replace("/racecard/", "/");
      }

      var showPromo = !!(redirect_url && (0, _utils.isBeforeOffStatus)(raceStatus));

      return _react2.default.createElement(
        'div',
        { className: 'fast-racecard-item' },
        _react2.default.createElement(
          'div',
          { className: 'fast-racecard-header' },
          _react2.default.createElement(
            'div',
            { className: 'fast-racecard-header-race', id: (0, _urlRewrite.titleToId)(courseName) },
            !!raceTime && _react2.default.createElement(_LocalDateTime.LocalTimeShort, { iso: today + 'T' + raceTime + 'Z' }),
            ' ',
            !meetingMode && (courseName ? courseName : "Unknown")
          ),
          showPromo && _react2.default.createElement(
            'div',
            { className: 'hr-meeting-race-promo' },
            _react2.default.createElement(
              'span',
              { className: 'hr-meeting-race-promo-icon' },
              _react2.default.createElement(_PromoIcon2.default, { type: promotionImage })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: "fast-racecard-header-fulllink" + (_lodash2.default.get(this, "props.videos.length") > 0 ? " button-with-radius" : "") },
            linkType == "card" && _react2.default.createElement(
              _CaretLink2.default,
              { to: cardUrl(racecardSlug) },
              'Race card'
            ),
            linkType == "full" && _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { className: "fast-racecard-header-fulllink-btn" + (_lodash2.default.get(this, "props.videos.length") > 0 ? "  button-without-radius" : ""), to: resultUrl(racecardSlug) },
                'Full Result'
              ),
              _lodash2.default.get(this, "props.videos.length") > 0 && _react2.default.createElement(_reactRouter.Link, { className: 'fast-racecard-header-fulllink-btn-video', to: resultUrl(racecardSlug) })
            ),
            linkType == "disabled" && _react2.default.createElement(
              'span',
              { className: 'fast-racecard-header-fulllink-btn without-video' },
              'Full Result'
            )
          )
        ),
        showRides && topFinishedRides(topHorses, extraPlaceHorses, favToken, eachWay),
        linkType == "card" && preRaceDetails(this.props),
        linkType != "card" && postRaceDetails(this.state, this.props, isAfter, favToken, togglePlayer, linkType)
      );
    }
  }]);
  return HorseRacingFastRacecard;
}(_react.Component), _class.propTypes = {
  non_runners: _propTypes2.default.arrayOf(_propTypes2.default.number),
  withdrawn: _propTypes2.default.arrayOf(_propTypes2.default.number),
  top_horses: _propTypes2.default.arrayOf(_propTypes2.default.object),
  extra_place_horses: _propTypes2.default.arrayOf(_propTypes2.default.object),
  unplaced_favourite: _propTypes2.default.arrayOf(_propTypes2.default.object),
  winning_trainers: _propTypes2.default.array,
  winning_jockeys: _propTypes2.default.array,
  number_of_placed_rides: _propTypes2.default.number,
  runners: _propTypes2.default.number,
  courseName: _propTypes2.default.string,
  status: _propTypes2.default.string,
  time: _propTypes2.default.string,
  distances: _propTypes2.default.string,
  exacta_win: _propTypes2.default.string,
  place_win: _propTypes2.default.string,
  straight_forecast: _propTypes2.default.string,
  swingers: _propTypes2.default.string,
  tote_win: _propTypes2.default.string,
  tricast: _propTypes2.default.string,
  trifecta: _propTypes2.default.string,
  slug: _propTypes2.default.string,
  meetingMode: _propTypes2.default.bool,
  deductions: _propTypes2.default.array,
  stewards: _propTypes2.default.string,
  race: _propTypes2.default.object,
  videos: _propTypes2.default.array,
  each_way: _propTypes2.default.object,
  promotions: _propTypes2.default.object
}, _temp);
exports.default = HorseRacingFastRacecard;


function topFinishedRides(topHorses, extraPlaceHorses, favToken, eachWay) {
  return _react2.default.createElement(
    'div',
    null,
    topHorses.map(function (ride) {
      return _react2.default.createElement(_HorseRacingFastRacecardRide2.default, { key: ride.horse_reference.id, ride: ride, favToken: favToken });
    }),
    extraPlaceHorses.length > 0 && _react2.default.createElement(_HorseRacingFastRacecardExtraPlaces2.default, { rides: extraPlaceHorses, places: eachWay.places, favToken: favToken })
  );
}

function preRaceDetails(raceDetails) {
  var _raceDetails$race = raceDetails.race;
  _raceDetails$race = _raceDetails$race === undefined ? {} : _raceDetails$race;
  var _raceDetails$race$rac = _raceDetails$race.race_summary;
  _raceDetails$race$rac = _raceDetails$race$rac === undefined ? {} : _raceDetails$race$rac;
  var _raceDetails$race$rac2 = _raceDetails$race$rac.race_summary_reference;
  _raceDetails$race$rac2 = _raceDetails$race$rac2 === undefined ? {} : _raceDetails$race$rac2;
  var _raceDetails$race$rac3 = _raceDetails$race$rac2.external_reference;
  _raceDetails$race$rac3 = _raceDetails$race$rac3 === undefined ? [] : _raceDetails$race$rac3;

  var _raceDetails$race$rac4 = (0, _slicedToArray3.default)(_raceDetails$race$rac3, 1),
      _raceDetails$race$rac5 = _raceDetails$race$rac4[0];

  _raceDetails$race$rac5 = _raceDetails$race$rac5 === undefined ? {} : _raceDetails$race$rac5;
  var raceExternalId = _raceDetails$race$rac5.value,
      distance = _raceDetails$race$rac.distance,
      race_summary = _raceDetails$race.race_summary,
      _raceDetails$race$pri = _raceDetails$race.prizes;
  _raceDetails$race$pri = _raceDetails$race$pri === undefined ? {} : _raceDetails$race$pri;
  var prize = _raceDetails$race$pri.prize,
      rides = _raceDetails$race.rides,
      number_of_placed_rides = _raceDetails$race.number_of_placed_rides,
      each_way = _raceDetails$race.each_way,
      market_suspended = _raceDetails$race.market_suspended,
      fixture = _raceDetails$race.fixture,
      _raceDetails$race$las = _raceDetails$race.last_years_winners;
  _raceDetails$race$las = _raceDetails$race$las === undefined ? [] : _raceDetails$race$las;

  var _raceDetails$race$las2 = (0, _slicedToArray3.default)(_raceDetails$race$las, 1),
      _raceDetails$race$las3 = _raceDetails$race$las2[0];

  _raceDetails$race$las3 = _raceDetails$race$las3 === undefined ? {} : _raceDetails$race$las3;
  var _raceDetails$race$las4 = _raceDetails$race$las3.horse;
  _raceDetails$race$las4 = _raceDetails$race$las4 === undefined ? {} : _raceDetails$race$las4;
  var lastYearWinner = _raceDetails$race$las4.name,
      _raceDetails$race$las5 = _raceDetails$race$las3.meeting_summary;
  _raceDetails$race$las5 = _raceDetails$race$las5 === undefined ? {} : _raceDetails$race$las5;
  var previousResultDate = _raceDetails$race$las5.date,
      _raceDetails$race$las6 = _raceDetails$race$las5.course;
  _raceDetails$race$las6 = _raceDetails$race$las6 === undefined ? {} : _raceDetails$race$las6;
  var previousResultCourseName = _raceDetails$race$las6.name,
      _raceDetails$race$las7 = _raceDetails$race$las3.race_summary;
  _raceDetails$race$las7 = _raceDetails$race$las7 === undefined ? {} : _raceDetails$race$las7;
  var _raceDetails$race$las8 = _raceDetails$race$las7.race_summary_reference;
  _raceDetails$race$las8 = _raceDetails$race$las8 === undefined ? {} : _raceDetails$race$las8;
  var previousResultRaceId = _raceDetails$race$las8.id,
      previousResultRaceName = _raceDetails$race$las7.name,
      runners = raceDetails.runners,
      raceStatus = raceDetails.status,
      stewards = raceDetails.stewards;


  function rideSummary() {
    if (rides) {
      var topRunners = (0, _rideFilter.filterRidesByStatus)(rides, "RUNNER").sort(_compare.sortByOdds).slice(0, number_of_placed_rides);
      return _react2.default.createElement(_HorseRacingRideSummaryTable2.default, { runners: topRunners, raceExternalId: raceExternalId, raceSummary: race_summary, eachWay: each_way,
        suspended: market_suspended, fixture: fixture });
    } else {
      return _react2.default.createElement('div', { className: 'no-rides-available' });
    }
  }

  function topPrize() {
    var _prize$filter$map = prize.filter(function (p) {
      return p.position == 1;
    }).map(function (p) {
      return (0, _CurrencyFormatting.convertCurrencyString)(p.prize);
    }),
        _prize$filter$map2 = (0, _slicedToArray3.default)(_prize$filter$map, 1),
        topPrize = _prize$filter$map2[0];

    return _react2.default.createElement(
      OptionalData,
      { className: 'fast-racecard-always-open', value: topPrize },
      'Winner:'
    );
  }

  return _react2.default.createElement(
    'div',
    { className: 'fast-result-pre-race' },
    rideSummary(),
    _react2.default.createElement(
      'ul',
      { className: 'fast-racecard-content' },
      _react2.default.createElement(
        OptionalData,
        { className: 'fast-racecard-always-open', value: distance },
        'Distance:'
      ),
      prize && topPrize(),
      _react2.default.createElement(
        OptionalData,
        { className: 'fast-racecard-always-open', value: runners },
        'Runners:'
      ),
      _react2.default.createElement(
        OptionalData,
        { className: 'fast-racecard-always-open', value: lastYearWinner },
        'Last Year\'s Winner:'
      ),
      previousResultDate && previousResultCourseName && previousResultRaceId && previousResultRaceName && _react2.default.createElement(
        _CaretLink2.default,
        { to: '/racing/results/' + previousResultDate + '/' + (0, _utils2.toSlug)(previousResultCourseName) + '/' + previousResultRaceId + '/' + (0, _utils2.toSlug)(previousResultRaceName) },
        'Last Year\'s Result'
      ),
      raceStatus && _react2.default.createElement(
        'li',
        { className: 'fast-result-status' },
        _react2.default.createElement(
          'span',
          { className: 'fast-result-status-label' },
          (0, _utils.raceStatusLabel)(raceStatus, stewards)
        )
      )
    )
  );
}

function postRaceDetails(state, raceDetails, isAfter, favToken, togglePlayer, linkType) {
  var _raceDetails$unplaced = raceDetails.unplaced_favourite,
      unplacedFavourite = _raceDetails$unplaced === undefined ? [] : _raceDetails$unplaced,
      raceStatus = raceDetails.status,
      _raceDetails$winning_ = raceDetails.winning_trainers,
      winningTrainers = _raceDetails$winning_ === undefined ? [] : _raceDetails$winning_,
      _raceDetails$winning_2 = raceDetails.winning_jockeys,
      winningJockeys = _raceDetails$winning_2 === undefined ? [] : _raceDetails$winning_2,
      runners = raceDetails.runners,
      _raceDetails$non_runn = raceDetails.non_runners,
      nonRunners = _raceDetails$non_runn === undefined ? [] : _raceDetails$non_runn,
      _raceDetails$withdraw = raceDetails.withdrawn,
      withdrawn = _raceDetails$withdraw === undefined ? [] : _raceDetails$withdraw,
      distances = raceDetails.distances,
      toteWin = raceDetails.tote_win,
      placeWin = raceDetails.place_win,
      exactaWin = raceDetails.exacta_win,
      trifecta = raceDetails.trifecta,
      straightForecast = raceDetails.straight_forecast,
      tricast = raceDetails.tricast,
      swingers = raceDetails.swingers,
      _raceDetails$deductio = raceDetails.deductions,
      deductions = _raceDetails$deductio === undefined ? [] : _raceDetails$deductio,
      stewards = raceDetails.stewards,
      _raceDetails$videos = raceDetails.videos,
      videos = _raceDetails$videos === undefined ? [] : _raceDetails$videos;


  return _react2.default.createElement(
    'div',
    { className: 'fast-racecard-content-wrapper' },
    _react2.default.createElement(
      'ul',
      { className: 'fast-racecard-content' },
      winningTrainers.map(function (t, i, _ref) {
        var length = _ref.length;
        return _react2.default.createElement(
          OptionalData,
          { key: i,
            className: 'fast-racecard-content-top fast-racecard-always-open' + (i == length - 1 && !winningJockeys.length ? ' fast-racecard-content-spaced' : ''),
            value: t.name },
          !i && 'Winning Trainer:'
        );
      }),
      winningJockeys.map(function (j, i, _ref2) {
        var length = _ref2.length;
        return _react2.default.createElement(
          OptionalData,
          { key: i,
            className: 'fast-racecard-content-top fast-racecard-always-open' + (i == length - 1 ? ' fast-racecard-content-spaced' : ''),
            value: j.name },
          !i && 'Winning Jockey:'
        );
      }),
      !!runners && _react2.default.createElement(
        'li',
        { className: 'fast-racecard-always-open' },
        _react2.default.createElement(
          'span',
          { className: 'fast-racecard-content-label' },
          'Runners:'
        ),
        _react2.default.createElement(
          'span',
          { className: 'fast-racecard-content-value' },
          runners,
          ' ',
          isAfter && "ran"
        )
      ),
      !!nonRunners.length && _react2.default.createElement(
        'li',
        { className: 'fast-racecard-always-open' },
        _react2.default.createElement(
          'span',
          { className: 'fast-racecard-content-label' },
          'Non-Runners:'
        ),
        _react2.default.createElement(
          'span',
          { className: 'fast-racecard-content-value' },
          nonRunners.sort(numberSort).join(", ")
        )
      ),
      deductions.map(function (deduction, index) {
        return _react2.default.createElement(
          'li',
          { key: index },
          _react2.default.createElement(
            'span',
            { className: 'fast-racecard-content-label' },
            !index && 'Rule 4:'
          ),
          _react2.default.createElement(
            'span',
            { className: 'fast-racecard-content-value' },
            (0, _utils.buildRuleFourString)(deduction)
          )
        );
      }),
      withdrawn.length > 0 && _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'span',
          { className: 'fast-racecard-content-label' },
          'Withdrawn:'
        ),
        _react2.default.createElement(
          'span',
          { className: 'fast-racecard-content-value' },
          withdrawn.sort(numberSort).join(", ")
        )
      ),
      unplacedFavourite.length > 0 && _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'span',
          { className: 'fast-racecard-content-label' },
          'Unpl.Fav:'
        ),
        _react2.default.createElement(
          'span',
          { className: 'fast-racecard-content-value' },
          unplacedFavourite.map(function (_ref3, index) {
            var horseName = _ref3.horse_name,
                odds = _ref3.odds;
            return _react2.default.createElement(
              'span',
              { key: index, className: 'fast-results-unplaced' },
              horseName,
              ' ',
              odds,
              ' ',
              favToken.toUpperCase()
            );
          })
        )
      ),
      _react2.default.createElement(
        OptionalData,
        { className: 'fast-racecard-always-open', value: distances },
        'Distances:'
      ),
      _react2.default.createElement(
        OptionalData,
        { value: (0, _CurrencyFormatting.convertCurrencyString)(toteWin) },
        'Tote Win:'
      ),
      _react2.default.createElement(
        OptionalData,
        { value: (0, _CurrencyFormatting.convertCurrencyString)(placeWin) },
        'Pl:'
      ),
      _react2.default.createElement(
        OptionalData,
        { value: (0, _CurrencyFormatting.convertCurrencyString)(exactaWin) },
        'EX:'
      ),
      _react2.default.createElement(
        OptionalData,
        { value: (0, _CurrencyFormatting.convertCurrencyString)(trifecta) },
        'Trifecta:'
      ),
      _react2.default.createElement(
        OptionalData,
        { value: (0, _CurrencyFormatting.convertCurrencyString)(straightForecast) },
        'SF:'
      ),
      _react2.default.createElement(
        OptionalData,
        { value: (0, _CurrencyFormatting.convertCurrencyString)(tricast) },
        'Tricast:'
      ),
      _react2.default.createElement(
        OptionalData,
        { value: (0, _CurrencyFormatting.convertCurrencyString)(swingers) },
        'Swingers:'
      ),
      raceStatus && _react2.default.createElement(
        'li',
        { className: 'fast-result-status' },
        _react2.default.createElement(
          'span',
          { className: 'fast-result-status-label' },
          (0, _utils.raceStatusLabel)(raceStatus, stewards)
        )
      )
    ),
    videos.length > 0 && _react2.default.createElement(
      'div',
      { className: 'fast-racecard-video' },
      state.playerOpen && _react2.default.createElement(_RaceVideoPlayer2.default, { videos: videos, showLoginBenefits: false }),
      !state.playerOpen && _react2.default.createElement(
        'div',
        { className: "fast-racecard-video-banner", onClick: togglePlayer },
        _react2.default.createElement('div', { className: 'fast-racecard-video-background' }),
        _react2.default.createElement('img', { className: 'fast-racecard-video-play-button', src: '/img/has-video-icon.svg' }),
        _react2.default.createElement(
          'div',
          { className: 'fast-racecard-video-copy' },
          'Replay now available for this race!'
        )
      )
    )
  );
}

function OptionalData(props) {
  return props.value ? _react2.default.createElement(
    'li',
    { className: props.className },
    _react2.default.createElement(
      'span',
      { className: 'fast-racecard-content-label' },
      props.children
    ),
    _react2.default.createElement(
      'span',
      { className: 'fast-racecard-content-value' },
      props.value
    )
  ) : null;
}

OptionalData.propTypes = {
  className: _propTypes2.default.string,
  value: _propTypes2.default.any,
  children: _propTypes2.default.node
};

function countFavHorses(array) {
  var result = 0;
  if (array) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].favourite === true) {
        result++;
      }
    }
  }
  return result;
}

function favHorsesToken(arrayTop, arrayUnfav) {
  var sum = countFavHorses(arrayTop) + countFavHorses(arrayUnfav);
  if (sum == 1) {
    return "f";
  } else if (sum >= 2) {
    return "j";
  }
  return "";
}

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HorseRacingFastRacecardRide;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Ordinal = __webpack_require__(200);

var _Ordinal2 = _interopRequireDefault(_Ordinal);

var _reactRouter = __webpack_require__(11);

var _Silk = __webpack_require__(113);

var _Silk2 = _interopRequireDefault(_Silk);

var _utils = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

HorseRacingFastRacecardRide.propTypes = {
  ride: _propTypes2.default.object,
  favToken: _propTypes2.default.string
};

function HorseRacingFastRacecardRide(_ref) {
  var ride = _ref.ride,
      favToken = _ref.favToken;
  var _ride$horse_reference = ride.horse_reference;
  _ride$horse_reference = _ride$horse_reference === undefined ? {} : _ride$horse_reference;
  var horseId = _ride$horse_reference.id,
      position = ride.position,
      _ride$amended_positio = ride.amended_position,
      actualPosition = _ride$amended_positio === undefined ? position : _ride$amended_positio,
      silkFilename = ride.silk_filename,
      clothNumber = ride.saddlecloth_number,
      drawNumber = ride.draw_number,
      horseName = ride.horse_name,
      horseOdds = ride.odds,
      favourite = ride.favourite;


  return _react2.default.createElement(
    'div',
    { key: horseId, className: 'fast-results-place' },
    _react2.default.createElement(
      'div',
      { className: 'fast-results-place-position' },
      _react2.default.createElement(_Ordinal2.default, { n: actualPosition, superscriptSuffix: false })
    ),
    _react2.default.createElement(
      'div',
      { className: 'fast-results-place-silk' },
      _react2.default.createElement(_Silk2.default, { filename: silkFilename })
    ),
    _react2.default.createElement(
      'div',
      { className: 'fast-results-stall-info' },
      _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'span',
          { className: 'fast-results-saddle-cloth-no' },
          clothNumber
        ),
        drawNumber && _react2.default.createElement(
          'span',
          { className: 'fast-results-runner-stall-no' },
          (0, _utils.bracket)(drawNumber)
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'fast-results-place-name' },
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/racing/profiles/horse/' + horseId },
        horseName
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'fast-results-place-odds' },
      horseOdds,
      ' ',
      favourite && favToken
    )
  );
}

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _RaceVideoPlayer = __webpack_require__(170);

var _RaceVideoPlayer2 = _interopRequireDefault(_RaceVideoPlayer);

var _HorseRacingFormTable = __webpack_require__(911);

var _HorseRacingFormTable2 = _interopRequireDefault(_HorseRacingFormTable);

var _HorseRacingLastRun = __webpack_require__(913);

var _HorseRacingLastRun2 = _interopRequireDefault(_HorseRacingLastRun);

var _HorseRacingInsightsList = __webpack_require__(952);

var _HorseRacingInsightsList2 = _interopRequireDefault(_HorseRacingInsightsList);

var _Silk = __webpack_require__(113);

var _Silk2 = _interopRequireDefault(_Silk);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _PlayIcon = __webpack_require__(767);

var _PlayIcon2 = _interopRequireDefault(_PlayIcon);

var _BetLink = __webpack_require__(114);

var _BetLink2 = _interopRequireDefault(_BetLink);

var _utils = __webpack_require__(32);

var _LocalDateTimeHelper = __webpack_require__(13);

var _reactDeviceDetect = __webpack_require__(109);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(513);

var HorseRacingRacecardRunner = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingRacecardRunner, _Component);

  function HorseRacingRacecardRunner(props) {
    (0, _classCallCheck3.default)(this, HorseRacingRacecardRunner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HorseRacingRacecardRunner.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingRacecardRunner)).call(this, props));

    _this.state = {
      formExpanded: _this.props.showExpandedForm || false,
      expandedTarget: null
    };
    return _this;
  }

  (0, _createClass3.default)(HorseRacingRacecardRunner, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.showExpandedForm !== this.props.showExpandedForm) {
        this.setState({ formExpanded: newProps.showExpandedForm });
      }
    }
  }, {
    key: 'hasFormList',
    value: function hasFormList() {
      var _props$runner = this.props.runner;
      _props$runner = _props$runner === undefined ? {} : _props$runner;
      var _props$runner$horse = _props$runner.horse;
      _props$runner$horse = _props$runner$horse === undefined ? {} : _props$runner$horse;
      var _props$runner$horse$p = _props$runner$horse.previous_results;
      _props$runner$horse$p = _props$runner$horse$p === undefined ? {} : _props$runner$horse$p;
      var length = _props$runner$horse$p.length;

      return !!length;
    }
  }, {
    key: 'getLastRun',
    value: function getLastRun() {
      var _props$runner2 = this.props.runner;
      _props$runner2 = _props$runner2 === undefined ? {} : _props$runner2;
      var _props$runner2$horse = _props$runner2.horse;
      _props$runner2$horse = _props$runner2$horse === undefined ? {} : _props$runner2$horse;
      var _props$runner2$horse$ = _props$runner2$horse.previous_results,
          previous_results = _props$runner2$horse$ === undefined ? {} : _props$runner2$horse$;


      if (previous_results && previous_results.length > 0) {
        return previous_results[0];
      }

      return false;
    }
  }, {
    key: 'getLastRunVideo',
    value: function getLastRunVideo() {
      var lastRun = this.getLastRun();

      if (lastRun) {
        return lastRun.video;
      }

      return false;
    }
  }, {
    key: 'toggleFormExpanded',
    value: function toggleFormExpanded(key, target) {
      this.setState({ expandedTarget: target });
      if (this.props.toggleFormExpanded) {
        this.props.toggleFormExpanded(key);
        return;
      }

      this.setState({ formExpanded: this.hasFormList() && !this.state.formExpanded });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToTarget();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.scrollToTarget();
    }
  }, {
    key: 'scrollToTarget',
    value: function scrollToTarget() {
      if (this.state.expandedTarget && this.state.formExpanded && window) {
        var id = this.props.runner.key + '-' + this.state.expandedTarget;
        document.getElementById(id).scrollIntoView({
          block: 'start'
        });
        var navOffset = _reactDeviceDetect.isMobile ? -160 : -207;
        window.scrollBy(0, navOffset);
        this.setState({ expandedTarget: null });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$runner3 = _props.runner,
          rideBetlinkIds = _props$runner3.rideBetlinkIds,
          odds = _props$runner3.odds,
          saddleClothNo = _props$runner3.saddleClothNo,
          drawNumber = _props$runner3.drawNumber,
          silkFilename = _props$runner3.silkFilename,
          _props$runner3$headge = _props$runner3.headgear,
          headgear = _props$runner3$headge === undefined ? [] : _props$runner3$headge,
          _props$runner3$raceHi = _props$runner3.raceHistoryStats,
          raceHistoryStats = _props$runner3$raceHi === undefined ? [] : _props$runner3$raceHi,
          weightPenalty = _props$runner3.weightPenalty,
          horse = _props$runner3.horse,
          _props$runner3$insigh = _props$runner3.insights,
          insights = _props$runner3$insigh === undefined ? [] : _props$runner3$insigh,
          horseName = _props$runner3.horseName,
          horseLastRan = _props$runner3.horseLastRan,
          horseAge = _props$runner3.horseAge,
          weight = _props$runner3.weight,
          _props$runner3$offici = _props$runner3.officialRating,
          officialRating = _props$runner3$offici === undefined ? '-' : _props$runner3$offici,
          form = _props$runner3.form,
          trainer = _props$runner3.trainer,
          jockey = _props$runner3.jockey,
          jockeyClaim = _props$runner3.jockeyClaim,
          commentary = _props$runner3.commentary,
          key = _props$runner3.key,
          startingPriceAvailable = _props$runner3.startingPriceAvailable,
          _props$runner3$medica = _props$runner3.medication,
          medication = _props$runner3$medica === undefined ? [] : _props$runner3$medica,
          eventBetlinkId = _props.eventRef,
          showLastRunVideo = _props.showLastRun,
          eachWay = _props.eachWay,
          suspended = _props.suspended,
          fixture = _props.fixture,
          _props$embedded = _props.embedded,
          embedded = _props$embedded === undefined ? false : _props$embedded;
      var formExpanded = this.state.formExpanded;


      var runnerHasForm = this.hasFormList();
      var lastRunVideo = this.getLastRunVideo();
      var lastRun = this.getLastRun();
      var hasLastRunVideo = !_lodash2.default.isEmpty(lastRunVideo);

      var betLinkProps = void 0;
      if (odds) {
        var displayTime = (0, _LocalDateTimeHelper.localTimeShort)(this.props.raceSummary.date + 'T' + this.props.raceSummary.time + 'Z');

        betLinkProps = {
          marketId: this.props.runner.marketId,
          eventId: eventBetlinkId,
          eventName: displayTime + ' ' + this.props.raceSummary.course_name,
          eventCompetition: this.props.raceSummary.course_name, // only relevant for feature "integrated-betslip"
          dateTime: this.props.raceSummary.date + ' ' + this.props.raceSummary.time,
          sport: "horseRacing",
          betId: rideBetlinkIds[0],
          betName: horseName,
          odds: odds,
          eachWay: eachWay, // only relevant for feature "integrated-betslip"
          suspended: suspended, // only relevant for feature "integrated-betslip"
          fixture: fixture, // only relevant for feature "integrated-betslip"
          startingPriceAvailable: startingPriceAvailable // only relevant for feature "integrated-betslip"
        };
      }

      return _react2.default.createElement(
        'section',
        { id: '' + this.props.runner.key, className: 'hr-racing-runner-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'hr-racing-runner-key-info-container' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-saddle-stall-info' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-runner-saddle-cloth-no' },
                saddleClothNo
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-runner-stall-no' },
                drawNumber
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-silks' },
            _react2.default.createElement(_Silk2.default, { filename: silkFilename })
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-horse-info' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-runner-horse-name' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/racing/profiles/horse/' + horse.horse_reference.id, id: "horse-number-" + saddleClothNo },
                  horseName
                ),
                headgear.length > 0 && _react2.default.createElement(
                  'sup',
                  { className: 'hr-racing-runner-horse-headgear' },
                  (0, _utils.formatHeadgear)(headgear)
                ),
                _react2.default.createElement(
                  'sup',
                  { className: 'hr-racing-runner-horse-last-ran' },
                  horseLastRan
                ),
                weightPenalty && _react2.default.createElement(
                  'sup',
                  { className: 'hr-racing-runner-horse-weight-penalty' },
                  '(ex ',
                  weightPenalty,
                  ')'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'hr-racing-runner-horse-sub-info' },
                horseAge && _react2.default.createElement(
                  'span',
                  null,
                  horseAge
                ),
                weight && _react2.default.createElement(
                  'span',
                  null,
                  weight
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  'OR: ' + officialRating
                ),
                raceHistoryStats.length > 0 && raceHistoryStats.map(function (_ref) {
                  var type = _ref.type;
                  return _react2.default.createElement(
                    'span',
                    { className: 'hr-racing-runner-race-history-stats', key: type },
                    (0, _utils.keepUpperCase)(type)
                  );
                }),
                medication.length > 0 && medication.map(function (type) {
                  return _react2.default.createElement(
                    'span',
                    { className: 'hr-racing-runner-race-medication-stats', key: type },
                    (0, _utils.keepUpperCase)(type)
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-betting-odds', id: "horse-odds-" + saddleClothNo },
            !!betLinkProps && _react2.default.createElement(
              _BetLink2.default,
              (0, _extends3.default)({ className: 'hr-racing-runner-betting-link sui-odds' }, betLinkProps),
              odds
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'hr-racing-runner-form-history-container' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-form-key-info' },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'hr-racing-runner-form-trainer', id: "trainer-number-" + saddleClothNo, to: '/racing/profiles/trainer/' + trainer.business_reference.id },
              'T:\xA0',
              _react2.default.createElement(
                'span',
                null,
                trainer.name
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'hr-racing-runner-form-jockey', to: '/racing/profiles/jockey/' + jockey.person_reference.id },
              'J:\xA0',
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-runner-form-jockey-name', id: "jockey-number-" + saddleClothNo },
                jockey.name
              ),
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-runner-form-jockey-claim' },
                ' ' + jockeyClaim
              )
            )
          )
        ),
        embedded ? showLastRunVideo && _react2.default.createElement(
          'div',
          { className: 'hr-racing-runner-form-watch-last-run', id: "watch-last-run-" + saddleClothNo },
          _react2.default.createElement(_RaceVideoPlayer2.default, { videos: lastRunVideo })
        ) : commentary && _react2.default.createElement(
          'div',
          { className: 'hr-racing-runner-form-watch-info-container' },
          _react2.default.createElement(
            'p',
            { className: 'hr-racing-runner-form-watch-info-full' },
            commentary
          ),
          _react2.default.createElement(_HorseRacingInsightsList2.default, { insights: insights })
        ),
        runnerHasForm && _react2.default.createElement(
          'div',
          { className: 'hr-racing-runner-form-history-container' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-form-key-info' },
            _react2.default.createElement(
              'button',
              { className: 'hr-racing-runner-show-form', onClick: function onClick() {
                  return _this2.toggleFormExpanded(key, "form");
                }, disabled: !runnerHasForm },
              runnerHasForm && _react2.default.createElement(_CaretIcon2.default, { type: 'full', direction: formExpanded ? "up" : "down" }),
              _react2.default.createElement(
                'label',
                { className: 'hr-racing-runner-form-stat' },
                _react2.default.createElement(
                  'span',
                  null,
                  'Form:'
                ),
                '\xA0',
                form
              )
            ),
            hasLastRunVideo && _react2.default.createElement(
              'span',
              { className: 'hr-racing-runner-embedded-last-run-button', id: "embedded-last-run-btn" + saddleClothNo, onClick: function onClick() {
                  return _this2.toggleFormExpanded(key, "last-run");
                } },
              _react2.default.createElement(_PlayIcon2.default, { title: 'Watch last race', subText: 'Last Run' })
            )
          ),
          formExpanded && _react2.default.createElement(
            'div',
            { id: key + '-form' },
            _react2.default.createElement(_HorseRacingFormTable2.default, { horse: horse, results: horse.previous_results }),
            _react2.default.createElement(
              'div',
              { className: 'hr-racing-runner-last-run-container', id: key + '-last-run' },
              _react2.default.createElement(_HorseRacingLastRun2.default, { lastRun: lastRun })
            )
          )
        )
      );
    }
  }]);
  return HorseRacingRacecardRunner;
}(_react.Component), _class.propTypes = {
  raceSummary: _propTypes2.default.shape({
    date: _propTypes2.default.string,
    time: _propTypes2.default.string,
    course_name: _propTypes2.default.string
  }),
  runner: _propTypes2.default.object,
  eventRef: _propTypes2.default.string,
  showExpandedForm: _propTypes2.default.bool,
  toggleFormExpanded: _propTypes2.default.func.isRequired,
  eachWay: _propTypes2.default.object,
  suspended: _propTypes2.default.bool,
  fixture: _propTypes2.default.string,
  embedded: _propTypes2.default.bool,
  dispatch: _propTypes2.default.func,
  key: _propTypes2.default.string
}, _temp);
exports.default = HorseRacingRacecardRunner;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = RacecardsMeetingSummary;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _utils = __webpack_require__(18);

var _AnalyticsUtils = __webpack_require__(63);

var _LocalDateTimeHelper = __webpack_require__(13);

var _commonUtils = __webpack_require__(36);

var _LocalDateTime = __webpack_require__(61);

var _CollapsibleSection = __webpack_require__(99);

var _CollapsibleSection2 = _interopRequireDefault(_CollapsibleSection);

var _RaceSummaryText = __webpack_require__(745);

var _RaceSummaryText2 = _interopRequireDefault(_RaceSummaryText);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _CaretLink = __webpack_require__(54);

var _CaretLink2 = _interopRequireDefault(_CaretLink);

var _RaceJSONLD = __webpack_require__(201);

var _RaceJSONLD2 = _interopRequireDefault(_RaceJSONLD);

var _SubscriptionContainer = __webpack_require__(92);

var _SubscriptionContainer2 = _interopRequireDefault(_SubscriptionContainer);

var _StarButton = __webpack_require__(373);

var _StarButton2 = _interopRequireDefault(_StarButton);

var _consts = __webpack_require__(46);

var _utils2 = __webpack_require__(32);

var _PromoIcon = __webpack_require__(255);

var _PromoIcon2 = _interopRequireDefault(_PromoIcon);

var _urlRewrite = __webpack_require__(120);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HORSE_RACE_COMPLETE_STATUSES = ['WEIGHEDIN', 'RESULT', 'FINISHED'];

var RACE_ENDED_STATUSES = HORSE_RACE_COMPLETE_STATUSES.concat(['ABANDONED']);

function RacecardsMeetingSummary(props) {
  var resultRacecard = props["result-racecard"],
      meeting = props.meeting,
      _props$meeting = props.meeting;
  _props$meeting = _props$meeting === undefined ? {} : _props$meeting;
  var _props$meeting$meetin = _props$meeting.meeting_summary;
  _props$meeting$meetin = _props$meeting$meetin === undefined ? {} : _props$meeting$meetin;
  var _props$meeting$meetin2 = _props$meeting$meetin.status,
      meetingStatus = _props$meeting$meetin2 === undefined ? "" : _props$meeting$meetin2,
      _props$meeting$meetin3 = _props$meeting$meetin.abandoned,
      abandonedReason = _props$meeting$meetin3 === undefined ? "" : _props$meeting$meetin3,
      _props$meeting$meetin4 = _props$meeting$meetin.inspection;
  _props$meeting$meetin4 = _props$meeting$meetin4 === undefined ? {} : _props$meeting$meetin4;
  var _props$meeting$meetin5 = _props$meeting$meetin4.time,
      inspectionTime = _props$meeting$meetin5 === undefined ? "" : _props$meeting$meetin5,
      _props$meeting$meetin6 = _props$meeting$meetin.course;
  _props$meeting$meetin6 = _props$meeting$meetin6 === undefined ? {} : _props$meeting$meetin6;
  var _props$meeting$meetin7 = _props$meeting$meetin6.name,
      courseName = _props$meeting$meetin7 === undefined ? 'unknown' : _props$meeting$meetin7,
      feedSource = _props$meeting$meetin6.feed_source,
      _props$meeting$meetin8 = _props$meeting$meetin.going,
      meetingGoing = _props$meeting$meetin8 === undefined ? ' - ' : _props$meeting$meetin8,
      _props$meeting$meetin9 = _props$meeting$meetin.surface_summary,
      meetingSurface = _props$meeting$meetin9 === undefined ? ' - ' : _props$meeting$meetin9,
      _props$meeting$meetin10 = _props$meeting$meetin.meeting_reference;
  _props$meeting$meetin10 = _props$meeting$meetin10 === undefined ? {} : _props$meeting$meetin10;
  var meetingId = _props$meeting$meetin10.id,
      _props$meeting$races = _props$meeting.races,
      races = _props$meeting$races === undefined ? [] : _props$meeting$races,
      meetingDate = props.date,
      dateIncrement = props.dateIncrement;


  var courseNameSlug = (0, _utils.toSlug)(courseName);

  var formattedInspectionTime = (0, _LocalDateTimeHelper.local12Hour)(inspectionTime);

  var racecardUrl = function racecardUrl(raceName, raceId) {
    return '/racing/racecards/' + meetingDate + '/' + courseNameSlug + '/racecard/' + raceId + '/' + (0, _utils.toSlug)(raceName);
  };

  var resultUrl = function resultUrl(raceName, raceId) {
    return '/racing/results/' + meetingDate + '/' + courseNameSlug + '/' + raceId + '/' + (0, _utils.toSlug)(raceName);
  };

  var type = resultRacecard === 'result' ? 'result' : 'racecard';
  function racecardHref() {
    var raceName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
    var raceId = arguments[1];

    if (resultRacecard == "result") {
      return resultUrl(raceName, raceId);
    } else {
      return racecardUrl(raceName, raceId);
    }
  }

  var courseTitle = meetingStatus === "ABANDONED" ? courseName + ' (OFF)' : courseName;

  var goingDescription = meetingGoing;

  // strip out any inspection text if inspection is already flagged in statue
  if (meetingStatus === "ABANDONED" && meetingGoing.toLowerCase().indexOf('(inspection')) {
    goingDescription = meetingGoing.replace(/\(.*\)/, "");
  }

  function resultHref() {
    var raceName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unknown';
    var raceId = arguments[1];

    return resultUrl(raceName, raceId);
  }

  var meetingPageUrl = '/racing/meeting/' + meetingDate + '/' + courseNameSlug + '/' + meetingId;

  function isRaceAbandoned(raceStage, meetingStatus) {
    return raceStage === "ABANDONED" || meetingStatus === "ABANDONED" && raceStage === "DORMANT";
  }

  return _react2.default.createElement(
    'section',
    { className: 'hr-meeting-container', id: (0, _urlRewrite.titleToId)(courseName) },
    _react2.default.createElement(_RaceJSONLD2.default, (0, _extends3.default)({ meeting: meeting }, { sport: 'racing', type: type })),
    dateIncrement === 1 ? _react2.default.createElement(
      _CollapsibleSection2.default,
      { feedLogo: feedSource, title: courseTitle, linkTo: meetingPageUrl },
      _react2.default.createElement(
        'div',
        { className: 'hr-meeting-meta' },
        _react2.default.createElement(
          'div',
          { className: 'hr-meeting-meta-going' },
          meetingStatus === "ABANDONED" && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: 'hr-meeting-meta-label' },
              'Abandoned: '
            ),
            _react2.default.createElement(
              'span',
              { className: 'hr-meeting-meta-value' },
              abandonedReason
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'hr-meeting-meta-label' },
            'Going: '
          ),
          _react2.default.createElement(
            'span',
            { className: 'hr-meeting-meta-value' },
            goingDescription
          ),
          meetingStatus === "INSPECTION" && formattedInspectionTime !== "" && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: 'hr-meeting-meta-label' },
              'Inspection: '
            ),
            _react2.default.createElement(
              'span',
              { className: 'hr-meeting-meta-value' },
              formattedInspectionTime
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'hr-meeting-meta-surface' },
          _react2.default.createElement(
            'strong',
            null,
            'Surface: '
          ),
          _react2.default.createElement(
            'span',
            { className: 'hr-meeting-meta-value' },
            meetingSurface
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'hr-meeting-meta-fast-cards' },
          _react2.default.createElement(
            _CaretLink2.default,
            { to: '/racing/fast-cards/' + meetingId + '/' + meetingDate + '/' + courseNameSlug },
            'Fast Cards'
          )
        ),
        !races.every(function (_ref) {
          var race_stage = _ref.race_stage;
          return RACE_ENDED_STATUSES.includes(race_stage);
        }) && meetingStatus !== "ABANDONED" && _react2.default.createElement(
          'div',
          { className: 'hr-meeting-all-follow' },
          _react2.default.createElement(_SubscriptionContainer2.default, {
            addSubscriptions: races.map(function (_ref2) {
              var _ref2$race_summary_re = _ref2.race_summary_reference;
              _ref2$race_summary_re = _ref2$race_summary_re === undefined ? {} : _ref2$race_summary_re;
              var raceId = _ref2$race_summary_re.id,
                  raceTime = _ref2.time;
              return {
                type: _consts.SUBSCRIPTIONS_HORSE_RACE,
                id: raceId,
                text: raceTime + ' ' + courseName
              };
            }),
            icon: _react2.default.createElement(_StarButton2.default, {
              trackClick: (0, _AnalyticsUtils.trackClick)("followMeeting", { meetingId: meetingId }, true),
              selectedTitle: 'Unfollow All Races',
              deselectedTitle: 'Follow All Races'
            })
          })
        )
      ),
      _react2.default.createElement(
        'ul',
        { className: 'hr-meeting-races-container' },
        races.map(function (race) {
          var _race$race_summary_re = race.race_summary_reference;
          _race$race_summary_re = _race$race_summary_re === undefined ? {} : _race$race_summary_re;
          var raceId = _race$race_summary_re.id,
              _race$promotion = race.promotion;
          _race$promotion = _race$promotion === undefined ? {} : _race$promotion;
          var promoIcon = _race$promotion.image,
              raceDate = race.date,
              raceTime = race.time,
              _race$name = race.name,
              raceName = _race$name === undefined ? 'unknown' : _race$name,
              raceStage = race.race_stage;


          var showPromo = !!(promoIcon && (0, _utils2.isBeforeOffStatus)(raceStage));

          return _react2.default.createElement(
            'li',
            { key: raceId, id: 'race-container' },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: racecardHref(raceName, raceId) },
              _react2.default.createElement(_LocalDateTime.LocalTimeShort, { className: 'hr-meeting-race-time', iso: raceDate + 'T' + raceTime + 'Z' }),
              _react2.default.createElement(
                'div',
                { className: 'hr-meeting-race-name-star', id: 'hr-meeting-race-name' },
                raceName,
                ' ',
                _react2.default.createElement(_RaceSummaryText2.default, { raceSummary: race })
              ),
              _react2.default.createElement(
                'div',
                { className: 'hr-meeting-race-promo' },
                showPromo && _react2.default.createElement(
                  'div',
                  { className: 'hr-meeting-race-promo-icon' },
                  _react2.default.createElement(_PromoIcon2.default, { type: promoIcon })
                )
              )
            ),
            isRaceAbandoned(raceStage, meetingStatus) ? _react2.default.createElement(
              'div',
              { className: 'hr-meeting-race-abandoned' },
              _react2.default.createElement(
                'span',
                { className: 'hr-meeting-race-abandoned-text' },
                'Abd.'
              )
            ) : HORSE_RACE_COMPLETE_STATUSES.includes(raceStage) ? _react2.default.createElement(
              'div',
              { className: 'hr-meeting-race-result-fulllink' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'hr-meeting-race-result-fulllink-btn', to: resultHref(raceName, raceId) },
                'Result'
              )
            ) : _react2.default.createElement(
              'div',
              { className: 'hr-meeting-race-follow' },
              _react2.default.createElement(_SubscriptionContainer2.default, {
                addSubscriptions: [{
                  type: _consts.SUBSCRIPTIONS_HORSE_RACE,
                  id: raceId,
                  text: raceTime + ' ' + courseName
                }],
                icon: _react2.default.createElement(_StarButton2.default, {
                  trackClick: (0, _AnalyticsUtils.trackClick)("followRace", { raceId: raceId }, true),
                  selectedTitle: 'Unfollow',
                  deselectedTitle: 'Follow'
                })
              })
            )
          );
        })
      )
    ) :
    // Results
    _react2.default.createElement(
      'div',
      { className: 'dividerRow' },
      _react2.default.createElement(
        'div',
        { className: 'divider-title' },
        _react2.default.createElement(
          'div',
          { className: 'divider-title-text' },
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/racing/meeting/' + meetingDate + '/' + courseNameSlug + '/' + meetingId },
              courseTitle
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'divider-subtitle' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/racing/meeting/' + meetingDate + '/' + courseNameSlug + '/' + meetingId },
            _react2.default.createElement(_CaretIcon2.default, { type: 'full', direction: 'right' }),
            '\xA0Fast Results'
          )
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'hr-meeting-meta' },
        _react2.default.createElement(
          'div',
          { className: 'hr-meeting-meta-going-no-star' },
          meetingStatus === "ABANDONED" && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { className: 'hr-meeting-meta-label' },
              'Abandoned: '
            ),
            _react2.default.createElement(
              'span',
              { className: 'hr-meeting-meta-value' },
              abandonedReason
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'hr-meeting-meta-label' },
            'Going: '
          ),
          _react2.default.createElement(
            'span',
            { className: 'hr-meeting-meta-value' },
            meetingGoing
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'hr-meeting-meta-surface' },
          _react2.default.createElement(
            'strong',
            null,
            'Surface: '
          ),
          _react2.default.createElement(
            'span',
            { className: 'hr-meeting-meta-value' },
            meetingSurface
          )
        )
      ),
      _react2.default.createElement(
        'ul',
        { className: 'hr-meeting-races-container' },
        races.map(function (_ref3) {
          var _ref3$race_summary_re = _ref3.race_summary_reference;
          _ref3$race_summary_re = _ref3$race_summary_re === undefined ? {} : _ref3$race_summary_re;
          var raceId = _ref3$race_summary_re.id,
              raceDate = _ref3.date,
              raceTime = _ref3.time,
              _ref3$name = _ref3.name,
              raceName = _ref3$name === undefined ? 'unknown' : _ref3$name,
              raceStage = _ref3.race_stage,
              hasRaceVid = _ref3.has_video;
          return _react2.default.createElement(
            'li',
            { key: raceId },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: racecardHref(raceName, raceId) },
              _react2.default.createElement(_LocalDateTime.LocalTimeShort, { className: 'hr-meeting-race-time', iso: raceDate + 'T' + raceTime + 'Z' }),
              _react2.default.createElement(
                'div',
                { className: hasRaceVid === true ? 'hr-meeting-race-name-result-with-video-icon' : 'hr-meeting-race-name-result' },
                raceName
              )
            ),
            HORSE_RACE_COMPLETE_STATUSES.includes(raceStage) && _react2.default.createElement(
              'div',
              { className: 'hr-meeting-race-result-fulllink' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'hr-meeting-race-result-fulllink-btn', to: resultHref(raceName, raceId) },
                'Result'
              )
            ),
            hasRaceVid === true && _react2.default.createElement(
              'div',
              { className: 'hr-meeting-race-result-video-icon' },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: resultHref(raceName, raceId) + '#video-player' },
                _react2.default.createElement('img', { src: '/img/icons/video-icon.png' })
              )
            ),
            isRaceAbandoned(raceStage, meetingStatus) && _react2.default.createElement(
              'div',
              { className: 'hr-meeting-race-abandoned' },
              _react2.default.createElement(
                'span',
                { className: 'hr-meeting-race-abandoned-text' },
                'Abd.'
              )
            )
          );
        })
      )
    )
  );
}

RacecardsMeetingSummary.propTypes = {
  "result-racecard": _propTypes2.default.string,
  meeting: _propTypes2.default.object.isRequired,
  date: _propTypes2.default.string.isRequired,
  dateIncrement: _propTypes2.default.number,
  toggleFollowed: _propTypes2.default.func,
  toggleAllFollowed: _propTypes2.default.func,
  checkFollowed: _propTypes2.default.func,
  checkAnyFollowed: _propTypes2.default.func
};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HorseRacingRideSummaryTable;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _HorseRacingNextRaceLine = __webpack_require__(917);

var _HorseRacingNextRaceLine2 = _interopRequireDefault(_HorseRacingNextRaceLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HorseRacingRideSummaryTable(props) {

  var runners = props.runners;

  __webpack_require__(1434);
  return _react2.default.createElement(
    'div',
    { className: 'next-race-off-list' },
    runners && runners.length > 0 ? runners.map(function (ride) {
      return _react2.default.createElement(_HorseRacingNextRaceLine2.default, { key: ride.ride_reference.id, ride: ride, raceExternalId: props.raceExternalId, raceSummary: props.raceSummary, eachWay: props.eachWay,
        suspended: props.suspended, fixture: props.fixture });
    }) : _react2.default.createElement(
      'div',
      { className: 'next-race-off-norunners' },
      'No listed runners.'
    )
  );
}

HorseRacingRideSummaryTable.propTypes = {
  runners: _propTypes2.default.array.isRequired,
  raceSummary: _propTypes2.default.object,
  raceExternalId: _propTypes2.default.string,
  eachWay: _propTypes2.default.object,
  suspended: _propTypes2.default.bool,
  fixture: _propTypes2.default.string
};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HorseProfileTable;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _utils = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1441);

function HorseProfileTable(_ref) {
  var profile = _ref.profile,
      _ref$earlyEntries = _ref.earlyEntries,
      earlyEntries = _ref$earlyEntries === undefined ? false : _ref$earlyEntries;

  var _getProfileHelpers = (0, _utils.getProfileHelpers)(profile, earlyEntries),
      horseResults = _getProfileHelpers.results,
      formatDateTime = _getProfileHelpers.formatDateTime,
      buildHref = _getProfileHelpers.buildHref;

  if (!earlyEntries) {
    horseResults.forEach(function (r) {
      return r.formattedPosition = (0, _utils.formatPosition)(r);
    });
  }

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'table',
      { className: 'default-table horse-profile-results-table' },
      _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'th',
            null,
            'Date ',
            earlyEntries && "/ Time"
          ),
          !earlyEntries && _react2.default.createElement(
            'th',
            null,
            'Pos'
          ),
          _react2.default.createElement(
            'th',
            null,
            'BHA'
          ),
          !earlyEntries && _react2.default.createElement(
            'th',
            { className: 'horse-profile-results-table-race-type' },
            'Type'
          ),
          _react2.default.createElement(
            'th',
            null,
            'Race Details'
          ),
          _react2.default.createElement(
            'th',
            null,
            'SP'
          )
        )
      ),
      _react2.default.createElement(
        'tbody',
        null,
        horseResults.map(function (result) {
          return _react2.default.createElement(
            'tr',
            { key: result.race_id },
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: buildHref(result),
                  className: 'horse-profile-racing-form-racecard-link' },
                formatDateTime(result)
              )
            ),
            !earlyEntries && _react2.default.createElement(
              'td',
              null,
              result.formattedPosition
            ),
            _react2.default.createElement(
              'td',
              null,
              result.bha || '-'
            ),
            !earlyEntries && _react2.default.createElement(
              'td',
              { className: 'horse-profile-results-table-race-type' },
              result.run_type
            ),
            _react2.default.createElement(
              'td',
              null,
              (0, _utils.formatRaceDetails)(result)
            ),
            _react2.default.createElement(
              'td',
              null,
              result.odds || ''
            )
          );
        })
      )
    ),
    !horseResults.length && _react2.default.createElement(
      'p',
      { className: 'horse-profile-results-table-empty' },
      'No ',
      earlyEntries ? "entries" : "results"
    )
  );
}

HorseProfileTable.propTypes = {
  profile: _propTypes2.default.object,
  earlyEntries: _propTypes2.default.bool
};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _SwitchBtns = __webpack_require__(102);

var _SwitchBtns2 = _interopRequireDefault(_SwitchBtns);

var _Tabs = __webpack_require__(70);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _HorseRacingAbcTable = __webpack_require__(905);

var _HorseRacingAbcTable2 = _interopRequireDefault(_HorseRacingAbcTable);

var _HorseRacingPersonAbcTable = __webpack_require__(919);

var _HorseRacingPersonAbcTable2 = _interopRequireDefault(_HorseRacingPersonAbcTable);

var _LocalDateTimeHelper = __webpack_require__(13);

var _userService = __webpack_require__(44);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _seoUtils = __webpack_require__(23);

var _abc = __webpack_require__(411);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultLetterRange = 'A-D';

function apiParams(_ref) {
  var days = _ref.days,
      letterRange = _ref.letterRange;

  var letterRangeParam = void 0;

  var start = (0, _LocalDateTimeHelper.momentInUTC)(),
      end = start;
  if (days == 'tomorrow') {
    start = (0, _LocalDateTimeHelper.momentInUTC)().add('1', 'day');
    end = start;
  } else if (days == '5-days') {
    end = (0, _LocalDateTimeHelper.momentInUTC)().add('5', 'day');
    letterRangeParam = letterRange ? letterRange.toUpperCase() : defaultLetterRange;
  }

  return [(0, _LocalDateTimeHelper.isoDate)(start), (0, _LocalDateTimeHelper.isoDate)(end), "UK,IRE", letterRangeParam];
}

var HorseRacingAbcGuide = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref2) {
    var params = _ref2.params;
    return _abc.load.apply(undefined, (0, _toConsumableArray3.default)(apiParams(params)));
  },
  preventResolve: function preventResolve(_ref3) {
    var state = _ref3.state,
        params = _ref3.params;
    return _abc.isLoaded.apply(undefined, [state].concat((0, _toConsumableArray3.default)(apiParams(params))));
  },
  state: function state(_state) {
    return { races: _state.horseRacing.abc.races };
  }
}, (0, _userService.userServiceLayoutConnect)()]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingAbcGuide, _Component);

  function HorseRacingAbcGuide() {
    (0, _classCallCheck3.default)(this, HorseRacingAbcGuide);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingAbcGuide.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingAbcGuide)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingAbcGuide, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          routes = _props.routes,
          races = _props.races,
          _props$params = _props.params,
          _props$params$days = _props$params.days,
          selectedDays = _props$params$days === undefined ? 'today' : _props$params$days,
          _props$params$type = _props$params.type,
          groupingBy = _props$params$type === undefined ? 'horses' : _props$params$type,
          _props$params$letterR = _props$params.letterRange,
          letterRange = _props$params$letterR === undefined ? defaultLetterRange : _props$params$letterR;


      __webpack_require__(1444);

      if (!races) {
        return _react2.default.createElement(
          'div',
          { className: 'hr-racing-racecards' },
          _react2.default.createElement(
            'p',
            { className: 'hr-racing-racecards-error-message' },
            'ABC Guide is currently unavailable. Please check back later.'
          )
        );
      }

      var todayTabs = [{
        href: '/racing/abc-guide',
        text: 'Declared Runners',
        isIndex: true
      }, { href: '/racing/abc-guide/today/jockeys',
        text: 'Jockey Rides'
      }, { href: '/racing/abc-guide/today/trainers',
        text: 'Trainer Entries'
      }];

      var letterRangeTabs = [{
        href: '/racing/abc-guide/5-days',
        text: 'A-D',
        isIndex: true
      }, {
        href: '/racing/abc-guide/5-days/horses/e-l',
        text: 'E-L'
      }, {
        href: '/racing/abc-guide/5-days/horses/m-r',
        text: 'M-R'
      }, {
        href: '/racing/abc-guide/5-days/horses/s-z',
        text: 'S-Z'
      }];

      var rides = [];

      races.map(function (race) {
        race.rides.map(function (ride) {
          rides.push({ race: race, ride: ride });
        });
      });

      var pageTitle = 'ABC Guide';
      var metaDescriptionDayText = void 0;
      if (selectedDays == 'today') {
        pageTitle = 'Today\'s ABC Guide of ' + groupingBy;
        metaDescriptionDayText = "today's";
      } else if (selectedDays == 'tomorrow') {
        pageTitle = 'Tomorrow\'s ABC Guide of ' + groupingBy;
        metaDescriptionDayText = "tomorrow's";
      } else {
        pageTitle = 'Five Day ABC Guide (' + letterRange.toUpperCase() + ')';
        metaDescriptionDayText = "the next five days'";
      }

      var helmetProps = (0, _extends3.default)({
        title: pageTitle
      }, (0, _seoUtils.metaDescription)('All of ' + metaDescriptionDayText + ' declared ' + groupingBy + ' and where they\u2019re running, listed in alphabetical order on Sporting Life and complete with Sky Bet odds.'), (0, _seoUtils.canonicalLink)(routes, { days: selectedDays, type: groupingBy, letterRange: letterRange }));

      return _react2.default.createElement(
        'div',
        { className: 'horse-racing-abc-guide' },
        _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
        _react2.default.createElement(
          'h1',
          { className: 'page-main-title' },
          'ABC Guide'
        ),
        _react2.default.createElement(_SwitchBtns2.default, { buttonCount: '3', buttons: [{ href: '/racing/abc-guide', text: 'Today', isIndex: true, alternatives: [{ href: '/racing/abc-guide/today/jockeys' }, { href: 'racing/abc-guide/today/trainers' }] }, { href: '/racing/abc-guide/tomorrow', text: 'Tomorrow' }, { href: '/racing/abc-guide/5-days', text: '5 Days' }] }),
        _react2.default.createElement(
          'section',
          { className: 'horse-racing-abc-guide-content' },
          selectedDays == 'today' && _react2.default.createElement(_Tabs2.default, { tabs: todayTabs, centerDefault: true }),
          selectedDays == '5-days' && _react2.default.createElement(_Tabs2.default, { tabs: letterRangeTabs, centerDefault: true }),
          groupingBy == 'horses' ? _react2.default.createElement(_HorseRacingAbcTable2.default, { rides: rides, days: selectedDays }) : _react2.default.createElement(_HorseRacingPersonAbcTable2.default, { rides: rides, tableType: groupingBy })
        )
      );
    }
  }]);
  return HorseRacingAbcGuide;
}(_react.Component), _class2.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  races: _propTypes2.default.array,
  params: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = HorseRacingAbcGuide;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _set = __webpack_require__(481);

var _set2 = _interopRequireDefault(_set);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(8);

var _moment2 = _interopRequireDefault(_moment);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _fastResults = __webpack_require__(414);

var _features = __webpack_require__(65);

var _HorseRacingFastRacecardsList = __webpack_require__(910);

var _HorseRacingFastRacecardsList2 = _interopRequireDefault(_HorseRacingFastRacecardsList);

var _trackingEvents = __webpack_require__(250);

var _raceUpdate = __webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POLLING_INTERVAL_MILLIS = 5000;
var REFRESH_INTERVAL_MILLIS = (0, _features.has)("push-fast-results") ? 60000 : POLLING_INTERVAL_MILLIS;

var dispatch = function dispatch(params) {
  return (0, _fastResults.load)((0, _fastResults.createParams)(params));
};

var HorseRacingFastRacecards = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: dispatch,
  preventResolve: function preventResolve(_ref) {
    var state = _ref.state;
    return (0, _fastResults.isLoading)(state);
  },
  refreshInterval: REFRESH_INTERVAL_MILLIS,
  state: function state(_state) {
    return {
      fastResults: _state.horseRacing.fastResults,
      pollFallbackEnabled: _state.horseRacing.raceUpdate.pollFallbackEnabled,
      subscribedTopics: _state.horseRacing.raceUpdate.subscribedTopics
    };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingFastRacecards, _Component);

  function HorseRacingFastRacecards() {
    (0, _classCallCheck3.default)(this, HorseRacingFastRacecards);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingFastRacecards.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingFastRacecards)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingFastRacecards, [{
    key: 'hasCountryFilterChanged',
    value: function hasCountryFilterChanged(newFilters) {
      var current = this.state.countryGroups || [];
      var newGroups = newFilters.filter(function (n) {
        return !this.has(n);
      }, new _set2.default(current));
      var oldGroups = current.filter(function (n) {
        return !this.has(n);
      }, new _set2.default(newFilters));

      return newGroups.length > 0 || oldGroups.length > 0;
    }
  }, {
    key: 'getCountryGroups',
    value: function getCountryGroups(location) {
      location = location || this.props.location;
      var params = (0, _fastResults.createParams)(location);
      if (!params.countryGroups) {
        return [];
      }

      return params.countryGroups.split(',');
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var cg = this.getCountryGroups();
      this.setState({ countryGroups: cg });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if ((0, _features.has)("push-fast-results")) {
        this.props.dispatch((0, _raceUpdate.connectToRaceUpdates)(this.state.countryGroups));
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var cg = this.getCountryGroups(nextProps.location);
      var filterChanged = this.hasCountryFilterChanged(cg);

      if (!filterChanged && nextProps && nextProps.fastResults.fastResults) {
        var _timedFastResultsTrac = timedFastResultsTracking(nextProps.fastResults.fastResults, this.props.fastResults.fastResults, this.isSubscribedToTopics()),
            metric = _timedFastResultsTrac.metric,
            label = _timedFastResultsTrac.label,
            times = _timedFastResultsTrac.times;

        this.props.dispatch((0, _trackingEvents.sendFeedReceivedTimeTracking)(metric, label, times));
      }

      if (filterChanged && (0, _features.has)("push-fast-results")) {
        this.props.dispatch((0, _raceUpdate.subscribeToRaceUpdates)(cg));
        this.setState({ countryGroups: cg });
      }

      if (this.fallbackTriggered(nextProps.pollFallbackEnabled)) {
        this.activeTimeouts.push(this.timeoutCallback(dispatch, POLLING_INTERVAL_MILLIS, this.activeTimeouts.length));
      }
    }
  }, {
    key: 'isSubscribedToTopics',
    value: function isSubscribedToTopics() {
      return this.props.subscribedTopics && this.props.subscribedTopics.length > 0;
    }
  }, {
    key: 'fallbackTriggered',
    value: function fallbackTriggered(nextFallbackEnabledState) {
      return nextFallbackEnabledState && !this.props.pollFallbackEnabled;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.dispatch((0, _raceUpdate.unSubscribeRaceUpdates)());
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_HorseRacingFastRacecardsList2.default, { fastResults: this.props.fastResults });
    }
  }]);
  return HorseRacingFastRacecards;
}(_react.Component), _class2.propTypes = {
  fastResults: _propTypes2.default.shape({
    fastResults: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      race_reference: _propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired
      }).isRequired
    })).isRequired
  }),
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string
  }),
  dispatch: _propTypes2.default.func.isRequired,
  pollFallbackEnabled: _propTypes2.default.bool,
  subscribedTopics: _propTypes2.default.arrayOf(_propTypes2.default.string)
}, _temp)) || _class) || _class);
exports.default = HorseRacingFastRacecards;


function timedFastResultsTracking(newFastResults, prevFastResults, isUsingPush) {

  var getRaceFeedTimes = function getRaceFeedTimes(fastResults) {
    return fastResults.reduce(function (times, result) {
      if (result.feed_received && result.race_reference.id) {
        var momentTime = (0, _moment2.default)(result.feed_received);
        if (momentTime.isValid()) {
          times[result.race_reference.id] = momentTime.valueOf();
        }
      }
      return times;
    }, {});
  };

  var prevFastResultTimes = getRaceFeedTimes(prevFastResults);
  var newFastResultTimes = getRaceFeedTimes(newFastResults);

  //map new times to old & return any changed times
  var times = (0, _keys2.default)(newFastResultTimes).map(function (raceId) {
    if (newFastResultTimes[raceId] > 0 && newFastResultTimes.hasOwnProperty(raceId) && prevFastResultTimes[raceId] !== newFastResultTimes[raceId]) {
      return Date.now() - newFastResultTimes[raceId];
    }
    return 0;
  }).filter(function (time) {
    return time > 0 && time < 1800000;
  });

  return {
    metric: 'timing.feeds.horse-racing.fast-results-received-to-display' + (isUsingPush ? ".websockets" : ""),
    label: 'Horse Racing Fast Results Feed Time' + (isUsingPush ? " Websocket Connected" : ""),
    times: times
  };
}

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _going = __webpack_require__(415);

var _HorseRacingGoing = __webpack_require__(912);

var _HorseRacingGoing2 = _interopRequireDefault(_HorseRacingGoing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingGoingContainer = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)("HorseRacingGoingContainer", [{
  dispatch: function dispatch() {
    return (0, _going.load)();
  },
  preventResolve: function preventResolve(_ref) {
    var state = _ref.state;
    return (0, _going.isLoading)(state);
  },
  state: function state(_state) {
    return { going: (0, _going.get)(_state) };
  }
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingGoingContainer, _Component);

  function HorseRacingGoingContainer() {
    (0, _classCallCheck3.default)(this, HorseRacingGoingContainer);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingGoingContainer.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingGoingContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingGoingContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_HorseRacingGoing2.default, { races: this.props.going });
    }
  }]);
  return HorseRacingGoingContainer;
}(_react.Component), _class2.propTypes = {
  going: _propTypes2.default.object
}, _temp)) || _class);
exports.default = HorseRacingGoingContainer;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _nonRunners = __webpack_require__(428);

var _HorseRacingNonRunners = __webpack_require__(918);

var _HorseRacingNonRunners2 = _interopRequireDefault(_HorseRacingNonRunners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingNonRunnersContainer = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)("HorseRacingNonRunnersContainer", [{
  dispatch: function dispatch() {
    return (0, _nonRunners.load)();
  },
  preventResolve: function preventResolve(_ref) {
    var state = _ref.state;
    return (0, _nonRunners.isLoading)(state);
  },
  refreshInterval: 30000,
  state: function state(_state) {
    return (0, _nonRunners.get)(_state);
  }
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingNonRunnersContainer, _Component);

  function HorseRacingNonRunnersContainer() {
    (0, _classCallCheck3.default)(this, HorseRacingNonRunnersContainer);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingNonRunnersContainer.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingNonRunnersContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingNonRunnersContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_HorseRacingNonRunners2.default, { meetings: this.props.meetings });
    }
  }]);
  return HorseRacingNonRunnersContainer;
}(_react.Component), _class2.propTypes = {
  meetings: _propTypes2.default.array
}, _temp)) || _class);
exports.default = HorseRacingNonRunnersContainer;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _Tabs = __webpack_require__(70);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _MyStableSearch = __webpack_require__(935);

var _MyStableSearch2 = _interopRequireDefault(_MyStableSearch);

var _userService = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyStablePageContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([(0, _userService.userServiceLayoutConnect)({
  state: function state(_state) {
    return { auth: _state.common.auth };
  }
})]), (0, _catchLifeCycleErrors2.default)(_class = _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(MyStablePageContainer, _Component);

  function MyStablePageContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MyStablePageContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MyStablePageContainer.__proto__ || (0, _getPrototypeOf2.default)(MyStablePageContainer)).call.apply(_ref, [this].concat(args))), _this), _this.isLoggedIn = function () {
      return _this.props.auth && _this.props.auth.loggedIn && _this.props.auth.user;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MyStablePageContainer, [{
    key: 'render',
    value: function render() {
      __webpack_require__(1437);
      var isLoggedIn = this.isLoggedIn,
          _props = this.props,
          router = _props.router,
          dispatch = _props.dispatch,
          children = _props.children;


      return _react2.default.createElement(
        'div',
        { className: 'my-stable-container' },
        _react2.default.createElement(
          'div',
          { className: 'my-stable-title' },
          _react2.default.createElement(
            'h1',
            { className: 'page-title' },
            'My Stable'
          ),
          _react2.default.createElement(_MyStableSearch2.default, { dispatch: dispatch, router: router })
        ),
        _react2.default.createElement(_Tabs2.default, { tabs: [{ href: '/racing/my-stable', text: 'Next Entries', isIndex: true }, { href: '/racing/my-stable/results', text: 'Results' }, { href: '/racing/my-stable/selections', text: 'Selections' }, { href: '/racing/my-stable/search', text: 'Search' }] }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.cloneElement(children, { isLoggedIn: isLoggedIn })
        )
      );
    }
  }]);
  return MyStablePageContainer;
}(_react.Component), _class2.propTypes = {
  auth: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.node.isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  router: _propTypes2.default.object.isRequired
}, _temp2)) || _class) || _class);
exports.default = MyStablePageContainer;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _LocalDateTimeHelper = __webpack_require__(13);

var _naps = __webpack_require__(426);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NapsTable = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch() {
    return (0, _naps.load)();
  },
  state: function state(_state) {
    return { naps: _state.horseRacing.naps.napsList };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(NapsTable, _Component);

  function NapsTable() {
    (0, _classCallCheck3.default)(this, NapsTable);
    return (0, _possibleConstructorReturn3.default)(this, (NapsTable.__proto__ || (0, _getPrototypeOf2.default)(NapsTable)).apply(this, arguments));
  }

  (0, _createClass3.default)(NapsTable, [{
    key: 'render',
    value: function render() {
      __webpack_require__(1450);

      var errorPixelSrc = '/1x1.gif?type=naps-table&id=0&cb=' + Date.now();

      return _react2.default.createElement(
        'div',
        { className: 'horse-racing-naps-table' },
        _react2.default.createElement(
          'h1',
          { className: 'page-main-title' },
          'Naps Table ',
          _react2.default.createElement(
            'small',
            null,
            (0, _LocalDateTimeHelper.localFullDateLong)((0, _LocalDateTimeHelper.momentInUTC)())
          )
        ),
        _react2.default.createElement(
          'section',
          { className: 'horse-racing-naps-table-content' },
          this.props.naps && this.props.naps.length > 0 ? _react2.default.createElement(
            'table',
            { className: 'naps-table' },
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'th',
                  null,
                  'SELECTION'
                ),
                _react2.default.createElement(
                  'th',
                  { className: 'race-name-column' },
                  'RACE'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'TIPSTER'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'W'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  'L'
                ),
                _react2.default.createElement(
                  'th',
                  null,
                  '\xA31 STAKE'
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              null,
              this.props.naps.map(function (nap) {
                return _react2.default.createElement(
                  'tr',
                  { key: nap.tipster + nap.tipsterSource },
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'div',
                      { className: 'horse-name' },
                      nap.horseName
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'race-name-selection-cell' },
                      nap.race
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    { className: 'race-name-column' },
                    nap.race
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'div',
                      { className: 'tipster-source' },
                      nap.tipsterSource
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'tipster' },
                      nap.tipster
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    nap.wins
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    nap.losses
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    nap.stake
                  )
                );
              })
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              { className: 'no-naps-msg' },
              'Today\'s Naps Table is currently unavailable. Please check back later.'
            ),
            _react2.default.createElement(
              'div',
              null,
              ' ',
              _react2.default.createElement('img', { src: errorPixelSrc, width: '1', height: '1' }),
              ' '
            )
          )
        )
      );
    }
  }]);
  return NapsTable;
}(_react.Component), _class2.propTypes = {
  naps: _propTypes2.default.array
}, _temp)) || _class) || _class);
exports.default = NapsTable;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(180);

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.load = load;
exports.isLoaded = isLoaded;
exports.get = get;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/abc/LOAD';
var LOAD_SUCCESS = 'horse-racing/abc/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/abc/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        races: action.result,
        key: action.key
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function load(fromDate, toDate, countryGroups, letterRange) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.abc, { params: { fromDate: fromDate, toDate: toDate, countryGroups: countryGroups, letterRange: letterRange } });
    },
    key: (0, _stringify2.default)({ fromDate: fromDate, toDate: toDate, countryGroups: countryGroups, letterRange: letterRange })
  };
}

function isLoaded(state, fromDate, toDate, countryGroups, letterRange) {
  var _state$horseRacing = state.horseRacing;
  _state$horseRacing = _state$horseRacing === undefined ? {} : _state$horseRacing;
  var _state$horseRacing$ab = _state$horseRacing.abc;
  _state$horseRacing$ab = _state$horseRacing$ab === undefined ? {} : _state$horseRacing$ab;
  var loading = _state$horseRacing$ab.loading,
      loaded = _state$horseRacing$ab.loaded,
      key = _state$horseRacing$ab.key;


  var testKey = (0, _stringify2.default)({ fromDate: fromDate, toDate: toDate, countryGroups: countryGroups, letterRange: letterRange });

  return !loading && loaded && key == testKey;
}

function get(state) {
  return { races: state.horseRacing.abc.races };
}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/early-entries/LOAD';
var LOAD_SUCCESS = 'horse-racing/early-entries/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/early-entries/LOAD_FAIL';

var initialState = {
  loading: false,
  loaded: false,
  earlyEntries: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        earlyEntries: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$horseRacing = _ref.horseRacing;

  _ref$horseRacing = _ref$horseRacing === undefined ? {} : _ref$horseRacing;
  var _ref$horseRacing$earl = _ref$horseRacing.earlyEntries;
  _ref$horseRacing$earl = _ref$horseRacing$earl === undefined ? {} : _ref$horseRacing$earl;
  var _ref$horseRacing$earl2 = _ref$horseRacing$earl.loading,
      loading = _ref$horseRacing$earl2 === undefined ? false : _ref$horseRacing$earl2;

  return loading;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('' + _config2.default.api.horseRacing.loadMeeting, { params: { earlyEntry: true } });
    }
  };
}

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__(7);

var _extends6 = _interopRequireDefault(_extends5);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/fast-cards/LOAD';
var LOAD_SUCCESS = 'horse-racing/fast-cards/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/fast-cards/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.meetingId, (0, _extends6.default)({}, state[action.meetingId], {
        loading: true
      })));
    case LOAD_SUCCESS:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.meetingId, (0, _extends6.default)({}, state[action.meetingId], {
        loading: false,
        loaded: true,
        meeting: action.result
      })));
    case LOAD_FAIL:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.meetingId, (0, _extends6.default)({}, state[action.meetingId], {
        loading: false,
        loaded: false,
        error: action.error
      })));
    default:
      return state;
  }
}

function isLoading(globalState, meetingId) {
  return globalState.horseRacing && globalState.horseRacing.fastCards && globalState.horseRacing.fastCards[meetingId] && globalState.horseRacing.fastCards[meetingId].loading;
}

function load(meetingId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.loadFastCard, { params: { meetingId: meetingId } });
    },
    meetingId: meetingId
  };
}

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_FAIL = exports.LOAD_SUCCESS = exports.LOAD = undefined;

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.createParams = createParams;
exports.isLoading = isLoading;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _routeUtils = __webpack_require__(38);

var _raceUpdate = __webpack_require__(169);

var _LocalDateTimeHelper = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = exports.LOAD = 'horse-racing/fast-results/LOAD';
var LOAD_SUCCESS = exports.LOAD_SUCCESS = 'horse-racing/fast-results/LOAD_SUCCESS';
var LOAD_FAIL = exports.LOAD_FAIL = 'horse-racing/fast-results/LOAD_FAIL';

var initialState = {
  loaded: false
};

var FR_RACE_LIMIT = 10;

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        fastResults: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case _raceUpdate.HORSE_RACE_UPDATE_RECEIVED:
      if (state.fastResults) {
        return (0, _extends3.default)({}, state, {
          fastResults: applyRaceUpdate(action.data, state.fastResults)
        });
      }
      return state;
    default:
      return state;
  }
}

function applyRaceUpdate(update, fastResults) {
  return addNewRaceUpdate(fastResults.reduce(function (raceData, race) {

    if (raceData.update && race.race_reference.id === raceData.update.race_reference.id) {
      if ((0, _LocalDateTimeHelper.timeStampToUnix)(raceData.update.feed_received) > (0, _LocalDateTimeHelper.timeStampToUnix)(race.feed_received)) {
        return { races: [].concat((0, _toConsumableArray3.default)(raceData.races), [raceData.update]), update: null };
      } else {
        return { races: [].concat((0, _toConsumableArray3.default)(raceData.races), [race]), update: null };
      }
    }
    return { races: [].concat((0, _toConsumableArray3.default)(raceData.races), [race]), update: raceData.update };
  }, { races: [], update: update }), FR_RACE_LIMIT);
}

function addNewRaceUpdate(raceUpdates) {
  var maxItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var _raceUpdates$update = raceUpdates.update,
      update = _raceUpdates$update === undefined ? null : _raceUpdates$update,
      _raceUpdates$races = raceUpdates.races,
      races = _raceUpdates$races === undefined ? [] : _raceUpdates$races;

  if (!update) {
    return races;
  }

  var updatedRaces = [update].concat((0, _toConsumableArray3.default)(races));
  if (updatedRaces.length > maxItems) {
    return updatedRaces.slice(0, maxItems - 1);
  }
  return updatedRaces;
}

function createParams() {
  var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var allResults = location.pathname && location.pathname.endsWith('all');
  return allResults ? {} : { countryGroups: 'UK,IRE' };
}

function isLoading(globalState) {
  return globalState.horseRacing && globalState.horseRacing.fastResults && globalState.horseRacing.fastResults.loading;
}

function load(params) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.loadFastResult, { params: params });
    }
  };
}

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;
exports.get = get;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/going/LOAD';
var LOAD_SUCCESS = 'horse-racing/going/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/going/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        going: segmentByDate(action.result)
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading(globalState) {
  return globalState.horseRacing && globalState.horseRacing.going && globalState.horseRacing.going.loading;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.going, { params: { countryGroups: "UK,IRE" } });
    }
  };
}

function get(state) {
  return state.horseRacing.going.going;
}

function segmentByDate(data) {
  var byDate = {};

  data.forEach(function (race) {
    var date = race.date;

    byDate[date] = byDate[date] || [];
    byDate[date].push(race);
  });

  return byDate;
}

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isProfileLoaded = isProfileLoaded;
exports.resetProfileLoaded = resetProfileLoaded;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/horseProfile/LOAD';
var LOAD_SUCCESS = 'horse-racing/horseProfile/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/horseProfile/LOAD_FAIL';
var LOAD_RESET = 'horse-racing/horseProfile/LOAD_RESET';

var initialState = {
  profile: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        profile: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case LOAD_RESET:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false
      });
    default:
      return state;
  }
}

function isProfileLoaded(_ref) {
  var _ref$horseRacing$hors = _ref.horseRacing.horseProfile,
      loading = _ref$horseRacing$hors.loading,
      loaded = _ref$horseRacing$hors.loaded;

  return loading || loaded;
}

function resetProfileLoaded() {
  return { type: LOAD_RESET };
}

function load(horseId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.horse + '/' + horseId);
    }
  };
}

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isProfileLoaded = isProfileLoaded;
exports.resetProfileLoaded = resetProfileLoaded;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/jockeyProfile/LOAD';
var LOAD_SUCCESS = 'horse-racing/jockeyProfile/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/jockeyProfile/LOAD_FAIL';
var LOAD_RESET = 'horse-racing/jockeyProfile/LOAD_RESET';

var initialState = {
  profile: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        profile: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case LOAD_RESET:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false
      });
    default:
      return state;
  }
}

function isProfileLoaded(_ref) {
  var _ref$horseRacing$jock = _ref.horseRacing.jockeyProfile,
      loading = _ref$horseRacing$jock.loading,
      loaded = _ref$horseRacing$jock.loaded;

  return loading || loaded;
}

function resetProfileLoaded() {
  return { type: LOAD_RESET };
}

function load(jockeyId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.jockey + '/' + jockeyId);
    }
  };
}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isMeetingLoading = isMeetingLoading;
exports.load = load;
exports.loadMeetingByRaceId = loadMeetingByRaceId;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/meeting/LOAD';
var LOAD_SUCCESS = 'horse-racing/meeting/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/meeting/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        meeting: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isMeetingLoading(globalState, meetingId) {
  return globalState.horseRacing.meeting && globalState.horseRacing.meeting.loading && globalState.horseRacing.meeting.meeting && globalState.horseRacing.meeting.meeting.id === meetingId;
}

function load(id) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.loadMeeting + '/' + id);
    }
  };
}

// given a race ID load the corresponding meeting for this race
function loadMeetingByRaceId(raceId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('' + _config2.default.api.horseRacing.loadMeeting, {
        params: {
          raceId: raceId
        }
      });
    }
  };
}

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/meeting-landing-page/LOAD';
var LOAD_SUCCESS = 'horse-racing/meeting-landing-page/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/meeting-landing-page/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        meeting: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading(globalState) {
  return globalState.horseRacing && globalState.horseRacing.meetingLandingPage && globalState.horseRacing.meetingLandingPage.loading;
}

function load(meetingId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.loadMeetingData + '/' + meetingId);
    }
  };
}

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.load = load;
exports.isLoading = isLoading;
exports.get = get;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/mostfollowed/LOAD';
var LOAD_SUCCESS = 'horse-racing/mostfollowed/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/mostfollowed/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        list: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function load(type) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.mostFollowed[type]);
    }
  };
}

function isLoading(state) {
  return state.horseRacing && state.horseRacing.mostFollowed && state.horseRacing.mostFollowed.loading;
}

function get(state) {
  return { mostFollowed: state.horseRacing.mostFollowed.list };
}

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadEntries = loadEntries;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _subscriptionUtils = __webpack_require__(277);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/my-stable-entries/LOAD';
var LOAD_SUCCESS = 'horse-racing/my-stable-entries/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/my-stable-entries/LOAD_FAIL';

var initialState = {
  entries: {
    horse: [],
    trainer: [],
    jockey: []
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        entries: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        error: action.error
      });
    default:
      return state;
  }
}

function loadEntries(subscriptions) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.post('' + _config2.default.api.horseRacing.loadEntries, {
        data: {
          subscription: (0, _subscriptionUtils.flattenSubscriptions)(subscriptions, ['HORSE', 'JOCKEY', 'TRAINER'])
        }
      });
    }
  };
}

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.resetHorses = resetHorses;
exports.areHorsesLoaded = areHorsesLoaded;
exports.loadHorses = loadHorses;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/my-stable-horse-search/LOAD';
var LOAD_SUCCESS = 'horse-racing/my-stable-horse-search/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/my-stable-horse-search/LOAD_FAIL';
var RESET = 'horse-racing/my-stable-horse-search/RESET';

var initialState = {
  loaded: false,
  horseSearchResults: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true,
        searchText: action.searchText
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        horseSearchResults: action.result,
        searchText: action.searchText
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error,
        searchText: action.searchText
      });
    case RESET:
      return (0, _extends3.default)({}, state, {
        horseSearchResults: [],
        searchText: ""
      });
    default:
      return state;
  }
}

function resetHorses() {
  return {
    type: RESET
  };
}

function areHorsesLoaded() {
  return false;
}

function loadHorses(name) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return name ? client.get(_config2.default.api.horseRacing.horse, { params: { name: name } }) : _promise2.default.resolve([]);
    },
    searchText: name
  };
}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.resetJockeys = resetJockeys;
exports.areJockeysLoaded = areJockeysLoaded;
exports.loadJockeys = loadJockeys;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/my-stable-jockey-search/LOAD';
var LOAD_SUCCESS = 'horse-racing/my-jockey-trainer-search/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/my-stable-jockey-search/LOAD_FAIL';
var RESET = 'horse-racing/my-stable-jockey-search/RESET';

var initialState = {
  loaded: false,
  jockeySearchResults: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        jockeySearchResults: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case RESET:
      return (0, _extends3.default)({}, state, {
        jockeySearchResults: [],
        searchText: ""
      });
    default:
      return state;
  }
}

function resetJockeys() {
  return {
    type: RESET
  };
}

function areJockeysLoaded() {

  return false;
}

function loadJockeys(name) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return name ? client.get(_config2.default.api.horseRacing.jockey, { params: { name: name } }) : _promise2.default.resolve([]);
    }
  };
}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadResults = loadResults;
exports.transformResult = transformResult;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _subscriptionUtils = __webpack_require__(277);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/my-stable-results/LOAD';
var LOAD_SUCCESS = 'horse-racing/my-stable-results/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/my-stable-results/LOAD_FAIL';

var initialState = {
  results: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        results: transformResult(action.result)
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        error: action.error
      });
    default:
      return state;
  }
}

function loadResults(subscriptions) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.post(_config2.default.api.horseRacing.loadResults, {
        data: {
          subscription: (0, _subscriptionUtils.flattenSubscriptions)(subscriptions, ['HORSE', 'JOCKEY', 'TRAINER'])
        }
      });
    }
  };
}

function transformResult(_ref) {
  var horse = _ref.horse,
      jockey = _ref.jockey,
      trainer = _ref.trainer;

  var resultsByDate = {};

  horse.forEach(function (h) {
    if (resultsByDate[h.race.race_summary.date] == undefined) {
      resultsByDate[h.race.race_summary.date] = [];
    }
    resultsByDate[h.race.race_summary.date].push((0, _extends3.default)({}, h, { matchType: "H" }));
  });

  jockey.forEach(function (j) {
    if (resultsByDate[j.race.race_summary.date] == undefined) {
      resultsByDate[j.race.race_summary.date] = [];
    }
    resultsByDate[j.race.race_summary.date].push((0, _extends3.default)({}, j, { matchType: "J" }));
  });
  trainer.forEach(function (t) {
    if (resultsByDate[t.race.race_summary.date] == undefined) {
      resultsByDate[t.race.race_summary.date] = [];
    }
    resultsByDate[t.race.race_summary.date].push((0, _extends3.default)({}, t, { matchType: "T" }));
  });

  return resultsByDate;
}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.resetTrainers = resetTrainers;
exports.areTrainersLoaded = areTrainersLoaded;
exports.loadTrainers = loadTrainers;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/my-stable-trainer-search/LOAD';
var LOAD_SUCCESS = 'horse-racing/my-stable-trainer-search/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/my-stable-trainer-search/LOAD_FAIL';
var RESET = 'horse-racing/my-stable-trainer-search/RESET';

var initialState = {
  loaded: false,
  trainerSearchResults: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        trainerSearchResults: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case RESET:
      return (0, _extends3.default)({}, state, {
        trainerSearchResults: [],
        searchText: ""
      });
    default:
      return state;
  }
}

function resetTrainers() {
  return {
    type: RESET
  };
}

function areTrainersLoaded() {
  return false;
}

function loadTrainers(name) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return name ? client.get(_config2.default.api.horseRacing.trainer, { params: { name: name } }) : _promise2.default.resolve([]);
    }
  };
}

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/naps/LOAD';
var LOAD_SUCCESS = 'horse-racing/naps/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/naps/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        napsList: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.naps);
    }
  };
}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isNextRaceLoading = isNextRaceLoading;
exports.loadNextRace = loadNextRace;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/nextrace/LOAD';
var LOAD_SUCCESS = 'horse-racing/nextrace/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/nextrace/LOAD_FAIL';

var initialState = {
  loaded: false,
  race: {
    race_summary: {
      meeting_summary_reference: { id: null, external_reference: [] },
      race_summary_reference: { id: null, external_reference: [] },
      name: null,
      course_name: null,
      course_surface: {
        surface: null,
        translation: null
      },
      age: null,
      race_class: null,
      distance: null,
      date: null,
      time: null,
      off_time: null,
      winning_time: null,
      ride_count: null,
      race_stage: null,
      has_video: null,
      going: null,
      has_handicap: false
    },
    previous_winner: null,
    prizes: {
      prize: []
    },
    verdict: null,
    betting_forecast: null,
    rides: [],
    number_of_placed_rides: null,
    videos: [],
    tote_win: null,
    place_win: null,
    exacta_win: null,
    trifecta: null,
    superfecta: null,
    tricast: null,
    swingers: null,
    straight_forecast: null,
    place_pot: { pot: null, pool: null, winStakes: null },
    quad_pot: { pot: null, pool: null, winStakes: null }
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      {
        // TODO: This is in relation to SPL-2289. The array should be fully parsed by this fix.
        var result = action.result[0] || null;
        return (0, _extends3.default)({}, state, {
          loading: false,
          loaded: true,
          race: result,
          error: null
        });
      }
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isNextRaceLoading(state) {
  return state.horseRacing.nextrace && state.horseRacing.nextrace.loading;
}

function loadNextRace() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.loadRace + '?limit=1&sort_direction=ASC&sort_field=RACE_TIME');
    }
  };
}

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;
exports.get = get;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _LocalDateTimeHelper = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Ready for use when the API is added
var LOAD = 'horse-racing/nonrunners/LOAD';
var LOAD_SUCCESS = 'horse-racing/nonrunners/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/nonrunners/LOAD_FAIL';

var initialState = {
  byDate: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        meetings: action.result,
        loading: false,
        loaded: true,
        error: null
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading(globalState) {
  return globalState.horseRacing.nonRunners && globalState.horseRacing.nonRunners.loading;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.nonRunners, { params: { meetingDate: (0, _LocalDateTimeHelper.isoDate)(), countryGroups: "UK,IRE" } });
    }
  };
}

function get(state) {
  return state.horseRacing.nonRunners;
}

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/race/LOAD';
var LOAD_SUCCESS = 'horse-racing/race/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/race/LOAD_FAIL';

var initialState = {
  loaded: false,
  race: {
    race_summary: {
      meeting_summary_reference: { id: null, external_reference: [] },
      race_summary_reference: { id: null, external_reference: [] },
      name: null,
      course_name: null,
      course_surface: {
        surface: null,
        translation: null
      },
      age: null,
      race_class: null,
      distance: null,
      date: null,
      time: null,
      off_time: null,
      winning_time: null,
      ride_count: null,
      race_stage: null,
      has_video: null,
      going: null,
      has_handicap: false
    },
    previous_winner: null,
    prizes: {
      prize: []
    },
    verdict: null,
    betting_forecast: null,
    rides: [],
    number_of_placed_rides: null,
    videos: [],
    tote_win: null,
    place_win: null,
    exacta_win: null,
    trifecta: null,
    superfecta: null,
    tricast: null,
    swingers: null,
    straight_forecast: null,
    place_pot: { pot: null, pool: null, winStakes: null },
    quad_pot: { pot: null, pool: null, winStakes: null }
  }
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      {
        // TODO: This is in relation to SPL-2289. The array should be fully parsed by this fix.
        var result = action.result[0] || null;
        return (0, _extends3.default)({}, state, {
          loading: false,
          loaded: true,
          race: result,
          error: null
        });
      }
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading(globalState, raceId) {
  return globalState.horseRacing.race && globalState.horseRacing.race.loading && globalState.horseRacing.race.race && globalState.horseRacing.race.race.race_summary && globalState.horseRacing.race.race.race_summary.race_summary_reference && globalState.horseRacing.race.race.race_summary.race_summary_reference.id == raceId;
}

function load(id) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.loadRace + '/' + id).then(function (race) {
        return [race];
      });
    }
  };
}

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isProfileLoaded = isProfileLoaded;
exports.resetProfileLoaded = resetProfileLoaded;
exports.load = load;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'horse-racing/trainerProfile/LOAD';
var LOAD_SUCCESS = 'horse-racing/trainerProfile/LOAD_SUCCESS';
var LOAD_FAIL = 'horse-racing/trainerProfile/LOAD_FAIL';
var LOAD_RESET = 'horse-racing/trainerProfile/LOAD_RESET';

var initialState = {
  profile: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        profile: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case LOAD_RESET:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: null
      });
    default:
      return state;
  }
}

function isProfileLoaded(_ref) {
  var _ref$horseRacing$trai = _ref.horseRacing.trainerProfile,
      loading = _ref$horseRacing$trai.loading,
      loaded = _ref$horseRacing$trai.loaded;

  return loading || loaded;
}

function resetProfileLoaded() {
  return { type: LOAD_RESET };
}

function load(trainerId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get(_config2.default.api.horseRacing.trainer + '/' + trainerId);
    }
  };
}

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _reactRedux = __webpack_require__(17);

var _morenews = __webpack_require__(79);

var _media = __webpack_require__(78);

var _StorySummary = __webpack_require__(215);

var _StorySummary2 = _interopRequireDefault(_StorySummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFRESH_INTERVAL_MILLIS = 30000;

// IMPORTANT
// These are the correct sizes for pages but most of the API calls will attempt to
// load this number + 1. This is to check if there are more articles to show
// i.e for the "Show More" button.
var PAGE_SIZE = 4;

__webpack_require__(515);

var MoreNewsList = (_dec = (0, _reactRedux.connect)(function (state) {
  return { morenews: state.common.morenews };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MoreNewsList, _Component);

  function MoreNewsList(props) {
    (0, _classCallCheck3.default)(this, MoreNewsList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MoreNewsList.__proto__ || (0, _getPrototypeOf2.default)(MoreNewsList)).call(this, props));

    _this.showMore = function () {
      var _this$props = _this.props,
          basketQuery = _this$props.basketQuery,
          dispatch = _this$props.dispatch;


      _this.setState({
        showMorePressed: true
      });

      dispatch((0, _morenews.loadByQuery)(basketQuery, PAGE_SIZE + 1, _this.state.displayedArticles)).then(function (articles) {
        (0, _media.loadMediaForArticles)(_this.context.store.getState(), dispatch, articles.articles);
      }).catch(function (e) {
        if (!_config2.default.isProduction) {
          console.error("Error in Live Update", e); // eslint-disable-line no-console
        }
      }).then(function () {
        _this.setState({
          showMorePressed: false,
          displayedArticles: _this.state.displayedArticles + PAGE_SIZE
        });
      });
    };

    _this.state = {
      displayedArticles: props.initialPageSize,
      showMorePressed: false
    };
    return _this;
  }

  (0, _createClass3.default)(MoreNewsList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refreshNews();
    }
  }, {
    key: 'refreshNews',
    value: function refreshNews() {
      var _this2 = this;

      var _props = this.props,
          basketQuery = _props.basketQuery,
          morenews = _props.morenews,
          dispatch = _props.dispatch;

      this.timeout = setTimeout(function () {

        if (!morenews[basketQuery.value].loading) {
          dispatch((0, _morenews.loadByQuery)(basketQuery, _this2.state.displayedArticles + 1, 0, true)).then(function (articles) {
            (0, _media.loadMediaForArticles)(_this2.context.store.getState(), dispatch, articles.articles);
          }).catch(function (e) {
            if (!_config2.default.isProduction) {
              console.error("Error in Live Update", e); // eslint-disable-line no-console
            }
          }).then(function () {
            return _this2.refreshNews();
          });
        } else {
          _this2.refreshNews();
        }
      }, REFRESH_INTERVAL_MILLIS);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          morenews = _props2.morenews,
          basketQuery = _props2.basketQuery;

      var newsBasketState = morenews[basketQuery.value];

      var loaded = newsBasketState.loaded,
          _newsBasketState$arti = newsBasketState.articles,
          articles = _newsBasketState$arti === undefined ? [] : _newsBasketState$arti,
          error = newsBasketState.error;


      if (loaded && articles.length > 0) {
        return this.renderNews(articles);
      } else if (error) {
        return this.renderError();
      }
      return this.renderNoNews();
    }
  }, {
    key: 'renderWrapper',
    value: function renderWrapper(component) {
      var title = this.props.title;


      return _react2.default.createElement(
        'div',
        { className: 'news' },
        title && _react2.default.createElement(_MetaDataWrapper2.default, { title: title }),
        component
      );
    }
  }, {
    key: 'renderNews',
    value: function renderNews(articles) {
      var _this3 = this;

      var newsSummaries = articles.slice(0, this.state.displayedArticles); // Only show as many as we should
      var loadedArticles = articles.length;
      var leadArticle = newsSummaries.slice(0, 1)[0]; // Always at least 1 in this case.
      var secondaryArticles = _lodash2.default.chunk(newsSummaries.slice(1, 5), 2);
      var otherArticles = _lodash2.default.chunk(newsSummaries.slice(5), 2);

      return this.renderWrapper(_react2.default.createElement(
        'section',
        { className: 'morenews' },
        _react2.default.createElement(
          'div',
          { className: 'lead-article', id: 'lead-article' },
          _react2.default.createElement(_StorySummary2.default, { className: 'morenews-article', imageType: 'leadArticle', key: leadArticle.article_reference.id, data: leadArticle, heroArticle: true })
        ),
        !!secondaryArticles.length && secondaryArticles.map(function (chunk, index) {
          return _react2.default.createElement(ArticleRow, { className: 'secondary-articles', imageType: 'secondaryArticle', key: index, articles: chunk });
        }),
        !!otherArticles.length && otherArticles.map(function (chunk, index) {
          return _react2.default.createElement(ArticleRow, { className: 'other-articles', imageType: 'otherArticle', key: index, articles: chunk });
        }),
        loadedArticles > this.state.displayedArticles && _react2.default.createElement(
          'div',
          { className: 'action-links' },
          !this.state.showMorePressed ? _react2.default.createElement(
            'button',
            { className: 'section-button large-primary-button', onClick: function onClick() {
                return _this3.showMore();
              } },
            'Load more news'
          ) : _react2.default.createElement(
            'button',
            { disabled: true, className: 'section-button large-primary-button' },
            'Loading...'
          )
        )
      ));
    }
  }, {
    key: 'renderNoNews',
    value: function renderNoNews() {
      return this.renderWrapper(_react2.default.createElement(
        'p',
        { className: 'morenews-no-news' },
        'There are currently no news articles to display here. Please try again later.'
      ));
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      return this.renderWrapper(_react2.default.createElement(
        'p',
        { className: 'morenews-error' },
        'There was a problem loading the news articles.'
      ));
    }
  }]);
  return MoreNewsList;
}(_react.Component), _class2.propTypes = {
  morenews: _propTypes2.default.object.isRequired,
  initialPageSize: _propTypes2.default.number.isRequired,
  basketQuery: _propTypes2.default.object,
  dispatch: _propTypes2.default.func,
  title: _propTypes2.default.string
}, _class2.contextTypes = {
  store: _propTypes2.default.object.isRequired
}, _temp)) || _class);
exports.default = MoreNewsList;


function ArticleRow(props) {
  var articles = props.articles,
      className = props.className,
      imageType = props.imageType;


  return _react2.default.createElement(
    'div',
    { className: className },
    articles.map(function (data) {
      return _react2.default.createElement(
        'div',
        { className: 'secondary-article', key: data.article_reference.id },
        _react2.default.createElement(_StorySummary2.default, {
          imageType: imageType,
          data: data,
          className: 'morenews-article'
        })
      );
    })
  );
}

ArticleRow.propTypes = {
  articles: _propTypes2.default.array.isRequired,
  className: _propTypes2.default.string.isRequired,
  imageType: _propTypes2.default.string.isRequired
};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdvertStraplineWidget = function AdvertStraplineWidget(_ref) {
  var bodyVisible = _ref.bodyVisible,
      article = _ref.article,
      view = _ref.view;

  return bodyVisible && !article.sensitive && _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["cms", "leaderboard"],
    additionalProperties: { view: view } });
};

AdvertStraplineWidget.mapProps = function (props) {
  return {
    article: props.article,
    bodyVisible: props.bodyVisible,
    view: props.view
  };
};
AdvertStraplineWidget.propTypes = {
  article: _propTypes2.default.object,
  bodyVisible: _propTypes2.default.bool,
  view: _propTypes2.default.string
};

exports.default = (0, _withErrorBoundry2.default)(AdvertStraplineWidget);

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _DesktopInteractivePlayerContainer = __webpack_require__(1021);

var _DesktopInteractivePlayerContainer2 = _interopRequireDefault(_DesktopInteractivePlayerContainer);

var _utils = __webpack_require__(18);

var _reactDeviceDetect = __webpack_require__(109);

var _MobileInteractivePlayerContainer = __webpack_require__(1023);

var _MobileInteractivePlayerContainer2 = _interopRequireDefault(_MobileInteractivePlayerContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moduleDefault = {};

if ((0, _utils.isServer)()) {
  moduleDefault = function moduleDefault() {
    return null;
  };
} else if (!_reactDeviceDetect.isMobile) {
  moduleDefault = _DesktopInteractivePlayerContainer2.default;
} else {
  moduleDefault = _MobileInteractivePlayerContainer2.default;
}

module.exports = moduleDefault;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ooyala = undefined;

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(7);

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uuid = __webpack_require__(1657);

var _uuid2 = _interopRequireDefault(_uuid);

var _lodash = __webpack_require__(20);

var _withPlayerManager = __webpack_require__(437);

var _withPlayerManager2 = _interopRequireDefault(_withPlayerManager);

var _PopOutPlayer = __webpack_require__(435);

var _ScrollingInspector = __webpack_require__(1025);

var _ScrollingInspector2 = _interopRequireDefault(_ScrollingInspector);

var _InteractivePlayerContainer = __webpack_require__(433);

var _InteractivePlayerContainer2 = _interopRequireDefault(_InteractivePlayerContainer);

var _PlayerEventNames = __webpack_require__(273);

var _utils = __webpack_require__(18);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1462);

var Ooyala = exports.Ooyala = function (_Component) {
  (0, _inherits3.default)(Ooyala, _Component);

  function Ooyala(props) {
    (0, _classCallCheck3.default)(this, Ooyala);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Ooyala.__proto__ || (0, _getPrototypeOf2.default)(Ooyala)).call(this, props));

    _this.hidePopOutIfAnotherStartsPlaying = function (event) {
      if (event.detail.containerId !== _this.state.playerPlaceholderId) {
        _this.interactivePlayer.setPopOutState(false);
      }
    };

    _this.onPlayerVisibilityChange = function (isPlayerInViewport) {
      if (!_this.playerIsInitialised()) {
        return;
      }

      if (!_this.state.player.isPlaying()) {
        if (isPlayerInViewport) {
          _this.interactivePlayer.setPopOutState(false);
        }
        return;
      }

      if (_this.state.dismissed) {
        !isPlayerInViewport && _this.state.player.pause();
        return;
      }

      _this.interactivePlayer.setPopOutState(!isPlayerInViewport);
    };

    _this.whenVideoIsFinished = function () {
      _this.interactivePlayer.setPopOutState(false);
    };

    _this.initialisePlayer = function () {
      var _this$props = _this.props,
          contentId = _this$props.contentId,
          createPlayer = _this$props.createPlayer;

      createPlayer(_this.state.playerPlaceholderId, contentId, window.OO).then(function (playerData) {
        playerData.player.mb.subscribe(_PlayerEventNames.VIDEO_FINISHED, '', _this.whenVideoIsFinished);
        playerData.player.mb.subscribe(_PlayerEventNames.PLAYBACK_READY, '', function () {
          _this.interactivePlayer.onPlayerReady();
        });

        var thumbnailsByWidth = (0, _lodash.get)(playerData, 'metadata.primary_preview_image.sizes', []).reduce(function (aggregator, val) {
          return (0, _extends4.default)({}, aggregator, (0, _defineProperty3.default)({}, val.width, val.url_ssl));
        }, {});

        _this.setState({ player: playerData.player, thumbnailsByWidth: thumbnailsByWidth });
      });
    };

    _this.playerIsInitialised = function () {
      return !!_this.state.playerPlaceholderId;
    };

    _this.dismissPlayer = function () {
      if (!_this.playerIsInitialised()) {
        return;
      }

      _this.state.player.pause();
      _this.interactivePlayer.setPopOutState(false);
      _this.setState({
        dismissed: true
      });
    };

    _this.setInteractivePlayer = function (ref) {
      _this.interactivePlayer = ref;
    };

    _this.updatePlaceholder = function (showPlaceholder) {
      _this.setState({
        showPlaceholder: showPlaceholder
      });
    };

    _this.scrollPlaceholderIntoView = function () {
      var playerPlaceholderId = _this.state.playerPlaceholderId;


      if (!playerPlaceholderId) {
        return;
      }

      var placeholderElement = document.getElementById('placeholder-' + playerPlaceholderId);
      if (!placeholderElement) {
        return;
      }

      var headerOffset = 250;

      var rect = placeholderElement.getClientRects()[0];
      window.scrollTo({
        top: window.scrollY + rect.y - headerOffset,
        behavior: 'smooth'
      });
    };

    _this.state = {
      playerPlaceholderId: undefined,
      player: { pause: function pause() {}, isPlaying: function isPlaying() {
          return false;
        }, getTitle: function getTitle() {
          return "";
        }, getState: function getState() {
          return "";
        } },
      imageUrl: undefined,
      dismissed: false,
      thumbnailsByWidth: {},
      articleUrl: (0, _utils.isServer)() ? "" : window.location.pathname
    };
    return _this;
  }

  (0, _createClass3.default)(Ooyala, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if ((0, _utils.isServer)()) {
        return;
      }
      window.addEventListener(_withPlayerManager.PLAYER_WAS_STARTED, this.hidePopOutIfAnotherStartsPlaying);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.playerIsInitialised()) {
        var removePlayer = this.props.removePlayer;


        if (this.state.player.isPlaying()) {
          (0, _PopOutPlayer.loadToGlobalPlayer)(this.state.player, this.state.articleUrl);
        }

        window.removeEventListener(_withPlayerManager.PLAYER_WAS_STARTED, this.hidePopOutIfAnotherStartsPlaying);
        removePlayer(this.state.playerPlaceholderId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.playerIsInitialised()) {
        var playerPlaceholderId = 'container_' + _uuid2.default.v4();
        this.setState({
          playerPlaceholderId: playerPlaceholderId
        }, this.initialisePlayer);
      }

      return _react2.default.createElement(
        _ScrollingInspector2.default,
        {
          playerPlaceholderId: this.state.playerPlaceholderId,
          thumbnails: this.state.thumbnailsByWidth,
          showPlaceholder: this.state.showPlaceholder,
          onVisibilityChange: this.onPlayerVisibilityChange
        },
        _react2.default.createElement(
          _InteractivePlayerContainer2.default,
          {
            ref: this.setInteractivePlayer,
            dismissPlayer: this.dismissPlayer,
            updatePlaceholder: this.updatePlaceholder,
            player: this.state.player,
            onMobilePopOutPress: this.scrollPlaceholderIntoView
          },
          _react2.default.createElement('div', { style: { minWidth: 'unset' }, id: this.state.playerPlaceholderId })
        )
      );
    }
  }]);
  return Ooyala;
}(_react.Component);

Ooyala.propTypes = {
  contentId: _propTypes2.default.string.isRequired,
  createPlayer: _propTypes2.default.func,
  removePlayer: _propTypes2.default.func
};

exports.default = (0, _withErrorBoundry2.default)((0, _withPlayerManager2.default)(Ooyala));

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadToGlobalPlayer = exports.PopOutPlayer = exports.POP_OUT_PLAYER_PLACEHOLDER_ID = exports.LOAD_POP_OUT_PLAYER_EVENT = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _playerParams = __webpack_require__(436);

var _playerParams2 = _interopRequireDefault(_playerParams);

var _InteractivePlayerContainer = __webpack_require__(433);

var _InteractivePlayerContainer2 = _interopRequireDefault(_InteractivePlayerContainer);

var _withPlayerManager = __webpack_require__(437);

var _PlayerEventNames = __webpack_require__(273);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD_POP_OUT_PLAYER_EVENT = exports.LOAD_POP_OUT_PLAYER_EVENT = 'SPL_PLAYER_LOAD_IN_POP_OUT';
var POP_OUT_PLAYER_PLACEHOLDER_ID = exports.POP_OUT_PLAYER_PLACEHOLDER_ID = 'static-route-independent-player';

var PopOutPlayer = exports.PopOutPlayer = function (_React$Component) {
  (0, _inherits3.default)(PopOutPlayer, _React$Component);

  function PopOutPlayer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PopOutPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopOutPlayer.__proto__ || (0, _getPrototypeOf2.default)(PopOutPlayer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      articleUrl: undefined
    }, _this.handleLoadPopOutPlayer = function (event) {
      if (!event || !event.detail) {
        return;
      }

      var articlePlayer = event.detail.player;
      var articleUrl = event.detail.articleUrl;

      if (!articlePlayer || !articlePlayer.getEmbedCode || !articlePlayer.getPlayheadTime) {
        return;
      }

      _this.setState({ articleUrl: articleUrl }, function () {
        _this.showPlayer(articlePlayer.getEmbedCode(), articlePlayer.getPlayheadTime());
      });
    }, _this.showPlayer = function (contentId, playheadTime) {
      if (!window.OO) {
        return;
      }

      window.OO.ready(function () {
        if (_this.state.popOutPlayer) {
          _this.state.popOutPlayer.destroy(function () {
            _this.createPlayer(contentId, playheadTime);
          });
        } else {
          _this.createPlayer(contentId, playheadTime);
        }
      });
    }, _this.onPlaybackReady = function () {
      _this.interactivePlayer.onPlayerReady && _this.interactivePlayer.onPlayerReady();
      _this.interactivePlayer.setPopOutState(true);
      var containerElement = document.getElementById(POP_OUT_PLAYER_PLACEHOLDER_ID);
      var videoElements = containerElement && containerElement.getElementsByTagName('video');
      if (videoElements && videoElements.length === 1) {
        var videoElement = videoElements[0];
        videoElement && videoElement.setAttribute("webkit-playsinline", true);
        videoElement && videoElement.setAttribute("playsinline", true);
      }

      if (!_this.state.popOutPlayer.isPlaying()) {
        _this.state.popOutPlayer.play();
      }
    }, _this.createPlayer = function (contentId, playheadTime) {
      _this.setState({ popOutPlayer: window.OO.Player.create(POP_OUT_PLAYER_PLACEHOLDER_ID, contentId, (0, _extends3.default)({}, _playerParams2.default, {
          initialTime: playheadTime,
          autoplay: true
        })) }, function () {
        _this.state.popOutPlayer.mb.subscribe(_PlayerEventNames.VIDEO_FINISHED, '', _this.dismissPlayer);
        _this.state.popOutPlayer.mb.subscribe(_PlayerEventNames.PLAYBACK_READY, '', _this.onPlaybackReady);
      });
    }, _this.dismissPlayer = function () {
      if (!_this.state.popOutPlayer || !_this.interactivePlayer) {
        return;
      }

      _this.interactivePlayer.setPopOutState(false).then(function () {
        _this.state.popOutPlayer.destroy();
        _this.setState({ popOutPlayer: undefined });
      });
      _this.state.popOutPlayer.pause();
    }, _this.setInteractivePlayer = function (ref) {
      _this.interactivePlayer = ref;
    }, _this.returnToArticle = function () {
      if (!_this.state.articleUrl) {
        return;
      }

      _this.onReturnToArticle = _this.dismissPlayer;
      _this.props.router.push(_this.state.articleUrl);
    }, _this.onRouteChange = function (event) {
      if (event.pathname === _this.state.articleUrl) {
        _this.onReturnToArticle && _this.onReturnToArticle();
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PopOutPlayer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.router.listen(this.onRouteChange);
      window.addEventListener(_withPlayerManager.PLAYER_WAS_STARTED, this.dismissPlayer);
      window.addEventListener(LOAD_POP_OUT_PLAYER_EVENT, this.handleLoadPopOutPlayer);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener(LOAD_POP_OUT_PLAYER_EVENT, this.handleLoadPopOutPlayer);
      window.removeEventListener(_withPlayerManager.PLAYER_WAS_STARTED, this.dismissPlayer);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _InteractivePlayerContainer2.default,
        {
          ref: this.setInteractivePlayer,
          dismissPlayer: this.dismissPlayer,
          player: this.state.popOutPlayer,
          articleUrl: this.state.articleUrl,
          onMobilePopOutPress: this.returnToArticle
        },
        _react2.default.createElement('div', { id: POP_OUT_PLAYER_PLACEHOLDER_ID })
      );
    }
  }]);
  return PopOutPlayer;
}(_react2.default.Component);

PopOutPlayer.propTypes = {
  router: _propTypes2.default.shape({
    listen: _propTypes2.default.func,
    push: _propTypes2.default.func
  })
};

var loadToGlobalPlayer = exports.loadToGlobalPlayer = function loadToGlobalPlayer(player, articleUrl) {
  var event = new CustomEvent(LOAD_POP_OUT_PLAYER_EVENT, {
    detail: { player: player, articleUrl: articleUrl }
  });

  window.dispatchEvent(event);
};

exports.default = (0, _withErrorBoundry2.default)((0, _reactRouter.withRouter)(PopOutPlayer));

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _env = __webpack_require__(197);

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  pcode: _env2.default.OOYALA_PCODE || 'lham0yOhn5VvLeBHrySRvf4ruRyC',
  playerBrandingId: _env2.default.OOYALA_BRANDING_ID || '8bcc8b5507b349b8b13d153891e44c60',
  autoplay: false,
  loop: false,
  skin: {
    config: "/ooyala-skin/assets/spl-skin.json"
  }
};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.playerManagerFactory = exports.PLAYER_WAS_STARTED = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(306);

var _entries2 = _interopRequireDefault(_entries);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _playerEventsTracker = __webpack_require__(1026);

var _playerEventsTracker2 = _interopRequireDefault(_playerEventsTracker);

var _playerParams = __webpack_require__(436);

var _playerParams2 = _interopRequireDefault(_playerParams);

var _OoyalaApiClient = __webpack_require__(272);

var _OoyalaApiClient2 = _interopRequireDefault(_OoyalaApiClient);

var _PlayerEventNames = __webpack_require__(273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PLAYER_WAS_STARTED = exports.PLAYER_WAS_STARTED = "SPL_PLAYER_WAS_STARTED";

var playerManagerFactory = exports.playerManagerFactory = function playerManagerFactory(playersMap, apiClient) {
  return function (WrappedComponent) {
    var _class, _temp2;

    return _temp2 = _class = function (_React$Component) {
      (0, _inherits3.default)(_class, _React$Component);

      function _class() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, _class);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(args))), _this), _this.stopOtherPlayers = function (containerId) {
          (0, _entries2.default)(playersMap).filter(function (_ref2) {
            var _ref3 = (0, _slicedToArray3.default)(_ref2, 1),
                key = _ref3[0];

            return key !== containerId;
          }).forEach(function (_ref4) {
            var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
                value = _ref5[1];

            value.player.pause();
          });
        }, _this.notifyPlayerIsPlaying = function (containerId) {
          return function () {
            var event = new CustomEvent("SPL_PLAYER_WAS_STARTED", {
              detail: { containerId: containerId }
            });

            window.dispatchEvent(event);
          };
        }, _this.createPlayer = function (containerId, contentId, ooyala) {
          if (!ooyala) {
            throw new Error("Can't create a player without reference to Ooyala plugin");
          }

          var createPlayer = new _promise2.default(function (resolve) {
            ooyala.ready(function () {
              var notifyPlayerIsPlaying = _this.notifyPlayerIsPlaying(containerId);
              var createdPlayer = ooyala.Player.create(containerId, contentId, _playerParams2.default);

              var playerMapEntry = {
                player: createdPlayer
              };

              playersMap[containerId] = playerMapEntry;

              createdPlayer.mb.subscribe(_PlayerEventNames.ALL_OOYALA_EVENTS, '', (0, _playerEventsTracker2.default)(_this.context));

              createdPlayer.mb.subscribe(_PlayerEventNames.VIDEO_HMTL_CREATED, '', function () {
                // Play inline on iphone instead of full screen
                var containerElement = document.getElementById(containerId);
                var videoElements = containerElement && containerElement.getElementsByTagName('video');
                if (videoElements && videoElements.length === 1) {
                  var videoElement = videoElements[0];
                  videoElement && videoElement.setAttribute("webkit-playsinline", true);
                  videoElement && videoElement.setAttribute("playsinline", true);
                }
              });

              createdPlayer.mb.subscribe(_PlayerEventNames.VIDEO_STARTED, '', function () {
                _this.stopOtherPlayers(containerId);
                notifyPlayerIsPlaying();
              });

              resolve(playerMapEntry);
            });
          });

          var fetchMetadata = new _promise2.default(function (resolve) {
            apiClient.getAsset(contentId).then(function (assetData) {
              resolve(assetData);
            }).catch(function (error) {
              console.log("Failed to fetch metadata for Ooyala content " + contentId, error);
              resolve({});
            });
          });

          return _promise2.default.all([createPlayer, fetchMetadata]).then(function (_ref6) {
            var _ref7 = (0, _slicedToArray3.default)(_ref6, 2),
                player = _ref7[0],
                metadata = _ref7[1];

            return (0, _extends3.default)({}, player, { metadata: metadata });
          });
        }, _this.removePlayer = function (containerId) {
          delete playersMap[containerId];
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
      }

      (0, _createClass3.default)(_class, [{
        key: "render",
        value: function render() {
          return _react2.default.createElement(WrappedComponent, (0, _extends3.default)({
            createPlayer: this.createPlayer,
            removePlayer: this.removePlayer
          }, this.props));
        }
      }]);
      return _class;
    }(_react2.default.Component), _class.contextTypes = {
      metrics: _propTypes2.default.object
    }, _temp2;
  };
};

exports.default = playerManagerFactory({}, _OoyalaApiClient2.default);

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.setStatus = setStatus;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STATUS = 'server/STATUS';

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case STATUS:
      return (0, _extends3.default)({}, state, {
        status: action.status,
        message: action.message
      });
    default:
      return state;
  }
}

function setStatus(status, message) {
  return {
    type: STATUS,
    status: status,
    message: message
  };
}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(147);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get3 = __webpack_require__(233);

var _get4 = _interopRequireDefault(_get3);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AnalyticsApi2 = __webpack_require__(274);

var _AnalyticsApi3 = _interopRequireDefault(_AnalyticsApi2);

var _AnalyticsUtils = __webpack_require__(63);

var _reactHelmet = __webpack_require__(156);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _omniture = __webpack_require__(375);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OmnitureAnalytics = function (_AnalyticsApi) {
  (0, _inherits3.default)(OmnitureAnalytics, _AnalyticsApi);

  function OmnitureAnalytics(options, store) {
    (0, _classCallCheck3.default)(this, OmnitureAnalytics);

    var _this = (0, _possibleConstructorReturn3.default)(this, (OmnitureAnalytics.__proto__ || (0, _getPrototypeOf2.default)(OmnitureAnalytics)).call(this, "Omniture", "omniture", options));

    _this.getState = store.getState;
    _this.dispatch = store.dispatch;

    if (typeof window !== 'undefined' && window.s_gi) {
      var s = _this.s = window.s_gi(options.suite);

      s.trackingServer = 'metrics.sky.com';
      s.trackingServerSecure = 'smetrics.sky.com';
      /* You may add or alter any code config here. */
      /* Link Tracking Config */
      s.trackDownloadLinks = false;
      s.trackExternalLinks = true;
      s.trackInlineStats = true;
      s.linkInternalFilters = 'javascript:,' + window.location.hostname;
      s.linkLeaveQueryString = false;
      s.linkTrackVars = "None";
      s.linkTrackEvents = "None";
      s.server = window.location.hostname;
    }
    return _this;
  }

  (0, _createClass3.default)(OmnitureAnalytics, [{
    key: 'isSetUp',
    value: function isSetUp() {
      return !!this.s;
    }
  }, {
    key: 'pageView',
    value: function pageView() {
      var _get2;

      var _Helmet$peek = _reactHelmet2.default.peek(),
          _Helmet$peek$title = _Helmet$peek.title,
          pageTitle = _Helmet$peek$title === undefined ? '' : _Helmet$peek$title;

      this.s.pageName = pageTitle;

      var path = window.location.pathname.substr(1);
      var paths = path.split("/");
      var pathsLen = paths.length;

      this.s.prop25 = '';
      this.s.prop27 = '';
      this.s.prop31 = '';

      if (pathsLen > 0) {
        this.s.prop25 = paths[0];
        this.s.channel = paths[0] || 'home';
      }
      if (pathsLen > 1) {
        this.s.prop27 = paths[0] + '/' + paths[1];
      }
      if (pathsLen > 2) {
        this.s.prop31 = path;
      }

      this.s.prop9 = window.location.href;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = (0, _get4.default)(OmnitureAnalytics.prototype.__proto__ || (0, _getPrototypeOf2.default)(OmnitureAnalytics.prototype), 'pageView', this)).call.apply(_get2, [this].concat(args));
    }
  }, {
    key: 'permanentEvars',
    value: function permanentEvars() {
      var _getState = this.getState(),
          _getState$common = _getState.common;

      _getState$common = _getState$common === undefined ? {} : _getState$common;
      var _getState$common$auth = _getState$common.auth;
      _getState$common$auth = _getState$common$auth === undefined ? {} : _getState$common$auth;
      var _getState$common$auth2 = _getState$common$auth.loggedIn,
          loggedIn = _getState$common$auth2 === undefined ? false : _getState$common$auth2,
          _getState$common$omni = _getState$common.omniture;
      _getState$common$omni = _getState$common$omni === undefined ? {} : _getState$common$omni;
      var _getState$common$omni2 = _getState$common$omni.eVar57,
          eVar57 = _getState$common$omni2 === undefined ? 'site' : _getState$common$omni2,
          _getState$common$cana = _getState$common.canary;
      _getState$common$cana = _getState$common$cana === undefined ? {} : _getState$common$cana;
      var _getState$common$cana2 = _getState$common$cana.bucketId,
          bucketId = _getState$common$cana2 === undefined ? "" : _getState$common$cana2;


      return {
        eVar11: loggedIn ? 'logged-in' : 'not logged-in',
        eVar57: eVar57,
        eVar37: bucketId
      };
    }
  }, {
    key: 'permanentProps',
    value: function permanentProps() {
      var _getState2 = this.getState(),
          _getState2$common = _getState2.common;

      _getState2$common = _getState2$common === undefined ? {} : _getState2$common;
      var _getState2$common$omn = _getState2$common.omniture;
      _getState2$common$omn = _getState2$common$omn === undefined ? {} : _getState2$common$omn;
      var _getState2$common$omn2 = _getState2$common$omn.prop45,
          prop45 = _getState2$common$omn2 === undefined ? '' : _getState2$common$omn2,
          _getState2$common$omn3 = _getState2$common$omn.prop47,
          prop47 = _getState2$common$omn3 === undefined ? '' : _getState2$common$omn3;


      return {
        prop45: prop45,
        prop47: prop47
      };
    }
  }, {
    key: 'transformParams',
    value: function transformParams(params, map) {
      var _map$events = map.events,
          events = _map$events === undefined ? [] : _map$events,
          evars = map.evars,
          props = map.props;


      return {
        events: events,
        evars: evars ? (0, _AnalyticsUtils.transformPlainParams)(params, evars) : {},
        props: props ? (0, _AnalyticsUtils.transformPlainParams)(params, props) : {}
      };
    }
  }, {
    key: 'sendTracking',
    value: function sendTracking(name, _ref, _ref2) {
      var _ref$events = _ref.events,
          events = _ref$events === undefined ? [] : _ref$events,
          _ref$evars = _ref.evars,
          evars = _ref$evars === undefined ? {} : _ref$evars,
          _ref$props = _ref.props,
          props = _ref$props === undefined ? {} : _ref$props;
      var _ref2$isPage = _ref2.isPage,
          isPage = _ref2$isPage === undefined ? false : _ref2$isPage;


      this.checkForQueryStrings();

      evars = (0, _extends3.default)({}, this.permanentEvars(), evars);
      props = (0, _extends3.default)({}, this.permanentProps(), props);

      var trackVars = [].concat((0, _toConsumableArray3.default)((0, _keys2.default)(evars)), (0, _toConsumableArray3.default)((0, _keys2.default)(props)), ['events']);

      this.setOmnitureVars(trackVars, events);

      if (isPage) {
        this.trackPage(evars, props, events);
      } else {
        this.trackLink(evars, props, name);
      }

      this.resetOmnitureVars();
    }
  }, {
    key: 'trackPage',
    value: function trackPage(evars, props, events) {
      this.s.t((0, _extends3.default)({}, evars, props, {
        events: events.join()
      }));
    }
  }, {
    key: 'trackLink',
    value: function trackLink(evars, props, name) {
      this.s.tl(true, // prevent Omniture click delay
      'o', // custom link
      name, (0, _extends3.default)({}, evars, props), false // disable forced link tracking
      );
    }
  }, {
    key: 'getQueryStringValue',
    value: function getQueryStringValue() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var _getState3 = this.getState(),
          _getState3$common = _getState3.common;

      _getState3$common = _getState3$common === undefined ? {} : _getState3$common;
      var _getState3$common$que = _getState3$common.queryParams,
          queryParams = _getState3$common$que === undefined ? {} : _getState3$common$que;

      // Get a shallow copy whose keys are all lower case, so that case insensitive comparison can be made

      var lowerCaseQueryParams = (0, _keys2.default)(queryParams).reduce(function (l, p) {
        return (0, _assign2.default)(l, (0, _defineProperty3.default)({}, p.toLowerCase(), queryParams[p]));
      }, {});

      // Destructure using lower case key, so that case insensitive comparison is made
      var qsValue = lowerCaseQueryParams[key.toLowerCase()];


      return qsValue;
    }
  }, {
    key: 'dispatchQueryStringVar',
    value: function dispatchQueryStringVar() {
      var qsKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var _this2 = this;

      var omnitureVar = arguments[1];
      var acc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '-';

      var qsVal = qsKey.map(function (o) {
        return _this2.getQueryStringValue(o);
      }).filter(function (o) {
        return !!o;
      }).join(acc);
      if (qsVal) {
        this.dispatch((0, _omniture.trackVar)(omnitureVar, qsVal));
      }
    }
  }, {
    key: 'checkForQueryStrings',
    value: function checkForQueryStrings() {
      this.dispatchQueryStringVar(['DCMP'], 'prop45');
      this.dispatchQueryStringVar(['aff'], 'prop47');
      this.dispatchQueryStringVar(['app', 'version'], 'eVar57');
    }
  }, {
    key: 'setOmnitureVars',
    value: function setOmnitureVars(vars, events) {
      this.s.linkTrackVars = vars.join();
      this.s.linkTrackEvents = events.join();
      this.s.events = events.join();
    }
  }, {
    key: 'resetOmnitureVars',
    value: function resetOmnitureVars() {
      this.s.linkTrackVars = "";
      this.s.linkTrackEvents = "";
      this.s.events = "";
    }
  }]);
  return OmnitureAnalytics;
}(_AnalyticsApi3.default);

exports.default = OmnitureAnalytics;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.watchMediaQuery = watchMediaQuery;

var _commonUtils = __webpack_require__(36);

/*

Use watchMediaQuery to attach event handlers the window changing it's size (and entering or leaving a medai quiry's matching state)

You need to attach in componentDidMount, and remove in componentWillUnmount or there will be a memory leak (at best) and probably errors.

watchMediaQuery returns a function that will unattach the listener.

e.g.

class Bob extends Component {
  constructor(...a) {
    super(...a);
    this.unwatchTablet = () => {}; // initial noop
  }

  componentDidMount() {
    this.unwatchTablet = watchMediaQuery("tablet", match => {
      console.log(`tablet ${match? "matches", "doesn't match"}`)
    });
  }

  componentWillUnmount() {
    this.unwatchTablet();
  }
}

*/
var mediaVars = (0, _commonUtils.globalCssExports)("media");

function watchMediaQuery(query, watcher) {
  var handler = function handler(e) {
    return watcher(e.matches);
  };

  var mediaQuery = mediaVars[query] || query;
  var matcher = window.matchMedia(mediaQuery);

  matcher.addListener(handler);
  handler(matcher);

  return function () {
    return matcher.removeListener(handler);
  };
}

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getStickyMenu = getStickyMenu;
exports.showMenu = showMenu;
var STICKY_MENU_ID = "#stickyMenu";

function getStickyMenu() {
    return document.querySelector(STICKY_MENU_ID);
}

function showMenu() {
    var stickyMenu = getStickyMenu();
    var menuStyle = stickyMenu.style;
    var menuClasses = stickyMenu.classList;
    menuStyle.top = 0;
    menuClasses.add("stuckToScreen");

    if (!menuClasses.contains("fadeIn")) {
        menuClasses.add("fadeIn");
    }
}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getMetricsConfig;

var _SbgSignalAnalytics = __webpack_require__(1053);

var _SbgSignalAnalytics2 = _interopRequireDefault(_SbgSignalAnalytics);

var _GoogleAnalytics = __webpack_require__(275);

var _GoogleAnalytics2 = _interopRequireDefault(_GoogleAnalytics);

var _OmnitureAnalytics = __webpack_require__(439);

var _OmnitureAnalytics2 = _interopRequireDefault(_OmnitureAnalytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMetricsConfig(store, config) {
  var _config$metricsVendor = config.metricsVendors,
      signal = _config$metricsVendor.signal,
      google = _config$metricsVendor.google,
      omniture = _config$metricsVendor.omniture;


  return {
    vendors: [getVendor(signal, _SbgSignalAnalytics2.default, store), getVendor(google, _GoogleAnalytics2.default), getVendor(omniture, _OmnitureAnalytics2.default, store)],
    pageDefaults: function pageDefaults(routeState) {
      var paths = routeState.pathname.substr(1).split("/");
      var timestamp = new Date();

      return {
        timestamp: timestamp,
        build: 1,
        siteName: "sptlfe-dev",
        category: !paths[0] ? "landing" : paths[0]
      };
    },
    pageViewEvent: "pageView"
  };
}

function getVendor(vendorConfig, apiClass) {
  var store = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var vendorSetup = vendorConfig.setup;
  return { name: vendorConfig.name, api: new apiClass(vendorSetup, store) };
}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = parse;
exports.init = init;
function parse(el) {
  var _global = global,
      _global$twttr = _global.twttr;
  _global$twttr = _global$twttr === undefined ? {} : _global$twttr;
  var _global$twttr$widgets = _global$twttr.widgets,
      widgets = _global$twttr$widgets === undefined ? {} : _global$twttr$widgets;


  if (widgets.load) {
    widgets.load(el);
  }
}

function init() {
  // disable eslint - this is Twitter provided code - https://dev.twitter.com/web/javascript/loading
  /* eslint-disable */
  window.twttr = function (d, s, id) {
    var js,
        fjs = d.getElementsByTagName(s)[0],
        t = window.twttr || {};
    if (d.getElementById(id)) return t;
    js = d.createElement(s);
    js.id = id;
    js.src = "https://platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);

    t._e = [];
    t.ready = function (f) {
      t._e.push(f);
    };

    return t;
  }(document, "script", "twitter-wjs");
  /* eslint-enable */
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(132);

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = __webpack_require__(180);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Root reference for iframes.
 */

var root = void 0;
if (typeof window !== 'undefined') {
  // Browser window
  root = window;
} else if (typeof self !== 'undefined') {
  // Web Worker
  root = self;
} else {
  // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = undefined;
}

var Emitter = __webpack_require__(1340);
var RequestBase = __webpack_require__(1060);
var isObject = __webpack_require__(445);
var ResponseBase = __webpack_require__(1061);
var Agent = __webpack_require__(1059);

/**
 * Noop.
 */

function noop() {};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function (method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
};

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest && (!root.location || 'file:' != root.location.protocol || !root.ActiveXObject)) {
    return new XMLHttpRequest();
  } else {
    try {
      return new ActiveXObject('Microsoft.XMLHTTP');
    } catch (e) {}
    try {
      return new ActiveXObject('Msxml2.XMLHTTP.6.0');
    } catch (e) {}
    try {
      return new ActiveXObject('Msxml2.XMLHTTP.3.0');
    } catch (e) {}
    try {
      return new ActiveXObject('Msxml2.XMLHTTP');
    } catch (e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim ? function (s) {
  return s.trim();
} : function (s) {
  return s.replace(/(^\s*|\s*$)/g, '');
};

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function (v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for (var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair = void 0;
  var pos = void 0;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': _stringify2.default
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index = void 0;
  var line = void 0;
  var field = void 0;
  var val = void 0;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) {
      // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return (/[\/+]json($|[^-\w])/.test(mime)
  );
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = this.req.method != 'HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text') || typeof this.xhr.responseType === 'undefined' ? this.xhr.responseText : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD' ? this._parseBody(this.text ? this.text : this.xhr.response) : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function (str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object) ? parse(str) : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function () {
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function () {
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch (e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err = void 0;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch (custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function (type) {
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function (type) {
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function (user, pass, options) {
  if (1 === arguments.length) pass = '';
  if ((typeof pass === 'undefined' ? 'undefined' : (0, _typeof3.default)(pass)) === 'object' && pass !== null) {
    // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto'
    };
  }

  var encoder = function encoder(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function (val) {
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function (field, file, options) {
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function () {
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function (err, res) {
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function () {
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function () {
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function () {
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj)) && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
};

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function (fn) {
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  this._end();
};

Request.prototype._end = function () {
  if (this._aborted) return this.callback(Error("The request has been aborted even before .end() was called"));

  var self = this;
  var xhr = this.xhr = request.getXHR();
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function () {
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status = void 0;
    try {
      status = xhr.status;
    } catch (e) {
      status = 0;
    }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function handleProgress(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch (e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var _serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!_serialize && isJSON(contentType)) {
      _serialize = request.serialize['application/json'];
    }
    if (_serialize) data = _serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field)) xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
};

request.agent = function () {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function (method) {
  Agent.prototype[method.toLowerCase()] = function (url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function (url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function (url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function (url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function (url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function (url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function (url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) fn = data, data = null;
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

var _typeof2 = __webpack_require__(132);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isObject(obj) {
  return null !== obj && 'object' === (typeof obj === 'undefined' ? 'undefined' : (0, _typeof3.default)(obj));
}

module.exports = isObject;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(73);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(45);
var toAbsoluteIndex = __webpack_require__(130);
var toLength = __webpack_require__(41);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(122);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(49);
var toObject = __webpack_require__(45);
var IObject = __webpack_require__(178);
var toLength = __webpack_require__(41);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(49);
var isObject = __webpack_require__(26);
var invoke = __webpack_require__(456);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(40).f;
var create = __webpack_require__(124);
var redefineAll = __webpack_require__(128);
var ctx = __webpack_require__(74);
var anInstance = __webpack_require__(121);
var forOf = __webpack_require__(122);
var $iterDefine = __webpack_require__(288);
var step = __webpack_require__(459);
var setSpecies = __webpack_require__(129);
var DESCRIPTORS = __webpack_require__(39);
var fastKey = __webpack_require__(104).fastKey;
var validate = __webpack_require__(145);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(177);
var from = __webpack_require__(448);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(128);
var getWeak = __webpack_require__(104).getWeak;
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(26);
var anInstance = __webpack_require__(121);
var forOf = __webpack_require__(122);
var createArrayMethod = __webpack_require__(81);
var $has = __webpack_require__(55);
var validate = __webpack_require__(145);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(223);
var isObject = __webpack_require__(26);
var toLength = __webpack_require__(41);
var ctx = __webpack_require__(74);
var IS_CONCAT_SPREADABLE = __webpack_require__(33)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(39) && !__webpack_require__(25)(function () {
  return Object.defineProperty(__webpack_require__(281)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 456 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(26);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(16);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(290);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 461 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 462 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(126);
var gOPS = __webpack_require__(227);
var pIE = __webpack_require__(179);
var toObject = __webpack_require__(45);
var IObject = __webpack_require__(178);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(25)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(40);
var anObject = __webpack_require__(16);
var getKeys = __webpack_require__(126);

module.exports = __webpack_require__(39) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(68);
var gOPN = __webpack_require__(125).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(55);
var toIObject = __webpack_require__(68);
var arrayIndexOf = __webpack_require__(219)(false);
var IE_PROTO = __webpack_require__(294)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(126);
var toIObject = __webpack_require__(68);
var isEnum = __webpack_require__(179).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(125);
var gOPS = __webpack_require__(227);
var anObject = __webpack_require__(16);
var Reflect = __webpack_require__(19).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(19).parseFloat;
var $trim = __webpack_require__(144).trim;

module.exports = 1 / $parseFloat(__webpack_require__(298) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(19).parseInt;
var $trim = __webpack_require__(144).trim;
var ws = __webpack_require__(298);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var isObject = __webpack_require__(26);
var newPromiseCapability = __webpack_require__(292);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(41);
var repeat = __webpack_require__(297);
var defined = __webpack_require__(83);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(85);
var toLength = __webpack_require__(41);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(33);


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(451);
var validate = __webpack_require__(145);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(220)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(39) && /./g.flags != 'g') __webpack_require__(40).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(222)
});


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(451);
var validate = __webpack_require__(145);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(220)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(81)(0);
var redefine = __webpack_require__(57);
var meta = __webpack_require__(104);
var assign = __webpack_require__(463);
var weak = __webpack_require__(453);
var isObject = __webpack_require__(26);
var fails = __webpack_require__(25);
var validate = __webpack_require__(145);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(220)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1273), __esModule: true };

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1289), __esModule: true };

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(77).f;
var create = __webpack_require__(236);
var redefineAll = __webpack_require__(318);
var ctx = __webpack_require__(96);
var anInstance = __webpack_require__(307);
var forOf = __webpack_require__(184);
var $iterDefine = __webpack_require__(312);
var step = __webpack_require__(491);
var setSpecies = __webpack_require__(501);
var DESCRIPTORS = __webpack_require__(88);
var fastKey = __webpack_require__(313).fastKey;
var validate = __webpack_require__(323);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(234);
var from = __webpack_require__(1293);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(53);
var $export = __webpack_require__(42);
var meta = __webpack_require__(313);
var fails = __webpack_require__(133);
var hide = __webpack_require__(105);
var redefineAll = __webpack_require__(318);
var forOf = __webpack_require__(184);
var anInstance = __webpack_require__(307);
var isObject = __webpack_require__(76);
var setToStringTag = __webpack_require__(187);
var dP = __webpack_require__(77).f;
var each = __webpack_require__(1295)(0);
var DESCRIPTORS = __webpack_require__(88);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(53).document;
module.exports = document && document.documentElement;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(88) && !__webpack_require__(133)(function () {
  return Object.defineProperty(__webpack_require__(309)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(149);
var ITERATOR = __webpack_require__(50)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(183);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(87);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(50)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(494);
var hiddenKeys = __webpack_require__(310).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(134);
var toObject = __webpack_require__(151);
var IE_PROTO = __webpack_require__(319)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(134);
var toIObject = __webpack_require__(106);
var arrayIndexOf = __webpack_require__(1294)(false);
var IE_PROTO = __webpack_require__(319)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(150);
var toIObject = __webpack_require__(106);
var isEnum = __webpack_require__(185).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(87);
var isObject = __webpack_require__(76);
var newPromiseCapability = __webpack_require__(314);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(105);


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(42);
var aFunction = __webpack_require__(182);
var ctx = __webpack_require__(96);
var forOf = __webpack_require__(184);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(42);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(53);
var core = __webpack_require__(34);
var dP = __webpack_require__(77);
var DESCRIPTORS = __webpack_require__(88);
var SPECIES = __webpack_require__(50)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(87);
var aFunction = __webpack_require__(182);
var SPECIES = __webpack_require__(50)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(96);
var invoke = __webpack_require__(1300);
var html = __webpack_require__(485);
var cel = __webpack_require__(309);
var global = __webpack_require__(53);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(183)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

var once = __webpack_require__(1532);

var noop = function() {};

var isRequest = function(stream) {
	return stream.setHeader && typeof stream.abort === 'function';
};

var isChildProcess = function(stream) {
	return stream.stdio && Array.isArray(stream.stdio) && stream.stdio.length === 3
};

var eos = function(stream, opts, callback) {
	if (typeof opts === 'function') return eos(stream, null, opts);
	if (!opts) opts = {};

	callback = once(callback || noop);

	var ws = stream._writableState;
	var rs = stream._readableState;
	var readable = opts.readable || (opts.readable !== false && stream.readable);
	var writable = opts.writable || (opts.writable !== false && stream.writable);

	var onlegacyfinish = function() {
		if (!stream.writable) onfinish();
	};

	var onfinish = function() {
		writable = false;
		if (!readable) callback.call(stream);
	};

	var onend = function() {
		readable = false;
		if (!writable) callback.call(stream);
	};

	var onexit = function(exitCode) {
		callback.call(stream, exitCode ? new Error('exited with error code: ' + exitCode) : null);
	};

	var onerror = function(err) {
		callback.call(stream, err);
	};

	var onclose = function() {
		if (readable && !(rs && rs.ended)) return callback.call(stream, new Error('premature close'));
		if (writable && !(ws && ws.ended)) return callback.call(stream, new Error('premature close'));
	};

	var onrequest = function() {
		stream.req.on('finish', onfinish);
	};

	if (isRequest(stream)) {
		stream.on('complete', onfinish);
		stream.on('abort', onclose);
		if (stream.req) onrequest();
		else stream.on('request', onrequest);
	} else if (writable && !ws) { // legacy streams
		stream.on('end', onlegacyfinish);
		stream.on('close', onlegacyfinish);
	}

	if (isChildProcess(stream)) stream.on('exit', onexit);

	stream.on('end', onend);
	stream.on('finish', onfinish);
	if (opts.error !== false) stream.on('error', onerror);
	stream.on('close', onclose);

	return function() {
		stream.removeListener('complete', onfinish);
		stream.removeListener('abort', onclose);
		stream.removeListener('request', onrequest);
		if (stream.req) stream.req.removeListener('finish', onfinish);
		stream.removeListener('end', onlegacyfinish);
		stream.removeListener('close', onlegacyfinish);
		stream.removeListener('finish', onfinish);
		stream.removeListener('exit', onexit);
		stream.removeListener('end', onend);
		stream.removeListener('error', onerror);
		stream.removeListener('close', onclose);
	};
};

module.exports = eos;


/***/ }),
/* 506 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\"","newsSectionImageSizes-sectionArticle":"(max-width: 319px) 85.33333px, (max-width: 674px) 26.66667vw, (max-width: 1019px) 26.66667vw, (min-width: 1020px) 189.33333px"};

/***/ }),
/* 507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\"","tipsSectionImageSizes-tipArticle":"(max-width: 319px) 122.66667px, (max-width: 674px) 38.33333vw, (max-width: 1019px) 38.33333vw, (min-width: 1020px) 118.83333px"};

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\"","tipsWidgetImageSizes-tipWidget":"(max-width: 674px) 300px, (min-width: 675px) 337px","tipsWidgetImageSizes-tipWidgetLarge":"(max-width: 674px) 300px, (min-width: 675px) 289px"};

/***/ }),
/* 509 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 510 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 512 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 513 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\"","articlePageImageSizes-articlePage":"(max-width: 319px) 320px, (max-width: 674px) 100vw, (max-width: 1019px) 100vw, (min-width: 1020px) 710px"};

/***/ }),
/* 515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\"","moreNewsImageSizes-leadArticle":"(max-width: 319px) 320px, (max-width: 674px) 100vw, (max-width: 1019px) 55vw, (min-width: 1020px) 390.5px","moreNewsImageSizes-secondaryArticle":"(max-width: 319px) 160px, (max-width: 674px) 50vw, (max-width: 1019px) 50vw, (min-width: 1020px) 355px","moreNewsImageSizes-otherArticle":"(max-width: 319px) 160px, (max-width: 674px) 50vw, (max-width: 1019px) 33.33333vw, (min-width: 1020px) 236.66667px"};

/***/ }),
/* 516 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(240);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 518 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(1495);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(527);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(522);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(712)(module)))

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(137);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(1504);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(712)(module)))

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/* harmony default export */ __webpack_exports__["a"] = (isNil);


/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(525);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(1516);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var af = moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            ss : '%d sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;

})));


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arDz = moment.defineLocale('ar-dz', {
        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arDz;

})));


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arKw = moment.defineLocale('ar-kw', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arKw;

})));


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var arLy = moment.defineLocale('ar-ly', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arLy;

})));


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arMa = moment.defineLocale('ar-ma', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arMa;

})));


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return arSa;

})));


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss : '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;

})));


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var ar = moment.defineLocale('ar', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ar;

})));


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[sabah saat] LT',
            nextWeek : '[gələn həftə] dddd [saat] LT',
            lastDay : '[dünən] LT',
            lastWeek : '[keçən həftə] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s əvvəl',
            s : 'birneçə saniyə',
            ss : '%d saniyə',
            m : 'bir dəqiqə',
            mm : '%d dəqiqə',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir il',
            yy : '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM : function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return az;

})));


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months : {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays : {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'праз %s',
            past : '%s таму',
            s : 'некалькі секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithPlural,
            hh : relativeTimeWithPlural,
            d : 'дзень',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM : function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return be;

})));


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bg = moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bg;

})));


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bm = moment.defineLocale('bm', {
        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'MMMM [tile] D [san] YYYY',
            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar : {
            sameDay : '[Bi lɛrɛ] LT',
            nextDay : '[Sini lɛrɛ] LT',
            nextWeek : 'dddd [don lɛrɛ] LT',
            lastDay : '[Kunu lɛrɛ] LT',
            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s kɔnɔ',
            past : 'a bɛ %s bɔ',
            s : 'sanga dama dama',
            ss : 'sekondi %d',
            m : 'miniti kelen',
            mm : 'miniti %d',
            h : 'lɛrɛ kelen',
            hh : 'lɛrɛ %d',
            d : 'tile kelen',
            dd : 'tile %d',
            M : 'kalo kelen',
            MM : 'kalo %d',
            y : 'san kelen',
            yy : 'san %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return bm;

})));


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            ss : '%d সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bn;

})));


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    },
    numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[དི་རིང] LT',
            nextDay : '[སང་ཉིན] LT',
            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay : '[ཁ་སང] LT',
            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ལ་',
            past : '%s སྔན་ལ',
            s : 'ལམ་སང',
            ss : '%d སྐར་ཆ།',
            m : 'སྐར་མ་གཅིག',
            mm : '%d སྐར་མ',
            h : 'ཆུ་ཚོད་གཅིག',
            hh : '%d ཆུ་ཚོད',
            d : 'ཉིན་གཅིག',
            dd : '%d ཉིན་',
            M : 'ཟླ་བ་གཅིག',
            MM : '%d ཟླ་བ',
            y : 'ལོ་གཅིག',
            yy : '%d ལོ'
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
                    meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bo;

})));


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h[e]mm A',
            LTS : 'h[e]mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [a viz] MMMM YYYY',
            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'a-benn %s',
            past : '%s \'zo',
            s : 'un nebeud segondennoù',
            ss : '%d eilenn',
            m : 'ur vunutenn',
            mm : relativeTimeWithMutation,
            h : 'un eur',
            hh : '%d eur',
            d : 'un devezh',
            dd : relativeTimeWithMutation,
            M : 'ur miz',
            MM : relativeTimeWithMutation,
            y : 'ur bloaz',
            yy : specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return br;

})));


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bs;

})));


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ca = moment.defineLocale('ca', {
        months : {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [de] YYYY',
            ll : 'D MMM YYYY',
            LLL : 'D MMMM [de] YYYY [a les] H:mm',
            lll : 'D MMM YYYY, H:mm',
            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll : 'ddd D MMM YYYY, H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'd\'aquí %s',
            past : 'fa %s',
            s : 'uns segons',
            ss : '%d segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;

})));


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');

    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

})));


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cv = moment.defineLocale('cv', {
        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past : '%s каялла',
            s : 'пӗр-ик ҫеккунт',
            ss : '%d ҫеккунт',
            m : 'пӗр минут',
            mm : '%d минут',
            h : 'пӗр сехет',
            hh : '%d сехет',
            d : 'пӗр кун',
            dd : '%d кун',
            M : 'пӗр уйӑх',
            MM : '%d уйӑх',
            y : 'пӗр ҫул',
            yy : '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal : '%d-мӗш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return cv;

})));


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;

})));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

})));


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;

})));


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;

})));


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު'
    ], weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު'
    ];

    var dv = moment.defineLocale('dv', {
        months : months,
        monthsShort : months,
        weekdays : weekdays,
        weekdaysShort : weekdays,
        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat : {

            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/M/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM : function (input) {
            return 'މފ' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar : {
            sameDay : '[މިއަދު] LT',
            nextDay : '[މާދަމާ] LT',
            nextWeek : 'dddd LT',
            lastDay : '[އިއްޔެ] LT',
            lastWeek : '[ފާއިތުވި] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ތެރޭގައި %s',
            past : 'ކުރިން %s',
            s : 'ސިކުންތުކޮޅެއް',
            ss : 'd% ސިކުންތު',
            m : 'މިނިޓެއް',
            mm : 'މިނިޓު %d',
            h : 'ގަޑިއިރެއް',
            hh : 'ގަޑިއިރު %d',
            d : 'ދުވަހެއް',
            dd : 'ދުވަސް %d',
            M : 'މަހެއް',
            MM : 'މަސް %d',
            y : 'އަހަރެއް',
            yy : 'އަހަރު %d'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 7,  // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return dv;

})));


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }


    var el = moment.defineLocale('el', {
        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM : function (input) {
            return ((input + '').toLowerCase()[0] === 'μ');
        },
        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
        },
        relativeTime : {
            future : 'σε %s',
            past : '%s πριν',
            s : 'λίγα δευτερόλεπτα',
            ss : '%d δευτερόλεπτα',
            m : 'ένα λεπτό',
            mm : '%d λεπτά',
            h : 'μία ώρα',
            hh : '%d ώρες',
            d : 'μία μέρα',
            dd : '%d μέρες',
            M : 'ένας μήνας',
            MM : '%d μήνες',
            y : 'ένας χρόνος',
            yy : '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;

})));


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enSG = moment.defineLocale('en-SG', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enSG;

})));


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIe = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;

})));


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIl = moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;

})));


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enNz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;

})));


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eo = moment.defineLocale('eo', {
        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D[-a de] MMMM, YYYY',
            LLL : 'D[-a de] MMMM, YYYY HH:mm',
            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'post %s',
            past : 'antaŭ %s',
            s : 'sekundoj',
            ss : '%d sekundoj',
            m : 'minuto',
            mm : '%d minutoj',
            h : 'horo',
            hh : '%d horoj',
            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
            dd : '%d tagoj',
            M : 'monato',
            MM : '%d monatoj',
            y : 'jaro',
            yy : '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal : '%da',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eo;

})));


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'MM/DD/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return esUs;

})));


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'ss': [number + 'sekundi', number + 'sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat : {
            LT   : 'H:mm',
            LTS : 'H:mm:ss',
            L    : 'DD.MM.YYYY',
            LL   : 'D. MMMM YYYY',
            LLL  : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s pärast',
            past   : '%s tagasi',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : '%d päeva',
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;

})));


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eu = moment.defineLocale('eu', {
        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact : true,
        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY[ko] MMMM[ren] D[a]',
            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l : 'YYYY-M-D',
            ll : 'YYYY[ko] MMM D[a]',
            lll : 'YYYY[ko] MMM D[a] HH:mm',
            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s barru',
            past : 'duela %s',
            s : 'segundo batzuk',
            ss : '%d segundo',
            m : 'minutu bat',
            mm : '%d minutu',
            h : 'ordu bat',
            hh : '%d ordu',
            d : 'egun bat',
            dd : '%d egun',
            M : 'hilabete bat',
            MM : '%d hilabete',
            y : 'urte bat',
            yy : '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eu;

})));


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چند ثانیه',
            ss : 'ثانیه d%',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return fa;

})));


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

})));


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fo = moment.defineLocale('fo', {
        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'um %s',
            past : '%s síðani',
            s : 'fá sekund',
            ss : '%d sekundir',
            m : 'ein minuttur',
            mm : '%d minuttir',
            h : 'ein tími',
            hh : '%d tímar',
            d : 'ein dagur',
            dd : '%d dagar',
            M : 'ein mánaður',
            MM : '%d mánaðir',
            y : 'eitt ár',
            yy : '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;

})));


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCa = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;

})));


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCh = moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;

})));


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'oer %s',
            past : '%s lyn',
            s : 'in pear sekonden',
            ss : '%d sekonden',
            m : 'ien minút',
            mm : '%d minuten',
            h : 'ien oere',
            hh : '%d oeren',
            d : 'ien dei',
            dd : '%d dagen',
            M : 'ien moanne',
            MM : '%d moannen',
            y : 'ien jier',
            yy : '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;

})));


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



    var months = [
        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
    ];

    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];

    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];

    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];

    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné aig] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d mí',
            y: 'bliain',
            yy: '%d bliain'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ga;

})));


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
    ];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months : months,
        monthsShort : monthsShort,
        monthsParseExact : true,
        weekdays : weekdays,
        weekdaysShort : weekdaysShort,
        weekdaysMin : weekdaysMin,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[An-diugh aig] LT',
            nextDay : '[A-màireach aig] LT',
            nextWeek : 'dddd [aig] LT',
            lastDay : '[An-dè aig] LT',
            lastWeek : 'dddd [seo chaidh] [aig] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ann an %s',
            past : 'bho chionn %s',
            s : 'beagan diogan',
            ss : '%d diogan',
            m : 'mionaid',
            mm : '%d mionaidean',
            h : 'uair',
            hh : '%d uairean',
            d : 'latha',
            dd : '%d latha',
            M : 'mìos',
            MM : '%d mìosan',
            y : 'bliadhna',
            yy : '%d bliadhna'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
        ordinal : function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;

})));


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var gl = moment.defineLocale('gl', {
        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past : 'hai %s',
            s : 'uns segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'unha hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;

})));


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'ss': [number + ' secondanim', number + ' second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka voran', 'ek vor'],
            'hh': [number + ' voranim', number + ' voram'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'A h:mm [vazta]',
            LTS : 'A h:mm:ss [vazta]',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY A h:mm [vazta]',
            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar : {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s',
            past : '%s adim',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
        ordinal : function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;

})));


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
            '1': '૧',
            '2': '૨',
            '3': '૩',
            '4': '૪',
            '5': '૫',
            '6': '૬',
            '7': '૭',
            '8': '૮',
            '9': '૯',
            '0': '૦'
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0'
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return gu;

})));


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var he = moment.defineLocale('he', {
        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [ב]MMMM YYYY',
            LLL : 'D [ב]MMMM YYYY HH:mm',
            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
            l : 'D/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'בעוד %s',
            past : 'לפני %s',
            s : 'מספר שניות',
            ss : '%d שניות',
            m : 'דקה',
            mm : '%d דקות',
            h : 'שעה',
            hh : function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d : 'יום',
            dd : function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M : 'חודש',
            MM : function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y : 'שנה',
            yy : function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM : function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;

})));


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm बजे',
            LTS : 'A h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s में',
            past : '%s पहले',
            s : 'कुछ ही क्षण',
            ss : '%d सेकंड',
            m : 'एक मिनट',
            mm : '%d मिनट',
            h : 'एक घंटा',
            hh : '%d घंटे',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महीने',
            MM : '%d महीने',
            y : 'एक वर्ष',
            yy : '%d वर्ष'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return hi;

})));


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hr;

})));


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;

})));


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var hyAm = moment.defineLocale('hy-am', {
        months : {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY թ.',
            LLL : 'D MMMM YYYY թ., HH:mm',
            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s հետո',
            past : '%s առաջ',
            s : 'մի քանի վայրկյան',
            ss : '%d վայրկյան',
            m : 'րոպե',
            mm : '%d րոպե',
            h : 'ժամ',
            hh : '%d ժամ',
            d : 'օր',
            dd : '%d օր',
            M : 'ամիս',
            MM : '%d ամիս',
            y : 'տարի',
            yy : '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem : function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hyAm;

})));


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var id = moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            ss : '%d detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return id;

})));


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'eftir %s',
            past : 'fyrir %s síðan',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : 'klukkustund',
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;

})));


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var itCh = moment.defineLocale('it-ch', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return itCh;

})));


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

})));


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var jv = moment.defineLocale('jv', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar : {
            sameDay : '[Dinten puniko pukul] LT',
            nextDay : '[Mbenjang pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kala wingi pukul] LT',
            lastWeek : 'dddd [kepengker pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'wonten ing %s',
            past : '%s ingkang kepengker',
            s : 'sawetawis detik',
            ss : '%d detik',
            m : 'setunggal menit',
            mm : '%d menit',
            h : 'setunggal jam',
            hh : '%d jam',
            d : 'sedinten',
            dd : '%d dinten',
            M : 'sewulan',
            MM : '%d wulan',
            y : 'setaun',
            yy : '%d taun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return jv;

})));


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ka = moment.defineLocale('ka', {
        months : {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays : {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, 'ში') :
                    s + 'ში';
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
            },
            s : 'რამდენიმე წამი',
            ss : '%d წამი',
            m : 'წუთი',
            mm : '%d წუთი',
            h : 'საათი',
            hh : '%d საათი',
            d : 'დღე',
            dd : '%d დღე',
            M : 'თვე',
            MM : '%d თვე',
            y : 'წელი',
            yy : '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week : {
            dow : 1,
            doy : 7
        }
    });

    return ka;

})));


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгін сағат] LT',
            nextDay : '[Ертең сағат] LT',
            nextWeek : 'dddd [сағат] LT',
            lastDay : '[Кеше сағат] LT',
            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ішінде',
            past : '%s бұрын',
            s : 'бірнеше секунд',
            ss : '%d секунд',
            m : 'бір минут',
            mm : '%d минут',
            h : 'бір сағат',
            hh : '%d сағат',
            d : 'бір күн',
            dd : '%d күн',
            M : 'бір ай',
            MM : '%d ай',
            y : 'бір жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return kk;

})));


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '១',
        '2': '២',
        '3': '៣',
        '4': '៤',
        '5': '៥',
        '6': '៦',
        '7': '៧',
        '8': '៨',
        '9': '៩',
        '0': '០'
    }, numberMap = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
        ordinal : 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;

})));


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    },
    numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[ಇಂದು] LT',
            nextDay : '[ನಾಳೆ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ನಿನ್ನೆ] LT',
            lastWeek : '[ಕೊನೆಯ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ನಂತರ',
            past : '%s ಹಿಂದೆ',
            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss : '%d ಸೆಕೆಂಡುಗಳು',
            m : 'ಒಂದು ನಿಮಿಷ',
            mm : '%d ನಿಮಿಷ',
            h : 'ಒಂದು ಗಂಟೆ',
            hh : '%d ಗಂಟೆ',
            d : 'ಒಂದು ದಿನ',
            dd : '%d ದಿನ',
            M : 'ಒಂದು ತಿಂಗಳು',
            MM : '%d ತಿಂಗಳು',
            y : 'ಒಂದು ವರ್ಷ',
            yy : '%d ವರ್ಷ'
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal : function (number) {
            return number + 'ನೇ';
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return kn;

})));


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    },
    months = [
        'کانونی دووەم',
        'شوبات',
        'ئازار',
        'نیسان',
        'ئایار',
        'حوزەیران',
        'تەمموز',
        'ئاب',
        'ئەیلوول',
        'تشرینی یەكەم',
        'تشرینی دووەم',
        'كانونی یەکەم'
    ];


    var ku = moment.defineLocale('ku', {
        months : months,
        monthsShort : months,
        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar : {
            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
            nextDay : '[به‌یانی كاتژمێر] LT',
            nextWeek : 'dddd [كاتژمێر] LT',
            lastDay : '[دوێنێ كاتژمێر] LT',
            lastWeek : 'dddd [كاتژمێر] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'له‌ %s',
            past : '%s',
            s : 'چه‌ند چركه‌یه‌ك',
            ss : 'چركه‌ %d',
            m : 'یه‌ك خوله‌ك',
            mm : '%d خوله‌ك',
            h : 'یه‌ك كاتژمێر',
            hh : '%d كاتژمێر',
            d : 'یه‌ك ڕۆژ',
            dd : '%d ڕۆژ',
            M : 'یه‌ك مانگ',
            MM : '%d مانگ',
            y : 'یه‌ك ساڵ',
            yy : '%d ساڵ'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ku;

})));


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгүн саат] LT',
            nextDay : '[Эртең саат] LT',
            nextWeek : 'dddd [саат] LT',
            lastDay : '[Кечээ саат] LT',
            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ичинде',
            past : '%s мурун',
            s : 'бирнече секунд',
            ss : '%d секунд',
            m : 'бир мүнөт',
            mm : '%d мүнөт',
            h : 'бир саат',
            hh : '%d саат',
            d : 'бир күн',
            dd : '%d күн',
            M : 'бир ай',
            MM : '%d ай',
            y : 'бир жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ky;

})));


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime : {
            future : processFutureTime,
            past : processPastTime,
            s : 'e puer Sekonnen',
            ss : '%d Sekonnen',
            m : processRelativeTime,
            mm : '%d Minutten',
            h : processRelativeTime,
            hh : '%d Stonnen',
            d : processRelativeTime,
            dd : '%d Deeg',
            M : processRelativeTime,
            MM : '%d Méint',
            y : processRelativeTime,
            yy : '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;

})));


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var lo = moment.defineLocale('lo', {
        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar : {
            sameDay : '[ມື້ນີ້ເວລາ] LT',
            nextDay : '[ມື້ອື່ນເວລາ] LT',
            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ອີກ %s',
            past : '%sຜ່ານມາ',
            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss : '%d ວິນາທີ' ,
            m : '1 ນາທີ',
            mm : '%d ນາທີ',
            h : '1 ຊົ່ວໂມງ',
            hh : '%d ຊົ່ວໂມງ',
            d : '1 ມື້',
            dd : '%d ມື້',
            M : '1 ເດືອນ',
            MM : '%d ເດືອນ',
            y : '1 ປີ',
            yy : '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal : function (number) {
            return 'ທີ່' + number;
        }
    });

    return lo;

})));


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss' : 'sekundė_sekundžių_sekundes',
        'm' : 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h' : 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd' : 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M' : 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y' : 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months : {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays : {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY [m.] MMMM D [d.]',
            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l : 'YYYY-MM-DD',
            ll : 'YYYY [m.] MMMM D [d.]',
            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar : {
            sameDay : '[Šiandien] LT',
            nextDay : '[Rytoj] LT',
            nextWeek : 'dddd LT',
            lastDay : '[Vakar] LT',
            lastWeek : '[Praėjusį] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'po %s',
            past : 'prieš %s',
            s : translateSeconds,
            ss : translate,
            m : translateSingular,
            mm : translate,
            h : translateSingular,
            hh : translate,
            d : translateSingular,
            dd : translate,
            M : translateSingular,
            MM : translate,
            y : translateSingular,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;

})));


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY.',
            LL : 'YYYY. [gada] D. MMMM',
            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'pēc %s',
            past : 'pirms %s',
            s : relativeSeconds,
            ss : relativeTimeWithPlural,
            m : relativeTimeWithSingular,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithSingular,
            hh : relativeTimeWithPlural,
            d : relativeTimeWithSingular,
            dd : relativeTimeWithPlural,
            M : relativeTimeWithSingular,
            MM : relativeTimeWithPlural,
            y : relativeTimeWithSingular,
            yy : relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;

})));


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact : true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mjesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return me;

})));


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;

})));


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mk = moment.defineLocale('mk', {
        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : '[Во] dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'после %s',
            past : 'пред %s',
            s : 'неколку секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дена',
            M : 'месец',
            MM : '%d месеци',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return mk;

})));


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ml = moment.defineLocale('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm -നു',
            LTS : 'A h:mm:ss -നു',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm -നു',
            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s കഴിഞ്ഞ്',
            past : '%s മുൻപ്',
            s : 'അൽപ നിമിഷങ്ങൾ',
            ss : '%d സെക്കൻഡ്',
            m : 'ഒരു മിനിറ്റ്',
            mm : '%d മിനിറ്റ്',
            h : 'ഒരു മണിക്കൂർ',
            hh : '%d മണിക്കൂർ',
            d : 'ഒരു ദിവസം',
            dd : '%d ദിവസം',
            M : 'ഒരു മാസം',
            MM : '%d മാസം',
            y : 'ഒരു വർഷം',
            yy : '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'രാത്രി' && hour >= 4) ||
                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                    meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;

})));


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact : true,
        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY оны MMMMын D',
            LLL : 'YYYY оны MMMMын D HH:mm',
            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM : function (input) {
            return input === 'ҮХ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar : {
            sameDay : '[Өнөөдөр] LT',
            nextDay : '[Маргааш] LT',
            nextWeek : '[Ирэх] dddd LT',
            lastDay : '[Өчигдөр] LT',
            lastWeek : '[Өнгөрсөн] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s дараа',
            past : '%s өмнө',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    return mn;

})));


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture)
    {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's': output = 'काही सेकंद'; break;
                case 'ss': output = '%d सेकंद'; break;
                case 'm': output = 'एक मिनिट'; break;
                case 'mm': output = '%d मिनिटे'; break;
                case 'h': output = 'एक तास'; break;
                case 'hh': output = '%d तास'; break;
                case 'd': output = 'एक दिवस'; break;
                case 'dd': output = '%d दिवस'; break;
                case 'M': output = 'एक महिना'; break;
                case 'MM': output = '%d महिने'; break;
                case 'y': output = 'एक वर्ष'; break;
                case 'yy': output = '%d वर्षे'; break;
            }
        }
        else {
            switch (string) {
                case 's': output = 'काही सेकंदां'; break;
                case 'ss': output = '%d सेकंदां'; break;
                case 'm': output = 'एका मिनिटा'; break;
                case 'mm': output = '%d मिनिटां'; break;
                case 'h': output = 'एका तासा'; break;
                case 'hh': output = '%d तासां'; break;
                case 'd': output = 'एका दिवसा'; break;
                case 'dd': output = '%d दिवसां'; break;
                case 'M': output = 'एका महिन्या'; break;
                case 'MM': output = '%d महिन्यां'; break;
                case 'y': output = 'एका वर्षा'; break;
                case 'yy': output = '%d वर्षां'; break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact : true,
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm वाजता',
            LTS : 'A h:mm:ss वाजता',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm वाजता',
            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return mr;

})));


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var msMy = moment.defineLocale('ms-my', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return msMy;

})));


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ms = moment.defineLocale('ms', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ms;

})));


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mt = moment.defineLocale('mt', {
        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Illum fil-]LT',
            nextDay : '[Għada fil-]LT',
            nextWeek : 'dddd [fil-]LT',
            lastDay : '[Il-bieraħ fil-]LT',
            lastWeek : 'dddd [li għadda] [fil-]LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'f’ %s',
            past : '%s ilu',
            s : 'ftit sekondi',
            ss : '%d sekondi',
            m : 'minuta',
            mm : '%d minuti',
            h : 'siegħa',
            hh : '%d siegħat',
            d : 'ġurnata',
            dd : '%d ġranet',
            M : 'xahar',
            MM : '%d xhur',
            y : 'sena',
            yy : '%d sni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mt;

})));


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    }, numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss : '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return my;

})));


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nb = moment.defineLocale('nb', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'noen sekunder',
            ss : '%d sekunder',
            m : 'ett minutt',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dager',
            M : 'en måned',
            MM : '%d måneder',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;

})));


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact : true,
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'Aको h:mm बजे',
            LTS : 'Aको h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, Aको h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोलि] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sमा',
            past : '%s अगाडि',
            s : 'केही क्षण',
            ss : '%d सेकेण्ड',
            m : 'एक मिनेट',
            mm : '%d मिनेट',
            h : 'एक घण्टा',
            hh : '%d घण्टा',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महिना',
            MM : '%d महिना',
            y : 'एक बर्ष',
            yy : '%d बर्ष'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ne;

})));


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;

})));


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nn = moment.defineLocale('nn', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s sidan',
            s : 'nokre sekund',
            ss : '%d sekund',
            m : 'eit minutt',
            mm : '%d minutt',
            h : 'ein time',
            hh : '%d timar',
            d : 'ein dag',
            dd : '%d dagar',
            M : 'ein månad',
            MM : '%d månader',
            y : 'eit år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;

})));


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    },
    numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm ਵਜੇ',
            LTS : 'A h:mm:ss ਵਜੇ',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar : {
            sameDay : '[ਅਜ] LT',
            nextDay : '[ਕਲ] LT',
            nextWeek : '[ਅਗਲਾ] dddd, LT',
            lastDay : '[ਕਲ] LT',
            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ਵਿੱਚ',
            past : '%s ਪਿਛਲੇ',
            s : 'ਕੁਝ ਸਕਿੰਟ',
            ss : '%d ਸਕਿੰਟ',
            m : 'ਇਕ ਮਿੰਟ',
            mm : '%d ਮਿੰਟ',
            h : 'ਇੱਕ ਘੰਟਾ',
            hh : '%d ਘੰਟੇ',
            d : 'ਇੱਕ ਦਿਨ',
            dd : '%d ਦਿਨ',
            M : 'ਇੱਕ ਮਹੀਨਾ',
            MM : '%d ਮਹੀਨੇ',
            y : 'ਇੱਕ ਸਾਲ',
            yy : '%d ਸਾਲ'
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return paIn;

})));


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

})));


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var pt = moment.defineLocale('pt', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

})));


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                'ss': 'secunde',
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            ss : relativeTimeWithPlural,
            m : 'un minut',
            mm : relativeTimeWithPlural,
            h : 'o oră',
            hh : relativeTimeWithPlural,
            d : 'o zi',
            dd : relativeTimeWithPlural,
            M : 'o lună',
            MM : relativeTimeWithPlural,
            y : 'un an',
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ro;

})));


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., H:mm',
            LLLL : 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar : {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;

})));


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوري',
        'فيبروري',
        'مارچ',
        'اپريل',
        'مئي',
        'جون',
        'جولاءِ',
        'آگسٽ',
        'سيپٽمبر',
        'آڪٽوبر',
        'نومبر',
        'ڊسمبر'
    ];
    var days = [
        'آچر',
        'سومر',
        'اڱارو',
        'اربع',
        'خميس',
        'جمع',
        'ڇنڇر'
    ];

    var sd = moment.defineLocale('sd', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[اڄ] LT',
            nextDay : '[سڀاڻي] LT',
            nextWeek : 'dddd [اڳين هفتي تي] LT',
            lastDay : '[ڪالهه] LT',
            lastWeek : '[گزريل هفتي] dddd [تي] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s پوء',
            past : '%s اڳ',
            s : 'چند سيڪنڊ',
            ss : '%d سيڪنڊ',
            m : 'هڪ منٽ',
            mm : '%d منٽ',
            h : 'هڪ ڪلاڪ',
            hh : '%d ڪلاڪ',
            d : 'هڪ ڏينهن',
            dd : '%d ڏينهن',
            M : 'هڪ مهينو',
            MM : '%d مهينا',
            y : 'هڪ سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;

})));


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var se = moment.defineLocale('se', {
        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'MMMM D. [b.] YYYY',
            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar : {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s geažes',
            past : 'maŋit %s',
            s : 'moadde sekunddat',
            ss: '%d sekunddat',
            m : 'okta minuhta',
            mm : '%d minuhtat',
            h : 'okta diimmu',
            hh : '%d diimmut',
            d : 'okta beaivi',
            dd : '%d beaivvit',
            M : 'okta mánnu',
            MM : '%d mánut',
            y : 'okta jahki',
            yy : '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;

})));


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'a h:mm',
            LTS : 'a h:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY MMMM D',
            LLL : 'YYYY MMMM D, a h:mm',
            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar : {
            sameDay : '[අද] LT[ට]',
            nextDay : '[හෙට] LT[ට]',
            nextWeek : 'dddd LT[ට]',
            lastDay : '[ඊයේ] LT[ට]',
            lastWeek : '[පසුගිය] dddd LT[ට]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sකින්',
            past : '%sකට පෙර',
            s : 'තත්පර කිහිපය',
            ss : 'තත්පර %d',
            m : 'මිනිත්තුව',
            mm : 'මිනිත්තු %d',
            h : 'පැය',
            hh : 'පැය %d',
            d : 'දිනය',
            dd : 'දින %d',
            M : 'මාසය',
            MM : 'මාස %d',
            y : 'වසර',
            yy : 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal : function (number) {
            return number + ' වැනි';
        },
        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM : function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;

})));


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months : months,
        monthsShort : monthsShort,
        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'pred %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;

})));


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : processRelativeTime,
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sl;

})));


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sq = moment.defineLocale('sq', {
        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'në %s',
            past : '%s më parë',
            s : 'disa sekonda',
            ss : '%d sekonda',
            m : 'një minutë',
            mm : '%d minuta',
            h : 'një orë',
            hh : '%d orë',
            d : 'një ditë',
            dd : '%d ditë',
            M : 'një muaj',
            MM : '%d muaj',
            y : 'një vit',
            yy : '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;

})));


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'за %s',
            past   : 'пре %s',
            s      : 'неколико секунди',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'дан',
            dd     : translator.translate,
            M      : 'месец',
            MM     : translator.translate,
            y      : 'годину',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return srCyrl;

})));


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sr;

})));


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ss = moment.defineLocale('ss', {
        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Namuhla nga] LT',
            nextDay : '[Kusasa nga] LT',
            nextWeek : 'dddd [nga] LT',
            lastDay : '[Itolo nga] LT',
            lastWeek : 'dddd [leliphelile] [nga] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'nga %s',
            past : 'wenteka nga %s',
            s : 'emizuzwana lomcane',
            ss : '%d mzuzwana',
            m : 'umzuzu',
            mm : '%d emizuzu',
            h : 'lihora',
            hh : '%d emahora',
            d : 'lilanga',
            dd : '%d emalanga',
            M : 'inyanga',
            MM : '%d tinyanga',
            y : 'umnyaka',
            yy : '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : '%d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;

})));


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sw = moment.defineLocale('sw', {
        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[leo saa] LT',
            nextDay : '[kesho saa] LT',
            nextWeek : '[wiki ijayo] dddd [saat] LT',
            lastDay : '[jana] LT',
            lastWeek : '[wiki iliyopita] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s baadaye',
            past : 'tokea %s',
            s : 'hivi punde',
            ss : 'sekunde %d',
            m : 'dakika moja',
            mm : 'dakika %d',
            h : 'saa limoja',
            hh : 'masaa %d',
            d : 'siku moja',
            dd : 'masiku %d',
            M : 'mwezi mmoja',
            MM : 'miezi %d',
            y : 'mwaka mmoja',
            yy : 'miaka %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sw;

})));


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    }, numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, HH:mm',
            LLLL : 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s இல்',
            past : '%s முன்',
            s : 'ஒரு சில விநாடிகள்',
            ss : '%d விநாடிகள்',
            m : 'ஒரு நிமிடம்',
            mm : '%d நிமிடங்கள்',
            h : 'ஒரு மணி நேரம்',
            hh : '%d மணி நேரம்',
            d : 'ஒரு நாள்',
            dd : '%d நாட்கள்',
            M : 'ஒரு மாதம்',
            MM : '%d மாதங்கள்',
            y : 'ஒரு வருடம்',
            yy : '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal : function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem : function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';  // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ta;

})));


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var te = moment.defineLocale('te', {
        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[నేడు] LT',
            nextDay : '[రేపు] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[నిన్న] LT',
            lastWeek : '[గత] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s లో',
            past : '%s క్రితం',
            s : 'కొన్ని క్షణాలు',
            ss : '%d సెకన్లు',
            m : 'ఒక నిమిషం',
            mm : '%d నిమిషాలు',
            h : 'ఒక గంట',
            hh : '%d గంటలు',
            d : 'ఒక రోజు',
            dd : '%d రోజులు',
            M : 'ఒక నెల',
            MM : '%d నెలలు',
            y : 'ఒక సంవత్సరం',
            yy : '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse : /\d{1,2}వ/,
        ordinal : '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return te;

})));


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tet = moment.defineLocale('tet', {
        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'iha %s',
            past : '%s liuba',
            s : 'minutu balun',
            ss : 'minutu %d',
            m : 'minutu ida',
            mm : 'minutu %d',
            h : 'oras ida',
            hh : 'oras %d',
            d : 'loron ida',
            dd : 'loron %d',
            M : 'fulan ida',
            MM : 'fulan %d',
            y : 'tinan ida',
            yy : 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;

})));


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    var tg = moment.defineLocale('tg', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Имрӯз соати] LT',
            nextDay : '[Пагоҳ соати] LT',
            lastDay : '[Дирӯз соати] LT',
            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'баъди %s',
            past : '%s пеш',
            s : 'якчанд сония',
            m : 'як дақиқа',
            mm : '%d дақиқа',
            h : 'як соат',
            hh : '%d соат',
            d : 'як рӯз',
            dd : '%d рӯз',
            M : 'як моҳ',
            MM : '%d моҳ',
            y : 'як сол',
            yy : '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1th is the first week of the year.
        }
    });

    return tg;

})));


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var th = moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            ss : '%d วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    return th;

})));


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tlPh = moment.defineLocale('tl-ph', {
        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'MM/D/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY HH:mm',
            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar : {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'sa loob ng %s',
            past : '%s ang nakalipas',
            s : 'ilang segundo',
            ss : '%d segundo',
            m : 'isang minuto',
            mm : '%d minuto',
            h : 'isang oras',
            hh : '%d oras',
            d : 'isang araw',
            dd : '%d araw',
            M : 'isang buwan',
            MM : '%d buwan',
            y : 'isang taon',
            yy : '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;

})));


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'leS' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'waQ' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'nem' :
        time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'Hu’' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'wen' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'ben' :
        time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
        }
        return (word === '') ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact : true,
        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime : {
            future : translateFuture,
            past : translatePast,
            s : 'puS lup',
            ss : translate,
            m : 'wa’ tup',
            mm : translate,
            h : 'wa’ rep',
            hh : translate,
            d : 'wa’ jaj',
            dd : translate,
            M : 'wa’ jar',
            MM : translate,
            y : 'wa’ DIS',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;

})));


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {


;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[gelecek] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            ss : '%d saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {  // special case for zero
                        return number + '\'ıncı';
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return tr;

})));


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM [dallas] YYYY',
            LLL : 'D. MMMM [dallas] YYYY HH.mm',
            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM : function (input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar : {
            sameDay : '[oxhi à] LT',
            nextDay : '[demà à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[ieiri à] LT',
            lastWeek : '[sür el] dddd [lasteu à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'osprei %s',
            past : 'ja%s',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'ss': [number + ' secunds', '' + number + ' secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
    }

    return tzl;

})));


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzmLatn = moment.defineLocale('tzm-latn', {
        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dadkh s yan %s',
            past : 'yan %s',
            s : 'imik',
            ss : '%d imik',
            m : 'minuḍ',
            mm : '%d minuḍ',
            h : 'saɛa',
            hh : '%d tassaɛin',
            d : 'ass',
            dd : '%d ossan',
            M : 'ayowr',
            MM : '%d iyyirn',
            y : 'asgas',
            yy : '%d isgasn'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzmLatn;

})));


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzm = moment.defineLocale('tzm', {
        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past : 'ⵢⴰⵏ %s',
            s : 'ⵉⵎⵉⴽ',
            ss : '%d ⵉⵎⵉⴽ',
            m : 'ⵎⵉⵏⵓⴺ',
            mm : '%d ⵎⵉⵏⵓⴺ',
            h : 'ⵙⴰⵄⴰ',
            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d : 'ⴰⵙⵙ',
            dd : '%d oⵙⵙⴰⵏ',
            M : 'ⴰⵢoⵓⵔ',
            MM : '%d ⵉⵢⵢⵉⵔⵏ',
            y : 'ⴰⵙⴳⴰⵙ',
            yy : '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzm;

})));


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js language configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ugCn;

})));


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (m === true) {
            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'годину',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'місяць',
            MM : relativeTimeWithPlural,
            y : 'рік',
            yy : relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uk;

})));


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر'
    ];
    var days = [
        'اتوار',
        'پیر',
        'منگل',
        'بدھ',
        'جمعرات',
        'جمعہ',
        'ہفتہ'
    ];

    var ur = moment.defineLocale('ur', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[آج بوقت] LT',
            nextDay : '[کل بوقت] LT',
            nextWeek : 'dddd [بوقت] LT',
            lastDay : '[گذشتہ روز بوقت] LT',
            lastWeek : '[گذشتہ] dddd [بوقت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s بعد',
            past : '%s قبل',
            s : 'چند سیکنڈ',
            ss : '%d سیکنڈ',
            m : 'ایک منٹ',
            mm : '%d منٹ',
            h : 'ایک گھنٹہ',
            hh : '%d گھنٹے',
            d : 'ایک دن',
            dd : '%d دن',
            M : 'ایک ماہ',
            MM : '%d ماہ',
            y : 'ایک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;

})));


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uzLatn = moment.defineLocale('uz-latn', {
        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Bugun soat] LT [da]',
            nextDay : '[Ertaga] LT [da]',
            nextWeek : 'dddd [kuni soat] LT [da]',
            lastDay : '[Kecha soat] LT [da]',
            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Yaqin %s ichida',
            past : 'Bir necha %s oldin',
            s : 'soniya',
            ss : '%d soniya',
            m : 'bir daqiqa',
            mm : '%d daqiqa',
            h : 'bir soat',
            hh : '%d soat',
            d : 'bir kun',
            dd : '%d kun',
            M : 'bir oy',
            MM : '%d oy',
            y : 'bir yil',
            yy : '%d yil'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uzLatn;

})));


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uz = moment.defineLocale('uz', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Якин %s ичида',
            past : 'Бир неча %s олдин',
            s : 'фурсат',
            ss : '%d фурсат',
            m : 'бир дакика',
            mm : '%d дакика',
            h : 'бир соат',
            hh : '%d соат',
            d : 'бир кун',
            dd : '%d кун',
            M : 'бир ой',
            MM : '%d ой',
            y : 'бир йил',
            yy : '%d йил'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;

})));


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var vi = moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            ss : '%d giây' ,
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;

})));


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var xPseudo = moment.defineLocale('x-pseudo', {
        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact : true,
        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[T~ódá~ý át] LT',
            nextDay : '[T~ómó~rró~w át] LT',
            nextWeek : 'dddd [át] LT',
            lastDay : '[Ý~ést~érdá~ý át] LT',
            lastWeek : '[L~ást] dddd [át] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'í~ñ %s',
            past : '%s á~gó',
            s : 'á ~féw ~sécó~ñds',
            ss : '%d s~écóñ~ds',
            m : 'á ~míñ~úté',
            mm : '%d m~íñú~tés',
            h : 'á~ñ hó~úr',
            hh : '%d h~óúrs',
            d : 'á ~dáý',
            dd : '%d d~áýs',
            M : 'á ~móñ~th',
            MM : '%d m~óñt~hs',
            y : 'á ~ýéár',
            yy : '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;

})));


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var yo = moment.defineLocale('yo', {
        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Ònì ni] LT',
            nextDay : '[Ọ̀la ni] LT',
            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay : '[Àna ni] LT',
            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ní %s',
            past : '%s kọjá',
            s : 'ìsẹjú aayá die',
            ss :'aayá %d',
            m : 'ìsẹjú kan',
            mm : 'ìsẹjú %d',
            h : 'wákati kan',
            hh : 'wákati %d',
            d : 'ọjọ́ kan',
            dd : 'ọjọ́ %d',
            M : 'osù kan',
            MM : 'osù %d',
            y : 'ọdún kan',
            yy : 'ọdún %d'
        },
        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
        ordinal : 'ọjọ́ %d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;

})));


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhCn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;

})));


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhHk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhHk;

})));


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(8)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhTw = moment.defineLocale('zh-tw', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天] LT',
            nextDay : '[明天] LT',
            nextWeek : '[下]dddd LT',
            lastDay : '[昨天] LT',
            lastWeek : '[上]dddd LT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhTw;

})));


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(97).Buffer

/* Protocol - protocol constants */
var protocol = module.exports

/* Command code => mnemonic */
protocol.types = {
  0: 'reserved',
  1: 'connect',
  2: 'connack',
  3: 'publish',
  4: 'puback',
  5: 'pubrec',
  6: 'pubrel',
  7: 'pubcomp',
  8: 'subscribe',
  9: 'suback',
  10: 'unsubscribe',
  11: 'unsuback',
  12: 'pingreq',
  13: 'pingresp',
  14: 'disconnect',
  15: 'reserved'
}

/* Mnemonic => Command code */
protocol.codes = {}
for (var k in protocol.types) {
  var v = protocol.types[k]
  protocol.codes[v] = k
}

/* Header */
protocol.CMD_SHIFT = 4
protocol.CMD_MASK = 0xF0
protocol.DUP_MASK = 0x08
protocol.QOS_MASK = 0x03
protocol.QOS_SHIFT = 1
protocol.RETAIN_MASK = 0x01

/* Length */
protocol.LENGTH_MASK = 0x7F
protocol.LENGTH_FIN_MASK = 0x80

/* Connack */
protocol.SESSIONPRESENT_MASK = 0x01
protocol.SESSIONPRESENT_HEADER = Buffer.from([protocol.SESSIONPRESENT_MASK])
protocol.CONNACK_HEADER = Buffer.from([protocol.codes['connack'] << protocol.CMD_SHIFT])

/* Connect */
protocol.USERNAME_MASK = 0x80
protocol.PASSWORD_MASK = 0x40
protocol.WILL_RETAIN_MASK = 0x20
protocol.WILL_QOS_MASK = 0x18
protocol.WILL_QOS_SHIFT = 3
protocol.WILL_FLAG_MASK = 0x04
protocol.CLEAN_SESSION_MASK = 0x02
protocol.CONNECT_HEADER = Buffer.from([protocol.codes['connect'] << protocol.CMD_SHIFT])

function genHeader (type) {
  return [0, 1, 2].map(function (qos) {
    return [0, 1].map(function (dup) {
      return [0, 1].map(function (retain) {
        var buf = new Buffer(1)
        buf.writeUInt8(
          protocol.codes[type] << protocol.CMD_SHIFT |
          (dup ? protocol.DUP_MASK : 0) |
          qos << protocol.QOS_SHIFT | retain, 0, true)
        return buf
      })
    })
  })
}

/* Publish */
protocol.PUBLISH_HEADER = genHeader('publish')

/* Subscribe */
protocol.SUBSCRIBE_HEADER = genHeader('subscribe')

/* Unsubscribe */
protocol.UNSUBSCRIBE_HEADER = genHeader('unsubscribe')

/* Confirmations */
protocol.ACKS = {
  unsuback: genHeader('unsuback'),
  puback: genHeader('puback'),
  pubcomp: genHeader('pubcomp'),
  pubrel: genHeader('pubrel'),
  pubrec: genHeader('pubrec')
}

protocol.SUBACK_HEADER = Buffer.from([protocol.codes['suback'] << protocol.CMD_SHIFT])

/* Protocol versions */
protocol.VERSION3 = Buffer.from([3])
protocol.VERSION4 = Buffer.from([4])

/* QoS */
protocol.QOS = [0, 1, 2].map(function (qos) {
  return Buffer.from([qos])
})

/* Empty packets */
protocol.EMPTY = {
  pingreq: Buffer.from([protocol.codes['pingreq'] << 4, 0]),
  pingresp: Buffer.from([protocol.codes['pingresp'] << 4, 0]),
  disconnect: Buffer.from([protocol.codes['disconnect'] << 4, 0])
}


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var protocol = __webpack_require__(661)
var Buffer = __webpack_require__(97).Buffer
var empty = Buffer.allocUnsafe(0)
var zeroBuf = Buffer.from([0])
var numbers = __webpack_require__(1524)
var nextTick = __webpack_require__(194)

var numCache = numbers.cache
var generateNumber = numbers.generateNumber
var generateCache = numbers.generateCache
var writeNumber = writeNumberCached
var toGenerate = true

function generate (packet, stream) {
  if (stream.cork) {
    stream.cork()
    nextTick(uncork, stream)
  }

  if (toGenerate) {
    toGenerate = false
    generateCache()
  }

  switch (packet.cmd) {
    case 'connect':
      return connect(packet, stream)
    case 'connack':
      return connack(packet, stream)
    case 'publish':
      return publish(packet, stream)
    case 'puback':
    case 'pubrec':
    case 'pubrel':
    case 'pubcomp':
    case 'unsuback':
      return confirmation(packet, stream)
    case 'subscribe':
      return subscribe(packet, stream)
    case 'suback':
      return suback(packet, stream)
    case 'unsubscribe':
      return unsubscribe(packet, stream)
    case 'pingreq':
    case 'pingresp':
    case 'disconnect':
      return emptyPacket(packet, stream)
    default:
      stream.emit('error', new Error('Unknown command'))
      return false
  }
}
/**
 * Controls numbers cache.
 * Set to "false" to allocate buffers on-the-flight instead of pre-generated cache
 */
Object.defineProperty(generate, 'cacheNumbers', {
  get: function () {
    return writeNumber === writeNumberCached
  },
  set: function (value) {
    if (value) {
      if (!numCache || Object.keys(numCache).length === 0) toGenerate = true
      writeNumber = writeNumberCached
    } else {
      toGenerate = false
      writeNumber = writeNumberGenerated
    }
  }
})

function uncork (stream) {
  stream.uncork()
}

function connect (opts, stream) {
  var settings = opts || {}
  var protocolId = settings.protocolId || 'MQTT'
  var protocolVersion = settings.protocolVersion || 4
  var will = settings.will
  var clean = settings.clean
  var keepalive = settings.keepalive || 0
  var clientId = settings.clientId || ''
  var username = settings.username
  var password = settings.password

  if (clean === undefined) clean = true

  var length = 0

  // Must be a string and non-falsy
  if (!protocolId ||
     (typeof protocolId !== 'string' && !Buffer.isBuffer(protocolId))) {
    stream.emit('error', new Error('Invalid protocolId'))
    return false
  } else length += protocolId.length + 2

  // Must be 3 or 4
  if (protocolVersion !== 3 && protocolVersion !== 4) {
    stream.emit('error', new Error('Invalid protocol version'))
    return false
  } else length += 1

  // ClientId might be omitted in 3.1.1, but only if cleanSession is set to 1
  if ((typeof clientId === 'string' || Buffer.isBuffer(clientId)) &&
     (clientId || protocolVersion === 4) && (clientId || clean)) {
    length += clientId.length + 2
  } else {
    if (protocolVersion < 4) {
      stream.emit('error', new Error('clientId must be supplied before 3.1.1'))
      return false
    }
    if ((clean * 1) === 0) {
      stream.emit('error', new Error('clientId must be given if cleanSession set to 0'))
      return false
    }
  }

  // Must be a two byte number
  if (typeof keepalive !== 'number' ||
      keepalive < 0 ||
      keepalive > 65535 ||
      keepalive % 1 !== 0) {
    stream.emit('error', new Error('Invalid keepalive'))
    return false
  } else length += 2

  // Connect flags
  length += 1

  // If will exists...
  if (will) {
    // It must be an object
    if (typeof will !== 'object') {
      stream.emit('error', new Error('Invalid will'))
      return false
    }
    // It must have topic typeof string
    if (!will.topic || typeof will.topic !== 'string') {
      stream.emit('error', new Error('Invalid will topic'))
      return false
    } else {
      length += Buffer.byteLength(will.topic) + 2
    }

    // Payload
    if (will.payload && will.payload) {
      if (will.payload.length >= 0) {
        if (typeof will.payload === 'string') {
          length += Buffer.byteLength(will.payload) + 2
        } else {
          length += will.payload.length + 2
        }
      } else {
        stream.emit('error', new Error('Invalid will payload'))
        return false
      }
    } else {
      length += 2
    }
  }

  // Username
  if (username) {
    if (username.length) {
      length += Buffer.byteLength(username) + 2
    } else {
      stream.emit('error', new Error('Invalid username'))
      return false
    }
  }

  // Password
  if (password) {
    if (password.length) {
      length += byteLength(password) + 2
    } else {
      stream.emit('error', new Error('Invalid password'))
      return false
    }
  }

  // Generate header
  stream.write(protocol.CONNECT_HEADER)

  // Generate length
  writeLength(stream, length)

  // Generate protocol ID
  writeStringOrBuffer(stream, protocolId)
  stream.write(
    protocolVersion === 4 ? protocol.VERSION4 : protocol.VERSION3
  )

  // Connect flags
  var flags = 0
  flags |= username ? protocol.USERNAME_MASK : 0
  flags |= password ? protocol.PASSWORD_MASK : 0
  flags |= (will && will.retain) ? protocol.WILL_RETAIN_MASK : 0
  flags |= (will && will.qos) ? will.qos << protocol.WILL_QOS_SHIFT : 0
  flags |= will ? protocol.WILL_FLAG_MASK : 0
  flags |= clean ? protocol.CLEAN_SESSION_MASK : 0

  stream.write(Buffer.from([flags]))

  // Keepalive
  writeNumber(stream, keepalive)

  // Client ID
  writeStringOrBuffer(stream, clientId)

  // Will
  if (will) {
    writeString(stream, will.topic)
    writeStringOrBuffer(stream, will.payload)
  }

  // Username and password
  if (username) writeStringOrBuffer(stream, username)
  if (password) writeStringOrBuffer(stream, password)

  // This is a small packet that happens only once on a stream
  // We assume the stream is always free to receive more data after this
  return true
}

function connack (opts, stream) {
  var settings = opts || {}
  var rc = settings.returnCode

  // Check return code
  if (typeof rc !== 'number') {
    stream.emit('error', new Error('Invalid return code'))
    return false
  }

  stream.write(protocol.CONNACK_HEADER)
  writeLength(stream, 2)
  stream.write(opts.sessionPresent ? protocol.SESSIONPRESENT_HEADER : zeroBuf)

  return stream.write(Buffer.from([rc]))
}

function publish (opts, stream) {
  var settings = opts || {}
  var qos = settings.qos || 0
  var retain = settings.retain ? protocol.RETAIN_MASK : 0
  var topic = settings.topic
  var payload = settings.payload || empty
  var id = settings.messageId

  var length = 0

  // Topic must be a non-empty string or Buffer
  if (typeof topic === 'string') length += Buffer.byteLength(topic) + 2
  else if (Buffer.isBuffer(topic)) length += topic.length + 2
  else {
    stream.emit('error', new Error('Invalid topic'))
    return false
  }

  // Get the payload length
  if (!Buffer.isBuffer(payload)) length += Buffer.byteLength(payload)
  else length += payload.length

  // Message ID must a number if qos > 0
  if (qos && typeof id !== 'number') {
    stream.emit('error', new Error('Invalid messageId'))
    return false
  } else if (qos) length += 2

  // Header
  stream.write(protocol.PUBLISH_HEADER[qos][opts.dup ? 1 : 0][retain ? 1 : 0])

  // Remaining length
  writeLength(stream, length)

  // Topic
  writeNumber(stream, byteLength(topic))
  stream.write(topic)

  // Message ID
  if (qos > 0) writeNumber(stream, id)

  // Payload
  return stream.write(payload)
}

/* Puback, pubrec, pubrel and pubcomp */
function confirmation (opts, stream) {
  var settings = opts || {}
  var type = settings.cmd || 'puback'
  var id = settings.messageId
  var dup = (settings.dup && type === 'pubrel') ? protocol.DUP_MASK : 0
  var qos = 0

  if (type === 'pubrel') qos = 1

  // Check message ID
  if (typeof id !== 'number') {
    stream.emit('error', new Error('Invalid messageId'))
    return false
  }

  // Header
  stream.write(protocol.ACKS[type][qos][dup][0])

  // Length
  writeLength(stream, 2)

  // Message ID
  return writeNumber(stream, id)
}

function subscribe (opts, stream) {
  var settings = opts || {}
  var dup = settings.dup ? protocol.DUP_MASK : 0
  var id = settings.messageId
  var subs = settings.subscriptions

  var length = 0

  // Check message ID
  if (typeof id !== 'number') {
    stream.emit('error', new Error('Invalid messageId'))
    return false
  } else length += 2

  // Check subscriptions
  if (typeof subs === 'object' && subs.length) {
    for (var i = 0; i < subs.length; i += 1) {
      var itopic = subs[i].topic
      var iqos = subs[i].qos

      if (typeof itopic !== 'string') {
        stream.emit('error', new Error('Invalid subscriptions - invalid topic'))
        return false
      }
      if (typeof iqos !== 'number') {
        stream.emit('error', new Error('Invalid subscriptions - invalid qos'))
        return false
      }

      length += Buffer.byteLength(itopic) + 2 + 1
    }
  } else {
    stream.emit('error', new Error('Invalid subscriptions'))
    return false
  }

  // Generate header
  stream.write(protocol.SUBSCRIBE_HEADER[1][dup ? 1 : 0][0])

  // Generate length
  writeLength(stream, length)

  // Generate message ID
  writeNumber(stream, id)

  var result = true

  // Generate subs
  for (var j = 0; j < subs.length; j++) {
    var sub = subs[j]
    var jtopic = sub.topic
    var jqos = sub.qos

    // Write topic string
    writeString(stream, jtopic)

    // Write qos
    result = stream.write(protocol.QOS[jqos])
  }

  return result
}

function suback (opts, stream) {
  var settings = opts || {}
  var id = settings.messageId
  var granted = settings.granted

  var length = 0

  // Check message ID
  if (typeof id !== 'number') {
    stream.emit('error', new Error('Invalid messageId'))
    return false
  } else length += 2

  // Check granted qos vector
  if (typeof granted === 'object' && granted.length) {
    for (var i = 0; i < granted.length; i += 1) {
      if (typeof granted[i] !== 'number') {
        stream.emit('error', new Error('Invalid qos vector'))
        return false
      }
      length += 1
    }
  } else {
    stream.emit('error', new Error('Invalid qos vector'))
    return false
  }

  // header
  stream.write(protocol.SUBACK_HEADER)

  // Length
  writeLength(stream, length)

  // Message ID
  writeNumber(stream, id)

  return stream.write(Buffer.from(granted))
}

function unsubscribe (opts, stream) {
  var settings = opts || {}
  var id = settings.messageId
  var dup = settings.dup ? protocol.DUP_MASK : 0
  var unsubs = settings.unsubscriptions

  var length = 0

  // Check message ID
  if (typeof id !== 'number') {
    stream.emit('error', new Error('Invalid messageId'))
    return false
  } else {
    length += 2
  }
  // Check unsubs
  if (typeof unsubs === 'object' && unsubs.length) {
    for (var i = 0; i < unsubs.length; i += 1) {
      if (typeof unsubs[i] !== 'string') {
        stream.emit('error', new Error('Invalid unsubscriptions'))
        return false
      }
      length += Buffer.byteLength(unsubs[i]) + 2
    }
  } else {
    stream.emit('error', new Error('Invalid unsubscriptions'))
    return false
  }

  // Header
  stream.write(protocol.UNSUBSCRIBE_HEADER[1][dup ? 1 : 0][0])

  // Length
  writeLength(stream, length)

  // Message ID
  writeNumber(stream, id)

  // Unsubs
  var result = true
  for (var j = 0; j < unsubs.length; j++) {
    result = writeString(stream, unsubs[j])
  }

  return result
}

function emptyPacket (opts, stream) {
  return stream.write(protocol.EMPTY[opts.cmd])
}

/**
 * calcLengthLength - calculate the length of the remaining
 * length field
 *
 * @api private
 */
function calcLengthLength (length) {
  if (length >= 0 && length < 128) return 1
  else if (length >= 128 && length < 16384) return 2
  else if (length >= 16384 && length < 2097152) return 3
  else if (length >= 2097152 && length < 268435456) return 4
  else return 0
}

function genBufLength (length) {
  var digit = 0
  var pos = 0
  var buffer = Buffer.allocUnsafe(calcLengthLength(length))

  do {
    digit = length % 128 | 0
    length = length / 128 | 0
    if (length > 0) digit = digit | 0x80

    buffer.writeUInt8(digit, pos++, true)
  } while (length > 0)

  return buffer
}

/**
 * writeLength - write an MQTT style length field to the buffer
 *
 * @param <Buffer> buffer - destination
 * @param <Number> pos - offset
 * @param <Number> length - length (>0)
 * @returns <Number> number of bytes written
 *
 * @api private
 */

var lengthCache = {}
function writeLength (stream, length) {
  var buffer = lengthCache[length]

  if (!buffer) {
    buffer = genBufLength(length)
    if (length < 16384) lengthCache[length] = buffer
  }

  stream.write(buffer)
}

/**
 * writeString - write a utf8 string to the buffer
 *
 * @param <Buffer> buffer - destination
 * @param <Number> pos - offset
 * @param <String> string - string to write
 * @return <Number> number of bytes written
 *
 * @api private
 */

function writeString (stream, string) {
  var strlen = Buffer.byteLength(string)
  writeNumber(stream, strlen)

  stream.write(string, 'utf8')
}

/**
 * writeNumber - write a two byte number to the buffer
 *
 * @param <Buffer> buffer - destination
 * @param <Number> pos - offset
 * @param <String> number - number to write
 * @return <Number> number of bytes written
 *
 * @api private
 */
function writeNumberCached (stream, number) {
  return stream.write(numCache[number])
}
function writeNumberGenerated (stream, number) {
  return stream.write(generateNumber(number))
}

/**
 * writeStringOrBuffer - write a String or Buffer with the its length prefix
 *
 * @param <Buffer> buffer - destination
 * @param <Number> pos - offset
 * @param <String> toWrite - String or Buffer
 * @return <Number> number of bytes written
 */
function writeStringOrBuffer (stream, toWrite) {
  if (toWrite && typeof toWrite === 'string') writeString(stream, toWrite)
  else if (toWrite) {
    writeNumber(stream, toWrite.length)
    stream.write(toWrite)
  } else writeNumber(stream, 0)
}

function byteLength (bufOrString) {
  if (!bufOrString) return 0
  else if (Buffer.isBuffer(bufOrString)) return bufOrString.length
  else return Buffer.byteLength(bufOrString)
}

module.exports = generate


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var net = __webpack_require__(1662)

/*
  variables port and host can be removed since
  you have all required information in opts object
*/
function buildBuilder (client, opts) {
  var port, host
  opts.port = opts.port || 1883
  opts.hostname = opts.hostname || opts.host || 'localhost'

  port = opts.port
  host = opts.hostname

  return net.createConnection(port, host)
}

module.exports = buildBuilder


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var websocket = __webpack_require__(713)
var urlModule = __webpack_require__(352)
var WSS_OPTIONS = [
  'rejectUnauthorized',
  'ca',
  'cert',
  'key',
  'pfx',
  'passphrase'
]
var IS_BROWSER = process.title === 'browser'

function buildUrl (opts, client) {
  var url = opts.protocol + '://' + opts.hostname + ':' + opts.port + opts.path
  if (typeof (opts.transformWsUrl) === 'function') {
    url = opts.transformWsUrl(url, opts, client)
  }
  return url
}

function setDefaultOpts (opts) {
  if (!opts.hostname) {
    opts.hostname = 'localhost'
  }
  if (!opts.port) {
    if (opts.protocol === 'wss') {
      opts.port = 443
    } else {
      opts.port = 80
    }
  }
  if (!opts.path) {
    opts.path = '/'
  }

  if (!opts.wsOptions) {
    opts.wsOptions = {}
  }
  if (!IS_BROWSER && opts.protocol === 'wss') {
    // Add cert/key/ca etc options
    WSS_OPTIONS.forEach(function (prop) {
      if (opts.hasOwnProperty(prop) && !opts.wsOptions.hasOwnProperty(prop)) {
        opts.wsOptions[prop] = opts[prop]
      }
    })
  }
}

function createWebSocket (client, opts) {
  var websocketSubProtocol =
    (opts.protocolId === 'MQIsdp') && (opts.protocolVersion === 3)
      ? 'mqttv3.1'
      : 'mqtt'

  setDefaultOpts(opts)
  var url = buildUrl(opts, client)
  return websocket(url, [websocketSubProtocol], opts.wsOptions)
}

function buildBuilder (client, opts) {
  return createWebSocket(client, opts)
}

function buildBuilderBrowser (client, opts) {
  if (!opts.hostname) {
    opts.hostname = opts.host
  }

  if (!opts.hostname) {
    // Throwing an error in a Web Worker if no `hostname` is given, because we
    // can not determine the `hostname` automatically.  If connecting to
    // localhost, please supply the `hostname` as an argument.
    if (typeof (document) === 'undefined') {
      throw new Error('Could not determine host. Specify host manually.')
    }
    var parsed = urlModule.parse(document.URL)
    opts.hostname = parsed.hostname

    if (!opts.port) {
      opts.port = parsed.port
    }
  }
  return createWebSocket(client, opts)
}

if (IS_BROWSER) {
  module.exports = buildBuilderBrowser
} else {
  module.exports = buildBuilder
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global wx */
var socketOpen = false
var socketMsgQueue = []

function sendSocketMessage (msg) {
  if (socketOpen) {
    wx.sendSocketMessage({
      data: msg
    })
  } else {
    socketMsgQueue.push(msg)
  }
}

function WebSocket (url, protocols) {
  var ws = {
    OPEN: 1,
    CLOSING: 2,
    CLOSED: 3,
    readyState: socketOpen ? 1 : 0,
    send: sendSocketMessage,
    close: wx.closeSocket,
    onopen: null,
    onmessage: null,
    onclose: null,
    onerror: null
  }

  wx.connectSocket({
    url: url,
    protocols: protocols
  })
  wx.onSocketOpen(function (res) {
    ws.readyState = ws.OPEN
    socketOpen = true
    for (var i = 0; i < socketMsgQueue.length; i++) {
      sendSocketMessage(socketMsgQueue[i])
    }
    socketMsgQueue = []

    ws.onopen && ws.onopen.apply(ws, arguments)
  })
  wx.onSocketMessage(function (res) {
    ws.onmessage && ws.onmessage.apply(ws, arguments)
  })
  wx.onSocketClose(function () {
    ws.onclose && ws.onclose.apply(ws, arguments)
    ws.readyState = ws.CLOSED
    socketOpen = false
  })
  wx.onSocketError(function () {
    ws.onerror && ws.onerror.apply(ws, arguments)
    ws.readyState = ws.CLOSED
    socketOpen = false
  })

  return ws
}

var websocket = __webpack_require__(713)
var urlModule = __webpack_require__(352)

function buildUrl (opts, client) {
  var protocol = opts.protocol === 'wxs' ? 'wss' : 'ws'
  var url = protocol + '://' + opts.hostname + ':' + opts.port + opts.path
  if (typeof (opts.transformWsUrl) === 'function') {
    url = opts.transformWsUrl(url, opts, client)
  }
  return url
}

function setDefaultOpts (opts) {
  if (!opts.hostname) {
    opts.hostname = 'localhost'
  }
  if (!opts.port) {
    if (opts.protocol === 'wss') {
      opts.port = 443
    } else {
      opts.port = 80
    }
  }
  if (!opts.path) {
    opts.path = '/'
  }

  if (!opts.wsOptions) {
    opts.wsOptions = {}
  }
}

function createWebSocket (client, opts) {
  var websocketSubProtocol =
    (opts.protocolId === 'MQIsdp') && (opts.protocolVersion === 3)
      ? 'mqttv3.1'
      : 'mqtt'

  setDefaultOpts(opts)
  var url = buildUrl(opts, client)
  return websocket(WebSocket(url, [websocketSubProtocol]))
}

function buildBuilder (client, opts) {
  if (!opts.hostname) {
    opts.hostname = opts.host
  }

  if (!opts.hostname) {
    // Throwing an error in a Web Worker if no `hostname` is given, because we
    // can not determine the `hostname` automatically.  If connecting to
    // localhost, please supply the `hostname` as an argument.
    if (typeof (document) === 'undefined') {
      throw new Error('Could not determine host. Specify host manually.')
    }
    var parsed = urlModule.parse(document.URL)
    opts.hostname = parsed.hostname

    if (!opts.port) {
      opts.port = parsed.port
    }
  }
  return createWebSocket(client, opts)
}

module.exports = buildBuilder


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

/**
 * Module dependencies
 */
var xtend = __webpack_require__(353)

var Readable = __webpack_require__(245).Readable
var streamsOpts = { objectMode: true }
var defaultStoreOptions = {
  clean: true
}

/**
 * In-memory implementation of the message store
 * This can actually be saved into files.
 *
 * @param {Object} [options] - store options
 */
function Store (options) {
  if (!(this instanceof Store)) {
    return new Store(options)
  }

  this.options = options || {}

  // Defaults
  this.options = xtend(defaultStoreOptions, options)

  this._inflights = {}
}

/**
 * Adds a packet to the store, a packet is
 * anything that has a messageId property.
 *
 */
Store.prototype.put = function (packet, cb) {
  this._inflights[packet.messageId] = packet

  if (cb) {
    cb()
  }

  return this
}

/**
 * Creates a stream with all the packets in the store
 *
 */
Store.prototype.createStream = function () {
  var stream = new Readable(streamsOpts)
  var inflights = this._inflights
  var ids = Object.keys(this._inflights)
  var destroyed = false
  var i = 0

  stream._read = function () {
    if (!destroyed && i < ids.length) {
      this.push(inflights[ids[i++]])
    } else {
      this.push(null)
    }
  }

  stream.destroy = function () {
    if (destroyed) {
      return
    }

    var self = this

    destroyed = true

    process.nextTick(function () {
      self.emit('close')
    })
  }

  return stream
}

/**
 * deletes a packet from the store.
 */
Store.prototype.del = function (packet, cb) {
  packet = this._inflights[packet.messageId]
  if (packet) {
    delete this._inflights[packet.messageId]
    cb(null, packet)
  } else if (cb) {
    cb(new Error('missing packet'))
  }

  return this
}

/**
 * get a packet from the store.
 */
Store.prototype.get = function (packet, cb) {
  packet = this._inflights[packet.messageId]
  if (packet) {
    cb(null, packet)
  } else if (cb) {
    cb(new Error('missing packet'))
  }

  return this
}

/**
 * Close the store
 */
Store.prototype.close = function (cb) {
  if (this.options.clean) {
    this._inflights = null
  }
  if (cb) {
    cb()
  }
}

module.exports = Store

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(1537);
exports.encode = exports.stringify = __webpack_require__(1538);


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Bling = __webpack_require__(1545);

Object.defineProperty(exports, "Bling", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Bling).default;
  }
});

var _Events = __webpack_require__(340);

Object.defineProperty(exports, "Events", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Events).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 669 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 671 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Type of default actions supported by metrics
 *
 * @module ActionTypes
 * @internal
 */
var ActionTypes = {
  PAGE_VIEW: "pageView", // request page view track
  TRACK: "track" // request custom link track
};

exports.default = ActionTypes;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Metrics = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.isMetrics = isMetrics;
exports.default = createMetrics;

var _eventemitter = __webpack_require__(1560);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _querystring = __webpack_require__(667);

var _querystring2 = _interopRequireDefault(_querystring);

var _ExecutionEnvironment = __webpack_require__(191);

var _invariant = __webpack_require__(107);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(517);

var _warning2 = _interopRequireDefault(_warning);

var _ActionTypes = __webpack_require__(671);

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _createService = __webpack_require__(1551);

var _createService2 = _interopRequireDefault(_createService);

var _extractApis = __webpack_require__(674);

var _extractApis2 = _interopRequireDefault(_extractApis);

var _isPromise = __webpack_require__(1553);

var _isPromise2 = _interopRequireDefault(_isPromise);

var _useTrackBindingPlugin = __webpack_require__(673);

var _useTrackBindingPlugin2 = _interopRequireDefault(_useTrackBindingPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var qs = _ExecutionEnvironment.canUseDOM ? _querystring2.default.decode(window.location.search.substr(1)) : {};
var defaults = {
    pageViewEvent: "pageLoad",
    pageDefaults: function pageDefaults() {
        return {};
    },
    requestTimeout: 15 * 1000
};

var Transaction = function () {
    function Transaction() {
        _classCallCheck(this, Transaction);

        this.pvTransactions = {};
        this.transactionId = 0;
    }

    _createClass(Transaction, [{
        key: "create",
        value: function create() {
            return ++this.transactionId;
        }
    }, {
        key: "current",
        value: function current() {
            return this.transactionId;
        }
    }, {
        key: "get",
        value: function get(tId) {
            return this.pvTransactions[tId];
        }
    }, {
        key: "set",
        value: function set(tId, value) {
            this.pvTransactions[tId] = value;
        }
    }, {
        key: "remove",
        value: function remove(tId) {
            if (tId && this.pvTransactions[tId]) {
                delete this.pvTransactions[tId];
            }
        }
    }, {
        key: "keys",
        value: function keys() {
            return Object.keys(this.pvTransactions);
        }
    }]);

    return Transaction;
}();

var Metrics = exports.Metrics = function (_EventEmitter) {
    _inherits(Metrics, _EventEmitter);

    function Metrics() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Metrics);

        if (!options.vendors) {
            throw new Error("'vendors' option is required.");
        }

        var _this = _possibleConstructorReturn(this, (Metrics.__proto__ || Object.getPrototypeOf(Metrics)).call(this));

        _this.enabled = options.enabled !== false;
        // undocumented option for unit test.
        _this.canUseDOM = options.canUseDOM !== undefined ? !!options.canUseDOM : _ExecutionEnvironment.canUseDOM;
        if (!_this.canUseDOM) {
            _this.enabled = false;
        }
        _this.debug = !!options.debug || qs.metrics_debug === "true";
        _this.customParams = options.customParams || {};
        _this.pageDefaults = options.pageDefaults || defaults.pageDefaults;
        _this.pageViewEvent = options.pageViewEvent || defaults.pageViewEvent;
        _this.requestTimeout = options.requestTimeout || defaults.requestTimeout;
        _this.cancelOnNext = options.cancelOnNext !== undefined ? !!options.cancelOnNext : true;
        _this.vendors = Array.isArray(options.vendors) ? options.vendors : [options.vendors];
        _this.services = _this.vendors.map(function (vendor) {
            return (0, _createService2.default)(vendor);
        });
        _this.apiList = (0, _extractApis2.default)(_this.services.map(function (service) {
            return service.apis;
        }));
        _this.transaction = new Transaction();
        _this.routeState = {};
        _this.apiImpl = _this.apiList.reduce(function (impl, api) {
            impl[api] = function () {
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                return _this._prepareTrack.apply(_this, [api].concat(args));
            };
            return impl;
        }, {});
        Object.freeze(_this.apiImpl);
        return _this;
    }

    _createClass(Metrics, [{
        key: "listen",
        value: function listen(type, callback) {
            var _this2 = this;

            // if type is not specified, listen for all the apis.
            if (typeof type === "function") {
                callback = type;
                type = null;
            }

            if (type) {
                this.on(type, callback);
            } else {
                this.apiList.forEach(function (api) {
                    _this2.on(api, callback);
                });
            }

            return function () {
                if (type) {
                    _this2.removeListener(type, callback);
                } else {
                    _this2.apiList.forEach(function (api) {
                        _this2.removeListener(api, callback);
                    });
                }
            };
        }
    }, {
        key: "setRouteState",
        value: function setRouteState(state) {
            this._cancelPreviousPromiseIfPending();
            this.routeState = state;
        }

        /* eslint-disable consistent-return */

    }, {
        key: "useTrackBinding",
        value: function useTrackBinding(rootElement, attributePrefix) {
            if (!this.enabled) {
                return;
            }

            // if 'false' is passed as first param, detach listeners
            if (rootElement === false) {
                this._removeTrackBindingListener();
                return;
            }

            (0, _invariant2.default)(typeof this.api.track === "function", "Metrics 'track' method needs to be defined for declarative tracking.");

            if (this._trackBindingListener) {
                this._removeTrackBindingListener();
            }

            this._trackBindingListener = (0, _useTrackBindingPlugin2.default)({
                callback: this._handleClick.bind(this),
                rootElement: rootElement,
                attributePrefix: attributePrefix
            });

            return this._removeTrackBindingListener.bind(this);
        }
    }, {
        key: "destroy",
        value: function destroy() {
            this._removeListeners();
            this._removeTrackBindingListener();
        }
    }, {
        key: "_callServices",

        /**
         * @method _callServices
         * @param type
         * @param promise
         * @returns {Promise.<T>}
         * @private
         */
        value: function _callServices(type, promise) {
            var _this3 = this;

            return promise.then(function (params) {
                params = params || [];
                var results = [];
                var services = _this3.services;
                var requestTimeout = _this3.requestTimeout;

                function isCompleted() {
                    return results.length === services.length;
                }

                function clearTimer(timer) {
                    if (timer) {
                        clearTimeout(timer);
                        timer = null;
                    }
                }

                return new Promise(function (resolve) {
                    function process(result) {
                        if (this.isTimeout) {
                            return;
                        }
                        this.isTimeout = true;
                        clearTimer(this.timer);
                        results.push(result);
                        if (isCompleted()) {
                            resolve(results);
                        }
                    }

                    services.map(function (service) {
                        var apis = service.apis,
                            name = service.name;

                        var apiExists = apis && apis[type];
                        if (apiExists) {
                            (0, _warning2.default)(typeof apis[type] === "function", "'" + type + "'" + (name ? "(" + name + " Service)" : "") + " is not a function");
                        }
                        var requestPromise = apiExists && typeof apis[type] === "function" ? apis[type].apply(apis, _toConsumableArray(params)) : undefined;
                        if (!(0, _isPromise2.default)(requestPromise)) {
                            requestPromise = Promise.resolve(requestPromise);
                        }
                        requestPromise.isTimeout = false;
                        requestPromise.timer = setTimeout(process.bind(requestPromise), requestTimeout, {
                            name: name,
                            params: params,
                            error: new Error("Request time out after " + requestTimeout + " ms."),
                            status: "failure"
                        });
                        return requestPromise.then(function (response) {
                            return {
                                name: name,
                                params: params,
                                response: response,
                                status: "success"
                            };
                        }).catch(function (error) {
                            return {
                                name: name,
                                params: params,
                                error: error,
                                status: "failure"
                            };
                        }).then(process.bind(requestPromise));
                    });
                });
            });
        }
        /**
         * Cancels page view promise if it's still pending while the route has changed.
         *
         * @method _cancelPreviousPromiseIfPending
         * @private
         */

    }, {
        key: "_cancelPreviousPromiseIfPending",
        value: function _cancelPreviousPromiseIfPending() {
            var _this4 = this;

            this.routeState = {};
            this.transaction.keys().forEach(function (tId) {
                var entry = _this4.transaction.get(tId);
                if (entry && entry.cancelOnNext) {
                    entry.shouldCancel = true;
                }
            });
        }

        /**
         * @method _createTransaction
         * @param args
         * @private
         */

    }, {
        key: "_createTransaction",
        value: function _createTransaction(args) {
            var tId = this.transaction.current();
            var cancelOnNext = this.cancelOnNext;
            this.transaction.set(tId, {
                promise: args[0],
                cancelOnNext: cancelOnNext
            });
            args.push(tId);
        }
        /**
         * @method _clearTransaction
         * @param tId
         * @private
         */

    }, {
        key: "_clearTransaction",
        value: function _clearTransaction(tId) {
            this.transaction.remove(tId);
        }
        /**
         * @method _doTrack
         * @param type
         * @param promise
         * @param tId
         * @private
         */

    }, {
        key: "_doTrack",
        value: function _doTrack(type, promise, tId) {
            promise = this._callServices(type, promise);
            var dispatchEvent = function (status, response, error) {
                var eventFacade = {
                    type: type,
                    status: status
                };
                if (response) {
                    eventFacade.response = response;
                } else if (error) {
                    eventFacade.error = error;
                }
                if (tId) {
                    eventFacade.transactionId = tId;
                    this._clearTransaction(tId);
                }
                this.emit(type, eventFacade);
                if (this.debug) {
                    console.log("track result", eventFacade);
                }
            }.bind(this);

            promise.then(function (response) {
                dispatchEvent(response.every(function (item) {
                    return item.status === "success";
                }) ? "success" : "failure", response);
            }).catch(function (error) {
                dispatchEvent("failure", null, error);
            });
        }
        /**
         * Returns the default tracking data provided by a helper object.
         *
         * @method __getDefaultData
         * @return {Object}
         * @private
         */

    }, {
        key: "_getDefaultData",
        value: function _getDefaultData(state) {
            return this.pageDefaults(state);
        }
        /**
         * Returns a merged data between the host passed object and the default tracking data provided by a helper object.
         *
         * @method __mergeWith
         * @return {Object}
         * @private
         */

    }, {
        key: "_mergeWith",
        value: function _mergeWith(data, state) {
            return Object.assign({}, this._getDefaultData(state), this.customParams, data);
        }
        /**
         * Checks if this promise should be cancelled by rejecting it before it's sent to the facade.
         *
         * @method __addCancelHook
         * @param {Promise} promise
         * @returns {Promise}
         * @private
         */

    }, {
        key: "_addCancelHook",
        value: function _addCancelHook(promise) {
            var _this5 = this;

            var tId = this.transaction.create();
            return promise.then(function (data) {
                return _this5.transaction.get(tId).shouldCancel ? Promise.reject(new Error("Page view cancelled")) : data;
            });
        }
        /**
         * Modify the data to include 'eventName' before it's sent to the facade.
         *
         * @method __addEventNameToPromise
         * @param {String} eventName
         * @param {Promise} promise
         * @param {boolean} shouldMerge
         * @returns {Promise}
         * @private
         */

    }, {
        key: "_addEventNameToPromise",
        value: function _addEventNameToPromise(eventName, promise, shouldMerge) {
            return promise.then(function (state, data) {
                data = [shouldMerge ? this._mergeWith(data, state) : data];
                data.unshift(eventName);
                return data;
            }.bind(this, this.routeState));
        }
        /**
         * Run checks to the arguments passed to 'pageView' and 'track', set default page view eventName if it's not provided.
         * Also merges the default data with the passed pageView data, and optionally for track data if a flag is set.
         *
         * @method __inspectArguments
         * @param {String} type
         * @param args
         * @returns {Array}
         * @private
         */

    }, {
        key: "_inspectArguments",
        value: function _inspectArguments(type) {
            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                args[_key2 - 1] = arguments[_key2];
            }

            var shouldMerge = true;
            if (type !== _ActionTypes2.default.PAGE_VIEW) {
                // don't merge `pageDefaults` with track params unless it's explicitly requested by the third argument.
                shouldMerge = false;
                if (type === _ActionTypes2.default.TRACK) {
                    (0, _invariant2.default)(typeof args[0] === "string", "Metrics 'track' method requires 'eventName' string as the first argument and object or promise as the second argument.");
                }
                // this might be confusing but for now, use the last argument as a flag for merge when it's boolean.
                if (args.length >= 3 && typeof args[args.length - 1] === "boolean") {
                    shouldMerge = args[args.length - 1];
                }
            }

            // set default page view event name when missing.

            var _args = args,
                _args2 = _slicedToArray(_args, 2),
                eventName = _args2[0],
                params = _args2[1];

            if (!params && typeof eventName !== "string") {
                params = eventName;
                eventName = type === _ActionTypes2.default.PAGE_VIEW ? this.pageViewEvent : null;
            }

            // make sure `params` is a promise.
            if (!(0, _isPromise2.default)(params)) {
                params = Promise.resolve(params);
            }

            // add cancel hook so that it can be cancelled(rejected) if the promise is still pending when the route changes.
            if (type === _ActionTypes2.default.PAGE_VIEW) {
                params = this._addCancelHook(params);
            }

            // PAGE_VIEW or TRACK should always have `eventName`.
            if (eventName) {
                params = this._addEventNameToPromise(eventName, params, shouldMerge);
            }
            args = [type, params];

            if (type === _ActionTypes2.default.PAGE_VIEW) {
                this._createTransaction(args);
            }

            return args;
        }
        /**
         * @method _prepareTrack
         * @param type
         * @param args
         * @private
         */

    }, {
        key: "_prepareTrack",
        value: function _prepareTrack(type) {
            for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                args[_key3 - 1] = arguments[_key3];
            }

            if (!this.enabled) {
                return;
            }
            args = this._inspectArguments.apply(this, [type].concat(_toConsumableArray(args)));
            this._doTrack.apply(this, _toConsumableArray(args));
        }
        /**
         * A click handler to perform custom link tracking, any element with 'metrics-*' attribute will be tracked.
         *
         * @method _handleClick
         * @param {Object} params
         * @private
         */

    }, {
        key: "_handleClick",
        value: function _handleClick() {
            var _api;

            (_api = this.api).track.apply(_api, arguments);
        }
    }, {
        key: "_removeListeners",
        value: function _removeListeners() {
            this.removeAllListeners();
        }
    }, {
        key: "_removeTrackBindingListener",
        value: function _removeTrackBindingListener() {
            if (this._trackBindingListener) {
                this._trackBindingListener.remove();
                this._trackBindingListener = null;
            }
        }
    }, {
        key: "api",
        get: function get() {
            return this.apiImpl;
        }
    }]);

    return Metrics;
}(_eventemitter2.default);

function isMetrics(value) {
    return value && typeof value.listen === "function" && typeof value.setRouteState === "function" && typeof value.useTrackBinding === "function" && typeof value.destroy === "function" && _typeof(value.api) === "object";
}

function createMetrics(options) {
    var metrics = new Metrics(options);
    return {
        listen: metrics.listen.bind(metrics),
        setRouteState: metrics.setRouteState.bind(metrics),
        useTrackBinding: metrics.useTrackBinding.bind(metrics),
        destroy: metrics.destroy.bind(metrics),
        get enabled() {
            return metrics.enabled;
        },
        get api() {
            return metrics.api;
        }
    };
}

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TrackBindingPlugin = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = useTrackBindingPlugin;

var _EventListener = __webpack_require__(1464);

var _EventListener2 = _interopRequireDefault(_EventListener);

var _attr2obj = __webpack_require__(1552);

var _attr2obj2 = _interopRequireDefault(_attr2obj);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function isLeftClickEvent(event) {
    return event.button === 0;
}

function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var TrackBindingPlugin = exports.TrackBindingPlugin = function () {
    function TrackBindingPlugin() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$attributePrefix = _ref.attributePrefix,
            attributePrefix = _ref$attributePrefix === undefined ? "data-metrics" : _ref$attributePrefix,
            _ref$traverseParent = _ref.traverseParent,
            traverseParent = _ref$traverseParent === undefined ? false : _ref$traverseParent;

        _classCallCheck(this, TrackBindingPlugin);

        this._attributePrefix = attributePrefix;
        this._traverseParent = traverseParent;
    }

    _createClass(TrackBindingPlugin, [{
        key: "listen",
        value: function listen(callback) {
            var rootElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

            if (typeof callback !== "function") {
                throw new Error("callback needs to be a function.");
            }

            if (rootElement && rootElement.nodeType !== 1) {
                throw new Error("rootElement needs to be a valid node element.");
            }

            if (this._clickHandler) {
                this.remove();
            }

            this._rootElement = rootElement;
            this._clickHandler = _EventListener2.default.listen(rootElement, "click", this._handleClick.bind(this, callback));

            return {
                target: this,
                remove: this.remove.bind(this)
            };
        }
    }, {
        key: "remove",
        value: function remove() {
            if (this._clickHandler) {
                this._clickHandler.remove();
                this._clickHandler = null;
            }
        }

        /**
         * A click handler to perform custom link tracking, any element with 'metrics-*' attribute will be tracked.
         *
         * @method _handleClick
         * @param {Object} event
         * @private
         */

    }, {
        key: "_handleClick",
        value: function _handleClick(callback, event) {
            if (isModifiedEvent(event) || !isLeftClickEvent(event)) {
                return;
            }

            var elem = event.target || event.srcElement;
            var dataset = this._getData(elem);

            if (this._traverseParent) {
                var rootElement = this._rootElement;
                while (elem !== rootElement) {
                    elem = elem.parentElement || elem.parentNode;
                    dataset = _extends({}, this._getData(elem), dataset);
                }
            }

            if (!Object.keys(dataset).length) {
                return;
            }

            var eventName = dataset && dataset.eventName;
            var mergePagedefaults = dataset && dataset.mergePagedefaults;
            delete dataset.mergePagedefaults;

            if (eventName) {
                delete dataset.eventName;
                callback(eventName, dataset, mergePagedefaults === "true");
            }
        }
    }, {
        key: "_getData",
        value: function _getData(elem) {
            return (0, _attr2obj2.default)(elem, this._attributePrefix);
        }
    }]);

    return TrackBindingPlugin;
}();

function useTrackBindingPlugin(_ref2) {
    var callback = _ref2.callback,
        rootElement = _ref2.rootElement,
        attributePrefix = _ref2.attributePrefix,
        traverseParent = _ref2.traverseParent;

    var trackBindingPlugin = new TrackBindingPlugin({
        attributePrefix: attributePrefix,
        traverseParent: traverseParent
    });
    return trackBindingPlugin.listen(callback, rootElement);
}

/***/ }),
/* 674 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.filterKeysByType = filterKeysByType;
exports.aggregateApisByType = aggregateApisByType;
exports.default = extractApis;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var EXCLUDES = ["constructor"].concat(Object.getOwnPropertyNames(Object.getPrototypeOf({})));

function filterKeysByType(obj) {
    var total = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "function";

    return Object.getOwnPropertyNames(obj).filter(function (key) {
        return total.indexOf(key) === -1 && EXCLUDES.indexOf(key) === -1 && key.indexOf("_") !== 0 && // consider it's private
        obj.hasOwnProperty(key) && _typeof(obj[key]) === type;
    });
}

function aggregateApisByType(obj) {
    var total = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var keys = [];
    while (obj !== null) {
        // eslint-disable-line no-eq-null
        var arr = filterKeysByType(obj, total);
        keys.push.apply(keys, _toConsumableArray(arr));
        obj = Object.getPrototypeOf(obj);
    }
    return keys;
}

// extracts lists of methods from each service object.
function extractApis(services) {
    services = Array.isArray(services) ? services : [services];
    var apis = services.reduce(function (total, service) {
        var obj = service.constructor === Object ? service : Object.getPrototypeOf(service);
        var keys = aggregateApisByType(obj, total);
        total.push.apply(total, _toConsumableArray(keys));
        return total;
    }, []);

    return apis;
}

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getMountedInstances = getMountedInstances;
exports.clearMountedInstances = clearMountedInstances;
exports.default = useMetrics;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ExecutionEnvironment = __webpack_require__(191);

var _hoistNonReactStatics = __webpack_require__(330);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _PropTypes = __webpack_require__(242);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mountedInstances = [];

function getMountedInstances() {
    return mountedInstances;
}

// convenient method for unit test
function clearMountedInstances() {
    mountedInstances.length = 0;
}

function getDisplayName(Comp) {
    return Comp.displayName || Comp.name || "Component";
}

function wrap(ComposedComponent) {
    var _class, _temp;

    var Metrics = (_temp = _class = function (_Component) {
        _inherits(Metrics, _Component);

        function Metrics() {
            _classCallCheck(this, Metrics);

            return _possibleConstructorReturn(this, (Metrics.__proto__ || Object.getPrototypeOf(Metrics)).apply(this, arguments));
        }

        _createClass(Metrics, [{
            key: "componentWillMount",
            value: function componentWillMount() {
                if (!_ExecutionEnvironment.canUseDOM) {
                    return;
                }

                mountedInstances.push(Metrics);
            }

            // context unit test fails w/o this, why??

        }, {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
            }
        }, {
            key: "render",
            value: function render() {
                return _react2.default.createElement(ComposedComponent, _extends({}, this.props, this.context));
            }
        }]);

        return Metrics;
    }(_react.Component), _class.displayName = "Metrics(" + getDisplayName(ComposedComponent) + ")", _class.contextTypes = {
        metrics: _PropTypes2.default.metrics
    }, _temp);

    return (0, _hoistNonReactStatics2.default)(Metrics, ComposedComponent);
}

function useMetrics() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    if (typeof args[0] === "function") {
        return wrap.apply(undefined, args);
    }

    return function (target) {
        return wrap.apply(undefined, [target].concat(args));
    };
}

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _propTypes2["default"].shape({
  subscribe: _propTypes2["default"].func.isRequired,
  dispatch: _propTypes2["default"].func.isRequired,
  getState: _propTypes2["default"].func.isRequired
});

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(342);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["b" /* routerShape */]
  },

  propTypes: {
    to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"]
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', props);
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(195);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(687);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(1582);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(98);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(348);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(1596);

var _runTransitionHook = __webpack_require__(348);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(159);

var _PathUtils = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(196);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(91);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactLifecyclesCompat = __webpack_require__(670);

var _PropTypes = __webpack_require__(693);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;

    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null // allows for nested Transitions
    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return { status: EXITED };
    }
    return null;
  };

  // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null

  //   if (prevProps !== this.props) {
  //     const { status } = this.state

  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }

  //   return { nextStatus }
  // }

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;


      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var nextStatus = arguments[1];

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func

  // Name the function so it is clearer in the documentation
} : {};function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(196);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactLifecyclesCompat = __webpack_require__(670);

var _ChildMapping = __webpack_require__(1606);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }

  /**
   * The `<TransitionGroup>` component manages a set of `<Transition>` components
   * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
   * state machine for managing the mounting and unmounting of components over
   * time.
   *
   * Consider the example below using the `Fade` CSS transition from before.
   * As items are removed or added to the TodoList the `in` prop is toggled
   * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
   * component in a `<TransitionGroup>`, not just css.
   *
   * ## Example
   *
   * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual `<Transition>`
   * components. This means you can mix and match animations across different
   * list items.
   */
};
var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var handleExited = _this.handleExited.bind(_this);

    // Initial children should all be entering, dependent on appear
    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;

    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
module.exports = exports['default'];

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(196);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var processNextTick = __webpack_require__(194);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(518);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(190).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(699);
/*</replacement>*/

// TODO(bmeurer): Change this back to const once hole checks are
// properly optimized away early in Ignition+TurboFan.
/*<replacement>*/
var Buffer = __webpack_require__(97).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(189);
util.inherits = __webpack_require__(90);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(1664);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(1615);
var destroyImpl = __webpack_require__(698);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') {
    return emitter.prependListener(event, fn);
  } else {
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
  }
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(139);

  options = options || {};

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(709).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(139);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(709).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    processNextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        processNextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    processNextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], self.emit.bind(self, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    processNextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30), __webpack_require__(59)))

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(139);

/*<replacement>*/
var util = __webpack_require__(189);
util.inherits = __webpack_require__(90);
/*</replacement>*/

util.inherits(Transform, Duplex);

function TransformState(stream) {
  this.afterTransform = function (er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
  this.writeencoding = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return stream.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined) stream.push(data);

  cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(this);

  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.once('prefinish', function () {
    if (typeof this._flush === 'function') this._flush(function (er, data) {
      done(stream, er, data);
    });else done(stream);
  });
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data !== null && data !== undefined) stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length) throw new Error('Calling transform done when ws.length != 0');

  if (ts.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var processNextTick = __webpack_require__(194);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(189);
util.inherits = __webpack_require__(90);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(1656)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(699);
/*</replacement>*/

/*<replacement>*/
var Buffer = __webpack_require__(97).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}
/*</replacement>*/

var destroyImpl = __webpack_require__(698);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(139);

  options = options || {};

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(139);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  processNextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    processNextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = _isUint8Array(chunk) && !state.objectMode;

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    processNextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    processNextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequestCount = 0;
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      processNextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), __webpack_require__(1653).setImmediate, __webpack_require__(30)))

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var processNextTick = __webpack_require__(194);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      processNextTick(emitErrorNT, this, err);
    }
    return;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      processNextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(190).EventEmitter;


/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// based on https://github.com/lodash/lodash/blob/4.17.2/lodash.js#L14100
// eslint-disable-next-line max-len
var wordPattern = /[A-Z\xc0-\xd6\xd8-\xde]?[a-z\xdf-\xf6\xf8-\xff]+(?:['’](?:d|ll|m|re|s|t|ve))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde]|$)|(?:[A-Z\xc0-\xd6\xd8-\xde]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:D|LL|M|RE|S|T|VE))?(?=[\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000]|[A-Z\xc0-\xd6\xd8-\xde](?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])|$)|[A-Z\xc0-\xd6\xd8-\xde]?(?:[a-z\xdf-\xf6\xf8-\xff]|[^\ud800-\udfff\xac\xb1\xd7\xf7\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\xbf\u2000-\u206f \t\x0b\f\xa0\ufeff\n\r\u2028\u2029\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\d+\u2700-\u27bfa-z\xdf-\xf6\xf8-\xffA-Z\xc0-\xd6\xd8-\xde])+(?:['’](?:d|ll|m|re|s|t|ve))?|[A-Z\xc0-\xd6\xd8-\xde]+(?:['’](?:D|LL|M|RE|S|T|VE))?|\d*(?:(?:1ST|2ND|3RD|(?![123])\dTH)\b)|\d*(?:(?:1st|2nd|3rd|(?![123])\dth)\b)|\d+|(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe2f\u20d0-\u20ff]|\ud83c[\udffb-\udfff])?)*/g;
var namespacer = '/';

function camelCase(string) {
  return string.match(wordPattern).reduce(function (camelCased, word, index) {
    return camelCased + (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.substring(1).toLowerCase());
  }, '');
}

/* harmony default export */ __webpack_exports__["a"] = (function (type) {
  return type.split(namespacer).map(camelCase).join(namespacer);
});

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTION_TYPE_DELIMITER; });
/* harmony export (immutable) */ __webpack_exports__["a"] = combineActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isString__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_toString__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isSymbol__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);







var ACTION_TYPE_DELIMITER = '||';

function isValidActionType(type) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isString__["a" /* default */])(type) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__["a" /* default */])(type) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isSymbol__["a" /* default */])(type);
}

function isValidActionTypes(types) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(types)) {
    return false;
  }
  return types.every(isValidActionType);
}

function combineActions() {
  for (var _len = arguments.length, actionsTypes = Array(_len), _key = 0; _key < _len; _key++) {
    actionsTypes[_key] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_5_invariant___default()(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
  var combinedActionType = actionsTypes.map(__WEBPACK_IMPORTED_MODULE_3_lodash_es_toString__["a" /* default */]).join(ACTION_TYPE_DELIMITER);
  return { toString: function toString() {
      return combinedActionType;
    } };
}

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isNull__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);





function createAction(type) {
  var payloadCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__["a" /* default */];
  var metaCreator = arguments[2];

  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__["a" /* default */])(payloadCreator) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isNull__["a" /* default */])(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');

  var finalPayloadCreator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isNull__["a" /* default */])(payloadCreator) || payloadCreator === __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0_lodash_es_identity__["a" /* default */] : function (head) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return head instanceof Error ? head : payloadCreator.apply(undefined, [head].concat(args));
  };

  var hasMeta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isFunction__["a" /* default */])(metaCreator);
  var typeString = type.toString();

  var actionCreator = function actionCreator() {
    var payload = finalPayloadCreator.apply(undefined, arguments);
    var action = { type: type };

    if (payload instanceof Error) {
      action.error = true;
    }

    if (payload !== undefined) {
      action.payload = payload;
    }

    if (hasMeta) {
      action.meta = metaCreator.apply(undefined, arguments);
    }

    return action;
  };

  actionCreator.toString = function () {
    return typeString;
  };

  return actionCreator;
}

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return defaultNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return flattenActionMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return flattenReducerMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return unflattenActionCreators; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camelCase__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ownKeys__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isMap__ = __webpack_require__(334);






var defaultNamespace = '/';

function get(key, x) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isMap__["a" /* default */])(x) ? x.get(key) : x[key];
}

var flattenWhenNode = function flattenWhenNode(predicate) {
  return function flatten(map) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$namespace = _ref.namespace,
        namespace = _ref$namespace === undefined ? defaultNamespace : _ref$namespace,
        prefix = _ref.prefix;

    var partialFlatMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var partialFlatActionType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

    function connectNamespace(type) {
      return partialFlatActionType ? '' + partialFlatActionType + namespace + type : type;
    }

    function connectPrefix(type) {
      if (partialFlatActionType || !prefix) {
        return type;
      }

      return '' + prefix + namespace + type;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ownKeys__["a" /* default */])(map).forEach(function (type) {
      var nextNamespace = connectPrefix(connectNamespace(type));
      var mapValue = get(type, map);

      if (!predicate(mapValue)) {
        partialFlatMap[nextNamespace] = mapValue;
      } else {
        flatten(mapValue, { namespace: namespace, prefix: prefix }, partialFlatMap, nextNamespace);
      }
    });

    return partialFlatMap;
  };
};

var flattenActionMap = flattenWhenNode(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__["a" /* default */]);
var flattenReducerMap = flattenWhenNode(function (node) {
  return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__["a" /* default */])(node) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isMap__["a" /* default */])(node)) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hasGeneratorInterface__["a" /* default */])(node);
});

function unflattenActionCreators(flatActionCreators) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$namespace = _ref2.namespace,
      namespace = _ref2$namespace === undefined ? defaultNamespace : _ref2$namespace,
      prefix = _ref2.prefix;

  function unflatten(flatActionType) {
    var partialNestedActionCreators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var partialFlatActionTypePath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var nextNamespace = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__camelCase__["a" /* default */])(partialFlatActionTypePath.shift());
    if (partialFlatActionTypePath.length) {
      if (!partialNestedActionCreators[nextNamespace]) {
        partialNestedActionCreators[nextNamespace] = {};
      }
      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
    } else {
      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
    }
  }

  var nestedActionCreators = {};
  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
    var unprefixedType = prefix ? type.replace('' + prefix + namespace, '') : type;
    return unflatten(type, nestedActionCreators, unprefixedType.split(namespace));
  });

  return nestedActionCreators;
}



/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleAction;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isFunction__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_identity__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isUndefined__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_includes__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__combineActions__ = __webpack_require__(701);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();










function handleAction(type) {
  var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_2_lodash_es_identity__["a" /* default */];
  var defaultState = arguments[2];

  var types = type.toString().split(__WEBPACK_IMPORTED_MODULE_7__combineActions__["b" /* ACTION_TYPE_DELIMITER */]);
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isUndefined__["a" /* default */])(defaultState), 'defaultState for reducer handling ' + types.join(', ') + ' should be defined');
  __WEBPACK_IMPORTED_MODULE_6_invariant___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isFunction__["a" /* default */])(reducer) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(reducer), 'Expected reducer to be a function or object with next and throw reducers');

  var _ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isFunction__["a" /* default */])(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(aReducer) ? __WEBPACK_IMPORTED_MODULE_2_lodash_es_identity__["a" /* default */] : aReducer;
  }),
      _ref2 = _slicedToArray(_ref, 2),
      nextReducer = _ref2[0],
      throwReducer = _ref2[1];

  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];
    var actionType = action.type;

    if (!actionType || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_includes__["a" /* default */])(types, actionType.toString())) {
      return state;
    }

    return (action.error === true ? throwReducer : nextReducer)(state, action);
  };
}

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var VIDEO = exports.VIDEO = "Video";
var IMAGE = exports.IMAGE = "Image";

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(97).Buffer;

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return -1;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd'.repeat(p);
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd'.repeat(p + 1);
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd'.repeat(p + 2);
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character for each buffered byte of a (partial)
// character needs to be added to the output.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd'.repeat(this.lastTotal - this.lastNeed);
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 710 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([bth[buf[i++]], bth[buf[i++]], 
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]], '-',
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]],
	bth[buf[i++]], bth[buf[i++]]]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 711 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {

var Transform = __webpack_require__(245).Transform
var duplexify = __webpack_require__(1354)
var WS = __webpack_require__(1660)
var Buffer = __webpack_require__(97).Buffer

module.exports = WebSocketStream

function buildProxy (options, socketWrite, socketEnd) {
  var proxy = new Transform({
    objectMode: options.objectMode
  })

  proxy._write = socketWrite
  proxy._flush = socketEnd

  proxy._destroy = function(err, cb) {
    var self = this
    this.push(null)
    this.end()
    process.nextTick(function() {
      cb(err);
      self.emit('close')
    })
  }

  return proxy
}

function WebSocketStream(target, protocols, options) {
  var stream, socket

  var isBrowser = process.title === 'browser'
  var isNative = !!global.WebSocket
  var socketWrite = isBrowser ? socketWriteBrowser : socketWriteNode

  if (protocols && !Array.isArray(protocols) && 'object' === typeof protocols) {
    // accept the "options" Object as the 2nd argument
    options = protocols
    protocols = null

    if (typeof options.protocol === 'string' || Array.isArray(options.protocol)) {
      protocols = options.protocol;
    }
  }

  if (!options) options = {}

  if (options.objectMode === undefined) {
    options.objectMode = !(options.binary === true || options.binary === undefined)
  }

  var proxy = buildProxy(options, socketWrite, socketEnd)

  if (!options.objectMode) {
    proxy._writev = writev
  }

  // browser only: sets the maximum socket buffer size before throttling
  var bufferSize = options.browserBufferSize || 1024 * 512

  // browser only: how long to wait when throttling
  var bufferTimeout = options.browserBufferTimeout || 1000

  // use existing WebSocket object that was passed in
  if (typeof target === 'object') {
    socket = target
  // otherwise make a new one
  } else {
    // special constructor treatment for native websockets in browsers, see
    // https://github.com/maxogden/websocket-stream/issues/82
    if (isNative && isBrowser) {
      socket = new WS(target, protocols)
    } else {
      socket = new WS(target, protocols, options)
    }

    socket.binaryType = 'arraybuffer'
  }

  // was already open when passed in
  if (socket.readyState === socket.OPEN) {
    stream = proxy
  } else {
    stream = duplexify.obj()
    socket.onopen = onopen
  }

  stream.socket = socket

  socket.onclose = onclose
  socket.onerror = onerror
  socket.onmessage = onmessage

  proxy.on('close', destroy)

  var coerceToBuffer = !options.objectMode

  function socketWriteNode(chunk, enc, next) {
    // avoid errors, this never happens unless
    // destroy() is called
    if (socket.readyState !== socket.OPEN) {
      next()
      return
    }

    if (coerceToBuffer && typeof chunk === 'string') {
      chunk = new Buffer(chunk, 'utf8')
    }
    socket.send(chunk, next)
  }

  function socketWriteBrowser(chunk, enc, next) {
    if (socket.bufferedAmount > bufferSize) {
      setTimeout(socketWriteBrowser, bufferTimeout, chunk, enc, next)
      return
    }

    if (coerceToBuffer && typeof chunk === 'string') {
      chunk = new Buffer(chunk, 'utf8')
    }

    try {
      socket.send(chunk)
    } catch(err) {
      return next(err)
    }

    next()
  }

  function socketEnd(done) {
    socket.close()
    done()
  }

  function onopen() {
    stream.setReadable(proxy)
    stream.setWritable(proxy)
    stream.emit('connect')
  }

  function onclose() {
    stream.end()
    stream.destroy()
  }

  function onerror(err) {
    stream.destroy(err)
  }

  function onmessage(event) {
    var data = event.data
    if (data instanceof ArrayBuffer) data = Buffer.from(data)
    else data = Buffer.from(data, 'utf8')
    proxy.push(data)
  }

  function destroy() {
    socket.close()
  }

  // this is to be enabled only if objectMode is false
  function writev (chunks, cb) {
    var buffers = new Array(chunks.length)
    for (var i = 0; i < chunks.length; i++) {
      if (typeof chunks[i].chunk === 'string') {
        buffers[i] = Buffer.from(chunks[i], 'utf8')
      } else {
        buffers[i] = chunks[i].chunk
      }
    }

    this._write(Buffer.concat(buffers), 'binary', cb)
  }

  return stream
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59), __webpack_require__(30)))

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(91);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _store = __webpack_require__(1050);

var _store2 = _interopRequireDefault(_store);

var _ApiClient = __webpack_require__(64);

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _reactRedux = __webpack_require__(17);

var _reactRouter = __webpack_require__(11);

var _reactRouterRedux = __webpack_require__(138);

var _reduxConnect = __webpack_require__(351);

var _routeUtils = __webpack_require__(38);

var _localStorage = __webpack_require__(249);

var _localStorage2 = _interopRequireDefault(_localStorage);

var _routes = __webpack_require__(1051);

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialData = window.__data;
var client = new _ApiClient2.default();
var dest = document.getElementById('clientContent');

//bucket id for canary
if (initialData.common.canary && initialData.common.canary.featureGroups) {

  //check for local stored bucket
  var localStorage = new _localStorage2.default();
  var bucketId = localStorage.getValue('bucketId');
  if (!bucketId) {
    bucketId = Math.floor(Math.random() * initialData.common.canary.maxBucketIds) + 1;
    localStorage.setValue('bucketId', bucketId);
  }

  initialData.common.canary.bucketId = bucketId;

  //set feature flags
  var featureGroups = initialData.common.canary.featureGroups;
  var featuresToSet = (0, _keys2.default)(featureGroups).reduce(function (toSet, key) {
    if (featureGroups[key].featureNames && featureGroups[key].bucketIds.includes(bucketId)) {
      toSet = [].concat((0, _toConsumableArray3.default)(toSet), (0, _toConsumableArray3.default)(featureGroups[key].featureNames));
    }
    return toSet;
  }, []);
  localStorage.setValue('features', featuresToSet);
}

var store = (0, _store2.default)(_reactRouter.browserHistory, client, initialData);
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
var component = _react2.default.createElement(
  _reactRouter.Router,
  { render: function render(props) {
      return _react2.default.createElement(_reduxConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, { helpers: { client: client }, filter: function filter(item) {
          return !item.deferred;
        } }));
    }, history: history },
  (0, _routes2.default)()
);

_reactDom2.default.hydrate(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store, key: 'provider' },
  component
), dest);

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(1262);

__webpack_require__(1263);

__webpack_require__(1063);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);
//# sourceMappingURL=hash.esm.js.map


/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);
//# sourceMappingURL=memoize.esm.js.map


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.getLayout = getLayout;
exports.preventLoadData = preventLoadData;

var _layouts = __webpack_require__(901);

var _layouts2 = _interopRequireDefault(_layouts);

var _layouts3 = __webpack_require__(854);

var _layouts4 = _interopRequireDefault(_layouts3);

var _layouts5 = __webpack_require__(976);

var _layouts6 = _interopRequireDefault(_layouts5);

var _layouts7 = __webpack_require__(892);

var _layouts8 = _interopRequireDefault(_layouts7);

var _layouts9 = __webpack_require__(993);

var _layouts10 = _interopRequireDefault(_layouts9);

var _layouts11 = __webpack_require__(1033);

var _layouts12 = _interopRequireDefault(_layouts11);

var _layouts13 = __webpack_require__(1019);

var _layouts14 = _interopRequireDefault(_layouts13);

var _layouts15 = __webpack_require__(812);

var _layouts16 = _interopRequireDefault(_layouts15);

var _layoutUtils = __webpack_require__(176);

var _commonUtils = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cricketPageLayouts = (0, _layoutUtils.genericSportLayout)('cricket');
var dartsPageLayouts = (0, _layoutUtils.genericSportLayout)('darts');
var golfPageLayouts = (0, _layoutUtils.genericSportLayout)('golf');
var boxingPageLayouts = (0, _layoutUtils.genericSportLayout)('boxing');
var formula1PageLayouts = (0, _layoutUtils.genericSportLayout)('formula1');
var nflPageLayouts = (0, _layoutUtils.genericSportLayout)('nfl');
var rugbyLeaguePageLayouts = (0, _layoutUtils.genericSportLayout)('rugby-league');
var rugbyUnionPageLayouts = (0, _layoutUtils.genericSportLayout)('rugby-union');
var snookerPageLayouts = (0, _layoutUtils.genericSportLayout)('snooker');
var tennisPageLayouts = (0, _layoutUtils.genericSportLayout)('tennis');
var otherSportsPageLayouts = (0, _layoutUtils.genericSportLayout)('other-sports');

var layouts = (0, _extends3.default)({}, _layouts2.default, _layouts4.default, _layouts6.default, _layouts8.default, cricketPageLayouts, dartsPageLayouts, golfPageLayouts, rugbyLeaguePageLayouts, rugbyUnionPageLayouts, tennisPageLayouts, boxingPageLayouts, formula1PageLayouts, snookerPageLayouts, nflPageLayouts, otherSportsPageLayouts, _layouts14.default, _layouts16.default, _layouts10.default, _layouts12.default);

/*
  Arguments are provided by LayoutManager. All are mandatory
    layout is possibly via a connection to Redux
    context is an object containing useful contextual data, such as `params` or the entire redux `state`
    path is the parametrised routing path of the page

*/
function getLayout(layout, context, path) {
  /*
   layoutComponents will either be an object with the following properties, or a function that returns one.
   section:
    This is mainly used for the GPT ads. It is optional and if omitted will default to the "sport" part of the URL
   bannerAd:
    The main (GPT served) advert that sits full width immediately underneath the header
    An object with `adUnitPath` and `type` properties
   leaderboardAd:
    Fresh 8 advert that is fixed to the bottom of the screen on Mobile
    An object with a `view` property
   components:
    will be an array of component specification objects, each of which has the following structure
     component:
      a mandatory string giving the component name, as specified in the routing for the relevant page
     props:
      optional object of props to send to the instatiated component
     desktopColumn:
      a string containing "left" or "right" to indicate which column the component shoudl appear in for desktop layout.
      Optional, defaulting to "left" if omitted (or indeed, if set to anything other than "right")
     desktopOrder:
    handheldOrder:
      These can be a number, boolean false, or omitted. It indicates the display order for the relevant layout.
      Ordering is done by CSS Flexbox.
      If a number is given, the compnent will be given it as a CSS order propery.
      If omitted the component will not have a CSS order property. If you mix components
        with and without an order, you might not get the results you want.
      If boolean false is given, the component will be hidden with display: false;
   */

  var layoutComponents = layouts[path];

  if (typeof layoutComponents == 'function') {
    return layoutComponents(layout, context);
  } else {
    return layoutComponents;
  }
}

function preventLoadData(component, context) {
  var state = context.state,
      routes = context.routes;

  var path = (0, _commonUtils.buildPath)(routes);

  var layout = state.common.layout && state.common.layout[path] && state.common.layout[path].layout;

  if (!layout) {
    return false;
  }

  var components = getLayout(layout, context, path).components;

  return !components.some(function (someComponent) {
    return someComponent.component == component;
  });
}

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(11);

var _reactRedux = __webpack_require__(17);

var _reactHelmet = __webpack_require__(156);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _skysso = __webpack_require__(72);

var _LoginLightboxContainer = __webpack_require__(777);

var _LoginLightboxContainer2 = _interopRequireDefault(_LoginLightboxContainer);

var _MyStableLightboxContainer = __webpack_require__(778);

var _MyStableLightboxContainer2 = _interopRequireDefault(_MyStableLightboxContainer);

var _JsonLD = __webpack_require__(164);

var _JsonLD2 = _interopRequireDefault(_JsonLD);

var _withAnalytics = __webpack_require__(1058);

var _withAnalytics2 = _interopRequireDefault(_withAnalytics);

var _mediaQueryHelpers = __webpack_require__(440);

var _pageTranstition = __webpack_require__(260);

var _features = __webpack_require__(65);

var _seoUtils = __webpack_require__(23);

var _InsiderNotification = __webpack_require__(992);

var _InsiderNotification2 = _interopRequireDefault(_InsiderNotification);

var _CookieNotice = __webpack_require__(774);

var _CookieNotice2 = _interopRequireDefault(_CookieNotice);

var _Footer = __webpack_require__(734);

var _Footer2 = _interopRequireDefault(_Footer);

var _SplashContainer = __webpack_require__(747);

var _SplashContainer2 = _interopRequireDefault(_SplashContainer);

var _StickyMenu = __webpack_require__(748);

var _StickyMenu2 = _interopRequireDefault(_StickyMenu);

var _Lightbox = __webpack_require__(358);

var _FeedbackForm = __webpack_require__(775);

var _FeedbackForm2 = _interopRequireDefault(_FeedbackForm);

var _feedbackForm = __webpack_require__(161);

var _betslip = __webpack_require__(205);

var _menuUtils = __webpack_require__(441);

var _smoothscrollPolyfill = __webpack_require__(1633);

var _smoothscrollPolyfill2 = _interopRequireDefault(_smoothscrollPolyfill);

var _PopOutPlayer = __webpack_require__(435);

var _PopOutPlayer2 = _interopRequireDefault(_PopOutPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MENU_OPEN_CLASS = " main-nav-open";

function getClosestRouteProperty(props, propertyName, defaultValue) {
  return props.routes.reduce(function (prev, curr) {
    return curr.hasOwnProperty(propertyName) ? curr[propertyName] : prev;
  }, defaultValue);
}

var App = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    queuedBetLinks: state.common.betlink.queue,
    pageTranstition: state.common.pageTranstition,
    loggedIn: state.common.auth.loggedIn,
    showFeedbackForm: state.common.display.feedbackForm.show
  };
}), _dec(_class = (0, _withAnalytics2.default)(_class = (0, _reactRouter.withRouter)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    var _ref;

    (0, _classCallCheck3.default)(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref, [this].concat(args)));

    _this.subnav = function () {
      // find the subnav component from the last route to have one defined, if any
      // ie find the subnav that's closest to the route in play
      return getClosestRouteProperty(_this.props, "subnav", undefined);
    };

    _this.toggleMainMenu = function (e) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !_this.state.mainMenuOpen;

      var allSportClicked = false;

      if (e) {
        if (e.target.getAttribute("target") !== "_blank") {
          e.preventDefault();
        }

        allSportClicked = e.target.hasAttribute("data-keep-menu-open");
      }

      var newState = {
        mainMenuOpen: state || allSportClicked,
        subNavOpen: false,
        subNavMoreOpen: false
      };

      if (!allSportClicked) {
        newState.allSportsOpen = false;
      }

      _this.setState(newState);

      _this.removeHTMLMenuOpenClass();

      if (_this.clickToCloseAll(newState.mainMenuOpen)) {
        _this.addHTMLMenuOpenClass();
      }
    };

    _this.toggleSubNav = function (e) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !_this.state.subNavOpen;

      _this.setState({
        mainMenuOpen: false,
        subNavOpen: state,
        allSportsOpen: false,
        subNavMoreOpen: false
      });

      _this.removeHTMLMenuOpenClass();
      _this.clickToCloseAll(state);
    };

    _this.toggleAllSports = function (e) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !_this.state.allSportsOpen;

      e && e.preventDefault();
      _this.setState({
        allSportsOpen: state,
        subNavMoreOpen: false
      });
    };

    _this.toggleSubNavMore = function (e) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !_this.state.subNavMoreOpen;

      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        subNavMoreOpen: state,
        allSportsOpen: false
      });

      _this.clickToCloseAll(state);
    };

    _this.handleOpenFeedbackForm = function (event) {
      //stop a tag event from adding href to location etc..
      event.preventDefault();
      _this.props.dispatch((0, _feedbackForm.showFeedbackForm)(true));
    };

    _this.state = {
      featureClasses: [],
      betCount: 0, // only relevant for feature "integrated-betslip", leaving it zero for feature off ensures it's never displayed
      mainMenuOpen: false,
      subNavOpen: false,
      allSportsOpen: false,
      subNavMoreOpen: false,
      suppressStickyMenu: true,
      JsonLD: {
        "@type": "Organization",
        "@id": "https://www.sportinglife.com",
        name: "Sporting Life",
        legalName: _config2.default.structuredData.legalName,
        url: "https://www.sportinglife.com",
        logo: "https://www.sportinglife.com/logo.jpg",
        foundingDate: _config2.default.structuredData.founded,
        address: {
          "@type": "PostalAddress",
          streetAddress: _config2.default.structuredData.streetAddress,
          addressLocality: _config2.default.structuredData.city,
          addressRegion: _config2.default.structuredData.region,
          postalCode: _config2.default.structuredData.postalCode,
          addressCountry: "UK"
        },
        contactPoint: {
          "@type": "ContactPoint",
          contactType: "customer support",
          email: _config2.default.structuredData.email,
          url: "https://www.sportinglife.com"
        },
        "sameAs": ["https://www.facebook.com/SportingLifeOfficial", "https://twitter.com/SportingLife", "https://soundcloud.com/sportinglife", "https://en.wikipedia.org/wiki/Sporting_Life_(British_newspaper)", "https://www.wikidata.org/wiki/Q7579580"]
      }
    };

    _this.removeDocumentClickToCloseAll = function () {}; // initial noop, gets reassigned by addDocumentClickToCloseAll
    // initial noops that get reassigned in componentDidMount
    _this.unwatchTablet = function () {};
    return _this;
  }

  (0, _createClass3.default)(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.props.dispatch((0, _skysso.bindToSSO)());
      this.props.dispatch((0, _pageTranstition.setBusy)(false));
      this.unwatchTablet = (0, _mediaQueryHelpers.watchMediaQuery)("tablet", function () {
        _this2.toggleSubNav(null, false); // Always close when the breakpoint changes, closing the subnav closes all menus
      });

      if ('serviceWorker' in navigator) {
        if (navigator.serviceWorker) {
          navigator.serviceWorker.register('/service-worker.js', { scope: '/' }).then(function (registration) {
            if (!_config2.default.serviceWorkerEnabled) {
              registration.unregister();
            }
          }).catch(function () {});
        }
      }

      _smoothscrollPolyfill2.default.polyfill();

      this.setState((0, _extends3.default)({}, this.state, { featureClasses: (0, _features.getEnabledFeatures)().map(function (f) {
          return f + '-feature';
        }) }));

      // If the app lives for 24 hours, reload it
      window.setTimeout(function () {
        location.reload();
      }, 86400000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unwatchTablet();

      // only relevant for feature "integrated-betslip"
      this.props.dispatch((0, _betslip.destructBetslip)());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.pageTranstition.busy === true && nextProps.pageTranstition.busy === true) {
        // Only set busy to false if it's currently true, and this update doesn't change it
        // (setting busy would also call componentWillReceiveProps, so checking for a change makes sure this update was caused by a different prop)
        // This way the dispatch wont be duplicated
        this.props.dispatch((0, _pageTranstition.setBusy)(false));
      }

      this.props.dispatch((0, _skysso.updateLoginState)());

      this.toggleMainMenu(null, false);

      var routePreventScroll = getClosestRouteProperty(nextProps, "preventScroll", false);

      // location state might be null, so easiest is to split the destructuring in two
      var _nextProps$location = nextProps.location;
      _nextProps$location = _nextProps$location === undefined ? {} : _nextProps$location;
      var locationState = _nextProps$location.state;

      var _ref2 = locationState || {},
          _ref2$preventScroll = _ref2.preventScroll,
          linkPreventedScroll = _ref2$preventScroll === undefined ? false : _ref2$preventScroll;

      if (!(routePreventScroll || linkPreventedScroll) && !nextProps.pageTranstition.busy) {
        this.toDefaultLocation();
      }
    }
  }, {
    key: 'hideMenu',
    value: function hideMenu() {
      var stickyMenu = (0, _menuUtils.getStickyMenu)();
      if (stickyMenu) {
        stickyMenu.style.top = -stickyMenu.clientHeight + 'px';
      }
    }
  }, {
    key: 'addDocumentClickToCloseAll',
    value: function addDocumentClickToCloseAll() {
      var _this3 = this;

      this.removeDocumentClickToCloseAll(); // remove any existing - there can be only one

      var closeAll = function closeAll(e) {
        return _this3.toggleMainMenu(e, false);
      }; // unique new function for this time

      document.addEventListener("click", closeAll, false); // add it

      this.removeDocumentClickToCloseAll = function () {
        return document.removeEventListener("click", closeAll);
      }; // store a function to remove it
    }
  }, {
    key: 'html',
    value: function html() {
      // memoise the value
      this.htmlElement = this.htmlElement || document.getElementsByTagName("html")[0];
      return this.htmlElement;
    }
  }, {
    key: 'addHTMLMenuOpenClass',
    value: function addHTMLMenuOpenClass() {
      this.html().className += MENU_OPEN_CLASS;
    }
  }, {
    key: 'removeHTMLMenuOpenClass',
    value: function removeHTMLMenuOpenClass() {
      this.html().className = this.html().className.replace(MENU_OPEN_CLASS, "");
    }
  }, {
    key: 'toTop',
    value: function toTop(e) {
      e && e.preventDefault();
      window.scrollTo(0, 0);
    }
  }, {
    key: 'toTopSmooth',
    value: function toTopSmooth(e) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });

      e.preventDefault();
    }
  }, {
    key: 'toDefaultLocation',
    value: function toDefaultLocation() {
      var hash = window.location.hash;

      if (hash !== '') {
        var id = hash.replace('#', '');
        this.setState({ suppressStickyMenu: true });
        this.hideMenu();
        var element = id != null ? document.getElementById(id) : null;
        if (element) {
          element.scrollIntoView();
        } else {
          this.toTop();
        }
      } else {
        this.toTop();
      }
    }
  }, {
    key: 'clickToCloseAll',
    value: function clickToCloseAll(state) {
      if (state) {
        this.addDocumentClickToCloseAll();
      } else {
        this.removeDocumentClickToCloseAll();
      }

      return state;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      __webpack_require__(1358);

      var LocalSubNav = this.subnav();

      // Doing props this way is only relevant for feature integrated-betslip
      // so that the class can be dynamically added
      // The class will be irrelevant once the feature is stripped, either way, so you can remove it

      var contentProps = {
        id: "content"
      };

      if (LocalSubNav) {
        contentProps.className = "withSubnav";
      } else {
        contentProps.className = "noSubnav";
      }

      if ((0, _features.has)("integrated-betslip")) {
        contentProps.className += " integrated-betslip";
      }

      // end of integrated-betslip block
      return _react2.default.createElement(
        'div',
        { id: 'container', className: this.state.featureClasses.join(' ') },
        _react2.default.createElement(_reactHelmet2.default, (0, _extends3.default)({
          titleTemplate: _seoUtils.titleTemplate.plain,
          defaultTitle: _config2.default.pageTitle.default + ' - ' + _config2.default.pageTitle.mainSuffix
        }, (0, _seoUtils.canonicalLink)(this.props.routes))),
        _react2.default.createElement(_JsonLD2.default, { data: this.state.JsonLD }),
        this.props.pageTranstition.busy && _react2.default.createElement('div', { className: 'pageTranstition' }),
        _react2.default.createElement('div', { id: 'mobile-bet-basket' }),
        _react2.default.createElement(_StickyMenu2.default, {
          subnav: LocalSubNav,
          location: this.props.location,
          loggedIn: this.props.loggedIn,
          router: this.props.router,
          featureClasses: this.state.featureClasses,
          toggleMainMenu: this.toggleMainMenu,
          mainMenuOpen: this.state.mainMenuOpen,
          allSportsOpen: this.state.allSportsOpen,
          subNavOpen: this.state.subNavOpen,
          subNavMoreOpen: this.state.subNavMoreOpen,
          toggleSubNav: this.toggleSubNav,
          toggleSubNavMore: this.toggleSubNavMore,
          toggleAllSports: this.toggleAllSports,
          navConfig: _config2.default.nav
        }),
        _react2.default.createElement(_LoginLightboxContainer2.default, null),
        _react2.default.createElement(_MyStableLightboxContainer2.default, null),
        _react2.default.createElement(
          'section',
          contentProps,
          _react2.default.createElement(_InsiderNotification2.default, null),
          _react2.default.createElement(_CookieNotice2.default, { policyLink: _config2.default.cookiePolicy.policyLink }),
          _react2.default.createElement(_SplashContainer2.default, null),
          this.props.children
        ),
        this.props.showFeedbackForm && _react2.default.createElement(
          'section',
          { className: 'feedback-lightbox' },
          _react2.default.createElement(
            _Lightbox.Lightbox,
            { title: 'Sporting Life Feedback', close: function close() {
                return _this4.props.dispatch((0, _feedbackForm.showFeedbackForm)(false));
              } },
            _react2.default.createElement(_FeedbackForm2.default, null)
          )
        ),
        _react2.default.createElement(
          'div',
          { id: 'footer' },
          _react2.default.createElement(_Footer2.default, { handleOpenFeedbackForm: this.handleOpenFeedbackForm, handleScrollTop: this.toTopSmooth })
        ),
        _react2.default.createElement(_PopOutPlayer2.default, null)
      );
    }
  }]);
  return App;
}(_react.Component), _class2.propTypes = {
  children: _propTypes2.default.node.isRequired,
  routes: _propTypes2.default.array.isRequired,
  router: _propTypes2.default.object.isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string.isRequired
  }).isRequired,
  dispatch: _propTypes2.default.func.isRequired,
  queuedBetLinks: _propTypes2.default.array,
  pageTranstition: _propTypes2.default.shape({
    busy: _propTypes2.default.bool.isRequired
  }).isRequired,
  loggedIn: _propTypes2.default.bool,
  showFeedbackForm: _propTypes2.default.bool.isRequired
}, _temp)) || _class) || _class) || _class);
exports.default = App;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BoxingHomePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(BoxingHomePage, _Component);

  function BoxingHomePage() {
    (0, _classCallCheck3.default)(this, BoxingHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (BoxingHomePage.__proto__ || (0, _getPrototypeOf2.default)(BoxingHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(BoxingHomePage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: 'boxing',
        title: 'Boxing News & Betting Odds',
        location: location
      });
    }
  }]);
  return BoxingHomePage;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node
}, _temp);
exports.default = BoxingHomePage;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BoxingNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "Boxing",
    links: [{ href: "/boxing", text: "News", isIndex: true }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

BoxingNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = BoxingNav;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routeUtils = __webpack_require__(38);

var _BoxingHomePage = __webpack_require__(721);

var _BoxingHomePage2 = _interopRequireDefault(_BoxingHomePage);

var _BoxingNav = __webpack_require__(722);

var _BoxingNav2 = _interopRequireDefault(_BoxingNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _routeUtils.genericRoute)(_BoxingHomePage2.default, _BoxingNav2.default, 'boxing');

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SET_CANARY_CONFIG = exports.SET_CANARY_CONFIG = "SET_CANARY_CONFIG";

var setCanaryFeatures = exports.setCanaryFeatures = function setCanaryFeatures(config) {
    return { type: SET_CANARY_CONFIG, data: config };
};

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LOAD_FAIL = exports.LOAD_SUCCESS = exports.LOAD = undefined;
exports.default = fetchMetadata;

var _ApiClient = __webpack_require__(64);

var _ApiClient2 = _interopRequireDefault(_ApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = exports.LOAD = 'common/metaData/LOAD';
var LOAD_SUCCESS = exports.LOAD_SUCCESS = 'common/metaData/SUCCESS';
var LOAD_FAIL = exports.LOAD_FAIL = 'common/metaData/FAILURE';

var apiClient = new _ApiClient2.default();

function fetchMetadata() {
    return {
        types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
        promise: function promise() {
            return apiClient.get('api/cms-app/pagemetadata');
        }
    };
}

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POST_METHOD = "POST";
var GET_METHOD = "GET";

exports.default = function (apiClient, endpoints, handlers) {
    var apiRequest = function apiRequest(method, endpoint) {
        var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var content = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        switch (method) {
            case POST_METHOD:
                return apiClient.post(endpoint, { data: content }, headers);
            case GET_METHOD:
                return apiClient.get(endpoint, {}, headers);
            default:
                return _promise2.default.reject('invalid requestType');
        }
    };

    //combined obj of all api request handlers (indexed by action type) 
    var requestHandlers = handlers.reduce(function (groupedHandlers, handler) {
        return (0, _extends3.default)({}, groupedHandlers, handler(apiRequest, endpoints));
    }, {});

    return function (action, store) {
        if (requestHandlers[action.type]) {
            return requestHandlers[action.type](action, store);
        }
    };
};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _feedbackForm = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (apiRequest, endpoints) {

    return (0, _defineProperty3.default)({}, _feedbackForm.SEND_FEEDBACK, sendFeedback);

    function sendFeedback(action, store) {
        if (!action.data) {
            return;
        }
        var _action$data = action.data,
            _action$data$feedback = _action$data.feedbackType,
            feedbackType = _action$data$feedback === undefined ? null : _action$data$feedback,
            _action$data$feedback2 = _action$data.feedbackText,
            feedbackText = _action$data$feedback2 === undefined ? null : _action$data$feedback2,
            _action$data$feedback3 = _action$data.feedbackRating,
            feedbackRating = _action$data$feedback3 === undefined ? null : _action$data$feedback3,
            _action$data$feedback4 = _action$data.feedbackRecaptcha,
            feedbackRecaptcha = _action$data$feedback4 === undefined ? null : _action$data$feedback4,
            _action$data$currentU = _action$data.currentUrl,
            currentUrl = _action$data$currentU === undefined ? null : _action$data$currentU,
            _action$data$userAgen = _action$data.userAgent,
            userAgent = _action$data$userAgen === undefined ? null : _action$data$userAgen,
            _action$data$username = _action$data.username,
            username = _action$data$username === undefined ? null : _action$data$username;
        var _endpoints$common = endpoints.common;
        _endpoints$common = _endpoints$common === undefined ? {} : _endpoints$common;
        var _endpoints$common$use = _endpoints$common.userService;
        _endpoints$common$use = _endpoints$common$use === undefined ? {} : _endpoints$common$use;
        var _endpoints$common$use2 = _endpoints$common$use.feedback,
            feedbackEndpoint = _endpoints$common$use2 === undefined ? '' : _endpoints$common$use2;


        if (![feedbackType, feedbackText, feedbackRating, feedbackRecaptcha, currentUrl, userAgent].includes(null) && feedbackEndpoint) {
            var requestBody = {
                current_url: currentUrl,
                feedback: feedbackText,
                feedback_score: feedbackRating,
                feedback_type: feedbackType,
                user_agent: userAgent
            };
            if (username) {
                requestBody["username"] = username;
            }

            apiRequest("POST", feedbackEndpoint, { recaptchatoken: feedbackRecaptcha }, requestBody).then(function () {
                store.dispatch({ type: _feedbackForm.SEND_FEEDBACK_SUCCESS });
            }).catch(function () {
                store.dispatch({ type: _feedbackForm.SEND_FEEDBACK_FAILED });
            });
        } else {
            store.dispatch({ type: _feedbackForm.SEND_FEEDBACK_FAILED });
        }
    }
};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Notification = __webpack_require__(359);

var _Notification2 = _interopRequireDefault(_Notification);

var _reactRouter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1364);

var PureCookieNotice = function (_PureComponent) {
    (0, _inherits3.default)(PureCookieNotice, _PureComponent);

    function PureCookieNotice() {
        var _ref;

        (0, _classCallCheck3.default)(this, PureCookieNotice);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = PureCookieNotice.__proto__ || (0, _getPrototypeOf2.default)(PureCookieNotice)).call.apply(_ref, [this].concat(args)));

        _this.state = {
            show: false
        };

        _this.onDismiss = _this.onDismiss.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(PureCookieNotice, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.fetchHasAcceptedPolicy();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (!newProps.accepted) {
                this.setState({ show: true });
            }
        }
    }, {
        key: 'onDismiss',
        value: function onDismiss() {
            this.setState({ show: false });
            this.props.acceptCookiePolicy();
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.show) {
                return null;
            }

            return _react2.default.createElement(
                _Notification2.default,
                { showClose: false, onDismiss: this.onDismiss, className: 'cookie-notice' },
                _react2.default.createElement(
                    'div',
                    { className: 'container row center wrap' },
                    _react2.default.createElement(
                        'p',
                        null,
                        'This website uses cookies. Cookies help us and our third party partners to provide, protect and improve our services. By visiting or using this website, you consent to the use of cookies in accordance with our ',
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: this.props.policyLink },
                            'Cookies policy'
                        ),
                        ', which includes details of ',
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: this.props.policyLink },
                            'how you can change your cookie settings'
                        ),
                        '.'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'actions' },
                        _react2.default.createElement(
                            'button',
                            { className: 'small-primary-button cookie-notice-accept', onClick: this.onDismiss },
                            'Accept & close'
                        )
                    )
                )
            );
        }
    }]);
    return PureCookieNotice;
}(_react.PureComponent);

exports.default = PureCookieNotice;


PureCookieNotice.propTypes = {
    acceptCookiePolicy: _propTypes2.default.func.isRequired,
    fetchHasAcceptedPolicy: _propTypes2.default.func.isRequired,
    policyLink: _propTypes2.default.string.isRequired,
    accepted: _propTypes2.default.any
};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Ellipsis;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(1367);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Ellipsis() {
  return _react2.default.createElement(
    'div',
    { className: 'ellipsis' },
    _react2.default.createElement('span', null),
    ' ',
    _react2.default.createElement('span', null),
    ' ',
    _react2.default.createElement('span', null)
  );
}

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; /* eslint react/no-danger: "off" */


var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _twitter = __webpack_require__(443);

__webpack_require__(1368);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailShareButton = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(EmailShareButton, _Component);

  function EmailShareButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EmailShareButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EmailShareButton.__proto__ || (0, _getPrototypeOf2.default)(EmailShareButton)).call.apply(_ref, [this].concat(args))), _this), _this.getHref = function () {
      var _this$props = _this.props,
          dcmp = _this$props.dcmp,
          page = _this$props.page,
          title = _this$props.title,
          firstParagraph = _this$props.firstParagraph;

      var href = dcmp ? page + '?dcmp=sl_social_email_' + dcmp : page;
      var body = firstParagraph.replace(/<.*?>/g, "") + '\n\nRead more: ' + href;

      return 'mailto:?subject=' + encodeURIComponent("Shared from Sporting Life: " + title) + '&body=' + encodeURIComponent(body);
    }, _this.handleClick = function () {
      if (_this.context.metrics) {
        _this.context.metrics.track("linkClick", { link: "[Article Share] Email" });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EmailShareButton, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      (0, _twitter.parse)(this.el);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _twitter.init)();
      (0, _twitter.parse)(this.el);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'a',
        { href: this.getHref(), onClick: this.handleClick, className: 'social-share-button-email' },
        _react2.default.createElement(
          'div',
          { className: 'social-share-button-email-image' },
          _react2.default.createElement(
            'div',
            { className: 'skycon email-icon', title: 'Email link' },
            _react2.default.createElement('img', { src: "/img/icons/envelope.svg" })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'social-share-button-email-text' },
          'Email'
        )
      );
    }
  }]);
  return EmailShareButton;
}(_react.Component), _class.contextTypes = {
  metrics: _propTypes2.default.object
}, _class.propTypes = {
  dcmp: _propTypes2.default.string,
  page: _propTypes2.default.string,
  title: _propTypes2.default.string,
  firstParagraph: _propTypes2.default.string
}, _temp2);
exports.default = EmailShareButton;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /* eslint react/no-danger: "off" */


var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__(156);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _commonUtils = __webpack_require__(36);

var _twitter = __webpack_require__(443);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var twitterTags = (0, _commonUtils.parseCssExports)(__webpack_require__(1369), { prefix: "embedded-tweet", transform: function transform(i) {
    return i;
  } });

var EmbeddedTweet = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(EmbeddedTweet, _Component);

  function EmbeddedTweet() {
    (0, _classCallCheck3.default)(this, EmbeddedTweet);
    return (0, _possibleConstructorReturn3.default)(this, (EmbeddedTweet.__proto__ || (0, _getPrototypeOf2.default)(EmbeddedTweet)).apply(this, arguments));
  }

  (0, _createClass3.default)(EmbeddedTweet, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      (0, _twitter.parse)(this.el);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      (0, _twitter.init)();
      (0, _twitter.parse)(this.el);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var helmetProps = {
        meta: []
      };

      (0, _keys2.default)(twitterTags).forEach(function (name) {
        helmetProps.meta.push({
          name: 'twitter:widgets:' + name,
          content: twitterTags[name]
        });
      });

      // Seems Twitter replaces the node, and this annoys React, so dangerouslySetInnerHTML to the rescue
      return _react2.default.createElement(
        'div',
        { className: 'embedded-tweet' },
        _react2.default.createElement(_reactHelmet2.default, helmetProps),
        _react2.default.createElement('div', {
          ref: function ref(el) {
            _this2.el = el;
          },
          dangerouslySetInnerHTML: { __html: this.props.html }
        })
      );
    }
  }]);
  return EmbeddedTweet;
}(_react.Component), _class.propTypes = {
  html: _propTypes2.default.string
}, _temp);
exports.default = EmbeddedTweet;

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _consts = __webpack_require__(46);

__webpack_require__(1371);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookShareButton = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(FacebookShareButton, _Component);

  function FacebookShareButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FacebookShareButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FacebookShareButton.__proto__ || (0, _getPrototypeOf2.default)(FacebookShareButton)).call.apply(_ref, [this].concat(args))), _this), _this.getHref = function () {
      var _this$props = _this.props,
          dcmp = _this$props.dcmp,
          page = _this$props.page;


      var tracking = dcmp ? '?dcmp=sl_social_fb_' + dcmp : "";
      var encUrl = encodeURIComponent(page + tracking);

      return _consts.FACEBOOK_BASE_URL + '?u=' + encUrl;
    }, _this.handleClick = function () {
      if (_this.context.metrics) {
        _this.context.metrics.track("linkClick", { link: "[Article Share] Facebook" });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FacebookShareButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'a',
        { href: this.getHref(), onClick: this.handleClick, target: '_blank', className: "social-share-button-facebook" },
        _react2.default.createElement(
          'div',
          { className: 'social-share-button-facebook-image' },
          _react2.default.createElement(
            'div',
            { className: 'facebook-icon', title: 'Share' },
            _react2.default.createElement('img', { src: "/img/icons/facebook.svg" })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'social-share-button-facebook-text' },
          'Share'
        )
      );
    }
  }]);
  return FacebookShareButton;
}(_react.Component), _class.contextTypes = {
  metrics: _propTypes2.default.object
}, _class.propTypes = {
  dcmp: _propTypes2.default.string,
  page: _propTypes2.default.string
}, _temp2);
exports.default = FacebookShareButton;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _entries = __webpack_require__(306);

var _entries2 = _interopRequireDefault(_entries);

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(7);

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactGoogleRecaptcha = __webpack_require__(1543);

var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);

var _SubmitButton = __webpack_require__(360);

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

__webpack_require__(1372);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeedbackForm = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(FeedbackForm, _Component);

    function FeedbackForm() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, FeedbackForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FeedbackForm.__proto__ || (0, _getPrototypeOf2.default)(FeedbackForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            feedbackType: { value: '' },
            feedbackText: { value: '' },
            feedbackRating: { value: '' },
            feedbackRecaptcha: { value: '' },
            submitDisabled: true,
            error: false,
            feedbackSent: false
        }, _this.handleOnChange = function (id) {
            return function (event) {
                var value = event.target.value;
                var state = (0, _extends4.default)({}, _this.state, (0, _defineProperty3.default)({}, id, (0, _extends4.default)({}, _this.state[id], { value: value })));
                if (_this.state[id] && value) {
                    var _this$setState;

                    _this.setState((_this$setState = {}, (0, _defineProperty3.default)(_this$setState, id, (0, _extends4.default)({}, _this.state[id], { value: value })), (0, _defineProperty3.default)(_this$setState, 'submitDisabled', _this.isSubmitDisabled(state)), _this$setState));
                }
            };
        }, _this.handleOnBlur = function () {
            if (_this.props.inFocusAction) {
                _this.props.inFocusAction(false);
            }
        }, _this.handleOnFocus = function () {
            if (_this.props.inFocusAction) {
                _this.props.inFocusAction(true);
            }
        }, _this.handleOnSubmit = function () {
            var values = (0, _entries2.default)(_this.state).reduce(function (values, objPair) {
                if (objPair[1].value) {
                    values[objPair[0]] = objPair[1].value;
                }
                return values;
            }, {});
            _this.props.formSubmitAction(values);
        }, _this.handleOnCancel = function () {
            _this.props.closeAction();
        }, _this.handleOnCaptchaSuccess = function (key) {
            var state = (0, _extends4.default)({}, _this.state, { feedbackRecaptcha: { value: key } });
            _this.setState({
                feedbackRecaptcha: { value: key },
                submitDisabled: _this.isSubmitDisabled(state)
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(FeedbackForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.feedbackSent || this.props.sendingError) {
                this.props.resetFormAction();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var stateUpdates = {};
            if (this.props.feedbackSent !== prevProps.feedbackSent) {
                stateUpdates = (0, _extends4.default)({}, stateUpdates, { submitDisabled: true, feedbackSent: true });
            }

            if (this.props.sendingError !== prevProps.sendingError) {
                stateUpdates = (0, _extends4.default)({}, stateUpdates, { error: this.props.sendingError });
            }

            if ((0, _keys2.default)(stateUpdates).length) {
                this.setState(stateUpdates); //eslint-disable-line react/no-did-update-set-state
            }
        }
    }, {
        key: 'isSubmitDisabled',
        value: function isSubmitDisabled(state) {
            return (0, _entries2.default)(state).filter(function (objPair) {
                if (objPair[1].value) {
                    return !objPair[1].value;
                }
                return true;
            }).length === 4;
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'aside',
                { className: 'feedback-form-wrapper' },
                _react2.default.createElement(
                    'header',
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        'We\'re always looking to improve Sporting Life for our customers and we\'d really like to know what you think of Sporting Life.'
                    )
                ),
                _react2.default.createElement(
                    'form',
                    { id: 'feedbackForm' },
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'feedbackType' },
                            'What would you like to tell us about today?'
                        ),
                        _react2.default.createElement(
                            'select',
                            { id: 'feedbackType', onChange: this.handleOnChange('feedbackType'), value: this.state.feedbackType.value },
                            _react2.default.createElement(
                                'option',
                                { disabled: true, value: '' },
                                '-- Please select --'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: 'Something I like' },
                                'Something I like'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: 'Something I think could be better' },
                                'Something I think could be better'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: 'I have a technical issue' },
                                'I have a technical issue'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: 'Something else' },
                                'Something else'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'feedbackText' },
                            'Please give your feedback:'
                        ),
                        _react2.default.createElement('textarea', { id: 'feedbackText', onChange: this.handleOnChange('feedbackText'), value: this.state.feedbackText.value })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-group' },
                        _react2.default.createElement(
                            'label',
                            { htmlFor: 'feedbackRating' },
                            'On a scale of 0-10, how would you rate Sporting Life and how likely are you to recommend us to a friend?'
                        ),
                        _react2.default.createElement(
                            'select',
                            { id: 'feedbackRating', onChange: this.handleOnChange('feedbackRating'), value: this.state.feedbackRating.value },
                            _react2.default.createElement(
                                'option',
                                { disabled: true, value: '' },
                                '-- Please select --'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '10' },
                                '10 - Extremely likely'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '9' },
                                '9'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '8' },
                                '8'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '7' },
                                '7'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '6' },
                                '6'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '5' },
                                '5'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '4' },
                                '4'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '3' },
                                '3'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '2' },
                                '2'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '1' },
                                '1'
                            ),
                            _react2.default.createElement(
                                'option',
                                { value: '0' },
                                '0 - Not at all likely'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'form-captcha' },
                        _react2.default.createElement(_reactGoogleRecaptcha2.default, { sitekey: this.props.reCaptchaKey, onChange: this.handleOnCaptchaSuccess })
                    )
                ),
                _react2.default.createElement(
                    'footer',
                    null,
                    this.state.error && _react2.default.createElement(
                        'p',
                        { className: 'feedback-form-error' },
                        'We\'re sorry, but there has been an error and your feedback could not be sent. Please try again.'
                    ),
                    this.state.feedbackSent && _react2.default.createElement(
                        'p',
                        null,
                        'Thank you for your feedback.'
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'btn cancel-btn', onClick: this.handleOnCancel, type: 'button' },
                        'Close'
                    ),
                    _react2.default.createElement(_SubmitButton2.default, { successResult: this.state.feedbackSent, btnClass: 'btn feedback-submit-btn', label: 'Submit Feedback', onClickAction: this.handleOnSubmit, disabled: this.state.submitDisabled, formRef: 'feedbackForm' })
                )
            );
        }
    }]);
    return FeedbackForm;
}(_react.Component), _class.propTypes = {
    closeAction: _propTypes2.default.func.isRequired,
    reCaptchaKey: _propTypes2.default.string.isRequired,
    inFocusAction: _propTypes2.default.func,
    formSubmitAction: _propTypes2.default.func.isRequired,
    resetFormAction: _propTypes2.default.func.isRequired,
    feedbackSent: _propTypes2.default.bool.isRequired,
    sendingError: _propTypes2.default.bool.isRequired
}, _temp2);
exports.default = FeedbackForm;

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(11);

var _SportingLifeLogo = __webpack_require__(368);

var _SportingLifeLogo2 = _interopRequireDefault(_SportingLifeLogo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(_ref) {
    var handleOpenFeedbackForm = _ref.handleOpenFeedbackForm,
        handleScrollTop = _ref.handleScrollTop;
    return _react2.default.createElement(
        'footer',
        { className: 'footer' },
        _react2.default.createElement(
            'div',
            { className: 'footer__top-wrapper' },
            _react2.default.createElement(
                'div',
                { className: 'footer__top' },
                _react2.default.createElement(
                    'div',
                    { className: 'footer__icon' },
                    _react2.default.createElement(
                        _reactRouter.IndexLink,
                        { to: '/', className: 'svg-fix' },
                        _react2.default.createElement(_SportingLifeLogo2.default, null)
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'footer__scroll-top' },
                    _react2.default.createElement(
                        'a',
                        { href: '#', onClick: function onClick(e) {
                                return handleScrollTop(e);
                            } },
                        'Top ',
                        _react2.default.createElement('i', { className: 'i', 'data-char': '\uF023' })
                    )
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: 'footer__bottom-wrapper' },
            _react2.default.createElement(
                'div',
                { className: 'footer__bottom' },
                _react2.default.createElement(
                    'div',
                    { className: 'footer__links' },
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                            'a',
                            { id: 'contactus', href: 'mailto:feedback@sportinglife.com' },
                            'Contact Us'
                        )
                    ),
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                            'a',
                            { href: '#feedback', onClick: handleOpenFeedbackForm },
                            'Feedback'
                        )
                    ),
                    _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                            _reactRouter.Link,
                            { to: '/privacy', title: 'Privacy and Cookie Notice' },
                            'Privacy and Cookie Notice'
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'footer__copy' },
                    '\xA9 ',
                    new Date().getFullYear(),
                    ' Hestview Ltd. All Rights Reserved.'
                )
            )
        )
    );
};

Footer.propTypes = {
    handleOpenFeedbackForm: _propTypes2.default.func.isRequired,
    handleScrollTop: _propTypes2.default.func.isRequired
};

exports.default = Footer;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactGpt = __webpack_require__(668);

var _commonUtils = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1373);

var GooglePublisherTag = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GooglePublisherTag, _Component);
  (0, _createClass3.default)(GooglePublisherTag, null, [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { hadError: false, loadGpt: false, gptParams: {} };

      var gptParams = (0, _extends3.default)({}, props.targetParams, {
        targeting: (0, _extends3.default)({}, props.targetParams.targeting, createTagTargetParams(props)),
        collapseEmptyDiv: true
      });

      return (0, _extends3.default)({}, state, { loadGpt: props.adsEnabled, gptParams: gptParams });
    }
  }]);

  function GooglePublisherTag(props) {
    (0, _classCallCheck3.default)(this, GooglePublisherTag);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GooglePublisherTag.__proto__ || (0, _getPrototypeOf2.default)(GooglePublisherTag)).call(this, props));

    _this.gptTag = _react2.default.createRef();
    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(GooglePublisherTag, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (!global.location) {
        return false;
      }
      var relevantProps = [[this.props.adUnitPath, nextProps.adUnitPath], [this.props.type, nextProps.type], [this.props.path, nextProps.path], [this.props.windowIsLoaded, nextProps.windowIsLoaded], [this.props.advertSlots, nextProps.advertSlots], [this.props.initializationComplete, nextProps.initializationComplete]];

      var diff = relevantProps.filter(function (pair) {
        return pair[0] !== pair[1];
      });

      var propsHaveChanged = diff.length > 0;

      return propsHaveChanged;
    }
  }, {
    key: 'componentDidCatch',
    value: function componentDidCatch() {

      if (this.gptTag.current && this.state.hadError === false) {
        this.gptTag.current.refresh();
      }
      this.setState((0, _extends3.default)({}, this.state, { hadError: true }));
    }
  }, {
    key: 'render',
    value: function render() {
      var initialized = this.props.adsEnabled && this.props.windowIsLoaded && this.props.initializationComplete;

      var slotId = this.props.adUnitPath;
      var renderSlot = true;

      var gptComponent = _react2.default.createElement(_reactGpt.Bling, (0, _extends3.default)({ id: slotId, ref: this.gptTag, adUnitPath: this.props.adUnitPath }, this.state.gptParams));

      if (initialized && this.props.tamAvailable && !this.props.advertSlots[slotId]) {
        var slotSize = this.state.gptParams.slotSize;
        var sizeMapping = this.state.gptParams.sizeMapping;
        this.props.fetchAdverts(slotId, slotSize, sizeMapping);
      }

      return _react2.default.createElement(
        'div',
        { className: 'gpt-container', 'data-type': this.props.type },
        initialized && renderSlot && gptComponent
      );
    }
  }]);
  return GooglePublisherTag;
}(_react.Component), _class.propTypes = {
  isStagingEnv: _propTypes2.default.bool.isRequired,
  adsEnabled: _propTypes2.default.bool.isRequired,
  path: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.oneOf(['topBanner', 'topMPU', 'bottomMPU', 'singleBottomMPU']).isRequired,
  adUnitPath: _propTypes2.default.string.isRequired,
  fullyRegistered: _propTypes2.default.bool,
  targetParams: _propTypes2.default.object.isRequired,
  location: _propTypes2.default.object.isRequired,
  windowIsLoaded: _propTypes2.default.bool.isRequired,
  hostname: _propTypes2.default.string.isRequired,
  routes: _propTypes2.default.array.isRequired,
  initializationComplete: _propTypes2.default.bool,
  tamAvailable: _propTypes2.default.bool,
  advertSlots: _propTypes2.default.object
}, _temp);
exports.default = GooglePublisherTag;


function getTagTestParams(queryParams) {
  var props = {};
  if (queryParams.Display_KW_Test && /^[a-z_0-9]+$/i.test(queryParams.Display_KW_Test)) {
    props = (0, _extends3.default)({}, props, { Display_KW_Test: [queryParams.Display_KW_Test] });
  }
  if (queryParams.app) {
    props = (0, _extends3.default)({}, props, { Display_SL_App_Type: [queryParams.app] });
  }
  return props;
}

function createTagTargetParams(props) {

  var params = props.location.query ? (0, _extends3.default)({}, getTagTestParams(props.location.query)) : {};

  if (props.isStagingEnv) {
    params.Display_SL_Staging = props.isStagingEnv;
  }

  if (props.location.pathname) {
    params.Display_SL_Pathname = [props.location.pathname];
  }

  if (props.hostname) {
    //lower case attribute name is correct here
    params.display_sl_hostname = [props.hostname];
  }

  if (props.fullyRegistered !== null) {
    params.Display_SL_Reg = props.fullyRegistered ? "full" : "part";
  }

  params.display_sl_section = (0, _commonUtils.getSection)(props.routes);
  return (0, _extends3.default)({}, params);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _routeUtils = __webpack_require__(38);

var _InsiderCta = __webpack_require__(776);

var _InsiderCta2 = _interopRequireDefault(_InsiderCta);

var _LoginButton = __webpack_require__(779);

var _LoginButton2 = _interopRequireDefault(_LoginButton);

var _BetslipButton = __webpack_require__(773);

var _BetslipButton2 = _interopRequireDefault(_BetslipButton);

var _features = __webpack_require__(65);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1375);

var HeaderActions = function (_Component) {
    (0, _inherits3.default)(HeaderActions, _Component);

    function HeaderActions(props) {
        (0, _classCallCheck3.default)(this, HeaderActions);

        var _this = (0, _possibleConstructorReturn3.default)(this, (HeaderActions.__proto__ || (0, _getPrototypeOf2.default)(HeaderActions)).call(this, props));

        _this.state = _this.setCssClasses(props, { insiderCta: null });
        return _this;
    }

    (0, _createClass3.default)(HeaderActions, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setState(this.setInsiderStateItems(this.props, this.state));
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextprops) {
            var state = this.setCssClasses(nextprops, this.state);
            this.setState((0, _extends3.default)({}, this.setInsiderStateItems(nextprops, state)));
        }
    }, {
        key: 'setCssClasses',
        value: function setCssClasses(props) {
            var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return (0, _extends3.default)({}, state, {
                loggedInCss: props.loggedIn ? 'logged-in' : 'logged-out',
                ctaBtnClasses: props.screenSize === 'mobile' ? '' : 'insider-button large-primary-button',
                insiderActiveClass: (0, _routeUtils.isLinkActive)(props.router, { href: '/insider' }) ? 'active' : ''
            });
        }
    }, {
        key: 'setInsiderStateItems',
        value: function setInsiderStateItems(props, state) {
            var isMobile = props.screenSize === 'mobile';
            if ((0, _features.has)('insider-benefits') && (isMobile || !props.loggedIn && !isMobile)) {
                return (0, _extends3.default)({}, state, {
                    insiderCta: _react2.default.createElement(
                        'div',
                        { className: 'header-action insider-action new-flag ' + state.loggedInCss + ' ' + state.insiderActiveClass },
                        _react2.default.createElement(_InsiderCta2.default, { isMobile: isMobile, active: !!state.insiderActiveClass, ctaBtnClasses: state.ctaBtnClasses })
                    )
                });
            }
            return (0, _extends3.default)({}, state, { insiderCta: null });
        }
    }, {
        key: 'render',
        value: function render() {
            var cssClasses = ['header-actions', this.props.screenSize, this.state.loggedInCss].join(' ');
            return _react2.default.createElement(
                'div',
                { className: cssClasses },
                this.state.insiderCta,
                _react2.default.createElement(
                    'div',
                    { className: 'header-action main-account-icon ' + this.state.loggedInCss },
                    _react2.default.createElement(_LoginButton2.default, { device: this.props.screenSize })
                ),
                _react2.default.createElement(_BetslipButton2.default, null)
            );
        }
    }]);
    return HeaderActions;
}(_react.Component);

exports.default = HeaderActions;


HeaderActions.propTypes = {
    screenSize: _propTypes2.default.string.isRequired, // desktop or mobile,
    loggedIn: _propTypes2.default.bool.isRequired,
    router: _propTypes2.default.object.isRequired
};

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.InsiderCta = InsiderCta;
exports.default = InsiderCtaWithTracking;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _InsiderIcon = __webpack_require__(253);

var _InsiderIcon2 = _interopRequireDefault(_InsiderIcon);

var _consts = __webpack_require__(46);

var _AnalyticsUtils = __webpack_require__(63);

var _reactMetrics = __webpack_require__(69);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var linkLabel = "Insiders";

var iconProps = {
    title: linkLabel
};

function InsiderCta(_ref) {
    var fireEventTracking = _ref.fireEventTracking,
        ctaBtnClasses = _ref.ctaBtnClasses,
        label = _ref.label,
        active = _ref.active,
        isMobile = _ref.isMobile;

    __webpack_require__(1377);

    if (label) {
        linkLabel = label;
        iconProps.title = label;
    }

    var linkOnClick = function linkOnClick() {
        fireEventTracking();
    };

    iconProps.colour = !active && isMobile ? "white" : "blue";

    return _react2.default.createElement(
        _reactRouter.Link,
        (0, _extends3.default)({ onClick: linkOnClick
        }, (0, _AnalyticsUtils.trackClick)(_consts.INSIDERS_LINK_CLICK_TRACKING_EVENT, { link: "[Insiders] Header CTA" }), {
            className: ctaBtnClasses,
            to: '/insider' }),
        _react2.default.createElement(_InsiderIcon2.default, iconProps),
        linkLabel
    );
}

function InsiderCtaWithTracking(props) {
    return _react2.default.createElement(
        'div',
        { className: 'insider-cta' },
        _react2.default.createElement(
            _reactMetrics.MetricsElement,
            null,
            _react2.default.createElement(InsiderCta, props)
        )
    );
}

InsiderCta.propTypes = {
    fireEventTracking: _propTypes2.default.func.isRequired,
    ctaBtnClasses: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string,
    active: _propTypes2.default.bool,
    isMobile: _propTypes2.default.bool
};

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSportsEvent = createSportsEvent;
exports.createSportsEvents = createSportsEvents;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _utils = __webpack_require__(18);

var _LocalDateTimeHelper = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createSportsEvent(props) {
  var uri = props.uri,
      name = props.name,
      startDate = props.startDate,
      endDate = props.endDate,
      courseName = props.courseName;


  return {
    "@id": uri,
    "@type": "SportsEvent",
    name: name,
    url: uri,
    startDate: startDate,
    endDate: endDate,
    location: {
      "@type": "Place",
      "name": courseName,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": courseName
      }
    }
  };
}

function createSportsEvents() {
  var racesToShow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var courseName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unknown';
  var sport = arguments[2];
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'racecard';

  if (!sport) {
    return [];
  }

  return racesToShow.map(function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        dateLong = _ref.date,
        time = _ref.time,
        _ref$race_summary_ref = _ref.race_summary_reference;

    _ref$race_summary_ref = _ref$race_summary_ref === undefined ? {} : _ref$race_summary_ref;
    var _ref$race_summary_ref2 = _ref$race_summary_ref.id,
        raceId = _ref$race_summary_ref2 === undefined ? '' : _ref$race_summary_ref2,
        name = _ref.name;

    var raceName = '';
    var event_time = '' + (0, _LocalDateTimeHelper.localTimeShort)(dateLong + 'T' + time + 'Z');
    if (sport === 'greyhounds') {
      name = event_time + ' ' + courseName;
    } else {
      raceName = '/' + (0, _utils.toSlug)(name);
    }

    var eventURI = '';
    if (type === 'racecard') {
      eventURI = _config2.default.canonicalBase + '/' + sport + '/racecards/' + dateLong + '/' + (0, _utils.toSlug)(courseName) + '/racecard/' + raceId + raceName;
    } else {
      eventURI = _config2.default.canonicalBase + '/' + sport + '/results/' + dateLong + '/' + (0, _utils.toSlug)(courseName) + '/' + raceId + raceName;
    }

    var startDate = dateLong + 'T' + time + 'Z';

    return createSportsEvent({ uri: eventURI, name: name, startDate: startDate, endDate: startDate, courseName: courseName });
  });
}

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /* eslint react/no-danger: "off" */


var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _copyToClipboard = __webpack_require__(1342);

var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);

__webpack_require__(1379);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STATE = {
  text: "Link",
  icon: null,
  copied: false,
  className: ""
};
var CLICKED_STATE = {
  text: "",
  icon: '\uF119',
  copied: true,
  className: "copied"
};

var LinkShareButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LinkShareButton, _Component);

  function LinkShareButton(props) {
    (0, _classCallCheck3.default)(this, LinkShareButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LinkShareButton.__proto__ || (0, _getPrototypeOf2.default)(LinkShareButton)).call(this, props));

    _this.getHref = function () {
      var _this$props = _this.props,
          dcmp = _this$props.dcmp,
          page = _this$props.page;

      var href = page;

      if (dcmp) {
        href = page + '?dcmp=sl_social_link_' + dcmp;
      }

      return href;
    };

    _this.handleClick = function () {
      if (_this.context.metrics) {
        _this.context.metrics.track("linkClick", { link: "[Article Share] Link" });
      }

      _this.copyFunction(_this.getHref());
      _this.setState(CLICKED_STATE);

      window.setTimeout(function () {
        return _this.setState(DEFAULT_STATE);
      }, 3000);
    };

    _this.copyFunction = props.copyFunction || _copyToClipboard2.default;
    _this.state = DEFAULT_STATE;
    return _this;
  }

  (0, _createClass3.default)(LinkShareButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { onClick: this.handleClick, className: "social-share-button-link " + this.state.className, id: 'social-share-link-button' },
        _react2.default.createElement(
          'div',
          { className: 'social-share-button-link-image' },
          _react2.default.createElement(
            'div',
            { id: 'social-share-button-link-icon', className: 'skycon link-icon', title: 'Copy link' },
            !this.state.copied && _react2.default.createElement('img', { src: "/img/icons/link.svg" }),
            this.state.copied && this.state.icon
          )
        ),
        _react2.default.createElement(
          'div',
          { id: 'social-share-button-link-text' },
          this.state.text
        )
      );
    }
  }]);
  return LinkShareButton;
}(_react.Component), _class.contextTypes = {
  metrics: _propTypes2.default.object
}, _class.propTypes = {
  copyFunction: _propTypes2.default.func,
  timeoutFunction: _propTypes2.default.func,
  dcmp: _propTypes2.default.string,
  page: _propTypes2.default.string
}, _temp);
exports.default = LinkShareButton;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _SportingLifeLogo = __webpack_require__(368);

var _SportingLifeLogo2 = _interopRequireDefault(_SportingLifeLogo);

var _BurgerIcon = __webpack_require__(763);

var _BurgerIcon2 = _interopRequireDefault(_BurgerIcon);

var _reactRouter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MainHeader = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(MainHeader, _Component);

    function MainHeader() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, MainHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MainHeader.__proto__ || (0, _getPrototypeOf2.default)(MainHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handlerMenuClick = function (e) {

            _this.props.toggleMenuAction(e);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(MainHeader, [{
        key: 'isRootPath',
        value: function isRootPath(path) {
            return '/' === path;
        }
    }, {
        key: 'getLogoClasses',
        value: function getLogoClasses() {
            return [this.isRootPath(this.props.path) ? "main-menu-logo" : "main-menu-logo-with-back", this.props.isLoggedIn ? "logged-in" : "logged-out"].concat((0, _toConsumableArray3.default)(this.props.featureStyleClasses)).join(' ');
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'header',
                { id: 'header-logo' },
                !this.isRootPath(this.props.path) && _react2.default.createElement(
                    'div',
                    { className: 'main-back-icon' },
                    _react2.default.createElement(
                        'button',
                        { id: 'back-button', onClick: this.props.backButtonAction },
                        _react2.default.createElement(_CaretIcon2.default, { type: 'line', direction: 'left' })
                    )
                ),
                _react2.default.createElement(
                    'span',
                    { className: this.getLogoClasses() },
                    _react2.default.createElement(
                        _reactRouter.IndexLink,
                        { to: '/', className: 'svg-fix' },
                        _react2.default.createElement(_SportingLifeLogo2.default, null)
                    )
                ),
                this.props.children,
                _react2.default.createElement(
                    'div',
                    { className: 'main-menu-icon' },
                    _react2.default.createElement(
                        'button',
                        { id: 'main-menu', onClick: this.handlerMenuClick },
                        _react2.default.createElement(_BurgerIcon2.default, { title: 'Menu', close: this.props.isMenuClosed })
                    )
                )
            );
        }
    }]);
    return MainHeader;
}(_react.Component), _class.propTypes = {
    path: _propTypes2.default.string.isRequired,
    isLoggedIn: _propTypes2.default.bool.isRequired,
    featureStyleClasses: _propTypes2.default.array.isRequired,
    backButtonAction: _propTypes2.default.func.isRequired,
    toggleMenuAction: _propTypes2.default.func.isRequired,
    isMenuClosed: _propTypes2.default.bool.isRequired,
    children: _propTypes2.default.object
}, _temp2);
exports.default = MainHeader;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _commonUtils = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appUserAgentRegex = /SkySportingLife\/([0-9a-zA-Z.]+)/;

var products = [{ appName: "skybet", imageName: "skybet-dec2017", href: "https://m.skybet.com", affId: "10392", dcmp: "SL_LOGO_SB_19" }, { appName: "skyvegas", imageName: "sky-vegas-feb2018", href: "https://www.skyvegas.com/", affId: "1197321629", dcmp: "SL_LOGO_SV_19" }, { appName: "skysports", imageName: "skysports-aug2017", href: "http://www.skysports.com/", affId: "1197321630", dcmp: "SL_LOGO_SSDM_19" }, { appName: "skyc4racingpick6", imageName: "itv7-feb2018", largeImage: true, href: "https://itv7.itv.com/", affId: "1197321631", dcmp: "SL_LOGO_FTP_ITV7_19" }, { appName: "super6", imageName: "super6-dec2017", largeImage: true, href: "https://super6.skysports.com/", affId: "1197321632", dcmp: "SL_LOGO_FTP_S6_19" }, { appName: "skycasino", imageName: "sky-casino-feb2018", href: "https://www.skycasino.com/", affId: "1197321633", dcmp: "SL_LOGO_SC_19" }, { appName: "SkyFF", imageName: "fantasy-football-dec2017", largeImage: true, href: "https://fantasyfootball.skysports.com/", affId: "1197321634", dcmp: "SL_LOGO_FTP_FF_19" }, { appName: "skypoker", imageName: "sky-poker-feb2018", href: "https://www.skypoker.com/", affId: "1197321636", dcmp: "SL_LOGO_FTP_SP_19" }, { appName: "skybingo", imageName: "sky-bingo-feb2018", href: "https://www.skybingo.com/", affId: "1197321637", dcmp: "SL_LOGO_SBIN_19" }];

var Masthead = function (_Component) {
    (0, _inherits3.default)(Masthead, _Component);

    function Masthead() {
        (0, _classCallCheck3.default)(this, Masthead);
        return (0, _possibleConstructorReturn3.default)(this, (Masthead.__proto__ || (0, _getPrototypeOf2.default)(Masthead)).apply(this, arguments));
    }

    (0, _createClass3.default)(Masthead, [{
        key: 'bindAppLinks',
        value: function bindAppLinks() {
            if (!window.SkyBetAccount) {
                return false;
            }

            // Don't enable appbridge if not being accessed through app
            if (!this.getAppVersion()) {
                return true;
            }

            var appLinks = document.getElementsByClassName('js-app-link');

            var self = this;
            [].forEach.call(appLinks, function (link) {
                link.addEventListener('click', function (evt) {
                    self.openAppLink(link, evt);
                });
            });

            return true;
        }
    }, {
        key: 'getAppVersion',
        value: function getAppVersion() {
            var userAgent = window.navigator.userAgent;
            var appVersion = userAgent.match(appUserAgentRegex);

            if (!appVersion) {
                return false;
            }
            return appVersion[1];
        }
    }, {
        key: 'openAppLink',
        value: function openAppLink(link, evt) {
            var appName = link.getAttribute('data-app-name');
            var appLink = link.getAttribute('data-app-link');
            var sba = window.SkyBetAccount;
            var appBridge = sba.getAppBridge();

            if (!(appName && appLink)) {
                return;
            }
            evt.preventDefault();

            // The iOS app will prepend the scheme
            var transferUrl = appLink.replace(/^https?:\/\//, '');

            // Only get a transfer token if we are on https and logged in
            if (window.location.protocol === 'https:' && sba.getLastLoginState() === 'loggedIn') {
                sba.getSsoTransferToken(function (err, ssoTransferToken) {
                    if (!err) {
                        // Append the SSO transfer token to the URL
                        transferUrl += transferUrl.indexOf('?') !== -1 ? '&' : '?';
                        transferUrl += 'sba_transferToken=' + ssoTransferToken;
                    } else {
                        console.log('Unable to transfer SSO session');
                    }

                    appBridge.trigger('openAppLink', {
                        app: appName,
                        url: transferUrl
                    });
                });
            } else {
                appBridge.trigger('openAppLink', {
                    app: appName,
                    url: transferUrl
                });
            }
        }
    }, {
        key: 'productListItem',
        value: function productListItem(item) {
            var targetUrl = (0, _commonUtils.getXsellUrl)(item.href + '?AFF_ID=' + item.affId + '&dcmp=' + item.dcmp, item.ssoConsumer);

            return _react2.default.createElement(
                'li',
                { className: 'masthead-item', key: products.indexOf(item) },
                _react2.default.createElement(
                    'a',
                    { className: 'js-app-link', 'data-app-name': item.appName, 'data-app-link': targetUrl, href: targetUrl, target: '_blank', rel: 'external' },
                    _react2.default.createElement('img', { className: item.largeImage ? 'masthead-large' : '', src: '/img/masthead/' + item.imageName + '.png' })
                )
            );
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.retriesLeft = 100; // arbitrary 10 second wait for the API to appear
            this.interval = setInterval(function () {
                if (_this2.bindAppLinks() || --_this2.retriesLeft === 0) {
                    clearInterval(_this2.interval);
                    _this2.interval = null;

                    if (!_this2.retriesLeft) {
                        /* eslint-disable no-console */
                        console.warn('Could not find SkyBetAccount integration object');
                        /* eslint-enable no-console */
                    }
                }
            }, 100);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'nav',
                { className: 'masthead' },
                _react2.default.createElement(
                    'ul',
                    { className: 'masthead-items' },
                    products.map(function (product) {
                        return _this3.productListItem(product);
                    })
                )
            );
        }
    }]);
    return Masthead;
}(_react.Component);

exports.default = Masthead;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NewsSection;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _StorySummary = __webpack_require__(215);

var _StorySummary2 = _interopRequireDefault(_StorySummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(506);

function NewsSection(_ref) {
  var sectionLabel = _ref.sectionLabel,
      newsItems = _ref.newsItems,
      _ref$additionalNewsLi = _ref.additionalNewsLinks,
      additionalNewsLinks = _ref$additionalNewsLi === undefined ? [] : _ref$additionalNewsLi,
      _ref$showHeading = _ref.showHeading,
      showHeading = _ref$showHeading === undefined ? true : _ref$showHeading,
      _ref$expandedHeading = _ref.expandedHeading,
      expandedHeading = _ref$expandedHeading === undefined ? true : _ref$expandedHeading,
      _ref$showCategory = _ref.showCategory,
      showCategory = _ref$showCategory === undefined ? false : _ref$showCategory,
      _ref$sectionLink = _ref.sectionLink,
      sectionLink = _ref$sectionLink === undefined ? null : _ref$sectionLink,
      showByline = _ref.showByline;

  if (newsItems.length > 0) {
    var heading = expandedHeading ? 'Latest ' + sectionLabel + ' News' : sectionLabel;
    if (sectionLink && sectionLink.length > 0) {
      heading = _react2.default.createElement(
        _reactRouter.Link,
        { to: sectionLink },
        heading
      );
    }

    return _react2.default.createElement(
      'section',
      { className: 'sport-section' },
      showHeading && _react2.default.createElement(
        'h3',
        { className: 'section-title' },
        heading
      ),
      _react2.default.createElement(
        'section',
        { className: 'sport-news' },
        newsItems.map(function (item) {
          return _react2.default.createElement(_StorySummary2.default, { key: item.article_reference.id, imageType: 'sectionArticle', data: item, metaDataFlags: { category: showCategory, showByline: showByline } });
        }),
        _react2.default.createElement(
          'div',
          { className: 'action-links sport-links' },
          additionalNewsLinks.map(function (link) {
            return _react2.default.createElement(
              _reactRouter.Link,
              { className: 'section-button large-primary-button', key: link.href + ':' + link.text, to: link.href },
              link.text
            );
          })
        )
      )
    );
  } else {
    return null;
  }
}

NewsSection.propTypes = {
  sectionLabel: _propTypes2.default.string.isRequired,
  sectionLink: _propTypes2.default.string,
  showHeading: _propTypes2.default.bool,
  expandedHeading: _propTypes2.default.bool,
  showCategory: _propTypes2.default.bool,
  showByline: _propTypes2.default.bool,
  newsItems: _propTypes2.default.array,
  additionalNewsLinks: _propTypes2.default.array
};

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1382);

var OddscheckerWidget = function (_Component) {
  (0, _inherits3.default)(OddscheckerWidget, _Component);

  function OddscheckerWidget() {
    (0, _classCallCheck3.default)(this, OddscheckerWidget);
    return (0, _possibleConstructorReturn3.default)(this, (OddscheckerWidget.__proto__ || (0, _getPrototypeOf2.default)(OddscheckerWidget)).apply(this, arguments));
  }

  (0, _createClass3.default)(OddscheckerWidget, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var hash = this.props.hash || "";
      if (window && window.ocBootstrap && window.ocBootstrap.scrapePage) {
        window.ocBootstrap.scrapePage(hash);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var hash = this.props.hash || "";
      var className = 'ocw ' + hash + ' ' + (this.props.isFooter ? 'oc-banner' : '');

      return _react2.default.createElement('div', { className: className });
    }
  }]);
  return OddscheckerWidget;
}(_react.Component);

exports.default = OddscheckerWidget;


OddscheckerWidget.propTypes = {
  hash: _propTypes2.default.string.isRequired,
  isFooter: _propTypes2.default.bool
};

OddscheckerWidget.defaultProps = {
  className: '',
  isFooter: false
};

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(7);

var _extends4 = _interopRequireDefault(_extends3);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _class, _temp;

exports.playbuzzPropsFromWidget = playbuzzPropsFromWidget;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _widgets = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROPS_MAP = {
  class_name: "className",
  item_id: "data-id",
  embed_by: "data-embed-by",
  shares: "data-shares",
  comments: "data-comments",
  version: "data-version",
  game_info: "data-game-info",
  recommend: "data-recommend"
};

var PROPS_LIST = (0, _keys2.default)(PROPS_MAP);

function playbuzzPropsFromWidget(widget) {
  return (0, _widgets.getWidgetValues)(widget, PROPS_LIST);
}

var PlaybuzzEmbed = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PlaybuzzEmbed, _Component);

  function PlaybuzzEmbed() {
    (0, _classCallCheck3.default)(this, PlaybuzzEmbed);
    return (0, _possibleConstructorReturn3.default)(this, (PlaybuzzEmbed.__proto__ || (0, _getPrototypeOf2.default)(PlaybuzzEmbed)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlaybuzzEmbed, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // add the script on demand, but only once (Helmet repeats it)
      if (!window.PlayBuzz) {
        var script = document.createElement('script');
        script.src = '//cdn.playbuzz.com/widget/feed.js';
        script.async = true;
        document.head.appendChild(script);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var divProps = PROPS_LIST.reduce(function (o, k) {
        if (_this2.props.hasOwnProperty(k)) {
          return (0, _extends4.default)({}, o, (0, _defineProperty3.default)({}, PROPS_MAP[k], _this2.props[k]));
        } else {
          return o;
        }
      }, {});

      return _react2.default.createElement('div', divProps);
    }
  }]);
  return PlaybuzzEmbed;
}(_react.Component), _class.propTypes = {
  data: _propTypes2.default.object
}, _temp);
exports.default = PlaybuzzEmbed;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RaceSummaryText;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RaceSummaryText(props) {
  var _props$raceSummary = props.raceSummary,
      raceDistance = _props$raceSummary.distance,
      raceClass = _props$raceSummary.race_class,
      age = _props$raceSummary.age,
      rideCount = _props$raceSummary.ride_count;


  return _react2.default.createElement(
    'span',
    null,
    '(',
    [(0, _utils.formatHorseAge)(age), raceClass && 'Class ' + raceClass, (0, _utils.distanceFormat)(raceDistance), rideCount + ' runners'].filter(function (x) {
      return !!x;
    }).join(', '),
    ')'
  );
}

RaceSummaryText.propTypes = {
  raceSummary: _propTypes2.default.object.isRequired
};

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.default = Splash;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDeviceDetect = __webpack_require__(109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Splash(_ref) {
  var data = _ref.data,
      handleClose = _ref.handleClose;
  var mobileImageUrl = data.mobileImageUrl,
      desktopImageUrl = data.desktopImageUrl,
      header = data.header,
      subHeader = data.subHeader,
      buttonUrl = data.buttonUrl,
      buttonImage = data.buttonImage,
      termsText = data.termsText,
      id = data.id,
      endDateTime = data.endDateTime;


  var imageUrl = _reactDeviceDetect.isMobile ? mobileImageUrl : desktopImageUrl;

  var _header$split = header.split(/ (.*)/),
      _header$split2 = (0, _slicedToArray3.default)(_header$split, 2),
      first = _header$split2[0],
      rest = _header$split2[1];

  var splashTerms = _react2.default.createElement(
    "div",
    { className: "splash-terms" },
    termsText,
    _react2.default.createElement(
      "span",
      { className: "splash-gambleaware" },
      _react2.default.createElement(
        "a",
        { href: "http://begambleaware.org", title: "Be Gamble Aware", target: "_blank" },
        "BEGAMBLEAWARE.ORG"
      )
    )
  );

  return _react2.default.createElement(
    "div",
    { className: "splash" },
    _react2.default.createElement(
      "div",
      {
        className: "splash__wrapper",
        style: { background: "linear-gradient(-90deg, rgba(27, 60, 123, 0) 0%, #1B3C7B 100%), url(" + imageUrl + ")", backgroundSize: "cover" }
      },
      _react2.default.createElement(
        "div",
        { className: "splash_tint" },
        _react2.default.createElement(
          "span",
          { className: "splash-close", onClick: function onClick() {
              return handleClose(id, endDateTime);
            } },
          _react2.default.createElement("img", { src: "/img/splash/close-icon.svg", alt: "Close", height: "14", width: "46", title: "Close" })
        ),
        _react2.default.createElement(
          "div",
          { className: "col1" },
          _react2.default.createElement(
            "div",
            { className: "splash-title" },
            _react2.default.createElement(
              "p",
              null,
              _react2.default.createElement(
                "span",
                { className: "header-first-word" },
                first
              ),
              " ",
              rest
            )
          ),
          _react2.default.createElement(
            "div",
            { className: "splash-body" },
            _react2.default.createElement(
              "p",
              null,
              subHeader
            )
          ),
          splashTerms
        ),
        _react2.default.createElement(
          "div",
          { className: "col2" },
          _react2.default.createElement(
            "div",
            { className: "splash-provided-by" },
            _react2.default.createElement(
              "p",
              null,
              "Betting provided by "
            ),
            _react2.default.createElement("img", { className: "splash-skybet-logo", src: "/img/splash/skybet-logo.png", alt: "Sky Bet Logo", height: "14", width: "46" })
          ),
          _react2.default.createElement(
            "div",
            { className: "splash-button" },
            _react2.default.createElement(
              "a",
              { href: buttonUrl, title: "Go to offer", target: "_blank" },
              _react2.default.createElement("img", { src: buttonImage, alt: "Bet Here Button", height: "336", width: "428" })
            )
          ),
          splashTerms
        )
      )
    )
  );
}

Splash.propTypes = {
  data: _propTypes2.default.shape({
    mobileImageUrl: _propTypes2.default.string.isRequired,
    desktopImageUrl: _propTypes2.default.string.isRequired,
    header: _propTypes2.default.string.isRequired,
    subHeader: _propTypes2.default.string.isRequired,
    buttonUrl: _propTypes2.default.string.isRequired,
    buttonImage: _propTypes2.default.string.isRequired,
    termsText: _propTypes2.default.string,
    id: _propTypes2.default.string.isRequired,
    endDateTime: _propTypes2.default.string.isRequired
  }).isRequired,
  handleClose: _propTypes2.default.func.isRequired
};

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PureSplash = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(17);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _cookies = __webpack_require__(206);

var _Splash = __webpack_require__(746);

var _Splash2 = _interopRequireDefault(_Splash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UNSET_COOKIE = 'UNSET_COOKIE';

__webpack_require__(1385);

var PureSplash = exports.PureSplash = function (_Component) {
  (0, _inherits3.default)(PureSplash, _Component);

  function PureSplash(props) {
    (0, _classCallCheck3.default)(this, PureSplash);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PureSplash.__proto__ || (0, _getPrototypeOf2.default)(PureSplash)).call(this, props));

    _this.handleClose = function (trigger) {
      return function (id, endDateTime) {
        if (trigger === 'login') {
          _this.setState((0, _extends3.default)({}, _this.state, {
            justSawASplash: true
          }));
        }

        _this.props.setSplashpageSeen(_config2.default.splashpage.cookieName + '_' + id, endDateTime);
      };
    };

    _this.triggers = ['siteLoad', 'login'];
    _this.state = {
      justSawASplash: false
    };
    return _this;
  }

  (0, _createClass3.default)(PureSplash, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var _props = this.props,
          splashpages = _props.splashpages,
          fetchSplashpageSeenProperty = _props.fetchSplashpageSeenProperty;


      this.triggers.forEach(function (trigger) {
        if (splashpages[trigger] && !prevProps.splashpages[trigger]) {
          fetchSplashpageSeenProperty(_this2.props.splashpages[trigger].id);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          splashpages = _props2.splashpages,
          cookies = _props2.cookies;
      var justSawASplash = this.state.justSawASplash;

      var shouldDisplayFromCookie = checkCookies(cookies);

      var siteLoadSplash = splashpages.siteLoad;
      var loginSplash = splashpages.login;

      var showLoginSplash = loginSplash && shouldDisplayFromCookie(loginSplash.id);
      var showSiteLoadSplash = !showLoginSplash && siteLoadSplash && shouldDisplayFromCookie(siteLoadSplash.id);

      if (!justSawASplash && (showLoginSplash || showSiteLoadSplash)) {
        return _react2.default.createElement(
          _react2.default.Fragment,
          null,
          showLoginSplash && _react2.default.createElement(_Splash2.default, {
            data: loginSplash,
            handleClose: this.handleClose('login')
          }),
          showSiteLoadSplash && _react2.default.createElement(_Splash2.default, {
            data: siteLoadSplash,
            handleClose: this.handleClose('siteLoad')
          })
        );
      }

      return null;
    }
  }]);
  return PureSplash;
}(_react.Component);

function checkCookies(cookies) {
  return function (cookieId) {
    var cookieForSp = cookies[_config2.default.splashpage.cookieName + '_' + cookieId];
    // if undefined, cookie not received yet return false to prevent splash page flashing up
    if (typeof cookieForSp === 'undefined') {
      return false;
    }

    return cookieForSp === UNSET_COOKIE;
  };
}

PureSplash.propTypes = {
  splashpages: _propTypes2.default.object,
  setSplashpageSeen: _propTypes2.default.func,
  fetchSplashpageSeenProperty: _propTypes2.default.func,
  cookies: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  var _state$common = state.common,
      splashpage = _state$common.splashpage,
      cookies = _state$common.cookies;


  return {
    splashpages: splashpage,
    cookies: cookies
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    setSplashpageSeen: function setSplashpageSeen(id, expiryDate) {
      return dispatch((0, _cookies.setCookie)(id, _config2.default.splashpage.cookieValue, {
        path: "/",
        expires: new Date(expiryDate)
      }));
    },
    fetchSplashpageSeenProperty: function fetchSplashpageSeenProperty(id) {
      return dispatch((0, _cookies.getCookie)(_config2.default.splashpage.cookieName + '_' + id, UNSET_COOKIE));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PureSplash);

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Masthead = __webpack_require__(741);

var _Masthead2 = _interopRequireDefault(_Masthead);

var _MainHeader = __webpack_require__(740);

var _MainHeader2 = _interopRequireDefault(_MainHeader);

var _HeaderActions = __webpack_require__(736);

var _HeaderActions2 = _interopRequireDefault(_HeaderActions);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _reactRouter = __webpack_require__(11);

var _features = __webpack_require__(65);

var _commonUtils = __webpack_require__(36);

var _AnalyticsUtils = __webpack_require__(63);

var _consts = __webpack_require__(46);

var _reactMetrics = __webpack_require__(69);

var _routeUtils = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StickyMenu = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(StickyMenu, _Component);

    function StickyMenu() {
        (0, _classCallCheck3.default)(this, StickyMenu);
        return (0, _possibleConstructorReturn3.default)(this, (StickyMenu.__proto__ || (0, _getPrototypeOf2.default)(StickyMenu)).apply(this, arguments));
    }

    (0, _createClass3.default)(StickyMenu, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps() {
            this.watchScroll();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.watchScroll();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.unwatchScroll();
        }
    }, {
        key: 'goBack',
        value: function goBack() {
            if (window.history.length > 1) {
                window.history.back();
            }
        }
    }, {
        key: 'isRoot',
        value: function isRoot() {
            return '/' === this.props.location.pathname;
        }
    }, {
        key: 'mainNavLink',
        value: function mainNavLink(link) {
            return link.href && _react2.default.createElement(
                _reactMetrics.MetricsElement,
                { key: link.text },
                _react2.default.createElement(
                    'li',
                    { className: link.className },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        (0, _extends3.default)({}, link.tracking, { className: (0, _routeUtils.activeClassName)(this.props.router, link, "nav-active"), to: link.href }),
                        link.text
                    )
                )
            );
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll() {
            var _this2 = this;

            var stickyMenu = this.menu;

            var menuStyle = stickyMenu.style;
            var menuHeight = stickyMenu.getBoundingClientRect().height;
            var scrollThreshold = 0;
            var lastScroll = 0;

            return function () {
                var scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
                var diff = scrollY - lastScroll;
                var maxScrollDiff = menuHeight * 2;

                scrollThreshold = StickyMenu.calculateScrollThreshold(maxScrollDiff, scrollThreshold, diff);

                if (scrollThreshold >= menuHeight && diff > 0) {
                    scrollThreshold = maxScrollDiff;
                }

                menuStyle['top'] = -scrollThreshold + 'px';
                lastScroll = scrollY;

                if (scrollThreshold >= menuHeight) {
                    if (_this2.props.allSportsOpen) {
                        _this2.props.toggleAllSports(null, false);
                    }
                }
            };
        }
    }, {
        key: 'watchScroll',
        value: function watchScroll() {
            document.addEventListener("scroll", this.handleScroll(), false);
        }
    }, {
        key: 'unwatchScroll',
        value: function unwatchScroll() {
            document.removeEventListener("scroll", this.handleScroll());
        }
    }, {
        key: 'getHeaderActions',
        value: function getHeaderActions(screenSize) {
            return _react2.default.createElement(_HeaderActions2.default, { loggedIn: this.props.loggedIn, router: this.props.router, screenSize: screenSize });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                subnav = _props.subnav,
                navConfig = _props.navConfig;

            var LocalSubNav = subnav;

            var stickyMenuProps = {
                id: "stickyMenu"
            };

            if ((0, _features.has)("integrated-betslip")) {
                stickyMenuProps.className = "integrated-betslip";
            }

            var mainNav = [{ href: "/racing", text: "Racing", exceptions: [{ href: "/racing/fast-results" }] }, { href: "/racing/fast-results", text: "Fast Results" }, { href: "/football", text: "Football" }, { href: "/news/rugby-world-cup/36", text: "Rugby World Cup" }, { href: "/greyhounds", text: "Greyhounds" }, { href: "/golf", text: "Golf" }, { href: "/darts", text: "Darts", className: "tablet-shift" }];
            //   const mainFestival = {href: navConfig.event.uri,    text: navConfig.event.title,   className: "tablet-shift"};
            //   if (navConfig.event.title){
            //     mainNav.splice(navConfig.event.mainNavIndex, 0, mainFestival);
            //   }

            var subNav = [{ href: "/darts", text: "Darts", className: "tablet-shift-more" }, { href: "/tennis", text: "Tennis" }, { href: "/cricket", text: "Cricket" }, { href: "/boxing", text: "Boxing / MMA" }, { href: "/formula1", text: "Formula 1" }, { href: "/nfl", text: "NFL" }, { href: "/rugby-league", text: "Rugby League" }, { href: "/rugby-union", text: "Rugby Union" }, { href: "/snooker", text: "Snooker" }, { href: "/other-sports", text: "Other Sports" }];
            //   const subFestival = {href: navConfig.event.uri,   text: navConfig.event.title,   className: "tablet-shift-more"};
            //   if (navConfig.event.title){
            //     subNav.splice(navConfig.event.subNavIndex, 0, subFestival);
            //   }

            return _react2.default.createElement(
                'div',
                (0, _extends3.default)({}, stickyMenuProps, { ref: function ref(menu) {
                        return _this3.menu = menu;
                    } }),
                _react2.default.createElement(
                    'section',
                    null,
                    _react2.default.createElement(_Masthead2.default, null)
                ),
                _react2.default.createElement(
                    'section',
                    null,
                    _react2.default.createElement(
                        'div',
                        { id: 'header' },
                        _react2.default.createElement(
                            _MainHeader2.default,
                            {
                                path: this.props.location.pathname,
                                isLoggedIn: this.props.loggedIn,
                                featureStyleClasses: this.props.featureClasses,
                                backButtonAction: this.goBack,
                                toggleMenuAction: this.props.toggleMainMenu,
                                isMenuClosed: this.props.mainMenuOpen
                            },
                            this.getHeaderActions("desktop")
                        )
                    )
                ),
                _react2.default.createElement(
                    'section',
                    null,
                    _react2.default.createElement(
                        'nav',
                        { id: 'nav' },
                        _react2.default.createElement(
                            'div',
                            { className: 'nav-level1 ' + (!this.isRoot() ? 'nav-level1-with-back' : ''), onClick: function onClick(e) {
                                    return _this3.props.toggleMainMenu(e, false);
                                } },
                            _react2.default.createElement(
                                'ul',
                                { className: this.props.mainMenuOpen ? "open" : "" },
                                mainNav.map(function (link) {
                                    return _this3.mainNavLink(link);
                                }),
                                _react2.default.createElement(
                                    'li',
                                    { 'data-keep-menu-open': true, className: 'no-link allsports-nav' + (this.props.allSportsOpen ? " sub-open" : ""), onClick: function onClick(e) {
                                            return _this3.props.toggleAllSports(e);
                                        } },
                                    'More',
                                    _react2.default.createElement(_CaretIcon2.default, { type: 'line', direction: '' + (this.props.allSportsOpen ? "left" : "right") }),
                                    _react2.default.createElement(
                                        'ul',
                                        null,
                                        subNav.map(function (link) {
                                            return _this3.mainNavLink(link);
                                        })
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    null,
                                    _react2.default.createElement(
                                        'a',
                                        { href: (0, _commonUtils.getXsellUrl)("https://m.skybet.com?aff=726&dcmp=SL_NAV_Main_SB_19"), target: '_blank' },
                                        'Sky Bet'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    { className: 'pick-7-menu-item' },
                                    _react2.default.createElement(
                                        'a',
                                        { href: (0, _commonUtils.getXsellUrl)("https://itv7.itv.com/?dcmp=SL_Nav"), target: '_blank' },
                                        'ITV7'
                                    )
                                ),
                                (0, _features.has)("insider-benefits") && this.mainNavLink({
                                    href: "/insider",
                                    text: "Insiders",
                                    className: "tablet-shift new-flag",
                                    tracking: (0, _AnalyticsUtils.trackClick)(_consts.INSIDERS_LINK_CLICK_TRACKING_EVENT, { link: "[Insiders] Nav Link" })
                                })
                            )
                        ),
                        this.getHeaderActions("mobile"),
                        LocalSubNav && _react2.default.createElement(LocalSubNav, {
                            open: this.props.subNavOpen,
                            opener: function opener() {
                                var _props2;

                                return (_props2 = _this3.props).toggleSubNav.apply(_props2, arguments);
                            },
                            moreOpen: this.props.subNavMoreOpen,
                            moreOpener: function moreOpener() {
                                var _props3;

                                return (_props3 = _this3.props).toggleSubNavMore.apply(_props3, arguments);
                            }
                        })
                    )
                )
            );
        }
    }], [{
        key: 'calculateScrollThreshold',
        value: function calculateScrollThreshold(maxScrollDiff, currentThreshold, scrollDiff) {
            var scrollThreshold = currentThreshold + scrollDiff > maxScrollDiff ? maxScrollDiff : currentThreshold + scrollDiff;

            return scrollThreshold < 0 ? 0 : scrollThreshold;
        }
    }]);
    return StickyMenu;
}(_react.Component), _class.propTypes = {
    subnav: _propTypes2.default.node,
    location: _propTypes2.default.shape({
        pathname: _propTypes2.default.string
    }).isRequired,
    loggedIn: _propTypes2.default.bool,
    router: _propTypes2.default.object.isRequired,
    featureClasses: _propTypes2.default.array.isRequired,
    toggleMainMenu: _propTypes2.default.func.isRequired,
    mainMenuOpen: _propTypes2.default.bool,
    allSportsOpen: _propTypes2.default.bool,
    subNavOpen: _propTypes2.default.bool,
    subNavMoreOpen: _propTypes2.default.bool,
    toggleSubNav: _propTypes2.default.func.isRequired,
    toggleSubNavMore: _propTypes2.default.func.isRequired,
    toggleAllSports: _propTypes2.default.func.isRequired,
    navConfig: _propTypes2.default.object.isRequired
}, _temp);
exports.default = StickyMenu;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TableCell;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableCell(props) {
  var classes = [];

  var addClass = function addClass(c) {
    return classes.push('column-' + c);
  };

  if ('BOLD' === props.format) {
    addClass('bold');
  } else if ('ITALIC' === props.format) {
    addClass('italic');
  }

  if ('NUMBER' === props.datatype) {
    addClass('num');
  } else if ('DATE' === props.datatype) {
    addClass('date');
  }

  if (props.column_name) {
    addClass(props.column_name);
  }

  return props.header ? _react2.default.createElement(
    'th',
    { className: classes.join(' ') },
    props.value
  ) : _react2.default.createElement(
    'td',
    { className: classes.join(' ') },
    props.value
  );
}

TableCell.propTypes = {
  header: _propTypes2.default.bool,
  format: _propTypes2.default.oneOf(['NORMAL', 'BOLD', 'ITALIC']),
  datatype: _propTypes2.default.oneOf(['NUMBER', 'DATE', 'STRING']),
  value: _propTypes2.default.string,
  column_name: _propTypes2.default.string
};

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = TableRow;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TableCell = __webpack_require__(749);

var _TableCell2 = _interopRequireDefault(_TableCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableRow(props) {
  if (!props.cell || !props.cell.length) {
    return false;
  }

  var classes = [];
  if (props.header) {
    classes.push('header');
  }
  if ('DASHED' === props.format) {
    classes.push('dashed');
  }

  var cells = props.cell.map(function (cell, index) {
    return _react2.default.createElement(_TableCell2.default, (0, _extends3.default)({ key: index }, cell));
  });

  return _react2.default.createElement(
    'tr',
    { className: classes.join(' ') },
    cells
  );
}

TableRow.propTypes = {
  header: _propTypes2.default.bool,
  format: _propTypes2.default.oneOf(['SOLID', 'DASHED']),
  cell: _propTypes2.default.array
};

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1387);

var TagLink = function TagLink(_ref) {
    var link = _ref.link,
        children = _ref.children;
    return _react2.default.createElement(
        'div',
        { className: 'tag-link' },
        _react2.default.createElement(
            _reactRouter.Link,
            { to: link },
            children
        )
    );
};

TagLink.propTypes = {
    link: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.any.isRequired
};

exports.default = TagLink;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TimeSince;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LocalDateTimeHelper = __webpack_require__(13);

var _ClockIcon = __webpack_require__(366);

var _ClockIcon2 = _interopRequireDefault(_ClockIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TimeSince(_ref) {
    var timestamp = _ref.timestamp,
        title = _ref.title;

    var timeSince = (0, _LocalDateTimeHelper.beforeNow)(timestamp);

    return _react2.default.createElement(
        'span',
        { className: 'time-since' },
        _react2.default.createElement(_ClockIcon2.default, { title: title }),
        '\xA0',
        timeSince
    );
}

TimeSince.propTypes = {
    timestamp: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(Date), _propTypes2.default.string, _propTypes2.default.number]),
    title: _propTypes2.default.string.isRequired
};

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PureTipsWidget = undefined;

var _trunc = __webpack_require__(1265);

var _trunc2 = _interopRequireDefault(_trunc);

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _map = __webpack_require__(181);

var _map2 = _interopRequireDefault(_map);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(17);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _tipUtils = __webpack_require__(757);

var _AuthorTile = __webpack_require__(754);

var _AuthorTile2 = _interopRequireDefault(_AuthorTile);

var _RacingTip = __webpack_require__(755);

var _RacingTip2 = _interopRequireDefault(_RacingTip);

var _rides = __webpack_require__(270);

var _reactDeviceDetect = __webpack_require__(109);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(508);

var ROOT_CLICK_EVENT_NAME = '[In Article Tips]';

var PureTipsWidget = exports.PureTipsWidget = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(PureTipsWidget, _Component);

    function PureTipsWidget(props) {
        (0, _classCallCheck3.default)(this, PureTipsWidget);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PureTipsWidget.__proto__ || (0, _getPrototypeOf2.default)(PureTipsWidget)).call(this, props));

        var tips = JSON.parse(_this.props.tips);
        _this.state = {
            tips: tips,
            tipRideData: new _map2.default(),
            rideIds: (0, _tipUtils.getExternalRideIdsFromTipsData)(tips)
        };

        _this.onAuthorNameClick = _this.onAuthorNameClick.bind(_this);
        _this.onOddsClick = _this.onOddsClick.bind(_this);
        _this.onRaceCardLinkClick = _this.onRaceCardLinkClick.bind(_this);
        _this.onMobileTipHorizontalSwipe = _this.onMobileTipHorizontalSwipe.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(PureTipsWidget, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.state.rideIds && this.state.rideIds.length > 0) {
                this.props.loadRides(this.state.rideIds);
            }
        }
    }, {
        key: 'onTrackClick',
        value: function onTrackClick(link) {
            if (!this.context.metrics || !this.context.metrics.track) {
                return;
            }

            this.context.metrics.track("linkClick", { link: link });
        }
    }, {
        key: 'onRaceCardLinkClick',
        value: function onRaceCardLinkClick() {
            this.onTrackClick(ROOT_CLICK_EVENT_NAME + ' Tip Click');
        }
    }, {
        key: 'onOddsClick',
        value: function onOddsClick() {
            this.onTrackClick(ROOT_CLICK_EVENT_NAME + ' Odds Click');
        }
    }, {
        key: 'onAuthorNameClick',
        value: function onAuthorNameClick() {
            this.onTrackClick(ROOT_CLICK_EVENT_NAME + ' Author Click');
        }
    }, {
        key: 'onMobileTipHorizontalSwipe',
        value: function onMobileTipHorizontalSwipe() {
            this.onTrackClick(ROOT_CLICK_EVENT_NAME + ' Tip Swipe');
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var groupedTips = (0, _tipUtils.groupTipsByAuthor)(this.state.tips);

            if (!groupedTips) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'tips-widget' },
                (0, _keys2.default)(groupedTips).map(function (author, idx) {
                    var tips = groupedTips[author];
                    var _tips$ = tips[0],
                        _tips$$author_name = _tips$.author_name,
                        author_name = _tips$$author_name === undefined ? 'SportingLife' : _tips$$author_name,
                        _tips$$author_type = _tips$.author_type,
                        author_type = _tips$$author_type === undefined ? 'Tipster' : _tips$$author_type,
                        _tips$$author_image = _tips$.author_image,
                        author_image = _tips$$author_image === undefined ? '' : _tips$$author_image;


                    var hasLargeTip = tips.length % 2 > 0;
                    var key = author + '-' + idx;

                    if (!_this2.state.tipRideData || _this2.state.tipRideData.size == 0) {
                        return null;
                    }

                    return _react2.default.createElement(
                        'div',
                        { key: key, className: 'tips-widget__author-tips' },
                        _react2.default.createElement(
                            'span',
                            { onClick: _this2.onAuthorNameClick },
                            _react2.default.createElement(_AuthorTile2.default, {
                                name: author_name,
                                type: author_type,
                                image: author_image
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'tips-widget__tips-list ' + (tips.length % 2 !== 0 ? 'tips-widget__tips-list--odd' : '') },
                            tips.map(function (tip, index) {
                                var isLarge = hasLargeTip && index === 0 && !_reactDeviceDetect.isMobile;

                                switch (tip.tip_type) {
                                    case 'racing':
                                        var ride = _this2.state.tipRideData && _this2.state.tipRideData.size > 0 ? _this2.state.tipRideData.get((0, _trunc2.default)(tip.sport_link)) : null;
                                        var imageSet = _this2.props.media[tip.image_id];
                                        return _react2.default.createElement(_RacingTip2.default, {
                                            key: tip.id, tip: tip,
                                            ride: ride,
                                            isLarge: isLarge,
                                            imageSet: imageSet,
                                            onRaceCardLinkClick: _this2.onRaceCardLinkClick,
                                            onOddsClick: _this2.onOddsClick });
                                    default:
                                        return null;
                                }
                            })
                        )
                    );
                })
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(props, state) {
            var tips = JSON.parse(props.tips);
            var rideIds = (0, _tipUtils.getExternalRideIdsFromTipsData)(tips);
            // Load any new ride IDs
            var newRideIds = props.rideIds ? props.rideIds.filter(function (r) {
                return !state.rideIds.includes(r);
            }) : [];
            if (newRideIds.length > 0) {
                props.loadRides(newRideIds);
            }

            return {
                tips: tips,
                rideIds: rideIds,
                tipRideData: (0, _tipUtils.generateRidesTipBettingData)(props.rides, rideIds)
            };
        }
    }]);
    return PureTipsWidget;
}(_react.Component), _class.contextTypes = {
    metrics: _propTypes2.default.object
}, _temp);


PureTipsWidget.propTypes = {
    tips: _propTypes2.default.string,
    loadRides: _propTypes2.default.func
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        rides: state.horseRacing.rides.races,
        media: state.common.media
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        loadRides: function loadRides(rideIds) {
            return dispatch((0, _rides.loadRides)(rideIds));
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PureTipsWidget);

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AuthorAvatar = __webpack_require__(354);

var _AuthorAvatar2 = _interopRequireDefault(_AuthorAvatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1388);

var AuthorTile = function AuthorTile(_ref) {
    var name = _ref.name,
        type = _ref.type,
        image = _ref.image;
    return _react2.default.createElement(
        'div',
        { className: 'author-tile' },
        _react2.default.createElement(
            'div',
            { className: 'author-tile__image' },
            _react2.default.createElement(_AuthorAvatar2.default, { image: image, size: 'small' })
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'div',
                { className: 'author-tile__name' },
                name
            ),
            _react2.default.createElement(
                'div',
                { className: 'author-tile__type' },
                type
            )
        )
    );
};

AuthorTile.propTypes = {
    name: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired,
    image: _propTypes2.default.string
};

AuthorTile.defaultProps = {
    image: ''
};

exports.default = AuthorTile;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(11);

var _BetLink = __webpack_require__(114);

var _BetLink2 = _interopRequireDefault(_BetLink);

var _utils = __webpack_require__(32);

var _Image = __webpack_require__(163);

var _Image2 = _interopRequireDefault(_Image);

var _Stars = __webpack_require__(756);

var _Stars2 = _interopRequireDefault(_Stars);

var _Silk = __webpack_require__(113);

var _Silk2 = _interopRequireDefault(_Silk);

var _moment = __webpack_require__(8);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1389);

var SKYBET_URL = "https://m.skybet.com";

var generateBetLink = function generateBetLink() {
  var rideStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var ride_reference = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var currentOdds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'SP';
  var raceId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  var onOddsClick = arguments[4];

  var canBetlink = rideStatus && rideStatus === 'RUNNER' && raceId && ride_reference.external_reference !== null;

  return canBetlink ? _react2.default.createElement(
    'span',
    { onClick: onOddsClick },
    _react2.default.createElement(
      _BetLink2.default,
      { className: 'tip__odds-link', forceLinkOut: true, eventId: raceId, betId: (0, _utils.getSkyRef)(ride_reference), odds: currentOdds },
      currentOdds
    )
  ) : _react2.default.createElement(
    'a',
    { onClick: onOddsClick, href: SKYBET_URL, className: 'tip__odds-link', target: '_blank' },
    'SP'
  );
};

function getRaceTime(tipDateTime) {
  var raceMoment = (0, _moment2.default)(tipDateTime);

  return raceMoment.format("HH:mm");
}

var RacingTip = function RacingTip(_ref) {
  var tip = _ref.tip,
      ride = _ref.ride,
      onRaceCardLinkClick = _ref.onRaceCardLinkClick,
      onOddsClick = _ref.onOddsClick,
      imageSet = _ref.imageSet,
      isLarge = _ref.isLarge;

  if (!ride || !tip) {
    return null;
  }

  var _ride$betting$current = ride.betting.current_odds,
      currentOdds = _ride$betting$current === undefined ? 'SP' : _ride$betting$current,
      rideStatus = ride.ride_status,
      rideReference = ride.ride_reference,
      raceData = ride.raceData,
      silk_filename = ride.silk_filename;


  var skybetLink = generateBetLink(rideStatus, rideReference, currentOdds, raceData.race_skybetId, onOddsClick);
  var tipCssClasses = ['tip'];
  var imageType = 'tipWidget';
  var imageRatio = 1.9;
  if (isLarge) {
    tipCssClasses.push('large-tip');
    imageType = 'tipWidgetLarge';
    imageRatio = 1.0;
  }

  var advisedAt = void 0;
  if (tip.use_starting_price) {
    advisedAt = "Advised at SP";
  } else if (tip.tipped_at_numerator && tip.tipped_at_denominator) {
    advisedAt = 'Advised at ' + tip.tipped_at_numerator + '/' + tip.tipped_at_denominator;
  } else {
    advisedAt = "";
  }

  return _react2.default.createElement(
    'div',
    { className: tipCssClasses.join(' ') },
    _react2.default.createElement(
      'div',
      { className: 'tip__image' },
      _react2.default.createElement(_Image2.default, { imageMedia: imageSet, imageType: imageType, ratio: imageRatio })
    ),
    _react2.default.createElement(
      'div',
      { className: 'tip__content' },
      _react2.default.createElement(
        'div',
        { className: 'tip__info' },
        _react2.default.createElement(
          'div',
          { className: 'tip__selection' },
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: onRaceCardLinkClick, to: (0, _utils.racecardResultHref)(raceData) + '#' + rideReference.id },
            _react2.default.createElement(
              'div',
              { className: 'tip__silk' },
              _react2.default.createElement(_Silk2.default, { filename: silk_filename })
            ),
            _react2.default.createElement(
              'div',
              { className: 'tip__description' },
              _react2.default.createElement(
                'div',
                { className: 'tip__horse' },
                tip.selection
              ),
              _react2.default.createElement(
                'div',
                { className: 'tip__course' },
                getRaceTime(tip.tip_date) + ' \u2022 ' + tip.course
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'tip__stake-odds' },
          _react2.default.createElement(_Stars2.default, { points: tip.points }),
          _react2.default.createElement(
            'span',
            { className: 'tip__stake' },
            ' \u2022 ' + tip.points + (tip.points == 1 ? 'pt' : 'pts') + ', ' + tip.bet_type + ' \u2022 '
          ),
          _react2.default.createElement(
            'span',
            { className: 'tip__advised-odds' },
            advisedAt
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'tip__summary' },
          tip.summary
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'tip__footer' },
        'Odds provided by ',
        _react2.default.createElement(
          'a',
          { onClick: onOddsClick, href: SKYBET_URL },
          _react2.default.createElement('img', { src: '/img/masthead/skybet-dec2017.png' })
        ),
        skybetLink
      )
    )
  );
};

RacingTip.propTypes = {
  tip: _propTypes2.default.object.isRequired,
  ride: _propTypes2.default.object,
  onRaceCardLinkClick: _propTypes2.default.func,
  onOddsClick: _propTypes2.default.func,
  imageSet: _propTypes2.default.object,
  isLarge: _propTypes2.default.bool
};

exports.default = RacingTip;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Stars;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OPACITY = {
    1: 1,
    2: 0.8,
    3: 0.6,
    4: 0.4,
    5: 0.2
};

function Stars(_ref) {
    var points = _ref.points;

    var count = void 0;
    var stars = [];

    if (points >= 5) {
        count = 5;
    } else {
        count = Math.ceil(points);
    }

    var opacityLevel = OPACITY[count];

    for (var i = 0; i < count; i++) {
        stars.push(_react2.default.createElement('i', { key: 'star' + i, className: 'star ' + (points % 1 !== 0 && i === count - 1 ? 'star--half' : ''),
            'data-char': '\uF0D0',
            style: { opacity: opacityLevel }
        }));
        opacityLevel += 0.2;
    }

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        stars
    );
}

Stars.propTypes = {
    points: _propTypes2.default.number.isRequired
};

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _map = __webpack_require__(181);

var _map2 = _interopRequireDefault(_map);

exports.getExternalRideIdsFromTipsData = getExternalRideIdsFromTipsData;
exports.groupTipsByAuthor = groupTipsByAuthor;
exports.generateRidesTipBettingData = generateRidesTipBettingData;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getExternalRideIdsFromTipsData(tips) {
  var getSportLinkId = function getSportLinkId(tip) {
    return tip.sport_link;
  };
  return tips ? tips.map(getSportLinkId) : [];
}

function groupTipsByAuthor() {
  var tips = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!tips) {
    return null;
  }

  var authorIdx = 0;
  var authorOrder = tips.reduce(function (order, tip) {
    if (!order.has(tip.author_id)) {
      order.set(tip.author_id, authorIdx);
      ++authorIdx;
    }
    return order;
  }, new _map2.default());

  var groupedTips = tips.reduce(function (byAuthor, tip) {
    var idx = authorOrder.get(tip.author_id);
    if (!byAuthor[idx]) {
      byAuthor[idx] = [];
    }

    byAuthor[idx].push(tip);
    return byAuthor;
  }, []);

  return groupedTips;
}
/* Generate the data structure nessesary to display the tip data */
function generateRidesTipBettingData(rides, rideIds) {
  var _ref;

  var flattenedRides = rides && rides.length > 0 ? (_ref = []).concat.apply(_ref, (0, _toConsumableArray3.default)(rides.map(function (race) {
    var _race$race_summary = race.race_summary,
        course_name = _race$race_summary.course_name,
        date = _race$race_summary.date,
        name = _race$race_summary.name,
        race_stage = _race$race_summary.race_stage;

    var skybetExtRaceId = race.race_summary.race_summary_reference.external_reference.find(function (extRef) {
      return extRef.ref === 'skybet';
    });

    race.rides.forEach(function (ride) {
      ride.raceData = {
        course_name: course_name,
        date: date,
        race_name: name,
        race_skybetId: skybetExtRaceId && skybetExtRaceId.value ? skybetExtRaceId.value : null,
        race_id: race.race_summary.race_summary_reference.id,
        raceStage: race_stage
      };
    });
    return race.rides;
  }))) : [];

  var isTippedRide = function isTippedRide(ride) {
    return ride && rideIds.includes(ride.ride_reference.id.toString());
  };

  var getBetAndRideData = function getBetAndRideData(ride) {
    var betting = ride.betting,
        ride_status = ride.ride_status,
        ride_reference = ride.ride_reference,
        silk_filename = ride.silk_filename,
        raceData = ride.raceData;


    return {
      betting: betting,
      ride_status: ride_status,
      ride_reference: ride_reference,
      silk_filename: silk_filename,
      raceData: raceData
    };
  };

  var mapByInternalRideId = function mapByInternalRideId(rideMap, ride) {
    return rideMap.set(ride.ride_reference.id, ride);
  };

  var ridesTipBettingData = flattenedRides.length > 0 ? flattenedRides.filter(isTippedRide).map(getBetAndRideData).reduce(mapByInternalRideId, new _map2.default()) : new _map2.default();

  return ridesTipBettingData;
}

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2; /* eslint react/no-danger: "off" */


var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _consts = __webpack_require__(46);

__webpack_require__(1390);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TwitterShareButton = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(TwitterShareButton, _Component);

  function TwitterShareButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TwitterShareButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TwitterShareButton.__proto__ || (0, _getPrototypeOf2.default)(TwitterShareButton)).call.apply(_ref, [this].concat(args))), _this), _this.getHref = function () {
      var _this$props = _this.props,
          dcmp = _this$props.dcmp,
          page = _this$props.page,
          title = _this$props.title;

      var href = page;

      if (dcmp) {
        href = page + '?dcmp=sl_social_twitter_' + dcmp;
      }

      var url = encodeURIComponent(href);
      var originalReferer = encodeURIComponent(page);
      var encTitle = encodeURIComponent(title + ":");

      return _consts.TWITTER_BASE_URL + '?url=' + url + '&original_referer=' + originalReferer + '&text=' + encTitle;
    }, _this.handleClick = function () {
      if (_this.context.metrics) {
        _this.context.metrics.track("linkClick", { link: "[Article Share] Twitter" });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TwitterShareButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'a',
        { href: this.getHref(), onClick: this.handleClick, target: '_blank', className: "social-share-button-twitter" },
        _react2.default.createElement(
          'div',
          { className: 'social-share-button-twitter-image' },
          _react2.default.createElement(
            'div',
            { className: 'twitter-icon', title: 'Tweet' },
            _react2.default.createElement('img', { src: "/img/icons/twitter.svg" })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'social-share-button-twitter-text' },
          'Tweet'
        )
      );
    }
  }]);
  return TwitterShareButton;
}(_react.Component), _class.contextTypes = {
  metrics: _propTypes2.default.object
}, _class.propTypes = {
  dcmp: _propTypes2.default.string,
  page: _propTypes2.default.string,
  title: _propTypes2.default.string
}, _temp2);
exports.default = TwitterShareButton;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Working m3u8 sample here:
// {src:"https://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8", type:"application/x-mpegURL"}
// Working mp4 sample here:
// return "https://www.w3schools.com/html/mov_bbb.mp4";


var VideoJS = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(VideoJS, _Component);

  function VideoJS() {
    (0, _classCallCheck3.default)(this, VideoJS);
    return (0, _possibleConstructorReturn3.default)(this, (VideoJS.__proto__ || (0, _getPrototypeOf2.default)(VideoJS)).apply(this, arguments));
  }

  (0, _createClass3.default)(VideoJS, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!(0, _lodash.isEqual)(this.props.src, prevProps.src)) {
        this.player.src(this.props.src);
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _lodash.isEqual)(this.props, nextProps) || !(0, _lodash.isEqual)(this.state, nextState);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // videojs is added as a global by manually adding the scripts in the HTML component
      var playerProps = {
        controls: true
      };

      playerProps.techOrder = ["html5", "youtube"];

      this.player = global.videojs(this.videoNode, playerProps);

      if (this.player) {
        this.player.src(this.props.src);

        this.player.on("ready", function () {
          if (_this2.props.autoPlay) {
            _this2.player.play();
          }
        });

        ["Playing", "Ended", "Error"].forEach(function (e) {
          var evName = e.toLowerCase();
          var propName = 'on' + e;

          _this2.player.on(evName, function (evt) {
            if (_this2.props[propName]) {
              _this2.props[propName](evt, _this2.player);
            }
          });
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      // it appears we need to ensure dispose happens *after* React has unmounted the player
      setTimeout(function () {
        return _this3.player.dispose();
      }, 100);
    }
  }, {
    key: 'getNode',
    value: function getNode(node) {
      this.videoNode = node;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var fallbackText = void 0;
      var caption = this.props.caption;


      if (caption) {
        fallbackText = caption + ' - video element not supported';
      } else {
        fallbackText = "Video element not supported";
      }

      return _react2.default.createElement(
        'div',
        { 'data-vjs-player': true },
        _react2.default.createElement(
          'video',
          { ref: function ref(node) {
              return _this4.getNode(node);
            }, className: 'video-js' },
          fallbackText
        )
      );
    }
  }]);
  return VideoJS;
}(_react.Component), _class.propTypes = {
  caption: _propTypes2.default.string,
  autoPlay: _propTypes2.default.bool,
  onPlaying: _propTypes2.default.func,
  onEnded: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  src: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
  children: _propTypes2.default.node
}, _temp);
exports.default = VideoJS;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _VideoPlayer = __webpack_require__(363);

var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YouTubeVideo = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(YouTubeVideo, _Component);

  function YouTubeVideo() {
    var _ref;

    (0, _classCallCheck3.default)(this, YouTubeVideo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = YouTubeVideo.__proto__ || (0, _getPrototypeOf2.default)(YouTubeVideo)).call.apply(_ref, [this].concat(args)));

    _this.state = {
      showPlayer: true
    };

    _this.playedOnce = false;
    return _this;
  }

  (0, _createClass3.default)(YouTubeVideo, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          videoId = _props.videoId,
          placeholderImage = _props.placeholderImage;


      var playerProps = {
        autoPlay: this.playedOnce,
        placeholderImage: placeholderImage,
        onEnded: function onEnded() {
          _this2.setState({ showPlayer: false });
        },
        errorMessage: function errorMessage(_ref2) {
          var code = _ref2.code;

          // These codes are from "videojs-youtube", but it doesn't export constants for them
          // hence the magic numbers. Comments show the associated "videojs-youtube" message
          switch (code) {
            case 1002:
            case 1100:
              // Unable to find the video
              return "this video is no longer available";
            case 1101:
            case 1150:
              // Playback on other Websites has been disabled by the video owner
              return "this video can no longer be played on our site";
          }
        }
      };

      if (this.state.showPlayer) {
        playerProps.src = {
          type: "video/youtube",
          src: 'https://www.youtube.com/watch?v=' + videoId
        };
      } else {
        playerProps.button = {
          type: "play",
          loadSrc: function loadSrc() {
            _this2.setState({ showPlayer: true });
            _this2.playedOnce = true;
          }
        };
      }

      return _react2.default.createElement(_VideoPlayer2.default, playerProps);
    }
  }]);
  return YouTubeVideo;
}(_react.Component), _class.propTypes = {
  videoId: _propTypes2.default.string,
  placeholderImage: _propTypes2.default.string
}, _temp);
exports.default = YouTubeVideo;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AccountIcon(_ref) {
  var title = _ref.title,
      _ref$loggedIn = _ref.loggedIn,
      loggedIn = _ref$loggedIn === undefined ? false : _ref$loggedIn;

  return _react2.default.createElement(
    'svg',
    { className: 'account-icon icon', id: 'account-icon', viewBox: '0 0 78 70', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    _react2.default.createElement(
      'g',
      { fillRule: 'evenodd' },
      _react2.default.createElement('path', { className: 'account', d: 'M32 40C21.4 40 0 45.4 0 56v8h64v-8c0-10.6-21.4-16-32-16m0-8c8.8 0 16-7.2 16-16S40.8 0 32 0 16 7.2 16 16s7.2 16 16 16' }),
      loggedIn && _react2.default.createElement('ellipse', { className: 'tick-circle', cx: '57.261', cy: '48.047', rx: '18.261', ry: '19.047' }),
      loggedIn && _react2.default.createElement('path', { className: 'tick', d: 'M64.847 39.62l-10.7 10.7-3.994-3.995L47 49.478l7.147 7.14.918-.917h.006L68 42.773' })
    )
  );
}

AccountIcon.propTypes = {
  title: _propTypes2.default.string.isRequired,
  loggedIn: _propTypes2.default.bool
};

exports.default = AccountIcon;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BetSlipIcon;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function BetSlipIcon() {
  return _react2.default.createElement(
    "svg",
    { className: "betslip-icon icon", id: "betslip-icon", viewBox: "0 0 20 23", xmlns: "http://www.w3.org/2000/svg" },
    _react2.default.createElement(
      "title",
      null,
      "BetSlip"
    ),
    _react2.default.createElement("path", { d: "M15.666 0H1.626C.77 0 0 .813 0 1.645v16.75C0 19.23.772 20 1.625 20h14.04c.856 0 1.647-.77 1.647-1.604V1.646c0-.833-.79-1.646-1.646-1.646zM3.314 16H13.98v-1.313H3.314V16zm0-3.313H13.98v-1.354H3.314v1.354zM16 18.02c0 .626-.437.668-.604.668H1.917c-.188 0-.604-.042-.604-.667V5.334H16V18.02zM3.314 9.355H13.98V8H3.314v1.354z", fillRule: "evenodd" })
  );
}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BURGER = {
  viewBox: "0 0 64 54",
  paths: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M58.9 21.333H5.1c-2.817 0-5.1 2.384-5.1 5.334C0 29.617 2.283 32 5.1 32h53.8c2.817 0 5.1-2.383 5.1-5.333s-2.283-5.334-5.1-5.334' }),
    _react2.default.createElement('path', { d: 'M58.9 0H5.1C2.283 0 0 2.383 0 5.333s2.283 5.334 5.1 5.334h53.8c2.817 0 5.1-2.384 5.1-5.334C64 2.383 61.717 0 58.9 0' }),
    _react2.default.createElement('path', { d: 'M58.9 42.667H5.1C2.283 42.667 0 45.05 0 48s2.283 5.333 5.1 5.333h53.8c2.817 0 5.1-2.383 5.1-5.333s-2.283-5.333-5.1-5.333' })
  )
};

var CROSS = {
  viewBox: "0 0 64 64",
  paths: _react2.default.createElement('path', { d: 'M63.275 53.79L41.408 31.85l21.917-21.655c.9-.9.9-2.366 0-3.265L57.092.666C56.658.233 56.075 0 55.46 0c-.618 0-1.202.25-1.635.666l-21.817 21.59L10.158.682C9.725.25 9.142.016 8.525.016s-1.2.25-1.633.667L.675 6.946c-.9.9-.9 2.366 0 3.265l21.917 21.66L.742 53.79c-.434.432-.684 1.015-.684 1.63 0 .617.234 1.2.684 1.634l6.233 6.263c.45.45 1.033.683 1.633.683.584 0 1.184-.217 1.634-.683l21.766-21.855L53.792 63.3c.45.45 1.033.683 1.633.683.583 0 1.183-.216 1.633-.683l6.234-6.263c.433-.433.683-1.016.683-1.633-.017-.6-.267-1.182-.7-1.615', fillRule: 'evenodd' })
};

function BurgerIcon(_ref) {
  var title = _ref.title,
      _ref$close = _ref.close,
      close = _ref$close === undefined ? false : _ref$close;

  var _ref2 = close ? CROSS : BURGER,
      viewBox = _ref2.viewBox,
      paths = _ref2.paths;

  return _react2.default.createElement(
    'svg',
    { className: 'burger-icon', viewBox: viewBox, xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement(
      'title',
      null,
      title
    ),
    paths
  );
}

BurgerIcon.propTypes = {
  title: _propTypes2.default.string.isRequired,
  close: _propTypes2.default.bool
};

exports.default = BurgerIcon;

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CalendarIcon;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CalendarIcon() {
  return _react2.default.createElement(
    "svg",
    { className: "calendar-icon", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 68 68" },
    _react2.default.createElement(
      "title",
      null,
      "Calendar"
    ),
    _react2.default.createElement(
      "g",
      { fillRule: "evenodd" },
      _react2.default.createElement("path", { d: "M17 14.57a4.852 4.852 0 0 0 4.857-4.856V4.857A4.852 4.852 0 0 0 17 0a4.852 4.852 0 0 0-4.857 4.857v4.857A4.852 4.852 0 0 0 17 14.57zm34 0a4.852 4.852 0 0 0 4.857-4.856V4.857A4.852 4.852 0 0 0 51 0a4.852 4.852 0 0 0-4.857 4.857v4.857A4.852 4.852 0 0 0 51 14.57" }),
      _react2.default.createElement("path", { d: "M7.286 60.714h53.428V21.857H7.286v38.857zm59.5-55.857h-8.5v6.178c0 3.415-3.522 5.965-7.165 5.965-3.64 0-7.406-2.55-7.406-5.965V4.857H24.286v6.178C24.286 14.45 20.643 17 17 17s-7.286-2.55-7.286-5.965V4.857h-8.5C.546 4.857 0 5.404 0 6.07v60.716C0 67.454.546 68 1.214 68h65.572c.667 0 1.214-.546 1.214-1.214V6.07c0-.667-.547-1.214-1.214-1.214z" })
    )
  );
}

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CloseIcon;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CloseIcon() {
  return _react2.default.createElement(
    "svg",
    { className: "close-icon icon", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" },
    _react2.default.createElement(
      "title",
      null,
      "Close"
    ),
    _react2.default.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }),
    _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
  );
}

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotificationsIcon() {
  return _react2.default.createElement(
    "svg",
    { className: "notifications-icon", viewBox: "0 0 73 82", xmlns: "http://www.w3.org/2000/svg" },
    _react2.default.createElement(
      "title",
      null,
      "Notifications"
    ),
    _react2.default.createElement(
      "g",
      { fill: "none", fillRule: "evenodd", transform: "translate(0 2)" },
      _react2.default.createElement("path", { fill: "#1B3C7B", d: "M47.68 16.512H4.947C2.35 16.512 0 19.092 0 21.735v53.172C0 77.553 2.35 80 4.947 80H47.68c2.6 0 5.008-2.447 5.008-5.093V21.735c0-2.644-2.407-5.223-5.008-5.223zM10.085 67.304h32.463v-4.17H10.085v4.17zm0-10.52h32.463v-4.298H10.085v4.3zm38.612 16.933c0 1.984-1.332 2.117-1.84 2.117H5.837c-.574 0-1.84-.133-1.84-2.117V33.44h44.7v40.277zm-38.612-27.51h32.463v-4.302H10.085v4.3z" }),
      _react2.default.createElement("ellipse", { cx: "51.739", cy: "19.686", fill: "#DD2E2E", stroke: "#FFF", strokeWidth: "4.5", rx: "18.261", ry: "19.047" })
    )
  );
}

exports.default = NotificationsIcon;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PlayIcon(_ref) {
  var title = _ref.title,
      subText = _ref.subText;

  return _react2.default.createElement(
    'div',
    { className: 'play-icon' },
    _react2.default.createElement(
      'span',
      null,
      subText
    ),
    _react2.default.createElement(
      'svg',
      { viewBox: '0 0 64 64', version: '1.1', xmlns: 'http://www.w3.org/2000/svg' },
      _react2.default.createElement(
        'title',
        null,
        title
      ),
      _react2.default.createElement(
        'g',
        { fillRule: 'evenodd' },
        _react2.default.createElement(
          'g',
          { transform: 'translate(-1566.000000, -367.000000)' },
          _react2.default.createElement(
            'g',
            { transform: 'translate(1365.000000, 35.000000)' },
            _react2.default.createElement('path', { d: 'M233,396 C250.673112,396 265,381.673112 265,364 C265,346.326888 250.673112,332 233,332 C215.326888,332 201,346.326888 201,364 C201,381.673112 215.326888,396 233,396 Z M229.316844,378.728219 L229.513822,378.559469 L244.193419,365.809375 C244.690462,365.378219 245,364.73125 245,364.009469 C245,363.287594 244.681176,362.640625 244.193419,362.209469 L229.541868,349.46875 L229.298084,349.253219 C229.063586,349.09375 228.782188,349 228.48203,349 C227.665882,349 227,349.693844 227,350.556344 L227,377.443844 C227,378.306344 227.665882,379 228.48203,379 C228.791474,379 229.082345,378.896969 229.316844,378.728219 Z' })
          )
        )
      )
    )
  );
}

PlayIcon.propTypes = {
  title: _propTypes2.default.string.isRequired,
  subText: _propTypes2.default.string
};

exports.default = PlayIcon;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PrintButton;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PrintButton() {
  return _react2.default.createElement(
    "button",
    { className: "print-button", onClick: function onClick() {
        return window.print();
      } },
    _react2.default.createElement(
      "svg",
      { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 -256 1792 1792", className: "print-icon" },
      _react2.default.createElement(
        "title",
        null,
        "Print"
      ),
      _react2.default.createElement("path", { d: "M437.153 1270.237h896v-256h-896v256zm0-640h896v-384h-160q-40 0-68-28t-28-68v-160h-640v640zm1152 64q0-26-19-45t-45-19q-26 0-45 19t-19 45q0 26 19 45t45 19q26 0 45-19t19-45zm128 0v416q0 13-9.5 22.5t-22.5 9.5h-224v160q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-224q-13 0-22.5-9.5t-9.5-22.5v-416q0-79 56.5-135.5t135.5-56.5h64v-544q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v256h64q79 0 135.5 56.5t56.5 135.5z" })
    ),
    _react2.default.createElement(
      "span",
      { className: "print-button-label" },
      "Print"
    )
  );
}

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SearchIcon() {
  return _react2.default.createElement(
    "svg",
    { className: "search-icon", viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg" },
    _react2.default.createElement(
      "title",
      null,
      "Search"
    ),
    _react2.default.createElement("path", { d: "M39.567 11.2c3.783 3.783 5.866 8.817 5.866 14.167S43.35 35.75 39.567 39.533C35.783 43.317 30.75 45.4 25.4 45.4s-10.383-2.083-14.167-5.867C7.45 35.75 5.367 30.717 5.367 25.367S7.45 14.983 11.233 11.2C15.017 7.417 20.05 5.333 25.4 5.333S35.783 7.417 39.567 11.2zM46.75 39c2.5-3.933 3.967-8.6 3.967-13.617C50.717 11.367 39.367 0 25.367 0 11.35 0 0 11.367 0 25.383 0 39.4 11.35 50.767 25.35 50.767c5.083 0 9.817-1.5 13.783-4.067l1.15-.8 18.1 18.1L64 58.283l-18.083-18.1L46.75 39z", fillRule: "evenodd" })
  );
}

exports.default = SearchIcon;

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SimpleDonut;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*

Usage <SimpleDonut a={oneValue} b={anotherValue} className="aClass" unit="%"/>

a: mandatory left hand value
b: mandatory right hand value
className: optionally set the base class for all the element. All sub classes will use this base.
unit: optional unit to display in the middle of the donut

*/
function SimpleDonut(_ref) {
  var a = _ref.a,
      b = _ref.b,
      _ref$unit = _ref.unit,
      unit = _ref$unit === undefined ? "" : _ref$unit,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? "simple-donut" : _ref$className;

  // these two values chosen to match dimensions given in design
  var outerRadius = 80;
  var donutThickness = 20;

  // derive some dimensions from them
  var svgSize = outerRadius * 2;
  var innerRadius = outerRadius - donutThickness;

  // trigonometry for calculating the end point
  var angle = void 0;

  if (a + b == 0) {
    angle = Math.PI;
  } else {
    angle = Math.PI * 2 * b / (a + b);
  }

  var sin = Math.sin(angle);
  var cos = Math.cos(angle);

  // the fout apex points required for the path
  var startPoint = outerRadius + ' 0';
  var innerStartPoint = outerRadius + ' ' + donutThickness;

  var outerEndPoint = getPoint(outerRadius, sin, cos);
  var innerEndPoint = getPoint(innerRadius, sin, cos);

  // Required for arcs that are larger than a half turn
  var outerBottomPoint = getPoint(outerRadius, 0, -1); // ie angle is pi
  var innerBottomPoint = getPoint(innerRadius, 0, -1); // ie angle is pi

  var leftArcIsLarge = a > b;

  // some helpers that clarify the calculations
  // inner functions to keep their signature clean

  function getPoint(radius, sin, cos) {
    return outerRadius + radius * sin + ' ' + (outerRadius - radius * cos);
  }

  function getArc(radius, sweepFlag, endPoint) {
    // arc is circular, so both radii are the same and that axes aren't rotated
    // arc sweeps no more than half a turn (it gets split in two if needed),
    // so the large arc flag is always zero
    return 'A' + radius + ' ' + radius + ' 0 0 ' + sweepFlag + ' ' + endPoint;
  }

  function getPath(arcIsLarge, arcIsLeft) {
    // sweep one way there and the other back
    // left and right sweep opposite ways
    var innerSweepFlag = arcIsLeft * 1;
    var outerSweepFlag = 1 - innerSweepFlag;

    var outerArc = getArc(outerRadius, outerSweepFlag, outerEndPoint);
    var innerArc = getArc(innerRadius, innerSweepFlag, innerStartPoint);

    // split the arc in two if it sweeps more than half a turn, by adding half turn arc first
    // * solves the full circle problem
    // * removes the need to calculate the large arc flag
    if (arcIsLarge) {
      outerArc = '' + getArc(outerRadius, outerSweepFlag, outerBottomPoint) + outerArc;
      innerArc = '' + getArc(innerRadius, innerSweepFlag, innerBottomPoint) + innerArc;
    }

    // move the top, arc around the outside, line to the inside, arc back along the inside, and close the path
    return 'M' + startPoint + outerArc + 'L' + innerEndPoint + innerArc + 'z';
  }

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'svg',
      { className: className + '-donut', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 ' + svgSize + ' ' + svgSize },
      _react2.default.createElement('path', { className: className + '-arc-a', d: getPath(leftArcIsLarge, true) }),
      _react2.default.createElement('path', { className: className + '-arc-b', d: getPath(!leftArcIsLarge, false) })
    ),
    _react2.default.createElement(
      'span',
      { className: className + '-text-a' },
      a
    ),
    _react2.default.createElement(
      'span',
      { className: className + '-text-b' },
      b
    ),
    _react2.default.createElement(
      'span',
      { className: className + '-text-unit' },
      unit
    )
  );
}

SimpleDonut.propTypes = {
  className: _propTypes2.default.string,
  unit: _propTypes2.default.string,
  a: _propTypes2.default.number.isRequired,
  b: _propTypes2.default.number.isRequired
};

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SkyBetLogo() {
  return _react2.default.createElement(
    "svg",
    { className: "skybet-logo", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 604.5 176.5", preserveAspectRatio: "xMinYMid" },
    _react2.default.createElement(
      "title",
      null,
      "Skybet - Making Betting Better"
    ),
    _react2.default.createElement("path", { className: "sbl-sky-background", d: "M195.344 336c-5.203 0-9.344-4.34-9.344-9.305V204.387c0-5.162 4.225-9.387 9.387-9.387H421v141H195.344z", transform: "matrix(1.25 0 0 -1.25 -232.25 420.36)" }),
    _react2.default.createElement("path", { className: "sbl-bet-background", d: "M421 336V195h238.812c5.185 0 9.388 4.203 9.388 9.387v122.226c0 5.185-4.203 9.387-9.388 9.387H421z", transform: "matrix(1.25 0 0 -1.25 -232.25 420.36)" }),
    _react2.default.createElement(
      "g",
      { className: "sbl-gradient", opacity: ".2", transform: "matrix(1.25 0 0 -1.25 -232.25 420.36)" },
      _react2.default.createElement("path", { d: "M195.388 336h464.425c5.184 0 9.387-4.203 9.387-9.387V281.78l-469.667-26.105c-7.56-.3-13.533-6.51-13.533-14.07v85.008c0 5.184 4.203 9.387 9.388 9.387" })
    ),
    _react2.default.createElement("path", { className: "sbl-sky-word", d: "M110.61 104.293c0 13.747-8.99 23.79-27.24 25.78-13.226 1.413-32.374-.258-41.462-1.302-.34-1.48-.603-3.33-.603-4.78 0-12.02 6.508-14.77 12.59-14.77 6.328 0 16.293 1.1 23.713 1.1 8.14 0 10.63-2.77 10.63-5.4 0-3.45-3.294-4.88-9.622-6.09L61.308 95.5c-14.414-2.76-22.105-12.735-22.105-23.31 0-12.86 9.1-23.626 27.005-25.607 13.532-1.465 30 .186 39.04 1.296.335 1.55.508 3.02.508 4.63 0 11.99-6.325 14.58-12.418 14.58-4.687 0-11.95-.88-20.242-.88-8.445 0-11.946 2.33-11.946 5.18 0 3 3.335 4.24 8.624 5.16l16.55 3.07c17 3.13 24.285 12.79 24.285 24.67m29.64 14.84c0 7.39-2.9 11.64-17.32 11.64-1.91 0-3.58-.14-5.19-.37v-98c0-7.44 2.53-15.2 17.1-15.2 1.83 0 3.68.19 5.4.55v101.37zm58.9 37.76c1.88.96 5.76 2.13 10.64 2.26 8.34.18 12.91-3.025 16.29-10.51L270.93 48.6c-1.85-.992-5.95-2.097-9.31-2.176-5.76-.1-13.5 1.08-18.45 12.88L228.65 93.6l-28.48-46.39c-1.834-.566-6.32-1.373-9.613-1.373-10.036 0-15.666 3.71-21.496 10.035l-27.69 30.282 22.27 35.057c4.12 6.39 9.55 9.65 18.35 9.65 5.77 0 10.56-1.31 12.78-2.37l-26.81-40.45 19.01-20.14 31.18 48.93-18.99 40.07z" }),
    _react2.default.createElement("path", { className: "sbl-bet-word", d: "M567.927 125.116c-7.064 3.446-15.336 5.514-23.776 5.514-16.19 0-26.01-9.305-26.65-25.326V31.542c.64-3.1 2.36-5.17 7.7-5.17 2.42 0 5 .518 6.05 1.034v19.2h33.06c.17 1.326.52 3.566.52 5.633 0 4.82-2.06 6.37-5 5.61h-28.58v46.41c.16 9.99 4.98 14.3 14.28 14.3 8.45 0 13.44-3.28 17.4-3.28 3.8 0 5.69 3.44 5 9.82" }),
    _react2.default.createElement("path", { className: "sbl-bet-word", d: "M369.663 119.315c-11.108 0-21.354-6.49-25.788-15.886V74.9c4.434-9.395 14.68-15.887 25.788-15.887 16.06 0 27.844 12.302 27.844 30.06 0 17.93-11.785 30.234-27.844 30.234M372.21 46.9c-12.398 0-22.4 5.773-28.34 14.08V19.95c-1.358-.33-3.74-.674-6.116-.674-5.775 0-7.635 2.04-7.635 5.26V129.2c1.36.514 4.07 1.017 6.44 1.017 5.43 0 7.3-2.204 7.3-6.45v-6.617c5.93 8.32 15.94 14.09 28.33 14.09 20.53 0 39.19-15.78 39.19-42.254 0-26.303-18.67-42.084-39.2-42.084" }),
    _react2.default.createElement("path", { className: "sbl-bet-word", d: "M463.895 57.852c3.57 0 6.84.685 9.714 2.043 2.88 1.37 5.38 3.255 7.41 5.604 2.07 2.37 3.73 5.18 4.94 8.36 1.07 2.81 1.77 5.83 2.07 8.99h-49.56c.39-3.25 1.17-6.31 2.35-9.13 1.32-3.17 3.12-6 5.33-8.37 2.2-2.37 4.84-4.22 7.84-5.55 2.98-1.31 6.32-1.97 9.9-1.97m34.94 14.52c-1.48-4.56-3.76-8.78-6.78-12.53-3.03-3.78-6.94-6.94-11.62-9.39-4.7-2.47-10.26-3.72-16.54-3.72-5.47 0-10.66 1.1-15.39 3.26-4.74 2.16-8.92 5.17-12.45 8.93-3.53 3.75-6.33 8.28-8.32 13.46-1.98 5.16-2.99 10.82-2.99 16.83 0 5.99.94 11.62 2.81 16.72 1.88 5.11 4.65 9.672 8.23 13.55 3.6 3.874 8.08 6.95 13.33 9.11 5.22 2.166 11.2 3.254 17.76 3.254 6.19 0 11.94-.81 17.09-2.386 5.1-1.567 9.22-3.17 12.25-4.747l.54-.27.1-.584c.5-2.766.16-5.05-1.02-6.815-1.21-1.82-2.884-2.79-4.84-2.79-1.357 0-2.85.31-4.43.92-1.39.54-3.03 1.125-5.026 1.81-1.893.65-4.083 1.26-6.53 1.8-2.384.526-5.234.81-8.463.81-3.84 0-7.49-.6-10.83-1.777-3.33-1.15-6.29-2.885-8.82-5.16-2.534-2.264-4.59-5.065-6.12-8.344-1.38-2.95-2.237-6.388-2.544-10.23h62.04l.23-.93c.37-1.45.54-3.93.54-7.63 0-4.21-.75-8.63-2.23-13.18" })
  );
}

exports.default = SkyBetLogo;

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VideoIcon() {
  return _react2.default.createElement(
    "svg",
    { className: "video-icon", viewBox: "0 0 63 41", xmlns: "http://www.w3.org/2000/svg" },
    _react2.default.createElement(
      "title",
      null,
      "Video"
    ),
    _react2.default.createElement("path", { d: "M38.07 0H5.296C2.505 0 0 2.253 0 5.225v30.027c0 2.972 2.506 5.657 5.295 5.657H38.07c2.788 0 4.94-2.686 4.94-5.658V5.225C43.01 2.253 40.86 0 38.07 0zm8.85 11.996v12.767l15.64 7.964V4.09z", fillRule: "evenodd" })
  );
}

exports.default = VideoIcon;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PureBetslipButton = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(17);

var _BetSlipIcon = __webpack_require__(762);

var _BetSlipIcon2 = _interopRequireDefault(_BetSlipIcon);

var _betslip = __webpack_require__(205);

var _features = __webpack_require__(65);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PureBetslipButton = exports.PureBetslipButton = function (_Component) {
    (0, _inherits3.default)(PureBetslipButton, _Component);

    function PureBetslipButton(props) {
        (0, _classCallCheck3.default)(this, PureBetslipButton);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PureBetslipButton.__proto__ || (0, _getPrototypeOf2.default)(PureBetslipButton)).call(this, props));

        _this.state = {
            betSlipEnabled: (0, _features.isBetSlipEnabled)()
        };

        _this.betSlipButtonClick = _this.betSlipButtonClick.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(PureBetslipButton, [{
        key: 'betSlipButtonClick',
        value: function betSlipButtonClick() {
            this.props.openBetslip();
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            if (nextProps.betCount != this.props.betCount) {
                return true;
            }

            return false;
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.props.betslipInitialised) {
                this.props.initBetslip();
            }

            var betSlipEnabled = (0, _features.isBetSlipEnabled)();
            if (betSlipEnabled !== this.state.betSlipEnabled) {
                this.setState({
                    betSlipEnabled: betSlipEnabled
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.state.betSlipEnabled) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: 'main-betslip-icon header-action' },
                _react2.default.createElement(
                    'button',
                    { onClick: this.betSlipButtonClick },
                    !!this.props.betCount && _react2.default.createElement(
                        'span',
                        { className: 'main-betslip-icon-count' },
                        this.props.betCount
                    ),
                    _react2.default.createElement(_BetSlipIcon2.default, null),
                    _react2.default.createElement(
                        'span',
                        null,
                        'Bet Slip'
                    )
                )
            );
        }
    }]);
    return PureBetslipButton;
}(_react.Component);

PureBetslipButton.propTypes = {
    openBetslip: _propTypes2.default.func.isRequired,
    initBetslip: _propTypes2.default.func.isRequired,
    betCount: _propTypes2.default.number,
    betslipInitialised: _propTypes2.default.bool
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        betCount: state.common.betslip.count,
        betslipInitialised: state.common.betslip.initialised
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        openBetslip: function openBetslip() {
            dispatch((0, _betslip.openBetslip)());
        },
        initBetslip: function initBetslip() {
            dispatch((0, _betslip.initBetslip)());
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PureBetslipButton);

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CookieNotice = __webpack_require__(728);

var _CookieNotice2 = _interopRequireDefault(_CookieNotice);

var _reactRedux = __webpack_require__(17);

var _cookies = __webpack_require__(206);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    var cookieName = _config2.default.cookiePolicy.cookieName;
    return {
        accepted: state.common.cookies[cookieName]
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        acceptCookiePolicy: function acceptCookiePolicy() {
            dispatch((0, _cookies.setCookie)(_config2.default.cookiePolicy.cookieName, _config2.default.cookiePolicy.cookieValue, {
                path: "/",
                expires: new Date(new Date().setFullYear(new Date().getFullYear() + 100))
            }));
        },
        fetchHasAcceptedPolicy: function fetchHasAcceptedPolicy() {
            dispatch((0, _cookies.getCookie)(_config2.default.cookiePolicy.cookieName, false));
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_CookieNotice2.default);

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = __webpack_require__(17);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _feedbackForm = __webpack_require__(161);

var _FeedbackForm = __webpack_require__(733);

var _FeedbackForm2 = _interopRequireDefault(_FeedbackForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, props) {
    var _config$googleRecaptc = _config2.default.googleRecaptchaSiteKey,
        reCaptchaKey = _config$googleRecaptc === undefined ? "" : _config$googleRecaptc;
    var _state$common = state.common;
    _state$common = _state$common === undefined ? {} : _state$common;
    var _state$common$display = _state$common.display;
    _state$common$display = _state$common$display === undefined ? {} : _state$common$display;
    var _state$common$display2 = _state$common$display.feedbackForm;
    _state$common$display2 = _state$common$display2 === undefined ? {} : _state$common$display2;
    var _state$common$display3 = _state$common$display2.sent,
        feedbackSent = _state$common$display3 === undefined ? false : _state$common$display3,
        _state$common$display4 = _state$common$display2.sendingError,
        sendingError = _state$common$display4 === undefined ? false : _state$common$display4;

    return (0, _extends3.default)({}, props, { reCaptchaKey: reCaptchaKey, feedbackSent: feedbackSent, sendingError: sendingError });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        formSubmitAction: function formSubmitAction(data) {
            return dispatch((0, _feedbackForm.sendFeedback)(data));
        },
        closeAction: function closeAction() {
            return dispatch((0, _feedbackForm.showFeedbackForm)(false));
        },
        resetFormAction: function resetFormAction() {
            return dispatch((0, _feedbackForm.resetFeedbackForm)());
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FeedbackForm2.default);

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(17);

var _trackingEvents = __webpack_require__(250);

var _InsiderCta = __webpack_require__(737);

var _InsiderCta2 = _interopRequireDefault(_InsiderCta);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    return {
        loggedIn: state.common.auth.loggedIn
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fireEventTracking: function fireEventTracking() {
            dispatch((0, _trackingEvents.sendEventTracking)(_trackingEvents.INSIDER_CATEGORY, _trackingEvents.INSIDER_CTA_CLICK));
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_InsiderCta2.default);

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseLightboxContainer = __webpack_require__(371);

var _BaseLightboxContainer2 = _interopRequireDefault(_BaseLightboxContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginLightboxContainer = function LoginLightboxContainer() {
  return _react2.default.createElement(_BaseLightboxContainer2.default, {
    type: 'login',
    title: 'Please sign in...',
    message: 'Please log in on the iOS app to receive notifications for this event.',
    messagesByType: {
      HORSE: "Please log in to add this horse to your stable",
      JOCKEY: "Please log in to add this jockey to your stable",
      TRAINER: "Please log in to add this trainer to your stable"
    }
  });
};

exports.default = LoginLightboxContainer;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseLightboxContainer = __webpack_require__(371);

var _BaseLightboxContainer2 = _interopRequireDefault(_BaseLightboxContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyStableLightboxContainer = function MyStableLightboxContainer() {
  return _react2.default.createElement(_BaseLightboxContainer2.default, {
    type: 'mystable',
    title: 'My Stable',
    message: 'You\'ll need to sign in or register with My Stable to enable this feature.'
  });
};

exports.default = MyStableLightboxContainer;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PureLoginButton = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(17);

var _reactMetrics = __webpack_require__(69);

var _AccountIcon = __webpack_require__(761);

var _AccountIcon2 = _interopRequireDefault(_AccountIcon);

var _AnalyticsUtils = __webpack_require__(63);

var _skysso = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PureLoginButton = exports.PureLoginButton = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PureLoginButton, _Component);

  function PureLoginButton(props) {
    (0, _classCallCheck3.default)(this, PureLoginButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PureLoginButton.__proto__ || (0, _getPrototypeOf2.default)(PureLoginButton)).call(this, props));

    _this.showMyAccount = _this.showMyAccount.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(PureLoginButton, [{
    key: 'showMyAccount',
    value: function showMyAccount() {
      if (this.props.auth.loggedIn) {
        this.props.openMyAccount();
      } else {
        this.props.openLogin();
      }
    }
  }, {
    key: 'getLabel',
    value: function getLabel() {
      if (this.props.auth.loggedIn) {
        return "My Account";
      }

      if (this.props.device === "mobile") {
        return "Log in";
      }

      return "Log in / Register";
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactMetrics.MetricsElement,
        null,
        _react2.default.createElement(
          'button',
          (0, _extends3.default)({ className: 'user-bar', id: 'user-bar-' + this.props.device,
            disabled: !this.props.auth.ssoApi,
            onClick: this.showMyAccount
          }, (0, _AnalyticsUtils.trackClick)("login", { loggedIn: this.props.auth.loggedIn ? 'logged-in' : 'not logged-in' })),
          _react2.default.createElement(_AccountIcon2.default, { title: 'My Account', loggedIn: this.props.auth.loggedIn }),
          _react2.default.createElement(
            'span',
            null,
            this.getLabel()
          )
        )
      );
    }
  }]);
  return PureLoginButton;
}(_react.Component), _class.contextTypes = {
  metrics: _reactMetrics.PropTypes.metrics
}, _class.propTypes = {
  auth: _propTypes2.default.object.isRequired,
  device: _propTypes2.default.string.isRequired,
  openMyAccount: _propTypes2.default.func.isRequired,
  openLogin: _propTypes2.default.func.isRequired
}, _temp);


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openLogin: function openLogin() {
      return dispatch((0, _skysso.SSOLogin)());
    },
    openMyAccount: function openMyAccount() {
      return dispatch((0, _skysso.SSOMyAccount)());
    }
  };
};

exports.default = (0, _reactMetrics.exposeMetrics)((0, _reactRedux.connect)(function (state) {
  return { auth: state.common.auth };
}, mapDispatchToProps)(PureLoginButton));

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(509);

var MyStableCross = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(MyStableCross, _PureComponent);

  function MyStableCross() {
    (0, _classCallCheck3.default)(this, MyStableCross);
    return (0, _possibleConstructorReturn3.default)(this, (MyStableCross.__proto__ || (0, _getPrototypeOf2.default)(MyStableCross)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyStableCross, [{
    key: 'render',
    value: function render() {
      var _props$deleteSubscrip = this.props.deleteSubscriptions,
          deleteSubscriptions = _props$deleteSubscrip === undefined ? function () {} : _props$deleteSubscrip;


      return _react2.default.createElement(
        'a',
        { className: 'my-stable-selections-remove', id: 'my-stable-selections-remove', href: '#', onClick: function onClick() {
            return deleteSubscriptions();
          } },
        '\xD7'
      );
    }
  }]);
  return MyStableCross;
}(_react.PureComponent), _class.propTypes = {
  deleteSubscriptions: _propTypes2.default.func
}, _temp);
exports.default = MyStableCross;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyStableLink = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(MyStableLink, _PureComponent);

  function MyStableLink() {
    (0, _classCallCheck3.default)(this, MyStableLink);
    return (0, _possibleConstructorReturn3.default)(this, (MyStableLink.__proto__ || (0, _getPrototypeOf2.default)(MyStableLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyStableLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$hasSubscriptio = _props.hasSubscriptions,
          hasSubscriptions = _props$hasSubscriptio === undefined ? false : _props$hasSubscriptio,
          _props$saveSubscripti = _props.saveSubscriptions,
          saveSubscriptions = _props$saveSubscripti === undefined ? function () {} : _props$saveSubscripti;


      if (!hasSubscriptions) {
        return _react2.default.createElement(
          'a',
          { className: 'my-stable-add-to-stable', id: 'my-stable-add-to-stable', onClick: function onClick() {
              return saveSubscriptions();
            } },
          'Add to my stable'
        );
      } else {
        return _react2.default.createElement(
          'a',
          { className: 'my-stable-already-in-stable' },
          'Following'
        );
      }
    }
  }]);
  return MyStableLink;
}(_react.PureComponent), _class.propTypes = {
  hasSubscriptions: _propTypes2.default.bool,
  saveSubscriptions: _propTypes2.default.func
}, _temp);
exports.default = MyStableLink;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (requestHandler) {

    return {
        sendToApi: sendToApi
    };

    function sendToApi(store, next, action) {
        if (!action.data) {
            return next(action);
        }
        //send action & store to api handler
        requestHandler(action, store);
        return next(action);
    }
};

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _combinedRequestHandler = __webpack_require__(726);

var _combinedRequestHandler2 = _interopRequireDefault(_combinedRequestHandler);

var _ApiClient = __webpack_require__(64);

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _apiRequest = __webpack_require__(782);

var _apiRequest2 = _interopRequireDefault(_apiRequest);

var _feedbackRequest = __webpack_require__(727);

var _feedbackRequest2 = _interopRequireDefault(_feedbackRequest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var requestHandlers = [_feedbackRequest2.default];
    var apiClient = new _ApiClient2.default();
    var combinedRequestHandler = new _combinedRequestHandler2.default(apiClient, _config2.default.api, requestHandlers);
    var apiRequest = new _apiRequest2.default(combinedRequestHandler);
    return (0, _keys2.default)(apiRequest).map(function (key) {
        return function (store) {
            return function (next) {
                return function (action) {
                    return apiRequest[key](store, next, action);
                };
            };
        };
    });
};

//handlers for api request actions

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _oddsCheckerBetslip = __webpack_require__(789);

var _oddsCheckerBetslip2 = _interopRequireDefault(_oddsCheckerBetslip);

var _features = __webpack_require__(65);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (config) {
  if (!global.window) {
    return [];
  }

  if ((0, _features.has)("integrated-betslip") && (0, _features.has)('oddschecker-betslip')) {
    return [].concat((0, _toConsumableArray3.default)((0, _oddsCheckerBetslip2.default)(global.window, config)));
  }

  return [];
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cookies = __webpack_require__(206);

var _middlewareUtils = __webpack_require__(119);

exports.default = function () {
    var cookie = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __webpack_require__(339);


    return [(0, _middlewareUtils.middlewareWrapper)(setCookie), (0, _middlewareUtils.middlewareWrapper)(getCookie)];

    function setCookie(store, next, action) {
        if (action.type === _cookies.SET_COOKIE) {
            cookie.save(action.cookieName, action.value, action.options);
            return next((0, _cookies.storeCookie)(action.cookieName, action.value));
        }
        return next(action);
    }

    function getCookie(store, next, action) {
        if (action.type === _cookies.GET_COOKIE) {
            var value = cookie.load(action.cookieName);
            if (value === undefined) {
                if (action.defaultValue === null) {
                    return next(action);
                }

                value = action.defaultValue;
            }
            return next((0, _cookies.storeCookie)(action.cookieName, value));
        }
        return next(action);
    }
};

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _feedbackForm = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (navigator, window) {
    return {
        submitFeedback: submitFeedback
    };
    function submitFeedback(store, next, action) {
        if (action.type === _feedbackForm.SUBMIT_FEEDBACK) {
            var getState = store.getState,
                dispatch = store.dispatch;
            var _navigator$userAgent = navigator.userAgent,
                userAgent = _navigator$userAgent === undefined ? null : _navigator$userAgent;
            var _window$location = window.location;
            _window$location = _window$location === undefined ? {} : _window$location;
            var _window$location$href = _window$location.href,
                currentUrl = _window$location$href === undefined ? '' : _window$location$href;

            var _getState = getState(),
                _getState$common = _getState.common;

            _getState$common = _getState$common === undefined ? {} : _getState$common;
            var _getState$common$auth = _getState$common.auth;
            _getState$common$auth = _getState$common$auth === undefined ? {} : _getState$common$auth;
            var _getState$common$auth2 = _getState$common$auth.username,
                username = _getState$common$auth2 === undefined ? null : _getState$common$auth2;


            if (userAgent && action.data) {
                dispatch({ type: _feedbackForm.SEND_FEEDBACK, data: (0, _extends3.default)({}, action.data, {
                        userAgent: userAgent,
                        username: username,
                        currentUrl: currentUrl
                    }) });
            }
        }
        return next(action);
    }
};

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _feedbackSubmit = __webpack_require__(786);

var _feedbackSubmit2 = _interopRequireDefault(_feedbackSubmit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var navigator = global.navigator ? global.navigator : null;
    var window = global.window ? global.window : null;
    var feedbackSubmit = new _feedbackSubmit2.default(navigator, window);
    return (0, _keys2.default)(feedbackSubmit).map(function (key) {
        return function (store) {
            return function (next) {
                return function (action) {
                    return feedbackSubmit[key](store, next, action);
                };
            };
        };
    });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _middlewareUtils = __webpack_require__(119);

var _menuUtils = __webpack_require__(441);

var _menu = __webpack_require__(259);

exports.default = function () {
    return [(0, _middlewareUtils.middlewareWrapper)(show)];

    function show(store, next, action) {
        if (action.type === _menu.SHOW) {
            (0, _menuUtils.showMenu)();
            store.dispatch((0, _menu.shownMenu)());
        }

        return next(action);
    }
};

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _middlewareUtils = __webpack_require__(119);

var _betslip = __webpack_require__(205);

var _betlink = __webpack_require__(257);

var _menu = __webpack_require__(259);

exports.default = function (window, config) {
    return [(0, _middlewareUtils.middlewareWrapper)(init), (0, _middlewareUtils.middlewareWrapper)(open), (0, _middlewareUtils.middlewareWrapper)(addBet)];

    function init(store, next, action) {
        if (action.type === _betslip.INIT) {
            if (typeof window == 'undefined' || !window.ocRenderers) {
                return next(action);
            }

            var dispatch = store.dispatch,
                getState = store.getState;

            var betslipState = getState().common.betslip;
            if (betslipState.initialised) {
                return next(action);
            }

            var initOcBetSlip = function initOcBetSlip() {
                if (!window.ocBetslip) {
                    setTimeout(initOcBetSlip, 1);
                    return;
                }

                var setCount = function setCount() {
                    var count = window.ocBetslip.getBetCount();
                    dispatch((0, _betslip.setBetCount)(count));
                    if (betslipState.count != count && count > 0) {
                        dispatch((0, _menu.showMenu)());
                    }
                };
                setCount();

                window.ocBetslip.setCallbacks({
                    setBetCount: function setBetCount() {
                        return setCount();
                    }
                });
            };

            if (window.ocRenderers && window.ocRenderers['integrated-betslip']) {
                window.ocRenderers['integrated-betslip']({
                    apiKey: config.oddschecker.apiKey,
                    affIds: {
                        SK: config.oddschecker.affId
                    }
                }, function (error) {
                    //handle error
                    if (!error) {
                        initOcBetSlip();
                    }
                });
            }
        }

        return next(action);
    }

    function open(store, next, action) {
        if (action.type === _betslip.OPEN && window.ocBetslip) {
            window.ocBetslip.toggle(true);
        }

        return next(action);
    }

    function addBet(store, next, action) {
        if (action.type === _betlink.ADD && window.ocBetslip) {
            var betId = action.data.betId;

            window.ocBetslip.addBet({
                betId: betId,
                betIdType: 'SK'
            });
        }

        return next(action);
    }
};

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _splashpage = __webpack_require__(376);

var _skysso = __webpack_require__(72);

var _windowEvents = __webpack_require__(199);

var _middlewareUtils = __webpack_require__(119);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPath = function getPath(uri) {
  return function () {
    var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var trigger = arguments[1];

    var queryFields = {
      fullyregistered: "userFullyRegistered",
      canbet: "canBet"
    };

    return (0, _keys2.default)(user).reduce(function (queryString, key) {
      if (!queryFields[key] || typeof user[key] === "undefined") {
        return queryString;
      }
      return queryString + "&" + queryFields[key] + "=" + user[key];
    }, uri + "?trigger=" + trigger);
  };
};

function createSplashPageAction(trigger, campaignGroup) {
  var data = (0, _extends3.default)({}, campaignGroup.splashPage, {
    endDateTime: campaignGroup.endDateTime
  });

  return {
    type: _splashpage.SPLASH_SCREEN_RESPONSE,
    trigger: trigger,
    data: data
  };
}

exports.default = function (apiClient, config) {
  var cmsCampaignGroupsUri = config.api.campaignGroups.cmsCampaignGroupsUri;

  var getCampaignGroupPath = getPath(cmsCampaignGroupsUri);

  function getLoginSplashpage(store, next, action) {
    if (action.type === _skysso.LOGIN) {
      var user = action.data.user;

      var path = getCampaignGroupPath(user, "Login");

      apiClient.get(path).then(function (campaignGroups) {
        if (campaignGroups[0]) {
          store.dispatch(createSplashPageAction('login', campaignGroups[0]));
        }
      }).catch(function () {});
    }

    next(action);
  }

  function getWindowLoadSplashpage(store, next, action) {
    if (action.type === _windowEvents.WINDOW_LOAD) {
      var user = store.getState().common.auth.user;

      var path = getCampaignGroupPath(user, "Site Load");

      apiClient.get(path).then(function (campaignGroups) {
        if (campaignGroups[0]) {
          store.dispatch(createSplashPageAction('siteLoad', campaignGroups[0]));
        }
      }).catch(function () {});
    }
    next(action);
  }

  return [(0, _middlewareUtils.middlewareWrapper)(getLoginSplashpage), (0, _middlewareUtils.middlewareWrapper)(getWindowLoadSplashpage)];
};

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _middlewareUtils = __webpack_require__(119);

var _skysso = __webpack_require__(72);

var _userService = __webpack_require__(44);

var _commonUtils = __webpack_require__(36);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGGED_IN_STATE_NAME = "loggedIn";
var INITIATED_LOGIN_COOKIE = "initiated_login";
var sbaBindAttempts = 0;
var appBridgeBindAttempts = 0;
var sba = null;

exports.default = function (window, config, client, createMetrics, getMetricsConfig) {
  var maxBindRetries = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 100;
  var bindRetryPeriod = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 100;
  var cookie = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : __webpack_require__(339);

  if (!window) {
    return [];
  }

  function getMetrics(store) {
    var metricsConfig = getMetricsConfig(store, config);
    return createMetrics((0, _extends3.default)({}, metricsConfig));
  }

  function isLocallyLoggedOut(authState) {
    return !authState || !authState.loggedIn;
  }

  function getLoginState(store, next, action) {
    if (action.type === _skysso.GET_LOGIN_STATE) {
      var getState = store.getState,
          dispatch = store.dispatch;

      var authState = getState().common.auth;
      var metrics = getMetrics(store);

      if (window.SkyBetAccount) {
        window.SkyBetAccount.getLoginState(function (err, data) {
          if (data && data.name === LOGGED_IN_STATE_NAME) {
            doLocalLogin(data, authState, dispatch, metrics);
            return;
          }

          doLocalLogout(authState, dispatch);
        });
      }
    }

    return next(action);
  }

  function bindToSSOApi(store, next, action) {

    if (action.type === _skysso.BIND_SSO_API && sbaBindAttempts < maxBindRetries) {
      ++sbaBindAttempts;
      var dispatch = store.dispatch,
          getState = store.getState;


      if (!window.SkyBetAccount) {
        setTimeout(function () {
          return dispatch((0, _skysso.bindToSSO)());
        }, bindRetryPeriod);
        return next(action);
      }

      sba = window.SkyBetAccount;
      var metrics = getMetrics(store);

      sba.bind('loggedIn', function (data) {
        var authState = getState().common.auth;
        doLocalLogin(data, authState, dispatch, metrics);
      });

      sba.bind('loggedOut', function () {
        var authState = getState().common.auth;
        doLocalLogout(authState, dispatch);
      });

      sba.setup({
        pollPeriod: 0,
        consumer: 'sportinglife',
        consumerUrl: (0, _commonUtils.consumerUrl)(),
        host: config.skyBetAccountHost
      });

      sbaBindAttempts = 0;
      dispatch((0, _skysso.sbaReady)(sba));
    }

    return next(action);
  }

  function bindAppBridge(store, next, action) {
    if ((action.type === _skysso.SBA_READY || action.type === _skysso.BIND_APPBRIDGE) && appBridgeBindAttempts < maxBindRetries) {
      ++appBridgeBindAttempts;
      var metrics = getMetrics(store);

      var dispatch = store.dispatch;

      if (!sba) {
        return next(action);
      }

      var appBridge = sba.getAppBridge();
      if (!appBridge) {
        setTimeout(function () {
          return dispatch((0, _skysso.bindToAppbridge)());
        }, bindRetryPeriod);
        return next(action);
      }
      dispatch((0, _skysso.appBridgeReady)());
      appBridge.consumerReady(true);
      appBridge.trigger('shouldFeedbackIncrement');
      appBridge.bind("setDeviceIDFA", function (_ref) {
        var deviceIDFA = _ref.deviceIDFA;

        metrics.api.track("deviceIDFA", {
          deviceIDFA: deviceIDFA
        });
      });

      appBridge.bind('wake', function () {
        window.location.reload();
      });

      appBridge.bind('sleep', function () {
        dispatch((0, _skysso.appBridgeSleep)());
      });

      appBridge.bind('notificationToken', function () {
        var deviceName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        var timeDeltas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        dispatch((0, _skysso.savePushId)(deviceName.token));
        metrics.api.track("reportTimings", timeDeltas);
      });

      appBridge.trigger('getDeviceIDFA');
      appBridgeBindAttempts = 0;
    }

    return next(action);
  }

  function ssoLogin(store, next, action) {
    if (action.type === _skysso.SSO_LOGIN && sba) {
      sba.openLogin();
      cookie.save(INITIATED_LOGIN_COOKIE, "yes", { path: "/" });
    }

    return next(action);
  }

  function ssoLogout(store, next, action) {
    if (action.type === _skysso.SSO_LOGOUT && sba) {
      sba.logout();
    }

    return next(action);
  }

  function ssoRegister(store, next, action) {
    if (action.type === _skysso.SSO_REGISTER && sba) {
      sba.openRegistration();
    }

    return next(action);
  }

  function ssoOpenMyaccount(store, next, action) {
    if (action.type === _skysso.SSO_MY_ACCOUNT && sba) {
      sba.openMyAccount();
    }

    return next(action);
  }

  function loginHandler(store, next, action) {
    if (action.type === _skysso.LOGIN) {
      var data = action.data;
      var hasUserData = data && data.user && data.user.ssoToken;

      if (hasUserData) {
        client.post(config.api.sso.loggedIn, { data: data.user, withCredentials: true });
      }
    }

    return next(action);
  }

  function logoutHandler(store, next, action) {
    if (action.type === _skysso.LOGOUT) {
      client.post(config.api.sso.loggedOut, { withCredentials: true });
    }

    return next(action);
  }

  function doLocalLogin(data, state, dispatch, metrics) {
    if (isLocallyLoggedOut(state)) {
      var loggedInHere = cookie.load(INITIATED_LOGIN_COOKIE);
      if (!state.loginInitiated && metrics && !loggedInHere) {
        metrics.api.track("arrivingUser", { custId: data.user.customerId });
      }

      dispatch((0, _skysso.login)(data));
      dispatch((0, _userService.loadSubscriptions)(data));
    }
  }

  function doLocalLogout(state, dispatch) {
    if (!isLocallyLoggedOut(state)) {
      dispatch((0, _skysso.logout)());
      dispatch((0, _userService.resetSubscriptions)());
    }
  }

  return [(0, _middlewareUtils.middlewareWrapper)(getLoginState), (0, _middlewareUtils.middlewareWrapper)(bindToSSOApi), (0, _middlewareUtils.middlewareWrapper)(bindAppBridge), (0, _middlewareUtils.middlewareWrapper)(ssoLogin), (0, _middlewareUtils.middlewareWrapper)(ssoLogout), (0, _middlewareUtils.middlewareWrapper)(ssoRegister), (0, _middlewareUtils.middlewareWrapper)(ssoOpenMyaccount), (0, _middlewareUtils.middlewareWrapper)(loginHandler), (0, _middlewareUtils.middlewareWrapper)(logoutHandler)];
};

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (config) {
    if (!global.window) {
        return [];
    }

    var client = new _ApiClient2.default();

    return (0, _ssoMiddleware2.default)(global.window, config, client, _reactMetrics.createMetrics, _metricsConfig2.default);
};

var _ssoMiddleware = __webpack_require__(791);

var _ssoMiddleware2 = _interopRequireDefault(_ssoMiddleware);

var _ApiClient = __webpack_require__(64);

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _reactMetrics = __webpack_require__(69);

var _metricsConfig = __webpack_require__(442);

var _metricsConfig2 = _interopRequireDefault(_metricsConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _trackingEvents = __webpack_require__(250);

var _middlewareUtils = __webpack_require__(119);

exports.default = function (googleTracking, omnitureTracking, config) {
    var _config$metricsVendor = config.metricsVendors,
        _config$metricsVendor2 = _config$metricsVendor.omniture,
        omnitureConfig = _config$metricsVendor2 === undefined ? null : _config$metricsVendor2,
        _config$metricsVendor3 = _config$metricsVendor.google,
        googleConfig = _config$metricsVendor3 === undefined ? null : _config$metricsVendor3;

    if (!omnitureConfig || !googleConfig) {
        throw new Error('missing third party metric configs');
    }

    var googleClient = new googleTracking(googleConfig);

    return [(0, _middlewareUtils.middlewareWrapper)(thirdPartyTimeTrackingEvents), (0, _middlewareUtils.middlewareWrapper)(thirdPartyEventTracking)];

    function thirdPartyTimeTrackingEvents(store, next, action) {
        if (action.type === _trackingEvents.SEND_TIME_TRACKING) {
            var _action$data = action.data,
                _action$data$times = _action$data.times,
                times = _action$data$times === undefined ? null : _action$data$times,
                _action$data$category = _action$data.category,
                category = _action$data$category === undefined ? null : _action$data$category,
                _action$data$metric = _action$data.metric,
                metric = _action$data$metric === undefined ? null : _action$data$metric,
                _action$data$label = _action$data.label,
                label = _action$data$label === undefined ? null : _action$data$label;

            if (!times || !category || !metric || !label) {
                return next(action);
            }

            times.forEach(function (time) {
                googleClient.sendTracking('timing', {
                    timingCategory: category,
                    timingVar: metric,
                    timingValue: time,
                    timingLabel: label
                });
            });
        }
        return next(action);
    }

    function thirdPartyEventTracking(store, next, action) {
        if (action.type === _trackingEvents.SEND_EVENT_TRACKING) {
            var _action$data2 = action.data,
                _action$data2$categor = _action$data2.category,
                eventCategory = _action$data2$categor === undefined ? null : _action$data2$categor,
                _action$data2$eventAc = _action$data2.eventAction,
                eventAction = _action$data2$eventAc === undefined ? null : _action$data2$eventAc,
                _action$data2$value = _action$data2.value,
                eventValue = _action$data2$value === undefined ? null : _action$data2$value;

            if (!eventCategory || !eventAction) {
                return next(action);
            }
            var event = {
                eventCategory: eventCategory,
                eventAction: eventAction
            };
            if (eventValue) {
                event.eventValue = eventValue;
            }

            googleClient.sendTracking('event', event);
        }
        return next(action);
    }
};

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _windowEvents = __webpack_require__(199);

exports.default = function (window) {
    var windowOnLoadListener = null;
    return {
        onLoad: onLoad
    };

    function onLoad(store, next, action) {
        if (!window) {
            return next(action);
        }

        var _store$getState = store.getState(),
            _store$getState$commo = _store$getState.common;

        _store$getState$commo = _store$getState$commo === undefined ? {} : _store$getState$commo;
        var _store$getState$commo2 = _store$getState$commo.window;
        _store$getState$commo2 = _store$getState$commo2 === undefined ? {} : _store$getState$commo2;
        var _store$getState$commo3 = _store$getState$commo2.isLoaded,
            isLoaded = _store$getState$commo3 === undefined ? false : _store$getState$commo3;

        if (!isLoaded && windowOnLoadListener === null) {
            //check document ready state
            if (window.document.readyState === "complete") {
                store.dispatch({ type: _windowEvents.WINDOW_LOAD });
                return next(action);
            }
            //add event listener
            windowOnLoadListener = window.addEventListener("load", function () {
                store.dispatch({ type: _windowEvents.WINDOW_LOAD });
            });
        }
        if (isLoaded && windowOnLoadListener !== null) {
            //remove event listener
            window.removeEventListener("load", windowOnLoadListener);
        }
        return next(action);
    }
};

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _entries = __webpack_require__(306);

var _entries2 = _interopRequireDefault(_entries);

var _windowEvents = __webpack_require__(794);

var _windowEvents2 = _interopRequireDefault(_windowEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return (0, _entries2.default)((0, _windowEvents2.default)(global.window)).map(function (keyValue) {
        return function (store) {
            return function (next) {
                return function (action) {
                    return keyValue[1](store, next, action);
                };
            };
        };
    });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reducer;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initalState = {
    placeholderTimeStamp: _config2.default.atrVideo.placeholderTimestamp
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initalState;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return state;
}

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _canary = __webpack_require__(724);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { bucketId: "" };
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (action.type == _canary.SET_CANARY_CONFIG) {
        return (0, _extends3.default)({}, state, action.data);
    }

    return state;
}

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _metaData = __webpack_require__(725);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (action.type == _metaData.LOAD_SUCCESS) {
        return (0, _extends3.default)({}, state, {
            entries: action.result.page_metadata
        });
    }

    return state;
}

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.setQuery = setQuery;
var STORE = 'common/queryParams/STORE';

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case STORE:
      return action.query;
    default:
      return state;
  }
}

function setQuery(query) {
  return {
    query: query,
    type: STORE
  };
}

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(112);

var _article = __webpack_require__(204);

var _article2 = _interopRequireDefault(_article);

var _media = __webpack_require__(78);

var _media2 = _interopRequireDefault(_media);

var _morenews = __webpack_require__(79);

var _morenews2 = _interopRequireDefault(_morenews);

var _skysso = __webpack_require__(72);

var _skysso2 = _interopRequireDefault(_skysso);

var _userService = __webpack_require__(44);

var _userService2 = _interopRequireDefault(_userService);

var _layout = __webpack_require__(374);

var _layout2 = _interopRequireDefault(_layout);

var _omniture = __webpack_require__(375);

var _omniture2 = _interopRequireDefault(_omniture);

var _pageTranstition = __webpack_require__(260);

var _pageTranstition2 = _interopRequireDefault(_pageTranstition);

var _display = __webpack_require__(258);

var _display2 = _interopRequireDefault(_display);

var _queryParams = __webpack_require__(799);

var _queryParams2 = _interopRequireDefault(_queryParams);

var _betlink = __webpack_require__(257);

var _betlink2 = _interopRequireDefault(_betlink);

var _atrVideo = __webpack_require__(796);

var _atrVideo2 = _interopRequireDefault(_atrVideo);

var _metaData = __webpack_require__(798);

var _metaData2 = _interopRequireDefault(_metaData);

var _canary = __webpack_require__(797);

var _canary2 = _interopRequireDefault(_canary);

var _cookies = __webpack_require__(206);

var _cookies2 = _interopRequireDefault(_cookies);

var _window = __webpack_require__(802);

var _window2 = _interopRequireDefault(_window);

var _betslip = __webpack_require__(205);

var _betslip2 = _interopRequireDefault(_betslip);

var _menu = __webpack_require__(259);

var _menu2 = _interopRequireDefault(_menu);

var _tamGpt = __webpack_require__(801);

var _tamGpt2 = _interopRequireDefault(_tamGpt);

var _splashpage = __webpack_require__(376);

var _splashpage2 = _interopRequireDefault(_splashpage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  article: _article2.default,
  media: _media2.default,
  morenews: _morenews2.default,
  auth: _skysso2.default,
  userService: _userService2.default,
  pageTranstition: _pageTranstition2.default,
  layout: _layout2.default,
  omniture: _omniture2.default,
  display: _display2.default,
  queryParams: _queryParams2.default,
  betlink: _betlink2.default, // Only relevant for feature "integrated-betslip"
  atrVideo: _atrVideo2.default,
  metaData: _metaData2.default,
  canary: _canary2.default,
  cookies: _cookies2.default,
  window: _window2.default,
  betslip: _betslip2.default,
  tamGpt: _tamGpt2.default,
  menu: _menu2.default,
  splashpage: _splashpage2.default
});

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(7);

var _extends5 = _interopRequireDefault(_extends4);

exports.default = reducer;

var _tamGptInitialization = __webpack_require__(256);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { initializationComplete: false, tamAvailable: false, advertSlots: {} };
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (action.type === _tamGptInitialization.INITIALIZE_TAM_SUCCESS) {
    console.log("TAM enabled");
    return (0, _extends5.default)({}, state, { initializationComplete: true, tamAvailable: true });
  }

  if ([_tamGptInitialization.TAM_SCRIPT_DISABLED, _tamGptInitialization.TAM_SCRIPT_LOAD_ERROR, _tamGptInitialization.TAM_SCRIPT_LOAD_TIMEOUT].includes(action.type)) {
    console.log("TAM Disabled: " + action.type.toLowerCase().replace("_", " "));
    return (0, _extends5.default)({}, state, { initializationComplete: true, tamAvailable: false });
  }

  if (action.type === _tamGptInitialization.UPDATE_ADVERT_SLOT) {
    return (0, _extends5.default)({}, state, { advertSlots: (0, _extends5.default)({}, state.advertSlots, (0, _defineProperty3.default)({}, action.slotId, action.status)) });
  }

  if (action.type === _tamGptInitialization.LOAD_ADVERTS) {
    return (0, _extends5.default)({}, state, { advertSlots: (0, _extends5.default)({}, state.advertSlots, (0, _defineProperty3.default)({}, action.slotId, _tamGptInitialization.ADVERT_BIDS_REQUESTED)) });
  }

  if (action.type === _tamGptInitialization.GPT_FALLBACK_TIMER_ID) {
    return (0, _extends5.default)({}, state, { gptTimeoutId: action.timeoutID });
  }

  return state;
}

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _windowEvents = __webpack_require__(199);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { isLoaded: false };
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case _windowEvents.WINDOW_LOAD:
      return (0, _extends3.default)({}, state, { isLoaded: true });
    default:
      return state;
  }
}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CricketHomePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CricketHomePage, _Component);

  function CricketHomePage() {
    (0, _classCallCheck3.default)(this, CricketHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (CricketHomePage.__proto__ || (0, _getPrototypeOf2.default)(CricketHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(CricketHomePage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: 'cricket',
        title: 'Cricket Scorecards & Ball-by-Ball Updates',
        location: location
      });
    }
  }]);
  return CricketHomePage;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node
}, _temp);
exports.default = CricketHomePage;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CricketNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "Cricket",
    links: [{ href: "/cricket", text: "News", isIndex: true }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

CricketNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = CricketNav;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routeUtils = __webpack_require__(38);

var _CricketHomePage = __webpack_require__(803);

var _CricketHomePage2 = _interopRequireDefault(_CricketHomePage);

var _CricketNav = __webpack_require__(804);

var _CricketNav2 = _interopRequireDefault(_CricketNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _routeUtils.genericRoute)(_CricketHomePage2.default, _CricketNav2.default, 'cricket');

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DartsHomePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(DartsHomePage, _Component);

  function DartsHomePage() {
    (0, _classCallCheck3.default)(this, DartsHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (DartsHomePage.__proto__ || (0, _getPrototypeOf2.default)(DartsHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(DartsHomePage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: 'darts',
        title: 'Darts News, Results & Betting',
        location: location
      });
    }
  }]);
  return DartsHomePage;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node
}, _temp);
exports.default = DartsHomePage;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DartsNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "Darts",
    links: [{ href: "/darts", text: "News", isIndex: true }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

DartsNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = DartsNav;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routeUtils = __webpack_require__(38);

var _DartsHomePage = __webpack_require__(806);

var _DartsHomePage2 = _interopRequireDefault(_DartsHomePage);

var _DartsNav = __webpack_require__(807);

var _DartsNav2 = _interopRequireDefault(_DartsNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _routeUtils.genericRoute)(_DartsHomePage2.default, _DartsNav2.default, 'darts');

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Error404Page;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ErrorPage = __webpack_require__(377);

var _ErrorPage2 = _interopRequireDefault(_ErrorPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Error404Page() {
  return _react2.default.createElement(
    _ErrorPage2.default,
    { title: 'Not Found' },
    'Sorry, but the page you were trying to view does not exist.'
  );
}

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toArray2 = __webpack_require__(1272);

var _toArray3 = _interopRequireDefault(_toArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorPage = __webpack_require__(377);

var _ErrorPage2 = _interopRequireDefault(_ErrorPage);

var _reactRedux = __webpack_require__(17);

var _reactRouterRedux = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Error500Page = (_dec = (0, _reactRedux.connect)(), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Error500Page, _Component);

  function Error500Page(props) {
    (0, _classCallCheck3.default)(this, Error500Page);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Error500Page.__proto__ || (0, _getPrototypeOf2.default)(Error500Page)).call(this, props));

    var _this$props = _this.props,
        dispatch = _this$props.dispatch,
        _this$props$params = _this$props.params;
    _this$props$params = _this$props$params === undefined ? {} : _this$props$params;
    var _this$props$params$sp = _this$props$params.splat,
        splat = _this$props$params$sp === undefined ? "" : _this$props$params$sp;

    var _splat$split = splat.split("/"),
        _splat$split2 = (0, _toArray3.default)(_splat$split),
        flag = _splat$split2[0],
        path = _splat$split2.slice(1);

    if (typeof history !== "undefined" && flag == "from") {
      setTimeout(function () {
        dispatch((0, _reactRouterRedux.replace)('/error/500/' + path.join("/")));
      }, 100); // give the "from" page time for its analytics to be ignored
    }
    return _this;
  }

  (0, _createClass3.default)(Error500Page, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _ErrorPage2.default,
        { title: 'Server Error' },
        'There has been an error and we can\'t continue. Our engineers have been notified and will resolve it as soon as possible.'
      );
    }
  }]);
  return Error500Page;
}(_react.Component), _class2.propTypes = {
  dispatch: _propTypes2.default.func,
  params: _propTypes2.default.object
}, _temp)) || _class);
exports.default = Error500Page;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorPageContainer = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ErrorPageContainer, _Component);

  function ErrorPageContainer() {
    (0, _classCallCheck3.default)(this, ErrorPageContainer);
    return (0, _possibleConstructorReturn3.default)(this, (ErrorPageContainer.__proto__ || (0, _getPrototypeOf2.default)(ErrorPageContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(ErrorPageContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          Error500Page = _props.Error500Page,
          Error404Page = _props.Error404Page;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: 'racing', title: 'Error' },
        _react2.default.createElement(
          'div',
          { className: 'main-layout-left-column' },
          Error500Page,
          Error404Page
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: 'racing',
          content: ["ocWidget"] })
      );
    }
  }]);
  return ErrorPageContainer;
}(_react.Component), _class.propTypes = {
  Error500Page: _propTypes2.default.element,
  Error404Page: _propTypes2.default.element,
  location: _propTypes2.default.object.isRequired
}, _temp);
exports.default = ErrorPageContainer;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var advertMPU = {
  component: "AdvertWrapper",
  props: {
    ocSlot: ["homepage", "leaderboard"],
    additionalProperties: {
      view: "football"
    }
  },
  desktopColumn: "right",
  desktopOrder: 1,
  handheldOrder: false
};

var leaderboardAd = {
  view: 'football'
};

function withAdverts() {
  for (var _len = arguments.length, components = Array(_len), _key = 0; _key < _len; _key++) {
    components[_key] = arguments[_key];
  }

  components.push(advertMPU);
  return {
    leaderboardAd: leaderboardAd,
    components: components
  };
}

var error404Layout = withAdverts({
  component: "Error404Page",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

var error500Layout = withAdverts({
  component: "Error500Page",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

exports.default = {
  '/error/404': error404Layout,
  '/error/404/*': error404Layout,
  '/error/500': error500Layout,
  '/error/500/*': error500Layout
};

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _Error404Page = __webpack_require__(809);

var _Error404Page2 = _interopRequireDefault(_Error404Page);

var _Error500Page = __webpack_require__(810);

var _Error500Page2 = _interopRequireDefault(_Error500Page);

var _ErrorPageContainer = __webpack_require__(811);

var _ErrorPageContainer2 = _interopRequireDefault(_ErrorPageContainer);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var error404Components = {
  Error404Page: _Error404Page2.default,
  AdvertWrapper: _AdvertWrapper2.default
};

var error500Components = {
  Error500Page: _Error500Page2.default,
  AdvertWrapper: _AdvertWrapper2.default
};

var errorRoutes = _react2.default.createElement(
  _reactRouter.Route,
  { path: 'error' },
  _react2.default.createElement(
    _reactRouter.Route,
    { path: '404', component: _ErrorPageContainer2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { components: error404Components }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', components: error404Components })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: '500', component: _ErrorPageContainer2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { components: error500Components }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', components: error500Components })
  )
);

exports.default = errorRoutes;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballComponent;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _seoUtils = __webpack_require__(23);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var helmetProps = {
  titleTemplate: _seoUtils.titleTemplate.football
};

function FootballComponent(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    { className: 'football-content' },
    _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
    children
  );
}

FootballComponent.propTypes = {
  children: _propTypes2.default.any
};

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballComparativeNumericStats;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballComparativeNumericStats(props) {
  __webpack_require__(1397);

  var title = props.title,
      bigNumber = props.bigNumber,
      smallNumber = props.smallNumber;


  return _react2.default.createElement(
    'div',
    { className: 'comparativeNumericStats' },
    _react2.default.createElement(
      'div',
      { className: 'live-score-emphasize' },
      _react2.default.createElement(
        'div',
        { className: 'live-score-title' },
        title
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'live-score-big-number' },
      _react2.default.createElement(
        'div',
        { className: 'big-number' },
        bigNumber
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'live-score-small-number' },
      _react2.default.createElement(
        'div',
        { className: 'small-number' },
        smallNumber
      )
    )
  );
}

FootballComparativeNumericStats.propTypes = {
  title: _propTypes2.default.string.isRequired,
  bigNumber: _propTypes2.default.number.isRequired,
  smallNumber: _propTypes2.default.number.isRequired
};

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballLiveHomeHeader;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LocalDateTime = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballLiveHomeHeader() {
  return _react2.default.createElement(
    'div',
    { className: 'footballLiveHomeHeader' },
    _react2.default.createElement(
      'h1',
      null,
      'Live Scores'
    ),
    _react2.default.createElement(
      'h2',
      null,
      _react2.default.createElement(_LocalDateTime.LocalFullDate, { iso: new Date() })
    )
  );
}

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.default = FootballLiveMatch;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FootballMatchSummary = __webpack_require__(824);

var _FootballMatchSummary2 = _interopRequireDefault(_FootballMatchSummary);

var _Tabs = __webpack_require__(70);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _consts = __webpack_require__(62);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _JsonLD = __webpack_require__(164);

var _JsonLD2 = _interopRequireDefault(_JsonLD);

var _seoUtils = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballLiveMatch(props) {
  __webpack_require__(1398);

  var routes = props.routes,
      match = props.match,
      matchId = props.matchId,
      events = props.events,
      children = props.children;


  if (match && match.match_detail) {
    var urlRoot = '/football/live/' + matchId + '/';

    var tabs = [{ href: urlRoot + 'preview', text: "Preview" }, { href: urlRoot + 'commentary', text: "Commentary" }, { href: urlRoot + 'stats', text: "Stats" }, { href: urlRoot + 'teams/home', text: "Teams", alternatives: [{ href: urlRoot + 'teams/away' }] }, { href: urlRoot + 'form', text: "Form" }];

    if (match.match_detail.competition.show_tables === true) {
      tabs.push({ href: urlRoot + 'table', text: "Table" });
    }

    if (_consts.MATCH_STATE_FINISHED.includes(match.match_detail.state)) {
      tabs.push({ href: urlRoot + 'report', text: "Report" }, { href: urlRoot + 'reaction', text: "Reaction" });
    }

    var _match$match_detail = match.match_detail,
        homeName = _match$match_detail.team_score_a.team.name,
        awayName = _match$match_detail.team_score_b.team.name,
        matchDate = _match$match_detail.match_date,
        _match$match_detail$c = _match$match_detail.competition.name,
        competitionName = _match$match_detail$c === undefined ? "" : _match$match_detail$c,
        venueName = _match$match_detail.venue;


    var matchLabel = homeName + ' v ' + awayName;

    // Only need the first few route components, to give a constant URL accross all tabs
    var reducedRoutes = routes;
    reducedRoutes.length = 4;

    var _canonicalLink = (0, _seoUtils.canonicalLink)(reducedRoutes, { matchId: matchId }),
        _canonicalLink$link = _canonicalLink.link;

    _canonicalLink$link = _canonicalLink$link === undefined ? [] : _canonicalLink$link;

    var _canonicalLink$link2 = (0, _slicedToArray3.default)(_canonicalLink$link, 1),
        _canonicalLink$link2$ = _canonicalLink$link2[0];

    _canonicalLink$link2$ = _canonicalLink$link2$ === undefined ? {} : _canonicalLink$link2$;
    var _canonicalLink$link2$2 = _canonicalLink$link2$.href,
        jsonLdUrl = _canonicalLink$link2$2 === undefined ? '' : _canonicalLink$link2$2;


    var jsonLdData = {
      "@type": "SportsEvent",
      "url": jsonLdUrl,
      "homeTeam": {
        "@type": "SportsTeam",
        "name": homeName
      },
      "awayTeam": {
        "@type": "SportsTeam",
        "name": awayName
      },
      "startDate": matchDate,
      "location": {
        "@type": "Place",
        "name": venueName,
        "address": {
          "@type": "PostalAddress",
          "addressLocality": ""
        }
      },
      "superEvent": {
        "@type": "SportsEvent",
        "name": competitionName
      }
    };

    return _react2.default.createElement(
      'div',
      { className: 'football-live-match' },
      _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: (0, _extends3.default)({}, (0, _seoUtils.canonicalLink)(routes, { matchId: matchId })) }),
      _react2.default.createElement(_JsonLD2.default, { data: jsonLdData }),
      _react2.default.createElement(
        'section',
        { className: 'footballLiveMatchHeader' },
        _react2.default.createElement(
          'div',
          { className: 'footballLiveMatchSummary' },
          _react2.default.createElement(_FootballMatchSummary2.default, { match: match, matchLabel: matchLabel })
        ),
        _react2.default.createElement(_Tabs2.default, { tabs: tabs })
      ),
      _react2.default.createElement(
        'section',
        { className: 'content' },
        _react2.default.cloneElement(children, { match: match, matchLabel: matchLabel, events: events })
      )
    );
  } else {

    var errorPixelSrc = '/1x1.gif?type=football-live-match&id=0&cb=' + Date.now();

    return _react2.default.createElement(
      'div',
      { className: 'football-live-match' },
      _react2.default.createElement(
        'section',
        { className: 'footballLiveMatchHeader' },
        _react2.default.createElement(
          'div',
          null,
          'There was a problem displaying the match.'
        ),
        _react2.default.createElement('img', { src: errorPixelSrc, width: '1', height: '1' })
      )
    );
  }
}

FootballLiveMatch.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  match: _propTypes2.default.object,
  events: _propTypes2.default.object,
  matchId: _propTypes2.default.string,
  children: _propTypes2.default.object
};

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _eventTypeToIconMap;

exports.default = FootballMatchCommentary;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _consts = __webpack_require__(62);

var _FootballMatchEventIcon = __webpack_require__(208);

var _FootballMatchEventIcon2 = _interopRequireDefault(_FootballMatchEventIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eventTypeToIconMap = (_eventTypeToIconMap = {}, (0, _defineProperty3.default)(_eventTypeToIconMap, _consts.GOAL, 'Goal'), (0, _defineProperty3.default)(_eventTypeToIconMap, _consts.OWNGOAL, 'Goal'), (0, _defineProperty3.default)(_eventTypeToIconMap, _consts.PENALTY, 'Penalty'), (0, _defineProperty3.default)(_eventTypeToIconMap, _consts.YELLOWCARD, 'Yellow Card'), (0, _defineProperty3.default)(_eventTypeToIconMap, _consts.SECONDYELLOWCARD, 'Second Yellow Card'), (0, _defineProperty3.default)(_eventTypeToIconMap, _consts.REDCARD, 'Red Card'), (0, _defineProperty3.default)(_eventTypeToIconMap, _consts.SUBON, 'Sub On'), (0, _defineProperty3.default)(_eventTypeToIconMap, _consts.SUBOFF, 'Sub Off'), (0, _defineProperty3.default)(_eventTypeToIconMap, _consts.FULLTIME, 'Full Time'), (0, _defineProperty3.default)(_eventTypeToIconMap, _consts.ENDOFFIRSTHALF, 'Half Time'), _eventTypeToIconMap);

function FootballMatchCommentary(_ref) {
  var events = _ref.events,
      matchLabel = _ref.matchLabel;

  __webpack_require__(1399);
  // filter the events down to those that have commentary, in reverse order of event ID
  var commentary = (0, _lodash2.default)(events).filter('event.comment').sortBy(['match_sequence', 'match_event_reference.id']).reverse().value();

  var helmetProps = {
    title: matchLabel + ' - Commentary'
  };

  return _react2.default.createElement(
    'div',
    null,
    !_lodash2.default.isEmpty(commentary) ? _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
      _react2.default.createElement(
        'ul',
        { className: 'commentary' },
        commentary.map(function (event) {
          return _react2.default.createElement(
            'li',
            { className: 'event', key: event.match_event_reference.id },
            _react2.default.createElement(
              'div',
              { className: 'time-col' },
              !!event.match_time && _react2.default.createElement(
                'span',
                { className: 'match-time' },
                '' + event.match_time
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'type-col' },
              event.event.event_type && _react2.default.createElement(_FootballMatchEventIcon2.default, { type: eventTypeToIconMap[event.event.event_type.event_type] || '' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'detail-col' },
              event.event.comment
            )
          );
        })
      )
    ) : _react2.default.createElement(
      'div',
      { className: 'football-match-stats-none' },
      _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
      'No match commentary available.'
    ),
    _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["football", "leaderboard"], additionalProperties: { view: "commentary" } })
  );
}

FootballMatchCommentary.propTypes = {
  match: _propTypes2.default.object,
  matchLabel: _propTypes2.default.string,
  events: _propTypes2.default.object
};

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.default = FootballMatchFormMatch;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CompactText = __webpack_require__(162);

var _CompactText2 = _interopRequireDefault(_CompactText);

var _FootballMatchOutcomeDescription = __webpack_require__(207);

var _FootballMatchOutcomeDescription2 = _interopRequireDefault(_FootballMatchOutcomeDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getId(team) {
  return team.team_reference.id;
}

function getTeam(match, code) {
  var teamScore = match['team_score_' + code];

  var id = getId(teamScore.team);
  var name = teamScore.team.name;
  var short_name = teamScore.team.short_name;

  var _teamScore$score = (0, _slicedToArray3.default)(teamScore.score, 1),
      _teamScore$score$ = _teamScore$score[0];

  _teamScore$score$ = _teamScore$score$ === undefined ? {} : _teamScore$score$;
  var _teamScore$score$$sco = _teamScore$score$.score,
      score = _teamScore$score$$sco === undefined ? '' : _teamScore$score$$sco;


  var outcome = "DRAW_LOSS";

  if (match.match_outcome && match.match_outcome.outcome == "WIN") {
    var winningId = getId(match.match_outcome.winner);

    if (winningId == id) {
      outcome = "WON";
    }
  }

  return {
    id: id,
    name: name,
    short_name: short_name,
    score: score,
    outcome: outcome
  };
}

function FootballMatchFormMatch(_ref) {
  var match = _ref.match;

  __webpack_require__(511);

  var homeTeam = getTeam(match, 'a');
  var awayTeam = getTeam(match, 'b');

  return _react2.default.createElement(
    'div',
    { className: 'formMatch' },
    _react2.default.createElement(
      'div',
      { className: 'formMatchScores' },
      _react2.default.createElement(
        'div',
        { className: 'homeTeam-' + homeTeam.outcome },
        _react2.default.createElement(
          _CompactText2.default,
          { compactText: homeTeam.short_name },
          homeTeam.name
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'scoreBox' },
        _react2.default.createElement(
          'div',
          { className: 'grey-score-box' },
          homeTeam.score,
          '-',
          awayTeam.score
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'awayTeam-' + awayTeam.outcome },
        _react2.default.createElement(
          _CompactText2.default,
          { compactText: awayTeam.short_name },
          awayTeam.name
        )
      )
    ),
    _react2.default.createElement(_FootballMatchOutcomeDescription2.default, { matchOutcome: match.match_outcome, penaltyShootoutScore: match.penalty_shootout_score })
  );
}

FootballMatchFormMatch.propTypes = {
  match: _propTypes2.default.object.isRequired
};

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballMatchHeadToHead;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _FootballWinsDrawsWins = __webpack_require__(830);

var _FootballWinsDrawsWins2 = _interopRequireDefault(_FootballWinsDrawsWins);

var _FootballComparativeNumericStats = __webpack_require__(815);

var _FootballComparativeNumericStats2 = _interopRequireDefault(_FootballComparativeNumericStats);

var _SimpleBar = __webpack_require__(367);

var _SimpleBar2 = _interopRequireDefault(_SimpleBar);

var _FootballMatchForm = __webpack_require__(379);

var _FootballMatchForm2 = _interopRequireDefault(_FootballMatchForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballMatchHeadToHead(props) {
  __webpack_require__(1400);
  return _react2.default.createElement(
    'div',
    { className: 'footballHeadToHead' },
    _react2.default.createElement(_MetaDataWrapper2.default, { title: props.matchLabel + ' - Head To Head' }),
    _react2.default.createElement(_FootballWinsDrawsWins2.default, { homeTeamName: props.H2H.team_a.name, awayTeamName: props.H2H.team_b.name, homeWins: props.H2H.team_a_wins, draws: props.H2H.team_a_draws, awayWins: props.H2H.team_a_losses }),
    _react2.default.createElement(
      'div',
      { className: 'football-match-statset' },
      _react2.default.createElement(
        'h3',
        { className: 'section-title' },
        'Goals Scored'
      ),
      _react2.default.createElement(_SimpleBar2.default, { a: props.H2H.statistics[0].team_a_value, b: props.H2H.statistics[0].team_b_value, highlightMax: false, className: "headToHead-bar" }),
      _react2.default.createElement(_FootballComparativeNumericStats2.default, { title: "Over 2.5 Goals", bigNumber: props.H2H.statistics[1].team_a_value, smallNumber: props.H2H.statistics[1].team_b_value }),
      _react2.default.createElement(_FootballComparativeNumericStats2.default, { title: "Both Teams Scored", bigNumber: props.H2H.statistics[2].team_a_value, smallNumber: props.H2H.statistics[2].team_b_value })
    ),
    _react2.default.createElement(
      'div',
      { className: 'table-block-header' },
      'Last ',
      props.H2H.matches.length,
      ' Matches'
    ),
    _react2.default.createElement(_FootballMatchForm2.default, { formMatches: props.H2H.matches }),
    _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["football", "leaderboard"], additionalProperties: { view: "live" } })
  );
}

FootballMatchHeadToHead.propTypes = {
  matchLabel: _propTypes2.default.string,
  H2H: _propTypes2.default.object.isRequired
};

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.default = FootballMatchListItem;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _AnalyticsUtils = __webpack_require__(63);

var _LocalDateTime = __webpack_require__(61);

var _CompactText = __webpack_require__(162);

var _CompactText2 = _interopRequireDefault(_CompactText);

var _SubscriptionContainer = __webpack_require__(92);

var _SubscriptionContainer2 = _interopRequireDefault(_SubscriptionContainer);

var _StarButton = __webpack_require__(373);

var _StarButton2 = _interopRequireDefault(_StarButton);

var _consts = __webpack_require__(62);

var _consts2 = __webpack_require__(46);

var _urlRewrite = __webpack_require__(120);

var _FootballMatchOutcomeDescription = __webpack_require__(207);

var _FootballMatchOutcomeDescription2 = _interopRequireDefault(_FootballMatchOutcomeDescription);

var _FootballMatchOdds = __webpack_require__(380);

var _FootballMatchOdds2 = _interopRequireDefault(_FootballMatchOdds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1402);

function hasScores(teamAScore, teamBScore) {
  return teamAScore !== undefined && teamBScore !== undefined;
}

function generateScoreString(teamAScore, teamBScore) {
  if (hasScores(teamAScore, teamBScore)) {
    return teamAScore + ' - ' + teamBScore;
  } else {
    return "v";
  }
}

function generateScoreClasses(matchState, teamAScore, teamBScore) {
  if (_consts.MATCH_STATE_LIVE.includes(matchState) && hasScores(teamAScore, teamBScore)) {
    return "scoreString matchInProgressOrHalfTime";
  } else {
    return "scoreString matchNotStartedOrFullTime";
  }
}

function showAggregateScore(teamAAggregate, teamBAggregate) {
  return teamAAggregate !== undefined && teamBAggregate !== undefined;
}

function FootballMatchListItem() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      match = _ref.match,
      _ref$match = _ref.match;

  _ref$match = _ref$match === undefined ? {} : _ref$match;
  var _ref$match$team_score = _ref$match.team_score_a;
  _ref$match$team_score = _ref$match$team_score === undefined ? {} : _ref$match$team_score;
  var _ref$match$team_score2 = _ref$match$team_score.team;
  _ref$match$team_score2 = _ref$match$team_score2 === undefined ? {} : _ref$match$team_score2;
  var teamAName = _ref$match$team_score2.name,
      teamAShortName = _ref$match$team_score2.short_name,
      _ref$match$team_score3 = _ref$match$team_score.score;
  _ref$match$team_score3 = _ref$match$team_score3 === undefined ? [{}] : _ref$match$team_score3;

  var _ref$match$team_score4 = (0, _slicedToArray3.default)(_ref$match$team_score3, 1),
      _ref$match$team_score5 = _ref$match$team_score4[0];

  _ref$match$team_score5 = _ref$match$team_score5 === undefined ? {} : _ref$match$team_score5;
  var teamAScore = _ref$match$team_score5.score,
      teamAAggregate = _ref$match$team_score.aggregate_score,
      _ref$match$team_score6 = _ref$match.team_score_b;
  _ref$match$team_score6 = _ref$match$team_score6 === undefined ? {} : _ref$match$team_score6;
  var _ref$match$team_score7 = _ref$match$team_score6.team;
  _ref$match$team_score7 = _ref$match$team_score7 === undefined ? {} : _ref$match$team_score7;
  var teamBName = _ref$match$team_score7.name,
      teamBShortName = _ref$match$team_score7.short_name,
      _ref$match$team_score8 = _ref$match$team_score6.score;
  _ref$match$team_score8 = _ref$match$team_score8 === undefined ? [{}] : _ref$match$team_score8;

  var _ref$match$team_score9 = (0, _slicedToArray3.default)(_ref$match$team_score8, 1),
      _ref$match$team_score10 = _ref$match$team_score9[0];

  _ref$match$team_score10 = _ref$match$team_score10 === undefined ? {} : _ref$match$team_score10;
  var teamBScore = _ref$match$team_score10.score,
      teamBAggregate = _ref$match$team_score6.aggregate_score,
      _ref$match$match_refe = _ref$match.match_reference;
  _ref$match$match_refe = _ref$match$match_refe === undefined ? {} : _ref$match$match_refe;
  var matchId = _ref$match$match_refe.id,
      matchOutcome = _ref$match.match_outcome,
      penaltyShootoutScore = _ref$match.penalty_shootout_score,
      matchState = _ref$match.state,
      matchDate = _ref$match.match_date,
      matchClock = _ref$match.clock;

  return _react2.default.createElement(
    'div',
    { className: 'footballMatchListItem' },
    _react2.default.createElement(
      'div',
      { className: 'topRow' },
      _react2.default.createElement(
        'div',
        { className: 'matchTime' },
        matchClock ? _react2.default.createElement(
          'div',
          { className: 'liveScoreMinutes' },
          matchClock
        ) : _react2.default.createElement(_LocalDateTime.LocalTimeShort, { iso: matchDate })
      ),
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/football/live/' + matchId + '/commentary' },
        _react2.default.createElement(
          'div',
          { className: 'matchInformation' },
          _react2.default.createElement(
            'div',
            { className: 'liveScoresTeamScores' },
            _react2.default.createElement(
              'div',
              { className: 'teamA', id: (0, _urlRewrite.titleToId)(teamAName) },
              _react2.default.createElement(
                _CompactText2.default,
                { compactText: teamAShortName },
                teamAName
              )
            ),
            _react2.default.createElement(
              'div',
              { className: generateScoreClasses(matchState, teamAScore, teamBScore) },
              generateScoreString(teamAScore, teamBScore)
            ),
            _react2.default.createElement(
              'div',
              { className: 'teamB', id: (0, _urlRewrite.titleToId)(teamBName) },
              _react2.default.createElement(
                _CompactText2.default,
                { compactText: teamBShortName },
                teamBName
              )
            )
          ),
          showAggregateScore(teamAAggregate, teamBAggregate) && _react2.default.createElement(
            'div',
            { className: 'liveScoresAggregateScores' },
            '(Agg: ',
            teamAAggregate,
            '-',
            teamBAggregate,
            ')'
          ),
          _react2.default.createElement(_FootballMatchOutcomeDescription2.default, { matchOutcome: matchOutcome, penaltyShootoutScore: penaltyShootoutScore })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'favourite' },
        _react2.default.createElement(_SubscriptionContainer2.default, {
          addSubscriptions: [{
            type: _consts2.SUBSCRIPTIONS_FOOTBALL_MATCH,
            id: matchId,
            text: teamAName + ' v ' + teamBName
          }],
          icon: _react2.default.createElement(_StarButton2.default, {
            trackClick: (0, _AnalyticsUtils.trackClick)("followMatch", { matchId: matchId }, true),
            selectedTitle: 'Remove from My Scores',
            deselectedTitle: 'Add to My Scores',
            hideIfDeselected: _consts.MATCH_STATE_FINISHED.includes(matchState)
          })
        })
      )
    ),
    _react2.default.createElement(_FootballMatchOdds2.default, { match: match })
  );
}

FootballMatchListItem.propTypes = {
  match: _propTypes2.default.object.isRequired
};

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballMatchPlayerGoals;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballMatchPlayerGoals(props) {
  return _react2.default.createElement(
    'div',
    { className: 'footballMatchPlayerGoals' },
    props.playerGoals.team_player,
    props.playerGoals.goal.map(function (eachGoal, index, array) {
      return _react2.default.createElement(
        'span',
        { key: eachGoal.event_id },
        '\xA0 ',
        eachGoal.time,
        eachGoal.type && _react2.default.createElement(
          'span',
          null,
          ' ',
          eachGoal.type
        ),
        index != array.length - 1 ? _react2.default.createElement(
          'span',
          null,
          ','
        ) : _react2.default.createElement('span', null)
      );
    })
  );
}

FootballMatchPlayerGoals.propTypes = {
  playerGoals: _propTypes2.default.shape({
    team_player: _propTypes2.default.string.isRequired,
    goal: _propTypes2.default.array.isRequired
  }).isRequired
};

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _SimpleDonut = __webpack_require__(770);

var _SimpleDonut2 = _interopRequireDefault(_SimpleDonut);

var _SimpleBar = __webpack_require__(367);

var _SimpleBar2 = _interopRequireDefault(_SimpleBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Need to do a version of bankers rounding to avoid percentages that are both N.5 rounding to a total of 101%
// Round to odd numbers to make 49.5:50.5 round to 49:51 (instead of 50:50)
// No need to avoid JS floating point issues because N.5 will never experience them
function oddRound(n) {
  var f = Math.floor(n);

  if (n - f == 0.5) {
    // limit to exactly half
    if (f % 2 == 1) {
      // floor is odd
      return f; // round down to odd
    } else {
      return f + 1; // round up to even
    }
  }

  // by default, just round
  return Math.round(n);
}

// Availability of individual stats is flakey, so we need some helper functions
// to see if they're there, both individually and in groups
function hasProperty(match, property, team) {
  var stat = 'team_statistics_' + team;
  return match.hasOwnProperty(stat) && match[stat].hasOwnProperty(property.key);
}

function propertyExists(match, property) {
  if (!hasProperty(match, property, 'a') && !hasProperty(match, property, 'b')) {
    return false;
  }

  //If property exists for one team but not the other, populate other as 0
  if (hasProperty(match, property, 'a') && !hasProperty(match, property, 'b')) {
    match['team_statistics_b'][property.key] = 0;
  } else if (!hasProperty(match, property, 'a') && hasProperty(match, property, 'b')) {
    match['team_statistics_a'][property.key] = 0;
  }
  return true;
}

function allPropertiesExist(match, properties) {
  return properties.reduce(function (result, property) {
    return result && propertyExists(match, property);
  }, true);
}

function somePropertiesExist(match, properties) {
  return properties.reduce(function (result, property) {
    return result || propertyExists(match, property);
  }, false);
}

// Helper for extracting (and possibly processing) an individual stat
function getData(match, extract) {
  return {
    a: extract(match.team_statistics_a),
    b: extract(match.team_statistics_b)
  };
}

var POSSESSION = { key: "possession" };
var SHOTS = [{ key: "shotsOffTarget" }, { key: "shotsOnTarget" }];
var CORNERS = { key: "corners", label: "Corners" };
var PASSES = [{ key: "totalPasses", label: "Total Passes" }, { key: "accuratePasses", label: "Accurate Passes" }];
var FOULS = [{ key: "foulsWon", label: "Fouls Won" }, { key: "foulsConceded", label: "Fouls Conceded" }, { key: "yellowCards", label: "Yellow Cards" }, { key: "redCards", label: "Red Cards" }];
var OFFSIDES = [{ key: "offsides", label: "Offsides" }];

var FootballMatchStats = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FootballMatchStats, _Component);

  function FootballMatchStats() {
    (0, _classCallCheck3.default)(this, FootballMatchStats);
    return (0, _possibleConstructorReturn3.default)(this, (FootballMatchStats.__proto__ || (0, _getPrototypeOf2.default)(FootballMatchStats)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballMatchStats, [{
    key: 'render',
    value: function render() {
      __webpack_require__(1406);

      var _props = this.props,
          match = _props.match,
          matchLabel = _props.matchLabel;

      // Curry (sorta) the helper functions to this scope

      var get = function get(extract) {
        return getData(match, extract);
      };
      var exists = function exists(property) {
        return propertyExists(match, property);
      };
      var allOf = function allOf(properties) {
        return allPropertiesExist(match, properties);
      };
      var someOf = function someOf(properties) {
        return somePropertiesExist(match, properties);
      };

      return _react2.default.createElement(
        'div',
        null,
        someOf([POSSESSION].concat(SHOTS, [CORNERS], PASSES, FOULS, OFFSIDES)) ? _react2.default.createElement(
          'div',
          { className: 'football-match-stats' },
          _react2.default.createElement(_MetaDataWrapper2.default, { title: matchLabel + ' - Match Stats' }),
          exists(POSSESSION) && _react2.default.createElement(
            'div',
            { className: 'football-match-statset' },
            _react2.default.createElement(
              'h3',
              { className: 'section-title' },
              'Possession'
            ),
            _react2.default.createElement(_SimpleDonut2.default, (0, _extends3.default)({ unit: '%' }, get(function (t) {
              return oddRound(t.possession);
            })))
          ),
          allOf(SHOTS) && _react2.default.createElement(
            'div',
            { className: 'football-match-statset' },
            _react2.default.createElement(
              'h3',
              { className: 'section-title' },
              'Shots'
            ),
            _react2.default.createElement(
              'div',
              { className: 'football-match-shotstats' },
              _react2.default.createElement(
                'div',
                { className: 'football-match-shotstats-offtarget' },
                _react2.default.createElement(
                  'div',
                  { className: 'football-match-shotstats-label' },
                  'Off Target'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'football-match-shotstats-a' },
                  match.team_statistics_a.shotsOffTarget
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'football-match-shotstats-b' },
                  match.team_statistics_b.shotsOffTarget
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'football-match-shotstats-ontarget' },
                _react2.default.createElement(
                  'div',
                  { className: 'football-match-shotstats-label' },
                  'On Target'
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'football-match-shotstats-a' },
                  match.team_statistics_a.shotsOnTarget
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'football-match-shotstats-b' },
                  match.team_statistics_b.shotsOnTarget
                )
              )
            )
          ),
          exists(CORNERS) && _react2.default.createElement(
            'div',
            { className: 'football-match-statset' },
            _react2.default.createElement(
              'h3',
              { className: 'section-title' },
              'Corners'
            ),
            _react2.default.createElement(_SimpleBar2.default, get(function (t) {
              return t.corners;
            }))
          ),
          someOf(PASSES) && _react2.default.createElement(
            'div',
            { className: 'football-match-statset' },
            PASSES.map(function (stat) {
              return exists(stat) && _react2.default.createElement(
                'div',
                { key: stat.key },
                _react2.default.createElement(
                  'h3',
                  { className: 'section-title' },
                  stat.label
                ),
                _react2.default.createElement(_SimpleBar2.default, get(function (t) {
                  return t[stat.key];
                }))
              );
            })
          ),
          someOf(FOULS) && _react2.default.createElement(
            'div',
            { className: 'football-match-statset' },
            FOULS.map(function (stat) {
              return exists(stat) && _react2.default.createElement(
                'div',
                { key: stat.key },
                _react2.default.createElement(
                  'h3',
                  { className: 'section-title' },
                  stat.label
                ),
                _react2.default.createElement(_SimpleBar2.default, get(function (t) {
                  return t[stat.key];
                }))
              );
            })
          ),
          someOf(OFFSIDES) && _react2.default.createElement(
            'div',
            { className: 'football-match-statset' },
            OFFSIDES.map(function (stat) {
              return exists(stat) && _react2.default.createElement(
                'div',
                { key: stat.key },
                _react2.default.createElement(
                  'h3',
                  { className: 'section-title' },
                  stat.label
                ),
                _react2.default.createElement(_SimpleBar2.default, get(function (t) {
                  return t[stat.key];
                }))
              );
            })
          )
        ) : _react2.default.createElement(
          'div',
          { className: 'football-match-stats-none' },
          _react2.default.createElement(_MetaDataWrapper2.default, { title: this.props.matchLabel + ' - Match Stats' }),
          'No match stats are available.'
        ),
        _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["football", "leaderboard"], additionalProperties: { view: "live" } })
      );
    }
  }]);
  return FootballMatchStats;
}(_react.Component), _class.propTypes = {
  matchLabel: _propTypes2.default.string,
  match: _propTypes2.default.object
}, _temp);
exports.default = FootballMatchStats;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballMatchSummary;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FootballMatchTeamStatus = __webpack_require__(826);

var _FootballMatchTeamStatus2 = _interopRequireDefault(_FootballMatchTeamStatus);

var _FootballMatchOdds = __webpack_require__(380);

var _FootballMatchOdds2 = _interopRequireDefault(_FootballMatchOdds);

var _FootballMatchOutcomeDescription = __webpack_require__(207);

var _FootballMatchOutcomeDescription2 = _interopRequireDefault(_FootballMatchOutcomeDescription);

var _LocalDateTime = __webpack_require__(61);

var _consts = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DASH_WITH_SPACES = ' - ';
var DASH_WITHOUT_SPACES = '-';

var HALF_TIME_LABEL = 'HT: ';
var FULL_TIME_LABEL = 'FT: ';
var AGGREGATE_SCORE_LABEL = 'Agg: ';

function FootballMatchSummary(_ref) {
  var matchLabel = _ref.matchLabel,
      _ref$match = _ref.match,
      match_detail = _ref$match.match_detail,
      homeTeam = _ref$match.homeTeam,
      awayTeam = _ref$match.awayTeam;

  var matchStarted = !_consts.MATCH_STATE_UPNEXT.includes(match_detail.state);

  return _react2.default.createElement(
    'div',
    { className: 'footballMatchSummary' },
    _react2.default.createElement(
      'div',
      { className: 'footballMatchSummaryDef' },
      _react2.default.createElement(
        'h1',
        null,
        matchLabel
      ),
      match_detail.description
    ),
    _react2.default.createElement(
      'div',
      { className: 'footballMatchSummaryInfo' },
      _react2.default.createElement(
        'span',
        { className: 'footballMatchInfoSpacing' },
        _react2.default.createElement(_LocalDateTime.LocalDate, { className: 'footballMatchSummaryGreyText', iso: match_detail.match_date })
      ),
      _react2.default.createElement(
        'span',
        { className: 'footballMatchInfoSpacing' },
        _react2.default.createElement(
          'span',
          { className: 'footballMatchInfoSpacing' },
          'KO:'
        ),
        _react2.default.createElement(_LocalDateTime.LocalTimeShort, { className: 'footballMatchSummaryGreyText', iso: match_detail.match_date })
      ),
      match_detail.attendance && _react2.default.createElement(
        'span',
        { className: 'footballMatchInfoSpacing' },
        _react2.default.createElement(
          'span',
          null,
          'ATT:\xA0'
        ),
        _react2.default.createElement(
          'span',
          { className: 'footballMatchSummaryGreyText' },
          '' + commaSeperateNumber(match_detail.attendance)
        )
      ),
      match_detail.referee && _react2.default.createElement(
        'span',
        { className: 'footballMatchInfoSpacing' },
        _react2.default.createElement(
          'span',
          null,
          'REF:\xA0'
        ),
        _react2.default.createElement(
          'span',
          { className: 'footballMatchSummaryGreyText' },
          '' + match_detail.referee
        )
      )
    ),
    _react2.default.createElement(
      'section',
      { className: 'footballMatchSummaryScores' },
      _react2.default.createElement(
        'div',
        { className: 'footballMatchSummaryHomeTeam' },
        _react2.default.createElement(_FootballMatchTeamStatus2.default, { team: match_detail.team_score_a, players: homeTeam.players.players })
      ),
      _react2.default.createElement(
        'div',
        { className: 'footballMatchSummaryCurrentStatus' },
        makeScoreFromMatch(match_detail, DASH_WITH_SPACES),
        _react2.default.createElement(
          'div',
          { className: 'footballScoreSummary' },
          matchStarted && _react2.default.createElement(
            'div',
            { className: _consts.MATCH_STATE_FINISHED.includes(match_detail.state) ? 'footballFullTime' : 'timer' },
            match_detail.clock || ''
          ),
          matchStarted && makeScoreFromScore(match_detail.half_time_score, DASH_WITHOUT_SPACES, HALF_TIME_LABEL),
          matchStarted && match_detail.extra_time_score && makeScoreFromScore(match_detail.full_time_score, DASH_WITHOUT_SPACES, FULL_TIME_LABEL),
          makeScoreFromScore(match_detail.aggregate_score, DASH_WITHOUT_SPACES, AGGREGATE_SCORE_LABEL)
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'footballMatchSummaryAwayTeam' },
        _react2.default.createElement(_FootballMatchTeamStatus2.default, { team: match_detail.team_score_b, players: awayTeam.players.players })
      )
    ),
    _react2.default.createElement(_FootballMatchOutcomeDescription2.default, { matchOutcome: match_detail.match_outcome, penaltyShootoutScore: match_detail.penalty_shootout_score, style: "live-match" }),
    _react2.default.createElement(_FootballMatchOdds2.default, { match: match_detail })
  );
}

function makeScoreFromMatch(match_detail, seperator) {
  var home = match_detail.team_score_a.total_goals;
  var away = match_detail.team_score_b.total_goals;

  var score = void 0;
  if (_consts.MATCH_STATE_UPNEXT.includes(match_detail.state) || !home || !away) {
    score = _react2.default.createElement(
      'div',
      { className: 'versus' },
      'v'
    );
  } else {
    score = _react2.default.createElement(
      'div',
      { className: _consts.MATCH_STATE_FINISHED.includes(match_detail.state) ? "ft-score-box" : "live-score-box" },
      formatScore({ home: home, away: away }, seperator)
    );
  }

  return score;
}

function makeScoreFromScore(score, seperator, prefix) {
  if (score) {
    return _react2.default.createElement(
      'div',
      { className: 'footballPeriodScore' },
      formatScore(score, seperator, prefix)
    );
  }
}

function formatScore(score, seperator) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  return '' + prefix + score.home + seperator + score.away;
}

function commaSeperateNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

FootballMatchSummary.propTypes = {
  matchLabel: _propTypes2.default.string,
  match: _propTypes2.default.object
};

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _Table = __webpack_require__(361);

var _Table2 = _interopRequireDefault(_Table);

var _LocalDateTime = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballMatchTable = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FootballMatchTable, _Component);

  function FootballMatchTable() {
    (0, _classCallCheck3.default)(this, FootballMatchTable);
    return (0, _possibleConstructorReturn3.default)(this, (FootballMatchTable.__proto__ || (0, _getPrototypeOf2.default)(FootballMatchTable)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballMatchTable, [{
    key: 'createLeagueTables',
    value: function createLeagueTables(tables) {
      return tables.map(function (table, key) {
        return _react2.default.createElement(
          'section',
          { key: key, className: 'football-match-table-section' },
          table.label && _react2.default.createElement(
            'header',
            null,
            _react2.default.createElement(
              'h2',
              null,
              table.label
            )
          ),
          _react2.default.createElement(_Table2.default, { row: table.row })
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      __webpack_require__(1407);

      if (!this.props.tables || this.props.tables.length == 0) {
        return _react2.default.createElement(
          'div',
          { className: 'default-no-article' },
          _react2.default.createElement(
            'p',
            null,
            'We are currently unable to show the table.'
          )
        );
      }

      var matchName = _lodash2.default.get(this.props, 'match.competition.name');
      return _react2.default.createElement(
        'div',
        { className: 'footballMatchTable' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: this.props.matchLabel + ' - Table' }),
        _react2.default.createElement(
          'h3',
          { className: 'competition-name section-title' },
          matchName
        ),
        _react2.default.createElement(
          'h4',
          { className: 'table-date section-subtitle' },
          _react2.default.createElement(_LocalDateTime.LocalFullDate, { iso: new Date() })
        ),
        this.createLeagueTables(this.props.tables),
        _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["football", "leaderboard"], additionalProperties: { view: "live" } })
      );
    }
  }]);
  return FootballMatchTable;
}(_react.Component), _class.propTypes = {
  matchLabel: _propTypes2.default.string,
  tables: _propTypes2.default.array.isRequired,
  match: _propTypes2.default.object
}, _temp);
exports.default = FootballMatchTable;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballMatchTeamStatus;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FootballMatchPlayerGoals = __webpack_require__(822);

var _FootballMatchPlayerGoals2 = _interopRequireDefault(_FootballMatchPlayerGoals);

var _CompactText = __webpack_require__(162);

var _CompactText2 = _interopRequireDefault(_CompactText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballMatchTeamStatus(_ref) {
  var players = _ref.players,
      _ref$team = _ref.team,
      _ref$team$team = _ref$team.team,
      name = _ref$team$team.name,
      short_name = _ref$team$team.short_name,
      goals = _ref$team.goals;

  var sentOffPlayers = players.filter(function (player) {
    return player.redCardTime || player.secondYellowCardTime;
  }).map(function (player) {
    return {
      id: player.player.player_reference.id,
      time: player.redCardTime || player.secondYellowCardTime,
      name: player.name
    };
  });

  return _react2.default.createElement(
    'div',
    { className: 'footballMatchTeamStatus' },
    _react2.default.createElement(
      'h2',
      { className: 'footballMatchTeamName' },
      _react2.default.createElement(
        _CompactText2.default,
        { compactText: short_name },
        name
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'small-copy' },
      goals.map(function (goal) {
        return _react2.default.createElement(
          'div',
          { key: goal.id },
          _react2.default.createElement(_FootballMatchPlayerGoals2.default, { playerGoals: goal })
        );
      }),
      sentOffPlayers.map(function (_ref2) {
        var id = _ref2.id,
            time = _ref2.time,
            name = _ref2.name;
        return _react2.default.createElement(
          'div',
          { className: 'FootballMatchStatusRedCard', key: id },
          name,
          ' s/o ',
          time
        );
      })
    )
  );
}

FootballMatchTeamStatus.propTypes = {
  team: _propTypes2.default.shape({
    team: _propTypes2.default.shape({ name: _propTypes2.default.string.isRequired }).isRequired,
    goals: _propTypes2.default.array.isRequired
  }).isRequired,
  players: _propTypes2.default.array
};

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballMatchTeamsForm;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _FootballMatchForm = __webpack_require__(379);

var _FootballMatchForm2 = _interopRequireDefault(_FootballMatchForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballMatchTeamsForm(props) {
  var teamA = _lodash2.default.get(props, 'teamsForm.team_a');
  var teamB = _lodash2.default.get(props, 'teamsForm.team_b');

  if (!teamA && !teamB) {
    return _react2.default.createElement(
      'div',
      { className: 'default-no-article' },
      _react2.default.createElement(
        'p',
        null,
        'No form data available.'
      )
    );
  }

  var renderTeamForm = function renderTeamForm(team) {
    if (!team || !team.team.name) {
      return null;
    }

    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      _react2.default.createElement(
        'div',
        { className: 'table-block-header' },
        team.team.name
      ),
      _react2.default.createElement(_FootballMatchForm2.default, { formMatches: team.matches })
    );
  };

  return _react2.default.createElement(
    'div',
    { className: 'footballMatchTeamsForm' },
    _react2.default.createElement(_MetaDataWrapper2.default, { title: props.matchLabel + ' - Team Form' }),
    renderTeamForm(teamA),
    renderTeamForm(teamB),
    _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["football", "leaderboard"], additionalProperties: { view: "live" } })
  );
}

FootballMatchTeamsForm.propTypes = {
  matchLabel: _propTypes2.default.string,
  teamsForm: _propTypes2.default.object.isRequired
};

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballPlayer;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SubIcon = __webpack_require__(831);

var _SubIcon2 = _interopRequireDefault(_SubIcon);

var _FootballMatchEventIcon = __webpack_require__(208);

var _FootballMatchEventIcon2 = _interopRequireDefault(_FootballMatchEventIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballPlayer(props) {
  var subOn = void 0;
  var subOff = void 0;
  if (props.player.starting) {
    if (props.player.sub.subbedOff) {
      subOn = 'Sub Off';
    }
  } else {
    if (props.player.sub.subbedOn) {
      subOn = 'Sub On';
    }
    if (props.player.sub.subbedOff) {
      subOff = 'Sub Off';
    }
  }

  var cards = [];
  if (props.player.yellowCardTime) {
    cards.push('Yellow Card');
  }
  if (props.player.secondYellowCardTime) {
    cards.push('Second Yellow Card');
  }
  if (props.player.redCardTime) {
    cards.push('Red Card');
  }

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'section',
      { className: 'footballPlayerRow' },
      _react2.default.createElement(
        'div',
        { className: 'footballPlayerNumber' },
        props.player.shirt_number
      ),
      _react2.default.createElement(
        'div',
        { className: 'footballPlayerNameSubCard' },
        _react2.default.createElement(
          'span',
          { className: 'playerName' },
          props.player.name
        ),
        subOn && _react2.default.createElement(_SubIcon2.default, { time: props.player.sub.onTime, type: subOn }),
        subOff && _react2.default.createElement(_SubIcon2.default, { time: props.player.sub.offTime, type: subOff }),
        _react2.default.createElement(
          'span',
          { className: 'cardIcon' },
          cards && cards.map(function (card, index) {
            return _react2.default.createElement(_FootballMatchEventIcon2.default, { key: index, type: card });
          })
        )
      )
    ),
    _react2.default.createElement('div', { className: 'rowUnderLine' })
  );
}

FootballPlayer.propTypes = {
  player: _propTypes2.default.object.isRequired
};

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _FootballVidiprinter = __webpack_require__(263);

var _FootballVidiprinter2 = _interopRequireDefault(_FootballVidiprinter);

var _LocalDateTime = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballVidiprinterPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FootballVidiprinterPage, _Component);

  function FootballVidiprinterPage() {
    (0, _classCallCheck3.default)(this, FootballVidiprinterPage);
    return (0, _possibleConstructorReturn3.default)(this, (FootballVidiprinterPage.__proto__ || (0, _getPrototypeOf2.default)(FootballVidiprinterPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballVidiprinterPage, [{
    key: 'render',
    value: function render() {
      __webpack_require__(1409);
      var data = this.props.data;


      return _react2.default.createElement(
        'div',
        { className: 'vidiprinter' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: 'Live Vidiprinter' }),
        _react2.default.createElement(
          'h1',
          { className: 'vidiprinter-title' },
          'Live Vidiprinter'
        ),
        _react2.default.createElement(
          'p',
          { className: 'vidiprinter-updated' },
          _react2.default.createElement(_LocalDateTime.LocalFullDate, null)
        ),
        _react2.default.createElement(_FootballVidiprinter2.default, { data: data.items })
      );
    }
  }]);
  return FootballVidiprinterPage;
}(_react.Component), _class.propTypes = {
  data: _propTypes2.default.object
}, _temp);
exports.default = FootballVidiprinterPage;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FootballWinsDrawsWins;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballWinsDrawsWins(props) {
  var homeTeamName = props.homeTeamName,
      awayTeamName = props.awayTeamName,
      homeWins = props.homeWins,
      draws = props.draws,
      awayWins = props.awayWins;


  __webpack_require__(1410);
  return _react2.default.createElement(
    'div',
    { className: 'headToHead' },
    _react2.default.createElement(
      'div',
      { className: 'teamA' },
      _react2.default.createElement(
        'div',
        { className: 'teamAName' },
        homeTeamName
      ),
      _react2.default.createElement(
        'div',
        { className: 'big-number' },
        homeWins
      ),
      _react2.default.createElement(
        'div',
        { className: 'teamAAnnotation' },
        'Wins'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'draws' },
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'div',
        { className: 'big-number' },
        draws
      ),
      _react2.default.createElement(
        'div',
        { className: 'drawsAnnotation' },
        'Draws'
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'teamB' },
      _react2.default.createElement(
        'div',
        { className: 'teamBName' },
        awayTeamName
      ),
      _react2.default.createElement(
        'div',
        { className: 'big-number' },
        awayWins
      ),
      _react2.default.createElement(
        'div',
        { className: 'teamBAnnotation' },
        'Wins'
      )
    )
  );
}

FootballWinsDrawsWins.propTypes = {
  homeTeamName: _propTypes2.default.string.isRequired,
  awayTeamName: _propTypes2.default.string.isRequired,
  homeWins: _propTypes2.default.number.isRequired,
  draws: _propTypes2.default.number.isRequired,
  awayWins: _propTypes2.default.number.isRequired

};

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SubIcon;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FootballMatchEventIcon = __webpack_require__(208);

var _FootballMatchEventIcon2 = _interopRequireDefault(_FootballMatchEventIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SubIcon(props) {
  return _react2.default.createElement(
    'span',
    { className: 'subIcon' },
    _react2.default.createElement(_FootballMatchEventIcon2.default, { type: props.type }),
    _react2.default.createElement(
      'span',
      { className: 'subTime' },
      props.time
    )
  );
}

SubIcon.propTypes = {
  type: _propTypes2.default.string.isRequired,
  time: _propTypes2.default.node.isRequired
};

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _moment = __webpack_require__(8);

var _moment2 = _interopRequireDefault(_moment);

var _seoUtils = __webpack_require__(23);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _LocalDateTimeHelper = __webpack_require__(13);

var _competitionMatches = __webpack_require__(385);

var _competition = __webpack_require__(264);

var _competitions = __webpack_require__(168);

var _userService = __webpack_require__(44);

var _FootballLiveDatesList = __webpack_require__(378);

var _FootballLiveDatesList2 = _interopRequireDefault(_FootballLiveDatesList);

var _Tabs = __webpack_require__(70);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Dropdown = __webpack_require__(100);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _utils = __webpack_require__(18);

var _utils2 = __webpack_require__(117);

var _routeUtils = __webpack_require__(38);

var _consts = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(328);

var FootballFixturesResults = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)('FootballFixturesResults', [{
  dispatch: function dispatch(_ref) {
    var _ref$params = _ref.params,
        compId = _ref$params.compId,
        month = _ref$params.month,
        routes = _ref.routes;

    var fixturesResults = (0, _routeUtils.getPropertyFromRoutes)(routes, 'fixturesResults');

    return (0, _competitionMatches.loadCompetitionMatches)(compId, month, fixturesResults);
  },
  refreshInterval: _consts.COMPETITIONS_REFRESH_INTERVAL_MILLIS,
  state: function state(_state) {
    return { matches: _state.football.competitionMatches.matches };
  }
}, {
  dispatch: function dispatch() {
    return (0, _competitions.load)();
  },
  state: function state(_state2) {
    return { competitions: _state2.football.competitions.list };
  }
}, {
  dispatch: function dispatch(_ref2) {
    var compId = _ref2.params.compId;
    return (0, _competition.loadCompetition)(compId);
  },
  state: function state(_state3) {
    return { selectedCompetition: _state3.football.competition.selectedCompetition };
  }
}, (0, _userService.userServiceLayoutConnect)()]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballFixturesResults, _Component);

  function FootballFixturesResults() {
    (0, _classCallCheck3.default)(this, FootballFixturesResults);
    return (0, _possibleConstructorReturn3.default)(this, (FootballFixturesResults.__proto__ || (0, _getPrototypeOf2.default)(FootballFixturesResults)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballFixturesResults, [{
    key: 'generateTabsBetweenMonths',
    value: function generateTabsBetweenMonths(competitionId, competitionName, competitionStart, competitionEnd, fixturesResults, monthStart, showingDefaultMonth) {

      var tabs = [];
      (0, _utils2.getMonths)(competitionStart, competitionEnd, fixturesResults).map(function (date) {

        var isIndex = showingDefaultMonth && date == (0, _LocalDateTimeHelper.localYearMonth)((0, _moment2.default)(monthStart));

        tabs.push({
          href: '/football/' + fixturesResults + '/competitions/' + (0, _utils.toSlug)(competitionName) + '/' + competitionId + '/' + (isIndex ? '' : date),
          text: (0, _LocalDateTimeHelper.localMonth)(date),
          isIndex: isIndex
        });
      });

      return tabs;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$matches = _props.matches,
          monthStart = _props$matches.from,
          _props$matches$match = _props$matches.match,
          matchList = _props$matches$match === undefined ? [] : _props$matches$match,
          _props$selectedCompet = _props.selectedCompetition,
          selectedCompetitionName = _props$selectedCompet.name,
          competitionId = _props$selectedCompet.competition_reference.id,
          seasonStartDate = _props$selectedCompet.season_start_date,
          seasonEndDate = _props$selectedCompet.season_end_date,
          _props$selectedCompet2 = _props$selectedCompet.show_teams_dropdown,
          showTeams = _props$selectedCompet2 === undefined ? true : _props$selectedCompet2,
          competitionTeams = _props$selectedCompet.teams,
          _props$competitions = _props.competitions,
          competitions = _props$competitions === undefined ? [] : _props$competitions,
          _props$params = _props.params,
          params = _props$params === undefined ? {} : _props$params,
          routes = _props.routes,
          fixturesResults = _props.fixturesResults;


      var title = void 0,
          h1 = void 0;

      if (fixturesResults == "results") {
        h1 = 'Results';
      } else {
        h1 = 'Fixtures';
      }

      title = h1 + ' - ' + (0, _LocalDateTimeHelper.localMonth)(monthStart);

      var helmetProps = (0, _extends3.default)({
        title: title
      }, (0, _seoUtils.canonicalLink)(routes, params), (0, _seoUtils.metaDescription)('Latest ' + fixturesResults + ' for ' + selectedCompetitionName + ' in ' + (0, _LocalDateTimeHelper.localLongMonth)(monthStart)));

      var tabs = this.generateTabsBetweenMonths(competitionId, selectedCompetitionName, seasonStartDate, seasonEndDate, fixturesResults, monthStart, !params.month);

      return _react2.default.createElement(
        'div',
        { className: 'footballFixturesResults' },
        _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(_Dropdown2.default, { title: selectedCompetitionName || 'COMPETITIONS', shouldNavigate: true, options: (0, _utils2.getCompetitionsNavList)(competitions, fixturesResults), className: 'competitions-dropdown', noOptionsMessage: 'No competitions found' }),
          showTeams && _react2.default.createElement(_Dropdown2.default, { shouldNavigate: true, title: 'TEAMS', options: (0, _utils2.getTeamsNavList)(competitionTeams, fixturesResults, selectedCompetitionName, competitionId), className: 'teams-dropdown', noOptionsMessage: 'No teams found' }),
          _react2.default.createElement(
            'h1',
            null,
            h1
          )
        ),
        _react2.default.createElement(_Tabs2.default, { tabs: tabs, centerDefault: true }),
        tabs.length > 0 ? _react2.default.createElement(_FootballLiveDatesList2.default, { matchList: matchList, fixturesResults: fixturesResults, messageType: 'month' }) : _react2.default.createElement(
          'div',
          { className: 'football-live-filter-no-match-msg' },
          _react2.default.createElement(
            'p',
            null,
            _consts.MATCH_FILTER_EMPTY_MESSAGE['noTabs']
          )
        )
      );
    }
  }]);
  return FootballFixturesResults;
}(_react.Component), _class2.propTypes = {
  matches: _propTypes2.default.object.isRequired,
  competitions: _propTypes2.default.array.isRequired,
  params: _propTypes2.default.object,
  routes: _propTypes2.default.array.isRequired,
  fixturesResults: _propTypes2.default.string.isRequired,
  selectedCompetition: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class);
exports.default = FootballFixturesResults;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RightColumn = __webpack_require__(21);

var _StandardPage = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballFixturesLayout = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FootballFixturesLayout, _Component);

  function FootballFixturesLayout() {
    (0, _classCallCheck3.default)(this, FootballFixturesLayout);
    return (0, _possibleConstructorReturn3.default)(this, (FootballFixturesLayout.__proto__ || (0, _getPrototypeOf2.default)(FootballFixturesLayout)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballFixturesLayout, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          FootballFixturesResults = _props.FootballFixturesResults,
          FootballCompetitionFixturesResults = _props.FootballCompetitionFixturesResults,
          FootballTeamFixturesResults = _props.FootballTeamFixturesResults,
          route = _props.route;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: 'racing', title: 'Fixtures' },
        _react2.default.createElement(
          'div',
          { className: 'main-layout-left-column' },
          FootballFixturesResults && _react2.default.cloneElement(FootballFixturesResults, { fixturesResults: route.fixturesResults }),
          FootballCompetitionFixturesResults && _react2.default.cloneElement(FootballCompetitionFixturesResults, { fixturesResults: route.fixturesResults }),
          FootballTeamFixturesResults && _react2.default.cloneElement(FootballTeamFixturesResults, { fixturesResults: route.fixturesResults })
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: 'football',
          content: ["topMpu", "ocWidget"] })
      );
    }
  }]);
  return FootballFixturesLayout;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object.isRequired,
  route: _propTypes2.default.object.isRequired,
  FootballFixturesResults: _propTypes2.default.element,
  FootballCompetitionFixturesResults: _propTypes2.default.element,
  FootballTeamFixturesResults: _propTypes2.default.element
}, _temp);
exports.default = FootballFixturesLayout;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = __webpack_require__(8);

var _moment2 = _interopRequireDefault(_moment);

var _seoUtils = __webpack_require__(23);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _LocalDateTimeHelper = __webpack_require__(13);

var _dailyMatches = __webpack_require__(209);

var _competitions = __webpack_require__(168);

var _userService = __webpack_require__(44);

var _FootballLiveCompetitionList = __webpack_require__(261);

var _FootballLiveCompetitionList2 = _interopRequireDefault(_FootballLiveCompetitionList);

var _FootballMyScores = __webpack_require__(384);

var _FootballMyScores2 = _interopRequireDefault(_FootballMyScores);

var _Tabs = __webpack_require__(70);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Dropdown = __webpack_require__(100);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _utils = __webpack_require__(18);

var _routeUtils = __webpack_require__(38);

var _consts = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(328);

var FootballFixturesResults = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)('FootballFixturesResults', [{
  dispatch: function dispatch(_ref) {
    var date = _ref.params.date,
        _ref$routes = _ref.routes,
        routes = _ref$routes === undefined ? [] : _ref$routes;

    var fixturesResults = (0, _routeUtils.getPropertyFromRoutes)(routes, 'fixturesResults');

    return (0, _dailyMatches.loadMatches)(date, fixturesResults == "results");
  },
  refreshInterval: _consts.FIXTURES_REFRESH_INTERVAL_MILLIS,
  state: function state(_state) {
    return { matches: _state.football.dailyMatches.matches };
  },
  reset: function reset() {
    return (0, _dailyMatches.resetMatchesLoaded)();
  }
}, {
  dispatch: function dispatch() {
    return (0, _competitions.load)();
  },
  state: function state(_state2) {
    return { competitions: _state2.football.competitions.list };
  }
}, (0, _userService.userServiceLayoutConnect)()]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballFixturesResults, _Component);

  function FootballFixturesResults() {
    (0, _classCallCheck3.default)(this, FootballFixturesResults);
    return (0, _possibleConstructorReturn3.default)(this, (FootballFixturesResults.__proto__ || (0, _getPrototypeOf2.default)(FootballFixturesResults)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballFixturesResults, [{
    key: 'generateTabsForOneWeekEitherSideOfToday',
    value: function generateTabsForOneWeekEitherSideOfToday(path) {
      var range = void 0;

      if (path == "results") {
        range = -7;
      } else {
        range = 7;
      }

      return _lodash2.default.range(0, range).map(function (inc) {
        var thisDate = (0, _moment2.default)().add(inc, 'days'),
            isIndex = inc === 0;
        var text = (0, _LocalDateTimeHelper.localDateShort)(thisDate, { convertToday: true });
        var alternatives = [];
        if (isIndex) {
          alternatives = [{ href: '/football/' + path + '/' + (0, _LocalDateTimeHelper.isoDate)(thisDate), isIndex: isIndex }];
        }

        return {
          href: isIndex ? '/football/' + path : '/football/' + path + '/' + (0, _LocalDateTimeHelper.isoDate)(thisDate),
          text: text,
          isIndex: isIndex,
          alternatives: alternatives
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$matches = _props.matches,
          matches = _props$matches === undefined ? [] : _props$matches,
          _props$competitions = _props.competitions,
          competitions = _props$competitions === undefined ? [] : _props$competitions,
          _props$params = _props.params;
      _props$params = _props$params === undefined ? {} : _props$params;
      var date = _props$params.date,
          routes = _props.routes,
          fixturesResults = _props.fixturesResults;


      var titleBase = void 0,
          title = void 0,
          h1 = void 0;

      if (fixturesResults === "results") {
        titleBase = "Results";
      } else {
        titleBase = "Fixtures";
      }

      if (date) {
        var longDate = (0, _LocalDateTimeHelper.localFullDateLong)(date);
        h1 = titleBase + ' - ' + longDate;
        title = titleBase + ' ' + longDate;
      } else {
        title = 'Today\'s ' + titleBase;
        h1 = titleBase;
      }

      var helmetProps = (0, _extends3.default)({
        title: title
      }, (0, _seoUtils.canonicalLink)(routes, { date: date }));

      var competitionOptions = competitions.map(function (_ref2) {
        var name = _ref2.name,
            competition_id = _ref2.competition_reference.id;
        return {
          text: name,
          href: '/football/' + fixturesResults + '/competitions/' + (0, _utils.toSlug)(name) + '/' + competition_id
        };
      });

      return _react2.default.createElement(
        'div',
        { className: 'footballFixturesResults' },
        _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(_Dropdown2.default, { title: 'COMPETITIONS', shouldNavigate: true, options: competitionOptions, className: 'competitions-dropdown' }),
          _react2.default.createElement(
            'h1',
            null,
            h1
          )
        ),
        _react2.default.createElement(_Tabs2.default, { tabs: this.generateTabsForOneWeekEitherSideOfToday(fixturesResults), centerDefault: true }),
        _react2.default.createElement(_FootballMyScores2.default, { hideIfEmpty: true, matchList: matches }),
        matches.length > 0 ? _react2.default.createElement(_FootballLiveCompetitionList2.default, { matchList: matches }) : _react2.default.createElement(
          'div',
          { className: 'football-live-filter-no-match-msg' },
          _react2.default.createElement(
            'p',
            null,
            _consts.MATCH_FILTER_EMPTY_MESSAGE[fixturesResults]
          )
        )
      );
    }
  }]);
  return FootballFixturesResults;
}(_react.Component), _class2.propTypes = {
  matches: _propTypes2.default.array.isRequired,
  competitions: _propTypes2.default.array.isRequired,
  params: _propTypes2.default.object,
  routes: _propTypes2.default.array.isRequired,
  fixturesResults: _propTypes2.default.string
}, _temp)) || _class) || _class);
exports.default = FootballFixturesResults;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _seoUtils = __webpack_require__(23);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballHomePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FootballHomePage, _Component);

  function FootballHomePage() {
    (0, _classCallCheck3.default)(this, FootballHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (FootballHomePage.__proto__ || (0, _getPrototypeOf2.default)(FootballHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballHomePage, [{
    key: "render",
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: "football",
        title: "Football News & Scores | Betting Tips & Transfers",
        location: location,
        helmetProps: { titleTemplate: _seoUtils.titleTemplate.plain },
        rightColumnContent: ["mostReadFootball", "topMpu", "footballTips", "ocWidget"]
      });
    }
  }]);
  return FootballHomePage;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object
}, _temp);
exports.default = FootballHomePage;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballLeagues = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FootballLeagues, _Component);

  function FootballLeagues() {
    (0, _classCallCheck3.default)(this, FootballLeagues);
    return (0, _possibleConstructorReturn3.default)(this, (FootballLeagues.__proto__ || (0, _getPrototypeOf2.default)(FootballLeagues)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballLeagues, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          FootballLeaguesContainer = _props.FootballLeaguesContainer;


      return _react2.default.createElement(
        'div',
        { className: 'footballLeagues' },
        _react2.default.createElement(
          _StandardPage.StandardPage,
          { sport: 'football', title: 'football-leagues' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-left-column' },
            FootballLeaguesContainer
          ),
          _react2.default.createElement(_RightColumn.RightColumn, { location: location,
            sport: 'football',
            content: ["topMpu"] })
        )
      );
    }
  }]);
  return FootballLeagues;
}(_react.Component), _class.propTypes = {
  FootballLeaguesContainer: _propTypes2.default.element.isRequired,
  location: _propTypes2.default.object.isRequired
}, _temp);
exports.default = FootballLeagues;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _utils = __webpack_require__(18);

var _seoUtils = __webpack_require__(23);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _leagueTable = __webpack_require__(265);

var _competitions = __webpack_require__(168);

var _Dropdown = __webpack_require__(100);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _Table = __webpack_require__(361);

var _Table2 = _interopRequireDefault(_Table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1411);

function href(_ref) {
  var name = _ref.name,
      id = _ref.competition_reference.id;

  return '/football/league-tables/' + (0, _utils.toSlug)(name) + '/' + id;
}

var FootballLeaguesContainer = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)('FootballLeagues', [{
  dispatch: function dispatch() {
    return (0, _competitions.load)();
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state;
    return (0, _competitions.isLoading)(state);
  },
  state: function state(_state) {
    return { competitionList: _state.football.competitions.list };
  }
}, {
  dispatch: function dispatch(_ref3) {
    var competition = _ref3.params.competition;
    return (0, _leagueTable.loadByCompetition)(competition);
  },
  preventResolve: function preventResolve(_ref4) {
    var state = _ref4.state,
        competition = _ref4.params.competition;
    return (0, _leagueTable.isLoadingByCompetition)(state, competition);
  },
  state: function state(_state2, _ref5) {
    var competition = _ref5.params.competition;
    return { leagueTables: (0, _leagueTable.getByCompetition)(_state2, competition) };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballLeaguesContainer, _Component);

  function FootballLeaguesContainer() {
    (0, _classCallCheck3.default)(this, FootballLeaguesContainer);
    return (0, _possibleConstructorReturn3.default)(this, (FootballLeaguesContainer.__proto__ || (0, _getPrototypeOf2.default)(FootballLeaguesContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballLeaguesContainer, [{
    key: 'createLeagueTables',
    value: function createLeagueTables(tables) {
      return tables.map(function (table, key) {
        return _react2.default.createElement(
          'section',
          { key: key, className: 'football-leagues-section' },
          table.label && _react2.default.createElement(
            'header',
            null,
            _react2.default.createElement(
              'h2',
              null,
              table.label
            )
          ),
          _react2.default.createElement(_Table2.default, { row: table.row })
        );
      });
    }
  }, {
    key: 'getKeyAndDescription',
    value: function getKeyAndDescription(tables) {
      if (tables.length > 0) {
        for (var i = 0; i < tables.length; i++) {
          if (tables[i].table_description) {
            return _react2.default.createElement(
              'div',
              { className: 'football-leagues-key' },
              _react2.default.createElement(
                'h2',
                null,
                'Key'
              ),
              tables[i].table_description.split("\n").map(function (p, i) {
                return _react2.default.createElement(
                  'p',
                  { key: i },
                  p
                );
              })
            );
          }
        }
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          competitionList = _props.competitionList,
          leagueTables = _props.leagueTables,
          competition = _props.params.competition;


      if (!competitionList) {
        return _react2.default.createElement(
          'div',
          { className: 'default-no-article' },
          _react2.default.createElement(
            'p',
            null,
            'Competition tables currently unavailable. Please check back later.'
          )
        );
      }

      var listToShow = competitionList.filter(function (c) {
        return c.show_tables;
      }).sort(function (a, b) {
        return a.sort_order - b.sort_order;
      });

      var selectedCompetition = competition ? listToShow.filter(function (c) {
        return c.competition_reference.id == competition;
      })[0] : listToShow[0];

      var dropdownOptions = listToShow.map(function (c) {
        return {
          href: href(c),
          text: c.name
        };
      });

      dropdownOptions[0].alternatives = [{
        href: "/football/league-tables",
        isIndex: true
      }];

      var helmetProps = (0, _extends3.default)({
        title: selectedCompetition.name + ' League Table'
      }, (0, _seoUtils.canonicalRel)(href(selectedCompetition)), (0, _seoUtils.metaDescription)('Latest table for ' + selectedCompetition.name));

      var hasLeague = false;
      if (leagueTables.length > 0) {
        hasLeague = !!leagueTables[0].row.filter(function (r) {
          return !r.header;
        }).length;
      }

      return _react2.default.createElement(
        'div',
        { className: 'football-leagues-content' },
        _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
        _react2.default.createElement(_Dropdown2.default, { title: 'COMPETITIONS', options: dropdownOptions, shouldNavigate: true }),
        _react2.default.createElement(
          'h1',
          null,
          selectedCompetition.name
        ),
        hasLeague ? this.createLeagueTables(leagueTables) : _react2.default.createElement(
          'div',
          { className: 'football-leagues-key' },
          _react2.default.createElement(
            'p',
            null,
            'There is no league data available for ',
            selectedCompetition.name,
            ' at the moment.'
          )
        ),
        this.getKeyAndDescription(leagueTables)
      );
    }
  }]);
  return FootballLeaguesContainer;
}(_react.Component), _class2.propTypes = {
  competitionList: _propTypes2.default.array,
  leagueTables: _propTypes2.default.array,
  params: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = FootballLeaguesContainer;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RightColumn = __webpack_require__(21);

var _StandardPage = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballLiveHome = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FootballLiveHome, _Component);

  function FootballLiveHome() {
    (0, _classCallCheck3.default)(this, FootballLiveHome);
    return (0, _possibleConstructorReturn3.default)(this, (FootballLiveHome.__proto__ || (0, _getPrototypeOf2.default)(FootballLiveHome)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballLiveHome, [{
    key: 'render',
    value: function render() {
      __webpack_require__(1412);
      var _props = this.props,
          location = _props.location,
          FootballLiveHomeHeader = _props.FootballLiveHomeHeader,
          FootballLiveHomeVidiprinterContainer = _props.FootballLiveHomeVidiprinterContainer,
          FootballLiveHomeTabs = _props.FootballLiveHomeTabs;


      return _react2.default.createElement(
        'div',
        { className: 'footballLiveHome' },
        _react2.default.createElement(
          _StandardPage.StandardPage,
          { sport: 'football', title: 'Live Scores' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-left-column' },
            _react2.default.createElement(
              'div',
              { className: 'main-layout-block' },
              FootballLiveHomeHeader
            ),
            _react2.default.createElement(
              'div',
              { className: 'main-layout-block main-layout-hide-desktop' },
              FootballLiveHomeVidiprinterContainer
            ),
            _react2.default.createElement(
              'div',
              { className: 'main-layout-block last-desktop last-handheld' },
              FootballLiveHomeTabs
            )
          ),
          _react2.default.createElement(_RightColumn.RightColumn, { location: location,
            sport: 'football',
            content: ["topMpu", "vidiPrinter", "ocWidget"] })
        )
      );
    }
  }]);
  return FootballLiveHome;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object.isRequired,
  FootballLiveHomeHeader: _propTypes2.default.element.isRequired,
  FootballLiveHomeVidiprinterContainer: _propTypes2.default.element.isRequired,
  FootballLiveHomeTabs: _propTypes2.default.element.isRequired
}, _temp);
exports.default = FootballLiveHome;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _dailyMatches = __webpack_require__(209);

var _utils = __webpack_require__(117);

var _userService = __webpack_require__(44);

var _FootballLiveCompetitionList = __webpack_require__(261);

var _FootballLiveCompetitionList2 = _interopRequireDefault(_FootballLiveCompetitionList);

var _FootballMyScores = __webpack_require__(384);

var _FootballMyScores2 = _interopRequireDefault(_FootballMyScores);

var _Tabs = __webpack_require__(70);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _consts = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballLiveHomeTabs = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)('FootballLiveHomeTabs', [{
  dispatch: function dispatch() {
    return (0, _dailyMatches.loadMatches)();
  },
  refreshInterval: _consts.LIVE_REFRESH_INTERVAL_MILLIS,
  preventResolve: function preventResolve(_ref) {
    var state = _ref.state,
        date = _ref.params.date;
    return (0, _dailyMatches.areMatchesLoaded)(state, date);
  },
  state: function state(_state) {
    return { matches: _state.football.dailyMatches.matches };
  },
  preserveRefresh: true,
  reset: function reset() {
    return (0, _dailyMatches.resetMatchesLoaded)();
  }
}, (0, _userService.userServiceLayoutConnect)()]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballLiveHomeTabs, _Component);

  function FootballLiveHomeTabs() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, FootballLiveHomeTabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = FootballLiveHomeTabs.__proto__ || (0, _getPrototypeOf2.default)(FootballLiveHomeTabs)).call.apply(_ref2, [this].concat(args))), _this), _this.getFilter = function (currentLocation) {
      if (currentLocation.endsWith('ongoing')) {
        return 'ongoing';
      }
      if (currentLocation.endsWith('up-next')) {
        return 'upNext';
      }
      if (currentLocation.endsWith('finished')) {
        return 'finished';
      }
      return 'all';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(FootballLiveHomeTabs, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$matches = _props.matches,
          matches = _props$matches === undefined ? [] : _props$matches,
          location = _props.location;

      var filter = this.getFilter(location.pathname);

      var liveMatchCount = (0, _utils.filterMatchesByState)(matches, 'ongoing').length;
      var filteredMatches = (0, _utils.filterMatchesByState)(matches, filter);

      return _react2.default.createElement(
        'div',
        { className: 'footballLiveHomeTabbed' },
        _react2.default.createElement(_Tabs2.default, { tabs: [{
            href: "/football/live",
            text: "All",
            isIndex: true,
            className: "allTab"
          }, {
            href: "/football/live/filter/ongoing",
            text: 'Live' + (liveMatchCount ? ' (' + liveMatchCount + ')' : ''),
            className: "liveTab"
          }, {
            href: "/football/live/filter/up-next",
            text: "Up Next",
            className: "upNextTab"
          }, {
            href: "/football/live/filter/finished",
            text: "Finished",
            className: "finishedTab"
          }] }),
        _react2.default.createElement(_FootballMyScores2.default, { hideIfEmpty: filter == 'finished', matchList: filteredMatches }),
        filteredMatches.length > 0 ? _react2.default.createElement(_FootballLiveCompetitionList2.default, { matchList: filteredMatches }) : _react2.default.createElement(
          'div',
          { className: 'football-live-filter-no-match-msg' },
          _react2.default.createElement(
            'p',
            null,
            _consts.MATCH_FILTER_EMPTY_MESSAGE[filter]
          )
        )
      );
    }
  }]);
  return FootballLiveHomeTabs;
}(_react.Component), _class2.propTypes = {
  matches: _propTypes2.default.array.isRequired,
  location: _propTypes2.default.object.isRequired
}, _temp2)) || _class) || _class);
exports.default = FootballLiveHomeTabs;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FootballTeam = __webpack_require__(382);

var _FootballTeam2 = _interopRequireDefault(_FootballTeam);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _reactRedux = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballLiveMatchHomeTeam = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    match: state.football.match
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballLiveMatchHomeTeam, _Component);

  function FootballLiveMatchHomeTeam() {
    (0, _classCallCheck3.default)(this, FootballLiveMatchHomeTeam);
    return (0, _possibleConstructorReturn3.default)(this, (FootballLiveMatchHomeTeam.__proto__ || (0, _getPrototypeOf2.default)(FootballLiveMatchHomeTeam)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballLiveMatchHomeTeam, [{
    key: 'render',
    value: function render() {
      var match = this.props.match[this.props.params.matchId].match;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'awayTeam' },
          _react2.default.createElement(_MetaDataWrapper2.default, { title: this.props.matchLabel + ' - Away Team' }),
          _react2.default.createElement(_FootballTeam2.default, { team: match.awayTeam })
        )
      );
    }
  }]);
  return FootballLiveMatchHomeTeam;
}(_react.Component), _class2.propTypes = {
  matchLabel: _propTypes2.default.string,
  match: _propTypes2.default.object,
  params: _propTypes2.default.object
}, _temp)) || _class);
exports.default = FootballLiveMatchHomeTeam;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _match = __webpack_require__(386);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _FootballLiveMatch = __webpack_require__(817);

var _FootballLiveMatch2 = _interopRequireDefault(_FootballLiveMatch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFRESH_INTERVAL_MILLIS = 10000;

var FootballLiveMatchContainer = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)('FootballLiveMatchContainer', [{
  dispatch: function dispatch(_ref) {
    var matchId = _ref.params.matchId,
        getState = _ref.getState;

    var _ref2 = getState() || {},
        _ref2$football = _ref2.football;

    _ref2$football = _ref2$football === undefined ? {} : _ref2$football;
    var _ref2$football$match = _ref2$football.match;
    _ref2$football$match = _ref2$football$match === undefined ? {} : _ref2$football$match;
    var _ref2$football$match$ = _ref2$football$match[matchId];
    _ref2$football$match$ = _ref2$football$match$ === undefined ? {} : _ref2$football$match$;
    var last_modified_date = _ref2$football$match$.last_modified_date;

    return (0, _match.loadMatchAndEvents)(matchId, last_modified_date);
  },
  refreshInterval: REFRESH_INTERVAL_MILLIS,
  preventResolve: function preventResolve(_ref3) {
    var state = _ref3.state,
        matchId = _ref3.params.matchId;
    return (0, _match.isMatchLoading)(state, matchId);
  },
  state: function state(_state) {
    return { match: _state.football.match };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballLiveMatchContainer, _Component);

  function FootballLiveMatchContainer() {
    (0, _classCallCheck3.default)(this, FootballLiveMatchContainer);
    return (0, _possibleConstructorReturn3.default)(this, (FootballLiveMatchContainer.__proto__ || (0, _getPrototypeOf2.default)(FootballLiveMatchContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballLiveMatchContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_FootballLiveMatch2.default, {
        match: this.props.match[this.props.params.matchId].match,
        matchId: this.props.params.matchId,
        events: this.props.match[this.props.params.matchId].events,
        children: this.props.children,
        routes: this.props.routes
      });
    }
  }]);
  return FootballLiveMatchContainer;
}(_react.Component), _class2.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  match: _propTypes2.default.object,
  params: _propTypes2.default.object,
  dispatch: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = FootballLiveMatchContainer;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FootballTeam = __webpack_require__(382);

var _FootballTeam2 = _interopRequireDefault(_FootballTeam);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _reactRedux = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballLiveMatchHomeTeam = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    match: state.football.match
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballLiveMatchHomeTeam, _Component);

  function FootballLiveMatchHomeTeam() {
    (0, _classCallCheck3.default)(this, FootballLiveMatchHomeTeam);
    return (0, _possibleConstructorReturn3.default)(this, (FootballLiveMatchHomeTeam.__proto__ || (0, _getPrototypeOf2.default)(FootballLiveMatchHomeTeam)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballLiveMatchHomeTeam, [{
    key: 'render',
    value: function render() {
      var match = this.props.match[this.props.params.matchId].match;
      return _react2.default.createElement(
        'div',
        { className: 'homeTeam' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: this.props.matchLabel + ' - Home Team' }),
        _react2.default.createElement(_FootballTeam2.default, { team: match.homeTeam })
      );
    }
  }]);
  return FootballLiveMatchHomeTeam;
}(_react.Component), _class2.propTypes = {
  matchLabel: _propTypes2.default.string,
  match: _propTypes2.default.object,
  params: _propTypes2.default.object
}, _temp)) || _class);
exports.default = FootballLiveMatchHomeTeam;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SwitchBtns = __webpack_require__(102);

var _SwitchBtns2 = _interopRequireDefault(_SwitchBtns);

var _reactRedux = __webpack_require__(17);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballLiveMatchTeams = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    match: state.football.match
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballLiveMatchTeams, _Component);

  function FootballLiveMatchTeams() {
    (0, _classCallCheck3.default)(this, FootballLiveMatchTeams);
    return (0, _possibleConstructorReturn3.default)(this, (FootballLiveMatchTeams.__proto__ || (0, _getPrototypeOf2.default)(FootballLiveMatchTeams)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballLiveMatchTeams, [{
    key: 'render',
    value: function render() {
      var matchId = this.props.params.matchId;
      var match = this.props.match[matchId].match;
      return _react2.default.createElement(
        'div',
        { className: 'football-match-teams' },
        _react2.default.createElement(_SwitchBtns2.default, { buttons: [{ href: '/football/live/' + matchId + '/teams/home', text: match.homeTeam.teamName }, { href: '/football/live/' + matchId + '/teams/away', text: match.awayTeam.teamName }] }),
        _react2.default.createElement(
          'section',
          { className: 'content' },
          _react2.default.cloneElement(this.props.children, { matchLabel: this.props.matchLabel })
        ),
        _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["football", "leaderboard"], additionalProperties: { view: "live" } })
      );
    }
  }]);
  return FootballLiveMatchTeams;
}(_react.Component), _class2.propTypes = {
  match: _propTypes2.default.object,
  matchLabel: _propTypes2.default.string,
  params: _propTypes2.default.object,
  children: _propTypes2.default.object
}, _temp)) || _class);
exports.default = FootballLiveMatchTeams;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _ArticleUtils = __webpack_require__(174);

var _article = __webpack_require__(204);

var _media = __webpack_require__(78);

var _Article = __webpack_require__(173);

var _Article2 = _interopRequireDefault(_Article);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballMatchArticle = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var state = _ref.state,
        matchId = _ref.params.matchId,
        routes = _ref.routes;
    return (0, _article.loadByEventIdStoryType)(state, matchId, (0, _ArticleUtils.getStoryType)(routes));
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state,
        matchId = _ref2.params.matchId,
        routes = _ref2.routes;
    return (0, _article.isLoadingByEventIdStoryType)(state, matchId, (0, _ArticleUtils.getStoryType)(routes));
  },
  then: function then(_ref3) {
    var dispatch = _ref3.dispatch,
        state = _ref3.state,
        result = _ref3.result;
    return (0, _media.loadMediaForArticles)(state, dispatch, result.articles);
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballMatchArticle, _Component);

  function FootballMatchArticle() {
    (0, _classCallCheck3.default)(this, FootballMatchArticle);
    return (0, _possibleConstructorReturn3.default)(this, (FootballMatchArticle.__proto__ || (0, _getPrototypeOf2.default)(FootballMatchArticle)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballMatchArticle, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          matchLabel = _props.matchLabel,
          _props$route = _props.route;
      _props$route = _props$route === undefined ? {} : _props$route;
      var storyType = _props$route.storyType,
          matchId = _props.params.matchId;


      var label = {
        MATCH_PREVIEW: "Preview",
        MATCH_REPORT: "Match Report",
        MATCH_REACTION: "Reaction"
      }[storyType];

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_MetaDataWrapper2.default, { title: matchLabel + ' - ' + label }),
        _react2.default.createElement(_Article2.default, { embedded: true, embeddedLabel: label, articleIdRef: (0, _article.lookupRef)(matchId, storyType) }),
        _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["football", "leaderboard"], additionalProperties: { view: "live" } })
      );
    }
  }]);
  return FootballMatchArticle;
}(_react.Component), _class2.propTypes = {
  matchLabel: _propTypes2.default.string,
  route: _propTypes2.default.shape({
    storyType: _propTypes2.default.string.isRequired
  }).isRequired,
  params: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class);
exports.default = FootballMatchArticle;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RightColumn = __webpack_require__(21);

var _StandardPage = __webpack_require__(22);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballMatchCentreLayout = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FootballMatchCentreLayout, _Component);

  function FootballMatchCentreLayout() {
    (0, _classCallCheck3.default)(this, FootballMatchCentreLayout);
    return (0, _possibleConstructorReturn3.default)(this, (FootballMatchCentreLayout.__proto__ || (0, _getPrototypeOf2.default)(FootballMatchCentreLayout)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballMatchCentreLayout, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          FootballLiveMatchContainer = _props.FootballLiveMatchContainer,
          location = _props.location;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: "football", title: "Live Scores" },
        _react2.default.createElement(
          "div",
          { className: "main-layout-left-column" },
          FootballLiveMatchContainer
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: "football",
          content: ["topMpu", "ocWidget"] })
      );
    }
  }]);
  return FootballMatchCentreLayout;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object.isRequired,
  FootballLiveMatchContainer: _propTypes2.default.element.isRequired
}, _temp);
exports.default = FootballMatchCentreLayout;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _teamForm = __webpack_require__(388);

var _FootballMatchTeamsForm = __webpack_require__(827);

var _FootballMatchTeamsForm2 = _interopRequireDefault(_FootballMatchTeamsForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballMatchFormContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var matchId = _ref.params.matchId;
    return (0, _teamForm.load)(matchId);
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state,
        matchId = _ref2.params.matchId;
    return (0, _teamForm.isLoading)(state, matchId);
  },
  state: function state(_state, props) {
    return { teamForm: _state.football.teamForm[props.params.matchId].form };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballMatchFormContainer, _Component);

  function FootballMatchFormContainer() {
    (0, _classCallCheck3.default)(this, FootballMatchFormContainer);
    return (0, _possibleConstructorReturn3.default)(this, (FootballMatchFormContainer.__proto__ || (0, _getPrototypeOf2.default)(FootballMatchFormContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballMatchFormContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_FootballMatchTeamsForm2.default, { teamsForm: this.props.teamForm, matchLabel: this.props.matchLabel });
    }
  }]);
  return FootballMatchFormContainer;
}(_react.Component), _class2.propTypes = {
  matchLabel: _propTypes2.default.string,
  teamForm: _propTypes2.default.object,
  params: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = FootballMatchFormContainer;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FootballMatchHeadToHead = __webpack_require__(820);

var _FootballMatchHeadToHead2 = _interopRequireDefault(_FootballMatchHeadToHead);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _teamHeadToHead = __webpack_require__(389);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballMatchHeadToHeadContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var matchId = _ref.params.matchId;
    return (0, _teamHeadToHead.load)(matchId);
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state,
        matchId = _ref2.params.matchId;
    return (0, _teamHeadToHead.isLoading)(state, matchId);
  },
  state: function state(_state, props) {
    return { teamHeadToHead: _state.football.teamHeadToHead[props.params.matchId].H2H };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballMatchHeadToHeadContainer, _Component);

  function FootballMatchHeadToHeadContainer() {
    (0, _classCallCheck3.default)(this, FootballMatchHeadToHeadContainer);
    return (0, _possibleConstructorReturn3.default)(this, (FootballMatchHeadToHeadContainer.__proto__ || (0, _getPrototypeOf2.default)(FootballMatchHeadToHeadContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballMatchHeadToHeadContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_FootballMatchHeadToHead2.default, { H2H: this.props.teamHeadToHead, matchLabel: this.props.matchLabel });
    }
  }]);
  return FootballMatchHeadToHeadContainer;
}(_react.Component), _class2.propTypes = {
  matchLabel: _propTypes2.default.string,
  teamHeadToHead: _propTypes2.default.object,
  params: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = FootballMatchHeadToHeadContainer;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FootballMatchTable = __webpack_require__(825);

var _FootballMatchTable2 = _interopRequireDefault(_FootballMatchTable);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _leagueTable = __webpack_require__(265);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballMatchTableContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var state = _ref.state,
        matchId = _ref.params.matchId;
    return (0, _leagueTable.loadByMatch)(state, matchId);
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state,
        matchId = _ref2.params.matchId;
    return (0, _leagueTable.isLoadingByMatch)(state, matchId) || !(0, _leagueTable.hasMatchCompetition)(state, matchId);
  },
  state: function state(_state, ownProps) {
    var tableState = (0, _leagueTable.get)(_state, ownProps.params.matchId) || {},
        matchState = _state.football.match[ownProps.params.matchId] || {};
    return {
      error: (tableState.error || matchState.error || {}).error,
      tables: tableState.tables,
      match: matchState.match
    };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballMatchTableContainer, _Component);

  function FootballMatchTableContainer() {
    (0, _classCallCheck3.default)(this, FootballMatchTableContainer);
    return (0, _possibleConstructorReturn3.default)(this, (FootballMatchTableContainer.__proto__ || (0, _getPrototypeOf2.default)(FootballMatchTableContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballMatchTableContainer, [{
    key: 'render',
    value: function render() {
      return this.props.error ? _react2.default.createElement(
        'p',
        { className: 'error' },
        'We are currently unable to show the table.'
      ) : _react2.default.createElement(_FootballMatchTable2.default, { match: this.props.match, tables: this.props.tables, matchLabel: this.props.matchLabel });
    }
  }]);
  return FootballMatchTableContainer;
}(_react.Component), _class2.propTypes = {
  error: _propTypes2.default.string,
  tables: _propTypes2.default.object,
  matchLabel: _propTypes2.default.string,
  match: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = FootballMatchTableContainer;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballPaperTalk = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FootballPaperTalk, _Component);

  function FootballPaperTalk() {
    (0, _classCallCheck3.default)(this, FootballPaperTalk);
    return (0, _possibleConstructorReturn3.default)(this, (FootballPaperTalk.__proto__ || (0, _getPrototypeOf2.default)(FootballPaperTalk)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballPaperTalk, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          MoreNews = _props.MoreNews,
          MostReadFootball = _props.MostReadFootball;


      return _react2.default.createElement(
        'div',
        { className: 'footballLeagues' },
        _react2.default.createElement(
          _StandardPage.StandardPage,
          { sport: 'football', title: 'Paper talk' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-left-column' },
            MoreNews
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block main-layout-hide-desktop' },
            MostReadFootball
          ),
          _react2.default.createElement(_RightColumn.RightColumn, { location: location,
            sport: 'football',
            content: ["mostReadFootball", "topMpu"] })
        )
      );
    }
  }]);
  return FootballPaperTalk;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object.isRequired,
  MoreNews: _propTypes2.default.element.isRequired,
  MostReadFootball: _propTypes2.default.element.isRequired
}, _temp);
exports.default = FootballPaperTalk;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _seoUtils = __webpack_require__(23);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _team = __webpack_require__(387);

var _competition = __webpack_require__(264);

var _competitions = __webpack_require__(168);

var _userService = __webpack_require__(44);

var _FootballLiveDatesList = __webpack_require__(378);

var _FootballLiveDatesList2 = _interopRequireDefault(_FootballLiveDatesList);

var _Dropdown = __webpack_require__(100);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _routeUtils = __webpack_require__(38);

var _utils = __webpack_require__(117);

var _consts = __webpack_require__(62);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(328);

var FootballFixturesResults = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)('FootballFixturesResults', [{
  dispatch: function dispatch(_ref) {
    var teamId = _ref.params.teamId,
        routes = _ref.routes;

    var fixturesResults = (0, _routeUtils.getPropertyFromRoutes)(routes, 'fixturesResults');

    return (0, _team.loadTeam)(teamId, fixturesResults);
  },
  refreshInterval: _consts.COMPETITIONS_REFRESH_INTERVAL_MILLIS,
  state: function state(_state) {
    return { team: _state.football.team.teamData };
  }
}, {
  dispatch: function dispatch() {
    return (0, _competitions.load)();
  },
  state: function state(_state2) {
    return { competitions: _state2.football.competitions.list };
  }
}, {
  dispatch: function dispatch(_ref2) {
    var compId = _ref2.params.compId;
    return (0, _competition.loadCompetition)(compId);
  },
  state: function state(_state3) {
    return { selectedCompetition: _state3.football.competition.selectedCompetition };
  }
}, (0, _userService.userServiceLayoutConnect)()]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballFixturesResults, _Component);

  function FootballFixturesResults() {
    (0, _classCallCheck3.default)(this, FootballFixturesResults);
    return (0, _possibleConstructorReturn3.default)(this, (FootballFixturesResults.__proto__ || (0, _getPrototypeOf2.default)(FootballFixturesResults)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballFixturesResults, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$team = _props.team,
          teamName = _props$team.team.name,
          _props$team$matches = _props$team.matches,
          matchList = _props$team$matches === undefined ? [] : _props$team$matches,
          _props$selectedCompet = _props.selectedCompetition,
          selectedCompetitionName = _props$selectedCompet.name,
          competitionId = _props$selectedCompet.competition_reference.id,
          _props$selectedCompet2 = _props$selectedCompet.show_teams_dropdown,
          showTeams = _props$selectedCompet2 === undefined ? true : _props$selectedCompet2,
          competitionTeams = _props$selectedCompet.teams,
          _props$competitions = _props.competitions,
          competitions = _props$competitions === undefined ? [] : _props$competitions,
          _props$params = _props.params,
          params = _props$params === undefined ? {} : _props$params,
          routes = _props.routes,
          fixturesResults = _props.fixturesResults;


      var title = void 0;

      if (fixturesResults == "results") {
        title = 'Results';
      } else {
        title = 'Fixtures';
      }

      var helmetProps = (0, _extends3.default)({
        title: title
      }, (0, _seoUtils.canonicalLink)(routes, params), (0, _seoUtils.metaDescription)('Latest ' + fixturesResults + ' for ' + teamName + '}'));

      return _react2.default.createElement(
        'div',
        { className: 'footballFixturesResults' },
        _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(_Dropdown2.default, { shouldNavigate: true, title: selectedCompetitionName || 'COMPETITIONS', options: (0, _utils.getCompetitionsNavList)(competitions, fixturesResults), className: 'competitions-dropdown', noOptionsMessage: 'No competitions found' }),
          showTeams && _react2.default.createElement(_Dropdown2.default, { shouldNavigate: true, title: teamName || 'TEAMS', options: (0, _utils.getTeamsNavList)(competitionTeams, fixturesResults, selectedCompetitionName, competitionId), className: 'teams-dropdown', noOptionsMessage: 'No teams found' }),
          _react2.default.createElement(
            'h1',
            null,
            title
          )
        ),
        _react2.default.createElement(_FootballLiveDatesList2.default, { matchList: matchList, fixturesResults: fixturesResults, showCompetitions: true })
      );
    }
  }]);
  return FootballFixturesResults;
}(_react.Component), _class2.propTypes = {
  team: _propTypes2.default.object.isRequired,
  competitions: _propTypes2.default.array.isRequired,
  params: _propTypes2.default.object,
  routes: _propTypes2.default.array.isRequired,
  fixturesResults: _propTypes2.default.string.isRequired,
  selectedCompetition: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class);
exports.default = FootballFixturesResults;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballTipsCentre = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FootballTipsCentre, _Component);

  function FootballTipsCentre() {
    (0, _classCallCheck3.default)(this, FootballTipsCentre);
    return (0, _possibleConstructorReturn3.default)(this, (FootballTipsCentre.__proto__ || (0, _getPrototypeOf2.default)(FootballTipsCentre)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballTipsCentre, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          MoreNews = _props.MoreNews,
          MostReadFootball = _props.MostReadFootball;


      return _react2.default.createElement(
        'div',
        { className: 'footballLeagues' },
        _react2.default.createElement(
          _StandardPage.StandardPage,
          { sport: 'football', title: 'Paper talk' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-left-column' },
            MoreNews
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block main-layout-hide-desktop' },
            MostReadFootball
          ),
          _react2.default.createElement(_RightColumn.RightColumn, { location: location,
            sport: 'football',
            content: ["mostReadFootball", "topMpu"] })
        )
      );
    }
  }]);
  return FootballTipsCentre;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object.isRequired,
  MoreNews: _propTypes2.default.element.isRequired,
  MostReadFootball: _propTypes2.default.element.isRequired
}, _temp);
exports.default = FootballTipsCentre;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _vidiprinter = __webpack_require__(211);

var _FootballVidiprinterPage = __webpack_require__(829);

var _FootballVidiprinterPage2 = _interopRequireDefault(_FootballVidiprinterPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFRESH_INTERVAL_MILLIS = 10000;

var FootballVidiprinterPageContainer = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)('FootballVidiprinterPageContainer', [{
  dispatch: function dispatch() {
    return (0, _vidiprinter.load)();
  },
  preventResolve: function preventResolve(_ref) {
    var state = _ref.state;
    return (0, _vidiprinter.isLoading)(state);
  },
  refreshInterval: REFRESH_INTERVAL_MILLIS,
  state: function state(_state) {
    var _state$football$vidip = _state.football.vidiprinter,
        vidiprinter = _state$football$vidip === undefined ? { items: [] } : _state$football$vidip;

    return { vidiprinter: vidiprinter };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FootballVidiprinterPageContainer, _Component);

  function FootballVidiprinterPageContainer() {
    (0, _classCallCheck3.default)(this, FootballVidiprinterPageContainer);
    return (0, _possibleConstructorReturn3.default)(this, (FootballVidiprinterPageContainer.__proto__ || (0, _getPrototypeOf2.default)(FootballVidiprinterPageContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballVidiprinterPageContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_FootballVidiprinterPage2.default, { data: this.props.vidiprinter });
    }
  }]);
  return FootballVidiprinterPageContainer;
}(_react.Component), _class2.propTypes = {
  vidiprinter: _propTypes2.default.object,

  // supplied by redux-react via @connect
  dispatch: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class);
exports.default = FootballVidiprinterPageContainer;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RightColumn = __webpack_require__(21);

var _StandardPage = __webpack_require__(22);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FootballVidiprinterPageLayout = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FootballVidiprinterPageLayout, _Component);

  function FootballVidiprinterPageLayout() {
    (0, _classCallCheck3.default)(this, FootballVidiprinterPageLayout);
    return (0, _possibleConstructorReturn3.default)(this, (FootballVidiprinterPageLayout.__proto__ || (0, _getPrototypeOf2.default)(FootballVidiprinterPageLayout)).apply(this, arguments));
  }

  (0, _createClass3.default)(FootballVidiprinterPageLayout, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          location = _props.location,
          FootballVidiprinterPageContainer = _props.FootballVidiprinterPageContainer;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: "racing", title: "Live Vidiprinter" },
        _react2.default.createElement(
          "div",
          { className: "main-layout-left-column" },
          FootballVidiprinterPageContainer
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: "football",
          content: ["topMpu"] })
      );
    }
  }]);
  return FootballVidiprinterPageLayout;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object.isRequired,
  FootballVidiprinterPageContainer: _propTypes2.default.element.isRequired
}, _temp);
exports.default = FootballVidiprinterPageLayout;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layoutUtils = __webpack_require__(176);

var _GptProperties = __webpack_require__(51);

var rosTopMpu = {
  component: 'GooglePublisherTag',
  desktopColumn: 'right',
  desktopOrder: 1,
  handheldOrder: false,
  props: _GptProperties.topMPUProps
};

var ocHomeProps = {
  ocSlot: ['football', 'leaderboard']
};

var leaderboardAd = {
  view: 'football'
};

var mostRead = {
  component: "MostReadFootball",
  desktopColumn: "right",
  desktopOrder: 1,
  handheldOrder: 4
};

var footballTips = {
  component: 'FootballTips',
  desktopColumn: 'right',
  desktopOrder: 2,
  handheldOrder: false
};

var advertOfferRight = {
  component: 'AdvertWrapper',
  desktopColumn: 'right',
  desktopOrder: 2,
  handheldOrder: false,
  props: {
    ocSlot: ["football", "mpu"],
    additionalProperties: {
      view: 'football'
    }
  }
};

var withAdverts = function withAdverts() {
  for (var _len = arguments.length, components = Array(_len), _key = 0; _key < _len; _key++) {
    components[_key] = arguments[_key];
  }

  return {
    bannerAd: _GptProperties.bannerAd,
    leaderboardAd: leaderboardAd,
    components: [rosTopMpu].concat(components)
  };
};

var withAdvertsAndMostRead = function withAdvertsAndMostRead() {
  for (var _len2 = arguments.length, components = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    components[_key2] = arguments[_key2];
  }

  return {
    bannerAd: _GptProperties.bannerAd,
    leaderboardAd: leaderboardAd,
    components: [mostRead, rosTopMpu].concat(components)
  };
};

var withAdvertsArticle = function withAdvertsArticle() {
  for (var _len3 = arguments.length, components = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    components[_key3] = arguments[_key3];
  }

  return {
    leaderboardAd: leaderboardAd,
    components: [mostRead, rosTopMpu].concat(components)
  };
};

var withoutAdvertsArticle = function withoutAdvertsArticle() {
  for (var _len4 = arguments.length, components = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    components[_key4] = arguments[_key4];
  }

  return {
    components: [mostRead].concat(components)
  };
};

var footballHomePageLayout = withAdvertsAndMostRead({
  component: 'MoreNews',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
}, {
  component: 'GptAdvert',
  props: {
    ocDetails: ocHomeProps,
    performDetails: _GptProperties.singleBottomMPUProps
  },
  desktopColumn: 'left',
  desktopOrder: 2,
  handheldOrder: 2
}, footballTips, advertOfferRight);

var footballLiveCentreLayout = withAdverts({
  component: 'FootballLiveHomeHeader',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
}, {
  component: 'FootballLiveHomeVidiprinterContainer',
  desktopColumn: 'right',
  desktopOrder: 2,
  handheldOrder: 2
}, {
  component: 'FootballLiveHomeTabs',
  desktopColumn: 'left',
  desktopOrder: 2,
  handheldOrder: 3
}, advertOfferRight);

var footballVidiprinterLayout = withAdverts({
  component: 'FootballVidiprinterPageContainer',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

var footballLeaguesLayout = withAdverts({
  component: 'FootballLeaguesContainer',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

var footballMatchLayout = withAdverts({
  component: 'FootballLiveMatchContainer',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
}, advertOfferRight);

var footballFixturesLayout = withAdverts({
  component: 'FootballFixturesResults',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
}, advertOfferRight);

var footballCompetitionLayout = withAdverts({
  component: 'FootballCompetitionFixturesResults',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
}, advertOfferRight);

var footballTeamLayout = withAdverts({
  component: 'FootballTeamFixturesResults',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
}, advertOfferRight);

var footballTipsCentreLayout = withAdvertsAndMostRead({
  component: 'MoreNews',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

var footballPaperTalkLayout = withAdvertsAndMostRead({
  component: 'MoreNews',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

var article = {
  component: 'Article',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
};
var footballArticleLayout = withAdvertsArticle(article, footballTips);
var footballArticleSensitiveLayout = withoutAdvertsArticle(article, footballTips);

exports.default = {
  '/football': footballHomePageLayout,

  '/football/live': footballLiveCentreLayout,
  '/football/live/filter/ongoing': footballLiveCentreLayout,
  '/football/live/filter/up-next': footballLiveCentreLayout,
  '/football/live/filter/finished': footballLiveCentreLayout,

  '/football/live/vidiprinter': footballVidiprinterLayout,

  '/football/league-tables': footballLeaguesLayout,
  '/football/league-tables/:name/:competition': footballLeaguesLayout,

  '/football/live/:matchId': footballMatchLayout,
  '/football/live/:matchId/commentary': footballMatchLayout,
  '/football/live/:matchId/preview': footballMatchLayout,
  '/football/live/:matchId/stats': footballMatchLayout,
  '/football/live/:matchId/teams': footballMatchLayout,
  '/football/live/:matchId/teams/home': footballMatchLayout,
  '/football/live/:matchId/teams/away': footballMatchLayout,
  '/football/live/:matchId/form': footballMatchLayout,
  '/football/live/:matchId/head-to-head': footballMatchLayout,
  '/football/live/:matchId/table': footballMatchLayout,
  '/football/live/:matchId/report': footballMatchLayout,
  '/football/live/:matchId/reaction': footballMatchLayout,

  '/football/results': footballFixturesLayout,
  '/football/results/:date': footballFixturesLayout,
  '/football/fixtures/competitions/:compName/:compId': footballCompetitionLayout,
  '/football/fixtures/competitions/:compName/:compId/:month': footballCompetitionLayout,
  '/football/results/competitions/:compName/:compId': footballCompetitionLayout,
  '/football/results/competitions/:compName/:compId/:month': footballCompetitionLayout,
  '/football/fixtures/teams/:teamName/:teamId/:compName/:compId': footballTeamLayout,
  '/football/results/teams/:teamName/:teamId/:compName/:compId': footballTeamLayout,

  '/football/fixtures': footballFixturesLayout,
  '/football/fixtures/:date': footballFixturesLayout,

  '/football/tips-centre': footballTipsCentreLayout,

  '/football/paper-talk': footballPaperTalkLayout,

  '/football/news/:title/:articleId': function footballNewsTitleArticleId(layout) {
    return (0, _layoutUtils.articleSensitivityLayout)(layout, footballArticleLayout, footballArticleSensitiveLayout);
  }
};

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballLiveCenterNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "Live Scores",
    links: [{ href: "/football/live", text: "Live Centre", exceptions: [{ href: "/football/live/vidiprinter" }] }, { href: "/football/live/vidiprinter", text: "Vidiprinter" }],
    back: [{ href: "/football", text: "Football Home" }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

FootballLiveCenterNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = FootballLiveCenterNav;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FootballNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "Football",
    links: [{ href: "/football", text: "News", isIndex: true }, { href: "/football/live", text: "Live", isIndex: true }, { href: "/football/fixtures", text: "Fixtures" }, { href: "/football/results", text: "Results" }, { href: "/football/league-tables", text: "Tables" }, { href: "/football/paper-talk", text: "Paper Talk" }, { href: "/football/tips-centre", text: "Tips" }, { href: "https://www.skybet.com/football?aff=1197321690&dcmp=SL_NAV_FB_LO_19", text: "Latest Odds" }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

FootballNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = FootballNav;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var HEADTOHEAD = exports.HEADTOHEAD = {
  "team_a": {
    "name": "Arsenal"
  },
  "team_b": {
    "name": "Liverpool"
  },
  "team_a_wins": 2,
  "team_a_draws": 3,
  "team_a_losses": 1,
  "statistics": [{
    "type": "GOALS_SCORED",
    "team_a_value": 10,
    "team_b_value": 12
  }, {
    "type": "OVER_2_5_GOALS",
    "team_a_value": 4,
    "team_b_value": 6
  }, {
    "type": "BOTH_TEAMS_SCORED",
    "team_a_value": 3,
    "team_b_value": 6
  }],
  "matches": [{
    "link": [],
    "match_reference": {
      "id": 1,
      "external_reference": []
    },
    "match_date": "2016-09-18T17:00:00.000Z",
    "legs": 1,
    "leg": 1,
    "team_score_a": {
      "team": {
        "team_reference": {
          "id": 2,
          "external_reference": []
        },
        "name": "Liverpool"
      },
      "score": [{
        "score": "3"
      }]
    },
    "team_score_b": {
      "team": {
        "team_reference": {
          "id": 1,
          "external_reference": []
        },
        "name": "Arsenal"
      },
      "score": [{
        "score": "4"
      }]
    },
    "lineup_a": [],
    "lineup_b": [],
    "leg_score": [],
    "match_outcome": {
      "outcome": "WIN",
      "winner": {
        "name": "Arsenal",
        "team_reference": {
          "id": 1,
          "external_reference": []
        }
      }
    }
  }, {
    "link": [],
    "match_reference": {
      "id": 2,
      "external_reference": []
    },
    "match_date": "2016-09-06T17:00:00.000Z",
    "legs": 1,
    "leg": 1,
    "team_score_a": {
      "team": {
        "team_reference": {
          "id": 1,
          "external_reference": []
        },
        "name": "Arsenal"
      },
      "score": [{
        "score": "0"
      }]
    },
    "team_score_b": {
      "team": {
        "team_reference": {
          "id": 2,
          "external_reference": []
        },
        "name": "Liverpool"
      },
      "score": [{
        "score": "0"
      }]
    },
    "lineup_a": [],
    "lineup_b": [],
    "leg_score": [],
    "match_outcome": {
      "outcome": "DRAW",
      "winner": {
        "name": "Arsenal",
        "team_reference": {
          "id": 2,
          "external_reference": []
        }
      }
    }
  }]
};

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__(7);

var _extends6 = _interopRequireDefault(_extends5);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _MockTeamAndPlayerData = __webpack_require__(210);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'footballplayerprofile/LOAD'; // saved for later
// import config from 'config';

var LOAD_SUCCESS = 'footballplayerprofile/LOAD_SUCCESS';
var LOAD_FAIL = 'footballplayerprofile/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.playerid, (0, _extends6.default)({}, state[action.playerid], {
        loading: true
      })));
    case LOAD_SUCCESS:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.playerid, (0, _extends6.default)({}, state[action.playerid], {
        loading: false,
        loaded: true,
        player: action.result
      })));
    case LOAD_FAIL:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.playerid, (0, _extends6.default)({}, state[action.playerid], {
        loading: false,
        loaded: false,
        error: action.error
      })));
    default:
      return state;
  }
}

function isLoading(globalState, playerid) {
  return globalState.football && globalState.football.playerProfile && globalState.football.playerProfile[playerid] && globalState.football.playerProfile[playerid].loading;
}

function load(playerid) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    // saved for later
    // promise: (client) => client.get(`${config.api.football.vidiprinter}`)
    promise: function promise() {
      return _promise2.default.resolve((0, _MockTeamAndPlayerData.getPlayer)(playerid));
    },
    playerid: playerid
  };
}

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(112);

var _match = __webpack_require__(386);

var _match2 = _interopRequireDefault(_match);

var _dailyMatches = __webpack_require__(209);

var _dailyMatches2 = _interopRequireDefault(_dailyMatches);

var _vidiprinter = __webpack_require__(211);

var _vidiprinter2 = _interopRequireDefault(_vidiprinter);

var _playerProfile = __webpack_require__(858);

var _playerProfile2 = _interopRequireDefault(_playerProfile);

var _teamDetails = __webpack_require__(860);

var _teamDetails2 = _interopRequireDefault(_teamDetails);

var _teamSquad = __webpack_require__(862);

var _teamSquad2 = _interopRequireDefault(_teamSquad);

var _teamList = __webpack_require__(861);

var _teamList2 = _interopRequireDefault(_teamList);

var _teamForm = __webpack_require__(388);

var _teamForm2 = _interopRequireDefault(_teamForm);

var _teamHeadToHead = __webpack_require__(389);

var _teamHeadToHead2 = _interopRequireDefault(_teamHeadToHead);

var _leagueTable = __webpack_require__(265);

var _leagueTable2 = _interopRequireDefault(_leagueTable);

var _competition = __webpack_require__(264);

var _competition2 = _interopRequireDefault(_competition);

var _competitions = __webpack_require__(168);

var _competitions2 = _interopRequireDefault(_competitions);

var _competitionMatches = __webpack_require__(385);

var _competitionMatches2 = _interopRequireDefault(_competitionMatches);

var _team = __webpack_require__(387);

var _team2 = _interopRequireDefault(_team);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  match: _match2.default,
  dailyMatches: _dailyMatches2.default,
  vidiprinter: _vidiprinter2.default,
  playerProfile: _playerProfile2.default,
  teamDetails: _teamDetails2.default,
  teamSquad: _teamSquad2.default,
  teamList: _teamList2.default,
  teamForm: _teamForm2.default,
  teamHeadToHead: _teamHeadToHead2.default,
  leagueTable: _leagueTable2.default,
  competition: _competition2.default,
  competitions: _competitions2.default,
  competitionMatches: _competitionMatches2.default,
  team: _team2.default
});

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__(7);

var _extends6 = _interopRequireDefault(_extends5);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _MockTeamAndPlayerData = __webpack_require__(210);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'footballteamsdetails/LOAD'; // saved for later
// import config from 'config';

var LOAD_SUCCESS = 'footballteamsdetails/LOAD_SUCCESS';
var LOAD_FAIL = 'footballteamsdetails/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.teamid, (0, _extends6.default)({}, state[action.teamid], {
        loading: true
      })));
    case LOAD_SUCCESS:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.teamid, (0, _extends6.default)({}, state[action.teamid], {
        loading: false,
        loaded: true,
        details: action.result
      })));
    case LOAD_FAIL:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.teamid, (0, _extends6.default)({}, state[action.teamid], {
        loading: false,
        loaded: false,
        error: action.error
      })));
    default:
      return state;
  }
}

function isLoading(globalState, teamid) {
  return globalState.football && globalState.football.teamDetails && globalState.football.teamDetails[teamid] && globalState.football.teamDetails[teamid].loading;
}

function load(teamid) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    // saved for later
    // promise: (client) => client.get(`${config.api.football.vidiprinter}`)
    promise: function promise() {
      var _getTeam = (0, _MockTeamAndPlayerData.getTeam)(teamid),
          id = _getTeam.id,
          name = _getTeam.name,
          urlSlug = _getTeam.urlSlug;

      return _promise2.default.resolve({ id: id, name: name, urlSlug: urlSlug });
    },
    teamid: teamid
  };
}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _MockTeamAndPlayerData = __webpack_require__(210);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'footballteamlist/LOAD'; // saved for later
// import config from 'config';

var LOAD_SUCCESS = 'footballteamlist/LOAD_SUCCESS';
var LOAD_FAIL = 'footballteamlist/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        teams: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading(globalState) {
  return globalState.football && globalState.football.teamList && globalState.football.teamList.loading;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    // saved for later
    // promise: (client) => client.get(`${config.api.football.vidiprinter}`)
    promise: function promise() {
      return _promise2.default.resolve((0, _MockTeamAndPlayerData.listTeams)());
    }
  };
}

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = __webpack_require__(28);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__(7);

var _extends6 = _interopRequireDefault(_extends5);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;

var _MockTeamAndPlayerData = __webpack_require__(210);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'footballteamsquad/LOAD'; // saved for later
// import config from 'config';

var LOAD_SUCCESS = 'footballteamsquad/LOAD_SUCCESS';
var LOAD_FAIL = 'footballteamsquad/LOAD_FAIL';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.teamid, (0, _extends6.default)({}, state[action.teamid], {
        loading: true
      })));
    case LOAD_SUCCESS:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.teamid, (0, _extends6.default)({}, state[action.teamid], {
        loading: false,
        loaded: true,
        squad: action.result
      })));
    case LOAD_FAIL:
      return (0, _extends6.default)({}, state, (0, _defineProperty3.default)({}, action.teamid, (0, _extends6.default)({}, state[action.teamid], {
        loading: false,
        loaded: false,
        error: action.error
      })));
    default:
      return state;
  }
}

function isLoading(globalState, teamid) {
  return globalState.football && globalState.football.teamSquad && globalState.football.teamSquad[teamid] && globalState.football.teamSquad[teamid].loading;
}

function load(teamid) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    // saved for later
    // promise: (client) => client.get(`${config.api.football.vidiprinter}`)
    promise: function promise() {
      return _promise2.default.resolve((0, _MockTeamAndPlayerData.getTeam)(teamid).players);
    },
    teamid: teamid
  };
}

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _FootballHomePage = __webpack_require__(835);

var _FootballHomePage2 = _interopRequireDefault(_FootballHomePage);

var _MoreNews = __webpack_require__(93);

var _MoreNews2 = _interopRequireDefault(_MoreNews);

var _MostReadFootball = __webpack_require__(372);

var _MostReadFootball2 = _interopRequireDefault(_MostReadFootball);

var _Football = __webpack_require__(814);

var _Football2 = _interopRequireDefault(_Football);

var _FootballLeagues = __webpack_require__(836);

var _FootballLeagues2 = _interopRequireDefault(_FootballLeagues);

var _FootballLeaguesContainer = __webpack_require__(837);

var _FootballLeaguesContainer2 = _interopRequireDefault(_FootballLeaguesContainer);

var _FootballLiveHome = __webpack_require__(838);

var _FootballLiveHome2 = _interopRequireDefault(_FootballLiveHome);

var _FootballLiveHomeHeader = __webpack_require__(816);

var _FootballLiveHomeHeader2 = _interopRequireDefault(_FootballLiveHomeHeader);

var _FootballLiveHomeTabs = __webpack_require__(839);

var _FootballLiveHomeTabs2 = _interopRequireDefault(_FootballLiveHomeTabs);

var _FootballLiveHomeVidiprinterContainer = __webpack_require__(383);

var _FootballLiveHomeVidiprinterContainer2 = _interopRequireDefault(_FootballLiveHomeVidiprinterContainer);

var _FootballMatchCentreLayout = __webpack_require__(845);

var _FootballMatchCentreLayout2 = _interopRequireDefault(_FootballMatchCentreLayout);

var _FootballLiveMatchContainer = __webpack_require__(841);

var _FootballLiveMatchContainer2 = _interopRequireDefault(_FootballLiveMatchContainer);

var _FootballFixturesLayout = __webpack_require__(833);

var _FootballFixturesLayout2 = _interopRequireDefault(_FootballFixturesLayout);

var _FootballFixturesResults = __webpack_require__(834);

var _FootballFixturesResults2 = _interopRequireDefault(_FootballFixturesResults);

var _FootballCompetitionFixturesResults = __webpack_require__(832);

var _FootballCompetitionFixturesResults2 = _interopRequireDefault(_FootballCompetitionFixturesResults);

var _FootballTeamFixturesResults = __webpack_require__(850);

var _FootballTeamFixturesResults2 = _interopRequireDefault(_FootballTeamFixturesResults);

var _FootballVidiprinterPageLayout = __webpack_require__(853);

var _FootballVidiprinterPageLayout2 = _interopRequireDefault(_FootballVidiprinterPageLayout);

var _FootballVidiprinterPageContainer = __webpack_require__(852);

var _FootballVidiprinterPageContainer2 = _interopRequireDefault(_FootballVidiprinterPageContainer);

var _FootballNav = __webpack_require__(856);

var _FootballNav2 = _interopRequireDefault(_FootballNav);

var _FootballLiveCenterNav = __webpack_require__(855);

var _FootballLiveCenterNav2 = _interopRequireDefault(_FootballLiveCenterNav);

var _FootballLiveMatchTeams = __webpack_require__(843);

var _FootballLiveMatchTeams2 = _interopRequireDefault(_FootballLiveMatchTeams);

var _FootballLiveMatchHomeTeam = __webpack_require__(842);

var _FootballLiveMatchHomeTeam2 = _interopRequireDefault(_FootballLiveMatchHomeTeam);

var _FootballLiveMatchAwayTeam = __webpack_require__(840);

var _FootballLiveMatchAwayTeam2 = _interopRequireDefault(_FootballLiveMatchAwayTeam);

var _FootballMatchArticle = __webpack_require__(844);

var _FootballMatchArticle2 = _interopRequireDefault(_FootballMatchArticle);

var _FootballMatchStats = __webpack_require__(823);

var _FootballMatchStats2 = _interopRequireDefault(_FootballMatchStats);

var _FootballMatchCommentary = __webpack_require__(818);

var _FootballMatchCommentary2 = _interopRequireDefault(_FootballMatchCommentary);

var _FootballMatchTableContainer = __webpack_require__(848);

var _FootballMatchTableContainer2 = _interopRequireDefault(_FootballMatchTableContainer);

var _FootballMatchHeadToHeadContainer = __webpack_require__(847);

var _FootballMatchHeadToHeadContainer2 = _interopRequireDefault(_FootballMatchHeadToHeadContainer);

var _FootballMatchFormContainer = __webpack_require__(846);

var _FootballMatchFormContainer2 = _interopRequireDefault(_FootballMatchFormContainer);

var _FootballTipsCentre = __webpack_require__(851);

var _FootballTipsCentre2 = _interopRequireDefault(_FootballTipsCentre);

var _FootballPaperTalk = __webpack_require__(849);

var _FootballPaperTalk2 = _interopRequireDefault(_FootballPaperTalk);

var _ArticleContainer = __webpack_require__(216);

var _ArticleContainer2 = _interopRequireDefault(_ArticleContainer);

var _Article = __webpack_require__(173);

var _Article2 = _interopRequireDefault(_Article);

var _sitemapHelper = __webpack_require__(217);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _GooglePublisherTag = __webpack_require__(71);

var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);

var _FootballTips = __webpack_require__(140);

var _FootballTips2 = _interopRequireDefault(_FootballTips);

var _GptAdvert = __webpack_require__(101);

var _GptAdvert2 = _interopRequireDefault(_GptAdvert);

var _sitemapHelper2 = __webpack_require__(864);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var footballGpt = {
  GooglePublisherTag: _GooglePublisherTag2.default
};

var footBallHomeComponents = (0, _extends3.default)({
  MoreNews: _MoreNews2.default,
  AdvertWrapper: _AdvertWrapper2.default,
  GptAdvert: _GptAdvert2.default,
  MostReadFootball: _MostReadFootball2.default,
  FootballTips: _FootballTips2.default
}, footballGpt);

var FootballLiveHomeComponents = (0, _extends3.default)({
  FootballLiveHomeHeader: _FootballLiveHomeHeader2.default,
  FootballLiveHomeVidiprinterContainer: _FootballLiveHomeVidiprinterContainer2.default,
  FootballLiveHomeTabs: _FootballLiveHomeTabs2.default,
  AdvertWrapper: _AdvertWrapper2.default
}, footballGpt);

var FootballVidiprinterPageComponents = (0, _extends3.default)({
  FootballVidiprinterPageContainer: _FootballVidiprinterPageContainer2.default
}, footballGpt);

var FootballMatchCentreComponents = (0, _extends3.default)({
  FootballLiveMatchContainer: _FootballLiveMatchContainer2.default,
  AdvertWrapper: _AdvertWrapper2.default
}, footballGpt);

var FootballFixturesComponents = (0, _extends3.default)({
  FootballFixturesResults: _FootballFixturesResults2.default,
  AdvertWrapper: _AdvertWrapper2.default
}, footballGpt);

var FootballLeaguesComponents = (0, _extends3.default)({
  FootballLeaguesContainer: _FootballLeaguesContainer2.default,
  AdvertWrapper: _AdvertWrapper2.default
}, footballGpt);

var FootballCompetitionFixturesComponents = (0, _extends3.default)({
  FootballCompetitionFixturesResults: _FootballCompetitionFixturesResults2.default,
  AdvertWrapper: _AdvertWrapper2.default
}, footballGpt);

var FootballTeamFixturesComponents = (0, _extends3.default)({
  FootballTeamFixturesResults: _FootballTeamFixturesResults2.default,
  AdvertWrapper: _AdvertWrapper2.default
}, footballGpt);

var TipsCentreComponents = (0, _extends3.default)({
  MoreNews: _MoreNews2.default,
  MostReadFootball: _MostReadFootball2.default
}, footballGpt);

var PaperTalkComponents = (0, _extends3.default)({
  MoreNews: _MoreNews2.default,
  MostReadFootball: _MostReadFootball2.default
}, footballGpt);

var footballRoutes = _react2.default.createElement(
  _reactRouter.Route,
  { path: 'football', component: _Football2.default, subnav: _FootballNav2.default },
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _FootballHomePage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: footBallHomeComponents })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'league-tables', component: _FootballLeagues2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { components: FootballLeaguesComponents }),
    _react2.default.createElement(_reactRouter.Route, { path: ':name/:competition', sitemap: { expand: _sitemapHelper2.leagueExpander }, components: FootballLeaguesComponents })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'live', subnav: _FootballLiveCenterNav2.default },
    _react2.default.createElement(
      _reactRouter.Route,
      { component: _FootballLiveHome2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: FootballLiveHomeComponents }),
      _react2.default.createElement(_reactRouter.Route, { path: 'filter/ongoing', components: FootballLiveHomeComponents, filterBy: 'ongoing' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'filter/up-next', components: FootballLiveHomeComponents, filterBy: 'upNext' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'filter/finished', components: FootballLiveHomeComponents, filterBy: 'finished' })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'vidiprinter', component: _FootballVidiprinterPageLayout2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: { changefreq: "always" }, components: FootballVidiprinterPageComponents })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: ':matchId', component: _FootballMatchCentreLayout2.default },
      _react2.default.createElement(
        _reactRouter.Route,
        { components: FootballMatchCentreComponents },
        _react2.default.createElement(_reactRouter.IndexRedirect, { to: 'commentary' }),
        ' ',
        _react2.default.createElement(_reactRouter.Route, { path: 'commentary', sitemap: { expand: _sitemapHelper2.matchExpander }, component: _FootballMatchCommentary2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'preview', component: _FootballMatchArticle2.default, storyType: 'MATCH_PREVIEW' }),
        _react2.default.createElement(_reactRouter.Route, { path: 'stats', component: _FootballMatchStats2.default }),
        _react2.default.createElement(
          _reactRouter.Route,
          { path: 'teams', component: _FootballLiveMatchTeams2.default },
          _react2.default.createElement(_reactRouter.IndexRedirect, { to: '/football/live/:matchId/teams/home' }),
          ' ',
          _react2.default.createElement(_reactRouter.Route, { path: 'home', component: _FootballLiveMatchHomeTeam2.default }),
          _react2.default.createElement(_reactRouter.Route, { path: 'away', component: _FootballLiveMatchAwayTeam2.default })
        ),
        _react2.default.createElement(_reactRouter.Route, { path: 'form', component: _FootballMatchFormContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'head-to-head', component: _FootballMatchHeadToHeadContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'table', component: _FootballMatchTableContainer2.default }),
        _react2.default.createElement(_reactRouter.Route, { path: 'report', component: _FootballMatchArticle2.default, storyType: 'MATCH_REPORT' }),
        _react2.default.createElement(_reactRouter.Route, { path: 'reaction', component: _FootballMatchArticle2.default, storyType: 'MATCH_REACTION' })
      )
    )
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'fixtures-results' },
    _react2.default.createElement(_reactRouter.IndexRedirect, { to: '/football/fixtures' }),
    _react2.default.createElement(_reactRouter.Redirect, { from: ':date', to: '/football/fixtures/:date' })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'fixtures', component: _FootballFixturesLayout2.default, fixturesResults: 'fixtures' },
    _react2.default.createElement(_reactRouter.IndexRoute, { components: FootballFixturesComponents }),
    _react2.default.createElement(_reactRouter.Route, { path: ':date', sitemap: { expand: _sitemapHelper2.fixturesResultsExpander }, components: FootballFixturesComponents }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'competitions/:compName/:compId', components: FootballCompetitionFixturesComponents },
      _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: { expand: _sitemapHelper2.competitionExpander }, components: FootballCompetitionFixturesComponents }),
      _react2.default.createElement(_reactRouter.Route, { path: ':month', sitemap: { expand: _sitemapHelper2.competitionMonthExpander, fixturesResults: "fixtures" }, components: FootballCompetitionFixturesComponents })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'teams/:teamName/:teamId/:compName/:compId', components: FootballTeamFixturesComponents })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'results', component: _FootballFixturesLayout2.default, fixturesResults: 'results' },
    _react2.default.createElement(_reactRouter.IndexRoute, { components: FootballFixturesComponents }),
    _react2.default.createElement(_reactRouter.Route, { path: ':date', sitemap: { expand: _sitemapHelper2.fixturesResultsExpander }, components: FootballFixturesComponents }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'competitions/:compName/:compId', components: FootballCompetitionFixturesComponents },
      _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: { expand: _sitemapHelper2.competitionExpander }, components: FootballCompetitionFixturesComponents }),
      _react2.default.createElement(_reactRouter.Route, { path: ':month', sitemap: { expand: _sitemapHelper2.competitionMonthExpander, fixturesResults: "results" }, components: FootballCompetitionFixturesComponents })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'teams/:teamName/:teamId/:compName/:compId', components: FootballTeamFixturesComponents })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'tips-centre', component: _FootballTipsCentre2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { components: TipsCentreComponents }),
    ' '
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'paper-talk', component: _FootballPaperTalk2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { components: PaperTalkComponents }),
    ' '
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'news/:title/:articleId',
      component: _ArticleContainer2.default,
      sport: 'football',
      rightHandContent: ['mostReadFootball', 'topMpu', 'footballTips'] },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: { expand: (0, _sitemapHelper.newsArticleExpander)("football") },
      components: (0, _extends3.default)({ Article: _Article2.default }, footBallHomeComponents) }),
    ' '
  )
);

exports.default = footballRoutes;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(146);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

exports.fixturesResultsExpander = fixturesResultsExpander;
exports.matchExpander = matchExpander;
exports.leagueExpander = leagueExpander;
exports.competitionExpander = competitionExpander;
exports.competitionMonthExpander = competitionMonthExpander;

var _logger = __webpack_require__(198);

var _logger2 = _interopRequireDefault(_logger);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _ApiClient = __webpack_require__(64);

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _LocalDateTimeHelper = __webpack_require__(13);

var _sitemapUtils = __webpack_require__(276);

var _utils = __webpack_require__(18);

var _utils2 = __webpack_require__(117);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var client = new _ApiClient2.default(); /**********************************************
                                          EXPANDERS EXPLAINED:
                                        
                                          Take a route from of the sitemap generation process,
                                          return a promise for thenable routes - to be flattened when the sitemap is generated
                                        
                                        */ /////////////////////////////////////////////

function fixturesResultsExpander(_ref) {
  var url = _ref.url,
      _ref$sitemap = _ref.sitemap,
      changefreq = _ref$sitemap.changefreq,
      priority = _ref$sitemap.priority;

  var routeArray = [];
  var dateArray = (0, _sitemapUtils.nDayArrFactoryBoth)();

  return new _promise2.default(function (resolve) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(dateArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var date = _step.value;

        routeArray.push({ url: url.replace(":date", date), sitemap: { changefreq: changefreq, priority: priority } });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return resolve(routeArray);
  });
}

function matchExpander(_ref2) {
  var url = _ref2.url,
      _ref2$sitemap = _ref2.sitemap,
      changefreq = _ref2$sitemap.changefreq,
      priority = _ref2$sitemap.priority;

  var routeArray = [];
  var dateArray = (0, _sitemapUtils.nDayArrFactoryBoth)();

  var promiseStack = [];

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(dateArray), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var date = _step2.value;

      promiseStack.push(client.get(_config2.default.api.football.dailyMatches, { params: { match_date: date } }).then(function (result) {
        return result;
      }).catch(function (err) {
        _logger2.default.debug(err);
        return [];
      }));
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return _promise2.default.all(promiseStack).then(function (results) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = (0, _getIterator3.default)(results), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var res = _step3.value;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = (0, _getIterator3.default)(res), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _ref4 = _step4.value;
            var id = _ref4.match_reference.id,
                matchDateTime = _ref4.match_date;

            var isInPast = (0, _LocalDateTimeHelper.isInThePast)(matchDateTime);
            // NB: Could add last modified here
            routeArray.push({
              url: url.replace(":matchId", id),
              sitemap: {
                changefreq: changefreq,
                priority: priority,
                lastmodISO: isInPast ? matchDateTime : undefined
              }
            });
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return routeArray;
  });
}

function leagueExpander(_ref5) {
  var url = _ref5.url,
      _ref5$sitemap = _ref5.sitemap,
      changefreq = _ref5$sitemap.changefreq,
      priority = _ref5$sitemap.priority;

  return client.get(_config2.default.api.football.competitionList).then(function (list) {
    return list.filter(function (c) {
      return c.show_tables;
    }).map(function (comp) {
      return {
        url: url.replace(":name", (0, _utils.toSlug)(comp.name)).replace(":competition", comp.competition_reference.id),
        sitemap: {
          changefreq: changefreq,
          priority: priority
        }
      };
    });
  });
}

function competitionExpander(_ref6) {
  var url = _ref6.url,
      _ref6$sitemap = _ref6.sitemap,
      changefreq = _ref6$sitemap.changefreq,
      priority = _ref6$sitemap.priority;

  return client.get(_config2.default.api.football.competitionList).then(function (list) {
    return list.map(function (comp) {
      return {
        url: url.replace(":compName", (0, _utils.toSlug)(comp.name)).replace(":compId", comp.competition_reference.id),
        sitemap: {
          changefreq: changefreq,
          priority: priority
        }
      };
    });
  });
}

function competitionMonthExpander(_ref7) {
  var url = _ref7.url,
      _ref7$sitemap = _ref7.sitemap,
      changefreq = _ref7$sitemap.changefreq,
      priority = _ref7$sitemap.priority,
      fixturesResults = _ref7$sitemap.fixturesResults;

  return client.get(_config2.default.api.football.competitionList).then(function (list) {
    return _promise2.default.all(list.map(function (comp) {
      return client.get(_config2.default.api.football.competitions + "/" + comp.competition_reference.id).catch(function () {
        return _promise2.default.resolve();
      });
    }));
  }).then(function () {
    var competitions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var entries = competitions.map(function (comp) {
      return comp && (0, _utils2.getMonths)(comp.season_start_date, comp.season_end_date, fixturesResults).map(function (month) {
        return {
          url: url.replace(":compName", (0, _utils.toSlug)(comp.name)).replace(":compId", comp.competition_reference.id).replace(":month", month),
          sitemap: {
            changefreq: changefreq,
            priority: priority
          }
        };
      });
    });

    return entries.filter(function (i) {
      return i;
    }).reduce(function (a, b) {
      return a.concat(b);
    });
  });
}

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormulaOneHomePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(FormulaOneHomePage, _Component);

  function FormulaOneHomePage() {
    (0, _classCallCheck3.default)(this, FormulaOneHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (FormulaOneHomePage.__proto__ || (0, _getPrototypeOf2.default)(FormulaOneHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(FormulaOneHomePage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: 'formula-1',
        title: 'Formula 1 News, Results & Schedule',
        location: location
      });
    }
  }]);
  return FormulaOneHomePage;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node
}, _temp);
exports.default = FormulaOneHomePage;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FormulaOneNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "Formula 1",
    links: [{ href: "/formula1", text: "News", isIndex: true }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

FormulaOneNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = FormulaOneNav;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routeUtils = __webpack_require__(38);

var _FormulaOneHomePage = __webpack_require__(865);

var _FormulaOneHomePage2 = _interopRequireDefault(_FormulaOneHomePage);

var _FormulaOneNav = __webpack_require__(866);

var _FormulaOneNav2 = _interopRequireDefault(_FormulaOneNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _routeUtils.genericRoute)(_FormulaOneHomePage2.default, _FormulaOneNav2.default, 'formula1');

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GolfHomePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GolfHomePage, _Component);

  function GolfHomePage() {
    (0, _classCallCheck3.default)(this, GolfHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (GolfHomePage.__proto__ || (0, _getPrototypeOf2.default)(GolfHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(GolfHomePage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: 'golf',
        title: 'Golf Betting Tips & Leaderboards',
        location: location
      });
    }
  }]);
  return GolfHomePage;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object
}, _temp);
exports.default = GolfHomePage;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GolfNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "Golf",
    links: [{ href: "/golf", text: "News", isIndex: true }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

GolfNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = GolfNav;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routeUtils = __webpack_require__(38);

var _GolfHomePage = __webpack_require__(868);

var _GolfHomePage2 = _interopRequireDefault(_GolfHomePage);

var _GolfNav = __webpack_require__(869);

var _GolfNav2 = _interopRequireDefault(_GolfNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _routeUtils.genericRoute)(_GolfHomePage2.default, _GolfNav2.default, 'golf');

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GreyhoundRacingBase;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _seoUtils = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var helmetProps = {
  titleTemplate: _seoUtils.titleTemplate.greyhoundRacing
};

function GreyhoundRacingBase(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    { className: 'greyhound-racing-content' },
    _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
    children
  );
}

GreyhoundRacingBase.propTypes = {
  children: _propTypes2.default.any
};

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _urlRewrite = __webpack_require__(120);

var _Ordinal = __webpack_require__(200);

var _Ordinal2 = _interopRequireDefault(_Ordinal);

var _LocalDateTime = __webpack_require__(61);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1413);

var GreyhoundRacingFastResult = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GreyhoundRacingFastResult, _Component);

  function GreyhoundRacingFastResult() {
    (0, _classCallCheck3.default)(this, GreyhoundRacingFastResult);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GreyhoundRacingFastResult.__proto__ || (0, _getPrototypeOf2.default)(GreyhoundRacingFastResult)).call(this));

    _this.state = { expanded: false };
    return _this;
  }

  (0, _createClass3.default)(GreyhoundRacingFastResult, [{
    key: 'toggleExpanded',
    value: function toggleExpanded() {
      this.setState({ expanded: !this.state.expanded });
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.data;
      // currently taking from slug as it isn't supplied with API request

      var raceDate = data.slug.split('/')[0];
      var favToken = favGreyhoundsToken(data.top_greyhounds, data.unplaced_favourite);

      return _react2.default.createElement(
        'div',
        { className: 'fast-racecard-item' },
        _react2.default.createElement(
          'div',
          { className: 'fast-racecard-header' },
          _react2.default.createElement(
            'div',
            { className: 'fast-racecard-header-race', id: (0, _urlRewrite.titleToId)(data.courseName) },
            data.time && _react2.default.createElement(_LocalDateTime.LocalTimeShort, { iso: raceDate + 'T' + data.time + 'Z' }),
            ' ',
            data.courseName ? data.courseName : "Unknown"
          ),
          _react2.default.createElement(
            'div',
            { className: 'fast-racecard-header-fulllink' },
            data.status == "Final Result" ? _react2.default.createElement(
              _reactRouter.Link,
              { className: 'fast-racecard-header-fulllink-btn', to: "/greyhounds/racecards/" + data.slug },
              'Full results'
            ) : _react2.default.createElement(
              'span',
              { className: 'fast-racecard-header-fulllink-btn' },
              'Full results'
            )
          )
        ),
        showTopGreyhounds(data) && data.top_greyhounds.map(function (dog) {
          return _react2.default.createElement(
            'div',
            { key: dog.greyhound_reference.id, className: 'fast-results-place' },
            _react2.default.createElement(
              'div',
              { className: 'fast-results-place-position' },
              _react2.default.createElement(_Ordinal2.default, { n: dog.position })
            ),
            _react2.default.createElement(
              'div',
              { className: 'fast-results-place-number' },
              '(',
              dog.saddlecloth_number,
              ')'
            ),
            _react2.default.createElement(
              'div',
              { className: 'fast-results-place-name' },
              _react2.default.createElement(
                'span',
                null,
                dog.greyhound_name
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'fast-results-place-odds' },
              dog.odds,
              ' ',
              dog.favourite && favToken
            )
          );
        }),
        _react2.default.createElement(
          'ul',
          { className: 'fast-racecard-content fast-result-without-more-link' },
          _react2.default.createElement(
            OptionalData,
            { className: 'fast-racecard-content-top', value: (data.winning_trainer || {}).name },
            'Winning Trainer:'
          ),
          _react2.default.createElement(
            OptionalData,
            { className: 'fast-racecard-content-top', value: data.off_time },
            'Off-Time:'
          ),
          _react2.default.createElement(
            OptionalData,
            { className: 'fast-racecard-content-top', value: data.straight_forecast },
            'Forecast:'
          ),
          _react2.default.createElement(
            OptionalData,
            { className: 'fast-racecard-content-top', value: data.tricast },
            'Tricast:'
          ),
          data.status && _react2.default.createElement(
            'li',
            { className: 'fast-result-status' },
            _react2.default.createElement(
              'span',
              { className: 'fast-result-status-label' },
              data.status
            )
          )
        )
      );
    }
  }]);
  return GreyhoundRacingFastResult;
}(_react.Component), _class.propTypes = {
  data: _propTypes2.default.shape({
    top_greyhounds: _propTypes2.default.arrayOf(_propTypes2.default.object),
    winning_trainer: _propTypes2.default.object,
    courseName: _propTypes2.default.string,
    status: _propTypes2.default.string,
    time: _propTypes2.default.string,
    off_time: _propTypes2.default.string,
    straight_forecast: _propTypes2.default.string,
    tricast: _propTypes2.default.string,
    slug: _propTypes2.default.string
  })
}, _temp);
exports.default = GreyhoundRacingFastResult;


function showTopGreyhounds(data) {
  return data.status && (data.status === "Result" || data.status === "Final Result") && data.top_greyhounds && data.top_greyhounds.length > 0;
}

function OptionalData(props) {
  return props.value ? _react2.default.createElement(
    'li',
    { className: props.className },
    _react2.default.createElement(
      'span',
      { className: 'fast-racecard-content-label' },
      props.children
    ),
    _react2.default.createElement(
      'span',
      { className: 'fast-racecard-content-value' },
      props.value
    )
  ) : null;
}
OptionalData.propTypes = {
  className: _propTypes2.default.string,
  value: _propTypes2.default.any,
  children: _propTypes2.default.node
};

function countFavGreyhounds(array) {
  var result = 0;
  if (array) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].favourite === true) {
        result++;
      }
    }
  }
  return result;
}

function favGreyhoundsToken(arrayTop, arrayUnfav) {
  var sum = countFavGreyhounds(arrayTop) + countFavGreyhounds(arrayUnfav);
  if (sum == 1) {
    return "f";
  } else if (sum >= 2) {
    return "j";
  }
  return "";
}

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDeviceDetect = __webpack_require__(109);

var _GptProperties = __webpack_require__(51);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _GptAdvert = __webpack_require__(101);

var _GptAdvert2 = _interopRequireDefault(_GptAdvert);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _GreyhoundRacingFastResult = __webpack_require__(872);

var _GreyhoundRacingFastResult2 = _interopRequireDefault(_GreyhoundRacingFastResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GreyhoundRacingFastResultsList = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GreyhoundRacingFastResultsList, _Component);

  function GreyhoundRacingFastResultsList() {
    (0, _classCallCheck3.default)(this, GreyhoundRacingFastResultsList);
    return (0, _possibleConstructorReturn3.default)(this, (GreyhoundRacingFastResultsList.__proto__ || (0, _getPrototypeOf2.default)(GreyhoundRacingFastResultsList)).apply(this, arguments));
  }

  (0, _createClass3.default)(GreyhoundRacingFastResultsList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$isMobileFn = _props.isMobileFn,
          isMobileFn = _props$isMobileFn === undefined ? function () {
        return _reactDeviceDetect.isMobile;
      } : _props$isMobileFn,
          _props$fastResults = _props.fastResults;
      _props$fastResults = _props$fastResults === undefined ? {} : _props$fastResults;
      var _props$fastResults$fa = _props$fastResults.fastResults,
          fastResultsList = _props$fastResults$fa === undefined ? [] : _props$fastResults$fa;


      var isMobileSize = isMobileFn();
      var initialFastResults = isMobileSize ? fastResultsList.slice(0, 3) : fastResultsList;
      var finalFastResults = isMobileSize ? fastResultsList.slice(3) : [];

      return _react2.default.createElement(
        'div',
        { className: 'fast-results' },
        _react2.default.createElement(
          'h1',
          { className: 'page-main-title' },
          'Fast Results'
        ),
        _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["greyhounds", "leaderboard"], additionalProperties: { view: "greyhounds", location: "/greyhounds" } }),
        initialFastResults.length > 0 ? _react2.default.createElement(
          'div',
          { className: 'fast-results-list initial-fast-results' },
          initialFastResults.map(function (fastResult) {
            return _react2.default.createElement(_GreyhoundRacingFastResult2.default, { key: fastResult.race_reference.id, data: fastResult });
          })
        ) : _react2.default.createElement(
          'div',
          { className: 'no-fast-results' },
          'No fast results.'
        ),
        isMobileSize && _react2.default.createElement(_GptAdvert2.default, {
          ocDetails: {
            ocSlot: ["greyhounds", "mpu"]
          },
          performDetails: _GptProperties.singleBottomMPUProps
        }),
        finalFastResults.length > 0 && _react2.default.createElement(
          'div',
          { className: 'fast-results-list remaining-fast-results' },
          finalFastResults.map(function (fastResult) {
            return _react2.default.createElement(_GreyhoundRacingFastResult2.default, { key: fastResult.race_reference.id, data: fastResult });
          })
        )
      );
    }
  }]);
  return GreyhoundRacingFastResultsList;
}(_react.Component), _class.propTypes = {
  isMobileFn: _propTypes2.default.func,
  fastResults: _propTypes2.default.shape({
    fastResults: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      race_reference: _propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired
      }).isRequired
    })).isRequired
  })
}, _temp);
exports.default = GreyhoundRacingFastResultsList;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = GreyhoundRacingRaceDetails;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CurrencyFormatting = __webpack_require__(175);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GreyhoundRacingRaceDetails(props) {
  __webpack_require__(1414);
  var _props$race = props.race,
      _props$race$race_summ = _props$race.race_summary,
      forecast = _props$race$race_summ.straight_forecast,
      tricast = _props$race$race_summ.tricast,
      raceOffTime = _props$race$race_summ.off_time,
      raceWinningTime = _props$race$race_summ.winning_time,
      raceRunners = _props$race.runs,
      _props$race$winning_t = _props$race.winning_trainer;
  _props$race$winning_t = _props$race$winning_t === undefined ? {
    name: "Not Available"
  } : _props$race$winning_t;
  var winningTrainer = _props$race$winning_t.name;


  return _react2.default.createElement(
    'div',
    { className: 'gh-racecard-result-details-wrapper' },
    _react2.default.createElement(
      'div',
      { className: 'gh-racing-racecard-section-header' },
      _react2.default.createElement(
        'h4',
        null,
        'Race Details'
      )
    ),
    _react2.default.createElement(
      'ul',
      { className: 'gh-race-details-summary' },
      _react2.default.createElement(
        SummaryElement,
        { label: 'Winning Trainer' },
        winningTrainer
      ),
      _react2.default.createElement(
        SummaryElement,
        { label: 'Winning Time' },
        raceWinningTime
      ),
      _react2.default.createElement(
        SummaryElement,
        { label: 'Runners' },
        raceRunners.length + ' ran'
      ),
      _react2.default.createElement(
        SummaryElement,
        { label: 'Distances' },
        concatRunnerDistances([].concat((0, _toConsumableArray3.default)(raceRunners)))
      ),
      _react2.default.createElement(
        SummaryElement,
        { label: 'Off Time' },
        raceOffTime
      ),
      _react2.default.createElement(
        SummaryElement,
        { label: 'Forecast' },
        (0, _CurrencyFormatting.formatCurrency)(forecast, 'GBP')
      ),
      _react2.default.createElement(
        SummaryElement,
        { label: 'Tricast' },
        (0, _CurrencyFormatting.formatCurrency)(tricast, 'GBP')
      )
    )
  );
}

function concatRunnerDistances(runs) {
  return runs.map(function (r) {
    return r.finish_distance;
  }).filter(function (s) {
    return s;
  }).join(", ");
}

GreyhoundRacingRaceDetails.propTypes = {
  race: _propTypes2.default.object
};

function SummaryElement(_ref) {
  var label = _ref.label,
      children = _ref.children;

  return _react2.default.createElement(
    'li',
    null,
    _react2.default.createElement(
      'span',
      { className: 'gh-race-details-summary-label' },
      label
    ),
    _react2.default.createElement(
      'span',
      { className: 'gh-race-details-summary-value' },
      children
    )
  );
}

SummaryElement.propTypes = {
  label: _propTypes2.default.string.isRequired,
  link: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired
};

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.default = GreyhoundRacingRacePage;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _utils = __webpack_require__(18);

var _LocalDateTimeHelper = __webpack_require__(13);

var _seoUtils = __webpack_require__(23);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _Dropdown = __webpack_require__(100);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1415);

function GreyhoundRacingRacePage(props) {
  var routes = props.routes,
      children = props.children,
      raceMeeting = props.meeting,
      race = props.race,
      _props$race$race_summ = props.race.race_summary,
      raceId = _props$race$race_summ.race_summary_reference.id,
      _props$race$race_summ2 = _props$race$race_summ.course_name,
      courseName = _props$race$race_summ2 === undefined ? '' : _props$race$race_summ2,
      _props$race$race_summ3 = _props$race$race_summ.date,
      dateLong = _props$race$race_summ3 === undefined ? new Date() : _props$race$race_summ3,
      raceTime = _props$race$race_summ.time,
      _props$meetings = props.meetings;
  _props$meetings = _props$meetings === undefined ? {} : _props$meetings;
  var _props$meetings$meeti = _props$meetings.meetings,
      meetings = _props$meetings$meeti === undefined ? [] : _props$meetings$meeti;


  var meetingsOnThisDay = meetings.map(function (_ref) {
    var _ref$meeting_summary$ = _ref.meeting_summary.course.name,
        courseName = _ref$meeting_summary$ === undefined ? '' : _ref$meeting_summary$,
        _ref$races = (0, _slicedToArray3.default)(_ref.races, 1),
        raceId = _ref$races[0].race_summary_reference.id;

    return {
      href: '/greyhounds/racecards/' + dateLong + '/' + (0, _utils.toSlug)(courseName) + '/racecard/' + raceId,
      text: courseName
    };
  });

  var londonRaceTime = (0, _LocalDateTimeHelper.localTimeShort)(dateLong + 'T' + raceTime + 'Z');
  var helmetDate = (0, _LocalDateTimeHelper.localFullDateNoDay)(dateLong);
  var headingDate = (0, _LocalDateTimeHelper.localFullDateLong)(dateLong);

  var helmetProps = (0, _extends3.default)({
    title: londonRaceTime + ' ' + courseName + ' - ' + helmetDate
  }, (0, _seoUtils.canonicalLink)(routes, { date: dateLong, courseSlug: (0, _utils.toSlug)(courseName), raceId: raceId }));

  return _react2.default.createElement(
    'div',
    { className: 'gh-racing-racecard-wrapper' },
    _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
    _react2.default.createElement(
      'section',
      { className: 'gh-racing-racecard-top-section' },
      _react2.default.createElement(
        'div',
        { className: 'dropdown-wrapper' },
        _react2.default.createElement(_Dropdown2.default, { title: 'Meetings', options: meetingsOnThisDay, shouldNavigate: true })
      ),
      _react2.default.createElement(
        'h1',
        null,
        londonRaceTime,
        '\xA0',
        courseName,
        ' ',
        _react2.default.createElement(
          'small',
          null,
          headingDate
        )
      )
    ),
    children && _react2.default.cloneElement(children, { race: race, meeting: raceMeeting }),
    _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["greyhounds", "leaderboard"], additionalProperties: { view: "racecard" } })
  );
}

GreyhoundRacingRacePage.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  race: _propTypes2.default.object.isRequired,
  meeting: _propTypes2.default.object,
  meetings: _propTypes2.default.object,
  children: _propTypes2.default.node
};

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GreyhoundRacingRacecardNonRunners;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _GreyhoundRacingRacecardRunner = __webpack_require__(391);

var _GreyhoundRacingRacecardRunner2 = _interopRequireDefault(_GreyhoundRacingRacecardRunner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GreyhoundRacingRacecardNonRunners(props) {

  if (props.nonRunners && props.nonRunners.length) {
    return _react2.default.createElement(
      'section',
      null,
      _react2.default.createElement(
        'div',
        { className: 'gh-racing-racecard-section-header' },
        _react2.default.createElement(
          'h4',
          null,
          'Non Runners'
        )
      ),
      props.nonRunners.map(function (nonRunner) {
        return _react2.default.createElement(_GreyhoundRacingRacecardRunner2.default, {
          runner: nonRunner,
          key: nonRunner.key
        });
      })
    );
  } else {
    return _react2.default.createElement('section', null);
  }
}

GreyhoundRacingRacecardNonRunners.propTypes = {
  nonRunners: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _utils = __webpack_require__(18);

var _LocalDateTimeHelper = __webpack_require__(13);

var _consts = __webpack_require__(46);

var _Tabs = __webpack_require__(70);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _GreyhoundRacingRacecardSummary = __webpack_require__(881);

var _GreyhoundRacingRacecardSummary2 = _interopRequireDefault(_GreyhoundRacingRacecardSummary);

var _GreyhoundRacingRacecardPreRace = __webpack_require__(879);

var _GreyhoundRacingRacecardPreRace2 = _interopRequireDefault(_GreyhoundRacingRacecardPreRace);

var _GreyhoundRacingRacecardPostRace = __webpack_require__(878);

var _GreyhoundRacingRacecardPostRace2 = _interopRequireDefault(_GreyhoundRacingRacecardPostRace);

var _RaceJSONLD = __webpack_require__(201);

var _RaceJSONLD2 = _interopRequireDefault(_RaceJSONLD);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GreyhoundRacingRacecardPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GreyhoundRacingRacecardPage, _Component);

  function GreyhoundRacingRacecardPage() {
    (0, _classCallCheck3.default)(this, GreyhoundRacingRacecardPage);
    return (0, _possibleConstructorReturn3.default)(this, (GreyhoundRacingRacecardPage.__proto__ || (0, _getPrototypeOf2.default)(GreyhoundRacingRacecardPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(GreyhoundRacingRacecardPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          race = _props.race,
          _props$race = _props.race,
          raceSummary = _props$race.race_summary,
          _props$race$race_summ = _props$race.race_summary,
          _props$race$race_summ2 = _props$race$race_summ.race_summary_reference;
      _props$race$race_summ2 = _props$race$race_summ2 === undefined ? {} : _props$race$race_summ2;
      var singleRaceId = _props$race$race_summ2.id,
          dateLong = _props$race$race_summ.date,
          raceStage = _props$race$race_summ.race_stage,
          winningTime = _props$race$race_summ.winning_time,
          offTime = _props$race$race_summ.off_time,
          _props$meeting = _props.meeting;
      _props$meeting = _props$meeting === undefined ? {} : _props$meeting;

      var _props$meeting$meetin = (0, _slicedToArray3.default)(_props$meeting.meeting, 1),
          singleMeeting = _props$meeting$meetin[0],
          _props$meeting$meetin2 = (0, _slicedToArray3.default)(_props$meeting.meeting, 1),
          _props$meeting$meetin3 = _props$meeting$meetin2[0];

      _props$meeting$meetin3 = _props$meeting$meetin3 === undefined ? {} : _props$meeting$meetin3;
      var _props$meeting$meetin4 = _props$meeting$meetin3.meeting_summary.course.name,
          meetingCourseName = _props$meeting$meetin4 === undefined ? 'unknown' : _props$meeting$meetin4,
          _props$meeting$meetin5 = _props$meeting$meetin3.races,
          meetingRaces = _props$meeting$meetin5 === undefined ? [] : _props$meeting$meetin5;


      var tabs = meetingRaces.map(function (_ref) {
        var raceId = _ref.race_summary_reference.id,
            raceDate = _ref.date,
            raceTime = _ref.time;
        return {
          href: '/greyhounds/racecards/' + dateLong + '/' + (0, _utils.toSlug)(meetingCourseName) + '/racecard/' + raceId,
          text: (0, _LocalDateTimeHelper.localTimeShort)(raceDate + 'T' + raceTime + 'Z')
        };
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_RaceJSONLD2.default, { meeting: singleMeeting, sport: 'greyhounds', type: 'racecard', raceId: singleRaceId }),
        _react2.default.createElement(
          'section',
          { className: 'gh-racing-racecard-section' },
          _react2.default.createElement(_Tabs2.default, { tabs: tabs }),
          _react2.default.createElement(_GreyhoundRacingRacecardSummary2.default, { raceSummary: raceSummary })
        ),
        _consts.GREYHOUND_RACE_COMPLETE_STATUSES.includes(raceStage) ? _react2.default.createElement(_GreyhoundRacingRacecardPostRace2.default, { race: race, winningTime: winningTime, offTime: offTime }) : _react2.default.createElement(_GreyhoundRacingRacecardPreRace2.default, { race: race }),
        _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["greyhounds", "leaderboard"], additionalProperties: { view: "greyhounds" } })
      );
    }
  }]);
  return GreyhoundRacingRacecardPage;
}(_react.Component), _class.propTypes = {
  race: _propTypes2.default.object,
  meeting: _propTypes2.default.object
}, _temp);
exports.default = GreyhoundRacingRacecardPage;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GreyhoundRacingRacecardPostRace;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _LocalDateTimeHelper = __webpack_require__(13);

var _runFilter = __webpack_require__(397);

var _GreyhoundRacingRaceDetails = __webpack_require__(874);

var _GreyhoundRacingRaceDetails2 = _interopRequireDefault(_GreyhoundRacingRaceDetails);

var _GreyhoundRacingRacecardResultRunner = __webpack_require__(390);

var _GreyhoundRacingRacecardResultRunner2 = _interopRequireDefault(_GreyhoundRacingRacecardResultRunner);

var _GreyhoundRacingRacecardResultNonRunners = __webpack_require__(880);

var _GreyhoundRacingRacecardResultNonRunners2 = _interopRequireDefault(_GreyhoundRacingRacecardResultNonRunners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hideNull(element) {
  return element ? element : '';
}

function bracket(element) {
  return element ? '(' + element + ')' : '';
}

function transformData(runners) {
  var hn = hideNull;
  return runners.map(function (runner) {
    return {
      key: runner.run_reference.id,
      clothNo: hn(runner.cloth_number),
      position: hn(runner.finish_position),
      finishDistance: hn(runner.finish_distance),
      form: hn(runner.greyhound.formsummary.display_text),
      greyhoundName: hn(runner.greyhound.name),
      greyhoundId: hn(runner.greyhound.greyhound_reference.id),
      runDesc: hn(runner.run_description),
      runTime: hn(runner.run_time),
      runSplit: hn(parseFloat(runner.sectional_time)),
      trainer: runner.trainer,
      odds: hn(runner.betting.current_odds) + hn(runner.betting.favourite.betting_favourite),
      reserve: runner.reserve
    };
  });
}

function GreyhoundRacingRacecardPostRace(props) {
  var race = props.race,
      _props$race = props.race,
      raceRuns = _props$race.runs,
      raceDate = _props$race.race_summary.date,
      winningTime = props.winningTime,
      offTime = props.offTime;


  var runners = transformData((0, _runFilter.filterRunsByStatus)(raceRuns, "RUNNER"));
  var nonRunners = transformData((0, _runFilter.filterRunsByStatus)(raceRuns, "NONRUNNER"));

  return _react2.default.createElement(
    'section',
    null,
    _react2.default.createElement(
      'div',
      { className: 'gh-racecard-weighed-in-wrapper' },
      _react2.default.createElement(
        'h3',
        { className: 'gh-racecard-weighed-in-title' },
        'Final Result'
      ),
      _react2.default.createElement(
        'div',
        { className: 'gh-racecard-weighed-in-info' },
        _react2.default.createElement(
          'span',
          { className: 'gh-racecard-weighed-in-wt' },
          'Winning time:',
          _react2.default.createElement(
            'span',
            null,
            winningTime ? winningTime : '-'
          )
        ),
        _react2.default.createElement(
          'span',
          { className: 'gh-racecard-weighed-in-ot' },
          'Off time:',
          _react2.default.createElement(
            'span',
            null,
            offTime ? (0, _LocalDateTimeHelper.localTime)(raceDate + 'T' + offTime + 'Z') : '-'
          )
        )
      )
    ),
    runners.map(function (runner) {
      return _react2.default.createElement(_GreyhoundRacingRacecardResultRunner2.default, { runner: runner, key: runner.key });
    }),
    _react2.default.createElement(_GreyhoundRacingRacecardResultNonRunners2.default, { nonRunners: nonRunners }),
    _react2.default.createElement(_GreyhoundRacingRaceDetails2.default, { race: race })
  );
}

GreyhoundRacingRacecardPostRace.propTypes = {
  race: _propTypes2.default.object.isRequired,
  meeting: _propTypes2.default.object,
  winningTime: _propTypes2.default.string,
  offTime: _propTypes2.default.string,
  meetings: _propTypes2.default.object
};

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = GreyhoundRacingRacecardPreRace;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _runFilter = __webpack_require__(397);

var _seoUtils = __webpack_require__(23);

var _GreyhoundRacingRacecardRunner = __webpack_require__(391);

var _GreyhoundRacingRacecardRunner2 = _interopRequireDefault(_GreyhoundRacingRacecardRunner);

var _GreyhoundRacingRacecardNonRunners = __webpack_require__(876);

var _GreyhoundRacingRacecardNonRunners2 = _interopRequireDefault(_GreyhoundRacingRacecardNonRunners);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GreyhoundRacingRacecardPreRace(props) {
  var _props$race = props.race,
      raceRuns = _props$race.runs,
      raceSummary = _props$race.race_summary;


  var transformData = function transformData(runners) {
    var hn = hideNull;
    return runners.map(function (runner) {
      return {
        key: runner.run_reference.id,
        clothNo: hn(runner.cloth_number),
        drawNumber: bracket(runner.draw_number),
        position: hn(runner.finish_position) + ' ' + bracket(runner.draw_number),
        form: hn(runner.greyhound.formsummary.display_text),
        bestRunTime: runner.best_run_time,
        lastRunTime: runner.greyhound.previous_results.length > 0 ? runner.greyhound.previous_results[0].run_time : undefined,
        commentary: hn(runner.commentary),
        formWatch: hn(runner.formwatch),
        greyhound: runner.greyhound,
        greyhoundName: hn(runner.greyhound.name),
        greyhoundLastRan: hn(runner.greyhound.last_ran_days),
        greyhoundAge: hn(runner.greyhound.age),
        weight: hn(runner.handicap),
        rideBetlinkIds: hn(runner.run_reference.external_reference.filter(function (r) {
          return r.ref === 'skybet';
        }).map(function (r) {
          return r.value;
        })),
        trainer: runner.trainer,
        owner: runner.owner,
        odds: hn(runner.betting.current_odds),
        reserve: runner.reserve
      };
    });
  };

  var sortedRaceRuns = [].concat((0, _toConsumableArray3.default)(raceRuns)).sort(_runFilter.sortByClothNo);
  var runners = transformData((0, _runFilter.filterRunsByStatus)(sortedRaceRuns, "RUNNER"));
  var nonRunners = transformData((0, _runFilter.filterRunsByStatus)(sortedRaceRuns, "NONRUNNER"));

  var names = [];
  sortedRaceRuns.forEach(function (_ref) {
    var _ref$greyhound = _ref.greyhound;
    _ref$greyhound = _ref$greyhound === undefined ? {} : _ref$greyhound;
    var _ref$greyhound$name = _ref$greyhound.name,
        name = _ref$greyhound$name === undefined ? '' : _ref$greyhound$name;
    return names.push(" " + name);
  });

  var metaDescriptionValue = 'View the racecard and form for dogs:' + names;

  return _react2.default.createElement(
    'section',
    null,
    _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: (0, _extends3.default)({}, (0, _seoUtils.metaDescription)(metaDescriptionValue)) }),
    runners.map(function (runner) {
      return _react2.default.createElement(_GreyhoundRacingRacecardRunner2.default, {
        runner: runner,
        key: runner.key
      });
    }),
    _react2.default.createElement(_GreyhoundRacingRacecardNonRunners2.default, { nonRunners: nonRunners })
  );
}

GreyhoundRacingRacecardPreRace.propTypes = {
  race: _propTypes2.default.object.isRequired,
  meeting: _propTypes2.default.object,
  meetings: _propTypes2.default.object
};

function hideNull(element) {
  return element ? element : '';
}

function bracket(element) {
  return element ? '(' + element + ')' : '';
}

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GreyhoundRacingRacecardResultNonRunners;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _GreyhoundRacingRacecardResultRunner = __webpack_require__(390);

var _GreyhoundRacingRacecardResultRunner2 = _interopRequireDefault(_GreyhoundRacingRacecardResultRunner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GreyhoundRacingRacecardResultNonRunners(props) {

  if (props.nonRunners && props.nonRunners.length) {
    return _react2.default.createElement(
      'section',
      null,
      _react2.default.createElement(
        'div',
        { className: 'gh-racing-racecard-section-header' },
        _react2.default.createElement(
          'h4',
          null,
          'Non Runners'
        )
      ),
      props.nonRunners.map(function (nonRunner) {
        return _react2.default.createElement(_GreyhoundRacingRacecardResultRunner2.default, {
          runner: nonRunner,
          key: nonRunner.key
        });
      })
    );
  } else {
    return _react2.default.createElement('section', null);
  }
}

GreyhoundRacingRacecardResultNonRunners.propTypes = {
  nonRunners: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = GreyhoundRacingRacecardSummary;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GreyhoundRacingRacecardSummary(props) {

  var distanceFormat = function distanceFormat(dist) {
    if (!dist) {
      return;
    }
    return dist.replace(' 0f', '').replace(' 0y', '');
  };

  var _props$raceSummary = props.raceSummary,
      raceDistance = _props$raceSummary.distance,
      raceClass = _props$raceSummary.race_class,
      racePrizePool = _props$raceSummary.prizes;


  return _react2.default.createElement(
    'section',
    { className: 'gh-racecard-summary-wrapper' },
    _react2.default.createElement(
      'ul',
      { className: 'gh-racecard-summary-information-wrapper' },
      !!raceDistance && _react2.default.createElement(
        'li',
        { className: 'gh-racecard-summary-race-distance gh-racecard-summary-always-open' },
        distanceFormat(raceDistance) + 'm'
      ),
      !!raceClass && _react2.default.createElement(
        'li',
        { className: 'gh-racecard-summary-race-class gh-racecard-summary-always-open' },
        raceClass
      ),
      !!racePrizePool && _react2.default.createElement(
        'li',
        { className: 'gh-racecard-summary-race-prizes gh-racecard-summary-always-open' },
        racePrizePool
      )
    )
  );
}

GreyhoundRacingRacecardSummary.propTypes = {
  prizes: _propTypes2.default.arrayOf(_propTypes2.default.object),
  raceSummary: _propTypes2.default.object
};

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _LocalDateTimeHelper = __webpack_require__(13);

var _seoUtils = __webpack_require__(23);

var _JsonLD = __webpack_require__(164);

var _JsonLD2 = _interopRequireDefault(_JsonLD);

var _GreyhoundRacingRacecardsMeetingSummary = __webpack_require__(392);

var _GreyhoundRacingRacecardsMeetingSummary2 = _interopRequireDefault(_GreyhoundRacingRacecardsMeetingSummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1418);

var RacecardsForDate = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RacecardsForDate, _Component);

  function RacecardsForDate() {
    (0, _classCallCheck3.default)(this, RacecardsForDate);
    return (0, _possibleConstructorReturn3.default)(this, (RacecardsForDate.__proto__ || (0, _getPrototypeOf2.default)(RacecardsForDate)).apply(this, arguments));
  }

  (0, _createClass3.default)(RacecardsForDate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var title;

      var racecardsDate = this.props.date ? (0, _LocalDateTimeHelper.isoDate)(this.props.date) : (0, _LocalDateTimeHelper.isoDate)(new Date()),
          meetings = this.props.meetingsByDate[racecardsDate] == null ? null : this.props.meetingsByDate[racecardsDate].meetings;

      if ((0, _LocalDateTimeHelper.isToday)(racecardsDate)) {
        title = 'Today\'s Racecards';
      } else {
        title = (0, _LocalDateTimeHelper.localFullDateLong)(racecardsDate) + ' Racecards';
      }
      var canonicalURL = (0, _extends3.default)({}, (0, _seoUtils.canonicalLink)(this.props.routes, { date: racecardsDate }));

      var _canonicalURL$link = canonicalURL.link;
      _canonicalURL$link = _canonicalURL$link === undefined ? [] : _canonicalURL$link;

      var _canonicalURL$link2 = (0, _slicedToArray3.default)(_canonicalURL$link, 1),
          _canonicalURL$link2$ = _canonicalURL$link2[0];

      _canonicalURL$link2$ = _canonicalURL$link2$ === undefined ? {} : _canonicalURL$link2$;
      var _canonicalURL$link2$$ = _canonicalURL$link2$.href,
          url = _canonicalURL$link2$$ === undefined ? '' : _canonicalURL$link2$$;


      var courseList = [];

      if (meetings === null || meetings === undefined) {
        return _react2.default.createElement(
          'div',
          { className: 'gh-racing-racecards' },
          'Failed to load results.'
        );
      }

      meetings.forEach(function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$meeting_summary$ = _ref.meeting_summary.course;

        _ref$meeting_summary$ = _ref$meeting_summary$ === undefined ? {} : _ref$meeting_summary$;
        var _ref$meeting_summary$2 = _ref$meeting_summary$.name,
            name = _ref$meeting_summary$2 === undefined ? '' : _ref$meeting_summary$2;
        return courseList.push(name);
      });

      var helmetProps = (0, _extends3.default)({
        title: title
      }, (0, _seoUtils.metaDescription)('Racecards, form, betting and tips for meetings at ' + courseList));

      return _react2.default.createElement(
        'div',
        { className: 'gh-racing-racecards' },
        _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
        _react2.default.createElement(_JsonLD2.default, { data: {
            "@id": url,
            "@type": "WebPage",
            breadcrumb: {
              "@type": "BreadcrumbList",
              itemListElement: [{
                "@type": "ListItem",
                position: 1,
                item: {
                  "@type": "WebSite",
                  "@id": "https://www.sportinglife.com",
                  name: "Sporting Life"
                }
              }, {
                "@type": "ListItem",
                position: 2,
                item: {
                  "@id": "https://www.sportinglife.com/greyhounds",
                  name: "Greyhounds"
                }
              }, {
                "@type": "ListItem",
                position: 3,
                item: {
                  "@id": url,
                  name: "Race Cards"
                }
              }]
            }
          } }),
        _react2.default.createElement(
          'div',
          { className: 'gh-racing-racecards-header-container' },
          _react2.default.createElement(
            'h1',
            { className: 'page-main-title' },
            title
          )
        ),
        _react2.default.createElement(
          'section',
          { className: 'gh-racing-content' },
          meetings && meetings.length > 0 ? _react2.default.createElement(
            'ul',
            { className: 'meetings' },
            meetings.map(function (meeting) {
              return _react2.default.createElement(
                'li',
                { key: meeting.meeting_summary.meeting_reference.id },
                _react2.default.createElement(_GreyhoundRacingRacecardsMeetingSummary2.default, {
                  meeting: meeting,
                  date: racecardsDate,
                  dateIncrement: _this2.props.dateIncrement })
              );
            })
          ) : _react2.default.createElement(
            'div',
            { className: 'gh-racing-racecards-none' },
            _react2.default.createElement(
              'p',
              null,
              'No meetings found'
            )
          )
        )
      );
    }
  }]);
  return RacecardsForDate;
}(_react.Component), _class.propTypes = {
  date: _propTypes2.default.string,
  dateIncrement: _propTypes2.default.number,
  meetingsByDate: _propTypes2.default.object.isRequired,
  raceType: _propTypes2.default.string,
  routes: _propTypes2.default.array.isRequired
}, _temp);
exports.default = RacecardsForDate;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _LocalDateTimeHelper = __webpack_require__(13);

var _seoUtils = __webpack_require__(23);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _Tabs = __webpack_require__(70);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _GreyhoundRacingRacecardsMeetingSummary = __webpack_require__(392);

var _GreyhoundRacingRacecardsMeetingSummary2 = _interopRequireDefault(_GreyhoundRacingRacecardsMeetingSummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GreyhoundRacingResultsForDate = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GreyhoundRacingResultsForDate, _Component);

  function GreyhoundRacingResultsForDate() {
    (0, _classCallCheck3.default)(this, GreyhoundRacingResultsForDate);
    return (0, _possibleConstructorReturn3.default)(this, (GreyhoundRacingResultsForDate.__proto__ || (0, _getPrototypeOf2.default)(GreyhoundRacingResultsForDate)).apply(this, arguments));
  }

  (0, _createClass3.default)(GreyhoundRacingResultsForDate, [{
    key: 'render',
    value: function render() {
      var title;
      var convertToday = true;
      var convertYesterday = true;

      var cardDate = this.props.date;
      // build the date navigation array
      var dateNav = [],
          date = new Date();
      for (var i = 0; i < 7; i++) {
        var urlPart = (0, _LocalDateTimeHelper.getRelativeDayURI)(date, 0, { convertToday: convertToday, convertYesterday: convertYesterday });
        var rawURLPart = (0, _LocalDateTimeHelper.getRelativeDayURI)(date, 0, { convertToday: false, convertYesterday: false });
        var alternatives = [];
        if (urlPart != rawURLPart) {
          alternatives = [{ href: '/greyhounds/results' + rawURLPart, isIndex: (0, _LocalDateTimeHelper.isToday)(date) }];
        }
        dateNav.push({ href: '/greyhounds/results' + urlPart,
          text: (0, _LocalDateTimeHelper.localDateShort)(date, { convertToday: convertToday, convertYesterday: convertYesterday }),
          isIndex: (0, _LocalDateTimeHelper.isToday)(date),
          alternatives: alternatives
        });
        date.setDate(date.getDate() - 1);
      }

      var racecardsDate = cardDate ? (0, _LocalDateTimeHelper.isoDate)(cardDate) : (0, _LocalDateTimeHelper.isoDate)(new Date()),
          meetings = this.props.meetingsByDate[racecardsDate].meetings;

      if ((0, _LocalDateTimeHelper.isToday)(racecardsDate)) {
        title = 'Today\'s Results';
      } else if ((0, _LocalDateTimeHelper.isYesterday)(racecardsDate)) {
        title = 'Yesterday\'s Results';
      } else {
        title = (0, _LocalDateTimeHelper.localFullDateLong)(racecardsDate) + ' Results';
      }

      var _canonicalLink = (0, _seoUtils.canonicalLink)(this.props.routes, { date: (0, _LocalDateTimeHelper.getRelativeDay)(racecardsDate, 0, { convertToday: convertToday, convertYesterday: convertYesterday }) }),
          _canonicalLink$link = _canonicalLink.link,
          link = _canonicalLink$link === undefined ? [] : _canonicalLink$link;

      if (!(0, _LocalDateTimeHelper.isToday)(racecardsDate)) {
        link.push({
          rel: "next",
          href: _config2.default.canonicalBase + '/greyhounds/results' + (0, _LocalDateTimeHelper.getRelativeDayURI)(cardDate, 1, { convertToday: convertToday, convertYesterday: convertYesterday })
        });
      }

      link.push({
        rel: "prev",
        href: _config2.default.canonicalBase + '/greyhounds/results' + (0, _LocalDateTimeHelper.getRelativeDayURI)(cardDate, -1, { convertToday: convertToday, convertYesterday: convertYesterday })
      });

      var helmetProps = {
        link: link
      };

      return _react2.default.createElement(
        'div',
        { className: 'gh-racing-racecards' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: title, helmetProps: helmetProps }),
        _react2.default.createElement(
          'div',
          { className: 'gh-racing-racecards-header-container' },
          _react2.default.createElement(
            'h1',
            { className: 'page-main-title' },
            title
          ),
          _react2.default.createElement(_Tabs2.default, { tabs: dateNav })
        ),
        _react2.default.createElement(
          'section',
          { className: 'gh-racing-content' },
          meetings && meetings.length > 0 ? _react2.default.createElement(
            'ul',
            { className: 'meetings' },
            meetings.map(function (meeting) {
              return _react2.default.createElement(
                'li',
                { key: meeting.meeting_summary.meeting_reference.id },
                _react2.default.createElement(_GreyhoundRacingRacecardsMeetingSummary2.default, { meeting: meeting, date: racecardsDate, dateIncrement: -1 })
              );
            })
          ) : _react2.default.createElement(
            'div',
            { className: 'gh-racing-racecards-none' },
            _react2.default.createElement(
              'p',
              null,
              'No meetings found'
            )
          )
        )
      );
    }
  }]);
  return GreyhoundRacingResultsForDate;
}(_react.Component), _class.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  date: _propTypes2.default.string,
  meetingsByDate: _propTypes2.default.object.isRequired,
  raceType: _propTypes2.default.string
}, _temp);
exports.default = GreyhoundRacingResultsForDate;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _fastResults = __webpack_require__(394);

var _GreyhoundRacingFastResultsList = __webpack_require__(873);

var _GreyhoundRacingFastResultsList2 = _interopRequireDefault(_GreyhoundRacingFastResultsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFRESH_INTERVAL_MILLIS = 5000;

var GreyhoundRacingFastResults = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch() {
    return (0, _fastResults.load)();
  },
  preventResolve: function preventResolve(_ref) {
    var state = _ref.state;
    return (0, _fastResults.isLoading)(state);
  },
  refreshInterval: REFRESH_INTERVAL_MILLIS,
  state: function state(_state) {
    return { fastResults: _state.greyhoundRacing.fastResults };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GreyhoundRacingFastResults, _Component);

  function GreyhoundRacingFastResults() {
    (0, _classCallCheck3.default)(this, GreyhoundRacingFastResults);
    return (0, _possibleConstructorReturn3.default)(this, (GreyhoundRacingFastResults.__proto__ || (0, _getPrototypeOf2.default)(GreyhoundRacingFastResults)).apply(this, arguments));
  }

  (0, _createClass3.default)(GreyhoundRacingFastResults, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_GreyhoundRacingFastResultsList2.default, { fastResults: this.props.fastResults });
    }
  }]);
  return GreyhoundRacingFastResults;
}(_react.Component), _class2.propTypes = {
  fastResults: _propTypes2.default.shape({
    fastResults: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      race_reference: _propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired
      }).isRequired
    })).isRequired
  }),
  dispatch: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class);
exports.default = GreyhoundRacingFastResults;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _seoUtils = __webpack_require__(23);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GreyhoundRacingFastResultsPage = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GreyhoundRacingFastResultsPage, _Component);

  function GreyhoundRacingFastResultsPage() {
    (0, _classCallCheck3.default)(this, GreyhoundRacingFastResultsPage);
    return (0, _possibleConstructorReturn3.default)(this, (GreyhoundRacingFastResultsPage.__proto__ || (0, _getPrototypeOf2.default)(GreyhoundRacingFastResultsPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(GreyhoundRacingFastResultsPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          GreyhoundRacingFastResults = _props.GreyhoundRacingFastResults;


      var metaDescriptionValue = "The latest Greyhound results as they happen from Sporting Life's Fast Results service";

      return _react2.default.createElement(
        'div',
        { className: 'GreyhoundRacingResults' },
        _react2.default.createElement(
          _StandardPage.StandardPage,
          { sport: 'greyhounds', title: 'Fast Results', helmetProps: (0, _extends3.default)({}, (0, _seoUtils.metaDescription)(metaDescriptionValue)) },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-left-column' },
            GreyhoundRacingFastResults
          ),
          _react2.default.createElement(_RightColumn.RightColumn, { location: location,
            sport: 'greyhounds',
            content: ["topMpu", "ocWidget", "racingTips", "bottomMpu", "horseRacingNextRaceOff", "footballTips"] })
        )
      );
    }
  }]);
  return GreyhoundRacingFastResultsPage;
}(_react.Component), _class2.propTypes = {
  GreyhoundRacingFastResults: _propTypes2.default.element.isRequired,
  location: _propTypes2.default.object.isRequired
}, _temp)) || _class;

exports.default = GreyhoundRacingFastResultsPage;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _seoUtils = __webpack_require__(23);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GreyhoundRacingHomePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GreyhoundRacingHomePage, _Component);

  function GreyhoundRacingHomePage() {
    (0, _classCallCheck3.default)(this, GreyhoundRacingHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (GreyhoundRacingHomePage.__proto__ || (0, _getPrototypeOf2.default)(GreyhoundRacingHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(GreyhoundRacingHomePage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: 'greyhounds',
        title: 'Greyhound News | Results & Racecards',
        location: location,
        helmetProps: { titleTemplate: _seoUtils.titleTemplate.plain },
        rightColumnContent: ["mostReadAll", "topMpu", "ocWidget", "racingTips", "horseRacingNextRaceOff", "footballTips"]
      });
    }
  }]);
  return GreyhoundRacingHomePage;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object
}, _temp);
exports.default = GreyhoundRacingHomePage;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _race = __webpack_require__(396);

var _meetings = __webpack_require__(212);

var _meeting = __webpack_require__(395);

var _LocalDateTimeHelper = __webpack_require__(13);

var _GreyhoundRacingRacePage = __webpack_require__(875);

var _GreyhoundRacingRacePage2 = _interopRequireDefault(_GreyhoundRacingRacePage);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _consts = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFRESH_INTERVAL_MILLIS = 15000;

var GreyhoundRacingRacecardContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{ // this race
  dispatch: function dispatch(_ref) {
    var raceId = _ref.params.raceId;
    return (0, _race.load)(raceId);
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state,
        raceId = _ref2.params.raceId;
    return (0, _race.isLoading)(state, raceId);
  },
  state: function state(_state) {
    return { race: _state.greyhoundRacing.race || {} };
  }
}, { // meetings for this date
  dispatch: function dispatch(_ref3) {
    var _ref3$params$date = _ref3.params.date,
        date = _ref3$params$date === undefined ? (0, _LocalDateTimeHelper.getTodaysDate)("YYYY-MM-DD") : _ref3$params$date;
    return (0, _meetings.load)(date);
  },
  preventResolve: function preventResolve(_ref4) {
    var state = _ref4.state,
        _ref4$params$date = _ref4.params.date,
        date = _ref4$params$date === undefined ? (0, _LocalDateTimeHelper.getTodaysDate)("YYYY-MM-DD") : _ref4$params$date;
    return (0, _meetings.isLoading)(state, date);
  },
  state: function state(_state2) {
    return { meetingsByDate: (0, _meetings.get)(_state2) };
  }
}, { // meeting for this race
  dispatch: function dispatch(_ref5) {
    var raceId = _ref5.params.raceId;
    return (0, _meeting.loadMeetingByRaceId)(raceId);
  },
  preventResolve: function preventResolve(_ref6) {
    var state = _ref6.state,
        raceId = _ref6.params.raceId;
    return (0, _meeting.isMeetingLoading)(state, raceId);
  },
  state: function state(_state3) {
    return { meeting: _state3.greyhoundRacing.meeting || {} };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GreyhoundRacingRacecardContainer, _Component);

  function GreyhoundRacingRacecardContainer() {
    (0, _classCallCheck3.default)(this, GreyhoundRacingRacecardContainer);
    return (0, _possibleConstructorReturn3.default)(this, (GreyhoundRacingRacecardContainer.__proto__ || (0, _getPrototypeOf2.default)(GreyhoundRacingRacecardContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(GreyhoundRacingRacecardContainer, [{
    key: 'raceIsFinished',
    value: function raceIsFinished() {
      return _consts.GREYHOUND_RACE_COMPLETE_STATUSES.includes(this.props.race.race.race_summary.race_stage);
    }
  }, {
    key: 'hasMatchingRaceIds',
    value: function hasMatchingRaceIds() {
      var stateRaceId = _lodash2.default.get(this.props, "race.race.race_summary.race_summary_reference.id");
      var currentRaceId = _lodash2.default.get(this.props, "params.raceId");

      return '' + stateRaceId === currentRaceId;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.raceIsFinished()) {
        this.interval = setInterval(function () {
          _this2.props.dispatch((0, _race.load)(_this2.props.race.race.race_summary.race_summary_reference.id));
          if (_this2.raceIsFinished() && _this2.interval) {
            clearInterval(_this2.interval);
          }
        }, REFRESH_INTERVAL_MILLIS);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }, {
    key: 'render',
    value: function render() {

      // If we have an error and we dont have race data or the race ID we are 
      // viewing doesnt match whats in state then show the error
      if (this.props.race.error && (!this.props.race.race || !this.hasMatchingRaceIds())) {
        var errorPixelSrc = '/1x1.gif?type=horseracing-racecard&id=0&cb=' + Date.now();

        return _react2.default.createElement(
          'div',
          { className: 'hr-racing-racecards' },
          _react2.default.createElement(
            'p',
            { className: 'hr-racing-racecards-error-message' },
            'There has been a problem displaying this race.'
          ),
          _react2.default.createElement('img', { src: errorPixelSrc, width: '1', height: '1' })
        );
      }

      return _react2.default.createElement(_GreyhoundRacingRacePage2.default, {
        routes: this.props.routes,
        race: this.props.race.race,
        meetings: this.props.meetingsByDate[this.props.params.date],
        meeting: this.props.meeting,
        children: this.props.children
      });
    }
  }]);
  return GreyhoundRacingRacecardContainer;
}(_react.Component), _class2.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  // supplied by react-router via @connect
  params: _propTypes2.default.shape({
    date: _propTypes2.default.string
  }),
  meeting: _propTypes2.default.object,
  meetingsByDate: _propTypes2.default.object,
  race: _propTypes2.default.object,
  dispatch: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node
}, _temp)) || _class) || _class);
exports.default = GreyhoundRacingRacecardContainer;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RightColumn = __webpack_require__(21);

var _StandardPage = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GreyhoundRacingRacecards = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GreyhoundRacingRacecards, _Component);

  function GreyhoundRacingRacecards() {
    (0, _classCallCheck3.default)(this, GreyhoundRacingRacecards);
    return (0, _possibleConstructorReturn3.default)(this, (GreyhoundRacingRacecards.__proto__ || (0, _getPrototypeOf2.default)(GreyhoundRacingRacecards)).apply(this, arguments));
  }

  (0, _createClass3.default)(GreyhoundRacingRacecards, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          GreyhoundRacingRacecardsForDateContainer = _props.GreyhoundRacingRacecardsForDateContainer,
          GreyhoundRacingRacePageContainer = _props.GreyhoundRacingRacePageContainer;


      return _react2.default.createElement(
        'div',
        { className: 'greyhound-racing-racecards' },
        _react2.default.createElement(
          _StandardPage.StandardPage,
          { sport: 'greyhounds', title: 'Greyhounds racecards' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-left-column' },
            GreyhoundRacingRacecardsForDateContainer || GreyhoundRacingRacePageContainer
          ),
          _react2.default.createElement(_RightColumn.RightColumn, { location: location,
            sport: 'greyhounds',
            content: ["topMpu", "ocWidget", "racingTips", "bottomMpu", "horseRacingNextRaceOff", "footballTips"] })
        )
      );
    }
  }]);
  return GreyhoundRacingRacecards;
}(_react.Component), _class.propTypes = {
  GreyhoundRacingRacecardsForDateContainer: _propTypes2.default.element,
  GreyhoundRacingRacePageContainer: _propTypes2.default.element,
  location: _propTypes2.default.object.isRequired
}, _temp);
exports.default = GreyhoundRacingRacecards;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _LocalDateTimeHelper = __webpack_require__(13);

var _meetings = __webpack_require__(212);

var _GreyhoundRacingRacecardsForDate = __webpack_require__(882);

var _GreyhoundRacingRacecardsForDate2 = _interopRequireDefault(_GreyhoundRacingRacecardsForDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFRESH_INTERVAL_MILLIS = 10000;

var GreyhoundRacingRacecardsForDateContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var _ref$params$date = _ref.params.date,
        date = _ref$params$date === undefined ? (0, _LocalDateTimeHelper.getTodaysDate)("YYYY-MM-DD") : _ref$params$date;
    return (0, _meetings.load)(date);
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state,
        _ref2$params$date = _ref2.params.date,
        date = _ref2$params$date === undefined ? (0, _LocalDateTimeHelper.getTodaysDate)("YYYY-MM-DD") : _ref2$params$date;
    return (0, _meetings.isLoading)(state, date);
  },
  refreshInterval: REFRESH_INTERVAL_MILLIS,
  state: function state(_state) {
    return { meetingsByDate: (0, _meetings.get)(_state) };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GreyhoundRacingRacecardsForDateContainer, _Component);

  function GreyhoundRacingRacecardsForDateContainer() {
    (0, _classCallCheck3.default)(this, GreyhoundRacingRacecardsForDateContainer);
    return (0, _possibleConstructorReturn3.default)(this, (GreyhoundRacingRacecardsForDateContainer.__proto__ || (0, _getPrototypeOf2.default)(GreyhoundRacingRacecardsForDateContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(GreyhoundRacingRacecardsForDateContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_GreyhoundRacingRacecardsForDate2.default, {
        date: this.props.params.date,
        dateIncrement: 1,
        meetingsByDate: this.props.meetingsByDate,
        routes: this.props.routes,
        raceType: 'Greyhounds' });
    }
  }]);
  return GreyhoundRacingRacecardsForDateContainer;
}(_react.Component), _class2.propTypes = {
  // supplied by react-router via @connect
  params: _propTypes2.default.shape({
    date: _propTypes2.default.string
  }),
  meetingsByDate: _propTypes2.default.object.isRequired,
  routes: _propTypes2.default.array.isRequired
}, _temp)) || _class) || _class);
exports.default = GreyhoundRacingRacecardsForDateContainer;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GreyhoundRacingResults = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(GreyhoundRacingResults, _Component);

  function GreyhoundRacingResults() {
    (0, _classCallCheck3.default)(this, GreyhoundRacingResults);
    return (0, _possibleConstructorReturn3.default)(this, (GreyhoundRacingResults.__proto__ || (0, _getPrototypeOf2.default)(GreyhoundRacingResults)).apply(this, arguments));
  }

  (0, _createClass3.default)(GreyhoundRacingResults, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          GreyhoundRacingResultsForDateContainer = _props.GreyhoundRacingResultsForDateContainer;


      return _react2.default.createElement(
        'div',
        { className: 'GreyhoundRacingResults' },
        _react2.default.createElement(
          _StandardPage.StandardPage,
          { sport: 'greyhounds', title: 'Greyhounds results' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-left-column' },
            GreyhoundRacingResultsForDateContainer
          ),
          _react2.default.createElement(_RightColumn.RightColumn, { location: location,
            sport: 'greyhounds',
            content: ["topMpu", "ocWidget", "racingTips", "bottomMpu", "horseRacingNextRaceOff", "footballTips"] })
        )
      );
    }
  }]);
  return GreyhoundRacingResults;
}(_react.Component), _class.propTypes = {
  GreyhoundRacingResultsForDateContainer: _propTypes2.default.element.isRequired,
  location: _propTypes2.default.object.isRequired
}, _temp);
exports.default = GreyhoundRacingResults;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _LocalDateTimeHelper = __webpack_require__(13);

var _meetings = __webpack_require__(212);

var _GreyhoundRacingResultsForDate = __webpack_require__(883);

var _GreyhoundRacingResultsForDate2 = _interopRequireDefault(_GreyhoundRacingResultsForDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFRESH_INTERVAL_MILLIS = 10000;

function convertDate(date) {
  if (date == 'yesterday') {
    date = (0, _LocalDateTimeHelper.getYesterdaysDate)("YYYY-MM-DD");
  }
  return date;
}

var GreyhoundRacingResultsForDateContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var _ref$params$date = _ref.params.date,
        date = _ref$params$date === undefined ? (0, _LocalDateTimeHelper.getTodaysDate)("YYYY-MM-DD") : _ref$params$date;
    return (0, _meetings.load)(convertDate(date));
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state,
        _ref2$params$date = _ref2.params.date,
        date = _ref2$params$date === undefined ? (0, _LocalDateTimeHelper.getTodaysDate)("YYYY-MM-DD") : _ref2$params$date;
    return (0, _meetings.isLoading)(state, convertDate(date));
  },
  refreshInterval: REFRESH_INTERVAL_MILLIS,
  state: function state(_state) {
    return { meetingsByDate: (0, _meetings.get)(_state) };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GreyhoundRacingResultsForDateContainer, _Component);

  function GreyhoundRacingResultsForDateContainer() {
    (0, _classCallCheck3.default)(this, GreyhoundRacingResultsForDateContainer);
    return (0, _possibleConstructorReturn3.default)(this, (GreyhoundRacingResultsForDateContainer.__proto__ || (0, _getPrototypeOf2.default)(GreyhoundRacingResultsForDateContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(GreyhoundRacingResultsForDateContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_GreyhoundRacingResultsForDate2.default, {
        routes: this.props.routes,
        date: convertDate(this.props.params.date),
        meetingsByDate: this.props.meetingsByDate,
        raceType: 'Greyhounds' });
    }
  }]);
  return GreyhoundRacingResultsForDateContainer;
}(_react.Component), _class2.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  // supplied by react-router via @connect
  params: _propTypes2.default.shape({
    date: _propTypes2.default.string
  }),
  meetingsByDate: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class);
exports.default = GreyhoundRacingResultsForDateContainer;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layoutUtils = __webpack_require__(176);

var _GptProperties = __webpack_require__(51);

var leaderboardAd = {
  view: 'greyhounds'
};

var topMPU = {
  component: 'GooglePublisherTag',
  props: _GptProperties.topMPUProps,
  desktopColumn: 'right',
  desktopOrder: 1,
  handheldOrder: false
};

var bottomMPU = {
  component: 'GooglePublisherTag',
  props: _GptProperties.bottomMPUProps,
  desktopColumn: 'right',
  desktopOrder: 8,
  handheldOrder: false
};

var advertMPU = {
  component: 'AdvertWrapper',
  props: {
    ocSlot: ["greyhounds", "mpu"],
    additionalProperties: {
      view: 'greyhounds'
    }
  },
  desktopColumn: 'right',
  desktopOrder: 2,
  handheldOrder: false
};

var mostRead = {
  component: "MostReadAll",
  desktopColumn: "right",
  desktopOrder: 1,
  handheldOrder: 3
};

var greyhoundRHSComponents = [{
  component: 'RacingTips',
  props: {
    plainTitle: true
  },
  desktopColumn: 'right',
  desktopOrder: 4,
  handheldOrder: false
}, {
  component: 'HorseRacingNextRaceOff',
  props: {
    plainTitle: true
  },
  desktopColumn: 'right',
  desktopOrder: 5,
  handheldOrder: false
}, {
  component: 'FootballTips',
  props: {
    plainTitle: true
  },
  desktopColumn: 'right',
  desktopOrder: 7,
  handheldOrder: false
}];

var withAdverts = function withAdverts() {
  for (var _len = arguments.length, components = Array(_len), _key = 0; _key < _len; _key++) {
    components[_key] = arguments[_key];
  }

  return {
    bannerAd: _GptProperties.bannerAd,
    leaderboardAd: leaderboardAd,
    components: [topMPU, advertMPU, bottomMPU].concat(components, greyhoundRHSComponents)
  };
};

var withAdvertsAndMostRead = function withAdvertsAndMostRead() {
  for (var _len2 = arguments.length, components = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    components[_key2] = arguments[_key2];
  }

  return {
    bannerAd: _GptProperties.bannerAd,
    leaderboardAd: leaderboardAd,
    components: [mostRead, topMPU, advertMPU, bottomMPU].concat(components, greyhoundRHSComponents)
  };
};

var withAdvertsArticle = function withAdvertsArticle() {
  for (var _len3 = arguments.length, components = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    components[_key3] = arguments[_key3];
  }

  return {
    leaderboardAd: leaderboardAd,
    components: [mostRead, topMPU, advertMPU, bottomMPU].concat(components, greyhoundRHSComponents)
  };
};

var withoutAdvertsArticle = function withoutAdvertsArticle() {
  for (var _len4 = arguments.length, components = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    components[_key4] = arguments[_key4];
  }

  return {
    components: [mostRead].concat(components, greyhoundRHSComponents)
  };
};

var greyhoundRacingHomePageLayout = withAdvertsAndMostRead({
  component: 'MoreNews',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
}, {
  component: 'GptAdvert',
  props: {
    ocDetails: {
      ocSlot: ['greyhounds', 'leaderboard']
    },
    performDetails: _GptProperties.singleBottomMPUProps
  },
  desktopColumn: 'left',
  desktopOrder: 2,
  handheldOrder: 2
});

var greyhoundRacingRacecardsLayout = withAdverts({
  component: 'GreyhoundRacingRacecardsForDateContainer',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

var greyhoundRacingRaceLayout = withAdverts({
  component: 'GreyhoundRacingRacePageContainer',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

var greyhoundRacingResultsLayout = withAdverts({
  component: 'GreyhoundRacingResultsForDateContainer',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

var greyhoundRacingFastResultsLayout = withAdverts({
  component: 'GreyhoundRacingFastResults',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
});

var article = {
  component: 'Article',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
};
var greyhoundArticleLayout = withAdvertsArticle(article);
var greyhoundArticleSensitiveLayout = withoutAdvertsArticle(article);

exports.default = {
  '/greyhounds': greyhoundRacingHomePageLayout,
  '/greyhounds/racecards': greyhoundRacingRacecardsLayout,
  '/greyhounds/racecards/:date/:courseSlug': greyhoundRacingRaceLayout,
  '/greyhounds/racecards/:date/:courseSlug/racecard/:raceId': greyhoundRacingRaceLayout,
  '/greyhounds/fast-results': greyhoundRacingFastResultsLayout,
  '/greyhounds/results': greyhoundRacingResultsLayout,
  '/greyhounds/results/:date': greyhoundRacingResultsLayout,
  '/greyhounds/news/:title/:articleId': function greyhoundsNewsTitleArticleId(layout) {
    return (0, _layoutUtils.articleSensitivityLayout)(layout, greyhoundArticleLayout, greyhoundArticleSensitiveLayout);
  }
};

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GreyhoundRacingNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "Greyhounds",
    links: [{ href: "/greyhounds", text: "News", isIndex: true }, { href: "/greyhounds/racecards", text: "Racecards" }, { href: "/greyhounds/fast-results", text: "Fast Results" }, { href: "/greyhounds/results", text: "Full Results" }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

GreyhoundRacingNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = GreyhoundRacingNav;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoading = isLoading;
exports.load = load;
exports.get = get;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'greyhound-racing/greyhound/LOAD';
var LOAD_SUCCESS = 'greyhound-racing/greyhound/LOAD_SUCCESS';
var LOAD_FAIL = 'greyhound-racing/greyhound/LOAD_FAIL';

var initialState = {};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        greyhound: action.result[0]
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoading(globalState) {
  return globalState.greyhoundRacing && globalState.greyhoundRacing.greyhound && globalState.greyhoundRacing.greyhound.loading;
}

function load(name) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(client) {
      return client.get('' + _config2.default.api.greyhoundRacing.loadGreyhound, {
        params: {
          name: name
        }
      });
    }
  };
}

function get(state) {
  return state.greyhoundRacing.greyhound.greyhound;
}

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(112);

var _meeting = __webpack_require__(395);

var _meeting2 = _interopRequireDefault(_meeting);

var _meetings = __webpack_require__(212);

var _meetings2 = _interopRequireDefault(_meetings);

var _greyhound = __webpack_require__(894);

var _greyhound2 = _interopRequireDefault(_greyhound);

var _race = __webpack_require__(396);

var _race2 = _interopRequireDefault(_race);

var _fastResults = __webpack_require__(394);

var _fastResults2 = _interopRequireDefault(_fastResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  meeting: _meeting2.default,
  meetings: _meetings2.default,
  greyhound: _greyhound2.default,
  race: _race2.default,
  fastResults: _fastResults2.default
});

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _GreyhoundRacingHomePage = __webpack_require__(886);

var _GreyhoundRacingHomePage2 = _interopRequireDefault(_GreyhoundRacingHomePage);

var _GreyhoundRacingRacecards = __webpack_require__(888);

var _GreyhoundRacingRacecards2 = _interopRequireDefault(_GreyhoundRacingRacecards);

var _GreyhoundRacingRacePageContainer = __webpack_require__(887);

var _GreyhoundRacingRacePageContainer2 = _interopRequireDefault(_GreyhoundRacingRacePageContainer);

var _GreyhoundRacingRacecardsForDateContainer = __webpack_require__(889);

var _GreyhoundRacingRacecardsForDateContainer2 = _interopRequireDefault(_GreyhoundRacingRacecardsForDateContainer);

var _GreyhoundRacingResultsForDateContainer = __webpack_require__(891);

var _GreyhoundRacingResultsForDateContainer2 = _interopRequireDefault(_GreyhoundRacingResultsForDateContainer);

var _GreyhoundRacingFastResultsPage = __webpack_require__(885);

var _GreyhoundRacingFastResultsPage2 = _interopRequireDefault(_GreyhoundRacingFastResultsPage);

var _GreyhoundRacingFastResults = __webpack_require__(884);

var _GreyhoundRacingFastResults2 = _interopRequireDefault(_GreyhoundRacingFastResults);

var _GreyhoundRacingResults = __webpack_require__(890);

var _GreyhoundRacingResults2 = _interopRequireDefault(_GreyhoundRacingResults);

var _GreyhoundRacingBase = __webpack_require__(871);

var _GreyhoundRacingBase2 = _interopRequireDefault(_GreyhoundRacingBase);

var _GreyhoundRacingRacecardPage = __webpack_require__(877);

var _GreyhoundRacingRacecardPage2 = _interopRequireDefault(_GreyhoundRacingRacecardPage);

var _ArticleContainer = __webpack_require__(216);

var _ArticleContainer2 = _interopRequireDefault(_ArticleContainer);

var _Article = __webpack_require__(173);

var _Article2 = _interopRequireDefault(_Article);

var _MoreNews = __webpack_require__(93);

var _MoreNews2 = _interopRequireDefault(_MoreNews);

var _MostReadAll = __webpack_require__(141);

var _MostReadAll2 = _interopRequireDefault(_MostReadAll);

var _SectionLink = __webpack_require__(202);

var _SectionLink2 = _interopRequireDefault(_SectionLink);

var _RacingTips = __webpack_require__(116);

var _RacingTips2 = _interopRequireDefault(_RacingTips);

var _FootballTips = __webpack_require__(140);

var _FootballTips2 = _interopRequireDefault(_FootballTips);

var _HorseRacingNextRaceOff = __webpack_require__(115);

var _HorseRacingNextRaceOff2 = _interopRequireDefault(_HorseRacingNextRaceOff);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _GptAdvert = __webpack_require__(101);

var _GptAdvert2 = _interopRequireDefault(_GptAdvert);

var _GooglePublisherTag = __webpack_require__(71);

var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);

var _GreyhoundRacingNav = __webpack_require__(893);

var _GreyhoundRacingNav2 = _interopRequireDefault(_GreyhoundRacingNav);

var _sitemapHelper = __webpack_require__(217);

var _sitemapHelper2 = __webpack_require__(897);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GreyhoundsRHSComponents = {
  MostReadAll: _MostReadAll2.default,
  SectionLink: _SectionLink2.default,
  RacingTips: _RacingTips2.default,
  FootballTips: _FootballTips2.default,
  HorseRacingNextRaceOff: _HorseRacingNextRaceOff2.default,
  AdvertWrapper: _AdvertWrapper2.default,
  GptAdvert: _GptAdvert2.default,
  GooglePublisherTag: _GooglePublisherTag2.default
};

var GreyhoundsRHSComponentsWithMostRead = (0, _extends3.default)({
  MostReadAll: _MostReadAll2.default
}, GreyhoundsRHSComponents);

var greyhoundRacingRoutes = _react2.default.createElement(
  _reactRouter.Route,
  { path: 'greyhounds', component: _GreyhoundRacingBase2.default, subnav: _GreyhoundRacingNav2.default },
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _GreyhoundRacingHomePage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: (0, _extends3.default)({ MoreNews: _MoreNews2.default }, GreyhoundsRHSComponentsWithMostRead) })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'racecards', component: _GreyhoundRacingRacecards2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { components: (0, _extends3.default)({ GreyhoundRacingRacecardsForDateContainer: _GreyhoundRacingRacecardsForDateContainer2.default }, GreyhoundsRHSComponents) }),
    ' ',
    _react2.default.createElement(
      _reactRouter.Route,
      { path: ':date/:courseSlug', components: (0, _extends3.default)({ GreyhoundRacingRacePageContainer: _GreyhoundRacingRacePageContainer2.default }, GreyhoundsRHSComponents) },
      ' ',
      _react2.default.createElement(_reactRouter.Route, { path: 'racecard/:raceId', sitemap: { changefreq: "always", priority: 0.5, expand: _sitemapHelper2.racecardExpander }, component: _GreyhoundRacingRacecardPage2.default })
    )
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'fast-results', component: _GreyhoundRacingFastResultsPage2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: (0, _extends3.default)({ GreyhoundRacingFastResults: _GreyhoundRacingFastResults2.default }, GreyhoundsRHSComponents) })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'results', component: _GreyhoundRacingResults2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: (0, _extends3.default)({ GreyhoundRacingResultsForDateContainer: _GreyhoundRacingResultsForDateContainer2.default }, GreyhoundsRHSComponents) }),
    ' ',
    _react2.default.createElement(_reactRouter.Route, { path: ':date', sitemap: { expand: _sitemapHelper2.resultsDateExpander }, components: (0, _extends3.default)({ GreyhoundRacingResultsForDateContainer: _GreyhoundRacingResultsForDateContainer2.default }, GreyhoundsRHSComponents) }),
    ' '
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'news/:title/:articleId',
      component: _ArticleContainer2.default,
      sport: 'greyhounds',
      rightHandContent: ['mostReadAll', 'topMpu', 'ocWidget', 'racingTips', 'horseRacingNextRaceOff', 'footballTips', 'bottomMpu'] },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: { expand: (0, _sitemapHelper.newsArticleExpander)("greyhounds") }, components: (0, _extends3.default)({ Article: _Article2.default }, GreyhoundsRHSComponentsWithMostRead) }),
    ' '
  )
);

exports.default = greyhoundRacingRoutes;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(146);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

exports.resultsDateExpander = resultsDateExpander;
exports.racecardExpander = racecardExpander;

var _momentTimezone = __webpack_require__(241);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _logger = __webpack_require__(198);

var _logger2 = _interopRequireDefault(_logger);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _ApiClient = __webpack_require__(64);

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _utils = __webpack_require__(18);

var _LocalDateTimeHelper = __webpack_require__(13);

var _sitemapUtils = __webpack_require__(276);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var client = new _ApiClient2.default(); /**********************************************
                                          EXPANDERS EXPLAINED:
                                        
                                          Take a route from of the sitemap generation process,
                                          return a promise for thenable routes - to be flattened when the sitemap is generated
                                        
                                        */ /////////////////////////////////////////////

function resultsDateExpander(_ref) {
  var url = _ref.url,
      _ref$sitemap = _ref.sitemap,
      changefreq = _ref$sitemap.changefreq,
      priority = _ref$sitemap.priority;

  var routeArray = [];
  var dateArray = (0, _sitemapUtils.nDayArrFactoryBackwards)();

  return new _promise2.default(function (resolve) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(dateArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var date = _step.value;

        var urlDate = (0, _LocalDateTimeHelper.getRelativeDay)(date, 0, { convertYesterday: true });
        routeArray.push({ url: url.replace(":date", urlDate), sitemap: { changefreq: changefreq, priority: priority } });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return resolve(routeArray);
  });
}

function racecardExpander(_ref2) {
  var url = _ref2.url,
      _ref2$sitemap = _ref2.sitemap,
      changefreq = _ref2$sitemap.changefreq,
      priority = _ref2$sitemap.priority;

  var routeArray = [];
  var dateArray = (0, _sitemapUtils.nDayArrFactoryBoth)();

  var promiseStack = [];

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(dateArray), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var date = _step2.value;

      // We need to presume that the provided timezone is UTC. That way it won"t be changed when valueOf converts to UTC.
      var startDate = _momentTimezone2.default.tz(date, "UTC").startOf("day");

      promiseStack.push(client.get(_config2.default.api.greyhoundRacing.loadMeetings, {
        params: {
          from: startDate.valueOf(),
          to: (0, _momentTimezone2.default)(startDate).add(1, "day").valueOf()
        }
      }).then(function (result) {
        return result;
      }).catch(function (err) {
        _logger2.default.debug(err);
        return [];
      }));
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return _promise2.default.all(promiseStack).then(function (results) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = (0, _getIterator3.default)(results), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var day = _step3.value;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = (0, _getIterator3.default)(day), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _ref4 = _step4.value;
            var meeting_summary = _ref4.meeting_summary,
                races = _ref4.races;
            var meetingDate = meeting_summary.date,
                courseName = meeting_summary.course.name;
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
              for (var _iterator5 = (0, _getIterator3.default)(races), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                var _ref6 = _step5.value;
                var raceId = _ref6.race_summary_reference.id,
                    raceDate = _ref6.date,
                    raceTime = _ref6.time,
                    raceOffTime = _ref6.off_time;

                if (meetingDate && courseName && raceId) {
                  var isInPast = raceOffTime ? (0, _LocalDateTimeHelper.isInThePast)(raceDate + "T" + raceOffTime + "Z") : (0, _LocalDateTimeHelper.isInThePast)(raceDate + "T" + raceTime + "Z");
                  routeArray.push({
                    url: url.replace(":date", meetingDate).replace(":courseSlug", (0, _utils.slugifyName)(courseName)).replace(":raceId", raceId),
                    sitemap: {
                      changefreq: changefreq,
                      priority: priority,
                      lastmodISO: isInPast ? raceOffTime ? raceDate + "T" + (0, _sitemapUtils.stripTZD)(raceOffTime) + "Z" : raceDate + "T" + (0, _sitemapUtils.stripTZD)(raceTime) + "Z" : undefined
                    }
                  });
                } else {
                  _logger2.default.debug("The following greyhound race has an issue, and won't be added to the sitemap: " + meetingDate + " " + courseName + " " + raceId);
                }
              }
            } catch (err) {
              _didIteratorError5 = true;
              _iteratorError5 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                  _iterator5.return();
                }
              } finally {
                if (_didIteratorError5) {
                  throw _iteratorError5;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    return routeArray;
  });
}

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _morenews = __webpack_require__(79);

var _media = __webpack_require__(78);

var _NewsSection = __webpack_require__(742);

var _NewsSection2 = _interopRequireDefault(_NewsSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PATH = '/columnists';

var HomeColumnists = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)("HomeColumnists", [{
  dispatch: function dispatch() {
    return (0, _morenews.load)(PATH, 3);
  },
  state: _morenews.connectMoreNews,
  then: function then(_ref) {
    var dispatch = _ref.dispatch,
        state = _ref.state,
        articles = _ref.result.articles;
    return (0, _media.loadMediaForArticles)(state, dispatch, articles);
  }
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HomeColumnists, _Component);

  function HomeColumnists() {
    (0, _classCallCheck3.default)(this, HomeColumnists);
    return (0, _possibleConstructorReturn3.default)(this, (HomeColumnists.__proto__ || (0, _getPrototypeOf2.default)(HomeColumnists)).apply(this, arguments));
  }

  (0, _createClass3.default)(HomeColumnists, [{
    key: 'render',
    value: function render() {
      var _props$news = this.props.news;
      _props$news = _props$news === undefined ? {} : _props$news;
      var _props$news$PATH = _props$news[PATH];
      _props$news$PATH = _props$news$PATH === undefined ? {} : _props$news$PATH;
      var _props$news$PATH$arti = _props$news$PATH.articles,
          newsItems = _props$news$PATH$arti === undefined ? [] : _props$news$PATH$arti;


      var componentData = {
        showHeading: true,
        showCategory: true,
        sectionLabel: "Columnists",
        expandedHeading: false,
        sectionLink: PATH,
        additionalNewsLinks: [{ text: "All Columnists", href: PATH }],
        newsItems: newsItems.slice(0, 3)
      };

      return _react2.default.createElement(_NewsSection2.default, componentData);
    }
  }]);
  return HomeColumnists;
}(_react.Component), _class2.propTypes = {
  news: _propTypes2.default.object
}, _temp)) || _class);
exports.default = HomeColumnists;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _moment = __webpack_require__(8);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _dailyMatches = __webpack_require__(209);

var _userService = __webpack_require__(44);

var _CaretLink = __webpack_require__(54);

var _CaretLink2 = _interopRequireDefault(_CaretLink);

var _FootballLiveCompetitionList = __webpack_require__(261);

var _FootballLiveCompetitionList2 = _interopRequireDefault(_FootballLiveCompetitionList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFRESH_INTERVAL_MILLIS = 10000;
var MAX_HOMEPAGE_FIXTURES = 6;

var HomeFootballLiveMatchesContainer = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)("HomeFootballLiveMatchesContainer", [{
  dispatch: function dispatch() {
    return (0, _dailyMatches.loadMatches)();
  },
  refreshInterval: REFRESH_INTERVAL_MILLIS,
  state: function state(_state) {
    return { competitions: _state.football.dailyMatches };
  }
}, (0, _userService.userServiceLayoutConnect)()]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HomeFootballLiveMatchesContainer, _Component);

  function HomeFootballLiveMatchesContainer() {
    (0, _classCallCheck3.default)(this, HomeFootballLiveMatchesContainer);
    return (0, _possibleConstructorReturn3.default)(this, (HomeFootballLiveMatchesContainer.__proto__ || (0, _getPrototypeOf2.default)(HomeFootballLiveMatchesContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(HomeFootballLiveMatchesContainer, [{
    key: 'now',
    value: function now(format) {
      return (0, _moment2.default)().format(format);
    }

    // filter supplied competition object so that the output contains at most maxMatches matches,
    // however may competitions that requires

  }, {
    key: 'filterTopCompetitions',
    value: function filterTopCompetitions(comps, maxMatches) {
      var compIds = (0, _keys2.default)(comps || {});
      var filteredComps = {};

      while (maxMatches > 0 && compIds.length) {
        var compId = compIds.shift(),
            comp = (0, _extends3.default)({}, comps[compId]);
        comp.matchList = (0, _lodash2.default)(comp.matchList).toPairs().take(maxMatches).fromPairs().value();
        var filteredMatches = _lodash2.default.size(comp.matchList);

        if (filteredMatches) {
          maxMatches -= filteredMatches;
          filteredComps[compId] = comp;
        }
      }

      return filteredComps;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'home-football-live-container' },
        _react2.default.createElement(
          'div',
          { className: 'home-football-live-heading' },
          _react2.default.createElement(
            'h3',
            null,
            'Football Fixtures'
          ),
          _react2.default.createElement(
            'h4',
            null,
            this.now("Do MMMM YYYY")
          )
        ),
        _react2.default.createElement(_FootballLiveCompetitionList2.default, { competitionList: this.filterTopCompetitions(this.props.competitions.competitions, MAX_HOMEPAGE_FIXTURES) }),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            _CaretLink2.default,
            { to: '/football/fixtures' },
            'All Football Fixtures'
          )
        )
      );
    }
  }]);
  return HomeFootballLiveMatchesContainer;
}(_react.Component), _class2.propTypes = {
  matches: _propTypes2.default.shape({
    matches: _propTypes2.default.array
  }),
  competitions: _propTypes2.default.object,
  children: _propTypes2.default.node,
  dispatch: _propTypes2.default.func.isRequired
}, _temp)) || _class);
exports.default = HomeFootballLiveMatchesContainer;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _JsonLD = __webpack_require__(164);

var _JsonLD2 = _interopRequireDefault(_JsonLD);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

var _GptProperties = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Home = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home() {
    (0, _classCallCheck3.default)(this, Home);
    return (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).apply(this, arguments));
  }

  (0, _createClass3.default)(Home, [{
    key: 'render',
    value: function render() {
      __webpack_require__(1419);
      var _props = this.props,
          location = _props.location,
          MoreNews = _props.MoreNews,
          HomeColumnists = _props.HomeColumnists,
          AdvertWrapper = _props.AdvertWrapper,
          MostReadAll = _props.MostReadAll,
          RacingTips = _props.RacingTips,
          InsiderMpu = _props.InsiderMpu,
          HorseRacingNextRaceOff = _props.HorseRacingNextRaceOff,
          FootballTips = _props.FootballTips,
          GooglePublisherTag = _props.GooglePublisherTag;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: 'racing', title: _config2.default.pageTitle.default },
        _react2.default.createElement(_JsonLD2.default, { data: {
            "@type": "WebSite",
            "@id": "https://www.sportinglife.com",
            url: "https://www.sportinglife.com",
            name: "Sporting Life",
            sameAs: ["https://www.facebook.com/SportingLifeOfficial", "https://twitter.com/SportingLife", "https://soundcloud.com/sportinglife", "https://en.wikipedia.org/wiki/Sporting_Life_(British_newspaper)", "https://www.wikidata.org/wiki/Q7579580"]
          } }),
        _react2.default.createElement(
          'div',
          { className: 'main-layout-left-column' },
          _react2.default.createElement(
            'div',
            { id: 'left-more-news', className: 'main-layout-block' },
            MoreNews
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block' },
            AdvertWrapper && _react2.default.cloneElement(AdvertWrapper, {
              ocSlot: ["homepage", "leaderboard"],
              additionalProperties: { view: "home-page" }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block main-layout-hide-desktop' },
            MostReadAll
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block main-layout-hide-desktop' },
            RacingTips
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block main-layout-hide-desktop' },
            InsiderMpu
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block main-layout-hide-desktop' },
            HorseRacingNextRaceOff
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block main-layout-hide-desktop' },
            AdvertWrapper && _react2.default.cloneElement(AdvertWrapper, {
              ocSlot: ["racing", "leaderboard"],
              additionalProperties: { view: "home-page" }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block main-layout-hide-desktop' },
            FootballTips
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block main-layout-hide-desktop' },
            AdvertWrapper && _react2.default.cloneElement(AdvertWrapper, {
              ocSlot: ["football", "leaderboard"],
              additionalProperties: { view: "home-page" }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block last-desktop' },
            HomeColumnists
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block last-handheld main-layout-hide-desktop' },
            GooglePublisherTag && _react2.default.cloneElement(GooglePublisherTag, _GptProperties.singleBottomMPUProps)
          ),
          _react2.default.createElement('div', null)
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: 'homepage',
          content: ["racingTips", "insiderMpu", "topMpu", "mostReadAll", "horseRacingNextRaceOff", "footballTips", "ocWidget", "bottomMpu"] })
      );
    }
  }]);
  return Home;
}(_react.Component), _class2.propTypes = {
  MoreNews: _propTypes2.default.element.isRequired,
  AdvertWrapper: _propTypes2.default.element.isRequired,
  HomeColumnists: _propTypes2.default.element.isRequired,
  MostReadAll: _propTypes2.default.element.isRequired,
  RacingTips: _propTypes2.default.element.isRequired,
  HorseRacingNextRaceOff: _propTypes2.default.element.isRequired,
  FootballTips: _propTypes2.default.element.isRequired,
  InsiderMpu: _propTypes2.default.element.isRequired,
  location: _propTypes2.default.object.isRequired
}, _temp)) || _class;

exports.default = Home;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _features = __webpack_require__(65);

var _GptProperties = __webpack_require__(51);

var leaderboardAd = {
  view: 'home-page'
};

var saturdayMorningLayout = [{
  component: "MoreNews",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
}, {
  component: "AdvertWrapper",
  props: {
    ocSlot: ["homepage", "leaderboard"],
    additionalProperties: {
      view: "home-page"
    }
  },
  desktopColumn: "left",
  desktopOrder: 2,
  handheldOrder: 2
}, {
  component: "RacingTips",
  props: {
    plainTitle: false
  },
  desktopColumn: "right",
  desktopOrder: 2,
  handheldOrder: 5
}, {
  component: "GooglePublisherTag",
  props: _GptProperties.topMPUProps,
  desktopColumn: "right",
  desktopOrder: 4,
  handheldOrder: false
}, {
  component: "MostReadAll",
  desktopColumn: "right",
  desktopOrder: 5,
  handheldOrder: 3
}, {
  component: "HorseRacingNextRaceOff",
  props: {
    plainTitle: true
  },
  desktopColumn: "right",
  desktopOrder: 7,
  handheldOrder: 6
}, {
  component: "AdvertWrapper",
  props: {
    ocSlot: ["racing", "leaderboard"],
    additionalProperties: {
      view: "home-page"
    }
  },
  desktopOrder: false,
  handheldOrder: 7
}, {
  component: "FootballTips",
  props: {
    plainTitle: true
  },
  desktopColumn: "right",
  desktopOrder: 9,
  handheldOrder: 9
}, {
  component: "AdvertWrapper",
  props: {
    ocSlot: ["football", "leaderboard"],
    additionalProperties: {
      view: "home-page"
    }
  },
  desktopOrder: false,
  handheldOrder: 10
}, {
  component: "HomeColumnists",
  desktopColumn: "left",
  desktopOrder: 4,
  handheldOrder: 12
}, {
  component: "GooglePublisherTag",
  props: {
    adUnitPath: '/67970281/display_thirdparty_gb/sporting_life_responsive/homepage/Bottom_MPU',
    type: "bottomMPU"
  },
  desktopColumn: "right",
  desktopOrder: 10,
  handheldOrder: false
}, {
  component: "AdvertWrapper",
  props: {
    ocSlot: ["homepage", "mpu"],
    additionalProperties: {
      view: "home-page"
    }
  },
  desktopColumn: "right",
  desktopOrder: 9,
  handheldOrder: false
}, {
  component: "GooglePublisherTag",
  props: _GptProperties.singleBottomMPUProps,
  desktopColumn: "right",
  desktopOrder: false,
  handheldOrder: 13
}];

if ((0, _features.has)('insider-benefits')) {
  saturdayMorningLayout.splice(3, 0, {
    component: "InsiderMpu",
    props: {},
    desktopColumn: "right",
    desktopOrder: 3,
    handheldOrder: 6,
    loggedInDisplay: false
  });
}

function pickHomepageLayout() {
  return saturdayMorningLayout;
}

var homePageComponents = function homePageComponents(layout) {
  return {
    bannerAd: _GptProperties.bannerAd,
    leaderboardAd: leaderboardAd,
    components: pickHomepageLayout(layout)
  };
};

exports.default = {
  '/': function _(layout) {
    return homePageComponents(layout);
  }
};

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _HomePage = __webpack_require__(900);

var _HomePage2 = _interopRequireDefault(_HomePage);

var _HomeFootballLiveMatchesContainer = __webpack_require__(899);

var _HomeFootballLiveMatchesContainer2 = _interopRequireDefault(_HomeFootballLiveMatchesContainer);

var _HomeFootballVidiprinter = __webpack_require__(398);

var _HomeFootballVidiprinter2 = _interopRequireDefault(_HomeFootballVidiprinter);

var _HomeColumnists = __webpack_require__(898);

var _HomeColumnists2 = _interopRequireDefault(_HomeColumnists);

var _SectionLink = __webpack_require__(202);

var _SectionLink2 = _interopRequireDefault(_SectionLink);

var _MoreNews = __webpack_require__(93);

var _MoreNews2 = _interopRequireDefault(_MoreNews);

var _MostReadAll = __webpack_require__(141);

var _MostReadAll2 = _interopRequireDefault(_MostReadAll);

var _RacingTips = __webpack_require__(116);

var _RacingTips2 = _interopRequireDefault(_RacingTips);

var _FootballTips = __webpack_require__(140);

var _FootballTips2 = _interopRequireDefault(_FootballTips);

var _HorseRacingNextRaceOff = __webpack_require__(115);

var _HorseRacingNextRaceOff2 = _interopRequireDefault(_HorseRacingNextRaceOff);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _GooglePublisherTag = __webpack_require__(71);

var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);

var _InsiderMpu = __webpack_require__(370);

var _InsiderMpu2 = _interopRequireDefault(_InsiderMpu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var homeRoutes = _react2.default.createElement(
  _reactRouter.Route,
  { component: _HomePage2.default },
  _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: {
      SectionLink: _SectionLink2.default,
      MoreNews: _MoreNews2.default,
      MostReadAll: _MostReadAll2.default,
      HomeFootballLiveMatchesContainer: _HomeFootballLiveMatchesContainer2.default,
      HomeFootballVidiprinter: _HomeFootballVidiprinter2.default,
      RacingTips: _RacingTips2.default,
      FootballTips: _FootballTips2.default,
      HorseRacingNextRaceOff: _HorseRacingNextRaceOff2.default,
      HomeColumnists: _HomeColumnists2.default,
      AdvertWrapper: _AdvertWrapper2.default,
      GooglePublisherTag: _GooglePublisherTag2.default,
      InsiderMpu: _InsiderMpu2.default
    } }),
  _react2.default.createElement(_reactRouter.Redirect, { from: 'sso/success', to: '/' })
);

exports.default = homeRoutes;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AtrPlaceholderPromptHeading = undefined;
exports.default = AtrPlaceholderPrompt;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AtrPlaceholderPrompt(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === undefined ? "standard" : _ref$size;

  __webpack_require__(1420);

  var img = function img(logo) {
    return _react2.default.createElement('img', { key: logo, width: '60', height: '35', src: '/img/masthead/' + logo + '.png' });
  };

  return _react2.default.createElement(
    'div',
    { className: 'atr-placeholder-prompt-' + size },
    _react2.default.createElement(
      'div',
      { className: 'atr-placeholder-prompt-accounts' },
      _react2.default.createElement(
        'div',
        { className: 'atr-placeholder-prompt-accounts-text' },
        'We understand the importance of these replays and will reinstate them as soon as possible. Replays from Racing TV racecourses are available as normal.'
      )
    )
  );
}

AtrPlaceholderPrompt.propTypes = {
  size: _propTypes2.default.string
};

var AtrPlaceholderPromptHeading = exports.AtrPlaceholderPromptHeading = "We regret that replays from Sky Sports Racing racecourses are unavailable until further notice.";

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _SubscriptionContainer = __webpack_require__(92);

var _SubscriptionContainer2 = _interopRequireDefault(_SubscriptionContainer);

var _MyStableButton = __webpack_require__(167);

var _MyStableButton2 = _interopRequireDefault(_MyStableButton);

var _BetLink = __webpack_require__(114);

var _BetLink2 = _interopRequireDefault(_BetLink);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _utils = __webpack_require__(32);

var _consts = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingAbcPersonEntry = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingAbcPersonEntry, _Component);

  function HorseRacingAbcPersonEntry() {
    (0, _classCallCheck3.default)(this, HorseRacingAbcPersonEntry);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HorseRacingAbcPersonEntry.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingAbcPersonEntry)).call(this));

    _this.state = { rideTableOpen: false };
    return _this;
  }

  (0, _createClass3.default)(HorseRacingAbcPersonEntry, [{
    key: 'showRideRow',
    value: function showRideRow(entry) {
      var _entry$ride = entry.ride,
          rideId = _entry$ride.ride_reference.id,
          _entry$ride$horse = _entry$ride.horse,
          horseId = _entry$ride$horse.horse_reference.id,
          horseName = _entry$ride$horse.name,
          odds = _entry$ride.betting.current_odds,
          _entry$ride$jockey = _entry$ride.jockey,
          jockeyId = _entry$ride$jockey.person_reference.id,
          jockeyName = _entry$ride$jockey.name,
          _entry$ride$trainer = _entry$ride.trainer,
          trainerId = _entry$ride$trainer.business_reference.id,
          trainerName = _entry$ride$trainer.name;


      var entryDetails = (0, _utils.rideDetailsFromEntry)(entry);

      return _react2.default.createElement(
        'span',
        { key: rideId, className: 'abc-guide-person-row' },
        _react2.default.createElement(
          'div',
          { className: 'abc-guide-ride-race' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: (0, _utils.racecardResultHref)(entryDetails.raceLinkDetails) },
            entryDetails.raceLinkDetails.eventName
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'abc-guide-ride-horse' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/racing/profiles/horse/' + horseId },
            horseName
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'abc-guide-ride-person jockey' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/racing/profiles/trainer/' + trainerId },
            trainerName
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'abc-guide-ride-person trainer' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/racing/profiles/jockey/' + jockeyId },
            jockeyName
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'abc-guide-ride-odds' },
          !!entryDetails.betlinkProps && _react2.default.createElement(
            _BetLink2.default,
            (0, _extends3.default)({ className: 'hr-racing-runner-betting-link sui-odds' }, entryDetails.betlinkProps),
            odds
          )
        )
      );
    }
  }, {
    key: 'toggleRidesOpen',
    value: function toggleRidesOpen() {
      this.setState({
        rideTableOpen: !this.state.rideTableOpen
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$entry = (0, _slicedToArray3.default)(_props.entry, 1),
          _props$entry$0$ride = _props$entry[0].ride,
          _props$entry$0$ride$j = _props$entry$0$ride.jockey,
          jockeyName = _props$entry$0$ride$j.name,
          jockeyId = _props$entry$0$ride$j.person_reference.id,
          _props$entry$0$ride$t = _props$entry$0$ride.trainer,
          trainerName = _props$entry$0$ride$t.name,
          trainerId = _props$entry$0$ride$t.business_reference.id,
          tableType = _props.tableType;

      __webpack_require__(1421);

      return _react2.default.createElement(
        'span',
        { key: jockeyId, className: 'abc-guide-person-row' },
        _react2.default.createElement(
          'div',
          { className: 'abc-guide-person-name jockey' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/racing/profiles/jockey/' + jockeyId },
            jockeyName
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'abc-guide-my-stable jockey' },
          _react2.default.createElement(_SubscriptionContainer2.default, {
            addSubscriptions: [{ type: "JOCKEY", id: jockeyId, text: jockeyName }],
            icon: _react2.default.createElement(_MyStableButton2.default, { noText: true }) })
        ),
        _react2.default.createElement(
          'div',
          { className: 'abc-guide-person-name trainer' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/racing/profiles/trainer/' + trainerId },
            trainerName
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'abc-guide-my-stable trainer' },
          _react2.default.createElement(_SubscriptionContainer2.default, {
            addSubscriptions: [{ type: "TRAINER", id: trainerId, text: trainerName }],
            icon: _react2.default.createElement(_MyStableButton2.default, { noText: true }) })
        ),
        _react2.default.createElement(
          'div',
          { className: 'abc-guide-todays-rides', onClick: function onClick() {
              return _this2.toggleRidesOpen();
            } },
          _react2.default.createElement(_CaretIcon2.default, { type: 'full', direction: this.state.rideTableOpen ? "up" : "down" }),
          _react2.default.createElement(
            'label',
            null,
            tableType == "jockeys" ? _consts.TODAYS_RIDES_STRING : _consts.TODAYS_ENTRIES_STRING
          )
        ),
        this.state.rideTableOpen && _react2.default.createElement(
          'div',
          { className: 'abc-guide-ride-table' },
          _react2.default.createElement(
            'span',
            { className: 'abc-guide-person-row' },
            _react2.default.createElement(
              'div',
              { className: 'abc-guide-ride-race subHeader' },
              'Race'
            ),
            _react2.default.createElement(
              'div',
              { className: 'abc-guide-ride-horse subHeader' },
              'Horse'
            ),
            _react2.default.createElement(
              'div',
              { className: 'abc-guide-ride-person jockey subHeader' },
              'Trainer'
            ),
            _react2.default.createElement(
              'div',
              { className: 'abc-guide-ride-person trainer subHeader' },
              'Jockey'
            ),
            _react2.default.createElement(
              'div',
              { className: 'abc-guide-ride-odds subHeader' },
              'Odds'
            )
          ),
          this.props.entry.map(this.showRideRow)
        )
      );
    }
  }]);
  return HorseRacingAbcPersonEntry;
}(_react.Component), _class.propTypes = {
  entry: _propTypes2.default.array,
  tableType: _propTypes2.default.string
}, _temp);
exports.default = HorseRacingAbcPersonEntry;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _SubscriptionContainer = __webpack_require__(92);

var _SubscriptionContainer2 = _interopRequireDefault(_SubscriptionContainer);

var _MyStableButton = __webpack_require__(167);

var _MyStableButton2 = _interopRequireDefault(_MyStableButton);

var _LocalDateTimeHelper = __webpack_require__(13);

var _BetLink = __webpack_require__(114);

var _BetLink2 = _interopRequireDefault(_BetLink);

var _utils = __webpack_require__(32);

var _compare = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingAbcTable = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingAbcTable, _Component);

  function HorseRacingAbcTable() {
    (0, _classCallCheck3.default)(this, HorseRacingAbcTable);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingAbcTable.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingAbcTable)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingAbcTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rides = _props.rides,
          days = _props.days;


      var orderedRides = rides.sort(function () {
        for (var _len = arguments.length, items = Array(_len), _key = 0; _key < _len; _key++) {
          items[_key] = arguments[_key];
        }

        return _compare.compareStrings.apply(undefined, (0, _toConsumableArray3.default)(items.map(function (_ref) {
          var name = _ref.ride.horse.name;
          return name;
        })));
      });
      var hideDays = days == '5-days' ? "" : "hideDays";

      return _react2.default.createElement(
        'table',
        { className: 'default-table ' + hideDays },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            { className: 'horse-abc-row' },
            _react2.default.createElement(
              'th',
              { className: 'horse-name heading', colSpan: '2' },
              'Horse'
            ),
            _react2.default.createElement(
              'th',
              { className: 'race-name heading' },
              'Race'
            ),
            _react2.default.createElement(
              'th',
              { className: 'race-day heading' },
              'Day'
            ),
            _react2.default.createElement(
              'th',
              { className: 'abc-guide-odds heading' },
              'Odds'
            )
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          orderedRides.map(function (entry) {
            var _entry$ride = entry.ride,
                rideId = _entry$ride.ride_reference.id,
                _entry$ride$horse = _entry$ride.horse,
                horseId = _entry$ride$horse.horse_reference.id,
                horseName = _entry$ride$horse.name,
                odds = _entry$ride.betting.current_odds,
                raceDate = entry.race.race_summary.date;


            var entryDetails = (0, _utils.rideDetailsFromEntry)(entry);

            return _react2.default.createElement(
              'tr',
              { key: rideId, className: 'horse-abc-row' },
              _react2.default.createElement(
                'td',
                { className: 'horse-name' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/racing/profiles/horse/' + horseId },
                  horseName
                )
              ),
              _react2.default.createElement(
                'td',
                { className: 'abc-guide-my-stable' },
                _react2.default.createElement(_SubscriptionContainer2.default, {
                  addSubscriptions: [{ type: "HORSE", id: horseId, text: horseName }],
                  icon: _react2.default.createElement(_MyStableButton2.default, { noText: true })
                })
              ),
              _react2.default.createElement(
                'td',
                { className: 'race-name' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: (0, _utils.racecardResultHref)(entryDetails.raceLinkDetails) },
                  entryDetails.raceLinkDetails.eventName
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'race-short-day' },
                  (0, _LocalDateTimeHelper.localShortDayOfWeek)(raceDate)
                )
              ),
              _react2.default.createElement(
                'td',
                { className: 'race-day' },
                (0, _LocalDateTimeHelper.localDayOfWeek)(raceDate)
              ),
              _react2.default.createElement(
                'td',
                { className: 'abc-guide-odds' },
                !!entryDetails.betlinkProps && _react2.default.createElement(
                  _BetLink2.default,
                  (0, _extends3.default)({ className: 'hr-racing-runner-betting-link sui-odds' }, entryDetails.betlinkProps),
                  odds
                )
              )
            );
          })
        )
      );
    }
  }]);
  return HorseRacingAbcTable;
}(_react.Component), _class.propTypes = {
  rides: _propTypes2.default.array,
  days: _propTypes2.default.string
}, _temp);
exports.default = HorseRacingAbcTable;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HorseRacingBase;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _seoUtils = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var helmetProps = {
  titleTemplate: _seoUtils.titleTemplate.horseRacing
};

function HorseRacingBase(_ref) {
  var children = _ref.children;

  return _react2.default.createElement(
    'div',
    { className: 'horse-racing-content' },
    _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
    children
  );
}

HorseRacingBase.propTypes = {
  children: _propTypes2.default.any
};

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HorseRacingEarlyEntriesList;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _HorseRacingEarlyEntriesListItem = __webpack_require__(908);

var _HorseRacingEarlyEntriesListItem2 = _interopRequireDefault(_HorseRacingEarlyEntriesListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1422);

function HorseRacingEarlyEntriesList() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$earlyEntries = props.earlyEntries,
      earlyEntries = _props$earlyEntries === undefined ? [] : _props$earlyEntries;


  return _react2.default.createElement(
    'div',
    { className: 'early-entries' },
    earlyEntries.length > 0 ? _react2.default.createElement(
      'div',
      { className: 'early-entries-list' },
      earlyEntries.map(function (_ref) {
        var _ref$meeting_summary = _ref.meeting_summary;
        _ref$meeting_summary = _ref$meeting_summary === undefined ? {} : _ref$meeting_summary;
        var _ref$meeting_summary$ = _ref$meeting_summary.meeting_reference;
        _ref$meeting_summary$ = _ref$meeting_summary$ === undefined ? {} : _ref$meeting_summary$;
        var meetingId = _ref$meeting_summary$.id,
            meetingSummary = _ref.meeting_summary,
            races = _ref.races;
        return _react2.default.createElement(_HorseRacingEarlyEntriesListItem2.default, { key: meetingId, meetingSummary: meetingSummary, races: races });
      })
    ) : _react2.default.createElement(
      'div',
      { className: 'no-early-entries' },
      'No early entries.'
    )
  );
}

HorseRacingEarlyEntriesList.propTypes = {
  earlyEntries: _propTypes2.default.arrayOf(_propTypes2.default.object)
};

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _moment = __webpack_require__(8);

var _moment2 = _interopRequireDefault(_moment);

var _utils = __webpack_require__(18);

var _LocalDateTimeHelper = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingEarlyEntriesListItem = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingEarlyEntriesListItem, _Component);

  function HorseRacingEarlyEntriesListItem() {
    (0, _classCallCheck3.default)(this, HorseRacingEarlyEntriesListItem);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingEarlyEntriesListItem.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingEarlyEntriesListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingEarlyEntriesListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$meetingSummary = _props.meetingSummary;
      _props$meetingSummary = _props$meetingSummary === undefined ? {} : _props$meetingSummary;
      var _props$meetingSummary2 = _props$meetingSummary.course;
      _props$meetingSummary2 = _props$meetingSummary2 === undefined ? {} : _props$meetingSummary2;
      var _props$meetingSummary3 = _props$meetingSummary2.name,
          courseName = _props$meetingSummary3 === undefined ? "Unknown" : _props$meetingSummary3,
          uncheckedMeetingDate = _props$meetingSummary.date,
          _props$races = _props.races,
          races = _props$races === undefined ? [] : _props$races;


      var sortedRaces = races.sort(function (a, b) {
        return a.time > b.time;
      });
      var meetingDate = uncheckedMeetingDate ? (0, _moment2.default)(uncheckedMeetingDate, "YYYY-MM-DD").format('ddd MMMM DD YYYY') : "Unknown";

      return _react2.default.createElement(
        'div',
        { className: 'early-entries-meeting' },
        _react2.default.createElement(
          'div',
          { className: 'early-entries-meeting-header' },
          _react2.default.createElement(
            'div',
            { className: 'early-entries-meeting-header-title' },
            meetingDate,
            ' - ',
            courseName
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: 'early-entries-meeting-races' },
          sortedRaces.map(function (_ref) {
            var raceDate = _ref.date,
                courseName = _ref.course_name,
                _ref$race_summary_ref = _ref.race_summary_reference;
            _ref$race_summary_ref = _ref$race_summary_ref === undefined ? {} : _ref$race_summary_ref;
            var raceId = _ref$race_summary_ref.id,
                _ref$name = _ref.name,
                raceName = _ref$name === undefined ? 'Unknown' : _ref$name,
                raceTime = _ref.time;

            var raceMeetingDate = (0, _moment2.default)(raceDate).format('YYYY-MM-DD');
            var raceCourseName = (0, _utils.toSlug)(courseName);
            var londonRaceTime = (0, _LocalDateTimeHelper.localTimeShort)(raceDate + 'T' + raceTime + 'Z');
            return _react2.default.createElement(
              'li',
              { key: '' + raceId },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/racing/racecards/' + raceMeetingDate + '/' + raceCourseName + '/racecard/' + raceId + '/' + (0, _utils.toSlug)(raceName) },
                _react2.default.createElement(
                  'span',
                  { className: 'early-entries-meeting-content-race-time' },
                  londonRaceTime
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'early-entries-meeting-content-race-name' },
                  raceName
                )
              )
            );
          })
        )
      );
    }
  }]);
  return HorseRacingEarlyEntriesListItem;
}(_react.Component), _class.propTypes = {
  meetingSummary: _propTypes2.default.shape({
    course: _propTypes2.default.shape({
      name: _propTypes2.default.string.isRequired
    }),
    date: _propTypes2.default.string.isRequired
  }),
  races: _propTypes2.default.arrayOf(_propTypes2.default.object)
}, _temp);
exports.default = HorseRacingEarlyEntriesListItem;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HorseRacingFastRacecardExtraPlaces;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HorseRacingFastRacecardRide = __webpack_require__(400);

var _HorseRacingFastRacecardRide2 = _interopRequireDefault(_HorseRacingFastRacecardRide);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

HorseRacingFastRacecardExtraPlaces.propTypes = {
  rides: _propTypes2.default.array,
  places: _propTypes2.default.number,
  favToken: _propTypes2.default.string
};

function HorseRacingFastRacecardExtraPlaces(_ref) {
  var rides = _ref.rides,
      places = _ref.places,
      favToken = _ref.favToken;


  if (!rides || rides.length == 0) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'fast-results-extra-places' },
    _react2.default.createElement(
      'div',
      { className: 'fast-results-extra-places-header fast-results-extra-places-marginals' },
      _react2.default.createElement(
        'span',
        { className: 'skycon' },
        String.fromCharCode(0xF30F)
      ),
      'Sky Bet paid ',
      places,
      ' places on this race',
      _react2.default.createElement(
        'span',
        { className: 'logo' },
        _react2.default.createElement('img', { src: '/img/masthead/skybet-dec2017.png' })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'fast-results-extra-places-content' },
      rides.map(function (ride) {
        return _react2.default.createElement(_HorseRacingFastRacecardRide2.default, { key: ride.horse_reference.id, ride: ride, favToken: favToken });
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'fast-results-extra-places-footer fast-results-extra-places-marginals' },
      _react2.default.createElement(
        'a',
        { target: '_blank', href: 'https://m.skybet.com/horse-racing/meetings?affid=720&dcmp=sl_fr_extra_places' },
        _react2.default.createElement(
          'span',
          null,
          'Tap here for the next Sky Bet Extra place race '
        ),
        _react2.default.createElement(_CaretIcon2.default, { type: "line", direction: 'right' })
      )
    )
  );
}

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _SwitchBtns = __webpack_require__(102);

var _SwitchBtns2 = _interopRequireDefault(_SwitchBtns);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _HorseRacingFastRacecard = __webpack_require__(399);

var _HorseRacingFastRacecard2 = _interopRequireDefault(_HorseRacingFastRacecard);

var _seoUtils = __webpack_require__(23);

var _reactDeviceDetect = __webpack_require__(109);

var _GptAdvert = __webpack_require__(101);

var _GptAdvert2 = _interopRequireDefault(_GptAdvert);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _GptProperties = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingFastRacecardsList = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingFastRacecardsList, _Component);

  function HorseRacingFastRacecardsList() {
    (0, _classCallCheck3.default)(this, HorseRacingFastRacecardsList);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingFastRacecardsList.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingFastRacecardsList)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingFastRacecardsList, [{
    key: 'render',
    value: function render() {
      __webpack_require__(1424);
      var metaDesc = 'The latest results as they happen from Sporting Life\'s Fast Results service.';
      var _props = this.props,
          _props$isMobileFn = _props.isMobileFn,
          isMobileFn = _props$isMobileFn === undefined ? function () {
        return _reactDeviceDetect.isMobile;
      } : _props$isMobileFn,
          _props$fastResults = _props.fastResults;
      _props$fastResults = _props$fastResults === undefined ? {} : _props$fastResults;
      var _props$fastResults$fa = _props$fastResults.fastResults,
          fastResultsList = _props$fastResults$fa === undefined ? [] : _props$fastResults$fa;


      var isMobileSize = isMobileFn();
      var initialFastResults = isMobileSize ? fastResultsList.slice(0, 3) : fastResultsList;
      var finalFastResults = isMobileSize ? fastResultsList.slice(3) : [];

      return _react2.default.createElement(
        'div',
        { className: 'fast-results' },
        _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: (0, _extends3.default)({}, (0, _seoUtils.metaDescription)(metaDesc)) }),
        _react2.default.createElement(
          'div',
          { className: 'fast-racecard-heading' },
          _react2.default.createElement(
            'h1',
            null,
            'Fast Results'
          ),
          _react2.default.createElement(_SwitchBtns2.default, { buttons: [{ href: '/racing/fast-results', text: 'UK/IRE Results', isIndex: true }, { href: '/racing/fast-results/all', text: 'All Results' }] })
        ),
        _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["racingFastResults", "leaderboard"], additionalProperties: { location: "/racing", view: "racing" } }),
        initialFastResults !== null && initialFastResults.length > 0 ? _react2.default.createElement(
          'div',
          { className: 'fast-results-list initial-fast-results' },
          initialFastResults.map(function (race) {
            return _lodash2.default.get(race, "race_reference.id") ? _react2.default.createElement(_HorseRacingFastRacecard2.default, (0, _extends3.default)({ key: race.race_reference.id }, race)) : _react2.default.createElement(
              'div',
              { className: 'fast-racecard-item failed-load' },
              'Failed to load Fast Result'
            );
          })
        ) : _react2.default.createElement(
          'div',
          { className: 'no-fast-results' },
          'No fast results.'
        ),
        isMobileSize && _react2.default.createElement(_GptAdvert2.default, {
          ocDetails: {
            ocSlot: ["racing", "mpu"]
          },
          performDetails: _GptProperties.singleBottomMPUProps
        }),
        finalFastResults !== null && finalFastResults.length > 0 && _react2.default.createElement(
          'div',
          { className: 'fast-results-list remaining-fast-results' },
          finalFastResults.map(function (race) {
            return _react2.default.createElement(_HorseRacingFastRacecard2.default, (0, _extends3.default)({ key: race.race_reference.id }, race));
          })
        )
      );
    }
  }]);
  return HorseRacingFastRacecardsList;
}(_react.Component), _class.propTypes = {
  isMobileFn: _propTypes2.default.func,
  fastResults: _propTypes2.default.shape({
    fastResults: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      race_reference: _propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired
      }).isRequired
    })).isRequired
  })
}, _temp);
exports.default = HorseRacingFastRacecardsList;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HorseRacingFormTable;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(32);

var _LocalDateTime = __webpack_require__(61);

var _CaretLink = __webpack_require__(54);

var _CaretLink2 = _interopRequireDefault(_CaretLink);

var _reactRouter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HorseRacingFormTable(_ref) {
    var horse = _ref.horse,
        results = _ref.results;


    if (!results || results.length === 0) {
        return null;
    }

    function renderResult(result) {
        var _result$course_name = result.course_name,
            course_name = _result$course_name === undefined ? "Unknown" : _result$course_name,
            race_id = result.race_id,
            date = result.date,
            distance = result.distance,
            run_type = result.run_type,
            weight = result.weight;


        return _react2.default.createElement(
            'tr',
            { key: race_id },
            _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: (0, _utils.resultHref)(result),
                        className: 'hr-racing-runner-form-racecard-link' },
                    _react2.default.createElement(_LocalDateTime.LocalFullDateShort, { iso: date })
                )
            ),
            _react2.default.createElement(
                'td',
                null,
                course_name
            ),
            _react2.default.createElement(
                'td',
                null,
                distance
            ),
            _react2.default.createElement(
                'td',
                null,
                run_type
            ),
            _react2.default.createElement(
                'td',
                null,
                weight
            ),
            _react2.default.createElement(
                'td',
                null,
                (0, _utils.formatPosition)(result, { showRunnerCount: false })
            )
        );
    }

    return _react2.default.createElement(
        'div',
        { className: 'hr-racing-runner-form-table' },
        _react2.default.createElement(
            'table',
            { className: 'default-table' },
            _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                        'th',
                        null,
                        'Date'
                    ),
                    _react2.default.createElement(
                        'th',
                        null,
                        'CRS'
                    ),
                    _react2.default.createElement(
                        'th',
                        null,
                        'Dist'
                    ),
                    _react2.default.createElement(
                        'th',
                        null,
                        'Type'
                    ),
                    _react2.default.createElement(
                        'th',
                        null,
                        'WGT'
                    ),
                    _react2.default.createElement(
                        'th',
                        null,
                        'Pos'
                    )
                )
            ),
            _react2.default.createElement(
                'tbody',
                null,
                results.map(function (result) {
                    return renderResult(result);
                })
            )
        ),
        _react2.default.createElement(
            _CaretLink2.default,
            { className: 'hr-racing-runner-form-lifetime-link', to: '/racing/profiles/horse/' + horse.horse_reference.id, caretDirection: 'right' },
            'See lifetime form'
        )
    );
}

HorseRacingFormTable.propTypes = {
    horse: _propTypes2.default.object.isRequired,
    results: _propTypes2.default.array.isRequired
};

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

exports.default = HorseRacingGoing;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _LocalDateTimeHelper = __webpack_require__(13);

var _reactRouter = __webpack_require__(11);

var _utils = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HorseRacingGoing(props) {
  __webpack_require__(1425);

  var title = "Going";

  if (!props.races) {
    return _react2.default.createElement(
      'div',
      { className: 'hr-racing-racecards' },
      _react2.default.createElement(
        'p',
        { className: 'hr-racing-racecards-error-message' },
        'There has been a problem displaying the race information.'
      )
    );
  }

  return _react2.default.createElement(
    'div',
    { className: 'horse-racing-going' },
    _react2.default.createElement(_MetaDataWrapper2.default, { title: title }),
    _react2.default.createElement(
      'h1',
      { className: 'page-main-title' },
      title
    ),
    _react2.default.createElement(
      'table',
      { className: 'hr-going-date-table' },
      (0, _keys2.default)(props.races).sort().map(function (date) {
        return _react2.default.createElement(
          'tbody',
          { key: date },
          _react2.default.createElement(
            'tr',
            { className: 'hr-going-date-header' },
            _react2.default.createElement(
              'th',
              { colSpan: '2' },
              (0, _LocalDateTimeHelper.localLongDate)(date)
            )
          ),
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'th',
              null,
              'Meeting'
            ),
            _react2.default.createElement(
              'th',
              null,
              'Going'
            )
          ),
          props.races[date].map(function (_ref) {
            var name = _ref.course.name,
                id = _ref.meeting_reference.id,
                _ref$going = _ref.going,
                going = _ref$going === undefined ? "-" : _ref$going,
                meetingDate = _ref.date;
            return _react2.default.createElement(
              'tr',
              { key: id },
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/racing/meeting/' + meetingDate + '/' + (0, _utils.toSlug)(name) + '/' + id },
                  name
                )
              ),
              _react2.default.createElement(
                'td',
                null,
                going
              )
            );
          })
        );
      })
    )
  );
}

HorseRacingGoing.propTypes = {
  races: _propTypes2.default.object
};

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = HorseRacingLastRun;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RaceVideoPlayer = __webpack_require__(170);

var _RaceVideoPlayer2 = _interopRequireDefault(_RaceVideoPlayer);

var _moment = __webpack_require__(8);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HorseRacingLastRun(_ref) {
    var lastRun = _ref.lastRun;

    if (!lastRun) {
        return null;
    }

    var lastRunMoment = (0, _moment2.default)(lastRun.date + ' ' + lastRun.time, 'YYYY-MM-DD HH:mm:ss');

    return _react2.default.createElement(
        'div',
        { className: 'hr-racing-runner-form-watch-last-run' },
        _react2.default.createElement(
            'h4',
            null,
            _react2.default.createElement(
                'span',
                { className: 'bold' },
                'Last Run'
            ),
            ' : ',
            lastRun.race_name,
            ' ',
            lastRunMoment ? lastRunMoment.format('HH:mm DD/MM/YYYY') : null
        ),
        lastRun.ride_description ? _react2.default.createElement(
            'p',
            null,
            lastRun.ride_description
        ) : null,
        lastRun.video && _react2.default.createElement(_RaceVideoPlayer2.default, { videos: [lastRun.video] })
    );
}

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _utils = __webpack_require__(32);

var _BetLink = __webpack_require__(114);

var _BetLink2 = _interopRequireDefault(_BetLink);

var _Dropdown = __webpack_require__(100);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _compare = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingLiveShowPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingLiveShowPage, _Component);

  function HorseRacingLiveShowPage() {
    var _ref;

    (0, _classCallCheck3.default)(this, HorseRacingLiveShowPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = HorseRacingLiveShowPage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingLiveShowPage)).call.apply(_ref, [this].concat(args)));

    _this.state = _this.getStateForRunners(_this.props, true);
    return _this;
  }

  (0, _createClass3.default)(HorseRacingLiveShowPage, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState(this.getStateForRunners(nextProps, this.state.sortPristine));
    }
  }, {
    key: 'getStateForRunners',
    value: function getStateForRunners(_ref2) {
      var rides = _ref2.race.rides;
      var sortPristine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var runners = rides.filter(function (ride) {
        return ride.ride_status == "RUNNER";
      });
      var haveHistoricalOdds = runners.map(function (runner) {
        return runner.betting.historical_odds.length;
      }).some(function (r) {
        return r;
      });
      var haveCurrentOdds = runners.map(function (runner) {
        return runner.betting.current_odds;
      }).some(function (r) {
        return r;
      });
      var nextState = { runners: runners, sortPristine: sortPristine, haveCurrentOdds: haveCurrentOdds, haveHistoricalOdds: haveHistoricalOdds };

      if (sortPristine) {
        if (haveHistoricalOdds) {
          nextState.sortOrder = "odds";
        } else {
          nextState.sortOrder = "cloth";
        }
      }

      return nextState;
    }
  }, {
    key: 'setSortOrder',
    value: function setSortOrder(sortOrder) {
      this.setState({
        sortOrder: sortOrder,
        sortPristine: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          helmetRaceLabel = _props.helmetRaceLabel,
          race = _props.race,
          on_course_book_percentage = _props.race.on_course_book_percentage;
      var _state = this.state,
          runners = _state.runners,
          sortOrder = _state.sortOrder,
          haveCurrentOdds = _state.haveCurrentOdds;


      switch (sortOrder) {
        case "horse":
          runners.sort(_compare.sortByHorseName);
          break;
        case "odds":
          runners.sort(_compare.sortByOdds);
          break;
        case "cloth":
        default:
          runners.sort(_compare.sortByClothNumber);
          break;
      }

      var sortOptions = [{ text: "Cloth number", value: "cloth" }, { text: "Horse A-Z", value: "horse" }];

      if (haveCurrentOdds) {
        sortOptions.splice(1, 0, { text: "Odds", value: "odds" });
      }

      return _react2.default.createElement(
        'div',
        { className: 'hr-racing-live-show' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: helmetRaceLabel + ' - Live Show' }),
        _react2.default.createElement(
          'div',
          { className: 'hr-live-show-sort' },
          _react2.default.createElement(
            'span',
            { className: 'hr-racecard-sort-text' },
            'Sort By:'
          ),
          _react2.default.createElement(_Dropdown2.default, {
            className: 'sort-dropdown',
            options: sortOptions,
            value: this.state.sortOrder,
            onChange: function onChange(value) {
              return _this2.setSortOrder(value);
            },
            title: 'Order?',
            showSelected: true,
            noOptionsMessage: 'No options'
          })
        ),
        _react2.default.createElement(
          'table',
          { className: 'default-table' },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                null,
                '#'
              ),
              _react2.default.createElement(
                'th',
                null,
                'Horse'
              ),
              _react2.default.createElement(
                'th',
                null,
                'On-Course Prices'
              ),
              _react2.default.createElement(
                'th',
                null,
                _react2.default.createElement(
                  'span',
                  { className: 'hr-odds-heading' },
                  'Odds'
                )
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            runners.map(function (ride) {
              var id = ride.ride_reference.id,
                  cloth_number = ride.cloth_number,
                  name = ride.horse.name,
                  _ride$betting = ride.betting,
                  _ride$betting$current = _ride$betting.current_odds,
                  current_odds = _ride$betting$current === undefined ? "" : _ride$betting$current,
                  _ride$betting$histori = _ride$betting.historical_odds,
                  historical_odds = _ride$betting$histori === undefined ? [] : _ride$betting$histori;

              var _rideDetailsFromEntry = (0, _utils.rideDetailsFromEntry)({ race: race, ride: ride }),
                  betlinkProps = _rideDetailsFromEntry.betlinkProps;

              return _react2.default.createElement(
                'tr',
                { key: id },
                _react2.default.createElement(
                  'td',
                  null,
                  cloth_number
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  name
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'hr-racing-live-show-prices' },
                  historical_odds.map(function (price, i) {
                    return _react2.default.createElement(
                      'span',
                      { key: i },
                      price
                    );
                  })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement(
                    _BetLink2.default,
                    (0, _extends3.default)({ className: 'hr-betting-link' }, betlinkProps),
                    current_odds
                  )
                )
              );
            })
          )
        ),
        _react2.default.createElement(
          'dl',
          null,
          on_course_book_percentage && _react2.default.createElement(
            'dt',
            { className: 'pool-label' },
            'On-course book percentage'
          ),
          _react2.default.createElement(
            'dd',
            { className: 'pool-value' },
            on_course_book_percentage
          )
        )
      );
    }
  }]);
  return HorseRacingLiveShowPage;
}(_react.Component), _class.propTypes = {
  helmetRaceLabel: _propTypes2.default.string,
  race: _propTypes2.default.object
}, _temp);
exports.default = HorseRacingLiveShowPage;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _rideFilter = __webpack_require__(171);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _FeedIcon = __webpack_require__(364);

var _FeedIcon2 = _interopRequireDefault(_FeedIcon);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _PrintButton = __webpack_require__(768);

var _PrintButton2 = _interopRequireDefault(_PrintButton);

var _LocalDateTimeHelper = __webpack_require__(13);

var _utils = __webpack_require__(18);

var _utils2 = __webpack_require__(32);

var _OrdinalSuffix = __webpack_require__(218);

var _OrdinalSuffix2 = _interopRequireDefault(_OrdinalSuffix);

var _CurrencyFormatting = __webpack_require__(175);

var _seoUtils = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1426);

function bracket(text) {
  if (text) {
    return '(' + text + ')';
  }
}

var HorseRacingMeetingFastCards = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingMeetingFastCards, _Component);

  function HorseRacingMeetingFastCards() {
    (0, _classCallCheck3.default)(this, HorseRacingMeetingFastCards);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingMeetingFastCards.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingMeetingFastCards)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingMeetingFastCards, [{
    key: 'render',
    value: function render() {
      if (!this.props.meeting) {

        var errorPixelSrc = '/1x1.gif?type=fast-cards&id=0&cb=' + Date.now();

        return _react2.default.createElement(
          'div',
          { className: 'fast-cards' },
          _react2.default.createElement(_MetaDataWrapper2.default, { title: 'Fast Cards - Error' }),
          _react2.default.createElement(
            'div',
            { className: 'fast-cards-meeting-title' },
            _react2.default.createElement(
              'h1',
              { className: 'page-title' },
              'No Fast Cards Found'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'fast-cards-meeting-summary' },
            _react2.default.createElement(
              'div',
              { className: 'fast-cards-meeting-summary-text' },
              'No meeting could be found to show fast cards for.'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('img', { src: errorPixelSrc, width: '1', height: '1' })
          )
        );
      }

      var _props = this.props,
          routes = _props.routes,
          _props$meeting = _props.meeting,
          _props$meeting$meetin = _props$meeting.meeting_summary,
          meetingId = _props$meeting$meetin.meeting_reference.id,
          _props$meeting$meetin2 = _props$meeting$meetin.course,
          courseName = _props$meeting$meetin2.name,
          feedSource = _props$meeting$meetin2.feed_source,
          date = _props$meeting$meetin.date,
          going = _props$meeting$meetin.going,
          races = _props$meeting.races;


      var courseNameSlug = (0, _utils.toSlug)(courseName);

      var racecardUrl = function racecardUrl(raceName, raceId) {
        return '/racing/racecards/' + date + '/' + courseNameSlug + '/racecard/' + raceId + '/' + (0, _utils.toSlug)(raceName);
      };

      var statusRunnerMap = {
        RUNNER: true,
        NONRUNNER: false,
        // DOUBTFUL: true, // not currently used
        WITHDRAWN: false
      };

      var runnerFilter = function runnerFilter(isRunner) {
        return function (_ref) {
          var ride_status = _ref.ride_status;
          return statusRunnerMap[ride_status] === isRunner;
        };
      };

      races.forEach(function (race) {
        race.runners = race.rides.filter(runnerFilter(true)).sort(_rideFilter.sortByClothNo);
        race.nonRunners = race.rides.filter(runnerFilter(false));
      });

      var helmetProps = (0, _extends3.default)({
        title: 'Fast Cards - ' + courseName + ' ' + date
      }, (0, _seoUtils.canonicalLink)(routes, { date: date, courseSlug: courseNameSlug, meetingId: meetingId }));

      return _react2.default.createElement(
        'div',
        { className: 'fast-cards' },
        _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
        _react2.default.createElement(
          'div',
          { className: 'fast-cards-meeting-title' },
          _react2.default.createElement(
            'h1',
            { className: 'page-title' },
            courseName,
            ' ',
            _react2.default.createElement(
              'small',
              null,
              (0, _LocalDateTimeHelper.localFullDate)(date)
            )
          ),
          _react2.default.createElement(_FeedIcon2.default, { feed: feedSource })
        ),
        _react2.default.createElement(
          'div',
          { className: 'fast-cards-meeting-summary' },
          _react2.default.createElement(
            'div',
            { className: 'fast-cards-meeting-summary-text' },
            'Going: ',
            going
          ),
          _react2.default.createElement(
            'div',
            { className: 'fast-cards-meeting-print' },
            _react2.default.createElement(_PrintButton2.default, null)
          )
        ),
        races.map(function (_ref2) {
          var _ref2$race_summary = _ref2.race_summary,
              raceId = _ref2$race_summary.race_summary_reference.id,
              raceName = _ref2$race_summary.name,
              time = _ref2$race_summary.time,
              distance = _ref2$race_summary.distance,
              race_class = _ref2$race_summary.race_class,
              age = _ref2$race_summary.age,
              _ref2$prizes = _ref2.prizes;
          _ref2$prizes = _ref2$prizes === undefined ? {} : _ref2$prizes;
          var _ref2$prizes$prize = _ref2$prizes.prize,
              prize = _ref2$prizes$prize === undefined ? [] : _ref2$prizes$prize,
              betting_forecast = _ref2.betting_forecast,
              runners = _ref2.runners,
              nonRunners = _ref2.nonRunners;
          return _react2.default.createElement(
            'div',
            { key: raceId, className: 'fast-card-race' },
            _react2.default.createElement(
              'div',
              { className: 'fast-card-race-title' },
              _react2.default.createElement(
                'div',
                { className: 'fast-card-race-title-text' },
                (0, _LocalDateTimeHelper.localTimeShort)(date + 'T' + time + 'Z'),
                ' ',
                raceName
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'fast-card-race-title-link', to: racecardUrl(raceName, raceId) },
                _react2.default.createElement(_CaretIcon2.default, { type: 'full', direction: 'right' }),
                'Full racecard'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'fast-card-race-meta' },
              _react2.default.createElement(
                'span',
                { className: 'fast-card-meta-distance' },
                (0, _utils2.distanceFormat)(distance)
              ),
              race_class && _react2.default.createElement(
                'span',
                { className: 'fast-card-meta-class' },
                '(Class ',
                race_class,
                ')'
              ),
              age && _react2.default.createElement(
                'span',
                { className: 'fast-card-meta-age' },
                (0, _utils2.formatHorseAge)(age)
              ),
              prize.sort(function (a, b) {
                return a.position - b.position;
              }).map(function (prize) {
                return _react2.default.createElement(
                  'span',
                  { className: 'fast-card-meta-prize', key: prize.position },
                  _react2.default.createElement(
                    'span',
                    { className: 'fast-card-meta-prize-label' },
                    (0, _OrdinalSuffix2.default)(prize.position)
                  ),
                  _CurrencyFormatting.formatCurrency.apply(undefined, (0, _toConsumableArray3.default)(prize.prize.split(" ")))
                );
              })
            ),
            runners.map(function (_ref3) {
              var rideId = _ref3.ride_reference.id,
                  clothNumber = _ref3.cloth_number,
                  drawNumber = _ref3.draw_number,
                  handicap = _ref3.handicap,
                  _ref3$headgear = _ref3.headgear,
                  headgear = _ref3$headgear === undefined ? [] : _ref3$headgear,
                  horse = _ref3.horse,
                  _ref3$horse = _ref3.horse,
                  formString = _ref3$horse.formsummary.display_text,
                  age = _ref3$horse.age,
                  trainer = _ref3.trainer,
                  jockey = _ref3.jockey,
                  jockey_claim = _ref3.jockey_claim,
                  _ref3$race_history_st = _ref3.race_history_stats,
                  race_history_stats = _ref3$race_history_st === undefined ? [] : _ref3$race_history_st,
                  _ref3$medication = _ref3.medication,
                  medication = _ref3$medication === undefined ? [] : _ref3$medication;
              return _react2.default.createElement(
                'div',
                { key: rideId, className: 'fast-card-runner' },
                _react2.default.createElement(
                  'span',
                  { className: 'fast-card-runner-cloth' },
                  clothNumber
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'fast-card-runner-draw' },
                  bracket(drawNumber)
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'fast-card-runner-form' },
                  formString
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'fast-card-runner-horse' },
                  _react2.default.createElement(
                    'span',
                    { className: 'fast-card-runner-horse-name' },
                    _react2.default.createElement(HorseLink, { horse: horse })
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'fast-card-runner-horse-headgear' },
                    (0, _utils2.formatHeadgear)(headgear)
                  ),
                  race_history_stats.length > 0 && race_history_stats.map(function (_ref4) {
                    var type = _ref4.type;
                    return _react2.default.createElement(
                      'span',
                      { className: 'fast-card-runner-race-history-stats', key: type },
                      (0, _utils2.keepUpperCase)(type)
                    );
                  }),
                  medication.length > 0 && medication.map(function (_ref5) {
                    var short_name = _ref5.short_name;
                    return _react2.default.createElement(
                      'span',
                      { className: 'fast-card-runner-race-medication-stats', key: short_name },
                      (0, _utils2.keepUpperCase)(short_name)
                    );
                  })
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'fast-card-runner-age' },
                  age
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'fast-card-runner-handicap' },
                  handicap
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'fast-card-runner-trainer' },
                  'T: ',
                  trainer && _react2.default.createElement(TrainerLink, { trainer: trainer })
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'fast-card-runner-jockey' },
                  'J: ',
                  jockey && _react2.default.createElement(JockeyLink, { jockey: jockey }),
                  jockey_claim && _react2.default.createElement(
                    'span',
                    { className: 'fast-card-runner-jockey-claim' },
                    bracket(jockey_claim)
                  )
                )
              );
            }),
            !!nonRunners.length && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'fast-card-sub-title' },
                'Non-Runners'
              ),
              nonRunners.map(function (_ref6) {
                var rideId = _ref6.ride_reference.id,
                    clothNumber = _ref6.cloth_number,
                    horse = _ref6.horse,
                    trainer = _ref6.trainer,
                    jockey = _ref6.jockey;
                return _react2.default.createElement(
                  'div',
                  { key: rideId, className: 'fast-card-non-runner' },
                  _react2.default.createElement(
                    'span',
                    { className: 'fast-card-runner-cloth' },
                    clothNumber
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'fast-card-runner-horse-name' },
                    _react2.default.createElement(HorseLink, { horse: horse })
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'fast-card-runner-trainer' },
                    'T: ',
                    trainer && _react2.default.createElement(TrainerLink, { trainer: trainer })
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: 'fast-card-runner-jockey' },
                    'J: ',
                    jockey && _react2.default.createElement(JockeyLink, { jockey: jockey })
                  )
                );
              })
            ),
            !!betting_forecast && _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'fast-card-sub-title' },
                'Forecast'
              ),
              _react2.default.createElement(
                'div',
                { className: 'fast-card-forecast' },
                betting_forecast
              )
            )
          );
        })
      );
    }
  }]);
  return HorseRacingMeetingFastCards;
}(_react.Component), _class.propTypes = {
  routes: _propTypes2.default.array,
  meeting: _propTypes2.default.object
}, _temp);
exports.default = HorseRacingMeetingFastCards;


function HorseLink(_ref7) {
  var _ref7$horse = _ref7.horse,
      id = _ref7$horse.horse_reference.id,
      name = _ref7$horse.name;

  return _react2.default.createElement(
    _reactRouter.Link,
    { to: '/racing/profiles/horse/' + id },
    name
  );
}
HorseLink.propTypes = { horse: _propTypes2.default.object.isRequired };

function TrainerLink(_ref8) {
  var _ref8$trainer = _ref8.trainer,
      id = _ref8$trainer.business_reference.id,
      name = _ref8$trainer.name;

  return _react2.default.createElement(
    _reactRouter.Link,
    { to: '/racing/profiles/trainer/' + id },
    name
  );
}
TrainerLink.propTypes = { trainer: _propTypes2.default.object.isRequired };

function JockeyLink(_ref9) {
  var _ref9$jockey = _ref9.jockey,
      id = _ref9$jockey.person_reference.id,
      name = _ref9$jockey.name;

  return _react2.default.createElement(
    _reactRouter.Link,
    { to: '/racing/profiles/jockey/' + id },
    name
  );
}
JockeyLink.propTypes = { jockey: _propTypes2.default.object.isRequired };

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _seoUtils = __webpack_require__(23);

var _utils = __webpack_require__(18);

var _LocalDateTimeHelper = __webpack_require__(13);

var _HorseRacingFastRacecard = __webpack_require__(399);

var _HorseRacingFastRacecard2 = _interopRequireDefault(_HorseRacingFastRacecard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingMeetingLandingPageList = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingMeetingLandingPageList, _Component);

  function HorseRacingMeetingLandingPageList() {
    (0, _classCallCheck3.default)(this, HorseRacingMeetingLandingPageList);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingMeetingLandingPageList.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingMeetingLandingPageList)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingMeetingLandingPageList, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          routes = _props.routes,
          _props$meeting = _props.meeting;
      _props$meeting = _props$meeting === undefined ? {} : _props$meeting;
      var meetingId = _props$meeting.meeting_reference.id,
          surface = _props$meeting.surface_summary,
          going = _props$meeting.going,
          date = _props$meeting.date,
          weather = _props$meeting.weather,
          _props$meeting$course = _props$meeting.course;
      _props$meeting$course = _props$meeting$course === undefined ? {} : _props$meeting$course;
      var courseName = _props$meeting$course.name,
          courseSummary = _props$meeting$course.course_summary,
          results = _props.results;


      var helmetProps = (0, _extends3.default)({
        title: courseName + ' - ' + (0, _LocalDateTimeHelper.localFullDateNoDay)(date)
      }, (0, _seoUtils.canonicalLink)(routes, { meetingDate: date, meetingName: (0, _utils.toSlug)(courseName), meetingId: meetingId }));

      return _react2.default.createElement(
        'div',
        { className: 'fast-results' },
        _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps }),
        _react2.default.createElement(
          'div',
          { className: 'meeting-heading' },
          _react2.default.createElement(
            'h1',
            { className: 'page-title' },
            courseName,
            ' ',
            _react2.default.createElement(
              'small',
              null,
              (0, _LocalDateTimeHelper.localFullDateLong)(date)
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'meeting-summary' },
          _react2.default.createElement(
            'h1',
            null,
            _react2.default.createElement(
              'small',
              null,
              'Meeting Summary'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'meeting-landing-page-summary-going' },
            'Going: ',
            going
          ),
          _react2.default.createElement(
            'div',
            { className: 'meeting-landing-page-summary-surface' },
            'Surface: ',
            surface
          ),
          _react2.default.createElement(
            'div',
            { className: 'meeting-landing-page-summary-weather' },
            'Weather: ',
            weather
          )
        ),
        results && results.length > 0 ? _react2.default.createElement(
          'div',
          { className: 'fast-results-list' },
          results.map(function (race) {
            return race.race_reference == null || race.race_reference == undefined ? _react2.default.createElement(
              'div',
              { className: 'fast-racecard-item' },
              'Fast Result not available.'
            ) : _react2.default.createElement(_HorseRacingFastRacecard2.default, (0, _extends3.default)({ key: race.race_reference.id }, race, { meetingMode: true }));
          })
        ) : _react2.default.createElement(
          'div',
          { className: 'no-fast-results' },
          'No fast results.'
        ),
        courseSummary && _react2.default.createElement(
          'div',
          { className: 'course-summary' },
          _react2.default.createElement(
            'h1',
            null,
            _react2.default.createElement(
              'small',
              null,
              'Course Summary'
            )
          ),
          courseSummary.split("\n").map(function (p, i) {
            return _react2.default.createElement(
              'p',
              { key: i },
              p
            );
          })
        )
      );
    }
  }]);
  return HorseRacingMeetingLandingPageList;
}(_react.Component), _class.propTypes = {
  routes: _propTypes2.default.array,
  meeting: _propTypes2.default.object,
  results: _propTypes2.default.array
}, _temp);
exports.default = HorseRacingMeetingLandingPageList;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.default = HorseRacingNextRaceLine;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Silk = __webpack_require__(113);

var _Silk2 = _interopRequireDefault(_Silk);

var _BetLink = __webpack_require__(114);

var _BetLink2 = _interopRequireDefault(_BetLink);

var _LocalDateTimeHelper = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HorseRacingNextRaceLine(props) {
  var ride = props.ride;
  var betlinkIds = ride.ride_reference.external_reference.filter(function (r) {
    return r.ref === 'skybet';
  }).map(function (r) {
    return r.value;
  });

  var betLinkProps = void 0;
  if (betlinkIds.length > 0 && ride.betting.current_odds) {
    var _props$ride$betting$m = props.ride.betting.market_reference;
    _props$ride$betting$m = _props$ride$betting$m === undefined ? {} : _props$ride$betting$m;
    var _props$ride$betting$m2 = _props$ride$betting$m.external_reference;
    _props$ride$betting$m2 = _props$ride$betting$m2 === undefined ? [] : _props$ride$betting$m2;

    var _props$ride$betting$m3 = (0, _slicedToArray3.default)(_props$ride$betting$m2, 1),
        _props$ride$betting$m4 = _props$ride$betting$m3[0];

    _props$ride$betting$m4 = _props$ride$betting$m4 === undefined ? {} : _props$ride$betting$m4;
    var marketId = _props$ride$betting$m4.value;


    var displayTime = (0, _LocalDateTimeHelper.localTimeShort)(props.raceSummary.date + 'T' + props.raceSummary.time + 'Z');

    betLinkProps = {
      marketId: marketId,
      eventId: props.raceExternalId,
      eventName: displayTime + ' ' + props.raceSummary.course_name,
      eventCompetition: props.raceSummary.course_name, // only relevant for feature "integrated-betslip"
      dateTime: props.raceSummary.date + ' ' + props.raceSummary.time,
      sport: "horseRacing",
      betId: betlinkIds[0],
      betName: ride.horse.name,
      odds: ride.betting.current_odds,
      eachWay: props.eachWay, // only relevant for feature "integrated-betslip"
      suspended: props.suspended, // only relevant for feature "integrated-betslip"
      fixture: props.fixture, // only relevant for feature "integrated-betslip"
      startingPriceAvailable: ride.has_sp // only relevant for feature "integrated-betslip"
    };
  }

  __webpack_require__(1427);
  return _react2.default.createElement(
    'div',
    { key: ride.horse.horse_reference.id, className: 'next-race-off-list-item' },
    _react2.default.createElement(
      'div',
      { className: 'next-race-off-saddle-stall-info' },
      _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'span',
          { className: 'next-race-off-saddle-cloth-no' },
          ride.cloth_number || 0
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'span',
          { className: 'next-race-off-stall-no' },
          '(',
          ride.draw_number || 0,
          ')'
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'next-race-off-silks' },
      _react2.default.createElement(_Silk2.default, { filename: ride.silk_filename })
    ),
    _react2.default.createElement(
      'div',
      { className: 'next-race-off-names' },
      _react2.default.createElement(
        'div',
        { className: 'next-race-off-horse' },
        ride.horse.name || "Unknown"
      ),
      _react2.default.createElement(
        'div',
        { className: 'next-race-off-jockey' },
        _react2.default.createElement(
          'b',
          null,
          'J:'
        ),
        ' ',
        ride.jockey.name || "Unknown"
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'next-race-off-betting-odds' },
      !!betLinkProps && _react2.default.createElement(
        _BetLink2.default,
        (0, _extends3.default)({ className: 'next-race-off-betting-link sui-odds' }, betLinkProps),
        betLinkProps.odds
      )
    )
  );
}

HorseRacingNextRaceLine.propTypes = {
  ride: _propTypes2.default.shape({
    horse: _propTypes2.default.shape({
      horse_reference: _propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired
      }).isRequired,
      name: _propTypes2.default.string
    }).isRequired,
    cloth_number: _propTypes2.default.number,
    draw_number: _propTypes2.default.number,
    jockey: _propTypes2.default.shape({
      name: _propTypes2.default.string
    }).isRequired,
    betting: _propTypes2.default.shape({
      current_odds: _propTypes2.default.string,
      market_reference: _propTypes2.default.shape({
        external_reference: _propTypes2.default.arrayOf(_propTypes2.default.shape({
          value: _propTypes2.default.string
        }))
      })
    })
  }).isRequired,
  raceSummary: _propTypes2.default.shape({
    date: _propTypes2.default.string,
    time: _propTypes2.default.string,
    course_name: _propTypes2.default.string
  }),
  eachWay: _propTypes2.default.object,
  suspended: _propTypes2.default.bool,
  fixture: _propTypes2.default.string,
  raceExternalId: _propTypes2.default.string
};

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HorseRacingNonRunners;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _reactRouter = __webpack_require__(11);

var _CollapsibleSection = __webpack_require__(99);

var _CollapsibleSection2 = _interopRequireDefault(_CollapsibleSection);

var _LocalDateTimeHelper = __webpack_require__(13);

var _utils = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HorseRacingNonRunners(props) {
  __webpack_require__(1428);

  var title = "Today's Non-Runners";

  return _react2.default.createElement(
    'div',
    { className: 'horse-racing-non-runners' },
    _react2.default.createElement(_MetaDataWrapper2.default, { title: title }),
    _react2.default.createElement(
      'h1',
      { className: 'page-main-title' },
      title
    ),
    _react2.default.createElement(
      'section',
      { className: 'hr-nr-meetings' },
      props.meetings && props.meetings.length > 0 ? props.meetings.map(function (_ref) {
        var races = _ref.races,
            _ref$meeting_summary = _ref.meeting_summary,
            meetingId = _ref$meeting_summary.meeting_reference.id,
            meetingDate = _ref$meeting_summary.date,
            _ref$meeting_summary$ = _ref$meeting_summary.course,
            courseName = _ref$meeting_summary$.name,
            feed_source = _ref$meeting_summary$.feed_source;

        var courseNameSlug = (0, _utils.toSlug)(courseName);

        var meetingPageUrl = '/racing/meeting/' + meetingDate + '/' + courseNameSlug + '/' + meetingId;

        return _react2.default.createElement(
          _CollapsibleSection2.default,
          { key: meetingId, feedLogo: feed_source, title: courseName, linkTo: meetingPageUrl },
          races.map(function (_ref2) {
            var _ref2$race_summary = _ref2.race_summary,
                raceId = _ref2$race_summary.race_summary_reference.id,
                time = _ref2$race_summary.time,
                date = _ref2$race_summary.date,
                raceName = _ref2$race_summary.name,
                rides = _ref2.rides;
            return _react2.default.createElement(
              'div',
              { key: raceId, className: 'hr-nr-race' },
              _react2.default.createElement(
                'div',
                { className: 'hr-nr-race-time' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/racing/racecards/' + meetingDate + '/' + courseNameSlug + '/racecard/' + raceId + '/' + (0, _utils.toSlug)(raceName) },
                  (0, _LocalDateTimeHelper.localTimeShort)(date + 'T' + time + 'Z')
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'hr-nr-race-rides' },
                rides.map(function (_ref3) {
                  var rideId = _ref3.ride_reference.id,
                      cloth_number = _ref3.cloth_number,
                      _ref3$horse = _ref3.horse,
                      horseId = _ref3$horse.horse_reference.id,
                      horseName = _ref3$horse.name;

                  return _react2.default.createElement(
                    'span',
                    { className: 'hr-nr-race-ride', key: rideId },
                    cloth_number,
                    ' ',
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/racing/profiles/horse/' + horseId },
                      horseName
                    )
                  );
                })
              )
            );
          })
        );
      }) : _react2.default.createElement(
        'div',
        { className: 'hr-racing-racecards-none' },
        _react2.default.createElement(
          'p',
          null,
          'No meetings found'
        )
      )
    )
  );
}

HorseRacingNonRunners.propTypes = {
  meetings: _propTypes2.default.array
};

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _HorseRacingAbcPersonEntry = __webpack_require__(904);

var _HorseRacingAbcPersonEntry2 = _interopRequireDefault(_HorseRacingAbcPersonEntry);

var _compare = __webpack_require__(118);

var _consts = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingPersonAbcTable = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingPersonAbcTable, _Component);

  function HorseRacingPersonAbcTable() {
    (0, _classCallCheck3.default)(this, HorseRacingPersonAbcTable);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingPersonAbcTable.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingPersonAbcTable)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingPersonAbcTable, [{
    key: 'groupBy',
    value: function groupBy(entries, getId) {
      var groupedEntries = [];

      entries.map(function (entry) {
        var entryId = getId(entry);

        if (!groupedEntries[entryId]) {
          groupedEntries[entryId] = [];
        }

        groupedEntries[entryId].push(entry);
      });

      return groupedEntries;
    }
  }, {
    key: 'groupByJockey',
    value: function groupByJockey(entries) {
      var _this2 = this;

      var jockeys = this.groupBy(entries, function (entry) {
        return _this2.entryId(entry, "jockeys");
      });
      var nonReservedJockeys = jockeys.filter(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
            first_names = _ref2[0].ride.jockey.first_names;

        return first_names !== "Reserve";
      });
      return nonReservedJockeys.sort(function () {
        for (var _len = arguments.length, items = Array(_len), _key = 0; _key < _len; _key++) {
          items[_key] = arguments[_key];
        }

        return _compare.compareStrings.apply(undefined, (0, _toConsumableArray3.default)(items.map(function (_ref3) {
          var _ref4 = (0, _slicedToArray3.default)(_ref3, 1),
              last_name = _ref4[0].ride.jockey.last_name;

          return last_name;
        })));
      });
    }
  }, {
    key: 'groupByTrainer',
    value: function groupByTrainer(entries) {
      var _this3 = this;

      var trainers = this.groupBy(entries, function (entry) {
        return _this3.entryId(entry, "trainers");
      });
      return trainers.sort(function () {
        for (var _len2 = arguments.length, items = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          items[_key2] = arguments[_key2];
        }

        return _compare.compareStrings.apply(undefined, (0, _toConsumableArray3.default)(items.map(function (_ref5) {
          var _ref6 = (0, _slicedToArray3.default)(_ref5, 1),
              last_name = _ref6[0].ride.trainer.last_name;

          return last_name;
        })));
      });
    }
  }, {
    key: 'entryId',
    value: function entryId(_ref7, tableType) {
      var _ref7$ride = _ref7.ride;
      _ref7$ride = _ref7$ride === undefined ? {} : _ref7$ride;
      var _ref7$ride$jockey = _ref7$ride.jockey;
      _ref7$ride$jockey = _ref7$ride$jockey === undefined ? {} : _ref7$ride$jockey;
      var _ref7$ride$jockey$per = _ref7$ride$jockey.person_reference;
      _ref7$ride$jockey$per = _ref7$ride$jockey$per === undefined ? {} : _ref7$ride$jockey$per;
      var _ref7$ride$jockey$per2 = _ref7$ride$jockey$per.id,
          jockeyId = _ref7$ride$jockey$per2 === undefined ? '' : _ref7$ride$jockey$per2,
          _ref7$ride$trainer = _ref7$ride.trainer;
      _ref7$ride$trainer = _ref7$ride$trainer === undefined ? {} : _ref7$ride$trainer;
      var _ref7$ride$trainer$bu = _ref7$ride$trainer.business_reference;
      _ref7$ride$trainer$bu = _ref7$ride$trainer$bu === undefined ? {} : _ref7$ride$trainer$bu;
      var _ref7$ride$trainer$bu2 = _ref7$ride$trainer$bu.id,
          trainerId = _ref7$ride$trainer$bu2 === undefined ? '' : _ref7$ride$trainer$bu2;

      return tableType == "jockeys" ? jockeyId : trainerId;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          entries = _props.rides,
          _props$tableType = _props.tableType,
          tableType = _props$tableType === undefined ? "jockeys" : _props$tableType;


      var groupedEntries = tableType == "jockeys" ? this.groupByJockey(entries) : this.groupByTrainer(entries);

      return _react2.default.createElement(
        'div',
        { className: 'horse-racing-abc-guide-content ' + tableType + 'Table' },
        _react2.default.createElement(
          'span',
          { className: 'abc-guide-person-row' },
          _react2.default.createElement(
            'div',
            { className: 'abc-guide-person-name jockey header' },
            'Jockey Name'
          ),
          _react2.default.createElement(
            'div',
            { className: 'abc-guide-person-name trainer header' },
            'Trainer Name'
          ),
          _react2.default.createElement('div', { className: 'abc-guide-my-stable header' }),
          _react2.default.createElement(
            'div',
            { className: 'abc-guide-todays-rides header' },
            tableType == "jockeys" ? _consts.TODAYS_RIDES_STRING : _consts.TODAYS_ENTRIES_STRING
          )
        ),
        groupedEntries.map(function (entry) {
          return _react2.default.createElement(_HorseRacingAbcPersonEntry2.default, { entry: entry, key: _this4.entryId(entry[0], tableType), tableType: tableType });
        })
      );
    }
  }]);
  return HorseRacingPersonAbcTable;
}(_react.Component), _class.propTypes = {
  rides: _propTypes2.default.array,
  tableType: _propTypes2.default.string
}, _temp);
exports.default = HorseRacingPersonAbcTable;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.default = HorseRacingRacePage;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _utils = __webpack_require__(32);

var _utils2 = __webpack_require__(18);

var _seoUtils = __webpack_require__(23);

var _LocalDateTimeHelper = __webpack_require__(13);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _Dropdown = __webpack_require__(100);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _SwitchBtns = __webpack_require__(102);

var _SwitchBtns2 = _interopRequireDefault(_SwitchBtns);

var _CaretLink = __webpack_require__(54);

var _CaretLink2 = _interopRequireDefault(_CaretLink);

var _consts = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1429);

function HorseRacingRacePage(props) {
  var children = props.children,
      params = props.params,
      routes = props.routes,
      resultRacecard = props.route["result-racecard"],
      raceMeeting = props.meeting,
      _props$meeting = props.meeting;
  _props$meeting = _props$meeting === undefined ? {} : _props$meeting;
  var _props$meeting$meetin = _props$meeting.meeting;
  _props$meeting$meetin = _props$meeting$meetin === undefined ? [] : _props$meeting$meetin;

  var _props$meeting$meetin2 = (0, _slicedToArray3.default)(_props$meeting$meetin, 1),
      _props$meeting$meetin3 = _props$meeting$meetin2[0];

  _props$meeting$meetin3 = _props$meeting$meetin3 === undefined ? {} : _props$meeting$meetin3;
  var _props$meeting$meetin4 = _props$meeting$meetin3.meeting_summary;
  _props$meeting$meetin4 = _props$meeting$meetin4 === undefined ? {} : _props$meeting$meetin4;
  var _props$meeting$meetin5 = _props$meeting$meetin4.meeting_reference;
  _props$meeting$meetin5 = _props$meeting$meetin5 === undefined ? {} : _props$meeting$meetin5;
  var meetingId = _props$meeting$meetin5.id,
      race = props.race,
      _props$race$race_summ = props.race.race_summary,
      raceTime = _props$race$race_summ.time,
      _props$race$race_summ2 = _props$race$race_summ.course_name,
      courseName = _props$race$race_summ2 === undefined ? '' : _props$race$race_summ2,
      dateLong = _props$race$race_summ.date,
      _props$race$race_summ3 = _props$race$race_summ.name,
      raceName = _props$race$race_summ3 === undefined ? '' : _props$race$race_summ3,
      raceStage = _props$race$race_summ.race_stage,
      raceId = _props$race$race_summ.race_summary_reference.id,
      _props$meetings = props.meetings;
  _props$meetings = _props$meetings === undefined ? {} : _props$meetings;
  var _props$meetings$meeti = _props$meetings.meetings,
      meetings = _props$meetings$meeti === undefined ? [] : _props$meetings$meeti,
      tipsArticle = props.tipsArticle;


  var isOnRaceCard = resultRacecard == "racecard";
  var dropdownHref = void 0;

  if (isOnRaceCard) {
    dropdownHref = function dropdownHref(date, course_name, race_id, race_name) {
      return (0, _utils.racecardHref)({ date: date, course_name: course_name, race_id: race_id, race_name: race_name });
    };
  } else {
    dropdownHref = function dropdownHref(date, course_name, race_id, race_name) {
      return (0, _utils.resultHref)({ date: date, course_name: course_name, race_id: race_id, race_name: race_name });
    };
  }

  var meetingsOnThisDay = meetings.map(function (_ref) {
    var _ref$meeting_summary$ = _ref.meeting_summary.course.name,
        courseName = _ref$meeting_summary$ === undefined ? '' : _ref$meeting_summary$,
        _ref$races = (0, _slicedToArray3.default)(_ref.races, 1),
        _ref$races$ = _ref$races[0],
        _ref$races$$name = _ref$races$.name,
        raceName = _ref$races$$name === undefined ? '' : _ref$races$$name,
        raceId = _ref$races$.race_summary_reference.id;

    return {
      href: dropdownHref(dateLong, courseName, raceId, raceName),
      text: courseName
    };
  });

  var londonRaceTime = (0, _LocalDateTimeHelper.localTimeShort)(dateLong + 'T' + raceTime + 'Z');
  var courseNameSlug = (0, _utils2.toSlug)(courseName);
  var helmetDate = (0, _LocalDateTimeHelper.localFullDateNoDay)(dateLong || new Date());
  var headingDate = (0, _LocalDateTimeHelper.localFullDateLong)(dateLong || new Date());

  var helmetRaceLabel = londonRaceTime + ' ' + courseName + ' - ' + helmetDate;

  var switchBtnHref = function switchBtnHref(page) {
    return '/racing/racecards/' + dateLong + '/' + courseNameSlug + '/' + page + '/' + raceId + '/' + (0, _utils2.toSlug)(raceName);
  };

  var canonicalParams = {
    date: dateLong,
    courseSlug: (0, _utils2.toSlug)(courseName),
    raceId: raceId,
    raceSlug: (0, _utils2.toSlug)(raceName)
  };

  var cloneProps = {
    race: race,
    meeting: raceMeeting,
    tipsArticle: tipsArticle,
    helmetRaceLabel: helmetRaceLabel
  };

  var isComplete = _consts.HORSE_RACE_COMPLETE_STATUSES.includes(raceStage);

  cloneProps.params = params;
  var showButtons = !isComplete && isOnRaceCard;
  var addProps = {
    location: "/racing/racecards",
    view: "racecard"
  };

  return _react2.default.createElement(
    'div',
    { className: 'hr-racing-racecard-wrapper' },
    _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: (0, _extends3.default)({}, (0, _seoUtils.canonicalLink)(routes, canonicalParams)) }),
    _react2.default.createElement(
      'section',
      { className: 'hr-racing-racecard-top-section' },
      _react2.default.createElement(
        'div',
        { className: 'dropdown-wrapper' },
        _react2.default.createElement(_Dropdown2.default, { title: 'Meetings', options: meetingsOnThisDay, shouldNavigate: true })
      ),
      showButtons && _react2.default.createElement(_SwitchBtns2.default, { buttons: [{ href: switchBtnHref('racecard'), text: 'Racecard', isIndex: true }, { href: switchBtnHref('live-show'), text: 'Live Show' }] }),
      _react2.default.createElement(
        'div',
        { className: 'hr-racing-racecard-heading' },
        _react2.default.createElement(
          'div',
          { className: 'hr-racing-racecard-heading-text' },
          _react2.default.createElement(
            'h1',
            null,
            londonRaceTime,
            '\xA0',
            courseName,
            ' ',
            _react2.default.createElement(
              'small',
              null,
              headingDate
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'hr-racing-racecard-heading-link' },
          _react2.default.createElement(
            _CaretLink2.default,
            { to: '/racing/fast-cards/' + meetingId + '/' + dateLong + '/' + courseNameSlug },
            'Fast Cards'
          )
        ),
        !isComplete && _react2.default.createElement(
          'div',
          { className: 'hr-racing-racecard-status' },
          (0, _utils.raceStatusLabel)(raceStage)
        )
      )
    ),
    children && _react2.default.cloneElement(children, cloneProps),
    _react2.default.createElement(_AdvertWrapper2.default, { ocSlot: ["racing", "leaderboard"], additionalProperties: addProps })
  );
}

HorseRacingRacePage.propTypes = {
  route: _propTypes2.default.object,
  params: _propTypes2.default.object,
  routes: _propTypes2.default.array.isRequired,
  race: _propTypes2.default.object.isRequired,
  meeting: _propTypes2.default.object,
  meetings: _propTypes2.default.object,
  children: _propTypes2.default.node,
  tipsArticle: _propTypes2.default.object
};

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HorseRacingRacecardLastYearsWinners;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _CaretLink = __webpack_require__(54);

var _CaretLink2 = _interopRequireDefault(_CaretLink);

var _CompactText = __webpack_require__(162);

var _CompactText2 = _interopRequireDefault(_CompactText);

var _utils = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1430);

function HorseRacingRacecardLastYearsWinners(props) {

  var lastYearsWinners = props.lastYearsWinners;
  return lastYearsWinners && lastYearsWinners.length ? _react2.default.createElement(
    'table',
    { className: 'hr-last-years-winners-table' },
    _react2.default.createElement(
      'thead',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'th',
          { className: 'draw-number' },
          'DRAW'
        ),
        _react2.default.createElement(
          'th',
          { className: 'horse-name' },
          'HORSE'
        ),
        _react2.default.createElement(
          'th',
          { className: 'horse-age' },
          'A'
        ),
        _react2.default.createElement(
          'th',
          { className: 'weight' },
          'WGT'
        ),
        _react2.default.createElement(
          'th',
          { className: 'starting-price' },
          'SP'
        ),
        _react2.default.createElement('th', { className: 'full-result-link' })
      )
    ),
    lastYearsWinners.map(function (previousWinner) {
      var drawNumber = previousWinner.draw_number,
          _previousWinner$horse = previousWinner.horse;
      _previousWinner$horse = _previousWinner$horse === undefined ? {} : _previousWinner$horse;
      var horseName = _previousWinner$horse.name,
          age = _previousWinner$horse.age,
          _previousWinner$horse2 = _previousWinner$horse.horse_reference;
      _previousWinner$horse2 = _previousWinner$horse2 === undefined ? {} : _previousWinner$horse2;
      var horseId = _previousWinner$horse2.id,
          odds = previousWinner.odds,
          _previousWinner$race_ = previousWinner.race_summary;
      _previousWinner$race_ = _previousWinner$race_ === undefined ? {} : _previousWinner$race_;
      var raceName = _previousWinner$race_.name,
          _previousWinner$race_2 = _previousWinner$race_.race_summary_reference;
      _previousWinner$race_2 = _previousWinner$race_2 === undefined ? {} : _previousWinner$race_2;
      var raceId = _previousWinner$race_2.id,
          weight = previousWinner.weight,
          _previousWinner$jocke = previousWinner.jockey;
      _previousWinner$jocke = _previousWinner$jocke === undefined ? {} : _previousWinner$jocke;
      var jockeyName = _previousWinner$jocke.name,
          _previousWinner$jocke2 = _previousWinner$jocke.person_reference;
      _previousWinner$jocke2 = _previousWinner$jocke2 === undefined ? {} : _previousWinner$jocke2;
      var jockeyId = _previousWinner$jocke2.id,
          _previousWinner$train = previousWinner.trainer;
      _previousWinner$train = _previousWinner$train === undefined ? {} : _previousWinner$train;
      var trainerName = _previousWinner$train.name,
          _previousWinner$train2 = _previousWinner$train.business_reference;
      _previousWinner$train2 = _previousWinner$train2 === undefined ? {} : _previousWinner$train2;
      var trainerId = _previousWinner$train2.id,
          _previousWinner$meeti = previousWinner.meeting_summary;
      _previousWinner$meeti = _previousWinner$meeti === undefined ? {} : _previousWinner$meeti;
      var meetingDate = _previousWinner$meeti.date,
          _previousWinner$meeti2 = _previousWinner$meeti.course;
      _previousWinner$meeti2 = _previousWinner$meeti2 === undefined ? {} : _previousWinner$meeti2;
      var courseName = _previousWinner$meeti2.name;

      return _react2.default.createElement(
        'tbody',
        { key: drawNumber + ':' + horseName },
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            null,
            drawNumber
          ),
          _react2.default.createElement(
            'td',
            null,
            horseId ? _react2.default.createElement(
              _reactRouter.Link,
              { to: '/racing/profiles/horse/' + horseId },
              horseName
            ) : horseName
          ),
          _react2.default.createElement(
            'td',
            null,
            age
          ),
          _react2.default.createElement(
            'td',
            null,
            weight
          ),
          _react2.default.createElement(
            'td',
            null,
            odds
          ),
          _react2.default.createElement(
            'td',
            { className: 'hr-last-years-winners-full-results' },
            meetingDate && courseName && raceId && raceName && _react2.default.createElement(
              _CaretLink2.default,
              { to: '/racing/results/' + meetingDate + '/' + (0, _utils.toSlug)(courseName) + '/' + raceId + '/' + (0, _utils.toSlug)(raceName) },
              _react2.default.createElement(
                _CompactText2.default,
                { compactText: 'Result' },
                'Full Result'
              )
            )
          )
        ),
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { colSpan: '5' },
            _react2.default.createElement(
              'span',
              { className: 'hr-last-years-winners-trainer-name' },
              'T:\xA0',
              trainerId ? _react2.default.createElement(
                _reactRouter.Link,
                { to: '/racing/profiles/trainer/' + trainerId },
                trainerName
              ) : trainerName
            ),
            _react2.default.createElement(
              'span',
              { className: 'hr-last-years-winners-jockey-name' },
              'J:\xA0',
              jockeyId ? _react2.default.createElement(
                _reactRouter.Link,
                { to: '/racing/profiles/jockey/' + jockeyId },
                jockeyName
              ) : jockeyName
            )
          ),
          _react2.default.createElement('td', null)
        )
      );
    })
  ) : _react2.default.createElement(
    'div',
    { className: 'hr-racing-racecard-section-body' },
    'Last year\'s winner is unavailable'
  );
}

HorseRacingRacecardLastYearsWinners.propTypes = {
  lastYearsWinners: _propTypes2.default.array
};

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Silk = __webpack_require__(113);

var _Silk2 = _interopRequireDefault(_Silk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(513);

var HorseRacingRacecardNonRunner = function (_Component) {
  (0, _inherits3.default)(HorseRacingRacecardNonRunner, _Component);

  function HorseRacingRacecardNonRunner(props) {
    (0, _classCallCheck3.default)(this, HorseRacingRacecardNonRunner);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingRacecardNonRunner.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingRacecardNonRunner)).call(this, props));
  }

  (0, _createClass3.default)(HorseRacingRacecardNonRunner, [{
    key: 'render',
    value: function render() {
      var nonRunner = this.props.nonRunner;


      return _react2.default.createElement(
        'section',
        { className: 'hr-racing-nonrunner-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'hr-racing-nonrunner-key-info-container' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-nonrunner-saddle-stall-info' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-nonrunner-saddle-cloth-no' },
                nonRunner.saddleClothNo
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-nonrunner-stall-no' },
                nonRunner.drawNumber
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-nonrunner-silks' },
            _react2.default.createElement(_Silk2.default, { filename: nonRunner.silkFilename })
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-nonrunner-horse-info' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-nonrunner-horse-name' },
                nonRunner.horseName,
                _react2.default.createElement(
                  'sup',
                  { className: 'hr-racing-nonrunner-horse-last-ran' },
                  nonRunner.horseLastRan
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'hr-racing-nonrunner-horse-sub-info' },
                nonRunner.horseAge && _react2.default.createElement(
                  'span',
                  null,
                  nonRunner.horseAge
                ),
                nonRunner.weight && _react2.default.createElement(
                  'span',
                  null,
                  nonRunner.weight
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  'OR:\xA0',
                  nonRunner.officialRating ? nonRunner.officialRating : '-'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-nonrunner-betting-odds' },
            _react2.default.createElement(
              'button',
              { className: 'hr-racing-nonrunner-betting-button disabled' },
              nonRunner.status === 'WITHDRAWN' ? 'WD' : 'NR'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'hr-racing-nonrunner-form-history-container' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-nonrunner-form-key-info' },
            _react2.default.createElement(
              'span',
              { className: 'hr-racing-nonrunner-form-trainer' },
              'T:\xA0',
              _react2.default.createElement(
                'span',
                null,
                nonRunner.trainer.name
              )
            ),
            _react2.default.createElement(
              'span',
              { className: 'hr-racing-nonrunner-form-jockey' },
              'J:\xA0',
              _react2.default.createElement(
                'span',
                null,
                nonRunner.jockey.name
              )
            )
          )
        )
      );
    }
  }]);
  return HorseRacingRacecardNonRunner;
}(_react.Component);

exports.default = HorseRacingRacecardNonRunner;


HorseRacingRacecardNonRunner.propTypes = {
  nonRunner: _propTypes2.default.object
};

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _utils = __webpack_require__(18);

var _LocalDateTimeHelper = __webpack_require__(13);

var _seoUtils = __webpack_require__(23);

var _consts = __webpack_require__(46);

var _Tabs = __webpack_require__(70);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _RaceJSONLD = __webpack_require__(201);

var _RaceJSONLD2 = _interopRequireDefault(_RaceJSONLD);

var _HorseRacingRacecardSummary = __webpack_require__(929);

var _HorseRacingRacecardSummary2 = _interopRequireDefault(_HorseRacingRacecardSummary);

var _HorseRacingRacecardPreRace = __webpack_require__(925);

var _HorseRacingRacecardPreRace2 = _interopRequireDefault(_HorseRacingRacecardPreRace);

var _HorseRacingRacecardPostRace = __webpack_require__(924);

var _HorseRacingRacecardPostRace2 = _interopRequireDefault(_HorseRacingRacecardPostRace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function racecardUrl(dateLong, meetingCourseName, raceId, raceName) {
  return '/racing/racecards/' + dateLong + '/' + (0, _utils.toSlug)(meetingCourseName) + '/racecard/' + raceId + '/' + (0, _utils.toSlug)(raceName);
}

function resultUrl(dateLong, meetingCourseName, raceId, raceName) {
  return '/racing/results/' + dateLong + '/' + (0, _utils.toSlug)(meetingCourseName) + '/' + raceId + '/' + (0, _utils.toSlug)(raceName);
}

var HorseRacingRacecardPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingRacecardPage, _Component);

  function HorseRacingRacecardPage() {
    var _ref;

    (0, _classCallCheck3.default)(this, HorseRacingRacecardPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = HorseRacingRacecardPage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingRacecardPage)).call.apply(_ref, [this].concat(args)));

    _this.state = {
      haveCurrentOdds: _this.ridesHaveCurrentOdds(_this.props),
      sortOrder: "cloth"
    };
    return _this;
  }

  (0, _createClass3.default)(HorseRacingRacecardPage, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        haveCurrentOdds: this.ridesHaveCurrentOdds(nextProps)
      });
    }
  }, {
    key: 'ridesHaveCurrentOdds',
    value: function ridesHaveCurrentOdds(_ref2) {
      var rides = _ref2.race.rides;

      var runners = rides.filter(function (ride) {
        return ride.ride_status == "RUNNER";
      });
      var haveCurrentOdds = runners.map(function (runner) {
        return runner.betting.current_odds;
      }).some(function (r) {
        return r;
      });

      return haveCurrentOdds;
    }
  }, {
    key: 'setSortOrder',
    value: function setSortOrder(sortOrder) {
      this.setState({
        sortOrder: sortOrder
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          params = _props.params,
          showComponent = _props.route["result-racecard"],
          race = _props.race,
          tipsArticle = _props.tipsArticle,
          _props$race = _props.race,
          raceSummary = _props$race.race_summary,
          _props$race$race_summ = _props$race.race_summary,
          dateLong = _props$race$race_summ.date,
          raceName = _props$race$race_summ.name,
          raceStage = _props$race$race_summ.race_stage,
          _props$race$race_summ2 = _props$race$race_summ.race_summary_reference;
      _props$race$race_summ2 = _props$race$race_summ2 === undefined ? {} : _props$race$race_summ2;
      var singleRaceId = _props$race$race_summ2.id,
          _props$race$videos = _props$race.videos,
          raceVideos = _props$race$videos === undefined ? [] : _props$race$videos,
          prizes = _props$race.prizes.prize,
          stewards = _props$race.stewards,
          helmetRaceLabel = _props.helmetRaceLabel,
          _props$meeting = _props.meeting;
      _props$meeting = _props$meeting === undefined ? {} : _props$meeting;

      var _props$meeting$meetin = (0, _slicedToArray3.default)(_props$meeting.meeting, 1),
          singleMeeting = _props$meeting$meetin[0],
          _props$meeting$meetin2 = (0, _slicedToArray3.default)(_props$meeting.meeting, 1),
          _props$meeting$meetin3 = _props$meeting$meetin2[0];

      _props$meeting$meetin3 = _props$meeting$meetin3 === undefined ? {} : _props$meeting$meetin3;
      var _props$meeting$meetin4 = _props$meeting$meetin3.meeting_summary.course.name,
          meetingCourseName = _props$meeting$meetin4 === undefined ? 'unknown' : _props$meeting$meetin4,
          _props$meeting$meetin5 = _props$meeting$meetin3.races,
          meetingRaces = _props$meeting$meetin5 === undefined ? [] : _props$meeting$meetin5;


      var tabHref = void 0;
      var metaDesc = void 0;
      var isComplete = _consts.HORSE_RACE_COMPLETE_STATUSES.includes(raceStage);
      var pageTitle = [helmetRaceLabel];

      var cardProps = { race: race, isComplete: isComplete, params: params };
      var summaryProps = { raceSummary: raceSummary, prizes: prizes, isComplete: isComplete, params: params, stewards: stewards };
      var cardType = showComponent == "result" ? 'result' : 'racecard';
      var provider = this.props.meeting.meeting.length > 0 ? this.props.meeting.meeting[0].meeting_summary.course.feed_source : 'unknown';

      if (showComponent == "result") {
        tabHref = resultUrl;
        pageTitle.push("Result");
        if (raceVideos.length === 0) {
          metaDesc = 'Full result from the ' + raceName + ' at ' + meetingCourseName;
        } else {
          metaDesc = 'Full result with video replay from the ' + raceName + ' at ' + meetingCourseName;
        }
      } else {
        tabHref = racecardUrl;
        pageTitle.push("Racecard");
        metaDesc = raceName + ' racecard with form, betting forecast and the Sporting Life verdict';

        var _state = this.state,
            haveCurrentOdds = _state.haveCurrentOdds,
            sortOrder = _state.sortOrder;


        summaryProps.sortOptions = [{ text: "Cloth number", value: "cloth" }, { text: "Horse A-Z", value: "horse" }];

        if (haveCurrentOdds) {
          summaryProps.sortOptions.splice(1, 0, { text: "Odds", value: "odds" });
        }

        summaryProps.setSortOrder = function (value) {
          return _this2.setSortOrder(value);
        };
        summaryProps.sortOrder = cardProps.sortOrder = sortOrder;
      }

      var tabs = meetingRaces.map(function (_ref3) {
        var raceId = _ref3.race_summary_reference.id,
            _ref3$name = _ref3.name,
            raceName = _ref3$name === undefined ? 'unknown' : _ref3$name,
            raceDate = _ref3.date,
            raceTime = _ref3.time;
        return {
          href: tabHref(dateLong, meetingCourseName, raceId, raceName),
          text: (0, _LocalDateTimeHelper.localTimeShort)(raceDate + 'T' + raceTime + 'Z')
        };
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_RaceJSONLD2.default, { meeting: singleMeeting, sport: 'racing', type: cardType, raceId: singleRaceId }),
        _react2.default.createElement(_MetaDataWrapper2.default, { title: pageTitle.join(" - "), helmetProps: (0, _extends3.default)({}, (0, _seoUtils.metaDescription)(metaDesc)) }),
        _react2.default.createElement(
          'section',
          { className: 'hr-racing-racecard-section' },
          _react2.default.createElement(_Tabs2.default, { tabs: tabs }),
          _react2.default.createElement(_HorseRacingRacecardSummary2.default, summaryProps)
        ),
        showComponent == "result" ? _react2.default.createElement(_HorseRacingRacecardPostRace2.default, (0, _extends3.default)({}, cardProps, { provider: provider })) : _react2.default.createElement(_HorseRacingRacecardPreRace2.default, (0, _extends3.default)({}, cardProps, { tipsArticle: tipsArticle }))
      );
    }
  }]);
  return HorseRacingRacecardPage;
}(_react.Component), _class.propTypes = {
  route: _propTypes2.default.object,
  params: _propTypes2.default.object,
  race: _propTypes2.default.object,
  meeting: _propTypes2.default.object,
  helmetRaceLabel: _propTypes2.default.string,
  tipsArticle: _propTypes2.default.object,
  raceId: _propTypes2.default.object
}, _temp);
exports.default = HorseRacingRacecardPage;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HorseRacingRacecardPostRace;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _rideFilter = __webpack_require__(171);

var _RaceVideoPlayer = __webpack_require__(170);

var _RaceVideoPlayer2 = _interopRequireDefault(_RaceVideoPlayer);

var _HorseRacingRacecardResultRunner = __webpack_require__(928);

var _HorseRacingRacecardResultRunner2 = _interopRequireDefault(_HorseRacingRacecardResultRunner);

var _HorseRacingRacecardResultNonRunner = __webpack_require__(927);

var _HorseRacingRacecardResultNonRunner2 = _interopRequireDefault(_HorseRacingRacecardResultNonRunner);

var _CaretLink = __webpack_require__(54);

var _CaretLink2 = _interopRequireDefault(_CaretLink);

var _CurrencyFormatting = __webpack_require__(175);

var _utils = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hideNull(element) {
  return element ? element : '';
}

function bracket(element) {
  return element ? '(' + element + ')' : '';
}

function transformData(runners) {
  var hn = hideNull;
  return runners.map(function (runner) {
    return {
      key: runner.ride_reference.id,
      status: hn(runner.ride_status),
      saddleClothNo: hn(runner.cloth_number),
      drawNumber: bracket(runner.draw_number),
      position: hn(runner.amended_position || runner.finish_position),
      casualty: hn(runner.casualty),
      finishDistance: hn(runner.finish_distance),
      form: hn(runner.horse.formsummary.display_text),
      formWatch: hn(runner.formwatch),
      horseName: hn(runner.horse.name),
      horseId: hn(runner.horse.horse_reference.id),
      horseLastRan: hn(runner.horse.last_ran_days),
      horseAge: runner.horse.age,
      weight: hn(runner.handicap),
      rideDesc: hn(runner.ride_description),
      betMovements: runner.bet_movements,
      trainer: runner.trainer,
      jockey: runner.jockey,
      jockeyClaim: bracket(runner.jockey_claim),
      officialRating: hn(runner.official_rating),
      odds: hn(runner.betting.current_odds) + hn(runner.betting.favourite.betting_favourite),
      silkFilename: hn(runner.silk_filename)
    };
  });
}

function HorseRacingRacecardPostRace(props) {
  var _props$race = props.race,
      raceRunners = _props$race.rides,
      raceVideos = _props$race.videos,
      tote_win = _props$race.tote_win,
      place_win = _props$race.place_win,
      exacta_win = _props$race.exacta_win,
      trifecta = _props$race.trifecta,
      straight_forecast = _props$race.straight_forecast,
      tricast = _props$race.tricast,
      swingers = _props$race.swingers,
      _props$race$deduction = _props$race.deductions,
      deductions = _props$race$deduction === undefined ? [] : _props$race$deduction;


  var orderedByClothRaceRunners = raceRunners.sort(_rideFilter.sortByClothNo);
  var runners = (0, _rideFilter.filterRidesByStatus)(raceRunners, "RUNNER");
  var nonRunners = (0, _rideFilter.filterRidesByStatus)(orderedByClothRaceRunners, "WITHDRAWN", "NONRUNNER");

  var placedRunners = (0, _rideFilter.filterRidesByPlacedStatus)(runners).sort(_rideFilter.sortByFinishPosition);
  var alsoRanRunners = (0, _rideFilter.filterRidesByAlsoRan)(runners).sort(_rideFilter.sortByClothNo);
  // Any horse who was a runner but had a finish position of 0 did not finish.
  var casualties = (0, _rideFilter.filterRidesByCasualty)(runners).sort(_rideFilter.sortByClothNo);

  var hasToteBreakdown = !!(tote_win || place_win);
  var hasOtherBettingBreakdown = !!(exacta_win || trifecta || straight_forecast || tricast || swingers);
  var hasBettingBreakdown = hasToteBreakdown || hasOtherBettingBreakdown;

  var meetingProvider = props.provider ? props.provider.toLowerCase() : 'unknown';

  if (!props.isComplete) {
    return _react2.default.createElement(
      'div',
      { className: 'hr-result-race-not-complete' },
      _react2.default.createElement(
        'p',
        null,
        'There is no result yet for this race.'
      ),
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          _CaretLink2.default,
          { to: '/racing/racecards/' + props.params.date + '/' + props.params.courseSlug + '/racecard/' + props.params.raceId + '/' + props.params.raceSlug },
          'View the race card.'
        )
      )
    );
  }

  return _react2.default.createElement(
    'section',
    null,
    transformData(placedRunners).map(function (runner) {
      return _react2.default.createElement(_HorseRacingRacecardResultRunner2.default, { runner: runner, key: runner.key });
    }),
    !_lodash2.default.isEmpty(alsoRanRunners) && _react2.default.createElement(
      'section',
      null,
      _react2.default.createElement(
        'div',
        { className: 'hr-racing-racecard-section-header' },
        _react2.default.createElement(
          'h4',
          null,
          'Also Ran'
        )
      ),
      transformData(alsoRanRunners).map(function (alsoRan) {
        return _react2.default.createElement(_HorseRacingRacecardResultRunner2.default, { runner: alsoRan, key: alsoRan.key });
      })
    ),
    !_lodash2.default.isEmpty(casualties) && _react2.default.createElement(
      'section',
      null,
      _react2.default.createElement(
        'div',
        { className: 'hr-racing-racecard-section-header' },
        _react2.default.createElement(
          'h4',
          null,
          'Did Not Finish'
        )
      ),
      transformData(casualties).map(function (casualty) {
        return _react2.default.createElement(_HorseRacingRacecardResultRunner2.default, { runner: casualty, key: casualty.key });
      })
    ),
    !_lodash2.default.isEmpty(nonRunners) && _react2.default.createElement(
      'section',
      null,
      _react2.default.createElement(
        'div',
        { className: 'hr-racing-racecard-section-header' },
        _react2.default.createElement(
          'h4',
          null,
          'Non-Runners'
        )
      ),
      transformData(nonRunners).map(function (nonRunner) {
        return _react2.default.createElement(_HorseRacingRacecardResultNonRunner2.default, { nonRunner: nonRunner, key: nonRunner.key });
      })
    ),
    hasBettingBreakdown && _react2.default.createElement(
      'section',
      { className: 'hr-racing-racecard-betting-breakdown' },
      _react2.default.createElement(
        'div',
        { className: 'hr-racing-racecard-section-header' },
        _react2.default.createElement(
          'h4',
          null,
          'Betting Breakdown'
        )
      ),
      hasToteBreakdown && _react2.default.createElement(
        'div',
        { className: 'hr-racing-racecard-betting-breakdown-content' },
        _react2.default.createElement(
          OptionalData,
          { value: (0, _CurrencyFormatting.convertCurrencyString)(tote_win) },
          'Tote Win:'
        ),
        _react2.default.createElement(
          OptionalData,
          { value: (0, _CurrencyFormatting.convertCurrencyString)(place_win) },
          'Pl:'
        )
      ),
      hasOtherBettingBreakdown && _react2.default.createElement(
        'div',
        { className: 'hr-racing-racecard-betting-breakdown-content' },
        _react2.default.createElement(
          OptionalData,
          { value: (0, _CurrencyFormatting.convertCurrencyString)(exacta_win) },
          'EX:'
        ),
        _react2.default.createElement(
          OptionalData,
          { value: (0, _CurrencyFormatting.convertCurrencyString)(trifecta) },
          'Trifecta:'
        ),
        _react2.default.createElement(
          OptionalData,
          { value: (0, _CurrencyFormatting.convertCurrencyString)(straight_forecast) },
          'SF:'
        ),
        _react2.default.createElement(
          OptionalData,
          { value: (0, _CurrencyFormatting.convertCurrencyString)(tricast) },
          'Tricast:'
        ),
        _react2.default.createElement(
          OptionalData,
          { value: (0, _CurrencyFormatting.convertCurrencyString)(swingers) },
          'Swingers:'
        )
      )
    ),
    deductions && deductions.length > 0 && _react2.default.createElement(
      'section',
      { className: 'hr-racing-racecard-rule-four' },
      _react2.default.createElement(
        'div',
        { className: 'hr-racing-racecard-section-header' },
        _react2.default.createElement(
          'h4',
          null,
          'Rule 4'
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'hr-racing-racecard-rule-four-content' },
        deductions.map(function (deduction, index) {
          return _react2.default.createElement(
            'p',
            { key: index },
            (0, _utils.buildRuleFourString)(deduction)
          );
        })
      )
    ),
    (raceVideos && raceVideos.length > 0 || meetingProvider === 'atr') && _react2.default.createElement(
      'section',
      null,
      _react2.default.createElement(
        'div',
        { className: 'video-replay-wrapper' },
        _react2.default.createElement(
          'h4',
          { className: 'video-replay-title' },
          'Video Replay'
        ),
        _react2.default.createElement(_RaceVideoPlayer2.default, { videos: raceVideos, provider: meetingProvider })
      )
    )
  );
}

HorseRacingRacecardPostRace.propTypes = {
  isComplete: _propTypes2.default.bool,
  params: _propTypes2.default.object,
  race: _propTypes2.default.object.isRequired,
  meeting: _propTypes2.default.object,
  meetings: _propTypes2.default.object,
  provider: _propTypes2.default.string
};

function OptionalData(props) {
  return props.value ? _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(
      'span',
      { className: 'hr-racing-racecard-betting-breakdown-content-label' },
      props.children
    ),
    _react2.default.createElement(
      'span',
      { className: 'hr-racing-racecard-betting-breakdown-content-value' },
      props.value
    )
  ) : null;
}
OptionalData.propTypes = {
  value: _propTypes2.default.any,
  children: _propTypes2.default.node
};

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /* eslint react/no-danger: "off" */

// super safe cloth number sort

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactMetrics = __webpack_require__(69);

var _reactRouter = __webpack_require__(11);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _rideFilter = __webpack_require__(171);

var _OutLink = __webpack_require__(252);

var _OutLink2 = _interopRequireDefault(_OutLink);

var _PromoIcon = __webpack_require__(255);

var _PromoIcon2 = _interopRequireDefault(_PromoIcon);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _HorseRacingRacecardPreRaceNotification = __webpack_require__(926);

var _HorseRacingRacecardPreRaceNotification2 = _interopRequireDefault(_HorseRacingRacecardPreRaceNotification);

var _HorseRacingRacecardRunner = __webpack_require__(401);

var _HorseRacingRacecardRunner2 = _interopRequireDefault(_HorseRacingRacecardRunner);

var _HorseRacingRacecardNonRunner = __webpack_require__(922);

var _HorseRacingRacecardNonRunner2 = _interopRequireDefault(_HorseRacingRacecardNonRunner);

var _HorseRacingRacecardLastYearsWinners = __webpack_require__(921);

var _HorseRacingRacecardLastYearsWinners2 = _interopRequireDefault(_HorseRacingRacecardLastYearsWinners);

var _RaceVideoPlayer = __webpack_require__(170);

var _RaceVideoPlayer2 = _interopRequireDefault(_RaceVideoPlayer);

var _utils = __webpack_require__(32);

var _compare = __webpack_require__(118);

var _AnalyticsUtils = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingRacecardPreRace = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingRacecardPreRace, _Component);

  function HorseRacingRacecardPreRace(props) {
    (0, _classCallCheck3.default)(this, HorseRacingRacecardPreRace);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HorseRacingRacecardPreRace.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingRacecardPreRace)).call(this, props));

    _this.transformData = function (runners) {
      var hn = hideNull;

      return runners.map(function (runner) {
        var _runner$betting$marke = runner.betting.market_reference;
        _runner$betting$marke = _runner$betting$marke === undefined ? {} : _runner$betting$marke;
        var _runner$betting$marke2 = _runner$betting$marke.external_reference;
        _runner$betting$marke2 = _runner$betting$marke2 === undefined ? [] : _runner$betting$marke2;

        var _runner$betting$marke3 = (0, _slicedToArray3.default)(_runner$betting$marke2, 1),
            _runner$betting$marke4 = _runner$betting$marke3[0];

        _runner$betting$marke4 = _runner$betting$marke4 === undefined ? {} : _runner$betting$marke4;
        var marketId = _runner$betting$marke4.value;


        var medication = runner.medication ? runner.medication.reduce(function (meds, med) {
          if (med.short_name) {
            return [].concat((0, _toConsumableArray3.default)(meds), [med.short_name]);
          }
          return meds;
        }, []) : [];

        return {
          key: runner.ride_reference.id,
          status: hn(runner.ride_status),
          saddleClothNo: hn(runner.cloth_number),
          drawNumber: bracket(runner.draw_number),
          position: hn(runner.amended_position || runner.finish_position) + '  ' + bracket(runner.draw_number),
          form: hn(runner.horse.formsummary.display_text),
          commentary: hn(runner.commentary),
          formWatch: hn(runner.formwatch),
          headgear: hn(runner.headgear),
          raceHistoryStats: runner.race_history_stats,
          weightPenalty: hn(runner.weight_penalty),
          insights: hn(runner.insights),
          horse: runner.horse,
          horseName: hn(runner.horse.name),
          horseLastRan: hn(runner.horse.last_ran_days),
          horseAge: hn(runner.horse.age),
          weight: hn(runner.handicap),
          rideDesc: hn(runner.ride_description),
          rideBetlinkIds: hn(getSkyBetReferences(runner)),
          trainer: runner.trainer,
          jockey: runner.jockey,
          jockeyClaim: bracket(runner.jockey_claim),
          officialRating: hn(runner.official_rating),
          odds: hn(runner.betting.current_odds),
          marketId: marketId,
          silkFilename: hn(runner.silk_filename),
          startingPriceAvailable: runner.has_sp,
          medication: medication
        };
      });
    };

    _this.toggleFormExpanded = function (runnerId) {
      // if they're equal, its a toggle request
      if (_this.state.showFormExpanded === runnerId) {
        _this.setState({ showFormExpanded: null });
      } else {
        _this.setState({ showFormExpanded: runnerId });
      }
    };

    _this.state = {
      showFormExpanded: false
    };
    return _this;
  }

  // show last run video for runner with Id


  (0, _createClass3.default)(HorseRacingRacecardPreRace, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$race = _props.race;
      _props$race = _props$race === undefined ? {} : _props$race;
      var raceRunners = _props$race.rides,
          raceNaps = _props$race.naps,
          raceSummary = _props$race.race_summary,
          _props$race$race_summ = _props$race.race_summary,
          _props$race$race_summ2 = _props$race$race_summ.promotion;
      _props$race$race_summ2 = _props$race$race_summ2 === undefined ? {} : _props$race$race_summ2;
      var image = _props$race$race_summ2.image,
          title = _props$race$race_summ2.title,
          subtitle = _props$race$race_summ2.subtitle,
          redirect_url = _props$race$race_summ2.redirect_url,
          _props$race$race_summ3 = _props$race$race_summ2.external_link,
          external_link = _props$race$race_summ3 === undefined ? false : _props$race$race_summ3,
          race_stage = _props$race$race_summ.race_stage,
          raceVideos = _props$race.videos,
          bettingForecast = _props$race.betting_forecast,
          eachWay = _props$race.each_way,
          fixture = _props$race.fixture,
          suspended = _props$race.market_suspended,
          deductions = _props$race.deductions,
          lastYearsWinners = _props$race.last_years_winners,
          _props$tipsArticle = _props.tipsArticle;
      _props$tipsArticle = _props$tipsArticle === undefined ? {} : _props$tipsArticle;
      var articleWidgets = _props$tipsArticle.widgets,
          sortOrder = _props.sortOrder;


      switch (sortOrder) {
        case "horse":
          raceRunners.sort(_compare.sortByHorseName);
          break;
        case "odds":
          raceRunners.sort(_compare.sortByOdds);
          break;
        case "cloth":
        default:
          raceRunners.sort(_rideFilter.sortByClothNo);
          break;
      }

      var runners = (0, _rideFilter.filterRidesByStatus)(raceRunners, "RUNNER");
      var nonRunners = (0, _rideFilter.filterRidesByStatus)(raceRunners, "WITHDRAWN", "NONRUNNER", "DOUBTFUL");
      var hasSkyOdds = hasSkyBetFeedOdds(runners);

      var skybetRef = getReferences(raceSummary.race_summary_reference.external_reference);
      var eventRef = skybetRef.length > 0 ? skybetRef[0] : '';

      var articleBody;
      if (articleWidgets) {
        var widgetLen = articleWidgets.length;
        for (var i = 0; i < widgetLen; i++) {
          if (articleWidgets[i].widget_type === "TextArea") {
            // For initial release assumption is that there will only be one text/html widget
            articleBody = articleWidgets[i].keys[0].value;
            break;
          }
        }
      }

      var showPromo = !!(redirect_url && (0, _utils.isBeforeOffStatus)(race_stage));
      var insightsTrackingAttrs = (0, _AnalyticsUtils.trackClick)("insightsLinkClick", { link: "[Insights] Racecard Notification Link" });

      return _react2.default.createElement(
        'section',
        null,
        showPromo && _react2.default.createElement(
          _OutLink2.default,
          { className: 'hr-racecard-promo', to: redirect_url, isExternal: external_link },
          _react2.default.createElement(
            'span',
            { className: 'hr-racecard-promo-icon' },
            _react2.default.createElement(_PromoIcon2.default, { type: image })
          ),
          _react2.default.createElement(
            'span',
            { className: 'hr-racecard-promo-text' },
            _react2.default.createElement(
              'span',
              { className: 'hr-racecard-promo-title' },
              title
            ),
            _react2.default.createElement(
              'span',
              { className: 'hr-racecard-promo-subtitle' },
              subtitle
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'hr-racecard-promo-caret' },
            _react2.default.createElement(_CaretIcon2.default, { type: 'line', direction: 'right' })
          )
        ),
        _react2.default.createElement(
          _HorseRacingRacecardPreRaceNotification2.default,
          null,
          _react2.default.createElement(
            _reactMetrics.MetricsElement,
            null,
            _react2.default.createElement(
              'span',
              null,
              ' ',
              _react2.default.createElement(
                _reactRouter.Link,
                (0, _extends3.default)({}, insightsTrackingAttrs, { to: '/racing/insights' }),
                'Keep an eye out for \u2018Insights\u2019 against a horse for additional clues towards its chance! ',
                _react2.default.createElement(
                  'span',
                  { className: 'underline' },
                  'Read more...'
                )
              )
            )
          )
        ),
        this.transformData(runners).map(function (runner) {
          return _react2.default.createElement(_HorseRacingRacecardRunner2.default, {
            runner: runner,
            raceSummary: raceSummary,
            key: runner.key,
            eventRef: eventRef,
            videos: raceVideos,
            showExpandedForm: _this2.state.showFormExpanded === runner.key,
            toggleFormExpanded: _this2.toggleFormExpanded,
            eachWay: eachWay,
            fixture: fixture,
            suspended: suspended
          });
        }),
        !_lodash2.default.isEmpty(nonRunners) && _react2.default.createElement(
          'section',
          null,
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecard-section-header' },
            _react2.default.createElement(
              'h4',
              null,
              'Non-Runners'
            )
          ),
          this.transformData(nonRunners).map(function (nonRunner) {
            return _react2.default.createElement(_HorseRacingRacecardNonRunner2.default, { nonRunner: nonRunner, key: nonRunner.key });
          })
        ),
        _react2.default.createElement(
          'section',
          { className: 'hr-racing-racecard-section' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecard-section-header' },
            _react2.default.createElement(
              'h4',
              null,
              'Last Year\'s Winner'
            )
          ),
          _react2.default.createElement(_HorseRacingRacecardLastYearsWinners2.default, { lastYearsWinners: lastYearsWinners })
        ),
        (hasSkyOdds || bettingForecast) && _react2.default.createElement(
          'section',
          { className: 'hr-racing-racecard-section' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecard-section-header' },
            _react2.default.createElement(
              'h4',
              null,
              'Betting'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecard-section-body' },
            !hasSkyOdds && _react2.default.createElement(
              'h4',
              null,
              'Forecast'
            ),
            !hasSkyOdds && _react2.default.createElement(
              'p',
              null,
              bettingForecast
            ),
            hasSkyOdds && _react2.default.createElement(
              'p',
              null,
              constructBettingForecastOdds(runners)
            )
          )
        ),
        raceSummary.verdict && _react2.default.createElement(
          'section',
          { className: 'hr-racing-racecard-section' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecard-section-header' },
            _react2.default.createElement(
              'h4',
              null,
              'Verdict'
            )
          ),
          _react2.default.createElement('div', { className: 'hr-racing-racecard-section-body', dangerouslySetInnerHTML: { __html: raceSummary.verdict } })
        ),
        raceNaps && _react2.default.createElement(
          'section',
          { className: 'hr-racing-racecard-section' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecard-section-header' },
            _react2.default.createElement(
              'h4',
              null,
              'Naps'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecard-section-body' },
            raceNaps
          )
        ),
        articleBody && _react2.default.createElement(
          'section',
          { className: 'hr-racing-racecard-section' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecard-section-header' },
            _react2.default.createElement(
              'h4',
              null,
              'Tips'
            )
          ),
          _react2.default.createElement('div', { className: 'hr-racing-racecard-section-body', dangerouslySetInnerHTML: { __html: articleBody } })
        ),
        deductions && deductions.length > 0 && _react2.default.createElement(
          'section',
          { className: 'hr-racing-racecard-rule-four' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecard-section-header' },
            _react2.default.createElement(
              'h4',
              null,
              'Rule 4'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecard-rule-four-content' },
            deductions.map(function (deduction, index) {
              return _react2.default.createElement(
                'p',
                { key: index },
                (0, _utils.buildRuleFourString)(deduction)
              );
            })
          )
        ),
        raceVideos && raceVideos.length > 0 && _react2.default.createElement(
          'div',
          { className: 'video-replay-wrapper' },
          _react2.default.createElement(
            'h4',
            { className: 'video-replay-title' },
            'Video Replay'
          ),
          _react2.default.createElement(_RaceVideoPlayer2.default, { videos: raceVideos })
        )
      );
    }
  }]);
  return HorseRacingRacecardPreRace;
}(_react.Component), _class.propTypes = {
  sortOrder: _propTypes2.default.string,
  isComplete: _propTypes2.default.bool,
  params: _propTypes2.default.object,
  race: _propTypes2.default.object.isRequired,
  meeting: _propTypes2.default.object,
  meetings: _propTypes2.default.object,
  tipsArticle: _propTypes2.default.object
}, _temp);
exports.default = HorseRacingRacecardPreRace;


function constructBettingForecastOdds(runners) {
  var res = '';

  runners.sort(function (a, b) {
    var oddsA = a.betting.current_odds.split('/');
    var oddsB = b.betting.current_odds.split('/');
    return oddsA[0] / oddsA[1] - oddsB[0] / oddsB[1];
  });

  runners.forEach(function (runner) {
    res += runner.horse.name + ' (' + runner.betting.current_odds + ') ';
  });
  return res.trim();
}

function hasSkyBetFeedOdds(runners) {
  runners.forEach(function (runner) {
    if (getSkyBetReferences(runner).length > 0) {
      return true;
    }
  });
  return false;
}

var getSkyBetReferences = function getSkyBetReferences(runner) {
  return getReferences(runner.ride_reference.external_reference);
};

var getReferences = function getReferences(extRef) {
  return extRef.filter(function (r) {
    return r.ref === 'skybet';
  }).map(function (r) {
    return r.value;
  });
};

function hideNull(element) {
  return element ? element : '';
}

function bracket(element) {
  return element ? '(' + element + ')' : '';
}

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1431);

var HorseRacingRacecardPreRaceNotification = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(HorseRacingRacecardPreRaceNotification, _Component);

    function HorseRacingRacecardPreRaceNotification() {
        (0, _classCallCheck3.default)(this, HorseRacingRacecardPreRaceNotification);
        return (0, _possibleConstructorReturn3.default)(this, (HorseRacingRacecardPreRaceNotification.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingRacecardPreRaceNotification)).apply(this, arguments));
    }

    (0, _createClass3.default)(HorseRacingRacecardPreRaceNotification, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'section',
                { className: 'hr-racecard-notification-container' },
                _react2.default.createElement(
                    'span',
                    { className: 'hr-racecard-notification-message' },
                    _react2.default.createElement(
                        'b',
                        { className: 'hr-racecard-notification-message-highlight' },
                        'NEW!'
                    ),
                    this.props.children
                )
            );
        }
    }]);
    return HorseRacingRacecardPreRaceNotification;
}(_react.Component), _class.propTypes = {
    children: _propTypes2.default.node.isRequired
}, _temp);
exports.default = HorseRacingRacecardPreRaceNotification;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(512);

var HorseRacingRacecardResultNonRunner = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingRacecardResultNonRunner, _Component);

  function HorseRacingRacecardResultNonRunner(props) {
    (0, _classCallCheck3.default)(this, HorseRacingRacecardResultNonRunner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HorseRacingRacecardResultNonRunner.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingRacecardResultNonRunner)).call(this, props));

    _this.state = { expanded: false };
    return _this;
  }

  (0, _createClass3.default)(HorseRacingRacecardResultNonRunner, [{
    key: 'toggleExpanded',
    value: function toggleExpanded() {
      this.setState({ expanded: !this.state.expanded });
    }
  }, {
    key: 'render',
    value: function render() {
      var nonRunner = this.props.nonRunner;


      return _react2.default.createElement(
        'section',
        { className: 'hr-racing-runner-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'hr-racing-runner-position-container' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-position' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-nonrunner-position-no' },
                nonRunner.status === 'WITHDRAWN' ? 'WD' : 'NR'
              )
            )
          ),
          _react2.default.createElement('div', { className: 'hr-racing-runner-space-from-winner' }),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-nonrunner-cloth-no' },
            nonRunner.saddleClothNo
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-horse-info' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-nonrunner-horse-name' },
                nonRunner.horseName
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'hr-racing-nonrunner-horse-sub-info' },
                _react2.default.createElement(
                  'span',
                  null,
                  nonRunner.horseAge
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  nonRunner.weight
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-nonrunner-betting-odds' },
            _react2.default.createElement(
              'span',
              { className: 'hr-racing-runner-betting-info' },
              nonRunner.odds
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'hr-racing-nonrunner-form-history-container' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-nonrunner-form-key-info' },
            _react2.default.createElement(
              'div',
              { className: 'hr-racing-nonrunner-form-trainer-jockey-block' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-nonrunner-form-trainer' },
                'T:\xA0',
                _react2.default.createElement(
                  'span',
                  null,
                  nonRunner.trainer.name
                )
              ),
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-nonrunner-form-jockey' },
                'J:\xA0',
                _react2.default.createElement(
                  'span',
                  null,
                  nonRunner.jockey.name + ' ' + nonRunner.jockeyClaim
                )
              )
            )
          )
        )
      );
    }
  }]);
  return HorseRacingRacecardResultNonRunner;
}(_react.Component), _class.propTypes = {
  nonRunner: _propTypes2.default.object
}, _temp);
exports.default = HorseRacingRacecardResultNonRunner;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _utils = __webpack_require__(32);

var _Silk = __webpack_require__(113);

var _Silk2 = _interopRequireDefault(_Silk);

var _Ordinal = __webpack_require__(200);

var _Ordinal2 = _interopRequireDefault(_Ordinal);

var _SubscriptionContainer = __webpack_require__(92);

var _SubscriptionContainer2 = _interopRequireDefault(_SubscriptionContainer);

var _MyStableButton = __webpack_require__(167);

var _MyStableButton2 = _interopRequireDefault(_MyStableButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(512);

var HorseRacingRacecardResultRunner = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingRacecardResultRunner, _Component);

  function HorseRacingRacecardResultRunner(props) {
    (0, _classCallCheck3.default)(this, HorseRacingRacecardResultRunner);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HorseRacingRacecardResultRunner.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingRacecardResultRunner)).call(this, props));

    _this.state = { expanded: false };
    return _this;
  }

  (0, _createClass3.default)(HorseRacingRacecardResultRunner, [{
    key: 'toggleExpanded',
    value: function toggleExpanded() {
      this.setState({ expanded: !this.state.expanded });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          runner = _props.runner,
          _props$runner = _props.runner,
          finishDistance = _props$runner.finishDistance,
          saddleClothNo = _props$runner.saddleClothNo,
          drawNumber = _props$runner.drawNumber,
          horseName = _props$runner.horseName,
          horseAge = _props$runner.horseAge,
          weight = _props$runner.weight,
          odds = _props$runner.odds,
          trainer = _props$runner.trainer,
          jockey = _props$runner.jockey,
          jockeyClaim = _props$runner.jockeyClaim,
          rideDesc = _props$runner.rideDesc,
          betMovements = _props$runner.betMovements,
          horseId = _props$runner.horseId,
          silkFilename = _props$runner.silkFilename;


      var finalPosition = (0, _utils.formatPosition)(runner, { defaultPosition: "N/A", showRunnerCount: false });
      var rideDescPlusBetMovements = [rideDesc, betMovements].join(' ').trim();

      return _react2.default.createElement(
        'section',
        { id: '' + this.props.runner.key, className: 'hr-racing-runner-wrapper' },
        _react2.default.createElement(
          'div',
          { className: 'hr-racing-runner-position-container' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-position' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-runner-position-no' },
                _react2.default.createElement(_Ordinal2.default, { n: finalPosition })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-silks' },
            _react2.default.createElement(_Silk2.default, { filename: silkFilename })
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-space-from-winner' },
            finishDistance
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-saddle-stall-info' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-runner-saddle-cloth-no' },
                saddleClothNo
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-runner-stall-no' },
                drawNumber
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-horse-info' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racing-runner-horse-name' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/racing/profiles/horse/' + horseId },
                  horseName
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'hr-racing-runner-horse-sub-info' },
                _react2.default.createElement(
                  'span',
                  null,
                  horseAge
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  weight
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-betting-odds' },
            _react2.default.createElement(
              'span',
              { className: 'hr-racing-runner-betting-info' },
              odds
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'hr-racing-runner-form-history-container' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-runner-form-key-info' },
            _react2.default.createElement(
              'div',
              { className: 'hr-racing-runner-form-trainer-jockey-block' },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'hr-racing-runner-form-trainer', to: '/racing/profiles/trainer/' + trainer.business_reference.id },
                'T:\xA0',
                _react2.default.createElement(
                  'span',
                  null,
                  trainer.name
                )
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'hr-racing-runner-form-jockey', to: '/racing/profiles/jockey/' + jockey.person_reference.id },
                'J:\xA0',
                _react2.default.createElement(
                  'span',
                  { className: 'hr-racing-runner-form-jockey-name' },
                  jockey.name
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'hr-racing-runner-form-jockey-claim' },
                  ' ' + jockeyClaim
                )
              ),
              rideDescPlusBetMovements && _react2.default.createElement(
                'div',
                { className: 'hr-racing-runner-ride-desc-info' },
                rideDescPlusBetMovements
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'hr-racing-runner-ride-desc-my-stable-btn' },
              _react2.default.createElement(_SubscriptionContainer2.default, {
                addSubscriptions: [{ type: "HORSE", id: horseId, text: horseName }],
                icon: _react2.default.createElement(_MyStableButton2.default, null)
              })
            )
          )
        )
      );
    }
  }]);
  return HorseRacingRacecardResultRunner;
}(_react.Component), _class.propTypes = {
  runner: _propTypes2.default.object
}, _temp);
exports.default = HorseRacingRacecardResultRunner;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CaretIcon = __webpack_require__(43);

var _CaretIcon2 = _interopRequireDefault(_CaretIcon);

var _OrdinalSuffix = __webpack_require__(218);

var _OrdinalSuffix2 = _interopRequireDefault(_OrdinalSuffix);

var _CurrencyFormatting = __webpack_require__(175);

var _LocalDateTimeHelper = __webpack_require__(13);

var _reactRouter = __webpack_require__(11);

var _commonUtils = __webpack_require__(36);

var _utils = __webpack_require__(32);

var _Dropdown = __webpack_require__(100);

var _Dropdown2 = _interopRequireDefault(_Dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingRacecardSummary = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingRacecardSummary, _Component);

  function HorseRacingRacecardSummary(props) {
    (0, _classCallCheck3.default)(this, HorseRacingRacecardSummary);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HorseRacingRacecardSummary.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingRacecardSummary)).call(this, props));

    _this.state = { expanded: false };
    return _this;
  }

  (0, _createClass3.default)(HorseRacingRacecardSummary, [{
    key: 'distanceFormat',
    value: function distanceFormat(dist) {
      if (dist) {
        return dist.replace(" 0f", "").replace(" 0y", "");
      }
    }
  }, {
    key: 'toggleExpanded',
    value: function toggleExpanded() {
      this.setState({ expanded: !this.state.expanded });
    }
  }, {
    key: 'surfaceFormat',
    value: function surfaceFormat(surf) {
      var a = surf.toLowerCase();
      return a.charAt(0).toUpperCase() + a.slice(1);
    }
  }, {
    key: 'prizeList',
    value: function prizeList(prizes) {
      return _react2.default.createElement(
        OptionalData,
        { className: 'hr-racecard-summary-prizes' },
        prizes.sort(function (a, b) {
          return a.position - b.position;
        }).map(function (prize) {
          var label = (prize.amended_position || prize.position) === 1 ? "Winner" : (0, _OrdinalSuffix2.default)(prize.amended_position || prize.position);

          var _prize$prize$split = prize.prize.split(" "),
              _prize$prize$split2 = (0, _slicedToArray3.default)(_prize$prize$split, 2),
              amount = _prize$prize$split2[0],
              currencyCode = _prize$prize$split2[1];

          return _react2.default.createElement(
            'span',
            { className: 'hr-racecard-summary-prize', key: prize.amended_position || prize.position },
            _react2.default.createElement(
              'span',
              { className: 'hr-racecard-summary-prize-label' },
              label
            ),
            (0, _CurrencyFormatting.formatCurrency)(amount, currencyCode)
          );
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          _props$params = _props.params,
          date = _props$params.date,
          courseSlug = _props$params.courseSlug,
          raceId = _props$params.raceId,
          raceSlug = _props$params.raceSlug,
          prizes = _props.prizes,
          isComplete = _props.isComplete,
          _props$raceSummary = _props.raceSummary,
          raceDate = _props$raceSummary.date,
          winningTime = _props$raceSummary.winning_time,
          offTime = _props$raceSummary.off_time,
          courseSurface = _props$raceSummary.course_surface.surface,
          raceDistance = _props$raceSummary.distance,
          raceClass = _props$raceSummary.race_class,
          raceGoing = _props$raceSummary.going,
          _props$raceSummary$na = _props$raceSummary.name,
          raceName = _props$raceSummary$na === undefined ? 'unknown' : _props$raceSummary$na,
          raceStage = _props$raceSummary.race_stage,
          stewards = _props.stewards,
          sortOptions = _props.sortOptions,
          sortOrder = _props.sortOrder,
          setSortOrder = _props.setSortOrder;


      var racecardHref = '/racing/racecards/' + date + '/' + courseSlug + '/racecard/' + raceId + '/' + raceSlug;
      var resultHref = '/racing/results/' + date + '/' + courseSlug + '/' + raceId + '/' + raceSlug;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'section',
          { className: 'hr-racecard-summary-wrapper' },
          _react2.default.createElement(
            'ul',
            { className: 'hr-racecard-summary-information-wrapper' + (this.state.expanded ? " hr-racecard-summary-open" : "") },
            _react2.default.createElement(
              'li',
              { className: 'hr-racecard-summary-race-name hr-racecard-summary-always-open' },
              raceName,
              ' ',
              raceClass && '(Class ' + raceClass + ')'
            ),
            (!!raceDistance || !!raceGoing) && _react2.default.createElement(
              'li',
              { className: 'hr-racecard-summary-race-distance hr-racecard-summary-always-open' },
              this.distanceFormat(raceDistance),
              ', ',
              raceGoing
            ),
            _react2.default.createElement(
              'li',
              { className: 'hr-racecard-summary-race-runners hr-racecard-summary-always-open' },
              this.props.raceSummary.ride_count,
              ' Runners'
            ),
            this.prizeList(prizes),
            _react2.default.createElement(
              OptionalData,
              { className: 'hr-racecard-summary-surface' },
              'Surface: ',
              courseSurface ? this.surfaceFormat(courseSurface) : 'unknown'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racecard-more-detail-' + (sortOptions ? "with" : "no") + '-sort' },
            _react2.default.createElement(
              'div',
              { className: 'hr-racecard-show-more' },
              _react2.default.createElement(
                'button',
                { onClick: function onClick(e) {
                    return _this2.toggleExpanded(e);
                  } },
                this.state.expanded && _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(_CaretIcon2.default, { type: 'full', direction: 'up' }),
                  ' Show Less'
                ),
                !this.state.expanded && _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(_CaretIcon2.default, { type: 'full', direction: 'down' }),
                  ' Show More'
                )
              )
            ),
            sortOptions && _react2.default.createElement(
              'div',
              { className: 'hr-racecard-sort' },
              _react2.default.createElement(
                'span',
                { className: 'hr-racecard-sort-text' },
                'Sort By:'
              ),
              _react2.default.createElement(_Dropdown2.default, {
                className: 'sort-dropdown',
                options: sortOptions,
                value: sortOrder,
                onChange: function onChange(value) {
                  return setSortOrder(value);
                },
                title: 'Order?',
                showSelected: true,
                noOptionsMessage: 'No options'
              })
            )
          ),
          stewards === "AMENDEDRESULT" && _react2.default.createElement(
            'span',
            { className: 'hr-racecard-summary-stewards' },
            'Result amended following stewards enquiry'
          )
        ),
        isComplete && _react2.default.createElement(
          'div',
          { className: 'hr-racecard-weighed-in-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racecard-weighed-in-title-row' },
            _react2.default.createElement(
              'h3',
              { className: 'hr-racecard-weighed-in-title' },
              (0, _utils.raceStatusLabel)(raceStage)
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'hr-racecard-weighed-in-card-result-switch', activeClassName: 'hr-racecard-weighed-in-card-result-switch-active', to: (0, _commonUtils.preventLinkScroll)(racecardHref) },
                'Racecard'
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'hr-racecard-weighed-in-card-result-switch', activeClassName: 'hr-racecard-weighed-in-card-result-switch-active', to: (0, _commonUtils.preventLinkScroll)(resultHref) },
                'Result'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'hr-racecard-weighed-in-info' },
            _react2.default.createElement(
              'span',
              { className: 'hr-racecard-weighed-in-wt' },
              'Winning time:',
              _react2.default.createElement(
                'span',
                null,
                winningTime ? winningTime : '-'
              )
            ),
            _react2.default.createElement(
              'span',
              { className: 'hr-racecard-weighed-in-ot' },
              'Off time:',
              _react2.default.createElement(
                'span',
                null,
                offTime ? (0, _LocalDateTimeHelper.localTime)(raceDate + 'T' + offTime + 'Z') : '-'
              )
            )
          )
        )
      );
    }
  }]);
  return HorseRacingRacecardSummary;
}(_react.Component), _class.propTypes = {
  sortOptions: _propTypes2.default.array,
  sortOrder: _propTypes2.default.string,
  setSortOrder: _propTypes2.default.func,
  prizes: _propTypes2.default.arrayOf(_propTypes2.default.object),
  raceSummary: _propTypes2.default.object,
  isComplete: _propTypes2.default.bool,
  params: _propTypes2.default.object,
  stewards: _propTypes2.default.string,
  "result-racecard": _propTypes2.default.string
}, _temp);
exports.default = HorseRacingRacecardSummary;


function OptionalData(props) {
  return props.children ? _react2.default.createElement(
    'li',
    { className: props.className },
    props.children
  ) : null;
}
OptionalData.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.any
};

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _seoUtils = __webpack_require__(23);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _LocalDateTimeHelper = __webpack_require__(13);

var _Tabs = __webpack_require__(70);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _HorseRacingRacecardsMeetingSummary = __webpack_require__(402);

var _HorseRacingRacecardsMeetingSummary2 = _interopRequireDefault(_HorseRacingRacecardsMeetingSummary);

var _DatePicker = __webpack_require__(356);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _CaretLink = __webpack_require__(54);

var _CaretLink2 = _interopRequireDefault(_CaretLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1432);

var HorseRacingRacecardsForDate = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingRacecardsForDate, _Component);

  function HorseRacingRacecardsForDate() {
    (0, _classCallCheck3.default)(this, HorseRacingRacecardsForDate);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingRacecardsForDate.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingRacecardsForDate)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingRacecardsForDate, [{
    key: 'render',
    value: function render() {
      var title;
      var convertToday = true;
      var convertTomorrow = true;
      // build the date navigation array
      var dateNav = [],
          date = new Date();
      for (var i = 0; i < 7; i++) {
        var urlPart = (0, _LocalDateTimeHelper.getRelativeDayURI)(date, 0, { convertToday: convertToday, convertTomorrow: convertTomorrow });
        var rawURLPart = (0, _LocalDateTimeHelper.getRelativeDayURI)(date, 0, { convertToday: false, convertTomorrow: false });
        var alternatives = [];
        if (urlPart != rawURLPart) {
          alternatives = [{ href: '/racing/racecards' + rawURLPart, isIndex: (0, _LocalDateTimeHelper.isToday)(date) }];
        }
        dateNav.push({ href: '/racing/racecards' + urlPart,
          text: (0, _LocalDateTimeHelper.localDateShort)(date, { convertToday: convertToday, convertTomorrow: convertTomorrow }),
          isIndex: (0, _LocalDateTimeHelper.isToday)(date),
          alternatives: alternatives
        });
        date.setDate(date.getDate() + 1);
      }

      // add option for early entries
      dateNav.push({ href: '/racing/early-entries',
        text: 'Early Entries',
        isIndex: false });

      var latestSelectableDate = (0, _LocalDateTimeHelper.getRelativeDay)(new Date(), 6);
      var earlyEntriesStartDate = (0, _LocalDateTimeHelper.getRelativeDay)(new Date(), 7);

      var racecardsDate = this.props.date ? (0, _LocalDateTimeHelper.isoDate)(this.props.date) : (0, _LocalDateTimeHelper.isoDate)(new Date()),
          meetings = this.props.meetingsByDate[racecardsDate] == null ? null : this.props.meetingsByDate[racecardsDate].meetings;

      var showNonRunnersButton = void 0;

      if ((0, _LocalDateTimeHelper.isToday)(racecardsDate)) {
        title = 'Today\'s Racecards';
        showNonRunnersButton = true;
      } else if ((0, _LocalDateTimeHelper.isTomorrow)(racecardsDate)) {
        title = 'Tomorrow\'s Racecards';
        showNonRunnersButton = false;
      } else {
        title = (0, _LocalDateTimeHelper.localFullDateNoDay)(racecardsDate) + ' Racecards';
        showNonRunnersButton = false;
      }

      var _canonicalLink = (0, _seoUtils.canonicalLink)(this.props.routes, { date: (0, _LocalDateTimeHelper.getRelativeDay)(racecardsDate, 0, { convertToday: convertToday, convertTomorrow: convertTomorrow }) }),
          _canonicalLink$link = _canonicalLink.link,
          link = _canonicalLink$link === undefined ? [] : _canonicalLink$link;

      if (!(0, _LocalDateTimeHelper.isToday)(racecardsDate)) {
        link.push({
          rel: "prev",
          href: _config2.default.canonicalBase + '/racing/racecards' + (0, _LocalDateTimeHelper.getRelativeDayURI)(racecardsDate, -1, { convertToday: convertToday, convertTomorrow: convertTomorrow })
        });
      }

      link.push({
        rel: "next",
        href: _config2.default.canonicalBase + '/racing/racecards' + (0, _LocalDateTimeHelper.getRelativeDayURI)(racecardsDate, 1, { convertToday: convertToday, convertTomorrow: convertTomorrow })
      });

      if (meetings === undefined || meetings === null) {
        return _react2.default.createElement(
          'div',
          { className: 'hr-racing-racecards' },
          _react2.default.createElement(
            'p',
            { className: 'hr-racing-racecards-error-message' },
            'Failed to load results.'
          )
        );
      }

      var courseList = [];
      meetings.forEach(function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$meeting_summary$ = _ref.meeting_summary.course;

        _ref$meeting_summary$ = _ref$meeting_summary$ === undefined ? {} : _ref$meeting_summary$;
        var _ref$meeting_summary$2 = _ref$meeting_summary$.name,
            name = _ref$meeting_summary$2 === undefined ? '' : _ref$meeting_summary$2;
        return courseList.push(name);
      });
      var courses = courseList.join(', ');
      var metaDesc = 'Racecards, form and betting for meetings including ' + courses;

      return _react2.default.createElement(
        'div',
        { className: 'hr-racing-racecards' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: title, helmetProps: (0, _extends3.default)({ link: link }, (0, _seoUtils.metaDescription)(metaDesc)) }),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecards-header-title' },
            _react2.default.createElement(
              'div',
              { className: 'hr-racing-racecards-header-title-text' },
              _react2.default.createElement(
                'h1',
                { className: 'page-main-title' },
                title
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'hr-racing-racecards-header-title-date-picker' },
              _react2.default.createElement(
                _DatePicker2.default,
                { urlBase: '/racing/racecards', date: racecardsDate, latestDate: latestSelectableDate },
                _react2.default.createElement(
                  _CaretLink2.default,
                  { to: '/racing/early-entries' },
                  'Early Entries (from ',
                  (0, _LocalDateTimeHelper.localFullDateNoDay)(earlyEntriesStartDate),
                  ')'
                )
              )
            )
          ),
          _react2.default.createElement(_Tabs2.default, { tabs: dateNav }),
          showNonRunnersButton && _react2.default.createElement(
            'div',
            { className: 'hr-non-runner-link' },
            _react2.default.createElement(
              _CaretLink2.default,
              { to: '/racing/non-runners' },
              'See today\'s non-runners'
            )
          )
        ),
        _react2.default.createElement(
          'section',
          { className: 'hr-racing-content' },
          meetings && meetings.length > 0 ? _react2.default.createElement(
            'ul',
            { className: 'meetings' },
            meetings.map(function (meeting) {
              return _react2.default.createElement(
                'li',
                { key: meeting.meeting_summary.meeting_reference.id },
                _react2.default.createElement(_HorseRacingRacecardsMeetingSummary2.default, {
                  meeting: meeting,
                  date: racecardsDate,
                  dateIncrement: 1
                })
              );
            })
          ) : _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecards-none' },
            _react2.default.createElement(
              'p',
              null,
              'No meetings found'
            )
          )
        )
      );
    }
  }]);
  return HorseRacingRacecardsForDate;
}(_react.Component), _class.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  date: _propTypes2.default.string,
  meetingsByDate: _propTypes2.default.object.isRequired,
  raceType: _propTypes2.default.string
}, _temp);
exports.default = HorseRacingRacecardsForDate;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _LocalDateTimeHelper = __webpack_require__(13);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _seoUtils = __webpack_require__(23);

var _DatePicker = __webpack_require__(356);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _Tabs = __webpack_require__(70);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _HorseRacingRacecardsMeetingSummary = __webpack_require__(402);

var _HorseRacingRacecardsMeetingSummary2 = _interopRequireDefault(_HorseRacingRacecardsMeetingSummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1433);

var HorseRacingResultsForDate = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingResultsForDate, _Component);

  function HorseRacingResultsForDate() {
    (0, _classCallCheck3.default)(this, HorseRacingResultsForDate);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingResultsForDate.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingResultsForDate)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingResultsForDate, [{
    key: 'render',
    value: function render() {
      var title;
      var convertToday = true;
      var convertYesterday = true;

      // build the date navigation array
      var dateNav = [],
          date = new Date();
      for (var i = 0; i < 7; i++) {
        var urlPart = (0, _LocalDateTimeHelper.getRelativeDayURI)(date, 0, { convertToday: convertToday, convertYesterday: convertYesterday });
        var rawURLPart = (0, _LocalDateTimeHelper.getRelativeDayURI)(date, 0, { convertToday: false, convertYesterday: false });
        var alternatives = [];
        if (urlPart != rawURLPart) {
          alternatives = [{ href: '/racing/results' + rawURLPart, isIndex: (0, _LocalDateTimeHelper.isToday)(date) }];
        }
        dateNav.push({ href: '/racing/results' + urlPart,
          text: (0, _LocalDateTimeHelper.localDateShort)(date, { convertToday: convertToday, convertYesterday: convertYesterday }),
          isIndex: (0, _LocalDateTimeHelper.isToday)(date),
          alternatives: alternatives });
        date.setDate(date.getDate() - 1);
      }

      var racecardsDate = this.props.date;
      var meetings = this.props.meetingsByDate[racecardsDate] == null ? null : this.props.meetingsByDate[racecardsDate].meetings;

      if ((0, _LocalDateTimeHelper.isToday)(racecardsDate)) {
        title = 'Today\'s Results';
      } else if ((0, _LocalDateTimeHelper.isYesterday)(racecardsDate)) {
        title = 'Yesterday\'s Results';
      } else {
        title = (0, _LocalDateTimeHelper.localFullDateLong)(racecardsDate) + ' Results';
      }

      var summaryBaseProps = {
        date: racecardsDate,
        dateIncrement: -1,
        // component is used on both results and racecards, so need to tell it this is the result page
        "result-racecard": "result"
      };

      var _canonicalLink = (0, _seoUtils.canonicalLink)(this.props.routes, { date: (0, _LocalDateTimeHelper.getRelativeDay)(racecardsDate, 0, { convertToday: convertToday, convertYesterday: convertYesterday }) }),
          _canonicalLink$link = _canonicalLink.link,
          link = _canonicalLink$link === undefined ? [] : _canonicalLink$link;

      if (!(0, _LocalDateTimeHelper.isToday)(racecardsDate)) {
        link.push({
          rel: "next",
          href: _config2.default.canonicalBase + '/racing/results' + (0, _LocalDateTimeHelper.getRelativeDayURI)(racecardsDate, 1, { convertToday: convertToday, convertYesterday: convertYesterday })
        });
      }

      link.push({
        rel: "prev",
        href: _config2.default.canonicalBase + '/racing/results' + (0, _LocalDateTimeHelper.getRelativeDayURI)(racecardsDate, -1, { convertToday: convertToday, convertYesterday: convertYesterday })
      });

      var courseList = [];

      if (meetings === undefined || meetings === null) {
        return _react2.default.createElement(
          'div',
          { className: 'hr-racing-racecards' },
          _react2.default.createElement(
            'p',
            null,
            'Failed to load results.'
          )
        );
      }

      meetings.forEach(function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref$meeting_summary$ = _ref.meeting_summary.course;

        _ref$meeting_summary$ = _ref$meeting_summary$ === undefined ? {} : _ref$meeting_summary$;
        var _ref$meeting_summary$2 = _ref$meeting_summary$.name,
            name = _ref$meeting_summary$2 === undefined ? '' : _ref$meeting_summary$2;
        return courseList.push(name);
      });
      var courses = courseList.join(', ');
      var metaDesc = 'Results and video replays from meetings including ' + courses;

      var helmetProps = (0, _extends3.default)({}, (0, _seoUtils.metaDescription)(metaDesc), { link: link });

      return _react2.default.createElement(
        'div',
        { className: 'hr-racing-racecards' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: title, helmetProps: (0, _extends3.default)({}, helmetProps) }),
        _react2.default.createElement(
          'div',
          { className: 'hr-racing-racecards-header-container' },
          _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecards-header-title' },
            _react2.default.createElement(
              'div',
              { className: 'hr-racing-racecards-header-title-text' },
              _react2.default.createElement(
                'h1',
                { className: 'page-main-title' },
                title
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'hr-racing-racecards-header-title-date-picker' },
              _react2.default.createElement(_DatePicker2.default, { urlBase: '/racing/results', date: racecardsDate })
            )
          ),
          _react2.default.createElement(_Tabs2.default, { tabs: dateNav })
        ),
        _react2.default.createElement(
          'section',
          { className: 'hr-racing-content' },
          meetings && meetings.length > 0 ? _react2.default.createElement(
            'ul',
            { className: 'meetings' },
            meetings.map(function (meeting) {
              return _react2.default.createElement(
                'li',
                { key: meeting.meeting_summary.meeting_reference.id },
                _react2.default.createElement(_HorseRacingRacecardsMeetingSummary2.default, (0, _extends3.default)({
                  meeting: meeting
                }, summaryBaseProps))
              );
            })
          ) : _react2.default.createElement(
            'div',
            { className: 'hr-racing-racecards-none' },
            _react2.default.createElement(
              'p',
              null,
              'No meetings found'
            )
          )
        )
      );
    }
  }]);
  return HorseRacingResultsForDate;
}(_react.Component), _class.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  date: _propTypes2.default.string,
  meetingsByDate: _propTypes2.default.object.isRequired,
  raceType: _propTypes2.default.string
}, _temp);
exports.default = HorseRacingResultsForDate;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _urlRewrite = __webpack_require__(120);

var _CollapsibleSection = __webpack_require__(99);

var _CollapsibleSection2 = _interopRequireDefault(_CollapsibleSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1435);

var InsightDescription = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(InsightDescription, _PureComponent);

  function InsightDescription(props) {
    (0, _classCallCheck3.default)(this, InsightDescription);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InsightDescription.__proto__ || (0, _getPrototypeOf2.default)(InsightDescription)).call(this, props));

    _this.state = { insightId: (0, _urlRewrite.titleToId)(props.type) };
    return _this;
  }

  (0, _createClass3.default)(InsightDescription, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'insight', id: this.state.insightId },
        _react2.default.createElement(
          _CollapsibleSection2.default,
          { title: this.props.title, collapsed: this.state.insightId !== this.props.selectedId },
          _react2.default.createElement(
            'p',
            { className: 'insight-description' },
            this.props.description
          )
        )
      );
    }
  }]);
  return InsightDescription;
}(_react.PureComponent), _class.propTypes = {
  type: _propTypes2.default.string.isRequired,
  title: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.string.isRequired,
  selectedId: _propTypes2.default.string
}, _temp);
exports.default = InsightDescription;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _InsightDescription = __webpack_require__(932);

var _InsightDescription2 = _interopRequireDefault(_InsightDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1436);

var InsightDescriptions = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(InsightDescriptions, _PureComponent);

  function InsightDescriptions() {
    (0, _classCallCheck3.default)(this, InsightDescriptions);
    return (0, _possibleConstructorReturn3.default)(this, (InsightDescriptions.__proto__ || (0, _getPrototypeOf2.default)(InsightDescriptions)).apply(this, arguments));
  }

  (0, _createClass3.default)(InsightDescriptions, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'insights-header' },
          _react2.default.createElement(
            'h1',
            { className: 'page-main-title-reduced-padding' },
            'Insights'
          ),
          _react2.default.createElement(
            'p',
            { className: 'insights-header-description' },
            'Insights are snippets of information towards a horse\'s chance that you might otherwise miss! You can read more about the specifics of each Insight below.'
          )
        ),
        _react2.default.createElement(
          'section',
          { className: 'insights-descriptions' },
          this.props.insights.map(function (insight) {
            return _react2.default.createElement(_InsightDescription2.default, (0, _extends3.default)({ key: insight.type, selectedId: _this2.props.selectedId }, insight));
          })
        )
      );
    }
  }]);
  return InsightDescriptions;
}(_react.PureComponent), _class.propTypes = {
  insights: _propTypes2.default.array.isRequired,
  selectedId: _propTypes2.default.string
}, _temp);
exports.default = InsightDescriptions;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CheckIcon = __webpack_require__(365);

var _CheckIcon2 = _interopRequireDefault(_CheckIcon);

var _SubmitButton = __webpack_require__(360);

var _SubmitButton2 = _interopRequireDefault(_SubmitButton);

__webpack_require__(1438);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyStableEmailUnsubscribe = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(MyStableEmailUnsubscribe, _Component);

    function MyStableEmailUnsubscribe() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, MyStableEmailUnsubscribe);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MyStableEmailUnsubscribe.__proto__ || (0, _getPrototypeOf2.default)(MyStableEmailUnsubscribe)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            btnLabel: "Unsubscribe",
            btnDisabled: false
        }, _this.handleOnClick = function (email, token) {
            _this.setState({
                btnDisabled: true
            });
            _this.props.unsubscribeAction(email, token);
        }, _this.parseQueryString = function (queryString) {
            var params = {};
            queryString.replace(/([^?=&]+)(=([^&]*))?/g, function (match, $1, $2, $3) {
                return params[$1] = $3;
            });
            return params;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(MyStableEmailUnsubscribe, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            //if missing qs params redirect back to my stable index
            var _parseQueryString = this.parseQueryString(this.props.location.search),
                email = _parseQueryString.email,
                token = _parseQueryString.token;

            if (!email || !token) {
                this.props.redirectAction('/racing/my-stable');
            }
            return _react2.default.createElement(
                'article',
                null,
                _react2.default.createElement(
                    'header',
                    null,
                    _react2.default.createElement(
                        'h2',
                        { className: 'section-title my-stable-subtitle' },
                        'Unsubscribe from My Stable emails'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'my-stable-selections-info' },
                        'Check the email address below and click Unsubscribe to stop receiving My Stable email notifications.'
                    )
                ),
                _react2.default.createElement(
                    'section',
                    { className: 'my-stable-unsubscribe-section' },
                    _react2.default.createElement('input', { className: 'my-stable-email-input', value: email, readOnly: true }),
                    _react2.default.createElement(_SubmitButton2.default, { successResult: this.props.unsubscribeSuccess, label: this.state.btnLabel, disabled: this.state.btnDisabled, onClickAction: function onClickAction() {
                            return _this2.handleOnClick(email, token);
                        } })
                )
            );
        }
    }], [{
        key: 'getDerivedStateFromProps',
        value: function getDerivedStateFromProps(nextProps, prevState) {
            if (nextProps.unsubscribeSuccess === true) {
                return (0, _extends3.default)({}, prevState, { btnLabel: "Unsubscribed", btnDisabled: true });
            } else if (nextProps.unsubscribeSuccess === false) {
                return (0, _extends3.default)({}, prevState, { btnLabel: "Unsubscribe Failed", btnDisabled: true });
            } else {
                return (0, _extends3.default)({}, prevState, { btnLabel: "Unsubscribe", btnDisabled: false });
            }
        }
    }]);
    return MyStableEmailUnsubscribe;
}(_react.Component), _class.propTypes = {
    location: _propTypes2.default.object.isRequired,
    unsubscribeAction: _propTypes2.default.func.isRequired,
    redirectAction: _propTypes2.default.func.isRequired,
    unsubscribeSuccess: _propTypes2.default.bool
}, _temp2);
exports.default = MyStableEmailUnsubscribe;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(20);

var _myStableHorseSearch = __webpack_require__(422);

var _myStableJockeySearch = __webpack_require__(423);

var _myStableTrainerSearch = __webpack_require__(425);

var _SearchIcon = __webpack_require__(769);

var _SearchIcon2 = _interopRequireDefault(_SearchIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1439);

var MyStableSearch = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MyStableSearch, _Component);

  function MyStableSearch(props) {
    (0, _classCallCheck3.default)(this, MyStableSearch);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MyStableSearch.__proto__ || (0, _getPrototypeOf2.default)(MyStableSearch)).call(this, props));

    _this.state = { text: '' };
    _this.debouncedSearch = (0, _lodash.debounce)(_this.debouncedSearch, 300);
    return _this;
  }

  (0, _createClass3.default)(MyStableSearch, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.resetSearchResults();
    }
  }, {
    key: 'resetSearchResults',
    value: function resetSearchResults() {
      // don't care about preserving order
      this.props.dispatch((0, _myStableHorseSearch.resetHorses)());
      this.props.dispatch((0, _myStableJockeySearch.resetJockeys)());
      this.props.dispatch((0, _myStableTrainerSearch.resetTrainers)());
    }
  }, {
    key: 'search',
    value: function search(inputText) {
      // "Clean" the input
      var searchText = inputText.replace(/[\|&;\$%@"'<>\(\)\+,]/g, "").trim();

      if (searchText.length > 0) {
        this.props.dispatch((0, _myStableHorseSearch.loadHorses)(searchText));
        this.props.dispatch((0, _myStableJockeySearch.loadJockeys)(searchText));
        this.props.dispatch((0, _myStableTrainerSearch.loadTrainers)(searchText));
      } else {
        this.resetSearchResults();
      }
      this.props.router.push('/racing/my-stable/search');
    }
  }, {
    key: 'debouncedSearch',
    value: function debouncedSearch(searchText) {
      this.search(searchText);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(_ref) {
      var _this2 = this;

      var searchText = _ref.target.value;

      this.setState({ text: searchText }, function () {
        _this2.debouncedSearch(searchText);
      });
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(_ref2) {
      var keyCode = _ref2.keyCode;

      if (keyCode === 13) {
        this.search(this.state.text);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        { className: 'my-stable-search-box' },
        _react2.default.createElement('input', { type: 'text', value: this.state.text, maxLength: 20, onKeyDown: function onKeyDown(e) {
            return _this3.handleKeyDown(e);
          }, onChange: function onChange(e) {
            return _this3.handleChange(e);
          } }),
        _react2.default.createElement(
          'button',
          { id: 'my-stable-search-btn', className: 'search-icon-btn', onClick: function onClick() {
              return _this3.search(_this3.state.text);
            } },
          _react2.default.createElement(_SearchIcon2.default, null)
        )
      );
    }
  }]);
  return MyStableSearch;
}(_react.Component), _class.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  router: _propTypes2.default.shape({
    push: _propTypes2.default.func.isRequired
  }).isRequired
}, _temp);
exports.default = MyStableSearch;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(32);

var _LocalDateTime = __webpack_require__(61);

var _HorseSummaryElement = __webpack_require__(939);

var _HorseSummaryElement2 = _interopRequireDefault(_HorseSummaryElement);

var _consts = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseProfileDetails = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(HorseProfileDetails, _PureComponent);

  function HorseProfileDetails() {
    (0, _classCallCheck3.default)(this, HorseProfileDetails);
    return (0, _possibleConstructorReturn3.default)(this, (HorseProfileDetails.__proto__ || (0, _getPrototypeOf2.default)(HorseProfileDetails)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseProfileDetails, [{
    key: 'render',
    value: function render() {
      var _props$profile = this.props.profile;
      _props$profile = _props$profile === undefined ? {} : _props$profile;
      var age = _props$profile.age,
          foaled = _props$profile.foaled,
          _props$profile$sex = _props$profile.sex;
      _props$profile$sex = _props$profile$sex === undefined ? {} : _props$profile$sex;
      var sexCode = _props$profile$sex.type,
          _props$profile$traine = _props$profile.trainer;
      _props$profile$traine = _props$profile$traine === undefined ? {} : _props$profile$traine;
      var trainerName = _props$profile$traine.name,
          _props$profile$traine2 = _props$profile$traine.business_reference;
      _props$profile$traine2 = _props$profile$traine2 === undefined ? {} : _props$profile$traine2;
      var trainerId = _props$profile$traine2.id,
          _props$profile$sire = _props$profile.sire;
      _props$profile$sire = _props$profile$sire === undefined ? {} : _props$profile$sire;
      var sireName = _props$profile$sire.name,
          _props$profile$dam = _props$profile.dam;
      _props$profile$dam = _props$profile$dam === undefined ? {} : _props$profile$dam;
      var damName = _props$profile$dam.name,
          owner = _props$profile.owner;
      var _HORSE_SEXES$sexCode = _consts.HORSE_SEXES[sexCode],
          sex = _HORSE_SEXES$sexCode === undefined ? "?" : _HORSE_SEXES$sexCode;


      return _react2.default.createElement(
        'ul',
        { className: 'horse-profile-summary' },
        age && foaled && _react2.default.createElement(
          _HorseSummaryElement2.default,
          { label: 'Age' },
          age,
          ' (Foaled ',
          _react2.default.createElement(_LocalDateTime.LocalFullDate, { iso: new Date(foaled) }),
          ')'
        ),
        trainerName && trainerId && _react2.default.createElement(
          _HorseSummaryElement2.default,
          { link: (0, _utils.racingProfileLink)('trainer', trainerId), label: 'Trainer' },
          trainerName
        ),
        sex && _react2.default.createElement(
          _HorseSummaryElement2.default,
          { label: 'Sex' },
          sex
        ),
        sireName && _react2.default.createElement(
          _HorseSummaryElement2.default,
          { label: 'Sire' },
          sireName
        ),
        damName && _react2.default.createElement(
          _HorseSummaryElement2.default,
          { label: 'Dam' },
          damName
        ),
        owner && _react2.default.createElement(
          _HorseSummaryElement2.default,
          { label: 'Owner' },
          owner
        )
      );
    }
  }]);
  return HorseProfileDetails;
}(_react.PureComponent), _class.propTypes = {
  profile: _propTypes2.default.object.isRequired
}, _temp);
exports.default = HorseProfileDetails;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _HorseProfileTable = __webpack_require__(404);

var _HorseProfileTable2 = _interopRequireDefault(_HorseProfileTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseProfileEntriesPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseProfileEntriesPage, _Component);

  function HorseProfileEntriesPage() {
    (0, _classCallCheck3.default)(this, HorseProfileEntriesPage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseProfileEntriesPage.__proto__ || (0, _getPrototypeOf2.default)(HorseProfileEntriesPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseProfileEntriesPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$profile = _props.profile,
          profile = _props$profile === undefined ? {} : _props$profile,
          _props$profile2 = _props.profile;
      _props$profile2 = _props$profile2 === undefined ? {} : _props$profile2;
      var name = _props$profile2.name;


      return _react2.default.createElement(
        'div',
        { className: 'horse-profile-results' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: name + ' - Horse Future Entries' }),
        _react2.default.createElement(_HorseProfileTable2.default, { profile: profile, earlyEntries: true })
      );
    }
  }]);
  return HorseProfileEntriesPage;
}(_react.Component), _class.propTypes = {
  profile: _propTypes2.default.object
}, _temp);
exports.default = HorseProfileEntriesPage;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _HorseProfileTable = __webpack_require__(404);

var _HorseProfileTable2 = _interopRequireDefault(_HorseProfileTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseProfileResultsPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseProfileResultsPage, _Component);

  function HorseProfileResultsPage() {
    (0, _classCallCheck3.default)(this, HorseProfileResultsPage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseProfileResultsPage.__proto__ || (0, _getPrototypeOf2.default)(HorseProfileResultsPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseProfileResultsPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$profile = _props.profile,
          profile = _props$profile === undefined ? {} : _props$profile,
          _props$profile2 = _props.profile;
      _props$profile2 = _props$profile2 === undefined ? {} : _props$profile2;
      var name = _props$profile2.name;


      return _react2.default.createElement(
        'div',
        { className: 'horse-profile-results' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: name + ' - Horse Profile' }),
        _react2.default.createElement(_HorseProfileTable2.default, { profile: profile })
      );
    }
  }]);
  return HorseProfileResultsPage;
}(_react.Component), _class.propTypes = {
  profile: _propTypes2.default.object
}, _temp);
exports.default = HorseProfileResultsPage;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseSummaryElement = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(HorseSummaryElement, _PureComponent);

  function HorseSummaryElement() {
    (0, _classCallCheck3.default)(this, HorseSummaryElement);
    return (0, _possibleConstructorReturn3.default)(this, (HorseSummaryElement.__proto__ || (0, _getPrototypeOf2.default)(HorseSummaryElement)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseSummaryElement, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          label = _props.label,
          link = _props.link,
          children = _props.children;


      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'span',
          { className: 'horse-profile-summary-label' },
          label
        ),
        link ? _react2.default.createElement(
          _reactRouter.Link,
          { className: 'horse-profile-summary-value', to: link },
          children
        ) : _react2.default.createElement(
          'span',
          { className: 'horse-profile-summary-value' },
          children
        )
      );
    }
  }]);
  return HorseSummaryElement;
}(_react.PureComponent), _class.propTypes = {
  label: _propTypes2.default.string,
  link: _propTypes2.default.string,
  children: _propTypes2.default.node
}, _temp);
exports.default = HorseSummaryElement;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _PersonProfileTable = __webpack_require__(213);

var _PersonProfileTable2 = _interopRequireDefault(_PersonProfileTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JockeyProfileEntriesPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(JockeyProfileEntriesPage, _Component);

  function JockeyProfileEntriesPage() {
    (0, _classCallCheck3.default)(this, JockeyProfileEntriesPage);
    return (0, _possibleConstructorReturn3.default)(this, (JockeyProfileEntriesPage.__proto__ || (0, _getPrototypeOf2.default)(JockeyProfileEntriesPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(JockeyProfileEntriesPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$profile = _props.profile,
          profile = _props$profile === undefined ? {} : _props$profile,
          _props$profile2 = _props.profile;
      _props$profile2 = _props$profile2 === undefined ? {} : _props$profile2;
      var _props$profile2$perso = _props$profile2.person_details;
      _props$profile2$perso = _props$profile2$perso === undefined ? {} : _props$profile2$perso;
      var name = _props$profile2$perso.name;


      return _react2.default.createElement(
        'div',
        { className: 'hr-jockey-profile-results' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: name + ' - Jockey Future Entries' }),
        _react2.default.createElement(_PersonProfileTable2.default, { profile: profile, rideLabel: 'Ride', earlyEntries: true })
      );
    }
  }]);
  return JockeyProfileEntriesPage;
}(_react.Component), _class.propTypes = {
  profile: _propTypes2.default.object
}, _temp);
exports.default = JockeyProfileEntriesPage;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _PersonProfileTable = __webpack_require__(213);

var _PersonProfileTable2 = _interopRequireDefault(_PersonProfileTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JockeyProfileResultsPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(JockeyProfileResultsPage, _Component);

  function JockeyProfileResultsPage() {
    (0, _classCallCheck3.default)(this, JockeyProfileResultsPage);
    return (0, _possibleConstructorReturn3.default)(this, (JockeyProfileResultsPage.__proto__ || (0, _getPrototypeOf2.default)(JockeyProfileResultsPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(JockeyProfileResultsPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$profile = _props.profile,
          profile = _props$profile === undefined ? {} : _props$profile,
          _props$profile2 = _props.profile;
      _props$profile2 = _props$profile2 === undefined ? {} : _props$profile2;
      var _props$profile2$perso = _props$profile2.person_details;
      _props$profile2$perso = _props$profile2$perso === undefined ? {} : _props$profile2$perso;
      var name = _props$profile2$perso.name;


      return _react2.default.createElement(
        'div',
        { className: 'hr-jockey-profile-results' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: name + ' - Jockey Profile' }),
        _react2.default.createElement(_PersonProfileTable2.default, { profile: profile, rideLabel: 'Ride' })
      );
    }
  }]);
  return JockeyProfileResultsPage;
}(_react.Component), _class.propTypes = {
  profile: _propTypes2.default.object
}, _temp);
exports.default = JockeyProfileResultsPage;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _PersonProfileTable = __webpack_require__(213);

var _PersonProfileTable2 = _interopRequireDefault(_PersonProfileTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrainerProfileEntriesPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TrainerProfileEntriesPage, _Component);

  function TrainerProfileEntriesPage() {
    (0, _classCallCheck3.default)(this, TrainerProfileEntriesPage);
    return (0, _possibleConstructorReturn3.default)(this, (TrainerProfileEntriesPage.__proto__ || (0, _getPrototypeOf2.default)(TrainerProfileEntriesPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(TrainerProfileEntriesPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$profile = _props.profile,
          profile = _props$profile === undefined ? {} : _props$profile,
          _props$profile2 = _props.profile;
      _props$profile2 = _props$profile2 === undefined ? {} : _props$profile2;
      var _props$profile2$perso = _props$profile2.person_details;
      _props$profile2$perso = _props$profile2$perso === undefined ? {} : _props$profile2$perso;
      var name = _props$profile2$perso.name;


      return _react2.default.createElement(
        'div',
        { className: 'hr-trainer-profile-results' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: name + ' - Trainer Future Entries' }),
        _react2.default.createElement(_PersonProfileTable2.default, { profile: profile, rideLabel: 'Horse', earlyEntries: true })
      );
    }
  }]);
  return TrainerProfileEntriesPage;
}(_react.Component), _class.propTypes = {
  profile: _propTypes2.default.object
}, _temp);
exports.default = TrainerProfileEntriesPage;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _PersonProfileTable = __webpack_require__(213);

var _PersonProfileTable2 = _interopRequireDefault(_PersonProfileTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrainerProfileResultsPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TrainerProfileResultsPage, _Component);

  function TrainerProfileResultsPage() {
    (0, _classCallCheck3.default)(this, TrainerProfileResultsPage);
    return (0, _possibleConstructorReturn3.default)(this, (TrainerProfileResultsPage.__proto__ || (0, _getPrototypeOf2.default)(TrainerProfileResultsPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(TrainerProfileResultsPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$profile = _props.profile,
          profile = _props$profile === undefined ? {} : _props$profile,
          _props$profile2 = _props.profile;
      _props$profile2 = _props$profile2 === undefined ? {} : _props$profile2;
      var _props$profile2$perso = _props$profile2.person_details;
      _props$profile2$perso = _props$profile2$perso === undefined ? {} : _props$profile2$perso;
      var name = _props$profile2$perso.name;


      return _react2.default.createElement(
        'div',
        { className: 'hr-trainer-profile-results' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: name + ' - Trainer Profile' }),
        _react2.default.createElement(_PersonProfileTable2.default, { profile: profile, rideLabel: 'Horse' })
      );
    }
  }]);
  return TrainerProfileResultsPage;
}(_react.Component), _class.propTypes = {
  profile: _propTypes2.default.object
}, _temp);
exports.default = TrainerProfileResultsPage;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _StandardPage = __webpack_require__(22);

var _HorseRacingMostFollowed = __webpack_require__(80);

var _HorseRacingMostFollowed2 = _interopRequireDefault(_HorseRacingMostFollowed);

var _RightColumn = __webpack_require__(21);

var _HorseRacingAbcGuide = __webpack_require__(405);

var _HorseRacingAbcGuide2 = _interopRequireDefault(_HorseRacingAbcGuide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingAbcGuidePage = (0, _catchLifeCycleErrors2.default)(_class = function (_Component) {
  (0, _inherits3.default)(HorseRacingAbcGuidePage, _Component);

  function HorseRacingAbcGuidePage() {
    (0, _classCallCheck3.default)(this, HorseRacingAbcGuidePage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingAbcGuidePage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingAbcGuidePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingAbcGuidePage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          params = _props.params;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: 'racing', title: 'Naps Table & Tips' },
        _react2.default.createElement(
          'div',
          { className: 'main-layout-left-column' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block last-desktop' },
            _react2.default.createElement(_HorseRacingAbcGuide2.default, { location: location, params: params })
          ),
          _react2.default.createElement(
            'div',
            { id: 'left-most-read', className: 'main-layout-block last-handheld main-layout-hide-desktop' },
            _react2.default.createElement(_HorseRacingMostFollowed2.default, { location: location, plainTitle: true })
          )
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: 'racing',
          content: ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget", "horseRacingMostFollowed"] })
      );
    }
  }]);
  return HorseRacingAbcGuidePage;
}(_react.Component)) || _class;

exports.default = HorseRacingAbcGuidePage;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _earlyEntries = __webpack_require__(412);

var _HorseRacingEarlyEntriesList = __webpack_require__(907);

var _HorseRacingEarlyEntriesList2 = _interopRequireDefault(_HorseRacingEarlyEntriesList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingEarlyEntriesContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch() {
    return (0, _earlyEntries.load)();
  },
  preventResolve: function preventResolve(_ref) {
    var state = _ref.state;
    return (0, _earlyEntries.isLoading)(state);
  },
  state: function state(_state) {
    return { earlyEntries: _state.horseRacing.earlyEntries.earlyEntries };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingEarlyEntriesContainer, _Component);

  function HorseRacingEarlyEntriesContainer() {
    (0, _classCallCheck3.default)(this, HorseRacingEarlyEntriesContainer);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingEarlyEntriesContainer.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingEarlyEntriesContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingEarlyEntriesContainer, [{
    key: 'render',
    value: function render() {
      var _props$earlyEntries = this.props.earlyEntries,
          earlyEntries = _props$earlyEntries === undefined ? [] : _props$earlyEntries;


      return _react2.default.createElement(
        'div',
        { className: 'early-entries-container' },
        _react2.default.createElement(
          'h1',
          { className: 'page-main-title' },
          'Early Entries'
        ),
        _react2.default.createElement(_HorseRacingEarlyEntriesList2.default, { earlyEntries: earlyEntries })
      );
    }
  }]);
  return HorseRacingEarlyEntriesContainer;
}(_react.Component), _class2.propTypes = {
  earlyEntries: _propTypes2.default.arrayOf(_propTypes2.default.object),
  dispatch: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class);
exports.default = HorseRacingEarlyEntriesContainer;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingEarlyEntriesPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingEarlyEntriesPage, _Component);

  function HorseRacingEarlyEntriesPage() {
    (0, _classCallCheck3.default)(this, HorseRacingEarlyEntriesPage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingEarlyEntriesPage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingEarlyEntriesPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingEarlyEntriesPage, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          location = _props.location,
          HorseRacingEarlyEntriesContainer = _props.HorseRacingEarlyEntriesContainer;


      return _react2.default.createElement(
        "div",
        { className: "early-entries-page" },
        _react2.default.createElement(
          _StandardPage.StandardPage,
          { sport: "racing", title: "Early Entries" },
          _react2.default.createElement(
            "div",
            { className: "main-layout-left-column" },
            HorseRacingEarlyEntriesContainer
          ),
          _react2.default.createElement(_RightColumn.RightColumn, { location: location,
            sport: "racing",
            content: ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"] })
        )
      );
    }
  }]);
  return HorseRacingEarlyEntriesPage;
}(_react.Component), _class.propTypes = {
  HorseRacingEarlyEntriesContainer: _propTypes2.default.element.isRequired,
  location: _propTypes2.default.object.isRequired
}, _temp);
exports.default = HorseRacingEarlyEntriesPage;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _fastCards = __webpack_require__(413);

var _HorseRacingMeetingFastCards = __webpack_require__(915);

var _HorseRacingMeetingFastCards2 = _interopRequireDefault(_HorseRacingMeetingFastCards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFRESH_INTERVAL_MILLIS = 60 * 1000;

var HorseRacingFastCards = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var meetingId = _ref.params.meetingId;
    return (0, _fastCards.load)(meetingId);
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state,
        meetingId = _ref2.params.meetingId;
    return (0, _fastCards.isLoading)(state, meetingId);
  },
  refreshInterval: REFRESH_INTERVAL_MILLIS,
  state: function state(_ref3, _ref4) {
    var fastCards = _ref3.horseRacing.fastCards;
    var meetingId = _ref4.params.meetingId;
    return { meeting: fastCards[meetingId].meeting };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingFastCards, _Component);

  function HorseRacingFastCards() {
    (0, _classCallCheck3.default)(this, HorseRacingFastCards);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingFastCards.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingFastCards)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingFastCards, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          meeting = _props.meeting,
          routes = _props.routes;


      return _react2.default.createElement(_HorseRacingMeetingFastCards2.default, { meeting: meeting, routes: routes });
    }
  }]);
  return HorseRacingFastCards;
}(_react.Component), _class2.propTypes = {
  routes: _propTypes2.default.array,
  meeting: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = HorseRacingFastCards;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingFastCardsPage = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingFastCardsPage, _Component);

  function HorseRacingFastCardsPage() {
    (0, _classCallCheck3.default)(this, HorseRacingFastCardsPage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingFastCardsPage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingFastCardsPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingFastCardsPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          HorseRacingFastCards = _props.HorseRacingFastCards;


      return _react2.default.createElement(
        'div',
        { className: 'fast-cards-page' },
        _react2.default.createElement(
          _StandardPage.StandardPage,
          { sport: 'racing', title: 'Fast cards' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-left-column' },
            HorseRacingFastCards
          ),
          _react2.default.createElement(_RightColumn.RightColumn, { location: location,
            sport: 'racing',
            content: ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"] })
        )
      );
    }
  }]);
  return HorseRacingFastCardsPage;
}(_react.Component), _class2.propTypes = {
  HorseRacingFastCards: _propTypes2.default.element.isRequired,
  location: _propTypes2.default.object.isRequired
}, _temp)) || _class;

exports.default = HorseRacingFastCardsPage;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

var _HorseRacingFastResults = __webpack_require__(406);

var _HorseRacingFastResults2 = _interopRequireDefault(_HorseRacingFastResults);

var _HorseRacingMostFollowed = __webpack_require__(80);

var _HorseRacingMostFollowed2 = _interopRequireDefault(_HorseRacingMostFollowed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingFastResultsPage = (0, _catchLifeCycleErrors2.default)(_class = function (_Component) {
  (0, _inherits3.default)(HorseRacingFastResultsPage, _Component);

  function HorseRacingFastResultsPage() {
    (0, _classCallCheck3.default)(this, HorseRacingFastResultsPage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingFastResultsPage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingFastResultsPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingFastResultsPage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: 'racing', title: 'Fast Results' },
        _react2.default.createElement(
          'div',
          { className: 'main-layout-left-column' },
          _react2.default.createElement(_HorseRacingFastResults2.default, { location: location }),
          _react2.default.createElement(
            'div',
            { id: 'left-most-read', className: 'main-layout-block last-handheld main-layout-hide-desktop' },
            _react2.default.createElement(_HorseRacingMostFollowed2.default, { location: location, plainTitle: true })
          )
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: 'racing',
          content: ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget", "horseRacingMostFollowed"] })
      );
    }
  }]);
  return HorseRacingFastResultsPage;
}(_react.Component)) || _class;

exports.default = HorseRacingFastResultsPage;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StandardPage = __webpack_require__(22);

var _HorseRacingGoingContainer = __webpack_require__(407);

var _HorseRacingGoingContainer2 = _interopRequireDefault(_HorseRacingGoingContainer);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingGoingPage = function (_Component) {
  (0, _inherits3.default)(HorseRacingGoingPage, _Component);

  function HorseRacingGoingPage() {
    (0, _classCallCheck3.default)(this, HorseRacingGoingPage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingGoingPage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingGoingPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingGoingPage, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          location = _props.location,
          params = _props.params;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: "racing", title: "Going" },
        _react2.default.createElement(
          "div",
          { className: "main-layout-left-column" },
          _react2.default.createElement(
            "div",
            { className: "main-layout-block last-desktop last-handheld" },
            _react2.default.createElement(_HorseRacingGoingContainer2.default, { location: location, params: params })
          )
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: "racing",
          content: ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"] })
      );
    }
  }]);
  return HorseRacingGoingPage;
}(_react.Component);

exports.default = HorseRacingGoingPage;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _seoUtils = __webpack_require__(23);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingHomePage = function (_Component) {
  (0, _inherits3.default)(HorseRacingHomePage, _Component);

  function HorseRacingHomePage() {
    (0, _classCallCheck3.default)(this, HorseRacingHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingHomePage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingHomePage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: 'racing',
        title: 'Horse Racing Betting Tips | Racecards & Resultss',
        location: location,
        helmetProps: { titleTemplate: _seoUtils.titleTemplate.plain },
        rightColumnContent: ["mostReadRacing", "topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"]
      });
    }
  }]);
  return HorseRacingHomePage;
}(_react.Component);

exports.default = HorseRacingHomePage;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _map = __webpack_require__(181);

var _map2 = _interopRequireDefault(_map);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.HorseRacingInsightsList = HorseRacingInsightsList;

var _reactRedux = __webpack_require__(17);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _reactMetrics = __webpack_require__(69);

var _AnalyticsUtils = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HorseRacingInsightsList(_ref) {
    var insights = _ref.insights,
        keyedInsightNames = _ref.keyedInsightNames;

    var insightsUrl = "/racing/insights";
    var insightsLinkClickEventName = "insightsLinkClick";
    if (!insights || insights.length === 0) {
        return [];
    }

    function renderInsight(insight, idx) {
        if (!insight.type) {
            return null;
        }

        var insightTrackingAttrs = (0, _AnalyticsUtils.trackClick)(insightsLinkClickEventName, { link: '[Insights] Racecard ' + insight.type + ' Link' });

        return _react2.default.createElement(
            'li',
            { key: insight.type },
            _react2.default.createElement(
                _reactRouter.Link,
                (0, _extends3.default)({}, insightTrackingAttrs, { to: insightsUrl + '#' + insight.type.toLowerCase() }),
                idx > 0 ? ', ' : '',
                keyedInsightNames.get(insight.type)
            )
        );
    }

    var insightsTrackingAttrs = (0, _AnalyticsUtils.trackClick)(insightsLinkClickEventName, { link: "[Insights] Racecard Link" });

    return _react2.default.createElement(
        _reactMetrics.MetricsElement,
        null,
        _react2.default.createElement(
            'div',
            { className: 'hr-insight-list' },
            _react2.default.createElement(
                'h4',
                null,
                _react2.default.createElement(
                    _reactRouter.Link,
                    (0, _extends3.default)({}, insightsTrackingAttrs, { to: insightsUrl }),
                    _react2.default.createElement(
                        'span',
                        { className: 'new-flag bold' },
                        'Insights'
                    )
                )
            ),
            _react2.default.createElement(
                'ul',
                null,
                insights.map(renderInsight)
            )
        )
    );
}

var mapStateToProps = function mapStateToProps(state) {
    var keyedInsightNames = new _map2.default();

    var insights = state.horseRacing.insights;
    if (insights && insights.length > 0) {
        keyedInsightNames = insights.reduce(function (insightMap, insight) {
            return insightMap.set(insight.type, insight.title);
        }, new _map2.default());
    }

    return {
        keyedInsightNames: keyedInsightNames
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(HorseRacingInsightsList);

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _meetingLandingPage = __webpack_require__(419);

var _HorseRacingMeetingLandingPageList = __webpack_require__(916);

var _HorseRacingMeetingLandingPageList2 = _interopRequireDefault(_HorseRacingMeetingLandingPageList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFRESH_INTERVAL_MILLIS = 10000;

var HorseRacingMeetingLandingContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var meetingId = _ref.params.meetingId;
    return (0, _meetingLandingPage.load)(meetingId);
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state;
    return (0, _meetingLandingPage.isLoading)(state);
  },
  refreshInterval: REFRESH_INTERVAL_MILLIS,
  state: function state(_state) {
    return { fastResults: _state.horseRacing.meetingLandingPage.meeting };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingMeetingLandingContainer, _Component);

  function HorseRacingMeetingLandingContainer() {
    (0, _classCallCheck3.default)(this, HorseRacingMeetingLandingContainer);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingMeetingLandingContainer.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingMeetingLandingContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingMeetingLandingContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          routes = _props.routes,
          _props$fastResults = _props.fastResults;
      _props$fastResults = _props$fastResults === undefined ? {} : _props$fastResults;
      var meeting = _props$fastResults.meeting_summary,
          results = _props$fastResults.fast_results;


      return _react2.default.createElement(_HorseRacingMeetingLandingPageList2.default, { results: results, meeting: meeting, routes: routes });
    }
  }]);
  return HorseRacingMeetingLandingContainer;
}(_react.Component), _class2.propTypes = {
  routes: _propTypes2.default.array,
  fastResults: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = HorseRacingMeetingLandingContainer;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingMeetingLandingPage = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingMeetingLandingPage, _Component);

  function HorseRacingMeetingLandingPage() {
    (0, _classCallCheck3.default)(this, HorseRacingMeetingLandingPage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingMeetingLandingPage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingMeetingLandingPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingMeetingLandingPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          HorseRacingMeetingLandingContainer = _props.HorseRacingMeetingLandingContainer;


      return _react2.default.createElement(
        'div',
        { className: 'meeting-landing-page' },
        _react2.default.createElement(
          _StandardPage.StandardPage,
          { sport: 'racing', title: 'Meeting Page' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-left-column' },
            HorseRacingMeetingLandingContainer
          ),
          _react2.default.createElement(_RightColumn.RightColumn, { location: location,
            sport: 'racing',
            content: ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"] })
        )
      );
    }
  }]);
  return HorseRacingMeetingLandingPage;
}(_react.Component), _class2.propTypes = {
  HorseRacingMeetingLandingContainer: _propTypes2.default.element.isRequired,
  location: _propTypes2.default.object.isRequired
}, _temp)) || _class;

exports.default = HorseRacingMeetingLandingPage;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

var _HorseRacingNonRunnersContainer = __webpack_require__(408);

var _HorseRacingNonRunnersContainer2 = _interopRequireDefault(_HorseRacingNonRunnersContainer);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingNonRunnersPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingNonRunnersPage, _Component);

  function HorseRacingNonRunnersPage() {
    (0, _classCallCheck3.default)(this, HorseRacingNonRunnersPage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingNonRunnersPage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingNonRunnersPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingNonRunnersPage, [{
    key: "render",
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: "racing", title: "Today's Non-Runners" },
        _react2.default.createElement(
          "div",
          { className: "main-layout-left-column" },
          _react2.default.createElement(_HorseRacingNonRunnersContainer2.default, { location: location })
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: "racing",
          content: ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"] })
      );
    }
  }]);
  return HorseRacingNonRunnersPage;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object.isRequired
}, _temp);
exports.default = HorseRacingNonRunnersPage;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorseRacingProfilePage = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _userService = __webpack_require__(44);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingProfilePage = exports.HorseRacingProfilePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingProfilePage, _Component);

  function HorseRacingProfilePage() {
    (0, _classCallCheck3.default)(this, HorseRacingProfilePage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingProfilePage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingProfilePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingProfilePage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          ProfilePageContainer = _props.ProfilePageContainer;


      return _react2.default.createElement(
        'div',
        { className: 'horse-profile-page' },
        _react2.default.createElement(
          _StandardPage.StandardPage,
          { sport: 'racing', title: 'Profile page' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-left-column' },
            ProfilePageContainer
          ),
          _react2.default.createElement(_RightColumn.RightColumn, { location: location,
            sport: 'racing',
            content: ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"] })
        )
      );
    }
  }]);
  return HorseRacingProfilePage;
}(_react.Component), _class.propTypes = {
  ProfilePageContainer: _propTypes2.default.element.isRequired,
  location: _propTypes2.default.object.isRequired
}, _temp);
exports.default = (0, _asyncConnectWrapper.standardAsyncConnect)([(0, _userService.userServiceLayoutConnect)()])(HorseRacingProfilePage);

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _userService = __webpack_require__(44);

var _race = __webpack_require__(429);

var _article = __webpack_require__(204);

var _meetings = __webpack_require__(214);

var _meeting = __webpack_require__(418);

var _LocalDateTimeHelper = __webpack_require__(13);

var _lodash = __webpack_require__(20);

var _lodash2 = _interopRequireDefault(_lodash);

var _HorseRacingRacePage = __webpack_require__(920);

var _HorseRacingRacePage2 = _interopRequireDefault(_HorseRacingRacePage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TIPS_STORY_TYPE = 'TIPS_FOR_HORSE_RACING';

var LONG_INTERVAL_MS = 5 * 60 * 1000;
var MEDIUM_INTERVAL_MS = 30 * 1000;
var SHORT_INTERVAL_MS = 15 * 1000;
var ACTIVE_INTERVAL_MS = 5 * 1000;
var NO_INTERVAL = false;

var ACTIVE_STATUSES = ["GOINGDOWN", "ATTHEPOST", "GOINGBEHIND", "GOINGINSTALLS", "UNDERORDERS", "OFF", "FINISHED", "PHOTOGRAPH", "RESULT"];

function raceInterval(_ref) {
  var _ref$state$horseRacin = _ref.state.horseRacing;
  _ref$state$horseRacin = _ref$state$horseRacin === undefined ? {} : _ref$state$horseRacin;
  var _ref$state$horseRacin2 = _ref$state$horseRacin.race;
  _ref$state$horseRacin2 = _ref$state$horseRacin2 === undefined ? {} : _ref$state$horseRacin2;
  var _ref$state$horseRacin3 = _ref$state$horseRacin2.race;
  _ref$state$horseRacin3 = _ref$state$horseRacin3 === undefined ? {} : _ref$state$horseRacin3;
  var _ref$state$horseRacin4 = _ref$state$horseRacin3.race_summary;
  _ref$state$horseRacin4 = _ref$state$horseRacin4 === undefined ? {} : _ref$state$horseRacin4;
  var time = _ref$state$horseRacin4.time,
      race_stage = _ref$state$horseRacin4.race_stage,
      date = _ref$state$horseRacin4.date;

  var timeStamp = date + 'T' + time + 'Z';
  var interval = void 0;

  if (ACTIVE_STATUSES.includes(race_stage)) {
    interval = ACTIVE_INTERVAL_MS;
  } else if ((0, _LocalDateTimeHelper.isBefore)(timeStamp, -3, "day")) {
    interval = NO_INTERVAL;
  } else if ((0, _LocalDateTimeHelper.isBefore)(timeStamp, -1, "day")) {
    interval = LONG_INTERVAL_MS;
  } else if ((0, _LocalDateTimeHelper.isBefore)(timeStamp, -15, "minutes")) {
    interval = MEDIUM_INTERVAL_MS;
  } else if ((0, _LocalDateTimeHelper.isBefore)(timeStamp, 15, "minutes")) {
    interval = SHORT_INTERVAL_MS;
  } else if ((0, _LocalDateTimeHelper.isBefore)(timeStamp, 1, "day")) {
    interval = LONG_INTERVAL_MS;
  } else {
    interval = NO_INTERVAL;
  }

  return interval;
}

var HorseRacingRacePageContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{ // this race
  dispatch: function dispatch(_ref2) {
    var raceId = _ref2.params.raceId;
    return (0, _race.load)(raceId);
  },
  preventResolve: function preventResolve(_ref3) {
    var state = _ref3.state,
        raceId = _ref3.params.raceId;
    return (0, _race.isLoading)(state, raceId);
  },
  state: function state(_state) {
    return { race: _state.horseRacing.race || {} };
  },
  refreshInterval: raceInterval
}, { // meetings for this date
  dispatch: function dispatch(_ref4) {
    var _ref4$params$date = _ref4.params.date,
        date = _ref4$params$date === undefined ? (0, _LocalDateTimeHelper.getTodaysDate)("YYYY-MM-DD") : _ref4$params$date;
    return (0, _meetings.load)(date);
  },
  preventResolve: function preventResolve(_ref5) {
    var state = _ref5.state,
        _ref5$params$date = _ref5.params.date,
        date = _ref5$params$date === undefined ? (0, _LocalDateTimeHelper.getTodaysDate)("YYYY-MM-DD") : _ref5$params$date;
    return (0, _meetings.isLoading)(state, date);
  },
  state: function state(_state2) {
    return { meetingsByDate: (0, _meetings.get)(_state2) };
  }
}, { // meeting for this race
  dispatch: function dispatch(_ref6) {
    var raceId = _ref6.params.raceId;
    return (0, _meeting.loadMeetingByRaceId)(raceId);
  },
  preventResolve: function preventResolve(_ref7) {
    var state = _ref7.state,
        raceId = _ref7.params.raceId;
    return (0, _meeting.isMeetingLoading)(state, raceId);
  },
  state: function state(_state3) {
    return { meeting: _state3.horseRacing.meeting || {} };
  }
}, { // tips article for this race
  dispatch: function dispatch(_ref8) {
    var raceId = _ref8.params.raceId;
    return (0, _article.loadByEventIdStoryType)(null, raceId, TIPS_STORY_TYPE);
  },
  preventResolve: function preventResolve(_ref9) {
    var state = _ref9.state,
        raceId = _ref9.params.raceId;
    return (0, _article.isLoadingByEventIdStoryType)(state, raceId, TIPS_STORY_TYPE);
  },
  state: function state(_state4, props) {
    return { tipsArticle: getArticle(_state4.common.article, (0, _article.lookupRef)(props.params.raceId, TIPS_STORY_TYPE)) || {} };
  }
}, (0, _userService.userServiceLayoutConnect)()]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingRacePageContainer, _Component);

  function HorseRacingRacePageContainer() {
    (0, _classCallCheck3.default)(this, HorseRacingRacePageContainer);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingRacePageContainer.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingRacePageContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingRacePageContainer, [{
    key: 'hasMatchingRaceIds',
    value: function hasMatchingRaceIds() {
      var stateRaceId = _lodash2.default.get(this.props, "race.race.race_summary.race_summary_reference.id");
      var currentRaceId = _lodash2.default.get(this.props, "params.raceId");

      return '' + stateRaceId === currentRaceId;
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.meeting && !_lodash2.default.isEmpty(this.props.meeting.meeting)) {
        this.props.meeting.meeting[0].races = _lodash2.default.sortBy(this.props.meeting.meeting[0].races, ['date', 'time']);
      }

      // If we have an error and we dont have race data or the race ID we are 
      // viewing doesnt match whats in state then show the error
      if (this.props.race.error && (!this.props.race.race || !this.hasMatchingRaceIds())) {
        var errorPixelSrc = '/1x1.gif?type=horseracing-racecard&id=0&cb=' + Date.now();

        return _react2.default.createElement(
          'div',
          { className: 'hr-racing-racecards' },
          _react2.default.createElement(
            'p',
            { className: 'hr-racing-racecards-error-message' },
            'There has been a problem displaying this race.'
          ),
          _react2.default.createElement('img', { src: errorPixelSrc, width: '1', height: '1' })
        );
      }

      var racePageProps = {
        race: this.props.race.race,
        meetings: this.props.meetingsByDate[this.props.params.date],
        meeting: this.props.meeting,
        children: this.props.children,
        tipsArticle: this.props.tipsArticle,
        routes: this.props.routes,
        route: this.props.route,
        params: this.props.params
      };

      return _react2.default.createElement(_HorseRacingRacePage2.default, racePageProps);
    }
  }]);
  return HorseRacingRacePageContainer;
}(_react.Component), _class2.propTypes = {
  route: _propTypes2.default.object,
  // supplied by react-router via @connect
  params: _propTypes2.default.shape({
    date: _propTypes2.default.string
  }),
  routes: _propTypes2.default.array.isRequired,
  meetingsByDate: _propTypes2.default.object,
  meeting: _propTypes2.default.object,
  tipsArticle: _propTypes2.default.object,
  race: _propTypes2.default.object,
  dispatch: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node
}, _temp)) || _class) || _class);
exports.default = HorseRacingRacePageContainer;


function getArticle(articles, ref) {
  // ArticleIdRefs maps reference values to article ids which are the main index of articles object
  var id = _lodash2.default.get(articles, 'articleIdRefs[' + ref + '].articleIds[0]');
  if (id) {
    return articles[id].article;
  } else {
    return {};
  }
}

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _meetings = __webpack_require__(214);

var _userService = __webpack_require__(44);

var _HorseRacingRacecardsForDate = __webpack_require__(930);

var _HorseRacingRacecardsForDate2 = _interopRequireDefault(_HorseRacingRacecardsForDate);

var _LocalDateTimeHelper = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function convertDate(date) {
  if (date == 'tomorrow') {
    date = (0, _LocalDateTimeHelper.getTomorrowsDate)("YYYY-MM-DD");
  }
  return date;
}

var HorseRacingRacecardsForDateContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var _ref$params$date = _ref.params.date,
        date = _ref$params$date === undefined ? (0, _LocalDateTimeHelper.isoDate)() : _ref$params$date;
    return (0, _meetings.load)(convertDate(date));
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state,
        _ref2$params$date = _ref2.params.date,
        date = _ref2$params$date === undefined ? (0, _LocalDateTimeHelper.isoDate)() : _ref2$params$date;
    return (0, _meetings.isLoading)(state, convertDate(date));
  },
  state: function state(_state) {
    return { meetingsByDate: (0, _meetings.get)(_state) };
  }
}, (0, _userService.userServiceLayoutConnect)()]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingRacecardsForDateContainer, _Component);

  function HorseRacingRacecardsForDateContainer() {
    (0, _classCallCheck3.default)(this, HorseRacingRacecardsForDateContainer);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingRacecardsForDateContainer.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingRacecardsForDateContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingRacecardsForDateContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_HorseRacingRacecardsForDate2.default, {
        date: convertDate(this.props.params.date) || (0, _LocalDateTimeHelper.isoDate)(),
        meetingsByDate: this.props.meetingsByDate,
        routes: this.props.routes,
        raceType: 'Racing'
      });
    }
  }]);
  return HorseRacingRacecardsForDateContainer;
}(_react.Component), _class2.propTypes = {
  // supplied by react-router via @connect
  params: _propTypes2.default.shape({
    date: _propTypes2.default.string
  }),
  routes: _propTypes2.default.array.isRequired,
  meetingsByDate: _propTypes2.default.object.isRequired,
  raceType: _propTypes2.default.string
}, _temp)) || _class) || _class);
exports.default = HorseRacingRacecardsForDateContainer;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RightColumn = __webpack_require__(21);

var _StandardPage = __webpack_require__(22);

var _HorseRacingMostFollowed = __webpack_require__(80);

var _HorseRacingMostFollowed2 = _interopRequireDefault(_HorseRacingMostFollowed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingRacecardsPage = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingRacecardsPage, _Component);

  function HorseRacingRacecardsPage() {
    (0, _classCallCheck3.default)(this, HorseRacingRacecardsPage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingRacecardsPage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingRacecardsPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingRacecardsPage, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          location = _props.location,
          HorseRacingRacePageContainer = _props.HorseRacingRacePageContainer,
          HorseRacingLiveShowPage = _props.HorseRacingLiveShowPage,
          HorseRacingRacecardsForDateContainer = _props.HorseRacingRacecardsForDateContainer;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: "racing", title: "Racecards" },
        _react2.default.createElement(
          "div",
          { className: "main-layout-left-column" },
          HorseRacingRacePageContainer,
          HorseRacingLiveShowPage,
          HorseRacingRacecardsForDateContainer,
          _react2.default.createElement(
            "div",
            { id: "left-most-read", className: "main-layout-block last-handheld main-layout-hide-desktop" },
            _react2.default.createElement(_HorseRacingMostFollowed2.default, { location: location, plainTitle: true })
          )
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: "racing",
          content: ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget", "horseRacingMostFollowed"] })
      );
    }
  }]);
  return HorseRacingRacecardsPage;
}(_react.Component), _class2.propTypes = {
  routes: _propTypes2.default.object,
  params: _propTypes2.default.object,
  location: _propTypes2.default.object,
  route: _propTypes2.default.object,
  HorseRacingRacePageContainer: _propTypes2.default.element,
  HorseRacingRacecardsForDateContainer: _propTypes2.default.element,
  HorseRacingLiveShowPage: _propTypes2.default.element
}, _temp)) || _class;

exports.default = HorseRacingRacecardsPage;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _meetings = __webpack_require__(214);

var _HorseRacingResultsForDate = __webpack_require__(931);

var _HorseRacingResultsForDate2 = _interopRequireDefault(_HorseRacingResultsForDate);

var _LocalDateTimeHelper = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFRESH_INTERVAL_MILLIS = 15000;

function convertDate(date) {
  if (date == 'yesterday') {
    date = (0, _LocalDateTimeHelper.getYesterdaysDate)("YYYY-MM-DD");
  }
  return date;
}

var HorseRacingResultsForDateContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var _ref$params$date = _ref.params.date,
        date = _ref$params$date === undefined ? (0, _LocalDateTimeHelper.isoDate)() : _ref$params$date;
    return (0, _meetings.load)(convertDate(date));
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state,
        _ref2$params$date = _ref2.params.date,
        date = _ref2$params$date === undefined ? (0, _LocalDateTimeHelper.isoDate)() : _ref2$params$date;
    return (0, _meetings.isLoading)(state, convertDate(date));
  },
  refreshInterval: REFRESH_INTERVAL_MILLIS,
  state: function state(_state) {
    return { meetingsByDate: (0, _meetings.get)(_state) };
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingResultsForDateContainer, _Component);

  function HorseRacingResultsForDateContainer() {
    (0, _classCallCheck3.default)(this, HorseRacingResultsForDateContainer);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingResultsForDateContainer.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingResultsForDateContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingResultsForDateContainer, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_HorseRacingResultsForDate2.default, {
        routes: this.props.routes,
        date: convertDate(this.props.params.date) || (0, _LocalDateTimeHelper.isoDate)(),
        meetingsByDate: this.props.meetingsByDate,
        raceType: 'Racing' });
    }
  }]);
  return HorseRacingResultsForDateContainer;
}(_react.Component), _class2.propTypes = {
  // supplied by react-router via @connect
  routes: _propTypes2.default.array.isRequired,
  params: _propTypes2.default.shape({
    date: _propTypes2.default.string
  }),
  meetingsByDate: _propTypes2.default.object.isRequired,
  dispatch: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class);
exports.default = HorseRacingResultsForDateContainer;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _StandardPage = __webpack_require__(22);

var _HorseRacingMostFollowed = __webpack_require__(80);

var _HorseRacingMostFollowed2 = _interopRequireDefault(_HorseRacingMostFollowed);

var _RightColumn = __webpack_require__(21);

var _seoUtils = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingResultsPage = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseRacingResultsPage, _Component);

  function HorseRacingResultsPage() {
    (0, _classCallCheck3.default)(this, HorseRacingResultsPage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingResultsPage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingResultsPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingResultsPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          params = _props.params,
          HorseRacingRacePageContainer = _props.HorseRacingRacePageContainer,
          HorseRacingResultsForDateContainer = _props.HorseRacingResultsForDateContainer;

      var helmetProps = (0, _seoUtils.canonicalLink)(this.props.routes, { date: params.date });

      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: 'racing', title: 'Racecards', helmetProps: helmetProps },
        _react2.default.createElement(
          'div',
          { className: 'main-layout-left-column' },
          HorseRacingRacePageContainer,
          HorseRacingResultsForDateContainer,
          _react2.default.createElement(
            'div',
            { id: 'left-most-read', className: 'main-layout-block last-handheld main-layout-hide-desktop' },
            _react2.default.createElement(_HorseRacingMostFollowed2.default, { location: location, plainTitle: true })
          )
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: 'racing',
          content: ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget", "horseRacingMostFollowed"] })
      );
    }
  }]);
  return HorseRacingResultsPage;
}(_react.Component), _class2.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  params: _propTypes2.default.shape({ date: _propTypes2.default.string }),
  location: _propTypes2.default.object,
  HorseRacingRacePageContainer: _propTypes2.default.element,
  HorseRacingResultsForDateContainer: _propTypes2.default.element
}, _temp)) || _class;

exports.default = HorseRacingResultsPage;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

var _SectionPlainTitle = __webpack_require__(166);

var _SectionPlainTitle2 = _interopRequireDefault(_SectionPlainTitle);

var _MoreNews = __webpack_require__(93);

var _MoreNews2 = _interopRequireDefault(_MoreNews);

var _MostReadRacing = __webpack_require__(203);

var _MostReadRacing2 = _interopRequireDefault(_MostReadRacing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingRichardFaheyPage = function (_Component) {
  (0, _inherits3.default)(HorseRacingRichardFaheyPage, _Component);

  function HorseRacingRichardFaheyPage() {
    (0, _classCallCheck3.default)(this, HorseRacingRichardFaheyPage);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingRichardFaheyPage.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingRichardFaheyPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingRichardFaheyPage, [{
    key: "render",
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: "racing", title: "Richard Fahey - Columnists" },
        _react2.default.createElement(
          "div",
          { className: "main-layout-left-column" },
          _react2.default.createElement(
            "div",
            { className: "main-layout-block" },
            _react2.default.createElement(
              _SectionPlainTitle2.default,
              { className: "page-main-section-title", level: 1 },
              "Richard Fahey"
            )
          ),
          _react2.default.createElement(
            "div",
            { id: "left-most-read", className: "main-layout-block last-desktop" },
            _react2.default.createElement(_MoreNews2.default, { location: location })
          ),
          _react2.default.createElement(
            "div",
            { id: "left-most-read", className: "main-layout-block last-handheld main-layout-hide-desktop" },
            _react2.default.createElement(_MostReadRacing2.default, { location: location, plainTitle: true })
          )
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: "racing",
          content: ["mostReadRacing", "topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"] })
      );
    }
  }]);
  return HorseRacingRichardFaheyPage;
}(_react.Component);

exports.default = HorseRacingRichardFaheyPage;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

var _MoreNews = __webpack_require__(93);

var _MoreNews2 = _interopRequireDefault(_MoreNews);

var _MostReadRacing = __webpack_require__(203);

var _MostReadRacing2 = _interopRequireDefault(_MostReadRacing);

var _HorseRacingMostFollowed = __webpack_require__(80);

var _HorseRacingMostFollowed2 = _interopRequireDefault(_HorseRacingMostFollowed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingTipsCentre = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(HorseRacingTipsCentre, _Component);

  function HorseRacingTipsCentre() {
    (0, _classCallCheck3.default)(this, HorseRacingTipsCentre);
    return (0, _possibleConstructorReturn3.default)(this, (HorseRacingTipsCentre.__proto__ || (0, _getPrototypeOf2.default)(HorseRacingTipsCentre)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseRacingTipsCentre, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: 'racing', title: 'Tips Centre' },
        _react2.default.createElement(
          'div',
          { className: 'main-layout-left-column ' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block last-desktop' },
            _react2.default.createElement(_MoreNews2.default, { location: location })
          ),
          _react2.default.createElement(
            'div',
            { id: 'left-most-followed', className: 'main-layout-block main-layout-hide-desktop' },
            _react2.default.createElement(_HorseRacingMostFollowed2.default, { location: location, plainTitle: true })
          ),
          _react2.default.createElement(
            'div',
            { id: 'left-most-read', className: 'main-layout-block last-handheld main-layout-hide-desktop' },
            _react2.default.createElement(_MostReadRacing2.default, { location: location, plainTitle: true })
          )
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: 'racing',
          content: ["mostReadRacing", "topMpu", "horseRacingNextRaceOffAll", "bottomMpu", "ocWidget", "horseRacingMostFollowed"] })
      );
    }
  }]);
  return HorseRacingTipsCentre;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object.isRequired
}, _temp);
exports.default = HorseRacingTipsCentre;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(17);

var _InsightDescriptions = __webpack_require__(933);

var _InsightDescriptions2 = _interopRequireDefault(_InsightDescriptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InsightDescriptionsContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    insights: state.horseRacing.insights
  };
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(InsightDescriptionsContainer, _Component);

  function InsightDescriptionsContainer(props) {
    (0, _classCallCheck3.default)(this, InsightDescriptionsContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (InsightDescriptionsContainer.__proto__ || (0, _getPrototypeOf2.default)(InsightDescriptionsContainer)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(InsightDescriptionsContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var selectedId = window.location.hash.replace('#', '');
      this.setState({ selectedId: selectedId });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_InsightDescriptions2.default, (0, _extends3.default)({}, this.props, this.state));
    }
  }]);
  return InsightDescriptionsContainer;
}(_react.Component)) || _class);
exports.default = InsightDescriptionsContainer;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InsightsPage = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(InsightsPage, _Component);

  function InsightsPage() {
    (0, _classCallCheck3.default)(this, InsightsPage);
    return (0, _possibleConstructorReturn3.default)(this, (InsightsPage.__proto__ || (0, _getPrototypeOf2.default)(InsightsPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(InsightsPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          InsightDescriptionsContainer = _props.InsightDescriptionsContainer;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: 'racing', title: 'Insights' },
        _react2.default.createElement(
          'div',
          { className: 'main-layout-left-column' },
          InsightDescriptionsContainer
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: 'racing',
          content: ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget"] })
      );
    }
  }]);
  return InsightsPage;
}(_react.Component), _class2.propTypes = {
  InsightDescriptionsContainer: _propTypes2.default.element,
  location: _propTypes2.default.object.isRequired
}, _temp)) || _class;

exports.default = InsightsPage;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(17);

var _reactRouterRedux = __webpack_require__(138);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _myStable = __webpack_require__(266);

var _MyStableEmailUnsubscribe = __webpack_require__(934);

var _MyStableEmailUnsubscribe2 = _interopRequireDefault(_MyStableEmailUnsubscribe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, props) {
    return (0, _extends3.default)({}, props, {
        unsubscribeSuccess: state.horseRacing.myStableEmailUnsubscribe.submitOk
    });
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        unsubscribeAction: function unsubscribeAction(email, token) {
            return dispatch((0, _myStable.myStableEmailUnsubscribe)(email, token));
        },
        redirectAction: function redirectAction(url) {
            return dispatch((0, _reactRouterRedux.push)(url));
        }
    };
};

var emailUnsubscribeWrapper = function emailUnsubscribeWrapper(props) {
    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_MetaDataWrapper2.default, { title: 'Email Unsubscribe' }),
        _react2.default.createElement(_MyStableEmailUnsubscribe2.default, props)
    );
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(emailUnsubscribeWrapper);

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _LocalDateTimeHelper = __webpack_require__(13);

var _reactRouter = __webpack_require__(11);

var _utils = __webpack_require__(18);

var _userService = __webpack_require__(44);

var _myStableEntries = __webpack_require__(421);

var _MyStableUnauthenticatedUser = __webpack_require__(267);

var _MyStableUnauthenticatedUser2 = _interopRequireDefault(_MyStableUnauthenticatedUser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1446);

var MyStableNextEntries = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([(0, _userService.userServiceLayoutConnect)({
  then: function then(_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return dispatch((0, _myStableEntries.loadEntries)(getState().common.userService.subscriptions));
  },
  state: function state(_state) {
    return { auth: _state.common.auth, myStableEntries: _state.horseRacing.myStableEntries };
  }
})]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MyStableNextEntries, _Component);

  function MyStableNextEntries() {
    (0, _classCallCheck3.default)(this, MyStableNextEntries);
    return (0, _possibleConstructorReturn3.default)(this, (MyStableNextEntries.__proto__ || (0, _getPrototypeOf2.default)(MyStableNextEntries)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyStableNextEntries, [{
    key: 'render',
    value: function render() {
      if (!this.props.isLoggedIn()) {
        return _react2.default.createElement(_MyStableUnauthenticatedUser2.default, null);
      }
      var entries = this.props.myStableEntries.entries;

      return _react2.default.createElement(
        'section',
        { className: 'nextEntries' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: 'Next Entries' }),
        _react2.default.createElement(
          'h3',
          { className: 'section-title my-stable-subtitle' },
          'Next Entries'
        ),
        _react2.default.createElement(MyStableEntriesTable, { label: 'Horses', entries: entries.horse || [], extractor: horseMatch }),
        _react2.default.createElement(MyStableEntriesTable, { label: 'Jockeys', entries: entries.jockey || [], extractor: jockeyMatch }),
        _react2.default.createElement(MyStableEntriesTable, { label: 'Trainers', entries: entries.trainer || [], extractor: trainerMatch })
      );
    }
  }]);
  return MyStableNextEntries;
}(_react.Component), _class2.propTypes = {
  isLoggedIn: _propTypes2.default.func.isRequired,
  auth: _propTypes2.default.object.isRequired,
  myStableEntries: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = MyStableNextEntries;


function genericMatch(race) {
  var matchingRide = race.rides[0];
  return [['Horse', matchingRide.horse.name || 'Not Specified'], ['Jockey', matchingRide.jockey.name || 'Not Specified'], ['Trainer', matchingRide.trainer.name || 'Not Specified']];
}

function extractAtIndex(parts, mainIndex) {
  return {
    mainName: parts.splice(mainIndex, 1)[0][1],
    parts: parts
  };
}

function horseMatch(race) {
  return extractAtIndex(genericMatch(race), 0);
}
function jockeyMatch(race) {
  return extractAtIndex(genericMatch(race), 1);
}
function trainerMatch(race) {
  return extractAtIndex(genericMatch(race), 2);
}

function MyStableEntriesTable(_ref2) {
  var label = _ref2.label,
      entries = _ref2.entries,
      extractor = _ref2.extractor;

  return _react2.default.createElement(
    'section',
    { className: 'my-stable-entries' },
    _react2.default.createElement(
      'div',
      { className: 'my-stable-section-header' },
      _react2.default.createElement(
        'span',
        { className: 'my-stable-section-header-key', id: label + "-section" },
        label
      ),
      _react2.default.createElement('span', { className: 'my-stable-section-header-remove' })
    ),
    _react2.default.createElement(
      'div',
      { className: '' },
      entries.length > 0 ? _react2.default.createElement(
        'table',
        { className: 'my-stable-table' },
        _react2.default.createElement(
          'tbody',
          null,
          entries.map(function (_ref3) {
            var race = _ref3.race,
                matched = _ref3.matched;
            return _react2.default.createElement(
              'tr',
              { className: 'my-stable-entries-row', key: matched + '-' + race.race_summary.race_summary_reference.id + '-' + race.rides[0].horse.name },
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/racing/racecards/' + (0, _LocalDateTimeHelper.isoDate)(race.race_summary.date) + '/' + (0, _utils.toSlug)(race.race_summary.course_name) + '/racecard/' + race.race_summary.race_summary_reference.id + '/' + (0, _utils.toSlug)(race.race_summary.name) },
                  _react2.default.createElement(MyStableEntryMatchRow, extractor(race)),
                  _react2.default.createElement(
                    'p',
                    { className: 'my-stable-entries-what-when' },
                    !!race.race_summary.date && !!race.race_summary.time && (0, _LocalDateTimeHelper.localFullDateTime)(race.race_summary.date + 'T' + race.race_summary.time + 'Z'),
                    !!race.race_summary.name && ' - ' + race.race_summary.name
                  ),
                  _react2.default.createElement(
                    'p',
                    { className: 'my-stable-entries-where' },
                    !!race.race_summary.course_name && 'Course: ' + race.race_summary.course_name + ' ',
                    !!race.race_summary.distance && 'Distance: ' + race.race_summary.distance.replace(/0m |0f |0y/ig, '') + ' ',
                    !!race.race_summary.race_class && 'Class: ' + race.race_summary.race_class
                  )
                )
              )
            );
          })
        )
      ) : _react2.default.createElement(
        'div',
        { className: 'my-stable-entries-none' },
        'No entries for your selections'
      )
    )
  );
}

MyStableEntriesTable.propTypes = {
  label: _propTypes2.default.string.isRequired,
  entries: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    matched: _propTypes2.default.number.isRequired,
    race: _propTypes2.default.shape({
      race_summary: _propTypes2.default.shape({
        race_summary_reference: _propTypes2.default.shape({
          id: _propTypes2.default.number
        })
      })
    })
  })),
  extractor: _propTypes2.default.func.isRequired
};

function MyStableEntryMatchRow(props) {
  return _react2.default.createElement(
    'p',
    { className: 'my-stable-entries-who' },
    _react2.default.createElement(
      'span',
      { className: 'my-stable-entries-horse' },
      props.mainName
    ),
    ' - ',
    props.parts.map(function (part) {
      return part.join(': ');
    }).join(', ')
  );
}

MyStableEntryMatchRow.propTypes = {
  mainName: _propTypes2.default.string.isRequired,
  parts: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string)).isRequired
};

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _seoUtils = __webpack_require__(23);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

var _MyStablePageContainer = __webpack_require__(409);

var _MyStablePageContainer2 = _interopRequireDefault(_MyStablePageContainer);

var _HorseRacingMostFollowed = __webpack_require__(80);

var _HorseRacingMostFollowed2 = _interopRequireDefault(_HorseRacingMostFollowed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyStablePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MyStablePage, _Component);

  function MyStablePage() {
    (0, _classCallCheck3.default)(this, MyStablePage);
    return (0, _possibleConstructorReturn3.default)(this, (MyStablePage.__proto__ || (0, _getPrototypeOf2.default)(MyStablePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyStablePage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          router = _props.router;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: 'racing', title: 'My Stable', helmetProps: { titleTemplate: _seoUtils.titleTemplate.plain } },
        _react2.default.createElement(
          'div',
          { className: 'main-layout-left-column' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block last-desktop' },
            _react2.default.createElement(
              _MyStablePageContainer2.default,
              { location: location, router: router },
              this.props.MyStablePageContainer.props.children
            )
          ),
          _react2.default.createElement(
            'div',
            { id: 'left-most-read', className: 'main-layout-block last-handheld main-layout-hide-desktop' },
            _react2.default.createElement(_HorseRacingMostFollowed2.default, { location: location, plainTitle: true })
          )
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: 'racing',
          content: ["topMpu", "horseRacingMostFollowed", "horseRacingNextRaceOffAll", "bottomMpu", "ocWidget"] })
      );
    }
  }]);
  return MyStablePage;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object.isRequired,
  router: _propTypes2.default.object.isRequired,
  MyStablePageContainer: _propTypes2.default.object.isRequired
}, _temp);
exports.default = MyStablePage;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _reactRouter = __webpack_require__(11);

var _utils = __webpack_require__(32);

var _lodash = __webpack_require__(20);

var _LocalDateTimeHelper = __webpack_require__(13);

var _OrdinalSuffix = __webpack_require__(218);

var _OrdinalSuffix2 = _interopRequireDefault(_OrdinalSuffix);

var _MyStableUnauthenticatedUser = __webpack_require__(267);

var _MyStableUnauthenticatedUser2 = _interopRequireDefault(_MyStableUnauthenticatedUser);

var _userService = __webpack_require__(44);

var _myStableResults = __webpack_require__(424);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1447);

var MyStableResults = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([(0, _userService.userServiceLayoutConnect)({
  then: function then(_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return dispatch((0, _myStableResults.loadResults)(getState().common.userService.subscriptions));
  },
  state: function state(_state) {
    return { auth: _state.common.auth, myStableResults: _state.horseRacing.myStableResults };
  }
})]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MyStableResults, _Component);

  function MyStableResults() {
    (0, _classCallCheck3.default)(this, MyStableResults);
    return (0, _possibleConstructorReturn3.default)(this, (MyStableResults.__proto__ || (0, _getPrototypeOf2.default)(MyStableResults)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyStableResults, [{
    key: 'render',
    value: function render() {
      if (!this.props.isLoggedIn()) {
        return _react2.default.createElement(_MyStableUnauthenticatedUser2.default, null);
      }
      var results = this.props.myStableResults.results;


      return _react2.default.createElement(
        'section',
        { className: 'my-stable-results-container' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: 'Next Results' }),
        _react2.default.createElement(
          'h3',
          { className: 'my-stable-subtitle section-title' },
          'Your Results'
        ),
        !(0, _lodash.isEmpty)(results) ? (0, _keys2.default)(results).sort().map(function (entry, i) {
          return _react2.default.createElement(MyStableResultsTable, { key: entry + '-' + i, label: (0, _LocalDateTimeHelper.localDateShortDescriptive)(entry), results: results[entry] });
        }) : _react2.default.createElement(
          'div',
          { className: 'my-stable-selection-none' },
          _react2.default.createElement(
            'span',
            null,
            'None of your selections have any results.'
          )
        )
      );
    }
  }]);
  return MyStableResults;
}(_react.Component), _class2.propTypes = {
  isLoggedIn: _propTypes2.default.func.isRequired,
  auth: _propTypes2.default.object.isRequired,
  myStableResults: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = MyStableResults;


function extractRaceProps(race, matchType) {
  var matchingRide = race.rides[0];
  var parts = [['Horse', matchingRide.horse.name || 'Not Specified'], ['Jockey', matchingRide.jockey.name || 'Not Specified'], ['Trainer', matchingRide.trainer.name || 'Not Specified']];

  var matchIndexMap = { 'H': 0, 'J': 1, 'T': 2 };

  return {
    mainName: parts.splice(matchIndexMap[matchType], 1)[0][1],
    matchType: matchType,
    raceName: race.race_summary.name,
    parts: parts
  };
}

function hrefData(race) {
  var _race$race_summary = race.race_summary,
      date = _race$race_summary.date,
      course_name = _race$race_summary.course_name,
      name = _race$race_summary.name,
      id = _race$race_summary.race_summary_reference.id;


  return {
    course_name: course_name,
    date: (0, _LocalDateTimeHelper.isoDate)(date),
    race_id: id,
    race_name: name
  };
}

function MyStableResultsTable(_ref2) {
  var label = _ref2.label,
      results = _ref2.results;

  var sortedRes = (0, _lodash.sortBy)(results, function (o) {
    return o.race.race_summary.time;
  });

  return _react2.default.createElement(
    'section',
    { className: 'my-stable-results' },
    _react2.default.createElement(
      'div',
      { className: 'my-stable-section-header' },
      _react2.default.createElement(
        'span',
        { className: 'my-stable-section-header-key' },
        label
      ),
      _react2.default.createElement('span', { className: 'my-stable-section-header-remove' })
    ),
    _react2.default.createElement(
      'div',
      { className: '' },
      _react2.default.createElement(
        'table',
        { className: 'my-stable-table' },
        _react2.default.createElement(
          'tbody',
          null,
          sortedRes.map(function (_ref3) {
            var matched = _ref3.matched,
                race = _ref3.race,
                matchType = _ref3.matchType;
            return _react2.default.createElement(
              'tr',
              { key: matched + '-' + race.race_summary.race_summary_reference.id + '-' + race.rides[0].horse.name + '-' + matchType },
              _react2.default.createElement(
                'td',
                { className: 'my-stable-results-time' },
                race.race_summary.time
              ),
              _react2.default.createElement(
                'td',
                { className: 'my-stable-results-details' },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: (0, _utils.resultHref)(hrefData(race)) },
                  _react2.default.createElement(MyStableResultMatchRows, extractRaceProps(race, matchType))
                )
              ),
              _react2.default.createElement(
                'td',
                { className: 'my-stable-results-pos' },
                (0, _OrdinalSuffix2.default)(race.rides[0].amended_position || race.rides[0].finish_position) || 'N/A'
              )
            );
          })
        )
      )
    )
  );
}

MyStableResultsTable.propTypes = {
  label: _propTypes2.default.string.isRequired,
  results: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    matched: _propTypes2.default.number.isRequired,
    race: _propTypes2.default.shape({
      race_summary: _propTypes2.default.shape({
        race_summary_reference: _propTypes2.default.shape({
          id: _propTypes2.default.number
        })
      })
    })
  }))
};

function MyStableResultMatchRows(props) {
  return _react2.default.createElement(
    'span',
    null,
    _react2.default.createElement(
      'p',
      { className: 'who-where' },
      _react2.default.createElement(
        'span',
        { className: 'my-stable-results-details-horse' },
        props.mainName
      ),
      ' (' + props.matchType + ') ',
      !!props.raceName && ' - ' + props.raceName
    ),
    _react2.default.createElement(
      'p',
      { className: 'others' },
      props.parts.map(function (part) {
        return part.join(': ');
      }).join(', ')
    )
  );
}

MyStableResultMatchRows.propTypes = {
  mainName: _propTypes2.default.string.isRequired,
  raceName: _propTypes2.default.string,
  matchType: _propTypes2.default.string.isRequired,
  parts: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.string)).isRequired
};

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _reactRouter = __webpack_require__(11);

var _reactRedux = __webpack_require__(17);

var _CollapsibleSection = __webpack_require__(99);

var _CollapsibleSection2 = _interopRequireDefault(_CollapsibleSection);

var _utils = __webpack_require__(32);

var _SubscriptionContainer = __webpack_require__(92);

var _SubscriptionContainer2 = _interopRequireDefault(_SubscriptionContainer);

var _MyStableLink = __webpack_require__(781);

var _MyStableLink2 = _interopRequireDefault(_MyStableLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1448);

function MyStableSearchResults(props) {
  return _react2.default.createElement(
    'section',
    { className: 'my-stable-search-container' },
    _react2.default.createElement(_MetaDataWrapper2.default, { title: 'Search' }),
    _react2.default.createElement(
      'h3',
      { className: 'section-title' },
      props.myStableHorseResults.searchText ? 'Search Results for "' + props.myStableHorseResults.searchText + '"' : 'Enter search criteria'
    ),
    _react2.default.createElement(SearchResultsTable, {
      keyName: 'Horse',
      linkType: 'horse',
      results: props.myStableHorseResults.horseSearchResults,
      loading: !!props.myStableHorseResults.loading,
      searchText: props.myStableHorseResults.searchText,
      resultMap: function resultMap(horse) {
        return { type: 'HORSE', id: horse.horse_reference.id, text: horse.name };
      }
    }),
    _react2.default.createElement(SearchResultsTable, {
      keyName: 'Jockey',
      linkType: 'jockey',
      results: props.myStableJockeyResults.jockeySearchResults,
      loading: !!props.myStableJockeyResults.loading,
      searchText: props.myStableHorseResults.searchText,
      resultMap: function resultMap(jockey) {
        return { type: 'JOCKEY', id: jockey.person_reference.id, text: jockey.name };
      }
    }),
    _react2.default.createElement(SearchResultsTable, {
      keyName: 'Trainer',
      linkType: 'trainer',
      results: props.myStableTrainerResults.trainerSearchResults,
      loading: !!props.myStableTrainerResults.loading,
      searchText: props.myStableHorseResults.searchText,
      resultMap: function resultMap(trainer) {
        return { type: 'TRAINER', id: trainer.business_reference.id, text: trainer.name };
      }
    })
  );
}

MyStableSearchResults.propTypes = {
  myStableHorseResults: _propTypes2.default.shape({
    loading: _propTypes2.default.bool,
    loaded: _propTypes2.default.bool,
    horseSearchResults: _propTypes2.default.array.isRequired,
    searchText: _propTypes2.default.string
  }),
  myStableJockeyResults: _propTypes2.default.shape({
    loading: _propTypes2.default.bool,
    loaded: _propTypes2.default.bool,
    jockeySearchResults: _propTypes2.default.array.isRequired
  }),
  myStableTrainerResults: _propTypes2.default.shape({
    loading: _propTypes2.default.bool,
    loaded: _propTypes2.default.bool,
    trainerSearchResults: _propTypes2.default.array.isRequired
  })
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    myStableHorseResults: state.horseRacing.myStableHorseSearch,
    myStableJockeyResults: state.horseRacing.myStableJockeySearch,
    myStableTrainerResults: state.horseRacing.myStableTrainerSearch
  };
})(MyStableSearchResults);


function SearchResultsTable(_ref) {
  var keyName = _ref.keyName,
      linkType = _ref.linkType,
      _ref$results = _ref.results,
      results = _ref$results === undefined ? [] : _ref$results,
      loading = _ref.loading,
      searchText = _ref.searchText,
      resultMap = _ref.resultMap;


  var mappedResults = results.map(function (result) {
    return resultMap(result);
  });

  return _react2.default.createElement(
    'div',
    { className: 'my-stable-search-results' },
    _react2.default.createElement(
      _CollapsibleSection2.default,
      { title: keyName + 's (' + (loading ? 'loading results...' : results.length + ' result/s') + ')', collapsed: !(results.length > 0) },
      results.length > 0 ? _react2.default.createElement(
        'div',
        { className: 'my-stable-search-table-container' },
        loading && _react2.default.createElement('div', { className: 'loading-overlay' }),
        _react2.default.createElement(
          'table',
          { className: 'my-stable-search-table' },
          _react2.default.createElement(
            'tbody',
            null,
            mappedResults.map(function (_ref2) {
              var type = _ref2.type,
                  id = _ref2.id,
                  text = _ref2.text;
              return _react2.default.createElement(
                'tr',
                { key: id, className: 'my-stable-search-row' },
                _react2.default.createElement(
                  'td',
                  { className: 'my-stable-search-name' },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: (0, _utils.racingProfileLink)(linkType, id) },
                    text
                  )
                ),
                _react2.default.createElement(
                  'td',
                  { className: 'my-stable-search-add' },
                  _react2.default.createElement(_SubscriptionContainer2.default, {
                    addSubscriptions: [{ type: type, id: id, text: text }],
                    icon: _react2.default.createElement(_MyStableLink2.default, null)
                  })
                )
              );
            })
          )
        )
      ) : searchText ? _react2.default.createElement(
        'div',
        { className: 'my-stable-search-no-results' },
        'Sorry, no ' + keyName + ' profiles found for ',
        _react2.default.createElement(
          'span',
          null,
          '\'' + searchText + '\''
        )
      ) : _react2.default.createElement(
        'div',
        { className: 'my-stable-search-no-results' },
        'Enter search criteria'
      )
    )
  );
}

SearchResultsTable.propTypes = {
  keyName: _propTypes2.default.string.isRequired,
  linkType: _propTypes2.default.string.isRequired,
  results: _propTypes2.default.array,
  loading: _propTypes2.default.bool,
  searchText: _propTypes2.default.string,
  resultMap: _propTypes2.default.func.isRequired
};

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _asyncConnectWrapper = __webpack_require__(14);

var _userService = __webpack_require__(44);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _reactRouter = __webpack_require__(11);

var _MyStableUnauthenticatedUser = __webpack_require__(267);

var _MyStableUnauthenticatedUser2 = _interopRequireDefault(_MyStableUnauthenticatedUser);

var _SubscriptionContainer = __webpack_require__(92);

var _SubscriptionContainer2 = _interopRequireDefault(_SubscriptionContainer);

var _MyStableCross = __webpack_require__(780);

var _MyStableCross2 = _interopRequireDefault(_MyStableCross);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1449);

var MyStableSelections = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([(0, _userService.userServiceLayoutConnect)({
  state: function state(_state) {
    return { auth: _state.common.auth, subscriptions: _state.common.userService.subscriptions };
  }
})]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(MyStableSelections, _Component);

  function MyStableSelections() {
    (0, _classCallCheck3.default)(this, MyStableSelections);
    return (0, _possibleConstructorReturn3.default)(this, (MyStableSelections.__proto__ || (0, _getPrototypeOf2.default)(MyStableSelections)).apply(this, arguments));
  }

  (0, _createClass3.default)(MyStableSelections, [{
    key: 'render',
    value: function render() {
      if (!this.props.isLoggedIn()) {
        return _react2.default.createElement(_MyStableUnauthenticatedUser2.default, null);
      }

      var subscriptionTypes = [{ type: 'HORSE', label: 'Horse', profileUrl: function profileUrl(id) {
          return '/racing/profiles/horse/' + id;
        } }, { type: 'JOCKEY', label: 'Jockey', profileUrl: function profileUrl(id) {
          return '/racing/profiles/jockey/' + id;
        } }, { type: 'TRAINER', label: 'Trainer', profileUrl: function profileUrl(id) {
          return '/racing/profiles/trainer/' + id;
        } }];

      var _props$subscriptions = this.props.subscriptions,
          subscriptions = _props$subscriptions === undefined ? {} : _props$subscriptions;


      var filteredSubscriptions = subscriptionTypes.filter(function (subscriptionType) {
        return (0, _keys2.default)(subscriptions[subscriptionType.type] || {}).length;
      });

      return _react2.default.createElement(
        'section',
        { className: 'userSelections' },
        _react2.default.createElement(_MetaDataWrapper2.default, { title: 'Your Selections' }),
        _react2.default.createElement(
          'h3',
          { className: 'my-stable-subtitle section-title' },
          'Your Selections'
        ),
        _react2.default.createElement(
          'p',
          { className: 'my-stable-selections-info' },
          _react2.default.createElement(
            'small',
            null,
            'You may select a maximum of 100 Horses, 10 Jockeys and 10 Trainers for e-mail updates.'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'my-stable-selections' },
          filteredSubscriptions.length > 0 ? filteredSubscriptions.map(function (subscriptionType) {
            return _react2.default.createElement(
              'div',
              { className: 'my-stable-selection-section', key: subscriptionType.type },
              _react2.default.createElement(
                'div',
                { className: 'my-stable-section-header' },
                _react2.default.createElement(
                  'span',
                  { className: 'my-stable-section-header-key', id: "my-stable-" + subscriptionType.label },
                  subscriptionType.label
                ),
                _react2.default.createElement('span', { className: 'my-stable-section-header-remove' })
              ),
              _react2.default.createElement(
                'table',
                { className: 'my-stable-table' },
                _react2.default.createElement(
                  'tbody',
                  null,
                  (0, _keys2.default)(subscriptions[subscriptionType.type]).map(function (id) {
                    return _react2.default.createElement(
                      'tr',
                      { key: id },
                      _react2.default.createElement(
                        'td',
                        { className: 'my-stable-selection-table-key-name' },
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { to: subscriptionType.profileUrl(id) },
                          subscriptions[subscriptionType.type][id].text
                        )
                      ),
                      _react2.default.createElement(
                        'td',
                        { className: 'my-stable-selection-table-key-remove' },
                        _react2.default.createElement(_SubscriptionContainer2.default, {
                          addSubscriptions: [{
                            type: subscriptionType.type,
                            id: id,
                            text: subscriptions[subscriptionType.type][id].text
                          }],
                          icon: _react2.default.createElement(_MyStableCross2.default, null)
                        })
                      )
                    );
                  })
                )
              )
            );
          }) : _react2.default.createElement(
            'div',
            { className: 'my-stable-selection-none' },
            _react2.default.createElement(
              'span',
              null,
              'You haven\'t made any selections for \'My Stable\'. Begin by searching for your favourite horse, jockey or trainer.'
            )
          )
        )
      );
    }
  }]);
  return MyStableSelections;
}(_react.Component), _class2.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  isLoggedIn: _propTypes2.default.func.isRequired,
  auth: _propTypes2.default.object.isRequired,
  subscriptions: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class);
exports.default = MyStableSelections;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _seoUtils = __webpack_require__(23);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

var _NapsTable = __webpack_require__(410);

var _NapsTable2 = _interopRequireDefault(_NapsTable);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HorseRacingMostFollowed = __webpack_require__(80);

var _HorseRacingMostFollowed2 = _interopRequireDefault(_HorseRacingMostFollowed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NapsTablePage = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(NapsTablePage, _Component);

  function NapsTablePage() {
    (0, _classCallCheck3.default)(this, NapsTablePage);
    return (0, _possibleConstructorReturn3.default)(this, (NapsTablePage.__proto__ || (0, _getPrototypeOf2.default)(NapsTablePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(NapsTablePage, [{
    key: 'render',
    value: function render() {
      var helmetProps = (0, _extends3.default)({
        title: "Naps Table & Tips"
      }, (0, _seoUtils.metaDescription)('Today\'s naps table and records of the best horse racing tipsters in the UK and Ireland, including Sporting Life\'s Ben Linfoot.'));

      var location = this.props.location;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: 'racing', title: 'Naps Table & Tips', helmetProps: helmetProps },
        _react2.default.createElement(
          'div',
          { className: 'main-layout-left-column' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block last-desktop' },
            _react2.default.createElement(_NapsTable2.default, { location: location })
          ),
          _react2.default.createElement(
            'div',
            { id: 'left-most-read', className: 'main-layout-block last-handheld main-layout-hide-desktop' },
            _react2.default.createElement(_HorseRacingMostFollowed2.default, { location: location, plainTitle: true })
          )
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: 'racing',
          content: ["topMpu", "horseRacingNextRaceOffAll", "racingTips", "bottomMpu", "ocWidget", "horseRacingMostFollowed"] })
      );
    }
  }]);
  return NapsTablePage;
}(_react.Component), _class2.propTypes = {
  location: _propTypes2.default.object.isRequired
}, _temp)) || _class;

exports.default = NapsTablePage;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _horseProfile = __webpack_require__(416);

var _asyncConnectWrapper = __webpack_require__(14);

var _seoUtils = __webpack_require__(23);

var _utils = __webpack_require__(32);

var _SwitchBtns = __webpack_require__(102);

var _SwitchBtns2 = _interopRequireDefault(_SwitchBtns);

var _ProfileHeading = __webpack_require__(268);

var _ProfileHeading2 = _interopRequireDefault(_ProfileHeading);

var _HorseProfileDetails = __webpack_require__(936);

var _HorseProfileDetails2 = _interopRequireDefault(_HorseProfileDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1451);

var HorseProfilePageContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var horseId = _ref.params.horseId;
    return (0, _horseProfile.load)(horseId);
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state;
    return (0, _horseProfile.isProfileLoaded)(state);
  },
  state: function state(_state) {
    return { profile: _state.horseRacing.horseProfile.profile };
  },
  errorState: function errorState(state) {
    return state.horseRacing.horseProfile.error;
  },
  refreshInterval: 60000,
  preserveRefresh: true,
  reset: function reset() {
    return (0, _horseProfile.resetProfileLoaded)();
  },
  handleError: true,
  reportStatus: true
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(HorseProfilePageContainer, _Component);

  function HorseProfilePageContainer() {
    (0, _classCallCheck3.default)(this, HorseProfilePageContainer);
    return (0, _possibleConstructorReturn3.default)(this, (HorseProfilePageContainer.__proto__ || (0, _getPrototypeOf2.default)(HorseProfilePageContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(HorseProfilePageContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          routes = _props.routes,
          children = _props.children,
          profile = _props.profile,
          _props$profile = _props.profile;
      _props$profile = _props$profile === undefined ? {} : _props$profile;
      var name = _props$profile.name,
          _props$profile$horse_ = _props$profile.horse_reference;
      _props$profile$horse_ = _props$profile$horse_ === undefined ? {} : _props$profile$horse_;
      var id = _props$profile$horse_.id;


      return _react2.default.createElement(
        'div',
        { className: 'horse-profile' },
        _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: (0, _extends3.default)({}, (0, _seoUtils.canonicalLink)(routes, { horseId: id })) }),
        _react2.default.createElement(_ProfileHeading2.default, (0, _extends3.default)({ classPrefix: 'horse', type: 'HORSE' }, { id: id, name: name })),
        _react2.default.createElement(_HorseProfileDetails2.default, { profile: profile }),
        _react2.default.createElement(_SwitchBtns2.default, { buttons: [{ href: (0, _utils.racingProfileLink)('horse', id), isIndex: true, text: "All Results" }, { href: (0, _utils.racingProfileLink)('horse', id) + '/future-entries', text: "Future Entries" }] }),
        children && _react2.default.cloneElement(children, { profile: profile })
      );
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      return _react2.default.createElement(
        'div',
        { className: 'horse-profile' },
        _react2.default.createElement(
          'h1',
          null,
          'Horse not found'
        ),
        _react2.default.createElement(
          'div',
          { className: 'horse-profile-not-found' },
          'The horse you were looking for could not be found'
        )
      );
    }
  }]);
  return HorseProfilePageContainer;
}(_react.Component), _class2.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  profile: _propTypes2.default.object,
  params: _propTypes2.default.object,
  children: _propTypes2.default.node.isRequired
}, _temp)) || _class);
exports.default = HorseProfilePageContainer;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _jockeyProfile = __webpack_require__(417);

var _asyncConnectWrapper = __webpack_require__(14);

var _seoUtils = __webpack_require__(23);

var _utils = __webpack_require__(32);

var _SwitchBtns = __webpack_require__(102);

var _SwitchBtns2 = _interopRequireDefault(_SwitchBtns);

var _ProfileHeading = __webpack_require__(268);

var _ProfileHeading2 = _interopRequireDefault(_ProfileHeading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1452);

var JockeyProfilePageContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var jockeyId = _ref.params.jockeyId;
    return (0, _jockeyProfile.load)(jockeyId);
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state;
    return (0, _jockeyProfile.isProfileLoaded)(state);
  },
  state: function state(_state) {
    return { profile: _state.horseRacing.jockeyProfile.profile };
  },
  errorState: function errorState(state) {
    return state.horseRacing.jockeyProfile.error;
  },
  refreshInterval: 60000,
  preserveRefresh: true,
  reset: function reset() {
    return (0, _jockeyProfile.resetProfileLoaded)();
  },
  handleError: true,
  reportStatus: true
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(JockeyProfilePageContainer, _Component);

  function JockeyProfilePageContainer() {
    (0, _classCallCheck3.default)(this, JockeyProfilePageContainer);
    return (0, _possibleConstructorReturn3.default)(this, (JockeyProfilePageContainer.__proto__ || (0, _getPrototypeOf2.default)(JockeyProfilePageContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(JockeyProfilePageContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          routes = _props.routes,
          children = _props.children,
          profile = _props.profile,
          _props$profile = _props.profile;
      _props$profile = _props$profile === undefined ? {} : _props$profile;
      var _props$profile$person = _props$profile.person_details;
      _props$profile$person = _props$profile$person === undefined ? {} : _props$profile$person;
      var name = _props$profile$person.name,
          _props$profile$person2 = _props$profile$person.person_reference;
      _props$profile$person2 = _props$profile$person2 === undefined ? {} : _props$profile$person2;
      var id = _props$profile$person2.id;


      return _react2.default.createElement(
        'div',
        { className: 'jockey-profile' },
        _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: (0, _extends3.default)({}, (0, _seoUtils.canonicalLink)(routes, { jockeyId: id })) }),
        _react2.default.createElement(_ProfileHeading2.default, (0, _extends3.default)({ classPrefix: 'jockey', type: 'JOCKEY' }, { id: id, name: name })),
        _react2.default.createElement(_SwitchBtns2.default, { buttons: [{ href: (0, _utils.racingProfileLink)('jockey', id), isIndex: true, text: "All Results" }, { href: (0, _utils.racingProfileLink)('jockey', id) + '/future-entries', text: "Future Entries" }] }),
        children && _react2.default.cloneElement(children, { profile: profile })
      );
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      return _react2.default.createElement(
        'div',
        { className: 'jockey-profile' },
        _react2.default.createElement(
          'h1',
          null,
          'Jockey not found'
        ),
        _react2.default.createElement(
          'div',
          { className: 'jockey-profile-not-found' },
          'The jockey you were looking for could not be found'
        )
      );
    }
  }]);
  return JockeyProfilePageContainer;
}(_react.Component), _class2.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  profile: _propTypes2.default.object,
  params: _propTypes2.default.object,
  children: _propTypes2.default.node.isRequired
}, _temp)) || _class);
exports.default = JockeyProfilePageContainer;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _trainerProfile = __webpack_require__(430);

var _asyncConnectWrapper = __webpack_require__(14);

var _seoUtils = __webpack_require__(23);

var _utils = __webpack_require__(32);

var _SwitchBtns = __webpack_require__(102);

var _SwitchBtns2 = _interopRequireDefault(_SwitchBtns);

var _ProfileHeading = __webpack_require__(268);

var _ProfileHeading2 = _interopRequireDefault(_ProfileHeading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1453);

var TrainerProfilePageContainer = (_dec = (0, _asyncConnectWrapper.standardAsyncConnect)([{
  dispatch: function dispatch(_ref) {
    var trainerId = _ref.params.trainerId;
    return (0, _trainerProfile.load)(trainerId);
  },
  preventResolve: function preventResolve(_ref2) {
    var state = _ref2.state;
    return (0, _trainerProfile.isProfileLoaded)(state);
  },
  state: function state(_state) {
    return { profile: _state.horseRacing.trainerProfile.profile };
  },
  errorState: function errorState(state) {
    return state.horseRacing.trainerProfile.error;
  },
  refreshInterval: 60000,
  preserveRefresh: true,
  reset: function reset() {
    return (0, _trainerProfile.resetProfileLoaded)();
  },
  handleError: true,
  reportStatus: true
}]), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TrainerProfilePageContainer, _Component);

  function TrainerProfilePageContainer() {
    (0, _classCallCheck3.default)(this, TrainerProfilePageContainer);
    return (0, _possibleConstructorReturn3.default)(this, (TrainerProfilePageContainer.__proto__ || (0, _getPrototypeOf2.default)(TrainerProfilePageContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(TrainerProfilePageContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          routes = _props.routes,
          children = _props.children,
          profile = _props.profile,
          _props$profile = _props.profile;
      _props$profile = _props$profile === undefined ? {} : _props$profile;
      var _props$profile$person = _props$profile.person_details;
      _props$profile$person = _props$profile$person === undefined ? {} : _props$profile$person;
      var name = _props$profile$person.name,
          _props$profile$person2 = _props$profile$person.person_reference;
      _props$profile$person2 = _props$profile$person2 === undefined ? {} : _props$profile$person2;
      var id = _props$profile$person2.id;


      return _react2.default.createElement(
        'div',
        { className: 'trainer-profile' },
        _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: (0, _extends3.default)({}, (0, _seoUtils.canonicalLink)(routes, { trainerId: id })) }),
        _react2.default.createElement(_ProfileHeading2.default, (0, _extends3.default)({ classPrefix: 'trainer', type: 'TRAINER' }, { id: id, name: name })),
        _react2.default.createElement(_SwitchBtns2.default, { buttons: [{ href: (0, _utils.racingProfileLink)('trainer', id), isIndex: true, text: "All Results" }, { href: (0, _utils.racingProfileLink)('trainer', id) + '/future-entries', text: "Future Entries" }] }),
        children && _react2.default.cloneElement(children, { profile: profile })
      );
    }
  }, {
    key: 'renderError',
    value: function renderError() {
      return _react2.default.createElement(
        'div',
        { className: 'trainer-profile' },
        _react2.default.createElement(
          'h1',
          null,
          'Trainer not found'
        ),
        _react2.default.createElement(
          'div',
          { className: 'trainer-profile-not-found' },
          'The trainer you were looking for could not be found'
        )
      );
    }
  }]);
  return TrainerProfilePageContainer;
}(_react.Component), _class2.propTypes = {
  routes: _propTypes2.default.array.isRequired,
  profile: _propTypes2.default.object,
  params: _propTypes2.default.object,
  children: _propTypes2.default.node.isRequired
}, _temp)) || _class);
exports.default = TrainerProfilePageContainer;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layoutUtils = __webpack_require__(176);

var _GptProperties = __webpack_require__(51);

var leaderboardAd = {
  view: 'racing'
};

var topMPU = {
  component: 'GooglePublisherTag',
  props: _GptProperties.topMPUProps,
  desktopColumn: 'right',
  desktopOrder: 1,
  handheldOrder: false
};

var bottomMPU = {
  component: 'GooglePublisherTag',
  props: _GptProperties.bottomMPUProps,
  desktopColumn: 'right',
  desktopOrder: 3,
  handheldOrder: false
};

var mostRead = {
  component: "MostReadRacing",
  desktopColumn: "right",
  desktopOrder: 1,
  handheldOrder: 3
};

var nextRaceOff = {
  component: "HorseRacingNextRaceOff",
  props: {
    displayAll: true
  },
  desktopColumn: "right",
  desktopOrder: 2,
  handheldOrder: false
};

var tips = {
  component: "RacingTips",
  desktopColumn: "right",
  desktopOrder: 3,
  handheldOrder: false
};

var advertMPU = {
  component: "AdvertWrapper",
  props: {
    ocSlot: ["racing", "mpu"],
    additionalProperties: {
      view: "racing"
    }
  },
  desktopColumn: "right",
  desktopOrder: 4,
  handheldOrder: false
};

var defaultSideBarComponentsNoTips = [topMPU, nextRaceOff, bottomMPU, advertMPU];
var defaultSideBarComponents = [topMPU, nextRaceOff, tips, bottomMPU, advertMPU];
var defaultSideBarComponentsNoAds = [nextRaceOff, tips];

var getMostFollowed = function getMostFollowed(desktopOrder, handheldOrder) {
  return {
    component: "HorseRacingMostFollowed",
    desktopColumn: "right",
    desktopOrder: desktopOrder,
    handheldOrder: handheldOrder
  };
};

var withAdverts = function withAdverts() {
  for (var _len = arguments.length, components = Array(_len), _key = 0; _key < _len; _key++) {
    components[_key] = arguments[_key];
  }

  return {
    bannerAd: _GptProperties.bannerAd,
    leaderboardAd: leaderboardAd,
    components: [].concat(components, defaultSideBarComponents)
  };
};

var withAdvertsAndMostRead = function withAdvertsAndMostRead() {
  for (var _len2 = arguments.length, components = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    components[_key2] = arguments[_key2];
  }

  return {
    bannerAd: _GptProperties.bannerAd,
    leaderboardAd: leaderboardAd,
    components: [].concat(components, [mostRead], defaultSideBarComponents)
  };
};

var withAdvertsNoTips = function withAdvertsNoTips() {
  for (var _len3 = arguments.length, components = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    components[_key3] = arguments[_key3];
  }

  return {
    bannerAd: _GptProperties.bannerAd,
    leaderboardAd: leaderboardAd,
    components: [].concat(components, defaultSideBarComponentsNoTips)
  };
};

var withAdvertsAndMostReadNoTips = function withAdvertsAndMostReadNoTips() {
  for (var _len4 = arguments.length, components = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    components[_key4] = arguments[_key4];
  }

  return {
    bannerAd: _GptProperties.bannerAd,
    leaderboardAd: leaderboardAd,
    components: [].concat(components, [mostRead], defaultSideBarComponentsNoTips)
  };
};

var withAdvertsArticle = function withAdvertsArticle() {
  for (var _len5 = arguments.length, components = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    components[_key5] = arguments[_key5];
  }

  return {
    leaderboardAd: leaderboardAd,
    components: [].concat(components, [mostRead], defaultSideBarComponents)
  };
};

var withoutAdvertsArticle = function withoutAdvertsArticle() {
  for (var _len6 = arguments.length, components = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    components[_key6] = arguments[_key6];
  }

  return {
    components: [].concat(components, [mostRead], defaultSideBarComponentsNoAds)
  };
};

var racingHomePageLayout = withAdvertsAndMostRead({
  component: "MoreNews",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
}, {
  component: 'GptAdvert',
  props: {
    ocDetails: {
      ocSlot: ['racing', 'leaderboard']
    },
    performDetails: _GptProperties.singleBottomMPUProps
  },
  desktopColumn: 'left',
  desktopOrder: 2,
  handheldOrder: 2
});

var racingFastcardsPageLayout = withAdverts({
  component: "HorseRacingFastCards",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

var racingNonRunnersPageLayout = withAdverts({
  component: "HorseRacingNonRunnersContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

var racingGoingPageLayout = withAdverts({
  component: "HorseRacingGoingContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

var racingRacecardsPageLayout = withAdverts({
  component: "HorseRacingRacecardsForDateContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
}, getMostFollowed(5, 2));

var racingFastResultsPageLayout = withAdverts({
  component: "HorseRacingFastResults",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
}, getMostFollowed(5, 2));

var racingMeetingLandingPageLayout = withAdverts({
  component: "HorseRacingMeetingLandingContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

var racingRacePageLayout = withAdverts({
  component: "HorseRacingRacePageContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
}, getMostFollowed(5, 2));

var racingResultPageLayout = withAdverts({
  component: "HorseRacingRacePageContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

var racingResultsPageLayout = withAdverts({
  component: "HorseRacingResultsForDateContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
}, getMostFollowed(5, 2));

var racingEarlyEntiresPageLayout = withAdverts({
  component: "HorseRacingEarlyEntriesContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

var racingHorseProfilePageLayout = withAdverts({
  component: "HorseProfilePageContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

var racingTrainerProfilePageLayout = withAdverts({
  component: "TrainerProfilePageContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

var racingJockeyProfilePageLayout = withAdverts({
  component: "JockeyProfilePageContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

var racingTipsCentrePageLayout = withAdvertsAndMostReadNoTips({
  component: "MoreNews",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
}, getMostFollowed(5, 2));

var racingRichardFaheyPageLayout = withAdvertsAndMostRead({
  component: 'SectionPlainTitle',
  props: {
    level: 1,
    className: 'page-main-section-title',
    children: 'Richard Fahey'
  },
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
}, {
  component: "MoreNews",
  desktopColumn: "left",
  desktopOrder: 2,
  handheldOrder: 2
});

var racingMyStable = withAdvertsNoTips({
  component: "MyStablePageContainer",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
}, getMostFollowed(2, 2));

var napsTableLayout = withAdverts({
  component: 'NapsTable',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
}, getMostFollowed(5, 2));

var abcGuideLayout = withAdverts({
  component: 'HorseRacingAbcGuide',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
}, getMostFollowed(5, 2));

var insightsLayout = withAdverts({
  component: 'InsightDescriptionsContainer',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
}, getMostFollowed(5, 2));

var article = {
  component: 'Article',
  desktopColumn: 'left',
  desktopOrder: 1,
  handheldOrder: 1
};
var racingArticleLayout = withAdvertsArticle(article);
var racingArticleSensitiveLayout = withoutAdvertsArticle(article);

exports.default = {
  '/racing': racingHomePageLayout,
  '/racing/fast-cards/:meetingId/:date/:courseSlug': racingFastcardsPageLayout,
  '/racing/going': racingGoingPageLayout,
  '/racing/non-runners': racingNonRunnersPageLayout,
  '/racing/racecards': racingRacecardsPageLayout,
  '/racing/racecards/:date': racingRacecardsPageLayout,
  '/racing/fast-results': racingFastResultsPageLayout,
  '/racing/meeting/:meetingDate/:meetingName/:meetingId': racingMeetingLandingPageLayout,
  '/racing/fast-results/all': racingFastResultsPageLayout,
  '/racing/racecards/:date/:courseSlug/racecard/:raceId/:raceSlug': racingRacePageLayout,
  '/racing/racecards/:date/:courseSlug/live-show/:raceId/:raceSlug': racingRacePageLayout,
  '/racing/results': racingResultsPageLayout,
  '/racing/results/:date': racingResultsPageLayout,
  '/racing/results/:date/:courseSlug/:raceId/:raceSlug': racingResultPageLayout,
  '/racing/early-entries': racingEarlyEntiresPageLayout,
  '/racing/profiles/horse/:horseId': racingHorseProfilePageLayout,
  '/racing/profiles/horse/:horseId/wins': racingHorseProfilePageLayout,
  '/racing/profiles/horse/:horseId/winsandpl': racingHorseProfilePageLayout,
  '/racing/profiles/horse/:horseId/after60': racingHorseProfilePageLayout,
  '/racing/profiles/horse/:horseId/future-entries': racingHorseProfilePageLayout,
  '/racing/profiles/trainer/:trainerId': racingTrainerProfilePageLayout,
  '/racing/profiles/trainer/:trainerId/future-entries': racingTrainerProfilePageLayout,
  '/racing/profiles/jockey/:jockeyId': racingJockeyProfilePageLayout,
  '/racing/profiles/jockey/:jockeyId/future-entries': racingJockeyProfilePageLayout,
  '/racing/tips-centre': racingTipsCentrePageLayout,
  '/racing/columnists/richard-fahey': racingRichardFaheyPageLayout,
  '/racing/my-stable': racingMyStable,
  '/racing/my-stable/results': racingMyStable,
  '/racing/my-stable/selections': racingMyStable,
  '/racing/my-stable/search': racingMyStable,
  '/racing/my-stable/unsubscribe': racingMyStable,
  '/racing/news/:title/:articleId': function racingNewsTitleArticleId(layout) {
    return (0, _layoutUtils.articleSensitivityLayout)(layout, racingArticleLayout, racingArticleSensitiveLayout);
  },
  '/racing/naps-table': napsTableLayout,
  '/racing/abc-guide': abcGuideLayout,
  '/racing/abc-guide/:days': abcGuideLayout,
  '/racing/abc-guide/:days/:type': abcGuideLayout,
  '/racing/abc-guide/:days/:type/:letterRange': abcGuideLayout,
  '/racing/insights': insightsLayout
};

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _raceUpdate = __webpack_require__(169);

var _GoogleAnalytics = __webpack_require__(275);

var _GoogleAnalytics2 = _interopRequireDefault(_GoogleAnalytics);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ERROR_EVENT_CATEGORY = 'Errors';

var errorActions = [_raceUpdate.HORSE_RACE_UPDATE_SUBSCRIBE_ERROR, _raceUpdate.HORSE_RACE_UPDATE_UNSUBSCRIBE_ERROR, _raceUpdate.HORSE_RACE_UPDATE_RECEIVE_ERROR, _raceUpdate.HORSE_RACE_UPDATE_CONNECT_ERROR, _raceUpdate.HORSE_RACE_UPDATE_FALLBACK_TO_POLLING];

var errorTracker = function errorTracker(store) {
    return function (next) {
        return function (action) {
            if (errorActions.includes(action.type)) {
                var google = _config2.default.metricsVendors.google;

                var googleAnalytics = new _GoogleAnalytics2.default(google.setup);
                var event = {
                    eventCategory: ERROR_EVENT_CATEGORY,
                    eventAction: action.type
                };

                if (action.type === _raceUpdate.HORSE_RACE_UPDATE_CONNECT_ERROR) {
                    event.eventValue = action.failedCount;
                }

                googleAnalytics.sendTracking('event', event);
            }

            return next(action);
        };
    };
};

exports.default = errorTracker;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _myStable = __webpack_require__(266);

exports.default = function (config, apiClient) {
    var postAPIUnsubscribe = sendUnsubscribeRequest(apiClient, config.api.common.userService.unsubscribeEmail);

    return {
        unsubscribeEmail: unsubscribeEmail
    };

    function unsubscribeEmail(store, next, action) {
        if (action.type === _myStable.MYSTABLE_EMAIL_UNSUBSCRIBE) {
            var _action$email = action.email,
                email = _action$email === undefined ? null : _action$email,
                _action$token = action.token,
                token = _action$token === undefined ? null : _action$token;

            if (!email || !token) {
                store.dispatch({ type: _myStable.MYSTABLE_EMAIL_UNSUBSCRIBE_FAIL });
                return next(action);
            }
            postAPIUnsubscribe(email, token).then(function () {
                store.dispatch({ type: _myStable.MYSTABLE_EMAIL_UNSUBSCRIBE_SUCCESS });
            }).catch(function () {
                store.dispatch({ type: _myStable.MYSTABLE_EMAIL_UNSUBSCRIBE_FAIL });
            });
        }
        return next(action);
    }
};

function sendUnsubscribeRequest(apiClient, url) {
    return function (email, token) {
        return apiClient.post(url, { data: { email: email, token: token } });
    };
}

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _ApiClient = __webpack_require__(64);

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _myStableEmailUnsubscribe = __webpack_require__(978);

var _myStableEmailUnsubscribe2 = _interopRequireDefault(_myStableEmailUnsubscribe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    var apiClient = new _ApiClient2.default();
    var myStableEmailUnsubscribe = new _myStableEmailUnsubscribe2.default(_config2.default, apiClient);
    return (0, _keys2.default)(myStableEmailUnsubscribe).map(function (key) {
        return function (store) {
            return function (next) {
                return function (action) {
                    return myStableEmailUnsubscribe[key](store, next, action);
                };
            };
        };
    });
};

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

exports.default = RaceUpdate;

var _raceUpdate = __webpack_require__(169);

var _skysso = __webpack_require__(72);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_COUNTRY_GROUPS = ['+'];
var QUALITY_OF_SERVICE = 0;
var MAX_CONNECTION_ATTEMPTS = 5;
var RECONNECT_DELAY = 1000;

function RaceUpdate(config, apiClient, mqttClient, hasFeature) {

    var notificationTopic = config.wss.topic.hrFastResults;
    var connect = mqttClient.connect,
        subscribe = mqttClient.subscribe,
        unsubscribe = mqttClient.unsubscribe,
        closeClient = mqttClient.closeClient;


    var fetchFrWssDetailsFromApi = getWssDetailsFromApi(apiClient, config.api.common.wssUrl);

    //return middleware funcs 
    return {
        connectToRaceUpdates: connectToRaceUpdates,
        unsubscribeFromRaceUpdates: unsubscribeFromRaceUpdates,
        subscribeToRaceUpdates: subscribeToRaceUpdates,
        failedRaceUpdateConnection: failedRaceUpdateConnection

        //create new connection to client
    };function connectToRaceUpdates(store, next, action) {
        if (hasFeature("push-fast-results") && action.type === _raceUpdate.HORSE_RACE_UPDATE_CONNECT) {
            var newMessageHandler = function newMessageHandler(topic, message) {

                try {
                    var messageItem = JSON.parse(message.toString());
                    return next({ type: _raceUpdate.HORSE_RACE_UPDATE_RECEIVED, data: messageItem });
                } catch (e) {
                    return next({ type: _raceUpdate.HORSE_RACE_UPDATE_RECEIVE_ERROR, error: e.message });
                }
            };

            var disconnectAction = function disconnectAction(err) {
                var state = store.getState();

                if (state.horseRacing.raceUpdate.intentionalMqttClose) {
                    return next(action);
                }

                if (err) {
                    var failedCount = state.horseRacing.raceUpdate.failedSubscriptionAttempts + 1;
                    return next({ type: _raceUpdate.HORSE_RACE_UPDATE_CONNECT_ERROR, err: err, failedCount: failedCount });
                }

                store.dispatch({ type: _raceUpdate.HORSE_RACE_UPDATE_CONNECT });
            };
            // get fresh details from api (true arg forces refresh of details)
            fetchFrWssDetailsFromApi(true).then(function (wssDetails) {
                var topic = wssDetails.topic,
                    wssUrl = wssDetails.wssUrl;

                connect(Buffer.from(wssUrl, 'base64').toString('ascii'), newMessageHandler, disconnectAction);
                return topic;
            }).then(function (topic) {
                //subscribe to topic
                var parsedTopics = createTopicPaths(action.countryGroups, topic);
                return subscribe(parsedTopics, QUALITY_OF_SERVICE);
            }).then(function (confirmed) {
                var confirmedTopics = confirmed.map(function (c) {
                    return c.topic;
                });
                return next({ type: _raceUpdate.HORSE_RACE_UPDATE_SUBSCRIBED, data: confirmedTopics });
            }).catch(function (error) {
                var failedCount = store.getState().horseRacing.raceUpdate.failedSubscriptionAttempts + 1;
                return next({ type: _raceUpdate.HORSE_RACE_UPDATE_CONNECT_ERROR, error: error, failedCount: failedCount });
            });
        }
        return next(action);
    }

    //subscribe to race updates topics
    function subscribeToRaceUpdates(store, next, action) {
        if (hasFeature("push-fast-results") && action.type === _raceUpdate.HORSE_RACE_UPDATE_SUBSCRIBE) {
            var state = store.getState();
            var oldTopics = state.horseRacing ? state.horseRacing.raceUpdate.subscribedTopics : [];
            var newTopics = createTopicPaths(action.countryGroups, notificationTopic);
            if (action.unsubscribe && oldTopics && oldTopics.length > 0) {
                // Unsubscribe from the old topics
                unsubscribe(oldTopics).then(function () {
                    //grab topic stored from api
                    return fetchFrWssDetailsFromApi();
                }).then(function (details) {
                    var topic = details.topic;
                    //create new cg topic groups

                    var topics = createTopicPaths(action.countryGroups, topic);
                    // Subscribe to the new topics 
                    store.dispatch({ type: _raceUpdate.HORSE_RACE_UPDATE_UNSUBSCRIBE_SUCCESS });
                    return subscribe(topics, QUALITY_OF_SERVICE);
                }).then(function (confirmed) {
                    var confirmedTopics = confirmed.map(function (c) {
                        return c.topic;
                    });
                    return next({ type: _raceUpdate.HORSE_RACE_UPDATE_SUBSCRIBED, data: confirmedTopics });
                }).catch(function (error) {
                    return next({ type: _raceUpdate.HORSE_RACE_UPDATE_SUBSCRIBE_ERROR, error: error });
                });
            } else {

                fetchFrWssDetailsFromApi().then(function (details) {
                    var topic = details.topic;

                    var topics = createTopicPaths(action.countryGroups, topic);
                    // Subscribe to the new topics
                    return subscribe(topics, QUALITY_OF_SERVICE);
                }).then(function () {
                    return next({ type: _raceUpdate.HORSE_RACE_UPDATE_SUBSCRIBED });
                }).catch(function (error) {
                    return next({ type: _raceUpdate.HORSE_RACE_UPDATE_SUBSCRIBE_ERROR, error: error });
                });
            }
        }
        return next(action);
    }

    //Unsubscribe from a topic and kill connection. 
    function unsubscribeFromRaceUpdates(store, next, action) {
        if (action.type === _raceUpdate.HORSE_RACE_UPDATE_DISCONNECTING) {
            store.dispatch({ type: _raceUpdate.HORSE_RACE_UPDATE_UNSUBSCRIBE });
        }

        if (action.type === _raceUpdate.HORSE_RACE_UPDATE_UNSUBSCRIBE || action.type === _skysso.APPBRIDGE_SLEEP) {
            var state = store.getState();
            var _state$horseRacing = state.horseRacing;
            _state$horseRacing = _state$horseRacing === undefined ? {} : _state$horseRacing;
            var _state$horseRacing$ra = _state$horseRacing.raceUpdate;
            _state$horseRacing$ra = _state$horseRacing$ra === undefined ? {} : _state$horseRacing$ra;
            var _state$horseRacing$ra2 = _state$horseRacing$ra.subscribedTopics,
                subscribedTopics = _state$horseRacing$ra2 === undefined ? [] : _state$horseRacing$ra2;


            if (subscribedTopics && subscribedTopics.length > 0) {
                unsubscribe(subscribedTopics).then(function () {
                    //kill client as its only valid for fast resutls at present
                    return closeClient();
                }).then(function () {
                    return next({ type: _raceUpdate.HORSE_RACE_UPDATE_DISCONNECTED });
                }).catch(function (error) {
                    return next({ type: _raceUpdate.HORSE_RACE_UPDATE_UNSUBSCRIBE_ERROR, error: error });
                });
            } else {
                closeClient().then(function () {
                    return next({ type: _raceUpdate.HORSE_RACE_UPDATE_UNSUBSCRIBE_SUCCESS });
                }).catch(function (error) {
                    closeClient();
                    return next({ type: _raceUpdate.HORSE_RACE_UPDATE_UNSUBSCRIBE_ERROR, error: error });
                });
            }
        }
        return next(action);
    }

    //Failed connection retry with back off delay & fallback to polling action trigger 
    function failedRaceUpdateConnection(store, next, action) {
        if (hasFeature("push-fast-results") && action.type === _raceUpdate.HORSE_RACE_UPDATE_CONNECT_ERROR) {
            var state = store.getState();
            var failedAttempts = state.horseRacing.raceUpdate.failedSubscriptionAttempts;
            if (failedAttempts >= MAX_CONNECTION_ATTEMPTS) {
                return next({ type: _raceUpdate.HORSE_RACE_UPDATE_FALLBACK_TO_POLLING });
            }

            setTimeout(function () {
                if (!state.horseRacing.raceUpdate.intentionalMqttClose) {
                    store.dispatch({ type: _raceUpdate.HORSE_RACE_UPDATE_CONNECT });
                }
            }, RECONNECT_DELAY * failedAttempts);
        }

        return next(action);
    }
}

//fetches and holds wss details from the supplied api client
function getWssDetailsFromApi(apiClient, url) {
    var details = null;
    return function () {
        var refresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        if (details && !refresh) {
            return _promise2.default.resolve(details);
        }
        return apiClient.get(url).then(function (result) {
            var _result$wss_url = result.wss_url,
                wss_url = _result$wss_url === undefined ? "" : _result$wss_url,
                _result$topics$fast_r = result.topics.fast_results,
                topic = _result$topics$fast_r === undefined ? null : _result$topics$fast_r;

            if (!wss_url) {
                return _promise2.default.reject('wss url is missing');
            }
            if (!topic) {
                return _promise2.default.reject('unable to find topic for fast results');
            }
            details = { topic: topic, wssUrl: wss_url };
            return details;
        });
    };
}

//hydrate a topic pattern with country groups
function createTopicPaths() {
    var countryGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_COUNTRY_GROUPS;
    var topicPattern = arguments[1];

    countryGroups = countryGroups.length > 0 ? countryGroups : DEFAULT_COUNTRY_GROUPS;
    var topics = countryGroups.map(function (g) {
        return topicPattern.replace('${countryGroup}', g).replace(/\${[a-zA-Z0-9]+}/g, '+');
    });
    return topics;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(188).Buffer))

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

exports.default = function () {
    var apiClient = new _ApiClient2.default();
    var mqttClient = new _MqttClient2.default();
    var raceUpdateMiddleware = new _raceUpdate2.default(_config2.default, apiClient, mqttClient, _features.has);
    //map & wrap exported middleware funcs 
    return (0, _keys2.default)(raceUpdateMiddleware).map(function (key) {
        return function (store) {
            return function (next) {
                return function (action) {
                    return raceUpdateMiddleware[key](store, next, action);
                };
            };
        };
    });
};

var _MqttClient = __webpack_require__(1047);

var _MqttClient2 = _interopRequireDefault(_MqttClient);

var _ApiClient = __webpack_require__(64);

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _features = __webpack_require__(65);

var _raceUpdate = __webpack_require__(980);

var _raceUpdate2 = _interopRequireDefault(_raceUpdate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HorseRacingNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener,
      moreOpen = _ref.moreOpen,
      moreOpener = _ref.moreOpener;

  var props = {
    open: open,
    opener: opener,
    moreOpen: moreOpen,
    moreOpener: moreOpener,
    title: "Racing",
    links: [{ href: "/racing", text: "News", isIndex: true }, { href: "/racing/racecards", text: "Racecards" }, { href: "/racing/fast-results", text: "Fast Results", alternatives: [{ href: "/racing/meeting/" }] }, { href: "/racing/results", text: "Full Results" }, { href: "/racing/non-runners", text: "NRs" }, { href: "/racing/my-stable", text: "My Stable", inDropdown: true, exceptions: [{ href: "/racing/my-stable/search" }] }, { href: "/racing/tips-centre", text: "Tips", inDropdown: true }, { href: "/racing/my-stable/search", text: "Search", inDropdown: true }, { href: "/racing/naps-table", text: "Naps", inDropdown: true }, { href: "/racing/abc-guide", text: "ABC", inDropdown: true }, { href: "/racing/going", text: "Going" }, { href: "/racing/columnists/richard-fahey", text: "Richard Fahey", inDropdown: true }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

HorseRacingNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired,
  moreOpen: _propTypes2.default.bool,
  moreOpener: _propTypes2.default.func
};

exports.default = HorseRacingNav;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var initialState = [{
  type: "FIRST_TIME_BLINKERS",
  title: "First-time Blinkers",
  description: "Blinkers are usually made of leather or plastic cups that are placed on the side of the eyes, either attached to a bridle or to an independent hood. They are used to help a horse focus on the task at hand, in some instances aiding concentration. The fitting of first-time blinkers may also be an indication that more positive tactics are in the offing."
}, {
  type: "FIRST_TIME_VISOR",
  title: "First-time Visor",
  description: "Visors are basically the same as blinkers but the main difference is that they have small peep holes cut into the back of the cups which cover the eyes. Trainers believe these keep horses focused on what is in front, encouraging them to pay attention to the race rather than distractions, such as the crowds."
}, {
  type: "FIRST_TIME_CHEEK_PIECES",
  title: "First-time Cheekpieces",
  description: "Initially used in France, cheekpieces are now popular all around the world and they are used to partially obscure a horse’s sideways and rear vision, with the aim of getting the horse to concentrate. The strips of sheepskin can be white, black or brown and are fastened to each side of a horse’s bridle."
}, {
  type: "FIRST_TIME_HOOD",
  title: "First-time Hood",
  description: "In contrast to blinkers, and to some extent cheekpieces, which are both used to sharpen a horse’s focus and liven them up a little, a hood is considered more of a pacifier in order to calm a horse down if it has a tendency to race too keenly or be overly exuberant in the preliminaries. The fitting of a hood for the first time can have a significant influence and may help a horse produce an improved finishing effort."
}, {
  type: "FIRST_TIME_EYE_SHIELD",
  title: "First-time Eye-Shield",
  description: "An eye-shield is employed by a trainer most often when their horse is running on all-weather polytrack and fibresand racetracks. The sand-based nature of the surface causes ‘kickback’ for those horses behind the leaders, so an eye-shield is a protective mesh over the horse’s eyes to guard against the sandstorm."
}, {
  type: "FIRST_TIME_EYE_COVER",
  title: "First-time Eye-Cover",
  description: "Eye-covers are very similar in principle to blinkers and eye-shields, whereby the horse’s concentration is channelled on the race at hand rather than risking distraction from their peripheral vision. The first-time application of an eye-cover might just eke out that bit of improvement required in the horse to get its head in front."
}, {
  type: "FIRST_TIME_TONGUE_STRAP",
  title: "First-time Tongue-strap",
  description: "The tongue-strap, or tongue-tie as it’s commonly known, is utilised to help a horse with its breathing and prevent respiratory noises. The strap holds the tongue down during the race and in some instances can result in a greatly improved performance. It is not necessarily a precursor to a breathing operation, but can be an indication that the horse has had such issues or made a noise in the past."
}, {
  type: "TRAVELLERS_CHECK",
  title: "Travellers Check",
  description: "This identifies the 10 horses that have travelled the furthest, from stable to racecourse. Petrol costs can really mount up so it’s generally worthwhile keeping an eye on which trainers have opted to send their horse/s a long way in search of a victory."
}, {
  type: "AHEAD_OF_THE_HANDICAPPER",
  title: "Ahead of the Handicapper",
  description: "More often than not, horses are handed increased BHA ratings for winning races which means they will compete from higher marks in the future. If they’re turned out quickly under a penalty, or unpenalised in some instances, then they can be racing from a lower mark than for future races. The ‘Ahead of the Handicapper’ identifies these horses that may be competing on favourable terms."
}, {
  type: "WIND_SURGERY_SINCE_LAST_RUN",
  title: "Wind Surgery Since Last Run",
  description: "Sometimes, significant improvement in a horse’s form can be brought about by small, routine operations to improve its breathing. Horses that have had wind surgery since their last run are worth keeping an eye on, particularly if they’ve shown glimmers of promise in the past, or the market speaks particularly strongly in their favour."
}, {
  type: "HOT_JOCKEY",
  title: "Hot Jockey",
  description: "Jockeys who are in a rich vein of form are indicated under the ‘Hot Jockey’ Insight, which highlights where the jockey is boasting a strike rate of at least 30% (with a minimum of 2 wins or 4 rides) in the last 14 days. Confidence is vital, so those jockeys on the crest of a wave might be worth extra attention."
}, {
  type: "HOT_TRAINER",
  title: "Hot Trainer",
  description: "Trainers whose horses are coming into form will be highlighted with a ‘Hot Trainer’ Insight: those are the trainers showing a strike rate of at least 30% (with a minimum of 2 wins or 4 rides) in the last 14 days. Catching yards whose horses are starting to find the winning post more frequently can often be a potent asset to the punter."
}];

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return state;
}

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _myStable = __webpack_require__(266);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    submitOk: null
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _myStable.MYSTABLE_EMAIL_UNSUBSCRIBE_SUCCESS:
            return (0, _extends3.default)({}, state, { submitOk: true });
        case _myStable.MYSTABLE_EMAIL_UNSUBSCRIBE_FAIL:
            return (0, _extends3.default)({}, state, { submitOk: false });
        default:
            return state;
    }
}

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _raceUpdate = __webpack_require__(169);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initState = {
    raceUpdates: [],
    subscribedTopics: [],
    failedSubscriptionAttempts: 0,
    pollFallbackEnabled: false,
    intentionalMqttClose: false
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
    var action = arguments[1];


    switch (action.type) {
        case _raceUpdate.HORSE_RACE_UPDATE_RECEIVED:
            return (0, _extends3.default)({}, state, {
                raceUpdates: [action.data].concat((0, _toConsumableArray3.default)(state.raceUpdates))
            });
        case _raceUpdate.HORSE_RACE_UPDATE_SUBSCRIBED:
            return (0, _extends3.default)({}, state, {
                subscribedTopics: [].concat((0, _toConsumableArray3.default)(state.subscribedTopics), (0, _toConsumableArray3.default)(action.data)),
                pollFallbackEnabled: false,
                failedSubscriptionAttempts: 0
            });
        case _raceUpdate.HORSE_RACE_UPDATE_UNSUBSCRIBE_SUCCESS:
            return (0, _extends3.default)({}, state, {
                subscribedTopics: []
            });
        case _raceUpdate.HORSE_RACE_UPDATE_CONNECT_ERROR:
            return (0, _extends3.default)({}, state, {
                failedSubscriptionAttempts: action.failedCount,
                intentionalMqttClose: false
            });
        case _raceUpdate.HORSE_RACE_UPDATE_FALLBACK_TO_POLLING:
            return (0, _extends3.default)({}, state, {
                pollFallbackEnabled: true
            });
        case _raceUpdate.HORSE_RACE_UPDATE_CONNECT:
            return (0, _extends3.default)({}, state, {
                intentionalMqttClose: false
            });
        case _raceUpdate.HORSE_RACE_UPDATE_DISCONNECTED:
            return (0, _extends3.default)({}, state, {
                subscribedTopics: [],
                intentionalMqttClose: true
            });
        case _raceUpdate.HORSE_RACE_UPDATE_DISCONNECTING:
            return (0, _extends3.default)({}, state, {
                intentionalMqttClose: true
            });
        default:
            return state;
    }
};

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(112);

var _meeting = __webpack_require__(418);

var _meeting2 = _interopRequireDefault(_meeting);

var _meetings = __webpack_require__(214);

var _meetings2 = _interopRequireDefault(_meetings);

var _race = __webpack_require__(429);

var _race2 = _interopRequireDefault(_race);

var _nextrace = __webpack_require__(427);

var _nextrace2 = _interopRequireDefault(_nextrace);

var _earlyEntries = __webpack_require__(412);

var _earlyEntries2 = _interopRequireDefault(_earlyEntries);

var _fastCards = __webpack_require__(413);

var _fastCards2 = _interopRequireDefault(_fastCards);

var _fastResults = __webpack_require__(414);

var _fastResults2 = _interopRequireDefault(_fastResults);

var _meetingLandingPage = __webpack_require__(419);

var _meetingLandingPage2 = _interopRequireDefault(_meetingLandingPage);

var _horseProfile = __webpack_require__(416);

var _horseProfile2 = _interopRequireDefault(_horseProfile);

var _jockeyProfile = __webpack_require__(417);

var _jockeyProfile2 = _interopRequireDefault(_jockeyProfile);

var _trainerProfile = __webpack_require__(430);

var _trainerProfile2 = _interopRequireDefault(_trainerProfile);

var _myStableEmailUnsubscribe = __webpack_require__(984);

var _myStableEmailUnsubscribe2 = _interopRequireDefault(_myStableEmailUnsubscribe);

var _myStableHorseSearch = __webpack_require__(422);

var _myStableHorseSearch2 = _interopRequireDefault(_myStableHorseSearch);

var _myStableTrainerSearch = __webpack_require__(425);

var _myStableTrainerSearch2 = _interopRequireDefault(_myStableTrainerSearch);

var _myStableJockeySearch = __webpack_require__(423);

var _myStableJockeySearch2 = _interopRequireDefault(_myStableJockeySearch);

var _myStableEntries = __webpack_require__(421);

var _myStableEntries2 = _interopRequireDefault(_myStableEntries);

var _myStableResults = __webpack_require__(424);

var _myStableResults2 = _interopRequireDefault(_myStableResults);

var _mostfollowed = __webpack_require__(420);

var _mostfollowed2 = _interopRequireDefault(_mostfollowed);

var _nonRunners = __webpack_require__(428);

var _nonRunners2 = _interopRequireDefault(_nonRunners);

var _going = __webpack_require__(415);

var _going2 = _interopRequireDefault(_going);

var _rides = __webpack_require__(270);

var _rides2 = _interopRequireDefault(_rides);

var _naps = __webpack_require__(426);

var _naps2 = _interopRequireDefault(_naps);

var _abc = __webpack_require__(411);

var _abc2 = _interopRequireDefault(_abc);

var _raceUpdate = __webpack_require__(985);

var _raceUpdate2 = _interopRequireDefault(_raceUpdate);

var _insights = __webpack_require__(983);

var _insights2 = _interopRequireDefault(_insights);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  meeting: _meeting2.default,
  meetings: _meetings2.default,
  race: _race2.default,
  nextrace: _nextrace2.default,
  fastCards: _fastCards2.default,
  fastResults: _fastResults2.default,
  meetingLandingPage: _meetingLandingPage2.default,
  earlyEntries: _earlyEntries2.default,
  horseProfile: _horseProfile2.default,
  jockeyProfile: _jockeyProfile2.default,
  trainerProfile: _trainerProfile2.default,
  myStableEmailUnsubscribe: _myStableEmailUnsubscribe2.default,
  myStableHorseSearch: _myStableHorseSearch2.default,
  myStableTrainerSearch: _myStableTrainerSearch2.default,
  myStableJockeySearch: _myStableJockeySearch2.default,
  myStableEntries: _myStableEntries2.default,
  myStableResults: _myStableResults2.default,
  mostFollowed: _mostfollowed2.default,
  naps: _naps2.default,
  nonRunners: _nonRunners2.default,
  going: _going2.default,
  rides: _rides2.default,
  abc: _abc2.default,
  raceUpdate: _raceUpdate2.default,
  insights: _insights2.default
});

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _SectionPlainTitle = __webpack_require__(166);

var _SectionPlainTitle2 = _interopRequireDefault(_SectionPlainTitle);

var _HorseRacingBase = __webpack_require__(906);

var _HorseRacingBase2 = _interopRequireDefault(_HorseRacingBase);

var _HorseRacingHomePage = __webpack_require__(951);

var _HorseRacingHomePage2 = _interopRequireDefault(_HorseRacingHomePage);

var _HorseRacingFastCardsPage = __webpack_require__(948);

var _HorseRacingFastCardsPage2 = _interopRequireDefault(_HorseRacingFastCardsPage);

var _HorseRacingRacecardsPage = __webpack_require__(959);

var _HorseRacingRacecardsPage2 = _interopRequireDefault(_HorseRacingRacecardsPage);

var _HorseRacingMostFollowed = __webpack_require__(80);

var _HorseRacingMostFollowed2 = _interopRequireDefault(_HorseRacingMostFollowed);

var _HorseRacingNonRunnersPage = __webpack_require__(955);

var _HorseRacingNonRunnersPage2 = _interopRequireDefault(_HorseRacingNonRunnersPage);

var _HorseRacingNonRunnersContainer = __webpack_require__(408);

var _HorseRacingNonRunnersContainer2 = _interopRequireDefault(_HorseRacingNonRunnersContainer);

var _HorseRacingGoingPage = __webpack_require__(950);

var _HorseRacingGoingPage2 = _interopRequireDefault(_HorseRacingGoingPage);

var _HorseRacingGoingContainer = __webpack_require__(407);

var _HorseRacingGoingContainer2 = _interopRequireDefault(_HorseRacingGoingContainer);

var _HorseRacingResultsPage = __webpack_require__(961);

var _HorseRacingResultsPage2 = _interopRequireDefault(_HorseRacingResultsPage);

var _HorseRacingFastResultsPage = __webpack_require__(949);

var _HorseRacingFastResultsPage2 = _interopRequireDefault(_HorseRacingFastResultsPage);

var _HorseRacingMeetingLandingPage = __webpack_require__(954);

var _HorseRacingMeetingLandingPage2 = _interopRequireDefault(_HorseRacingMeetingLandingPage);

var _HorseRacingEarlyEntriesPage = __webpack_require__(946);

var _HorseRacingEarlyEntriesPage2 = _interopRequireDefault(_HorseRacingEarlyEntriesPage);

var _HorseRacingRichardFaheyPage = __webpack_require__(962);

var _HorseRacingRichardFaheyPage2 = _interopRequireDefault(_HorseRacingRichardFaheyPage);

var _HorseRacingProfilePage = __webpack_require__(956);

var _HorseRacingProfilePage2 = _interopRequireDefault(_HorseRacingProfilePage);

var _NapsTablePage = __webpack_require__(972);

var _NapsTablePage2 = _interopRequireDefault(_NapsTablePage);

var _HorseRacingAbcGuidePage = __webpack_require__(944);

var _HorseRacingAbcGuidePage2 = _interopRequireDefault(_HorseRacingAbcGuidePage);

var _HorseRacingRacePageContainer = __webpack_require__(957);

var _HorseRacingRacePageContainer2 = _interopRequireDefault(_HorseRacingRacePageContainer);

var _HorseRacingFastCards = __webpack_require__(947);

var _HorseRacingFastCards2 = _interopRequireDefault(_HorseRacingFastCards);

var _HorseRacingRacecardsForDateContainer = __webpack_require__(958);

var _HorseRacingRacecardsForDateContainer2 = _interopRequireDefault(_HorseRacingRacecardsForDateContainer);

var _HorseRacingFastResults = __webpack_require__(406);

var _HorseRacingFastResults2 = _interopRequireDefault(_HorseRacingFastResults);

var _HorseRacingMeetingLandingContainer = __webpack_require__(953);

var _HorseRacingMeetingLandingContainer2 = _interopRequireDefault(_HorseRacingMeetingLandingContainer);

var _HorseRacingEarlyEntriesContainer = __webpack_require__(945);

var _HorseRacingEarlyEntriesContainer2 = _interopRequireDefault(_HorseRacingEarlyEntriesContainer);

var _HorseRacingResultsForDateContainer = __webpack_require__(960);

var _HorseRacingResultsForDateContainer2 = _interopRequireDefault(_HorseRacingResultsForDateContainer);

var _NapsTable = __webpack_require__(410);

var _NapsTable2 = _interopRequireDefault(_NapsTable);

var _HorseRacingAbcGuide = __webpack_require__(405);

var _HorseRacingAbcGuide2 = _interopRequireDefault(_HorseRacingAbcGuide);

var _MyStablePageContainer = __webpack_require__(409);

var _MyStablePageContainer2 = _interopRequireDefault(_MyStablePageContainer);

var _MyStablePage = __webpack_require__(968);

var _MyStablePage2 = _interopRequireDefault(_MyStablePage);

var _MyStableSearchResults = __webpack_require__(970);

var _MyStableSearchResults2 = _interopRequireDefault(_MyStableSearchResults);

var _MyStableSelections = __webpack_require__(971);

var _MyStableSelections2 = _interopRequireDefault(_MyStableSelections);

var _MyStableNextEntries = __webpack_require__(967);

var _MyStableNextEntries2 = _interopRequireDefault(_MyStableNextEntries);

var _MyStableResults = __webpack_require__(969);

var _MyStableResults2 = _interopRequireDefault(_MyStableResults);

var _MyStableEmailUnsubscribe = __webpack_require__(966);

var _MyStableEmailUnsubscribe2 = _interopRequireDefault(_MyStableEmailUnsubscribe);

var _InsightsPage = __webpack_require__(965);

var _InsightsPage2 = _interopRequireDefault(_InsightsPage);

var _InsightDescriptionsContainer = __webpack_require__(964);

var _InsightDescriptionsContainer2 = _interopRequireDefault(_InsightDescriptionsContainer);

var _HorseRacingTipsCentre = __webpack_require__(963);

var _HorseRacingTipsCentre2 = _interopRequireDefault(_HorseRacingTipsCentre);

var _HorseRacingRacecardPage = __webpack_require__(923);

var _HorseRacingRacecardPage2 = _interopRequireDefault(_HorseRacingRacecardPage);

var _HorseRacingLiveShowPage = __webpack_require__(914);

var _HorseRacingLiveShowPage2 = _interopRequireDefault(_HorseRacingLiveShowPage);

var _HorseRacingNav = __webpack_require__(982);

var _HorseRacingNav2 = _interopRequireDefault(_HorseRacingNav);

var _MoreNews = __webpack_require__(93);

var _MoreNews2 = _interopRequireDefault(_MoreNews);

var _MostReadRacing = __webpack_require__(203);

var _MostReadRacing2 = _interopRequireDefault(_MostReadRacing);

var _HorseProfilePageContainer = __webpack_require__(973);

var _HorseProfilePageContainer2 = _interopRequireDefault(_HorseProfilePageContainer);

var _HorseProfileResultsPage = __webpack_require__(938);

var _HorseProfileResultsPage2 = _interopRequireDefault(_HorseProfileResultsPage);

var _HorseProfileEntriesPage = __webpack_require__(937);

var _HorseProfileEntriesPage2 = _interopRequireDefault(_HorseProfileEntriesPage);

var _JockeyProfilePageContainer = __webpack_require__(974);

var _JockeyProfilePageContainer2 = _interopRequireDefault(_JockeyProfilePageContainer);

var _JockeyProfileResultsPage = __webpack_require__(941);

var _JockeyProfileResultsPage2 = _interopRequireDefault(_JockeyProfileResultsPage);

var _JockeyProfileEntriesPage = __webpack_require__(940);

var _JockeyProfileEntriesPage2 = _interopRequireDefault(_JockeyProfileEntriesPage);

var _TrainerProfilePageContainer = __webpack_require__(975);

var _TrainerProfilePageContainer2 = _interopRequireDefault(_TrainerProfilePageContainer);

var _TrainerProfileResultsPage = __webpack_require__(943);

var _TrainerProfileResultsPage2 = _interopRequireDefault(_TrainerProfileResultsPage);

var _TrainerProfileEntriesPage = __webpack_require__(942);

var _TrainerProfileEntriesPage2 = _interopRequireDefault(_TrainerProfileEntriesPage);

var _HorseRacingNextRaceOff = __webpack_require__(115);

var _HorseRacingNextRaceOff2 = _interopRequireDefault(_HorseRacingNextRaceOff);

var _RacingTips = __webpack_require__(116);

var _RacingTips2 = _interopRequireDefault(_RacingTips);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _GooglePublisherTag = __webpack_require__(71);

var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);

var _ArticleContainer = __webpack_require__(216);

var _ArticleContainer2 = _interopRequireDefault(_ArticleContainer);

var _Article = __webpack_require__(173);

var _Article2 = _interopRequireDefault(_Article);

var _sitemapHelper = __webpack_require__(217);

var _GptAdvert = __webpack_require__(101);

var _GptAdvert2 = _interopRequireDefault(_GptAdvert);

var _sitemapHelper2 = __webpack_require__(988);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingSideBarComponentsNoTips = {
  GooglePublisherTag: _GooglePublisherTag2.default,
  HorseRacingNextRaceOff: _HorseRacingNextRaceOff2.default,
  AdvertWrapper: _AdvertWrapper2.default
};

var HorseRacingSideBarComponents = (0, _extends3.default)({}, HorseRacingSideBarComponentsNoTips, {
  RacingTips: _RacingTips2.default
});

var HorseRacingHomePageComponents = (0, _extends3.default)({
  MoreNews: _MoreNews2.default,
  AdvertWrapper: _AdvertWrapper2.default,
  GptAdvert: _GptAdvert2.default,
  MostReadRacing: _MostReadRacing2.default
}, HorseRacingSideBarComponents);

var HorseRacingFastResultsPageComponents = (0, _extends3.default)({
  HorseRacingFastResults: _HorseRacingFastResults2.default,
  HorseRacingMostFollowed: _HorseRacingMostFollowed2.default
}, HorseRacingSideBarComponents);

var InsightsPageComponents = (0, _extends3.default)({
  InsightDescriptionsContainer: _InsightDescriptionsContainer2.default
}, HorseRacingSideBarComponents);

var HorseRacingMeetingLandingPageComponents = (0, _extends3.default)({
  HorseRacingMeetingLandingContainer: _HorseRacingMeetingLandingContainer2.default
}, HorseRacingSideBarComponents);

var HorseRacingNonRunnersPageComponents = (0, _extends3.default)({
  HorseRacingNonRunnersContainer: _HorseRacingNonRunnersContainer2.default
}, HorseRacingSideBarComponents);

var HorseRacingGoingPageComponents = (0, _extends3.default)({
  HorseRacingGoingContainer: _HorseRacingGoingContainer2.default
}, HorseRacingSideBarComponents);

var HorseRacingRacecardsPageComponents = (0, _extends3.default)({
  HorseRacingRacecardsForDateContainer: _HorseRacingRacecardsForDateContainer2.default,
  HorseRacingMostFollowed: _HorseRacingMostFollowed2.default
}, HorseRacingSideBarComponents);

var HorseRacingRacePageComponents = (0, _extends3.default)({
  HorseRacingRacePageContainer: _HorseRacingRacePageContainer2.default,
  HorseRacingMostFollowed: _HorseRacingMostFollowed2.default
}, HorseRacingSideBarComponents);

var HorseRacingFastCardsPageComponents = (0, _extends3.default)({
  HorseRacingFastCards: _HorseRacingFastCards2.default
}, HorseRacingSideBarComponents);

var HorseRacingResultsPageComponents = (0, _extends3.default)({
  HorseRacingResultsForDateContainer: _HorseRacingResultsForDateContainer2.default,
  HorseRacingMostFollowed: _HorseRacingMostFollowed2.default
}, HorseRacingSideBarComponents);

var HorseRacingEarlyEntriesPageComponents = (0, _extends3.default)({
  HorseRacingEarlyEntriesContainer: _HorseRacingEarlyEntriesContainer2.default
}, HorseRacingSideBarComponents);

var HorseProfilePageComponents = (0, _extends3.default)({
  ProfilePageContainer: _HorseProfilePageContainer2.default
}, HorseRacingSideBarComponents);

var TrainerProfilePageComponents = (0, _extends3.default)({
  ProfilePageContainer: _TrainerProfilePageContainer2.default
}, HorseRacingSideBarComponents);

var JockeyProfilePageComponents = (0, _extends3.default)({
  ProfilePageContainer: _JockeyProfilePageContainer2.default
}, HorseRacingSideBarComponents);

var RichardFaheyPageComponents = (0, _extends3.default)({
  MoreNews: _MoreNews2.default,
  SectionPlainTitle: _SectionPlainTitle2.default,
  MostReadRacing: _MostReadRacing2.default
}, HorseRacingSideBarComponents);

var TipsCentrePageComponents = (0, _extends3.default)({
  MoreNews: _MoreNews2.default,
  MostReadRacing: _MostReadRacing2.default,
  HorseRacingMostFollowed: _HorseRacingMostFollowed2.default
}, HorseRacingSideBarComponentsNoTips);

var MyStablePageComponents = (0, _extends3.default)({
  MyStablePageContainer: _MyStablePageContainer2.default,
  HorseRacingMostFollowed: _HorseRacingMostFollowed2.default
}, HorseRacingSideBarComponents);

var HorseRacingArticleComponents = (0, _extends3.default)({
  Article: _Article2.default,
  MostReadRacing: _MostReadRacing2.default
}, HorseRacingSideBarComponents);

var NapsTableComponents = (0, _extends3.default)({
  NapsTable: _NapsTable2.default,
  HorseRacingMostFollowed: _HorseRacingMostFollowed2.default
}, HorseRacingSideBarComponents);

var AbcGuideComponents = (0, _extends3.default)({
  HorseRacingAbcGuide: _HorseRacingAbcGuide2.default,
  HorseRacingMostFollowed: _HorseRacingMostFollowed2.default
}, HorseRacingSideBarComponents);

var horseRacingRoutes = _react2.default.createElement(
  _reactRouter.Route,
  { path: 'racing', component: _HorseRacingBase2.default, subnav: _HorseRacingNav2.default },
  _react2.default.createElement(_reactRouter.Redirect, { path: 'fast%20results', to: 'fast-results' }),
  _react2.default.createElement(
    _reactRouter.Route,
    { component: _HorseRacingHomePage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: HorseRacingHomePageComponents }),
    ' '
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'going', component: _HorseRacingGoingPage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: HorseRacingGoingPageComponents }),
    ' '
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'non-runners', component: _HorseRacingNonRunnersPage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: HorseRacingNonRunnersPageComponents }),
    ' '
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'fast-cards/:meetingId/:date/:courseSlug', component: _HorseRacingFastCardsPage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { components: HorseRacingFastCardsPageComponents }),
    ' '
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'racecards', component: _HorseRacingRacecardsPage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: HorseRacingRacecardsPageComponents }),
    ' ',
    _react2.default.createElement(_reactRouter.Route, { sitemap: { expand: _sitemapHelper2.racecardForDatesExpander }, path: ':date', components: HorseRacingRacecardsPageComponents }),
    ' ',
    _react2.default.createElement(
      _reactRouter.Route,
      { path: ':date/:courseSlug', components: HorseRacingRacePageComponents, 'result-racecard': 'racecard' },
      _react2.default.createElement(_reactRouter.Route, { path: 'racecard/:raceId/:raceSlug', sitemap: { changefreq: "always", priority: 0.5, expand: _sitemapHelper2.racecardExpander }, component: _HorseRacingRacecardPage2.default, 'result-racecard': 'racecard' }),
      ' ',
      _react2.default.createElement(_reactRouter.Route, { path: 'live-show/:raceId/:raceSlug', component: _HorseRacingLiveShowPage2.default }),
      ' '
    )
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'fast-results', component: _HorseRacingFastResultsPage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: HorseRacingFastResultsPageComponents, filterResults: true }),
    ' ',
    _react2.default.createElement(_reactRouter.Route, { path: 'all', sitemap: {}, components: HorseRacingFastResultsPageComponents, filterResults: false }),
    ' ',
    _react2.default.createElement(_reactRouter.Redirect, { path: ':meetingDate/:meetingName/:meetingId', to: '/racing/meeting/:meetingDate/:meetingName/:meetingId' }),
    ' '
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'meeting/:meetingDate/:meetingName/:meetingId', component: _HorseRacingMeetingLandingPage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { components: HorseRacingMeetingLandingPageComponents })
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'results', component: _HorseRacingResultsPage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: HorseRacingResultsPageComponents }),
    ' ',
    _react2.default.createElement(_reactRouter.Route, { path: ':date', sitemap: { expand: _sitemapHelper2.resultsExpander }, components: HorseRacingResultsPageComponents }),
    ' ',
    _react2.default.createElement(
      _reactRouter.Route,
      { path: ':date/:courseSlug/:raceId/:raceSlug', components: HorseRacingRacePageComponents, 'result-racecard': 'result' },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _HorseRacingRacecardPage2.default, 'result-racecard': 'result' }),
      ' '
    )
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'early-entries', component: _HorseRacingEarlyEntriesPage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: HorseRacingEarlyEntriesPageComponents }),
    ' '
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'profiles', component: _HorseRacingProfilePage2.default },
    ' ',
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'horse/:horseId', components: HorseProfilePageComponents },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _HorseProfileResultsPage2.default }),
      ' ',
      _react2.default.createElement(_reactRouter.Route, { path: 'future-entries', component: _HorseProfileEntriesPage2.default }),
      ' '
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'jockey/:jockeyId', components: JockeyProfilePageComponents },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _JockeyProfileResultsPage2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'future-entries', component: _JockeyProfileEntriesPage2.default })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'trainer/:trainerId', components: TrainerProfilePageComponents },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _TrainerProfileResultsPage2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'future-entries', component: _TrainerProfileEntriesPage2.default })
    )
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'my-stable', component: _MyStablePage2.default },
    '  ',
    _react2.default.createElement(
      _reactRouter.Route,
      { components: MyStablePageComponents },
      _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, component: _MyStableNextEntries2.default }),
      ' ',
      _react2.default.createElement(_reactRouter.Route, { sitemap: {}, path: 'results', component: _MyStableResults2.default }),
      ' ',
      _react2.default.createElement(_reactRouter.Route, { sitemap: {}, path: 'selections', component: _MyStableSelections2.default }),
      ' ',
      _react2.default.createElement(_reactRouter.Route, { sitemap: {}, path: 'search', component: _MyStableSearchResults2.default }),
      ' ',
      _react2.default.createElement(_reactRouter.Route, { sitemap: {}, path: 'unsubscribe', component: _MyStableEmailUnsubscribe2.default }),
      ' '
    )
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'columnists' },
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'richard-fahey', component: _HorseRacingRichardFaheyPage2.default },
      ' ',
      _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: RichardFaheyPageComponents }),
      ' '
    )
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'tips-centre', component: _HorseRacingTipsCentre2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: TipsCentrePageComponents }),
    ' '
  ),
  _react2.default.createElement(_reactRouter.Redirect, { path: 'news/going/37632', to: 'going' }),
  ' ',
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'news/:title/:articleId',
      component: _ArticleContainer2.default,
      sport: 'racing',
      rightHandContent: ['mostReadRacing', 'topMpu', 'horseRacingNextRaceOffAll', 'racingTips', 'bottomMpu', 'ocWidget'] },
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: { expand: (0, _sitemapHelper.newsArticleExpander)("racing") }, components: HorseRacingArticleComponents }),
    ' '
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'naps-table', component: _NapsTablePage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: NapsTableComponents }),
    ' '
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'abc-guide', component: _HorseRacingAbcGuidePage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: AbcGuideComponents }),
    ' ',
    _react2.default.createElement(
      _reactRouter.Route,
      { path: ':days', components: AbcGuideComponents },
      _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: { expand: _sitemapHelper2.abcDaysExpander } }),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: ':type' },
        _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: { expand: _sitemapHelper2.abcTypeExpander } }),
        _react2.default.createElement(_reactRouter.Route, { path: ':letterRange', sitemap: { expand: _sitemapHelper2.abcFiveDayExpander } })
      )
    )
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'insights', component: _InsightsPage2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { sitemap: {}, components: InsightsPageComponents }),
    ' '
  )
);

exports.default = horseRacingRoutes;

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(146);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

exports.racecardForDatesExpander = racecardForDatesExpander;
exports.resultsExpander = resultsExpander;
exports.racecardExpander = racecardExpander;
exports.abcFiveDayExpander = abcFiveDayExpander;
exports.abcTypeExpander = abcTypeExpander;
exports.abcDaysExpander = abcDaysExpander;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _logger = __webpack_require__(198);

var _logger2 = _interopRequireDefault(_logger);

var _ApiClient = __webpack_require__(64);

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _utils = __webpack_require__(18);

var _LocalDateTimeHelper = __webpack_require__(13);

var _sitemapUtils = __webpack_require__(276);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**********************************************
  EXPANDERS EXPLAINED:

  Take a route from of the sitemap generation process,
  return a promise for thenable routes - to be flattened when the sitemap is generated

*/ /////////////////////////////////////////////

var client = new _ApiClient2.default();

function racecardForDatesExpander(_ref) {
  var url = _ref.url,
      _ref$sitemap = _ref.sitemap,
      changefreq = _ref$sitemap.changefreq,
      priority = _ref$sitemap.priority;

  var routeArray = [];
  var dateArray = (0, _sitemapUtils.nDayArrFactoryForwards)();

  return new _promise2.default(function (resolve) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(dateArray), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var date = _step.value;

        var urlDate = (0, _LocalDateTimeHelper.getRelativeDay)(date, 0, { convertToday: true, convertTomorrow: true });
        routeArray.push({ url: url.replace(":date", urlDate), sitemap: { changefreq: changefreq, priority: priority } });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return resolve(routeArray);
  });
}

function resultsExpander(_ref2) {
  var url = _ref2.url,
      _ref2$sitemap = _ref2.sitemap,
      changefreq = _ref2$sitemap.changefreq,
      priority = _ref2$sitemap.priority;

  var routeArray = [];
  var dateArray = (0, _sitemapUtils.nDayArrFactoryBackwards)();

  return new _promise2.default(function (resolve) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = (0, _getIterator3.default)(dateArray), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var date = _step2.value;

        var urlDate = (0, _LocalDateTimeHelper.getRelativeDay)(date, 0, { convertToday: true, convertYesterday: true });
        routeArray.push({ url: url.replace(":date", urlDate), sitemap: { changefreq: changefreq, priority: priority } });
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return resolve(routeArray);
  });
}

function racecardExpander(_ref3) {
  var url = _ref3.url,
      _ref3$sitemap = _ref3.sitemap,
      changefreq = _ref3$sitemap.changefreq,
      priority = _ref3$sitemap.priority;

  var routeArray = [];
  var dateArray = (0, _sitemapUtils.nDayArrFactoryBoth)();

  var promiseStack = [];

  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = (0, _getIterator3.default)(dateArray), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var date = _step3.value;

      promiseStack.push(client.get(_config2.default.api.horseRacing.loadMeetings + "/" + date).then(function (result) {
        return result;
      }).catch(function (err) {
        _logger2.default.debug(err);
        return [];
      }));
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return _promise2.default.all(promiseStack).then(function (results) {
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = (0, _getIterator3.default)(results), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var day = _step4.value;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = (0, _getIterator3.default)(day), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _ref5 = _step5.value;
            var meeting_summary = _ref5.meeting_summary,
                races = _ref5.races;
            var meetingDate = meeting_summary.date,
                courseName = meeting_summary.course.name;
            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = (0, _getIterator3.default)(races), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var _ref7 = _step6.value;
                var raceId = _ref7.race_summary_reference.id,
                    raceName = _ref7.name,
                    raceDate = _ref7.date,
                    raceTime = _ref7.time,
                    raceOffTime = _ref7.off_time;

                if (meetingDate && courseName && raceId && raceName) {
                  var isInPast = raceOffTime ? (0, _LocalDateTimeHelper.isInThePast)(raceDate + "T" + raceOffTime + "Z") : (0, _LocalDateTimeHelper.isInThePast)(raceDate + "T" + raceTime + "Z");
                  routeArray.push({
                    url: url.replace(":date", meetingDate).replace(":courseSlug", (0, _utils.slugifyName)(courseName)).replace(":raceId", raceId).replace(":raceSlug", (0, _utils.slugifyName)(raceName)),
                    sitemap: {
                      changefreq: changefreq,
                      priority: priority,
                      lastmodISO: isInPast ? raceOffTime ? raceDate + "T" + (0, _sitemapUtils.stripTZD)(raceOffTime) + "Z" : raceDate + "T" + (0, _sitemapUtils.stripTZD)(raceTime) + "Z" : undefined
                    }
                  });
                } else {
                  _logger2.default.debug("The following horserace has an issue, and won't be added to the sitemap: " + meetingDate + " " + courseName + " " + raceId + " " + raceName);
                }
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }

    return routeArray;
  });
}

function abcFiveDayExpander(_ref8) {
  var url = _ref8.url,
      _ref8$sitemap = _ref8.sitemap,
      changefreq = _ref8$sitemap.changefreq,
      priority = _ref8$sitemap.priority;

  var routeArray = [];
  var days = ['5-days'];
  var tableTypes = ['horses'];
  var letterRanges = ['a-d', 'e-l', 'm-r', 's-z'];

  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = (0, _getIterator3.default)(days), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var day = _step7.value;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = (0, _getIterator3.default)(tableTypes), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var tableType = _step8.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = (0, _getIterator3.default)(letterRanges), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var letterRange = _step9.value;

              routeArray.push({
                url: url.replace(":days", day).replace(":type", tableType).replace(":letterRange", letterRange),
                sitemap: {
                  changefreq: changefreq,
                  priority: priority
                }
              });
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }

  return routeArray;
}

function abcTypeExpander(_ref9) {
  var url = _ref9.url,
      _ref9$sitemap = _ref9.sitemap,
      changefreq = _ref9$sitemap.changefreq,
      priority = _ref9$sitemap.priority;

  var routeArray = [];
  var days = ['today'];
  var tableTypes = ['jockeys', 'trainers'];

  var _iteratorNormalCompletion10 = true;
  var _didIteratorError10 = false;
  var _iteratorError10 = undefined;

  try {
    for (var _iterator10 = (0, _getIterator3.default)(days), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
      var day = _step10.value;
      var _iteratorNormalCompletion11 = true;
      var _didIteratorError11 = false;
      var _iteratorError11 = undefined;

      try {
        for (var _iterator11 = (0, _getIterator3.default)(tableTypes), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
          var tableType = _step11.value;

          routeArray.push({
            url: url.replace(":days", day).replace(":type", tableType),
            sitemap: {
              changefreq: changefreq,
              priority: priority
            }
          });
        }
      } catch (err) {
        _didIteratorError11 = true;
        _iteratorError11 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion11 && _iterator11.return) {
            _iterator11.return();
          }
        } finally {
          if (_didIteratorError11) {
            throw _iteratorError11;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError10 = true;
    _iteratorError10 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion10 && _iterator10.return) {
        _iterator10.return();
      }
    } finally {
      if (_didIteratorError10) {
        throw _iteratorError10;
      }
    }
  }

  return routeArray;
}

function abcDaysExpander(_ref10) {
  var url = _ref10.url,
      _ref10$sitemap = _ref10.sitemap,
      changefreq = _ref10$sitemap.changefreq,
      priority = _ref10$sitemap.priority;

  var routeArray = [];
  var days = ['tomorrow', '5-days'];

  var _iteratorNormalCompletion12 = true;
  var _didIteratorError12 = false;
  var _iteratorError12 = undefined;

  try {
    for (var _iterator12 = (0, _getIterator3.default)(days), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
      var day = _step12.value;

      routeArray.push({
        url: url.replace(":days", day),
        sitemap: {
          changefreq: changefreq,
          priority: priority
        }
      });
    }
  } catch (err) {
    _didIteratorError12 = true;
    _iteratorError12 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion12 && _iterator12.return) {
        _iterator12.return();
      }
    } finally {
      if (_didIteratorError12) {
        throw _iteratorError12;
      }
    }
  }

  return routeArray;
}

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(91);

var _RegisterLoginButtons = __webpack_require__(165);

var _RegisterLoginButtons2 = _interopRequireDefault(_RegisterLoginButtons);

var _MyStableIcon = __webpack_require__(254);

var _MyStableIcon2 = _interopRequireDefault(_MyStableIcon);

var _InsiderIcon = __webpack_require__(253);

var _InsiderIcon2 = _interopRequireDefault(_InsiderIcon);

var _AnalyticsUtils = __webpack_require__(63);

var _reactRouter = __webpack_require__(11);

var _consts = __webpack_require__(46);

__webpack_require__(1455);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOGIN_TRACKING_ATTRIBUTES = (0, _AnalyticsUtils.trackClick)(_consts.INSIDERS_LINK_CLICK_TRACKING_EVENT, { link: "[Insiders] Page Login" });
var REGISTER_TRACKING_ATTRIBUTES = (0, _AnalyticsUtils.trackClick)(_consts.INSIDERS_LINK_CLICK_TRACKING_EVENT, { link: "[Insiders] Page Register" });

var InsiderBenefits = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(InsiderBenefits, _Component);

  function InsiderBenefits() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, InsiderBenefits);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = InsiderBenefits.__proto__ || (0, _getPrototypeOf2.default)(InsiderBenefits)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      articleHeight: 0,
      footerClass: '',
      scrollEvents: ['scroll', 'mousewheel', 'DOMMouseScroll', 'MozMousePixelScroll', 'resize', 'touchmove', 'touchend'],
      benefitItems: [{
        title: "Horse racing video replays",
        content: "Unlimited video replays Watch race replays from all Sky Sports Racing and Racing TV tracks, from 30 minutes after the race.",
        skycon: 0xF04A,
        url: "/racing/results"
      }, {
        title: "Expert Tips and Previews",
        content: "Exclusive access to leading analysis, previews, and tips from our top columnists.",
        skycon: 0xF711,
        url: "/racing/tips-centre"
      }, {
        title: "My Stable",
        content: "Keep track of all of your selected horses with email reminders the night before they're due to run.",
        icon: _react2.default.createElement(_MyStableIcon2.default, { className: 'insider-icon', title: 'My Stable', key: 'icon' }),
        url: "/racing/my-stable"
      }, {
        title: "Exclusive Offers",
        content: "Take advantage of exclusive offers and promotions at our partner betting site, Sky Bet.",
        skycon: 0xF0D2,
        url: "/"
      }, {
        title: "Live Score Notifications",
        content: "Never miss a goal with live score notifications straight to your phone on all football matches.",
        skycon: 0xF406,
        url: "/football/live"
      }, {
        title: "Enter ITV7",
        content: "Use your Insider account to enter ITV7, the free to enter competition with a huge cash prize.",
        skycon: 0xF302,
        url: "https://itv7.itv.com"
      }]

      //life cycle events
    }, _this.attachStickyFooter = function () {
      _this.state.scrollEvents.forEach(function (event) {
        if (window.addEventListener) {
          window.addEventListener(event, _this.onScroll, false);
        } else {
          window.attachEvent('on' + event, _this.onScroll, false);
        }
      });
    }, _this.onScroll = function () {
      var article = (0, _reactDom.findDOMNode)(_this.refs.insiderArticle);
      var articleBondingRect = article.getBoundingClientRect();
      var articlePosition = ~articleBondingRect.top + window.innerHeight - 123;
      var articleFooterNode = (0, _reactDom.findDOMNode)(_this.refs.insiderArticleFooter);
      var articleFooterHeight = articleFooterNode ? articleFooterNode.offsetHeight : 0;

      if (_this.state.articleHeight === 0) {
        _this.setState((0, _extends3.default)({}, _this.state, { articleHeight: article.offsetHeight }));
      }

      if (articlePosition > _this.state.articleHeight - articleFooterHeight + 100) {
        _this.setState((0, _extends3.default)({}, _this.state, { footerClass: 'unstick' }));
        return;
      }

      if (articlePosition < _this.state.articleHeight + articleFooterHeight) {
        _this.setState((0, _extends3.default)({}, _this.state, { footerClass: '' }));
        return;
      }
    }, _this.getArticleTitle = function (loggedIn, userFirstName) {
      if (loggedIn && userFirstName) {
        return _react2.default.createElement(
          'h1',
          null,
          _react2.default.createElement(
            'span',
            null,
            'Welcome to Insiders, ',
            userFirstName[0].toUpperCase() + userFirstName.substring(1),
            '.'
          )
        );
      }
      return _react2.default.createElement(
        'h1',
        null,
        _react2.default.createElement(
          'span',
          null,
          'Know it all.'
        )
      );
    }, _this.getFeaturesSubTitle = function (loggedIn) {
      return loggedIn ? "As an Insider, make the most of..." : "What you get (it's all FREE)";
    }, _this.getFeaturesTagLine = function (loggedIn) {
      if (loggedIn) {
        return _react2.default.createElement(
          'div',
          { className: 'tag-line' },
          _react2.default.createElement(
            'p',
            null,
            'Access features and exclusive promotions you won\u2019t find anywhere else! Check back here to see the latest offers and features, exclusively for ',
            _react2.default.createElement(
              'b',
              null,
              'Insiders'
            ),
            '.'
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'tag-line' },
        _react2.default.createElement(
          'p',
          null,
          'All you need to do to become an ',
          _react2.default.createElement(_InsiderIcon2.default, { title: 'Insiders', color: 'blue' }),
          _react2.default.createElement(
            'strong',
            null,
            'Insider'
          ),
          ' is log in - it\'s that simple.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Log in with your existing ',
          _react2.default.createElement(
            'strong',
            null,
            'Sporting Life, Sky Bet'
          ),
          ', or ',
          _react2.default.createElement(
            'strong',
            null,
            'Sky Games'
          ),
          ' account. If you don\'t have any of those, it\'s completely free to register!'
        )
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  //component state and proptypes


  (0, _createClass3.default)(InsiderBenefits, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.attachStickyFooter();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      this.state.scrollEvents.forEach(function (event) {
        if (window.removeEventListener) {
          window.removeEventListener(event, _this2.onScroll, false);
        } else {
          window.detachEvent('on' + event, _this2.onScroll, false);
        }
      });
    }

    //render template helpers

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'article',
        { ref: 'insiderArticle', className: 'insider-benefits' },
        _react2.default.createElement(
          'header',
          { className: 'insider-header' },
          this.getArticleTitle(this.props.loggedIn, this.props.userFirstName),
          !this.props.loggedIn && _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Log in or register now for FREE and UNLIMITED access to ALL Sporting Life features.'
            )
          )
        ),
        _react2.default.createElement(
          'section',
          { className: 'insider-features' },
          _react2.default.createElement(
            'header',
            { className: 'insider-features-header' },
            this.getFeaturesTagLine(this.props.loggedIn),
            !this.props.loggedIn && _react2.default.createElement(
              'section',
              { className: 'insider-cta-login' },
              _react2.default.createElement(_RegisterLoginButtons2.default, {
                trackLoginClickAttributes: LOGIN_TRACKING_ATTRIBUTES,
                trackRegisterClickAttributes: REGISTER_TRACKING_ATTRIBUTES,
                registerClick: this.props.trackRegisterClick,
                loginClick: this.props.trackLoginClick,
                registerLabel: "Join for free" })
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.getFeaturesSubTitle(this.props.loggedIn)
            )
          ),
          _react2.default.createElement(
            'ul',
            null,
            this.state.benefitItems.map(function (benefit, key) {
              return BenefitItemComponent((0, _extends3.default)({}, benefit, { key: key, loggedIn: _this3.props.loggedIn }));
            })
          )
        ),
        _react2.default.createElement(
          'section',
          { className: 'insider-extra' },
          _react2.default.createElement(
            'header',
            null,
            _react2.default.createElement(
              'h2',
              null,
              'Plus'
            ),
            _react2.default.createElement(
              'p',
              null,
              'Access to all your favourite free-to-enter competitions.'
            )
          ),
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement('img', { key: '1', src: '/img/insider-benefit-logos/itv-racing.png' }),
            _react2.default.createElement('img', { key: '2', src: '/img/insider-benefit-logos/super6.png' }),
            _react2.default.createElement('img', { key: '3', src: '/img/insider-benefit-logos/fantasyfootball.png' }),
            _react2.default.createElement('img', { key: '4', src: '/img/insider-benefit-logos/six-a-side.png' })
          )
        ),
        !this.props.loggedIn && _react2.default.createElement(
          'footer',
          { ref: 'insiderArticleFooter', className: this.state.footerClass },
          _react2.default.createElement(
            'h2',
            null,
            ' Know it all - become an Insider'
          ),
          _react2.default.createElement(_RegisterLoginButtons2.default, {
            trackLoginClickAttributes: LOGIN_TRACKING_ATTRIBUTES,
            trackRegisterClickAttributes: REGISTER_TRACKING_ATTRIBUTES,
            registerClick: this.props.trackRegisterClick,
            loginClick: this.props.trackLoginClick,
            registerLabel: "Join for free" })
        )
      );
    }
  }]);
  return InsiderBenefits;
}(_react.Component), _class.propTypes = {
  loggedIn: _propTypes2.default.bool.isRequired,
  userFirstName: _propTypes2.default.string.isRequired,
  trackRegisterClick: _propTypes2.default.func.isRequired,
  trackLoginClick: _propTypes2.default.func.isRequired
}, _temp2);
exports.default = InsiderBenefits;


function BenefitItemComponent(_ref2) {
  var _ref2$title = _ref2.title,
      title = _ref2$title === undefined ? "" : _ref2$title,
      _ref2$content = _ref2.content,
      content = _ref2$content === undefined ? "" : _ref2$content,
      _ref2$key = _ref2.key,
      key = _ref2$key === undefined ? 0 : _ref2$key,
      skycon = _ref2.skycon,
      icon = _ref2.icon,
      url = _ref2.url,
      loggedIn = _ref2.loggedIn;

  __webpack_require__(1454);

  var children = [_react2.default.createElement(
    'h3',
    { key: 'title', className: 'detail-title' },
    title
  ), _react2.default.createElement(
    'p',
    { key: 'desc', className: 'detail-content' },
    content
  )];

  if (icon) {
    children.unshift(icon);
  }

  if (skycon) {
    children.unshift(_react2.default.createElement(
      'span',
      { key: 'skycon', className: 'skycon insider-icon', title: title },
      String.fromCharCode(skycon)
    ));
  }

  if (loggedIn) {
    if (url.indexOf('http') === 0) {
      children = _react2.default.createElement(
        'a',
        { href: url },
        children
      );
    } else {
      children = _react2.default.createElement(
        _reactRouter.Link,
        { to: url },
        children
      );
    }
  }

  return _react2.default.createElement(
    'li',
    { key: key, className: 'insider-benefit-item' },
    children
  );
}

BenefitItemComponent.propTypes = {
  title: _propTypes2.default.string.isRequired,
  content: _propTypes2.default.string.isRequired,
  key: _propTypes2.default.number.isRequired,
  loggedIn: _propTypes2.default.bool,
  skycon: _propTypes2.default.string,
  icon: _propTypes2.default.object,
  url: _propTypes2.default.string
};

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(17);

var _reducer = __webpack_require__(172);

var _InsiderBenefits = __webpack_require__(989);

var _InsiderBenefits2 = _interopRequireDefault(_InsiderBenefits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {

    var firstName = '';
    if (state.common.auth && state.common.auth.user && state.common.auth.user.firstname) {
        firstName = state.common.auth.user.firstname;
    }

    return {
        loggedIn: state.common.auth.loggedIn,
        userFirstName: firstName
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        trackLoginClick: function trackLoginClick() {
            dispatch((0, _reducer.insiderLoginInitiated)());
        },
        trackRegisterClick: function trackRegisterClick() {
            dispatch((0, _reducer.insiderLoginInitiated)());
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_InsiderBenefits2.default);

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InsiderBenefitsPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(InsiderBenefitsPage, _Component);

  function InsiderBenefitsPage() {
    (0, _classCallCheck3.default)(this, InsiderBenefitsPage);
    return (0, _possibleConstructorReturn3.default)(this, (InsiderBenefitsPage.__proto__ || (0, _getPrototypeOf2.default)(InsiderBenefitsPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(InsiderBenefitsPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          InsiderBenefits = _props.InsiderBenefits;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: 'racing', title: 'Insider Benefits' },
        _react2.default.createElement(
          'div',
          { className: 'main-layout-left-column' },
          InsiderBenefits
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: 'racing',
          content: ["horseRacingNextRaceOffAll", "horseRacingMostFollowed"] })
      );
    }
  }]);
  return InsiderBenefitsPage;
}(_react.Component), _class.propTypes = {
  InsiderBenefits: _propTypes2.default.element,
  location: _propTypes2.default.object.isRequired
}, _temp);
exports.default = InsiderBenefitsPage;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PureInsiderNotification = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(17);

var _reducer = __webpack_require__(172);

var _Notification = __webpack_require__(359);

var _Notification2 = _interopRequireDefault(_Notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

__webpack_require__(1456);

var PureInsiderNotification = exports.PureInsiderNotification = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(PureInsiderNotification, _Component);

    function PureInsiderNotification(props) {
        (0, _classCallCheck3.default)(this, PureInsiderNotification);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PureInsiderNotification.__proto__ || (0, _getPrototypeOf2.default)(PureInsiderNotification)).call(this, props));

        _this.dismiss = _this.dismiss.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(PureInsiderNotification, [{
        key: 'dismiss',
        value: function dismiss() {
            this.props.onHideNotification();
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.showNotification) {
                return null;
            }

            return _react2.default.createElement(
                _Notification2.default,
                { showClose: true, onDismiss: this.dismiss, className: 'insider-notification' },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'p',
                        null,
                        'Thanks for becoming an ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Insider'
                        ),
                        ', ',
                        this.props.userFirstName,
                        '! You can now access My Stable, video replays, score updates and lots more.'
                    )
                )
            );
        }
    }]);
    return PureInsiderNotification;
}(_react.Component), _class.propTypes = {
    onHideNotification: _propTypes2.default.func.isRequired,
    showNotification: _propTypes2.default.bool.isRequired,
    userFirstName: _propTypes2.default.string
}, _temp);


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        onHideNotification: function onHideNotification() {
            dispatch((0, _reducer.hideNotification)());
        }
    };
};

var mapStateToProps = function mapStateToProps(state) {
    var firstName = '';
    if (state.common.auth && state.common.auth.user && state.common.auth.user.firstname) {
        firstName = state.common.auth.user.firstname;
    }

    return {
        showNotification: state.insider.showNotification,
        userFirstName: firstName
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PureInsiderNotification);

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var nextRaceOff = {
  component: "HorseRacingNextRaceOff",
  props: {
    displayAll: true
  },
  desktopColumn: "right",
  desktopOrder: 2,
  handheldOrder: false
};

var defaultSideBarComponents = [nextRaceOff];

var getMostFollowed = function getMostFollowed(desktopOrder, handheldOrder) {
  return {
    component: "HorseRacingMostFollowed",
    desktopColumn: "right",
    desktopOrder: desktopOrder,
    handheldOrder: handheldOrder
  };
};

var withNoAdverts = function withNoAdverts() {
  for (var _len = arguments.length, components = Array(_len), _key = 0; _key < _len; _key++) {
    components[_key] = arguments[_key];
  }

  return {
    components: [].concat(components, defaultSideBarComponents)
  };
};

var insiderPageLayout = withNoAdverts({
  component: "InsiderBenefits",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
}, getMostFollowed(5, 2));

exports.default = {
  '/insider': insiderPageLayout
};

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.insiderLogin = exports.setLocalStorageClient = undefined;

var _skysso = __webpack_require__(72);

var _reducer = __webpack_require__(172);

var _features = __webpack_require__(65);

var _localStorage = __webpack_require__(249);

var _localStorage2 = _interopRequireDefault(_localStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INSIDER_LOGIN_STORAGE_KEY = 'shown_insider_notification';

var localStorage = new _localStorage2.default();
var setLocalStorageClient = exports.setLocalStorageClient = function setLocalStorageClient(client) {
    localStorage = client;
};

var insiderLogin = exports.insiderLogin = function insiderLogin(store) {
    return function (next) {
        return function (action) {
            if ((0, _features.has)("insider-benefits") && action.type === _skysso.LOGIN) {
                var state = store.getState();
                var _state$insider = state.insider;
                _state$insider = _state$insider === undefined ? {} : _state$insider;
                var _state$insider$loginI = _state$insider.loginInitiated,
                    loginInitiated = _state$insider$loginI === undefined ? false : _state$insider$loginI;


                var previouslyShownNotification = localStorage.getValue(INSIDER_LOGIN_STORAGE_KEY, false);

                if (loginInitiated && !previouslyShownNotification) {
                    localStorage.setValue(INSIDER_LOGIN_STORAGE_KEY, true);
                    store.dispatch((0, _reducer.showNotification)());
                }
            }

            return next(action);
        };
    };
};

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _HorseRacingMostFollowed = __webpack_require__(80);

var _HorseRacingMostFollowed2 = _interopRequireDefault(_HorseRacingMostFollowed);

var _HorseRacingNextRaceOff = __webpack_require__(115);

var _HorseRacingNextRaceOff2 = _interopRequireDefault(_HorseRacingNextRaceOff);

var _RacingTips = __webpack_require__(116);

var _RacingTips2 = _interopRequireDefault(_RacingTips);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _GooglePublisherTag = __webpack_require__(71);

var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);

var _InsiderBenefitsPage = __webpack_require__(991);

var _InsiderBenefitsPage2 = _interopRequireDefault(_InsiderBenefitsPage);

var _InsiderBenefits = __webpack_require__(990);

var _InsiderBenefits2 = _interopRequireDefault(_InsiderBenefits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseRacingSideBarComponentsNoTips = {
  GooglePublisherTag: _GooglePublisherTag2.default,
  HorseRacingNextRaceOff: _HorseRacingNextRaceOff2.default,
  AdvertWrapper: _AdvertWrapper2.default
};

var HorseRacingSideBarComponents = (0, _extends3.default)({}, HorseRacingSideBarComponentsNoTips, {
  RacingTips: _RacingTips2.default
});

var InsiderBenefitsPageComponents = (0, _extends3.default)({
  InsiderBenefits: _InsiderBenefits2.default,
  HorseRacingMostFollowed: _HorseRacingMostFollowed2.default
}, HorseRacingSideBarComponents);

var InsiderRoutes = _react2.default.createElement(
  _reactRouter.Route,
  { path: 'insider', components: _InsiderBenefitsPage2.default },
  _react2.default.createElement(_reactRouter.IndexRoute, { components: InsiderBenefitsPageComponents }),
  ' '
);

exports.default = InsiderRoutes;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NFLHomePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(NFLHomePage, _Component);

  function NFLHomePage() {
    (0, _classCallCheck3.default)(this, NFLHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (NFLHomePage.__proto__ || (0, _getPrototypeOf2.default)(NFLHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(NFLHomePage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: 'nfl',
        title: 'NFL Fixtures, Results & Predictions',
        location: location
      });
    }
  }]);
  return NFLHomePage;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node
}, _temp);
exports.default = NFLHomePage;

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NFLNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "NFL",
    links: [{ href: "/nfl", text: "News", isIndex: true }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

NFLNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = NFLNav;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routeUtils = __webpack_require__(38);

var _NFLHomePage = __webpack_require__(996);

var _NFLHomePage2 = _interopRequireDefault(_NFLHomePage);

var _NFLNav = __webpack_require__(997);

var _NFLNav2 = _interopRequireDefault(_NFLNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _routeUtils.genericRoute)(_NFLHomePage2.default, _NFLNav2.default, 'nfl');

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(8);

var _moment2 = _interopRequireDefault(_moment);

var _ClockIcon = __webpack_require__(366);

var _ClockIcon2 = _interopRequireDefault(_ClockIcon);

var _AuthorAvatar = __webpack_require__(354);

var _AuthorAvatar2 = _interopRequireDefault(_AuthorAvatar);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(271);

__webpack_require__(1457);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ROOT_CLICK_EVENT_NAME = '[Articles]';

var ArticleAuthor = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ArticleAuthor, _Component);

    function ArticleAuthor(props) {
        (0, _classCallCheck3.default)(this, ArticleAuthor);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ArticleAuthor.__proto__ || (0, _getPrototypeOf2.default)(ArticleAuthor)).call(this, props));

        _this.onAvatarClick = _this.onAvatarClick.bind(_this);
        _this.onNameClick = _this.onNameClick.bind(_this);
        _this.onTypeClick = _this.onTypeClick.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(ArticleAuthor, [{
        key: "onTrackClick",
        value: function onTrackClick(link) {
            if (!this.context.metrics || !this.context.metrics.track) {
                return;
            }

            this.context.metrics.track("linkClick", { link: link });
        }
    }, {
        key: "onAvatarClick",
        value: function onAvatarClick() {
            this.onTrackClick(ROOT_CLICK_EVENT_NAME + " Author Avatar Click");
        }
    }, {
        key: "onNameClick",
        value: function onNameClick() {
            this.onTrackClick(ROOT_CLICK_EVENT_NAME + " Author Name Click");
        }
    }, {
        key: "onTypeClick",
        value: function onTypeClick() {
            this.onTrackClick(ROOT_CLICK_EVENT_NAME + " Author Type Click");
        }
    }, {
        key: "render",
        value: function render() {
            var article = this.props.article;
            var last_updated = article.last_updated,
                author_profile = article.author_profile;


            var readTime = (0, _utils.getArticleReadTime)(article);

            return _react2.default.createElement(
                "div",
                { className: "article-author" },
                author_profile && _react2.default.createElement(
                    "div",
                    { className: "article-author__avatar" },
                    _react2.default.createElement(_AuthorAvatar2.default, { onClick: this.onAvatarClick, image: author_profile.image_ref })
                ),
                _react2.default.createElement(
                    "div",
                    { className: "article-author__right" },
                    author_profile && _react2.default.createElement(
                        "div",
                        { className: "article-author__author-info" },
                        _react2.default.createElement(
                            "span",
                            { onClick: this.onNameClick, className: "author-name" },
                            author_profile.name
                        ),
                        " \xB7 ",
                        _react2.default.createElement(
                            "span",
                            { onClick: this.onTypeClick, className: "author-bio" },
                            author_profile.type_name
                        )
                    ),
                    _react2.default.createElement(
                        "div",
                        { className: "article-author__last-updated" },
                        _react2.default.createElement(_ClockIcon2.default, { title: "Last Updated" }),
                        _react2.default.createElement(
                            "div",
                            null,
                            _moment2.default.unix(last_updated / 1000.0).format("HH:mm · MMMM DD, YYYY"),
                            " \xB7 ",
                            _react2.default.createElement(
                                "span",
                                { className: "readTime" },
                                readTime,
                                " min read"
                            )
                        )
                    )
                )
            );
        }
    }]);
    return ArticleAuthor;
}(_react.Component), _class.contextTypes = {
    metrics: _propTypes2.default.object
}, _temp);


ArticleAuthor.propTypes = {
    article: _propTypes2.default.object.isRequired
};

exports.default = (0, _withErrorBoundry2.default)(ArticleAuthor);

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(147);

var _assign2 = _interopRequireDefault(_assign);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

var _lodash = __webpack_require__(20);

var _Image = __webpack_require__(163);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleHelmetProps = function ArticleHelmetProps(_ref) {
  var embedded = _ref.embedded,
      article = _ref.article,
      canonical = _ref.canonical,
      topImageSet = _ref.topImageSet;

  var helmetProps = {
    meta: []
  };

  function _meta(name, content) {
    helmetProps.meta.push({ name: name, content: content });
  }

  function _ogMeta(property, content) {
    helmetProps.meta.push({ property: property, content: content });
  }

  if (!embedded) {
    _meta("twitter:site", "@SportingLife");
    _meta("twitter:card", "summary_large_image");
    _ogMeta("og:type", "article");
    _ogMeta("og:locale", "en_GB");

    if (article.long_headline) {
      helmetProps.title = article.long_headline;
      _ogMeta("og:title", article.long_headline);
    }

    if (article.article_abstract) {
      _ogMeta("og:description", article.article_abstract);
    }

    if ((0, _lodash.get)(canonical, 'link[0].href', undefined)) {
      (0, _assign2.default)(helmetProps, canonical);
      _ogMeta("og:url", canonical.link[0].href);
    }

    if (topImageSet.artefacts && topImageSet.artefacts.length > 0) {
      var shareImage = (0, _Image.getFBImage)(topImageSet.artefacts);
      var shareImageUri = _config2.default.canonicalBase + '/' + shareImage.uri;
      var shareImageCaption = topImageSet.caption;

      _meta("twitter:image", shareImageUri);
      _meta("twitter:image:alt", shareImageCaption);

      _ogMeta("og:image:secure_url", shareImageUri);
      _ogMeta("og:image:height", shareImage.height);
      _ogMeta("og:image:width", shareImage.width);
      _ogMeta("og:image:type", shareImage.mime_type);
      _ogMeta("og:image:alt", shareImageCaption);
    }

    // TODO Populate OG if video hero
  }

  if (article.keywords && article.keywords.length) {
    _meta("keywords", article.keywords.join(","));
  }

  return _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: helmetProps });
};

ArticleHelmetProps.propTypes = {
  embedded: _propTypes2.default.bool,
  article: _propTypes2.default.object,
  canonical: _propTypes2.default.object,
  topImageSet: _propTypes2.default.array
};

exports.default = (0, _withErrorBoundry2.default)(ArticleHelmetProps);

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArticleHeroImage = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Image = __webpack_require__(163);

var _Image2 = _interopRequireDefault(_Image);

var _widgets = __webpack_require__(60);

var _lodash = __webpack_require__(20);

var _reactRedux = __webpack_require__(17);

var _Ooyala = __webpack_require__(434);

var _Ooyala2 = _interopRequireDefault(_Ooyala);

var _withErrorBoundry = __webpack_require__(47);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleHeroImage = exports.ArticleHeroImage = function ArticleHeroImage(_ref) {
  var widgets = _ref.widgets,
      media = _ref.media;

  var primaryWidget = (0, _widgets.spreadWidget)((0, _widgets.getPrimaryMediaWidget)(widgets));

  if (primaryWidget.widget_type === "Image") {
    var topImageSet = media && media[primaryWidget.media_id] || [];

    if (!topImageSet.artefacts || topImageSet.artefacts.length === 0) {
      return null;
    }

    return _react2.default.createElement(
      'div',
      { className: 'news-article-image' },
      _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_Image2.default, {
          imageMedia: topImageSet,
          imageType: 'articlePage'
        })
      )
    );
  }

  if (primaryWidget.widget_type === "Video") {
    return _react2.default.createElement(
      'div',
      { className: 'ooyala-hero-image' },
      _react2.default.createElement(_Ooyala2.default, { contentId: primaryWidget.media_id })
    );
  }

  return null;
};
ArticleHeroImage.propTypes = {
  widgets: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    widget_type: _propTypes2.default.string,
    keys: _propTypes2.default.array
  })),
  media: _propTypes2.default.object,
  articleId: _propTypes2.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _state$common = state.common,
      articles = _state$common.article,
      media = _state$common.media;

  var article = (0, _lodash.get)(articles, ownProps.articleId + '.article', {});

  return {
    widgets: article.widgets || [],
    media: media
  };
};

exports.default = (0, _withErrorBoundry.withErrorBoundary)((0, _reactRedux.connect)(mapStateToProps)(ArticleHeroImage));

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /* eslint react/no-danger: "off" */


var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _EmailShareButton = __webpack_require__(730);

var _EmailShareButton2 = _interopRequireDefault(_EmailShareButton);

var _LinkShareButton = __webpack_require__(739);

var _LinkShareButton2 = _interopRequireDefault(_LinkShareButton);

var _TwitterShareButton = __webpack_require__(758);

var _TwitterShareButton2 = _interopRequireDefault(_TwitterShareButton);

var _FacebookShareButton = __webpack_require__(732);

var _FacebookShareButton2 = _interopRequireDefault(_FacebookShareButton);

var _Ellipsis = __webpack_require__(729);

var _Ellipsis2 = _interopRequireDefault(_Ellipsis);

__webpack_require__(1458);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleSocialMediaButtons = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ArticleSocialMediaButtons, _Component);

  function ArticleSocialMediaButtons() {
    (0, _classCallCheck3.default)(this, ArticleSocialMediaButtons);
    return (0, _possibleConstructorReturn3.default)(this, (ArticleSocialMediaButtons.__proto__ || (0, _getPrototypeOf2.default)(ArticleSocialMediaButtons)).apply(this, arguments));
  }

  (0, _createClass3.default)(ArticleSocialMediaButtons, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'news-article-share-buttons-footer' },
        _react2.default.createElement(_Ellipsis2.default, null),
        _react2.default.createElement(
          'div',
          { className: 'news-article-share-buttons-footer-inner' },
          _react2.default.createElement(
            'div',
            { className: 'news-article-share-header' },
            'Like what you\'ve read?'
          ),
          _react2.default.createElement(
            'div',
            { className: 'news-article-share-body' },
            'Help your friends Know It All by sharing this article to your social media.'
          ),
          _react2.default.createElement(
            'div',
            { className: 'news-article-media-button-container' },
            _react2.default.createElement(
              'div',
              { className: 'news-article-media-button' },
              _react2.default.createElement(_FacebookShareButton2.default, (0, _extends3.default)({ dcmp: 'article_bottom' }, this.props))
            ),
            _react2.default.createElement(
              'div',
              { className: 'news-article-media-button' },
              _react2.default.createElement(_TwitterShareButton2.default, (0, _extends3.default)({ dcmp: 'article_bottom' }, this.props))
            ),
            _react2.default.createElement(
              'div',
              { className: 'news-article-media-button' },
              _react2.default.createElement(_EmailShareButton2.default, (0, _extends3.default)({ dcmp: 'article_bottom' }, this.props))
            ),
            _react2.default.createElement(
              'div',
              { className: 'news-article-media-button' },
              _react2.default.createElement(_LinkShareButton2.default, (0, _extends3.default)({ dcmp: 'article_bottom' }, this.props))
            )
          )
        )
      );
    }
  }]);
  return ArticleSocialMediaButtons;
}(_react.Component), _class.contextTypes = {
  metrics: _propTypes2.default.object
}, _class.propTypes = {
  copyFunction: _propTypes2.default.func,
  timeoutFunction: _propTypes2.default.func,
  dcmp: _propTypes2.default.string,
  page: _propTypes2.default.string
}, _temp);
exports.default = ArticleSocialMediaButtons;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ArticleSubheading = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TagLink = __webpack_require__(751);

var _TagLink2 = _interopRequireDefault(_TagLink);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ArticleUtils = __webpack_require__(174);

__webpack_require__(1459);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArticleSubheading = exports.ArticleSubheading = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(ArticleSubheading, _Component);

    function ArticleSubheading(props) {
        (0, _classCallCheck3.default)(this, ArticleSubheading);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ArticleSubheading.__proto__ || (0, _getPrototypeOf2.default)(ArticleSubheading)).call(this, props));

        _this.onCategoryClick = _this.onCategoryClick.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(ArticleSubheading, [{
        key: 'onCategoryClick',
        value: function onCategoryClick() {
            if (!this.context.metrics || !this.context.metrics.track) {
                return;
            }

            this.context.metrics.track("linkClick", { link: '[Articles] Article Bucket Tag Click' });
        }
    }, {
        key: 'render',
        value: function render() {
            var article = this.props.article;
            var category = article.category;


            return _react2.default.createElement(
                'div',
                { className: 'news-article-subheading' },
                _react2.default.createElement(
                    'div',
                    { className: 'news-article-lastupdated' },
                    _react2.default.createElement(
                        'span',
                        { onClick: this.onCategoryClick },
                        _react2.default.createElement(
                            _TagLink2.default,
                            { link: '/' + (0, _ArticleUtils.categoryUrlRoot)(category) },
                            (0, _ArticleUtils.categoryName)(category)
                        )
                    )
                )
            );
        }
    }]);
    return ArticleSubheading;
}(_react.Component), _class.contextTypes = {
    metrics: _propTypes2.default.object
}, _class.propTypes = {
    article: _propTypes2.default.object
}, _temp);
exports.default = (0, _withErrorBoundry2.default)(ArticleSubheading);

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(1460);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OoyalaVideoIndicator = function OoyalaVideoIndicator(_ref) {
  var _ref$widgetTypes = _ref.widgetTypes,
      widgetTypes = _ref$widgetTypes === undefined ? [] : _ref$widgetTypes,
      heroImageType = _ref.heroImageType;

  if (heroImageType === "Video" || widgetTypes.find(function (val) {
    return val === "OoyalaEmbed";
  })) {
    return _react2.default.createElement(
      'div',
      { className: 'ooyala-video-indicator' },
      _react2.default.createElement('img', { className: 'ooyala-gradient', src: '/img/thumbnail-gradient.svg' }),
      _react2.default.createElement('img', { className: 'ooyala-indicator', src: '/img/has-video-icon.svg' })
    );
  }

  return null;
};

OoyalaVideoIndicator.propTypes = {
  widgetTypes: _propTypes2.default.array,
  heroImageType: _propTypes2.default.string
};

exports.default = OoyalaVideoIndicator;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DividerWidget = function DividerWidget() {
  return _react2.default.createElement("hr", { className: "news-article-body-divider" });
};

DividerWidget.mapProps = function () {
  return (/*props*/{}
  );
};
DividerWidget.propTypes = {};

exports.default = DividerWidget;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EmbeddedTweet = __webpack_require__(731);

var _EmbeddedTweet2 = _interopRequireDefault(_EmbeddedTweet);

var _widgets = __webpack_require__(60);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmbeddedTweetWidget = function EmbeddedTweetWidget(_ref) {
  var bodyVisible = _ref.bodyVisible,
      widget = _ref.widget;

  if (!bodyVisible) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'news-article-tweet' },
    _react2.default.createElement(_EmbeddedTweet2.default, { html: (0, _widgets.getWidgetValue)(widget, "html") })
  );
};

EmbeddedTweetWidget.mapProps = function (props) {
  return {
    bodyVisible: props.bodyVisible,
    widget: props.widget
  };
};
EmbeddedTweetWidget.propTypes = {
  bodyVisible: _propTypes2.default.bool,
  widget: _propTypes2.default.object
};

exports.default = (0, _withErrorBoundry2.default)(EmbeddedTweetWidget);

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgets = __webpack_require__(60);

var _OutLink = __webpack_require__(252);

var _OutLink2 = _interopRequireDefault(_OutLink);

var _Image = __webpack_require__(163);

var _Image2 = _interopRequireDefault(_Image);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageWidget = function ImageWidget(_ref) {
  var widget = _ref.widget,
      media = _ref.media;

  if (!widget || !media) {
    return _react2.default.createElement(
      'div',
      { className: 'news-article-body-image' },
      _react2.default.createElement('div', { className: 'news-article-image' })
    );
  }

  var _getWidgetValues = (0, _widgets.getWidgetValues)(widget, ["media_id", "external", "href", "caption"]),
      media_id = _getWidgetValues.media_id,
      external = _getWidgetValues.external,
      href = _getWidgetValues.href,
      caption = _getWidgetValues.caption;

  var imageSet = media[media_id];

  if (!imageSet) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'news-article-body-image' },
    _react2.default.createElement(
      'div',
      { className: 'news-article-image' },
      _react2.default.createElement(
        'span',
        null,
        href ? _react2.default.createElement(
          _OutLink2.default,
          { to: href, isExternal: external == "true" },
          _react2.default.createElement(_Image2.default, { imageMedia: imageSet, imageType: 'articlePage' })
        ) : _react2.default.createElement(_Image2.default, { imageMedia: imageSet, imageType: 'articlePage' })
      )
    ),
    caption && caption.trim() && _react2.default.createElement(
      'div',
      { className: 'photo-caption' },
      caption
    )
  );
};

ImageWidget.mapProps = function (props) {
  return {
    media: props.media,
    widget: props.widget
  };
};
ImageWidget.propTypes = {
  media: _propTypes2.default.object,
  widget: _propTypes2.default.object
};

exports.default = (0, _withErrorBoundry2.default)(ImageWidget);

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgets = __webpack_require__(60);

var _Ooyala = __webpack_require__(434);

var _Ooyala2 = _interopRequireDefault(_Ooyala);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OoyalaEmbed = function OoyalaEmbed(_ref) {
  var widget = _ref.widget,
      bodyVisible = _ref.bodyVisible;

  var _getWidgetValues = (0, _widgets.getWidgetValues)(widget, ["content_id"]),
      content_id = _getWidgetValues.content_id;

  return bodyVisible && _react2.default.createElement(_Ooyala2.default, { contentId: content_id });
};

OoyalaEmbed.mapProps = function (props) {
  return {
    bodyVisible: props.bodyVisible,
    widget: props.widget
  };
};
OoyalaEmbed.propTypes = {
  bodyVisible: _propTypes2.default.bool,
  widget: _propTypes2.default.object
};

exports.default = (0, _withErrorBoundry2.default)(OoyalaEmbed);

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PlaybuzzEmbed = __webpack_require__(744);

var _PlaybuzzEmbed2 = _interopRequireDefault(_PlaybuzzEmbed);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlaybuzzEmbedWidget = function PlaybuzzEmbedWidget(_ref) {
  var bodyVisible = _ref.bodyVisible,
      widget = _ref.widget;

  return bodyVisible && _react2.default.createElement(
    'div',
    { className: 'news-article-playbuzz' },
    _react2.default.createElement(_PlaybuzzEmbed2.default, (0, _PlaybuzzEmbed.playbuzzPropsFromWidget)(widget))
  );
};

PlaybuzzEmbedWidget.mapProps = function (props) {
  return {
    bodyVisible: props.bodyVisible,
    widget: props.widget
  };
};
PlaybuzzEmbedWidget.propTypes = {
  bodyVisible: _propTypes2.default.bool,
  widget: _propTypes2.default.object
};

exports.default = (0, _withErrorBoundry2.default)(PlaybuzzEmbedWidget);

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RacerunnerWidget = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = __webpack_require__(32);

var _HorseRacingRacecardRunner = __webpack_require__(401);

var _HorseRacingRacecardRunner2 = _interopRequireDefault(_HorseRacingRacecardRunner);

var _SkyBetLogo = __webpack_require__(771);

var _SkyBetLogo2 = _interopRequireDefault(_SkyBetLogo);

var _reactRedux = __webpack_require__(17);

var _lodash = __webpack_require__(20);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RacerunnerWidget = exports.RacerunnerWidget = function (_React$PureComponent) {
  (0, _inherits3.default)(RacerunnerWidget, _React$PureComponent);

  function RacerunnerWidget() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, RacerunnerWidget);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RacerunnerWidget.__proto__ || (0, _getPrototypeOf2.default)(RacerunnerWidget)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      show: false
    }, _this.toggleFormExpanded = function (runnerId) {
      var newValue = _this.state.show === runnerId ? null : runnerId;
      _this.setState({ show: newValue });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(RacerunnerWidget, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          widget = _props.widget,
          races = _props.races;

      var cardProps = (0, _utils.transformedRideDataFromArticleWidget)(widget, races);
      var showExpandedForm = cardProps && this.state.show === cardProps.runner.key;

      if (!cardProps) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'news-article-body-race-runner-' + (showExpandedForm ? "showing" : "no") + '-video' },
        _react2.default.createElement(_HorseRacingRacecardRunner2.default, (0, _extends3.default)({
          embedded: true,
          showExpandedForm: showExpandedForm,
          toggleFormExpanded: this.toggleFormExpanded
        }, cardProps)),
        cardProps.eventRef && _react2.default.createElement(
          'div',
          { className: 'news-article-body-race-runner-skybet' },
          _react2.default.createElement(
            'span',
            { className: 'news-article-body-race-runner-skybet-text' },
            'Live betting powered by'
          ),
          _react2.default.createElement(_SkyBetLogo2.default, null)
        )
      );
    }
  }]);
  return RacerunnerWidget;
}(_react2.default.PureComponent);

RacerunnerWidget.mapProps = function (props) {
  return {
    widget: props.widget
  };
};
RacerunnerWidget.propTypes = {
  widget: _propTypes2.default.object,
  races: _propTypes2.default.array
};

var mapStateToProps = function mapStateToProps(state) {
  var races = (0, _lodash.get)(state, 'horseRacing.rides.races', []);

  return {
    races: races
  };
};
exports.default = (0, _withErrorBoundry2.default)((0, _reactRedux.connect)(mapStateToProps)(RacerunnerWidget));

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgets = __webpack_require__(60);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextAreaWidget = function TextAreaWidget(_ref) {
  var widget = _ref.widget;

  var textContent = (0, _widgets.getWidgetValue)(widget, "html");

  // eslint-disable-next-line react/no-danger
  return _react2.default.createElement('div', { className: 'news-article-body-text', dangerouslySetInnerHTML: { __html: textContent } });
};

TextAreaWidget.mapProps = function (props) {
  return {
    widget: props.widget
  };
};
TextAreaWidget.propTypes = {
  widget: _propTypes2.default.object
};

exports.default = (0, _withErrorBoundry2.default)(TextAreaWidget);

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgets = __webpack_require__(60);

var _TipsWidget = __webpack_require__(753);

var _TipsWidget2 = _interopRequireDefault(_TipsWidget);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TipWidget = function TipWidget(_ref) {
  var widget = _ref.widget;

  var tipsData = (0, _widgets.getWidgetValue)(widget, "tips");
  return (0, _keys2.default)(tipsData).length > 0 && _react2.default.createElement(_TipsWidget2.default, { tips: tipsData });
};

TipWidget.mapProps = function (props) {
  return {
    widget: props.widget
  };
};
TipWidget.propTypes = {
  widget: _propTypes2.default.object
};

exports.default = (0, _withErrorBoundry2.default)(TipWidget);

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _widgets = __webpack_require__(60);

var _YouTubeVideo = __webpack_require__(760);

var _YouTubeVideo2 = _interopRequireDefault(_YouTubeVideo);

var _withErrorBoundry = __webpack_require__(47);

var _withErrorBoundry2 = _interopRequireDefault(_withErrorBoundry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var YoutubeVideoWidget = function YoutubeVideoWidget(_ref) {
  var bodyVisible = _ref.bodyVisible,
      widget = _ref.widget;

  var _getWidgetValues = (0, _widgets.getWidgetValues)(widget, ["video_id", "placeholder", "title"]),
      video_id = _getWidgetValues.video_id,
      placeholder = _getWidgetValues.placeholder,
      title = _getWidgetValues.title;

  return bodyVisible && _react2.default.createElement(
    'div',
    { className: 'news-article-body-video' },
    _react2.default.createElement(_YouTubeVideo2.default, { videoId: video_id, placeholderImage: placeholder }),
    title && title.trim() && _react2.default.createElement(
      'div',
      { className: 'photo-caption' },
      title
    )
  );
};

YoutubeVideoWidget.mapProps = function (props) {
  return {
    bodyVisible: props.bodyVisible,
    widget: props.widget
  };
};
YoutubeVideoWidget.propTypes = {
  bodyVisible: _propTypes2.default.bool,
  widget: _propTypes2.default.object
};

exports.default = (0, _withErrorBoundry2.default)(YoutubeVideoWidget);

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _importAllWidgets = __webpack_require__(1015);

var _importAllWidgets2 = _interopRequireDefault(_importAllWidgets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var allWidgets = (0, _importAllWidgets2.default)();
var widgetsByType = {};

var findWidget = function findWidget(widgetType) {
  if (!widgetsByType[widgetType]) {
    var key = (0, _keys2.default)(allWidgets).filter(function (widgetFileName) {
      return widgetFileName.match(/(.*)\.widget.js/)[1] === widgetType;
    });

    widgetsByType[widgetType] = allWidgets[key].default;
  }

  return widgetsByType[widgetType];
};

var getWidget = function getWidget(props) {
  var widgetType = props.widget && props.widget.widget_type;

  if (!widgetType) {
    return null;
  }

  var Widget = findWidget(widgetType);
  var widgetProps = Widget.mapProps ? Widget.mapProps(props) : props;

  return { Widget: Widget, widgetProps: widgetProps };
};

exports.default = getWidget;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

// Generated by tools/generateWidgets.js 
exports.default = function () {
	return {
		"Divider.widget.js": __webpack_require__(1005),
		"EmbeddedTweet.widget.js": __webpack_require__(1006),
		"Fresh8Strapline.widget.js": __webpack_require__(432),
		"AdvertStrapline.widget.js": __webpack_require__(432),
		"Image.widget.js": __webpack_require__(1007),
		"OoyalaEmbed.widget.js": __webpack_require__(1008),
		"PlaybuzzEmbed.widget.js": __webpack_require__(1009),
		"Racerunner.widget.js": __webpack_require__(1010),
		"TextArea.widget.js": __webpack_require__(1011),
		"Tip.widget.js": __webpack_require__(1012),
		"YouTubeVideo.widget.js": __webpack_require__(1013)
	};
};

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

var _SectionPlainTitle = __webpack_require__(166);

var _SectionPlainTitle2 = _interopRequireDefault(_SectionPlainTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColumnistsLayout = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ColumnistsLayout, _Component);

  function ColumnistsLayout() {
    (0, _classCallCheck3.default)(this, ColumnistsLayout);
    return (0, _possibleConstructorReturn3.default)(this, (ColumnistsLayout.__proto__ || (0, _getPrototypeOf2.default)(ColumnistsLayout)).apply(this, arguments));
  }

  (0, _createClass3.default)(ColumnistsLayout, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          MoreNews = _props.MoreNews;


      return _react2.default.createElement(
        'div',
        { className: 'horse-profile-page' },
        _react2.default.createElement(
          _StandardPage.StandardPage,
          { sport: 'racing', title: 'Columnists' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block' },
            _react2.default.createElement(
              _SectionPlainTitle2.default,
              { className: 'page-main-section-title', level: 1 },
              'Columnists'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-left-column' },
            MoreNews
          ),
          _react2.default.createElement(_RightColumn.RightColumn, { location: location,
            sport: 'racing',
            content: ["mostReadAll", "topMpu", "ocWidget", "racingTips", "horseRacingNextRaceOff", "footballTips"] })
        )
      );
    }
  }]);
  return ColumnistsLayout;
}(_react.Component), _class.propTypes = {
  MoreNews: _propTypes2.default.element.isRequired,
  location: _propTypes2.default.object.isRequired
}, _temp);
exports.default = ColumnistsLayout;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(17);

var _StandardPage = __webpack_require__(22);

var _SectionPlainTitle = __webpack_require__(166);

var _SectionPlainTitle2 = _interopRequireDefault(_SectionPlainTitle);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomBasketLayout = (_dec = (0, _reactRedux.connect)(function (state) {
  return { morenews: state.common.morenews };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CustomBasketLayout, _Component);

  function CustomBasketLayout() {
    (0, _classCallCheck3.default)(this, CustomBasketLayout);
    return (0, _possibleConstructorReturn3.default)(this, (CustomBasketLayout.__proto__ || (0, _getPrototypeOf2.default)(CustomBasketLayout)).apply(this, arguments));
  }

  (0, _createClass3.default)(CustomBasketLayout, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          CustomBasketNews = _props.CustomBasketNews;


      return _react2.default.createElement(
        'div',
        { className: 'horse-profile-page' },
        _react2.default.createElement(
          _StandardPage.StandardPage,
          { sport: 'racing', title: 'Columnists' },
          _react2.default.createElement(
            'div',
            { className: 'main-layout-block' },
            _react2.default.createElement(
              _SectionPlainTitle2.default,
              { className: 'page-main-section-title', level: 1 },
              'Columnists'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'main-layout-left-column' },
            CustomBasketNews
          ),
          _react2.default.createElement(_RightColumn.RightColumn, { location: location,
            sport: 'racing',
            content: ["mostReadAll", "topMpu", "ocWidget", "racingTips", "horseRacingNextRaceOff", "footballTips"] })
        )
      );
    }
  }]);
  return CustomBasketLayout;
}(_react.Component), _class2.propTypes = {
  CustomBasketNews: _propTypes2.default.element.isRequired,
  location: _propTypes2.default.object.isRequired
}, _temp)) || _class);
exports.default = CustomBasketLayout;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _asyncConnectWrapper = __webpack_require__(14);

var _catchLifeCycleErrors = __webpack_require__(15);

var _catchLifeCycleErrors2 = _interopRequireDefault(_catchLifeCycleErrors);

var _morenews = __webpack_require__(79);

var _media = __webpack_require__(78);

var _MoreNewsList = __webpack_require__(431);

var _MoreNewsList2 = _interopRequireDefault(_MoreNewsList);

var _seoUtils = __webpack_require__(23);

var _MetaDataWrapper = __webpack_require__(12);

var _MetaDataWrapper2 = _interopRequireDefault(_MetaDataWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_PAGE_SIZE = 12;

var CustomBasketNews = (_dec = (0, _asyncConnectWrapper.layoutAsyncConnect)('MoreNews', [{
  dispatch: function dispatch(_ref) {
    var basketId = _ref.params.basketId;
    return (0, _morenews.loadById)(basketId, INITIAL_PAGE_SIZE + 1);
  },
  state: function state(_state) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$params = _ref2.params;

    _ref2$params = _ref2$params === undefined ? {} : _ref2$params;
    var basketId = _ref2$params.basketId;
    return { basket: _state.common.morenews[basketId] };
  },
  then: function then(_ref3) {
    var dispatch = _ref3.dispatch,
        state = _ref3.state,
        articles = _ref3.result.articles;
    return (0, _media.loadMediaForArticles)(state, dispatch, articles);
  }
}]), _dec(_class = (0, _catchLifeCycleErrors2.default)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CustomBasketNews, _Component);

  function CustomBasketNews() {
    (0, _classCallCheck3.default)(this, CustomBasketNews);
    return (0, _possibleConstructorReturn3.default)(this, (CustomBasketNews.__proto__ || (0, _getPrototypeOf2.default)(CustomBasketNews)).apply(this, arguments));
  }

  (0, _createClass3.default)(CustomBasketNews, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$basket = _props.basket;
      _props$basket = _props$basket === undefined ? {} : _props$basket;
      var _props$basket$title = _props$basket.title,
          title = _props$basket$title === undefined ? "News" : _props$basket$title,
          basketName = _props$basket.name,
          _props$params = _props.params;
      _props$params = _props$params === undefined ? {} : _props$params;
      var basketId = _props$params.basketId,
          routes = _props.routes;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_MetaDataWrapper2.default, { helmetProps: (0, _extends3.default)({}, (0, _seoUtils.canonicalLink)(routes, { basketId: basketId, basketName: basketName })) }),
        _react2.default.createElement(
          'h1',
          { className: 'page-main-title' },
          title
        ),
        _react2.default.createElement(_MoreNewsList2.default, {
          title: title,
          basketQuery: { key: "basketId", value: basketId },
          initialPageSize: INITIAL_PAGE_SIZE
        })
      );
    }
  }]);
  return CustomBasketNews;
}(_react.Component), _class2.propTypes = {
  basket: _propTypes2.default.object,
  params: _propTypes2.default.object,
  routes: _propTypes2.default.array
}, _temp)) || _class) || _class);
exports.default = CustomBasketNews;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _layoutUtils = __webpack_require__(176);

var _GptProperties = __webpack_require__(51);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columnistsLayout = {
  bannerAd: _GptProperties.bannerAd,
  leaderboardAd: {
    view: 'home-page'
  },
  components: [{
    component: 'SectionPlainTitle',
    props: {
      level: 1,
      className: 'page-main-section-title',
      children: 'Columnists'
    },
    desktopColumn: 'left',
    desktopOrder: 1,
    handheldOrder: 1
  }, {
    component: 'MoreNews',
    desktopColumn: 'left',
    desktopOrder: 2,
    handheldOrder: 2
  }, {
    component: "MostReadAll",
    desktopColumn: "right",
    desktopOrder: 1,
    handheldOrder: 3
  }, {
    component: 'GooglePublisherTag',
    props: _GptProperties.topMPUProps,
    desktopColumn: 'right',
    desktopOrder: 1,
    handheldOrder: false
  }, {
    component: 'AdvertWrapper',
    props: {
      ocSlot: ["homepage", "mpu"],
      additionalProperties: {
        view: 'home-page'
      }
    },
    desktopColumn: 'right',
    desktopOrder: 2,
    handheldOrder: false
  }, {
    component: 'RacingTips',
    props: {
      plainTitle: true
    },
    desktopColumn: 'right',
    desktopOrder: 4,
    handheldOrder: false
  }, {
    component: 'HorseRacingNextRaceOff',
    props: {
      plainTitle: true
    },
    desktopColumn: 'right',
    desktopOrder: 5,
    handheldOrder: false
  }, {
    component: 'FootballTips',
    props: {
      plainTitle: true
    },
    desktopColumn: 'right',
    desktopOrder: 7,
    handheldOrder: false
  }]
};

exports.default = {
  '/columnists': columnistsLayout,
  '/news/:basketName/:basketId': function newsBasketNameBasketId(layout, context) {
    var _context$params = context.params;
    _context$params = _context$params === undefined ? {} : _context$params;
    var basketId = _context$params.basketId,
        _context$state = context.state;
    _context$state = _context$state === undefined ? {} : _context$state;
    var _context$state$common = _context$state.common;
    _context$state$common = _context$state$common === undefined ? {} : _context$state$common;
    var _context$state$common2 = _context$state$common.morenews;
    _context$state$common2 = _context$state$common2 === undefined ? {} : _context$state$common2;
    var _context$state$common3 = _context$state$common2[basketId];
    _context$state$common3 = _context$state$common3 === undefined ? {} : _context$state$common3;
    var _context$state$common4 = _context$state$common3.path,
        path = _context$state$common4 === undefined ? "" : _context$state$common4;

    var _path$split = path.split("/"),
        _path$split2 = (0, _slicedToArray3.default)(_path$split, 2),
        section = _path$split2[1];

    section = {
      homepage: "home",
      columnists: "home"
    }[section] || section;

    var customBasketLayout = (0, _extends3.default)({
      section: section
    }, (0, _layoutUtils.genericLayoutFactory)("custom-basket", section).withAdverts({
      component: "CustomBasketNews",
      desktopOrder: 1,
      handheldOrder: 1,
      desktopColumn: "left"
    }));

    return customBasketLayout;
  }
};

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _ColumnistsLayout = __webpack_require__(1016);

var _ColumnistsLayout2 = _interopRequireDefault(_ColumnistsLayout);

var _CustomBasketLayout = __webpack_require__(1017);

var _CustomBasketLayout2 = _interopRequireDefault(_CustomBasketLayout);

var _GooglePublisherTag = __webpack_require__(71);

var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _SectionPlainTitle = __webpack_require__(166);

var _SectionPlainTitle2 = _interopRequireDefault(_SectionPlainTitle);

var _MoreNews = __webpack_require__(93);

var _MoreNews2 = _interopRequireDefault(_MoreNews);

var _CustomBasketNews = __webpack_require__(1018);

var _CustomBasketNews2 = _interopRequireDefault(_CustomBasketNews);

var _MostReadAll = __webpack_require__(141);

var _MostReadAll2 = _interopRequireDefault(_MostReadAll);

var _SectionLink = __webpack_require__(202);

var _SectionLink2 = _interopRequireDefault(_SectionLink);

var _RacingTips = __webpack_require__(116);

var _RacingTips2 = _interopRequireDefault(_RacingTips);

var _FootballTips = __webpack_require__(140);

var _FootballTips2 = _interopRequireDefault(_FootballTips);

var _HorseRacingNextRaceOff = __webpack_require__(115);

var _HorseRacingNextRaceOff2 = _interopRequireDefault(_HorseRacingNextRaceOff);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColumnistsComponents = {
  MostReadAll: _MostReadAll2.default,
  SectionPlainTitle: _SectionPlainTitle2.default,
  MoreNews: _MoreNews2.default,
  GooglePublisherTag: _GooglePublisherTag2.default,
  AdvertWrapper: _AdvertWrapper2.default,
  SectionLink: _SectionLink2.default,
  RacingTips: _RacingTips2.default,
  HorseRacingNextRaceOff: _HorseRacingNextRaceOff2.default,
  FootballTips: _FootballTips2.default
};

var CustomBasketComponents = {
  MostReadAll: _MostReadAll2.default,
  CustomBasketNews: _CustomBasketNews2.default,
  GooglePublisherTag: _GooglePublisherTag2.default,
  AdvertWrapper: _AdvertWrapper2.default,
  SectionLink: _SectionLink2.default,
  RacingTips: _RacingTips2.default,
  HorseRacingNextRaceOff: _HorseRacingNextRaceOff2.default,
  FootballTips: _FootballTips2.default
};

var newsRoutes = _react2.default.createElement(
  _reactRouter.Route,
  null,
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'columnists', component: _ColumnistsLayout2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { components: ColumnistsComponents }),
    ' '
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'news/:basketName/:basketId', component: _CustomBasketLayout2.default },
    ' ',
    _react2.default.createElement(_reactRouter.IndexRoute, { components: CustomBasketComponents }),
    ' '
  )
);

exports.default = newsRoutes;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DragAnchor = __webpack_require__(1022);

var _DragAnchor2 = _interopRequireDefault(_DragAnchor);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DesktopInteractivePlayerContainer = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(DesktopInteractivePlayerContainer, _React$Component);

  function DesktopInteractivePlayerContainer(props) {
    (0, _classCallCheck3.default)(this, DesktopInteractivePlayerContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DesktopInteractivePlayerContainer.__proto__ || (0, _getPrototypeOf2.default)(DesktopInteractivePlayerContainer)).call(this, props));

    _this.playerTransitionStyle = function () {
      var showPlaceholder = _this.state.poppedOut || _this.state.transitioning;
      var style = {
        zIndex: 1000,
        transition: 'right 0.3s ease-in-out'
      };

      style.minWidth = 320;

      if (showPlaceholder) {
        style.position = 'fixed';
        style.width = '25vw';
        style.top = _this.state.top;
      }

      if (_this.state.poppedOut) {
        style.left = _this.state.left;
        style.right = !_this.state.left ? 10 : 300;
      } else {
        style.right = -400;
      }

      style.bottom = !_this.state.top && 10;

      return style;
    };

    _this.onDrag = function (x, y) {
      _this.setState({
        left: x,
        top: y
      });
    };

    _this.resetTransitioning = function () {
      return new _promise2.default(function (resolve) {
        setTimeout(function () {
          if (!_this.state.poppedOut) {
            _this.props.updatePlaceholder(false);
          }

          _this.setState({
            transitioning: false
          }, resolve);
        }, 300);
      });
    };

    _this.setContainerReference = function (ref) {
      _this.container = ref;
    };

    _this.state = {
      top: undefined,
      left: undefined,
      transitioning: false,
      poppedOut: false
    };
    return _this;
  }

  (0, _createClass3.default)(DesktopInteractivePlayerContainer, [{
    key: "setPopOutState",
    value: function setPopOutState(isPoppedOut) {
      if (isPoppedOut) {
        this.props.updatePlaceholder(true);
      }

      if (this.state.poppedOut !== isPoppedOut) {
        this.setState({
          transitioning: true,
          poppedOut: isPoppedOut
        });

        return this.resetTransitioning();
      }
    }
  }, {
    key: "popOutPlayerMenu",
    value: function popOutPlayerMenu() {
      var _this2 = this;

      if (!this.state.poppedOut) {
        return null;
      }

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement("img", { onClick: this.props.dismissPlayer, className: "dismiss-button", src: "/img/icons/ooyala/close-icon.svg" }),
        _react2.default.createElement(_DragAnchor2.default, {
          onDrag: this.onDrag,
          getDraggedRect: function getDraggedRect() {
            return _this2.container.getBoundingClientRect();
          }
        })
      );
    }
  }, {
    key: "resetPopOutPosition",
    value: function resetPopOutPosition() {
      if (this.state.poppedOut || this.state.transitioning) {
        return;
      }

      if (!this.state.top || !this.state.left) {
        return;
      }

      this.setState({
        top: undefined,
        left: undefined
      });
    }
  }, {
    key: "render",
    value: function render() {
      this.resetPopOutPosition();

      return _react2.default.createElement(
        "div",
        {
          ref: this.setContainerReference,
          className: "transitionPosition spl-interactive-video-player",
          style: this.playerTransitionStyle()
        },
        this.popOutPlayerMenu(),
        this.props.children
      );
    }
  }]);
  return DesktopInteractivePlayerContainer;
}(_react2.default.Component), _class.defaultProps = {
  updatePlaceholder: function updatePlaceholder() {}
}, _temp);


DesktopInteractivePlayerContainer.propTypes = {
  player: _propTypes2.default.shape({
    play: _propTypes2.default.func,
    pause: _propTypes2.default.func
  }),
  children: _propTypes2.default.any,
  updatePlaceholder: _propTypes2.default.func,
  dismissPlayer: _propTypes2.default.func
};

exports.default = DesktopInteractivePlayerContainer;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DragAnchor = function (_React$Component) {
  (0, _inherits3.default)(DragAnchor, _React$Component);

  function DragAnchor(props) {
    (0, _classCallCheck3.default)(this, DragAnchor);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DragAnchor.__proto__ || (0, _getPrototypeOf2.default)(DragAnchor)).call(this, props));

    _this.onDrag = function (event) {
      event.preventDefault();
      var clientX = event.clientX,
          clientY = event.clientY;


      if (clientX === 0 && clientY === 0) {
        return;
      }

      var dragX = clientX - _this.state.anchorX;
      var dragY = clientY - _this.state.anchorY;

      _this.props.onDrag(dragX, dragY);
    };

    _this.setAnchor = function (_ref) {
      var clientX = _ref.clientX,
          clientY = _ref.clientY;

      var rect = _this.props.getDraggedRect();
      var x = clientX - rect.left; //x position within the element.
      var y = clientY - rect.top; //y position within the element.

      _this.setState({
        anchorX: x,
        anchorY: y
      });
    };

    _this.resetAnchor = function () {
      _this.setState({
        anchorX: undefined,
        anchorY: undefined
      });
    };

    _this.state = {
      anchorX: undefined,
      anchorY: undefined
    };
    return _this;
  }

  (0, _createClass3.default)(DragAnchor, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement("div", {
        draggable: "true",
        onMouseDown: this.setAnchor,
        onMouseUp: this.resetAnchor,
        onDrag: this.onDrag,
        style: {
          position: 'absolute',
          top: 0,
          left: 40,
          right: 0,
          height: 40,
          cursor: 'move',
          opacity: 0,
          zIndex: 1
        }
      });
    }
  }]);
  return DragAnchor;
}(_react2.default.Component);

DragAnchor.propTypes = {
  onDrag: _propTypes2.default.func,
  getDraggedRect: _propTypes2.default.func
};

exports.default = DragAnchor;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _MobilePlayerControl = __webpack_require__(1024);

var _MobilePlayerControl2 = _interopRequireDefault(_MobilePlayerControl);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MobileInteractivePlayerContainer = (_temp2 = _class = function (_React$Component) {
  (0, _inherits3.default)(MobileInteractivePlayerContainer, _React$Component);

  function MobileInteractivePlayerContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MobileInteractivePlayerContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MobileInteractivePlayerContainer.__proto__ || (0, _getPrototypeOf2.default)(MobileInteractivePlayerContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      poppedOut: false
    }, _this.handleContainerClick = function (e) {
      if (_this.state.poppedOut) {
        e.stopPropagation();
        e.preventDefault();
        e.stopImmediatePropagation();
        var onMobilePopOutPress = _this.props.onMobilePopOutPress;

        onMobilePopOutPress && onMobilePopOutPress();
      }
    }, _this.findOoyalaPlayerElement = function () {
      return _this.container.getElementsByClassName('oo-player')[0];
    }, _this.onPlayerReady = function () {
      _this.playerSkin = _this.findOoyalaPlayerElement();
      _this.videoElement = _this.container.getElementsByTagName('video')[0];
    }, _this.getPlayerSkin = function () {
      if (!_this.container) {
        return undefined;
      }

      if (!_this.playerSkin) {
        _this.playerSkin = _this.findOoyalaPlayerElement();
      }

      return _this.playerSkin;
    }, _this.mobilePlayerTransitionPositionStyle = function () {
      var showPlaceholder = _this.state.poppedOut;
      var style = {
        zIndex: 1000
      };

      style.minWidth = 320;

      if (showPlaceholder) {
        style.position = 'fixed';
        style.transform = 'scale(0.75)';
      }

      style.left = 10;
      style.bottom = 55;

      return style;
    }, _this.bouncePlayerIn = function () {
      var playerSkin = _this.getPlayerSkin();

      if (!playerSkin) {
        return _promise2.default.resolve();
      }

      return new _promise2.default(function (resolve) {
        playerSkin.classList.add('bounceIn');
        var handler = function handler() {
          playerSkin.classList.remove('bounceIn');
          playerSkin.removeEventListener('animationend', handler);
          resolve();
        };
        playerSkin.addEventListener('animationend', handler);
      });
    }, _this.bouncePlayerOut = function () {
      var playerSkin = _this.getPlayerSkin();

      if (!playerSkin) {
        return _promise2.default.resolve();
      }

      return new _promise2.default(function (resolve) {
        playerSkin.classList.add('bounceOut');
        var handler = function handler() {
          playerSkin.classList.remove('bounceOut');
          playerSkin.removeEventListener('animationend', handler);
          resolve();
        };
        playerSkin.addEventListener('animationend', handler);
      });
    }, _this.slideControlsIn = function () {
      if (!_this.playerControls) {
        return _promise2.default.resolve();
      }

      return new _promise2.default(function (resolve) {
        _this.playerControls.style.display = "unset";
        _this.playerControls.classList.add('slideIn');
        var handler = function handler() {
          _this.playerControls.classList.remove('slideIn');
          _this.playerSkin.removeEventListener('animationend', handler);
          resolve();
        };
        _this.playerControls.addEventListener('animationend', handler);
      });
    }, _this.slideControlsOut = function () {
      if (!_this.playerControls) {
        return _promise2.default.resolve();
      }

      return new _promise2.default(function (resolve) {
        _this.playerControls.classList.add('slideOut');
        var handler = function handler() {
          _this.playerControls.style.display = "none";
          _this.playerControls.classList.remove('slideOut');
          _this.playerControls.removeEventListener('animationend', handler);
          resolve();
        };
        _this.playerControls.addEventListener('animationend', handler);
      });
    }, _this.setContainerReference = function (ref) {
      _this.container = ref;
    }, _this.setPlayerControlsReference = function (ref) {
      _this.playerControls = ref;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MobileInteractivePlayerContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.playerControls.style.display = "none";
      this.container.addEventListener('touchend', this.handleContainerClick, true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.container.removeEventListener('click', this.handleContainerClick);
    }
  }, {
    key: "popOut",
    value: function popOut() {
      var _this2 = this;

      this.setState({
        poppedOut: true
      });
      this.props.updatePlaceholder(true);
      return new _promise2.default(function (resolve) {
        _this2.bouncePlayerIn().then(_this2.slideControlsIn).then(function () {
          resolve();
        });
      });
    }
  }, {
    key: "popIn",
    value: function popIn() {
      var _this3 = this;

      return new _promise2.default(function (resolve) {
        _this3.slideControlsOut().then(_this3.bouncePlayerOut).then(function () {
          _this3.setState({
            poppedOut: false
          });
          _this3.props.updatePlaceholder(false);
          resolve();
        });
      });
    }
  }, {
    key: "setPopOutState",
    value: function setPopOutState(shouldPopOut) {
      if (shouldPopOut && !this.state.poppedOut) {
        return this.popOut();
      }

      if (!shouldPopOut && this.state.poppedOut) {
        return this.popIn();
      }

      return _promise2.default.resolve();
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "spl-interactive-video-player" },
        _react2.default.createElement(
          "div",
          {
            ref: this.setContainerReference,
            className: "transitionPosition " + (this.state.poppedOut ? 'poppedOut' : ''),
            style: this.mobilePlayerTransitionPositionStyle()
          },
          this.props.children
        ),
        _react2.default.createElement(
          "div",
          {
            ref: this.setPlayerControlsReference,
            style: {
              position: 'fixed',
              bottom: 54,
              left: 249,
              right: 10,
              height: 135,
              borderRadius: '0 4px 4px 0',
              boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
              backgroundColor: '#0b2451',
              color: 'white',
              zIndex: 1000
            }
          },
          _react2.default.createElement("img", {
            onClick: this.props.dismissPlayer,
            className: "dismiss-button-mobile",
            src: "/img/icons/ooyala/close-icon.svg"
          }),
          _react2.default.createElement(_MobilePlayerControl2.default, { player: this.props.player })
        )
      );
    }
  }]);
  return MobileInteractivePlayerContainer;
}(_react2.default.Component), _class.defaultProps = {
  updatePlaceholder: function updatePlaceholder() {}
}, _temp2);


MobileInteractivePlayerContainer.propTypes = {
  player: _propTypes2.default.shape({
    play: _propTypes2.default.func,
    pause: _propTypes2.default.func
  }),
  children: _propTypes2.default.any,
  updatePlaceholder: _propTypes2.default.func,
  dismissPlayer: _propTypes2.default.func,
  onMobilePopOutPress: _propTypes2.default.func
};

exports.default = MobileInteractivePlayerContainer;

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PLAYING = 'playing';
var PAUSED = 'paused';

var MobilePlayerControl = function (_React$Component) {
  (0, _inherits3.default)(MobilePlayerControl, _React$Component);

  function MobilePlayerControl() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MobilePlayerControl);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MobilePlayerControl.__proto__ || (0, _getPrototypeOf2.default)(MobilePlayerControl)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      playerState: PLAYING
    }, _this.pause = function () {
      _this.props.player.pause();
      _this.setState({ playerState: PAUSED });
    }, _this.play = function () {
      _this.props.player.play();
      _this.setState({ playerState: PLAYING });
    }, _this.getPlayerIcon = function () {
      switch (_this.state.playerState) {
        case PLAYING:
          return _react2.default.createElement('img', { className: 'control-button-mobile', onClick: _this.pause, src: '/img/icons/ooyala/pause-icon.svg' });
        case PAUSED:
          return _react2.default.createElement('img', { className: 'control-button-mobile', onClick: _this.play, src: '/img/icons/ooyala/play-icon.svg' });
        default:
          return null;
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MobilePlayerControl, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _this2 = this;

      if (this.props.player && this.props.player.mb && !this.subscribed) {
        this.props.player.mb.subscribe('paused', '', function () {
          _this2.setState({ playerState: PAUSED });
        });
        this.props.player.mb.subscribe('playing', '', function () {
          _this2.setState({ playerState: PLAYING });
        });
        this.subscribed = true;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.getPlayerIcon()
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props) {
      if (!props.player) {
        return null;
      }

      if (!props.player.isPlaying) {
        return null;
      }

      return {
        playerState: props.player.isPlaying() ? PLAYING : PAUSED
      };
    }
  }]);
  return MobilePlayerControl;
}(_react2.default.Component);

MobilePlayerControl.propTypes = {
  player: _propTypes2.default.shape({
    play: _propTypes2.default.func,
    pause: _propTypes2.default.func,
    mb: _propTypes2.default.shape({
      subscribe: _propTypes2.default.func
    })
  })
};

exports.default = MobilePlayerControl;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(29);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _makeValueChangeSpy = __webpack_require__(1057);

var _makeValueChangeSpy2 = _interopRequireDefault(_makeValueChangeSpy);

var _isInViewport = __webpack_require__(1056);

var _isInViewport2 = _interopRequireDefault(_isInViewport);

var _getNearestNumber = __webpack_require__(1055);

var _getNearestNumber2 = _interopRequireDefault(_getNearestNumber);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScrollingInspector = function (_React$Component) {
  (0, _inherits3.default)(ScrollingInspector, _React$Component);

  function ScrollingInspector() {
    (0, _classCallCheck3.default)(this, ScrollingInspector);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScrollingInspector.__proto__ || (0, _getPrototypeOf2.default)(ScrollingInspector)).call(this));

    _this.setContainerReference = function (ref) {
      _this.container = ref;
    };

    _this.handleScroll = function () {
      var isElementInViewport = (0, _isInViewport2.default)(_this.container);
      _this.comparator(isElementInViewport);
    };

    _this.getImageUrl = function () {
      if (!_this.container) {
        return "";
      }

      var containerWidth = _this.container.clientWidth;
      var width = (0, _getNearestNumber2.default)((0, _keys2.default)(_this.props.thumbnails), containerWidth);
      return _this.props.thumbnails[width];
    };

    var valueChangeSpy = (0, _makeValueChangeSpy2.default)(true);
    _this.comparator = valueChangeSpy.comparator;
    _this.registerCallback = valueChangeSpy.registerCallback;
    return _this;
  }

  (0, _createClass3.default)(ScrollingInspector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
      this.registerCallback(this.props.onVisibilityChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: "render",
    value: function render() {
      var showPlaceholder = this.props.showPlaceholder;


      return _react2.default.createElement(
        "div",
        {
          ref: this.setContainerReference,
          className: "player-container " + (showPlaceholder && "retainAspectRatio")
        },
        showPlaceholder && _react2.default.createElement("div", {
          id: "placeholder-" + this.props.playerPlaceholderId,
          style: { background: "url(" + this.getImageUrl() + ")", backgroundSize: 'cover' },
          className: "ooyala-background-image-placeholder"
        }),
        this.props.children
      );
    }
  }]);
  return ScrollingInspector;
}(_react2.default.Component);

ScrollingInspector.propTypes = {
  children: _propTypes2.default.any,
  showPlaceholder: _propTypes2.default.bool,
  thumbnails: _propTypes2.default.object,
  onVisibilityChange: _propTypes2.default.func,
  playerPlaceholderId: _propTypes2.default.string
};

exports.default = ScrollingInspector;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASE_TRACKING_LINK_NAME = '[Sporting Life Video]';
var TRACKING_EVENT = 'linkClick';

var makePlayerEventTracker = function makePlayerEventTracker(context) {
  return function (eventName, response) {
    if (eventName === 'initialPlay') {
      context.metrics.track(TRACKING_EVENT, { link: BASE_TRACKING_LINK_NAME + ' Video Play Clicked' });
      return;
    }

    if (eventName === 'play') {
      context.metrics.track(TRACKING_EVENT, { link: BASE_TRACKING_LINK_NAME + ' Video Play Start' });
      return;
    }

    if (eventName.indexOf('error') > -1) {
      if (response && response.code === 'unplayable_content') {
        context.metrics.track(TRACKING_EVENT, { link: BASE_TRACKING_LINK_NAME + ' Video Play Fail - Video Missing' });
        return;
      }

      context.metrics.track(TRACKING_EVENT, { link: BASE_TRACKING_LINK_NAME + ' Video Play Fail - Playback Error' });
    }
  };
};

exports.default = makePlayerEventTracker;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OtherSportsHomePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(OtherSportsHomePage, _Component);

  function OtherSportsHomePage() {
    (0, _classCallCheck3.default)(this, OtherSportsHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (OtherSportsHomePage.__proto__ || (0, _getPrototypeOf2.default)(OtherSportsHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(OtherSportsHomePage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: 'other',
        title: 'Other Sports News',
        location: location
      });
    }
  }]);
  return OtherSportsHomePage;
}(_react.Component), _class.propTypes = {
  children: _propTypes2.default.node
}, _temp);
exports.default = OtherSportsHomePage;

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OtherSportsNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "Other Sports",
    links: [{ href: "/other-sports", text: "News", isIndex: true }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

OtherSportsNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = OtherSportsNav;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routeUtils = __webpack_require__(38);

var _OtherSportsHomePage = __webpack_require__(1027);

var _OtherSportsHomePage2 = _interopRequireDefault(_OtherSportsHomePage);

var _OtherSportsNav = __webpack_require__(1028);

var _OtherSportsNav2 = _interopRequireDefault(_OtherSportsNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _routeUtils.genericRoute)(_OtherSportsHomePage2.default, _OtherSportsNav2.default, 'other-sports');

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(516);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviousPrivacyPolicyComponent = function (_Component) {
    (0, _inherits3.default)(PreviousPrivacyPolicyComponent, _Component);

    function PreviousPrivacyPolicyComponent() {
        (0, _classCallCheck3.default)(this, PreviousPrivacyPolicyComponent);
        return (0, _possibleConstructorReturn3.default)(this, (PreviousPrivacyPolicyComponent.__proto__ || (0, _getPrototypeOf2.default)(PreviousPrivacyPolicyComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(PreviousPrivacyPolicyComponent, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'section',
                { className: 'privacy-policy-section' },
                _react2.default.createElement(
                    'header',
                    { className: 'section-header' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'title' },
                        'Privacy Policy (Previous)'
                    )
                ),
                _react2.default.createElement(
                    'article',
                    { className: 'section-article' },
                    _react2.default.createElement(
                        'p',
                        null,
                        'This privacy notice applies to the use of personal information and other information by Hestview Limited, whose trading names include Sky Games,  Sky Sports Super 6, and Sky Sports Fantasy Football (collectively, \'Sky Games\').'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Sky Games and its affiliated companies may use and share, within that group and with its advisors, the information you provide and other information it holds about you for the purposes set out below.'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Information we may hold'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'Information you provided to us, including on our websites'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Information about our content, products and services you\u2019ve interacted with or played.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Information provided by other companies who\u2019ve obtained your permission to share information about you.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Information, uploads and comments you make about the services you use and our related products, including how you access, view, share, contribute to and communicate with them.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Information we collect from devices you use to receive Sky Games content, products and services and about your use of Sky Games and/or selected third party content, products and services. For more information about cookies and how to manage them please see the Cookies Notice.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'IP address (this is a number that identifies a specific network device on the internet and is required for your device to communicate with websites) and location data.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Technical information from the devices you use to receive Sky Games content, products and services, for example the collection of diagnostic and traffic information.'
                        )
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'How we may use your information'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In addition to using your information to provide you with content, products, services, tailored and personalised recommendations and general account management, we may also use your information in the following ways:'
                    ),
                    _react2.default.createElement(
                        'ol',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'To monitor, improve and protect our content, products and services, work with our agents and business partners to improve the products and services we offer, and develop new content, products and services.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'We may share information with fraud or crime prevention agencies for fraud detection and prevention purposes.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'We may transfer your information to our data processors outside the European Economic Area, but will do so with appropriate measures and controls in place to protect that information in accordance with applicable data protection laws and regulations.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'For market research.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'To enable us to comply with any legal or regulatory requirements; to protect or enforce our rights or the rights of any third party; in the detection and prevention of fraud and other crimes; and for the purpose of safeguarding national security.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'We may disclose your information to any successors of our business for them to use for the purposes set out in this Privacy Notice.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'If you log into one of our products through Facebook, Facebook provides us with some of your Facebook user details. We may use and share these details with our partners, each of whom may use the details to provide you with a more personalised experience on Facebook. This means that we and they may, for example, tailor the advertisements you see on Facebook so that you see advertisements for similar apps to Apps provided by us.'
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            'Unless you\'ve asked us not to:'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'To send you periodic communications and other information about your chosen content, products and services.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'To send you direct marketing from us or our trusted business partners (specifically including Sky Betting and Gaming). This may include communications by post, telephone or email and SMS, about us and our business partners\u2019 content, products and services, events and special offers, including, where applicable, for a reasonable time after you have ceased to be a customer of ours.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'To provide you with tailored advertising. This means that we have your agreement to use the information we hold about you, for example, to make some of the adverts you see more relevant to you.'
                        ),
                        _react2.default.createElement(
                            'h6',
                            null,
                            'Your preferences'
                        ),
                        _react2.default.createElement(
                            'h5',
                            null,
                            'Marketing'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'You can choose not to receive direct marketing. You can adjust your preferences in the following ways:'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'via your Sky Games account preferences.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'by clicking on the "unsubscribe" link in email marketing information from us in relation to future email marketing.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'By contacting us on 0330 024 4777 or through support@skybet.com'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Online behavioural advertising'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'If you don\'t want any information processed through the use of cookies, please see the Cookies Notice.'
                        ),
                        _react2.default.createElement(
                            'h5',
                            null,
                            'Contacting Sky Games'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Any queries or comments about this Privacy Notice or for requests of copies of the information we hold about you should be sent to DP@skybettingandgaming.com with the subject line \u201CData Protection Query\u201D.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Please ensure you notify us of any updates, amendments and corrections to your information by contacting us by phoning us on 0330 024 4777 or writing to Sky Games, 2 Wellington Place, Leeds, West Yorkshire, LS1 4AP.'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We may make changes to this Privacy Notice at any time, at our sole discretion. Such changes will take effect from the date specified by us on our websites, whether or not we have notified you specifically of such changes. It is important, therefore, that You log in to the websites from time to time to check to see whether there is a notification of change.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You agree to be solely responsible for becoming informed of such changes. If You continue to use the Sky Games websites or services after the effective date of certain changes (regardless of the way we have notified such changes), You agree to be bound by those changes whether or not You have had actual notice of, or have read, the relevant changes. If You do not agree to be bound by relevant changes, You should not continue to use our websites or services any further.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'This Privacy Notice was last updated on 13 February 2017.'
                    ),
                    _react2.default.createElement('div', { id: 'cookie-policy', className: 'anchor-push' }),
                    _react2.default.createElement(
                        'h4',
                        { id: 'cookie-policy-header' },
                        'Cookies Policy'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'This cookies policy (the \u201CPolicy\u201D) applies to the websites operated by Hestview Limited, whose trading names include Sky Games, Fantasy Six-A-Side, Sky Sports Super 6, Sky Sports Fantasy Football and Sporting Life Pick 7 (collectively, \u201CSky Games\u201D).'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'When you create or log into an online account via the Sky Games websites, you agree to our use of cookies as set out in this Policy. Otherwise, by continuing to scroll, click, navigate or use the Sky Games websites, content, products or services you agree to the use of cookies as described in this Policy.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You should be aware that when you access or use our content, products and services, we may collect information from your devices by using \'cookies\'. For further details about the types of cookies we use, please see the section \u201CCookies on the Sky Games websites\u201D '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you would like to learn more about your cookie settings, how to manage these cookies and/or how to opt-out from the cookies being set, please see the section "Controlling My Cookies".'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'What are cookies and how do they work?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Cookies are small bits of text and numbers that are downloaded onto the devices you use to receive Sky Games content, products and services and access online information. Your browser makes these cookies available every time you visit the website again, so it can recognise you and your device and can then tailor what you see.'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'What do we use cookies for?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Cookies play an important part in the day-to-day functioning of websites and other online content. Cookies help your device or browser to access information, identify you as a user (for example, so we can keep you logged into your account when you navigate around the websites) or use certain features (for example, you want to reset your PIN or User ID) when you use the Sky Games websites. We also sometimes use other cookies to enhance your experience (for example, by showing more relevant games based on your previous activity). We do not use cookies for any reason that does not:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'Make adverts and other content more effective and relevant to you.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Ensure we can pay our affiliate partners correctly for the users they refer to us.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Improve your Sky Games experience by providing anonymised analytics.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Deliver features and content (for example we might want to see how many customers visited the homepage yesterday compared to last week).'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Detect and defend against fraud and other security risks to protect our customers, partners and Sky Games itself.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Meet our legal, compliance and regulatory duties. '
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Continually improve our products and services (for example, by testing different product experiences with different users to see which the best is).'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'As outlined in the summary above, there are many different types of, and uses for, cookies. However, they can be grouped in the following four main groups: (1) strictly necessary, (2) functionality, (3) targeting and (4) analytical. Further detail about how and why Sky Games uses each of this type of cookie can be found in the detail below:'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Cookies on Sky Games websites'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Our websites use the following cookies:'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Type of cookie:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Strictly necessary - some are session and persistent cookies. Some of these cookies are set by third parties such as Infinity Works Consulting and GFM.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'What do they do?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'These are cookies which are needed to provide the content, product or service you have asked for. These cookies are essential to help your device download or stream information, so that you can move around our websites and use their features. Without these cookies, we can\u2019t provide the content, products or services you\'ve asked for.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'How do we use this type of cookie?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'Here are a few examples of some of the ways in which we use functionality cookies:'
                        ),
                        _react2.default.createElement(
                            'ul',
                            null,
                            _react2.default.createElement(
                                'li',
                                null,
                                'positioning information on your smartphone screen, tablet device or other screen so that you can see and use our websites;'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'keeping you logged in during your visit so that you don\u2019t have to log in on every one of our websites each time you visit;'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'enabling you to stream content, without having to repeatedly adjust your volume and viewing settings; and'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'allowing you to navigate through our websites smoothly by identifying your device or browser and subsequently showing the most appropriate format of website.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Do these cookies collect my personal data? Does the information get passed onto third parties?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Yes, some of these cookies do collect your personal data and some of your personal data may be passed onto third parties such as Infinity Works Consulting and GFM.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Links to more information:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'Page 8 \u2013 9 of this guide, provided by the ICO, details the types of cookies in more detail: '
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: 'https://www.cookielaw.org/media/1096/icc_uk_cookiesguide_revnov.pdf', target: '_blank' },
                            'https://www.cookielaw.org/media/1096/icc_uk_cookiesguide_revnov.pdf'
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Type of cookie:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Functionality. Some of these cookies are set by third parties such as OpenBet, and GetClicky.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'What do they do?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'These cookies recognise you when you return to our website and allow us to remember the choices you make. They also help us to provide improved features.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'How do we use this type of cookie?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'Here are a few examples of some of the ways in which we use functionality cookies:'
                        ),
                        _react2.default.createElement(
                            'ul',
                            null,
                            _react2.default.createElement(
                                'li',
                                null,
                                'remembering your preferences and settings, including language, location and marketing preferences (such as choosing whether you wish to receive marketing information);'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'remembering the selections in your betslip;'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'remembering if you\'ve used a specific application or website before;'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'showing you information that\'s relevant to the content, products or services that you receive;'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'giving you access to content provided by social-media websites, such as Twitter; and'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'showing \'related article\' links that are relevant to the information you\'re looking at.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Do these cookies collect my personal data? Does the information get passed onto third parties?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Yes, some of these cookies do collect your personal data. Some of these cookies don\'t collect personal data, but we do sometimes pass on this anonymised data to third parties such as Maxymiser.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Links to more information:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'Page 8 \u2013 9 of this guide, provided by the ICO, details the types of cookies in more detail: '
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: 'https://www.cookielaw.org/media/1096/icc_uk_cookiesguide_revnov.pdf', target: '_blank' },
                            'https://www.cookielaw.org/media/1096/icc_uk_cookiesguide_revnov.pdf'
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Type of cookie:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Targeting. Some of these cookies are set by third parties such as TeaLeaf, Revenue Science, Google and Oddschecker.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'What do they do?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'We sell space on some of our websites to advertisers. The resulting adverts often contain cookies which are stored onto your device as you visit different websites. The advertiser uses the browsing information collected from these cookies to:'
                        ),
                        _react2.default.createElement(
                            'ul',
                            null,
                            _react2.default.createElement(
                                'li',
                                null,
                                'restrict the number of times you are shown a particular advertisement. This is sometimes called \'frequency capping\'; and'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'show other advertisements that are relevant to you, while you\'re accessing our information.'
                            )
                        ),
                        _react2.default.createElement(
                            'span',
                            null,
                            'Your browsing activity may be grouped with information about what is being accessed by other users within similar interest and demographic groups. The result is then used to show you advertisements based on those interests. This is often called online behavioural advertising (OBA).'
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'How do we use this type of cookie?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'Here are a few examples of some of the ways in which we use targeting cookies:'
                        ),
                        _react2.default.createElement(
                            'ul',
                            null,
                            _react2.default.createElement(
                                'li',
                                null,
                                'to remember websites you have visited;'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'to remember links you have followed; and'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'within advertisements for our own Sky Games products.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Do these cookies collect my personal data? Does the information get passed onto third parties?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Yes, some of these cookies do collect your personal data.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Links to more information:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'Page 8 \u2013 9 of this guide, provided by the ICO, details the types of cookies in more detail: '
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: 'https://www.cookielaw.org/media/1096/icc_uk_cookiesguide_revnov.pdf', target: '_blank' },
                            'https://www.cookielaw.org/media/1096/icc_uk_cookiesguide_revnov.pdf'
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Type of cookie:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Analytical. Some of these cookies are set by third parties such as Omniture, and Google.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'What do they do?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Analytical cookies gather information about which of our websites, information and links are popular and which ones don\'t get used as much. Our applications, web locations, websites and communications that you get from us also contain small invisible images known as \'web beacons\' or \'pixels\'. These \u2018pixels\u2019 simply let us know that an advert or affiliate partner has successfully connected a customer to Sky Games. For example, when a new customer successfully registers on a Sky Games website after clicking an advert, a \u201Cpixel\u201D will let us know that the advert worked or that we need to pay an affiliate partner for sending a new customer to us. These pixels cannot identify an individual user. Your information is collected and grouped together with information collected from everyone else\u2019s devices. These cookies don\u2019t identify you and all the data is collected and aggregated anonymously. We can then see overall patterns of usage, rather than any one person\u2019s activity.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'How do we use this type of cookie?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'Here are a few examples of some of the ways in which we use Analytical cookies:'
                        ),
                        _react2.default.createElement(
                            'ul',
                            null,
                            _react2.default.createElement(
                                'li',
                                null,
                                'to identify trends about how people navigate (find their way through) our information and when and where \'error messages\' may originate;'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'to help us keep our information relevant and up to date;'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'to count the number of times a page or email has been viewed and allow us to measure the effectiveness of the communication; and'
                            ),
                            _react2.default.createElement(
                                'li',
                                null,
                                'to improve how our applications, and websites and their pages work.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Do these cookies collect my personal data? Does the information get passed onto third parties?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Yes, some of these cookies collect some personal data. We pass on both anonymised and personal information collected onto third parties such as Omniture and Google'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Links to more information:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'Page 8 \u2013 9 of this guide, provided by the ICO, details the types of cookies in more detail: '
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: 'https://www.cookielaw.org/media/1096/icc_uk_cookiesguide_revnov.pdf', target: '_blank' },
                            'https://www.cookielaw.org/media/1096/icc_uk_cookiesguide_revnov.pdf'
                        )
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Cookies explained'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Neither we, nor the companies who show advertisements on our websites, sell personal data collected from cookies to any other organisations. Where we transfer any of your data to third parties, we do so in accordance with our Privacy Policy.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'It is easy for you to choose not to receive behavioural advertising and manage your cookie preferences. Please see the "Controlling my Cookies" section for further details.'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Controlling my Cookies'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'How can I see and manage my cookies in my browser?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Virtually all modern browsers allow you to see what cookies you have, and to clear them individually or in their entirety. To find out how to do this, visit aboutcookies.org, which contains comprehensive information about how to manage your cookie preferences on a wide variety of desktop browsers.'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'How can I choose not to receive Online Behavioural Advertising and other tracking cookies?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In addition to the controls available on your computer and through the Sky Games websites, there are other ways of choosing not to receive Online Behavioural Advertising and other tracking cookies.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Please note that most of these choices work by setting a cookie that remembers your choice of opting-out. If you clear all of your cookies, you will also clear these opt-out cookies. In this instance you would need to opt-out from Online Behavioural Advertising again.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The following organisations provide more information about Online Behavioural Advertising:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'http://www.youronlinechoices.com/uk/', target: '_blank' },
                                'Your Online Choices'
                            ),
                            _react2.default.createElement(
                                'span',
                                null,
                                ' - This allows you to choose not to receive behavioural advertising from the majority of the advertising networks.'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'https://www.networkadvertising.org/', target: '_blank' },
                                'Network Advertising Initiative (NAI)'
                            ),
                            _react2.default.createElement(
                                'span',
                                null,
                                ' \u2013 Please see the \u201Copt-out\u201D page. This allows you to opt-out of behavioural advertising from each of the ad networks represented by the NAI.'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'http://www.edaa.eu/', target: '_blank' },
                                'European Digital Advertising Alliance'
                            ),
                            _react2.default.createElement(
                                'span',
                                null,
                                ' \u2013 Please see the Online Behavioural Advertising choices page.'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Can I disable cookies altogether rather than just deleting them?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Yes. If you would rather not let websites set any cookies at all on your browser or device you can follow the steps outlined below. Please note that this will affect the normal function of Sky Games websites and other websites that you might access.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Internet Explorer'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'To prevent new cookies from being installed and delete existing cookies: '
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: 'http://windows.microsoft.com/en-GB/internet-explorer/delete-manage-cookies', target: '_blank' },
                            'http://windows.microsoft.com/en-GB/internet-explorer/delete-manage-cookies'
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Firefox'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'To prevent new cookies from being installed: '
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: 'https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences', target: '_blank' },
                            'https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'To delete existing cookies: '
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: 'https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored', target: '_blank' },
                            'https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored'
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Google Chrome'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'To prevent new cookies from being installed and delete existing cookies: '
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: 'https://support.google.com/chrome/answer/95647?hl=en', target: '_blank' },
                            'https://support.google.com/chrome/answer/95647?hl=en'
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Safari'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'span',
                            null,
                            'To prevent new cookies from being installed and delete existing cookies: '
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: 'http://help.apple.com/safari/mac/8.0/#/sfri11471', target: '_blank' },
                            'http://help.apple.com/safari/mac/8.0/#/sfri11471'
                        )
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'How can I get more information?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Any queries or comments about this Policy should be sent to support@skybet.com with the subject line \u201CCookie Policy Query\u201D.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'This Cookies Policy was last updated on 13 February 2017.'
                    )
                )
            );
        }
    }]);
    return PreviousPrivacyPolicyComponent;
}(_react.Component);

exports.default = PreviousPrivacyPolicyComponent;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

__webpack_require__(516);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrivacyPolicyComponent = function (_Component) {
    (0, _inherits3.default)(PrivacyPolicyComponent, _Component);

    function PrivacyPolicyComponent() {
        (0, _classCallCheck3.default)(this, PrivacyPolicyComponent);
        return (0, _possibleConstructorReturn3.default)(this, (PrivacyPolicyComponent.__proto__ || (0, _getPrototypeOf2.default)(PrivacyPolicyComponent)).apply(this, arguments));
    }

    (0, _createClass3.default)(PrivacyPolicyComponent, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'section',
                { className: 'privacy-policy-section' },
                _react2.default.createElement(
                    'header',
                    { className: 'section-header' },
                    _react2.default.createElement(
                        'h3',
                        { className: 'title' },
                        'Let\'s talk about Privacy'
                    )
                ),
                _react2.default.createElement(
                    'article',
                    { className: 'section-article' },
                    _react2.default.createElement(
                        'p',
                        null,
                        'We like to make things easier for our customers and that includes being clear and open about how and why we use your personal information. We know there\'s nothing more off-putting than the sight of a lot of boring small print, so we\'ve written our Privacy Policy in plain English to make it clear, simple and easy to read. We hope you\'ll find it helpful but if you have any concerns or questions please feel free to contact our ',
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:dp@skybettingandgaming.com' },
                            'Data Privacy Office.'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'This Privacy Policy was updated in March 2018. We will update it from time to time and if we make any changes that could affect you, we\'ll let you know before they happen.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Our Policy explains how Sky Betting and Gaming uses your personal data, whether you\'re just visiting one of our websites, placing a bet or playing one of our games. There is a lot of information, and we know you won\'t want to read it all at once, ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'but where you see the \'',
                            _react2.default.createElement(
                                'span',
                                { className: 'important-policy-key' },
                                '!'
                            ),
                            '\' symbol, it indicates something that we particularly need you to be aware of as it has an impact on your privacy. This includes information you may not already know about your data privacy rights, circumstances in which we share and obtain information about you, and how we use it to personalise the marketing you receive. Please take time to read those sections carefully.'
                        )
                    ),
                    _react2.default.createElement(
                        'h4',
                        null,
                        'Our Privacy Promise:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We never lose sight of the fact that your personal information is ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'your'
                        ),
                        ' personal information. Your privacy is important both to you and to us and we make the following promise to you:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Sky Betting and Gaming is committed to protecting your privacy.  We believe in using your personal information to make things simpler and better for you.  We will always keep your personal information safe.  We\'ll be clear and open with you about why we collect your personal information and how we use it. Where you have choices or rights, we\'ll explain them to you and respect your wishes.'
                    ),
                    _react2.default.createElement(
                        'h3',
                        null,
                        'Our Privacy Policy'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Who\'s in control of your information?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Throughout this Privacy Policy, \'we\', \'our\', \'Sky Bet\' or \'Sky Betting and Gaming\' means companies within the Bonne Terre, Hestview Group, Cyan Blue International Limited, Cyan Blue Odds Limited & Core Gaming Limited. You will know us better by our trading names, which include Sky Betting & Gaming, Sky Bet, Sky Vegas, Sky Casino, Sky Bingo, Sky Poker, Sky Games, Sky Sports Super 6, Sky Sports Fantasy Football, Fantasy Six a Side, ITV7, SkyBet Italia, and Sportinglife.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Although Oddschecker (Cyan Blue Odds Limited) is part of our group of companies, it has a separate privacy policy as its products and services differ from those of our other group companies, so if you are also an Oddschecker customer you may wish to have a look at the Oddschecker privacy policy as well as this one.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In the UK, to comply with local data protection law, Hestview Limited, Bonne Terre Limited, Cyan Blue Odds Limited & Core Gaming Limited are registered as \'Data Controllers\' with the Information Commissioner\'s Office (ICO) and details are published on a public register on the ICO website at ',
                        _react2.default.createElement(
                            'a',
                            { href: 'http://ico.org.uk', target: '_blank' },
                            'http://ico.org.uk'
                        ),
                        '. In Germany, the \'Data Controller\' is Cyan Blue International Limited.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In Italy, to comply with local data protection requirements, our employees are officially appointed as \'Incaricati Del Trattamento\' (\'persons in charge of handling of personal data\') on behalf of the company.  They, like all our employees in any of our locations, undertake regular data privacy training and are required to comply with internal policies and procedures whenever they handle personal information.'
                    ),
                    _react2.default.createElement(
                        'h4',
                        null,
                        'Our Data Protection Officer'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you have any concerns about how SBG handles your personal information, you can contact our Data Protection Officer at: ',
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:dp@skybettingandgaming.com' },
                            'dp@skybettingandgaming.com'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you wish to submit a subject access request or a request to exercise any of your rights here, please ',
                        _react2.default.createElement(
                            'a',
                            { href: '#how-and-why-we-use-your-personal-info' },
                            'click here'
                        ),
                        ' for details of how to do so.'
                    ),
                    _react2.default.createElement(
                        'h4',
                        null,
                        'Collecting information about you'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Information we get from you'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Sky Betting and Gaming collects personal information about you whenever you use our services. Some of it is information you give us directly when, for example, you register for an account, deposit funds, place a bet or play one of our games.  Other information is collected as you interact with us, such as the bets you place or online chats with our customer services team. We also collect information about the way you access, view, share, contribute to and communicate with and through our services, for example when you post comments via our social media channels or chat functionalities (such as via Sky Poker).'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Information we get from your device'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'We collect information from the devices you use to receive Sky Betting and Gaming content, products and services.  This includes, but is not limited to the following: your IP address (a number that identifies a specific device on the internet and is required for your device to communicate with websites), hardware model, operating system and version, software, preferred language, serial numbers, device motion information, mobile network information and location data.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We also collect server logs, which include information such as dates and times of access, the app features or pages you view, app crashes and other system activity, and the third party site or service you were using immediately before visiting our site.'
                    ),
                    _react2.default.createElement(
                        'h5',
                        { id: 'cookie-policy' },
                        'Information we get via Cookies'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        '\'Cookies\' are small text files stored in your web browser that enable us to recognise your computer when you visit one of our websites.  Cookies are essential to keep certain parts of our websites functioning correctly and securely.  We also use them to make things quicker, easier and more personal to you, and to help us understand how our websites are used.  They can also be used to present you with more tailored advertising content. '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'To do all of these things, cookies collect some personal information about you whenever you use our websites.  You can choose whether to accept or reject some or all types of cookies and control this through your device\'s browser settings.  We will make you aware of this by showing you our cookie banner when you visit our site.  ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'If you then continue to use our websites without adjusting your browser settings, we will use cookies as set out in the sections below'
                        ),
                        ', so to help you make an informed choice it\'s important to know why we use the different types of cookie and what that means for your online experience.  This section provides you with a summary of the main points and tells you how switching off the different types of cookie will affect your experience on our websites.'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'The cookies we use fall into the following categories:'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Strictly Necessary cookies: Making our websites work:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'These Cookies are essential so that you can move around the sites and log in to the secure areas. They also enable us to deliver content in a way that works for your device.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Without these cookies'
                        ),
                        ' you would be unable to place bets, play games or access your account so if you opt out of receiving these cookies, parts of our site will not work correctly and may not work at all.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'A few examples of the ways in which we use strictly necessary cookies:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'Allowing you to navigate smoothly through our websites;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Showing content in the best format for your device or browser and positioning it for your screen;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'keeping you logged in during your visit so that you don\'t have to log in on every one of our websites each time you visit;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Enabling you to stream content without having to repeatedly adjust volume and viewing settings.'
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        { id: 'cookies-for-fraud' },
                        'Cookies for Fraud and money laundering prevention and identifying unfair use of our services:'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'As a betting and gaming company we have certain ',
                        _react2.default.createElement(
                            'a',
                            { href: '#legal-and-regulatory-requirements' },
                            'legal obligations'
                        ),
                        ' we need to abide by.  One of those rules is that we must do everything we can to prevent fraud and money laundering.  These Cookies help us to protect our customers and our business by ensuring that customers are genuine, haven\'t registered more than once, and are not fraudulently trying to access accounts that don\'t belong to them.  They also help us to recognise behaviour that may indicate fraud, money laundering, other illegal activities or breaches of our terms and conditions. We use the \'iesnare\' cookie for these purposes. '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Without these cookies'
                        ),
                        ' you will be unable to use our websites.  If you do not wish to accept this type of cookie, your option will be to close your account and not use our services.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Functionality cookies: Enabling the features of the website:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'These Cookies allow our websites to remember choices you have made, such as your user name, your region or the selections you have placed on your bet slip.  They help us keep you logged into your account as you navigate around our websites, and enable you to use certain features such as resetting your PIN or user ID.  We also use them to personalise your experience by, for example, showing more relevant price boosts based on your previous activity, giving you access to information provided by social media websites such as Twitter, or to show you \'related article\' links relevant to information you\'re looking at. '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Without these cookies'
                        ),
                        ' you will still be able to use the site but may experience difficulty using certain features, and will need to keep logging in as you navigate around our sites.  You will not see content (including price boosts) that is relevant to you.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Analytical cookies - Monitoring the performance of our websites:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'These Cookies collect information about how people use our websites and how the sites are performing, e.g. how many people visit, which pages are most popular and whether and where people see error messages.  They also ensure we can pay our marketing partners correctly for users they refer to us.  A few examples of the ways in which we use Analytical cookies:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'to identify trends about how people use our website;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'to help us keep our content relevant and up to date;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'to count the number of times a page or email has been viewed and allow us to measure the effectiveness of our content and communication; and'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'to improve the functioning of our applications and websites.'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Without these cookies'
                        ),
                        ' you will still be able to use and enjoy all the online features of our websites'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Targeting Cookies - Marketing & advertising:'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'These cookies are used to deliver adverts and content that are more relevant to you as well as to limit the number of times you see a particular advertisement and to measure the effectiveness of advertising campaigns. The Cookies remember that you have visited a website, and we share this information with other organisations for advertising purposes.  We also use them to test and improve our products and services by, for example, testing out different product experiences with different groups of customers to see which is most popular'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Without these cookies'
                        ),
                        ':  You will be able to use and enjoy all the features of our websites but the adverts you see will not be tailored to your interests'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Tracking Cookies: Online Behavioural Advertising'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'We use cookies placed by third parties to collect personal information about your browsing activity, which they then group with data about what other people with similar interests in similar demographic groups are looking at.  The resulting information is used to show you online adverts based on those interests (this is known as \'online behavioural advertising\').  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We use a cookie placed by a company called Lotame to collect non-personal data that is used for online behavioural advertising. To opt out of the collection and use of data by Lotame in your browser (including a mobile browser if you have enabled third-party cookies), you can ',
                        _react2.default.createElement(
                            'a',
                            { href: 'https://www.lotame.com/about-lotame/privacy/opt-out/', target: '_blank' },
                            'click here'
                        ),
                        ' and follow the instructions provided.  ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Your opt-out choice is applied only to the browser from which you make the choice'
                        ),
                        ', so if you use different browsers you will need to opt out in each one.  This opt-out is cookie based, so if you delete your cookies, you will no longer be opted out and will need to opt out again.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In Germany, our Skybet.de website uses third party cookies from a company called Exactag, from which you can opt out ',
                        _react2.default.createElement(
                            'a',
                            { href: 'https://www.exactag.com/datenschutz/', target: '_blank' },
                            'here'
                        ),
                        ', and Google Analytics, from which you can opt out ',
                        _react2.default.createElement(
                            'a',
                            { href: '#FIXME!' },
                            'here'
                        ),
                        '  Again, these two opt outs are cookie-based.  Skybet.de also uses the following third party tracking cookies, all of which you can control through your browser settings: Silverpop (now IBM Digital Marketing), Fabric Engine, DoubleClick, Google Tag Manager, Income Access and Urban Airship.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Without these cookies'
                        ),
                        ':  you will still be able to use and enjoy the features of our websites and you will still be presented with advertising but it is unlikely to be relevant to you. '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you would like to find out more information about Online Behavioural Advertising and the choices you have, the following websites are helpful:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'http://www.youronlinechoices.com/uk/', target: '_blank' },
                                'Your Online Choices'
                            ),
                            '- Provides information and allows you to choose not to receive behavioural advertising from the majority of the advertising networks.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'https://www.networkadvertising.org/', target: '_blank' },
                                'Network Advertising Initiative (NAI)'
                            ),
                            '- Please see the "opt-out" page. This allows you to opt-out of behavioural advertising from each of the ad networks represented by the NAI.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'http://www.edaa.eu/', target: '_blank' },
                                'European Digital Advertising Alliance'
                            ),
                            '- Please see the Online Behavioural Advertising Choices page.'
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Controlling my cookies'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'All modern browsers allow you to see what cookies you have, and to clear them individually or in their entirety by changing your cookie settings.  Cookie settings are typically found in the \'options\' or \'preferences\' menu of your browser, otherwise you should use the \'Help\' option in your browser for more details.  You may also find the links below helpful:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'http://www.aboutcookies.org/', target: '_blank' },
                                'aboutcookies.org'
                            ),
                            ' (contains information about cookies on a wide variety of desktop browsers.)'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies', target: '_blank' },
                                'Cookie settings in Internet Explorer'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences', target: '_blank' },
                                'Cookie settings in Firefox'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=en', target: '_blank' },
                                'Cookie settings in Chrome'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'https://support.apple.com/kb/ph21411?locale=en_US', target: '_blank' },
                                'Cookie settings in Safari'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: 'https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies', target: '_blank' },
                                'Cookie settings in Edge'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'h5',
                        { id: 'information-we-get' },
                        'Information we get from external companies'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'To help us comply with our ',
                        _react2.default.createElement(
                            'a',
                            { href: '#legal-and-regulatory-requirements' },
                            'legal and regulatory obligations'
                        ),
                        ', when you open your account we obtain information (in the UK and Germany) from a Credit Reference Agency called CallCredit and, in the UK, from GB Group plc. This does not involve data about your credit standing or \'credit score\'.  If you are SkyBet Italia customer, we check your details through a portal provided by the ADM (Agenzia delle Dogane e dei Monopoli).   '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Sometimes we need to undertake additional checks to verify information or, once an account is active, to investigate activity that could indicate a risk.  To do this we use organisations and databases (such as Iovation Ltd) which collate information and make it commercially available for use in crime prevention and detection, the promotion of responsible gambling and ensuring the fair use of services.  We also look at publicly available information to verify things like occupation status or property ownership, and at social media.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Where a UK customer self-excludes through the \'Gamstop\' national self-exclusion scheme, we will receive a notification of this, which we will use to apply their chosen restriction across our sites and apps.  To help us in our ',
                        _react2.default.createElement(
                            'a',
                            { href: '#legal-and-regulatory-requirements' },
                            'commitment to responsible gambling'
                        ),
                        ', we aim to understand the factors that can lead people to self-exclude or indicate the early stages of problem gambling.  We look at information about customers who have self-excluded (such as age group, location and past betting behaviour)  to identify common factors and this helps us to provide better and earlier support for customers who may be at risk of problem gambling.  We may in future subscribe to similar national self-exclusion schemes in any of the countries in which we operate, and we will update this policy to let you know.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Like many companies, from time to time we may supplement the information we hold about you with data from companies such as Experian or in the UK, the Royal Mail, that collate and update address and household information from a range of sources and make it commercially available.  This helps us keep our records up to date, fill gaps in our data and learn more about our customers so we can continue to improve our products and services.  We will only work with reputable organisations that obtain their data legally in accordance with data protection law.    '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Occasionally, we obtain lists of potential customers from companies that collate these details and make them commercially available for marketing purposes.  We only deal with reputable companies that take privacy as seriously as we do and have obtained your consent to share this data with us or companies in our sector for marketing, and you will always be able to opt out of receiving further marketing from us.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If we acquire another business, we will usually obtain customer information as part of the handover process.  In this case, we or the other company will let you know that your personal information is changing hands, provide you with a copy of this privacy policy after completion of the acquisition, and explain what to do if you do not wish your information to change hands.'
                    ),
                    _react2.default.createElement(
                        'h5',
                        { id: 'publicly-available-info' },
                        'Publicly available information '
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'As a betting and gaming company we must comply with ',
                        _react2.default.createElement(
                            'a',
                            { href: '#meeting-our-obligations' },
                            'legal obligations'
                        ),
                        ' to promote responsible gambling, consider our customers\' financial ability to gamble, and prevent our products and services being misused or used for ',
                        _react2.default.createElement(
                            'a',
                            { href: '#meeting-our-obligations' },
                            'illegal purposes'
                        ),
                        '.   If we observe account activity that could present a risk, or believe you have given false information, we will look at publically available information about you such as your Facebook or other social media pages, property ownership details, the electoral roll, company annual returns for places you have worked, industry bodies of which you may be a member, and insolvency registers.  Although this information is public, we remain mindful of your privacy and use it only as and where necessary for carrying out these checks.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you would like to know more about gambling regulation and the obligations it places on companies like SB&G, you can find out more on the ',
                        _react2.default.createElement(
                            'a',
                            { href: 'http://www.gamblingcommission.gov.uk/Home.aspx', target: '_blank' },
                            'Gambling Commission website'
                        ),
                        ' for the UK, the ',
                        _react2.default.createElement(
                            'a',
                            { href: 'http://www.mga.org.mt/', target: '_blank' },
                            'Malta Gaming Authority'
                        ),
                        ' for Germany or the ',
                        _react2.default.createElement(
                            'a',
                            { href: 'https://www.agenziadoganemonopoli.gov.it/portale/', target: '_blank' },
                            'AAMS'
                        ),
                        ' for Italy'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Information we get from social media'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you raise a query or a complaint through the Sky Betting and Gaming Facebook or Twitter pages, we will of course have a record of your user name and will use this to talk to you to resolve the matter you\'ve raised and keep accurate records of how it was resolved.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We look at information on your Facebook or other public social media pages when carrying out checks to comply with our ',
                        _react2.default.createElement(
                            'a',
                            { href: '#publicly-available-info' },
                            'legal and regulatory obligations'
                        ),
                        '. This helps us to verify information you have given us and ensure our products are being used legally and responsibly.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We use information posted publicly on social media sites to help us understand how our customers interact with us.  For example, we might look at which groups of customers are more likely to contact us via social media or to use social media to talk about our products and services.  We do this in a way that does not identify individual customers.  '
                    ),
                    _react2.default.createElement(
                        'h4',
                        { id: 'how-and-why-we-use-your-personal-info' },
                        'How and why we use your personal information'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'We use the information we hold about you in a range of different ways, which fall into these broad categories:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'Things we need to do ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'in order to provide you with the products or services you\'ve requested'
                            ),
                            ' '
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Things we need to do ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'to meet legal or regulatory obligations'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Things that enable us ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'to run our business effectively and efficiently'
                            ),
                            ', and '
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Things we do ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'with your consent'
                            ),
                            ' for marketing purposes'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We\'re telling you this because data protection law gives you rights over your personal data, which differ according to which of these categories it falls into.  This section explains more about each category, the rights it gives you, how to exercise them and what that means in practice.'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Providing our products and services'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'There are certain things we have to do in order to be able to provide you with our products and services.  As you would expect, we use your personal information to enable you to use our sites, to set up your account  respond to queries, contact you about bets you have placed or games played and provide you with the best possible level of customer service.   We use technical information about your device, such as operating system, browser version and location to present you with the correct version of our website or app and keep it functioning securely and correctly.   '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Like most organisations, to provide our products and services we share your information with external organisations working on our behalf.  You can find out more about this ',
                        _react2.default.createElement(
                            'a',
                            { href: '#sharing-your-information' },
                            'here'
                        ),
                        ' '
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Privacy Rights: Can I opt out of having any of my data used in this way?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'This category covers everything that is essential in order for us to provide you with the service(s) you use or sign up for. If you don\'t want your data used in this way your option is to not use our services and close your account.'
                    ),
                    _react2.default.createElement(
                        'h4',
                        { id: 'meeting-our-obligations' },
                        'Meeting our Obligations '
                    ),
                    _react2.default.createElement(
                        'h5',
                        { id: 'legal-and-regulatory-requirements' },
                        'Legal and Regulatory Requirements'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We need to comply with a range of legal and regulatory requirements, some of which involve the use of personal information and/or set out timescales for which we need to keep that information.  As a provider of betting and gaming services, we are regulated by the ',
                        _react2.default.createElement(
                            'a',
                            { href: 'http://www.gamblingcommission.gov.uk/Home.aspx', target: '_blank' },
                            'UK Gambling Commission'
                        ),
                        ' and, outside Great Britain, by the Alderney ',
                        _react2.default.createElement(
                            'a',
                            { href: 'https://www.gamblingcontrol.org/', target: '_blank' },
                            'Gambling Control Commission'
                        ),
                        '.  In Germany, operate with a Maltese License issued by the Maltese Gaming Authority and we comply with German regulations where applicable, and in Italy we are regulated by the ',
                        _react2.default.createElement(
                            'a',
                            { href: 'https://www.agenziadoganemonopoli.gov.it/portale/', target: '_blank' },
                            'AAMS'
                        ),
                        '. To comply with their requirements, we carry out checks during account opening and throughout the life of account to ensure our customers bet and play responsibly and legally.   Free-to-play games on SkyGames are not regulated in this way, although we do carry out age verification checks to ensure players are over 18.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'We take our social responsibility and our ',
                        _react2.default.createElement(
                            'a',
                            { href: '#legal-and-regulatory-requirements' },
                            'commitment to responsible gambling'
                        ),
                        ' very seriously and we actively look for behaviour that may indicate that someone is at risk of problem gambling so that we can intervene at an early stage to provide them with support and direct them to sources of help.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Where a UK customer self-excludes through the \'Gamstop\' national self-exclusion scheme, we will receive a notification of this, which we will use to apply their chosen restriction across our sites and apps.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'To help us understand the factors that can indicate the early stages of problem gambling, we look at information about customers who have self-excluded (either directly or through Gamstop), such as age, location and past betting behaviour,  to identify common factors.  This helps us intervene earlier in cases where customers may be at risk of problem gambling, and provide them with better support. '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We are also subject to laws and regulations relating to other aspects of our business, such as payment processing or complaint handling and some of these too involve the use of, or set timescales for holding, your personal information.'
                    ),
                    _react2.default.createElement(
                        'h5',
                        { id: 'fraud-money-laundering' },
                        'Fraud, Money Laundering and Other Illegal Activity'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'When you set up an account with us, place bets or play our games (other than free-to-play games on Sky Games), we carry out identity verification, fraud prevention and anti-money laundering checks, validating the information you give against ',
                        _react2.default.createElement(
                            'a',
                            { href: '#information-we-get' },
                            'third party crime prevention databases'
                        ),
                        ' and, where necessary, information from ',
                        _react2.default.createElement(
                            'a',
                            { href: '#publicly-available-info' },
                            'publicly-available sources'
                        ),
                        '.  We share your personal data with organisations that verify details and transactions and identify potential indicators of illegal activity, which they make available to other organisations using their services.  Where necessary, we share your data with Credit Reference Agencies or fraud prevention agencies, which keep a record of that information and make it available to other organisations for use in credit decisions, identification checks and fraud detection and prevention.  Where appropriate, we pass information to the police and other law enforcement agencies, debt recovery companies and other similar bodies. '
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'It is important that Betting and Gaming operators work together to prevent illegal activity and promote responsible gaming.  In the UK, our industry is working with the Gambling Anti-Money Laundering Group, the Gambling Commission and the UK Information Commissioner\'s Office to establish a framework for sharing information between providers for this purpose.   Where we believe it appropriate and necessary to do so to prevent money laundering and fraud, we will share information with, and receive information from, other betting and gaming providers.  We will always do this in legally and in line with any industry guidelines. '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you are a Sky Games customer, we carry out age verification checks using publicly available information but we don\'t carry out full identity, fraud prevention and anti-money laundering checks unless you later upgrade your account to use our pay-to-play products.'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'As well as fraud and money laundering, we carry out ongoing monitoring to ensure that our products and services are not used for other ',
                        _react2.default.createElement(
                            'a',
                            { href: 'https://support.skybet.com/app/answers/detail/a_id/40', target: '_blank' },
                            'Illegal purposes'
                        ),
                        ' such as event manipulation, "match-rigging" or other forms of cheating.   We do this in a variety of ways, including the ',
                        _react2.default.createElement(
                            'a',
                            { href: '#cookies-for-fraud' },
                            'use of cookies'
                        ),
                        ', and where we find transactions, data or behaviour that could indicate illegal activity we share information with third parties, including the European Sports Security Association (ESSA) and the police'
                    ),
                    _react2.default.createElement(
                        'h4',
                        null,
                        'Privacy Rights: Can I object to having my personal information used in this way?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'This category covers  activities we are obliged to do in order to provide our products and services legally, responsibly, and in line with the requirements of our regulators, and ultimately to protect our customers and our business.   We cannot provide you with our products and services without carrying out these activities, and if you don\'t want your data used in this way your option is to not use our services and close your account '
                    ),
                    _react2.default.createElement(
                        'h5',
                        { id: 'running-our-business' },
                        'Running our business effectively and efficiently '
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'There are some things we do to help us operate as a commercial organisation.  We have a legitimate interest in carrying out these activities, and where they involve using your personal information we are careful to carry them out in a way that minimises any impact on your privacy.   Data protection law gives you the \'',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'right of objection'
                        ),
                        '\' to the activities in this category ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'if your right to privacy outweighs our legitimate business interest'
                        ),
                        ' in doing them.  You always have the option to exercise this right but, as we explain in more detail below, the activities involved are central to our business, ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'so if you wish to do so it will usually mean you need to close your account'
                        ),
                        '.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Please read this section carefully and ensure you are happy with it before providing us with your personal information'
                        ),
                        '.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Business Insights '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We carry out basic analytics to help us understand, how, when, where and why our customers use our services, and how our business is performing.  This helps us monitor and plan everything from the effectiveness of our advertising through to ensuring we have enough staff available to handle queries at peak times.  It also gives us a much clearer picture of our customers generally, the broad demographic groups they fit into (e.g. age group, gender, location, etc.) and the products and services they use, which in turn helps us to develop better and more relevant features, products and services.  We do this analysis in a way that does not identify individual customers, so there is no impact on the privacy of any one person.'
                    ),
                    _react2.default.createElement(
                        'h7',
                        null,
                        'Privacy Rights: Can I object to having my personal information used in this way?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Like any business, we need to keep a close eye on how our business is performing and whether we\'re meeting the needs of our customers.  As we do this in a way that does not identify you as an individual, there is no impact on your privacy.   If you don\'t want your data used in this way your option is to not use our services and close your account.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        { id: 'giving-you-a-more-personal-experience' },
                        'Giving you a more personal experience'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Whichever SBG products or services you use, wherever and however you interact with us, we want to give you the same great level of service and make it personal to you.  We will tailor your experience, personalising the layout and content of our sites according to what we know about you, your preferences and the way you like to play or bet.  For example, we will present you with features we know you have used or think you are likely to use, show you the type of score card or bet slip that best suits your style of betting, remind you to deposit funds when your account is running low and personalise search results to show more relevant results first.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We also look at aggregated (non-identifiable) data showing how our customers use our products and features and which games they tend to enjoy.  We use this information to suggest games we think you\'ll enjoy because they are popular with others who play the same games as you'
                    ),
                    _react2.default.createElement(
                        'h7',
                        null,
                        'Privacy Rights: Can I object to having my personal information used in this way?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We believe this personalised experience makes betting and gaming better and we want to give you the best customer experience we can.  Using your personal data in this way enables us to do that in a way that we believe does not have an impact on your privacy.  If you don\'t want your data used in this way your option is to not use our services and to close your account   '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Please note that some aspects of your customer experience are provided via cookies.  If you have enabled cookies in your browser, we will personalise certain aspects of our site, such as remembering your user name and location, and you can control this via your browser settings.  You can learn more about how to control this ',
                        _react2.default.createElement(
                            'a',
                            { href: '#information-we-get' },
                            'here'
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        { id: 'protecting-our-commercial' },
                        'Protecting our commercial interests'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'Most people use our products and services fairly, but we carry out monitoring of how our customers bet, play and interact with our products and services, to identify behaviour that is not in line with our ',
                        _react2.default.createElement(
                            'a',
                            { href: '#protecting-our-commercial' },
                            'Terms and Conditions'
                        ),
                        ' or that could be prejudicial to our commercial interests.  To help us do this, we receive information from tools and databases which collate information about customer behaviour across the industry and share it with betting and gaming operators for this purpose.  We use services provided by Iovation Ltd., and may also use others including (in the UK) CIFAS.  Although we obtain information from these sources, we do not allow the information we provide to them to be used by other operators for this purpose.'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'At our discretion, we have the right to use this information in making decisions about whether to place restrictions on people\'s accounts or, on very rare occasions, to close their accounts.   We take this very seriously, and consider a wide variety of factors in making such a decision, taking into the information we hold about you as well as any information obtained from industry data bases.  Please note that we do not use cookies to obtain information for this purpose, and the decision to restrict or close an account is always made with human intervention; it is never wholly automated. '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Privacy Rights: Can I object to having my personal information used in this way?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'As a business, we have a legitimate interest in protecting our commercial interests against deliberate misuse, and we are confident that we do it in a way that is proportionate to the risks we face and has minimal impact on your privacy.  If you don\'t want your data used in this way your option is to not use our services and to close your account'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Market Research '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We will occasionally invite you to give feedback on SB&G services you have used or to take part in customer surveys, questionnaires or focus groups.  We will contact you online or via email, directly or through a third party organisation acting on our behalf.  Taking part in research is always voluntary, and where we use a third party we do not pass over any details (other than your contact details so they can send you the initial request or invitation) unless and until we have your consent to do so.'
                    ),
                    _react2.default.createElement(
                        'h7',
                        null,
                        'Privacy Rights: Can I object to having my personal information used in this way?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'It\'s really important for any business to find out what its customers think.  As we are careful to limit the number and frequency of feedback/research requests we send to any one person, and you can always decline to take part, there is no adverse impact on your privacy and you cannot opt out of receiving these very occasional requests. '
                    ),
                    _react2.default.createElement(
                        'h5',
                        { id: 'things-we-do-with-your-consent-marketing' },
                        'Things we do with your consent: Marketing'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We will send you offers and information only if you have given your consent for us to do so, in which case we will contact you via email, post, SMS or online about any of our group products and services.  ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'We never share your data with companies outside our group for them to use for their own marketing'
                        ),
                        '.   From time to time, we may team up with a third party to bring you details of a product or service we think might interest you, but where we do this the contact will come from us - we will never pass your details to the third party without your prior consent.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Please be assured that we do not use any sensitive information we hold about you (for example, information about self-exclusion, health or ethnicity) for marketing-related purposes.'
                    ),
                    _react2.default.createElement(
                        'h7',
                        { id: 'keeping-it-relevant' },
                        'Keeping it Relevant '
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'At SBG we want to make betting and gaming better for you, so we want to be able to tell you about products, services and features that ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'you'
                        ),
                        ' will find exciting and relevant, and we tailor the offers and information we send to suit ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'you'
                        ),
                        '.  To do this, we look at what we know about you - such as your age, location and gender, your browsing, betting and gaming history and patterns, your social media usage and how you interact with us - and we use it to build up a picture of you that helps us decide what you\'re most likely to want to hear about. (This is sometimes known as \'Profiling\').   We also combine this with information we\'ve obtained from publicly or commercially available sources about the things people with similar characteristics to you (in terms of age, gender, location etc.) tend to be interested in so we can fine-tune the offers we present to you.  '
                    ),
                    _react2.default.createElement(
                        'h7',
                        { id: 'putting-you-in-control' },
                        'Putting you in Control'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'We firmly believe our customers prefer offers and information that are relevant to them and their interests over general adverts, so we tailor ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'all'
                        ),
                        ' our marketing using this picture we\'ve built up of you.  We think this makes our marketing better both for you and for us.  However, data protection law gives you the right to opt out of having your personal data used to build up this type of picture and predict what you might be interested in, so ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'you can opt out at any time'
                        ),
                        '.  As we explain above, ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'all our marketing is tailored to you in this way, so to opt out of this type of personalisation you will need to opt out of receiving all direct marketing from us'
                        ),
                        '.  You can do this when you sign up, by not ticking the box to opt in to marketing, or at any later point via your online account, and SkyBet customers in Italy and Germany can also do this via their online preference centre.  We won\'t then send you offers and information by post, email or SMS ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'but we will continue to personalise your online experience based on the picture we\'ve built up of you'
                        ),
                        '.  This means you\'ll continue to benefit from a more personalised look and feel on our websites and apps, and will still see the following:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        { className: 'important-policy no-margin' },
                        _react2.default.createElement(
                            'li',
                            null,
                            'Targeted pop-ups telling you about products, services and offers we think you\'ll like'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Bespoke offers relevant to you, communicated through pop-ups or other on-site content '
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'On-site (including in-game) recommendations for games you have played or might enjoy'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Targeted messages on social media platforms such as Facebook or Twitter (which you can control easily through your privacy settings on each individual platform) and in other places on the internet that support targeted advertising.'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'We think this strikes the best balance: it lets you opt out of receiving marketing through offline channels (post, email and SMS) while still enjoying the best online and in-game experience and without having to miss out on boosts, bonuses and other benefits.  ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'However, if you prefer not to receive any personalised messages or offers online you can opt out by out by editing your account details via your online account'
                        ),
                        '.  If you do opt out  you will experience a less personal look and feel on our sites and apps and won\'t get to hear about bespoke offers and bonuses, but don\'t worry - we will continue to ',
                        _react2.default.createElement(
                            'a',
                            { href: '#giving-you-a-more-personal-experience' },
                            'personalise'
                        ),
                        ' those aspects of your online experience that are not marketing-related so, for example, you will still see games you recently played.  Please also note the following:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'We will still make onsite recommendations for games you might enjoy.  We base these on how ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'our customers as a whole'
                            ),
                            ' tend to use our sites and features, not on information about you as in individual.'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Some personalised banner adverts on our sites are controlled separately through cookies, so ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'you will also need to adjust your browser\'s ',
                                _react2.default.createElement(
                                    'a',
                                    { href: '#information-we-get' },
                                    'cookie settings'
                                )
                            ),
                            ' or you will continue to see them. '
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'You may still see our adverts on ',
                            _react2.default.createElement(
                                'a',
                                { href: '#online-banner-adverts' },
                                'other websites'
                            ),
                            ' or social media platforms you visit, but these will not be specifically targeted at you. '
                        )
                    ),
                    _react2.default.createElement(
                        'h7',
                        null,
                        'Marketing: Keeping it relevant and putting you in control - At a Glance:'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'All our marketing is tailored to be more relevant and interesting to you, so if you\'re:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        { className: 'important-policy' },
                        _react2.default.createElement(
                            'li',
                            null,
                            'Happy to receive personalised offers and information by email, post, SMS and online. Make sure you ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'opt in to direct marketing'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Happy to see personalised offers and information when you\'re online but ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'don\'t'
                            ),
                            ' want to receive them by email, post or SMS - you need to ',
                            _react2.default.createElement(
                                'a',
                                { href: '#privacy-rights-can-i-opt-out-of-marketing' },
                                'opt out of direct marketing'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'strong',
                                null,
                                'Not'
                            ),
                            ' happy to see personalised offers and information online or by e-mail, post or SMS - be sure ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'to opt out of personalised marketing and adjust your cookie settings'
                            ),
                            ' to avoid receiving banner adverts'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Remember, you can change your mind at any time by updating your preferences in your account.'
                    ),
                    _react2.default.createElement(
                        'h7',
                        null,
                        'Upgrading from Free to Play:  marketing preferences'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you are a Free to Play member and you upgrade your account, your existing marketing preferences will continue to apply unless you change them.  You can do this easily at any time via your online account.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        { id: 'online-banner-adverts' },
                        'Online banner adverts: cookies'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you have enabled cookies in your browser you may receive banner adverts on our homepage, as these are cookie-based and not tailored using other information we hold about you.  As they are cookie-based you will receive them ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'even after you have opted out of personalised marketing'
                        ),
                        ', but you can control them easily via your ',
                        _react2.default.createElement(
                            'a',
                            { href: '#information-we-get' },
                            'browser settings'
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Advertising on Social Media'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'If you have given your consent to marketing, we will work with social media companies such as Facebook and Twitter to provide you with information about our products and services via their platforms.  If you do not wish to see these adverts, you can control this easily by disabling preference-based marketing in the privacy and ad settings on each individual platform.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Even if you have withdrawn your consent to personalised marketing by SBG, you might still see general adverts for SBG products and services on your social media feeds.  These will not be specifically targeted to you, and again, you can control this via the privacy and ad settings on each platform.  '
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Online Behavioural Advertising '
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'We use cookies placed by third parties to collect personal information about your browsing activity, which is then grouped with data about what other people with similar interests and characteristics (in terms of age, gender, location etc.) are looking at.  The combined information is used to show you online adverts based on those interests, either for our own products and services or those of a third party (this is known as \'Online behavioural Advertising\').  You can find out more about controlling this in our ',
                        _react2.default.createElement(
                            'a',
                            { href: '#information-we-get' },
                            'cookie policy section'
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Marketing on our apps: Push Messages'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'When using our apps, you will receive push messages.  These can be easily disabled through your phone or device\'s settings.  '
                    ),
                    _react2.default.createElement(
                        'h6',
                        { id: 'privacy-rights-can-i-opt-out-of-marketing' },
                        'Privacy Rights: Can I opt out of marketing?'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'Yes, you have the right to opt out of having your information used for direct marketing and the right to opt out of having it used to build up a picture of you so we can personalise our marketing to suit you. ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Please read the sections headed \'',
                            _react2.default.createElement(
                                'a',
                                { href: '#keeping-it-relevant' },
                                'Keeping it relevant'
                            ),
                            ' and ',
                            _react2.default.createElement(
                                'a',
                                { href: '#putting-you-in-control' },
                                'keeping you in control'
                            ),
                            '\''
                        ),
                        ', which explain how we use your personal data in our marketing, and how to control the marketing you see, and remember you can change your mind about receiving marketing material at any time via your online Sky Betting and Gaming account or, if you are a SkyBet Italia customer, through your online preference centre.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you wish to ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'opt out of e-mail marketing only'
                        ),
                        ', you can also do this by clicking on the link at the bottom of any email we have sent you.  To ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'opt out of receiving SMS messages'
                        ),
                        ' you can reply "STOP" to 57785, and you can disable our push notifications via your phone\'s settings.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'As our marketing campaigns are prepared well in advance, you are likely to continue to receive material for a short period of time after updating your preferences.    '
                    ),
                    _react2.default.createElement(
                        'h4',
                        null,
                        'More sensitive matters: how we use sensitive data'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'As a responsible provider of betting and gaming services, we do our best to ensure that our customers bet responsibly, and encourage you to make use of the ',
                        _react2.default.createElement(
                            'a',
                            { href: 'https://support.skybet.com/app/answers/detail/a_id/249/kw/exclude', target: '_blank' },
                            'range of tools'
                        ),
                        ' available to help you with this.  This means that on occasion you may provide us, directly or indirectly with information about your physical, psychological or emotional health or situation and talk to us about problems with gambling.  We appreciate the sensitivity of this information and use it only to provide you with the support you have asked for and to signpost you to the appropriate sources of help.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'To help us in our commitment to responsible gambling, it\'s important that we understand the factors that can lead people to self-exclude or may indicate the early stages of problem gambling.  Where a customer self-excludes, either directly or (in the UK) through the national Gamstop scheme, we look at demographic information about them (such as age group and location) and their past betting behaviour and transactions to help us identify common factors.  This in turn helps us to provide earlier and better support to customers who may be at risk of problem gambling.  As well as ensuring we do all we can to fulfil our regulatory obligations, it helps us to help our customers gamble responsibly. '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'On occasion, you may provide us, usually indirectly, with other sensitive information about yourself, such as your ethnicity or nationality (for example, identity verification documentation or checks can reveal this information).  It is rare for us to ask you for this type of information directly, and we will only do so if we have a specific and valid legal reason, which we will explain clearly at the time.   Where we do need to hold this type of sensitive information because it is shown in an identification document for example, we will do so only to comply with our legal or regulatory requirements and will not use or make it available for any other purpose.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Where you provide us with details of, or a copy of, your passport, driving licence, national identity card, code fiscal (in Italy), or other national identification documentation, we use it only for identification and verification purposes required to fulfil our legal and regulatory requirements.'
                    ),
                    _react2.default.createElement(
                        'h4',
                        { id: 'sharing-your-information' },
                        'Sharing Your Information '
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Companies that provide services on our behalf'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'We share your personal information with external organisations that carry out a range of services on behalf of SB&G.  We carry out checks to ensure that the companies we work with will give your information the same level of care and protection as we do.  Both we and they are obliged to handle your information in accordance with data protection law, and we are also required to put in place contractual measures reinforcing those obligations.    '
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'The main functions that are or may be carried out, fully or in part, by third parties are listed below:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'Account set-up and registration '
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Management and execution of marketing campaigns'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Printing '
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Customer services'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Payment processing and verification'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'a',
                                { href: '#fraud-money-laundering' },
                                'Anti-fraud and money laundering checks and ID verification'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Checks to detect unfair use of our products and services'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Web hosting, online content services and data storage'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Management of competitions, contests and offers'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Data analytics and data cleansing'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Market research and collecting or analysing customer feedback'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'IT services and support '
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Audit, Legal & Compliance related services'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In Germany, Skybet uses a gaming platform and technical services provided by SBTech Malta an (d other significant third party providers include Amazon Web Services, which provides data warehousing, and SafeCharge, which provides payment processing.  '
                    ),
                    _react2.default.createElement(
                        'h7',
                        null,
                        'Sharing information with Credit and Fraud-Prevention Agencies'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'For ID verification and the prevention of fraud, money laundering and other illegal use of our pay-to-play services, we use commercially-available tools or services provided by Credit Reference and Fraud Prevention Agencies and services: Iovation Ltd (in the UK, Germany and Itay), CallCredit (in the UK and Germany), and GB Group (in the UK). These agencies/services keep a record of the information we and other companies provide and make it available for use by other organisations carrying out identification checks and fraud prevention.  In order to provide this essential service, these agencies/services are \'data controllers\' for the purposes of data protection law, which means they own and control the information we and their other subscribers provide to them.  As \'data controllers\', they are obliged to comply with data protection law and can use the information shared with them only to provide these checks.  We cannot provide our products and services without carrying out these essential checks by sharing your data in this way, so it is important that we make you aware of it from the outset, and for this reason we bring it to your attention in \'Fraud, Money Laundering and Other Illegal Activity\' above. ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'If you are not happy for us to pass your information to credit and fraud prevention agencies, you will not be able to open an account and use our pay-to-play products and services'
                        ),
                        '.'
                    ),
                    _react2.default.createElement(
                        'h7',
                        null,
                        'Sending Personal Information outside Europe'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'Some of the third party providers we use are based in, or carry out their activities in, countries outside the European Economic Area (EEA), which is made up of the EU Member states plus certain countries considered to offer a standard of data protection equivalent to that of Europe.  Where this means personal information is transferred outside the EEA, we have to put in place additional legal protections on top of our standard checks and measures, to ensure it receives the same level of protection as it would within Europe.  We do this by using standardised contractual clauses (sometimes called \'the EU Model Clauses\') approved by the European Commission and European privacy regulators, although there are alternative approved legal mechanisms which we can decide to use instead.  Where necessary, we also put in place any additional contractual measures required by local law in any of the countries in which we operate, except where they conflict with the General European Data Protection Regulation.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you would like to know more about the EU \'Model Clauses\' or the other measures organisations like SB&G can use when transferring personal data overseas, you can find information ',
                        _react2.default.createElement(
                            'a',
                            { href: 'http://europa.eu/', target: '_blank' },
                            'here'
                        )
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Other circumstances in which we share your personal data'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Apart from the functions set out above, we do not share your personal information with third parties except where we are compelled or permitted by law to do so.   These circumstances are rare, but may require us to share information with the police or other law enforcement agencies, the courts, statutory authorities (e.g. in connection with tax matters) and sporting bodies (in connection with sporting integrity issues) in any of the countries in which we operate.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Where necessary to protect or defend our rights and interests, resolve disputes or enforce our agreements, we will share personal data with our regulators, external legal advisors and debt recovery and tracing agencies, although again these circumstances are rare.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'As we\'re a group we may sometimes need to share your information within our group for any of the purposes outlined in this policy, but we only do this if it\'s strictly necessary for one of those purposes and where the law permits us to do so.   '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If ownership of all or part of our business changes or we undergo a reorganisation or restructure, we will transfer your personal information to the new owner or successor company so we or they can continue to provide the services you have requested.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Whenever we share personal information, and whatever the reason or circumstances, we will always do so legally and with due regard to your privacy.  If we receive a request from law enforcement or other statutory bodies, we do not disclose personal information without a warrant, court order or other legally valid proof of authority.'
                    ),
                    _react2.default.createElement(
                        'h4',
                        { id: 'how-long-do-we-keep-your-information' },
                        'How long do we keep your information?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We hold your personal information only as long as we have a valid legal reason to do so, which includes providing you with the services you have requested, meeting our legal and regulatory obligations, resolving disputes and enforcing our agreements.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The length of time for which we keep different types of personal information can vary, depending on why we originally obtained them, the reason we process them and the legal requirements that apply to ',
                        _react2.default.createElement(
                            'a',
                            { href: '#how-and-why-we-use-your-personal-info' },
                            'them'
                        ),
                        '.  When setting our data retention and deletion timescales we take into account a range of factors including applicable regulations and standards relating to gambling and gaming , anti-money laundering, taxation, payment processing and complaint handling, the need to prevent or detect crime or other misuse of our services, and audit requirements.  To fulfil our requirements, some of your personal data will need to be retained for a period of time after you cease to be a customer.  When we no longer need it to fulfil the above requirements, we delete it securely.   Where we wish to retain any information for analysis purposes, we first anonymise it to the standards approved by the UK Information Commissioner\'s Office, (which, as we are based in the UK, is our lead regulator on matters relating to Data protection) so that it can no longer be linked back to an individual.  ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Please note that if you opt out of receiving marketing from us, we will still need to keep your contact details in order to suppress them from future marketing activity'
                        ),
                        '.   '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Privacy Rights: How do I exercise my \'',
                        _react2.default.createElement(
                            'a',
                            { href: '#your-right-to-erasure' },
                            'right to be forgotten'
                        ),
                        '?\''
                    ),
                    _react2.default.createElement(
                        'h4',
                        null,
                        'Staying in control of your Personal information: Your Privacy rights'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We respect the fact that your personal information is your information so we want to be clear about what those rights mean in practice and how you can exercise them.  Please see \'',
                        _react2.default.createElement(
                            'a',
                            { href: '#things-we-do-with-your-consent-marketing' },
                            'how and why we use your data'
                        ),
                        '\' for more information about the purposes for which we process your information and the rights this gives you. '
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'The right to opt out of having your information used for marketing'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You can ',
                        _react2.default.createElement(
                            'a',
                            { href: '#privacy-rights-can-i-opt-out-of-marketing' },
                            'opt out of receiving marketing'
                        ),
                        ' at any time.  You also have the right to opt out of having your information used to create ',
                        _react2.default.createElement(
                            'a',
                            { href: '#things-we-do-with-your-consent-marketing' },
                            'a \'profile\' of you for marketing purposes'
                        ),
                        '.   '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We firmly believe that our customers prefer to receive offers and information that are relevant to them so we tailor all of our marketing to make it more interesting to our customers.  ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Please read the section \'',
                            _react2.default.createElement(
                                'a',
                                { href: '#keeping-it-relevant' },
                                'Keeping it relevant and putting you in control'
                            ),
                            '\''
                        ),
                        ' for more details.'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'The right to have any inaccuracies in your personal information corrected'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'You can update your personal details at any time via your online Sky Betting and Gaming account, ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'but please be aware that if you have an account with Oddschecker you will need to update your personal details with them directly'
                        ),
                        '.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Please help us to help you by keeping your contact details up to date and letting us know if you spot any errors in the information we hold about you.  If it is something you cannot correct yourself online, you should contact us at ',
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:support@skybettingandgaming.com' },
                            'support@skybettingandgaming.com'
                        ),
                        ' if you are in the UK, ',
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:info@skybet.it' },
                            'info@skybet.it'
                        ),
                        ' if you are a SkyBet Italia customer and ',
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:info@skybet.de' },
                            'info@skybet.de'
                        ),
                        ' if you are in Germany.  We\'ll update inaccuracies promptly, and within a month if you are requesting a more complex change.  If we take the decision not to make a change you have requested, we will explain why and make a note on your account to show that you requested the change.   If you disagree with our decision, you have the right to complain to the ',
                        _react2.default.createElement(
                            'a',
                            { href: '#right-to-complain' },
                            'privacy regulator'
                        )
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Your \'right of objection\' to certain activities'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'Data protection law gives you the right to express an ',
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:dp@skybettingandgaming.com' },
                            'objection'
                        ),
                        ' to activities detailed in the section entitled \'',
                        _react2.default.createElement(
                            'a',
                            { href: '#running-our-business' },
                            'Running our business effectively and efficiently'
                        ),
                        '\' ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'if you believe your privacy rights outweigh the legitimate interest we have as a business in doing those things.   Please read that section carefully before getting in touch with us and note that exercising your right of objection will usually mean you need to close your account and stop using our services'
                        ),
                        '.   If you disagree with our decision on this, you have the right to complain to the ',
                        _react2.default.createElement(
                            'a',
                            { href: '#right-to-complain' },
                            'privacy regulator'
                        ),
                        '.'
                    ),
                    _react2.default.createElement(
                        'h5',
                        { id: 'your-right-to-erasure' },
                        'Your Right to Erasure'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'People sometimes refer to this as ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'the \'right to be forgotten'
                        ),
                        '\'.  Under data protection law, you have the right to ',
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:dp@skybettingandgaming.com' },
                            'request erasure'
                        ),
                        ' of your personal data in the following circumstances:'
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'Where the courts or our regulators have found us to be processing it unlawfully;'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Where our original purpose for collecting the data has been completed and we have no other valid legal grounds for continuing to ',
                            _react2.default.createElement(
                                'a',
                                { href: '#how-long-do-we-keep-your-information' },
                                'hold it'
                            ),
                            ';'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Where you have withdrawn your ',
                            _react2.default.createElement(
                                'a',
                                { href: '#things-we-do-with-your-consent-marketing' },
                                'consent to marketing'
                            ),
                            ' and ',
                            _react2.default.createElement(
                                'a',
                                { href: '#things-we-do-with-your-consent-marketing' },
                                'personalised marketing'
                            ),
                            ' and asked us to delete the information we previously used for those purposes, in which case we will either delete it from our marketing systems or fully anonymise it, but note that ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'we will retain your contact details in order to prevent further marketing'
                            ),
                            '; '
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'Where you have successfully exercised your \'right to object\' to one of the activities in the section entitled \'',
                            _react2.default.createElement(
                                'a',
                                { href: '#running-our-business' },
                                'running our business effectively and efficiently'
                            ),
                            '\' and asked us to delete the information we used for that purpose.  As we explain in that section, ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'exercising your right to object will usually mean closing your account'
                            ),
                            ', and note that in most cases we will need to retain your information ',
                            _react2.default.createElement(
                                'a',
                                { href: '#how-long-do-we-keep-your-information' },
                                'for a period of time after your account is closed'
                            ),
                            '.  ',
                            _react2.default.createElement(
                                'strong',
                                null,
                                'We will not delete information as long as we still have a valid legal or regulatory reason to hold it, unless the courts or our regulators order us to do so'
                            ),
                            '.'
                        )
                    ),
                    _react2.default.createElement(
                        'h7',
                        null,
                        'How do I exercise this right?'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'Please read the sections entitled \'',
                            _react2.default.createElement(
                                'a',
                                { href: '#how-long-do-we-keep-your-information' },
                                'How long do we keep information'
                            ),
                            '\' and \'\'',
                            _react2.default.createElement(
                                'a',
                                { href: '#your-right-to-erasure' },
                                'your right to erasure'
                            ),
                            '\' carefully before contacting us'
                        ),
                        '.  If you still wish to exercise your right, you should contact us at ',
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:dp@skybettingandgaming.com' },
                            'dp@skybettingandgaming.com'
                        ),
                        ' and we will respond to your request within a month.  If we uphold your request and erase your data we will also notify any third parties to which the data has been passed, where we are able to do so, and tell you who they are.  If we do not uphold your request, we will tell you why.  If you disagree, you have the right to complain to the ',
                        _react2.default.createElement(
                            'a',
                            { href: '#right-to-complain' },
                            'privacy regulator'
                        ),
                        ' '
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'The right to access the data we hold about you'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you would like a copy of the personal information we hold about you, you should request it here. We will ask you to complete and return a form, which is not compulsory but helps us to help you by providing the information you are looking for.  Before we respond to your request, we will ask you for valid proof of identity and once we\'ve received it we will provide our response within one month.   If your request is unusually complex and likely to take longer than a month, we will let you know as soon as we can and tell you how long we think it will take.  '
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _react2.default.createElement(
                            'strong',
                            null,
                            'If you are also a customer of SportingLife or Oddschecker and require any information we hold about you there, please let us know this when you make your request.'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'We will fulfil requests wherever possible, but there are occasional situations in which local or European data protection law requires or permits us to withhold some information (such as where it would involve disclosing information about another person or information which is commercially sensitive), or permits us to make a small charge.  If either of these applies, we will explain this to you.'
                    ),
                    _react2.default.createElement(
                        'h7',
                        null,
                        'Your Right to \'Data Portability\''
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'The right to \'data portability\' aims to enable consumers to re-use some of their personal information online by making it available in a commonly-used, machine-readable format that can be passed to and used by other organisations.   This is a new initiative and it is not yet possible to \'port\' data directly between providers in the betting and gaming industry.  However, if you wish to exercise this right, you should submit your request ',
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:SAR@skybettingandgaming.com' },
                            'here'
                        ),
                        ', and we will provide you with the following information as a CSV file:  '
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'the personal and contact details held in your online account'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'your betting and gaming history'
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'A list of payments made and funds withdrawn'
                        )
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Before responding to your request, we will ask you to provide valid proof of identity, and we will provide our response within one month of receiving it.'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'In future, it may become possible to transfer (or \'port\') data directly between organisations.  In the meanwhile, if you would like to take your SBG data ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'to another provider'
                        ),
                        ' you should first check that your chosen provider is able to upload data from a CSV file before making your request as above and passing the file to the provider yourself.  If you would like to \'port\' your data ',
                        _react2.default.createElement(
                            'strong',
                            null,
                            'into SBG from another provider'
                        ),
                        ', you should first contact ',
                        _react2.default.createElement(
                            'a',
                            { href: 'mailto:SAR@skybettingandgaming.com' },
                            'SAR@skybettingandgaming.com'
                        ),
                        ' to see whether we can accommodate your request.  It is unlikely that we will be able to do so at the present time, but we will try to accommodate requests where we can. '
                    ),
                    _react2.default.createElement(
                        'h5',
                        { id: 'right-to-complain' },
                        'Your Right to Complain to the Regulator'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'important-policy' },
                        'If you believe your privacy rights have been infringed, or you disagree with a decision we have made about your privacy rights, you have the right to complain to the privacy regulator.  As we are based in the UK, our principal data protection regulator is the UK\'s ICO, but if you are in Germany, Italy or any other country in which we operate, you may prefer to initiate contact through the regulator in your country of residence: '
                    ),
                    _react2.default.createElement(
                        'ul',
                        null,
                        _react2.default.createElement(
                            'li',
                            null,
                            'In the UK, ICO ',
                            _react2.default.createElement(
                                'a',
                                { href: 'https://ico.org.uk/', target: '_blank' },
                                'https://ico.org.uk/'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'In Ireland, Data Protection Commissioner ',
                            _react2.default.createElement(
                                'a',
                                { href: 'https://www.dataprotection.ie/docs/Home/4.htm', target: '_blank' },
                                'https://www.dataprotection.ie/docs/Home/4.htm'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'In Germany: ',
                            _react2.default.createElement(
                                'a',
                                { href: 'https://www.bfdi.bund.de/DE/Home/home_node.html', target: '_blank' },
                                'https://www.bfdi.bund.de/DE/Home/home_node.html'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'In Italy: ',
                            _react2.default.createElement(
                                'a',
                                { href: 'http://www.garanteprivacy.it/home_en', target: '_blank' },
                                'http://www.garanteprivacy.it/home_en'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'In the Isle of Man: ',
                            _react2.default.createElement(
                                'a',
                                { href: 'mailto:ask@inforights.im' },
                                'ask@inforights.im'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'In Jersey and Guernsey: ',
                            _react2.default.createElement(
                                'a',
                                { href: 'mailto:enquiries@dataci.org' },
                                'enquiries@dataci.org'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            'In Gibraltar: ',
                            _react2.default.createElement(
                                'a',
                                { href: 'mailto:info@gra.gi' },
                                'info@gra.gi'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Links to Third Party Sites'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Sometimes our websites provide links from SBG sites to those of third parties.  These organisations and sites will have their own privacy policies which will not be the same as ours so when you visit one of these sites, check that you\'re happy with their privacy policy before providing them with any personal information.'
                    ),
                    _react2.default.createElement(
                        'h5',
                        null,
                        'Keeping your data secure'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'SB&G Security Accreditations'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'At SB&G we adhere to ISO27001 principles, we are Cyber Essentials Plus accredited and PCI compliant.'
                    ),
                    _react2.default.createElement(
                        'h6',
                        null,
                        'Your privacy and shared computers'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'If you log in to one of our websites from a shared computer, cookies may cause your e-mail address or user name to display in the login field to anyone who uses the site on that computer after you.  You can avoid this by clearing the Cookies stored by the web browser.  The option to do this is normally in the \'Tools\' dropdown menu at the top of the browser window.  If you have opted to stay logged in, remember that another person using the same device could access your account unless you log out.'
                    ),
                    _react2.default.createElement(
                        'h7',
                        null,
                        'Passwords and PINs'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Remember to keep your passwords and PINS secret, choose complex passwords, change them periodically and never use the same password or PIN on multiple websites.'
                    )
                ),
                _react2.default.createElement(
                    'footer',
                    { className: 'section-footer' },
                    _react2.default.createElement(
                        _reactRouter.Link,
                        { title: 'Previous Privacy Policy', to: '/privacy-previous' },
                        'Previous Privacy Policy'
                    )
                )
            );
        }
    }]);
    return PrivacyPolicyComponent;
}(_react.Component);

exports.default = PrivacyPolicyComponent;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _StandardPage = __webpack_require__(22);

var _RightColumn = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrivacyPolicyPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PrivacyPolicyPage, _Component);

  function PrivacyPolicyPage() {
    (0, _classCallCheck3.default)(this, PrivacyPolicyPage);
    return (0, _possibleConstructorReturn3.default)(this, (PrivacyPolicyPage.__proto__ || (0, _getPrototypeOf2.default)(PrivacyPolicyPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(PrivacyPolicyPage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          location = _props.location,
          PrivacyPolicy = _props.PrivacyPolicy,
          PreviousPrivacyPolicy = _props.PreviousPrivacyPolicy;


      return _react2.default.createElement(
        _StandardPage.StandardPage,
        { sport: 'privacy', title: 'Privacy Policy' },
        _react2.default.createElement(
          'div',
          { className: 'main-layout-left-column' },
          PrivacyPolicy,
          PreviousPrivacyPolicy
        ),
        _react2.default.createElement(_RightColumn.RightColumn, { location: location,
          sport: 'racing',
          content: ["topMpu", "bottomMpu", "ocWidget"] })
      );
    }
  }]);
  return PrivacyPolicyPage;
}(_react.Component), _class.propTypes = {
  PrivacyPolicy: _propTypes2.default.element,
  PreviousPrivacyPolicy: _propTypes2.default.element,
  location: _propTypes2.default.object.isRequired
}, _temp);
exports.default = PrivacyPolicyPage;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GptProperties = __webpack_require__(51);

var leaderboardAd = {
  view: 'racing'
};

var topMPU = {
  component: 'GooglePublisherTag',
  props: _GptProperties.topMPUProps,
  desktopColumn: 'right',
  desktopOrder: 1,
  handheldOrder: false
};

var bottomMPU = {
  component: 'GooglePublisherTag',
  props: _GptProperties.bottomMPUProps,
  desktopColumn: 'right',
  desktopOrder: 3,
  handheldOrder: false
};

var advertMPU = {
  component: "AdvertWrapper",
  props: {
    ocSlot: ["homepage", "mpu"],
    additionalProperties: {
      view: "racing"
    }
  },
  desktopColumn: "right",
  desktopOrder: 4,
  handheldOrder: false
};

var defaultSideBarComponents = [topMPU, bottomMPU, advertMPU];

var withAdverts = function withAdverts() {
  for (var _len = arguments.length, components = Array(_len), _key = 0; _key < _len; _key++) {
    components[_key] = arguments[_key];
  }

  return {
    bannerAd: _GptProperties.bannerAd,
    leaderboardAd: leaderboardAd,
    components: [].concat(components, defaultSideBarComponents)
  };
};

var PrivacyPolicyPageLayout = withAdverts({
  component: "PrivacyPolicy",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

var PreviousPrivacyPolicyPageLayout = withAdverts({
  component: "PreviousPrivacyPolicy",
  desktopColumn: "left",
  desktopOrder: 1,
  handheldOrder: 1
});

exports.default = {
  '/privacy': PrivacyPolicyPageLayout,
  '/privacy-previous': PreviousPrivacyPolicyPageLayout
};

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _AdvertWrapper = __webpack_require__(31);

var _AdvertWrapper2 = _interopRequireDefault(_AdvertWrapper);

var _GooglePublisherTag = __webpack_require__(71);

var _GooglePublisherTag2 = _interopRequireDefault(_GooglePublisherTag);

var _PrivacyPolicy = __webpack_require__(1031);

var _PrivacyPolicy2 = _interopRequireDefault(_PrivacyPolicy);

var _PrivacyPolicyPage = __webpack_require__(1032);

var _PrivacyPolicyPage2 = _interopRequireDefault(_PrivacyPolicyPage);

var _PreviousPrivacyPolicy = __webpack_require__(1030);

var _PreviousPrivacyPolicy2 = _interopRequireDefault(_PreviousPrivacyPolicy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adsSideBarComponents = {
  GooglePublisherTag: _GooglePublisherTag2.default,
  AdvertWrapper: _AdvertWrapper2.default
};

var privacyPolicyPageComponents = (0, _extends3.default)({
  PrivacyPolicy: _PrivacyPolicy2.default
}, adsSideBarComponents);

var previousPrivacyPolicyComponents = (0, _extends3.default)({
  PreviousPrivacyPolicy: _PreviousPrivacyPolicy2.default
}, adsSideBarComponents);

var PrivacyRoutes = _react2.default.createElement(
  'div',
  null,
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'privacy', components: _PrivacyPolicyPage2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { components: privacyPolicyPageComponents }),
    ' '
  ),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: 'privacy-previous', components: _PrivacyPolicyPage2.default },
    _react2.default.createElement(_reactRouter.IndexRoute, { components: previousPrivacyPolicyComponents }),
    ' '
  )
);

exports.default = PrivacyRoutes;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RugbyLeagueHomePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RugbyLeagueHomePage, _Component);

  function RugbyLeagueHomePage() {
    (0, _classCallCheck3.default)(this, RugbyLeagueHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (RugbyLeagueHomePage.__proto__ || (0, _getPrototypeOf2.default)(RugbyLeagueHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(RugbyLeagueHomePage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: 'rugby-league',
        title: 'Rugby League Scores, Fixtures & Results',
        location: location
      });
    }
  }]);
  return RugbyLeagueHomePage;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object
}, _temp);
exports.default = RugbyLeagueHomePage;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RugbyLeagueNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "Rugby League",
    links: [{ href: "/rugby-league", text: "News", isIndex: true }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

RugbyLeagueNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = RugbyLeagueNav;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routeUtils = __webpack_require__(38);

var _RugbyLeagueHomePage = __webpack_require__(1035);

var _RugbyLeagueHomePage2 = _interopRequireDefault(_RugbyLeagueHomePage);

var _RugbyLeagueNav = __webpack_require__(1036);

var _RugbyLeagueNav2 = _interopRequireDefault(_RugbyLeagueNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _routeUtils.genericRoute)(_RugbyLeagueHomePage2.default, _RugbyLeagueNav2.default, 'rugby-league');

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RugbyUnionHomePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(RugbyUnionHomePage, _Component);

  function RugbyUnionHomePage() {
    (0, _classCallCheck3.default)(this, RugbyUnionHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (RugbyUnionHomePage.__proto__ || (0, _getPrototypeOf2.default)(RugbyUnionHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(RugbyUnionHomePage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: 'rugby-union',
        title: 'Rugby Union Scores, Fixtures & Results',
        location: location
      });
    }
  }]);
  return RugbyUnionHomePage;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object
}, _temp);
exports.default = RugbyUnionHomePage;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RugbyUnionNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "Rugby Union",
    links: [{ href: "/rugby-union", text: "News", isIndex: true }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

RugbyUnionNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = RugbyUnionNav;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routeUtils = __webpack_require__(38);

var _RugbyUnionHomePage = __webpack_require__(1038);

var _RugbyUnionHomePage2 = _interopRequireDefault(_RugbyUnionHomePage);

var _RugbyUnionNav = __webpack_require__(1039);

var _RugbyUnionNav2 = _interopRequireDefault(_RugbyUnionNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _routeUtils.genericRoute)(_RugbyUnionHomePage2.default, _RugbyUnionNav2.default, 'rugby-union');

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SnookerHomePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SnookerHomePage, _Component);

  function SnookerHomePage() {
    (0, _classCallCheck3.default)(this, SnookerHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (SnookerHomePage.__proto__ || (0, _getPrototypeOf2.default)(SnookerHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(SnookerHomePage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: 'snooker',
        title: 'Snooker News & Betting Tips',
        location: location
      });
    }
  }]);
  return SnookerHomePage;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object
}, _temp);
exports.default = SnookerHomePage;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SnookerNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "Snooker",
    links: [{ href: "/snooker", text: "News", isIndex: true }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

SnookerNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = SnookerNav;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routeUtils = __webpack_require__(38);

var _SnookerHomePage = __webpack_require__(1041);

var _SnookerHomePage2 = _interopRequireDefault(_SnookerHomePage);

var _SnookerNav = __webpack_require__(1042);

var _SnookerNav2 = _interopRequireDefault(_SnookerNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _routeUtils.genericRoute)(_SnookerHomePage2.default, _SnookerNav2.default, 'snooker');

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SportHomePageContent = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TennisHomePage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(TennisHomePage, _Component);

  function TennisHomePage() {
    (0, _classCallCheck3.default)(this, TennisHomePage);
    return (0, _possibleConstructorReturn3.default)(this, (TennisHomePage.__proto__ || (0, _getPrototypeOf2.default)(TennisHomePage)).apply(this, arguments));
  }

  (0, _createClass3.default)(TennisHomePage, [{
    key: 'render',
    value: function render() {
      var location = this.props.location;


      return _react2.default.createElement(_SportHomePageContent.SportHomePageContent, {
        sport: 'tennis',
        title: 'Tennis News & Betting Tips',
        location: location
      });
    }
  }]);
  return TennisHomePage;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object
}, _temp);
exports.default = TennisHomePage;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SecondaryNav = __webpack_require__(48);

var _SecondaryNav2 = _interopRequireDefault(_SecondaryNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TennisNav(_ref) {
  var open = _ref.open,
      opener = _ref.opener;

  var props = {
    open: open,
    opener: opener,
    title: "Tennis",
    links: [{ href: "/tennis", text: "News", isIndex: true }]
  };

  return _react2.default.createElement(_SecondaryNav2.default, props);
}

TennisNav.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  opener: _propTypes2.default.func.isRequired
};

exports.default = TennisNav;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _routeUtils = __webpack_require__(38);

var _TennisHomePage = __webpack_require__(1044);

var _TennisHomePage2 = _interopRequireDefault(_TennisHomePage);

var _TennisNav = __webpack_require__(1045);

var _TennisNav2 = _interopRequireDefault(_TennisNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _routeUtils.genericRoute)(_TennisHomePage2.default, _TennisNav2.default, 'tennis');

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unsubscribe = exports.subscribe = exports.isConnected = exports.reConnect = exports.closeClient = exports.connect = undefined;

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

exports.default = function () {
    return { connect: connect, closeClient: closeClient, reConnect: reConnect, isConnected: isConnected, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _mqtt = __webpack_require__(1528);

var _mqtt2 = _interopRequireDefault(_mqtt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var client = null;

var connect = exports.connect = function connect(url, messageCb, closeCb) {
    return new _promise2.default(function (resolve, reject) {

        client = _mqtt2.default.connect(url, { reconnectPeriod: 0 });

        client.on('connect', function () {
            resolve('success');
        });

        client.on('error', function (err) {
            reject(err);
        });

        client.on('close', closeCb);

        client.on('message', messageCb);
    });
};

var closeClient = exports.closeClient = function closeClient() {
    if (!client) {
        return _promise2.default.resolve('success');
    }
    return new _promise2.default(function (resolve) {
        client.end(false, function () {
            return resolve('success');
        });
    });
};

var reConnect = exports.reConnect = function reConnect() {
    if (!client) {
        throw new Error('client does not exist');
    }
    if (client.isConnected) {
        return true;
    }

    client.reConnect();
    return true;
};

var isConnected = exports.isConnected = function isConnected() {
    if (!client) {
        return false;
    }

    return client.connected;
};

var subscribe = exports.subscribe = function subscribe(topics) {
    var qos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    return new _promise2.default(function (resolve, reject) {
        if (!client) {
            return reject('no client defined, try connect() before subscribing');
        }

        if (!topics || topics.length === 0) {
            return reject('topic required');
        }

        client.subscribe(topics, { qos: qos }, function (err, granted) {
            if (err) {
                return reject(err);
            }
            return resolve(granted);
        });
    });
};

var unsubscribe = exports.unsubscribe = function unsubscribe(topic) {
    return new _promise2.default(function (resolve, reject) {
        if (!client) {
            return reject('client does not exist');
        }
        if (!topic) {
            return reject('topic required');
        }

        client.unsubscribe(topic, function (err) {
            if (err) {
                return reject(err);
            }

            return resolve('successfully unsubscribed from topic: ' + topic);
        });
    });
};

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = __webpack_require__(24);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = __webpack_require__(148);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = clientMiddleware;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clientMiddleware(client) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;

    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState);
        }

        var _action$promise = action.promise,
            promise = _action$promise === undefined ? null : _action$promise,
            _action$types = action.types,
            types = _action$types === undefined ? [] : _action$types,
            rest = (0, _objectWithoutProperties3.default)(action, ['promise', 'types']); // eslint-disable-line no-redeclare

        if (!promise) {
          return next(action);
        }

        var _types = (0, _slicedToArray3.default)(types, 3),
            REQUEST = _types[0],
            SUCCESS = _types[1],
            FAILURE = _types[2];

        next((0, _extends3.default)({}, rest, { type: REQUEST }));

        var actionPromise = promise(client);

        actionPromise.then(function (result) {
          return next((0, _extends3.default)({}, rest, { result: result, type: SUCCESS }));
        }, function (error) {
          return next((0, _extends3.default)({}, rest, { error: error, type: FAILURE }));
        }).catch(function (error) {
          return next((0, _extends3.default)({}, rest, { error: error, type: FAILURE }));
        });

        return actionPromise;
      };
    };
  };
}

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(112);

var _reactRouterRedux = __webpack_require__(138);

var _reduxConnect = __webpack_require__(351);

var _reducer = __webpack_require__(859);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(986);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(895);

var _reducer6 = _interopRequireDefault(_reducer5);

var _reducer7 = __webpack_require__(800);

var _reducer8 = _interopRequireDefault(_reducer7);

var _reducer9 = __webpack_require__(172);

var _reducer10 = _interopRequireDefault(_reducer9);

var _server = __webpack_require__(438);

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  reduxAsyncConnect: _reduxConnect.reducer,
  server: _server2.default,
  football: _reducer2.default,
  horseRacing: _reducer4.default,
  greyhoundRacing: _reducer6.default,
  common: _reducer8.default,
  insider: _reducer10.default
});

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(35);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = createStore;

var _redux = __webpack_require__(112);

var _clientMiddleware = __webpack_require__(1048);

var _clientMiddleware2 = _interopRequireDefault(_clientMiddleware);

var _raceUpdateFactory = __webpack_require__(981);

var _raceUpdateFactory2 = _interopRequireDefault(_raceUpdateFactory);

var _myStableEmailUnsubscribeFactory = __webpack_require__(979);

var _myStableEmailUnsubscribeFactory2 = _interopRequireDefault(_myStableEmailUnsubscribeFactory);

var _apiRequestFactory = __webpack_require__(783);

var _apiRequestFactory2 = _interopRequireDefault(_apiRequestFactory);

var _feedbackSubmitFactory = __webpack_require__(787);

var _feedbackSubmitFactory2 = _interopRequireDefault(_feedbackSubmitFactory);

var _reactRouterRedux = __webpack_require__(138);

var _developmentOnly = __webpack_require__(1625);

var _trackingEvents = __webpack_require__(793);

var _trackingEvents2 = _interopRequireDefault(_trackingEvents);

var _cookies = __webpack_require__(785);

var _cookies2 = _interopRequireDefault(_cookies);

var _errorTracking = __webpack_require__(977);

var _errorTracking2 = _interopRequireDefault(_errorTracking);

var _insiderLogin = __webpack_require__(994);

var _windowEventsFactory = __webpack_require__(795);

var _windowEventsFactory2 = _interopRequireDefault(_windowEventsFactory);

var _ssoMiddlewareFactory = __webpack_require__(792);

var _ssoMiddlewareFactory2 = _interopRequireDefault(_ssoMiddlewareFactory);

var _betslipMiddlewareFactory = __webpack_require__(784);

var _betslipMiddlewareFactory2 = _interopRequireDefault(_betslipMiddlewareFactory);

var _menuEvents = __webpack_require__(788);

var _menuEvents2 = _interopRequireDefault(_menuEvents);

var _tamGptInitialization = __webpack_require__(256);

var _tamGptInitialization2 = _interopRequireDefault(_tamGptInitialization);

var _splashpageMiddleware = __webpack_require__(790);

var _splashpageMiddleware2 = _interopRequireDefault(_splashpageMiddleware);

var _OmnitureAnalytics = __webpack_require__(439);

var _OmnitureAnalytics2 = _interopRequireDefault(_OmnitureAnalytics);

var _GoogleAnalytics = __webpack_require__(275);

var _GoogleAnalytics2 = _interopRequireDefault(_GoogleAnalytics);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _ApiClient = __webpack_require__(64);

var _ApiClient2 = _interopRequireDefault(_ApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trackingEventsMiddleware = new _trackingEvents2.default(_GoogleAnalytics2.default, _OmnitureAnalytics2.default, _config2.default);
var ssoMiddleware = (0, _ssoMiddlewareFactory2.default)(_config2.default);

function createStore(history, client, data) {
  // Sync dispatched route actions to the history
  var reduxRouterMiddleware = (0, _reactRouterRedux.routerMiddleware)(history);
  var raceUpdateMiddleware = new _raceUpdateFactory2.default();
  var myStableEmailUnsubscribeMiddleware = new _myStableEmailUnsubscribeFactory2.default();
  var apiRequestMiddleware = new _apiRequestFactory2.default();
  var feedbackMiddleware = new _feedbackSubmitFactory2.default();
  var betslipMiddleware = new _betslipMiddlewareFactory2.default(_config2.default);
  var splashMiddleware = (0, _splashpageMiddleware2.default)(new _ApiClient2.default(), _config2.default);

  var middleware = [(0, _clientMiddleware2.default)(client), reduxRouterMiddleware].concat((0, _toConsumableArray3.default)(trackingEventsMiddleware), (0, _toConsumableArray3.default)(myStableEmailUnsubscribeMiddleware), (0, _toConsumableArray3.default)(raceUpdateMiddleware), [_errorTracking2.default, _insiderLogin.insiderLogin], (0, _toConsumableArray3.default)((0, _cookies2.default)()), (0, _toConsumableArray3.default)((0, _windowEventsFactory2.default)()), (0, _toConsumableArray3.default)(apiRequestMiddleware), (0, _toConsumableArray3.default)(feedbackMiddleware), (0, _toConsumableArray3.default)(betslipMiddleware), (0, _toConsumableArray3.default)((0, _menuEvents2.default)()), (0, _toConsumableArray3.default)(ssoMiddleware), (0, _toConsumableArray3.default)(splashMiddleware), (0, _toConsumableArray3.default)((0, _tamGptInitialization2.default)()));

  var composeEnhancers = (0, _developmentOnly.composeWithDevTools)({});

  var finalCreateStore = composeEnhancers(_redux.applyMiddleware.apply(undefined, (0, _toConsumableArray3.default)(middleware)))(_redux.createStore);

  var reducer = __webpack_require__(1049).default;
  var store = finalCreateStore(reducer, data);

  return store;
}

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Routes;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(11);

var _App = __webpack_require__(720);

var _App2 = _interopRequireDefault(_App);

var _routes = __webpack_require__(902);

var _routes2 = _interopRequireDefault(_routes);

var _routes3 = __webpack_require__(863);

var _routes4 = _interopRequireDefault(_routes3);

var _routes5 = __webpack_require__(987);

var _routes6 = _interopRequireDefault(_routes5);

var _routes7 = __webpack_require__(896);

var _routes8 = _interopRequireDefault(_routes7);

var _routes9 = __webpack_require__(805);

var _routes10 = _interopRequireDefault(_routes9);

var _routes11 = __webpack_require__(808);

var _routes12 = _interopRequireDefault(_routes11);

var _routes13 = __webpack_require__(870);

var _routes14 = _interopRequireDefault(_routes13);

var _routes15 = __webpack_require__(1037);

var _routes16 = _interopRequireDefault(_routes15);

var _routes17 = __webpack_require__(1040);

var _routes18 = _interopRequireDefault(_routes17);

var _routes19 = __webpack_require__(1046);

var _routes20 = _interopRequireDefault(_routes19);

var _routes21 = __webpack_require__(723);

var _routes22 = _interopRequireDefault(_routes21);

var _routes23 = __webpack_require__(867);

var _routes24 = _interopRequireDefault(_routes23);

var _routes25 = __webpack_require__(1043);

var _routes26 = _interopRequireDefault(_routes25);

var _routes27 = __webpack_require__(998);

var _routes28 = _interopRequireDefault(_routes27);

var _routes29 = __webpack_require__(1029);

var _routes30 = _interopRequireDefault(_routes29);

var _routes31 = __webpack_require__(813);

var _routes32 = _interopRequireDefault(_routes31);

var _routes33 = __webpack_require__(1020);

var _routes34 = _interopRequireDefault(_routes33);

var _routes35 = __webpack_require__(995);

var _routes36 = _interopRequireDefault(_routes35);

var _routes37 = __webpack_require__(1034);

var _routes38 = _interopRequireDefault(_routes37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Routes() {
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _App2.default },
    _routes2.default,
    _routes4.default,
    _routes6.default,
    _routes8.default,
    _routes10.default,
    _routes12.default,
    _routes14.default,
    _routes16.default,
    _routes18.default,
    _routes20.default,
    _routes22.default,
    _routes24.default,
    _routes26.default,
    _routes28.default,
    _routes30.default,
    _routes32.default,
    _routes34.default,
    _routes36.default,
    _routes38.default,
    _react2.default.createElement(_reactRouter.Redirect, { from: '*', to: '/error/404/*' })
  );
}

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*

Structure is

{
  [internalEventName]: {
    [vendorId]: { // currently 'google' or 'omniture'

    }
  }
}

If the internal event name is not listed, no vendors will track the event.

If, for a listed event, a vendor is not listed (or explicitly set to false) that vendor will not track the event.

The object given for a vendor under an event has two properties;
  name:     Optionally maps the internal name to the eventName for that vendor.
            If omitted the internal name is passed through.

  paramMap: Optional configuration that tells the eventParams method of the vendor specific API class how to
                convert the given data.
            If omitted, an empty map is passed, which will probably result in no params being sent (although
                a vendor may behave differently).

Note that both properties are optional. If neither is needed it is still necessary to provide an empty object, or
    the event will nto be tracked by that vendor.

*/

exports.default = {
  deviceIDFA: {
    signal: {
      paramMap: {
        deviceIDFA: "deviceIDFA"
      }
      //no google
      //no omniture
    } },
  pageView: {
    signal: {
      name: "pageLoad",
      paramMap: {
        pageUrl: "url"
      }
    },
    google: {
      name: "pageview"
    },
    omniture: {
      options: {
        isPage: true
      }
    }
  },
  playVideo: {
    //no signal
    //no google
    omniture: {
      paramMap: {
        events: ["event11"],
        evars: {
          videoUri: "eVar28"
        }
      }
    }
  },
  followMatch: {
    //no signal
    //no google
    omniture: {
      paramMap: {
        events: ["event6"],
        evars: {
          matchId: "eVar75"
        }
      }
    }
  },
  followMeeting: {
    //no signal
    //no google
    omniture: {
      paramMap: {
        events: ["event6"],
        evars: {
          meetingId: "eVar76"
        }
      }
    }
  },
  followRace: {
    //no signal
    //no google
    omniture: {
      paramMap: {
        events: ["event6"],
        evars: {
          raceId: "eVar77"
        }
      }
    }
  },
  addToBetSlip: {
    //no signal
    //no google
    omniture: {
      paramMap: {
        events: ["event31"]
      }
    }
  },
  reportTimings: {
    //no signal
    //no google
    omniture: {
      paramMap: {
        events: ["event10"],
        evars: {
          LocationCheck: "eVar58",
          SiteLoad: "eVar59",
          applicationLoadTime: "eVar60"
        }
      }
    }
  },
  insidersLinkClick: {
    omniture: {
      paramMap: {
        props: {
          link: "prop15"
        }
      }
    }
  },
  insightsLinkClick: {
    omniture: {
      paramMap: {
        props: {
          link: "prop15"
        }
      }
    }
  },
  linkClick: {
    omniture: {
      paramMap: {
        props: {
          link: "prop15"
        }
      }
    }
  },
  arrivingUser: {
    //no signal
    //no google
    omniture: {
      paramMap: {
        evars: {
          custId: "eVar39"
        }
      }
    }
  }
};

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TAGGERT_EMBED = undefined;

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get3 = __webpack_require__(233);

var _get4 = _interopRequireDefault(_get3);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _AnalyticsApi2 = __webpack_require__(274);

var _AnalyticsApi3 = _interopRequireDefault(_AnalyticsApi2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// As provided by SkyBet
var TAGGERT_EMBED = exports.TAGGERT_EMBED = '!function(){"use strict";var n=function(n,t){return Object.prototype.hasOwnProperty.call(t,n)},t="function"==typeof Object.assign?Object.assign:function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var e=Object(t),r=1,o=arguments.length;r<o;){var c=arguments[r];if(null!=c)for(var u in c)n(u,c)&&(e[u]=c[u]);r+=1}return e},e=function(n){return null!=n&&"object"==typeof n&&!0===n["@@functional/placeholder"]},r=function(n){return function t(r){return 0===arguments.length||e(r)?t:n.apply(this,arguments)}},o=function(n){return function t(o,c){switch(arguments.length){case 0:return t;case 1:return e(o)?t:r(function(t){return n(o,t)});default:return e(o)&&e(c)?t:e(o)?r(function(t){return n(t,c)}):e(c)?r(function(t){return n(o,t)}):n(o,c)}}}(function(n,e){return t({},n,e)});const c=(n,t,e)=>{const r=[],c=t=>{n.contentWindow.postMessage(t,e)};let u=!1;return n.addEventListener("load",()=>{u=!0,r.forEach(c)}),(n,e)=>{const a=o(e,{event:`${t}.${n}`});u?c(a):r.push(a)}},u=(n,t,e)=>{const r=n.createElement("iframe");return r.id="data-layer-iframe",r.sandbox="allow-scripts allow-same-origin",r.src=`${t}/tag-manager.html?consumer=${encodeURIComponent(e)}`,r.style.display="none",r};window.Taggert={report:((n,t)=>{const e=n.SIGNAL_CONSUMER||n.location.hostname,r=u(n.document,t,e);return document.body.appendChild(r),c(r,e,t)})(window,"https://www.bonne-terre-data-layer.com")}}();';

var SbgSignalAnalytics = function (_AnalyticsApi) {
  (0, _inherits3.default)(SbgSignalAnalytics, _AnalyticsApi);

  function SbgSignalAnalytics(options, store) {
    (0, _classCallCheck3.default)(this, SbgSignalAnalytics);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SbgSignalAnalytics.__proto__ || (0, _getPrototypeOf2.default)(SbgSignalAnalytics)).call(this, "SBG Signal", "signal", options));

    _this.getState = store.getState;
    return _this;
  }

  (0, _createClass3.default)(SbgSignalAnalytics, [{
    key: 'pageView',
    value: function pageView() {
      var _get2;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = (0, _get4.default)(SbgSignalAnalytics.prototype.__proto__ || (0, _getPrototypeOf2.default)(SbgSignalAnalytics.prototype), 'pageView', this)).call.apply(_get2, [this].concat(args));
      this.trackDeviceId();
    }
  }, {
    key: 'trackDeviceId',
    value: function trackDeviceId() {
      var appBridgeReady = this.getState().common.auth.appBridgeReady || false;
      if (window.SkyBetAccount && appBridgeReady) {
        var appBridge = window.SkyBetAccount.getAppBridge();
        if (appBridge) {
          appBridge.trigger('getDeviceIDFA');
        }
      }
    }
  }, {
    key: 'isSetUp',
    value: function isSetUp() {
      return !!window.Taggert;
    }
  }, {
    key: 'sendTracking',
    value: function sendTracking(hitType, params) {
      window.Taggert.report(hitType, params);
    }
  }]);
  return SbgSignalAnalytics;
}(_AnalyticsApi3.default);

exports.default = SbgSignalAnalytics;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ["sl", "sl/home", "sl/football", "sl/football/tips-centre", "sl/racing", "sl/racing/tips-centre", "sl/greyhounds", "sl/cricket", "sl/darts", "sl/golf", "sl/rugby-league", "sl/rugby-union", "sl/tennis", "sl/boxing", "sl/formula1", "sl/snooker", "sl/nfl", "sl/other-sports"];

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (counts, goal) {
  if (!(counts && counts.reduce)) {
    return undefined;
  }

  if (!(typeof goal === 'number')) {
    return undefined;
  }

  return counts.reduce(function (prev, curr) {
    return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
  }, 0);
};

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _index = __webpack_require__(18);

exports.default = function (ref) {
  if (!ref || (0, _index.isServer)()) {
    return false;
  }

  var bounding = ref.getBoundingClientRect();

  return bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth);
};

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (initialValue) {
  var oldValue = initialValue;
  var callbacks = [];

  var registerCallback = function registerCallback(callback) {
    callbacks.push(callback);
  };

  var comparator = function comparator(newValue) {
    if (oldValue !== newValue) {
      oldValue = newValue;
      callbacks.forEach(function (callback) {
        callback(newValue);
      });
    }
  };

  return {
    comparator: comparator,
    registerCallback: registerCallback
  };
};

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(6);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(3);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = withAnalytics;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactMetrics = __webpack_require__(69);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _metricsConfig = __webpack_require__(442);

var _metricsConfig2 = _interopRequireDefault(_metricsConfig);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
  This is to be used as a decorator for App It configures and then uses the provided `metrics` decorator
 */
function withAnalytics(ComposedComponent) {
  var _class, _temp;

  var WithAnalytics = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(WithAnalytics, _Component);

    function WithAnalytics() {
      var _ref;

      (0, _classCallCheck3.default)(this, WithAnalytics);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithAnalytics.__proto__ || (0, _getPrototypeOf2.default)(WithAnalytics)).call.apply(_ref, [this].concat(args)));

      _this.metricsConfig = (0, _metricsConfig2.default)(_this.context.store, _config2.default);

      _this.metricsOptions = {
        useTrackBinding: false
      };

      _this.metricsInstance = (0, _reactMetrics.metrics)(_this.metricsConfig, _this.metricsOptions)(ComposedComponent);
      return _this;
    }

    (0, _createClass3.default)(WithAnalytics, [{
      key: 'render',
      value: function render() {
        var Metrics = this.metricsInstance;

        return _react2.default.createElement(Metrics, this.props);
      }
    }]);
    return WithAnalytics;
  }(_react.Component), _class.contextTypes = {
    store: _propTypes2.default.object.isRequired
  }, _temp);


  return WithAnalytics;
}

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects", "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function (fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    this._defaults.push({ fn: fn, args: args });
    return this;
  };
});

Agent.prototype._setDefaults = function (req) {
  this._defaults.forEach(function (def) {
    req[def.fn].apply(req, def.args);
  });
};

module.exports = Agent;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module of mixed-in functions shared between node and client code
 */

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _typeof2 = __webpack_require__(132);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isObject = __webpack_require__(445);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout() {
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn) {
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function (val) {
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn) {
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options) {
  if (!options || 'object' !== (typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options))) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for (var option in options) {
    switch (option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn) {
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = ['ECONNRESET', 'ETIMEDOUT', 'EADDRINFO', 'ESOCKETTIMEDOUT'];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function (err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch (e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function () {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  var _this = this;

  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new _promise2.default(function (innerResolve, innerReject) {
      self.on('error', innerReject);
      self.on('abort', function () {
        var err = new Error('Aborted');
        err.code = "ABORTED";
        err.status = _this.status;
        err.method = _this.method;
        err.url = _this.url;
        innerReject(err);
      });
      self.end(function (err, res) {
        if (err) innerReject(err);else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype['catch'] = function (cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function (cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function (res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function (field) {
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function (field, val) {
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function (field) {
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function (name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function () {
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function (user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer':
      // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function (on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function (n) {
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function (n) {
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function () {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function (data) {
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data ? this._data + '&' + data : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function (sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function () {
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function () {
  console.trace("Unsupported");
};

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function (reason, timeout, errno) {
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function () {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function () {
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function () {
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */

var utils = __webpack_require__(1062);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function (field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function (header) {
  // TODO: moar!
  // TODO: make this a util

  // content-type
  var ct = header['content-type'] || '';
  this.type = utils.type(ct);

  // params
  var params = utils.params(ct);
  for (var key in params) {
    this[key] = params[key];
  }this.links = {};

  // links
  try {
    if (header.link) {
      this.links = utils.parseLinks(header.link);
    }
  } catch (err) {
    // ignore
  }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function (status) {
  var type = status / 100 | 0;

  // status / class
  this.status = this.statusCode = status;
  this.statusType = type;

  // basics
  this.info = 1 == type;
  this.ok = 2 == type;
  this.redirect = 3 == type;
  this.clientError = 4 == type;
  this.serverError = 5 == type;
  this.error = 4 == type || 5 == type ? this.toError() : false;

  // sugar
  this.created = 201 == status;
  this.accepted = 202 == status;
  this.noContent = 204 == status;
  this.badRequest = 400 == status;
  this.unauthorized = 401 == status;
  this.notAcceptable = 406 == status;
  this.forbidden = 403 == status;
  this.notFound = 404 == status;
  this.unprocessableEntity = 422 == status;
};

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function (str) {
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function (str) {
  return str.split(/ *; */).reduce(function (obj, str) {
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function (str) {
  return str.split(/ *, */).reduce(function (obj, str) {
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function (header, changesOrigin) {
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1070);
module.exports = __webpack_require__(82).RegExp.escape;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
var isArray = __webpack_require__(223);
var SPECIES = __webpack_require__(33)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(25);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(86);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(126);
var gOPS = __webpack_require__(227);
var pIE = __webpack_require__(179);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(9);
var $re = __webpack_require__(1068)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(9);

$export($export.P, 'Array', { copyWithin: __webpack_require__(447) });

__webpack_require__(103)('copyWithin');


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $every = __webpack_require__(81)(4);

$export($export.P + $export.F * !__webpack_require__(75)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(9);

$export($export.P, 'Array', { fill: __webpack_require__(278) });

__webpack_require__(103)('fill');


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $filter = __webpack_require__(81)(2);

$export($export.P + $export.F * !__webpack_require__(75)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(9);
var $find = __webpack_require__(81)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(103)(KEY);


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(9);
var $find = __webpack_require__(81)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(103)(KEY);


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $forEach = __webpack_require__(81)(0);
var STRICT = __webpack_require__(75)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(74);
var $export = __webpack_require__(9);
var toObject = __webpack_require__(45);
var call = __webpack_require__(458);
var isArrayIter = __webpack_require__(286);
var toLength = __webpack_require__(41);
var createProperty = __webpack_require__(280);
var getIterFn = __webpack_require__(303);

$export($export.S + $export.F * !__webpack_require__(225)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $indexOf = __webpack_require__(219)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(75)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(9);

$export($export.S, 'Array', { isArray: __webpack_require__(223) });


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(9);
var toIObject = __webpack_require__(68);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(178) != Object || !__webpack_require__(75)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toIObject = __webpack_require__(68);
var toInteger = __webpack_require__(85);
var toLength = __webpack_require__(41);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(75)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $map = __webpack_require__(81)(1);

$export($export.P + $export.F * !__webpack_require__(75)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var createProperty = __webpack_require__(280);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(25)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $reduce = __webpack_require__(449);

$export($export.P + $export.F * !__webpack_require__(75)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $reduce = __webpack_require__(449);

$export($export.P + $export.F * !__webpack_require__(75)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var html = __webpack_require__(284);
var cof = __webpack_require__(73);
var toAbsoluteIndex = __webpack_require__(130);
var toLength = __webpack_require__(41);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(25)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $some = __webpack_require__(81)(3);

$export($export.P + $export.F * !__webpack_require__(75)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var aFunction = __webpack_require__(49);
var toObject = __webpack_require__(45);
var fails = __webpack_require__(25);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(75)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(129)('Array');


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(9);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(9);
var toISOString = __webpack_require__(1065);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(86);

$export($export.P + $export.F * __webpack_require__(25)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(33)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(56)(proto, TO_PRIMITIVE, __webpack_require__(1066));


/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(57)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(9);

$export($export.P, 'Function', { bind: __webpack_require__(450) });


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(26);
var getPrototypeOf = __webpack_require__(67);
var HAS_INSTANCE = __webpack_require__(33)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(40).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(40).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(39) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(9);
var log1p = __webpack_require__(461);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(9);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(9);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(9);
var sign = __webpack_require__(290);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(9);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(9);
var $expm1 = __webpack_require__(289);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', { fround: __webpack_require__(460) });


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(9);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(9);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(25)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', { log1p: __webpack_require__(461) });


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', { sign: __webpack_require__(290) });


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(9);
var expm1 = __webpack_require__(289);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(25)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(9);
var expm1 = __webpack_require__(289);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(19);
var has = __webpack_require__(55);
var cof = __webpack_require__(73);
var inheritIfRequired = __webpack_require__(285);
var toPrimitive = __webpack_require__(86);
var fails = __webpack_require__(25);
var gOPN = __webpack_require__(125).f;
var gOPD = __webpack_require__(66).f;
var dP = __webpack_require__(40).f;
var $trim = __webpack_require__(144).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(124)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(39) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(57)(global, NUMBER, $Number);
}


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(9);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(9);
var _isFinite = __webpack_require__(19).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(9);

$export($export.S, 'Number', { isInteger: __webpack_require__(457) });


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(9);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(9);
var isInteger = __webpack_require__(457);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(9);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(9);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var $parseFloat = __webpack_require__(469);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var $parseInt = __webpack_require__(470);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toInteger = __webpack_require__(85);
var aNumberValue = __webpack_require__(446);
var repeat = __webpack_require__(297);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(25)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $fails = __webpack_require__(25);
var aNumberValue = __webpack_require__(446);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(9);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(463) });


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(124) });


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(39), 'Object', { defineProperties: __webpack_require__(464) });


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(39), 'Object', { defineProperty: __webpack_require__(40).f });


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(26);
var meta = __webpack_require__(104).onFreeze;

__webpack_require__(84)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(68);
var $getOwnPropertyDescriptor = __webpack_require__(66).f;

__webpack_require__(84)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(84)('getOwnPropertyNames', function () {
  return __webpack_require__(465).f;
});


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(45);
var $getPrototypeOf = __webpack_require__(67);

__webpack_require__(84)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(26);

__webpack_require__(84)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(26);

__webpack_require__(84)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(26);

__webpack_require__(84)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(9);
$export($export.S, 'Object', { is: __webpack_require__(1069) });


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(45);
var $keys = __webpack_require__(126);

__webpack_require__(84)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(26);
var meta = __webpack_require__(104).onFreeze;

__webpack_require__(84)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(26);
var meta = __webpack_require__(104).onFreeze;

__webpack_require__(84)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(9);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(293).set });


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(177);
var test = {};
test[__webpack_require__(33)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(57)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var $parseFloat = __webpack_require__(469);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var $parseInt = __webpack_require__(470);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(123);
var global = __webpack_require__(19);
var ctx = __webpack_require__(74);
var classof = __webpack_require__(177);
var $export = __webpack_require__(9);
var isObject = __webpack_require__(26);
var aFunction = __webpack_require__(49);
var anInstance = __webpack_require__(121);
var forOf = __webpack_require__(122);
var speciesConstructor = __webpack_require__(231);
var task = __webpack_require__(299).set;
var microtask = __webpack_require__(291)();
var newPromiseCapabilityModule = __webpack_require__(292);
var perform = __webpack_require__(471);
var promiseResolve = __webpack_require__(472);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(33)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(128)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(143)($Promise, PROMISE);
__webpack_require__(129)(PROMISE);
Wrapper = __webpack_require__(82)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(225)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(9);
var aFunction = __webpack_require__(49);
var anObject = __webpack_require__(16);
var rApply = (__webpack_require__(19).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(25)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(9);
var create = __webpack_require__(124);
var aFunction = __webpack_require__(49);
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(26);
var fails = __webpack_require__(25);
var bind = __webpack_require__(450);
var rConstruct = (__webpack_require__(19).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(40);
var $export = __webpack_require__(9);
var anObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(86);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(25)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(9);
var gOPD = __webpack_require__(66).f;
var anObject = __webpack_require__(16);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(9);
var anObject = __webpack_require__(16);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(287)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(66);
var $export = __webpack_require__(9);
var anObject = __webpack_require__(16);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(9);
var getProto = __webpack_require__(67);
var anObject = __webpack_require__(16);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(66);
var getPrototypeOf = __webpack_require__(67);
var has = __webpack_require__(55);
var $export = __webpack_require__(9);
var isObject = __webpack_require__(26);
var anObject = __webpack_require__(16);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(9);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(9);
var anObject = __webpack_require__(16);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(9);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(468) });


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(9);
var anObject = __webpack_require__(16);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(9);
var setProto = __webpack_require__(293);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(40);
var gOPD = __webpack_require__(66);
var getPrototypeOf = __webpack_require__(67);
var has = __webpack_require__(55);
var $export = __webpack_require__(9);
var createDesc = __webpack_require__(127);
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(26);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(19);
var inheritIfRequired = __webpack_require__(285);
var dP = __webpack_require__(40).f;
var gOPN = __webpack_require__(125).f;
var isRegExp = __webpack_require__(224);
var $flags = __webpack_require__(222);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(39) && (!CORRECT_NEW || __webpack_require__(25)(function () {
  re2[__webpack_require__(33)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(57)(global, 'RegExp', $RegExp);
}

__webpack_require__(129)('RegExp');


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(221)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(221)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(221)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(221)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(224);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(477);
var anObject = __webpack_require__(16);
var $flags = __webpack_require__(222);
var DESCRIPTORS = __webpack_require__(39);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(57)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(25)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(58)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(58)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(58)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(58)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $at = __webpack_require__(295)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(9);
var toLength = __webpack_require__(41);
var context = __webpack_require__(296);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(283)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(58)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(58)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(58)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(130);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(9);
var context = __webpack_require__(296);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(283)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(58)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(295)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(288)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(58)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var toIObject = __webpack_require__(68);
var toLength = __webpack_require__(41);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(297)
});


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(58)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(9);
var toLength = __webpack_require__(41);
var context = __webpack_require__(296);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(283)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(58)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(58)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(58)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(144)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(19);
var has = __webpack_require__(55);
var DESCRIPTORS = __webpack_require__(39);
var $export = __webpack_require__(9);
var redefine = __webpack_require__(57);
var META = __webpack_require__(104).KEY;
var $fails = __webpack_require__(25);
var shared = __webpack_require__(230);
var setToStringTag = __webpack_require__(143);
var uid = __webpack_require__(131);
var wks = __webpack_require__(33);
var wksExt = __webpack_require__(475);
var wksDefine = __webpack_require__(302);
var enumKeys = __webpack_require__(1067);
var isArray = __webpack_require__(223);
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(26);
var toIObject = __webpack_require__(68);
var toPrimitive = __webpack_require__(86);
var createDesc = __webpack_require__(127);
var _create = __webpack_require__(124);
var gOPNExt = __webpack_require__(465);
var $GOPD = __webpack_require__(66);
var $DP = __webpack_require__(40);
var $keys = __webpack_require__(126);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(125).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(179).f = $propertyIsEnumerable;
  __webpack_require__(227).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(123)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(56)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var $typed = __webpack_require__(232);
var buffer = __webpack_require__(300);
var anObject = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(130);
var toLength = __webpack_require__(41);
var isObject = __webpack_require__(26);
var ArrayBuffer = __webpack_require__(19).ArrayBuffer;
var speciesConstructor = __webpack_require__(231);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(25)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(129)(ARRAY_BUFFER);


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
$export($export.G + $export.W + $export.F * !__webpack_require__(232).ABV, {
  DataView: __webpack_require__(300).DataView
});


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(95)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(453);
var validate = __webpack_require__(145);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(220)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(9);
var flattenIntoArray = __webpack_require__(454);
var toObject = __webpack_require__(45);
var toLength = __webpack_require__(41);
var aFunction = __webpack_require__(49);
var arraySpeciesCreate = __webpack_require__(279);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(103)('flatMap');


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(9);
var flattenIntoArray = __webpack_require__(454);
var toObject = __webpack_require__(45);
var toLength = __webpack_require__(41);
var toInteger = __webpack_require__(85);
var arraySpeciesCreate = __webpack_require__(279);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(103)('flatten');


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(9);
var $includes = __webpack_require__(219)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(103)('includes');


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(9);
var microtask = __webpack_require__(291)();
var process = __webpack_require__(19).process;
var isNode = __webpack_require__(73)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(9);
var cof = __webpack_require__(73);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(9);

$export($export.G, { global: __webpack_require__(19) });


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(228)('Map');


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(229)('Map');


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(9);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(452)('Map') });


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);
var scale = __webpack_require__(462);
var fround = __webpack_require__(460);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(9);

$export($export.S, 'Math', { scale: __webpack_require__(462) });


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(9);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(9);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toObject = __webpack_require__(45);
var aFunction = __webpack_require__(49);
var $defineProperty = __webpack_require__(40);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(39) && $export($export.P + __webpack_require__(226), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toObject = __webpack_require__(45);
var aFunction = __webpack_require__(49);
var $defineProperty = __webpack_require__(40);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(39) && $export($export.P + __webpack_require__(226), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(9);
var $entries = __webpack_require__(467)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(9);
var ownKeys = __webpack_require__(468);
var toIObject = __webpack_require__(68);
var gOPD = __webpack_require__(66);
var createProperty = __webpack_require__(280);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(86);
var getPrototypeOf = __webpack_require__(67);
var getOwnPropertyDescriptor = __webpack_require__(66).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(39) && $export($export.P + __webpack_require__(226), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(9);
var toObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(86);
var getPrototypeOf = __webpack_require__(67);
var getOwnPropertyDescriptor = __webpack_require__(66).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(39) && $export($export.P + __webpack_require__(226), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(9);
var $values = __webpack_require__(467)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(9);
var global = __webpack_require__(19);
var core = __webpack_require__(82);
var microtask = __webpack_require__(291)();
var OBSERVABLE = __webpack_require__(33)('observable');
var aFunction = __webpack_require__(49);
var anObject = __webpack_require__(16);
var anInstance = __webpack_require__(121);
var redefineAll = __webpack_require__(128);
var hide = __webpack_require__(56);
var forOf = __webpack_require__(122);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(129)('Observable');


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(9);
var core = __webpack_require__(82);
var global = __webpack_require__(19);
var speciesConstructor = __webpack_require__(231);
var promiseResolve = __webpack_require__(472);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(9);
var newPromiseCapability = __webpack_require__(292);
var perform = __webpack_require__(471);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(94);
var anObject = __webpack_require__(16);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(94);
var anObject = __webpack_require__(16);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(478);
var from = __webpack_require__(448);
var metadata = __webpack_require__(94);
var anObject = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(67);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(94);
var anObject = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(67);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(94);
var anObject = __webpack_require__(16);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(94);
var anObject = __webpack_require__(16);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(94);
var anObject = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(67);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(94);
var anObject = __webpack_require__(16);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(94);
var anObject = __webpack_require__(16);
var aFunction = __webpack_require__(49);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(228)('Set');


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(229)('Set');


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(9);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(452)('Set') });


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(9);
var $at = __webpack_require__(295)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(9);
var defined = __webpack_require__(83);
var toLength = __webpack_require__(41);
var isRegExp = __webpack_require__(224);
var getFlags = __webpack_require__(222);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(287)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(9);
var $pad = __webpack_require__(473);
var userAgent = __webpack_require__(301);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(9);
var $pad = __webpack_require__(473);
var userAgent = __webpack_require__(301);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(144)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(144)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(302)('asyncIterator');


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(302)('observable');


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(9);

$export($export.S, 'System', { global: __webpack_require__(19) });


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(228)('WeakMap');


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(229)('WeakMap');


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(228)('WeakSet');


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(229)('WeakSet');


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(304);
var getKeys = __webpack_require__(126);
var redefine = __webpack_require__(57);
var global = __webpack_require__(19);
var hide = __webpack_require__(56);
var Iterators = __webpack_require__(142);
var wks = __webpack_require__(33);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(9);
var $task = __webpack_require__(299);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(19);
var $export = __webpack_require__(9);
var userAgent = __webpack_require__(301);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1190);
__webpack_require__(1129);
__webpack_require__(1131);
__webpack_require__(1130);
__webpack_require__(1133);
__webpack_require__(1135);
__webpack_require__(1140);
__webpack_require__(1134);
__webpack_require__(1132);
__webpack_require__(1142);
__webpack_require__(1141);
__webpack_require__(1137);
__webpack_require__(1138);
__webpack_require__(1136);
__webpack_require__(1128);
__webpack_require__(1139);
__webpack_require__(1143);
__webpack_require__(1144);
__webpack_require__(1096);
__webpack_require__(1098);
__webpack_require__(1097);
__webpack_require__(1146);
__webpack_require__(1145);
__webpack_require__(1116);
__webpack_require__(1126);
__webpack_require__(1127);
__webpack_require__(1117);
__webpack_require__(1118);
__webpack_require__(1119);
__webpack_require__(1120);
__webpack_require__(1121);
__webpack_require__(1122);
__webpack_require__(1123);
__webpack_require__(1124);
__webpack_require__(1125);
__webpack_require__(1099);
__webpack_require__(1100);
__webpack_require__(1101);
__webpack_require__(1102);
__webpack_require__(1103);
__webpack_require__(1104);
__webpack_require__(1105);
__webpack_require__(1106);
__webpack_require__(1107);
__webpack_require__(1108);
__webpack_require__(1109);
__webpack_require__(1110);
__webpack_require__(1111);
__webpack_require__(1112);
__webpack_require__(1113);
__webpack_require__(1114);
__webpack_require__(1115);
__webpack_require__(1177);
__webpack_require__(1182);
__webpack_require__(1189);
__webpack_require__(1180);
__webpack_require__(1172);
__webpack_require__(1173);
__webpack_require__(1178);
__webpack_require__(1183);
__webpack_require__(1185);
__webpack_require__(1168);
__webpack_require__(1169);
__webpack_require__(1170);
__webpack_require__(1171);
__webpack_require__(1174);
__webpack_require__(1175);
__webpack_require__(1176);
__webpack_require__(1179);
__webpack_require__(1181);
__webpack_require__(1184);
__webpack_require__(1186);
__webpack_require__(1187);
__webpack_require__(1188);
__webpack_require__(1091);
__webpack_require__(1093);
__webpack_require__(1092);
__webpack_require__(1095);
__webpack_require__(1094);
__webpack_require__(1080);
__webpack_require__(1078);
__webpack_require__(1084);
__webpack_require__(1081);
__webpack_require__(1087);
__webpack_require__(1089);
__webpack_require__(1077);
__webpack_require__(1083);
__webpack_require__(1074);
__webpack_require__(1088);
__webpack_require__(1072);
__webpack_require__(1086);
__webpack_require__(1085);
__webpack_require__(1079);
__webpack_require__(1082);
__webpack_require__(1071);
__webpack_require__(1073);
__webpack_require__(1076);
__webpack_require__(1075);
__webpack_require__(1090);
__webpack_require__(304);
__webpack_require__(1162);
__webpack_require__(1167);
__webpack_require__(477);
__webpack_require__(1163);
__webpack_require__(1164);
__webpack_require__(1165);
__webpack_require__(1166);
__webpack_require__(1147);
__webpack_require__(476);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(1202);
__webpack_require__(1191);
__webpack_require__(1192);
__webpack_require__(1197);
__webpack_require__(1200);
__webpack_require__(1201);
__webpack_require__(1195);
__webpack_require__(1198);
__webpack_require__(1196);
__webpack_require__(1199);
__webpack_require__(1193);
__webpack_require__(1194);
__webpack_require__(1148);
__webpack_require__(1149);
__webpack_require__(1150);
__webpack_require__(1151);
__webpack_require__(1152);
__webpack_require__(1155);
__webpack_require__(1153);
__webpack_require__(1154);
__webpack_require__(1156);
__webpack_require__(1157);
__webpack_require__(1158);
__webpack_require__(1159);
__webpack_require__(1161);
__webpack_require__(1160);
__webpack_require__(1205);
__webpack_require__(1203);
__webpack_require__(1204);
__webpack_require__(1246);
__webpack_require__(1249);
__webpack_require__(1248);
__webpack_require__(1250);
__webpack_require__(1251);
__webpack_require__(1247);
__webpack_require__(1252);
__webpack_require__(1253);
__webpack_require__(1227);
__webpack_require__(1230);
__webpack_require__(1226);
__webpack_require__(1224);
__webpack_require__(1225);
__webpack_require__(1228);
__webpack_require__(1229);
__webpack_require__(1211);
__webpack_require__(1245);
__webpack_require__(1210);
__webpack_require__(1244);
__webpack_require__(1256);
__webpack_require__(1258);
__webpack_require__(1209);
__webpack_require__(1243);
__webpack_require__(1255);
__webpack_require__(1257);
__webpack_require__(1208);
__webpack_require__(1254);
__webpack_require__(1207);
__webpack_require__(1212);
__webpack_require__(1213);
__webpack_require__(1214);
__webpack_require__(1215);
__webpack_require__(1216);
__webpack_require__(1218);
__webpack_require__(1217);
__webpack_require__(1219);
__webpack_require__(1220);
__webpack_require__(1221);
__webpack_require__(1223);
__webpack_require__(1222);
__webpack_require__(1232);
__webpack_require__(1233);
__webpack_require__(1234);
__webpack_require__(1235);
__webpack_require__(1237);
__webpack_require__(1236);
__webpack_require__(1239);
__webpack_require__(1238);
__webpack_require__(1240);
__webpack_require__(1241);
__webpack_require__(1242);
__webpack_require__(1206);
__webpack_require__(1231);
__webpack_require__(1261);
__webpack_require__(1260);
__webpack_require__(1259);
module.exports = __webpack_require__(82);


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1275), __esModule: true };

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1278), __esModule: true };

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1280), __esModule: true };

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1283), __esModule: true };

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1286), __esModule: true };

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1287), __esModule: true };

/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1290), __esModule: true };

/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1291), __esModule: true };

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(480);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(135);
__webpack_require__(1311);
module.exports = __webpack_require__(34).Array.from;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(152);
__webpack_require__(135);
module.exports = __webpack_require__(1309);


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(152);
__webpack_require__(135);
module.exports = __webpack_require__(1310);


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(34);
var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(239);
__webpack_require__(135);
__webpack_require__(152);
__webpack_require__(1313);
__webpack_require__(1327);
__webpack_require__(1326);
__webpack_require__(1325);
module.exports = __webpack_require__(34).Map;


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1314);
module.exports = __webpack_require__(34).Math.trunc;


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1315);
module.exports = __webpack_require__(34).Object.assign;


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1316);
var $Object = __webpack_require__(34).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1317);
var $Object = __webpack_require__(34).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1328);
module.exports = __webpack_require__(34).Object.entries;


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1318);
var $Object = __webpack_require__(34).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1319);
module.exports = __webpack_require__(34).Object.getPrototypeOf;


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1320);
module.exports = __webpack_require__(34).Object.keys;


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1321);
module.exports = __webpack_require__(34).Object.setPrototypeOf;


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1329);
module.exports = __webpack_require__(34).Object.values;


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(239);
__webpack_require__(135);
__webpack_require__(152);
__webpack_require__(1322);
__webpack_require__(1330);
__webpack_require__(1331);
module.exports = __webpack_require__(34).Promise;


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(239);
__webpack_require__(135);
__webpack_require__(152);
__webpack_require__(1323);
__webpack_require__(1334);
__webpack_require__(1333);
__webpack_require__(1332);
module.exports = __webpack_require__(34).Set;


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1324);
__webpack_require__(239);
__webpack_require__(1335);
__webpack_require__(1336);
module.exports = __webpack_require__(34).Symbol;


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(135);
__webpack_require__(152);
module.exports = __webpack_require__(325).f('iterator');


/***/ }),
/* 1292 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(184);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(106);
var toLength = __webpack_require__(237);
var toAbsoluteIndex = __webpack_require__(1308);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(96);
var IObject = __webpack_require__(311);
var toObject = __webpack_require__(151);
var toLength = __webpack_require__(237);
var asc = __webpack_require__(1297);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(76);
var isArray = __webpack_require__(488);
var SPECIES = __webpack_require__(50)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(1296);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(77);
var createDesc = __webpack_require__(186);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(150);
var gOPS = __webpack_require__(316);
var pIE = __webpack_require__(185);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1300 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(236);
var descriptor = __webpack_require__(186);
var setToStringTag = __webpack_require__(187);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(105)(IteratorPrototype, __webpack_require__(50)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(53);
var macrotask = __webpack_require__(503).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(183)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(150);
var gOPS = __webpack_require__(316);
var pIE = __webpack_require__(185);
var toObject = __webpack_require__(151);
var IObject = __webpack_require__(311);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(133)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(77);
var anObject = __webpack_require__(87);
var getKeys = __webpack_require__(150);

module.exports = __webpack_require__(88) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(106);
var gOPN = __webpack_require__(492).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(76);
var anObject = __webpack_require__(87);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(96)(Function.call, __webpack_require__(315).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(321);
var defined = __webpack_require__(308);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(321);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(87);
var get = __webpack_require__(326);
module.exports = __webpack_require__(34).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(234);
var ITERATOR = __webpack_require__(50)('iterator');
var Iterators = __webpack_require__(149);
module.exports = __webpack_require__(34).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(96);
var $export = __webpack_require__(42);
var toObject = __webpack_require__(151);
var call = __webpack_require__(489);
var isArrayIter = __webpack_require__(487);
var toLength = __webpack_require__(237);
var createProperty = __webpack_require__(1298);
var getIterFn = __webpack_require__(326);

$export($export.S + $export.F * !__webpack_require__(490)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1292);
var step = __webpack_require__(491);
var Iterators = __webpack_require__(149);
var toIObject = __webpack_require__(106);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(312)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(482);
var validate = __webpack_require__(323);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(484)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(42);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(42);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1303) });


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(42);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(236) });


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(42);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(88), 'Object', { defineProperty: __webpack_require__(77).f });


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(106);
var $getOwnPropertyDescriptor = __webpack_require__(315).f;

__webpack_require__(317)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(151);
var $getPrototypeOf = __webpack_require__(493);

__webpack_require__(317)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(151);
var $keys = __webpack_require__(150);

__webpack_require__(317)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(42);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1306).set });


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(235);
var global = __webpack_require__(53);
var ctx = __webpack_require__(96);
var classof = __webpack_require__(234);
var $export = __webpack_require__(42);
var isObject = __webpack_require__(76);
var aFunction = __webpack_require__(182);
var anInstance = __webpack_require__(307);
var forOf = __webpack_require__(184);
var speciesConstructor = __webpack_require__(502);
var task = __webpack_require__(503).set;
var microtask = __webpack_require__(1302)();
var newPromiseCapabilityModule = __webpack_require__(314);
var perform = __webpack_require__(496);
var promiseResolve = __webpack_require__(497);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(50)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(318)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(187)($Promise, PROMISE);
__webpack_require__(501)(PROMISE);
Wrapper = __webpack_require__(34)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(490)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(482);
var validate = __webpack_require__(323);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(484)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(53);
var has = __webpack_require__(134);
var DESCRIPTORS = __webpack_require__(88);
var $export = __webpack_require__(42);
var redefine = __webpack_require__(498);
var META = __webpack_require__(313).KEY;
var $fails = __webpack_require__(133);
var shared = __webpack_require__(320);
var setToStringTag = __webpack_require__(187);
var uid = __webpack_require__(238);
var wks = __webpack_require__(50);
var wksExt = __webpack_require__(325);
var wksDefine = __webpack_require__(324);
var enumKeys = __webpack_require__(1299);
var isArray = __webpack_require__(488);
var anObject = __webpack_require__(87);
var isObject = __webpack_require__(76);
var toIObject = __webpack_require__(106);
var toPrimitive = __webpack_require__(322);
var createDesc = __webpack_require__(186);
var _create = __webpack_require__(236);
var gOPNExt = __webpack_require__(1305);
var $GOPD = __webpack_require__(315);
var $DP = __webpack_require__(77);
var $keys = __webpack_require__(150);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(492).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(185).f = $propertyIsEnumerable;
  __webpack_require__(316).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(235)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(105)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(499)('Map');


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(500)('Map');


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(42);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(483)('Map') });


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(42);
var $entries = __webpack_require__(495)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(42);
var $values = __webpack_require__(495)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(42);
var core = __webpack_require__(34);
var global = __webpack_require__(53);
var speciesConstructor = __webpack_require__(502);
var promiseResolve = __webpack_require__(497);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(42);
var newPromiseCapability = __webpack_require__(314);
var perform = __webpack_require__(496);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(499)('Set');


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(500)('Set');


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(42);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(483)('Set') });


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(324)('asyncIterator');


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(324)('observable');


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var DuplexStream = __webpack_require__(1613)
  , util         = __webpack_require__(1531)


function BufferList (callback) {
  if (!(this instanceof BufferList))
    return new BufferList(callback)

  this._bufs  = []
  this.length = 0

  if (typeof callback == 'function') {
    this._callback = callback

    var piper = function piper (err) {
      if (this._callback) {
        this._callback(err)
        this._callback = null
      }
    }.bind(this)

    this.on('pipe', function onPipe (src) {
      src.on('error', piper)
    })
    this.on('unpipe', function onUnpipe (src) {
      src.removeListener('error', piper)
    })
  } else {
    this.append(callback)
  }

  DuplexStream.call(this)
}


util.inherits(BufferList, DuplexStream)


BufferList.prototype._offset = function _offset (offset) {
  var tot = 0, i = 0, _t
  if (offset === 0) return [ 0, 0 ]
  for (; i < this._bufs.length; i++) {
    _t = tot + this._bufs[i].length
    if (offset < _t || i == this._bufs.length - 1)
      return [ i, offset - tot ]
    tot = _t
  }
}


BufferList.prototype.append = function append (buf) {
  var i = 0

  if (Buffer.isBuffer(buf)) {
    this._appendBuffer(buf);
  } else if (Array.isArray(buf)) {
    for (; i < buf.length; i++)
      this.append(buf[i])
  } else if (buf instanceof BufferList) {
    // unwrap argument into individual BufferLists
    for (; i < buf._bufs.length; i++)
      this.append(buf._bufs[i])
  } else if (buf != null) {
    // coerce number arguments to strings, since Buffer(number) does
    // uninitialized memory allocation
    if (typeof buf == 'number')
      buf = buf.toString()

    this._appendBuffer(new Buffer(buf));
  }

  return this
}


BufferList.prototype._appendBuffer = function appendBuffer (buf) {
  this._bufs.push(buf)
  this.length += buf.length
}


BufferList.prototype._write = function _write (buf, encoding, callback) {
  this._appendBuffer(buf)

  if (typeof callback == 'function')
    callback()
}


BufferList.prototype._read = function _read (size) {
  if (!this.length)
    return this.push(null)

  size = Math.min(size, this.length)
  this.push(this.slice(0, size))
  this.consume(size)
}


BufferList.prototype.end = function end (chunk) {
  DuplexStream.prototype.end.call(this, chunk)

  if (this._callback) {
    this._callback(null, this.slice())
    this._callback = null
  }
}


BufferList.prototype.get = function get (index) {
  return this.slice(index, index + 1)[0]
}


BufferList.prototype.slice = function slice (start, end) {
  if (typeof start == 'number' && start < 0)
    start += this.length
  if (typeof end == 'number' && end < 0)
    end += this.length
  return this.copy(null, 0, start, end)
}


BufferList.prototype.copy = function copy (dst, dstStart, srcStart, srcEnd) {
  if (typeof srcStart != 'number' || srcStart < 0)
    srcStart = 0
  if (typeof srcEnd != 'number' || srcEnd > this.length)
    srcEnd = this.length
  if (srcStart >= this.length)
    return dst || new Buffer(0)
  if (srcEnd <= 0)
    return dst || new Buffer(0)

  var copy   = !!dst
    , off    = this._offset(srcStart)
    , len    = srcEnd - srcStart
    , bytes  = len
    , bufoff = (copy && dstStart) || 0
    , start  = off[1]
    , l
    , i

  // copy/slice everything
  if (srcStart === 0 && srcEnd == this.length) {
    if (!copy) { // slice, but full concat if multiple buffers
      return this._bufs.length === 1
        ? this._bufs[0]
        : Buffer.concat(this._bufs, this.length)
    }

    // copy, need to copy individual buffers
    for (i = 0; i < this._bufs.length; i++) {
      this._bufs[i].copy(dst, bufoff)
      bufoff += this._bufs[i].length
    }

    return dst
  }

  // easy, cheap case where it's a subset of one of the buffers
  if (bytes <= this._bufs[off[0]].length - start) {
    return copy
      ? this._bufs[off[0]].copy(dst, dstStart, start, start + bytes)
      : this._bufs[off[0]].slice(start, start + bytes)
  }

  if (!copy) // a slice, we need something to copy in to
    dst = new Buffer(len)

  for (i = off[0]; i < this._bufs.length; i++) {
    l = this._bufs[i].length - start

    if (bytes > l) {
      this._bufs[i].copy(dst, bufoff, start)
    } else {
      this._bufs[i].copy(dst, bufoff, start, start + bytes)
      break
    }

    bufoff += l
    bytes -= l

    if (start)
      start = 0
  }

  return dst
}

BufferList.prototype.shallowSlice = function shallowSlice (start, end) {
  start = start || 0
  end = end || this.length

  if (start < 0)
    start += this.length
  if (end < 0)
    end += this.length

  var startOffset = this._offset(start)
    , endOffset = this._offset(end)
    , buffers = this._bufs.slice(startOffset[0], endOffset[0] + 1)

  if (endOffset[1] == 0)
    buffers.pop()
  else
    buffers[buffers.length-1] = buffers[buffers.length-1].slice(0, endOffset[1])

  if (startOffset[1] != 0)
    buffers[0] = buffers[0].slice(startOffset[1])

  return new BufferList(buffers)
}

BufferList.prototype.toString = function toString (encoding, start, end) {
  return this.slice(start, end).toString(encoding)
}

BufferList.prototype.consume = function consume (bytes) {
  while (this._bufs.length) {
    if (bytes >= this._bufs[0].length) {
      bytes -= this._bufs[0].length
      this.length -= this._bufs[0].length
      this._bufs.shift()
    } else {
      this._bufs[0] = this._bufs[0].slice(bytes)
      this.length -= bytes
      break
    }
  }
  return this
}


BufferList.prototype.duplicate = function duplicate () {
  var i = 0
    , copy = new BufferList()

  for (; i < this._bufs.length; i++)
    copy.append(this._bufs[i])

  return copy
}


BufferList.prototype.destroy = function destroy () {
  this._bufs.length = 0
  this.length = 0
  this.push(null)
}


;(function () {
  var methods = {
      'readDoubleBE' : 8
    , 'readDoubleLE' : 8
    , 'readFloatBE'  : 4
    , 'readFloatLE'  : 4
    , 'readInt32BE'  : 4
    , 'readInt32LE'  : 4
    , 'readUInt32BE' : 4
    , 'readUInt32LE' : 4
    , 'readInt16BE'  : 2
    , 'readInt16LE'  : 2
    , 'readUInt16BE' : 2
    , 'readUInt16LE' : 2
    , 'readInt8'     : 1
    , 'readUInt8'    : 1
  }

  for (var m in methods) {
    (function (m) {
      BufferList.prototype[m] = function (offset) {
        return this.slice(offset, offset + methods[m])[m](0)
      }
    }(m))
  }
}())


module.exports = BufferList

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(188).Buffer))

/***/ }),
/* 1339 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }
  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};
  var args = [].slice.call(arguments, 1)
    , callbacks = this._callbacks['$' + event];

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var deselectCurrent = __webpack_require__(1654);

var defaultMessage = 'Copy to clipboard: #{key}, Enter';

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl') + '+C';
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug, message, reselectPrevious, range, selection, mark, success = false;
  if (!options) { options = {}; }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement('span');
    mark.textContent = text;
    // reset user styles for span element
    mark.style.all = 'unset';
    // prevents scrolling to the end of the page
    mark.style.position = 'fixed';
    mark.style.top = 0;
    mark.style.clip = 'rect(0, 0, 0, 0)';
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = 'pre';
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = 'text';
    mark.style.MozUserSelect = 'text';
    mark.style.msUserSelect = 'text';
    mark.style.userSelect = 'text';

    document.body.appendChild(mark);

    range.selectNode(mark);
    selection.addRange(range);

    var successful = document.execCommand('copy');
    if (!successful) {
      throw new Error('copy command was unsuccessful');
    }
    success = true;
  } catch (err) {
    debug && console.error('unable to copy using execCommand: ', err);
    debug && console.warn('trying IE specific stuff');
    try {
      window.clipboardData.setData('text', text);
      success = true;
    } catch (err) {
      debug && console.error('unable to copy using clipboardData: ', err);
      debug && console.error('falling back to prompt');
      message = format('message' in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == 'function') {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (false) {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = "production" === 'production'; // the big drawback here is that the css won't be editable in devtools

    this.tags = [];
    this.ctr = 0;
    this.opts = options;
  }

  var _proto = StyleSheet.prototype;

  _proto.inject = function inject() {
    if (this.injected) {
      throw new Error('already injected!');
    }

    this.tags[0] = makeStyleTag(this.opts);
    this.injected = true;
  };

  _proto.speedy = function speedy(bool) {
    if (this.ctr !== 0) {
      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
      throw new Error("cannot change speedy now");
    }

    this.isSpeedy = !!bool;
  };

  _proto.insert = function insert(rule, sourceMap) {
    // this is the ultrafast version, works across browsers
    if (this.isSpeedy) {
      var tag = this.tags[this.tags.length - 1];
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn('illegal rule', rule); // eslint-disable-line no-console
        }
      }
    } else {
      var _tag = makeStyleTag(this.opts);

      this.tags.push(_tag);

      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
    }

    this.ctr++;

    if (this.ctr % 65000 === 0) {
      this.tags.push(makeStyleTag(this.opts));
    }
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0; // todo - look for remnants in document.styleSheets

    this.injected = false;
  };

  return StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (false) {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && "production" !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + "{" + caches.registered[obj[key]] + "}";
          } else {
            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
            });
          } else {
            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createClassName = function createClassName(styles, identifierName) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
  };

  if (false) {
    var oldCreateClassName = createClassName;
    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    createClassName = function createClassName(styles, identifierName) {
      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
        currentSourceMap = sourceMap;
        return '';
      }), identifierName);
    };
  }

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = createClassName(styles, identifierName);
    return styles;
  };

  if (false) {
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);
//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var W = function da(X) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, J = 0, k, u = k = q = 0, l = 0, r = 0, z = 0, t = 0, K = e.length, I = K - 1, y, f = '', p = '', F = '', G = '', C; l < K;) {
      g = e.charCodeAt(l);
      l === I && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, K++, I++);

      if (0 === b + n + v + m) {
        if (l === I && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < K;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < I; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < I && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ea, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < B && (r = Y(O, f, z), C = H(3, k, r, c, D, A, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(fa, ha);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(ia, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, Y(c, f, z), k, h, a + 1);
            }

            F += k;
            k = z = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < B && void 0 !== (C = H(1, f, c, d, D, A, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            z = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < B * Z && H(0, f, c, d, D, A, p.length, h, a, h);
          A = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            A++;
            break;
          }

        default:
          A++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = z = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === J && (E = J);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * J) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      J = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < B && (C = H(2, p, r, d, D, A, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ja, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function Y(d, c, e) {
    var h = c.trim().split(ka);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = aa(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = aa(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function aa(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(la, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ma.test(a) ? a.replace(ba, ':-webkit-') + a.replace(ba, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ca, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ca, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === na.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(oa, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(pa, '$1'), e, c);
  }

  function ha(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(qa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < B; ++g) {
      switch (w = S[g].call(z, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        B = S.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, e = d.length; c < e; ++c) {
              T(d[c]);
            }

            break;

          case Function:
            S[B++] = d;
            break;

          case Boolean:
            Z = !!d | 0;
        }

    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function z(d, c) {
    if (void 0 !== this && this.constructor === z) return da(d);
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < B) {
      var h = H(-1, c, e, e, D, A, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < B && (h = H(-2, a, e, e, D, A, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    A = D = 1;
    return a;
  }

  var ea = /^\0+/g,
      N = /[\0\r\f]/g,
      ba = /: */g,
      ma = /zoo|gra/,
      oa = /([,: ])(transform)/g,
      ka = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      ia = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ja = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      fa = /\(\s*(.*)\s*\)/g,
      qa = /([\s\S]*?);/g,
      ca = /-self|flex-/g,
      pa = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      na = /stretch|:\s*\w+\-(?:conte|avail)/,
      la = /([^-])(image-set\()/,
      A = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      B = 0,
      R = null,
      Z = 0,
      V = '';
  z.use = T;
  z.set = U;
  void 0 !== X && U(X);
  return z;
};

/* harmony default export */ __webpack_exports__["a"] = (W);
//# sourceMappingURL=stylis.esm.js.map


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(155);

var emptyObject = __webpack_require__(329);
var _invariant = __webpack_require__(107);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 1346 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

module.exports = function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};


/***/ }),
/* 1347 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 1348 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(1350);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element)) element.className = element.className + ' ' + className;
}
module.exports = exports['default'];

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + element.className + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(504);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;


  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};


function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(504);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, process) {var stream = __webpack_require__(245)
var eos = __webpack_require__(505)
var inherits = __webpack_require__(90)
var shift = __webpack_require__(1647)

var SIGNAL_FLUSH = new Buffer([0])

var onuncork = function(self, fn) {
  if (self._corked) self.once('uncork', fn)
  else fn()
}

var destroyer = function(self, end) {
  return function(err) {
    if (err) self._destroyInterval(err)
    else if (end && !self._ended) self.end()
  }
}

var end = function(ws, fn) {
  if (!ws) return fn()
  if (ws._writableState && ws._writableState.finished) return fn()
  if (ws._writableState) return ws.end(fn)
  ws.end()
  fn()
}

var toStreams2 = function(rs) {
  return new (stream.Readable)({objectMode:true, highWaterMark:16}).wrap(rs)
}

var Duplexify = function(writable, readable, opts) {
  if (!(this instanceof Duplexify)) return new Duplexify(writable, readable, opts)
  stream.Duplex.call(this, opts)

  this._writable = null
  this._readable = null
  this._readable2 = null

  this._forwardDestroy = !opts || opts.destroy !== false
  this._forwardEnd = !opts || opts.end !== false
  this._corked = 1 // start corked
  this._ondrain = null
  this._drained = false
  this._forwarding = false
  this._unwrite = null
  this._unread = null
  this._ended = false
  this._error = null
  this._preferError = false

  this.destroyed = false

  if (writable) this.setWritable(writable)
  if (readable) this.setReadable(readable)
}

inherits(Duplexify, stream.Duplex)

Duplexify.obj = function(writable, readable, opts) {
  if (!opts) opts = {}
  opts.objectMode = true
  opts.highWaterMark = 16
  return new Duplexify(writable, readable, opts)
}

Duplexify.prototype.cork = function() {
  if (++this._corked === 1) this.emit('cork')
}

Duplexify.prototype.uncork = function() {
  if (this._corked && --this._corked === 0) this.emit('uncork')
}

Duplexify.prototype.setWritable = function(writable) {
  if (this._unwrite) this._unwrite()

  if (this.destroyed) {
    if (writable && writable.destroy) writable.destroy()
    return
  }

  if (writable === null || writable === false) {
    this.end()
    return
  }

  var self = this
  var unend = eos(writable, {writable:true, readable:false}, destroyer(this, this._forwardEnd))

  var ondrain = function() {
    var ondrain = self._ondrain
    self._ondrain = null
    if (ondrain) ondrain()
  }

  var clear = function() {
    self._writable.removeListener('drain', ondrain)
    unend()
  }

  if (this._unwrite) process.nextTick(ondrain) // force a drain on stream reset to avoid livelocks

  this._writable = writable
  this._writable.on('drain', ondrain)
  this._unwrite = clear

  this.uncork() // always uncork setWritable
}

Duplexify.prototype.setReadable = function(readable) {
  if (this._unread) this._unread()

  if (this.destroyed) {
    if (readable && readable.destroy) readable.destroy()
    return
  }

  if (readable === null || readable === false) {
    this.push(null)
    this.resume()
    return
  }

  var self = this
  var unend = eos(readable, {writable:false, readable:true}, destroyer(this))

  var onreadable = function() {
    self._forward()
  }

  var onend = function() {
    self.push(null)
  }

  var clear = function() {
    self._readable2.removeListener('readable', onreadable)
    self._readable2.removeListener('end', onend)
    unend()
  }

  this._drained = true
  this._readable = readable
  this._readable2 = readable._readableState ? readable : toStreams2(readable)
  this._readable2.on('readable', onreadable)
  this._readable2.on('end', onend)
  this._unread = clear

  this._forward()
}

Duplexify.prototype._read = function() {
  this._drained = true
  this._forward()
}

Duplexify.prototype._forward = function() {
  if (this._forwarding || !this._readable2 || !this._drained) return
  this._forwarding = true

  var data

  while (this._drained && (data = shift(this._readable2)) !== null) {
    if (this.destroyed) continue
    this._drained = this.push(data)
  }

  this._forwarding = false
}

Duplexify.prototype.destroy = function(err) {
  if (this._preferError && !this._error && err) this._error = err

  if (this.destroyed) return
  this.destroyed = true

  var self = this
  process.nextTick(function() {
    self._destroy(self._preferError ? self._error : err)
  })
}

Duplexify.prototype._destroyInterval = function(err) {
  if (this.destroyed) return
  if (err.message !== 'premature close') return this.destroy(err)
  this._preferError = true
  this.destroy(null)
}

Duplexify.prototype._destroy = function(err) {
  if (err) {
    var ondrain = this._ondrain
    this._ondrain = null
    if (ondrain) ondrain(err)
    else this.emit('error', err)
  }

  if (this._forwardDestroy) {
    if (this._readable && this._readable.destroy) this._readable.destroy()
    if (this._writable && this._writable.destroy) this._writable.destroy()
  }

  this.emit('close')
}

Duplexify.prototype._write = function(data, enc, cb) {
  if (this.destroyed) return cb()
  if (this._corked) return onuncork(this, this._write.bind(this, data, enc, cb))
  if (data === SIGNAL_FLUSH) return this._finish(cb)
  if (!this._writable) return cb()

  if (this._writable.write(data) === false) this._ondrain = cb
  else cb()
}


Duplexify.prototype._finish = function(cb) {
  var self = this
  this.emit('preend')
  onuncork(this, function() {
    end(self._forwardEnd && self._writable, function() {
      // haxx to not emit prefinish twice
      if (self._writableState.prefinished === false) self._writableState.prefinished = true
      self.emit('prefinish')
      onuncork(self, cb)
    })
  })
}

Duplexify.prototype.end = function(data, enc, cb) {
  if (typeof data === 'function') return this.end(null, null, data)
  if (typeof enc === 'function') return this.end(data, null, enc)
  this._ended = true
  if (data) this.write(data)
  if (!this._writableState.ending) this.write(SIGNAL_FLUSH)
  return stream.Writable.prototype.end.call(this, cb)
}

module.exports = Duplexify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(188).Buffer, __webpack_require__(59)))

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export flush */
/* unused harmony export hydrate */
/* unused harmony export cx */
/* unused harmony export merge */
/* unused harmony export getRegisteredStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return injectGlobal; });
/* unused harmony export keyframes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return css; });
/* unused harmony export sheet */
/* unused harmony export caches */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(1343);


var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(context),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(30)))

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\"","embedded-tweet-theme":"light","embedded-tweet-link-color":"#32579e"};

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1407 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1410 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1429 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1459 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1461 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"animations-highlightNewDataDuration":"4000","animations-fadeInDuration":"250","tabs-arrowWidth":"25","adverts-smallBannerHeight":"50","adverts-mediumBannerWidth":"728","adverts-mediumBannerSafeWidth":"748","adverts-mediumBannerHeight":"90","adverts-billboardBannerHeight":"250","adverts-billboardBannerWidth":"970","adverts-billboardBannerSafeWidth":"990","adverts-singleMpuHeight":"250","adverts-doubleMpuHeight":"600","media-mobile":"\"screen and (max-width: 674px)\"","media-tablet":"\"screen and (min-width: 675px) and (max-width: 1019px)\"","media-desktop":"\"screen and (min-width: 1020px)\"","media-notMobile":"\"screen and (min-width: 675px)\"","media-notTablet":"\"screen and (max-width: 674px), screen and (min-width: 1020px)\"","media-notDesktop":"\"screen and (max-width: 1019px)\""};

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(240);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(1468);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(1467);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 1470 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {// Coding standard for this project defined @ https://github.com/MatthewSH/standards/blob/master/JavaScript.md


exports = module.exports = !!(typeof process !== 'undefined' && process.versions && process.versions.node);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 1472 */
/***/ (function(module, exports) {

module.exports = {
	"version": "2016i",
	"zones": [
		"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
		"Africa/Accra|LMT GMT GHST|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
		"Africa/Nairobi|LMT EAT BEAT BEAUT|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
		"Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
		"Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
		"Africa/Bissau|LMT WAT GMT|12.k 10 0|012|-2ldWV.E 2xonV.E|39e4",
		"Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
		"Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
		"Africa/Casablanca|LMT WET WEST CET|u.k 0 -10 -10|0121212121212121213121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|32e5",
		"Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1y7p0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
		"Africa/El_Aaiun|LMT WAT WET WEST|Q.M 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 Rc0 11A0 e00 e00 U00 11A0 8o0 e00 11A0 11A0 5A0 e00 17c0 1fA0 1a00 1a00 1fA0 17c0 1io0 14o0 1lc0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1lc0 14o0 1fA0|20e4",
		"Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
		"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|01212121212121212121212121212121213|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|51e5",
		"Africa/Monrovia|MMT LRT GMT|H.8 I.u 0|012|-23Lzg.Q 29s01.m|11e5",
		"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
		"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
		"Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
		"Africa/Windhoek|SWAT SAST SAST CAT WAT WAST|-1u -20 -30 -20 -10 -20|012134545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2GJdu 1Ajdu 1cL0 1SqL0 9NA0 11D0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0|32e4",
		"America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
		"America/Anchorage|CAT CAWT CAPT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
		"America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
		"America/Araguaina|LMT BRT BRST|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
		"America/Argentina/Buenos_Aires|CMT ART ARST ART ARST|4g.M 40 30 30 20|0121212121212121212121212121212121212121213434343434343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0",
		"America/Argentina/Catamarca|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
		"America/Argentina/Cordoba|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343454343234343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0 1qN0 WL0",
		"America/Argentina/Jujuy|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 g0p0 10M0 j3c0 uL0",
		"America/Argentina/La_Rioja|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
		"America/Argentina/Mendoza|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|0121212121212121212121212121212121212121213434345656543235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 g0p0 10M0 agM0 Op0 7TX0 uL0",
		"America/Argentina/Rio_Gallegos|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ako0 7B0 8zb0 uL0",
		"America/Argentina/Salta|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434543432343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 j3c0 uL0",
		"America/Argentina/San_Juan|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|01212121212121212121212121212121212121212134343434534343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 g0p0 10M0 ak00 m10 8lb0 uL0",
		"America/Argentina/San_Luis|CMT ART ARST ART ARST WART WARST|4g.M 40 30 30 20 40 30|01212121212121212121212121212121212121212134343456536353465653|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 kin0 10M0 ak00 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0",
		"America/Argentina/Tucuman|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|012121212121212121212121212121212121212121343434345434323534343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 g0p0 10M0 ako0 4N0 8BX0 uL0 1qN0 WL0",
		"America/Argentina/Ushuaia|CMT ART ARST ART ARST WART|4g.M 40 30 30 20 40|0121212121212121212121212121212121212121213434343434343235343|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 g0p0 10M0 ajA0 8p0 8zb0 uL0",
		"America/Curacao|LMT ANT AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
		"America/Asuncion|AMT PYT PYT PYST|3O.E 40 30 30|012131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
		"America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
		"America/Bahia|LMT BRT BRST|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
		"America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
		"America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
		"America/Belem|LMT BRT BRST|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
		"America/Belize|LMT CST CHDT CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
		"America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
		"America/Boa_Vista|LMT AMT AMST|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
		"America/Bogota|BMT COT COST|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
		"America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
		"America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
		"America/Campo_Grande|LMT AMT AMST|3C.s 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|77e4",
		"America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
		"America/Caracas|CMT VET VET|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
		"America/Cayenne|LMT GFT GFT|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
		"America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
		"America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
		"America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
		"America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
		"America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
		"America/Cuiaba|LMT AMT AMST|3I.k 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|54e4",
		"America/Danmarkshavn|LMT WGT WGST GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
		"America/Dawson|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|13e2",
		"America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
		"America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
		"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|01234252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 Jy10 SL0 dnB0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
		"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|01212121212121341212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 LFB0 1cL0 3Cp0 1cL0 66N0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
		"America/Eirunepe|LMT ACT ACST AMT|4D.s 50 40 40|0121212121212121212121212121212131|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
		"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
		"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
		"America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
		"America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Fortaleza|LMT BRT BRST|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
		"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
		"America/Godthab|LMT WGT WGST|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
		"America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
		"America/Grand_Turk|KMT EST EDT AST|57.b 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212123|-2l1uQ.N 2HHBQ.N 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
		"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
		"America/Guayaquil|QMT ECT|5e 50|01|-1yVSK|27e5",
		"America/Guyana|LMT GBGT GYT GYT GYT|3Q.E 3J 3J 30 40|01234|-2dvU7.k 24JzQ.k mlc0 Bxbf|80e4",
		"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
		"America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
		"America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
		"America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
		"America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
		"America/Jamaica|KMT EST EDT|57.b 50 40|0121212121212121212121|-2l1uQ.N 2uM1Q.N 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
		"America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
		"America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 Bb0 10N0 2bB0 8in0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/La_Paz|CMT BOST BOT|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
		"America/Lima|LMT PET PEST|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
		"America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
		"America/Maceio|LMT BRT BRST|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
		"America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
		"America/Manaus|LMT AMT AMST|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
		"America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
		"America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
		"America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
		"America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
		"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
		"America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|0120303030303030303030303030303030454545454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
		"America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
		"America/Miquelon|LMT AST PMST PMDT|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
		"America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
		"America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
		"America/Montevideo|MMT UYT UYHST UYST UYT UYHST|3I.I 3u 30 20 30 2u|012121212121212121212121213434343434345454543453434343434343434343434343434343434343434|-20UIf.g 8jzJ.g 1cLu 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1qMu WLu 1qMu 11zu 1o0u 11zu NAu 11bu 2iMu zWu Dq10 19X0 pd0 jz0 cm10 19X0 1fB0 1on0 11d0 1oL0 1nB0 1fzu 1aou 1fzu 1aou 1fzu 3nAu Jb0 3MN0 1SLu 4jzu 2PB0 Lb0 3Dd0 1pb0 ixd0 An0 1MN0 An0 1wp0 On0 1wp0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
		"America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
		"America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
		"America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
		"America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
		"America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
		"America/Noronha|LMT FNT FNST|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
		"America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
		"America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
		"America/Paramaribo|LMT PMT PMT NEGT SRT SRT|3E.E 3E.Q 3E.A 3u 3u 30|012345|-2nDUj.k Wqo0.c qanX.I 1dmLN.o lzc0|24e4",
		"America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
		"America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
		"America/Rio_Branco|LMT ACT ACST AMT|4v.c 50 40 40|01212121212121212121212121212131|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
		"America/Porto_Velho|LMT AMT AMST|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
		"America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
		"America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
		"America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
		"America/Recife|LMT BRT BRST|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
		"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
		"America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
		"America/Santarem|LMT AMT AMST BRT|3C.M 40 30 30|0121212121212121212121212121213|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
		"America/Santiago|SMT CLT CLT CLST CLST|4G.K 50 40 40 30|010203131313131212421242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|62e5",
		"America/Santo_Domingo|SDMT EST EDT EHDT AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
		"America/Sao_Paulo|LMT BRT BRST|36.s 30 20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1C10 Lz0 1C10 Lz0 1C10 Lz0 1C10 On0 1zd0 Rb0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0|20e6",
		"America/Scoresbysund|LMT CGT CGST EGST EGT|1r.Q 20 10 0 10|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
		"America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
		"America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
		"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
		"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
		"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
		"America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
		"America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
		"America/Whitehorse|YST YDT YWT YPT YDDT PST PDT|90 80 80 80 70 80 70|0101023040565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
		"America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
		"America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
		"America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
		"Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212|-2q00 1DjS0 T90 40P0 KL0 blz0|10",
		"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
		"Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
		"Antarctica/Macquarie|AEST AEDT -00 MIST|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
		"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
		"Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
		"Antarctica/Palmer|-00 ARST ART ART ARST CLT CLST|0 30 40 30 20 40 30|0121212121234356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|40",
		"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
		"Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
		"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
		"Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
		"Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
		"Asia/Riyadh|LMT AST|-36.Q -30|01|-TvD6.Q|57e5",
		"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
		"Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
		"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
		"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
		"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
		"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
		"Asia/Baghdad|BMT AST ADT|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
		"Asia/Qatar|LMT GST AST|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
		"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
		"Asia/Bangkok|BMT ICT|-6G.4 -70|01|-218SG.4|15e6",
		"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
		"Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
		"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
		"Asia/Brunei|LMT BNT BNT|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
		"Asia/Kolkata|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0|15e6",
		"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
		"Asia/Choibalsan|LMT ULAT ULAT CHOST CHOT CHOT CHOST|-7C -70 -80 -a0 -90 -80 -90|0123434343434343434343434343434343434343434343456565656565656565656565656565656565656565656565|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|38e3",
		"Asia/Shanghai|CST CDT|-80 -90|01010101010101010|-1c1I0 LX0 16p0 1jz0 1Myp0 Rb0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
		"Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
		"Asia/Dhaka|HMT BURT IST DACT BDT BDST|-5R.k -6u -5u -60 -60 -70|01213454|-18LFR.k 1unn.k HB0 m6n0 LqMu 1x6n0 1i00|16e6",
		"Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
		"Asia/Dili|LMT TLT JST TLT WITA|-8m.k -80 -90 -90 -80|012343|-2le8m.k 1dnXm.k 8HA0 1ew00 Xld0|19e4",
		"Asia/Dubai|LMT GST|-3F.c -40|01|-21JfF.c|39e5",
		"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
		"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0",
		"Asia/Gaza|EET EET EEST IST IDT|-20 -30 -30 -20 -30|010101010102020202020202020202023434343434343434343434343430202020202020202020202020202020202020202020202020202020202020202020202020202020202020|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|18e5",
		"Asia/Hebron|EET EET EEST IST IDT|-20 -30 -30 -20 -30|01010101010202020202020202020202343434343434343434343434343020202020202020202020202020202020202020202020202020202020202020202020202020202020202020|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0|25e4",
		"Asia/Ho_Chi_Minh|LMT PLMT ICT IDT JST|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
		"Asia/Hong_Kong|LMT HKT HKST JST|-7A.G -80 -90 -90|0121312121212121212121212121212121212121212121212121212121212121212121|-2CFHA.G 1sEP6.G 1cL0 ylu 93X0 1qQu 1tX0 Rd0 1In0 NB0 1cL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1kL0 14N0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
		"Asia/Hovd|LMT HOVT HOVT HOVST|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|81e3",
		"Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
		"Europe/Istanbul|IMT EET EEST +04 +03|-1U.U -20 -30 -40 -30|012121212121212121212121212121212121212121212121212121234343434342121212121212121212121212121212121212121212121212121212121212124|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSp0 CL0 mN0 1Vz0 1gN0 1pz0 5Rd0 1fz0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1jB0 18L0 1ip0 17z0 qdd0 xX0 3S10 Tz0 dA10 11z0 1o10 11z0 1qN0 11z0 1ze0 11B0 WM0 1qO0 WI0 1nX0 1rB0 10L0 11B0 1in0 17d0 1in0 2pX0 19E0 1fU0 16Q0 1iI0 16Q0 1iI0 1Vd0 pb0 3Kp0 14o0 1de0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
		"Asia/Jakarta|BMT JAVT WIB JST WIB WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
		"Asia/Jayapura|LMT WIT ACST|-9m.M -90 -9u|0121|-1uu9m.M sMMm.M L4nu|26e4",
		"Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212132121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 npB0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
		"Asia/Kabul|AFT AFT|-40 -4u|01|-10Qs0|46e5",
		"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
		"Asia/Karachi|LMT IST IST KART PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
		"Asia/Urumqi|LMT XJT|-5O.k -60|01|-1GgtO.k|32e5",
		"Asia/Kathmandu|LMT IST NPT|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
		"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
		"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
		"Asia/Kuala_Lumpur|SMT MALT MALST MALT MALT JST MYT|-6T.p -70 -7k -7k -7u -90 -80|01234546|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu 1so1u|71e5",
		"Asia/Kuching|LMT BORT BORT BORTST JST MYT|-7l.k -7u -80 -8k -90 -80|01232323232323232425|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0 1so10|13e4",
		"Asia/Macau|LMT MOT MOST CST|-7y.k -80 -90 -80|0121212121212121212121212121212121212121213|-2le7y.k 1XO34.k 1wn0 Rd0 1wn0 R9u 1wqu U10 1tz0 TVu 1tz0 17gu 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cOu 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cJu 1cL0 1cN0 1fz0 1cN0 1cL0 KEp0|57e4",
		"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
		"Asia/Makassar|LMT MMT WITA JST|-7V.A -7V.A -80 -90|01232|-21JjV.A vfc0 myLV.A 8ML0|15e5",
		"Asia/Manila|PHT PHST JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
		"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
		"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
		"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
		"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
		"Asia/Oral|LMT +04 +05 +06|-3p.o -40 -50 -60|01232323232323232121212121212121212121212121212|-1Pc3p.o eUnp.o 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
		"Asia/Pontianak|LMT PMT WIB JST WIB WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
		"Asia/Pyongyang|LMT KST JCST JST KST|-8n -8u -90 -90 -90|012341|-2um8n 97XR 12FXu jdA0 2Onc0|29e5",
		"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|0123232323232323232323232323232323232323232323|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|73e4",
		"Asia/Rangoon|RMT BURT JST MMT|-6o.E -6u -90 -6u|0123|-21Jio.E SmnS.E 7j9u|48e5",
		"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
		"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
		"Asia/Seoul|LMT KST JCST JST KST KDT KDT|-8r.Q -8u -90 -90 -90 -9u -a0|01234151515151515146464|-2um8r.Q 97XV.Q 12FXu jjA0 kKo0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
		"Asia/Singapore|SMT MALT MALST MALT MALT JST SGT SGT|-6T.p -70 -7k -7k -7u -90 -7u -80|012345467|-2Bg6T.p 17anT.p 7hXE dM00 17bO 8Fyu Mspu DTA0|56e5",
		"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
		"Asia/Taipei|JWST JST CST CDT|-80 -90 -80 -90|01232323232323232323232323232323232323232|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
		"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
		"Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
		"Asia/Tehran|LMT TMT IRST IRST IRDT IRDT|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
		"Asia/Thimphu|LMT IST BTT|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
		"Asia/Tokyo|JCST JST JDT|-90 -90 -a0|0121212121|-1iw90 pKq0 QL0 1lB0 13X0 1zB0 NX0 1zB0 NX0|38e6",
		"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
		"Asia/Ulaanbaatar|LMT ULAT ULAT ULAST|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1fx0 1cP0 1cJ0 1cP0 1cJ0 1cP0 1cJ0|12e5",
		"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
		"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
		"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
		"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
		"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
		"Atlantic/Azores|HMT AZOT AZOST AZOMT AZOT AZOST WET|1S.w 20 10 0 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545456545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldW5.s aPX5.s Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
		"Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
		"Atlantic/Canary|LMT CANT WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Atlantic/Cape_Verde|LMT CVT CVST CVT|1y.4 20 10 10|01213|-2xomp.U 1qOMp.U 7zX0 1djf0|50e4",
		"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
		"Atlantic/Madeira|FMT MADT MADST MADMT WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldWQ.o aPWQ.o Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
		"Atlantic/Reykjavik|LMT IST ISST GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
		"Atlantic/South_Georgia|GST|20|0||30",
		"Atlantic/Stanley|SMT FKT FKST FKT FKST|3P.o 40 30 30 20|0121212121212134343212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 U10 1qM0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
		"Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
		"Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
		"Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
		"Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
		"Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
		"Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
		"Australia/Eucla|ACWST ACWDT|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
		"Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
		"Australia/Lord_Howe|AEST LHST LHDT LHDT|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
		"Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
		"Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
		"Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
		"CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
		"CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Pacific/Easter|EMT EAST EASST EAST EASST|7h.s 70 60 60 50|0121212121212121212121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Dd0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1Nb0 Ap0|30e2",
		"EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
		"EST|EST|50|0|",
		"EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g5X0 14p0 1wn0 17d0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Etc/GMT+0|GMT|0|0|",
		"Etc/GMT+1|-01|10|0|",
		"Etc/GMT+10|-10|a0|0|",
		"Etc/GMT+11|-11|b0|0|",
		"Etc/GMT+12|-12|c0|0|",
		"Etc/GMT+2|-02|20|0|",
		"Etc/GMT+3|-03|30|0|",
		"Etc/GMT+4|-04|40|0|",
		"Etc/GMT+5|-05|50|0|",
		"Etc/GMT+6|-06|60|0|",
		"Etc/GMT+7|-07|70|0|",
		"Etc/GMT+8|-08|80|0|",
		"Etc/GMT+9|-09|90|0|",
		"Etc/GMT-1|+01|-10|0|",
		"Etc/GMT-10|+10|-a0|0|",
		"Etc/GMT-11|+11|-b0|0|",
		"Etc/GMT-12|+12|-c0|0|",
		"Etc/GMT-13|+13|-d0|0|",
		"Etc/GMT-14|+14|-e0|0|",
		"Etc/GMT-2|+02|-20|0|",
		"Etc/GMT-3|+03|-30|0|",
		"Etc/GMT-4|+04|-40|0|",
		"Etc/GMT-5|+05|-50|0|",
		"Etc/GMT-6|+06|-60|0|",
		"Etc/GMT-7|+07|-70|0|",
		"Etc/GMT-8|+08|-80|0|",
		"Etc/GMT-9|+09|-90|0|",
		"Etc/UCT|UCT|0|0|",
		"Etc/UTC|UTC|0|0|",
		"Europe/Amsterdam|AMT NST NEST NET CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
		"Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
		"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
		"Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
		"Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
		"Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
		"Europe/Prague|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 16M0 1lc0 1tA0 17A0 11c0 1io0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
		"Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
		"Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
		"Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
		"Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
		"Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
		"Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
		"Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Kaliningrad|CET CEST CET CEST MSK MSD EEST EET +03|-10 -20 -20 -30 -30 -40 -30 -20 -30|0101010101010232454545454545454546767676767676767676767676767676767676767676787|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 Am0 Lb0 1en0 op0 1pNz0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
		"Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
		"Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
		"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ldXn.f aPWn.f Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
		"Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|01010101010101010101010121212121234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-28dd0 11A0 1go0 19A0 1co0 1dA0 b1A0 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 iyo0 Rc0 18o0 1hc0 1io0 1a00 14o0 5aL0 MM0 1vc0 17A0 1i00 1bc0 1eo0 17d0 1in0 17A0 6hA0 10N0 XIL0 1a10 1in0 17d0 19X0 1cN0 1fz0 1a10 1fX0 1cp0 1cO0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
		"Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
		"Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
		"Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
		"Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
		"Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
		"Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
		"Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
		"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
		"Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
		"Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
		"Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
		"Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
		"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
		"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0",
		"Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
		"Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1a00 1cM0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
		"Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
		"Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|01232323232323232121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
		"Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
		"Europe/Zaporozhye|CUT EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
		"HST|HST|a0|0|",
		"Indian/Chagos|LMT IOT IOT|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
		"Indian/Christmas|CXT|-70|0||21e2",
		"Indian/Cocos|CCT|-6u|0||596",
		"Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
		"Indian/Mahe|LMT SCT|-3F.M -40|01|-2yO3F.M|79e3",
		"Indian/Maldives|MMT MVT|-4S -50|01|-olgS|35e4",
		"Indian/Mauritius|LMT MUT MUST|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
		"Indian/Reunion|LMT RET|-3F.Q -40|01|-2mDDF.Q|84e4",
		"Pacific/Kwajalein|MHT KWAT MHT|-b0 c0 -c0|012|-AX0 W9X0|14e3",
		"MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00",
		"MST|MST|70|0|",
		"MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Pacific/Chatham|CHAST CHAST CHADT|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
		"PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0",
		"Pacific/Apia|LMT WSST SST SDT WSDT WSST|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
		"Pacific/Bougainville|PGT JST BST|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
		"Pacific/Chuuk|CHUT|-a0|0||49e3",
		"Pacific/Efate|LMT VUT VUST|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
		"Pacific/Enderbury|PHOT PHOT PHOT|c0 b0 -d0|012|nIc0 B8n0|1",
		"Pacific/Fakaofo|TKT TKT|b0 -d0|01|1Gfn0|483",
		"Pacific/Fiji|LMT FJT FJST|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|88e4",
		"Pacific/Funafuti|TVT|-c0|0||45e2",
		"Pacific/Galapagos|LMT ECT GALT|5W.o 50 60|012|-1yVS1.A 2dTz1.A|25e3",
		"Pacific/Gambier|LMT GAMT|8X.M 90|01|-2jof0.c|125",
		"Pacific/Guadalcanal|LMT SBT|-aD.M -b0|01|-2joyD.M|11e4",
		"Pacific/Guam|GST ChST|-a0 -a0|01|1fpq0|17e4",
		"Pacific/Honolulu|HST HDT HST|au 9u a0|010102|-1thLu 8x0 lef0 8Pz0 46p0|37e4",
		"Pacific/Kiritimati|LINT LINT LINT|aE a0 -e0|012|nIaE B8nk|51e2",
		"Pacific/Kosrae|KOST KOST|-b0 -c0|010|-AX0 1bdz0|66e2",
		"Pacific/Majuro|MHT MHT|-b0 -c0|01|-AX0|28e3",
		"Pacific/Marquesas|LMT MART|9i 9u|01|-2joeG|86e2",
		"Pacific/Pago_Pago|LMT NST BST SST|bm.M b0 b0 b0|0123|-2nDMB.c 2gVzB.c EyM0|37e2",
		"Pacific/Nauru|LMT NRT JST NRT|-b7.E -bu -90 -c0|01213|-1Xdn7.E PvzB.E 5RCu 1ouJu|10e3",
		"Pacific/Niue|NUT NUT NUT|bk bu b0|012|-KfME 17y0a|12e2",
		"Pacific/Norfolk|NMT NFT NFST NFT|-bc -bu -cu -b0|01213|-Kgbc W01G On0 1COp0|25e4",
		"Pacific/Noumea|LMT NCT NCST|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
		"Pacific/Palau|PWT|-90|0||21e3",
		"Pacific/Pitcairn|PNT PST|8u 80|01|18Vku|56",
		"Pacific/Pohnpei|PONT|-b0|0||34e3",
		"Pacific/Port_Moresby|PGT|-a0|0||25e4",
		"Pacific/Rarotonga|CKT CKHST CKT|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
		"Pacific/Tahiti|LMT TAHT|9W.g a0|01|-2joe1.I|18e4",
		"Pacific/Tarawa|GILT|-c0|0||29e3",
		"Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121212121212121212121212121212121212121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 uM0 1SM0 uM0 1SM0 uM0 1SM0 uM0|75e3",
		"Pacific/Wake|WAKT|-c0|0||16e3",
		"Pacific/Wallis|WFT|-c0|0||94",
		"WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00"
	],
	"links": [
		"Africa/Abidjan|Africa/Bamako",
		"Africa/Abidjan|Africa/Banjul",
		"Africa/Abidjan|Africa/Conakry",
		"Africa/Abidjan|Africa/Dakar",
		"Africa/Abidjan|Africa/Freetown",
		"Africa/Abidjan|Africa/Lome",
		"Africa/Abidjan|Africa/Nouakchott",
		"Africa/Abidjan|Africa/Ouagadougou",
		"Africa/Abidjan|Africa/Sao_Tome",
		"Africa/Abidjan|Africa/Timbuktu",
		"Africa/Abidjan|Atlantic/St_Helena",
		"Africa/Cairo|Egypt",
		"Africa/Johannesburg|Africa/Maseru",
		"Africa/Johannesburg|Africa/Mbabane",
		"Africa/Khartoum|Africa/Juba",
		"Africa/Lagos|Africa/Bangui",
		"Africa/Lagos|Africa/Brazzaville",
		"Africa/Lagos|Africa/Douala",
		"Africa/Lagos|Africa/Kinshasa",
		"Africa/Lagos|Africa/Libreville",
		"Africa/Lagos|Africa/Luanda",
		"Africa/Lagos|Africa/Malabo",
		"Africa/Lagos|Africa/Niamey",
		"Africa/Lagos|Africa/Porto-Novo",
		"Africa/Maputo|Africa/Blantyre",
		"Africa/Maputo|Africa/Bujumbura",
		"Africa/Maputo|Africa/Gaborone",
		"Africa/Maputo|Africa/Harare",
		"Africa/Maputo|Africa/Kigali",
		"Africa/Maputo|Africa/Lubumbashi",
		"Africa/Maputo|Africa/Lusaka",
		"Africa/Nairobi|Africa/Addis_Ababa",
		"Africa/Nairobi|Africa/Asmara",
		"Africa/Nairobi|Africa/Asmera",
		"Africa/Nairobi|Africa/Dar_es_Salaam",
		"Africa/Nairobi|Africa/Djibouti",
		"Africa/Nairobi|Africa/Kampala",
		"Africa/Nairobi|Africa/Mogadishu",
		"Africa/Nairobi|Indian/Antananarivo",
		"Africa/Nairobi|Indian/Comoro",
		"Africa/Nairobi|Indian/Mayotte",
		"Africa/Tripoli|Libya",
		"America/Adak|America/Atka",
		"America/Adak|US/Aleutian",
		"America/Anchorage|US/Alaska",
		"America/Argentina/Buenos_Aires|America/Buenos_Aires",
		"America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
		"America/Argentina/Catamarca|America/Catamarca",
		"America/Argentina/Cordoba|America/Cordoba",
		"America/Argentina/Cordoba|America/Rosario",
		"America/Argentina/Jujuy|America/Jujuy",
		"America/Argentina/Mendoza|America/Mendoza",
		"America/Atikokan|America/Coral_Harbour",
		"America/Chicago|US/Central",
		"America/Curacao|America/Aruba",
		"America/Curacao|America/Kralendijk",
		"America/Curacao|America/Lower_Princes",
		"America/Denver|America/Shiprock",
		"America/Denver|Navajo",
		"America/Denver|US/Mountain",
		"America/Detroit|US/Michigan",
		"America/Edmonton|Canada/Mountain",
		"America/Fort_Wayne|America/Indiana/Indianapolis",
		"America/Fort_Wayne|America/Indianapolis",
		"America/Fort_Wayne|US/East-Indiana",
		"America/Halifax|Canada/Atlantic",
		"America/Havana|Cuba",
		"America/Indiana/Knox|America/Knox_IN",
		"America/Indiana/Knox|US/Indiana-Starke",
		"America/Jamaica|Jamaica",
		"America/Kentucky/Louisville|America/Louisville",
		"America/Los_Angeles|US/Pacific",
		"America/Los_Angeles|US/Pacific-New",
		"America/Manaus|Brazil/West",
		"America/Mazatlan|Mexico/BajaSur",
		"America/Mexico_City|Mexico/General",
		"America/New_York|US/Eastern",
		"America/Noronha|Brazil/DeNoronha",
		"America/Panama|America/Cayman",
		"America/Phoenix|US/Arizona",
		"America/Port_of_Spain|America/Anguilla",
		"America/Port_of_Spain|America/Antigua",
		"America/Port_of_Spain|America/Dominica",
		"America/Port_of_Spain|America/Grenada",
		"America/Port_of_Spain|America/Guadeloupe",
		"America/Port_of_Spain|America/Marigot",
		"America/Port_of_Spain|America/Montserrat",
		"America/Port_of_Spain|America/St_Barthelemy",
		"America/Port_of_Spain|America/St_Kitts",
		"America/Port_of_Spain|America/St_Lucia",
		"America/Port_of_Spain|America/St_Thomas",
		"America/Port_of_Spain|America/St_Vincent",
		"America/Port_of_Spain|America/Tortola",
		"America/Port_of_Spain|America/Virgin",
		"America/Regina|Canada/East-Saskatchewan",
		"America/Regina|Canada/Saskatchewan",
		"America/Rio_Branco|America/Porto_Acre",
		"America/Rio_Branco|Brazil/Acre",
		"America/Santiago|Chile/Continental",
		"America/Sao_Paulo|Brazil/East",
		"America/St_Johns|Canada/Newfoundland",
		"America/Tijuana|America/Ensenada",
		"America/Tijuana|America/Santa_Isabel",
		"America/Tijuana|Mexico/BajaNorte",
		"America/Toronto|America/Montreal",
		"America/Toronto|Canada/Eastern",
		"America/Vancouver|Canada/Pacific",
		"America/Whitehorse|Canada/Yukon",
		"America/Winnipeg|Canada/Central",
		"Asia/Ashgabat|Asia/Ashkhabad",
		"Asia/Bangkok|Asia/Phnom_Penh",
		"Asia/Bangkok|Asia/Vientiane",
		"Asia/Dhaka|Asia/Dacca",
		"Asia/Dubai|Asia/Muscat",
		"Asia/Ho_Chi_Minh|Asia/Saigon",
		"Asia/Hong_Kong|Hongkong",
		"Asia/Jerusalem|Asia/Tel_Aviv",
		"Asia/Jerusalem|Israel",
		"Asia/Kathmandu|Asia/Katmandu",
		"Asia/Kolkata|Asia/Calcutta",
		"Asia/Macau|Asia/Macao",
		"Asia/Makassar|Asia/Ujung_Pandang",
		"Asia/Nicosia|Europe/Nicosia",
		"Asia/Qatar|Asia/Bahrain",
		"Asia/Rangoon|Asia/Yangon",
		"Asia/Riyadh|Asia/Aden",
		"Asia/Riyadh|Asia/Kuwait",
		"Asia/Seoul|ROK",
		"Asia/Shanghai|Asia/Chongqing",
		"Asia/Shanghai|Asia/Chungking",
		"Asia/Shanghai|Asia/Harbin",
		"Asia/Shanghai|PRC",
		"Asia/Singapore|Singapore",
		"Asia/Taipei|ROC",
		"Asia/Tehran|Iran",
		"Asia/Thimphu|Asia/Thimbu",
		"Asia/Tokyo|Japan",
		"Asia/Ulaanbaatar|Asia/Ulan_Bator",
		"Asia/Urumqi|Asia/Kashgar",
		"Atlantic/Faroe|Atlantic/Faeroe",
		"Atlantic/Reykjavik|Iceland",
		"Australia/Adelaide|Australia/South",
		"Australia/Brisbane|Australia/Queensland",
		"Australia/Broken_Hill|Australia/Yancowinna",
		"Australia/Darwin|Australia/North",
		"Australia/Hobart|Australia/Tasmania",
		"Australia/Lord_Howe|Australia/LHI",
		"Australia/Melbourne|Australia/Victoria",
		"Australia/Perth|Australia/West",
		"Australia/Sydney|Australia/ACT",
		"Australia/Sydney|Australia/Canberra",
		"Australia/Sydney|Australia/NSW",
		"Etc/GMT+0|Etc/GMT",
		"Etc/GMT+0|Etc/GMT-0",
		"Etc/GMT+0|Etc/GMT0",
		"Etc/GMT+0|Etc/Greenwich",
		"Etc/GMT+0|GMT",
		"Etc/GMT+0|GMT+0",
		"Etc/GMT+0|GMT-0",
		"Etc/GMT+0|GMT0",
		"Etc/GMT+0|Greenwich",
		"Etc/UCT|UCT",
		"Etc/UTC|Etc/Universal",
		"Etc/UTC|Etc/Zulu",
		"Etc/UTC|UTC",
		"Etc/UTC|Universal",
		"Etc/UTC|Zulu",
		"Europe/Belgrade|Europe/Ljubljana",
		"Europe/Belgrade|Europe/Podgorica",
		"Europe/Belgrade|Europe/Sarajevo",
		"Europe/Belgrade|Europe/Skopje",
		"Europe/Belgrade|Europe/Zagreb",
		"Europe/Chisinau|Europe/Tiraspol",
		"Europe/Dublin|Eire",
		"Europe/Helsinki|Europe/Mariehamn",
		"Europe/Istanbul|Asia/Istanbul",
		"Europe/Istanbul|Turkey",
		"Europe/Lisbon|Portugal",
		"Europe/London|Europe/Belfast",
		"Europe/London|Europe/Guernsey",
		"Europe/London|Europe/Isle_of_Man",
		"Europe/London|Europe/Jersey",
		"Europe/London|GB",
		"Europe/London|GB-Eire",
		"Europe/Moscow|W-SU",
		"Europe/Oslo|Arctic/Longyearbyen",
		"Europe/Oslo|Atlantic/Jan_Mayen",
		"Europe/Prague|Europe/Bratislava",
		"Europe/Rome|Europe/San_Marino",
		"Europe/Rome|Europe/Vatican",
		"Europe/Warsaw|Poland",
		"Europe/Zurich|Europe/Busingen",
		"Europe/Zurich|Europe/Vaduz",
		"Pacific/Auckland|Antarctica/McMurdo",
		"Pacific/Auckland|Antarctica/South_Pole",
		"Pacific/Auckland|NZ",
		"Pacific/Chatham|NZ-CHAT",
		"Pacific/Chuuk|Pacific/Truk",
		"Pacific/Chuuk|Pacific/Yap",
		"Pacific/Easter|Chile/EasterIsland",
		"Pacific/Guam|Pacific/Saipan",
		"Pacific/Honolulu|Pacific/Johnston",
		"Pacific/Honolulu|US/Hawaii",
		"Pacific/Kwajalein|Kwajalein",
		"Pacific/Pago_Pago|Pacific/Midway",
		"Pacific/Pago_Pago|Pacific/Samoa",
		"Pacific/Pago_Pago|US/Samoa",
		"Pacific/Pohnpei|Pacific/Ponape"
	]
};

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(108);



/* Built-in method references that are verified to be native. */
var DataView = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(108);



/* Built-in method references that are verified to be native. */
var Map = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(108);



/* Built-in method references that are verified to be native. */
var Promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(108);



/* Built-in method references that are verified to be native. */
var Set = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(108);



/* Built-in method references that are verified to be native. */
var WeakMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(532);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFindIndex);


/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strictIndexOf_js__ = __webpack_require__(1497);




/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__strictIndexOf_js__["a" /* default */])(array, value, fromIndex)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__["a" /* default */], fromIndex);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIndexOf);


/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(137);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getTag_js__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(137);



/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getTag_js__["a" /* default */])(value) == mapTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMap);


/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNaN);


/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(527);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(137);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(337);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(519);


/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(props, function(key) {
    return object[key];
  });
}

/* harmony default export */ __webpack_exports__["a"] = (baseValues);


/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(108);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(526);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(331);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(1489);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(526);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (strictIndexOf);


/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_js__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values_js__ = __webpack_require__(1509);






/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(collection) ? collection : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__values_js__["a" /* default */])(collection);
  fromIndex = (fromIndex && !guard) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toInteger_js__["a" /* default */])(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__["a" /* default */])(collection, value, fromIndex) > -1);
}

/* harmony default export */ __webpack_exports__["a"] = (includes);


/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(532);









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */
function isNull(value) {
  return value === null;
}

/* harmony default export */ __webpack_exports__["a"] = (isNull);


/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (isUndefined);


/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(333);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (last);


/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toNumber_js__ = __webpack_require__(1507);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toNumber_js__["a" /* default */])(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toFinite);


/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toFinite_js__ = __webpack_require__(1505);


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toFinite_js__["a" /* default */])(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toInteger);


/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(337);



/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(1487);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseValues_js__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(1502);



/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseValues_js__["a" /* default */])(object, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (values);


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(533),
    getRawTag = __webpack_require__(1513),
    objectToString = __webpack_require__(1514);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1515);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(533);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1514 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1515 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1511);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 1517 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(1510),
    getPrototype = __webpack_require__(1512),
    isObjectLike = __webpack_require__(1517);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = simpleIsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index]);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.9
//! author : Tim Wood
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else if (typeof module === 'object' && module.exports) {
		module.exports = factory(require('moment')); // Node
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Do not load moment-timezone a second time.
	if (moment.tz !== undefined) {
		logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
		return moment;
	}

	var VERSION = "0.5.9",
		zones = {},
		links = {},
		names = {},
		guesses = {},
		cachedGuess,

		momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.offset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		return b.zone.population - a.zone.population;
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName){
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			if (split[5]) {
				addToGuesses(normalized, split[2].split(' '));
			}
		}
	}

	function getZone (name, caller) {
		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		return !!(m._a && (m._tzm === undefined));
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.offset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				mom.utcOffset(-offset, keepTime);
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name) {
		if (name) {
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName = abbrWrap(fn.zoneName);
	fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
	fn.utc      = resetZoneWrap(fn.utc);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 534,
	"./af.js": 534,
	"./ar": 541,
	"./ar-dz": 535,
	"./ar-dz.js": 535,
	"./ar-kw": 536,
	"./ar-kw.js": 536,
	"./ar-ly": 537,
	"./ar-ly.js": 537,
	"./ar-ma": 538,
	"./ar-ma.js": 538,
	"./ar-sa": 539,
	"./ar-sa.js": 539,
	"./ar-tn": 540,
	"./ar-tn.js": 540,
	"./ar.js": 541,
	"./az": 542,
	"./az.js": 542,
	"./be": 543,
	"./be.js": 543,
	"./bg": 544,
	"./bg.js": 544,
	"./bm": 545,
	"./bm.js": 545,
	"./bn": 546,
	"./bn.js": 546,
	"./bo": 547,
	"./bo.js": 547,
	"./br": 548,
	"./br.js": 548,
	"./bs": 549,
	"./bs.js": 549,
	"./ca": 550,
	"./ca.js": 550,
	"./cs": 551,
	"./cs.js": 551,
	"./cv": 552,
	"./cv.js": 552,
	"./cy": 553,
	"./cy.js": 553,
	"./da": 554,
	"./da.js": 554,
	"./de": 557,
	"./de-at": 555,
	"./de-at.js": 555,
	"./de-ch": 556,
	"./de-ch.js": 556,
	"./de.js": 557,
	"./dv": 558,
	"./dv.js": 558,
	"./el": 559,
	"./el.js": 559,
	"./en-SG": 560,
	"./en-SG.js": 560,
	"./en-au": 561,
	"./en-au.js": 561,
	"./en-ca": 562,
	"./en-ca.js": 562,
	"./en-gb": 563,
	"./en-gb.js": 563,
	"./en-ie": 564,
	"./en-ie.js": 564,
	"./en-il": 565,
	"./en-il.js": 565,
	"./en-nz": 566,
	"./en-nz.js": 566,
	"./eo": 567,
	"./eo.js": 567,
	"./es": 570,
	"./es-do": 568,
	"./es-do.js": 568,
	"./es-us": 569,
	"./es-us.js": 569,
	"./es.js": 570,
	"./et": 571,
	"./et.js": 571,
	"./eu": 572,
	"./eu.js": 572,
	"./fa": 573,
	"./fa.js": 573,
	"./fi": 574,
	"./fi.js": 574,
	"./fo": 575,
	"./fo.js": 575,
	"./fr": 578,
	"./fr-ca": 576,
	"./fr-ca.js": 576,
	"./fr-ch": 577,
	"./fr-ch.js": 577,
	"./fr.js": 578,
	"./fy": 579,
	"./fy.js": 579,
	"./ga": 580,
	"./ga.js": 580,
	"./gd": 581,
	"./gd.js": 581,
	"./gl": 582,
	"./gl.js": 582,
	"./gom-latn": 583,
	"./gom-latn.js": 583,
	"./gu": 584,
	"./gu.js": 584,
	"./he": 585,
	"./he.js": 585,
	"./hi": 586,
	"./hi.js": 586,
	"./hr": 587,
	"./hr.js": 587,
	"./hu": 588,
	"./hu.js": 588,
	"./hy-am": 589,
	"./hy-am.js": 589,
	"./id": 590,
	"./id.js": 590,
	"./is": 591,
	"./is.js": 591,
	"./it": 593,
	"./it-ch": 592,
	"./it-ch.js": 592,
	"./it.js": 593,
	"./ja": 594,
	"./ja.js": 594,
	"./jv": 595,
	"./jv.js": 595,
	"./ka": 596,
	"./ka.js": 596,
	"./kk": 597,
	"./kk.js": 597,
	"./km": 598,
	"./km.js": 598,
	"./kn": 599,
	"./kn.js": 599,
	"./ko": 600,
	"./ko.js": 600,
	"./ku": 601,
	"./ku.js": 601,
	"./ky": 602,
	"./ky.js": 602,
	"./lb": 603,
	"./lb.js": 603,
	"./lo": 604,
	"./lo.js": 604,
	"./lt": 605,
	"./lt.js": 605,
	"./lv": 606,
	"./lv.js": 606,
	"./me": 607,
	"./me.js": 607,
	"./mi": 608,
	"./mi.js": 608,
	"./mk": 609,
	"./mk.js": 609,
	"./ml": 610,
	"./ml.js": 610,
	"./mn": 611,
	"./mn.js": 611,
	"./mr": 612,
	"./mr.js": 612,
	"./ms": 614,
	"./ms-my": 613,
	"./ms-my.js": 613,
	"./ms.js": 614,
	"./mt": 615,
	"./mt.js": 615,
	"./my": 616,
	"./my.js": 616,
	"./nb": 617,
	"./nb.js": 617,
	"./ne": 618,
	"./ne.js": 618,
	"./nl": 620,
	"./nl-be": 619,
	"./nl-be.js": 619,
	"./nl.js": 620,
	"./nn": 621,
	"./nn.js": 621,
	"./pa-in": 622,
	"./pa-in.js": 622,
	"./pl": 623,
	"./pl.js": 623,
	"./pt": 625,
	"./pt-br": 624,
	"./pt-br.js": 624,
	"./pt.js": 625,
	"./ro": 626,
	"./ro.js": 626,
	"./ru": 627,
	"./ru.js": 627,
	"./sd": 628,
	"./sd.js": 628,
	"./se": 629,
	"./se.js": 629,
	"./si": 630,
	"./si.js": 630,
	"./sk": 631,
	"./sk.js": 631,
	"./sl": 632,
	"./sl.js": 632,
	"./sq": 633,
	"./sq.js": 633,
	"./sr": 635,
	"./sr-cyrl": 634,
	"./sr-cyrl.js": 634,
	"./sr.js": 635,
	"./ss": 636,
	"./ss.js": 636,
	"./sv": 637,
	"./sv.js": 637,
	"./sw": 638,
	"./sw.js": 638,
	"./ta": 639,
	"./ta.js": 639,
	"./te": 640,
	"./te.js": 640,
	"./tet": 641,
	"./tet.js": 641,
	"./tg": 642,
	"./tg.js": 642,
	"./th": 643,
	"./th.js": 643,
	"./tl-ph": 644,
	"./tl-ph.js": 644,
	"./tlh": 645,
	"./tlh.js": 645,
	"./tr": 646,
	"./tr.js": 646,
	"./tzl": 647,
	"./tzl.js": 647,
	"./tzm": 649,
	"./tzm-latn": 648,
	"./tzm-latn.js": 648,
	"./tzm.js": 649,
	"./ug-cn": 650,
	"./ug-cn.js": 650,
	"./uk": 651,
	"./uk.js": 651,
	"./ur": 652,
	"./ur.js": 652,
	"./uz": 654,
	"./uz-latn": 653,
	"./uz-latn.js": 653,
	"./uz.js": 654,
	"./vi": 655,
	"./vi.js": 655,
	"./x-pseudo": 656,
	"./x-pseudo.js": 656,
	"./yo": 657,
	"./yo.js": 657,
	"./zh-cn": 658,
	"./zh-cn.js": 658,
	"./zh-hk": 659,
	"./zh-hk.js": 659,
	"./zh-tw": 660,
	"./zh-tw.js": 660
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1521;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(97).Buffer
var writeToStream = __webpack_require__(662)
var EE = __webpack_require__(190).EventEmitter
var inherits = __webpack_require__(90)

function generate (packet) {
  var stream = new Accumulator()
  writeToStream(packet, stream)
  return stream.concat()
}

function Accumulator () {
  this._array = new Array(20)
  this._i = 0
}

inherits(Accumulator, EE)

Accumulator.prototype.write = function (chunk) {
  this._array[this._i++] = chunk
  return true
}

Accumulator.prototype.concat = function () {
  var length = 0
  var lengths = new Array(this._array.length)
  var list = this._array
  var pos = 0
  var i
  var result

  for (i = 0; i < list.length && list[i]; i++) {
    if (typeof list[i] !== 'string') lengths[i] = list[i].length
    else lengths[i] = Buffer.byteLength(list[i])

    length += lengths[i]
  }

  result = Buffer.allocUnsafe(length)

  for (i = 0; i < list.length && list[i]; i++) {
    if (typeof list[i] !== 'string') {
      list[i].copy(result, pos)
      pos += lengths[i]
    } else {
      result.write(list[i], pos)
      pos += lengths[i]
    }
  }

  return result
}

module.exports = generate


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.parser = __webpack_require__(1526)
exports.generate = __webpack_require__(1522)
exports.writeToStream = __webpack_require__(662)


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Buffer = __webpack_require__(97).Buffer
var max = 65536
var cache = {}

function generateBuffer (i) {
  var buffer = Buffer.allocUnsafe(2)
  buffer.writeUInt8(i >> 8, 0, true)
  buffer.writeUInt8(i & 0x00FF, 0 + 1, true)

  return buffer
}

function generateCache () {
  for (var i = 0; i < max; i++) {
    cache[i] = generateBuffer(i)
  }
}

module.exports = {
  cache: cache,
  generateCache: generateCache,
  generateNumber: generateBuffer
}


/***/ }),
/* 1525 */
/***/ (function(module, exports) {


function Packet () {
  this.cmd = null
  this.retain = false
  this.qos = 0
  this.dup = false
  this.length = -1
  this.topic = null
  this.payload = null
}

module.exports = Packet


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bl = __webpack_require__(1338)
var inherits = __webpack_require__(90)
var EE = __webpack_require__(190).EventEmitter
var Packet = __webpack_require__(1525)
var constants = __webpack_require__(661)

function Parser () {
  if (!(this instanceof Parser)) return new Parser()

  this._states = [
    '_parseHeader',
    '_parseLength',
    '_parsePayload',
    '_newPacket'
  ]

  this._resetState()
}

inherits(Parser, EE)

Parser.prototype._resetState = function () {
  this.packet = new Packet()
  this.error = null
  this._list = bl()
  this._stateCounter = 0
}

Parser.prototype.parse = function (buf) {
  if (this.error) this._resetState()

  this._list.append(buf)

  while ((this.packet.length !== -1 || this._list.length > 0) &&
         this[this._states[this._stateCounter]]() &&
         !this.error) {
    this._stateCounter++

    if (this._stateCounter >= this._states.length) this._stateCounter = 0
  }

  return this._list.length
}

Parser.prototype._parseHeader = function () {
  // There is at least one byte in the buffer
  var zero = this._list.readUInt8(0)
  this.packet.cmd = constants.types[zero >> constants.CMD_SHIFT]
  this.packet.retain = (zero & constants.RETAIN_MASK) !== 0
  this.packet.qos = (zero >> constants.QOS_SHIFT) & constants.QOS_MASK
  this.packet.dup = (zero & constants.DUP_MASK) !== 0

  this._list.consume(1)

  return true
}

Parser.prototype._parseLength = function () {
  // There is at least one byte in the list
  var bytes = 0
  var mul = 1
  var length = 0
  var result = true
  var current

  while (bytes < 5) {
    current = this._list.readUInt8(bytes++)
    length += mul * (current & constants.LENGTH_MASK)
    mul *= 0x80

    if ((current & constants.LENGTH_FIN_MASK) === 0) break
    if (this._list.length <= bytes) {
      result = false
      break
    }
  }

  if (result) {
    this.packet.length = length
    this._list.consume(bytes)
  }

  return result
}

Parser.prototype._parsePayload = function () {
  var result = false

  // Do we have a payload? Do we have enough data to complete the payload?
  // PINGs have no payload
  if (this.packet.length === 0 || this._list.length >= this.packet.length) {
    this._pos = 0

    switch (this.packet.cmd) {
      case 'connect':
        this._parseConnect()
        break
      case 'connack':
        this._parseConnack()
        break
      case 'publish':
        this._parsePublish()
        break
      case 'puback':
      case 'pubrec':
      case 'pubrel':
      case 'pubcomp':
        this._parseMessageId()
        break
      case 'subscribe':
        this._parseSubscribe()
        break
      case 'suback':
        this._parseSuback()
        break
      case 'unsubscribe':
        this._parseUnsubscribe()
        break
      case 'unsuback':
        this._parseUnsuback()
        break
      case 'pingreq':
      case 'pingresp':
      case 'disconnect':
        // These are empty, nothing to do
        break
      default:
        this._emitError(new Error('Not supported'))
    }

    result = true
  }

  return result
}

Parser.prototype._parseConnect = function () {
  var protocolId // Protocol ID
  var clientId // Client ID
  var topic // Will topic
  var payload // Will payload
  var password // Password
  var username // Username
  var flags = {}
  var packet = this.packet

  // Parse protocolId
  protocolId = this._parseString()

  if (protocolId === null) return this._emitError(new Error('Cannot parse protocolId'))
  if (protocolId !== 'MQTT' && protocolId !== 'MQIsdp') {
    return this._emitError(new Error('Invalid protocolId'))
  }

  packet.protocolId = protocolId

  // Parse constants version number
  if (this._pos >= this._list.length) return this._emitError(new Error('Packet too short'))

  packet.protocolVersion = this._list.readUInt8(this._pos)

  if (packet.protocolVersion !== 3 && packet.protocolVersion !== 4) {
    return this._emitError(new Error('Invalid protocol version'))
  }

  this._pos++

  if (this._pos >= this._list.length) {
    return this._emitError(new Error('Packet too short'))
  }

  // Parse connect flags
  flags.username = (this._list.readUInt8(this._pos) & constants.USERNAME_MASK)
  flags.password = (this._list.readUInt8(this._pos) & constants.PASSWORD_MASK)
  flags.will = (this._list.readUInt8(this._pos) & constants.WILL_FLAG_MASK)

  if (flags.will) {
    packet.will = {}
    packet.will.retain = (this._list.readUInt8(this._pos) & constants.WILL_RETAIN_MASK) !== 0
    packet.will.qos = (this._list.readUInt8(this._pos) &
                          constants.WILL_QOS_MASK) >> constants.WILL_QOS_SHIFT
  }

  packet.clean = (this._list.readUInt8(this._pos) & constants.CLEAN_SESSION_MASK) !== 0
  this._pos++

  // Parse keepalive
  packet.keepalive = this._parseNum()
  if (packet.keepalive === -1) return this._emitError(new Error('Packet too short'))

  // Parse clientId
  clientId = this._parseString()
  if (clientId === null) return this._emitError(new Error('Packet too short'))
  packet.clientId = clientId

  if (flags.will) {
    // Parse will topic
    topic = this._parseString()
    if (topic === null) return this._emitError(new Error('Cannot parse will topic'))
    packet.will.topic = topic

    // Parse will payload
    payload = this._parseBuffer()
    if (payload === null) return this._emitError(new Error('Cannot parse will payload'))
    packet.will.payload = payload
  }

  // Parse username
  if (flags.username) {
    username = this._parseString()
    if (username === null) return this._emitError(new Error('Cannot parse username'))
    packet.username = username
  }

  // Parse password
  if (flags.password) {
    password = this._parseBuffer()
    if (password === null) return this._emitError(new Error('Cannot parse password'))
    packet.password = password
  }

  return packet
}

Parser.prototype._parseConnack = function () {
  var packet = this.packet

  if (this._list.length < 2) return null

  packet.sessionPresent = !!(this._list.readUInt8(this._pos++) & constants.SESSIONPRESENT_MASK)
  packet.returnCode = this._list.readUInt8(this._pos)

  if (packet.returnCode === -1) return this._emitError(new Error('Cannot parse return code'))
}

Parser.prototype._parsePublish = function () {
  var packet = this.packet
  packet.topic = this._parseString()

  if (packet.topic === null) return this._emitError(new Error('Cannot parse topic'))

  // Parse messageId
  if (packet.qos > 0) if (!this._parseMessageId()) { return }

  packet.payload = this._list.slice(this._pos, packet.length)
}

Parser.prototype._parseSubscribe = function () {
  var packet = this.packet
  var topic
  var qos

  if (packet.qos !== 1) {
    return this._emitError(new Error('Wrong subscribe header'))
  }

  packet.subscriptions = []

  if (!this._parseMessageId()) { return }

  while (this._pos < packet.length) {
    // Parse topic
    topic = this._parseString()
    if (topic === null) return this._emitError(new Error('Cannot parse topic'))

    qos = this._list.readUInt8(this._pos++)

    // Push pair to subscriptions
    packet.subscriptions.push({ topic: topic, qos: qos })
  }
}

Parser.prototype._parseSuback = function () {
  this.packet.granted = []

  if (!this._parseMessageId()) { return }

  // Parse granted QoSes
  while (this._pos < this.packet.length) {
    this.packet.granted.push(this._list.readUInt8(this._pos++))
  }
}

Parser.prototype._parseUnsubscribe = function () {
  var packet = this.packet

  packet.unsubscriptions = []

  // Parse messageId
  if (!this._parseMessageId()) { return }

  while (this._pos < packet.length) {
    var topic

    // Parse topic
    topic = this._parseString()
    if (topic === null) return this._emitError(new Error('Cannot parse topic'))

    // Push topic to unsubscriptions
    packet.unsubscriptions.push(topic)
  }
}

Parser.prototype._parseUnsuback = function () {
  if (!this._parseMessageId()) return this._emitError(new Error('Cannot parse messageId'))
}

Parser.prototype._parseMessageId = function () {
  var packet = this.packet

  packet.messageId = this._parseNum()

  if (packet.messageId === null) {
    this._emitError(new Error('Cannot parse messageId'))
    return false
  }

  return true
}

Parser.prototype._parseString = function (maybeBuffer) {
  var length = this._parseNum()
  var result
  var end = length + this._pos

  if (length === -1 || end > this._list.length || end > this.packet.length) return null

  result = this._list.toString('utf8', this._pos, end)
  this._pos += length

  return result
}

Parser.prototype._parseBuffer = function () {
  var length = this._parseNum()
  var result
  var end = length + this._pos

  if (length === -1 || end > this._list.length || end > this.packet.length) return null

  result = this._list.slice(this._pos, end)

  this._pos += length

  return result
}

Parser.prototype._parseNum = function () {
  if (this._list.length - this._pos < 2) return -1

  var result = this._list.readUInt16BE(this._pos)
  this._pos += 2

  return result
}

Parser.prototype._newPacket = function () {
  if (this.packet) {
    this._list.consume(this.packet.length)
    this.emit('packet', this.packet)
  }

  this.packet = new Packet()

  return true
}

Parser.prototype._emitError = function (err) {
  this.error = err
  this.emit('error', err)
}

module.exports = Parser


/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

/**
 * Module dependencies
 */
var events = __webpack_require__(190)
var Store = __webpack_require__(666)
var eos = __webpack_require__(505)
var mqttPacket = __webpack_require__(1523)
var Writable = __webpack_require__(245).Writable
var inherits = __webpack_require__(90)
var reInterval = __webpack_require__(1629)
var validations = __webpack_require__(1529)
var xtend = __webpack_require__(353)
var setImmediate = global.setImmediate || function (callback) {
  // works in node v0.8
  process.nextTick(callback)
}
var defaultConnectOptions = {
  keepalive: 60,
  reschedulePings: true,
  protocolId: 'MQTT',
  protocolVersion: 4,
  reconnectPeriod: 1000,
  connectTimeout: 30 * 1000,
  clean: true,
  resubscribe: true
}

function defaultId () {
  return 'mqttjs_' + Math.random().toString(16).substr(2, 8)
}

function sendPacket (client, packet, cb) {
  client.emit('packetsend', packet)

  var result = mqttPacket.writeToStream(packet, client.stream)

  if (!result && cb) {
    client.stream.once('drain', cb)
  } else if (cb) {
    cb()
  }
}

function storeAndSend (client, packet, cb) {
  client.outgoingStore.put(packet, function storedPacket (err) {
    if (err) {
      return cb && cb(err)
    }
    sendPacket(client, packet, cb)
  })
}

function nop () {}

/**
 * MqttClient constructor
 *
 * @param {Stream} stream - stream
 * @param {Object} [options] - connection options
 * (see Connection#connect)
 */
function MqttClient (streamBuilder, options) {
  var k
  var that = this

  if (!(this instanceof MqttClient)) {
    return new MqttClient(streamBuilder, options)
  }

  this.options = options || {}

  // Defaults
  for (k in defaultConnectOptions) {
    if (typeof this.options[k] === 'undefined') {
      this.options[k] = defaultConnectOptions[k]
    } else {
      this.options[k] = options[k]
    }
  }

  this.options.clientId = (typeof this.options.clientId === 'string') ? this.options.clientId : defaultId()

  this.streamBuilder = streamBuilder

  // Inflight message storages
  this.outgoingStore = this.options.outgoingStore || new Store()
  this.incomingStore = this.options.incomingStore || new Store()

  // Should QoS zero messages be queued when the connection is broken?
  this.queueQoSZero = this.options.queueQoSZero === undefined ? true : this.options.queueQoSZero

  // map of subscribed topics to support reconnection
  this._resubscribeTopics = {}

  // map of a subscribe messageId and a topic
  this.messageIdToTopic = {}

  // Ping timer, setup in _setupPingTimer
  this.pingTimer = null
  // Is the client connected?
  this.connected = false
  // Are we disconnecting?
  this.disconnecting = false
  // Packet queue
  this.queue = []
  // connack timer
  this.connackTimer = null
  // Reconnect timer
  this.reconnectTimer = null
  // MessageIDs starting with 1
  this.nextId = Math.floor(Math.random() * 65535)

  // Inflight callbacks
  this.outgoing = {}

  // Mark connected on connect
  this.on('connect', function () {
    if (this.disconnected) {
      return
    }

    this.connected = true
    var outStore = null
    outStore = this.outgoingStore.createStream()

    // Control of stored messages
    outStore.once('readable', function () {
      function storeDeliver () {
        var packet = outStore.read(1)
        var cb

        if (!packet) {
          return
        }

        // Avoid unnecesary stream read operations when disconnected
        if (!that.disconnecting && !that.reconnectTimer && that.options.reconnectPeriod > 0) {
          outStore.read(0)
          cb = that.outgoing[packet.messageId]
          that.outgoing[packet.messageId] = function (err, status) {
            // Ensure that the original callback passed in to publish gets invoked
            if (cb) {
              cb(err, status)
            }

            storeDeliver()
          }
          that._sendPacket(packet)
        } else if (outStore.destroy) {
          outStore.destroy()
        }
      }
      storeDeliver()
    })
    .on('error', this.emit.bind(this, 'error'))
  })

  // Mark disconnected on stream close
  this.on('close', function () {
    this.connected = false
    clearTimeout(this.connackTimer)
  })

  // Setup ping timer
  this.on('connect', this._setupPingTimer)

  // Send queued packets
  this.on('connect', function () {
    var queue = this.queue

    function deliver () {
      var entry = queue.shift()
      var packet = null

      if (!entry) {
        return
      }

      packet = entry.packet

      that._sendPacket(
        packet,
        function (err) {
          if (entry.cb) {
            entry.cb(err)
          }
          deliver()
        }
      )
    }

    deliver()
  })

  var firstConnection = true
  // resubscribe
  this.on('connect', function () {
    if (!firstConnection &&
        this.options.clean &&
        Object.keys(this._resubscribeTopics).length > 0) {
      if (this.options.resubscribe) {
        this._resubscribeTopics.resubscribe = true
        this.subscribe(this._resubscribeTopics)
      } else {
        this._resubscribeTopics = {}
      }
    }

    firstConnection = false
  })

  // Clear ping timer
  this.on('close', function () {
    if (that.pingTimer !== null) {
      that.pingTimer.clear()
      that.pingTimer = null
    }
  })

  // Setup reconnect timer on disconnect
  this.on('close', this._setupReconnect)

  events.EventEmitter.call(this)

  this._setupStream()
}
inherits(MqttClient, events.EventEmitter)

/**
 * setup the event handlers in the inner stream.
 *
 * @api private
 */
MqttClient.prototype._setupStream = function () {
  var connectPacket
  var that = this
  var writable = new Writable()
  var parser = mqttPacket.parser(this.options)
  var completeParse = null
  var packets = []

  this._clearReconnect()

  this.stream = this.streamBuilder(this)

  parser.on('packet', function (packet) {
    packets.push(packet)
  })

  function nextTickWork () {
    process.nextTick(work)
  }

  function work () {
    var packet = packets.shift()
    var done = completeParse

    if (packet) {
      that._handlePacket(packet, nextTickWork)
    } else {
      completeParse = null
      done()
    }
  }

  writable._write = function (buf, enc, done) {
    completeParse = done
    parser.parse(buf)
    work()
  }

  this.stream.pipe(writable)

  // Suppress connection errors
  this.stream.on('error', nop)

  // Echo stream close
  eos(this.stream, this.emit.bind(this, 'close'))

  // Send a connect packet
  connectPacket = Object.create(this.options)
  connectPacket.cmd = 'connect'
  // avoid message queue
  sendPacket(this, connectPacket)

  // Echo connection errors
  parser.on('error', this.emit.bind(this, 'error'))

  // many drain listeners are needed for qos 1 callbacks if the connection is intermittent
  this.stream.setMaxListeners(1000)

  clearTimeout(this.connackTimer)
  this.connackTimer = setTimeout(function () {
    that._cleanUp(true)
  }, this.options.connectTimeout)
}

MqttClient.prototype._handlePacket = function (packet, done) {
  this.emit('packetreceive', packet)

  switch (packet.cmd) {
    case 'publish':
      this._handlePublish(packet, done)
      break
    case 'puback':
    case 'pubrec':
    case 'pubcomp':
    case 'suback':
    case 'unsuback':
      this._handleAck(packet)
      done()
      break
    case 'pubrel':
      this._handlePubrel(packet, done)
      break
    case 'connack':
      this._handleConnack(packet)
      done()
      break
    case 'pingresp':
      this._handlePingresp(packet)
      done()
      break
    default:
      // do nothing
      // maybe we should do an error handling
      // or just log it
      break
  }
}

MqttClient.prototype._checkDisconnecting = function (callback) {
  if (this.disconnecting) {
    if (callback) {
      callback(new Error('client disconnecting'))
    } else {
      this.emit('error', new Error('client disconnecting'))
    }
  }
  return this.disconnecting
}

/**
 * publish - publish <message> to <topic>
 *
 * @param {String} topic - topic to publish to
 * @param {String, Buffer} message - message to publish
 * @param {Object} [opts] - publish options, includes:
 *    {Number} qos - qos level to publish on
 *    {Boolean} retain - whether or not to retain the message
 *    {Boolean} dup - whether or not mark a message as duplicate
 * @param {Function} [callback] - function(err){}
 *    called when publish succeeds or fails
 * @returns {MqttClient} this - for chaining
 * @api public
 *
 * @example client.publish('topic', 'message');
 * @example
 *     client.publish('topic', 'message', {qos: 1, retain: true, dup: true});
 * @example client.publish('topic', 'message', console.log);
 */
MqttClient.prototype.publish = function (topic, message, opts, callback) {
  var packet

  // .publish(topic, payload, cb);
  if (typeof opts === 'function') {
    callback = opts
    opts = null
  }

  // default opts
  var defaultOpts = {qos: 0, retain: false, dup: false}
  opts = xtend(defaultOpts, opts)

  if (this._checkDisconnecting(callback)) {
    return this
  }

  packet = {
    cmd: 'publish',
    topic: topic,
    payload: message,
    qos: opts.qos,
    retain: opts.retain,
    messageId: this._nextId(),
    dup: opts.dup
  }

  switch (opts.qos) {
    case 1:
    case 2:

      // Add to callbacks
      this.outgoing[packet.messageId] = callback || nop
      this._sendPacket(packet)
      break
    default:
      this._sendPacket(packet, callback)
      break
  }

  return this
}

/**
 * subscribe - subscribe to <topic>
 *
 * @param {String, Array, Object} topic - topic(s) to subscribe to, supports objects in the form {'topic': qos}
 * @param {Object} [opts] - optional subscription options, includes:
 *    {Number} qos - subscribe qos level
 * @param {Function} [callback] - function(err, granted){} where:
 *    {Error} err - subscription error (none at the moment!)
 *    {Array} granted - array of {topic: 't', qos: 0}
 * @returns {MqttClient} this - for chaining
 * @api public
 * @example client.subscribe('topic');
 * @example client.subscribe('topic', {qos: 1});
 * @example client.subscribe({'topic': 0, 'topic2': 1}, console.log);
 * @example client.subscribe('topic', console.log);
 */
MqttClient.prototype.subscribe = function () {
  var packet
  var args = Array.prototype.slice.call(arguments)
  var subs = []
  var obj = args.shift()
  var resubscribe = obj.resubscribe
  var callback = args.pop() || nop
  var opts = args.pop()
  var invalidTopic
  var that = this

  delete obj.resubscribe

  if (typeof obj === 'string') {
    obj = [obj]
  }

  if (typeof callback !== 'function') {
    opts = callback
    callback = nop
  }

  invalidTopic = validations.validateTopics(obj)
  if (invalidTopic !== null) {
    setImmediate(callback, new Error('Invalid topic ' + invalidTopic))
    return this
  }

  if (this._checkDisconnecting(callback)) {
    return this
  }

  var defaultOpts = { qos: 0 }
  opts = xtend(defaultOpts, opts)

  if (Array.isArray(obj)) {
    obj.forEach(function (topic) {
      if (that._resubscribeTopics[topic] < opts.qos ||
          !that._resubscribeTopics.hasOwnProperty(topic) ||
          resubscribe
        ) {
        subs.push({
          topic: topic,
          qos: opts.qos
        })
      }
    })
  } else {
    Object
      .keys(obj)
      .forEach(function (k) {
        if (that._resubscribeTopics[k] < obj[k] ||
            !that._resubscribeTopics.hasOwnProperty(k) ||
            resubscribe
          ) {
          subs.push({
            topic: k,
            qos: obj[k]
          })
        }
      })
  }

  packet = {
    cmd: 'subscribe',
    subscriptions: subs,
    qos: 1,
    retain: false,
    dup: false,
    messageId: this._nextId()
  }

  if (!subs.length) {
    callback(null, [])
    return
  }

  // subscriptions to resubscribe to in case of disconnect
  if (this.options.resubscribe) {
    var topics = []
    subs.forEach(function (sub) {
      if (that.options.reconnectPeriod > 0) {
        that._resubscribeTopics[sub.topic] = sub.qos
        topics.push(sub.topic)
      }
    })
    that.messageIdToTopic[packet.messageId] = topics
  }

  this.outgoing[packet.messageId] = function (err, packet) {
    if (!err) {
      var granted = packet.granted
      for (var i = 0; i < granted.length; i += 1) {
        subs[i].qos = granted[i]
      }
    }

    callback(err, subs)
  }

  this._sendPacket(packet)

  return this
}

/**
 * unsubscribe - unsubscribe from topic(s)
 *
 * @param {String, Array} topic - topics to unsubscribe from
 * @param {Function} [callback] - callback fired on unsuback
 * @returns {MqttClient} this - for chaining
 * @api public
 * @example client.unsubscribe('topic');
 * @example client.unsubscribe('topic', console.log);
 */
MqttClient.prototype.unsubscribe = function (topic, callback) {
  var packet = {
    cmd: 'unsubscribe',
    qos: 1,
    messageId: this._nextId()
  }
  var that = this

  callback = callback || nop

  if (this._checkDisconnecting(callback)) {
    return this
  }

  if (typeof topic === 'string') {
    packet.unsubscriptions = [topic]
  } else if (typeof topic === 'object' && topic.length) {
    packet.unsubscriptions = topic
  }

  if (this.options.resubscribe) {
    packet.unsubscriptions.forEach(function (topic) {
      delete that._resubscribeTopics[topic]
    })
  }

  this.outgoing[packet.messageId] = callback

  this._sendPacket(packet)

  return this
}

/**
 * end - close connection
 *
 * @returns {MqttClient} this - for chaining
 * @param {Boolean} force - do not wait for all in-flight messages to be acked
 * @param {Function} cb - called when the client has been closed
 *
 * @api public
 */
MqttClient.prototype.end = function (force, cb) {
  var that = this

  if (typeof force === 'function') {
    cb = force
    force = false
  }

  function closeStores () {
    that.disconnected = true
    that.incomingStore.close(function () {
      that.outgoingStore.close(cb)
    })
    if (that._deferredReconnect) {
      that._deferredReconnect()
    }
  }

  function finish () {
    // defer closesStores of an I/O cycle,
    // just to make sure things are
    // ok for websockets
    that._cleanUp(force, setImmediate.bind(null, closeStores))
  }

  if (this.disconnecting) {
    return this
  }

  this._clearReconnect()

  this.disconnecting = true

  if (!force && Object.keys(this.outgoing).length > 0) {
    // wait 10ms, just to be sure we received all of it
    this.once('outgoingEmpty', setTimeout.bind(null, finish, 10))
  } else {
    finish()
  }

  return this
}

/**
 * removeOutgoingMessage - remove a message in outgoing store
 * the outgoing callback will be called withe Error('Message removed') if the message is removed
 *
 * @param {Number} mid - messageId to remove message
 * @returns {MqttClient} this - for chaining
 * @api public
 *
 * @example client.removeOutgoingMessage(client.getLastMessageId());
 */
MqttClient.prototype.removeOutgoingMessage = function (mid) {
  var cb = this.outgoing[mid]
  delete this.outgoing[mid]
  this.outgoingStore.del({messageId: mid}, function () {
    cb(new Error('Message removed'))
  })
  return this
}

/**
 * reconnect - connect again using the same options as connect()
 *
 * @param {Object} [opts] - optional reconnect options, includes:
 *    {Store} incomingStore - a store for the incoming packets
 *    {Store} outgoingStore - a store for the outgoing packets
 *    if opts is not given, current stores are used
 * @returns {MqttClient} this - for chaining
 *
 * @api public
 */
MqttClient.prototype.reconnect = function (opts) {
  var that = this
  var f = function () {
    if (opts) {
      that.options.incomingStore = opts.incomingStore
      that.options.outgoingStore = opts.outgoingStore
    } else {
      that.options.incomingStore = null
      that.options.outgoingStore = null
    }
    that.incomingStore = that.options.incomingStore || new Store()
    that.outgoingStore = that.options.outgoingStore || new Store()
    that.disconnecting = false
    that.disconnected = false
    that._deferredReconnect = null
    that._reconnect()
  }

  if (this.disconnecting && !this.disconnected) {
    this._deferredReconnect = f
  } else {
    f()
  }
  return this
}

/**
 * _reconnect - implement reconnection
 * @api privateish
 */
MqttClient.prototype._reconnect = function () {
  this.emit('reconnect')
  this._setupStream()
}

/**
 * _setupReconnect - setup reconnect timer
 */
MqttClient.prototype._setupReconnect = function () {
  var that = this

  if (!that.disconnecting && !that.reconnectTimer && (that.options.reconnectPeriod > 0)) {
    if (!this.reconnecting) {
      this.emit('offline')
      this.reconnecting = true
    }
    that.reconnectTimer = setInterval(function () {
      that._reconnect()
    }, that.options.reconnectPeriod)
  }
}

/**
 * _clearReconnect - clear the reconnect timer
 */
MqttClient.prototype._clearReconnect = function () {
  if (this.reconnectTimer) {
    clearInterval(this.reconnectTimer)
    this.reconnectTimer = null
  }
}

/**
 * _cleanUp - clean up on connection end
 * @api private
 */
MqttClient.prototype._cleanUp = function (forced, done) {
  if (done) {
    this.stream.on('close', done)
  }

  if (forced) {
    this.stream.destroy()
  } else {
    this._sendPacket(
      { cmd: 'disconnect' },
      setImmediate.bind(
        null,
        this.stream.end.bind(this.stream)
      )
    )
  }

  if (!this.disconnecting) {
    this._clearReconnect()
    this._setupReconnect()
  }

  if (this.pingTimer !== null) {
    this.pingTimer.clear()
    this.pingTimer = null
  }
}

/**
 * _sendPacket - send or queue a packet
 * @param {String} type - packet type (see `protocol`)
 * @param {Object} packet - packet options
 * @param {Function} cb - callback when the packet is sent
 * @api private
 */
MqttClient.prototype._sendPacket = function (packet, cb) {
  if (!this.connected) {
    if (((packet.qos || 0) === 0 && this.queueQoSZero) || packet.cmd !== 'publish') {
      this.queue.push({ packet: packet, cb: cb })
    } else if (packet.qos > 0) {
      cb = this.outgoing[packet.messageId]
      this.outgoingStore.put(packet, function (err) {
        if (err) {
          return cb && cb(err)
        }
      })
    } else if (cb) {
      cb(new Error('No connection to broker'))
    }

    return
  }

  // When sending a packet, reschedule the ping timer
  this._shiftPingInterval()

  if (packet.cmd !== 'publish') {
    sendPacket(this, packet, cb)
    return
  }

  switch (packet.qos) {
    case 2:
    case 1:
      storeAndSend(this, packet, cb)
      break
    /**
     * no need of case here since it will be caught by default
     * and jshint comply that before default it must be a break
     * anyway it will result in -1 evaluation
     */
    case 0:
      /* falls through */
    default:
      sendPacket(this, packet, cb)
      break
  }
}

/**
 * _setupPingTimer - setup the ping timer
 *
 * @api private
 */
MqttClient.prototype._setupPingTimer = function () {
  var that = this

  if (!this.pingTimer && this.options.keepalive) {
    this.pingResp = true
    this.pingTimer = reInterval(function () {
      that._checkPing()
    }, this.options.keepalive * 1000)
  }
}

/**
 * _shiftPingInterval - reschedule the ping interval
 *
 * @api private
 */
MqttClient.prototype._shiftPingInterval = function () {
  if (this.pingTimer && this.options.keepalive && this.options.reschedulePings) {
    this.pingTimer.reschedule(this.options.keepalive * 1000)
  }
}
/**
 * _checkPing - check if a pingresp has come back, and ping the server again
 *
 * @api private
 */
MqttClient.prototype._checkPing = function () {
  if (this.pingResp) {
    this.pingResp = false
    this._sendPacket({ cmd: 'pingreq' })
  } else {
    // do a forced cleanup since socket will be in bad shape
    this._cleanUp(true)
  }
}

/**
 * _handlePingresp - handle a pingresp
 *
 * @api private
 */
MqttClient.prototype._handlePingresp = function () {
  this.pingResp = true
}

/**
 * _handleConnack
 *
 * @param {Object} packet
 * @api private
 */

MqttClient.prototype._handleConnack = function (packet) {
  var rc = packet.returnCode
  var errors = [
    '',
    'Unacceptable protocol version',
    'Identifier rejected',
    'Server unavailable',
    'Bad username or password',
    'Not authorized'
  ]

  clearTimeout(this.connackTimer)

  if (rc === 0) {
    this.reconnecting = false
    this.emit('connect', packet)
  } else if (rc > 0) {
    var err = new Error('Connection refused: ' + errors[rc])
    err.code = rc
    this.emit('error', err)
  }
}

/**
 * _handlePublish
 *
 * @param {Object} packet
 * @api private
 */
/*
those late 2 case should be rewrite to comply with coding style:

case 1:
case 0:
  // do not wait sending a puback
  // no callback passed
  if (1 === qos) {
    this._sendPacket({
      cmd: 'puback',
      messageId: mid
    });
  }
  // emit the message event for both qos 1 and 0
  this.emit('message', topic, message, packet);
  this.handleMessage(packet, done);
  break;
default:
  // do nothing but every switch mus have a default
  // log or throw an error about unknown qos
  break;

for now i just suppressed the warnings
*/
MqttClient.prototype._handlePublish = function (packet, done) {
  var topic = packet.topic.toString()
  var message = packet.payload
  var qos = packet.qos
  var mid = packet.messageId
  var that = this

  switch (qos) {
    case 2:
      this.incomingStore.put(packet, function () {
        that._sendPacket({cmd: 'pubrec', messageId: mid}, done)
      })
      break
    case 1:
      // emit the message event
      this.emit('message', topic, message, packet)
      this.handleMessage(packet, function (err) {
        if (err) {
          return done && done(err)
        }
        // send 'puback' if the above 'handleMessage' method executed
        // successfully.
        that._sendPacket({cmd: 'puback', messageId: mid}, done)
      })
      break
    case 0:
      // emit the message event
      this.emit('message', topic, message, packet)
      this.handleMessage(packet, done)
      break
    default:
      // do nothing
      // log or throw an error about unknown qos
      break
  }
}

/**
 * Handle messages with backpressure support, one at a time.
 * Override at will.
 *
 * @param Packet packet the packet
 * @param Function callback call when finished
 * @api public
 */
MqttClient.prototype.handleMessage = function (packet, callback) {
  callback()
}

/**
 * _handleAck
 *
 * @param {Object} packet
 * @api private
 */

MqttClient.prototype._handleAck = function (packet) {
  /* eslint no-fallthrough: "off" */
  var mid = packet.messageId
  var type = packet.cmd
  var response = null
  var cb = this.outgoing[mid]
  var that = this

  if (!cb) {
    // Server sent an ack in error, ignore it.
    return
  }

  // Process
  switch (type) {
    case 'pubcomp':
      // same thing as puback for QoS 2
    case 'puback':
      // Callback - we're done
      delete this.outgoing[mid]
      this.outgoingStore.del(packet, cb)
      break
    case 'pubrec':
      response = {
        cmd: 'pubrel',
        qos: 2,
        messageId: mid
      }

      this._sendPacket(response)
      break
    case 'suback':
      delete this.outgoing[mid]
      if (packet.granted.length === 1 && (packet.granted[0] & 0x80) !== 0) {
        // suback with Failure status
        var topics = this.messageIdToTopic[mid]
        if (topics) {
          topics.forEach(function (topic) {
            delete that._resubscribeTopics[topic]
          })
        }
      }
      cb(null, packet)
      break
    case 'unsuback':
      delete this.outgoing[mid]
      cb(null)
      break
    default:
      that.emit('error', new Error('unrecognized packet type'))
  }

  if (this.disconnecting &&
      Object.keys(this.outgoing).length === 0) {
    this.emit('outgoingEmpty')
  }
}

/**
 * _handlePubrel
 *
 * @param {Object} packet
 * @api private
 */
MqttClient.prototype._handlePubrel = function (packet, callback) {
  var mid = packet.messageId
  var that = this

  var comp = {cmd: 'pubcomp', messageId: mid}

  that.incomingStore.get(packet, function (err, pub) {
    if (!err && pub.cmd !== 'pubrel') {
      that.emit('message', pub.topic, pub.payload, pub)
      that.incomingStore.put(packet)
      that.handleMessage(pub, function (err) {
        if (err) {
          return callback && callback(err)
        }
        that._sendPacket(comp, callback)
      })
    } else {
      that._sendPacket(comp, callback)
    }
  })
}

/**
 * _nextId
 */
MqttClient.prototype._nextId = function () {
  var id = this.nextId++
  // Ensure 16 bit unsigned int:
  if (id === 65535) {
    this.nextId = 1
  }
  return id
}

/**
 * getLastMessageId
 */
MqttClient.prototype.getLastMessageId = function () {
  return (this.nextId === 1) ? 65535 : (this.nextId - 1)
}

module.exports = MqttClient

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30), __webpack_require__(59)))

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var MqttClient = __webpack_require__(1527)
var Store = __webpack_require__(666)
var url = __webpack_require__(352)
var xtend = __webpack_require__(353)
var protocols = {}

if (process.title !== 'browser') {
  protocols.mqtt = __webpack_require__(663)
  protocols.tcp = __webpack_require__(663)
  protocols.ssl = __webpack_require__(338)
  protocols.tls = __webpack_require__(338)
  protocols.mqtts = __webpack_require__(338)
} else {
  protocols.wx = __webpack_require__(665)
  protocols.wxs = __webpack_require__(665)
}

protocols.ws = __webpack_require__(664)
protocols.wss = __webpack_require__(664)

/**
 * Parse the auth attribute and merge username and password in the options object.
 *
 * @param {Object} [opts] option object
 */
function parseAuthOptions (opts) {
  var matches
  if (opts.auth) {
    matches = opts.auth.match(/^(.+):(.+)$/)
    if (matches) {
      opts.username = matches[1]
      opts.password = matches[2]
    } else {
      opts.username = opts.auth
    }
  }
}

/**
 * connect - connect to an MQTT broker.
 *
 * @param {String} [brokerUrl] - url of the broker, optional
 * @param {Object} opts - see MqttClient#constructor
 */
function connect (brokerUrl, opts) {
  if ((typeof brokerUrl === 'object') && !opts) {
    opts = brokerUrl
    brokerUrl = null
  }

  opts = opts || {}

  if (brokerUrl) {
    var parsed = url.parse(brokerUrl, true)
    if (parsed.port != null) {
      parsed.port = Number(parsed.port)
    }

    opts = xtend(parsed, opts)

    if (opts.protocol === null) {
      throw new Error('Missing protocol')
    }
    opts.protocol = opts.protocol.replace(/:$/, '')
  }

  // merge in the auth options if supplied
  parseAuthOptions(opts)

  // support clientId passed in the query string of the url
  if (opts.query && typeof opts.query.clientId === 'string') {
    opts.clientId = opts.query.clientId
  }

  if (opts.cert && opts.key) {
    if (opts.protocol) {
      if (['mqtts', 'wss', 'wxs'].indexOf(opts.protocol) === -1) {
        switch (opts.protocol) {
          case 'mqtt':
            opts.protocol = 'mqtts'
            break
          case 'ws':
            opts.protocol = 'wss'
            break
          case 'wx':
            opts.protocol = 'wxs'
            break
          default:
            throw new Error('Unknown protocol for secure connection: "' + opts.protocol + '"!')
        }
      }
    } else {
      // don't know what protocol he want to use, mqtts or wss
      throw new Error('Missing secure protocol key')
    }
  }

  if (!protocols[opts.protocol]) {
    var isSecure = ['mqtts', 'wss'].indexOf(opts.protocol) !== -1
    opts.protocol = [
      'mqtt',
      'mqtts',
      'ws',
      'wss',
      'wx',
      'wxs'
    ].filter(function (key, index) {
      if (isSecure && index % 2 === 0) {
        // Skip insecure protocols when requesting a secure one.
        return false
      }
      return (typeof protocols[key] === 'function')
    })[0]
  }

  if (opts.clean === false && !opts.clientId) {
    throw new Error('Missing clientId for unclean clients')
  }

  function wrapper (client) {
    if (opts.servers) {
      if (!client._reconnectCount || client._reconnectCount === opts.servers.length) {
        client._reconnectCount = 0
      }

      opts.host = opts.servers[client._reconnectCount].host
      opts.port = opts.servers[client._reconnectCount].port
      opts.hostname = opts.host

      client._reconnectCount++
    }

    return protocols[opts.protocol](client, opts)
  }

  return new MqttClient(wrapper, opts)
}

module.exports = connect
module.exports.connect = connect
module.exports.MqttClient = MqttClient
module.exports.Store = Store

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Validate a topic to see if it's valid or not.
 * A topic is valid if it follow below rules:
 * - Rule #1: If any part of the topic is not `+` or `#`, then it must not contain `+` and '#'
 * - Rule #2: Part `#` must be located at the end of the mailbox
 *
 * @param {String} topic - A topic
 * @returns {Boolean} If the topic is valid, returns true. Otherwise, returns false.
 */
function validateTopic (topic) {
  var parts = topic.split('/')

  for (var i = 0; i < parts.length; i++) {
    if (parts[i] === '+') {
      continue
    }

    if (parts[i] === '#') {
      // for Rule #2
      return i === parts.length - 1
    }

    if (parts[i].indexOf('+') !== -1 || parts[i].indexOf('#') !== -1) {
      return false
    }
  }

  return true
}

/**
 * Validate an array of topics to see if any of them is valid or not
  * @param {Array} topics - Array of topics
 * @returns {String} If the topics is valid, returns null. Otherwise, returns the invalid one
 */
function validateTopics (topics) {
  if (topics.length === 0) {
    return 'empty_topic_list'
  }
  for (var i = 0; i < topics.length; i++) {
    if (!validateTopic(topics[i])) {
      return topics[i]
    }
  }
  return null
}

module.exports = {
  validateTopics: validateTopics
}


/***/ }),
/* 1530 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = __webpack_require__.i({"NODE_ENV":"production"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(1530);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(90);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30), __webpack_require__(59)))

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

var wrappy = __webpack_require__(1661)
module.exports = wrappy(once)
module.exports.strict = wrappy(onceStrict)

once.proto = once(function () {
  Object.defineProperty(Function.prototype, 'once', {
    value: function () {
      return once(this)
    },
    configurable: true
  })

  Object.defineProperty(Function.prototype, 'onceStrict', {
    value: function () {
      return onceStrict(this)
    },
    configurable: true
  })
})

function once (fn) {
  var f = function () {
    if (f.called) return f.value
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  f.called = false
  return f
}

function onceStrict (fn) {
  var f = function () {
    if (f.called)
      throw new Error(f.onceError)
    f.called = true
    return f.value = fn.apply(this, arguments)
  }
  var name = fn.name || 'Function wrapped with `once`'
  f.onceError = name + " shouldn't be called more than once"
  f.called = false
  return f
}


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1535);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(248)(module), __webpack_require__(30)))

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1533)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(1608);


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(148);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getIterator2 = __webpack_require__(146);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _map = __webpack_require__(181);

var _map2 = _interopRequireDefault(_map);

exports.default = makeAsyncScript;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SCRIPT_MAP = new _map2.default();

// A counter used to generate a unique id for each component that uses the function
var idCount = 0;

function makeAsyncScript(Component, scriptURL, options) {
  options = options || {};
  var wrappedComponentName = Component.displayName || Component.name || "Component";

  var AsyncScriptLoader = function (_React$Component) {
    (0, _inherits3.default)(AsyncScriptLoader, _React$Component);

    function AsyncScriptLoader() {
      (0, _classCallCheck3.default)(this, AsyncScriptLoader);

      var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));

      _this.state = {};
      return _this;
    }

    AsyncScriptLoader.prototype.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
      if (!this.__scriptLoaderID) {
        this.__scriptLoaderID = "async-script-loader-" + idCount++;
      }
      return this.__scriptLoaderID;
    };

    AsyncScriptLoader.prototype.getComponent = function getComponent() {
      return this.childComponent;
    };

    AsyncScriptLoader.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      var key = this.asyncScriptLoaderGetScriptLoaderID();
      var _options = options,
          globalName = _options.globalName,
          callbackName = _options.callbackName;

      if (globalName && typeof window[globalName] !== "undefined") {
        SCRIPT_MAP.set(scriptURL, { loaded: true, observers: new _map2.default() });
      }

      if (SCRIPT_MAP.has(scriptURL)) {
        var entry = SCRIPT_MAP.get(scriptURL);
        if (entry && (entry.loaded || entry.errored)) {
          this.asyncScriptLoaderHandleLoad(entry);
          return;
        }
        entry.observers.set(key, function (entry) {
          return _this2.asyncScriptLoaderHandleLoad(entry);
        });
        return;
      }

      var observers = new _map2.default();
      observers.set(key, function (entry) {
        return _this2.asyncScriptLoaderHandleLoad(entry);
      });
      SCRIPT_MAP.set(scriptURL, {
        loaded: false,
        observers: observers
      });

      var script = document.createElement("script");

      script.src = scriptURL;
      script.async = 1;

      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
        if (SCRIPT_MAP.has(scriptURL)) {
          var mapEntry = SCRIPT_MAP.get(scriptURL);
          var observersMap = mapEntry.observers;

          for (var _iterator = observersMap, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
            var _ref;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }

            var _ref2 = _ref,
                obsKey = _ref2[0],
                observer = _ref2[1];

            if (func(observer)) {
              observersMap.delete(obsKey);
            }
          }
        }
      };

      if (callbackName && typeof window !== "undefined") {
        window[callbackName] = AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded;
      }

      script.onload = function () {
        var mapEntry = SCRIPT_MAP.get(scriptURL);
        if (mapEntry) {
          mapEntry.loaded = true;
          callObserverFuncAndRemoveObserver(function (observer) {
            if (callbackName) {
              return false;
            }
            observer(mapEntry);
            return true;
          });
        }
      };
      script.onerror = function (event) {
        var mapEntry = SCRIPT_MAP.get(scriptURL);
        if (mapEntry) {
          mapEntry.errored = true;
          callObserverFuncAndRemoveObserver(function (observer) {
            observer(mapEntry);
            return true;
          });
        }
      };

      // (old) MSIE browsers may call "onreadystatechange" instead of "onload"
      script.onreadystatechange = function () {
        if (_this2.readyState === "loaded") {
          // wait for other events, then call onload if default onload hadn't been called
          window.setTimeout(function () {
            var mapEntry = SCRIPT_MAP.get(scriptURL);
            if (mapEntry && mapEntry.loaded !== true) {
              script.onload();
            }
          }, 0);
        }
      };

      document.body.appendChild(script);
    };

    AsyncScriptLoader.prototype.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
      this.setState(state, this.props.asyncScriptOnLoad);
    };

    AsyncScriptLoader.prototype.componentWillUnmount = function componentWillUnmount() {
      // Remove tag script
      if (options.removeOnUnmount === true) {
        var allScripts = document.getElementsByTagName("script");
        for (var i = 0; i < allScripts.length; i += 1) {
          if (allScripts[i].src.indexOf(scriptURL) > -1) {
            if (allScripts[i].parentNode) {
              allScripts[i].parentNode.removeChild(allScripts[i]);
            }
          }
        }
      }
      // Clean the observer entry
      var mapEntry = SCRIPT_MAP.get(scriptURL);
      if (mapEntry) {
        mapEntry.observers.delete(this.asyncScriptLoaderGetScriptLoaderID());
        if (options.removeOnUnmount === true) {
          SCRIPT_MAP.delete(scriptURL);
        }
      }
    };

    AsyncScriptLoader.prototype.render = function render() {
      var _this3 = this;

      var globalName = options.globalName;
      var _props = this.props,
          asyncScriptOnLoad = _props.asyncScriptOnLoad,
          childProps = (0, _objectWithoutProperties3.default)(_props, ["asyncScriptOnLoad"]);

      if (globalName && typeof window !== "undefined") {
        childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
      }
      return _react2.default.createElement(Component, (0, _extends3.default)({ ref: function ref(comp) {
          _this3.childComponent = comp;
        } }, childProps));
    };

    return AsyncScriptLoader;
  }(_react2.default.Component);

  AsyncScriptLoader.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
  AsyncScriptLoader.propTypes = {
    asyncScriptOnLoad: _propTypes2.default.func
  };
  AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded = function () {
    var mapEntry = SCRIPT_MAP.get(scriptURL);
    if (!mapEntry || !mapEntry.loaded) {
      throw new Error("Script is not loaded.");
    }
    for (var _iterator2 = mapEntry.observers.values(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
      var _ref3;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref3 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref3 = _i2.value;
      }

      var observer = _ref3;

      observer(mapEntry);
    }
    delete window[options.callbackName];
  };

  if (options.exposeFuncs) {
    var _loop = function _loop() {
      if (_isArray3) {
        if (_i3 >= _iterator3.length) return "break";
        _ref4 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) return "break";
        _ref4 = _i3.value;
      }

      var funcToExpose = _ref4;

      /* eslint-disable no-loop-func */
      AsyncScriptLoader.prototype[funcToExpose] = function () {
        var _getComponent;

        return (_getComponent = this.getComponent())[funcToExpose].apply(_getComponent, arguments);
      };
      /* eslint-enable no-loop-func */
    };

    for (var _iterator3 = options.exposeFuncs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
      var _ref4;

      var _ret = _loop();

      if (_ret === "break") break;
    }
  }
  return AsyncScriptLoader;
}

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var ba=__webpack_require__(107),ea=__webpack_require__(0),m=__webpack_require__(191),A=__webpack_require__(155),C=__webpack_require__(240),fa=__webpack_require__(1466),ha=__webpack_require__(1469),ja=__webpack_require__(1465),ka=__webpack_require__(329);
function D(a){for(var b=arguments.length-1,c="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);ba(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ea?void 0:D("227");
function ma(a,b,c,d,e,f,h,g,k){this._hasCaughtError=!1;this._caughtError=null;var v=Array.prototype.slice.call(arguments,3);try{b.apply(c,v)}catch(l){this._caughtError=l,this._hasCaughtError=!0}}
var E={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,h,g,k){ma.apply(E,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,h,g,k){E.invokeGuardedCallback.apply(this,arguments);if(E.hasCaughtError()){var v=E.clearCaughtError();E._hasRethrowError||(E._hasRethrowError=!0,E._rethrowError=v)}},rethrowCaughtError:function(){return na.apply(E,arguments)},hasCaughtError:function(){return E._hasCaughtError},clearCaughtError:function(){if(E._hasCaughtError){var a=
E._caughtError;E._caughtError=null;E._hasCaughtError=!1;return a}D("198")}};function na(){if(E._hasRethrowError){var a=E._rethrowError;E._rethrowError=null;E._hasRethrowError=!1;throw a;}}var oa=null,pa={};
function qa(){if(oa)for(var a in pa){var b=pa[a],c=oa.indexOf(a);-1<c?void 0:D("96",a);if(!ra[c]){b.extractEvents?void 0:D("97",a);ra[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;sa.hasOwnProperty(g)?D("99",g):void 0;sa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ta(k[e],h,g);e=!0}else f.registrationName?(ta(f.registrationName,h,g),e=!0):e=!1;e?void 0:D("98",d,a)}}}}
function ta(a,b,c){ua[a]?D("100",a):void 0;ua[a]=b;va[a]=b.eventTypes[c].dependencies}var ra=[],sa={},ua={},va={};function wa(a){oa?D("101"):void 0;oa=Array.prototype.slice.call(a);qa()}function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];pa.hasOwnProperty(c)&&pa[c]===d||(pa[c]?D("102",c):void 0,pa[c]=d,b=!0)}b&&qa()}
var Ca=Object.freeze({plugins:ra,eventNameDispatchConfigs:sa,registrationNameModules:ua,registrationNameDependencies:va,possibleRegistrationNames:null,injectEventPluginOrder:wa,injectEventPluginsByName:xa}),Da=null,Ea=null,Fa=null;function Ga(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=Fa(d);E.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Ha(a,b){null==b?D("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ia(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ja=null;
function Ka(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)Ga(a,b,c[e],d[e]);else c&&Ga(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function La(a){return Ka(a,!0)}function Ma(a){return Ka(a,!1)}var Na={injectEventPluginOrder:wa,injectEventPluginsByName:xa};
function Oa(a,b){var c=a.stateNode;if(!c)return null;var d=Da(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?D("231",b,typeof c):void 0;
return c}function Pa(a,b){null!==a&&(Ja=Ha(Ja,a));a=Ja;Ja=null;a&&(b?Ia(a,La):Ia(a,Ma),Ja?D("95"):void 0,E.rethrowCaughtError())}function Qa(a,b,c,d){for(var e=null,f=0;f<ra.length;f++){var h=ra[f];h&&(h=h.extractEvents(a,b,c,d))&&(e=Ha(e,h))}Pa(e,!1)}var Ra=Object.freeze({injection:Na,getListener:Oa,runEventsInBatch:Pa,runExtractedEventsInBatch:Qa}),Sa=Math.random().toString(36).slice(2),F="__reactInternalInstance$"+Sa,Ta="__reactEventHandlers$"+Sa;
function Ua(a){if(a[F])return a[F];for(;!a[F];)if(a.parentNode)a=a.parentNode;else return null;a=a[F];return 5===a.tag||6===a.tag?a:null}function Va(a){if(5===a.tag||6===a.tag)return a.stateNode;D("33")}function Xa(a){return a[Ta]||null}var bb=Object.freeze({precacheFiberNode:function(a,b){b[F]=a},getClosestInstanceFromNode:Ua,getInstanceFromNode:function(a){a=a[F];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Va,getFiberCurrentPropsFromNode:Xa,updateFiberProps:function(a,b){a[Ta]=b}});
function L(a){do a=a["return"];while(a&&5!==a.tag);return a?a:null}function cb(a,b,c){for(var d=[];a;)d.push(a),a=L(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function db(a,b,c){if(b=Oa(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a)}function eb(a){a&&a.dispatchConfig.phasedRegistrationNames&&cb(a._targetInst,db,a)}
function fb(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?L(b):null;cb(b,db,a)}}function gb(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Oa(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Ha(c._dispatchListeners,b),c._dispatchInstances=Ha(c._dispatchInstances,a))}function hb(a){a&&a.dispatchConfig.registrationName&&gb(a._targetInst,null,a)}function ib(a){Ia(a,eb)}
function jb(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,h=0,g=e;g;g=L(g))h++;g=0;for(var k=f;k;k=L(k))g++;for(;0<h-g;)e=L(e),h--;for(;0<g-h;)f=L(f),g--;for(;h--;){if(e===f||e===f.alternate)break a;e=L(e);f=L(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){h=c.alternate;if(null!==h&&h===f)break;e.push(c);c=L(c)}for(c=[];d&&d!==f;){h=d.alternate;if(null!==h&&h===f)break;c.push(d);d=L(d)}for(d=0;d<e.length;d++)gb(e[d],"bubbled",a);for(a=c.length;0<a--;)gb(c[a],"captured",b)}
var kb=Object.freeze({accumulateTwoPhaseDispatches:ib,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ia(a,fb)},accumulateEnterLeaveDispatches:jb,accumulateDirectDispatches:function(a){Ia(a,hb)}}),lb=null;function mb(){!lb&&m.canUseDOM&&(lb="textContent"in document.documentElement?"textContent":"innerText");return lb}var M={_root:null,_startText:null,_fallbackText:null};
function nb(){if(M._fallbackText)return M._fallbackText;var a,b=M._startText,c=b.length,d,e=ob(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);M._fallbackText=e.slice(a,1<d?1-d:void 0);return M._fallbackText}function ob(){return"value"in M._root?M._root.value:M._root[mb()]}
var pb="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),qb={type:null,target:null,currentTarget:C.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function N(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C.thatReturnsTrue:C.thatReturnsFalse;this.isPropagationStopped=C.thatReturnsFalse;return this}
A(N.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C.thatReturnsTrue)},persist:function(){this.isPersistent=C.thatReturnsTrue},isPersistent:C.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<pb.length;a++)this[pb[a]]=null}});N.Interface=qb;N.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;A(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=A({},d.Interface,a);c.extend=d.extend;rb(c);return c};rb(N);
function sb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function tb(a){a instanceof this?void 0:D("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function rb(a){a.eventPool=[];a.getPooled=sb;a.release=tb}var ub=N.extend({data:null}),vb=N.extend({data:null}),wb=[9,13,27,32],xb=m.canUseDOM&&"CompositionEvent"in window,yb=null;m.canUseDOM&&"documentMode"in document&&(yb=document.documentMode);
var zb=m.canUseDOM&&"TextEvent"in window&&!yb,Ab=m.canUseDOM&&(!xb||yb&&8<yb&&11>=yb),Bb=String.fromCharCode(32),Kb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},Lb=!1;
function Mb(a,b){switch(a){case "topKeyUp":return-1!==wb.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function Nb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Ob=!1;function Pb(a,b){switch(a){case "topCompositionEnd":return Nb(b);case "topKeyPress":if(32!==b.which)return null;Lb=!0;return Bb;case "topTextInput":return a=b.data,a===Bb&&Lb?null:a;default:return null}}
function Qb(a,b){if(Ob)return"topCompositionEnd"===a||!xb&&Mb(a,b)?(a=nb(),M._root=null,M._startText=null,M._fallbackText=null,Ob=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return Ab?null:b.data;default:return null}}
var Rb={eventTypes:Kb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(xb)b:{switch(a){case "topCompositionStart":e=Kb.compositionStart;break b;case "topCompositionEnd":e=Kb.compositionEnd;break b;case "topCompositionUpdate":e=Kb.compositionUpdate;break b}e=void 0}else Ob?Mb(a,c)&&(e=Kb.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(e=Kb.compositionStart);e?(Ab&&(Ob||e!==Kb.compositionStart?e===Kb.compositionEnd&&Ob&&(f=nb()):(M._root=d,M._startText=ob(),Ob=!0)),e=ub.getPooled(e,
b,c,d),f?e.data=f:(f=Nb(c),null!==f&&(e.data=f)),ib(e),f=e):f=null;(a=zb?Pb(a,c):Qb(a,c))?(b=vb.getPooled(Kb.beforeInput,b,c,d),b.data=a,ib(b)):b=null;return null===f?b:null===b?f:[f,b]}},Sb=null,Tb={injectFiberControlledHostComponent:function(a){Sb=a}},Ub=null,Vb=null;function Wb(a){if(a=Ea(a)){Sb&&"function"===typeof Sb.restoreControlledState?void 0:D("194");var b=Da(a.stateNode);Sb.restoreControlledState(a.stateNode,a.type,b)}}function Xb(a){Ub?Vb?Vb.push(a):Vb=[a]:Ub=a}
function Yb(){return null!==Ub||null!==Vb}function Zb(){if(Ub){var a=Ub,b=Vb;Vb=Ub=null;Wb(a);if(b)for(a=0;a<b.length;a++)Wb(b[a])}}var $b=Object.freeze({injection:Tb,enqueueStateRestore:Xb,needsStateRestore:Yb,restoreStateIfNeeded:Zb});function ac(a,b){return a(b)}function bc(a,b,c){return a(b,c)}function cc(){}var dc=!1;function ec(a,b){if(dc)return a(b);dc=!0;try{return ac(a,b)}finally{dc=!1,Yb()&&(cc(),Zb())}}
var fc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function gc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!fc[a.type]:"textarea"===b?!0:!1}function hc(a){a=a.target||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function ic(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function jc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function kc(a){var b=jc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),Object.defineProperty(a,b,{enumerable:c.enumerable}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
function lc(a){a._valueTracker||(a._valueTracker=kc(a))}function mc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=jc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var nc=ea.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,O="function"===typeof Symbol&&Symbol["for"],oc=O?Symbol["for"]("react.element"):60103,pc=O?Symbol["for"]("react.call"):60104,qc=O?Symbol["for"]("react.return"):60105,rc=O?Symbol["for"]("react.portal"):60106,sc=O?Symbol["for"]("react.fragment"):60107,tc=O?Symbol["for"]("react.strict_mode"):60108,uc=O?Symbol["for"]("react.provider"):60109,vc=O?Symbol["for"]("react.context"):60110,wc=O?Symbol["for"]("react.async_mode"):60111,
xc=O?Symbol["for"]("react.forward_ref"):60112,yc="function"===typeof Symbol&&Symbol.iterator;function zc(a){if(null===a||"undefined"===typeof a)return null;a=yc&&a[yc]||a["@@iterator"];return"function"===typeof a?a:null}
function Ac(a){a=a.type;if("function"===typeof a)return a.displayName||a.name;if("string"===typeof a)return a;switch(a){case sc:return"ReactFragment";case rc:return"ReactPortal";case pc:return"ReactCall";case qc:return"ReactReturn"}if("object"===typeof a&&null!==a)switch(a.$$typeof){case xc:return a=a.render.displayName||a.render.name||"",""!==a?"ForwardRef("+a+")":"ForwardRef"}return null}
function Bc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=Ac(a);var f=null;c&&(f=Ac(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a["return"]}while(a);return b}
var Cc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Dc={},Ec={};function Fc(a){if(Ec.hasOwnProperty(a))return!0;if(Dc.hasOwnProperty(a))return!1;if(Cc.test(a))return Ec[a]=!0;Dc[a]=!0;return!1}
function Gc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}function Hc(a,b,c,d){if(null===b||"undefined"===typeof b||Gc(a,b,c,d))return!0;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}
function U(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var V={};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){V[a]=new U(a,0,!1,a,null)});
[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];V[b]=new U(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){V[a]=new U(a,2,!1,a.toLowerCase(),null)});["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){V[a]=new U(a,2,!1,a,null)});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){V[a]=new U(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){V[a]=new U(a,3,!0,a.toLowerCase(),null)});["capture","download"].forEach(function(a){V[a]=new U(a,4,!1,a.toLowerCase(),null)});
["cols","rows","size","span"].forEach(function(a){V[a]=new U(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){V[a]=new U(a,5,!1,a.toLowerCase(),null)});var Sc=/[\-:]([a-z])/g;function Tc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Sc,
Tc);V[b]=new U(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Sc,Tc);V[b]=new U(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});V.tabIndex=new U("tabIndex",1,!1,"tabindex",null);
function Uc(a,b,c,d){var e=V.hasOwnProperty(b)?V[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Hc(b,c,e,d)&&(c=null),d||null===e?Fc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Vc(a,b){var c=b.checked;return A({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Wc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Xc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Yc(a,b){b=b.checked;null!=b&&Uc(a,"checked",b,!1)}
function Zc(a,b){Yc(a,b);var c=Xc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?$c(a,b.type,c):b.hasOwnProperty("defaultValue")&&$c(a,b.type,Xc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function ad(a,b){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue"))""===a.value&&(a.value=""+a._wrapperState.initialValue),a.defaultValue=""+a._wrapperState.initialValue;b=a.name;""!==b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)}function $c(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Xc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var bd={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function cd(a,b,c){a=N.getPooled(bd.change,a,b,c);a.type="change";Xb(c);ib(a);return a}var dd=null,ed=null;function fd(a){Pa(a,!1)}
function gd(a){var b=Va(a);if(mc(b))return a}function hd(a,b){if("topChange"===a)return b}var id=!1;m.canUseDOM&&(id=ic("input")&&(!document.documentMode||9<document.documentMode));function jd(){dd&&(dd.detachEvent("onpropertychange",kd),ed=dd=null)}function kd(a){"value"===a.propertyName&&gd(ed)&&(a=cd(ed,a,hc(a)),ec(fd,a))}function ld(a,b,c){"topFocus"===a?(jd(),dd=b,ed=c,dd.attachEvent("onpropertychange",kd)):"topBlur"===a&&jd()}
function md(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return gd(ed)}function nd(a,b){if("topClick"===a)return gd(b)}function od(a,b){if("topInput"===a||"topChange"===a)return gd(b)}
var pd={eventTypes:bd,_isInputEventSupported:id,extractEvents:function(a,b,c,d){var e=b?Va(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=hd:gc(e)?id?f=od:(f=md,h=ld):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=nd);if(f&&(f=f(a,b)))return cd(f,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&$c(e,"number",e.value)}},qd=N.extend({view:null,
detail:null}),rd={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function sd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=rd[a])?!!b[a]:!1}function td(){return sd}
var ud=qd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:td,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),vd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},wd={eventTypes:vd,extractEvents:function(a,
b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?Ua(b):null):a=null;if(a===b)return null;var f=null==a?e:Va(a);e=null==b?e:Va(b);var h=ud.getPooled(vd.mouseLeave,a,c,d);h.type="mouseleave";h.target=f;h.relatedTarget=e;c=ud.getPooled(vd.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=
f;jb(h,c,a,b);return[h,c]}};function xd(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if(0!==(b.effectTag&2))return 1;for(;b["return"];)if(b=b["return"],0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function yd(a){return(a=a._reactInternalFiber)?2===xd(a):!1}function zd(a){2!==xd(a)?D("188"):void 0}
function Ad(a){var b=a.alternate;if(!b)return b=xd(a),3===b?D("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var h=e.child;h;){if(h===c)return zd(e),a;if(h===d)return zd(e),b;h=h.sibling}D("188")}if(c["return"]!==d["return"])c=e,d=f;else{h=!1;for(var g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}h?
void 0:D("189")}}c.alternate!==d?D("190"):void 0}3!==c.tag?D("188"):void 0;return c.stateNode.current===c?a:b}function Bd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}
function Cd(a){a=Ad(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}var Dd=N.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Ed=N.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Fd=qd.extend({relatedTarget:null});
function Gd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Hd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Id={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Jd=qd.extend({key:function(a){if(a.key){var b=Hd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Gd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Id[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:td,charCode:function(a){return"keypress"===
a.type?Gd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Gd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Kd=ud.extend({dataTransfer:null}),Ld=qd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:td}),Md=N.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Nd=ud.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Od={},Pd={};function Qd(a,b){var c=a[0].toUpperCase()+a.slice(1),d="on"+c;c="top"+c;b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Od[a]=b;Pd[c]=b}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function(a){Qd(a,!0)});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function(a){Qd(a,!1)});
var Rd={eventTypes:Od,isInteractiveTopLevelEventType:function(a){a=Pd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Pd[a];if(!e)return null;switch(a){case "topKeyPress":if(0===Gd(c))return null;case "topKeyDown":case "topKeyUp":a=Jd;break;case "topBlur":case "topFocus":a=Fd;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":a=
ud;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":a=Kd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":a=Ld;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":a=Dd;break;case "topTransitionEnd":a=Md;break;case "topScroll":a=qd;break;case "topWheel":a=Nd;break;case "topCopy":case "topCut":case "topPaste":a=Ed;break;default:a=
N}b=a.getPooled(e,b,c,d);ib(b);return b}},Sd=Rd.isInteractiveTopLevelEventType,Td=[];function Ud(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c["return"];)c=c["return"];c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Ua(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Qa(a.topLevelType,b,a.nativeEvent,hc(a.nativeEvent))}var Vd=!0;function Wd(a){Vd=!!a}
function W(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!1)}function Zd(a,b,c){if(!c)return null;a=(Sd(a)?Xd:Yd).bind(null,a);c.addEventListener(b,a,!0)}function Xd(a,b){bc(Yd,a,b)}
function Yd(a,b){if(Vd){var c=hc(b);c=Ua(c);null!==c&&"number"===typeof c.tag&&2!==xd(c)&&(c=null);if(Td.length){var d=Td.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{ec(Ud,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Td.length&&Td.push(a)}}}
var $d=Object.freeze({get _enabled(){return Vd},setEnabled:Wd,isEnabled:function(){return Vd},trapBubbledEvent:W,trapCapturedEvent:Zd,dispatchEvent:Yd});function ae(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var be={animationend:ae("Animation","AnimationEnd"),animationiteration:ae("Animation","AnimationIteration"),animationstart:ae("Animation","AnimationStart"),transitionend:ae("Transition","TransitionEnd")},ce={},de={};m.canUseDOM&&(de=document.createElement("div").style,"AnimationEvent"in window||(delete be.animationend.animation,delete be.animationiteration.animation,delete be.animationstart.animation),"TransitionEvent"in window||delete be.transitionend.transition);
function ee(a){if(ce[a])return ce[a];if(!be[a])return a;var b=be[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in de)return ce[a]=b[c];return a}
var fe={topAnimationEnd:ee("animationend"),topAnimationIteration:ee("animationiteration"),topAnimationStart:ee("animationstart"),topBlur:"blur",topCancel:"cancel",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",
topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoad:"load",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topScroll:"scroll",topSelectionChange:"selectionchange",topTextInput:"textInput",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:ee("transitionend"),topWheel:"wheel"},ge={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",
topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},he={},ie=0,je="_reactListenersID"+(""+Math.random()).slice(2);function ke(a){Object.prototype.hasOwnProperty.call(a,je)||(a[je]=ie++,he[a[je]]={});return he[a[je]]}function le(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function me(a,b){var c=le(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=le(c)}}function ne(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)}
var oe=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,pe={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},qe=null,re=null,se=null,te=!1;
function ue(a,b){if(te||null==qe||qe!==fa())return null;var c=qe;"selectionStart"in c&&ne(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return se&&ha(se,c)?null:(se=c,a=N.getPooled(pe.select,re,a,b),a.type="select",a.target=qe,ib(a),a)}
var ve={eventTypes:pe,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=ke(e);f=va.onSelect;for(var h=0;h<f.length;h++){var g=f[h];if(!e.hasOwnProperty(g)||!e[g]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Va(b):window;switch(a){case "topFocus":if(gc(e)||"true"===e.contentEditable)qe=e,re=b,se=null;break;case "topBlur":se=re=qe=null;break;case "topMouseDown":te=!0;break;case "topContextMenu":case "topMouseUp":return te=!1,ue(c,d);case "topSelectionChange":if(oe)break;
case "topKeyDown":case "topKeyUp":return ue(c,d)}return null}};Na.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Da=bb.getFiberCurrentPropsFromNode;Ea=bb.getInstanceFromNode;Fa=bb.getNodeFromInstance;Na.injectEventPluginsByName({SimpleEventPlugin:Rd,EnterLeaveEventPlugin:wd,ChangeEventPlugin:pd,SelectEventPlugin:ve,BeforeInputEventPlugin:Rb});
function xe(a,b,c,d){this.tag=a;this.key=c;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function ze(a,b,c){var d=a.alternate;null===d?(d=new xe(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Ae(a,b,c){var d=a.type,e=a.key;a=a.props;var f=void 0;if("function"===typeof d)f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case sc:return Be(a.children,b,c,e);case wc:f=11;b|=3;break;case tc:f=11;b|=2;break;case pc:f=7;break;case qc:f=9;break;default:if("object"===typeof d&&null!==d)switch(d.$$typeof){case uc:f=13;break;case vc:f=12;break;case xc:f=14;break;default:if("number"===typeof d.tag)return b=d,b.pendingProps=a,b.expirationTime=c,
b;D("130",null==d?d:typeof d,"")}else D("130",null==d?d:typeof d,"")}b=new xe(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Be(a,b,c,d){a=new xe(10,a,d,b);a.expirationTime=c;return a}function Ce(a,b,c){a=new xe(6,a,null,b);a.expirationTime=c;return a}function De(a,b,c){b=new xe(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}var Ee=null,Fe=null;
function Ge(a){return function(b){try{return a(b)}catch(c){}}}function He(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ee=Ge(function(a){return b.onCommitFiberRoot(c,a)});Fe=Ge(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Ie(a){"function"===typeof Ee&&Ee(a)}function Je(a){"function"===typeof Fe&&Fe(a)}new Set;
function Ke(a){return{baseState:a,expirationTime:0,first:null,last:null,callbackList:null,hasForceUpdate:!1,isInitialized:!1,capturedValues:null}}function Le(a,b){null===a.last?a.first=a.last=b:(a.last.next=b,a.last=b);if(0===a.expirationTime||a.expirationTime>b.expirationTime)a.expirationTime=b.expirationTime}var Me=void 0,Ne=void 0;
function Oe(a){Me=Ne=null;var b=a.alternate,c=a.updateQueue;null===c&&(c=a.updateQueue=Ke(null));null!==b?(a=b.updateQueue,null===a&&(a=b.updateQueue=Ke(null))):a=null;Me=c;Ne=a!==c?a:null}function Pe(a,b){Oe(a);a=Me;var c=Ne;null===c?Le(a,b):null===a.last||null===c.last?(Le(a,b),Le(c,b)):(Le(a,b),c.last=b)}function Qe(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
function Re(a,b,c,d,e,f){null!==a&&a.updateQueue===c&&(c=b.updateQueue={baseState:c.baseState,expirationTime:c.expirationTime,first:c.first,last:c.last,isInitialized:c.isInitialized,capturedValues:c.capturedValues,callbackList:null,hasForceUpdate:!1});c.expirationTime=0;c.isInitialized?a=c.baseState:(a=c.baseState=b.memoizedState,c.isInitialized=!0);for(var h=!0,g=c.first,k=!1;null!==g;){var v=g.expirationTime;if(v>f){var l=c.expirationTime;if(0===l||l>v)c.expirationTime=v;k||(k=!0,c.baseState=a)}else{k||
(c.first=g.next,null===c.first&&(c.last=null));if(g.isReplace)a=Qe(g,d,a,e),h=!0;else if(v=Qe(g,d,a,e))a=h?A({},a,v):A(a,v),h=!1;g.isForced&&(c.hasForceUpdate=!0);null!==g.callback&&(v=c.callbackList,null===v&&(v=c.callbackList=[]),v.push(g));null!==g.capturedValue&&(v=c.capturedValues,null===v?c.capturedValues=[g.capturedValue]:v.push(g.capturedValue))}g=g.next}null!==c.callbackList?b.effectTag|=32:null!==c.first||c.hasForceUpdate||null!==c.capturedValues||(b.updateQueue=null);k||(c.baseState=a);
return a}function Se(a,b){var c=a.callbackList;if(null!==c)for(a.callbackList=null,a=0;a<c.length;a++){var d=c[a],e=d.callback;d.callback=null;"function"!==typeof e?D("191",e):void 0;e.call(b)}}
function Te(a,b,c,d,e){function f(a,b,c,d,e,f){if(null===b||null!==a.updateQueue&&a.updateQueue.hasForceUpdate)return!0;var n=a.stateNode;a=a.type;return"function"===typeof n.shouldComponentUpdate?n.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ha(b,c)||!ha(d,e):!0}function h(a,b){b.updater=r;a.stateNode=b;b._reactInternalFiber=a}function g(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&
b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&r.enqueueReplaceState(b,b.state,null)}function k(a,b,c,d){a=a.type;if("function"===typeof a.getDerivedStateFromProps)return a.getDerivedStateFromProps.call(null,c,d)}var v=a.cacheContext,l=a.getMaskedContext,p=a.getUnmaskedContext,z=a.isContextConsumer,B=a.hasContextChanged,r={isMounted:yd,enqueueSetState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!1,isForced:!1,
capturedValue:null,next:null});b(a,f)},enqueueReplaceState:function(a,d,e){a=a._reactInternalFiber;e=void 0===e?null:e;var f=c(a);Pe(a,{expirationTime:f,partialState:d,callback:e,isReplace:!0,isForced:!1,capturedValue:null,next:null});b(a,f)},enqueueForceUpdate:function(a,d){a=a._reactInternalFiber;d=void 0===d?null:d;var e=c(a);Pe(a,{expirationTime:e,partialState:null,callback:d,isReplace:!1,isForced:!0,capturedValue:null,next:null});b(a,e)}};return{adoptClassInstance:h,callGetDerivedStateFromProps:k,
constructClassInstance:function(a,b){var c=a.type,d=p(a),e=z(a),f=e?l(a,d):ka;c=new c(b,f);var n=null!==c.state&&void 0!==c.state?c.state:null;h(a,c);a.memoizedState=n;b=k(a,c,b,n);null!==b&&void 0!==b&&(a.memoizedState=A({},a.memoizedState,b));e&&v(a,d,f);return c},mountClassInstance:function(a,b){var c=a.type,d=a.alternate,e=a.stateNode,f=a.pendingProps,n=p(a);e.props=f;e.state=a.memoizedState;e.refs=ka;e.context=l(a,n);"function"===typeof c.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||
"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||(c=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),c!==e.state&&r.enqueueReplaceState(e,e.state,null),c=a.updateQueue,null!==c&&(e.state=Re(d,a,c,e,f,b)));"function"===typeof e.componentDidMount&&(a.effectTag|=4)},resumeMountClassInstance:function(a,b){var c=a.type,n=a.stateNode;n.props=a.memoizedProps;n.state=
a.memoizedState;var h=a.memoizedProps,r=a.pendingProps,z=n.context,q=p(a);q=l(a,q);(c="function"===typeof c.getDerivedStateFromProps||"function"===typeof n.getSnapshotBeforeUpdate)||"function"!==typeof n.UNSAFE_componentWillReceiveProps&&"function"!==typeof n.componentWillReceiveProps||(h!==r||z!==q)&&g(a,n,r,q);z=a.memoizedState;b=null!==a.updateQueue?Re(null,a,a.updateQueue,n,r,b):z;var u=void 0;h!==r&&(u=k(a,n,r,b));if(null!==u&&void 0!==u){b=null===b||void 0===b?u:A({},b,u);var t=a.updateQueue;
null!==t&&(t.baseState=A({},t.baseState,u))}if(!(h!==r||z!==b||B()||null!==a.updateQueue&&a.updateQueue.hasForceUpdate))return"function"===typeof n.componentDidMount&&(a.effectTag|=4),!1;(h=f(a,h,r,z,b,q))?(c||"function"!==typeof n.UNSAFE_componentWillMount&&"function"!==typeof n.componentWillMount||("function"===typeof n.componentWillMount&&n.componentWillMount(),"function"===typeof n.UNSAFE_componentWillMount&&n.UNSAFE_componentWillMount()),"function"===typeof n.componentDidMount&&(a.effectTag|=
4)):("function"===typeof n.componentDidMount&&(a.effectTag|=4),d(a,r),e(a,b));n.props=r;n.state=b;n.context=q;return h},updateClassInstance:function(a,b,c){var n=b.type,x=b.stateNode;x.props=b.memoizedProps;x.state=b.memoizedState;var h=b.memoizedProps,r=b.pendingProps,q=x.context,u=p(b);u=l(b,u);(n="function"===typeof n.getDerivedStateFromProps||"function"===typeof x.getSnapshotBeforeUpdate)||"function"!==typeof x.UNSAFE_componentWillReceiveProps&&"function"!==typeof x.componentWillReceiveProps||
(h!==r||q!==u)&&g(b,x,r,u);q=b.memoizedState;c=null!==b.updateQueue?Re(a,b,b.updateQueue,x,r,c):q;var t=void 0;h!==r&&(t=k(b,x,r,c));if(null!==t&&void 0!==t){c=null===c||void 0===c?t:A({},c,t);var y=b.updateQueue;null!==y&&(y.baseState=A({},y.baseState,t))}if(!(h!==r||q!==c||B()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=2048),!1;(t=f(b,h,r,q,c,u))?(n||"function"!==typeof x.UNSAFE_componentWillUpdate&&"function"!==typeof x.componentWillUpdate||("function"===typeof x.componentWillUpdate&&x.componentWillUpdate(r,c,u),"function"===typeof x.UNSAFE_componentWillUpdate&&x.UNSAFE_componentWillUpdate(r,c,u)),"function"===typeof x.componentDidUpdate&&(b.effectTag|=4),"function"===typeof x.getSnapshotBeforeUpdate&&(b.effectTag|=2048)):("function"!==typeof x.componentDidUpdate||h===a.memoizedProps&&
q===a.memoizedState||(b.effectTag|=4),"function"!==typeof x.getSnapshotBeforeUpdate||h===a.memoizedProps&&q===a.memoizedState||(b.effectTag|=2048),d(b,r),e(b,c));x.props=r;x.state=c;x.context=u;return t}}}var Ue=Array.isArray;
function Ve(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?D("110"):void 0,d=c.stateNode);d?void 0:D("147",a);var e=""+a;if(null!==b&&null!==b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ka?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?D("148"):void 0;c._owner?void 0:D("254",a)}return a}
function We(a,b){"textarea"!==a.type&&D("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Xe(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ze(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=Ce(c,a.mode,d),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=Ve(a,b,c),d["return"]=a,d;d=Ae(c,a.mode,d);d.ref=Ve(a,b,c);d["return"]=a;return d}function v(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
De(c,a.mode,d),b["return"]=a,b;b=e(b,c.children||[],d);b["return"]=a;return b}function l(a,b,c,d,f){if(null===b||10!==b.tag)return b=Be(c,a.mode,d,f),b["return"]=a,b;b=e(b,c,d);b["return"]=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ce(""+b,a.mode,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case oc:return c=Ae(b,a.mode,c),c.ref=Ve(a,null,b),c["return"]=a,c;case rc:return b=De(b,a.mode,c),b["return"]=a,b}if(Ue(b)||zc(b))return b=Be(b,
a.mode,c,null),b["return"]=a,b;We(a,b)}return null}function z(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case oc:return c.key===e?c.type===sc?l(a,b,c.props.children,d,e):k(a,b,c,d):null;case rc:return c.key===e?v(a,b,c,d):null}if(Ue(c)||zc(c))return null!==e?null:l(a,b,c,d,null);We(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case oc:return a=a.get(null===d.key?c:d.key)||null,d.type===sc?l(b,a,d.props.children,e,d.key):k(b,a,d,e);case rc:return a=a.get(null===d.key?c:d.key)||null,v(b,a,d,e)}if(Ue(d)||zc(d))return a=a.get(c)||null,l(b,a,d,e,null);We(b,d)}return null}function r(e,l,g,h){for(var r=null,k=null,q=l,u=l=0,t=null;null!==q&&u<g.length;u++){q.index>u?(t=q,q=null):t=q.sibling;var n=z(e,q,g[u],h);if(null===n){null===q&&(q=t);break}a&&q&&null===
n.alternate&&b(e,q);l=f(n,l,u);null===k?r=n:k.sibling=n;k=n;q=t}if(u===g.length)return c(e,q),r;if(null===q){for(;u<g.length;u++)if(q=p(e,g[u],h))l=f(q,l,u),null===k?r=q:k.sibling=q,k=q;return r}for(q=d(e,q);u<g.length;u++)if(t=B(q,e,u,g[u],h)){if(a&&null!==t.alternate)q["delete"](null===t.key?u:t.key);l=f(t,l,u);null===k?r=t:k.sibling=t;k=t}a&&q.forEach(function(a){return b(e,a)});return r}function Q(e,l,g,h){var r=zc(g);"function"!==typeof r?D("150"):void 0;g=r.call(g);null==g?D("151"):void 0;for(var k=
r=null,q=l,u=l=0,t=null,n=g.next();null!==q&&!n.done;u++,n=g.next()){q.index>u?(t=q,q=null):t=q.sibling;var H=z(e,q,n.value,h);if(null===H){q||(q=t);break}a&&q&&null===H.alternate&&b(e,q);l=f(H,l,u);null===k?r=H:k.sibling=H;k=H;q=t}if(n.done)return c(e,q),r;if(null===q){for(;!n.done;u++,n=g.next())n=p(e,n.value,h),null!==n&&(l=f(n,l,u),null===k?r=n:k.sibling=n,k=n);return r}for(q=d(e,q);!n.done;u++,n=g.next())if(n=B(q,e,u,n.value,h),null!==n){if(a&&null!==n.alternate)q["delete"](null===n.key?u:n.key);
l=f(n,l,u);null===k?r=n:k.sibling=n;k=n}a&&q.forEach(function(a){return b(e,a)});return r}return function(a,d,f,l){"object"===typeof f&&null!==f&&f.type===sc&&null===f.key&&(f=f.props.children);var g="object"===typeof f&&null!==f;if(g)switch(f.$$typeof){case oc:a:{var k=f.key;for(g=d;null!==g;){if(g.key===k)if(10===g.tag?f.type===sc:g.type===f.type){c(a,g.sibling);d=e(g,f.type===sc?f.props.children:f.props,l);d.ref=Ve(a,g,f);d["return"]=a;a=d;break a}else{c(a,g);break}else b(a,g);g=g.sibling}f.type===
sc?(d=Be(f.props.children,a.mode,l,f.key),d["return"]=a,a=d):(l=Ae(f,a.mode,l),l.ref=Ve(a,d,f),l["return"]=a,a=l)}return h(a);case rc:a:{for(g=f.key;null!==d;){if(d.key===g)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],l);d["return"]=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=De(f,a.mode,l);d["return"]=a;a=d}return h(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&
6===d.tag?(c(a,d.sibling),d=e(d,f,l),d["return"]=a,a=d):(c(a,d),d=Ce(f,a.mode,l),d["return"]=a,a=d),h(a);if(Ue(f))return r(a,d,f,l);if(zc(f))return Q(a,d,f,l);g&&We(a,f);if("undefined"===typeof f)switch(a.tag){case 2:case 1:l=a.type,D("152",l.displayName||l.name||"Component")}return c(a,d)}}var Ye=Xe(!0),Ze=Xe(!1);
function $e(a,b,c,d,e,f,h){function g(a,b,c){k(a,b,c,b.expirationTime)}function k(a,b,c,d){b.child=null===a?Ze(b,null,c,d):Ye(b,a.child,c,d)}function v(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function l(a,b,c,d,e,f){v(a,b);if(!c&&!e)return d&&y(b,!1),r(a,b);c=b.stateNode;nc.current=b;var l=e?null:c.render();b.effectTag|=1;e&&(k(a,b,null,f),b.child=null);k(a,b,l,f);b.memoizedState=c.state;b.memoizedProps=c.props;d&&y(b,!0);return b.child}function p(a){var b=a.stateNode;
b.pendingContext?t(a,b.pendingContext,b.pendingContext!==b.context):b.context&&t(a,b.context,!1);Y(a,b.containerInfo)}function z(a,b,c,d){var e=a.child;for(null!==e&&(e["return"]=a);null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var l=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==l&&(0===l.expirationTime||l.expirationTime>d)&&(l.expirationTime=d);else if(null!==l&&(0===l.expirationTime||l.expirationTime>d))l.expirationTime=
d;else break;f=f["return"]}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=e.child}if(null!==f)f["return"]=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){f=e;break}f=f["return"]}e=f}}function B(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps;if(!q()&&f===e)return b.stateNode=0,G(b),r(a,b);var l=e.value;b.memoizedProps=e;if(null===f)l=1073741823;else if(f.value===e.value){if(f.children===e.children)return b.stateNode=0,G(b),
r(a,b);l=0}else{var h=f.value;if(h===l&&(0!==h||1/h===1/l)||h!==h&&l!==l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b);l=0}else if(l="function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,l):1073741823,l|=0,0===l){if(f.children===e.children)return b.stateNode=0,G(b),r(a,b)}else z(b,d,l,c)}b.stateNode=l;G(b);g(a,b,e.children);return b.child}function r(a,b){null!==a&&b.child!==a.child?D("153"):void 0;if(null!==b.child){a=b.child;var c=ze(a,a.pendingProps,a.expirationTime);
b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ze(a,a.pendingProps,a.expirationTime),c["return"]=b;c.sibling=null}return b.child}var Q=a.shouldSetTextContent,n=a.shouldDeprioritizeSubtree,x=b.pushHostContext,Y=b.pushHostContainer,G=d.pushProvider,R=c.getMaskedContext,S=c.getUnmaskedContext,q=c.hasContextChanged,u=c.pushContextProvider,t=c.pushTopLevelContextObject,y=c.invalidateContextProvider,H=e.enterHydrationState,Wa=e.resetHydrationState,Cb=e.tryToClaimNextHydratableInstance;
a=Te(c,f,h,function(a,b){a.memoizedProps=b},function(a,b){a.memoizedState=b});var Jc=a.adoptClassInstance,Kc=a.callGetDerivedStateFromProps,Lc=a.constructClassInstance,Db=a.mountClassInstance,Mc=a.resumeMountClassInstance,Eb=a.updateClassInstance;return{beginWork:function(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:p(b);break;case 2:u(b);break;case 4:Y(b,b.stateNode.containerInfo);break;case 13:G(b)}return null}switch(b.tag){case 0:null!==a?D("155"):void 0;var d=b.type,
e=b.pendingProps,f=S(b);f=R(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,"function"===typeof f.getDerivedStateFromProps&&(e=Kc(b,d,e,b.memoizedState),null!==e&&void 0!==e&&(b.memoizedState=A({},b.memoizedState,e))),e=u(b),Jc(b,d),Db(b,c),a=l(a,b,!0,e,!1,c)):(b.tag=1,g(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,q()||
b.memoizedProps!==c?(d=S(b),d=R(b,d),e=e(c,d),b.effectTag|=1,g(a,b,e),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 2:e=u(b);null===a?null===b.stateNode?(Lc(b,b.pendingProps),Db(b,c),d=!0):d=Mc(b,c):d=Eb(a,b,c);f=!1;var h=b.updateQueue;null!==h&&null!==h.capturedValues&&(f=d=!0);return l(a,b,d,e,f,c);case 3:a:if(p(b),d=b.updateQueue,null!==d){f=b.memoizedState;e=Re(a,b,d,null,null,c);b.memoizedState=e;d=b.updateQueue;if(null!==d&&null!==d.capturedValues)d=null;else if(f===e){Wa();a=r(a,b);break a}else d=
e.element;f=b.stateNode;(null===a||null===a.child)&&f.hydrate&&H(b)?(b.effectTag|=2,b.child=Ze(b,null,d,c)):(Wa(),g(a,b,d));b.memoizedState=e;a=b.child}else Wa(),a=r(a,b);return a;case 5:a:{x(b);null===a&&Cb(b);e=b.type;h=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!q()&&h===d){if(h=b.mode&1&&n(e,d))b.expirationTime=1073741823;if(!h||1073741823!==c){a=r(a,b);break a}}h=d.children;Q(e,d)?h=null:f&&Q(e,f)&&(b.effectTag|=16);v(a,b);1073741823!==c&&b.mode&1&&n(e,d)?(b.expirationTime=
1073741823,b.memoizedProps=d,a=null):(g(a,b,h),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Cb(b),b.memoizedProps=b.pendingProps,null;case 8:b.tag=7;case 7:return e=b.pendingProps,q()||b.memoizedProps!==e||(e=b.memoizedProps),d=e.children,b.stateNode=null===a?Ze(b,b.stateNode,d,c):Ye(b,a.stateNode,d,c),b.memoizedProps=e,b.stateNode;case 9:return null;case 4:return Y(b,b.stateNode.containerInfo),e=b.pendingProps,q()||b.memoizedProps!==e?(null===a?b.child=Ye(b,null,e,c):g(a,b,e),b.memoizedProps=
e,a=b.child):a=r(a,b),a;case 14:return c=b.type.render,c=c(b.pendingProps,b.ref),g(a,b,c),b.memoizedProps=c,b.child;case 10:return c=b.pendingProps,q()||b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 11:return c=b.pendingProps.children,q()||null!==c&&b.memoizedProps!==c?(g(a,b,c),b.memoizedProps=c,a=b.child):a=r(a,b),a;case 13:return B(a,b,c);case 12:a:{d=b.type;f=b.pendingProps;h=b.memoizedProps;e=d._currentValue;var t=d._changedBits;if(q()||0!==t||h!==f){b.memoizedProps=
f;var k=f.unstable_observedBits;if(void 0===k||null===k)k=1073741823;b.stateNode=k;if(0!==(t&k))z(b,d,t,c);else if(h===f){a=r(a,b);break a}c=f.children;c=c(e);g(a,b,c);a=b.child}else a=r(a,b)}return a;default:D("156")}}}}
function af(a,b,c,d,e){function f(a){a.effectTag|=4}var h=a.createInstance,g=a.createTextInstance,k=a.appendInitialChild,v=a.finalizeInitialChildren,l=a.prepareUpdate,p=a.persistence,z=b.getRootHostContainer,B=b.popHostContext,r=b.getHostContext,Q=b.popHostContainer,n=c.popContextProvider,x=c.popTopLevelContextObject,Y=d.popProvider,G=e.prepareToHydrateHostInstance,R=e.prepareToHydrateHostTextInstance,S=e.popHydrationState,q=void 0,u=void 0,t=void 0;a.mutation?(q=function(){},u=function(a,b,c){(b.updateQueue=
c)&&f(b)},t=function(a,b,c,d){c!==d&&f(b)}):p?D("235"):D("236");return{completeWork:function(a,b,c){var d=b.pendingProps;switch(b.tag){case 1:return null;case 2:return n(b),a=b.stateNode,d=b.updateQueue,null!==d&&null!==d.capturedValues&&(b.effectTag&=-65,"function"===typeof a.componentDidCatch?b.effectTag|=256:d.capturedValues=null),null;case 3:Q(b);x(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)S(b),b.effectTag&=-3;q(b);a=b.updateQueue;
null!==a&&null!==a.capturedValues&&(b.effectTag|=256);return null;case 5:B(b);c=z();var e=b.type;if(null!==a&&null!=b.stateNode){var p=a.memoizedProps,H=b.stateNode,y=r();H=l(H,e,p,d,c,y);u(a,b,H,e,p,d,c,y);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!d)return null===b.stateNode?D("166"):void 0,null;a=r();if(S(b))G(b,c,a)&&f(b);else{p=h(e,d,c,a,b);a:for(y=b.child;null!==y;){if(5===y.tag||6===y.tag)k(p,y.stateNode);else if(4!==y.tag&&null!==y.child){y.child["return"]=y;y=y.child;continue}if(y===b)break;
for(;null===y.sibling;){if(null===y["return"]||y["return"]===b)break a;y=y["return"]}y.sibling["return"]=y["return"];y=y.sibling}v(p,e,d,c,a)&&f(b);b.stateNode=p}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)t(a,b,a.memoizedProps,d);else{if("string"!==typeof d)return null===b.stateNode?D("166"):void 0,null;a=z();c=r();S(b)?R(b)&&f(b):b.stateNode=g(d,a,c,b)}return null;case 7:(d=b.memoizedProps)?void 0:D("165");b.tag=8;e=[];a:for((p=b.stateNode)&&(p["return"]=b);null!==
p;){if(5===p.tag||6===p.tag||4===p.tag)D("247");else if(9===p.tag)e.push(p.pendingProps.value);else if(null!==p.child){p.child["return"]=p;p=p.child;continue}for(;null===p.sibling;){if(null===p["return"]||p["return"]===b)break a;p=p["return"]}p.sibling["return"]=p["return"];p=p.sibling}p=d.handler;d=p(d.props,e);b.child=Ye(b,null!==a?a.child:null,d,c);return b.child;case 8:return b.tag=7,null;case 9:return null;case 14:return null;case 10:return null;case 11:return null;case 4:return Q(b),q(b),null;
case 13:return Y(b),null;case 12:return null;case 0:D("167");default:D("156")}}}}
function bf(a,b,c,d,e){var f=a.popHostContainer,h=a.popHostContext,g=b.popContextProvider,k=b.popTopLevelContextObject,v=c.popProvider;return{throwException:function(a,b,c){b.effectTag|=512;b.firstEffect=b.lastEffect=null;b={value:c,source:b,stack:Bc(b)};do{switch(a.tag){case 3:Oe(a);a.updateQueue.capturedValues=[b];a.effectTag|=1024;return;case 2:if(c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&!e(c)){Oe(a);c=a.updateQueue;var d=c.capturedValues;null===d?
c.capturedValues=[b]:d.push(b);a.effectTag|=1024;return}}a=a["return"]}while(null!==a)},unwindWork:function(a){switch(a.tag){case 2:g(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return f(a),k(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return h(a),null;case 4:return f(a),null;case 13:return v(a),null;default:return null}},unwindInterruptedWork:function(a){switch(a.tag){case 2:g(a);break;case 3:f(a);k(a);break;case 5:h(a);break;case 4:f(a);break;case 13:v(a)}}}}
function cf(a,b){var c=b.source;null===b.stack&&Bc(c);null!==c&&Ac(c);b=b.value;null!==a&&2===a.tag&&Ac(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}
function df(a,b,c,d,e){function f(a){var c=a.ref;if(null!==c)if("function"===typeof c)try{c(null)}catch(t){b(a,t)}else c.current=null}function h(a){"function"===typeof Je&&Je(a);switch(a.tag){case 2:f(a);var c=a.stateNode;if("function"===typeof c.componentWillUnmount)try{c.props=a.memoizedProps,c.state=a.memoizedState,c.componentWillUnmount()}catch(t){b(a,t)}break;case 5:f(a);break;case 7:g(a.stateNode);break;case 4:p&&v(a)}}function g(a){for(var b=a;;)if(h(b),null===b.child||p&&4===b.tag){if(b===
a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}else b.child["return"]=b,b=b.child}function k(a){return 5===a.tag||3===a.tag||4===a.tag}function v(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?D("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c["return"]}c=!0}if(5===
b.tag||6===b.tag)g(b),e?S(d,b.stateNode):R(d,b.stateNode);else if(4===b.tag?d=b.stateNode.containerInfo:h(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];4===b.tag&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}var l=a.getPublicInstance,p=a.mutation;a=a.persistence;p||(a?D("235"):D("236"));var z=p.commitMount,B=p.commitUpdate,r=p.resetTextContent,Q=p.commitTextUpdate,n=p.appendChild,
x=p.appendChildToContainer,Y=p.insertBefore,G=p.insertInContainerBefore,R=p.removeChild,S=p.removeChildFromContainer;return{commitBeforeMutationLifeCycles:function(a,b){switch(b.tag){case 2:if(b.effectTag&2048&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;a.props=b.memoizedProps;a.state=b.memoizedState;b=a.getSnapshotBeforeUpdate(c,d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:break;default:D("163")}},commitResetTextContent:function(a){r(a.stateNode)},
commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(k(b)){var c=b;break a}b=b["return"]}D("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:D("161")}c.effectTag&16&&(r(b),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||k(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;5!==c.tag&&6!==
c.tag;){if(c.effectTag&2)continue b;if(null===c.child||4===c.tag)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)c?d?G(b,e.stateNode,c):Y(b,e.stateNode,c):d?x(b,e.stateNode):n(b,e.stateNode);else if(4!==e.tag&&null!==e.child){e.child["return"]=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e["return"]||e["return"]===a)return;e=e["return"]}e.sibling["return"]=e["return"];e=e.sibling}},commitDeletion:function(a){v(a);
a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&B(c,f,e,a,d,b)}break;case 6:null===b.stateNode?D("162"):void 0;c=b.memoizedProps;Q(b.stateNode,null!==a?a.memoizedProps:c,c);break;case 3:break;default:D("163")}},commitLifeCycles:function(a,b,c){switch(c.tag){case 2:a=
c.stateNode;if(c.effectTag&4)if(null===b)a.props=c.memoizedProps,a.state=c.memoizedState,a.componentDidMount();else{var d=b.memoizedProps;b=b.memoizedState;a.props=c.memoizedProps;a.state=c.memoizedState;a.componentDidUpdate(d,b,a.__reactInternalSnapshotBeforeUpdate)}c=c.updateQueue;null!==c&&Se(c,a);break;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=l(c.child.stateNode);break;case 2:a=c.child.stateNode}Se(b,a)}break;case 5:a=c.stateNode;null===b&&c.effectTag&
4&&z(a,c.type,c.memoizedProps,c);break;case 6:break;case 4:break;default:D("163")}},commitErrorLogging:function(a,b){switch(a.tag){case 2:var c=a.type;b=a.stateNode;var d=a.updateQueue;null===d||null===d.capturedValues?D("264"):void 0;var f=d.capturedValues;d.capturedValues=null;"function"!==typeof c.getDerivedStateFromCatch&&e(b);b.props=a.memoizedProps;b.state=a.memoizedState;for(c=0;c<f.length;c++){d=f[c];var l=d.value,g=d.stack;cf(a,d);b.componentDidCatch(l,{componentStack:null!==g?g:""})}break;
case 3:c=a.updateQueue;null===c||null===c.capturedValues?D("264"):void 0;f=c.capturedValues;c.capturedValues=null;for(c=0;c<f.length;c++)d=f[c],cf(a,d),b(d.value);break;default:D("265")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case 5:a=l(c);break;default:a=c}"function"===typeof b?b(a):b.current=a}},commitDetachRef:function(a){a=a.ref;null!==a&&("function"===typeof a?a(null):a.current=null)}}}var ef={};
function ff(a,b){function c(a){a===ef?D("174"):void 0;return a}var d=a.getChildHostContext,e=a.getRootHostContext;a=b.createCursor;var f=b.push,h=b.pop,g=a(ef),k=a(ef),v=a(ef);return{getHostContext:function(){return c(g.current)},getRootHostContainer:function(){return c(v.current)},popHostContainer:function(a){h(g,a);h(k,a);h(v,a)},popHostContext:function(a){k.current===a&&(h(g,a),h(k,a))},pushHostContainer:function(a,b){f(v,b,a);f(k,a,a);f(g,ef,a);b=e(b);h(g,a);f(g,b,a)},pushHostContext:function(a){var b=
c(v.current),e=c(g.current);b=d(e,a.type,b);e!==b&&(f(k,a,a),f(g,b,a))}}}
function gf(a){function b(a,b){var c=new xe(5,null,null,0);c.type="DELETED";c.stateNode=b;c["return"]=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case 5:return b=f(b,a.type,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;case 6:return b=h(b,a.pendingProps),null!==b?(a.stateNode=b,!0):!1;default:return!1}}function d(a){for(a=a["return"];null!==a&&5!==a.tag&&3!==a.tag;)a=a["return"];p=a}var e=a.shouldSetTextContent;
a=a.hydration;if(!a)return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){D("175")},prepareToHydrateHostTextInstance:function(){D("176")},popHydrationState:function(){return!1}};var f=a.canHydrateInstance,h=a.canHydrateTextInstance,g=a.getNextHydratableSibling,k=a.getFirstHydratableChild,v=a.hydrateInstance,l=a.hydrateTextInstance,p=null,z=null,B=!1;return{enterHydrationState:function(a){z=
k(a.stateNode.containerInfo);p=a;return B=!0},resetHydrationState:function(){z=p=null;B=!1},tryToClaimNextHydratableInstance:function(a){if(B){var d=z;if(d){if(!c(a,d)){d=g(d);if(!d||!c(a,d)){a.effectTag|=2;B=!1;p=a;return}b(p,z)}p=a;z=k(d)}else a.effectTag|=2,B=!1,p=a}},prepareToHydrateHostInstance:function(a,b,c){b=v(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return l(a.stateNode,a.memoizedProps,a)},popHydrationState:function(a){if(a!==
p)return!1;if(!B)return d(a),B=!0,!1;var c=a.type;if(5!==a.tag||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=z;c;)b(a,c),c=g(c);d(a);z=p?g(a.stateNode):null;return!0}}}
function hf(a){function b(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function c(a){return 2===a.tag&&null!=a.type.childContextTypes}function d(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:D("108",Ac(a)||"Unknown",e);return A({},b,c)}var e=a.createCursor,f=a.push,h=a.pop,g=e(ka),k=e(!1),v=ka;return{getUnmaskedContext:function(a){return c(a)?
v:g.current},cacheContext:b,getMaskedContext:function(a,c){var d=a.type.contextTypes;if(!d)return ka;var e=a.stateNode;if(e&&e.__reactInternalMemoizedUnmaskedChildContext===c)return e.__reactInternalMemoizedMaskedChildContext;var f={},g;for(g in d)f[g]=c[g];e&&b(a,c,f);return f},hasContextChanged:function(){return k.current},isContextConsumer:function(a){return 2===a.tag&&null!=a.type.contextTypes},isContextProvider:c,popContextProvider:function(a){c(a)&&(h(k,a),h(g,a))},popTopLevelContextObject:function(a){h(k,
a);h(g,a)},pushTopLevelContextObject:function(a,b,c){null!=g.cursor?D("168"):void 0;f(g,b,a);f(k,c,a)},processChildContext:d,pushContextProvider:function(a){if(!c(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ka;v=g.current;f(g,b,a);f(k,k.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:D("169");if(b){var e=d(a,v);c.__reactInternalMemoizedMergedChildContext=e;h(k,a);h(g,a);f(g,e,a)}else h(k,a);f(k,b,a)},findCurrentUnmaskedContext:function(a){for(2!==
xd(a)||2!==a.tag?D("170"):void 0;3!==a.tag;){if(c(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:D("171")}return a.stateNode.context}}}
function jf(a){var b=a.createCursor,c=a.push,d=a.pop,e=b(null),f=b(null),h=b(0);return{pushProvider:function(a){var b=a.type._context;c(h,b._changedBits,a);c(f,b._currentValue,a);c(e,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode},popProvider:function(a){var b=h.current,c=f.current;d(e,a);d(f,a);d(h,a);a=a.type._context;a._currentValue=c;a._changedBits=b}}}
function kf(){var a=[],b=-1;return{createCursor:function(a){return{current:a}},isEmpty:function(){return-1===b},pop:function(c){0>b||(c.current=a[b],a[b]=null,b--)},push:function(c,d){b++;a[b]=c.current;c.current=d},checkThatStackIsEmpty:function(){},resetStackAfterFatalErrorInDev:function(){}}}
function lf(a){function b(){if(null!==I)for(var a=I["return"];null!==a;)Lc(a),a=a["return"];Ya=null;Z=0;I=null;Nc=!1}function c(a){return null!==ya&&ya.has(a)}function d(a){for(;;){var b=a.alternate,c=a["return"],d=a.sibling;if(0===(a.effectTag&512)){b=Cb(b,a,Z);var e=a;if(1073741823===Z||1073741823!==e.expirationTime){b:switch(e.tag){case 3:case 2:var f=e.updateQueue;f=null===f?0:f.expirationTime;break b;default:f=0}for(var g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=
g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{Nc=!0;break}}else{a=Kc(a);if(null!==a)return a.effectTag&=2559,a;null!==c&&(c.firstEffect=c.lastEffect=
null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}function e(a){var b=Wa(a.alternate,a,Z);null===b&&(b=d(a));nc.current=null;return b}function f(a,c,f){ca?D("243"):void 0;ca=!0;if(c!==Z||a!==Ya||null===I)b(),Ya=a,Z=c,I=ze(Ya.current,null,Z),a.pendingCommitExpirationTime=0;var g=!1;do{try{if(f)for(;null!==I&&!S();)I=e(I);else for(;null!==I;)I=e(I)}catch(Oc){if(null===I){g=!0;q(Oc);break}f=I;var h=f["return"];if(null===h){g=!0;q(Oc);break}Jc(h,f,Oc);I=d(f)}break}while(1);
ca=!1;if(g||null!==I)return null;if(Nc)return a.pendingCommitExpirationTime=c,a.current.alternate;D("262")}function h(a,b,c,d){a={value:c,source:a,stack:Bc(a)};Pe(b,{expirationTime:d,partialState:null,callback:null,isReplace:!1,isForced:!1,capturedValue:a,next:null});v(b,d)}function g(a,b){a:{ca&&!Za?D("263"):void 0;for(var d=a["return"];null!==d;){switch(d.tag){case 2:var e=d.stateNode;if("function"===typeof d.type.getDerivedStateFromCatch||"function"===typeof e.componentDidCatch&&!c(e)){h(a,d,b,
1);a=void 0;break a}break;case 3:h(a,d,b,1);a=void 0;break a}d=d["return"]}3===a.tag&&h(a,a,b,1);a=void 0}return a}function k(a){a=0!==ia?ia:ca?Za?1:Z:a.mode&1?za?10*(((l()+15)/10|0)+1):25*(((l()+500)/25|0)+1):1;za&&(0===da||a>da)&&(da=a);return a}function v(a,c){a:{for(;null!==a;){if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>c)&&(a.alternate.expirationTime=c);if(null===a["return"])if(3===a.tag){var d=
a.stateNode;!ca&&0!==Z&&c<Z&&b();ca&&!Za&&Ya===d||B(d,c);Fb>xg&&D("185")}else{c=void 0;break a}a=a["return"]}c=void 0}return c}function l(){ye=Ic()-Pc;return yg=(ye/10|0)+2}function p(a,b,c,d,e){var f=ia;ia=1;try{return a(b,c,d,e)}finally{ia=f}}function z(a){if(0!==Gb){if(a>Gb)return;mg(Qc)}var b=Ic()-Pc;Gb=a;Qc=lg(Q,{timeout:10*(a-2)-b})}function B(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===K?(la=K=a,a.nextScheduledRoot=a):(K=K.nextScheduledRoot=a,K.nextScheduledRoot=la);
else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}T||(J?Hb&&(aa=a,P=1,G(a,1,!1)):1===b?n():z(b))}function r(){var a=0,b=null;if(null!==K)for(var c=K,d=la;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===K?D("244"):void 0;if(d===d.nextScheduledRoot){la=K=d.nextScheduledRoot=null;break}else if(d===la)la=e=d.nextScheduledRoot,K.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===K){K=c;K.nextScheduledRoot=la;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=
d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===K)break;c=d;d=d.nextScheduledRoot}}c=aa;null!==c&&c===b&&1===a?Fb++:Fb=0;aa=b;P=a}function Q(a){x(0,!0,a)}function n(){x(1,!1,null)}function x(a,b,c){$a=c;r();if(b)for(;null!==aa&&0!==P&&(0===a||a>=P)&&(!Ib||l()>=P);)G(aa,P,!Ib),r();else for(;null!==aa&&0!==P&&(0===a||a>=P);)G(aa,P,!1),r();null!==$a&&(Gb=0,Qc=-1);0!==P&&z(P);$a=null;Ib=!1;Y()}function Y(){Fb=0;if(null!==Aa){var a=Aa;Aa=null;for(var b=
0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(wg){Ba||(Ba=!0,Jb=wg)}}}if(Ba)throw a=Jb,Jb=null,Ba=!1,a;}function G(a,b,c){T?D("245"):void 0;T=!0;c?(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!0),null!==c&&(S()?a.finishedWork=c:R(a,c,b)))):(c=a.finishedWork,null!==c?R(a,c,b):(a.finishedWork=null,c=f(a,b,!1),null!==c&&R(a,c,b)));T=!1}function R(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Aa?Aa=[d]:Aa.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=
0;return}a.finishedWork=null;Za=ca=!0;c=b.stateNode;c.current===b?D("177"):void 0;d=c.pendingCommitExpirationTime;0===d?D("261"):void 0;c.pendingCommitExpirationTime=0;var e=l();nc.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var f=b.firstEffect}else f=b;else f=b.firstEffect;zg(c.containerInfo);for(w=f;null!==w;){var h=!1,k=void 0;try{for(;null!==w;)w.effectTag&2048&&Db(w.alternate,w),w=w.nextEffect}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==
w&&(w=w.nextEffect))}for(w=f;null!==w;){h=!1;k=void 0;try{for(;null!==w;){var p=w.effectTag;p&16&&Mc(w);if(p&128){var n=w.alternate;null!==n&&kg(n)}switch(p&14){case 2:Eb(w);w.effectTag&=-3;break;case 6:Eb(w);w.effectTag&=-3;we(w.alternate,w);break;case 4:we(w.alternate,w);break;case 8:gg(w)}w=w.nextEffect}}catch(ab){h=!0,k=ab}h&&(null===w?D("178"):void 0,g(w,k),null!==w&&(w=w.nextEffect))}Ag(c.containerInfo);c.current=b;for(w=f;null!==w;){p=!1;n=void 0;try{for(f=c,h=e,k=d;null!==w;){var r=w.effectTag;
r&36&&hg(f,w.alternate,w,h,k);r&256&&ig(w,q);r&128&&jg(w);var t=w.nextEffect;w.nextEffect=null;w=t}}catch(ab){p=!0,n=ab}p&&(null===w?D("178"):void 0,g(w,n),null!==w&&(w=w.nextEffect))}ca=Za=!1;"function"===typeof Ie&&Ie(b.stateNode);b=c.current.expirationTime;0===b&&(ya=null);a.remainingExpirationTime=b}function S(){return null===$a||$a.timeRemaining()>Bg?!1:Ib=!0}function q(a){null===aa?D("246"):void 0;aa.remainingExpirationTime=0;Ba||(Ba=!0,Jb=a)}var u=kf(),t=ff(a,u),y=hf(u);u=jf(u);var H=gf(a),
Wa=$e(a,t,y,u,H,v,k).beginWork,Cb=af(a,t,y,u,H).completeWork;t=bf(t,y,u,v,c);var Jc=t.throwException,Kc=t.unwindWork,Lc=t.unwindInterruptedWork;t=df(a,g,v,k,function(a){null===ya?ya=new Set([a]):ya.add(a)},l);var Db=t.commitBeforeMutationLifeCycles,Mc=t.commitResetTextContent,Eb=t.commitPlacement,gg=t.commitDeletion,we=t.commitWork,hg=t.commitLifeCycles,ig=t.commitErrorLogging,jg=t.commitAttachRef,kg=t.commitDetachRef,Ic=a.now,lg=a.scheduleDeferredCallback,mg=a.cancelDeferredCallback,zg=a.prepareForCommit,
Ag=a.resetAfterCommit,Pc=Ic(),yg=2,ye=Pc,Rc=0,ia=0,ca=!1,I=null,Ya=null,Z=0,w=null,Za=!1,Nc=!1,ya=null,la=null,K=null,Gb=0,Qc=-1,T=!1,aa=null,P=0,da=0,Ib=!1,Ba=!1,Jb=null,$a=null,J=!1,Hb=!1,za=!1,Aa=null,xg=1E3,Fb=0,Bg=1;return{recalculateCurrentTime:l,computeExpirationForFiber:k,scheduleWork:v,requestWork:B,flushRoot:function(a,b){T?D("253"):void 0;aa=a;P=b;G(a,b,!1);n();Y()},batchedUpdates:function(a,b){var c=J;J=!0;try{return a(b)}finally{(J=c)||T||n()}},unbatchedUpdates:function(a,b){if(J&&!Hb){Hb=
!0;try{return a(b)}finally{Hb=!1}}return a(b)},flushSync:function(a,b){T?D("187"):void 0;var c=J;J=!0;try{return p(a,b)}finally{J=c,n()}},flushControlled:function(a){var b=J;J=!0;try{p(a)}finally{(J=b)||T||x(1,!1,null)}},deferredUpdates:function(a){var b=ia;ia=25*(((l()+500)/25|0)+1);try{return a()}finally{ia=b}},syncUpdates:p,interactiveUpdates:function(a,b,c){if(za)return a(b,c);J||T||0===da||(x(da,!1,null),da=0);var d=za,e=J;J=za=!0;try{return a(b,c)}finally{za=d,(J=e)||T||n()}},flushInteractiveUpdates:function(){T||
0===da||(x(da,!1,null),da=0)},computeUniqueAsyncExpiration:function(){var a=25*(((l()+500)/25|0)+1);a<=Rc&&(a=Rc+1);return Rc=a},legacyContext:y}}
function mf(a){function b(a,b,c,d,e,h){d=b.current;if(c){c=c._reactInternalFiber;var l=g(c);c=k(c)?v(c,l):l}else c=ka;null===b.context?b.context=c:b.pendingContext=c;b=h;Pe(d,{expirationTime:e,partialState:{element:a},callback:void 0===b?null:b,isReplace:!1,isForced:!1,capturedValue:null,next:null});f(d,e);return e}var c=a.getPublicInstance;a=lf(a);var d=a.recalculateCurrentTime,e=a.computeExpirationForFiber,f=a.scheduleWork,h=a.legacyContext,g=h.findCurrentUnmaskedContext,k=h.isContextProvider,v=
h.processChildContext;return{createContainer:function(a,b,c){b=new xe(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a},updateContainer:function(a,c,f,h){var g=c.current,k=d();g=e(g);return b(a,c,f,k,g,h)},updateContainerAtExpirationTime:function(a,c,e,f,g){var h=d();return b(a,c,e,h,f,g)},flushRoot:a.flushRoot,
requestWork:a.requestWork,computeUniqueAsyncExpiration:a.computeUniqueAsyncExpiration,batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,syncUpdates:a.syncUpdates,interactiveUpdates:a.interactiveUpdates,flushInteractiveUpdates:a.flushInteractiveUpdates,flushControlled:a.flushControlled,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return c(a.child.stateNode);default:return a.child.stateNode}},
findHostInstance:function(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?D("188"):D("268",Object.keys(a)));a=Bd(b);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=Cd(a);return null===a?null:a.stateNode},injectIntoDevTools:function(a){var b=a.findFiberByHostInstance;return He(A({},a,{findHostInstanceByFiber:function(a){a=Bd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}}}
var nf=Object.freeze({default:mf}),of=nf&&mf||nf,pf=of["default"]?of["default"]:of;function qf(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:rc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}var rf="object"===typeof performance&&"function"===typeof performance.now,sf=void 0;sf=rf?function(){return performance.now()}:function(){return Date.now()};var tf=void 0,uf=void 0;
if(m.canUseDOM)if("function"!==typeof requestIdleCallback||"function"!==typeof cancelIdleCallback){var vf=null,wf=!1,xf=-1,yf=!1,zf=0,Af=33,Bf=33,Cf=void 0;Cf=rf?{didTimeout:!1,timeRemaining:function(){var a=zf-performance.now();return 0<a?a:0}}:{didTimeout:!1,timeRemaining:function(){var a=zf-Date.now();return 0<a?a:0}};var Df="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===Df){wf=!1;a=sf();if(0>=zf-a)if(-1!==
xf&&xf<=a)Cf.didTimeout=!0;else{yf||(yf=!0,requestAnimationFrame(Ef));return}else Cf.didTimeout=!1;xf=-1;a=vf;vf=null;null!==a&&a(Cf)}},!1);var Ef=function(a){yf=!1;var b=a-zf+Bf;b<Bf&&Af<Bf?(8>b&&(b=8),Bf=b<Af?Af:b):Af=b;zf=a+Bf;wf||(wf=!0,window.postMessage(Df,"*"))};tf=function(a,b){vf=a;null!=b&&"number"===typeof b.timeout&&(xf=sf()+b.timeout);yf||(yf=!0,requestAnimationFrame(Ef));return 0};uf=function(){vf=null;wf=!1;xf=-1}}else tf=window.requestIdleCallback,uf=window.cancelIdleCallback;else tf=
function(a){return setTimeout(function(){a({timeRemaining:function(){return Infinity},didTimeout:!1})})},uf=function(a){clearTimeout(a)};function Ff(a){var b="";ea.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function Gf(a,b){a=A({children:void 0},b);if(b=Ff(b.children))a.children=b;return a}
function Hf(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function If(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Jf(a,b){null!=b.dangerouslySetInnerHTML?D("91"):void 0;return A({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Kf(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?D("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:D("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Lf(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Mf(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Nf={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Of(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Pf(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Of(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Qf=void 0,Rf=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Nf.svg||"innerHTML"in a)a.innerHTML=b;else{Qf=Qf||document.createElement("div");Qf.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e";for(b=Qf.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Sf(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Tf={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Uf=["Webkit","ms","Moz","O"];Object.keys(Tf).forEach(function(a){Uf.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Tf[b]=Tf[a]})});
function Vf(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Tf.hasOwnProperty(e)&&Tf[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Wf=A({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Xf(a,b,c){b&&(Wf[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?D("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?D("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:D("61")),null!=b.style&&"object"!==typeof b.style?D("62",c()):void 0)}
function Yf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Zf=C.thatReturns("");
function $f(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=ke(a);b=va[b];for(var d=0;d<b.length;d++){var e=b[d];c.hasOwnProperty(e)&&c[e]||("topScroll"===e?Zd("topScroll","scroll",a):"topFocus"===e||"topBlur"===e?(Zd("topFocus","focus",a),Zd("topBlur","blur",a),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(ic("cancel",!0)&&Zd("topCancel","cancel",a),c.topCancel=!0):"topClose"===e?(ic("close",!0)&&Zd("topClose","close",a),c.topClose=!0):fe.hasOwnProperty(e)&&W(e,fe[e],a),c[e]=!0)}}
function ag(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Nf.html&&(d=Of(a));d===Nf.html?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function bg(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function cg(a,b,c,d){var e=Yf(b,c);switch(b){case "iframe":case "object":W("topLoad","load",a);var f=c;break;case "video":case "audio":for(f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);f=c;break;case "source":W("topError","error",a);f=c;break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);f=c;break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);f=c;break;case "details":W("topToggle","toggle",a);f=c;break;case "input":Wc(a,c);f=Vc(a,c);W("topInvalid",
"invalid",a);$f(d,"onChange");break;case "option":f=Gf(a,c);break;case "select":If(a,c);f=A({},c,{value:void 0});W("topInvalid","invalid",a);$f(d,"onChange");break;case "textarea":Kf(a,c);f=Jf(a,c);W("topInvalid","invalid",a);$f(d,"onChange");break;default:f=c}Xf(b,f,Zf);var h=f,g;for(g in h)if(h.hasOwnProperty(g)){var k=h[g];"style"===g?Vf(a,k,Zf):"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,null!=k&&Rf(a,k)):"children"===g?"string"===typeof k?("textarea"!==b||""!==k)&&Sf(a,k):"number"===typeof k&&
Sf(a,""+k):"suppressContentEditableWarning"!==g&&"suppressHydrationWarning"!==g&&"autoFocus"!==g&&(ua.hasOwnProperty(g)?null!=k&&$f(d,g):null!=k&&Uc(a,g,k,e))}switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Hf(a,!!c.multiple,b,!1):null!=c.defaultValue&&Hf(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=C)}}
function dg(a,b,c,d,e){var f=null;switch(b){case "input":c=Vc(a,c);d=Vc(a,d);f=[];break;case "option":c=Gf(a,c);d=Gf(a,d);f=[];break;case "select":c=A({},c,{value:void 0});d=A({},d,{value:void 0});f=[];break;case "textarea":c=Jf(a,c);d=Jf(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=C)}Xf(b,d,Zf);b=a=void 0;var h=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var g=c[a];for(b in g)g.hasOwnProperty(b)&&(h||
(h={}),h[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ua.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];g=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==g&&(null!=k||null!=g))if("style"===a)if(g){for(b in g)!g.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(h||(h={}),h[b]="");for(b in k)k.hasOwnProperty(b)&&g[b]!==k[b]&&(h||(h={}),h[b]=k[b])}else h||(f||(f=[]),f.push(a,h)),
h=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,g=g?g.__html:void 0,null!=k&&g!==k&&(f=f||[]).push(a,""+k)):"children"===a?g===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ua.hasOwnProperty(a)?(null!=k&&$f(e,a),f||g===k||(f=[])):(f=f||[]).push(a,k))}h&&(f=f||[]).push("style",h);return f}
function eg(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Yc(a,e);Yf(c,d);d=Yf(c,e);for(var f=0;f<b.length;f+=2){var h=b[f],g=b[f+1];"style"===h?Vf(a,g,Zf):"dangerouslySetInnerHTML"===h?Rf(a,g):"children"===h?Sf(a,g):Uc(a,h,g,d)}switch(c){case "input":Zc(a,e);break;case "textarea":Lf(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Hf(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Hf(a,!!e.multiple,e.defaultValue,!0):Hf(a,!!e.multiple,e.multiple?[]:"",!1))}}
function fg(a,b,c,d,e){switch(b){case "iframe":case "object":W("topLoad","load",a);break;case "video":case "audio":for(var f in ge)ge.hasOwnProperty(f)&&W(f,ge[f],a);break;case "source":W("topError","error",a);break;case "img":case "image":case "link":W("topError","error",a);W("topLoad","load",a);break;case "form":W("topReset","reset",a);W("topSubmit","submit",a);break;case "details":W("topToggle","toggle",a);break;case "input":Wc(a,c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "select":If(a,
c);W("topInvalid","invalid",a);$f(e,"onChange");break;case "textarea":Kf(a,c),W("topInvalid","invalid",a),$f(e,"onChange")}Xf(b,c,Zf);d=null;for(var h in c)c.hasOwnProperty(h)&&(f=c[h],"children"===h?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):ua.hasOwnProperty(h)&&null!=f&&$f(e,h));switch(b){case "input":lc(a);ad(a,c);break;case "textarea":lc(a);Mf(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&
(a.onclick=C)}return d}function ng(a,b){return a.nodeValue!==b}
var og=Object.freeze({createElement:ag,createTextNode:bg,setInitialProperties:cg,diffProperties:dg,updateProperties:eg,diffHydratedProperties:fg,diffHydratedText:ng,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Zc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=
c.parentNode;c=c.querySelectorAll("input[name\x3d"+JSON.stringify(""+b)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Xa(d);e?void 0:D("90");mc(d);Zc(d,e)}}}break;case "textarea":Lf(a,c);break;case "select":b=c.value,null!=b&&Hf(a,!!c.multiple,b,!1)}}});Tb.injectFiberControlledHostComponent(og);var pg=null,qg=null;
function rg(a){this._expirationTime=X.computeUniqueAsyncExpiration();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}rg.prototype.render=function(a){this._defer?void 0:D("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new sg;X.updateContainerAtExpirationTime(a,b,null,c,d._onCommit);return d};
rg.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
rg.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:D("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?D("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;X.flushRoot(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};rg.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function sg(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}sg.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
sg.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?D("191",c):void 0;c()}}};function tg(a,b,c){this._internalRoot=X.createContainer(a,b,c)}tg.prototype.render=function(a,b){var c=this._internalRoot,d=new sg;b=void 0===b?null:b;null!==b&&d.then(b);X.updateContainer(a,c,null,d._onCommit);return d};
tg.prototype.unmount=function(a){var b=this._internalRoot,c=new sg;a=void 0===a?null:a;null!==a&&c.then(a);X.updateContainer(null,b,null,c._onCommit);return c};tg.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new sg;c=void 0===c?null:c;null!==c&&e.then(c);X.updateContainer(b,d,a,e._onCommit);return e};
tg.prototype.createBatch=function(){var a=new rg(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function ug(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function vg(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
var X=pf({getRootHostContext:function(a){var b=a.nodeType;switch(b){case 9:case 11:a=(a=a.documentElement)?a.namespaceURI:Pf(null,"");break;default:b=8===b?a.parentNode:a,a=b.namespaceURI||null,b=b.tagName,a=Pf(a,b)}return a},getChildHostContext:function(a,b){return Pf(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){pg=Vd;var a=fa();if(ne(a)){if("selectionStart"in a)var b={start:a.selectionStart,end:a.selectionEnd};else a:{var c=window.getSelection&&window.getSelection();
if(c&&0!==c.rangeCount){b=c.anchorNode;var d=c.anchorOffset,e=c.focusNode;c=c.focusOffset;try{b.nodeType,e.nodeType}catch(B){b=null;break a}var f=0,h=-1,g=-1,k=0,v=0,l=a,p=null;b:for(;;){for(var z;;){l!==b||0!==d&&3!==l.nodeType||(h=f+d);l!==e||0!==c&&3!==l.nodeType||(g=f+c);3===l.nodeType&&(f+=l.nodeValue.length);if(null===(z=l.firstChild))break;p=l;l=z}for(;;){if(l===a)break b;p===b&&++k===d&&(h=f);p===e&&++v===c&&(g=f);if(null!==(z=l.nextSibling))break;l=p;p=l.parentNode}l=z}b=-1===h||-1===g?null:
{start:h,end:g}}else b=null}b=b||{start:0,end:0}}else b=null;qg={focusedElem:a,selectionRange:b};Wd(!1)},resetAfterCommit:function(){var a=qg,b=fa(),c=a.focusedElem,d=a.selectionRange;if(b!==c&&ja(document.documentElement,c)){if(ne(c))if(b=d.start,a=d.end,void 0===a&&(a=b),"selectionStart"in c)c.selectionStart=b,c.selectionEnd=Math.min(a,c.value.length);else if(window.getSelection){b=window.getSelection();var e=c[mb()].length;a=Math.min(d.start,e);d=void 0===d.end?a:Math.min(d.end,e);!b.extend&&a>
d&&(e=d,d=a,a=e);e=me(c,a);var f=me(c,d);if(e&&f&&(1!==b.rangeCount||b.anchorNode!==e.node||b.anchorOffset!==e.offset||b.focusNode!==f.node||b.focusOffset!==f.offset)){var h=document.createRange();h.setStart(e.node,e.offset);b.removeAllRanges();a>d?(b.addRange(h),b.extend(f.node,f.offset)):(h.setEnd(f.node,f.offset),b.addRange(h))}}b=[];for(a=c;a=a.parentNode;)1===a.nodeType&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});c.focus();for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,
a.element.scrollTop=a.top}qg=null;Wd(pg);pg=null},createInstance:function(a,b,c,d,e){a=ag(a,b,c,d);a[F]=e;a[Ta]=b;return a},appendInitialChild:function(a,b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){cg(a,b,c,d);return vg(b,c)},prepareUpdate:function(a,b,c,d,e){return dg(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===
typeof b.dangerouslySetInnerHTML.__html},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=bg(a,b);a[F]=d;return a},now:sf,mutation:{commitMount:function(a,b,c){vg(b,c)&&a.focus()},commitUpdate:function(a,b,c,d,e){a[Ta]=e;eg(a,b,c,d,e)},resetTextContent:function(a){Sf(a,"")},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){8===a.nodeType?a.parentNode.insertBefore(b,a):a.appendChild(b)},
insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,b,c){8===a.nodeType?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){8===a.nodeType?a.parentNode.removeChild(b):a.removeChild(b)}},hydration:{canHydrateInstance:function(a,b){return 1!==a.nodeType||b.toLowerCase()!==a.nodeName.toLowerCase()?null:a},canHydrateTextInstance:function(a,b){return""===b||3!==a.nodeType?null:a},getNextHydratableSibling:function(a){for(a=
a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){a[F]=f;a[Ta]=c;return fg(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){a[F]=c;return ng(a,b)},didNotMatchHydratedContainerTextInstance:function(){},didNotMatchHydratedTextInstance:function(){},didNotHydrateContainerInstance:function(){},didNotHydrateInstance:function(){},
didNotFindHydratableContainerInstance:function(){},didNotFindHydratableContainerTextInstance:function(){},didNotFindHydratableInstance:function(){},didNotFindHydratableTextInstance:function(){}},scheduleDeferredCallback:tf,cancelDeferredCallback:uf}),Cg=X;ac=Cg.batchedUpdates;bc=Cg.interactiveUpdates;cc=Cg.flushInteractiveUpdates;
function Dg(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new tg(a,!1,b)}
function Eg(a,b,c,d,e){ug(c)?void 0:D("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var h=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);h.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Dg(c,d);if("function"===typeof e){var g=e;e=function(){var a=X.getPublicRootInstance(f._internalRoot);g.call(a)}}X.unbatchedUpdates(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return X.getPublicRootInstance(f._internalRoot)}
function Fg(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ug(b)?void 0:D("200");return qf(a,b,null,c)}
var Gg={createPortal:Fg,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:X.findHostInstance(a)},hydrate:function(a,b,c){return Eg(null,a,b,!0,c)},render:function(a,b,c){return Eg(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?D("38"):void 0;return Eg(a,b,c,!1,d)},unmountComponentAtNode:function(a){ug(a)?void 0:D("40");return a._reactRootContainer?(X.unbatchedUpdates(function(){Eg(null,null,a,!1,function(){a._reactRootContainer=
null})}),!0):!1},unstable_createPortal:function(){return Fg.apply(void 0,arguments)},unstable_batchedUpdates:X.batchedUpdates,unstable_deferredUpdates:X.deferredUpdates,flushSync:X.flushSync,unstable_flushControlled:X.flushControlled,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ra,EventPluginRegistry:Ca,EventPropagators:kb,ReactControlledComponent:$b,ReactDOMComponentTree:bb,ReactDOMEventListener:$d},unstable_createRoot:function(a,b){return new tg(a,!0,null!=b&&!0===b.hydrate)}};
X.injectIntoDevTools({findFiberByHostInstance:Ua,bundleType:0,version:"16.3.2",rendererPackageName:"react-dom"});var Hg=Object.freeze({default:Gg}),Ig=Hg&&Gg||Hg;module.exports=Ig["default"]?Ig["default"]:Ig;


/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recaptcha__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_async_script__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_async_script___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_async_script__);



var callbackName = "onloadcallback";
var options = typeof window !== "undefined" && window.recaptchaOptions || {};

var lang = options.lang ? "&hl=" + options.lang : "";
var hostname = options.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
var URL = "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit" + lang;
var globalName = "grecaptcha";

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_1_react_async_script___default()(__WEBPACK_IMPORTED_MODULE_0__recaptcha__["a" /* default */], URL, {
  callbackName: callbackName,
  globalName: globalName,
  exposeFuncs: ["getValue", "getWidgetId", "reset", "execute"]
}));

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var ReCAPTCHA = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ReCAPTCHA);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this));

    _this.state = {};
    _this.handleExpired = _this.handleExpired.bind(_this);
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_this);
    return _this;
  }

  ReCAPTCHA.prototype.getValue = function getValue() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this.state.widgetId);
    }
    return null;
  };

  ReCAPTCHA.prototype.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      return this.state.widgetId;
    }
    return null;
  };

  ReCAPTCHA.prototype.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;
    var widgetId = this.state.widgetId;


    if (grecaptcha && widgetId !== undefined) {
      return grecaptcha.execute(widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  ReCAPTCHA.prototype.reset = function reset() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      this.props.grecaptcha.reset(this.state.widgetId);
    }
  };

  ReCAPTCHA.prototype.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else if (this.props.onChange) {
      this.props.onChange(null);
    }
  };

  ReCAPTCHA.prototype.explicitRender = function explicitRender(cb) {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this.state.widgetId === undefined) {
      var wrapper = document.createElement("div");
      var id = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.props.onChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        size: this.props.size,
        stoken: this.props.stoken,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);

      this.setState({
        widgetId: id
      }, cb);
    }
    if (this._executeRequested && this.props.grecaptcha && this.state.widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  ReCAPTCHA.prototype.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  ReCAPTCHA.prototype.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  ReCAPTCHA.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.state.widgetId !== undefined) {
      while (this.captcha.firstChild) {
        this.captcha.removeChild(this.captcha.firstChild);
      }
      this.reset();
    }
  };

  ReCAPTCHA.prototype.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  ReCAPTCHA.prototype.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
    /* eslint-disable no-unused-vars */
    var _props = this.props,
        sitekey = _props.sitekey,
        onChange = _props.onChange,
        theme = _props.theme,
        type = _props.type,
        tabindex = _props.tabindex,
        onExpired = _props.onExpired,
        size = _props.size,
        stoken = _props.stoken,
        grecaptcha = _props.grecaptcha,
        badge = _props.badge,
        childProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "size", "stoken", "grecaptcha", "badge"]);
    /* eslint-enable no-unused-vars */


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, childProps, { ref: this.handleRecaptchaRef }));
  };

  return ReCAPTCHA;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ReCAPTCHA);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  grecaptcha: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  theme: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(["dark", "light"]),
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(["image", "audio"]),
  tabindex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  onExpired: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(["compact", "normal", "invisible"]),
  stoken: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  badge: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2; /* eslint-disable react/sort-comp */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(91);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _invariant = __webpack_require__(107);

var _invariant2 = _interopRequireDefault(_invariant);

var _deepEqual = __webpack_require__(327);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _hoistNonReactStatics = __webpack_require__(330);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _Events = __webpack_require__(340);

var _Events2 = _interopRequireDefault(_Events);

var _filterProps = __webpack_require__(1547);

var _filterProps2 = _interopRequireDefault(_filterProps);

var _createManager = __webpack_require__(1546);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * An Ad Component using Google Publisher Tags.
 * This component should work standalone w/o context.
 * https://developers.google.com/doubleclick-gpt/
 *
 * @module Bling
 * @class Bling
 * @fires Bling#Events.READY
 * @fires Bling#Events.SLOT_RENDER_ENDED
 * @fires Bling#Events.IMPRESSION_VIEWABLE
 * @fires Bling#Events.SLOT_VISIBILITY_CHANGED
 */
var Bling = (_temp2 = _class = function (_Component) {
    _inherits(Bling, _Component);

    function Bling() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Bling);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Bling.__proto__ || Object.getPrototypeOf(Bling)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            scriptLoaded: false,
            inViewport: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    /**
        * An array of prop names which can reflect to the ad by calling `refresh`.
        *
        * @property refreshableProps
        * @static
        */

    /**
     * An array of prop names which requires to create a new ad slot and render as a new ad.
     *
     * @property reRenderProps
     * @static
     */

    /**
     * An instance of ad manager.
     *
     * @property _adManager
     * @private
     * @static
     */

    /**
        *
        * @property
        * @private
        * @static
        */


    _createClass(Bling, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            Bling._adManager.addInstance(this);
            Bling._adManager.load(Bling._config.seedFileUrl).then(this.onScriptLoaded.bind(this)).catch(this.onScriptError.bind(this));
        }
    }, {
        key: "componentWillReceiveProps",
        value: function componentWillReceiveProps(nextProps) {
            var propsEqual = Bling._config.propsEqual;
            var sizeMapping = this.props.sizeMapping;

            if ((nextProps.sizeMapping || sizeMapping) && !propsEqual(nextProps.sizeMapping, sizeMapping)) {
                Bling._adManager.removeMQListener(this, nextProps);
            }
        }
    }, {
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, nextState) {
            // if adUnitPath changes, need to create a new slot, re-render
            // otherwise, just refresh
            var scriptLoaded = nextState.scriptLoaded,
                inViewport = nextState.inViewport;

            var notInViewport = this.notInViewport(nextProps, nextState);
            var inViewportChanged = this.state.inViewport !== inViewport;
            var isScriptLoaded = this.state.scriptLoaded !== scriptLoaded;

            // Exit early for visibility change, before executing deep equality check.
            if (notInViewport) {
                return false;
            } else if (inViewportChanged) {
                return true;
            }

            var _Bling$_config = Bling._config,
                filterProps = _Bling$_config.filterProps,
                propsEqual = _Bling$_config.propsEqual;

            var refreshableProps = filterProps(Bling.refreshableProps, this.props, nextProps);
            var reRenderProps = filterProps(Bling.reRenderProps, this.props, nextProps);
            var shouldRender = !propsEqual(reRenderProps.props, reRenderProps.nextProps);
            var shouldRefresh = !shouldRender && !propsEqual(refreshableProps.props, refreshableProps.nextProps);
            // console.log(`shouldRefresh: ${shouldRefresh}, shouldRender: ${shouldRender}, isScriptLoaded: ${isScriptLoaded}, syncCorrelator: ${Bling._adManager._syncCorrelator}`);

            if (shouldRefresh) {
                this.configureSlot(this._adSlot, nextProps);
            }

            if (Bling._adManager._syncCorrelator) {
                if (shouldRefresh) {
                    Bling._adManager.refresh();
                } else if (shouldRender || isScriptLoaded) {
                    Bling._adManager.renderAll();
                }
            } else {
                if (shouldRefresh) {
                    this.refresh();
                    return false;
                }
                if (shouldRender || isScriptLoaded) {
                    return true;
                }
            }

            return false;
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
            if (this.notInViewport(this.props, this.state)) {
                return;
            }
            if (this._divId) {
                // initial render will enable pubads service before any ad renders
                // so taken care of by the manager
                if (Bling._adManager._initialRender) {
                    Bling._adManager.render();
                } else {
                    this.renderAd();
                }
            }
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            Bling._adManager.removeInstance(this);
            if (this._adSlot) {
                Bling._adManager.googletag.destroySlots([this._adSlot]);
                this._adSlot = null;
            }
        }
    }, {
        key: "onScriptLoaded",
        value: function onScriptLoaded() {
            var onScriptLoaded = this.props.onScriptLoaded;


            if (this.getRenderWhenViewable()) {
                this.foldCheck();
            }
            this.setState({ scriptLoaded: true }, onScriptLoaded); // eslint-disable-line react/no-did-mount-set-state
        }
    }, {
        key: "onScriptError",
        value: function onScriptError(err) {
            console.warn("Ad: Failed to load gpt for " + Bling._config.seedFileUrl, err);
        }
    }, {
        key: "getRenderWhenViewable",
        value: function getRenderWhenViewable() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return props.renderWhenViewable !== undefined ? props.renderWhenViewable : Bling._config.renderWhenViewable;
        }
    }, {
        key: "foldCheck",
        value: function foldCheck() {
            if (this.state.inViewport) {
                return;
            }

            var slotSize = this.getSlotSize();
            if (Array.isArray(slotSize) && Array.isArray(slotSize[0])) {
                slotSize = slotSize[0];
            }
            if (slotSize === "fluid") {
                slotSize = [0, 0];
            }

            var inViewport = Bling._adManager.isInViewport(_reactDom2.default.findDOMNode(this), slotSize, this.viewableThreshold);
            if (inViewport) {
                this.setState({ inViewport: true });
            }
        }
    }, {
        key: "defineSizeMapping",
        value: function defineSizeMapping(adSlot, sizeMapping) {
            if (sizeMapping) {
                Bling._adManager.addMQListener(this, this.props);
                var sizeMappingArray = sizeMapping.reduce(function (mapping, size) {
                    return mapping.addSize(size.viewport, size.slot);
                }, Bling._adManager.googletag.sizeMapping()).build();
                adSlot.defineSizeMapping(sizeMappingArray);
            }
        }
    }, {
        key: "setAttributes",
        value: function setAttributes(adSlot, attributes) {
            // no clear method, attempting to clear existing attributes before setting new ones.
            var attributeKeys = adSlot.getAttributeKeys();
            attributeKeys.forEach(function (key) {
                adSlot.set(key, null);
            });
            if (attributes) {
                Object.keys(attributes).forEach(function (key) {
                    adSlot.set(key, attributes[key]);
                });
            }
        }
    }, {
        key: "setTargeting",
        value: function setTargeting(adSlot, targeting) {
            adSlot.clearTargeting();
            if (targeting) {
                Object.keys(targeting).forEach(function (key) {
                    adSlot.setTargeting(key, targeting[key]);
                });
            }
        }
    }, {
        key: "addCompanionAdService",
        value: function addCompanionAdService(serviceConfig, adSlot) {
            var companionAdsService = Bling._adManager.googletag.companionAds();
            adSlot.addService(companionAdsService);
            if ((typeof serviceConfig === "undefined" ? "undefined" : _typeof(serviceConfig)) === "object") {
                if (serviceConfig.hasOwnProperty("enableSyncLoading")) {
                    companionAdsService.enableSyncLoading();
                }
                if (serviceConfig.hasOwnProperty("refreshUnfilledSlots")) {
                    companionAdsService.setRefreshUnfilledSlots(serviceConfig.refreshUnfilledSlots);
                }
            }
        }
    }, {
        key: "getSlotSize",
        value: function getSlotSize() {
            var _props = this.props,
                origSlotSize = _props.slotSize,
                origSizeMapping = _props.sizeMapping;

            var slotSize = void 0;
            if (origSlotSize) {
                slotSize = origSlotSize;
            } else if (origSizeMapping) {
                var sizeMapping = origSizeMapping;
                slotSize = sizeMapping[0] && sizeMapping[0].slot;
            }

            return slotSize;
        }
    }, {
        key: "renderAd",
        value: function renderAd() {
            this.defineSlot();
            this.display();
        }
    }, {
        key: "notInViewport",
        value: function notInViewport() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
            var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
            var inViewport = state.inViewport;

            return this.getRenderWhenViewable(props) && !inViewport;
        }
    }, {
        key: "defineSlot",
        value: function defineSlot() {
            var _props2 = this.props,
                adUnitPath = _props2.adUnitPath,
                outOfPage = _props2.outOfPage;

            var divId = this._divId;
            var slotSize = this.getSlotSize();

            if (!this._adSlot) {
                if (outOfPage) {
                    this._adSlot = Bling._adManager.googletag.defineOutOfPageSlot(adUnitPath, divId);
                } else {
                    this._adSlot = Bling._adManager.googletag.defineSlot(adUnitPath, slotSize || [], divId);
                }
            }

            this.configureSlot(this._adSlot);
        }
    }, {
        key: "configureSlot",
        value: function configureSlot(adSlot) {
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
            var sizeMapping = props.sizeMapping,
                attributes = props.attributes,
                targeting = props.targeting,
                companionAdService = props.companionAdService,
                categoryExclusion = props.categoryExclusion,
                collapseEmptyDiv = props.collapseEmptyDiv,
                safeFrameConfig = props.safeFrameConfig,
                content = props.content,
                clickUrl = props.clickUrl,
                forceSafeFrame = props.forceSafeFrame;


            this.defineSizeMapping(adSlot, sizeMapping);

            if (collapseEmptyDiv !== undefined) {
                if (Array.isArray(collapseEmptyDiv)) {
                    var _adSlot$setCollapseEm;

                    (_adSlot$setCollapseEm = adSlot.setCollapseEmptyDiv).call.apply(_adSlot$setCollapseEm, [adSlot].concat(_toConsumableArray(collapseEmptyDiv)));
                } else {
                    adSlot.setCollapseEmptyDiv(collapseEmptyDiv);
                }
            }

            // Overrides click url
            if (clickUrl) {
                adSlot.setClickUrl(clickUrl);
            }

            // Sets category exclusion
            if (categoryExclusion) {
                var exclusion = categoryExclusion;
                if (typeof exclusion === "string") {
                    exclusion = [exclusion];
                }
                adSlot.clearCategoryExclusions();
                exclusion.forEach(function (item) {
                    adSlot.setCategoryExclusion(item);
                });
            }

            // Sets AdSense attributes
            this.setAttributes(adSlot, attributes);

            // Sets custom targeting parameters
            this.setTargeting(adSlot, targeting);

            if (safeFrameConfig) {
                adSlot.setSafeFrameConfig(safeFrameConfig);
            }

            if (forceSafeFrame) {
                adSlot.setForceSafeFrame(forceSafeFrame);
            }

            // Enables companion ad service
            if (companionAdService) {
                this.addCompanionAdService(companionAdService, adSlot);
            }

            // GPT checks if the same service is already added.
            if (content) {
                adSlot.addService(Bling._adManager.googletag.content());
            } else {
                adSlot.addService(Bling._adManager.googletag.pubads());
            }
        }
    }, {
        key: "display",
        value: function display() {
            var content = this.props.content;

            var divId = this._divId;
            var adSlot = this._adSlot;

            if (content) {
                Bling._adManager.googletag.content().setContent(adSlot, content);
            } else {
                if (!Bling._adManager._disableInitialLoad && !Bling._adManager._syncCorrelator) {
                    Bling._adManager.updateCorrelator();
                }
                Bling._adManager.googletag.display(divId);
                if (Bling._adManager._disableInitialLoad && !Bling._adManager._initialRender) {
                    this.refresh();
                }
            }
        }
    }, {
        key: "clear",
        value: function clear() {
            var adSlot = this._adSlot;
            if (adSlot && adSlot.hasOwnProperty("getServices")) {
                // googletag.ContentService doesn't clear content
                var services = adSlot.getServices();
                if (this._divId && services.some(function (s) {
                    return !!s.setContent;
                })) {
                    document.getElementById(this._divId).innerHTML = "";
                    return;
                }
                Bling._adManager.clear([adSlot]);
            }
        }
    }, {
        key: "refresh",
        value: function refresh(options) {
            var adSlot = this._adSlot;
            if (adSlot) {
                this.clear();
                Bling._adManager.refresh([adSlot], options);
            }
        }
    }, {
        key: "render",
        value: function render() {
            var scriptLoaded = this.state.scriptLoaded;
            var _props3 = this.props,
                id = _props3.id,
                outOfPage = _props3.outOfPage,
                style = _props3.style;

            var shouldNotRender = this.notInViewport(this.props, this.state);

            if (!scriptLoaded || shouldNotRender) {
                var slotSize = this.getSlotSize();

                if (!outOfPage) {
                    (0, _invariant2.default)(slotSize, "Either 'slotSize' or 'sizeMapping' prop needs to be set.");
                }

                if (Array.isArray(slotSize) && Array.isArray(slotSize[0])) {
                    slotSize = slotSize[0];
                }
                // https://developers.google.com/doubleclick-gpt/reference?hl=en#googletag.NamedSize
                if (slotSize === "fluid") {
                    slotSize = ["auto", "auto"];
                }
                var emptyStyle = slotSize && { width: slotSize[0], height: slotSize[1] };
                // render node element instead of script element so that `inViewport` check works.
                return _react2.default.createElement("div", { style: emptyStyle });
            }

            // clear the current ad if exists
            this.clear();
            if (this._adSlot) {
                Bling._adManager.googletag.destroySlots([this._adSlot]);
                this._adSlot = null;
            }
            this._divId = id || Bling._adManager.generateDivId();

            return _react2.default.createElement("div", { id: this._divId, style: style });
        }
    }, {
        key: "adSlot",
        get: function get() {
            return this._adSlot;
        }
    }, {
        key: "viewableThreshold",
        get: function get() {
            return this.props.viewableThreshold >= 0 ? this.props.viewableThreshold : Bling._config.viewableThreshold;
        }
    }], [{
        key: "on",
        value: function on(eventType, cb) {
            Bling._on("on", eventType, cb);
        }
    }, {
        key: "once",
        value: function once(eventType, cb) {
            Bling._on("once", eventType, cb);
        }
    }, {
        key: "removeListener",
        value: function removeListener() {
            var _Bling$_adManager;

            (_Bling$_adManager = Bling._adManager).removeListener.apply(_Bling$_adManager, arguments);
        }
    }, {
        key: "removeAllListeners",
        value: function removeAllListeners() {
            var _Bling$_adManager2;

            (_Bling$_adManager2 = Bling._adManager).removeAllListeners.apply(_Bling$_adManager2, arguments);
        }
    }, {
        key: "_on",
        value: function _on(fn, eventType, cb) {
            if (typeof cb !== "function") {
                return;
            }
            if (eventType === _Events2.default.READY && Bling._adManager.isReady) {
                cb.call(Bling._adManager, Bling._adManager.googletag);
            } else {
                Bling._adManager[fn](eventType, cb);
            }
        }
    }, {
        key: "configure",
        value: function configure() {
            var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            Bling._config = _extends({}, Bling._config, config);
        }
        /**
            * Returns the GPT version.
            *
            * @method getGPTVersion
            * @returns {Number|boolean} a version or false if GPT is not yet ready.
            * @static
            */

    }, {
        key: "getGPTVersion",
        value: function getGPTVersion() {
            return Bling._adManager.getGPTVersion();
        }
        /**
         * Returns the Pubads Service version.
         *
         * @method getPubadsVersion
         * @returns {Number|boolean} a version or false if Pubads Service is not yet ready.
         * @static
         */

    }, {
        key: "getPubadsVersion",
        value: function getPubadsVersion() {
            return Bling._adManager.getPubadsVersion();
        }
        /**
            * Sets a flag to indicate whether the correlator value should always be same across the ads in the page or not.
            *
            * @method syncCorrelator
            * @param {boolean} value
            * @static
            */

    }, {
        key: "syncCorrelator",
        value: function syncCorrelator(value) {
            Bling._adManager.syncCorrelator(value);
        }
        /**
         * Trigger re-rendering of all the ads.
         *
         * @method render
         * @static
         */

    }, {
        key: "render",
        value: function render() {
            Bling._adManager.renderAll();
        }
        /**
         * Refreshes all the ads in the page with a new correlator value.
         *
         * @param {Array} slots An array of ad slots.
         * @param {Object} options You can pass `changeCorrelator` flag.
         * @static
         */

    }, {
        key: "refresh",
        value: function refresh(slots, options) {
            Bling._adManager.refresh(slots, options);
        }
        /**
            * Clears the ads for the specified ad slots, if no slots are provided, all the ads will be cleared.
            *
            * @method clear
            * @param {Array} slots An optional array of slots to clear.
            * @static
            */

    }, {
        key: "clear",
        value: function clear(slots) {
            Bling._adManager.clear(slots);
        }
        /**
         * Updates the correlator value for the next ad request.
         *
         * @method updateCorrelator
         * @static
         */

    }, {
        key: "updateCorrelator",
        value: function updateCorrelator() {
            Bling._adManager.updateCorrelator();
        }
    }, {
        key: "testManager",
        set: function set(testManager) {
            (0, _invariant2.default)(testManager, "Pass in createManagerTest to mock GPT");
            Bling._adManager = testManager;
        }
    }]);

    return Bling;
}(_react.Component), _class.propTypes = {
    /**
     * An optional string to be used as container div id.
     *
     * @property id
     */
    id: _propTypes2.default.string,
    /**
     * An optional string indicating ad unit path which will be used
     * to create an ad slot.
     *
     * @property adUnitPath
     */
    adUnitPath: _propTypes2.default.string.isRequired,
    /**
     * An optional object which includes ad targeting key-value pairs.
     *
     * @property targeting
     */
    targeting: _propTypes2.default.object,
    /**
     * An optional prop to specify the ad slot size which accepts [googletag.GeneralSize](https://developers.google.com/doubleclick-gpt/reference#googletag.GeneralSize) as a type.
     * This will be preceded by the sizeMapping if specified.
     *
     * @property slotSize
     */
    slotSize: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
    /**
     * An optional array of object which contains an array of viewport size and slot size.
     * This needs to be set if the ad needs to serve different ad sizes per different viewport sizes (responsive ad).
     * Setting the `slot` to any dimension that's not configured in DFP results in rendering an empty ad.
     * The ad slot size which is provided for the viewport size of [0, 0] will be used as default ad size if none of viewport size matches.
     *
     * https://support.google.com/dfp_premium/answer/3423562?hl=en
     *
     * e.g.
     *
     * sizeMapping={[
     *   {viewport: [0, 0], slot: [320, 50]},
     *   {viewport: [768, 0], slot: [728, 90]}
     * ]}
     *
     * @property sizeMapping
     */
    sizeMapping: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        viewport: _propTypes2.default.array,
        slot: _propTypes2.default.array
    })),
    /**
     * An optional flag to indicate whether an ad slot should be out-of-page slot.
     *
     * @property outOfPage
     */
    outOfPage: _propTypes2.default.bool,
    /**
     * An optional flag to indicate whether companion ad service should be enabled for the ad.
     * If an object is passed, it takes as a configuration expecting `enableSyncLoading` or `refreshUnfilledSlots`.
     *
     * @property companionAdService
     */
    companionAdService: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object]),
    /**
     * An optional HTML content for the slot. If specified, the ad will render with the HTML content using content service.
     *
     * @property content
     */
    content: _propTypes2.default.string,
    /**
     * An optional click through URL. If specified, any landing page URL associated with the creative that is served is overridden.
     *
     * @property clickUrl
     */
    clickUrl: _propTypes2.default.string,
    /**
     * An optional string or an array of string which specifies a page-level ad category exclusion for the given label name.
     *
     * @property categoryExclusion
     */
    categoryExclusion: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]),
    /**
     * An optional map of key-value pairs for an AdSense attribute on a particular ad slot.
     * see the list of supported key value: https://developers.google.com/doubleclick-gpt/adsense_attributes#adsense_parameters.googletag.Slot
     *
     * @property attributes
     */
    attributes: _propTypes2.default.object,
    /**
     * An optional flag to indicate whether an empty ad should be collapsed or not.
     *
     * @property collapseEmptyDiv
     */
    collapseEmptyDiv: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.array]),
    /**
     * An optional flag to indicate whether ads in this slot should be forced to be rendered using a SafeFrame container.
     *
     * @property forceSafeFrame
     */
    forceSafeFrame: _propTypes2.default.bool,
    /**
     * An optional object to set the slot-level preferences for SafeFrame configuration.
     *
     * @property safeFrameConfig
     */
    safeFrameConfig: _propTypes2.default.object,
    /**
     * An optional event handler function for `googletag.events.SlotRenderEndedEvent`.
     *
     * @property onSlotRenderEnded
     */
    onSlotRenderEnded: _propTypes2.default.func,
    /**
     * An optional event handler function for `googletag.events.ImpressionViewableEvent`.
     *
     * @property onImpressionViewable
     */
    onImpressionViewable: _propTypes2.default.func,
    /**
     * An optional event handler function for `googletag.events.slotVisibilityChangedEvent`.
     *
     * @property onSlotVisibilityChanged
     */
    onSlotVisibilityChanged: _propTypes2.default.func,
    /**
     * An optional flag to indicate whether an ad should only render when it's fully in the viewport area.
     *
     * @property renderWhenViewable
     */
    renderWhenViewable: _propTypes2.default.bool,
    /**
     * An optional number to indicate how much percentage of an ad area needs to be in a viewable area before rendering.
     * Acceptable range is between 0 and 1.
     *
     * @property viewableThreshold
     */
    viewableThreshold: _propTypes2.default.number,
    /**
     * An optional call back function to notify when the script is loaded.
     *
     * @property onScriptLoaded
     */
    onScriptLoaded: _propTypes2.default.func,
    /**
     * An optional call back function to notify when the media queries on the document change.
     *
     * @property onMediaQueryChange
     */
    onMediaQueryChange: _propTypes2.default.func,
    /**
     * An optional object to be applied as `style` props to the container div.
     *
     * @property style
     */
    style: _propTypes2.default.object }, _class.refreshableProps = ["targeting", "sizeMapping", "clickUrl", "categoryExclusion", "attributes", "collapseEmptyDiv", "companionAdService", "forceSafeFrame", "safeFrameConfig"], _class.reRenderProps = ["adUnitPath", "slotSize", "outOfPage", "content"], _class._adManager = (0, _createManager.createManager)(), _class._config = {
    /**
     * An optional string for GPT seed file url to override.
     */
    seedFileUrl: "//www.googletagservices.com/tag/js/gpt.js",
    /**
     * An optional flag to indicate whether an ad should only render when it's fully in the viewport area. Default is `true`.
     */
    renderWhenViewable: true,
    /**
     * An optional number to indicate how much percentage of an ad area needs to be in a viewable area before rendering. Default value is 0.5.
     * Acceptable range is between 0 and 1.
     */
    viewableThreshold: 0.5,
    /**
     * An optional function to create an object with filtered current props and next props for a given keys to perform equality check.
     */
    filterProps: _filterProps2.default,
    /**
     * An optional function for the filtered props and the next props to perform equality check.
     */
    propsEqual: _deepEqual2.default
}, _temp2);

// proxy pubads API through Bling

exports.default = (0, _hoistNonReactStatics2.default)(Bling, _createManager.pubadsAPI.reduce(function (api, method) {
    api[method] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        return Bling._adManager.pubadsProxy({ method: method, args: args });
    };
    return api;
}, {}));

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AdManager = exports.APIToCallBeforeServiceEnabled = exports.pubadsAPI = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.createManager = createManager;

var _eventemitter = __webpack_require__(1356);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _debounce = __webpack_require__(1346);

var _debounce2 = _interopRequireDefault(_debounce);

var _invariant = __webpack_require__(107);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(191);

var _Events = __webpack_require__(340);

var _Events2 = _interopRequireDefault(_Events);

var _isInViewport2 = __webpack_require__(1548);

var _isInViewport3 = _interopRequireDefault(_isInViewport2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// based on https://developers.google.com/doubleclick-gpt/reference?hl=en
var pubadsAPI = exports.pubadsAPI = ["enableAsyncRendering", "enableSingleRequest", "enableSyncRendering", "disableInitialLoad", "collapseEmptyDivs", "enableVideoAds", "set", "get", "getAttributeKeys", "setTargeting", "clearTargeting", "setCategoryExclusion", "clearCategoryExclusions", "setCentering", "setCookieOptions", "setLocation", "setPublisherProvidedId", "setTagForChildDirectedTreatment", "clearTagForChildDirectedTreatment", "setVideoContent", "setForceSafeFrame"];

var APIToCallBeforeServiceEnabled = exports.APIToCallBeforeServiceEnabled = ["enableAsyncRendering", "enableSingleRequest", "enableSyncRendering", "disableInitialLoad", "collapseEmptyDivs", "setCentering"];

var AdManager = exports.AdManager = function (_EventEmitter) {
    _inherits(AdManager, _EventEmitter);

    function AdManager() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, AdManager);

        var _this = _possibleConstructorReturn(this, (AdManager.__proto__ || Object.getPrototypeOf(AdManager)).call(this, config));

        _this._adCnt = 0;
        _this._initialRender = true;
        _this._syncCorrelator = false;
        _this._testMode = false;
        _this._foldCheck = (0, _debounce2.default)(function (event) {
            var instances = _this.getMountedInstances();
            instances.forEach(function (instance) {
                if (instance.getRenderWhenViewable()) {
                    instance.foldCheck(event);
                }
            });
        }, 66);

        _this._handleMediaQueryChange = function (event) {
            if (_this._syncCorrelator) {
                _this.refresh();
                return;
            }
            // IE returns `event.media` value differently, need to use regex to evaluate.
            var res = /min-width:\s?(\d+)px/.exec(event.media);
            var viewportWidth = res && res[1];

            if (viewportWidth && _this._mqls[viewportWidth]) {
                _this._mqls[viewportWidth].listeners.forEach(function (instance) {
                    instance.refresh();
                    if (instance.props.onMediaQueryChange) {
                        instance.props.onMediaQueryChange(event);
                    }
                });
            }
        };

        _this.render = (0, _debounce2.default)(function () {
            if (!_this._initialRender) {
                return;
            }

            var checkPubadsReady = function checkPubadsReady(cb) {
                if (_this.pubadsReady) {
                    cb();
                } else {
                    setTimeout(checkPubadsReady, 50, cb);
                }
            };

            var instances = _this.getMountedInstances();
            var hasPubAdsService = false;
            var dummyAdSlot = void 0;

            // Define all the slots
            instances.forEach(function (instance) {
                if (!instance.notInViewport()) {
                    instance.defineSlot();
                    var adSlot = instance.adSlot;

                    if (adSlot && adSlot.hasOwnProperty("getServices")) {
                        var services = adSlot.getServices();
                        if (!hasPubAdsService) {
                            hasPubAdsService = services.filter(function (service) {
                                return !!service.enableAsyncRendering;
                            }).length > 0;
                        }
                    }
                }
            });
            // if none of the ad slots uses pubads service, create dummy slot to use pubads service.
            if (!hasPubAdsService) {
                dummyAdSlot = _this.googletag.defineSlot("/", []);
                dummyAdSlot.addService(_this.googletag.pubads());
            }

            // Call pubads API which needs to be called before service is enabled.
            _this._processPubadsQueue();

            // Enable service
            _this.googletag.enableServices();

            // After the service is enabled, check periodically until `pubadsReady` flag returns true before proceeding the rest.
            checkPubadsReady(function () {
                // destroy dummy ad slot if exists.
                if (dummyAdSlot) {
                    _this.googletag.destroySlots([dummyAdSlot]);
                }
                // Call the rest of the pubads API that's in the queue.
                _this._processPubadsQueue();
                // listen for GPT events
                _this._listen();
                // client should be able to set any page-level setting within the event handler.
                _this._isReady = true;
                _this.emit(_Events2.default.READY, _this.googletag);

                // Call display
                instances.forEach(function (instance) {
                    if (!instance.notInViewport()) {
                        instance.display();
                    }
                });

                _this.emit(_Events2.default.RENDER, _this.googletag);

                _this._initialRender = false;
            });
        }, 4);
        _this.renderAll = (0, _debounce2.default)(function () {
            if (!_this.apiReady) {
                return false;
            }

            // first instance updates correlator value and re-render each ad
            var instances = _this.getMountedInstances();
            instances.forEach(function (instance, i) {
                if (i === 0) {
                    _this.updateCorrelator();
                }
                instance.forceUpdate();
            });

            return true;
        }, 4);


        if (config.test) {
            _this.testMode = config;
        }
        return _this;
    }

    _createClass(AdManager, [{
        key: "_processPubadsQueue",
        value: function _processPubadsQueue() {
            var _this2 = this;

            if (this._pubadsProxyQueue) {
                Object.keys(this._pubadsProxyQueue).forEach(function (method) {
                    if (_this2.googletag && !_this2.googletag.pubadsReady && APIToCallBeforeServiceEnabled.indexOf(method) > -1 || _this2.pubadsReady) {
                        _this2._pubadsProxyQueue[method].forEach(function (params) {
                            return _this2.pubadsProxy(params);
                        });
                        delete _this2._pubadsProxyQueue[method];
                    }
                });
                if (!Object.keys(this._pubadsProxyQueue).length) {
                    this._pubadsProxyQueue = null;
                }
            }
        }
    }, {
        key: "_callPubads",
        value: function _callPubads(_ref) {
            var method = _ref.method,
                args = _ref.args,
                resolve = _ref.resolve,
                reject = _ref.reject;

            if (typeof this.googletag.pubads()[method] !== "function") {
                reject(new Error("googletag.pubads does not support " + method + ", please update pubadsAPI"));
            } else {
                try {
                    var _googletag$pubads;

                    var result = (_googletag$pubads = this.googletag.pubads())[method].apply(_googletag$pubads, _toConsumableArray(args));
                    resolve(result);
                } catch (err) {
                    reject(err);
                }
            }
        }
    }, {
        key: "_toggleListener",
        value: function _toggleListener(add) {
            var _this3 = this;

            ["scroll", "resize"].forEach(function (eventName) {
                window[add ? "addEventListener" : "removeEventListener"](eventName, _this3._foldCheck);
            });
        }
    }, {
        key: "_listen",
        value: function _listen() {
            var _this4 = this;

            if (!this._listening) {
                [_Events2.default.SLOT_RENDER_ENDED, _Events2.default.IMPRESSION_VIEWABLE, _Events2.default.SLOT_VISIBILITY_CHANGED].forEach(function (eventType) {
                    ["pubads", "content", "companionAds"].forEach(function (service) {
                        // there is no API to remove listeners.
                        _this4.googletag[service]().addEventListener(eventType, _this4._onEvent.bind(_this4, eventType));
                    });
                });
                this._listening = true;
            }
        }
    }, {
        key: "_onEvent",
        value: function _onEvent(eventType, event) {
            // fire to the global listeners
            if (this.listeners(eventType, true)) {
                this.emit(eventType, event);
            }
            // call event handler props
            var instances = this.getMountedInstances();
            var slot = event.slot;

            var funcName = "on" + eventType.charAt(0).toUpperCase() + eventType.substr(1);
            var instance = instances.filter(function (inst) {
                return slot === inst.adSlot;
            })[0];
            if (instance && instance.props[funcName]) {
                instance.props[funcName](event);
            }
        }
    }, {
        key: "syncCorrelator",
        value: function syncCorrelator() {
            var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this._syncCorrelator = value;
        }
    }, {
        key: "generateDivId",
        value: function generateDivId() {
            return "bling-" + ++this._adCnt;
        }
    }, {
        key: "getMountedInstances",
        value: function getMountedInstances() {
            if (!this.mountedInstances) {
                this.mountedInstances = [];
            }
            return this.mountedInstances;
        }
    }, {
        key: "addInstance",
        value: function addInstance(instance) {
            var instances = this.getMountedInstances();
            var index = instances.indexOf(instance);
            if (index === -1) {
                // The first instance starts listening for the event.
                if (instances.length === 0) {
                    this._toggleListener(true);
                }
                this.addMQListener(instance, instance.props);
                instances.push(instance);
            }
        }
    }, {
        key: "removeInstance",
        value: function removeInstance(instance) {
            var instances = this.getMountedInstances();
            var index = instances.indexOf(instance);
            if (index >= 0) {
                instances.splice(index, 1);
                // The last instance removes listening for the event.
                if (instances.length === 0) {
                    this._toggleListener(false);
                }
                this.removeMQListener(instance, instance.props);
            }
        }
    }, {
        key: "addMQListener",
        value: function addMQListener(instance, _ref2) {
            var _this5 = this;

            var sizeMapping = _ref2.sizeMapping;

            if (!sizeMapping || !Array.isArray(sizeMapping)) {
                return;
            }

            sizeMapping.forEach(function (size) {
                var viewportWidth = size.viewport && size.viewport[0];
                if (viewportWidth !== undefined) {
                    if (!_this5._mqls) {
                        _this5._mqls = {};
                    }
                    if (!_this5._mqls[viewportWidth]) {
                        var mql = window.matchMedia("(min-width: " + viewportWidth + "px)");
                        mql.addListener(_this5._handleMediaQueryChange);
                        _this5._mqls[viewportWidth] = {
                            mql: mql,
                            listeners: []
                        };
                    }
                    if (_this5._mqls[viewportWidth].listeners.indexOf(instance) === -1) {
                        _this5._mqls[viewportWidth].listeners.push(instance);
                    }
                }
            });
        }
    }, {
        key: "removeMQListener",
        value: function removeMQListener(instance) {
            var _this6 = this;

            if (!this._mqls) {
                return;
            }

            Object.keys(this._mqls).forEach(function (key) {
                var index = _this6._mqls[key].listeners.indexOf(instance);
                if (index > -1) {
                    _this6._mqls[key].listeners.splice(index, 1);
                }
                if (_this6._mqls[key].listeners.length === 0) {
                    _this6._mqls[key].mql.removeListener(_this6._handleMediaQueryChange);
                    delete _this6._mqls[key];
                }
            });
        }
    }, {
        key: "isInViewport",
        value: function isInViewport() {
            return _isInViewport3.default.apply(undefined, arguments);
        }

        /**
         * Refreshes all the ads in the page with a new correlator value.
         *
         * @param {Array} slots An array of ad slots.
         * @param {Object} options You can pass `changeCorrelator` flag.
         * @static
         */

    }, {
        key: "refresh",
        value: function refresh(slots, options) {
            if (!this.pubadsReady) {
                return false;
            }

            // gpt already debounces refresh
            this.googletag.pubads().refresh(slots, options);

            return true;
        }
    }, {
        key: "clear",
        value: function clear(slots) {
            if (!this.pubadsReady) {
                return false;
            }

            this.googletag.pubads().clear(slots);

            return true;
        }

        /**
         * Re-render(not refresh) all the ads in the page and the first ad will update the correlator value.
         * Updating correlator value ensures competitive exclusion.
         *
         * @method renderAll
         * @static
         */

    }, {
        key: "getGPTVersion",
        value: function getGPTVersion() {
            if (!this.apiReady) {
                return false;
            }
            return this.googletag.getVersion();
        }
    }, {
        key: "getPubadsVersion",
        value: function getPubadsVersion() {
            if (!this.pubadsReady) {
                return false;
            }
            return this.googletag.pubads().getVersion();
        }
    }, {
        key: "updateCorrelator",
        value: function updateCorrelator() {
            if (!this.pubadsReady) {
                return false;
            }
            this.googletag.pubads().updateCorrelator();

            return true;
        }
    }, {
        key: "load",
        value: function load(url) {
            var _this7 = this;

            return this._loadPromise || (this._loadPromise = new Promise(function (resolve, reject) {
                // test mode can't be enabled in production mode
                if (_this7.testMode) {
                    resolve(_this7.googletag);
                    return;
                }
                if (!_ExecutionEnvironment.canUseDOM) {
                    reject(new Error("DOM not available"));
                    return;
                }
                if (!url) {
                    reject(new Error("url is missing"));
                    return;
                }
                var onLoad = function onLoad() {
                    if (window.googletag) {
                        _this7._googletag = window.googletag;
                        // make sure API is ready for use.
                        _this7.googletag.cmd.push(function () {
                            _this7._isLoaded = true;
                            resolve(_this7.googletag);
                        });
                    } else {
                        reject(new Error("window.googletag is not available"));
                    }
                };
                if (window.googletag && window.googletag.apiReady) {
                    onLoad();
                } else {
                    var script = document.createElement("script");
                    script.async = true;
                    script.onload = onLoad;
                    script.onerror = function () {
                        reject(new Error("failed to load script"));
                    };
                    script.src = url;
                    document.head.appendChild(script);
                }
            }));
        }
    }, {
        key: "pubadsProxy",
        value: function pubadsProxy(_ref3) {
            var _this8 = this;

            var method = _ref3.method,
                _ref3$args = _ref3.args,
                args = _ref3$args === undefined ? [] : _ref3$args,
                resolve = _ref3.resolve,
                reject = _ref3.reject;

            if (!resolve) {
                // there are couple pubads API which doesn't provide getter methods for later use,
                // so remember them here.
                if (APIToCallBeforeServiceEnabled.indexOf(method) > -1) {
                    this["_" + method] = args && args.length && args[0] || true;
                }
                return new Promise(function (resolve2, reject2) {
                    var params = { method: method, args: args, resolve: resolve2, reject: reject2 };
                    if (!_this8.pubadsReady) {
                        if (!_this8._pubadsProxyQueue) {
                            _this8._pubadsProxyQueue = {};
                        }
                        if (!_this8._pubadsProxyQueue[method]) {
                            _this8._pubadsProxyQueue[method] = [];
                        }
                        _this8._pubadsProxyQueue[method].push(params);
                    } else {
                        _this8._callPubads(params);
                    }
                });
            }

            this._callPubads({ method: method, args: args, resolve: resolve, reject: reject });

            return Promise.resolve();
        }
    }, {
        key: "googletag",
        get: function get() {
            return this._googletag;
        }
    }, {
        key: "isLoaded",
        get: function get() {
            return !!this._isLoaded;
        }
    }, {
        key: "isReady",
        get: function get() {
            return !!this._isReady;
        }
    }, {
        key: "apiReady",
        get: function get() {
            return this.googletag && this.googletag.apiReady;
        }
    }, {
        key: "pubadsReady",
        get: function get() {
            return this.googletag && this.googletag.pubadsReady;
        }
    }, {
        key: "testMode",
        get: function get() {
            return this._testMode;
        },
        set: function set(config) {
            if (true) {
                return;
            }
            var test = config.test,
                GPTMock = config.GPTMock;

            this._isLoaded = true;
            this._testMode = !!test;

            if (test) {
                (0, _invariant2.default)(test && GPTMock, "Must provide GPTMock to enable testMode. config{GPTMock}");
                this._googletag = new GPTMock(config);
            }
        }
    }]);

    return AdManager;
}(_eventemitter2.default);

function createManager(config) {
    return new AdManager(config);
}

/***/ }),
/* 1547 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = filterProps;
function filterProps(propKeys, props, nextProps) {
    return propKeys.reduce(function (filtered, key) {
        filtered.props[key] = props[key];
        filtered.nextProps[key] = nextProps[key];
        return filtered;
    }, {
        props: {},
        nextProps: {}
    });
}

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = isInViewport;
function isInViewport(el) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 0],
        _ref2 = _slicedToArray(_ref, 2),
        width = _ref2[0],
        height = _ref2[1];

    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    if (!el || el.nodeType !== 1) {
        return false;
    }
    var clientRect = el.getBoundingClientRect();
    var rect = {
        top: clientRect.top,
        left: clientRect.left,
        bottom: clientRect.bottom,
        right: clientRect.right
    };
    var viewport = {
        top: 0,
        left: 0,
        bottom: window.innerHeight,
        right: window.innerWidth
    };
    var inViewport = rect.bottom >= viewport.top + height * offset && rect.right >= viewport.left + width * offset && rect.top <= viewport.bottom - height * offset && rect.left <= viewport.right - width * offset;
    return inViewport;
}

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(155);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(669);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultService = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _defaultService;

exports.default = createService;

var _ActionTypes = __webpack_require__(671);

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _extractApis = __webpack_require__(674);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable no-empty */


var noop = function noop() {};

function isService(obj) {
    var functionProps = (0, _extractApis.aggregateApisByType)(obj);
    return functionProps.length > 0;
}

var defaultService = exports.defaultService = (_defaultService = {}, _defineProperty(_defaultService, _ActionTypes2.default.PAGE_VIEW, noop), _defineProperty(_defaultService, _ActionTypes2.default.TRACK, noop), _defaultService);

function createService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var api = options.api;

    var instance = defaultService;
    function instantiate() {
        var ClassType = api;
        return new ClassType(options);
    }
    if (typeof api === "function") {
        var inst = void 0;
        try {
            inst = api(options);
        } catch (err) {} finally {
            if (!inst || !isService(inst)) {
                inst = instantiate();
            }
            if (isService(inst)) {
                instance = inst;
            }
        }
    } else if (api && (typeof api === "undefined" ? "undefined" : _typeof(api)) === "object" && isService(api)) {
        instance = api;
    }
    var name = options.name || instance.name;
    return { name: name, apis: instance };
}

/***/ }),
/* 1552 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var attr2obj = function attr2obj(elem) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "data";

    var attrs = elem.attributes;
    var dataAttrs = {};
    var rdashAlpha = /-([\da-z])/gi;
    var fcamelCase = function fcamelCase(all, letter) {
        return letter.toUpperCase();
    };
    var camelCase = function camelCase(string) {
        return string.replace(rdashAlpha, fcamelCase);
    };

    if (elem.nodeType === 1) {
        var i = attrs.length;
        while (i--) {
            var name = attrs[i].name;
            if (name.indexOf(prefix + "-") === 0) {
                var camelName = camelCase(name.slice(prefix.length + 1));
                dataAttrs[camelName] = elem.getAttribute(name);
            }
        }
    }
    return dataAttrs;
};

exports.default = attr2obj;

/***/ }),
/* 1553 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isPromise;
// to support Promise-like object.
function isPromise(value) {
    return value && typeof value.then === "function";
}

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(91);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _invariant = __webpack_require__(107);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(517);

var _warning2 = _interopRequireDefault(_warning);

var _PropTypes = __webpack_require__(242);

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _useTrackBindingPlugin = __webpack_require__(673);

var _useTrackBindingPlugin2 = _interopRequireDefault(_useTrackBindingPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MetricsElement = (_temp = _class = function (_Component) {
    _inherits(MetricsElement, _Component);

    function MetricsElement() {
        _classCallCheck(this, MetricsElement);

        return _possibleConstructorReturn(this, (MetricsElement.__proto__ || Object.getPrototypeOf(MetricsElement)).apply(this, arguments));
    }

    _createClass(MetricsElement, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _context = this.context,
                metrics = _context.metrics,
                _metricsConfig = _context._metricsConfig;


            (0, _invariant2.default)(metrics, "MetricsElement requires metrics HOC to exist in the parent tree.");

            var useTrackBinding = _metricsConfig.useTrackBinding,
                attributePrefix = _metricsConfig.attributePrefix,
                suppressTrackBindingWarning = _metricsConfig.suppressTrackBindingWarning;


            if (!suppressTrackBindingWarning) {
                (0, _warning2.default)(!useTrackBinding, "You are using 'MetricsElement' while default track binding is turned on. " + "It is recommended that you stick with either one to avoid double tracking accidentally. " + "If you intentionally use both and want to suppress this warning, pass 'suppressTrackBindingWarning=true' to the metrics options.");
            }

            this._trackBindingListener = (0, _useTrackBindingPlugin2.default)({
                callback: this._handleClick.bind(this),
                rootElement: _reactDom2.default.findDOMNode(this),
                attributePrefix: attributePrefix,
                traverseParent: true
            });
        }
    }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
            if (this._trackBindingListener) {
                this._trackBindingListener.remove();
                this._trackBindingListener = null;
            }
        }
    }, {
        key: "_handleClick",
        value: function _handleClick() {
            var _context$metrics;

            (_context$metrics = this.context.metrics).track.apply(_context$metrics, arguments);
        }
    }, {
        key: "render",
        value: function render() {
            var _props = this.props,
                element = _props.element,
                children = _props.children,
                rest = _objectWithoutProperties(_props, ["element", "children"]);

            if (!element) {
                return _react.Children.only(children);
            }

            return (0, _react.isValidElement)(element) ? (0, _react.cloneElement)(element, rest) : (0, _react.createElement)(element, rest, children);
        }
    }]);

    return MetricsElement;
}(_react.Component), _class.contextTypes = {
    metrics: _PropTypes2.default.metrics,
    _metrics: _propTypes2.default.object,
    _metricsConfig: _propTypes2.default.object
}, _class.propTypes = {
    children: _propTypes2.default.node,
    element: _propTypes2.default.any
}, _temp);
exports.default = MetricsElement;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = findRouteComponent;

var _exposeMetrics = __webpack_require__(675);

function findRouteComponent() {
    var routes = (0, _exposeMetrics.getMountedInstances)();
    var component = routes && routes.length > 0 && routes[routes.length - 1];
    return component;
}

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getRouteState;

var _locationEquals = __webpack_require__(1558);

var _locationEquals2 = _interopRequireDefault(_locationEquals);

var _isLocationValid = __webpack_require__(1557);

var _isLocationValid2 = _interopRequireDefault(_isLocationValid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mergeParam(location, params) {
    return Object.keys(location).reduce(function (obj, key) {
        obj[key] = location[key];
        return obj;
    }, { params: params });
}

function getRouteState(newProps) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if ((0, _isLocationValid2.default)(newProps.location) && !(0, _locationEquals2.default)(props.location, newProps.location)) {
        // additional params for the dynamic segments of the URL if available.
        var location = newProps.location,
            params = newProps.params;

        if (location.params || !params) {
            return location;
        }
        var routeState = mergeParam(location, params);
        return routeState;
    }
    return null;
}

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isLocationValid;
/**
 * `location` is a plain object which represents the current location in browser similar to document.location.
 * see https://github.com/rackt/history/blob/master/docs/Location.md
 *
 * @method isLocationValid
 * @param location
 * @returns {boolean}
 */
function isLocationValid(location) {
    return !!location && (typeof location === "undefined" ? "undefined" : _typeof(location)) === "object" && location.hasOwnProperty("pathname") && location.hasOwnProperty("hash") && location.hasOwnProperty("search") && location.hasOwnProperty("state");
}

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = locationEquals;

var _deepEqual = __webpack_require__(327);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function locationEquals(a, b) {
    if (!a && !b) {
        return true;
    }
    if (a && !b || !a && b) {
        return false;
    }

    return a.pathname === b.pathname && a.search === b.search && (0, _deepEqual2.default)(a.state, b.state);
}

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = metrics;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(91);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _invariant = __webpack_require__(107);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(191);

var _PropTypes = __webpack_require__(242);

var _createMetrics = __webpack_require__(672);

var _createMetrics2 = _interopRequireDefault(_createMetrics);

var _getRouteState = __webpack_require__(1556);

var _getRouteState2 = _interopRequireDefault(_getRouteState);

var _findRouteComponent = __webpack_require__(1555);

var _findRouteComponent2 = _interopRequireDefault(_findRouteComponent);

var _hoistNonReactStatics = __webpack_require__(330);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getDisplayName(Comp) {
    return Comp.displayName || Comp.name || "Component";
}

var mountedInstances = void 0;

function metrics(metricsOrConfig) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var autoTrackPageView = options.autoTrackPageView !== false;
    var useTrackBinding = options.useTrackBinding !== false;
    var attributePrefix = options.attributePrefix;
    var suppressTrackBindingWarning = !!options.suppressTrackBindingWarning;
    var getNewRouteState = options.getRouteState || _getRouteState2.default;
    var findNewRouteComponent = options.findRouteComponent || _findRouteComponent2.default;
    var metricsInstance = (0, _createMetrics.isMetrics)(metricsOrConfig) ? metricsOrConfig : (0, _createMetrics2.default)(metricsOrConfig);

    return function wrap(ComposedComponent) {
        var _class, _temp;

        var MetricsContainer = (_temp = _class = function (_Component) {
            _inherits(MetricsContainer, _Component);

            function MetricsContainer() {
                _classCallCheck(this, MetricsContainer);

                return _possibleConstructorReturn(this, (MetricsContainer.__proto__ || Object.getPrototypeOf(MetricsContainer)).apply(this, arguments));
            }

            _createClass(MetricsContainer, [{
                key: "componentWillMount",
                value: function componentWillMount() {
                    if (!_ExecutionEnvironment.canUseDOM) {
                        return;
                    }

                    var instances = this.constructor.getMountedMetricsInstances();
                    instances.push(ComposedComponent);

                    this._newRouteState = getNewRouteState(this.props);
                    if (this._newRouteState) {
                        this._getMetrics().setRouteState(this._newRouteState);
                    }
                }
            }, {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (useTrackBinding) {
                        var rootElement = _reactDom2.default.findDOMNode(this);
                        // TODO: is this invariant check still valid after react >= 0.14.0?
                        (0, _invariant2.default)(rootElement, "`metrics` should be added to the root most component which renders node element for declarative tracking to work.");
                        this._getMetrics().useTrackBinding(rootElement, attributePrefix);
                    }

                    if (this._newRouteState) {
                        this._handleRouteStateChange(this._newRouteState);
                        this._newRouteState = null;
                    }
                }
            }, {
                key: "componentWillReceiveProps",
                value: function componentWillReceiveProps(newProps) {
                    this._newRouteState = getNewRouteState(newProps, this.props);
                    if (this._newRouteState) {
                        this._getMetrics().setRouteState(this._newRouteState);
                    }
                }
            }, {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    if (this._newRouteState) {
                        this._handleRouteStateChange(this._newRouteState);
                        this._newRouteState = null;
                    }
                }
            }, {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    var instances = this.constructor.getMountedMetricsInstances();
                    var index = instances.indexOf(ComposedComponent);
                    instances.splice(index, 1);

                    this._getMetrics().destroy();
                }
            }, {
                key: "getChildContext",
                value: function getChildContext() {
                    return {
                        metrics: this._getMetrics().api,
                        _metricsConfig: {
                            autoTrackPageView: autoTrackPageView,
                            useTrackBinding: useTrackBinding,
                            attributePrefix: attributePrefix,
                            suppressTrackBindingWarning: suppressTrackBindingWarning,
                            getNewRouteState: getNewRouteState,
                            findNewRouteComponent: findNewRouteComponent
                        }
                    };
                }
            }, {
                key: "_getMetrics",
                value: function _getMetrics() {
                    return metricsInstance;
                }
                /**
                 * Triggered when the route changes and fires page view tracking.
                 *
                 * @method _handleRouteStateChange
                 * @param {Object} props
                 * @private
                 */

            }, {
                key: "_handleRouteStateChange",
                value: function _handleRouteStateChange(routeState) {
                    var component = findNewRouteComponent();
                    var metricsInst = this._getMetrics();
                    var pageViewParams = void 0;
                    var shouldSuppress = false;

                    if (component) {
                        var ret = component.willTrackPageView && component.willTrackPageView(routeState);
                        if (ret === false) {
                            shouldSuppress = true;
                        } else if (ret) {
                            pageViewParams = ret;
                        }
                    }

                    if (metricsInst.enabled && autoTrackPageView && !shouldSuppress) {
                        (0, _invariant2.default)(typeof metricsInst.api.pageView === "function", "react-metrics: 'pageView' api needs to be defined for automatic page view tracking.");
                        metricsInst.api.pageView(pageViewParams);
                    }
                }
                /**
                 * Renders composed component.
                 *
                 * @method render
                 * @returns {ReactElement}
                 */

            }, {
                key: "render",
                value: function render() {
                    return _react2.default.createElement(ComposedComponent, _extends({}, this.props, this.getChildContext()));
                }
            }], [{
                key: "getMountedMetricsInstances",
                value: function getMountedMetricsInstances() {
                    // eslint-disable-line react/sort-comp
                    if (!mountedInstances) {
                        mountedInstances = [];
                    }
                    return mountedInstances;
                }
            }]);

            return MetricsContainer;
        }(_react.Component), _class.displayName = "MetricsContainer", _class.childContextTypes = {
            metrics: _PropTypes.metrics.isRequired,
            _metricsConfig: _propTypes2.default.object
        }, _class.propTypes = {
            location: _PropTypes.location,
            params: _propTypes2.default.object
        }, _temp);


        return (0, _hoistNonReactStatics2.default)(MetricsContainer, ComposedComponent);
    };
}

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

//
// We store our EE objects in a plain object whose properties are event names.
// If `Object.create(null)` is not supported we prefix the event names with a
// `~` to make sure that the built-in object properties are not overridden or
// used as an attack vector.
// We also assume that `Object.create(null)` is available when the event name
// is an ES6 Symbol.
//
var prefix = typeof Object.create !== 'function' ? '~' : false;

/**
 * Representation of a single EventEmitter function.
 *
 * @param {Function} fn Event handler to be called.
 * @param {Mixed} context Context for function execution.
 * @param {Boolean} [once=false] Only emit once
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal EventEmitter interface that is molded against the Node.js
 * EventEmitter interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() { /* Nothing to set */ }

/**
 * Hold the assigned EventEmitters by name.
 *
 * @type {Object}
 * @private
 */
EventEmitter.prototype._events = undefined;

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var events = this._events
    , names = []
    , name;

  if (!events) return names;

  for (name in events) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return a list of assigned event listeners.
 *
 * @param {String} event The events that should be listed.
 * @param {Boolean} exists We only need to know if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events && this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Emit an event to all registered event listeners.
 *
 * @param {String} event The name of the event.
 * @returns {Boolean} Indication if we've emitted an event.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if ('function' === typeof listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Register a new EventListener for the given event.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Add an EventListener that's only called once.
 *
 * @param {String} event Name of the event.
 * @param {Function} fn Callback function.
 * @param {Mixed} [context=this] The context of the function.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events) this._events = prefix ? {} : Object.create(null);
  if (!this._events[evt]) this._events[evt] = listener;
  else {
    if (!this._events[evt].fn) this._events[evt].push(listener);
    else this._events[evt] = [
      this._events[evt], listener
    ];
  }

  return this;
};

/**
 * Remove event listeners.
 *
 * @param {String} event The event we want to remove.
 * @param {Function} fn The listener that we need to find.
 * @param {Mixed} context Only remove listeners matching this context.
 * @param {Boolean} once Only remove once listeners.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events || !this._events[evt]) return this;

  var listeners = this._events[evt]
    , events = [];

  if (fn) {
    if (listeners.fn) {
      if (
           listeners.fn !== fn
        || (once && !listeners.once)
        || (context && listeners.context !== context)
      ) {
        events.push(listeners);
      }
    } else {
      for (var i = 0, length = listeners.length; i < length; i++) {
        if (
             listeners[i].fn !== fn
          || (once && !listeners[i].once)
          || (context && listeners[i].context !== context)
        ) {
          events.push(listeners[i]);
        }
      }
    }
  }

  //
  // Reset the array, or remove it completely if we have no more listeners.
  //
  if (events.length) {
    this._events[evt] = events.length === 1 ? events[0] : events;
  } else {
    delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners or only the listeners for the specified event.
 *
 * @param {String} event The event want to remove all listeners for.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  if (!this._events) return this;

  if (event) delete this._events[prefix ? prefix + event : event];
  else this._events = prefix ? {} : Object.create(null);

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = undefined;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _storeShape = __webpack_require__(676);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _warning = __webpack_require__(677);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  Provider.prototype.getChildContext = function getChildContext() {
    return { store: this.store };
  };

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.store = props.store;
    return _this;
  }

  Provider.prototype.render = function render() {
    return _react.Children.only(this.props.children);
  };

  return Provider;
}(_react.Component);

exports["default"] = Provider;


if (false) {
  Provider.prototype.componentWillReceiveProps = function (nextProps) {
    var store = this.store;
    var nextStore = nextProps.store;


    if (store !== nextStore) {
      warnAboutReceivingStore();
    }
  };
}

Provider.propTypes = {
  store: _storeShape2["default"].isRequired,
  children: _propTypes2["default"].element.isRequired
};
Provider.childContextTypes = {
  store: _storeShape2["default"].isRequired
};

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = connect;

var _react = __webpack_require__(0);

var _storeShape = __webpack_require__(676);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _shallowEqual = __webpack_require__(1563);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _wrapActionCreators = __webpack_require__(1564);

var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);

var _warning = __webpack_require__(677);

var _warning2 = _interopRequireDefault(_warning);

var _isPlainObject = __webpack_require__(1518);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _hoistNonReactStatics = __webpack_require__(1565);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultMapStateToProps = function defaultMapStateToProps(state) {
  return {};
}; // eslint-disable-line no-unused-vars
var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
};
var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
  return _extends({}, parentProps, stateProps, dispatchProps);
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var errorObject = { value: null };
function tryCatch(fn, ctx) {
  try {
    return fn.apply(ctx);
  } catch (e) {
    errorObject.value = e;
    return errorObject;
  }
}

// Helps track hot reloading.
var nextVersion = 0;

function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var shouldSubscribe = Boolean(mapStateToProps);
  var mapState = mapStateToProps || defaultMapStateToProps;

  var mapDispatch = void 0;
  if (typeof mapDispatchToProps === 'function') {
    mapDispatch = mapDispatchToProps;
  } else if (!mapDispatchToProps) {
    mapDispatch = defaultMapDispatchToProps;
  } else {
    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
  }

  var finalMergeProps = mergeProps || defaultMergeProps;
  var _options$pure = options.pure,
      pure = _options$pure === undefined ? true : _options$pure,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;

  // Helps track hot reloading.
  var version = nextVersion++;

  return function wrapWithConnect(WrappedComponent) {
    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';

    function checkStateShape(props, methodName) {
      if (!(0, _isPlainObject2["default"])(props)) {
        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
      }
    }

    function computeMergedProps(stateProps, dispatchProps, parentProps) {
      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
      if (false) {
        checkStateShape(mergedProps, 'mergeProps');
      }
      return mergedProps;
    }

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
      };

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.store = props.store || context.store;

        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));

        var storeState = _this.store.getState();
        _this.state = { storeState: storeState };
        _this.clearCache();
        return _this;
      }

      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
        if (!this.finalMapStateToProps) {
          return this.configureFinalMapState(store, props);
        }

        var state = store.getState();
        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);

        if (false) {
          checkStateShape(stateProps, 'mapStateToProps');
        }
        return stateProps;
      };

      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
        var mappedState = mapState(store.getState(), props);
        var isFactory = typeof mappedState === 'function';

        this.finalMapStateToProps = isFactory ? mappedState : mapState;
        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;

        if (isFactory) {
          return this.computeStateProps(store, props);
        }

        if (false) {
          checkStateShape(mappedState, 'mapStateToProps');
        }
        return mappedState;
      };

      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
        if (!this.finalMapDispatchToProps) {
          return this.configureFinalMapDispatch(store, props);
        }

        var dispatch = store.dispatch;

        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);

        if (false) {
          checkStateShape(dispatchProps, 'mapDispatchToProps');
        }
        return dispatchProps;
      };

      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
        var mappedDispatch = mapDispatch(store.dispatch, props);
        var isFactory = typeof mappedDispatch === 'function';

        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;

        if (isFactory) {
          return this.computeDispatchProps(store, props);
        }

        if (false) {
          checkStateShape(mappedDispatch, 'mapDispatchToProps');
        }
        return mappedDispatch;
      };

      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
        var nextStateProps = this.computeStateProps(this.store, this.props);
        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
          return false;
        }

        this.stateProps = nextStateProps;
        return true;
      };

      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
          return false;
        }

        this.dispatchProps = nextDispatchProps;
        return true;
      };

      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
          return false;
        }

        this.mergedProps = nextMergedProps;
        return true;
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return typeof this.unsubscribe === 'function';
      };

      Connect.prototype.trySubscribe = function trySubscribe() {
        if (shouldSubscribe && !this.unsubscribe) {
          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
          this.handleChange();
        }
      };

      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        this.trySubscribe();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
          this.haveOwnPropsChanged = true;
        }
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        this.tryUnsubscribe();
        this.clearCache();
      };

      Connect.prototype.clearCache = function clearCache() {
        this.dispatchProps = null;
        this.stateProps = null;
        this.mergedProps = null;
        this.haveOwnPropsChanged = true;
        this.hasStoreStateChanged = true;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;
        this.renderedElement = null;
        this.finalMapDispatchToProps = null;
        this.finalMapStateToProps = null;
      };

      Connect.prototype.handleChange = function handleChange() {
        if (!this.unsubscribe) {
          return;
        }

        var storeState = this.store.getState();
        var prevStoreState = this.state.storeState;
        if (pure && prevStoreState === storeState) {
          return;
        }

        if (pure && !this.doStatePropsDependOnOwnProps) {
          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
          if (!haveStatePropsChanged) {
            return;
          }
          if (haveStatePropsChanged === errorObject) {
            this.statePropsPrecalculationError = errorObject.value;
          }
          this.haveStatePropsBeenPrecalculated = true;
        }

        this.hasStoreStateChanged = true;
        this.setState({ storeState: storeState });
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');

        return this.refs.wrappedInstance;
      };

      Connect.prototype.render = function render() {
        var haveOwnPropsChanged = this.haveOwnPropsChanged,
            hasStoreStateChanged = this.hasStoreStateChanged,
            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
            statePropsPrecalculationError = this.statePropsPrecalculationError,
            renderedElement = this.renderedElement;


        this.haveOwnPropsChanged = false;
        this.hasStoreStateChanged = false;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;

        if (statePropsPrecalculationError) {
          throw statePropsPrecalculationError;
        }

        var shouldUpdateStateProps = true;
        var shouldUpdateDispatchProps = true;
        if (pure && renderedElement) {
          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
        }

        var haveStatePropsChanged = false;
        var haveDispatchPropsChanged = false;
        if (haveStatePropsBeenPrecalculated) {
          haveStatePropsChanged = true;
        } else if (shouldUpdateStateProps) {
          haveStatePropsChanged = this.updateStatePropsIfNeeded();
        }
        if (shouldUpdateDispatchProps) {
          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
        }

        var haveMergedPropsChanged = true;
        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
        } else {
          haveMergedPropsChanged = false;
        }

        if (!haveMergedPropsChanged && renderedElement) {
          return renderedElement;
        }

        if (withRef) {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
            ref: 'wrappedInstance'
          }));
        } else {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
        }

        return this.renderedElement;
      };

      return Connect;
    }(_react.Component);

    Connect.displayName = connectDisplayName;
    Connect.WrappedComponent = WrappedComponent;
    Connect.contextTypes = {
      store: _storeShape2["default"]
    };
    Connect.propTypes = {
      store: _storeShape2["default"]
    };

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        if (this.version === version) {
          return;
        }

        // We are hot reloading!
        this.version = version;
        this.trySubscribe();
        this.clearCache();
      };
    }

    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
  };
}

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = shallowEqual;
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = wrapActionCreators;

var _redux = __webpack_require__(112);

function wrapActionCreators(actionCreators) {
  return function (dispatch) {
    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
  };
}

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(678);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(679);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(680);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexLink);

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(195);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRedirect);

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(195);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["c" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(195);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(158);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]

  /**
   * A <Router> is a high-level API for automatically setting up
   * a router that renders a <RouterContext> with all the props
   * it needs each time the URL changes.
   */
};var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["a" /* createRoutes */])(routes || children));
  },
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(341);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(158);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(685);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(157);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(681);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(157);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(685);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(157);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(683);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["a" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(110);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(indexRoute)[0]);
    });

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(343);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ContextProvider = ContextProvider;
exports.ContextSubscriber = ContextSubscriber;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = _propTypes2.default.shape({
  subscribe: _propTypes2.default.func.isRequired,
  eventIndex: _propTypes2.default.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

function ContextProvider(name) {
  var _childContextTypes, _ref2;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  return _ref2 = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _ref2[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _ref2;
}

function ContextSubscriber(name) {
  var _contextTypes, _ref4;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  return _ref4 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref3;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref3 = {}, _ref3[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref3;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _ref4[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _ref4;
}

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.compilePattern = compilePattern;
exports.matchPattern = matchPattern;
exports.getParamNames = getParamNames;
exports.getParams = getParams;
exports.formatPattern = formatPattern;

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isReactChildren = isReactChildren;
exports.createRouteFromReactElement = createRouteFromReactElement;
exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
exports.createRoutes = createRoutes;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidChild(object) {
  return object == null || _react2.default.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  _react2.default.Children.forEach(children, function (element) {
    if (_react2.default.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(89);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(1);

var _getRouteParams = __webpack_require__(1588);

var _getRouteParams2 = _interopRequireDefault(_getRouteParams);

var _ContextUtils = __webpack_require__(1584);

var _RouteUtils = __webpack_require__(1586);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = (0, _createReactClass2.default)({
  displayName: 'RouterContext',

  mixins: [(0, _ContextUtils.ContextProvider)('router')],

  propTypes: {
    router: _propTypes.object.isRequired,
    location: _propTypes.object.isRequired,
    routes: _propTypes.array.isRequired,
    params: _propTypes.object.isRequired,
    components: _propTypes.array.isRequired,
    createElement: _propTypes.func.isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: _react2.default.createElement
    };
  },


  childContextTypes: {
    router: _propTypes.object.isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = (0, _getRouteParams2.default)(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if ((0, _RouteUtils.isReactChildren)(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;

    return element;
  }
});

exports.default = RouterContext;
module.exports = exports['default'];

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _PatternUtils = __webpack_require__(1585);

/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

exports.default = getRouteParams;
module.exports = exports['default'];

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(345);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(98);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(159);

var _DOMUtils = __webpack_require__(244);

var _DOMStateStorage = __webpack_require__(688);

var _PathUtils = __webpack_require__(111);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(345);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(159);

var _PathUtils = __webpack_require__(111);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(346);

var _BrowserProtocol = __webpack_require__(345);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(1591);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(244);

var _createHistory = __webpack_require__(347);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(98);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(346);

var _DOMUtils = __webpack_require__(244);

var _HashProtocol = __webpack_require__(1590);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(347);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(98);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(159);

var _PathUtils = __webpack_require__(111);

var _createHistory = __webpack_require__(347);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(243);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global.hoistNonReactStatics = factory());
}(this, (function () {
    'use strict';
    
    var REACT_STATICS = {
        childContextTypes: true,
        contextTypes: true,
        defaultProps: true,
        displayName: true,
        getDefaultProps: true,
        getDerivedStateFromProps: true,
        mixins: true,
        propTypes: true,
        type: true
    };
    
    var KNOWN_STATICS = {
        name: true,
        length: true,
        prototype: true,
        caller: true,
        callee: true,
        arguments: true,
        arity: true
    };
    
    var defineProperty = Object.defineProperty;
    var getOwnPropertyNames = Object.getOwnPropertyNames;
    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var getPrototypeOf = Object.getPrototypeOf;
    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
    
    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
            
            if (objectPrototype) {
                var inheritedComponent = getPrototypeOf(sourceComponent);
                if (inheritedComponent && inheritedComponent !== objectPrototype) {
                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
                }
            }
            
            var keys = getOwnPropertyNames(sourceComponent);
            
            if (getOwnPropertySymbols) {
                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
            }
            
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                    try { // Avoid failures from read-only properties
                        defineProperty(targetComponent, key, descriptor);
                    } catch (e) {}
                }
            }
            
            return targetComponent;
        }
        
        return targetComponent;
    };
})));


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(1648);
var objectAssign = __webpack_require__(155);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectBase", function() { return Select; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Async", function() { return Async; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncCreatable", function() { return AsyncCreatable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Creatable", function() { return Creatable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFilter", function() { return createFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeAnimated", function() { return index; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "components", function() { return components; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeStyles", function() { return mergeStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emotion__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_autosize__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_memoize_one__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && (typeof a === 'undefined' ? 'undefined' : _typeof(a)) == 'object' && (typeof b === 'undefined' ? 'undefined' : _typeof(b)) == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    }
    // end fast-deep-equal

    // Custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
}

var diacritics = [{ base: 'A', letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { base: 'AA', letters: /[\uA732]/g }, { base: 'AE', letters: /[\u00C6\u01FC\u01E2]/g }, { base: 'AO', letters: /[\uA734]/g }, { base: 'AU', letters: /[\uA736]/g }, { base: 'AV', letters: /[\uA738\uA73A]/g }, { base: 'AY', letters: /[\uA73C]/g }, { base: 'B', letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { base: 'C', letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { base: 'D', letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { base: 'DZ', letters: /[\u01F1\u01C4]/g }, { base: 'Dz', letters: /[\u01F2\u01C5]/g }, { base: 'E', letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { base: 'F', letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { base: 'G', letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { base: 'H', letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { base: 'I', letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { base: 'J', letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { base: 'K', letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { base: 'L', letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { base: 'LJ', letters: /[\u01C7]/g }, { base: 'Lj', letters: /[\u01C8]/g }, { base: 'M', letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { base: 'N', letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { base: 'NJ', letters: /[\u01CA]/g }, { base: 'Nj', letters: /[\u01CB]/g }, { base: 'O', letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { base: 'OI', letters: /[\u01A2]/g }, { base: 'OO', letters: /[\uA74E]/g }, { base: 'OU', letters: /[\u0222]/g }, { base: 'P', letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { base: 'Q', letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { base: 'R', letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { base: 'S', letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { base: 'T', letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { base: 'TZ', letters: /[\uA728]/g }, { base: 'U', letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { base: 'V', letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { base: 'VY', letters: /[\uA760]/g }, { base: 'W', letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { base: 'X', letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { base: 'Y', letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { base: 'Z', letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { base: 'a', letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { base: 'aa', letters: /[\uA733]/g }, { base: 'ae', letters: /[\u00E6\u01FD\u01E3]/g }, { base: 'ao', letters: /[\uA735]/g }, { base: 'au', letters: /[\uA737]/g }, { base: 'av', letters: /[\uA739\uA73B]/g }, { base: 'ay', letters: /[\uA73D]/g }, { base: 'b', letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { base: 'c', letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { base: 'd', letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { base: 'dz', letters: /[\u01F3\u01C6]/g }, { base: 'e', letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { base: 'f', letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { base: 'g', letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { base: 'h', letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { base: 'hv', letters: /[\u0195]/g }, { base: 'i', letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { base: 'j', letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { base: 'k', letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { base: 'l', letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { base: 'lj', letters: /[\u01C9]/g }, { base: 'm', letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { base: 'n', letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { base: 'nj', letters: /[\u01CC]/g }, { base: 'o', letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { base: 'oi', letters: /[\u01A3]/g }, { base: 'ou', letters: /[\u0223]/g }, { base: 'oo', letters: /[\uA74F]/g }, { base: 'p', letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { base: 'q', letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { base: 'r', letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { base: 's', letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { base: 't', letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { base: 'tz', letters: /[\uA729]/g }, { base: 'u', letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { base: 'v', letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { base: 'vy', letters: /[\uA761]/g }, { base: 'w', letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { base: 'x', letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { base: 'y', letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { base: 'z', letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < diacritics.length; i++) {
		str = str.replace(diacritics[i].letters, diacritics[i].base);
	}
	return str;
};

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaulStringify = function defaulStringify(option) {
  return option.label + ' ' + option.value;
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _extends({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaulStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

// Assistive text to describe visual elements. Hidden for sighted users.
var A11yText = function A11yText(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', _extends({
    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({
      zIndex: 9999,
      border: 0,
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      width: 1,
      position: 'absolute',
      overflow: 'hidden',
      padding: 0,
      whiteSpace: 'nowrap',
      backgroundColor: 'red',
      color: 'blue'
    })
  }, props));
};

var DummyInput = function (_Component) {
  inherits(DummyInput, _Component);

  function DummyInput() {
    classCallCheck(this, DummyInput);
    return possibleConstructorReturn(this, (DummyInput.__proto__ || Object.getPrototypeOf(DummyInput)).apply(this, arguments));
  }

  createClass(DummyInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          inProp = _props.in,
          out = _props.out,
          onExited = _props.onExited,
          appear = _props.appear,
          enter = _props.enter,
          exit = _props.exit,
          innerRef = _props.innerRef,
          props = objectWithoutProperties(_props, ['in', 'out', 'onExited', 'appear', 'enter', 'exit', 'innerRef']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', _extends({
        ref: innerRef
      }, props, {
        className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({
          // get rid of any default styles
          background: 0,
          border: 0,
          fontSize: 'inherit',
          outline: 0,
          padding: 0,

          // important! without `width` browsers won't allow focus
          width: 1,

          // remove cursor on desktop
          color: 'transparent',

          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
          left: -100,
          opacity: 0,
          position: 'relative',
          transform: 'scale(0)'
        })
      }));
    }
  }]);
  return DummyInput;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var NodeResolver = function (_Component) {
  inherits(NodeResolver, _Component);

  function NodeResolver() {
    classCallCheck(this, NodeResolver);
    return possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
  }

  createClass(NodeResolver, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.innerRef(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return NodeResolver;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];

var LOCK_STYLES = {
  boxSizing: 'border-box', // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var activeScrollLocks = 0;

var ScrollLock = function (_Component) {
  inherits(ScrollLock, _Component);

  function ScrollLock() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).call.apply(_ref, [this].concat(args))), _this), _this.originalStyles = {}, _this.listenerOptions = {
      capture: false,
      passive: false
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ScrollLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;

      var _props = this.props,
          accountForScrollbars = _props.accountForScrollbars,
          touchScrollTarget = _props.touchScrollTarget;

      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      }

      // apply the lock styles and padding if this is the first scroll lock
      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;

        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = adjustedPadding + 'px';
        }
      }

      // account for touch devices
      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions);

        // Allow scroll on provided target
        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }

      // increment active scroll locks
      activeScrollLocks += 1;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;

      var _props2 = this.props,
          accountForScrollbars = _props2.accountForScrollbars,
          touchScrollTarget = _props2.touchScrollTarget;

      var target = document.body;
      var targetStyle = target && target.style;

      // safely decrement active scroll locks
      activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

      // reapply original body styles, if any
      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      }

      // remove touch listeners
      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return ScrollLock;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref

var ScrollBlock = function (_PureComponent) {
  inherits(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollBlock.__proto__ || Object.getPrototypeOf(ScrollBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = { touchScrollTarget: null }, _this.getScrollTarget = function (ref) {
      if (ref === _this.state.touchScrollTarget) return;
      _this.setState({ touchScrollTarget: ref });
    }, _this.blurSelectInput = function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  // must be in state to trigger a re-render, only runs once per instance


  // this will close the menu when a user clicks outside


  createClass(ScrollBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isEnabled = _props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget;

      // bail early if not enabled

      if (!isEnabled) return children;

      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', {
          onClick: this.blurSelectInput,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({ position: 'fixed', left: 0, bottom: 0, right: 0, top: 0 })
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          NodeResolver,
          { innerRef: this.getScrollTarget },
          children
        ),
        touchScrollTarget ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ScrollLock, { touchScrollTarget: touchScrollTarget }) : null
      );
    }
  }]);
  return ScrollBlock;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

var ScrollCaptor = function (_Component) {
  inherits(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollCaptor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollCaptor.__proto__ || Object.getPrototypeOf(ScrollCaptor)).call.apply(_ref, [this].concat(args))), _this), _this.isBottom = false, _this.isTop = false, _this.cancelScroll = function (event) {
      event.preventDefault();
      event.stopPropagation();
    }, _this.handleEventDelta = function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;

      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false;

      // reset bottom/top flags
      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }
      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      }

      // bottom limit
      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }
        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true;

        // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }
        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      }

      // cancel scroll
      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    }, _this.onWheel = function (event) {
      _this.handleEventDelta(event, event.deltaY);
    }, _this.onTouchStart = function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    }, _this.onTouchMove = function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
      _this.handleEventDelta(event, deltaY);
    }, _this.getScrollTarget = function (ref) {
      _this.scrollTarget = ref;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ScrollCaptor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: 'startListening',
    value: function startListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return;

      // all the if statements are to appease Flow 😢
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: 'stopListening',
    value: function stopListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return;

      // all the if statements are to appease Flow 😢
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        NodeResolver,
        { innerRef: this.getScrollTarget },
        this.props.children
      );
    }
  }]);
  return ScrollCaptor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var ScrollCaptorSwitch = function (_Component2) {
  inherits(ScrollCaptorSwitch, _Component2);

  function ScrollCaptorSwitch() {
    classCallCheck(this, ScrollCaptorSwitch);
    return possibleConstructorReturn(this, (ScrollCaptorSwitch.__proto__ || Object.getPrototypeOf(ScrollCaptorSwitch)).apply(this, arguments));
  }

  createClass(ScrollCaptorSwitch, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isEnabled = _props.isEnabled,
          props = objectWithoutProperties(_props, ['isEnabled']);

      return isEnabled ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ScrollCaptor, props) : this.props.children;
    }
  }]);
  return ScrollCaptorSwitch;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ScrollCaptorSwitch.defaultProps = { isEnabled: true };

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label;

  switch (event) {
    case 'menu':
      return 'Use Up and Down to choose options, press Backspace to select the currently focused option, press Escape to exit the menu, press Tab to select the option and exit the menu.';
    case 'input':
      return (label ? label : 'Select') + ' is focused ' + (isSearchable ? ',type to refine list' : '') + ', press Down to open the menu, ' + (isMulti ? ' press left to focus selected values' : '');
    case 'value':
      return 'Use left and right to toggle between focused values, press Enter to remove the currently focused value';
  }
};

var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value;

  if (!value) return;
  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return 'option ' + value + ', deselected.';
    case 'select-option':
      return 'option ' + value + ', selected.';
  }
};

var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return 'value ' + getOptionLabel(focusedValue) + ' focused, ' + (selectValue.indexOf(focusedValue) + 1) + ' of ' + selectValue.length + '.';
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return 'option ' + getOptionLabel(focusedOption) + ' focused, ' + (options.indexOf(focusedOption) + 1) + ' of ' + options.length + '.';
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return '' + screenReaderMessage + (inputValue ? ' for search term ' + inputValue : '') + '.';
};

// ==============================
// NO OP
// ==============================

var noop = function noop() {};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, cssKey, state, className) {
  var arr = [cssKey, className];
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push('' + applyPrefixToName(prefix, key));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }
  return inputValue;
}

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}

function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;

  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      __WEBPACK_IMPORTED_MODULE_3_raf___default()(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
  } catch (e) {
    return false;
  }
}

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};

var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};

var getOptionValue = function getOptionValue(option) {
  return option.value;
};

var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

var borderRadius = 4;

var colors = {
  text: '#222',
  textLight: '#444',
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',
  danger: '#DE350B',
  dangerLight: '#FFBDAD',

  neutral0: 'hsl(0, 0%, 100%)',
  neutral1: 'hsl(0, 0%, 99%)',
  neutral2: 'hsl(0, 0%, 98%)',
  neutral3: 'hsl(0, 0%, 97%)',
  neutral4: 'hsl(0, 0%, 96%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)',
  neutral100: 'hsl(0, 0%, 0%)',

  neutral1a: 'hsla(0, 0%, 0%, 0.01)',
  neutral2a: 'hsla(0, 0%, 0%, 0.02)',
  neutral3a: 'hsla(0, 0%, 0%, 0.03)',
  neutral4a: 'hsla(0, 0%, 0%, 0.04)',
  neutral5a: 'hsla(0, 0%, 0%, 0.05)',
  neutral10a: 'hsla(0, 0%, 0%, 0.1)',
  neutral20a: 'hsla(0, 0%, 0%, 0.2)',
  neutral30a: 'hsla(0, 0%, 0%, 0.3)',
  neutral40a: 'hsla(0, 0%, 0%, 0.4)',
  neutral50a: 'hsla(0, 0%, 0%, 0.5)',
  neutral60a: 'hsla(0, 0%, 0%, 0.6)',
  neutral70a: 'hsla(0, 0%, 0%, 0.7)',
  neutral80a: 'hsla(0, 0%, 0%, 0.8)',
  neutral90a: 'hsla(0, 0%, 0%, 0.9)'
};

var baseUnit = 4;

var spacing = {
  /* Used to calculate consistent margin/padding on elements */
  baseUnit: baseUnit,
  /* The minimum height of the control */
  controlHeight: 38,
  /* The amount of space between the control and menu */
  menuGutter: baseUnit * 2
};

// ==============================
// Root Container
// ==============================

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null, // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('container', props)), {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
      }, className)
    }, innerProps),
    children
  );
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS() {
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: spacing.baseUnit / 2 + 'px ' + spacing.baseUnit * 2 + 'px',
    WebkitOverflowScrolling: 'touch',
    position: 'relative'
  };
};
var ValueContainer = function (_Component) {
  inherits(ValueContainer, _Component);

  function ValueContainer() {
    classCallCheck(this, ValueContainer);
    return possibleConstructorReturn(this, (ValueContainer.__proto__ || Object.getPrototypeOf(ValueContainer)).apply(this, arguments));
  }

  createClass(ValueContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          cx = _props.cx,
          isMulti = _props.isMulti,
          getStyles = _props.getStyles,
          hasValue = _props.hasValue;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('valueContainer', this.props)), {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
          }, className)
        },
        children
      );
    }
  }]);
  return ValueContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;


  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('indicatorsContainer', props)), {
        'indicators': true
      }, className)
    },
    children
  );
};

// ==============================
// Dropdown & Clear Icons
// ==============================

var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = objectWithoutProperties(_ref, ['size']);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg', _extends({
    height: size,
    width: size,
    viewBox: '0 0 20 20',
    'aria-hidden': 'true',
    focusable: 'false',
    className: /*#__PURE__*/ /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({
      display: 'inline-block',
      fill: 'currentColor',
      lineHeight: 1,
      stroke: 'currentColor',
      strokeWidth: 0
    })
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    Svg,
    _extends({ size: 20 }, props),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z' })
  );
};
var DownChevron = function DownChevron(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    Svg,
    _extends({ size: 20 }, props),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z' })
  );
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref2) {
  var isFocused = _ref2.isFocused;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: spacing.baseUnit * 2,
    transition: 'color 150ms',

    ':hover': {
      color: isFocused ? colors.neutral100 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var _props$children = props.children,
      children = _props$children === undefined ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DownChevron, null) : _props$children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('dropdownIndicator', props)), {
        'indicator': true,
        'dropdown-indicator': true
      }, className)
    }),
    children
  );
};

var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var _props$children2 = props.children,
      children = _props$children2 === undefined ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CrossIcon, null) : _props$children2,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('clearIndicator', props)), {
        'indicator': true,
        'clear-indicator': true
      }, className)
    }),
    children
  );
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
  var isDisabled = _ref3.isDisabled;
  return {
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: spacing.baseUnit * 2,
    marginTop: spacing.baseUnit * 2,
    width: 1
  };
};

var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', _extends({}, innerProps, {
    className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('indicatorSeparator', props)), { 'indicator-separator': true }, className)
  }));
};

// ==============================
// Loading
// ==============================

var keyframesName = 'react-select-loading-indicator';

var loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
  var isFocused = _ref4.isFocused,
      size = _ref4.size;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: spacing.baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref5) {
  var color = _ref5.color,
      delay = _ref5.delay,
      offset = _ref5.offset;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
    className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])({
      animationDuration: '1s',
      animationDelay: delay + 'ms',
      animationIterationCount: 'infinite',
      animationName: keyframesName,
      animationTimingFunction: 'ease-in-out',
      backgroundColor: color,
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    })
  });
};

// eslint-disable-next-line no-unused-expressions
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["b" /* injectGlobal */])('@keyframes ', keyframesName, '{0%,80%,100%{opacity:0;}40%{opacity:1;}};');

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isFocused = props.isFocused,
      isRtl = props.isRtl;

  var color = isFocused ? colors.text : colors.neutral20;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('loadingIndicator', props)), {
        'indicator': true,
        'loading-indicator': true
      }, className)
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { color: color, delay: 0, offset: isRtl }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { color: color, delay: 160, offset: true }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { color: color, delay: 320, offset: !isRtl })
  );
};
LoadingIndicator.defaultProps = { size: 4 };

var css$1 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused;
  return {
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : isFocused ? colors.neutral0 : colors.neutral2,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? '0 0 0 1px ' + colors.primary : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',

    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('control', props)), {
        'control': true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused
      }, className)
    }, innerProps),
    children
  );
};

var groupCSS = function groupCSS() {
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      label = props.label;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('group', props)), { 'group': true }, className)
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Heading,
      { getStyles: getStyles, cx: cx },
      label
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      children
    )
  );
};

var groupHeadingCSS = function groupHeadingCSS() {
  return {
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};

var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      cleanProps = objectWithoutProperties(props, ['className', 'cx', 'getStyles']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', _extends({
    className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('groupHeading', props)), { 'group-heading': true }, className)
  }, cleanProps));
};

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.text
  };
};
var inputStyle = function inputStyle(isHidden) {
  return {
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      props = objectWithoutProperties(_ref2, ['className', 'cx', 'getStyles', 'innerRef', 'isHidden', 'isDisabled']);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('input', props))
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_autosize___default.a, _extends({
      className: cx(null, { 'input': true }, className),
      inputRef: innerRef,
      inputStyle: inputStyle(isHidden),
      disabled: isDisabled
    }, props))
  );
};

// ==============================
// Menu
// ==============================

// Get Menu Placement
// ------------------------------

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition;

  var scrollParent = getScrollParent(menuEl);
  var defaultState = { placement: 'bottom', maxHeight: maxHeight };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  // $FlowFixMe function returns above if there's no offsetParent


  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);
  var gutter = spacing.menuGutter;

  var viewSpaceAbove = containerTop - gutter;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;

  var scrollDown = menuBottom - viewHeight + scrollTop + gutter;
  var scrollUp = scrollTop + menuTop - gutter;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - gutter : scrollSpaceBelow - gutter;

        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight = isFixedPosition ? viewSpaceAbove - gutter - spacing.controlHeight : scrollSpaceAbove - gutter - spacing.controlHeight;
        }

        return { placement: 'top', maxHeight: _constrainedHeight };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (placement === 'bottom') {
        scrollTo(scrollParent, scrollDown);
        return { placement: 'bottom', maxHeight: maxHeight };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return { placement: 'top', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return { placement: 'top', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - gutter : scrollSpaceAbove - gutter;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return { placement: 'bottom', maxHeight: maxHeight };
    default:
      throw new Error('Invalid placement provided "' + placement + '".');
  }

  // fulfil contract with flow: implicit return value of undefined
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = { bottom: 'top', top: 'bottom' };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement;
  return _ref3 = {}, defineProperty(_ref3, alignToControl(placement), '100%'), defineProperty(_ref3, 'backgroundColor', colors.neutral0), defineProperty(_ref3, 'borderRadius', borderRadius), defineProperty(_ref3, 'boxShadow', '0 0 0 1px ' + colors.neutral10a + ', 0 4px 11px ' + colors.neutral10a), defineProperty(_ref3, 'marginBottom', spacing.menuGutter), defineProperty(_ref3, 'marginTop', spacing.menuGutter), defineProperty(_ref3, 'position', 'absolute'), defineProperty(_ref3, 'width', '100%'), defineProperty(_ref3, 'zIndex', 1), _ref3;
};

var Menu = function (_Component) {
  inherits(Menu, _Component);

  function Menu() {
    var _ref4;

    var _temp, _this, _ret;

    classCallCheck(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref4 = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    }, _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView;
      var getPortalPlacement = _this.context.getPortalPlacement;


      if (!ref) return;

      // DO NOT scroll if position is fixed
      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;

      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition
      });

      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    }, _this.getState = function () {
      var menuPlacement = _this.props.menuPlacement;

      var placement = _this.state.placement || coercePlacement(menuPlacement);

      return _extends({}, _this.props, { placement: placement, maxHeight: _this.state.maxHeight });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Menu, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          cx = _props.cx,
          getStyles = _props.getStyles,
          innerProps = _props.innerProps;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        _extends({
          className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('menu', this.getState())), {
            'menu': true
          }, className),
          ref: this.getPlacement
        }, innerProps),
        children
      );
    }
  }]);
  return Menu;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Menu.contextTypes = {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

// ==============================
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref5) {
  var maxHeight = _ref5.maxHeight;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: spacing.baseUnit,
    paddingTop: spacing.baseUnit,
    position: 'relative', // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('menuList', props)), {
        'menu-list': true,
        'menu-list--is-multi': isMulti
      }, className),
      ref: innerRef
    },
    children
  );
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS() {
  return {
    color: colors.neutral40,
    padding: spacing.baseUnit * 2 + 'px ' + spacing.baseUnit * 3 + 'px',
    textAlign: 'center'
  };
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;

var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('noOptionsMessage', props)), {
        'menu-notice': true,
        'menu-notice--no-options': true
      }, className)
    }, innerProps),
    children
  );
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};

var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('loadingMessage', props)), {
        'menu-notice': true,
        'menu-notice--loading': true
      }, className)
    }, innerProps),
    children
  );
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref6) {
  var rect = _ref6.rect,
      offset = _ref6.offset,
      position = _ref6.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};

var MenuPortal = function (_Component2) {
  inherits(MenuPortal, _Component2);

  function MenuPortal() {
    var _ref7;

    var _temp2, _this2, _ret2;

    classCallCheck(this, MenuPortal);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = possibleConstructorReturn(this, (_ref7 = MenuPortal.__proto__ || Object.getPrototypeOf(MenuPortal)).call.apply(_ref7, [this].concat(args))), _this2), _this2.state = { placement: null }, _this2.getPortalPlacement = function (_ref8) {
      var placement = _ref8.placement;

      var initialPlacement = coercePlacement(_this2.props.menuPlacement);

      // avoid re-renders if the placement has not changed
      if (placement !== initialPlacement) {
        _this2.setState({ placement: placement });
      }
    }, _temp2), possibleConstructorReturn(_this2, _ret2);
  }

  createClass(MenuPortal, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    }

    // callback for occassions where the menu must "flip"

  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          appendTo = _props2.appendTo,
          children = _props2.children,
          controlElement = _props2.controlElement,
          menuPlacement = _props2.menuPlacement,
          position = _props2.menuPosition,
          getStyles = _props2.getStyles;

      var isFixed = position === 'fixed';

      // bail early if required elements aren't present
      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = { offset: offset, position: position, rect: rect };

      // same wrapper element whether fixed or portalled
      var menuWrapper = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: /*#__PURE__*/ /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('menuPortal', state))
        },
        children
      );

      return appendTo ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper;
    }
  }]);
  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
MenuPortal.childContextTypes = {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var multiValueCSS = function multiValueCSS() {
  return {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug
  };
};
var multiValueLabelCSS = function multiValueLabelCSS(_ref) {
  var cropWithEllipsis = _ref.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.text,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};
var multiValueRemoveCSS = function multiValueRemoveCSS(_ref2) {
  var isFocused = _ref2.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};

var MultiValueGeneric = function MultiValueGeneric(_ref3) {
  var children = _ref3.children,
      innerProps = _ref3.innerProps;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    innerProps,
    children
  );
};

var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;

var MultiValueRemove = function (_Component) {
  inherits(MultiValueRemove, _Component);

  function MultiValueRemove() {
    classCallCheck(this, MultiValueRemove);
    return possibleConstructorReturn(this, (MultiValueRemove.__proto__ || Object.getPrototypeOf(MultiValueRemove)).apply(this, arguments));
  }

  createClass(MultiValueRemove, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          innerProps = _props.innerProps;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        innerProps,
        children
      );
    }
  }]);
  return MultiValueRemove;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MultiValueRemove.defaultProps = {
  children: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CrossIcon, { size: 14 })
};

var MultiValue = function (_Component2) {
  inherits(MultiValue, _Component2);

  function MultiValue() {
    classCallCheck(this, MultiValue);
    return possibleConstructorReturn(this, (MultiValue.__proto__ || Object.getPrototypeOf(MultiValue)).apply(this, arguments));
  }

  createClass(MultiValue, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          components = _props2.components,
          cx = _props2.cx,
          data = _props2.data,
          getStyles = _props2.getStyles,
          innerProps = _props2.innerProps,
          isDisabled = _props2.isDisabled,
          removeProps = _props2.removeProps,
          selectProps = _props2.selectProps;
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;


      var containerInnerProps = _extends({
        className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('multiValue', this.props)), {
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className)
      }, innerProps);

      var labelInnerProps = {
        className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('multiValueLabel', this.props)), {
          'multi-value__label': true
        }, className)
      };

      var removeInnerProps = _extends({
        className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('multiValueRemove', this.props)), {
          'multi-value__remove': true
        }, className)
      }, removeProps);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        Container,
        {
          data: data,
          innerProps: containerInnerProps,
          selectProps: selectProps
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Label,
          {
            data: data,
            innerProps: labelInnerProps,
            selectProps: selectProps
          },
          children
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Remove, {
          data: data,
          innerProps: removeInnerProps,
          selectProps: selectProps
        })
      );
    }
  }]);
  return MultiValue;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MultiValue.defaultProps = {
  cropWithEllipsis: true
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected;
  return {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: spacing.baseUnit * 2 + 'px ' + spacing.baseUnit * 3 + 'px',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',

    // provide some affordance on touch devices
    ':active': {
      backgroundColor: isSelected ? colors.primary : colors.primary50
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('option', props)), {
        'option': true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
      }, className)
    }, innerProps),
    children
  );
};

var placeholderCSS = function placeholderCSS() {
  return {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('placeholder', props)), {
        'placeholder': true
      }, className)
    }, innerProps),
    children
  );
};

var css$2 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled;
  return {
    color: isDisabled ? colors.neutral40 : colors.text,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: 'calc(100% - ' + spacing.baseUnit * 2 + 'px)',
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_emotion__["a" /* css */])(getStyles('singleValue', props)), {
        'single-value': true,
        'single-value--is-disabled': isDisabled
      }, className)
    }, innerProps),
    children
  );
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};

var defaultComponents = function defaultComponents(props) {
  return _extends({}, components, props.components);
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$2,
  valueContainer: valueContainerCSS
};

// Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = _extends({}, source);

  // massage in target styles
  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });

  return styles;
}

var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return count + ' result' + (count !== 1 ? 's' : '') + ' available';
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};

var instanceId = 1;

var Select = function (_Component) {
  inherits(Select, _Component);

  // Lifecycle
  // ------------------------------

  // Refs
  // ------------------------------

  // Misc. Instance Properties
  // ------------------------------

  function Select(props) {
    classCallCheck(this, Select);

    var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _initialiseProps.call(_this);

    var value = props.value;

    _this.cacheComponents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_memoize_one__["a" /* default */])(_this.cacheComponents, exportedEqual).bind(_this);
    _this.cacheComponents(props.components);
    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var selectValue = cleanValue(value);
    var menuOptions = _this.buildMenuOptions(props, selectValue);

    _this.state.menuOptions = menuOptions;
    _this.state.selectValue = selectValue;
    return _this;
  } // TODO


  createClass(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          options = _props.options,
          value = _props.value,
          inputValue = _props.inputValue;
      // re-cache custom components

      this.cacheComponents(nextProps.components);
      // rebuild the menu options
      if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
        var _selectValue = cleanValue(nextProps.value);
        var _menuOptions = this.buildMenuOptions(nextProps, _selectValue);
        var _focusedValue = this.getNextFocusedValue(_selectValue);
        var _focusedOption = this.getNextFocusedOption(_menuOptions.focusable);
        this.setState({ menuOptions: _menuOptions, selectValue: _selectValue, focusedOption: _focusedOption, focusedValue: _focusedValue });
      }
      // some updates should toggle the state of the input visibility
      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          isDisabled = _props2.isDisabled,
          menuIsOpen = _props2.menuIsOpen;
      var isFocused = this.state.isFocused;


      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      // scroll the focused option into view if necessary
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
      this.scrollToFocusedOptionOnUpdate = false;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'onMenuOpen',

    // ==============================
    // Consumer Handlers
    // ==============================

    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: 'onMenuClose',
    value: function onMenuClose() {
      var _props3 = this.props,
          isSearchable = _props3.isSearchable,
          isMulti = _props3.isMulti;

      this.announceAriaLiveContext({
        event: 'input',
        context: { isSearchable: isSearchable, isMulti: isMulti }
      });
      this.onInputChange('', { action: 'menu-close' });
      this.props.onMenuClose();
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }

    // ==============================
    // Methods
    // ==============================

  }, {
    key: 'focusInput',
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: 'blurInput',
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }

    // aliased for consumers

  }, {
    key: 'openMenu',
    value: function openMenu(focusOption) {
      var _state = this.state,
          menuOptions = _state.menuOptions,
          selectValue = _state.selectValue;
      var isMulti = this.props.isMulti;

      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.inputIsHiddenAfterUpdate = false;

      this.onMenuOpen();
      this.setState({
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      });

      this.announceAriaLiveContext({ event: 'menu' });
    }
  }, {
    key: 'focusValue',
    value: function focusValue(direction) {
      var _props4 = this.props,
          isMulti = _props4.isMulti,
          isSearchable = _props4.isSearchable;
      var _state2 = this.state,
          selectValue = _state2.selectValue,
          focusedValue = _state2.focusedValue;

      // Only multiselects support value focusing

      if (!isMulti) return;

      this.setState({
        focusedOption: null
      });

      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({ event: 'value' });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: { isSearchable: isSearchable, isMulti: isMulti }
        });
      }

      this.setState({
        inputIsHidden: nextFocus === -1 ? false : true,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: 'focusOption',
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var _state3 = this.state,
          focusedOption = _state3.focusedOption,
          menuOptions = _state3.menuOptions;

      var options = menuOptions.focusable;

      if (!options.length) return;
      var nextFocus = 0; // handles 'first'
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({ event: 'menu' });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: 'getCommonProps',


    // ==============================
    // Getters
    // ==============================

    value: function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;

      var hasValue = this.hasValue();
      var getValue = function getValue() {
        return selectValue;
      };
      var cxPrefix = classNamePrefix;

      var cx = classNames.bind(null, cxPrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props
      };
    }
  }, {
    key: 'getNextFocusedValue',
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }
      var _state4 = this.state,
          focusedValue = _state4.focusedValue,
          lastSelectValue = _state4.selectValue;

      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }
      return null;
    }
  }, {
    key: 'getNextFocusedOption',
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;

      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }

    // ==============================
    // Helpers
    // ==============================

  }, {
    key: 'hasValue',
    value: function hasValue() {
      var selectValue = this.state.selectValue;

      return selectValue.length > 0;
    }
  }, {
    key: 'hasOptions',
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: 'countOptions',
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: 'isClearable',
    value: function isClearable() {
      var _props5 = this.props,
          isClearable = _props5.isClearable,
          isMulti = _props5.isMulti;

      // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;

      return isClearable;
    }
  }, {
    key: 'isOptionDisabled',
    value: function isOptionDisabled$$1(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: 'isOptionSelected',
    value: function isOptionSelected(option, selectValue) {
      var _this2 = this;

      if (selectValue.indexOf(option) > -1) return true;
      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }
      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this2.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: 'filterOption',
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: 'formatOptionLabel',
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue2 = this.state.selectValue;

        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue2
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: 'formatGroupLabel',
    value: function formatGroupLabel$$1(data) {
      return this.props.formatGroupLabel(data);
    }

    // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: 'startListeningComposition',


    // ==============================
    // Composition Handlers
    // ==============================

    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: 'stopListeningComposition',
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: 'startListeningToTouch',


    // ==============================
    // Touch Handlers
    // ==============================

    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: 'stopListeningToTouch',
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }

    // ==============================
    // Focus Handlers
    // ==============================

    // ==============================
    // Keyboard Handlers
    // ==============================

  }, {
    key: 'buildMenuOptions',


    // ==============================
    // Menu Options
    // ==============================

    value: function buildMenuOptions(props, selectValue) {
      var _this3 = this;

      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === undefined ? '' : _props$inputValue,
          options = props.options;


      var toOption = function toOption(option, id) {
        var isDisabled = _this3.isOptionDisabled(option, selectValue);
        var isSelected = _this3.isOptionSelected(option, selectValue);
        var label = _this3.getOptionLabel(option);
        var value = _this3.getOptionValue(option);

        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({ label: label, value: value, data: option }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this3.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this3.selectOption(option);
        };
        var optionId = _this3.getElementId('option') + '-' + id;

        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            role: 'option',
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this3.hasGroups) _this3.hasGroups = true;

          var items = item.options;

          var children = items.map(function (child, i) {
            var option = toOption(child, itemIndex + '-' + i);
            if (option && !option.isDisabled) acc.focusable.push(child);
            return option;
          }).filter(Boolean);
          if (children.length) {
            var groupId = _this3.getElementId('group') + '-' + itemIndex;
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, '' + itemIndex);
          if (option) {
            acc.render.push(option);
            if (!option.isDisabled) acc.focusable.push(item);
          }
        }
        return acc;
      }, { render: [], focusable: [] });
    }

    // ==============================
    // Renderers
    // ==============================

  }, {
    key: 'constructAriaLiveMessage',
    value: function constructAriaLiveMessage() {
      var _state5 = this.state,
          ariaLiveContext = _state5.ariaLiveContext,
          selectValue = _state5.selectValue,
          focusedValue = _state5.focusedValue,
          focusedOption = _state5.focusedOption;
      var _props6 = this.props,
          options = _props6.options,
          menuIsOpen = _props6.menuIsOpen,
          inputValue = _props6.inputValue,
          screenReaderStatus = _props6.screenReaderStatus;

      // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : '';
      // An aria live message representing the currently focused option in the select.
      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : '';
      // An aria live message representing the set of focusable results and current searchterm/inputvalue.
      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({ count: this.countOptions() })
      });

      return focusedValueMsg + ' ' + focusedOptionMsg + ' ' + resultsMsg + ' ' + ariaLiveContext;
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var _props7 = this.props,
          isDisabled = _props7.isDisabled,
          isSearchable = _props7.isSearchable,
          inputId = _props7.inputId,
          inputValue = _props7.inputValue,
          tabIndex = _props7.tabIndex;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;


      var id = inputId || this.getElementId('input');

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DummyInput, {
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          tabIndex: tabIndex,
          value: ''
        });
      }

      // aria attributes makes the JSX "noisy", separated for clarity
      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };

      var cx = this.commonProps.cx;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Input, _extends({
        autoCapitalize: 'none',
        autoComplete: 'off',
        autoCorrect: 'off',
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: 'false',
        tabIndex: tabIndex,
        type: 'text',
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: 'renderPlaceholderOrValue',
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _components = this.components,
          MultiValue = _components.MultiValue,
          MultiValueContainer = _components.MultiValueContainer,
          MultiValueLabel = _components.MultiValueLabel,
          MultiValueRemove = _components.MultiValueRemove,
          SingleValue = _components.SingleValue,
          Placeholder = _components.Placeholder;
      var commonProps = this.commonProps;
      var _props8 = this.props,
          controlShouldRenderValue = _props8.controlShouldRenderValue,
          isDisabled = _props8.isDisabled,
          isMulti = _props8.isMulti,
          inputValue = _props8.inputValue,
          placeholder = _props8.placeholder;
      var _state6 = this.state,
          selectValue = _state6.selectValue,
          focusedValue = _state6.focusedValue;


      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Placeholder,
          _extends({}, commonProps, { key: 'placeholder', isDisabled: isDisabled }),
          placeholder
        );
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt) {
          var isFocused = opt === focusedValue;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            MultiValue,
            _extends({}, commonProps, {
              components: {
                Container: MultiValueContainer,
                Label: MultiValueLabel,
                Remove: MultiValueRemove
              },
              isFocused: isFocused,
              isDisabled: isDisabled,
              key: _this4.getOptionValue(opt),
              removeProps: {
                onClick: function onClick() {
                  return _this4.removeValue(opt);
                },
                onTouchEnd: function onTouchEnd() {
                  return _this4.removeValue(opt);
                },
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              },
              data: opt
            }),
            _this4.formatOptionLabel(opt, 'value')
          );
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        SingleValue,
        _extends({}, commonProps, { data: singleValue, isDisabled: isDisabled }),
        this.formatOptionLabel(singleValue, 'value')
      );
    }
  }, {
    key: 'renderClearIndicator',
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _props9 = this.props,
          isDisabled = _props9.isDisabled,
          isLoading = _props9.isLoading;
      var isFocused = this.state.isFocused;


      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClearIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderLoadingIndicator',
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _props10 = this.props,
          isDisabled = _props10.isDisabled,
          isLoading = _props10.isLoading;
      var isFocused = this.state.isFocused;


      if (!LoadingIndicator || !isLoading) return null;

      var innerProps = { 'aria-hidden': 'true' };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderIndicatorSeparator',
    value: function renderIndicatorSeparator() {
      var _components2 = this.components,
          DropdownIndicator = _components2.DropdownIndicator,
          IndicatorSeparator = _components2.IndicatorSeparator;

      // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;

      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(IndicatorSeparator, _extends({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderDropdownIndicator',
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;

      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;


      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DropdownIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _this5 = this;

      var _components3 = this.components,
          Group = _components3.Group,
          GroupHeading = _components3.GroupHeading,
          Menu = _components3.Menu,
          MenuList = _components3.MenuList,
          MenuPortal = _components3.MenuPortal,
          LoadingMessage = _components3.LoadingMessage,
          NoOptionsMessage = _components3.NoOptionsMessage,
          Option = _components3.Option;
      var commonProps = this.commonProps;
      var _state7 = this.state,
          focusedOption = _state7.focusedOption,
          menuOptions = _state7.menuOptions;
      var _props11 = this.props,
          captureMenuScroll = _props11.captureMenuScroll,
          inputValue = _props11.inputValue,
          isLoading = _props11.isLoading,
          loadingMessage = _props11.loadingMessage,
          minMenuHeight = _props11.minMenuHeight,
          maxMenuHeight = _props11.maxMenuHeight,
          menuIsOpen = _props11.menuIsOpen,
          menuPlacement = _props11.menuPlacement,
          menuPosition = _props11.menuPosition,
          menuPortalTarget = _props11.menuPortalTarget,
          menuShouldBlockScroll = _props11.menuShouldBlockScroll,
          menuShouldScrollIntoView = _props11.menuShouldScrollIntoView,
          noOptionsMessage = _props11.noOptionsMessage,
          onMenuScrollToTop = _props11.onMenuScrollToTop,
          onMenuScrollToBottom = _props11.onMenuScrollToBottom;


      if (!menuIsOpen) return null;

      // TODO: Internal Option Type here
      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Option,
          _extends({}, commonProps, props, { isFocused: isFocused }),
          _this5.formatOptionLabel(props.data, 'menu')
        );
      };

      var menuUI = void 0;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = objectWithoutProperties(item, ['type']);

            var headingId = item.key + '-heading';

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              Group,
              _extends({}, commonProps, group, {
                Heading: GroupHeading,
                headingProps: {
                  id: headingId
                },
                label: _this5.formatGroupLabel(item.data)
              }),
              item.options.map(function (option) {
                return render(option);
              })
            );
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({ inputValue: inputValue });
        if (message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          LoadingMessage,
          commonProps,
          message
        );
      } else {
        var _message = noOptionsMessage({ inputValue: inputValue });
        if (_message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          NoOptionsMessage,
          commonProps,
          _message
        );
      }

      var menuElement = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Menu,
          _extends({}, commonProps, {
            innerProps: {
              onMouseDown: this.onMenuMouseDown,
              onMouseMove: this.onMenuMouseMove
            },
            isLoading: isLoading,
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            ScrollCaptorSwitch,
            {
              isEnabled: captureMenuScroll,
              onTopArrive: onMenuScrollToTop,
              onBottomArrive: onMenuScrollToBottom
            },
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              ScrollBlock,
              { isEnabled: menuShouldBlockScroll },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                MenuList,
                _extends({}, commonProps, {
                  innerRef: this.getMenuListRef,
                  isLoading: isLoading,
                  maxHeight: maxMenuHeight
                }),
                menuUI
              )
            )
          )
        )
      );

      // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`
      return menuPortalTarget || menuPosition === 'fixed' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        MenuPortal,
        _extends({}, commonProps, {
          appendTo: menuPortalTarget,
          controlElement: this.controlRef,
          menuPlacement: menuPlacement,
          menuPosition: menuPosition
        }),
        menuElement
      ) : menuElement;
    }
  }, {
    key: 'renderFormField',
    value: function renderFormField() {
      var _this6 = this;

      var _props12 = this.props,
          delimiter = _props12.delimiter,
          isDisabled = _props12.isDisabled,
          isMulti = _props12.isMulti,
          name = _props12.name;
      var selectValue = this.state.selectValue;


      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var _value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: name, type: 'hidden', value: _value });
        } else {
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            selectValue.map(function (opt, i) {
              return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                key: 'i-' + i,
                name: name,
                type: 'hidden',
                value: _this6.getOptionValue(opt)
              });
            })
          );
        }
      } else {
        var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: name, type: 'hidden', value: _value2 });
      }
    }
  }, {
    key: 'renderLiveRegion',
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        A11yText,
        { 'aria-live': 'assertive' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { id: 'aria-selection-event' },
          '\xA0',
          this.state.ariaLiveSelection
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { id: 'aria-context' },
          '\xA0',
          this.constructAriaLiveMessage()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _components4 = this.components,
          Control = _components4.Control,
          IndicatorsContainer = _components4.IndicatorsContainer,
          SelectContainer = _components4.SelectContainer,
          ValueContainer = _components4.ValueContainer;
      var _props13 = this.props,
          className = _props13.className,
          id = _props13.id,
          isDisabled = _props13.isDisabled;
      var isFocused = this.state.isFocused;


      var commonProps = this.commonProps = this.getCommonProps();

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        SelectContainer,
        _extends({}, commonProps, {
          className: className,
          innerProps: {
            id: id,
            onKeyDown: this.onKeyDown
          },
          isDisabled: isDisabled,
          isFocused: isFocused
        }),
        this.renderLiveRegion(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Control,
          _extends({}, commonProps, {
            innerRef: this.getControlRef,
            innerProps: {
              onMouseDown: this.onControlMouseDown,
              onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: isDisabled,
            isFocused: isFocused
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            ValueContainer,
            _extends({}, commonProps, { isDisabled: isDisabled }),
            this.renderPlaceholderOrValue(),
            this.renderInput()
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            IndicatorsContainer,
            _extends({}, commonProps, { isDisabled: isDisabled }),
            this.renderClearIndicator(),
            this.renderLoadingIndicator(),
            this.renderIndicatorSeparator(),
            this.renderDropdownIndicator()
          )
        ),
        this.renderMenu(),
        this.renderFormField()
      );
    }
  }]);
  return Select;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Select.defaultProps = defaultProps;

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.state = {
    ariaLiveSelection: '',
    ariaLiveContext: '',
    focusedOption: null,
    focusedValue: null,
    inputIsHidden: false,
    isFocused: false,
    isComposing: false,
    menuOptions: { render: [], focusable: [] },
    selectValue: []
  };
  this.blockOptionHover = false;
  this.clearFocusValueOnUpdate = false;
  this.hasGroups = false;
  this.initialTouchX = 0;
  this.initialTouchY = 0;
  this.instancePrefix = '';
  this.openAfterFocus = false;
  this.scrollToFocusedOptionOnUpdate = false;
  this.controlRef = null;

  this.getControlRef = function (ref) {
    _this7.controlRef = ref;
  };

  this.focusedOptionRef = null;

  this.getFocusedOptionRef = function (ref) {
    _this7.focusedOptionRef = ref;
  };

  this.menuListRef = null;

  this.getMenuListRef = function (ref) {
    _this7.menuListRef = ref;
  };

  this.inputRef = null;

  this.getInputRef = function (ref) {
    _this7.inputRef = ref;
  };

  this.cacheComponents = function (components$$1) {
    _this7.components = defaultComponents({ components: components$$1 });
  };

  this.focus = this.focusInput;
  this.blur = this.blurInput;

  this.setValue = function (newValue) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
    var option = arguments[2];
    var _props14 = _this7.props,
        closeMenuOnSelect = _props14.closeMenuOnSelect,
        isMulti = _props14.isMulti,
        onChange = _props14.onChange;

    _this7.onInputChange('', { action: 'set-value' });
    if (closeMenuOnSelect) {
      _this7.inputIsHiddenAfterUpdate = !isMulti;
      _this7.onMenuClose();
    }
    // when the select value should change, we should reset focusedValue
    _this7.clearFocusValueOnUpdate = true;
    onChange(newValue, { action: action, option: option });
  };

  this.selectOption = function (newValue) {
    var _props15 = _this7.props,
        blurInputOnSelect = _props15.blurInputOnSelect,
        isMulti = _props15.isMulti;


    if (isMulti) {
      var _selectValue3 = _this7.state.selectValue;

      if (_this7.isOptionSelected(newValue, _selectValue3)) {
        var candidate = _this7.getOptionValue(newValue);
        _this7.setValue(_selectValue3.filter(function (i) {
          return _this7.getOptionValue(i) !== candidate;
        }), 'deselect-option', newValue);
        _this7.announceAriaLiveSelection({
          event: 'deselect-option',
          context: { value: _this7.getOptionLabel(newValue) }
        });
      } else {
        _this7.setValue([].concat(toConsumableArray(_selectValue3), [newValue]), 'select-option', newValue);
        _this7.announceAriaLiveSelection({
          event: 'select-option',
          context: { value: _this7.getOptionLabel(newValue) }
        });
      }
    } else {
      _this7.setValue(newValue, 'select-option');
      _this7.announceAriaLiveSelection({
        event: 'select-option',
        context: { value: _this7.getOptionLabel(newValue) }
      });
    }

    if (blurInputOnSelect) {
      _this7.blurInput();
    }
  };

  this.removeValue = function (removedValue) {
    var onChange = _this7.props.onChange;
    var selectValue = _this7.state.selectValue;

    var candidate = _this7.getOptionValue(removedValue);
    onChange(selectValue.filter(function (i) {
      return _this7.getOptionValue(i) !== candidate;
    }), {
      action: 'remove-value',
      removedValue: removedValue
    });
    _this7.announceAriaLiveSelection({
      event: 'remove-value',
      context: {
        value: removedValue ? _this7.getOptionLabel(removedValue) : undefined
      }
    });
    _this7.focusInput();
  };

  this.clearValue = function () {
    var _props16 = _this7.props,
        isMulti = _props16.isMulti,
        onChange = _props16.onChange;

    onChange(isMulti ? [] : null, { action: 'clear' });
  };

  this.popValue = function () {
    var onChange = _this7.props.onChange;
    var selectValue = _this7.state.selectValue;

    var lastSelectedValue = selectValue[selectValue.length - 1];
    _this7.announceAriaLiveSelection({
      event: 'pop-value',
      context: {
        value: lastSelectedValue ? _this7.getOptionLabel(lastSelectedValue) : undefined
      }
    });
    onChange(selectValue.slice(0, selectValue.length - 1), {
      action: 'pop-value',
      removedValue: lastSelectedValue
    });
  };

  this.getOptionLabel = function (data) {
    return _this7.props.getOptionLabel(data);
  };

  this.getOptionValue = function (data) {
    return _this7.props.getOptionValue(data);
  };

  this.getStyles = function (key, props) {
    var base = defaultStyles[key](props);
    base.boxSizing = 'border-box';
    var custom = _this7.props.styles[key];
    return custom ? custom(base, props) : base;
  };

  this.getElementId = function (element) {
    return _this7.instancePrefix + '-' + element;
  };

  this.getActiveDescendentId = function () {
    var menuIsOpen = _this7.props.menuIsOpen;
    var _state8 = _this7.state,
        menuOptions = _state8.menuOptions,
        focusedOption = _state8.focusedOption;


    if (!focusedOption || !menuIsOpen) return undefined;

    var index = menuOptions.focusable.indexOf(focusedOption);
    var option = menuOptions.render[index];

    return option && option.key;
  };

  this.announceAriaLiveSelection = function (_ref2) {
    var event = _ref2.event,
        context = _ref2.context;

    _this7.setState({
      ariaLiveSelection: valueEventAriaMessage(event, context)
    });
  };

  this.announceAriaLiveContext = function (_ref3) {
    var event = _ref3.event,
        context = _ref3.context;

    _this7.setState({
      ariaLiveContext: instructionsAriaMessage(event, _extends({}, context, {
        label: _this7.props['aria-label']
      }))
    });
  };

  this.onMenuMouseDown = function (event) {
    if (event.button !== 0) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    _this7.focusInput();
  };

  this.onMenuMouseMove = function (event) {
    _this7.blockOptionHover = false;
  };

  this.onControlMouseDown = function (event) {
    var openMenuOnClick = _this7.props.openMenuOnClick;

    if (!_this7.state.isFocused) {
      if (openMenuOnClick) {
        _this7.openAfterFocus = true;
      }
      _this7.focusInput();
    } else if (!_this7.props.menuIsOpen) {
      _this7.openMenu('first');
    } else {
      _this7.onMenuClose();
    }
    // $FlowFixMe HTMLElement type does not have tagName property
    if (event.target.tagName !== 'INPUT') {
      event.preventDefault();
    }
  };

  this.onDropdownIndicatorMouseDown = function (event) {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    if (_this7.props.isDisabled) return;
    var _props17 = _this7.props,
        isMulti = _props17.isMulti,
        menuIsOpen = _props17.menuIsOpen;

    _this7.focusInput();
    if (menuIsOpen) {
      _this7.inputIsHiddenAfterUpdate = !isMulti;
      _this7.onMenuClose();
    } else {
      _this7.openMenu('first');
    }
    event.preventDefault();
    event.stopPropagation();
  };

  this.onClearIndicatorMouseDown = function (event) {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    _this7.clearValue();
    event.stopPropagation();
    _this7.openAfterFocus = false;
    setTimeout(function () {
      return _this7.focusInput();
    });
  };

  this.onScroll = function (event) {
    if (typeof _this7.props.closeMenuOnScroll === 'boolean') {
      if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
        _this7.props.onMenuClose();
      }
    } else if (typeof _this7.props.closeMenuOnScroll === 'function') {
      if (_this7.props.closeMenuOnScroll(event)) {
        _this7.props.onMenuClose();
      }
    }
  };

  this.onCompositionStart = function () {
    _this7.setState({
      isComposing: true
    });
  };

  this.onCompositionEnd = function () {
    _this7.setState({
      isComposing: false
    });
  };

  this.onTouchStart = function (_ref4) {
    var _ref4$touches = slicedToArray(_ref4.touches, 1),
        touch = _ref4$touches[0];

    _this7.initialTouchX = touch.clientX;
    _this7.initialTouchY = touch.clientY;
    _this7.userIsDragging = false;
  };

  this.onTouchMove = function (_ref5) {
    var _ref5$touches = slicedToArray(_ref5.touches, 1),
        touch = _ref5$touches[0];

    var deltaX = Math.abs(touch.clientX - _this7.initialTouchX);
    var deltaY = Math.abs(touch.clientY - _this7.initialTouchY);
    var moveThreshold = 5;

    _this7.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
  };

  this.onTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    // type cast the EventTarget
    var target = event.target;

    // close the menu if the user taps outside
    if (_this7.controlRef && !_this7.controlRef.contains(target) && _this7.menuListRef && !_this7.menuListRef.contains(target)) {
      _this7.blurInput();
    }

    // reset move vars
    _this7.initialTouchX = 0;
    _this7.initialTouchY = 0;
  };

  this.onControlTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onControlMouseDown(event);
  };

  this.onClearIndicatorTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onClearIndicatorMouseDown(event);
  };

  this.onDropdownIndicatorTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onDropdownIndicatorMouseDown(event);
  };

  this.handleInputChange = function (event) {
    var inputValue = event.currentTarget.value;
    _this7.inputIsHiddenAfterUpdate = false;
    _this7.onInputChange(inputValue, { action: 'input-change' });
    _this7.onMenuOpen();
  };

  this.onInputFocus = function (event) {
    var _props18 = _this7.props,
        isSearchable = _props18.isSearchable,
        isMulti = _props18.isMulti;

    if (_this7.props.onFocus) {
      _this7.props.onFocus(event);
    }
    _this7.inputIsHiddenAfterUpdate = false;
    _this7.announceAriaLiveContext({
      event: 'input',
      context: { isSearchable: isSearchable, isMulti: isMulti }
    });
    _this7.setState({
      isFocused: true
    });
    if (_this7.openAfterFocus || _this7.props.openMenuOnFocus) {
      _this7.openMenu('first');
    }
    _this7.openAfterFocus = false;
  };

  this.onInputBlur = function (event) {
    if (_this7.props.onBlur) {
      _this7.props.onBlur(event);
    }
    _this7.onInputChange('', { action: 'input-blur' });
    _this7.onMenuClose();
    _this7.setState({
      focusedValue: null,
      isFocused: false
    });
  };

  this.onOptionHover = function (focusedOption) {
    if (_this7.blockOptionHover || _this7.state.focusedOption === focusedOption) {
      return;
    }
    _this7.setState({ focusedOption: focusedOption });
  };

  this.shouldHideSelectedOptions = function () {
    var _props19 = _this7.props,
        hideSelectedOptions = _props19.hideSelectedOptions,
        isMulti = _props19.isMulti;

    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
  };

  this.onKeyDown = function (event) {
    var _props20 = _this7.props,
        isMulti = _props20.isMulti,
        backspaceRemovesValue = _props20.backspaceRemovesValue,
        escapeClearsValue = _props20.escapeClearsValue,
        inputValue = _props20.inputValue,
        isClearable = _props20.isClearable,
        isDisabled = _props20.isDisabled,
        menuIsOpen = _props20.menuIsOpen,
        onKeyDown = _props20.onKeyDown,
        tabSelectsValue = _props20.tabSelectsValue,
        openMenuOnFocus = _props20.openMenuOnFocus;
    var _state9 = _this7.state,
        isComposing = _state9.isComposing,
        focusedOption = _state9.focusedOption,
        focusedValue = _state9.focusedValue,
        selectValue = _state9.selectValue;


    if (isDisabled) return;

    if (typeof onKeyDown === 'function') {
      onKeyDown(event);
      if (event.defaultPrevented) {
        return;
      }
    }

    // Block option hover events when the user has just pressed a key
    _this7.blockOptionHover = true;
    switch (event.key) {
      case 'ArrowLeft':
        if (!isMulti || inputValue) return;
        _this7.focusValue('previous');
        break;
      case 'ArrowRight':
        if (!isMulti || inputValue) return;
        _this7.focusValue('next');
        break;
      case 'Backspace':
        if (inputValue) return;
        if (focusedValue) {
          _this7.removeValue(focusedValue);
        } else {
          if (!backspaceRemovesValue) return;
          _this7.popValue();
        }
        break;
      case 'Tab':
        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
        // don't capture the event if the menu opens on focus and the focused
        // option is already selected; it breaks the flow of navigation
        openMenuOnFocus && _this7.isOptionSelected(focusedOption, selectValue)) {
          return;
        }
        _this7.selectOption(focusedOption);
        break;
      case 'Enter':
        if (menuIsOpen) {
          if (!focusedOption) return;
          if (isComposing) return;
          _this7.selectOption(focusedOption);
        } else {
          _this7.focusOption('first');
        }
        break;
      case 'Escape':
        if (menuIsOpen) {
          _this7.inputIsHiddenAfterUpdate = false;
          _this7.onInputChange('', { action: 'menu-close' });
          _this7.onMenuClose();
        } else if (isClearable && escapeClearsValue) {
          _this7.clearValue();
        }
        break;
      case ' ':
        // space
        if (inputValue) {
          return;
        }
        if (!menuIsOpen) {
          _this7.openMenu('first');
          break;
        }
        if (!focusedOption) return;
        _this7.selectOption(focusedOption);
        break;
      case 'ArrowUp':
        if (menuIsOpen) {
          _this7.focusOption('up');
        } else {
          _this7.openMenu('last');
        }
        break;
      case 'ArrowDown':
        if (menuIsOpen) {
          _this7.focusOption('down');
        } else {
          _this7.openMenu('first');
        }
        break;
      case 'PageUp':
        if (!menuIsOpen) return;
        _this7.focusOption('pageup');
        break;
      case 'PageDown':
        if (!menuIsOpen) return;
        _this7.focusOption('pagedown');
        break;
      case 'Home':
        if (!menuIsOpen) return;
        _this7.focusOption('first');
        break;
      case 'End':
        if (!menuIsOpen) return;
        _this7.focusOption('last');
        break;
      default:
        return;
    }
    event.preventDefault();
  };
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    inherits(StateManager, _Component);

    function StateManager() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, StateManager);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = StateManager.__proto__ || Object.getPrototypeOf(StateManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      }, _this.onChange = function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);
        _this.setState({ value: value });
      }, _this.onInputChange = function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);
        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      }, _this.onMenuOpen = function () {
        _this.callProp('onMenuOpen');
        _this.setState({ menuIsOpen: true });
      }, _this.onMenuClose = function () {
        _this.callProp('onMenuClose');
        _this.setState({ menuIsOpen: false });
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(StateManager, [{
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'getProp',
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      }
    }, {
      key: 'callProp',
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _props;

          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_props = this.props)[name].apply(_props, toConsumableArray(args));
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, this.props, {
          ref: function ref(_ref2) {
            _this2.select = _ref2;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);
    return StateManager;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
  }, _temp2;
};

var defaultProps$1 = {
  cacheOptions: false,
  defaultOptions: false
};

var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    inherits(Async, _Component);

    function Async(props) {
      classCallCheck(this, Async);

      var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this));

      _this.mounted = false;
      _this.optionsCache = {};

      _this.handleInputChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            cacheOptions = _this$props.cacheOptions,
            onInputChange = _this$props.onInputChange;
        // TODO

        var inputValue = handleInputChange(newValue, actionMeta, onInputChange);
        if (!inputValue) {
          delete _this.lastRequest;
          _this.setState({
            inputValue: '',
            loadedInputValue: '',
            loadedOptions: [],
            isLoading: false,
            passEmptyOptions: false
          });
          return;
        }
        if (cacheOptions && _this.optionsCache[inputValue]) {
          _this.setState({
            inputValue: inputValue,
            loadedInputValue: inputValue,
            loadedOptions: _this.optionsCache[inputValue],
            isLoading: false,
            passEmptyOptions: false
          });
        } else {
          var request = _this.lastRequest = {};
          _this.setState({
            inputValue: inputValue,
            isLoading: true,
            passEmptyOptions: !_this.state.loadedInputValue
          }, function () {
            _this.loadOptions(inputValue, function (options) {
              if (!_this.mounted) return;
              if (options) {
                _this.optionsCache[inputValue] = options;
              }
              if (request !== _this.lastRequest) return;
              delete _this.lastRequest;
              _this.setState({
                isLoading: false,
                loadedInputValue: inputValue,
                loadedOptions: options || [],
                passEmptyOptions: false
              });
            });
          });
        }
        return inputValue;
      };

      _this.state = {
        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
        inputValue: '',
        isLoading: props.defaultOptions === true ? true : false,
        loadedOptions: [],
        passEmptyOptions: false
      };
      return _this;
    }

    createClass(Async, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.mounted = true;
        var defaultOptions = this.props.defaultOptions;

        if (defaultOptions === true) {
          this.loadOptions('', function (options) {
            if (!_this2.mounted) return;
            var isLoading = !!_this2.lastRequest;
            _this2.setState({ defaultOptions: options || [], isLoading: isLoading });
          });
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        // if the cacheOptions prop changes, clear the cache
        if (nextProps.cacheOptions !== this.props.cacheOptions) {
          this.optionsCache = {};
        }
        if (nextProps.defaultOptions !== this.props.defaultOptions) {
          this.setState({
            defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'loadOptions',
      value: function loadOptions(inputValue, callback) {
        var loadOptions = this.props.loadOptions;

        if (!loadOptions) return callback();
        var loader = loadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') {
          loader.then(callback, function () {
            return callback();
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var _props = this.props,
            loadOptions = _props.loadOptions,
            props = objectWithoutProperties(_props, ['loadOptions']);
        var _state = this.state,
            defaultOptions = _state.defaultOptions,
            inputValue = _state.inputValue,
            isLoading = _state.isLoading,
            loadedInputValue = _state.loadedInputValue,
            loadedOptions = _state.loadedOptions,
            passEmptyOptions = _state.passEmptyOptions;

        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return (
          // $FlowFixMe
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, props, {
            filterOption: this.props.filterOption || null,
            ref: function ref(_ref) {
              _this3.select = _ref;
            },
            options: options,
            isLoading: isLoading,
            onInputChange: this.handleInputChange
          }))
        );
      }
    }]);
    return Async;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = defaultProps$1, _temp;
};
var Async = makeAsyncSelect(manageState(Select));

var compareOption = function compareOption(inputValue, option) {
  var candidate = inputValue.toLowerCase();
  return option.value.toLowerCase() === candidate || option.label.toLowerCase() === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return 'Create "' + inputValue + '"';
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};

var defaultProps$2 = _extends({
  allowCreateWhileLoading: false,
  createOptionPosition: 'last'
}, builtins);

var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    inherits(Creatable, _Component);

    function Creatable(props) {
      classCallCheck(this, Creatable);

      var _this = possibleConstructorReturn(this, (Creatable.__proto__ || Object.getPrototypeOf(Creatable)).call(this, props));

      _this.onChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            getNewOptionData = _this$props.getNewOptionData,
            inputValue = _this$props.inputValue,
            isMulti = _this$props.isMulti,
            onChange = _this$props.onChange,
            onCreateOption = _this$props.onCreateOption,
            value = _this$props.value;

        if (actionMeta.action !== 'select-option') {
          return onChange(newValue, actionMeta);
        }
        var newOption = _this.state.newOption;

        var valueArray = Array.isArray(newValue) ? newValue : [newValue];

        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption) onCreateOption(inputValue);else {
            var newOptionData = getNewOptionData(inputValue, inputValue);
            var newActionMeta = { action: 'create-option' };
            if (isMulti) {
              onChange([].concat(toConsumableArray(cleanValue(value)), [newOptionData]), newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }
        onChange(newValue, actionMeta);
      };

      var options = props.options || [];
      _this.state = {
        newOption: undefined,
        options: options
      };
      return _this;
    }

    createClass(Creatable, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
            createOptionPosition = nextProps.createOptionPosition,
            formatCreateLabel = nextProps.formatCreateLabel,
            getNewOptionData = nextProps.getNewOptionData,
            inputValue = nextProps.inputValue,
            isLoading = nextProps.isLoading,
            isValidNewOption = nextProps.isValidNewOption,
            value = nextProps.value;

        var options = nextProps.options || [];
        var newOption = this.state.newOption;

        if (isValidNewOption(inputValue, cleanValue(value), options)) {
          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
        } else {
          newOption = undefined;
        }
        this.setState({
          newOption: newOption,
          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(toConsumableArray(options)) : [].concat(toConsumableArray(options), [newOption]) : options
        });
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var props = objectWithoutProperties(this.props, []);
        var options = this.state.options;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          options: options,
          onChange: this.onChange
        }));
      }
    }]);
    return Creatable;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = defaultProps$2, _temp;
};
var Creatable = manageState(makeCreatableSelect(Select));

var AsyncCreatable = makeAsyncSelect(manageState(makeCreatableSelect(Select)));

// ==============================
// Fade Transition
// ==============================

var Fade = function Fade(_ref) {
  var Tag = _ref.component,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 1 : _ref$duration,
      inProp = _ref.in,
      onExited = _ref.onExited,
      props = objectWithoutProperties(_ref, ['component', 'duration', 'in', 'onExited']);

  var transition = {
    entering: { opacity: 0 },
    entered: { opacity: 1, transition: 'opacity ' + duration + 'ms' },
    exiting: { opacity: 0 },
    exited: { opacity: 0 }
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"],
    { mountOnEnter: true, unmountOnExit: true, 'in': inProp, timeout: duration },
    function (state) {
      var innerProps = {
        style: _extends({}, transition[state])
      };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag, _extends({ innerProps: innerProps }, props));
    }
  );
};
var collapseDuration = 260;

// wrap each MultiValue with a collapse transition; decreases width until
// finally removing from DOM
var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, Collapse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call.apply(_ref2, [this].concat(args))), _this), _this.duration = collapseDuration, _this.state = { width: 'auto' }, _this.transition = {
      exiting: { width: 0, transition: 'width ' + _this.duration + 'ms ease-out' },
      exited: { width: 0 }
    }, _this.getWidth = function (ref) {
      if (ref && isNaN(_this.state.width)) {
        // cannot use `offsetWidth` because it is rounded
        var _ref$getBoundingClien = ref.getBoundingClientRect(),
            _width = _ref$getBoundingClien.width;

        _this.setState({ width: _width });
      }
    }, _this.getStyle = function (width) {
      return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: width
      };
    }, _this.getTransition = function (state) {
      return _this.transition[state];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  // width must be calculated; cannot transition from `undefined` to `number`


  // get base styles


  // get transition styles


  createClass(Collapse, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          inProp = _props.in;
      var width = this.state.width;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"],
        {
          enter: false,
          mountOnEnter: true,
          unmountOnExit: true,
          'in': inProp,
          timeout: this.duration
        },
        function (state) {
          var style = _extends({}, _this2.getStyle(width), _this2.getTransition(state));
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { ref: _this2.getWidth, style: style },
            children
          );
        }
      );
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

// strip transition props off before spreading onto select component
// note we need to be explicit about innerRef for flow
var AnimatedInput = function AnimatedInput(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        appear = _ref.appear,
        enter = _ref.enter,
        exit = _ref.exit,
        innerRef = _ref.innerRef,
        props = objectWithoutProperties(_ref, ['in', 'onExited', 'appear', 'enter', 'exit', 'innerRef']);
    return (
      // $FlowFixMe
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, _extends({ innerRef: innerRef }, props))
    );
  };
};

// strip transition props off before spreading onto actual component


var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        props = objectWithoutProperties(_ref, ['in', 'onExited']);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Collapse,
      { 'in': inProp, onExited: onExited },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, _extends({ cropWithEllipsis: inProp }, props))
    );
  };
};

// fade in when last multi-value removed, otherwise instant
var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Fade, _extends({
      component: WrappedComponent,
      duration: props.isMulti ? collapseDuration : 1
    }, props));
  };
};

// instant fade; all transition-group children must be transitions

var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Fade, _extends({ component: WrappedComponent }, props));
  };
};

// make ValueContainer a transition group
var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["TransitionGroup"], _extends({ component: WrappedComponent }, props));
  };
};

var makeAnimated = function makeAnimated(externalComponents) {
  var components$$1 = defaultComponents({ components: externalComponents });
  var Input = components$$1.Input,
      MultiValue = components$$1.MultiValue,
      Placeholder = components$$1.Placeholder,
      SingleValue = components$$1.SingleValue,
      ValueContainer = components$$1.ValueContainer,
      rest = objectWithoutProperties(components$$1, ['Input', 'MultiValue', 'Placeholder', 'SingleValue', 'ValueContainer']);

  return _extends({
    Input: AnimatedInput(Input),
    MultiValue: AnimatedMultiValue(MultiValue),
    Placeholder: AnimatedPlaceholder(Placeholder),
    SingleValue: AnimatedSingleValue(SingleValue),
    ValueContainer: AnimatedValueContainer(ValueContainer)
  }, rest);
};

var AnimatedComponents = makeAnimated();

var Input$1 = AnimatedComponents.Input;
var MultiValue$1 = AnimatedComponents.MultiValue;
var Placeholder$1 = AnimatedComponents.Placeholder;
var SingleValue$1 = AnimatedComponents.SingleValue;
var ValueContainer$1 = AnimatedComponents.ValueContainer;

var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_memoize_one__["a" /* default */])(makeAnimated, exportedEqual);

var index$1 = manageState(Select);

/* harmony default export */ __webpack_exports__["default"] = (index$1);



/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(1599);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(196);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(1598);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(1600);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(691);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(693);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */
      addClass(node, className);
    }
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(196);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(91);

var _TransitionGroup = __webpack_require__(692);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  in: _propTypes2.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');

    return null;
  }
};

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = function (_React$Component) {
  _inherits(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReplaceTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react2.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  ReplaceTransition.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        inProp = _props.in,
        props = _objectWithoutProperties(_props, ['children', 'in']);

    var _React$Children$toArr = _react2.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;

    return _react2.default.createElement(
      _TransitionGroup2.default,
      props,
      inProp ? _react2.default.cloneElement(first, {
        key: 'first',
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered

      }) : _react2.default.cloneElement(second, {
        key: 'second',
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      })
    );
  };

  return ReplaceTransition;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleEnter = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.handleLifecycle('onEnter', 0, args);
  };

  this.handleEntering = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.handleLifecycle('onEntering', 0, args);
  };

  this.handleEntered = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _this2.handleLifecycle('onEntered', 0, args);
  };

  this.handleExit = function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _this2.handleLifecycle('onExit', 1, args);
  };

  this.handleExiting = function () {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _this2.handleLifecycle('onExiting', 1, args);
  };

  this.handleExited = function () {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _this2.handleLifecycle('onExited', 1, args);
  };
};

ReplaceTransition.propTypes =  false ? propTypes : {};

exports.default = ReplaceTransition;
module.exports = exports['default'];

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(1601);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _ReplaceTransition = __webpack_require__(1602);

var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);

var _TransitionGroup = __webpack_require__(692);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(691);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1605);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);

  Object.keys(children).forEach(function (key) {
    var child = children[key];

    if (!(0, _react.isValidElement)(child)) return;

    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;

    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

    // item is new (entering)
    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, { in: false });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });

  return children;
}

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _exenv = __webpack_require__(1357);

var _exenv2 = _interopRequireDefault(_exenv);

var _shallowequal = __webpack_require__(1631);

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !(0, _shallowequal2.default)(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return _react2.default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(_react.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = _exenv2.default.canUseDOM;


    return SideEffect;
  };
};

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(1610);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(1609);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(694);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(1349);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(1351);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(1353);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(1352);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(91);

var _PropTypes = __webpack_require__(694);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(1339);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(98);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(1611);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var m=__webpack_require__(155),n=__webpack_require__(107),p=__webpack_require__(329),q=__webpack_require__(240),r="function"===typeof Symbol&&Symbol["for"],t=r?Symbol["for"]("react.element"):60103,u=r?Symbol["for"]("react.portal"):60106,v=r?Symbol["for"]("react.fragment"):60107,w=r?Symbol["for"]("react.strict_mode"):60108,x=r?Symbol["for"]("react.provider"):60109,y=r?Symbol["for"]("react.context"):60110,z=r?Symbol["for"]("react.async_mode"):60111,A=r?Symbol["for"]("react.forward_ref"):
60112,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b=arguments.length-1,e="http://reactjs.org/docs/error-decoder.html?invariant\x3d"+a,c=0;c<b;c++)e+="\x26args[]\x3d"+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};
function E(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?C("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||D}var H=G.prototype=new F;
H.constructor=G;m(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J=Object.prototype.hasOwnProperty,K={key:!0,ref:!0,__self:!0,__source:!0};
function L(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var k=Array(f),l=0;l<f;l++)k[l]=arguments[l+2];d.children=k}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:I.current}}
function M(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var N=/\/+/g,O=[];function P(a,b,e,c){if(O.length){var d=O.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function Q(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>O.length&&O.push(a)}
function R(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+S(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+S(d,h);g+=R(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+S(d,h++),g+=R(d,f,e,c);else"object"===d&&(e=""+a,C("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function S(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function T(a,b){a.func.call(a.context,b,a.count++)}
function U(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,e,q.thatReturnsArgument):null!=a&&(M(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(N,"$\x26/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function V(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(N,"$\x26/")+"/");b=P(b,g,c,d);null==a||R(a,"",U,b);Q(b)}
var W={Children:{map:function(a,b,e){if(null==a)return a;var c=[];V(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=P(null,null,b,e);null==a||R(a,"",T,b);Q(b)},count:function(a){return null==a?0:R(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];V(a,b,null,q.thatReturnsArgument);return b},only:function(a){M(a)?void 0:C("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:y,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_changedBits:0,Provider:null,Consumer:null};a.Provider={$$typeof:x,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:A,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:z,createElement:L,cloneElement:function(a,b,e){null===a||void 0===a?C("267",a):void 0;var c=void 0,d=m({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=I.current);void 0!==b.key&&(g=""+b.key);var k=void 0;a.type&&a.type.defaultProps&&
(k=a.type.defaultProps);for(c in b)J.call(b,c)&&!K.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==k?k[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){k=Array(c);for(var l=0;l<c;l++)k[l]=arguments[l+2];d.children=k}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=L.bind(null,a);b.type=a;return b},isValidElement:M,version:"16.3.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:I,assign:m}},X=Object.freeze({default:W}),
Y=X&&W||X;module.exports=Y["default"]?Y["default"]:Y;


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(139);


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(696);

/*<replacement>*/
var util = __webpack_require__(189);
util.inherits = __webpack_require__(90);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(97).Buffer;
/*</replacement>*/

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = reduceReducers;

function reduceReducers() {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (array, callback) {
  return array.reduce(function (partialObject, element) {
    return callback(partialObject, element);
  }, {});
});

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__camelCase__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_identity__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isArray__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_last__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es_isNil__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__createAction__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__arrayToObject__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__flattenUtils__ = __webpack_require__(703);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }














function createActions(actionMap) {
  for (var _len = arguments.length, identityActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    identityActions[_key - 1] = arguments[_key];
  }

  var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_last__["a" /* default */])(identityActions)) ? identityActions.pop() : {};
  __WEBPACK_IMPORTED_MODULE_9_invariant___default()(identityActions.every(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__["a" /* default */]) && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__["a" /* default */])(actionMap) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__["a" /* default */])(actionMap)), 'Expected optional object followed by string action types');
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isString__["a" /* default */])(actionMap)) {
    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions), options);
  }
  return _extends({}, actionCreatorsFromActionMap(actionMap, options), actionCreatorsFromIdentityActions(identityActions, options));
}

function actionCreatorsFromActionMap(actionMap, options) {
  var flatActionMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__flattenUtils__["b" /* flattenActionMap */])(actionMap, options);
  var flatActionCreators = actionMapToActionCreators(flatActionMap);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__flattenUtils__["c" /* unflattenActionCreators */])(flatActionCreators, options);
}

function actionMapToActionCreators(actionMap) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      prefix = _ref.prefix,
      _ref$namespace = _ref.namespace,
      namespace = _ref$namespace === undefined ? __WEBPACK_IMPORTED_MODULE_11__flattenUtils__["d" /* defaultNamespace */] : _ref$namespace;

  function isValidActionMapValue(actionMapValue) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__["a" /* default */])(actionMapValue) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_isNil__["a" /* default */])(actionMapValue)) {
      return true;
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isArray__["a" /* default */])(actionMapValue)) {
      var _actionMapValue = _slicedToArray(actionMapValue, 2),
          _actionMapValue$ = _actionMapValue[0],
          payload = _actionMapValue$ === undefined ? __WEBPACK_IMPORTED_MODULE_1_lodash_es_identity__["a" /* default */] : _actionMapValue$,
          meta = _actionMapValue[1];

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__["a" /* default */])(payload) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isFunction__["a" /* default */])(meta);
    }
    return false;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__arrayToObject__["a" /* default */])(Object.keys(actionMap), function (partialActionCreators, type) {
    var actionMapValue = actionMap[type];
    __WEBPACK_IMPORTED_MODULE_9_invariant___default()(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ('functions for ' + type));
    var prefixedType = prefix ? '' + prefix + namespace + type : type;
    var actionCreator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isArray__["a" /* default */])(actionMapValue) ? __WEBPACK_IMPORTED_MODULE_8__createAction__["a" /* default */].apply(undefined, [prefixedType].concat(_toConsumableArray(actionMapValue))) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__createAction__["a" /* default */])(prefixedType, actionMapValue);
    return _extends({}, partialActionCreators, _defineProperty({}, type, actionCreator));
  });
}

function actionCreatorsFromIdentityActions(identityActions, options) {
  var actionMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__arrayToObject__["a" /* default */])(identityActions, function (partialActionMap, type) {
    return _extends({}, partialActionMap, _defineProperty({}, type, __WEBPACK_IMPORTED_MODULE_1_lodash_es_identity__["a" /* default */]));
  });
  var actionCreators = actionMapToActionCreators(actionMap, options);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__arrayToObject__["a" /* default */])(Object.keys(actionCreators), function (partialActionCreators, type) {
    return _extends({}, partialActionCreators, _defineProperty({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__camelCase__["a" /* default */])(type), actionCreators[type]));
  });
}

/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isMap__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reduce_reducers__ = __webpack_require__(1616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_reduce_reducers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_reduce_reducers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__handleAction__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ownKeys__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__flattenUtils__ = __webpack_require__(703);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }









function get(key, x) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isMap__["a" /* default */])(x) ? x.get(key) : x[key];
}

function handleActions(handlers, defaultState) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(handlers) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isMap__["a" /* default */])(handlers), 'Expected handlers to be a plain object.');
  var flattenedReducerMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__flattenUtils__["a" /* flattenReducerMap */])(handlers, options);
  var reducers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ownKeys__["a" /* default */])(flattenedReducerMap).map(function (type) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__handleAction__["a" /* default */])(type, get(type, flattenedReducerMap), defaultState);
  });
  var reducer = __WEBPACK_IMPORTED_MODULE_2_reduce_reducers___default.a.apply(undefined, _toConsumableArray(reducers));
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];
    return reducer(state, action);
  };
}

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasGeneratorInterface;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownKeys__ = __webpack_require__(349);


function hasGeneratorInterface(handler) {
  var keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ownKeys__["a" /* default */])(handler);
  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
    return ownKey === 'next' || ownKey === 'throw';
  });
  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
}

/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createAction__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__handleAction__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__handleActions__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__combineActions__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createActions__ = __webpack_require__(1618);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createAction", function() { return __WEBPACK_IMPORTED_MODULE_0__createAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createActions", function() { return __WEBPACK_IMPORTED_MODULE_4__createActions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "handleAction", function() { return __WEBPACK_IMPORTED_MODULE_1__handleAction__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "handleActions", function() { return __WEBPACK_IMPORTED_MODULE_2__handleActions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineActions", function() { return __WEBPACK_IMPORTED_MODULE_3__combineActions__["a"]; });








/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AsyncConnect = undefined;

var _extends2 = __webpack_require__(7);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(2);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(5);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RouterContext = __webpack_require__(1587);

var _RouterContext2 = _interopRequireDefault(_RouterContext);

var _utils = __webpack_require__(350);

var _state = __webpack_require__(246);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AsyncConnect = exports.AsyncConnect = function (_Component) {
  (0, _inherits3.default)(AsyncConnect, _Component);

  function AsyncConnect(props, context) {
    (0, _classCallCheck3.default)(this, AsyncConnect);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props, context));

    _this.state = {
      propsToShow: _this.isLoaded() ? props : null
    };

    _this.mounted = false;
    _this.loadDataCounter = 0;
    return _this;
  }

  AsyncConnect.prototype.componentDidMount = function componentDidMount() {
    this.mounted = true;
    var dataLoaded = this.isLoaded();

    // we dont need it if we already made it on server-side
    if (!dataLoaded) {
      this.loadAsyncData(this.props);
    }
  };

  AsyncConnect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    // Allow a user supplied function to determine if an async reload is necessary
    if (this.props.reloadOnPropsChange(this.props, nextProps)) {
      this.loadAsyncData(nextProps);
    }
  };

  AsyncConnect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return this.state.propsToShow !== nextState.propsToShow;
  };

  AsyncConnect.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  AsyncConnect.prototype.isLoaded = function isLoaded() {
    return (0, _state.getMutableState)(this.context.store.getState()).reduxAsyncConnect.loaded;
  };

  AsyncConnect.prototype.loadAsyncData = function loadAsyncData(props) {
    var _this2 = this;

    var store = this.context.store;
    var loadResult = (0, _utils.loadAsyncConnect)((0, _extends3.default)({}, props, { store: store }));

    // TODO: think of a better solution to a problem?
    this.loadDataCounter += 1;
    this.props.beginGlobalLoad();
    return function (loadDataCounterOriginal) {
      return loadResult.then(function () {
        // We need to change propsToShow only if loadAsyncData that called this promise
        // is the last invocation of loadAsyncData method. Otherwise we can face a situation
        // when user is changing route several times and we finally show him route that has
        // loaded props last time and not the last called route
        if (_this2.loadDataCounter === loadDataCounterOriginal && _this2.mounted !== false) {
          _this2.setState({ propsToShow: props });
        }

        // TODO: investigate race conditions
        // do we need to call this if it's not last invocation?
        _this2.props.endGlobalLoad();
      });
    }(this.loadDataCounter);
  };

  AsyncConnect.prototype.render = function render() {
    var propsToShow = this.state.propsToShow;

    return propsToShow && this.props.render(propsToShow);
  };

  return AsyncConnect;
}(_react.Component);

AsyncConnect.contextTypes = {
  store: _propTypes2.default.object.isRequired
};
AsyncConnect.defaultProps = {
  helpers: {},
  reloadOnPropsChange: function reloadOnPropsChange() {
    return true;
  },
  render: function render(props) {
    return _react2.default.createElement(_RouterContext2.default, props);
  }
};
exports.default = AsyncConnect;

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _reactRedux = __webpack_require__(17);

var _AsyncConnect = __webpack_require__(1622);

var _store = __webpack_require__(247);

exports.default = (0, _reactRedux.connect)(null, { beginGlobalLoad: _store.beginGlobalLoad, endGlobalLoad: _store.endGlobalLoad })(_AsyncConnect.AsyncConnect);

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends3 = __webpack_require__(7);

var _extends4 = _interopRequireDefault(_extends3);

exports.asyncConnect = asyncConnect;

var _reactRedux = __webpack_require__(17);

var _utils = __webpack_require__(350);

var _store = __webpack_require__(247);

var _state = __webpack_require__(246);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wraps react components with data loaders
 * @param  {Array} asyncItems
 * @return {WrappedComponent}
 */
function wrapWithDispatch(asyncItems) {
  return asyncItems.map(function (item) {
    var key = item.key;
    if (!key) {
      return item;
    }

    return (0, _extends4.default)({}, item, {
      promise: function promise(options) {
        var dispatch = options.store.dispatch;

        var next = item.promise(options);

        // NOTE: possibly refactor this with a breaking change in mind for future versions
        // we can return result of processed promise/thunk if need be
        if ((0, _utils.isPromise)(next)) {
          dispatch((0, _store.load)(key));
          // add action dispatchers
          next.then(function (data) {
            return dispatch((0, _store.loadSuccess)(key, data));
          }).catch(function (err) {
            return dispatch((0, _store.loadFail)(key, err));
          });
        } else if (next) {
          dispatch((0, _store.loadSuccess)(key, next));
        }

        return next;
      }
    });
  });
}

/**
 * Exports decorator, which wraps React components with asyncConnect and connect at the same time
 * @param  {Array} asyncItems
 * @param  {Function} [mapStateToProps]
 * @param  {Object|Function} [mapDispatchToProps]
 * @param  {Function} [mergeProps]
 * @param  {Object} [options]
 * @return {Function}
 */
function asyncConnect(asyncItems, mapStateToProps, mapDispatchToProps, mergeProps, options) {
  return function (Component) {
    Component.reduxAsyncConnect = wrapWithDispatch(asyncItems);

    var finalMapStateToProps = function finalMapStateToProps(state, ownProps) {
      var mutableState = (0, _state.getMutableState)(state);
      var asyncStateToProps = asyncItems.reduce(function (result, _ref) {
        var _extends2;

        var key = _ref.key;

        if (!key) {
          return result;
        }

        return (0, _extends4.default)({}, result, (_extends2 = {}, _extends2[key] = mutableState.reduxAsyncConnect[key], _extends2));
      }, {});

      if (typeof mapStateToProps !== 'function') {
        return asyncStateToProps;
      }

      return (0, _extends4.default)({}, mapStateToProps((0, _state.getImmutableState)(mutableState), ownProps), asyncStateToProps);
    };

    return (0, _reactRedux.connect)(finalMapStateToProps, mapDispatchToProps, mergeProps, options)(Component);
  };
}

// convinience export
exports.default = asyncConnect;

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.composeWithDevTools = (
   false ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      var compose = __webpack_require__(112).compose;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(705);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(707);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function ReInterval (callback, interval, args) {
  var self = this;

  this._callback = callback;
  this._args = args;

  this._interval = setInterval(callback, interval, this._args);

  this.reschedule = function (interval) {
    // if no interval entered, use the interval passed in on creation
    if (!interval)
      interval = self._interval;

    if (self._interval)
      clearInterval(self._interval);
    self._interval = setInterval(self._callback, interval, self._args);
  };

  this.clear = function () {
    if (self._interval) {
      clearInterval(self._interval);
      self._interval = undefined;
    }
  };
  
  this.destroy = function () {
    if (self._interval) {
      clearInterval(self._interval);
    }
    self._callback = undefined;
    self._interval = undefined;
    self._args = undefined;
  };
}

function reInterval () {
  if (typeof arguments[0] !== 'function')
    throw new Error('callback needed');
  if (typeof arguments[1] !== 'number')
    throw new Error('interval needed');

  var args;

  if (arguments.length > 0) {
    args = new Array(arguments.length - 2);

    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i + 2];
    }
  }

  return new ReInterval(arguments[0], arguments[1], args);
}

module.exports = reInterval;


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30), __webpack_require__(59)))

/***/ }),
/* 1631 */
/***/ (function(module, exports) {

module.exports = function shallowEqual(objA, objB, compare, compareContext) {

    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

    if(ret !== void 0) {
        return !!ret;
    }

    if(objA === objB) {
        return true;
    }

    if(typeof objA !== 'object' || !objA ||
       typeof objB !== 'object' || !objB) {
        return false;
    }

    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);

    if(keysA.length !== keysB.length) {
        return false;
    }

    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++) {

        var key = keysA[idx];

        if(!bHasOwnProperty(key)) {
            return false;
        }

        var valueA = objA[key];
        var valueB = objB[key];

        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

        if(ret === false ||
           ret === void 0 && valueA !== valueB) {
            return false;
        }

    }

    return true;

};


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
  }
  /* istanbul ignore next */
  else if (typeof define === 'function' && define.amd) {
    define(factory)
  }
  else {
    root[name] = factory()
  }
}('slugify', this, function () {
  /*eslint-disable */
  var charMap = JSON.parse('{"$":"dollar","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","џ":"dz","Ґ":"G","ґ":"g","฿":"baht","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₹":"indian rupee","₽":"russian ruble","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial"}')
  /*eslint-enable */

  function replace (string, options) {
    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    string = string.split('')
      .reduce(function (result, ch) {
        if (charMap[ch]) {
          ch = charMap[ch]
        }
        // allowed
        ch = ch.replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]/g, '')
        result += ch
        return result
      }, '')
      // trim leading/trailing spaces
      .replace(/^\s+|\s+$/g, '')
      // convert spaces
      .replace(/[-\s]+/g, options.replacement || '-')
      // remove trailing separator
      .replace('#{replacement}$', '')

    return options.lower ? string.toLowerCase() : string
  }

  replace.extend = function (customMap) {
    for (var key in customMap) {
      charMap[key] = customMap[key]
    }
  }

  return replace
}))


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

/* smoothscroll v0.4.0 - 2018 - Dustan Kasten, Jeremias Menichelli - MIT License */
(function () {
  'use strict';

  // polyfill
  function polyfill() {
    // aliases
    var w = window;
    var d = document;

    // return if scroll behavior is supported and polyfill is not forced
    if (
      'scrollBehavior' in d.documentElement.style &&
      w.__forceSmoothScrollPolyfill__ !== true
    ) {
      return;
    }

    // globals
    var Element = w.HTMLElement || w.Element;
    var SCROLL_TIME = 468;

    // object gathering original scroll methods
    var original = {
      scroll: w.scroll || w.scrollTo,
      scrollBy: w.scrollBy,
      elementScroll: Element.prototype.scroll || scrollElement,
      scrollIntoView: Element.prototype.scrollIntoView
    };

    // define timing method
    var now =
      w.performance && w.performance.now
        ? w.performance.now.bind(w.performance)
        : Date.now;

    /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */
    function isMicrosoftBrowser(userAgent) {
      var userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/'];

      return new RegExp(userAgentPatterns.join('|')).test(userAgent);
    }

    /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */
    var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;

    /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function scrollElement(x, y) {
      this.scrollLeft = x;
      this.scrollTop = y;
    }

    /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */
    function ease(k) {
      return 0.5 * (1 - Math.cos(Math.PI * k));
    }

    /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */
    function shouldBailOut(firstArg) {
      if (
        firstArg === null ||
        typeof firstArg !== 'object' ||
        firstArg.behavior === undefined ||
        firstArg.behavior === 'auto' ||
        firstArg.behavior === 'instant'
      ) {
        // first argument is not an object/null
        // or behavior is auto, instant or undefined
        return true;
      }

      if (typeof firstArg === 'object' && firstArg.behavior === 'smooth') {
        // first argument is an object and behavior is smooth
        return false;
      }

      // throw error when behavior is not supported
      throw new TypeError(
        'behavior member of ScrollOptions ' +
          firstArg.behavior +
          ' is not a valid value for enumeration ScrollBehavior.'
      );
    }

    /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function hasScrollableSpace(el, axis) {
      if (axis === 'Y') {
        return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
      }

      if (axis === 'X') {
        return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
      }
    }

    /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function canOverflow(el, axis) {
      var overflowValue = w.getComputedStyle(el, null)['overflow' + axis];

      return overflowValue === 'auto' || overflowValue === 'scroll';
    }

    /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */
    function isScrollable(el) {
      var isScrollableY = hasScrollableSpace(el, 'Y') && canOverflow(el, 'Y');
      var isScrollableX = hasScrollableSpace(el, 'X') && canOverflow(el, 'X');

      return isScrollableY || isScrollableX;
    }

    /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */
    function findScrollableParent(el) {
      var isBody;

      do {
        el = el.parentNode;

        isBody = el === d.body;
      } while (isBody === false && isScrollable(el) === false);

      isBody = null;

      return el;
    }

    /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */
    function step(context) {
      var time = now();
      var value;
      var currentX;
      var currentY;
      var elapsed = (time - context.startTime) / SCROLL_TIME;

      // avoid elapsed times higher than one
      elapsed = elapsed > 1 ? 1 : elapsed;

      // apply easing to elapsed time
      value = ease(elapsed);

      currentX = context.startX + (context.x - context.startX) * value;
      currentY = context.startY + (context.y - context.startY) * value;

      context.method.call(context.scrollable, currentX, currentY);

      // scroll more if we have not reached our destination
      if (currentX !== context.x || currentY !== context.y) {
        w.requestAnimationFrame(step.bind(w, context));
      }
    }

    /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */
    function smoothScroll(el, x, y) {
      var scrollable;
      var startX;
      var startY;
      var method;
      var startTime = now();

      // define scroll context
      if (el === d.body) {
        scrollable = w;
        startX = w.scrollX || w.pageXOffset;
        startY = w.scrollY || w.pageYOffset;
        method = original.scroll;
      } else {
        scrollable = el;
        startX = el.scrollLeft;
        startY = el.scrollTop;
        method = scrollElement;
      }

      // scroll looping over a frame
      step({
        scrollable: scrollable,
        method: method,
        startTime: startTime,
        startX: startX,
        startY: startY,
        x: x,
        y: y
      });
    }

    // ORIGINAL METHODS OVERRIDES
    // w.scroll and w.scrollTo
    w.scroll = w.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scroll.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object'
              ? arguments[0]
              : w.scrollX || w.pageXOffset,
          // use top prop, second argument if present or fallback to scrollY
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined
              ? arguments[1]
              : w.scrollY || w.pageYOffset
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        arguments[0].left !== undefined
          ? ~~arguments[0].left
          : w.scrollX || w.pageXOffset,
        arguments[0].top !== undefined
          ? ~~arguments[0].top
          : w.scrollY || w.pageYOffset
      );
    };

    // w.scrollBy
    w.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0])) {
        original.scrollBy.call(
          w,
          arguments[0].left !== undefined
            ? arguments[0].left
            : typeof arguments[0] !== 'object' ? arguments[0] : 0,
          arguments[0].top !== undefined
            ? arguments[0].top
            : arguments[1] !== undefined ? arguments[1] : 0
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        w,
        d.body,
        ~~arguments[0].left + (w.scrollX || w.pageXOffset),
        ~~arguments[0].top + (w.scrollY || w.pageYOffset)
      );
    };

    // Element.prototype.scroll and Element.prototype.scrollTo
    Element.prototype.scroll = Element.prototype.scrollTo = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        // if one number is passed, throw error to match Firefox implementation
        if (typeof arguments[0] === 'number' && arguments[1] === undefined) {
          throw new SyntaxError('Value could not be converted');
        }

        original.elementScroll.call(
          this,
          // use left prop, first number argument or fallback to scrollLeft
          arguments[0].left !== undefined
            ? ~~arguments[0].left
            : typeof arguments[0] !== 'object' ? ~~arguments[0] : this.scrollLeft,
          // use top prop, second argument or fallback to scrollTop
          arguments[0].top !== undefined
            ? ~~arguments[0].top
            : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop
        );

        return;
      }

      var left = arguments[0].left;
      var top = arguments[0].top;

      // LET THE SMOOTHNESS BEGIN!
      smoothScroll.call(
        this,
        this,
        typeof left === 'undefined' ? this.scrollLeft : ~~left,
        typeof top === 'undefined' ? this.scrollTop : ~~top
      );
    };

    // Element.prototype.scrollBy
    Element.prototype.scrollBy = function() {
      // avoid action when no arguments are passed
      if (arguments[0] === undefined) {
        return;
      }

      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.elementScroll.call(
          this,
          arguments[0].left !== undefined
            ? ~~arguments[0].left + this.scrollLeft
            : ~~arguments[0] + this.scrollLeft,
          arguments[0].top !== undefined
            ? ~~arguments[0].top + this.scrollTop
            : ~~arguments[1] + this.scrollTop
        );

        return;
      }

      this.scroll({
        left: ~~arguments[0].left + this.scrollLeft,
        top: ~~arguments[0].top + this.scrollTop,
        behavior: arguments[0].behavior
      });
    };

    // Element.prototype.scrollIntoView
    Element.prototype.scrollIntoView = function() {
      // avoid smooth behavior if not required
      if (shouldBailOut(arguments[0]) === true) {
        original.scrollIntoView.call(
          this,
          arguments[0] === undefined ? true : arguments[0]
        );

        return;
      }

      // LET THE SMOOTHNESS BEGIN!
      var scrollableParent = findScrollableParent(this);
      var parentRects = scrollableParent.getBoundingClientRect();
      var clientRects = this.getBoundingClientRect();

      if (scrollableParent !== d.body) {
        // reveal element inside parent
        smoothScroll.call(
          this,
          scrollableParent,
          scrollableParent.scrollLeft + clientRects.left - parentRects.left,
          scrollableParent.scrollTop + clientRects.top - parentRects.top
        );

        // reveal parent in viewport unless is fixed
        if (w.getComputedStyle(scrollableParent).position !== 'fixed') {
          w.scrollBy({
            left: parentRects.left,
            top: parentRects.top,
            behavior: 'smooth'
          });
        }
      } else {
        // reveal element in viewport
        w.scrollBy({
          left: clientRects.left,
          top: clientRects.top,
          behavior: 'smooth'
        });
      }
    };
  }

  if (true) {
    // commonjs
    module.exports = { polyfill: polyfill };
  } else {
    // global
    polyfill();
  }

}());


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.byMatching = byMatching;
exports.getWidgetValue = getWidgetValue;
exports.getWidgetValues = getWidgetValues;
exports.isTextAreaWidget = isTextAreaWidget;
exports.getPrimaryMediaWidget = getPrimaryMediaWidget;
exports.getPrimaryMediaWidgetId = getPrimaryMediaWidgetId;
exports.getBodyWidgets = getBodyWidgets;
exports.getMediaWidgets = getMediaWidgets;
exports.makeWidget = makeWidget;
exports.spreadWidget = spreadWidget;

var _mediaTypes = __webpack_require__(708);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function widgetMatches(widget, tests) {
  var matches = true;

  if (tests.hasOwnProperty("type")) {
    matches = matches && widget.widget_type == tests.type;
  }

  if (tests.hasOwnProperty("key")) {
    if (tests.hasOwnProperty("value")) {
      matches = matches && widget.keys.some(function (k) {
        return k.key == tests.key && "" + k.value == "" + tests.value;
      });
    } else {
      matches = matches && widget.keys.some(function (k) {
        return k.key == tests.key;
      });
    }
  }

  return matches;
}

function byValue(key) {
  var cast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (i) {
    return i;
  };

  return function () {
    for (var _len = arguments.length, widgets = Array(_len), _key = 0; _key < _len; _key++) {
      widgets[_key] = arguments[_key];
    }

    var _widgets$map = widgets.map(function (w) {
      return cast(getWidgetValue(w, key));
    }),
        _widgets$map2 = _slicedToArray(_widgets$map, 2),
        a = _widgets$map2[0],
        b = _widgets$map2[1];

    if (a > b) {
      return 1;
    } else if (a < b) {
      return -1;
    }

    return 0;
  };
}

function byMatching() {
  for (var _len2 = arguments.length, tests = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    tests[_key2] = arguments[_key2];
  }

  return function (widget) {
    return widget && tests.reduce(function (matches, test) {
      return matches || widgetMatches(widget, test);
    }, false);
  };
}

function getWidgetValue(widget, key) {
  var _widget$keys$filter = widget.keys.filter(function (k) {
    return k.key == key;
  }),
      _widget$keys$filter2 = _slicedToArray(_widget$keys$filter, 1),
      _widget$keys$filter2$ = _widget$keys$filter2[0];

  _widget$keys$filter2$ = _widget$keys$filter2$ === undefined ? {} : _widget$keys$filter2$;
  var value = _widget$keys$filter2$.value;

  return value;
}

function getWidgetValues(widget, keys) {
  return widget.keys.reduce(function (o, _ref) {
    var key = _ref.key,
        value = _ref.value;
    return keys.includes(key) ? _extends({}, o, _defineProperty({}, key, value)) : o;
  }, {});
}

function isTextAreaWidget(widget) {
  return widgetMatches(widget, { type: "TextArea" });
}

function getPrimaryMediaWidget(widgets) {
  var _widgets$filter = widgets.filter(byMatching({ key: "primary", value: true })),
      _widgets$filter2 = _slicedToArray(_widgets$filter, 1),
      primaryImage = _widgets$filter2[0];

  return primaryImage;
}

function getPrimaryMediaWidgetId(widgets) {
  var primaryImageWidget = getPrimaryMediaWidget(widgets);

  if (primaryImageWidget) {
    return getWidgetValue(primaryImageWidget, "media_id");
  }
}

function getBodyWidgets(widgets) {
  // two filter tests to catch legacy content
  return widgets.filter(byMatching({ type: "TextArea" }, /* or */{ key: "body", value: "true" })).sort(byValue("order", parseInt));
}

function getMediaWidgets(widgets) {
  // two tests to catch legacy content
  return widgets.filter(byMatching({ type: _mediaTypes.VIDEO }, { type: _mediaTypes.IMAGE }, /* or */{ key: "media", value: "true" }));
}

function makeWidget(type, properties) {
  // only those properties that have defined values
  function _hasValue(list, key) {
    var val = properties[key];
    if (val !== undefined) {
      return [].concat(_toConsumableArray(list), [{ key: key, value: "" + val }]);
    } else {
      return list;
    }
  }

  return {
    widget_type: type,
    keys: Object.keys(properties).reduce(_hasValue, [])
  };
}

function spreadWidget(widget) {
  if (!widget) {
    return {};
  }

  return (widget.keys || []).reduce(function (accumulator, _ref2) {
    var key = _ref2.key,
        value = _ref2.value;

    return _extends({}, accumulator, _defineProperty({}, key, value));
  }, { widget_type: widget.widget_type });
}

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

// Generated by tools/gen_submodule.js 
module['exports'] = __webpack_require__(708);

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

var engine = __webpack_require__(1639)

var storages = __webpack_require__(1640)
var plugins = [__webpack_require__(1637)]

module.exports = engine.createStore(storages, plugins)


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = json2Plugin

function json2Plugin() {
	__webpack_require__(1638)
	return {}
}


/***/ }),
/* 1638 */
/***/ (function(module, exports) {

/* eslint-disable */

//  json2.js
//  2016-10-28
//  Public Domain.
//  NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
//  See http://www.JSON.org/js.html
//  This code should be minified before deployment.
//  See http://javascript.crockford.com/jsmin.html

//  USE YOUR OWN COPY. IT IS EXTREMELY UNWISE TO LOAD CODE FROM SERVERS YOU DO
//  NOT CONTROL.

//  This file creates a global JSON object containing two methods: stringify
//  and parse. This file provides the ES5 JSON capability to ES3 systems.
//  If a project might run on IE8 or earlier, then this file should be included.
//  This file does nothing on ES5 systems.

//      JSON.stringify(value, replacer, space)
//          value       any JavaScript value, usually an object or array.
//          replacer    an optional parameter that determines how object
//                      values are stringified for objects. It can be a
//                      function or an array of strings.
//          space       an optional parameter that specifies the indentation
//                      of nested structures. If it is omitted, the text will
//                      be packed without extra whitespace. If it is a number,
//                      it will specify the number of spaces to indent at each
//                      level. If it is a string (such as "\t" or "&nbsp;"),
//                      it contains the characters used to indent at each level.
//          This method produces a JSON text from a JavaScript value.
//          When an object value is found, if the object contains a toJSON
//          method, its toJSON method will be called and the result will be
//          stringified. A toJSON method does not serialize: it returns the
//          value represented by the name/value pair that should be serialized,
//          or undefined if nothing should be serialized. The toJSON method
//          will be passed the key associated with the value, and this will be
//          bound to the value.

//          For example, this would serialize Dates as ISO strings.

//              Date.prototype.toJSON = function (key) {
//                  function f(n) {
//                      // Format integers to have at least two digits.
//                      return (n < 10)
//                          ? "0" + n
//                          : n;
//                  }
//                  return this.getUTCFullYear()   + "-" +
//                       f(this.getUTCMonth() + 1) + "-" +
//                       f(this.getUTCDate())      + "T" +
//                       f(this.getUTCHours())     + ":" +
//                       f(this.getUTCMinutes())   + ":" +
//                       f(this.getUTCSeconds())   + "Z";
//              };

//          You can provide an optional replacer method. It will be passed the
//          key and value of each member, with this bound to the containing
//          object. The value that is returned from your method will be
//          serialized. If your method returns undefined, then the member will
//          be excluded from the serialization.

//          If the replacer parameter is an array of strings, then it will be
//          used to select the members to be serialized. It filters the results
//          such that only members with keys listed in the replacer array are
//          stringified.

//          Values that do not have JSON representations, such as undefined or
//          functions, will not be serialized. Such values in objects will be
//          dropped; in arrays they will be replaced with null. You can use
//          a replacer function to replace those with JSON values.

//          JSON.stringify(undefined) returns undefined.

//          The optional space parameter produces a stringification of the
//          value that is filled with line breaks and indentation to make it
//          easier to read.

//          If the space parameter is a non-empty string, then that string will
//          be used for indentation. If the space parameter is a number, then
//          the indentation will be that many spaces.

//          Example:

//          text = JSON.stringify(["e", {pluribus: "unum"}]);
//          // text is '["e",{"pluribus":"unum"}]'

//          text = JSON.stringify(["e", {pluribus: "unum"}], null, "\t");
//          // text is '[\n\t"e",\n\t{\n\t\t"pluribus": "unum"\n\t}\n]'

//          text = JSON.stringify([new Date()], function (key, value) {
//              return this[key] instanceof Date
//                  ? "Date(" + this[key] + ")"
//                  : value;
//          });
//          // text is '["Date(---current time---)"]'

//      JSON.parse(text, reviver)
//          This method parses a JSON text to produce an object or array.
//          It can throw a SyntaxError exception.

//          The optional reviver parameter is a function that can filter and
//          transform the results. It receives each of the keys and values,
//          and its return value is used instead of the original value.
//          If it returns what it received, then the structure is not modified.
//          If it returns undefined then the member is deleted.

//          Example:

//          // Parse the text. Values that look like ISO date strings will
//          // be converted to Date objects.

//          myData = JSON.parse(text, function (key, value) {
//              var a;
//              if (typeof value === "string") {
//                  a =
//   /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)Z$/.exec(value);
//                  if (a) {
//                      return new Date(Date.UTC(+a[1], +a[2] - 1, +a[3], +a[4],
//                          +a[5], +a[6]));
//                  }
//              }
//              return value;
//          });

//          myData = JSON.parse('["Date(09/09/2001)"]', function (key, value) {
//              var d;
//              if (typeof value === "string" &&
//                      value.slice(0, 5) === "Date(" &&
//                      value.slice(-1) === ")") {
//                  d = new Date(value.slice(5, -1));
//                  if (d) {
//                      return d;
//                  }
//              }
//              return value;
//          });

//  This is a reference implementation. You are free to copy, modify, or
//  redistribute.

/*jslint
    eval, for, this
*/

/*property
    JSON, apply, call, charCodeAt, getUTCDate, getUTCFullYear, getUTCHours,
    getUTCMinutes, getUTCMonth, getUTCSeconds, hasOwnProperty, join,
    lastIndex, length, parse, prototype, push, replace, slice, stringify,
    test, toJSON, toString, valueOf
*/


// Create a JSON object only if one does not already exist. We create the
// methods in a closure to avoid creating global variables.

if (typeof JSON !== "object") {
    JSON = {};
}

(function () {
    "use strict";

    var rx_one = /^[\],:{}\s]*$/;
    var rx_two = /\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g;
    var rx_three = /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
    var rx_four = /(?:^|:|,)(?:\s*\[)+/g;
    var rx_escapable = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    var rx_dangerous = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;

    function f(n) {
        // Format integers to have at least two digits.
        return n < 10
            ? "0" + n
            : n;
    }

    function this_value() {
        return this.valueOf();
    }

    if (typeof Date.prototype.toJSON !== "function") {

        Date.prototype.toJSON = function () {

            return isFinite(this.valueOf())
                ? this.getUTCFullYear() + "-" +
                        f(this.getUTCMonth() + 1) + "-" +
                        f(this.getUTCDate()) + "T" +
                        f(this.getUTCHours()) + ":" +
                        f(this.getUTCMinutes()) + ":" +
                        f(this.getUTCSeconds()) + "Z"
                : null;
        };

        Boolean.prototype.toJSON = this_value;
        Number.prototype.toJSON = this_value;
        String.prototype.toJSON = this_value;
    }

    var gap;
    var indent;
    var meta;
    var rep;


    function quote(string) {

// If the string contains no control characters, no quote characters, and no
// backslash characters, then we can safely slap some quotes around it.
// Otherwise we must also replace the offending characters with safe escape
// sequences.

        rx_escapable.lastIndex = 0;
        return rx_escapable.test(string)
            ? "\"" + string.replace(rx_escapable, function (a) {
                var c = meta[a];
                return typeof c === "string"
                    ? c
                    : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
            }) + "\""
            : "\"" + string + "\"";
    }


    function str(key, holder) {

// Produce a string from holder[key].

        var i;          // The loop counter.
        var k;          // The member key.
        var v;          // The member value.
        var length;
        var mind = gap;
        var partial;
        var value = holder[key];

// If the value has a toJSON method, call it to obtain a replacement value.

        if (value && typeof value === "object" &&
                typeof value.toJSON === "function") {
            value = value.toJSON(key);
        }

// If we were called with a replacer function, then call the replacer to
// obtain a replacement value.

        if (typeof rep === "function") {
            value = rep.call(holder, key, value);
        }

// What happens next depends on the value's type.

        switch (typeof value) {
        case "string":
            return quote(value);

        case "number":

// JSON numbers must be finite. Encode non-finite numbers as null.

            return isFinite(value)
                ? String(value)
                : "null";

        case "boolean":
        case "null":

// If the value is a boolean or null, convert it to a string. Note:
// typeof null does not produce "null". The case is included here in
// the remote chance that this gets fixed someday.

            return String(value);

// If the type is "object", we might be dealing with an object or an array or
// null.

        case "object":

// Due to a specification blunder in ECMAScript, typeof null is "object",
// so watch out for that case.

            if (!value) {
                return "null";
            }

// Make an array to hold the partial results of stringifying this object value.

            gap += indent;
            partial = [];

// Is the value an array?

            if (Object.prototype.toString.apply(value) === "[object Array]") {

// The value is an array. Stringify every element. Use null as a placeholder
// for non-JSON values.

                length = value.length;
                for (i = 0; i < length; i += 1) {
                    partial[i] = str(i, value) || "null";
                }

// Join all of the elements together, separated with commas, and wrap them in
// brackets.

                v = partial.length === 0
                    ? "[]"
                    : gap
                        ? "[\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "]"
                        : "[" + partial.join(",") + "]";
                gap = mind;
                return v;
            }

// If the replacer is an array, use it to select the members to be stringified.

            if (rep && typeof rep === "object") {
                length = rep.length;
                for (i = 0; i < length; i += 1) {
                    if (typeof rep[i] === "string") {
                        k = rep[i];
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (
                                gap
                                    ? ": "
                                    : ":"
                            ) + v);
                        }
                    }
                }
            } else {

// Otherwise, iterate through all of the keys in the object.

                for (k in value) {
                    if (Object.prototype.hasOwnProperty.call(value, k)) {
                        v = str(k, value);
                        if (v) {
                            partial.push(quote(k) + (
                                gap
                                    ? ": "
                                    : ":"
                            ) + v);
                        }
                    }
                }
            }

// Join all of the member texts together, separated with commas,
// and wrap them in braces.

            v = partial.length === 0
                ? "{}"
                : gap
                    ? "{\n" + gap + partial.join(",\n" + gap) + "\n" + mind + "}"
                    : "{" + partial.join(",") + "}";
            gap = mind;
            return v;
        }
    }

// If the JSON object does not yet have a stringify method, give it one.

    if (typeof JSON.stringify !== "function") {
        meta = {    // table of character substitutions
            "\b": "\\b",
            "\t": "\\t",
            "\n": "\\n",
            "\f": "\\f",
            "\r": "\\r",
            "\"": "\\\"",
            "\\": "\\\\"
        };
        JSON.stringify = function (value, replacer, space) {

// The stringify method takes a value and an optional replacer, and an optional
// space parameter, and returns a JSON text. The replacer can be a function
// that can replace values, or an array of strings that will select the keys.
// A default replacer method can be provided. Use of the space parameter can
// produce text that is more easily readable.

            var i;
            gap = "";
            indent = "";

// If the space parameter is a number, make an indent string containing that
// many spaces.

            if (typeof space === "number") {
                for (i = 0; i < space; i += 1) {
                    indent += " ";
                }

// If the space parameter is a string, it will be used as the indent string.

            } else if (typeof space === "string") {
                indent = space;
            }

// If there is a replacer, it must be a function or an array.
// Otherwise, throw an error.

            rep = replacer;
            if (replacer && typeof replacer !== "function" &&
                    (typeof replacer !== "object" ||
                    typeof replacer.length !== "number")) {
                throw new Error("JSON.stringify");
            }

// Make a fake root object containing our value under the key of "".
// Return the result of stringifying the value.

            return str("", {"": value});
        };
    }


// If the JSON object does not yet have a parse method, give it one.

    if (typeof JSON.parse !== "function") {
        JSON.parse = function (text, reviver) {

// The parse method takes a text and an optional reviver function, and returns
// a JavaScript value if the text is a valid JSON text.

            var j;

            function walk(holder, key) {

// The walk method is used to recursively walk the resulting structure so
// that modifications can be made.

                var k;
                var v;
                var value = holder[key];
                if (value && typeof value === "object") {
                    for (k in value) {
                        if (Object.prototype.hasOwnProperty.call(value, k)) {
                            v = walk(value, k);
                            if (v !== undefined) {
                                value[k] = v;
                            } else {
                                delete value[k];
                            }
                        }
                    }
                }
                return reviver.call(holder, key, value);
            }


// Parsing happens in four stages. In the first stage, we replace certain
// Unicode characters with escape sequences. JavaScript handles many characters
// incorrectly, either silently deleting them, or treating them as line endings.

            text = String(text);
            rx_dangerous.lastIndex = 0;
            if (rx_dangerous.test(text)) {
                text = text.replace(rx_dangerous, function (a) {
                    return "\\u" +
                            ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
                });
            }

// In the second stage, we run the text against regular expressions that look
// for non-JSON patterns. We are especially concerned with "()" and "new"
// because they can cause invocation, and "=" because it can cause mutation.
// But just to be safe, we want to reject all unexpected forms.

// We split the second stage into 4 regexp operations in order to work around
// crippling inefficiencies in IE's and Safari's regexp engines. First we
// replace the JSON backslash pairs with "@" (a non-JSON character). Second, we
// replace all simple value tokens with "]" characters. Third, we delete all
// open brackets that follow a colon or comma or that begin the text. Finally,
// we look to see that the remaining characters are only whitespace or "]" or
// "," or ":" or "{" or "}". If that is so, then the text is safe for eval.

            if (
                rx_one.test(
                    text
                        .replace(rx_two, "@")
                        .replace(rx_three, "]")
                        .replace(rx_four, "")
                )
            ) {

// In the third stage we use the eval function to compile the text into a
// JavaScript structure. The "{" operator is subject to a syntactic ambiguity
// in JavaScript: it can begin a block or an object literal. We wrap the text
// in parens to eliminate the ambiguity.

                j = eval("(" + text + ")");

// In the optional fourth stage, we recursively walk the new structure, passing
// each name/value pair to a reviver function for possible transformation.

                return (typeof reviver === "function")
                    ? walk({"": j}, "")
                    : j;
            }

// If the text is not JSON parseable, then a SyntaxError is thrown.

            throw new SyntaxError("JSON.parse");
        };
    }
}());

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(160)
var slice = util.slice
var pluck = util.pluck
var each = util.each
var bind = util.bind
var create = util.create
var isList = util.isList
var isFunction = util.isFunction
var isObject = util.isObject

module.exports = {
	createStore: createStore
}

var storeAPI = {
	version: '2.0.12',
	enabled: false,
	
	// get returns the value of the given key. If that value
	// is undefined, it returns optionalDefaultValue instead.
	get: function(key, optionalDefaultValue) {
		var data = this.storage.read(this._namespacePrefix + key)
		return this._deserialize(data, optionalDefaultValue)
	},

	// set will store the given value at key and returns value.
	// Calling set with value === undefined is equivalent to calling remove.
	set: function(key, value) {
		if (value === undefined) {
			return this.remove(key)
		}
		this.storage.write(this._namespacePrefix + key, this._serialize(value))
		return value
	},

	// remove deletes the key and value stored at the given key.
	remove: function(key) {
		this.storage.remove(this._namespacePrefix + key)
	},

	// each will call the given callback once for each key-value pair
	// in this store.
	each: function(callback) {
		var self = this
		this.storage.each(function(val, namespacedKey) {
			callback.call(self, self._deserialize(val), (namespacedKey || '').replace(self._namespaceRegexp, ''))
		})
	},

	// clearAll will remove all the stored key-value pairs in this store.
	clearAll: function() {
		this.storage.clearAll()
	},

	// additional functionality that can't live in plugins
	// ---------------------------------------------------

	// hasNamespace returns true if this store instance has the given namespace.
	hasNamespace: function(namespace) {
		return (this._namespacePrefix == '__storejs_'+namespace+'_')
	},

	// createStore creates a store.js instance with the first
	// functioning storage in the list of storage candidates,
	// and applies the the given mixins to the instance.
	createStore: function() {
		return createStore.apply(this, arguments)
	},
	
	addPlugin: function(plugin) {
		this._addPlugin(plugin)
	},
	
	namespace: function(namespace) {
		return createStore(this.storage, this.plugins, namespace)
	}
}

function _warn() {
	var _console = (typeof console == 'undefined' ? null : console)
	if (!_console) { return }
	var fn = (_console.warn ? _console.warn : _console.log)
	fn.apply(_console, arguments)
}

function createStore(storages, plugins, namespace) {
	if (!namespace) {
		namespace = ''
	}
	if (storages && !isList(storages)) {
		storages = [storages]
	}
	if (plugins && !isList(plugins)) {
		plugins = [plugins]
	}

	var namespacePrefix = (namespace ? '__storejs_'+namespace+'_' : '')
	var namespaceRegexp = (namespace ? new RegExp('^'+namespacePrefix) : null)
	var legalNamespaces = /^[a-zA-Z0-9_\-]*$/ // alpha-numeric + underscore and dash
	if (!legalNamespaces.test(namespace)) {
		throw new Error('store.js namespaces can only have alphanumerics + underscores and dashes')
	}
	
	var _privateStoreProps = {
		_namespacePrefix: namespacePrefix,
		_namespaceRegexp: namespaceRegexp,

		_testStorage: function(storage) {
			try {
				var testStr = '__storejs__test__'
				storage.write(testStr, testStr)
				var ok = (storage.read(testStr) === testStr)
				storage.remove(testStr)
				return ok
			} catch(e) {
				return false
			}
		},

		_assignPluginFnProp: function(pluginFnProp, propName) {
			var oldFn = this[propName]
			this[propName] = function pluginFn() {
				var args = slice(arguments, 0)
				var self = this

				// super_fn calls the old function which was overwritten by
				// this mixin.
				function super_fn() {
					if (!oldFn) { return }
					each(arguments, function(arg, i) {
						args[i] = arg
					})
					return oldFn.apply(self, args)
				}

				// Give mixing function access to super_fn by prefixing all mixin function
				// arguments with super_fn.
				var newFnArgs = [super_fn].concat(args)

				return pluginFnProp.apply(self, newFnArgs)
			}
		},

		_serialize: function(obj) {
			return JSON.stringify(obj)
		},

		_deserialize: function(strVal, defaultVal) {
			if (!strVal) { return defaultVal }
			// It is possible that a raw string value has been previously stored
			// in a storage without using store.js, meaning it will be a raw
			// string value instead of a JSON serialized string. By defaulting
			// to the raw string value in case of a JSON parse error, we allow
			// for past stored values to be forwards-compatible with store.js
			var val = ''
			try { val = JSON.parse(strVal) }
			catch(e) { val = strVal }

			return (val !== undefined ? val : defaultVal)
		},
		
		_addStorage: function(storage) {
			if (this.enabled) { return }
			if (this._testStorage(storage)) {
				this.storage = storage
				this.enabled = true
			}
		},

		_addPlugin: function(plugin) {
			var self = this

			// If the plugin is an array, then add all plugins in the array.
			// This allows for a plugin to depend on other plugins.
			if (isList(plugin)) {
				each(plugin, function(plugin) {
					self._addPlugin(plugin)
				})
				return
			}

			// Keep track of all plugins we've seen so far, so that we
			// don't add any of them twice.
			var seenPlugin = pluck(this.plugins, function(seenPlugin) {
				return (plugin === seenPlugin)
			})
			if (seenPlugin) {
				return
			}
			this.plugins.push(plugin)

			// Check that the plugin is properly formed
			if (!isFunction(plugin)) {
				throw new Error('Plugins must be function values that return objects')
			}

			var pluginProperties = plugin.call(this)
			if (!isObject(pluginProperties)) {
				throw new Error('Plugins must return an object of function properties')
			}

			// Add the plugin function properties to this store instance.
			each(pluginProperties, function(pluginFnProp, propName) {
				if (!isFunction(pluginFnProp)) {
					throw new Error('Bad plugin property: '+propName+' from plugin '+plugin.name+'. Plugins should only return functions.')
				}
				self._assignPluginFnProp(pluginFnProp, propName)
			})
		},
		
		// Put deprecated properties in the private API, so as to not expose it to accidential
		// discovery through inspection of the store object.
		
		// Deprecated: addStorage
		addStorage: function(storage) {
			_warn('store.addStorage(storage) is deprecated. Use createStore([storages])')
			this._addStorage(storage)
		}
	}

	var store = create(_privateStoreProps, storeAPI, {
		plugins: []
	})
	store.raw = {}
	each(store, function(prop, propName) {
		if (isFunction(prop)) {
			store.raw[propName] = bind(store, prop)			
		}
	})
	each(storages, function(storage) {
		store._addStorage(storage)
	})
	each(plugins, function(plugin) {
		store._addPlugin(plugin)
	})
	return store
}


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = [
	// Listed in order of usage preference
	__webpack_require__(1642),
	__webpack_require__(1644),
	__webpack_require__(1645),
	__webpack_require__(1641),
	__webpack_require__(1646),
	__webpack_require__(1643)
]


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

// cookieStorage is useful Safari private browser mode, where localStorage
// doesn't work but cookies do. This implementation is adopted from
// https://developer.mozilla.org/en-US/docs/Web/API/Storage/LocalStorage

var util = __webpack_require__(160)
var Global = util.Global
var trim = util.trim

module.exports = {
	name: 'cookieStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var doc = Global.document

function read(key) {
	if (!key || !_has(key)) { return null }
	var regexpStr = "(?:^|.*;\\s*)" +
		escape(key).replace(/[\-\.\+\*]/g, "\\$&") +
		"\\s*\\=\\s*((?:[^;](?!;))*[^;]?).*"
	return unescape(doc.cookie.replace(new RegExp(regexpStr), "$1"))
}

function each(callback) {
	var cookies = doc.cookie.split(/; ?/g)
	for (var i = cookies.length - 1; i >= 0; i--) {
		if (!trim(cookies[i])) {
			continue
		}
		var kvp = cookies[i].split('=')
		var key = unescape(kvp[0])
		var val = unescape(kvp[1])
		callback(val, key)
	}
}

function write(key, data) {
	if(!key) { return }
	doc.cookie = escape(key) + "=" + escape(data) + "; expires=Tue, 19 Jan 2038 03:14:07 GMT; path=/"
}

function remove(key) {
	if (!key || !_has(key)) {
		return
	}
	doc.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/"
}

function clearAll() {
	each(function(_, key) {
		remove(key)
	})
}

function _has(key) {
	return (new RegExp("(?:^|;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(doc.cookie)
}


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(160)
var Global = util.Global

module.exports = {
	name: 'localStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

function localStorage() {
	return Global.localStorage
}

function read(key) {
	return localStorage().getItem(key)
}

function write(key, data) {
	return localStorage().setItem(key, data)
}

function each(fn) {
	for (var i = localStorage().length - 1; i >= 0; i--) {
		var key = localStorage().key(i)
		fn(read(key), key)
	}
}

function remove(key) {
	return localStorage().removeItem(key)
}

function clearAll() {
	return localStorage().clear()
}


/***/ }),
/* 1643 */
/***/ (function(module, exports) {

// memoryStorage is a useful last fallback to ensure that the store
// is functions (meaning store.get(), store.set(), etc will all function).
// However, stored values will not persist when the browser navigates to
// a new page or reloads the current page.

module.exports = {
	name: 'memoryStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var memoryStorage = {}

function read(key) {
	return memoryStorage[key]
}

function write(key, data) {
	memoryStorage[key] = data
}

function each(callback) {
	for (var key in memoryStorage) {
		if (memoryStorage.hasOwnProperty(key)) {
			callback(memoryStorage[key], key)
		}
	}
}

function remove(key) {
	delete memoryStorage[key]
}

function clearAll(key) {
	memoryStorage = {}
}


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

// oldFF-globalStorage provides storage for Firefox
// versions 6 and 7, where no localStorage, etc
// is available.

var util = __webpack_require__(160)
var Global = util.Global

module.exports = {
	name: 'oldFF-globalStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var globalStorage = Global.globalStorage

function read(key) {
	return globalStorage[key]
}

function write(key, data) {
	globalStorage[key] = data
}

function each(fn) {
	for (var i = globalStorage.length - 1; i >= 0; i--) {
		var key = globalStorage.key(i)
		fn(globalStorage[key], key)
	}
}

function remove(key) {
	return globalStorage.removeItem(key)
}

function clearAll() {
	each(function(key, _) {
		delete globalStorage[key]
	})
}


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

// oldIE-userDataStorage provides storage for Internet Explorer
// versions 6 and 7, where no localStorage, sessionStorage, etc
// is available.

var util = __webpack_require__(160)
var Global = util.Global

module.exports = {
	name: 'oldIE-userDataStorage',
	write: write,
	read: read,
	each: each,
	remove: remove,
	clearAll: clearAll,
}

var storageName = 'storejs'
var doc = Global.document
var _withStorageEl = _makeIEStorageElFunction()
var disable = (Global.navigator ? Global.navigator.userAgent : '').match(/ (MSIE 8|MSIE 9|MSIE 10)\./) // MSIE 9.x, MSIE 10.x

function write(unfixedKey, data) {
	if (disable) { return }
	var fixedKey = fixKey(unfixedKey)
	_withStorageEl(function(storageEl) {
		storageEl.setAttribute(fixedKey, data)
		storageEl.save(storageName)
	})
}

function read(unfixedKey) {
	if (disable) { return }
	var fixedKey = fixKey(unfixedKey)
	var res = null
	_withStorageEl(function(storageEl) {
		res = storageEl.getAttribute(fixedKey)
	})
	return res
}

function each(callback) {
	_withStorageEl(function(storageEl) {
		var attributes = storageEl.XMLDocument.documentElement.attributes
		for (var i=attributes.length-1; i>=0; i--) {
			var attr = attributes[i]
			callback(storageEl.getAttribute(attr.name), attr.name)
		}
	})
}

function remove(unfixedKey) {
	var fixedKey = fixKey(unfixedKey)
	_withStorageEl(function(storageEl) {
		storageEl.removeAttribute(fixedKey)
		storageEl.save(storageName)
	})
}

function clearAll() {
	_withStorageEl(function(storageEl) {
		var attributes = storageEl.XMLDocument.documentElement.attributes
		storageEl.load(storageName)
		for (var i=attributes.length-1; i>=0; i--) {
			storageEl.removeAttribute(attributes[i].name)
		}
		storageEl.save(storageName)
	})
}

// Helpers
//////////

// In IE7, keys cannot start with a digit or contain certain chars.
// See https://github.com/marcuswestin/store.js/issues/40
// See https://github.com/marcuswestin/store.js/issues/83
var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g")
function fixKey(key) {
	return key.replace(/^\d/, '___$&').replace(forbiddenCharsRegex, '___')
}

function _makeIEStorageElFunction() {
	if (!doc || !doc.documentElement || !doc.documentElement.addBehavior) {
		return null
	}
	var scriptTag = 'script',
		storageOwner,
		storageContainer,
		storageEl

	// Since #userData storage applies only to specific paths, we need to
	// somehow link our data to a specific path.  We choose /favicon.ico
	// as a pretty safe option, since all browsers already make a request to
	// this URL anyway and being a 404 will not hurt us here.  We wrap an
	// iframe pointing to the favicon in an ActiveXObject(htmlfile) object
	// (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
	// since the iframe access rules appear to allow direct access and
	// manipulation of the document element, even for a 404 page.  This
	// document can be used instead of the current document (which would
	// have been limited to the current path) to perform #userData storage.
	try {
		/* global ActiveXObject */
		storageContainer = new ActiveXObject('htmlfile')
		storageContainer.open()
		storageContainer.write('<'+scriptTag+'>document.w=window</'+scriptTag+'><iframe src="/favicon.ico"></iframe>')
		storageContainer.close()
		storageOwner = storageContainer.w.frames[0].document
		storageEl = storageOwner.createElement('div')
	} catch(e) {
		// somehow ActiveXObject instantiation failed (perhaps some special
		// security settings or otherwse), fall back to per-path storage
		storageEl = doc.createElement('div')
		storageOwner = doc.body
	}

	return function(storeFunction) {
		var args = [].slice.call(arguments, 0)
		args.unshift(storageEl)
		// See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
		// and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
		storageOwner.appendChild(storageEl)
		storageEl.addBehavior('#default#userData')
		storageEl.load(storageName)
		storeFunction.apply(this, args)
		storageOwner.removeChild(storageEl)
		return
	}
}


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

var util = __webpack_require__(160)
var Global = util.Global

module.exports = {
	name: 'sessionStorage',
	read: read,
	write: write,
	each: each,
	remove: remove,
	clearAll: clearAll
}

function sessionStorage() {
	return Global.sessionStorage
}

function read(key) {
	return sessionStorage().getItem(key)
}

function write(key, data) {
	return sessionStorage().setItem(key, data)
}

function each(fn) {
	for (var i = sessionStorage().length - 1; i >= 0; i--) {
		var key = sessionStorage().key(i)
		fn(read(key), key)
	}
}

function remove(key) {
	return sessionStorage().removeItem(key)
}

function clearAll() {
	return sessionStorage().clear()
}


/***/ }),
/* 1647 */
/***/ (function(module, exports) {

module.exports = shift

function shift (stream) {
  var rs = stream._readableState
  if (!rs) return null
  return rs.objectMode ? stream.read() : stream.read(getStateLength(rs))
}

function getStateLength (state) {
  if (state.buffer.length) {
    // Since node 6.3.0 state.buffer is a BufferList not an array
    if (state.buffer.head) {
      return state.buffer.head.data.length
    }

    return state.buffer[0].length
  }

  return state.length
}


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1651);


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(1652);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30), __webpack_require__(248)(module)))

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1630);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 1654 */
/***/ (function(module, exports) {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1658);
var v4 = __webpack_require__(1659);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(711);
var bytesToUuid = __webpack_require__(710);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(711);
var bytesToUuid = __webpack_require__(710);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1660 */
/***/ (function(module, exports) {


var ws = null

if (typeof WebSocket !== 'undefined') {
  ws = WebSocket
} else if (typeof MozWebSocket !== 'undefined') {
  ws = MozWebSocket
} else if (typeof window !== 'undefined') {
  ws = window.WebSocket || window.MozWebSocket
}

module.exports = ws


/***/ }),
/* 1661 */
/***/ (function(module, exports) {

// Returns a wrapper function that returns a wrapped callback
// The wrapper function should do some stuff, and return a
// presumably different callback function.
// This makes sure that own properties are retained, so that
// decorations and such are not lost along the way.
module.exports = wrappy
function wrappy (fn, cb) {
  if (fn && cb) return wrappy(fn)(cb)

  if (typeof fn !== 'function')
    throw new TypeError('need wrapper function')

  Object.keys(fn).forEach(function (k) {
    wrapper[k] = fn[k]
  })

  return wrapper

  function wrapper() {
    var args = new Array(arguments.length)
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i]
    }
    var ret = fn.apply(this, args)
    var cb = args[args.length-1]
    if (typeof ret === 'function' && ret !== cb) {
      Object.keys(cb).forEach(function (k) {
        ret[k] = cb[k]
      })
    }
    return ret
  }
}


/***/ }),
/* 1662 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1663 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1664 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(715);
module.exports = __webpack_require__(714);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main-81cc09400f1b903678a6.js